
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredb62"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredb62"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ih19M", function(module, exports) {
'use strict';

module.exports = (parcelRequire("0qhf8"));

});
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
'use strict';

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
'use strict';
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("7MXrw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $51lpG = parcelRequire("51lpG");

var $fivc7 = parcelRequire("fivc7");

var $kuNiL = parcelRequire("kuNiL");

var $hqR4t = parcelRequire("hqR4t");

var $7uMzR = parcelRequire("7uMzR");

var $gLqR5 = parcelRequire("gLqR5");

var $k5JCq = parcelRequire("k5JCq");

var $2ryml = parcelRequire("2ryml");

var $d85KZ = parcelRequire("d85KZ");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $fivc7.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $kuNiL.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $fivc7.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $kuNiL.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $k5JCq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $k5JCq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gLqR5.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ResourceStore = function(_EventEmitter) {
    (0, $7uMzR.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $fivc7.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $hqR4t.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $kuNiL.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $k5JCq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $k5JCq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gLqR5.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $7uMzR.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $fivc7.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $hqR4t.default)(_this));
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $hqR4t.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        return _this;
    }
    (0, $kuNiL.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $51lpG.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $51lpG.default)(options) === 'object') options = _objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $fivc7.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    (0, $kuNiL.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    'v1',
    'v2',
    'v3'
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $fivc7.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    (0, $kuNiL.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? 'ordinal' : 'cardinal'
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = 'plural';
                    else if (suffix === 1) suffix = '';
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === 'v1') {
                    if (suffix === 1) return '';
                    if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $fivc7.default)(this, Interpolator);
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $kuNiL.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(':'), _opt$split2 = (0, $d85KZ.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $fivc7.default)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
                    style: 'currency'
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || 'day');
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $kuNiL.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $k5JCq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $k5JCq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gLqR5.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $7uMzR.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $fivc7.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $hqR4t.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $kuNiL.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $51lpG.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $51lpG.default)(args[2]) === 'object' || (0, $51lpG.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $2ryml.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $k5JCq.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $k5JCq.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $gLqR5.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $7uMzR.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $fivc7.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $hqR4t.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $hqR4t.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $gLqR5.default)(_this, (0, $hqR4t.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $kuNiL.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === 'string') options.defaultNS = options.ns;
                    else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== 'undefined') formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $51lpG.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $2ryml.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("51lpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3a7da7f4c81a8554$export$2e2bcd8739ae039; });
function $3a7da7f4c81a8554$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3a7da7f4c81a8554$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a7da7f4c81a8554$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fivc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b230bc0d4245014d$export$2e2bcd8739ae039; });
function $b230bc0d4245014d$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kuNiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eebcda4657ff09bb$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $eebcda4657ff09bb$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $hTglg.default)(o.key), o);
    }
}
function $eebcda4657ff09bb$export$2e2bcd8739ae039(e, r, t) {
    return r && $eebcda4657ff09bb$var$_defineProperties(e.prototype, r), t && $eebcda4657ff09bb$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("hTglg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0643fe154cb74c1$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $cMfNc = parcelRequire("cMfNc");
function $d0643fe154cb74c1$export$2e2bcd8739ae039(t) {
    var i = (0, $cMfNc.default)(t, "string");
    return "symbol" == (0, $51lpG.default)(i) ? i : i + "";
}

});
parcelRegister("cMfNc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94d637ce061dd3ca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");
function $94d637ce061dd3ca$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $51lpG.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $51lpG.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hqR4t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0e0834598ff6d6$export$2e2bcd8739ae039; });
function $cb0e0834598ff6d6$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("7uMzR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5751042f9a4a77f6$export$2e2bcd8739ae039; });

var $hloi6 = parcelRequire("hloi6");
function $5751042f9a4a77f6$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hloi6.default)(t, e);
}

});
parcelRegister("hloi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca073d81f2a471af$export$2e2bcd8739ae039; });
function $ca073d81f2a471af$export$2e2bcd8739ae039(t, e) {
    return $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca073d81f2a471af$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gLqR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c345de07753d2fca$export$2e2bcd8739ae039; });

var $51lpG = parcelRequire("51lpG");

var $hqR4t = parcelRequire("hqR4t");
function $c345de07753d2fca$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $51lpG.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hqR4t.default)(t);
}

});

parcelRegister("k5JCq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea07a931d040ec2a$export$2e2bcd8739ae039; });
function $ea07a931d040ec2a$export$2e2bcd8739ae039(t) {
    return $ea07a931d040ec2a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ea07a931d040ec2a$export$2e2bcd8739ae039(t);
}

});

parcelRegister("2ryml", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c78c172f6af0e63$export$2e2bcd8739ae039; });

var $hTglg = parcelRequire("hTglg");
function $1c78c172f6af0e63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $hTglg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("d85KZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f07cea90eeadfa$export$2e2bcd8739ae039; });

var $klRdc = parcelRequire("klRdc");

var $cq1as = parcelRequire("cq1as");

var $9F6mQ = parcelRequire("9F6mQ");

var $1ZnLp = parcelRequire("1ZnLp");
function $98f07cea90eeadfa$export$2e2bcd8739ae039(r) {
    return (0, $klRdc.default)(r) || (0, $cq1as.default)(r) || (0, $9F6mQ.default)(r) || (0, $1ZnLp.default)();
}

});
parcelRegister("klRdc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed0f0b97866d6cfa$export$2e2bcd8739ae039; });
function $ed0f0b97866d6cfa$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("cq1as", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90a8d1a06a2704aa$export$2e2bcd8739ae039; });
function $90a8d1a06a2704aa$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("9F6mQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708ce1d4f20bd938$export$2e2bcd8739ae039; });

var $cnxX0 = parcelRequire("cnxX0");
function $708ce1d4f20bd938$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cnxX0.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cnxX0.default)(r, a) : void 0;
    }
}

});
parcelRegister("cnxX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9031f7f2924753e9$export$2e2bcd8739ae039; });
function $9031f7f2924753e9$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1ZnLp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $172debecf3a06e01$export$2e2bcd8739ae039; });
function $172debecf3a06e01$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("6afFj", function(module, exports) {
'use strict';
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

module.exports = (parcelRequire("foRq4"));

});
parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
'use strict';

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("4LCdk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
'use strict';
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});




parcelRegister("fSg2G", function(module, exports) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("28Nm5", function(module, exports) {
var $18f29d118a1c540c$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $18f29d118a1c540c$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($18f29d118a1c540c$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = $18f29d118a1c540c$var$charenc;

});

parcelRegister("fV4Tl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b96ff9463710b32b$var$isValid;

var $b96ff9463710b32b$var$_index = $b96ff9463710b32b$var$_interopRequireDefault((parcelRequire("gepV0")));

var $b96ff9463710b32b$var$_index2 = $b96ff9463710b32b$var$_interopRequireDefault((parcelRequire("99U8H")));

var $b96ff9463710b32b$var$_index3 = $b96ff9463710b32b$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $b96ff9463710b32b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $b96ff9463710b32b$var$isValid(dirtyDate) {
    (0, $b96ff9463710b32b$var$_index3.default)(1, arguments);
    if (!(0, $b96ff9463710b32b$var$_index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $b96ff9463710b32b$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});
parcelRegister("gepV0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $bd120f04c645c71a$var$isDate;

var $bd120f04c645c71a$var$_index = $bd120f04c645c71a$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $bd120f04c645c71a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd120f04c645c71a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bd120f04c645c71a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bd120f04c645c71a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bd120f04c645c71a$var$_typeof(obj);
}
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $bd120f04c645c71a$var$isDate(value) {
    (0, $bd120f04c645c71a$var$_index.default)(1, arguments);
    return value instanceof Date || $bd120f04c645c71a$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = module.exports.default;

});
parcelRegister("kMAIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f214c5d8a83db1e7$var$requiredArgs;
function $f214c5d8a83db1e7$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});


parcelRegister("99U8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6ab080651a5f52b8$var$toDate;

var $6ab080651a5f52b8$var$_index = $6ab080651a5f52b8$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $6ab080651a5f52b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6ab080651a5f52b8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6ab080651a5f52b8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6ab080651a5f52b8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6ab080651a5f52b8$var$_typeof(obj);
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $6ab080651a5f52b8$var$toDate(argument) {
    (0, $6ab080651a5f52b8$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $6ab080651a5f52b8$var$_typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});


parcelRegister("bkUS7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $840dad8f93ebfb05$var$subMilliseconds;

var $840dad8f93ebfb05$var$_index = $840dad8f93ebfb05$var$_interopRequireDefault((parcelRequire("5Eds5")));

var $840dad8f93ebfb05$var$_index2 = $840dad8f93ebfb05$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $840dad8f93ebfb05$var$_index3 = $840dad8f93ebfb05$var$_interopRequireDefault((parcelRequire("8WZx9")));
function $840dad8f93ebfb05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $840dad8f93ebfb05$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $840dad8f93ebfb05$var$_index2.default)(2, arguments);
    var amount = (0, $840dad8f93ebfb05$var$_index3.default)(dirtyAmount);
    return (0, $840dad8f93ebfb05$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("5Eds5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $41cb1f719bf07bab$var$addMilliseconds;

var $41cb1f719bf07bab$var$_index = $41cb1f719bf07bab$var$_interopRequireDefault((parcelRequire("8WZx9")));

var $41cb1f719bf07bab$var$_index2 = $41cb1f719bf07bab$var$_interopRequireDefault((parcelRequire("99U8H")));

var $41cb1f719bf07bab$var$_index3 = $41cb1f719bf07bab$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $41cb1f719bf07bab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $41cb1f719bf07bab$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $41cb1f719bf07bab$var$_index3.default)(2, arguments);
    var timestamp = (0, $41cb1f719bf07bab$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $41cb1f719bf07bab$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});
parcelRegister("8WZx9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $684378d1860d5f25$var$toInteger;
function $684378d1860d5f25$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});



parcelRegister("cB9mK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $92c034977e82c825$var$_index = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("bo450")));

var $92c034977e82c825$var$_index2 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("alqY4")));

var $92c034977e82c825$var$_index3 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("3n32G")));

var $92c034977e82c825$var$_index4 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("409Hf")));

var $92c034977e82c825$var$_index5 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("kHxT8")));

var $92c034977e82c825$var$_index6 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("9VYDZ")));

var $92c034977e82c825$var$_index7 = $92c034977e82c825$var$_interopRequireDefault((parcelRequire("lu5J3")));
function $92c034977e82c825$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $92c034977e82c825$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $92c034977e82c825$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $92c034977e82c825$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $92c034977e82c825$var$_index5.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $92c034977e82c825$var$_index6.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $92c034977e82c825$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $92c034977e82c825$var$_index3.default)(date); // Padding
        return (0, $92c034977e82c825$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $92c034977e82c825$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $92c034977e82c825$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $92c034977e82c825$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $92c034977e82c825$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $92c034977e82c825$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $92c034977e82c825$var$_index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $92c034977e82c825$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $92c034977e82c825$var$_index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $92c034977e82c825$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $92c034977e82c825$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $92c034977e82c825$var$_index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $92c034977e82c825$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $92c034977e82c825$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $92c034977e82c825$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $92c034977e82c825$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $92c034977e82c825$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $92c034977e82c825$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $92c034977e82c825$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $92c034977e82c825$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $92c034977e82c825$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $92c034977e82c825$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $92c034977e82c825$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $92c034977e82c825$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $92c034977e82c825$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $92c034977e82c825$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $92c034977e82c825$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $92c034977e82c825$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $92c034977e82c825$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $92c034977e82c825$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $92c034977e82c825$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $92c034977e82c825$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $92c034977e82c825$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $92c034977e82c825$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $92c034977e82c825$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $92c034977e82c825$var$_index6.default)(timestamp, token.length);
    }
};
function $92c034977e82c825$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $92c034977e82c825$var$_index6.default)(minutes, 2);
}
function $92c034977e82c825$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $92c034977e82c825$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $92c034977e82c825$var$formatTimezone(offset, dirtyDelimiter);
}
function $92c034977e82c825$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $92c034977e82c825$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $92c034977e82c825$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $92c034977e82c825$var$_default = $92c034977e82c825$var$formatters;
module.exports.default = $92c034977e82c825$var$_default;
module.exports = module.exports.default;

});
parcelRegister("bo450", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0223b1f6c64e9e4b$var$getUTCDayOfYear;

var $0223b1f6c64e9e4b$var$_index = $0223b1f6c64e9e4b$var$_interopRequireDefault((parcelRequire("99U8H")));

var $0223b1f6c64e9e4b$var$_index2 = $0223b1f6c64e9e4b$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $0223b1f6c64e9e4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0223b1f6c64e9e4b$var$MILLISECONDS_IN_DAY = 86400000;
function $0223b1f6c64e9e4b$var$getUTCDayOfYear(dirtyDate) {
    (0, $0223b1f6c64e9e4b$var$_index2.default)(1, arguments);
    var date = (0, $0223b1f6c64e9e4b$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $0223b1f6c64e9e4b$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("alqY4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7880c8d4fc5ebe96$var$getUTCISOWeek;

var $7880c8d4fc5ebe96$var$_index = $7880c8d4fc5ebe96$var$_interopRequireDefault((parcelRequire("99U8H")));

var $7880c8d4fc5ebe96$var$_index2 = $7880c8d4fc5ebe96$var$_interopRequireDefault((parcelRequire("hZ9Pl")));

var $7880c8d4fc5ebe96$var$_index3 = $7880c8d4fc5ebe96$var$_interopRequireDefault((parcelRequire("eBGY1")));

var $7880c8d4fc5ebe96$var$_index4 = $7880c8d4fc5ebe96$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $7880c8d4fc5ebe96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7880c8d4fc5ebe96$var$MILLISECONDS_IN_WEEK = 604800000;
function $7880c8d4fc5ebe96$var$getUTCISOWeek(dirtyDate) {
    (0, $7880c8d4fc5ebe96$var$_index4.default)(1, arguments);
    var date = (0, $7880c8d4fc5ebe96$var$_index.default)(dirtyDate);
    var diff = (0, $7880c8d4fc5ebe96$var$_index2.default)(date).getTime() - (0, $7880c8d4fc5ebe96$var$_index3.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $7880c8d4fc5ebe96$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("hZ9Pl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d17fc1a5ab958c52$var$startOfUTCISOWeek;

var $d17fc1a5ab958c52$var$_index = $d17fc1a5ab958c52$var$_interopRequireDefault((parcelRequire("99U8H")));

var $d17fc1a5ab958c52$var$_index2 = $d17fc1a5ab958c52$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $d17fc1a5ab958c52$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d17fc1a5ab958c52$var$startOfUTCISOWeek(dirtyDate) {
    (0, $d17fc1a5ab958c52$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $d17fc1a5ab958c52$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("eBGY1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa25d9c34605cbf3$var$startOfUTCISOWeekYear;

var $aa25d9c34605cbf3$var$_index = $aa25d9c34605cbf3$var$_interopRequireDefault((parcelRequire("3n32G")));

var $aa25d9c34605cbf3$var$_index2 = $aa25d9c34605cbf3$var$_interopRequireDefault((parcelRequire("hZ9Pl")));

var $aa25d9c34605cbf3$var$_index3 = $aa25d9c34605cbf3$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $aa25d9c34605cbf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa25d9c34605cbf3$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $aa25d9c34605cbf3$var$_index3.default)(1, arguments);
    var year = (0, $aa25d9c34605cbf3$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $aa25d9c34605cbf3$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("3n32G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2745e13815a637cd$var$getUTCISOWeekYear;

var $2745e13815a637cd$var$_index = $2745e13815a637cd$var$_interopRequireDefault((parcelRequire("99U8H")));

var $2745e13815a637cd$var$_index2 = $2745e13815a637cd$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $2745e13815a637cd$var$_index3 = $2745e13815a637cd$var$_interopRequireDefault((parcelRequire("hZ9Pl")));
function $2745e13815a637cd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2745e13815a637cd$var$getUTCISOWeekYear(dirtyDate) {
    (0, $2745e13815a637cd$var$_index2.default)(1, arguments);
    var date = (0, $2745e13815a637cd$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $2745e13815a637cd$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $2745e13815a637cd$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("409Hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2e9eaf0578c8249e$var$getUTCWeek;

var $2e9eaf0578c8249e$var$_index = $2e9eaf0578c8249e$var$_interopRequireDefault((parcelRequire("99U8H")));

var $2e9eaf0578c8249e$var$_index2 = $2e9eaf0578c8249e$var$_interopRequireDefault((parcelRequire("e0Qxn")));

var $2e9eaf0578c8249e$var$_index3 = $2e9eaf0578c8249e$var$_interopRequireDefault((parcelRequire("apWdd")));

var $2e9eaf0578c8249e$var$_index4 = $2e9eaf0578c8249e$var$_interopRequireDefault((parcelRequire("kMAIB")));
function $2e9eaf0578c8249e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2e9eaf0578c8249e$var$MILLISECONDS_IN_WEEK = 604800000;
function $2e9eaf0578c8249e$var$getUTCWeek(dirtyDate, options) {
    (0, $2e9eaf0578c8249e$var$_index4.default)(1, arguments);
    var date = (0, $2e9eaf0578c8249e$var$_index.default)(dirtyDate);
    var diff = (0, $2e9eaf0578c8249e$var$_index2.default)(date, options).getTime() - (0, $2e9eaf0578c8249e$var$_index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2e9eaf0578c8249e$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("e0Qxn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a339d19743f6b73b$var$startOfUTCWeek;

var $a339d19743f6b73b$var$_index = $a339d19743f6b73b$var$_interopRequireDefault((parcelRequire("99U8H")));

var $a339d19743f6b73b$var$_index2 = $a339d19743f6b73b$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $a339d19743f6b73b$var$_index3 = $a339d19743f6b73b$var$_interopRequireDefault((parcelRequire("8WZx9")));

var $fFrSb = parcelRequire("fFrSb");
function $a339d19743f6b73b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a339d19743f6b73b$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $a339d19743f6b73b$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $fFrSb.getDefaultOptions)();
    var weekStartsOn = (0, $a339d19743f6b73b$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $a339d19743f6b73b$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("fFrSb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $b6804e5179b98dda$var$getDefaultOptions;
module.exports.setDefaultOptions = $b6804e5179b98dda$var$setDefaultOptions;
var $b6804e5179b98dda$var$defaultOptions = {};
function $b6804e5179b98dda$var$getDefaultOptions() {
    return $b6804e5179b98dda$var$defaultOptions;
}
function $b6804e5179b98dda$var$setDefaultOptions(newOptions) {
    $b6804e5179b98dda$var$defaultOptions = newOptions;
}

});


parcelRegister("apWdd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $795964e6b8ac8377$var$startOfUTCWeekYear;

var $795964e6b8ac8377$var$_index = $795964e6b8ac8377$var$_interopRequireDefault((parcelRequire("kHxT8")));

var $795964e6b8ac8377$var$_index2 = $795964e6b8ac8377$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $795964e6b8ac8377$var$_index3 = $795964e6b8ac8377$var$_interopRequireDefault((parcelRequire("e0Qxn")));

var $795964e6b8ac8377$var$_index4 = $795964e6b8ac8377$var$_interopRequireDefault((parcelRequire("8WZx9")));

var $fFrSb = parcelRequire("fFrSb");
function $795964e6b8ac8377$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $795964e6b8ac8377$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $795964e6b8ac8377$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $fFrSb.getDefaultOptions)();
    var firstWeekContainsDate = (0, $795964e6b8ac8377$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $795964e6b8ac8377$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $795964e6b8ac8377$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("kHxT8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1221c48c01febb0$var$getUTCWeekYear;

var $f1221c48c01febb0$var$_index = $f1221c48c01febb0$var$_interopRequireDefault((parcelRequire("99U8H")));

var $f1221c48c01febb0$var$_index2 = $f1221c48c01febb0$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $f1221c48c01febb0$var$_index3 = $f1221c48c01febb0$var$_interopRequireDefault((parcelRequire("e0Qxn")));

var $f1221c48c01febb0$var$_index4 = $f1221c48c01febb0$var$_interopRequireDefault((parcelRequire("8WZx9")));

var $fFrSb = parcelRequire("fFrSb");
function $f1221c48c01febb0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f1221c48c01febb0$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f1221c48c01febb0$var$_index2.default)(1, arguments);
    var date = (0, $f1221c48c01febb0$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $fFrSb.getDefaultOptions)();
    var firstWeekContainsDate = (0, $f1221c48c01febb0$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f1221c48c01febb0$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f1221c48c01febb0$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("9VYDZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $73b87a8e58868bcd$var$addLeadingZeros;
function $73b87a8e58868bcd$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("lu5J3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa40d74d01dfe18d$var$_index = $fa40d74d01dfe18d$var$_interopRequireDefault((parcelRequire("9VYDZ")));
function $fa40d74d01dfe18d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $fa40d74d01dfe18d$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $fa40d74d01dfe18d$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $fa40d74d01dfe18d$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $fa40d74d01dfe18d$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $fa40d74d01dfe18d$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $fa40d74d01dfe18d$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $fa40d74d01dfe18d$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $fa40d74d01dfe18d$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $fa40d74d01dfe18d$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $fa40d74d01dfe18d$var$_default = $fa40d74d01dfe18d$var$formatters;
module.exports.default = $fa40d74d01dfe18d$var$_default;
module.exports = module.exports.default;

});


parcelRegister("Js4Jx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $0889fb434ea81f23$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $0889fb434ea81f23$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $0889fb434ea81f23$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $0889fb434ea81f23$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $0889fb434ea81f23$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $0889fb434ea81f23$var$timeLongFormatter(timePattern, formatLong));
};
var $0889fb434ea81f23$var$longFormatters = {
    p: $0889fb434ea81f23$var$timeLongFormatter,
    P: $0889fb434ea81f23$var$dateTimeLongFormatter
};
var $0889fb434ea81f23$var$_default = $0889fb434ea81f23$var$longFormatters;
module.exports.default = $0889fb434ea81f23$var$_default;
module.exports = module.exports.default;

});

parcelRegister("kXZ8N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f438be9ee4c5a441$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $f438be9ee4c5a441$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("3NNiF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c4c30aa5bd80457$var$_index = $2c4c30aa5bd80457$var$_interopRequireDefault((parcelRequire("47f1Q")));
function $2c4c30aa5bd80457$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2c4c30aa5bd80457$var$_default = $2c4c30aa5bd80457$var$_index.default;
module.exports.default = $2c4c30aa5bd80457$var$_default;
module.exports = module.exports.default;

});
parcelRegister("47f1Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ff379420ca6d8b0$var$_index = $2ff379420ca6d8b0$var$_interopRequireDefault((parcelRequire("hyoME")));

var $2ff379420ca6d8b0$var$_index2 = $2ff379420ca6d8b0$var$_interopRequireDefault((parcelRequire("dHSOQ")));

var $2ff379420ca6d8b0$var$_index3 = $2ff379420ca6d8b0$var$_interopRequireDefault((parcelRequire("7zKae")));

var $2ff379420ca6d8b0$var$_index4 = $2ff379420ca6d8b0$var$_interopRequireDefault((parcelRequire("jB7Gt")));

var $2ff379420ca6d8b0$var$_index5 = $2ff379420ca6d8b0$var$_interopRequireDefault((parcelRequire("f5CGk")));
function $2ff379420ca6d8b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $2ff379420ca6d8b0$var$locale = {
    code: 'en-US',
    formatDistance: $2ff379420ca6d8b0$var$_index.default,
    formatLong: $2ff379420ca6d8b0$var$_index2.default,
    formatRelative: $2ff379420ca6d8b0$var$_index3.default,
    localize: $2ff379420ca6d8b0$var$_index4.default,
    match: $2ff379420ca6d8b0$var$_index5.default,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $2ff379420ca6d8b0$var$_default = $2ff379420ca6d8b0$var$locale;
module.exports.default = $2ff379420ca6d8b0$var$_default;
module.exports = module.exports.default;

});
parcelRegister("hyoME", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cc78d628e968e0e3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $cc78d628e968e0e3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cc78d628e968e0e3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $cc78d628e968e0e3$var$_default = $cc78d628e968e0e3$var$formatDistance;
module.exports.default = $cc78d628e968e0e3$var$_default;
module.exports = module.exports.default;

});

parcelRegister("dHSOQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9fa9d071030e3662$var$_index = $9fa9d071030e3662$var$_interopRequireDefault((parcelRequire("cCxiJ")));
function $9fa9d071030e3662$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9fa9d071030e3662$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $9fa9d071030e3662$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $9fa9d071030e3662$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9fa9d071030e3662$var$formatLong = {
    date: (0, $9fa9d071030e3662$var$_index.default)({
        formats: $9fa9d071030e3662$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $9fa9d071030e3662$var$_index.default)({
        formats: $9fa9d071030e3662$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $9fa9d071030e3662$var$_index.default)({
        formats: $9fa9d071030e3662$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9fa9d071030e3662$var$_default = $9fa9d071030e3662$var$formatLong;
module.exports.default = $9fa9d071030e3662$var$_default;
module.exports = module.exports.default;

});
parcelRegister("cCxiJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9302dd88c9f82063$var$buildFormatLongFn;
function $9302dd88c9f82063$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("7zKae", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $583f9c7d74e9b4dd$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $583f9c7d74e9b4dd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $583f9c7d74e9b4dd$var$formatRelativeLocale[token];
};
var $583f9c7d74e9b4dd$var$_default = $583f9c7d74e9b4dd$var$formatRelative;
module.exports.default = $583f9c7d74e9b4dd$var$_default;
module.exports = module.exports.default;

});

parcelRegister("jB7Gt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e4476eecc854b719$var$_index = $e4476eecc854b719$var$_interopRequireDefault((parcelRequire("yGPYD")));
function $e4476eecc854b719$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e4476eecc854b719$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $e4476eecc854b719$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $e4476eecc854b719$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $e4476eecc854b719$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $e4476eecc854b719$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $e4476eecc854b719$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $e4476eecc854b719$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $e4476eecc854b719$var$localize = {
    ordinalNumber: $e4476eecc854b719$var$ordinalNumber,
    era: (0, $e4476eecc854b719$var$_index.default)({
        values: $e4476eecc854b719$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $e4476eecc854b719$var$_index.default)({
        values: $e4476eecc854b719$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e4476eecc854b719$var$_index.default)({
        values: $e4476eecc854b719$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $e4476eecc854b719$var$_index.default)({
        values: $e4476eecc854b719$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $e4476eecc854b719$var$_index.default)({
        values: $e4476eecc854b719$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e4476eecc854b719$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e4476eecc854b719$var$_default = $e4476eecc854b719$var$localize;
module.exports.default = $e4476eecc854b719$var$_default;
module.exports = module.exports.default;

});
parcelRegister("yGPYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $068467b19bf97ac2$var$buildLocalizeFn;
function $068467b19bf97ac2$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("f5CGk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afc55409e2cae70a$var$_index = $afc55409e2cae70a$var$_interopRequireDefault((parcelRequire("joyIY")));

var $afc55409e2cae70a$var$_index2 = $afc55409e2cae70a$var$_interopRequireDefault((parcelRequire("ljSbo")));
function $afc55409e2cae70a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $afc55409e2cae70a$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $afc55409e2cae70a$var$parseOrdinalNumberPattern = /\d+/i;
var $afc55409e2cae70a$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $afc55409e2cae70a$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $afc55409e2cae70a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $afc55409e2cae70a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $afc55409e2cae70a$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $afc55409e2cae70a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $afc55409e2cae70a$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $afc55409e2cae70a$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $afc55409e2cae70a$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $afc55409e2cae70a$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $afc55409e2cae70a$var$match = {
    ordinalNumber: (0, $afc55409e2cae70a$var$_index2.default)({
        matchPattern: $afc55409e2cae70a$var$matchOrdinalNumberPattern,
        parsePattern: $afc55409e2cae70a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $afc55409e2cae70a$var$_index.default)({
        matchPatterns: $afc55409e2cae70a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afc55409e2cae70a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $afc55409e2cae70a$var$_index.default)({
        matchPatterns: $afc55409e2cae70a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afc55409e2cae70a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $afc55409e2cae70a$var$_index.default)({
        matchPatterns: $afc55409e2cae70a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afc55409e2cae70a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $afc55409e2cae70a$var$_index.default)({
        matchPatterns: $afc55409e2cae70a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $afc55409e2cae70a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $afc55409e2cae70a$var$_index.default)({
        matchPatterns: $afc55409e2cae70a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $afc55409e2cae70a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $afc55409e2cae70a$var$_default = $afc55409e2cae70a$var$match;
module.exports.default = $afc55409e2cae70a$var$_default;
module.exports = module.exports.default;

});
parcelRegister("joyIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1eb31c3f104aa4a$var$buildMatchFn;
function $e1eb31c3f104aa4a$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $e1eb31c3f104aa4a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $e1eb31c3f104aa4a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e1eb31c3f104aa4a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e1eb31c3f104aa4a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("ljSbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f85566e65676210c$var$buildMatchPatternFn;
function $f85566e65676210c$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});




parcelRegister("2LfAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $202c0ef0ea07630f$var$assign;
function $202c0ef0ea07630f$var$assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("8MQJ5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $665bb4baa73432fa$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");
var $665bb4baa73432fa$var$MILLISECONDS_IN_MINUTE = 60000;
function $665bb4baa73432fa$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, amount * $665bb4baa73432fa$var$MILLISECONDS_IN_MINUTE);
}

});
parcelRegister("8d3vD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fa2427dbbbb369e$export$2e2bcd8739ae039; });
function $5fa2427dbbbb369e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});

parcelRegister("egwKS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a62bf7cf7b9521d9$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $a62bf7cf7b9521d9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var timestamp = (0, $le96L.default)(dirtyDate).getTime();
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("le96L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f741f874145d0154$export$2e2bcd8739ae039; });

var $6RzIO = parcelRequire("6RzIO");
function $f741f874145d0154$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f741f874145d0154$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f741f874145d0154$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f741f874145d0154$var$_typeof(obj);
}
function $f741f874145d0154$export$2e2bcd8739ae039(argument) {
    (0, $6RzIO.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $f741f874145d0154$var$_typeof(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("6RzIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ff366e58c33ccee$export$2e2bcd8739ae039; });
function $4ff366e58c33ccee$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});




parcelRegister("fxy8a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b50469c0909a5344$export$2e2bcd8739ae039; });

var $8zxzx = parcelRequire("8zxzx");

var $h8HSd = parcelRequire("h8HSd");

var $6RzIO = parcelRequire("6RzIO");
var $b50469c0909a5344$var$MILLISECONDS_IN_DAY = 86400000;
function $b50469c0909a5344$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var startOfDayLeft = (0, $h8HSd.default)(dirtyDateLeft);
    var startOfDayRight = (0, $h8HSd.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $8zxzx.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $8zxzx.default)(startOfDayRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $b50469c0909a5344$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("8zxzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63dba254cf419de0$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $63dba254cf419de0$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("h8HSd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c7a5375f03b0a15d$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c7a5375f03b0a15d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("k0Sb0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e91dd50cc5cd7f0e$export$2e2bcd8739ae039; });

var $7pQzR = parcelRequire("7pQzR");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $3rsJw = parcelRequire("3rsJw");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $dCCOX = parcelRequire("dCCOX");

var $fhQJu = parcelRequire("fhQJu");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e91dd50cc5cd7f0e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e91dd50cc5cd7f0e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e91dd50cc5cd7f0e$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e91dd50cc5cd7f0e$var$doubleQuoteRegExp = /''/g;
var $e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e91dd50cc5cd7f0e$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $le96L.default)(dirtyDate);
    if (!(0, $7pQzR.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $8zxzx.default)(originalDate);
    var utcDate = (0, $cfoI5.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e91dd50cc5cd7f0e$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e91dd50cc5cd7f0e$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e91dd50cc5cd7f0e$var$cleanEscapedString(substring);
        var formatter = (0, $3rsJw.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(substring)) (0, $xRN1E.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e91dd50cc5cd7f0e$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e91dd50cc5cd7f0e$var$cleanEscapedString(input) {
    var matched = input.match($e91dd50cc5cd7f0e$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e91dd50cc5cd7f0e$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("7pQzR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5663a6fd5511e169$export$2e2bcd8739ae039; });

var $cmc1k = parcelRequire("cmc1k");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5663a6fd5511e169$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    if (!(0, $cmc1k.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $le96L.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("cmc1k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8ff0dd17621a97b7$export$2e2bcd8739ae039; });

var $6RzIO = parcelRequire("6RzIO");
function $8ff0dd17621a97b7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8ff0dd17621a97b7$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8ff0dd17621a97b7$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8ff0dd17621a97b7$var$_typeof(obj);
}
function $8ff0dd17621a97b7$export$2e2bcd8739ae039(value) {
    (0, $6RzIO.default)(1, arguments);
    return value instanceof Date || $8ff0dd17621a97b7$var$_typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("cfoI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8eaa0dace66c235b$export$2e2bcd8739ae039; });

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $8eaa0dace66c235b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, -amount);
}

});

parcelRegister("3rsJw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $281a2e82d409b287$export$2e2bcd8739ae039; });

var $iUfDY = parcelRequire("iUfDY");

var $9rMx7 = parcelRequire("9rMx7");

var $iymSi = parcelRequire("iymSi");

var $bCYgf = parcelRequire("bCYgf");

var $e0HMe = parcelRequire("e0HMe");

var $jOrUI = parcelRequire("jOrUI");

var $bDYa5 = parcelRequire("bDYa5");
var $281a2e82d409b287$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $281a2e82d409b287$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $bDYa5.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $e0HMe.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $jOrUI.default)(twoDigitYear, 2);
        } // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
         // Padding
        return (0, $jOrUI.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $iymSi.default)(date); // Padding
        return (0, $jOrUI.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $jOrUI.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $jOrUI.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $bDYa5.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $jOrUI.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $bCYgf.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $jOrUI.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $9rMx7.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $jOrUI.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $bDYa5.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iUfDY.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $jOrUI.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $jOrUI.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $jOrUI.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $jOrUI.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $281a2e82d409b287$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $bDYa5.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $bDYa5.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $jOrUI.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $bDYa5.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $bDYa5.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $bDYa5.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $281a2e82d409b287$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $281a2e82d409b287$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $jOrUI.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $jOrUI.default)(timestamp, token.length);
    }
};
function $281a2e82d409b287$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $jOrUI.default)(minutes, 2);
}
function $281a2e82d409b287$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $jOrUI.default)(Math.abs(offset) / 60, 2);
    }
    return $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter);
}
function $281a2e82d409b287$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $jOrUI.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $jOrUI.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $281a2e82d409b287$export$2e2bcd8739ae039 = $281a2e82d409b287$var$formatters;

});
parcelRegister("iUfDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc399780b2b0aec4$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
var $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY = 86400000;
function $dc399780b2b0aec4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dc399780b2b0aec4$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("9rMx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0c4858e45e9a69$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $byvVj = parcelRequire("byvVj");

var $60OYk = parcelRequire("60OYk");

var $6RzIO = parcelRequire("6RzIO");
var $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK = 604800000;
function $6e0c4858e45e9a69$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $byvVj.default)(date).getTime() - (0, $60OYk.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $6e0c4858e45e9a69$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("byvVj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $869ba20767f1348a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $869ba20767f1348a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("60OYk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $460a48298a6e483f$export$2e2bcd8739ae039; });

var $iymSi = parcelRequire("iymSi");

var $byvVj = parcelRequire("byvVj");

var $6RzIO = parcelRequire("6RzIO");
function $460a48298a6e483f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var year = (0, $iymSi.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $byvVj.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("iymSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d81d25690b2c97ba$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $byvVj = parcelRequire("byvVj");
function $d81d25690b2c97ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $byvVj.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $byvVj.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bCYgf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8771fceed12cf89e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $j1YKz = parcelRequire("j1YKz");

var $2yvSN = parcelRequire("2yvSN");

var $6RzIO = parcelRequire("6RzIO");
var $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK = 604800000;
function $8771fceed12cf89e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $j1YKz.default)(date, options).getTime() - (0, $2yvSN.default)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $8771fceed12cf89e$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("j1YKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddad3c02657f84fd$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $ddad3c02657f84fd$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("dCCOX", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $9eacf000ef47a2dd$export$430a3269e24b912e; });
var $9eacf000ef47a2dd$var$defaultOptions = {};
function $9eacf000ef47a2dd$export$430a3269e24b912e() {
    return $9eacf000ef47a2dd$var$defaultOptions;
}
function $9eacf000ef47a2dd$export$95365be1b0704abc(newOptions) {
    $9eacf000ef47a2dd$var$defaultOptions = newOptions;
}

});


parcelRegister("2yvSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1dc77d031b6877e7$export$2e2bcd8739ae039; });

var $e0HMe = parcelRequire("e0HMe");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $1dc77d031b6877e7$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $e0HMe.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $j1YKz.default)(firstWeek, options);
    return date;
}

});
parcelRegister("e0HMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a33305f247e30adc$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $j1YKz = parcelRequire("j1YKz");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $a33305f247e30adc$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $j1YKz.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $j1YKz.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("jOrUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6c856ebc9ae82ee$export$2e2bcd8739ae039; });
function $e6c856ebc9ae82ee$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("bDYa5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87a2011828c90e33$export$2e2bcd8739ae039; });

var $jOrUI = parcelRequire("jOrUI");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $87a2011828c90e33$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $jOrUI.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $jOrUI.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $jOrUI.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $jOrUI.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $jOrUI.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $jOrUI.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $jOrUI.default)(fractionalSeconds, token.length);
    }
};
var $87a2011828c90e33$export$2e2bcd8739ae039 = $87a2011828c90e33$var$formatters;

});


parcelRegister("dmQbx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9bb5cf506dd06653$export$2e2bcd8739ae039; });
var $9bb5cf506dd06653$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $9bb5cf506dd06653$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $9bb5cf506dd06653$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $9bb5cf506dd06653$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $9bb5cf506dd06653$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $9bb5cf506dd06653$var$timeLongFormatter(timePattern, formatLong));
};
var $9bb5cf506dd06653$var$longFormatters = {
    p: $9bb5cf506dd06653$var$timeLongFormatter,
    P: $9bb5cf506dd06653$var$dateTimeLongFormatter
};
var $9bb5cf506dd06653$export$2e2bcd8739ae039 = $9bb5cf506dd06653$var$longFormatters;

});

parcelRegister("xRN1E", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $065cceb4149e3fc5$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $065cceb4149e3fc5$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $065cceb4149e3fc5$export$8073c1ae88f0e727; });
var $065cceb4149e3fc5$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $065cceb4149e3fc5$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $065cceb4149e3fc5$export$c6cc36aa33304772(token) {
    return $065cceb4149e3fc5$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$c6b49d6dceb604a1(token) {
    return $065cceb4149e3fc5$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $065cceb4149e3fc5$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("fhQJu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b211592c26324d97$export$2e2bcd8739ae039; });

var $eG059 = parcelRequire("eG059");
var $b211592c26324d97$export$2e2bcd8739ae039 = (0, $eG059.default);

});
parcelRegister("eG059", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aaf50d37016ddcb1$export$2e2bcd8739ae039; });

var $bvM2P = parcelRequire("bvM2P");

var $haCAZ = parcelRequire("haCAZ");

var $AVlzc = parcelRequire("AVlzc");

var $eiIUR = parcelRequire("eiIUR");

var $8rsbS = parcelRequire("8rsbS");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $aaf50d37016ddcb1$var$locale = {
    code: 'en-US',
    formatDistance: (0, $bvM2P.default),
    formatLong: (0, $haCAZ.default),
    formatRelative: (0, $AVlzc.default),
    localize: (0, $eiIUR.default),
    match: (0, $8rsbS.default),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $aaf50d37016ddcb1$export$2e2bcd8739ae039 = $aaf50d37016ddcb1$var$locale;

});
parcelRegister("bvM2P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8617db99f2cb39a3$export$2e2bcd8739ae039; });
var $8617db99f2cb39a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $8617db99f2cb39a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8617db99f2cb39a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $8617db99f2cb39a3$export$2e2bcd8739ae039 = $8617db99f2cb39a3$var$formatDistance;

});

parcelRegister("haCAZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8014f25de2be27f$export$2e2bcd8739ae039; });

var $lbh04 = parcelRequire("lbh04");
var $c8014f25de2be27f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $c8014f25de2be27f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $c8014f25de2be27f$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c8014f25de2be27f$var$formatLong = {
    date: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $lbh04.default)({
        formats: $c8014f25de2be27f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c8014f25de2be27f$export$2e2bcd8739ae039 = $c8014f25de2be27f$var$formatLong;

});
parcelRegister("lbh04", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b7cff3d084a1cf$export$2e2bcd8739ae039; });
function $f6b7cff3d084a1cf$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("AVlzc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06efd8cc10c4bd73$export$2e2bcd8739ae039; });
var $06efd8cc10c4bd73$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $06efd8cc10c4bd73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $06efd8cc10c4bd73$var$formatRelativeLocale[token];
};
var $06efd8cc10c4bd73$export$2e2bcd8739ae039 = $06efd8cc10c4bd73$var$formatRelative;

});

parcelRegister("eiIUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6959687464919d6$export$2e2bcd8739ae039; });

var $jZkn4 = parcelRequire("jZkn4");
var $a6959687464919d6$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $a6959687464919d6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a6959687464919d6$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $a6959687464919d6$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $a6959687464919d6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $a6959687464919d6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $a6959687464919d6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $a6959687464919d6$var$localize = {
    ordinalNumber: $a6959687464919d6$var$ordinalNumber,
    era: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $jZkn4.default)({
        values: $a6959687464919d6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a6959687464919d6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a6959687464919d6$export$2e2bcd8739ae039 = $a6959687464919d6$var$localize;

});
parcelRegister("jZkn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8d3841961a689fd$export$2e2bcd8739ae039; });
function $e8d3841961a689fd$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("8rsbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6256b66dca390462$export$2e2bcd8739ae039; });

var $gcy5I = parcelRequire("gcy5I");

var $jChsd = parcelRequire("jChsd");
var $6256b66dca390462$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $6256b66dca390462$var$parseOrdinalNumberPattern = /\d+/i;
var $6256b66dca390462$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $6256b66dca390462$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $6256b66dca390462$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $6256b66dca390462$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6256b66dca390462$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $6256b66dca390462$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6256b66dca390462$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $6256b66dca390462$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6256b66dca390462$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $6256b66dca390462$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $6256b66dca390462$var$match = {
    ordinalNumber: (0, $jChsd.default)({
        matchPattern: $6256b66dca390462$var$matchOrdinalNumberPattern,
        parsePattern: $6256b66dca390462$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6256b66dca390462$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gcy5I.default)({
        matchPatterns: $6256b66dca390462$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6256b66dca390462$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6256b66dca390462$export$2e2bcd8739ae039 = $6256b66dca390462$var$match;

});
parcelRegister("gcy5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bcb83626ff750417$export$2e2bcd8739ae039; });
function $bcb83626ff750417$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $bcb83626ff750417$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $bcb83626ff750417$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $bcb83626ff750417$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $bcb83626ff750417$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("jChsd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03af782d2d1fcb5a$export$2e2bcd8739ae039; });
function $03af782d2d1fcb5a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("igItr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d4cc3831797a4057$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d4cc3831797a4057$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("hBud4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cd0d536eff711dcf$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $cd0d536eff711dcf$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var hours = (0, $8d3vD.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("kzEvi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $efa67eb820959ebb$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $efa67eb820959ebb$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var minutes = (0, $8d3vD.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("j1vsN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $dd968448a852b241$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $dd968448a852b241$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var seconds = (0, $8d3vD.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("lW2XZ", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return getIn; });
$parcel$export(module.exports, "FormikContext", function () { return FormikContext; });
$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "useField", function () { return useField; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "ErrorMessage", function () { return ErrorMessage; });

var $bh6RR = parcelRequire("bh6RR");

var $4y4jn = parcelRequire("4y4jn");

var $kEUSt = parcelRequire("kEUSt");

var $eCVt1 = parcelRequire("eCVt1");

var $77si3 = parcelRequire("77si3");

var $hUHCH = parcelRequire("hUHCH");

var $bKo8Q = parcelRequire("bKo8Q");

var $adG4d = parcelRequire("adG4d");

var $26oc5 = parcelRequire("26oc5");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $bh6RR.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $hUHCH.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $77si3.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $hUHCH.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $77si3.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
var FormikContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $bh6RR.useContext)(FormikContext);
    !!!formik && (0, $bKo8Q.default)(false);
    return formik;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $bh6RR.useRef)(props.initialValues);
    var initialErrors = (0, $bh6RR.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $bh6RR.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $bh6RR.useRef)(props.initialStatus);
    var isMounted = (0, $bh6RR.useRef)(false);
    var fieldRegistry = (0, $bh6RR.useRef)({});
    (0, $bh6RR.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useReducer = (0, $bh6RR.useReducer)(formikReducer, {
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    }), state = _React$useReducer[0], dispatch = _React$useReducer[1];
    var runValidateHandler = (0, $bh6RR.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $bh6RR.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $bh6RR.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $bh6RR.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $bh6RR.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $kEUSt.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $bh6RR.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $bh6RR.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
            }
            if (validateOnMount) validateFormWithHighPriority(initialValues.current);
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $bh6RR.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: error[name]
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $bh6RR.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $bh6RR.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $bh6RR.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $bh6RR.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $bh6RR.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            field;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $bh6RR.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        field;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $bh6RR.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $bh6RR.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $bh6RR.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $bh6RR.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $bh6RR.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $bh6RR.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $bh6RR.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $bh6RR.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $bh6RR.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $bh6RR.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $bh6RR.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $bh6RR.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    if (context === void 0) context = {};
    var validateData = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](validateData, {
        abortEarly: false,
        context: context
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $eCVt1.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $eCVt1.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $kEUSt.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $kEUSt.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
function useEventCallback(fn) {
    var ref = (0, $bh6RR.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $bh6RR.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $bh6RR.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $bKo8Q.default)(false);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        getFieldHelpers(fieldName)
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $bh6RR.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $bh6RR.createElement)(component, _extends({
                ref: innerRef
            }, field, rest), children);
        } // We don't pass `meta` for backwards compat
        return (0, $bh6RR.createElement)(component, _extends({
            field: field,
            form: formik
        }, props), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $bh6RR.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest), children);
    }
    return (0, $bh6RR.createElement)(asElement, _extends({}, field, props), children);
}
var Form = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $bh6RR.createElement)("form", Object.assign({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                _this = _React$Component.apply(this, arguments) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                /**
         * Just avoiding a render callback for perf here
         */ _this.renderFormComponent = function(formikProps) {
                    return (0, $bh6RR.createElement)(Component$1, Object.assign({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $bh6RR.createElement)(Formik, Object.assign({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $bh6RR.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $bh6RR.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $bKo8Q.default)(false);
            return (0, $bh6RR.createElement)(Comp, Object.assign({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($adG4d)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
                var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $26oc5.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            }, function(array) {
                var arr = array ? [
                    null
                ].concat(array) : [
                    null
                ];
                if (length < 0) length = arr.length;
                return arr;
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        }; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($4y4jn)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
            return copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array;
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $bh6RR.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $bh6RR.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $bh6RR.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $bh6RR.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $bh6RR.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $bKo8Q.default)(false);
        !!(component && render) && (0, $bKo8Q.default)(false);
        !!(is && children && isFunction(children)) && (0, $bKo8Q.default)(false);
        !!(component && children && isFunction(children)) && (0, $bKo8Q.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $bKo8Q.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $bh6RR.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $bh6RR.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $bh6RR.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $bh6RR.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $bh6RR.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("4y4jn", function(module, exports) {
'use strict';
var $34fdae974607be90$var$isArray = Array.isArray;
var $34fdae974607be90$var$keyList = Object.keys;
var $34fdae974607be90$var$hasProp = Object.prototype.hasOwnProperty;
var $34fdae974607be90$var$hasElementType = typeof Element !== 'undefined';
function $34fdae974607be90$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $34fdae974607be90$var$isArray(a), arrB = $34fdae974607be90$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$34fdae974607be90$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $34fdae974607be90$var$keyList(a);
        length = keys.length;
        if (length !== $34fdae974607be90$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$34fdae974607be90$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($34fdae974607be90$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$34fdae974607be90$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $34fdae974607be90$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("kEUSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0a3a9c1ee8e066f$export$2e2bcd8739ae039; });
var $f0a3a9c1ee8e066f$var$isMergeableObject = function isMergeableObject(value) {
    return $f0a3a9c1ee8e066f$var$isNonNullObject(value) && !$f0a3a9c1ee8e066f$var$isSpecial(value);
};
function $f0a3a9c1ee8e066f$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $f0a3a9c1ee8e066f$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $f0a3a9c1ee8e066f$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $f0a3a9c1ee8e066f$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $f0a3a9c1ee8e066f$var$REACT_ELEMENT_TYPE = $f0a3a9c1ee8e066f$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $f0a3a9c1ee8e066f$var$isReactElement(value) {
    return value.$$typeof === $f0a3a9c1ee8e066f$var$REACT_ELEMENT_TYPE;
}
function $f0a3a9c1ee8e066f$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $f0a3a9c1ee8e066f$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $f0a3a9c1ee8e066f$var$deepmerge($f0a3a9c1ee8e066f$var$emptyTarget(value), value, options) : value;
}
function $f0a3a9c1ee8e066f$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $f0a3a9c1ee8e066f$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $f0a3a9c1ee8e066f$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $f0a3a9c1ee8e066f$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $f0a3a9c1ee8e066f$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $f0a3a9c1ee8e066f$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $f0a3a9c1ee8e066f$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $f0a3a9c1ee8e066f$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $f0a3a9c1ee8e066f$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $f0a3a9c1ee8e066f$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $f0a3a9c1ee8e066f$var$mergeObject(target, source, options);
}
$f0a3a9c1ee8e066f$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $f0a3a9c1ee8e066f$var$deepmerge(prev, next, options);
    }, {});
};
var $f0a3a9c1ee8e066f$var$deepmerge_1 = $f0a3a9c1ee8e066f$var$deepmerge;
var $f0a3a9c1ee8e066f$export$2e2bcd8739ae039 = $f0a3a9c1ee8e066f$var$deepmerge_1;

});

parcelRegister("eCVt1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa61311201be6269$export$2e2bcd8739ae039; });

var $8qlH6 = parcelRequire("8qlH6");

var $2SuGb = parcelRequire("2SuGb");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $aa61311201be6269$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $aa61311201be6269$var$funcProto = Function.prototype, $aa61311201be6269$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aa61311201be6269$var$funcToString = $aa61311201be6269$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aa61311201be6269$var$hasOwnProperty = $aa61311201be6269$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aa61311201be6269$var$objectCtorString = $aa61311201be6269$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aa61311201be6269$var$isPlainObject(value) {
    if (!(0, $d2dL4.default)(value) || (0, $8qlH6.default)(value) != $aa61311201be6269$var$objectTag) return false;
    var proto = (0, $2SuGb.default)(value);
    if (proto === null) return true;
    var Ctor = $aa61311201be6269$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $aa61311201be6269$var$funcToString.call(Ctor) == $aa61311201be6269$var$objectCtorString;
}
var $aa61311201be6269$export$2e2bcd8739ae039 = $aa61311201be6269$var$isPlainObject;

});
parcelRegister("8qlH6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $622194736393697a$export$2e2bcd8739ae039; });

var $1ln2D = parcelRequire("1ln2D");

var $fRmFJ = parcelRequire("fRmFJ");

var $1IxrF = parcelRequire("1IxrF");
/** `Object#toString` result references. */ var $622194736393697a$var$nullTag = '[object Null]', $622194736393697a$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $622194736393697a$var$symToStringTag = (0, $1ln2D.default) ? (0, $1ln2D.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $622194736393697a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $622194736393697a$var$undefinedTag : $622194736393697a$var$nullTag;
    return $622194736393697a$var$symToStringTag && $622194736393697a$var$symToStringTag in Object(value) ? (0, $fRmFJ.default)(value) : (0, $1IxrF.default)(value);
}
var $622194736393697a$export$2e2bcd8739ae039 = $622194736393697a$var$baseGetTag;

});
parcelRegister("1ln2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fa9a02f9756f657$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $0fa9a02f9756f657$var$Symbol = (0, $6AhZS.default).Symbol;
var $0fa9a02f9756f657$export$2e2bcd8739ae039 = $0fa9a02f9756f657$var$Symbol;

});
parcelRegister("6AhZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb410b494b5bfba$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `self`. */ var $4cb410b494b5bfba$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4cb410b494b5bfba$var$root = (0, $g6iKt.default) || $4cb410b494b5bfba$var$freeSelf || Function('return this')();
var $4cb410b494b5bfba$export$2e2bcd8739ae039 = $4cb410b494b5bfba$var$root;

});
parcelRegister("g6iKt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8bbff47a3b420b$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $bb8bbff47a3b420b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bb8bbff47a3b420b$export$2e2bcd8739ae039 = $bb8bbff47a3b420b$var$freeGlobal;

});



parcelRegister("fRmFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8bd64751e10f60b$export$2e2bcd8739ae039; });

var $1ln2D = parcelRequire("1ln2D");
/** Used for built-in method references. */ var $b8bd64751e10f60b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8bd64751e10f60b$var$hasOwnProperty = $b8bd64751e10f60b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b8bd64751e10f60b$var$nativeObjectToString = $b8bd64751e10f60b$var$objectProto.toString;
/** Built-in value references. */ var $b8bd64751e10f60b$var$symToStringTag = (0, $1ln2D.default) ? (0, $1ln2D.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b8bd64751e10f60b$var$getRawTag(value) {
    var isOwn = $b8bd64751e10f60b$var$hasOwnProperty.call(value, $b8bd64751e10f60b$var$symToStringTag), tag = value[$b8bd64751e10f60b$var$symToStringTag];
    try {
        value[$b8bd64751e10f60b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b8bd64751e10f60b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b8bd64751e10f60b$var$symToStringTag] = tag;
        else delete value[$b8bd64751e10f60b$var$symToStringTag];
    }
    return result;
}
var $b8bd64751e10f60b$export$2e2bcd8739ae039 = $b8bd64751e10f60b$var$getRawTag;

});

parcelRegister("1IxrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1403d80719b32f26$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $1403d80719b32f26$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1403d80719b32f26$var$nativeObjectToString = $1403d80719b32f26$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1403d80719b32f26$var$objectToString(value) {
    return $1403d80719b32f26$var$nativeObjectToString.call(value);
}
var $1403d80719b32f26$export$2e2bcd8739ae039 = $1403d80719b32f26$var$objectToString;

});


parcelRegister("2SuGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21886c33f3299694$export$2e2bcd8739ae039; });

var $6mQFg = parcelRequire("6mQFg");
/** Built-in value references. */ var $21886c33f3299694$var$getPrototype = (0, $6mQFg.default)(Object.getPrototypeOf, Object);
var $21886c33f3299694$export$2e2bcd8739ae039 = $21886c33f3299694$var$getPrototype;

});
parcelRegister("6mQFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a2da63f82711215$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4a2da63f82711215$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $4a2da63f82711215$export$2e2bcd8739ae039 = $4a2da63f82711215$var$overArg;

});


parcelRegister("d2dL4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97d6226034a0ca4f$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97d6226034a0ca4f$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $97d6226034a0ca4f$export$2e2bcd8739ae039 = $97d6226034a0ca4f$var$isObjectLike;

});


parcelRegister("77si3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52ef21b016ef7197$export$2e2bcd8739ae039; });

var $fLqrY = parcelRequire("fLqrY");
/** Used to compose bitmasks for cloning. */ var $52ef21b016ef7197$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $52ef21b016ef7197$var$clone(value) {
    return (0, $fLqrY.default)(value, $52ef21b016ef7197$var$CLONE_SYMBOLS_FLAG);
}
var $52ef21b016ef7197$export$2e2bcd8739ae039 = $52ef21b016ef7197$var$clone;

});
parcelRegister("fLqrY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02f63091ab584fe8$export$2e2bcd8739ae039; });

var $bW4ry = parcelRequire("bW4ry");

var $6JjSi = parcelRequire("6JjSi");

var $9JQRP = parcelRequire("9JQRP");

var $7CJoo = parcelRequire("7CJoo");

var $8kTkC = parcelRequire("8kTkC");

var $bcoTo = parcelRequire("bcoTo");

var $8nk1V = parcelRequire("8nk1V");

var $6GTQF = parcelRequire("6GTQF");

var $135Ea = parcelRequire("135Ea");

var $hhRWj = parcelRequire("hhRWj");

var $9j2XF = parcelRequire("9j2XF");

var $8eYI3 = parcelRequire("8eYI3");

var $bRMCu = parcelRequire("bRMCu");

var $iis7A = parcelRequire("iis7A");

var $47zBg = parcelRequire("47zBg");

var $d8gzz = parcelRequire("d8gzz");

var $h0k3u = parcelRequire("h0k3u");

var $jZ68t = parcelRequire("jZ68t");

var $1tXpJ = parcelRequire("1tXpJ");

var $cbtCS = parcelRequire("cbtCS");

var $TRanc = parcelRequire("TRanc");

var $b1vZg = parcelRequire("b1vZg");
/** Used to compose bitmasks for cloning. */ var $02f63091ab584fe8$var$CLONE_DEEP_FLAG = 1, $02f63091ab584fe8$var$CLONE_FLAT_FLAG = 2, $02f63091ab584fe8$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $02f63091ab584fe8$var$argsTag = '[object Arguments]', $02f63091ab584fe8$var$arrayTag = '[object Array]', $02f63091ab584fe8$var$boolTag = '[object Boolean]', $02f63091ab584fe8$var$dateTag = '[object Date]', $02f63091ab584fe8$var$errorTag = '[object Error]', $02f63091ab584fe8$var$funcTag = '[object Function]', $02f63091ab584fe8$var$genTag = '[object GeneratorFunction]', $02f63091ab584fe8$var$mapTag = '[object Map]', $02f63091ab584fe8$var$numberTag = '[object Number]', $02f63091ab584fe8$var$objectTag = '[object Object]', $02f63091ab584fe8$var$regexpTag = '[object RegExp]', $02f63091ab584fe8$var$setTag = '[object Set]', $02f63091ab584fe8$var$stringTag = '[object String]', $02f63091ab584fe8$var$symbolTag = '[object Symbol]', $02f63091ab584fe8$var$weakMapTag = '[object WeakMap]';
var $02f63091ab584fe8$var$arrayBufferTag = '[object ArrayBuffer]', $02f63091ab584fe8$var$dataViewTag = '[object DataView]', $02f63091ab584fe8$var$float32Tag = '[object Float32Array]', $02f63091ab584fe8$var$float64Tag = '[object Float64Array]', $02f63091ab584fe8$var$int8Tag = '[object Int8Array]', $02f63091ab584fe8$var$int16Tag = '[object Int16Array]', $02f63091ab584fe8$var$int32Tag = '[object Int32Array]', $02f63091ab584fe8$var$uint8Tag = '[object Uint8Array]', $02f63091ab584fe8$var$uint8ClampedTag = '[object Uint8ClampedArray]', $02f63091ab584fe8$var$uint16Tag = '[object Uint16Array]', $02f63091ab584fe8$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $02f63091ab584fe8$var$cloneableTags = {};
$02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$argsTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$arrayTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$arrayBufferTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$dataViewTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$boolTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$dateTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$float32Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$float64Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$int8Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$int16Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$int32Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$mapTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$numberTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$objectTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$regexpTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$setTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$stringTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$symbolTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$uint8Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$uint8ClampedTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$uint16Tag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$uint32Tag] = true;
$02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$errorTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$funcTag] = $02f63091ab584fe8$var$cloneableTags[$02f63091ab584fe8$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $02f63091ab584fe8$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $02f63091ab584fe8$var$CLONE_DEEP_FLAG, isFlat = bitmask & $02f63091ab584fe8$var$CLONE_FLAT_FLAG, isFull = bitmask & $02f63091ab584fe8$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $1tXpJ.default)(value)) return value;
    var isArr = (0, $d8gzz.default)(value);
    if (isArr) {
        result = (0, $bRMCu.default)(value);
        if (!isDeep) return (0, $8nk1V.default)(value, result);
    } else {
        var tag = (0, $8eYI3.default)(value), isFunc = tag == $02f63091ab584fe8$var$funcTag || tag == $02f63091ab584fe8$var$genTag;
        if ((0, $h0k3u.default)(value)) return (0, $bcoTo.default)(value, isDeep);
        if (tag == $02f63091ab584fe8$var$objectTag || tag == $02f63091ab584fe8$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $47zBg.default)(value);
            if (!isDeep) return isFlat ? (0, $135Ea.default)(value, (0, $8kTkC.default)(result, value)) : (0, $6GTQF.default)(value, (0, $7CJoo.default)(result, value));
        } else {
            if (!$02f63091ab584fe8$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iis7A.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $bW4ry.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $cbtCS.default)(value)) value.forEach(function(subValue) {
        result.add($02f63091ab584fe8$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $jZ68t.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $02f63091ab584fe8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $9j2XF.default) : (0, $hhRWj.default) : isFlat ? (0, $b1vZg.default) : (0, $TRanc.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $6JjSi.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $9JQRP.default)(result, key, $02f63091ab584fe8$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $02f63091ab584fe8$export$2e2bcd8739ae039 = $02f63091ab584fe8$var$baseClone;

});
parcelRegister("bW4ry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b088ed672f4e479$export$2e2bcd8739ae039; });

var $1gEvW = parcelRequire("1gEvW");

var $euNXB = parcelRequire("euNXB");

var $lEoyZ = parcelRequire("lEoyZ");

var $7ZIzO = parcelRequire("7ZIzO");

var $6UepC = parcelRequire("6UepC");

var $8rqIh = parcelRequire("8rqIh");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8b088ed672f4e479$var$Stack(entries) {
    var data = this.__data__ = new (0, $1gEvW.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8b088ed672f4e479$var$Stack.prototype.clear = (0, $euNXB.default);
$8b088ed672f4e479$var$Stack.prototype['delete'] = (0, $lEoyZ.default);
$8b088ed672f4e479$var$Stack.prototype.get = (0, $7ZIzO.default);
$8b088ed672f4e479$var$Stack.prototype.has = (0, $6UepC.default);
$8b088ed672f4e479$var$Stack.prototype.set = (0, $8rqIh.default);
var $8b088ed672f4e479$export$2e2bcd8739ae039 = $8b088ed672f4e479$var$Stack;

});
parcelRegister("1gEvW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ec6b653931e70c0$export$2e2bcd8739ae039; });

var $7DMoc = parcelRequire("7DMoc");

var $9N71y = parcelRequire("9N71y");

var $9xhsp = parcelRequire("9xhsp");

var $cVyfW = parcelRequire("cVyfW");

var $4EtG9 = parcelRequire("4EtG9");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0ec6b653931e70c0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0ec6b653931e70c0$var$ListCache.prototype.clear = (0, $7DMoc.default);
$0ec6b653931e70c0$var$ListCache.prototype['delete'] = (0, $9N71y.default);
$0ec6b653931e70c0$var$ListCache.prototype.get = (0, $9xhsp.default);
$0ec6b653931e70c0$var$ListCache.prototype.has = (0, $cVyfW.default);
$0ec6b653931e70c0$var$ListCache.prototype.set = (0, $4EtG9.default);
var $0ec6b653931e70c0$export$2e2bcd8739ae039 = $0ec6b653931e70c0$var$ListCache;

});
parcelRegister("7DMoc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5901b603012da595$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5901b603012da595$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $5901b603012da595$export$2e2bcd8739ae039 = $5901b603012da595$var$listCacheClear;

});

parcelRegister("9N71y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $720e237c00c1b03f$export$2e2bcd8739ae039; });

var $kkT63 = parcelRequire("kkT63");
/** Used for built-in method references. */ var $720e237c00c1b03f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $720e237c00c1b03f$var$splice = $720e237c00c1b03f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $720e237c00c1b03f$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $kkT63.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $720e237c00c1b03f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $720e237c00c1b03f$export$2e2bcd8739ae039 = $720e237c00c1b03f$var$listCacheDelete;

});
parcelRegister("kkT63", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ece069ed9bfec089$export$2e2bcd8739ae039; });

var $393Ci = parcelRequire("393Ci");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ece069ed9bfec089$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $393Ci.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ece069ed9bfec089$export$2e2bcd8739ae039 = $ece069ed9bfec089$var$assocIndexOf;

});
parcelRegister("393Ci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24a50494b56303fa$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $24a50494b56303fa$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $24a50494b56303fa$export$2e2bcd8739ae039 = $24a50494b56303fa$var$eq;

});



parcelRegister("9xhsp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f14bcc7444cf375$export$2e2bcd8739ae039; });

var $kkT63 = parcelRequire("kkT63");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6f14bcc7444cf375$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $kkT63.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $6f14bcc7444cf375$export$2e2bcd8739ae039 = $6f14bcc7444cf375$var$listCacheGet;

});

parcelRegister("cVyfW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9695617145d17fca$export$2e2bcd8739ae039; });

var $kkT63 = parcelRequire("kkT63");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9695617145d17fca$var$listCacheHas(key) {
    return (0, $kkT63.default)(this.__data__, key) > -1;
}
var $9695617145d17fca$export$2e2bcd8739ae039 = $9695617145d17fca$var$listCacheHas;

});

parcelRegister("4EtG9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3631eb7360761131$export$2e2bcd8739ae039; });

var $kkT63 = parcelRequire("kkT63");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3631eb7360761131$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $kkT63.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $3631eb7360761131$export$2e2bcd8739ae039 = $3631eb7360761131$var$listCacheSet;

});


parcelRegister("euNXB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8da9f1850418a97$export$2e2bcd8739ae039; });

var $1gEvW = parcelRequire("1gEvW");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a8da9f1850418a97$var$stackClear() {
    this.__data__ = new (0, $1gEvW.default);
    this.size = 0;
}
var $a8da9f1850418a97$export$2e2bcd8739ae039 = $a8da9f1850418a97$var$stackClear;

});

parcelRegister("lEoyZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc3063294f0985d4$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fc3063294f0985d4$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $fc3063294f0985d4$export$2e2bcd8739ae039 = $fc3063294f0985d4$var$stackDelete;

});

parcelRegister("7ZIzO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d20cedfc2997602$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5d20cedfc2997602$var$stackGet(key) {
    return this.__data__.get(key);
}
var $5d20cedfc2997602$export$2e2bcd8739ae039 = $5d20cedfc2997602$var$stackGet;

});

parcelRegister("6UepC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $507326fb3b1993fe$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $507326fb3b1993fe$var$stackHas(key) {
    return this.__data__.has(key);
}
var $507326fb3b1993fe$export$2e2bcd8739ae039 = $507326fb3b1993fe$var$stackHas;

});

parcelRegister("8rqIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62559106803ce443$export$2e2bcd8739ae039; });

var $1gEvW = parcelRequire("1gEvW");

var $3o8E7 = parcelRequire("3o8E7");

var $gkT4m = parcelRequire("gkT4m");
/** Used as the size to enable large array optimizations. */ var $62559106803ce443$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $62559106803ce443$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $1gEvW.default)) {
        var pairs = data.__data__;
        if (!(0, $3o8E7.default) || pairs.length < $62559106803ce443$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $gkT4m.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $62559106803ce443$export$2e2bcd8739ae039 = $62559106803ce443$var$stackSet;

});
parcelRegister("3o8E7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $277a51f176965052$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");

var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $277a51f176965052$var$Map = (0, $jJGP0.default)((0, $6AhZS.default), 'Map');
var $277a51f176965052$export$2e2bcd8739ae039 = $277a51f176965052$var$Map;

});
parcelRegister("jJGP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e36fcd795e94d7$export$2e2bcd8739ae039; });

var $43xz4 = parcelRequire("43xz4");

var $jz8Vg = parcelRequire("jz8Vg");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e5e36fcd795e94d7$var$getNative(object, key) {
    var value = (0, $jz8Vg.default)(object, key);
    return (0, $43xz4.default)(value) ? value : undefined;
}
var $e5e36fcd795e94d7$export$2e2bcd8739ae039 = $e5e36fcd795e94d7$var$getNative;

});
parcelRegister("43xz4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f417a79d5f65102$export$2e2bcd8739ae039; });

var $cc5PI = parcelRequire("cc5PI");

var $bYPjw = parcelRequire("bYPjw");

var $1tXpJ = parcelRequire("1tXpJ");

var $c3L0V = parcelRequire("c3L0V");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2f417a79d5f65102$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2f417a79d5f65102$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2f417a79d5f65102$var$funcProto = Function.prototype, $2f417a79d5f65102$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2f417a79d5f65102$var$funcToString = $2f417a79d5f65102$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2f417a79d5f65102$var$hasOwnProperty = $2f417a79d5f65102$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2f417a79d5f65102$var$reIsNative = RegExp('^' + $2f417a79d5f65102$var$funcToString.call($2f417a79d5f65102$var$hasOwnProperty).replace($2f417a79d5f65102$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2f417a79d5f65102$var$baseIsNative(value) {
    if (!(0, $1tXpJ.default)(value) || (0, $bYPjw.default)(value)) return false;
    var pattern = (0, $cc5PI.default)(value) ? $2f417a79d5f65102$var$reIsNative : $2f417a79d5f65102$var$reIsHostCtor;
    return pattern.test((0, $c3L0V.default)(value));
}
var $2f417a79d5f65102$export$2e2bcd8739ae039 = $2f417a79d5f65102$var$baseIsNative;

});
parcelRegister("cc5PI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e0b215b91f51a44$export$2e2bcd8739ae039; });

var $8qlH6 = parcelRequire("8qlH6");

var $1tXpJ = parcelRequire("1tXpJ");
/** `Object#toString` result references. */ var $8e0b215b91f51a44$var$asyncTag = '[object AsyncFunction]', $8e0b215b91f51a44$var$funcTag = '[object Function]', $8e0b215b91f51a44$var$genTag = '[object GeneratorFunction]', $8e0b215b91f51a44$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8e0b215b91f51a44$var$isFunction(value) {
    if (!(0, $1tXpJ.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $8qlH6.default)(value);
    return tag == $8e0b215b91f51a44$var$funcTag || tag == $8e0b215b91f51a44$var$genTag || tag == $8e0b215b91f51a44$var$asyncTag || tag == $8e0b215b91f51a44$var$proxyTag;
}
var $8e0b215b91f51a44$export$2e2bcd8739ae039 = $8e0b215b91f51a44$var$isFunction;

});
parcelRegister("1tXpJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1146963f863a9576$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1146963f863a9576$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $1146963f863a9576$export$2e2bcd8739ae039 = $1146963f863a9576$var$isObject;

});


parcelRegister("bYPjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b8d1a3043bd607a$export$2e2bcd8739ae039; });

var $3TuwC = parcelRequire("3TuwC");
/** Used to detect methods masquerading as native. */ var $8b8d1a3043bd607a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $3TuwC.default) && (0, $3TuwC.default).keys && (0, $3TuwC.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8b8d1a3043bd607a$var$isMasked(func) {
    return !!$8b8d1a3043bd607a$var$maskSrcKey && $8b8d1a3043bd607a$var$maskSrcKey in func;
}
var $8b8d1a3043bd607a$export$2e2bcd8739ae039 = $8b8d1a3043bd607a$var$isMasked;

});
parcelRegister("3TuwC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d5e2fcca347b6df$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Used to detect overreaching core-js shims. */ var $2d5e2fcca347b6df$var$coreJsData = (0, $6AhZS.default)['__core-js_shared__'];
var $2d5e2fcca347b6df$export$2e2bcd8739ae039 = $2d5e2fcca347b6df$var$coreJsData;

});


parcelRegister("c3L0V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c7a3bd26fa17d1b$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $8c7a3bd26fa17d1b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $8c7a3bd26fa17d1b$var$funcToString = $8c7a3bd26fa17d1b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $8c7a3bd26fa17d1b$var$toSource(func) {
    if (func != null) {
        try {
            return $8c7a3bd26fa17d1b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $8c7a3bd26fa17d1b$export$2e2bcd8739ae039 = $8c7a3bd26fa17d1b$var$toSource;

});


parcelRegister("jz8Vg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3e8350a409520b9$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e3e8350a409520b9$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e3e8350a409520b9$export$2e2bcd8739ae039 = $e3e8350a409520b9$var$getValue;

});



parcelRegister("gkT4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be493b3f39c647b0$export$2e2bcd8739ae039; });

var $fcodw = parcelRequire("fcodw");

var $lTxpG = parcelRequire("lTxpG");

var $ahCHp = parcelRequire("ahCHp");

var $j0y7H = parcelRequire("j0y7H");

var $5myQO = parcelRequire("5myQO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $be493b3f39c647b0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$be493b3f39c647b0$var$MapCache.prototype.clear = (0, $fcodw.default);
$be493b3f39c647b0$var$MapCache.prototype['delete'] = (0, $lTxpG.default);
$be493b3f39c647b0$var$MapCache.prototype.get = (0, $ahCHp.default);
$be493b3f39c647b0$var$MapCache.prototype.has = (0, $j0y7H.default);
$be493b3f39c647b0$var$MapCache.prototype.set = (0, $5myQO.default);
var $be493b3f39c647b0$export$2e2bcd8739ae039 = $be493b3f39c647b0$var$MapCache;

});
parcelRegister("fcodw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b10ac3021210b27d$export$2e2bcd8739ae039; });

var $4qsM3 = parcelRequire("4qsM3");

var $1gEvW = parcelRequire("1gEvW");

var $3o8E7 = parcelRequire("3o8E7");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b10ac3021210b27d$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $4qsM3.default),
        'map': new ((0, $3o8E7.default) || (0, $1gEvW.default)),
        'string': new (0, $4qsM3.default)
    };
}
var $b10ac3021210b27d$export$2e2bcd8739ae039 = $b10ac3021210b27d$var$mapCacheClear;

});
parcelRegister("4qsM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $338fe90c604e77a6$export$2e2bcd8739ae039; });

var $gmzF2 = parcelRequire("gmzF2");

var $jboig = parcelRequire("jboig");

var $2olLa = parcelRequire("2olLa");

var $8vH44 = parcelRequire("8vH44");

var $h87nj = parcelRequire("h87nj");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $338fe90c604e77a6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$338fe90c604e77a6$var$Hash.prototype.clear = (0, $gmzF2.default);
$338fe90c604e77a6$var$Hash.prototype['delete'] = (0, $jboig.default);
$338fe90c604e77a6$var$Hash.prototype.get = (0, $2olLa.default);
$338fe90c604e77a6$var$Hash.prototype.has = (0, $8vH44.default);
$338fe90c604e77a6$var$Hash.prototype.set = (0, $h87nj.default);
var $338fe90c604e77a6$export$2e2bcd8739ae039 = $338fe90c604e77a6$var$Hash;

});
parcelRegister("gmzF2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be9a5cf3e915f078$export$2e2bcd8739ae039; });

var $fnnZr = parcelRequire("fnnZr");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $be9a5cf3e915f078$var$hashClear() {
    this.__data__ = (0, $fnnZr.default) ? (0, $fnnZr.default)(null) : {};
    this.size = 0;
}
var $be9a5cf3e915f078$export$2e2bcd8739ae039 = $be9a5cf3e915f078$var$hashClear;

});
parcelRegister("fnnZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b31b9ce951d45915$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");
/* Built-in method references that are verified to be native. */ var $b31b9ce951d45915$var$nativeCreate = (0, $jJGP0.default)(Object, 'create');
var $b31b9ce951d45915$export$2e2bcd8739ae039 = $b31b9ce951d45915$var$nativeCreate;

});


parcelRegister("jboig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df71e396e71e4535$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df71e396e71e4535$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $df71e396e71e4535$export$2e2bcd8739ae039 = $df71e396e71e4535$var$hashDelete;

});

parcelRegister("2olLa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bdeb3b3b807852d$export$2e2bcd8739ae039; });

var $fnnZr = parcelRequire("fnnZr");
/** Used to stand-in for `undefined` hash values. */ var $1bdeb3b3b807852d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $1bdeb3b3b807852d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1bdeb3b3b807852d$var$hasOwnProperty = $1bdeb3b3b807852d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1bdeb3b3b807852d$var$hashGet(key) {
    var data = this.__data__;
    if (0, $fnnZr.default) {
        var result = data[key];
        return result === $1bdeb3b3b807852d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1bdeb3b3b807852d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $1bdeb3b3b807852d$export$2e2bcd8739ae039 = $1bdeb3b3b807852d$var$hashGet;

});

parcelRegister("8vH44", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63229fbed401bb0c$export$2e2bcd8739ae039; });

var $fnnZr = parcelRequire("fnnZr");
/** Used for built-in method references. */ var $63229fbed401bb0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $63229fbed401bb0c$var$hasOwnProperty = $63229fbed401bb0c$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $63229fbed401bb0c$var$hashHas(key) {
    var data = this.__data__;
    return (0, $fnnZr.default) ? data[key] !== undefined : $63229fbed401bb0c$var$hasOwnProperty.call(data, key);
}
var $63229fbed401bb0c$export$2e2bcd8739ae039 = $63229fbed401bb0c$var$hashHas;

});

parcelRegister("h87nj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c788e785baf0d991$export$2e2bcd8739ae039; });

var $fnnZr = parcelRequire("fnnZr");
/** Used to stand-in for `undefined` hash values. */ var $c788e785baf0d991$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c788e785baf0d991$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $fnnZr.default) && value === undefined ? $c788e785baf0d991$var$HASH_UNDEFINED : value;
    return this;
}
var $c788e785baf0d991$export$2e2bcd8739ae039 = $c788e785baf0d991$var$hashSet;

});



parcelRegister("lTxpG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff08a738a3d9692c$export$2e2bcd8739ae039; });

var $foRQ0 = parcelRequire("foRQ0");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff08a738a3d9692c$var$mapCacheDelete(key) {
    var result = (0, $foRQ0.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ff08a738a3d9692c$export$2e2bcd8739ae039 = $ff08a738a3d9692c$var$mapCacheDelete;

});
parcelRegister("foRQ0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b362dbf6ad299a4e$export$2e2bcd8739ae039; });

var $71kJc = parcelRequire("71kJc");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b362dbf6ad299a4e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $71kJc.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $b362dbf6ad299a4e$export$2e2bcd8739ae039 = $b362dbf6ad299a4e$var$getMapData;

});
parcelRegister("71kJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51c8b4911caf5a5e$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $51c8b4911caf5a5e$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $51c8b4911caf5a5e$export$2e2bcd8739ae039 = $51c8b4911caf5a5e$var$isKeyable;

});



parcelRegister("ahCHp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77c982c7650c0855$export$2e2bcd8739ae039; });

var $foRQ0 = parcelRequire("foRQ0");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $77c982c7650c0855$var$mapCacheGet(key) {
    return (0, $foRQ0.default)(this, key).get(key);
}
var $77c982c7650c0855$export$2e2bcd8739ae039 = $77c982c7650c0855$var$mapCacheGet;

});

parcelRegister("j0y7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd687c91ca0fd21b$export$2e2bcd8739ae039; });

var $foRQ0 = parcelRequire("foRQ0");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd687c91ca0fd21b$var$mapCacheHas(key) {
    return (0, $foRQ0.default)(this, key).has(key);
}
var $dd687c91ca0fd21b$export$2e2bcd8739ae039 = $dd687c91ca0fd21b$var$mapCacheHas;

});

parcelRegister("5myQO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e7a0a72446267a7$export$2e2bcd8739ae039; });

var $foRQ0 = parcelRequire("foRQ0");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3e7a0a72446267a7$var$mapCacheSet(key, value) {
    var data = (0, $foRQ0.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $3e7a0a72446267a7$export$2e2bcd8739ae039 = $3e7a0a72446267a7$var$mapCacheSet;

});




parcelRegister("6JjSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e665cc54a815f7f$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $4e665cc54a815f7f$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $4e665cc54a815f7f$export$2e2bcd8739ae039 = $4e665cc54a815f7f$var$arrayEach;

});

parcelRegister("9JQRP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7171535fac2abf8e$export$2e2bcd8739ae039; });

var $2lVsh = parcelRequire("2lVsh");

var $393Ci = parcelRequire("393Ci");
/** Used for built-in method references. */ var $7171535fac2abf8e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7171535fac2abf8e$var$hasOwnProperty = $7171535fac2abf8e$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7171535fac2abf8e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($7171535fac2abf8e$var$hasOwnProperty.call(object, key) && (0, $393Ci.default)(objValue, value)) || value === undefined && !(key in object)) (0, $2lVsh.default)(object, key, value);
}
var $7171535fac2abf8e$export$2e2bcd8739ae039 = $7171535fac2abf8e$var$assignValue;

});
parcelRegister("2lVsh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b6a1c4ec76a886d$export$2e2bcd8739ae039; });

var $4rhyb = parcelRequire("4rhyb");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1b6a1c4ec76a886d$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $4rhyb.default)) (0, $4rhyb.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $1b6a1c4ec76a886d$export$2e2bcd8739ae039 = $1b6a1c4ec76a886d$var$baseAssignValue;

});
parcelRegister("4rhyb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33b74c324685bdc6$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");
var $33b74c324685bdc6$var$defineProperty = function() {
    try {
        var func = (0, $jJGP0.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $33b74c324685bdc6$export$2e2bcd8739ae039 = $33b74c324685bdc6$var$defineProperty;

});



parcelRegister("7CJoo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58cf4b03be801724$export$2e2bcd8739ae039; });

var $iNY6U = parcelRequire("iNY6U");

var $TRanc = parcelRequire("TRanc");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $58cf4b03be801724$var$baseAssign(object, source) {
    return object && (0, $iNY6U.default)(source, (0, $TRanc.default)(source), object);
}
var $58cf4b03be801724$export$2e2bcd8739ae039 = $58cf4b03be801724$var$baseAssign;

});
parcelRegister("iNY6U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db0b6e48253ee39d$export$2e2bcd8739ae039; });

var $9JQRP = parcelRequire("9JQRP");

var $2lVsh = parcelRequire("2lVsh");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $db0b6e48253ee39d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $2lVsh.default)(object, key, newValue);
        else (0, $9JQRP.default)(object, key, newValue);
    }
    return object;
}
var $db0b6e48253ee39d$export$2e2bcd8739ae039 = $db0b6e48253ee39d$var$copyObject;

});

parcelRegister("TRanc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a7e60e3e1b696d0$export$2e2bcd8739ae039; });

var $j563p = parcelRequire("j563p");

var $9SQLS = parcelRequire("9SQLS");

var $2GbHU = parcelRequire("2GbHU");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0a7e60e3e1b696d0$var$keys(object) {
    return (0, $2GbHU.default)(object) ? (0, $j563p.default)(object) : (0, $9SQLS.default)(object);
}
var $0a7e60e3e1b696d0$export$2e2bcd8739ae039 = $0a7e60e3e1b696d0$var$keys;

});
parcelRegister("j563p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de432e29eceb0e20$export$2e2bcd8739ae039; });

var $hA8JS = parcelRequire("hA8JS");

var $c0EkT = parcelRequire("c0EkT");

var $d8gzz = parcelRequire("d8gzz");

var $h0k3u = parcelRequire("h0k3u");

var $cP9yH = parcelRequire("cP9yH");

var $7SB23 = parcelRequire("7SB23");
/** Used for built-in method references. */ var $de432e29eceb0e20$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de432e29eceb0e20$var$hasOwnProperty = $de432e29eceb0e20$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $de432e29eceb0e20$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $d8gzz.default)(value), isArg = !isArr && (0, $c0EkT.default)(value), isBuff = !isArr && !isArg && (0, $h0k3u.default)(value), isType = !isArr && !isArg && !isBuff && (0, $7SB23.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $hA8JS.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $de432e29eceb0e20$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $cP9yH.default)(key, length)))) result.push(key);
    return result;
}
var $de432e29eceb0e20$export$2e2bcd8739ae039 = $de432e29eceb0e20$var$arrayLikeKeys;

});
parcelRegister("hA8JS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccc93d07b8d8aae$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $cccc93d07b8d8aae$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $cccc93d07b8d8aae$export$2e2bcd8739ae039 = $cccc93d07b8d8aae$var$baseTimes;

});

parcelRegister("c0EkT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8be4c6075fd28431$export$2e2bcd8739ae039; });

var $76gEz = parcelRequire("76gEz");

var $d2dL4 = parcelRequire("d2dL4");
/** Used for built-in method references. */ var $8be4c6075fd28431$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8be4c6075fd28431$var$hasOwnProperty = $8be4c6075fd28431$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8be4c6075fd28431$var$propertyIsEnumerable = $8be4c6075fd28431$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8be4c6075fd28431$var$isArguments = (0, $76gEz.default)(function() {
    return arguments;
}()) ? (0, $76gEz.default) : function(value) {
    return (0, $d2dL4.default)(value) && $8be4c6075fd28431$var$hasOwnProperty.call(value, 'callee') && !$8be4c6075fd28431$var$propertyIsEnumerable.call(value, 'callee');
};
var $8be4c6075fd28431$export$2e2bcd8739ae039 = $8be4c6075fd28431$var$isArguments;

});
parcelRegister("76gEz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52b602f09e00e5f5$export$2e2bcd8739ae039; });

var $8qlH6 = parcelRequire("8qlH6");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $52b602f09e00e5f5$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $52b602f09e00e5f5$var$baseIsArguments(value) {
    return (0, $d2dL4.default)(value) && (0, $8qlH6.default)(value) == $52b602f09e00e5f5$var$argsTag;
}
var $52b602f09e00e5f5$export$2e2bcd8739ae039 = $52b602f09e00e5f5$var$baseIsArguments;

});


parcelRegister("d8gzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $98f8e0b2d1df3aed$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $98f8e0b2d1df3aed$var$isArray = Array.isArray;
var $98f8e0b2d1df3aed$export$2e2bcd8739ae039 = $98f8e0b2d1df3aed$var$isArray;

});

parcelRegister("h0k3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c611fe4b92607a0d$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");

var $86exc = parcelRequire("86exc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $86exc.default);
var $c611fe4b92607a0d$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("86exc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5a287dab114ff7$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $5e5a287dab114ff7$var$stubFalse() {
    return false;
}
var $5e5a287dab114ff7$export$2e2bcd8739ae039 = $5e5a287dab114ff7$var$stubFalse;

});


parcelRegister("cP9yH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9561a998e411883c$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $9561a998e411883c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9561a998e411883c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9561a998e411883c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9561a998e411883c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9561a998e411883c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9561a998e411883c$export$2e2bcd8739ae039 = $9561a998e411883c$var$isIndex;

});

parcelRegister("7SB23", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bca4d58ac751b05$export$2e2bcd8739ae039; });

var $cvjkZ = parcelRequire("cvjkZ");

var $vsC1F = parcelRequire("vsC1F");

var $gLfdj = parcelRequire("gLfdj");
/* Node.js helper references. */ var $5bca4d58ac751b05$var$nodeIsTypedArray = (0, $gLfdj.default) && (0, $gLfdj.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5bca4d58ac751b05$var$isTypedArray = $5bca4d58ac751b05$var$nodeIsTypedArray ? (0, $vsC1F.default)($5bca4d58ac751b05$var$nodeIsTypedArray) : (0, $cvjkZ.default);
var $5bca4d58ac751b05$export$2e2bcd8739ae039 = $5bca4d58ac751b05$var$isTypedArray;

});
parcelRegister("cvjkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91a76151d4364000$export$2e2bcd8739ae039; });

var $8qlH6 = parcelRequire("8qlH6");

var $9jL2n = parcelRequire("9jL2n");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $91a76151d4364000$var$argsTag = '[object Arguments]', $91a76151d4364000$var$arrayTag = '[object Array]', $91a76151d4364000$var$boolTag = '[object Boolean]', $91a76151d4364000$var$dateTag = '[object Date]', $91a76151d4364000$var$errorTag = '[object Error]', $91a76151d4364000$var$funcTag = '[object Function]', $91a76151d4364000$var$mapTag = '[object Map]', $91a76151d4364000$var$numberTag = '[object Number]', $91a76151d4364000$var$objectTag = '[object Object]', $91a76151d4364000$var$regexpTag = '[object RegExp]', $91a76151d4364000$var$setTag = '[object Set]', $91a76151d4364000$var$stringTag = '[object String]', $91a76151d4364000$var$weakMapTag = '[object WeakMap]';
var $91a76151d4364000$var$arrayBufferTag = '[object ArrayBuffer]', $91a76151d4364000$var$dataViewTag = '[object DataView]', $91a76151d4364000$var$float32Tag = '[object Float32Array]', $91a76151d4364000$var$float64Tag = '[object Float64Array]', $91a76151d4364000$var$int8Tag = '[object Int8Array]', $91a76151d4364000$var$int16Tag = '[object Int16Array]', $91a76151d4364000$var$int32Tag = '[object Int32Array]', $91a76151d4364000$var$uint8Tag = '[object Uint8Array]', $91a76151d4364000$var$uint8ClampedTag = '[object Uint8ClampedArray]', $91a76151d4364000$var$uint16Tag = '[object Uint16Array]', $91a76151d4364000$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $91a76151d4364000$var$typedArrayTags = {};
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float64Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8ClampedTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint32Tag] = true;
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$argsTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayBufferTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$boolTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dataViewTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dateTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$errorTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$funcTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$mapTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$numberTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$objectTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$regexpTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$setTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$stringTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $91a76151d4364000$var$baseIsTypedArray(value) {
    return (0, $d2dL4.default)(value) && (0, $9jL2n.default)(value.length) && !!$91a76151d4364000$var$typedArrayTags[(0, $8qlH6.default)(value)];
}
var $91a76151d4364000$export$2e2bcd8739ae039 = $91a76151d4364000$var$baseIsTypedArray;

});
parcelRegister("9jL2n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c8a600bb2a3ff82$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6c8a600bb2a3ff82$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER;
}
var $6c8a600bb2a3ff82$export$2e2bcd8739ae039 = $6c8a600bb2a3ff82$var$isLength;

});


parcelRegister("vsC1F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05e9172cfe434229$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $05e9172cfe434229$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $05e9172cfe434229$export$2e2bcd8739ae039 = $05e9172cfe434229$var$baseUnary;

});

parcelRegister("gLfdj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33cd6441f500087$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $g6iKt.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $c33cd6441f500087$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("9SQLS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7322177d0c9e5ec1$export$2e2bcd8739ae039; });

var $8n3YS = parcelRequire("8n3YS");

var $4cZTS = parcelRequire("4cZTS");
/** Used for built-in method references. */ var $7322177d0c9e5ec1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7322177d0c9e5ec1$var$hasOwnProperty = $7322177d0c9e5ec1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7322177d0c9e5ec1$var$baseKeys(object) {
    if (!(0, $8n3YS.default)(object)) return (0, $4cZTS.default)(object);
    var result = [];
    for(var key in Object(object))if ($7322177d0c9e5ec1$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $7322177d0c9e5ec1$export$2e2bcd8739ae039 = $7322177d0c9e5ec1$var$baseKeys;

});
parcelRegister("8n3YS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61838f3cfb255cdf$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $61838f3cfb255cdf$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $61838f3cfb255cdf$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $61838f3cfb255cdf$var$objectProto;
    return value === proto;
}
var $61838f3cfb255cdf$export$2e2bcd8739ae039 = $61838f3cfb255cdf$var$isPrototype;

});

parcelRegister("4cZTS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31084c80262f0678$export$2e2bcd8739ae039; });

var $6mQFg = parcelRequire("6mQFg");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $31084c80262f0678$var$nativeKeys = (0, $6mQFg.default)(Object.keys, Object);
var $31084c80262f0678$export$2e2bcd8739ae039 = $31084c80262f0678$var$nativeKeys;

});


parcelRegister("2GbHU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f3895d15a1c09ab$export$2e2bcd8739ae039; });

var $cc5PI = parcelRequire("cc5PI");

var $9jL2n = parcelRequire("9jL2n");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1f3895d15a1c09ab$var$isArrayLike(value) {
    return value != null && (0, $9jL2n.default)(value.length) && !(0, $cc5PI.default)(value);
}
var $1f3895d15a1c09ab$export$2e2bcd8739ae039 = $1f3895d15a1c09ab$var$isArrayLike;

});



parcelRegister("8kTkC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $611b1cb313019d0f$export$2e2bcd8739ae039; });

var $iNY6U = parcelRequire("iNY6U");

var $b1vZg = parcelRequire("b1vZg");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $611b1cb313019d0f$var$baseAssignIn(object, source) {
    return object && (0, $iNY6U.default)(source, (0, $b1vZg.default)(source), object);
}
var $611b1cb313019d0f$export$2e2bcd8739ae039 = $611b1cb313019d0f$var$baseAssignIn;

});
parcelRegister("b1vZg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $806899b4212b4069$export$2e2bcd8739ae039; });

var $j563p = parcelRequire("j563p");

var $4xACs = parcelRequire("4xACs");

var $2GbHU = parcelRequire("2GbHU");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $806899b4212b4069$var$keysIn(object) {
    return (0, $2GbHU.default)(object) ? (0, $j563p.default)(object, true) : (0, $4xACs.default)(object);
}
var $806899b4212b4069$export$2e2bcd8739ae039 = $806899b4212b4069$var$keysIn;

});
parcelRegister("4xACs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34e6a65508d052bc$export$2e2bcd8739ae039; });

var $1tXpJ = parcelRequire("1tXpJ");

var $8n3YS = parcelRequire("8n3YS");

var $7hiYR = parcelRequire("7hiYR");
/** Used for built-in method references. */ var $34e6a65508d052bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $34e6a65508d052bc$var$hasOwnProperty = $34e6a65508d052bc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $34e6a65508d052bc$var$baseKeysIn(object) {
    if (!(0, $1tXpJ.default)(object)) return (0, $7hiYR.default)(object);
    var isProto = (0, $8n3YS.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$34e6a65508d052bc$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $34e6a65508d052bc$export$2e2bcd8739ae039 = $34e6a65508d052bc$var$baseKeysIn;

});
parcelRegister("7hiYR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54c8d812217bf591$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $54c8d812217bf591$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $54c8d812217bf591$export$2e2bcd8739ae039 = $54c8d812217bf591$var$nativeKeysIn;

});




parcelRegister("bcoTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021aa5aca9b47e9e$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $021aa5aca9b47e9e$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("8nk1V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61900241098abc0a$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $61900241098abc0a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $61900241098abc0a$export$2e2bcd8739ae039 = $61900241098abc0a$var$copyArray;

});

parcelRegister("6GTQF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4df1fca9379a9f05$export$2e2bcd8739ae039; });

var $iNY6U = parcelRequire("iNY6U");

var $8870d = parcelRequire("8870d");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $4df1fca9379a9f05$var$copySymbols(source, object) {
    return (0, $iNY6U.default)(source, (0, $8870d.default)(source), object);
}
var $4df1fca9379a9f05$export$2e2bcd8739ae039 = $4df1fca9379a9f05$var$copySymbols;

});
parcelRegister("8870d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5eb480a5a820f908$export$2e2bcd8739ae039; });

var $hvEDK = parcelRequire("hvEDK");

var $Dmdhd = parcelRequire("Dmdhd");
/** Used for built-in method references. */ var $5eb480a5a820f908$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5eb480a5a820f908$var$propertyIsEnumerable = $5eb480a5a820f908$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5eb480a5a820f908$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5eb480a5a820f908$var$getSymbols = !$5eb480a5a820f908$var$nativeGetSymbols ? (0, $Dmdhd.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $hvEDK.default)($5eb480a5a820f908$var$nativeGetSymbols(object), function(symbol) {
        return $5eb480a5a820f908$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $5eb480a5a820f908$export$2e2bcd8739ae039 = $5eb480a5a820f908$var$getSymbols;

});
parcelRegister("hvEDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbf4db2dc1415291$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cbf4db2dc1415291$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $cbf4db2dc1415291$export$2e2bcd8739ae039 = $cbf4db2dc1415291$var$arrayFilter;

});

parcelRegister("Dmdhd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0764dfb344313c12$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0764dfb344313c12$var$stubArray() {
    return [];
}
var $0764dfb344313c12$export$2e2bcd8739ae039 = $0764dfb344313c12$var$stubArray;

});



parcelRegister("135Ea", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3a7396fd396536$export$2e2bcd8739ae039; });

var $iNY6U = parcelRequire("iNY6U");

var $8JDQa = parcelRequire("8JDQa");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $0c3a7396fd396536$var$copySymbolsIn(source, object) {
    return (0, $iNY6U.default)(source, (0, $8JDQa.default)(source), object);
}
var $0c3a7396fd396536$export$2e2bcd8739ae039 = $0c3a7396fd396536$var$copySymbolsIn;

});
parcelRegister("8JDQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65c16e2f69f43e56$export$2e2bcd8739ae039; });

var $8WNCE = parcelRequire("8WNCE");

var $2SuGb = parcelRequire("2SuGb");

var $8870d = parcelRequire("8870d");

var $Dmdhd = parcelRequire("Dmdhd");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $65c16e2f69f43e56$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $65c16e2f69f43e56$var$getSymbolsIn = !$65c16e2f69f43e56$var$nativeGetSymbols ? (0, $Dmdhd.default) : function(object) {
    var result = [];
    while(object){
        (0, $8WNCE.default)(result, (0, $8870d.default)(object));
        object = (0, $2SuGb.default)(object);
    }
    return result;
};
var $65c16e2f69f43e56$export$2e2bcd8739ae039 = $65c16e2f69f43e56$var$getSymbolsIn;

});
parcelRegister("8WNCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $683a3b780d4eb41b$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $683a3b780d4eb41b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $683a3b780d4eb41b$export$2e2bcd8739ae039 = $683a3b780d4eb41b$var$arrayPush;

});



parcelRegister("hhRWj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c95ddd733823b884$export$2e2bcd8739ae039; });

var $jTPDj = parcelRequire("jTPDj");

var $8870d = parcelRequire("8870d");

var $TRanc = parcelRequire("TRanc");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c95ddd733823b884$var$getAllKeys(object) {
    return (0, $jTPDj.default)(object, (0, $TRanc.default), (0, $8870d.default));
}
var $c95ddd733823b884$export$2e2bcd8739ae039 = $c95ddd733823b884$var$getAllKeys;

});
parcelRegister("jTPDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7cb349a473b00eb$export$2e2bcd8739ae039; });

var $8WNCE = parcelRequire("8WNCE");

var $d8gzz = parcelRequire("d8gzz");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e7cb349a473b00eb$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $d8gzz.default)(object) ? result : (0, $8WNCE.default)(result, symbolsFunc(object));
}
var $e7cb349a473b00eb$export$2e2bcd8739ae039 = $e7cb349a473b00eb$var$baseGetAllKeys;

});


parcelRegister("9j2XF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c682f73179ad689$export$2e2bcd8739ae039; });

var $jTPDj = parcelRequire("jTPDj");

var $8JDQa = parcelRequire("8JDQa");

var $b1vZg = parcelRequire("b1vZg");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $6c682f73179ad689$var$getAllKeysIn(object) {
    return (0, $jTPDj.default)(object, (0, $b1vZg.default), (0, $8JDQa.default));
}
var $6c682f73179ad689$export$2e2bcd8739ae039 = $6c682f73179ad689$var$getAllKeysIn;

});

parcelRegister("8eYI3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ffeb92c4e5cd318$export$2e2bcd8739ae039; });

var $bqEgT = parcelRequire("bqEgT");

var $3o8E7 = parcelRequire("3o8E7");

var $dZcxk = parcelRequire("dZcxk");

var $gWBbg = parcelRequire("gWBbg");

var $jjN1X = parcelRequire("jjN1X");

var $8qlH6 = parcelRequire("8qlH6");

var $c3L0V = parcelRequire("c3L0V");
/** `Object#toString` result references. */ var $5ffeb92c4e5cd318$var$mapTag = '[object Map]', $5ffeb92c4e5cd318$var$objectTag = '[object Object]', $5ffeb92c4e5cd318$var$promiseTag = '[object Promise]', $5ffeb92c4e5cd318$var$setTag = '[object Set]', $5ffeb92c4e5cd318$var$weakMapTag = '[object WeakMap]';
var $5ffeb92c4e5cd318$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $5ffeb92c4e5cd318$var$dataViewCtorString = (0, $c3L0V.default)((0, $bqEgT.default)), $5ffeb92c4e5cd318$var$mapCtorString = (0, $c3L0V.default)((0, $3o8E7.default)), $5ffeb92c4e5cd318$var$promiseCtorString = (0, $c3L0V.default)((0, $dZcxk.default)), $5ffeb92c4e5cd318$var$setCtorString = (0, $c3L0V.default)((0, $gWBbg.default)), $5ffeb92c4e5cd318$var$weakMapCtorString = (0, $c3L0V.default)((0, $jjN1X.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5ffeb92c4e5cd318$var$getTag = (0, $8qlH6.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $bqEgT.default) && $5ffeb92c4e5cd318$var$getTag(new (0, $bqEgT.default)(new ArrayBuffer(1))) != $5ffeb92c4e5cd318$var$dataViewTag || (0, $3o8E7.default) && $5ffeb92c4e5cd318$var$getTag(new (0, $3o8E7.default)) != $5ffeb92c4e5cd318$var$mapTag || (0, $dZcxk.default) && $5ffeb92c4e5cd318$var$getTag((0, $dZcxk.default).resolve()) != $5ffeb92c4e5cd318$var$promiseTag || (0, $gWBbg.default) && $5ffeb92c4e5cd318$var$getTag(new (0, $gWBbg.default)) != $5ffeb92c4e5cd318$var$setTag || (0, $jjN1X.default) && $5ffeb92c4e5cd318$var$getTag(new (0, $jjN1X.default)) != $5ffeb92c4e5cd318$var$weakMapTag) $5ffeb92c4e5cd318$var$getTag = function(value) {
    var result = (0, $8qlH6.default)(value), Ctor = result == $5ffeb92c4e5cd318$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $c3L0V.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $5ffeb92c4e5cd318$var$dataViewCtorString:
            return $5ffeb92c4e5cd318$var$dataViewTag;
        case $5ffeb92c4e5cd318$var$mapCtorString:
            return $5ffeb92c4e5cd318$var$mapTag;
        case $5ffeb92c4e5cd318$var$promiseCtorString:
            return $5ffeb92c4e5cd318$var$promiseTag;
        case $5ffeb92c4e5cd318$var$setCtorString:
            return $5ffeb92c4e5cd318$var$setTag;
        case $5ffeb92c4e5cd318$var$weakMapCtorString:
            return $5ffeb92c4e5cd318$var$weakMapTag;
    }
    return result;
};
var $5ffeb92c4e5cd318$export$2e2bcd8739ae039 = $5ffeb92c4e5cd318$var$getTag;

});
parcelRegister("bqEgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85215c80e1973d51$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");

var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $85215c80e1973d51$var$DataView = (0, $jJGP0.default)((0, $6AhZS.default), 'DataView');
var $85215c80e1973d51$export$2e2bcd8739ae039 = $85215c80e1973d51$var$DataView;

});

parcelRegister("dZcxk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2eab25dde92b3ad$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");

var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $a2eab25dde92b3ad$var$Promise = (0, $jJGP0.default)((0, $6AhZS.default), 'Promise');
var $a2eab25dde92b3ad$export$2e2bcd8739ae039 = $a2eab25dde92b3ad$var$Promise;

});

parcelRegister("gWBbg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55ee7709f40bf07$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");

var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $c55ee7709f40bf07$var$Set = (0, $jJGP0.default)((0, $6AhZS.default), 'Set');
var $c55ee7709f40bf07$export$2e2bcd8739ae039 = $c55ee7709f40bf07$var$Set;

});

parcelRegister("jjN1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e105d31ff046e80b$export$2e2bcd8739ae039; });

var $jJGP0 = parcelRequire("jJGP0");

var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $e105d31ff046e80b$var$WeakMap = (0, $jJGP0.default)((0, $6AhZS.default), 'WeakMap');
var $e105d31ff046e80b$export$2e2bcd8739ae039 = $e105d31ff046e80b$var$WeakMap;

});


parcelRegister("bRMCu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a3a5bd69a8c886e$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $8a3a5bd69a8c886e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8a3a5bd69a8c886e$var$hasOwnProperty = $8a3a5bd69a8c886e$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $8a3a5bd69a8c886e$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $8a3a5bd69a8c886e$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $8a3a5bd69a8c886e$export$2e2bcd8739ae039 = $8a3a5bd69a8c886e$var$initCloneArray;

});

parcelRegister("iis7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d51fb8c255a1587c$export$2e2bcd8739ae039; });

var $4L53j = parcelRequire("4L53j");

var $14vaz = parcelRequire("14vaz");

var $2D5u4 = parcelRequire("2D5u4");

var $k16Ly = parcelRequire("k16Ly");

var $iMed0 = parcelRequire("iMed0");
/** `Object#toString` result references. */ var $d51fb8c255a1587c$var$boolTag = '[object Boolean]', $d51fb8c255a1587c$var$dateTag = '[object Date]', $d51fb8c255a1587c$var$mapTag = '[object Map]', $d51fb8c255a1587c$var$numberTag = '[object Number]', $d51fb8c255a1587c$var$regexpTag = '[object RegExp]', $d51fb8c255a1587c$var$setTag = '[object Set]', $d51fb8c255a1587c$var$stringTag = '[object String]', $d51fb8c255a1587c$var$symbolTag = '[object Symbol]';
var $d51fb8c255a1587c$var$arrayBufferTag = '[object ArrayBuffer]', $d51fb8c255a1587c$var$dataViewTag = '[object DataView]', $d51fb8c255a1587c$var$float32Tag = '[object Float32Array]', $d51fb8c255a1587c$var$float64Tag = '[object Float64Array]', $d51fb8c255a1587c$var$int8Tag = '[object Int8Array]', $d51fb8c255a1587c$var$int16Tag = '[object Int16Array]', $d51fb8c255a1587c$var$int32Tag = '[object Int32Array]', $d51fb8c255a1587c$var$uint8Tag = '[object Uint8Array]', $d51fb8c255a1587c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d51fb8c255a1587c$var$uint16Tag = '[object Uint16Array]', $d51fb8c255a1587c$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d51fb8c255a1587c$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d51fb8c255a1587c$var$arrayBufferTag:
            return (0, $4L53j.default)(object);
        case $d51fb8c255a1587c$var$boolTag:
        case $d51fb8c255a1587c$var$dateTag:
            return new Ctor(+object);
        case $d51fb8c255a1587c$var$dataViewTag:
            return (0, $14vaz.default)(object, isDeep);
        case $d51fb8c255a1587c$var$float32Tag:
        case $d51fb8c255a1587c$var$float64Tag:
        case $d51fb8c255a1587c$var$int8Tag:
        case $d51fb8c255a1587c$var$int16Tag:
        case $d51fb8c255a1587c$var$int32Tag:
        case $d51fb8c255a1587c$var$uint8Tag:
        case $d51fb8c255a1587c$var$uint8ClampedTag:
        case $d51fb8c255a1587c$var$uint16Tag:
        case $d51fb8c255a1587c$var$uint32Tag:
            return (0, $iMed0.default)(object, isDeep);
        case $d51fb8c255a1587c$var$mapTag:
            return new Ctor;
        case $d51fb8c255a1587c$var$numberTag:
        case $d51fb8c255a1587c$var$stringTag:
            return new Ctor(object);
        case $d51fb8c255a1587c$var$regexpTag:
            return (0, $2D5u4.default)(object);
        case $d51fb8c255a1587c$var$setTag:
            return new Ctor;
        case $d51fb8c255a1587c$var$symbolTag:
            return (0, $k16Ly.default)(object);
    }
}
var $d51fb8c255a1587c$export$2e2bcd8739ae039 = $d51fb8c255a1587c$var$initCloneByTag;

});
parcelRegister("4L53j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376f78894f31a267$export$2e2bcd8739ae039; });

var $5Jztt = parcelRequire("5Jztt");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $376f78894f31a267$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $5Jztt.default)(result).set(new (0, $5Jztt.default)(arrayBuffer));
    return result;
}
var $376f78894f31a267$export$2e2bcd8739ae039 = $376f78894f31a267$var$cloneArrayBuffer;

});
parcelRegister("5Jztt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42ccac2ef9780f37$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $42ccac2ef9780f37$var$Uint8Array = (0, $6AhZS.default).Uint8Array;
var $42ccac2ef9780f37$export$2e2bcd8739ae039 = $42ccac2ef9780f37$var$Uint8Array;

});


parcelRegister("14vaz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c7e57c088334278$export$2e2bcd8739ae039; });

var $4L53j = parcelRequire("4L53j");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $0c7e57c088334278$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $4L53j.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $0c7e57c088334278$export$2e2bcd8739ae039 = $0c7e57c088334278$var$cloneDataView;

});

parcelRegister("2D5u4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ea37a4f77fc0a4e$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $1ea37a4f77fc0a4e$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $1ea37a4f77fc0a4e$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $1ea37a4f77fc0a4e$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $1ea37a4f77fc0a4e$export$2e2bcd8739ae039 = $1ea37a4f77fc0a4e$var$cloneRegExp;

});

parcelRegister("k16Ly", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e92926397623e8ab$export$2e2bcd8739ae039; });

var $1ln2D = parcelRequire("1ln2D");
/** Used to convert symbols to primitives and strings. */ var $e92926397623e8ab$var$symbolProto = (0, $1ln2D.default) ? (0, $1ln2D.default).prototype : undefined, $e92926397623e8ab$var$symbolValueOf = $e92926397623e8ab$var$symbolProto ? $e92926397623e8ab$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e92926397623e8ab$var$cloneSymbol(symbol) {
    return $e92926397623e8ab$var$symbolValueOf ? Object($e92926397623e8ab$var$symbolValueOf.call(symbol)) : {};
}
var $e92926397623e8ab$export$2e2bcd8739ae039 = $e92926397623e8ab$var$cloneSymbol;

});

parcelRegister("iMed0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dab7bb403ffc4337$export$2e2bcd8739ae039; });

var $4L53j = parcelRequire("4L53j");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $dab7bb403ffc4337$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $4L53j.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $dab7bb403ffc4337$export$2e2bcd8739ae039 = $dab7bb403ffc4337$var$cloneTypedArray;

});


parcelRegister("47zBg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30036e4acfc7be83$export$2e2bcd8739ae039; });

var $gGEbw = parcelRequire("gGEbw");

var $2SuGb = parcelRequire("2SuGb");

var $8n3YS = parcelRequire("8n3YS");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $30036e4acfc7be83$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $8n3YS.default)(object) ? (0, $gGEbw.default)((0, $2SuGb.default)(object)) : {};
}
var $30036e4acfc7be83$export$2e2bcd8739ae039 = $30036e4acfc7be83$var$initCloneObject;

});
parcelRegister("gGEbw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c25fbd736b9c0c05$export$2e2bcd8739ae039; });

var $1tXpJ = parcelRequire("1tXpJ");
/** Built-in value references. */ var $c25fbd736b9c0c05$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c25fbd736b9c0c05$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $1tXpJ.default)(proto)) return {};
        if ($c25fbd736b9c0c05$var$objectCreate) return $c25fbd736b9c0c05$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $c25fbd736b9c0c05$export$2e2bcd8739ae039 = $c25fbd736b9c0c05$var$baseCreate;

});


parcelRegister("jZ68t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8c87938a4c49b18$export$2e2bcd8739ae039; });

var $43Vo9 = parcelRequire("43Vo9");

var $vsC1F = parcelRequire("vsC1F");

var $gLfdj = parcelRequire("gLfdj");
/* Node.js helper references. */ var $e8c87938a4c49b18$var$nodeIsMap = (0, $gLfdj.default) && (0, $gLfdj.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $e8c87938a4c49b18$var$isMap = $e8c87938a4c49b18$var$nodeIsMap ? (0, $vsC1F.default)($e8c87938a4c49b18$var$nodeIsMap) : (0, $43Vo9.default);
var $e8c87938a4c49b18$export$2e2bcd8739ae039 = $e8c87938a4c49b18$var$isMap;

});
parcelRegister("43Vo9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53f56a2c5c16a4$export$2e2bcd8739ae039; });

var $8eYI3 = parcelRequire("8eYI3");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $2f53f56a2c5c16a4$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $2f53f56a2c5c16a4$var$baseIsMap(value) {
    return (0, $d2dL4.default)(value) && (0, $8eYI3.default)(value) == $2f53f56a2c5c16a4$var$mapTag;
}
var $2f53f56a2c5c16a4$export$2e2bcd8739ae039 = $2f53f56a2c5c16a4$var$baseIsMap;

});


parcelRegister("cbtCS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ded7e3e93c9e478$export$2e2bcd8739ae039; });

var $4yptF = parcelRequire("4yptF");

var $vsC1F = parcelRequire("vsC1F");

var $gLfdj = parcelRequire("gLfdj");
/* Node.js helper references. */ var $8ded7e3e93c9e478$var$nodeIsSet = (0, $gLfdj.default) && (0, $gLfdj.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8ded7e3e93c9e478$var$isSet = $8ded7e3e93c9e478$var$nodeIsSet ? (0, $vsC1F.default)($8ded7e3e93c9e478$var$nodeIsSet) : (0, $4yptF.default);
var $8ded7e3e93c9e478$export$2e2bcd8739ae039 = $8ded7e3e93c9e478$var$isSet;

});
parcelRegister("4yptF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $350e19ad3f3d785f$export$2e2bcd8739ae039; });

var $8eYI3 = parcelRequire("8eYI3");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $350e19ad3f3d785f$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $350e19ad3f3d785f$var$baseIsSet(value) {
    return (0, $d2dL4.default)(value) && (0, $8eYI3.default)(value) == $350e19ad3f3d785f$var$setTag;
}
var $350e19ad3f3d785f$export$2e2bcd8739ae039 = $350e19ad3f3d785f$var$baseIsSet;

});




parcelRegister("hUHCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0a98146dce9b0be$export$2e2bcd8739ae039; });

var $bCslM = parcelRequire("bCslM");

var $8nk1V = parcelRequire("8nk1V");

var $d8gzz = parcelRequire("d8gzz");

var $4jOpt = parcelRequire("4jOpt");

var $ccAQ5 = parcelRequire("ccAQ5");

var $8kBAg = parcelRequire("8kBAg");

var $jUaVy = parcelRequire("jUaVy");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $d0a98146dce9b0be$var$toPath(value) {
    if ((0, $d8gzz.default)(value)) return (0, $bCslM.default)(value, (0, $8kBAg.default));
    return (0, $4jOpt.default)(value) ? [
        value
    ] : (0, $8nk1V.default)((0, $ccAQ5.default)((0, $jUaVy.default)(value)));
}
var $d0a98146dce9b0be$export$2e2bcd8739ae039 = $d0a98146dce9b0be$var$toPath;

});
parcelRegister("bCslM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87593c1a2aec5b96$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $87593c1a2aec5b96$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $87593c1a2aec5b96$export$2e2bcd8739ae039 = $87593c1a2aec5b96$var$arrayMap;

});

parcelRegister("4jOpt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32500a1e560de4f0$export$2e2bcd8739ae039; });

var $8qlH6 = parcelRequire("8qlH6");

var $d2dL4 = parcelRequire("d2dL4");
/** `Object#toString` result references. */ var $32500a1e560de4f0$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $32500a1e560de4f0$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $d2dL4.default)(value) && (0, $8qlH6.default)(value) == $32500a1e560de4f0$var$symbolTag;
}
var $32500a1e560de4f0$export$2e2bcd8739ae039 = $32500a1e560de4f0$var$isSymbol;

});

parcelRegister("ccAQ5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e232e870bfb6095$export$2e2bcd8739ae039; });

var $7xzg5 = parcelRequire("7xzg5");
/** Used to match property names within property paths. */ var $8e232e870bfb6095$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e232e870bfb6095$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e232e870bfb6095$var$stringToPath = (0, $7xzg5.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($8e232e870bfb6095$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e232e870bfb6095$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $8e232e870bfb6095$export$2e2bcd8739ae039 = $8e232e870bfb6095$var$stringToPath;

});
parcelRegister("7xzg5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d6f715260ef7ce$export$2e2bcd8739ae039; });

var $4ETPa = parcelRequire("4ETPa");
/** Used as the maximum memoize cache size. */ var $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $57d6f715260ef7ce$var$memoizeCapped(func) {
    var result = (0, $4ETPa.default)(func, function(key) {
        if (cache.size === $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $57d6f715260ef7ce$export$2e2bcd8739ae039 = $57d6f715260ef7ce$var$memoizeCapped;

});
parcelRegister("4ETPa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364633689371ed49$export$2e2bcd8739ae039; });

var $gkT4m = parcelRequire("gkT4m");
/** Error message constants. */ var $364633689371ed49$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $364633689371ed49$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($364633689371ed49$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($364633689371ed49$var$memoize.Cache || (0, $gkT4m.default));
    return memoized;
}
// Expose `MapCache`.
$364633689371ed49$var$memoize.Cache = (0, $gkT4m.default);
var $364633689371ed49$export$2e2bcd8739ae039 = $364633689371ed49$var$memoize;

});



parcelRegister("8kBAg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0190bb3b3a7b4f9b$export$2e2bcd8739ae039; });

var $4jOpt = parcelRequire("4jOpt");
/** Used as references for various `Number` constants. */ var $0190bb3b3a7b4f9b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0190bb3b3a7b4f9b$var$toKey(value) {
    if (typeof value == 'string' || (0, $4jOpt.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$0190bb3b3a7b4f9b$var$INFINITY ? '-0' : result;
}
var $0190bb3b3a7b4f9b$export$2e2bcd8739ae039 = $0190bb3b3a7b4f9b$var$toKey;

});

parcelRegister("jUaVy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7dbb931e76f7087$export$2e2bcd8739ae039; });

var $MfEZR = parcelRequire("MfEZR");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e7dbb931e76f7087$var$toString(value) {
    return value == null ? '' : (0, $MfEZR.default)(value);
}
var $e7dbb931e76f7087$export$2e2bcd8739ae039 = $e7dbb931e76f7087$var$toString;

});
parcelRegister("MfEZR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0910a19b4de51393$export$2e2bcd8739ae039; });

var $1ln2D = parcelRequire("1ln2D");

var $bCslM = parcelRequire("bCslM");

var $d8gzz = parcelRequire("d8gzz");

var $4jOpt = parcelRequire("4jOpt");
/** Used as references for various `Number` constants. */ var $0910a19b4de51393$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0910a19b4de51393$var$symbolProto = (0, $1ln2D.default) ? (0, $1ln2D.default).prototype : undefined, $0910a19b4de51393$var$symbolToString = $0910a19b4de51393$var$symbolProto ? $0910a19b4de51393$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0910a19b4de51393$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $d8gzz.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $bCslM.default)(value, $0910a19b4de51393$var$baseToString) + '';
    if ((0, $4jOpt.default)(value)) return $0910a19b4de51393$var$symbolToString ? $0910a19b4de51393$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0910a19b4de51393$var$INFINITY ? '-0' : result;
}
var $0910a19b4de51393$export$2e2bcd8739ae039 = $0910a19b4de51393$var$baseToString;

});



parcelRegister("bKo8Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88d6b79dcec0cfd7$export$2e2bcd8739ae039; });
var $88d6b79dcec0cfd7$var$isProduction = true;
function $88d6b79dcec0cfd7$var$warning(condition, message) {
    if (!$88d6b79dcec0cfd7$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $88d6b79dcec0cfd7$export$2e2bcd8739ae039 = $88d6b79dcec0cfd7$var$warning;

});

parcelRegister("adG4d", function(module, exports) {
'use strict';

var $lhF4u = parcelRequire("lhF4u");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $770bbfe5492d7fd4$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $770bbfe5492d7fd4$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $770bbfe5492d7fd4$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $770bbfe5492d7fd4$var$TYPE_STATICS = {};
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.ForwardRef] = $770bbfe5492d7fd4$var$FORWARD_REF_STATICS;
$770bbfe5492d7fd4$var$TYPE_STATICS[$lhF4u.Memo] = $770bbfe5492d7fd4$var$MEMO_STATICS;
function $770bbfe5492d7fd4$var$getStatics(component) {
    // React v16.11 and below
    if ($lhF4u.isMemo(component)) return $770bbfe5492d7fd4$var$MEMO_STATICS;
     // React v16.12 and above
    return $770bbfe5492d7fd4$var$TYPE_STATICS[component['$$typeof']] || $770bbfe5492d7fd4$var$REACT_STATICS;
}
var $770bbfe5492d7fd4$var$defineProperty = Object.defineProperty;
var $770bbfe5492d7fd4$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $770bbfe5492d7fd4$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $770bbfe5492d7fd4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $770bbfe5492d7fd4$var$getPrototypeOf = Object.getPrototypeOf;
var $770bbfe5492d7fd4$var$objectPrototype = Object.prototype;
function $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($770bbfe5492d7fd4$var$objectPrototype) {
            var inheritedComponent = $770bbfe5492d7fd4$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $770bbfe5492d7fd4$var$objectPrototype) $770bbfe5492d7fd4$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $770bbfe5492d7fd4$var$getOwnPropertyNames(sourceComponent);
        if ($770bbfe5492d7fd4$var$getOwnPropertySymbols) keys = keys.concat($770bbfe5492d7fd4$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $770bbfe5492d7fd4$var$getStatics(targetComponent);
        var sourceStatics = $770bbfe5492d7fd4$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$770bbfe5492d7fd4$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $770bbfe5492d7fd4$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $770bbfe5492d7fd4$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $770bbfe5492d7fd4$var$hoistNonReactStatics;

});
parcelRegister("lhF4u", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g4WQO"));

});
parcelRegister("g4WQO", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $bb4aab9d21a68c2e$export$2b8d127b894957b9; }, function (v) { return $bb4aab9d21a68c2e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $bb4aab9d21a68c2e$export$cea3a54a6425200c; }, function (v) { return $bb4aab9d21a68c2e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae; }, function (v) { return $bb4aab9d21a68c2e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d; }, function (v) { return $bb4aab9d21a68c2e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac; }, function (v) { return $bb4aab9d21a68c2e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35; }, function (v) { return $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $bb4aab9d21a68c2e$export$ffb0004e005737fa; }, function (v) { return $bb4aab9d21a68c2e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $bb4aab9d21a68c2e$export$b624eff549462981; }, function (v) { return $bb4aab9d21a68c2e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $bb4aab9d21a68c2e$export$7897aa7841a5380c; }, function (v) { return $bb4aab9d21a68c2e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $bb4aab9d21a68c2e$export$602eac185826482c; }, function (v) { return $bb4aab9d21a68c2e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $bb4aab9d21a68c2e$export$e2c29f18771995cb; }, function (v) { return $bb4aab9d21a68c2e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $bb4aab9d21a68c2e$export$5f8d39834fd61797; }, function (v) { return $bb4aab9d21a68c2e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5; }, function (v) { return $bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $bb4aab9d21a68c2e$export$92387174baf9b227; }, function (v) { return $bb4aab9d21a68c2e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6; }, function (v) { return $bb4aab9d21a68c2e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $bb4aab9d21a68c2e$export$b706b080d889d2c9; }, function (v) { return $bb4aab9d21a68c2e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc; }, function (v) { return $bb4aab9d21a68c2e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d; }, function (v) { return $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $bb4aab9d21a68c2e$export$455c2e768291efa6; }, function (v) { return $bb4aab9d21a68c2e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $bb4aab9d21a68c2e$export$9522e17588c12572; }, function (v) { return $bb4aab9d21a68c2e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $bb4aab9d21a68c2e$export$2110ac352bb060b9; }, function (v) { return $bb4aab9d21a68c2e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab; }, function (v) { return $bb4aab9d21a68c2e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de; }, function (v) { return $bb4aab9d21a68c2e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $bb4aab9d21a68c2e$export$b82d16f27459e05a; }, function (v) { return $bb4aab9d21a68c2e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8; }, function (v) { return $bb4aab9d21a68c2e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6; }, function (v) { return $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $bb4aab9d21a68c2e$export$9b621391a187a31a; }, function (v) { return $bb4aab9d21a68c2e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f; }, function (v) { return $bb4aab9d21a68c2e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bb4aab9d21a68c2e$export$2b8d127b894957b9;
var $bb4aab9d21a68c2e$export$cea3a54a6425200c;
var $bb4aab9d21a68c2e$export$a7c73072b1a182ae;
var $bb4aab9d21a68c2e$export$9f27bc3417b4524d;
var $bb4aab9d21a68c2e$export$db77ccec0bb4ccac;
var $bb4aab9d21a68c2e$export$8392c0c9d3dcbd35;
var $bb4aab9d21a68c2e$export$ffb0004e005737fa;
var $bb4aab9d21a68c2e$export$b624eff549462981;
var $bb4aab9d21a68c2e$export$7897aa7841a5380c;
var $bb4aab9d21a68c2e$export$602eac185826482c;
var $bb4aab9d21a68c2e$export$e2c29f18771995cb;
var $bb4aab9d21a68c2e$export$5f8d39834fd61797;
var $bb4aab9d21a68c2e$export$74bf444e3cd11ea5;
var $bb4aab9d21a68c2e$export$92387174baf9b227;
var $bb4aab9d21a68c2e$export$ec112efeb987d9c6;
var $bb4aab9d21a68c2e$export$b706b080d889d2c9;
var $bb4aab9d21a68c2e$export$5be5a87408f70ddc;
var $bb4aab9d21a68c2e$export$45a5e7f76e0caa8d;
var $bb4aab9d21a68c2e$export$455c2e768291efa6;
var $bb4aab9d21a68c2e$export$9522e17588c12572;
var $bb4aab9d21a68c2e$export$2110ac352bb060b9;
var $bb4aab9d21a68c2e$export$56885ab8b9c456ab;
var $bb4aab9d21a68c2e$export$d927fcb6adf8f9de;
var $bb4aab9d21a68c2e$export$b82d16f27459e05a;
var $bb4aab9d21a68c2e$export$522c17b4f5e123e8;
var $bb4aab9d21a68c2e$export$1aabd8a0274ecfd6;
var $bb4aab9d21a68c2e$export$9b621391a187a31a;
var $bb4aab9d21a68c2e$export$f5bbd400c2f4426f;
'use strict';
var $bb4aab9d21a68c2e$var$b = "function" === typeof Symbol && Symbol.for, $bb4aab9d21a68c2e$var$c = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.element") : 60103, $bb4aab9d21a68c2e$var$d = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.portal") : 60106, $bb4aab9d21a68c2e$var$e = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fragment") : 60107, $bb4aab9d21a68c2e$var$f = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.strict_mode") : 60108, $bb4aab9d21a68c2e$var$g = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.profiler") : 60114, $bb4aab9d21a68c2e$var$h = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.provider") : 60109, $bb4aab9d21a68c2e$var$k = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.context") : 60110, $bb4aab9d21a68c2e$var$l = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.async_mode") : 60111, $bb4aab9d21a68c2e$var$m = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $bb4aab9d21a68c2e$var$n = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.forward_ref") : 60112, $bb4aab9d21a68c2e$var$p = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense") : 60113, $bb4aab9d21a68c2e$var$q = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.suspense_list") : 60120, $bb4aab9d21a68c2e$var$r = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.memo") : 60115, $bb4aab9d21a68c2e$var$t = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.lazy") : 60116, $bb4aab9d21a68c2e$var$v = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.block") : 60121, $bb4aab9d21a68c2e$var$w = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.fundamental") : 60117, $bb4aab9d21a68c2e$var$x = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.responder") : 60118, $bb4aab9d21a68c2e$var$y = $bb4aab9d21a68c2e$var$b ? Symbol.for("react.scope") : 60119;
function $bb4aab9d21a68c2e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $bb4aab9d21a68c2e$var$c:
                switch(a = a.type, a){
                    case $bb4aab9d21a68c2e$var$l:
                    case $bb4aab9d21a68c2e$var$m:
                    case $bb4aab9d21a68c2e$var$e:
                    case $bb4aab9d21a68c2e$var$g:
                    case $bb4aab9d21a68c2e$var$f:
                    case $bb4aab9d21a68c2e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $bb4aab9d21a68c2e$var$k:
                            case $bb4aab9d21a68c2e$var$n:
                            case $bb4aab9d21a68c2e$var$t:
                            case $bb4aab9d21a68c2e$var$r:
                            case $bb4aab9d21a68c2e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $bb4aab9d21a68c2e$var$d:
                return u;
        }
    }
}
function $bb4aab9d21a68c2e$var$A(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$m;
}
$bb4aab9d21a68c2e$export$2b8d127b894957b9 = $bb4aab9d21a68c2e$var$l;
$bb4aab9d21a68c2e$export$cea3a54a6425200c = $bb4aab9d21a68c2e$var$m;
$bb4aab9d21a68c2e$export$a7c73072b1a182ae = $bb4aab9d21a68c2e$var$k;
$bb4aab9d21a68c2e$export$9f27bc3417b4524d = $bb4aab9d21a68c2e$var$h;
$bb4aab9d21a68c2e$export$db77ccec0bb4ccac = $bb4aab9d21a68c2e$var$c;
$bb4aab9d21a68c2e$export$8392c0c9d3dcbd35 = $bb4aab9d21a68c2e$var$n;
$bb4aab9d21a68c2e$export$ffb0004e005737fa = $bb4aab9d21a68c2e$var$e;
$bb4aab9d21a68c2e$export$b624eff549462981 = $bb4aab9d21a68c2e$var$t;
$bb4aab9d21a68c2e$export$7897aa7841a5380c = $bb4aab9d21a68c2e$var$r;
$bb4aab9d21a68c2e$export$602eac185826482c = $bb4aab9d21a68c2e$var$d;
$bb4aab9d21a68c2e$export$e2c29f18771995cb = $bb4aab9d21a68c2e$var$g;
$bb4aab9d21a68c2e$export$5f8d39834fd61797 = $bb4aab9d21a68c2e$var$f;
$bb4aab9d21a68c2e$export$74bf444e3cd11ea5 = $bb4aab9d21a68c2e$var$p;
$bb4aab9d21a68c2e$export$92387174baf9b227 = function(a) {
    return $bb4aab9d21a68c2e$var$A(a) || $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$l;
};
$bb4aab9d21a68c2e$export$ec112efeb987d9c6 = $bb4aab9d21a68c2e$var$A;
$bb4aab9d21a68c2e$export$b706b080d889d2c9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$k;
};
$bb4aab9d21a68c2e$export$5be5a87408f70ddc = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$h;
};
$bb4aab9d21a68c2e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $bb4aab9d21a68c2e$var$c;
};
$bb4aab9d21a68c2e$export$455c2e768291efa6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$n;
};
$bb4aab9d21a68c2e$export$9522e17588c12572 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$e;
};
$bb4aab9d21a68c2e$export$2110ac352bb060b9 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$t;
};
$bb4aab9d21a68c2e$export$56885ab8b9c456ab = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$r;
};
$bb4aab9d21a68c2e$export$d927fcb6adf8f9de = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$d;
};
$bb4aab9d21a68c2e$export$b82d16f27459e05a = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$g;
};
$bb4aab9d21a68c2e$export$522c17b4f5e123e8 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$f;
};
$bb4aab9d21a68c2e$export$1aabd8a0274ecfd6 = function(a) {
    return $bb4aab9d21a68c2e$var$z(a) === $bb4aab9d21a68c2e$var$p;
};
$bb4aab9d21a68c2e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $bb4aab9d21a68c2e$var$e || a === $bb4aab9d21a68c2e$var$m || a === $bb4aab9d21a68c2e$var$g || a === $bb4aab9d21a68c2e$var$f || a === $bb4aab9d21a68c2e$var$p || a === $bb4aab9d21a68c2e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $bb4aab9d21a68c2e$var$t || a.$$typeof === $bb4aab9d21a68c2e$var$r || a.$$typeof === $bb4aab9d21a68c2e$var$h || a.$$typeof === $bb4aab9d21a68c2e$var$k || a.$$typeof === $bb4aab9d21a68c2e$var$n || a.$$typeof === $bb4aab9d21a68c2e$var$w || a.$$typeof === $bb4aab9d21a68c2e$var$x || a.$$typeof === $bb4aab9d21a68c2e$var$y || a.$$typeof === $bb4aab9d21a68c2e$var$v);
};
$bb4aab9d21a68c2e$export$f5bbd400c2f4426f = $bb4aab9d21a68c2e$var$z;

});



parcelRegister("26oc5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $187ee8b65b3cfc60$export$2e2bcd8739ae039; });

var $fLqrY = parcelRequire("fLqrY");
/** Used to compose bitmasks for cloning. */ var $187ee8b65b3cfc60$var$CLONE_DEEP_FLAG = 1, $187ee8b65b3cfc60$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $187ee8b65b3cfc60$var$cloneDeep(value) {
    return (0, $fLqrY.default)(value, $187ee8b65b3cfc60$var$CLONE_DEEP_FLAG | $187ee8b65b3cfc60$var$CLONE_SYMBOLS_FLAG);
}
var $187ee8b65b3cfc60$export$2e2bcd8739ae039 = $187ee8b65b3cfc60$var$cloneDeep;

});


parcelRegister("8TKuU", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");

var $lAPp0 = parcelRequire("lAPp0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lAPp0;
module.exports = isBuffer;

});
parcelRegister("dnnhb", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `self`. */ var $9bcf7a804d00ded1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9bcf7a804d00ded1$var$root = $8vz42 || $9bcf7a804d00ded1$var$freeSelf || Function('return this')();
module.exports = $9bcf7a804d00ded1$var$root;

});
parcelRegister("8vz42", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $631c6b00c6701f20$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $631c6b00c6701f20$var$freeGlobal;

});


parcelRegister("lAPp0", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fb84d52c0f9b5c17$var$stubFalse() {
    return false;
}
module.exports = $fb84d52c0f9b5c17$var$stubFalse;

});


parcelRegister("1mm29", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8vz42.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("51vFz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3a859ca9a069815b$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3a859ca9a069815b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3a859ca9a069815b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3a859ca9a069815b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3a859ca9a069815b$var$_typeof(obj);
}
function $3a859ca9a069815b$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6RzIO.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if ($3a859ca9a069815b$var$_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $le96L.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("57Qo5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3bb63e45ffe0ab23$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3bb63e45ffe0ab23$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3bb63e45ffe0ab23$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3bb63e45ffe0ab23$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3bb63e45ffe0ab23$var$_typeof(obj);
}
function $3bb63e45ffe0ab23$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $6RzIO.default)(1, arguments);
    var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
    else if ($3bb63e45ffe0ab23$var$_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $le96L.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("5TnqA", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = '[native code]';
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(' ');
    }
    if (module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("1JHgz", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $143b8e347aaa867b$export$306c0aa65ff9ec16; }, function (v) { return $143b8e347aaa867b$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $143b8e347aaa867b$export$306c0aa65ff9ec16;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
function $143b8e347aaa867b$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $143b8e347aaa867b$var$objectIs = "function" === typeof Object.is ? Object.is : $143b8e347aaa867b$var$is, $143b8e347aaa867b$var$useState = $bh6RR.useState, $143b8e347aaa867b$var$useEffect = $bh6RR.useEffect, $143b8e347aaa867b$var$useLayoutEffect = $bh6RR.useLayoutEffect, $143b8e347aaa867b$var$useDebugValue = $bh6RR.useDebugValue;
function $143b8e347aaa867b$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $143b8e347aaa867b$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $143b8e347aaa867b$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $143b8e347aaa867b$var$useEffect(function() {
        $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $143b8e347aaa867b$var$useDebugValue(value);
    return value;
}
function $143b8e347aaa867b$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$143b8e347aaa867b$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $143b8e347aaa867b$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $143b8e347aaa867b$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $143b8e347aaa867b$var$useSyncExternalStore$1 : $143b8e347aaa867b$var$useSyncExternalStore$2;
$143b8e347aaa867b$export$306c0aa65ff9ec16 = void 0 !== $bh6RR.useSyncExternalStore ? $bh6RR.useSyncExternalStore : $143b8e347aaa867b$var$shim;

});

parcelRegister("eCdfQ", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ID", function () { return $b989095678aad739$export$19fc78b4b5aa5d0d; });
$parcel$export(module.exports, "LoaderStatus", function () { return $b989095678aad739$export$406cfe323c8bb8e4; });
$parcel$export(module.exports, "Loader", function () { return $b989095678aad739$export$3b0d6d7590275603; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $b989095678aad739$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $b989095678aad739$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $b989095678aad739$var$fastDeepEqual;
var $b989095678aad739$var$hasRequiredFastDeepEqual;
function $b989095678aad739$var$requireFastDeepEqual() {
    if ($b989095678aad739$var$hasRequiredFastDeepEqual) return $b989095678aad739$var$fastDeepEqual;
    $b989095678aad739$var$hasRequiredFastDeepEqual = 1;
    // do not edit .js files directly - edit src/index.jst
    $b989095678aad739$var$fastDeepEqual = function equal(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == 'object' && typeof b == 'object') {
            if (a.constructor !== b.constructor) return false;
            var length, i, keys;
            if (Array.isArray(a)) {
                length = a.length;
                if (length != b.length) return false;
                for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
                return true;
            }
            if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
            if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
            if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
            keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
            for(i = length; i-- !== 0;){
                var key = keys[i];
                if (!equal(a[key], b[key])) return false;
            }
            return true;
        }
        // true if both NaN, false otherwise
        return a !== a && b !== b;
    };
    return $b989095678aad739$var$fastDeepEqual;
}
var $b989095678aad739$var$fastDeepEqualExports = $b989095678aad739$var$requireFastDeepEqual();
var $b989095678aad739$var$isEqual = /*@__PURE__*/ $b989095678aad739$var$getDefaultExportFromCjs($b989095678aad739$var$fastDeepEqualExports);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b989095678aad739$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $b989095678aad739$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($b989095678aad739$export$406cfe323c8bb8e4 || ($b989095678aad739$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $b989095678aad739$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $b989095678aad739$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $b989095678aad739$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($b989095678aad739$export$3b0d6d7590275603.instance) {
            if (!$b989095678aad739$var$isEqual(this.options, $b989095678aad739$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($b989095678aad739$export$3b0d6d7590275603.instance.options)}`);
            return $b989095678aad739$export$3b0d6d7590275603.instance;
        }
        $b989095678aad739$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $b989095678aad739$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $b989095678aad739$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $b989095678aad739$export$406cfe323c8bb8e4.LOADING;
        return $b989095678aad739$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$b989095678aad739$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.loading) // do nothing but wait
        return;
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            this.loading = true;
            this.setScript();
        }
    }
}

});

parcelRegister("kEUo3", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("eCfBx", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("2tbKl"))();

});
parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $8c849a51633fc8b0$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});



parcelRegister("jmY8A", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e19eb875fe23a456$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $egwKS = parcelRequire("egwKS");

var $6RzIO = parcelRequire("6RzIO");
var $e19eb875fe23a456$var$MILLISECONDS_IN_HOUR = 3600000;
function $e19eb875fe23a456$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $egwKS.default)(dirtyDate, amount * $e19eb875fe23a456$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("h8qn4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c797a3ca3cdb5932$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $igItr = parcelRequire("igItr");

var $6RzIO = parcelRequire("6RzIO");
function $c797a3ca3cdb5932$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $igItr.default)(dirtyDate, days);
}

});

parcelRegister("4jKL6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $324d3518b1b08498$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $324d3518b1b08498$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("l7KXm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f60eacfe0e9716b8$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $4jKL6 = parcelRequire("4jKL6");

var $6RzIO = parcelRequire("6RzIO");
function $f60eacfe0e9716b8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $4jKL6.default)(dirtyDate, amount * 12);
}

});

parcelRegister("4iUK7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3224dbcc374d7f1a$export$2e2bcd8739ae039; });

var $8MQJ5 = parcelRequire("8MQJ5");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $3224dbcc374d7f1a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $8MQJ5.default)(dirtyDate, -amount);
}

});

parcelRegister("kh6Tl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ec2abdbcef4de5ce$export$2e2bcd8739ae039; });

var $jmY8A = parcelRequire("jmY8A");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $ec2abdbcef4de5ce$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $jmY8A.default)(dirtyDate, -amount);
}

});

parcelRegister("2Fdb4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1f09a1e13b0fcc18$export$2e2bcd8739ae039; });

var $igItr = parcelRequire("igItr");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $1f09a1e13b0fcc18$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $igItr.default)(dirtyDate, -amount);
}

});

parcelRegister("5VoG8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $45056b4386191645$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $h8qn4 = parcelRequire("h8qn4");

var $6RzIO = parcelRequire("6RzIO");
function $45056b4386191645$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $h8qn4.default)(dirtyDate, -amount);
}

});

parcelRegister("9c06P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $6b1551b9374f6b68$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $4jKL6 = parcelRequire("4jKL6");

var $6RzIO = parcelRequire("6RzIO");
function $6b1551b9374f6b68$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $4jKL6.default)(dirtyDate, -amount);
}

});

parcelRegister("8ztBX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $63d88fc7ac3543a3$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $l7KXm = parcelRequire("l7KXm");

var $6RzIO = parcelRequire("6RzIO");
function $63d88fc7ac3543a3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $6RzIO.default)(2, arguments);
    var amount = (0, $8d3vD.default)(dirtyAmount);
    return (0, $l7KXm.default)(dirtyDate, -amount);
}

});

parcelRegister("itOb4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d741dbab944cfeba$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d741dbab944cfeba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("bjv6P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $83c999b24199fe93$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $83c999b24199fe93$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("iuIgx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d76d5d942b6c7603$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d76d5d942b6c7603$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("dAPQy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9e56dad6a723865d$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $9e56dad6a723865d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("i8Ftf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $d3492493f9431cac$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $d3492493f9431cac$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("46D1n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $2fd5fdbd48aa4d51$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $fdRJz = parcelRequire("fdRJz");

var $cmTKX = parcelRequire("cmTKX");

var $6RzIO = parcelRequire("6RzIO");
var $2fd5fdbd48aa4d51$var$MILLISECONDS_IN_WEEK = 604800000;
function $2fd5fdbd48aa4d51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var diff = (0, $fdRJz.default)(date).getTime() - (0, $cmTKX.default)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2fd5fdbd48aa4d51$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("fdRJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b151c062c4dfd956$export$2e2bcd8739ae039; });

var $a0b1b = parcelRequire("a0b1b");

var $6RzIO = parcelRequire("6RzIO");
function $b151c062c4dfd956$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    return (0, $a0b1b.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("a0b1b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7482736b8e287f15$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $dCCOX = parcelRequire("dCCOX");
function $7482736b8e287f15$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("cmTKX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9012ca2dbc35bed9$export$2e2bcd8739ae039; });

var $eEXq4 = parcelRequire("eEXq4");

var $fdRJz = parcelRequire("fdRJz");

var $6RzIO = parcelRequire("6RzIO");
function $9012ca2dbc35bed9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var year = (0, $eEXq4.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $fdRJz.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("eEXq4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac2e49479d14f72$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $fdRJz = parcelRequire("fdRJz");

var $6RzIO = parcelRequire("6RzIO");
function $aac2e49479d14f72$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $fdRJz.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $fdRJz.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("g4Oj6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $bb440afc64012a62$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $bb440afc64012a62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("7rQJQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $56c3f6cb3d64a212$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $56c3f6cb3d64a212$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("7Qx6a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5b67106b80303158$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $5b67106b80303158$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    return (0, $le96L.default)(dirtyDate).getFullYear();
}

});

parcelRegister("8Pk0g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $66d29a62ad671df6$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $66d29a62ad671df6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("jewTs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e008d718aba2e9eb$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $ajF1O = parcelRequire("ajF1O");

var $6RzIO = parcelRequire("6RzIO");
function $e008d718aba2e9eb$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = (0, $8d3vD.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $ajF1O.default)(dateWithDesiredMonth); // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("ajF1O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $782b811855cace18$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $782b811855cace18$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("8Hcps", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $654bf72d32fd87c1$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $jewTs = parcelRequire("jewTs");

var $6RzIO = parcelRequire("6RzIO");
function $654bf72d32fd87c1$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var quarter = (0, $8d3vD.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $jewTs.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("585Rh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3bc23e7a7ee03bfe$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3bc23e7a7ee03bfe$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var year = (0, $8d3vD.default)(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("frPzN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $b3f16299565f3818$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $b3f16299565f3818$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("2rZyX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1c8ddb7b1b390e0d$export$2e2bcd8739ae039; });

var $a0b1b = parcelRequire("a0b1b");

var $8zxzx = parcelRequire("8zxzx");

var $6RzIO = parcelRequire("6RzIO");
var $1c8ddb7b1b390e0d$var$MILLISECONDS_IN_WEEK = 604800000;
function $1c8ddb7b1b390e0d$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $6RzIO.default)(2, arguments);
    var startOfWeekLeft = (0, $a0b1b.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $a0b1b.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $8zxzx.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $8zxzx.default)(startOfWeekRight); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $1c8ddb7b1b390e0d$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("ckwmq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8fa074789f5a199e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $8fa074789f5a199e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("krZy8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ee3612bcc22c95f6$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $ee3612bcc22c95f6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("5zLGe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $40f534e90d6b3242$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $40f534e90d6b3242$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("cbgMD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $8de387f375648f3e$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $8de387f375648f3e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var cleanDate = (0, $le96L.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("4tTuR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3434eb5bab1e76df$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $3434eb5bab1e76df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("dRdrY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a16aa884d52fc460$export$2e2bcd8739ae039; });

var $dCCOX = parcelRequire("dCCOX");

var $le96L = parcelRequire("le96L");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");
function $a16aa884d52fc460$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(1, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("TDfe5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0a7394535777dacf$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $0a7394535777dacf$export$2e2bcd8739ae039(dirtyDate) {
    (0, $6RzIO.default)(1, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("f66eH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $afdc40e50ef8ccc8$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $afdc40e50ef8ccc8$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyLeftDate);
    var dateRight = (0, $le96L.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("gUIpT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c5045487affbaf52$export$2e2bcd8739ae039; });

var $h8HSd = parcelRequire("h8HSd");

var $6RzIO = parcelRequire("6RzIO");
function $c5045487affbaf52$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeftStartOfDay = (0, $h8HSd.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $h8HSd.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("kqTgn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ee011a7595cab906$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $ee011a7595cab906$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("etVP0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a8b0a05107fac9a4$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $a8b0a05107fac9a4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeft = (0, $le96L.default)(dirtyDateLeft);
    var dateRight = (0, $le96L.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("hBzYg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $cd11cb73faaf7a50$export$2e2bcd8739ae039; });

var $5zLGe = parcelRequire("5zLGe");

var $6RzIO = parcelRequire("6RzIO");
function $cd11cb73faaf7a50$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $6RzIO.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $5zLGe.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $5zLGe.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("jNzMQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e69e5a70118ffe6b$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $e69e5a70118ffe6b$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dateToCompare = (0, $le96L.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("22veB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $17c3ff3944cd98da$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $17c3ff3944cd98da$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var dateToCompare = (0, $le96L.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("gDyFX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c1cb2fb95fbd857a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");
function $c1cb2fb95fbd857a$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $6RzIO.default)(2, arguments);
    var time = (0, $le96L.default)(dirtyDate).getTime();
    var startTime = (0, $le96L.default)(interval.start).getTime();
    var endTime = (0, $le96L.default)(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

});

parcelRegister("ejCCE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a6c0cca4ba136238$export$2e2bcd8739ae039; });

var $fhQJu = parcelRequire("fhQJu");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $5lXXI = parcelRequire("5lXXI");

var $dmQbx = parcelRequire("dmQbx");

var $8zxzx = parcelRequire("8zxzx");

var $xRN1E = parcelRequire("xRN1E");

var $8d3vD = parcelRequire("8d3vD");

var $6RzIO = parcelRequire("6RzIO");

var $bF26l = parcelRequire("bF26l");

var $dLP8x = parcelRequire("dLP8x");

var $dCCOX = parcelRequire("dCCOX");
function $a6c0cca4ba136238$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a6c0cca4ba136238$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a6c0cca4ba136238$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a6c0cca4ba136238$var$_typeof(obj);
}
function $a6c0cca4ba136238$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $a6c0cca4ba136238$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a6c0cca4ba136238$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a6c0cca4ba136238$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a6c0cca4ba136238$var$_arrayLikeToArray(o, minLen);
}
function $a6c0cca4ba136238$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $a6c0cca4ba136238$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $a6c0cca4ba136238$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $a6c0cca4ba136238$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $a6c0cca4ba136238$var$doubleQuoteRegExp = /''/g;
var $a6c0cca4ba136238$var$notWhitespaceRegExp = /\S/;
var $a6c0cca4ba136238$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $a6c0cca4ba136238$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $6RzIO.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $8d3vD.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $le96L.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    }; // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $bF26l.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($a6c0cca4ba136238$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $dmQbx.default)) {
            var longFormatter = (0, $dmQbx.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($a6c0cca4ba136238$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = $a6c0cca4ba136238$var$_createForOfIteratorHelper(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $xRN1E.isProtectedWeekYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $xRN1E.isProtectedDayOfYearToken)(token)) (0, $xRN1E.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $dLP8x.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($a6c0cca4ba136238$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                 // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $a6c0cca4ba136238$var$cleanEscapedString(token);
                 // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ($a6c0cca4ba136238$var$_typeof(_ret) === "object") return _ret.v;
        } // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $a6c0cca4ba136238$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $le96L.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $cfoI5.default)(date, (0, $8zxzx.default)(date));
    var flags = {};
    var _iterator2 = $a6c0cca4ba136238$var$_createForOfIteratorHelper(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions); // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $5lXXI.default)(flags, result[1]); // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $a6c0cca4ba136238$var$cleanEscapedString(input) {
    return input.match($a6c0cca4ba136238$var$escapedStringRegExp)[1].replace($a6c0cca4ba136238$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("5lXXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e5d6d2694ed7592$export$2e2bcd8739ae039; });
function $3e5d6d2694ed7592$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("bF26l", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", function () { return $87d5274f95235e24$export$9a09e32dd4990fd5; });
$parcel$export(module.exports, "DateToSystemTimezoneSetter", function () { return $87d5274f95235e24$export$5aaf7ff7f09ea4ee; });
function $87d5274f95235e24$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $87d5274f95235e24$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $87d5274f95235e24$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $87d5274f95235e24$var$_typeof(obj);
}
function $87d5274f95235e24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $87d5274f95235e24$var$_setPrototypeOf(subClass, superClass);
}
function $87d5274f95235e24$var$_setPrototypeOf(o, p) {
    $87d5274f95235e24$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $87d5274f95235e24$var$_setPrototypeOf(o, p);
}
function $87d5274f95235e24$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87d5274f95235e24$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $87d5274f95235e24$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $87d5274f95235e24$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $87d5274f95235e24$var$_possibleConstructorReturn(this, result);
    };
}
function $87d5274f95235e24$var$_possibleConstructorReturn(self, call) {
    if (call && ($87d5274f95235e24$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $87d5274f95235e24$var$_assertThisInitialized(self);
}
function $87d5274f95235e24$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $87d5274f95235e24$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $87d5274f95235e24$var$_getPrototypeOf(o) {
    $87d5274f95235e24$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $87d5274f95235e24$var$_getPrototypeOf(o);
}
function $87d5274f95235e24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d5274f95235e24$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87d5274f95235e24$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d5274f95235e24$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d5274f95235e24$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $87d5274f95235e24$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY = 10;
var $87d5274f95235e24$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        $87d5274f95235e24$var$_classCallCheck(this, Setter);
        $87d5274f95235e24$var$_defineProperty(this, "subPriority", 0);
    }
    $87d5274f95235e24$var$_createClass(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $87d5274f95235e24$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    $87d5274f95235e24$var$_inherits(ValueSetter, _Setter);
    var _super = $87d5274f95235e24$var$_createSuper(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        $87d5274f95235e24$var$_classCallCheck(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    $87d5274f95235e24$var$_createClass(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($87d5274f95235e24$export$81d53e3678089a6);
var $87d5274f95235e24$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    $87d5274f95235e24$var$_inherits(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = $87d5274f95235e24$var$_createSuper(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        $87d5274f95235e24$var$_classCallCheck(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        $87d5274f95235e24$var$_defineProperty($87d5274f95235e24$var$_assertThisInitialized(_this2), "priority", $87d5274f95235e24$var$TIMEZONE_UNIT_PRIORITY);
        $87d5274f95235e24$var$_defineProperty($87d5274f95235e24$var$_assertThisInitialized(_this2), "subPriority", -1);
        return _this2;
    }
    $87d5274f95235e24$var$_createClass(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($87d5274f95235e24$export$81d53e3678089a6);

});

parcelRegister("dLP8x", function(module, exports) {

$parcel$export(module.exports, "parsers", function () { return $a06754d708967e28$export$19131010e7fd8373; });

var $kfK2H = parcelRequire("kfK2H");

var $7giry = parcelRequire("7giry");

var $bCjfP = parcelRequire("bCjfP");

var $erSGt = parcelRequire("erSGt");

var $b8jnr = parcelRequire("b8jnr");

var $9AuQQ = parcelRequire("9AuQQ");

var $fE7CR = parcelRequire("fE7CR");

var $4rJhG = parcelRequire("4rJhG");

var $l09IK = parcelRequire("l09IK");

var $kHjhn = parcelRequire("kHjhn");

var $ijC3v = parcelRequire("ijC3v");

var $k1agz = parcelRequire("k1agz");

var $hfumD = parcelRequire("hfumD");

var $34xUW = parcelRequire("34xUW");

var $1hrH9 = parcelRequire("1hrH9");

var $1y17U = parcelRequire("1y17U");

var $lAmiB = parcelRequire("lAmiB");

var $hBBos = parcelRequire("hBBos");

var $iaLki = parcelRequire("iaLki");

var $hjAYL = parcelRequire("hjAYL");

var $5c3u4 = parcelRequire("5c3u4");

var $gBHKn = parcelRequire("gBHKn");

var $iBp2S = parcelRequire("iBp2S");

var $5MoaU = parcelRequire("5MoaU");

var $4WIYq = parcelRequire("4WIYq");

var $pKJVW = parcelRequire("pKJVW");

var $9ieQT = parcelRequire("9ieQT");

var $58dhe = parcelRequire("58dhe");

var $5zhxn = parcelRequire("5zhxn");

var $ap9CX = parcelRequire("ap9CX");

var $iiRyl = parcelRequire("iiRyl");
var $a06754d708967e28$export$19131010e7fd8373 = {
    G: new (0, $kfK2H.EraParser)(),
    y: new (0, $7giry.YearParser)(),
    Y: new (0, $bCjfP.LocalWeekYearParser)(),
    R: new (0, $erSGt.ISOWeekYearParser)(),
    u: new (0, $b8jnr.ExtendedYearParser)(),
    Q: new (0, $9AuQQ.QuarterParser)(),
    q: new (0, $fE7CR.StandAloneQuarterParser)(),
    M: new (0, $4rJhG.MonthParser)(),
    L: new (0, $l09IK.StandAloneMonthParser)(),
    w: new (0, $kHjhn.LocalWeekParser)(),
    I: new (0, $ijC3v.ISOWeekParser)(),
    d: new (0, $k1agz.DateParser)(),
    D: new (0, $hfumD.DayOfYearParser)(),
    E: new (0, $34xUW.DayParser)(),
    e: new (0, $1hrH9.LocalDayParser)(),
    c: new (0, $1y17U.StandAloneLocalDayParser)(),
    i: new (0, $lAmiB.ISODayParser)(),
    a: new (0, $hBBos.AMPMParser)(),
    b: new (0, $iaLki.AMPMMidnightParser)(),
    B: new (0, $hjAYL.DayPeriodParser)(),
    h: new (0, $5c3u4.Hour1to12Parser)(),
    H: new (0, $gBHKn.Hour0to23Parser)(),
    K: new (0, $iBp2S.Hour0To11Parser)(),
    k: new (0, $5MoaU.Hour1To24Parser)(),
    m: new (0, $4WIYq.MinuteParser)(),
    s: new (0, $pKJVW.SecondParser)(),
    S: new (0, $9ieQT.FractionOfSecondParser)(),
    X: new (0, $58dhe.ISOTimezoneWithZParser)(),
    x: new (0, $5zhxn.ISOTimezoneParser)(),
    t: new (0, $ap9CX.TimestampSecondsParser)(),
    T: new (0, $iiRyl.TimestampMillisecondsParser)()
};

});
parcelRegister("kfK2H", function(module, exports) {

$parcel$export(module.exports, "EraParser", function () { return $ebe8ec790bf47813$export$8e5a1d3f85a9688; });

var $hUQxR = parcelRequire("hUQxR");
function $ebe8ec790bf47813$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ebe8ec790bf47813$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ebe8ec790bf47813$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ebe8ec790bf47813$var$_typeof(obj);
}
function $ebe8ec790bf47813$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ebe8ec790bf47813$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ebe8ec790bf47813$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ebe8ec790bf47813$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ebe8ec790bf47813$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ebe8ec790bf47813$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ebe8ec790bf47813$var$_setPrototypeOf(subClass, superClass);
}
function $ebe8ec790bf47813$var$_setPrototypeOf(o, p) {
    $ebe8ec790bf47813$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ebe8ec790bf47813$var$_setPrototypeOf(o, p);
}
function $ebe8ec790bf47813$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ebe8ec790bf47813$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ebe8ec790bf47813$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ebe8ec790bf47813$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ebe8ec790bf47813$var$_possibleConstructorReturn(this, result);
    };
}
function $ebe8ec790bf47813$var$_possibleConstructorReturn(self, call) {
    if (call && ($ebe8ec790bf47813$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ebe8ec790bf47813$var$_assertThisInitialized(self);
}
function $ebe8ec790bf47813$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ebe8ec790bf47813$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ebe8ec790bf47813$var$_getPrototypeOf(o) {
    $ebe8ec790bf47813$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ebe8ec790bf47813$var$_getPrototypeOf(o);
}
function $ebe8ec790bf47813$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ebe8ec790bf47813$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    $ebe8ec790bf47813$var$_inherits(EraParser, _Parser);
    var _super = $ebe8ec790bf47813$var$_createSuper(EraParser);
    function EraParser() {
        var _this;
        $ebe8ec790bf47813$var$_classCallCheck(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $ebe8ec790bf47813$var$_defineProperty($ebe8ec790bf47813$var$_assertThisInitialized(_this), "priority", 140);
        $ebe8ec790bf47813$var$_defineProperty($ebe8ec790bf47813$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    $ebe8ec790bf47813$var$_createClass(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $hUQxR.Parser));

});
parcelRegister("hUQxR", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $d0b06d02a4758be0$export$7acfa6ed01010e37; });

var $bF26l = parcelRequire("bF26l");
function $d0b06d02a4758be0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0b06d02a4758be0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d0b06d02a4758be0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0b06d02a4758be0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0b06d02a4758be0$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $d0b06d02a4758be0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        $d0b06d02a4758be0$var$_classCallCheck(this, Parser);
    }
    $d0b06d02a4758be0$var$_createClass(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $bF26l.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("7giry", function(module, exports) {

$parcel$export(module.exports, "YearParser", function () { return $549855817f3e82c6$export$48d352de7cd4a988; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $549855817f3e82c6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $549855817f3e82c6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $549855817f3e82c6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $549855817f3e82c6$var$_typeof(obj);
}
function $549855817f3e82c6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $549855817f3e82c6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $549855817f3e82c6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $549855817f3e82c6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $549855817f3e82c6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $549855817f3e82c6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $549855817f3e82c6$var$_setPrototypeOf(subClass, superClass);
}
function $549855817f3e82c6$var$_setPrototypeOf(o, p) {
    $549855817f3e82c6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $549855817f3e82c6$var$_setPrototypeOf(o, p);
}
function $549855817f3e82c6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $549855817f3e82c6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $549855817f3e82c6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $549855817f3e82c6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $549855817f3e82c6$var$_possibleConstructorReturn(this, result);
    };
}
function $549855817f3e82c6$var$_possibleConstructorReturn(self, call) {
    if (call && ($549855817f3e82c6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $549855817f3e82c6$var$_assertThisInitialized(self);
}
function $549855817f3e82c6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $549855817f3e82c6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $549855817f3e82c6$var$_getPrototypeOf(o) {
    $549855817f3e82c6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $549855817f3e82c6$var$_getPrototypeOf(o);
}
function $549855817f3e82c6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $549855817f3e82c6$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    $549855817f3e82c6$var$_inherits(YearParser, _Parser);
    var _super = $549855817f3e82c6$var$_createSuper(YearParser);
    function YearParser() {
        var _this;
        $549855817f3e82c6$var$_classCallCheck(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $549855817f3e82c6$var$_defineProperty($549855817f3e82c6$var$_assertThisInitialized(_this), "priority", 130);
        $549855817f3e82c6$var$_defineProperty($549855817f3e82c6$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $549855817f3e82c6$var$_createClass(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $hUQxR.Parser));

});
parcelRegister("34rIp", function(module, exports) {

$parcel$export(module.exports, "mapValue", function () { return $23c73e81834f16a1$export$4f84e3a82c7b538; });
$parcel$export(module.exports, "parseNumericPattern", function () { return $23c73e81834f16a1$export$cc7cc9e2a3ff9388; });
$parcel$export(module.exports, "parseTimezonePattern", function () { return $23c73e81834f16a1$export$6497f4c0ecdfba8e; });
$parcel$export(module.exports, "parseAnyDigitsSigned", function () { return $23c73e81834f16a1$export$d931c43c4608a164; });
$parcel$export(module.exports, "parseNDigits", function () { return $23c73e81834f16a1$export$513bb01536146ab6; });
$parcel$export(module.exports, "parseNDigitsSigned", function () { return $23c73e81834f16a1$export$2c9307b2e29c533c; });
$parcel$export(module.exports, "dayPeriodEnumToHours", function () { return $23c73e81834f16a1$export$fb506d2676e7f207; });
$parcel$export(module.exports, "normalizeTwoDigitYear", function () { return $23c73e81834f16a1$export$29126f735cbf69f7; });
$parcel$export(module.exports, "isLeapYearIndex", function () { return $23c73e81834f16a1$export$3d50627710b84d75; });

var $6QTFS = parcelRequire("6QTFS");

var $hTmlY = parcelRequire("hTmlY");
function $23c73e81834f16a1$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $23c73e81834f16a1$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * (0, $6QTFS.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $23c73e81834f16a1$export$d931c43c4608a164(dateString) {
    return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).anyDigitsSigned, dateString);
}
function $23c73e81834f16a1$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigit, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigits, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigits, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigits, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $23c73e81834f16a1$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388((0, $hTmlY.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $23c73e81834f16a1$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $23c73e81834f16a1$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $23c73e81834f16a1$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $23c73e81834f16a1$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("6QTFS", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", function () { return $4fd2c93311e78e29$export$91246f0b9bd9beff; });
$parcel$export(module.exports, "millisecondsInHour", function () { return $4fd2c93311e78e29$export$7f72910d6dfd237a; });
$parcel$export(module.exports, "millisecondsInSecond", function () { return $4fd2c93311e78e29$export$397c2d5776aa9055; });
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4fd2c93311e78e29$export$dfd9b671c89acc8e = 7;
var $4fd2c93311e78e29$export$3913210603d8e9ae = 365.2425;
var $4fd2c93311e78e29$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4fd2c93311e78e29$export$91246f0b9bd9beff = 60000;
var $4fd2c93311e78e29$export$7f72910d6dfd237a = 3600000;
var $4fd2c93311e78e29$export$397c2d5776aa9055 = 1000;
var $4fd2c93311e78e29$export$4dec998e48f9c246 = -$4fd2c93311e78e29$export$81caae6e1cc7a622;
var $4fd2c93311e78e29$export$f2f5ae5a8e2d8f9f = 60;
var $4fd2c93311e78e29$export$3c58128db900d44e = 3;
var $4fd2c93311e78e29$export$80d7e435f744f319 = 12;
var $4fd2c93311e78e29$export$4db7641526e3241f = 4;
var $4fd2c93311e78e29$export$698aec755e92c695 = 3600;
var $4fd2c93311e78e29$export$a77c1a7ebebe2a5a = 60;
var $4fd2c93311e78e29$export$815a9362476d2fe3 = $4fd2c93311e78e29$export$698aec755e92c695 * 24;
var $4fd2c93311e78e29$export$34804a017b31e2fe = $4fd2c93311e78e29$export$815a9362476d2fe3 * 7;
var $4fd2c93311e78e29$export$7271e9e3478110d1 = $4fd2c93311e78e29$export$815a9362476d2fe3 * $4fd2c93311e78e29$export$3913210603d8e9ae;
var $4fd2c93311e78e29$export$8e6600bbdee7dabb = $4fd2c93311e78e29$export$7271e9e3478110d1 / 12;
var $4fd2c93311e78e29$export$be1dccf2de902d31 = $4fd2c93311e78e29$export$8e6600bbdee7dabb * 3;

});

parcelRegister("hTmlY", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", function () { return $d068e9ab48ef4207$export$c123ee06d9da8480; });
$parcel$export(module.exports, "timezonePatterns", function () { return $d068e9ab48ef4207$export$a7ee192b982af9c1; });
var $d068e9ab48ef4207$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $d068e9ab48ef4207$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("bCjfP", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", function () { return $87522dd793180ae9$export$b8ef38dfcf05d5db; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $e0HMe = parcelRequire("e0HMe");

var $j1YKz = parcelRequire("j1YKz");
function $87522dd793180ae9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $87522dd793180ae9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $87522dd793180ae9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $87522dd793180ae9$var$_typeof(obj);
}
function $87522dd793180ae9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87522dd793180ae9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $87522dd793180ae9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87522dd793180ae9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87522dd793180ae9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $87522dd793180ae9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $87522dd793180ae9$var$_setPrototypeOf(subClass, superClass);
}
function $87522dd793180ae9$var$_setPrototypeOf(o, p) {
    $87522dd793180ae9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $87522dd793180ae9$var$_setPrototypeOf(o, p);
}
function $87522dd793180ae9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $87522dd793180ae9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $87522dd793180ae9$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $87522dd793180ae9$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $87522dd793180ae9$var$_possibleConstructorReturn(this, result);
    };
}
function $87522dd793180ae9$var$_possibleConstructorReturn(self, call) {
    if (call && ($87522dd793180ae9$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $87522dd793180ae9$var$_assertThisInitialized(self);
}
function $87522dd793180ae9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $87522dd793180ae9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $87522dd793180ae9$var$_getPrototypeOf(o) {
    $87522dd793180ae9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $87522dd793180ae9$var$_getPrototypeOf(o);
}
function $87522dd793180ae9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $87522dd793180ae9$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    $87522dd793180ae9$var$_inherits(LocalWeekYearParser, _Parser);
    var _super = $87522dd793180ae9$var$_createSuper(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        $87522dd793180ae9$var$_classCallCheck(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $87522dd793180ae9$var$_defineProperty($87522dd793180ae9$var$_assertThisInitialized(_this), "priority", 130);
        $87522dd793180ae9$var$_defineProperty($87522dd793180ae9$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $87522dd793180ae9$var$_createClass(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $e0HMe.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $34rIp.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $j1YKz.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $j1YKz.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("erSGt", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", function () { return $a84e016bf722cd37$export$951d1df011fde06f; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $byvVj = parcelRequire("byvVj");
function $a84e016bf722cd37$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a84e016bf722cd37$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a84e016bf722cd37$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a84e016bf722cd37$var$_typeof(obj);
}
function $a84e016bf722cd37$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a84e016bf722cd37$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a84e016bf722cd37$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a84e016bf722cd37$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a84e016bf722cd37$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a84e016bf722cd37$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a84e016bf722cd37$var$_setPrototypeOf(subClass, superClass);
}
function $a84e016bf722cd37$var$_setPrototypeOf(o, p) {
    $a84e016bf722cd37$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a84e016bf722cd37$var$_setPrototypeOf(o, p);
}
function $a84e016bf722cd37$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a84e016bf722cd37$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $a84e016bf722cd37$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $a84e016bf722cd37$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a84e016bf722cd37$var$_possibleConstructorReturn(this, result);
    };
}
function $a84e016bf722cd37$var$_possibleConstructorReturn(self, call) {
    if (call && ($a84e016bf722cd37$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $a84e016bf722cd37$var$_assertThisInitialized(self);
}
function $a84e016bf722cd37$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a84e016bf722cd37$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a84e016bf722cd37$var$_getPrototypeOf(o) {
    $a84e016bf722cd37$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a84e016bf722cd37$var$_getPrototypeOf(o);
}
function $a84e016bf722cd37$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $a84e016bf722cd37$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    $a84e016bf722cd37$var$_inherits(ISOWeekYearParser, _Parser);
    var _super = $a84e016bf722cd37$var$_createSuper(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        $a84e016bf722cd37$var$_classCallCheck(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $a84e016bf722cd37$var$_defineProperty($a84e016bf722cd37$var$_assertThisInitialized(_this), "priority", 130);
        $a84e016bf722cd37$var$_defineProperty($a84e016bf722cd37$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $a84e016bf722cd37$var$_createClass(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $byvVj.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("b8jnr", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", function () { return $81af78f43f454158$export$bad9d2ea38e8f1a; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $81af78f43f454158$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $81af78f43f454158$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $81af78f43f454158$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $81af78f43f454158$var$_typeof(obj);
}
function $81af78f43f454158$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $81af78f43f454158$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $81af78f43f454158$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $81af78f43f454158$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $81af78f43f454158$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $81af78f43f454158$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $81af78f43f454158$var$_setPrototypeOf(subClass, superClass);
}
function $81af78f43f454158$var$_setPrototypeOf(o, p) {
    $81af78f43f454158$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $81af78f43f454158$var$_setPrototypeOf(o, p);
}
function $81af78f43f454158$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $81af78f43f454158$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $81af78f43f454158$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $81af78f43f454158$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $81af78f43f454158$var$_possibleConstructorReturn(this, result);
    };
}
function $81af78f43f454158$var$_possibleConstructorReturn(self, call) {
    if (call && ($81af78f43f454158$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $81af78f43f454158$var$_assertThisInitialized(self);
}
function $81af78f43f454158$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $81af78f43f454158$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $81af78f43f454158$var$_getPrototypeOf(o) {
    $81af78f43f454158$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81af78f43f454158$var$_getPrototypeOf(o);
}
function $81af78f43f454158$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $81af78f43f454158$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    $81af78f43f454158$var$_inherits(ExtendedYearParser, _Parser);
    var _super = $81af78f43f454158$var$_createSuper(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        $81af78f43f454158$var$_classCallCheck(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $81af78f43f454158$var$_defineProperty($81af78f43f454158$var$_assertThisInitialized(_this), "priority", 130);
        $81af78f43f454158$var$_defineProperty($81af78f43f454158$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $81af78f43f454158$var$_createClass(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $34rIp.parseNDigitsSigned)(4, dateString);
                return (0, $34rIp.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9AuQQ", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", function () { return $6faf6842e3324a5b$export$5cb0f701186dde1d; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $6faf6842e3324a5b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6faf6842e3324a5b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6faf6842e3324a5b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6faf6842e3324a5b$var$_typeof(obj);
}
function $6faf6842e3324a5b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6faf6842e3324a5b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6faf6842e3324a5b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6faf6842e3324a5b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6faf6842e3324a5b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6faf6842e3324a5b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6faf6842e3324a5b$var$_setPrototypeOf(subClass, superClass);
}
function $6faf6842e3324a5b$var$_setPrototypeOf(o, p) {
    $6faf6842e3324a5b$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6faf6842e3324a5b$var$_setPrototypeOf(o, p);
}
function $6faf6842e3324a5b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6faf6842e3324a5b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6faf6842e3324a5b$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6faf6842e3324a5b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6faf6842e3324a5b$var$_possibleConstructorReturn(this, result);
    };
}
function $6faf6842e3324a5b$var$_possibleConstructorReturn(self, call) {
    if (call && ($6faf6842e3324a5b$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6faf6842e3324a5b$var$_assertThisInitialized(self);
}
function $6faf6842e3324a5b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6faf6842e3324a5b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6faf6842e3324a5b$var$_getPrototypeOf(o) {
    $6faf6842e3324a5b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6faf6842e3324a5b$var$_getPrototypeOf(o);
}
function $6faf6842e3324a5b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6faf6842e3324a5b$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    $6faf6842e3324a5b$var$_inherits(QuarterParser, _Parser);
    var _super = $6faf6842e3324a5b$var$_createSuper(QuarterParser);
    function QuarterParser() {
        var _this;
        $6faf6842e3324a5b$var$_classCallCheck(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6faf6842e3324a5b$var$_defineProperty($6faf6842e3324a5b$var$_assertThisInitialized(_this), "priority", 120);
        $6faf6842e3324a5b$var$_defineProperty($6faf6842e3324a5b$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $6faf6842e3324a5b$var$_createClass(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("fE7CR", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", function () { return $b64081c42280f47c$export$300c0c2990e20e6d; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $b64081c42280f47c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b64081c42280f47c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b64081c42280f47c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b64081c42280f47c$var$_typeof(obj);
}
function $b64081c42280f47c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b64081c42280f47c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b64081c42280f47c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b64081c42280f47c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b64081c42280f47c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b64081c42280f47c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b64081c42280f47c$var$_setPrototypeOf(subClass, superClass);
}
function $b64081c42280f47c$var$_setPrototypeOf(o, p) {
    $b64081c42280f47c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b64081c42280f47c$var$_setPrototypeOf(o, p);
}
function $b64081c42280f47c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b64081c42280f47c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b64081c42280f47c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b64081c42280f47c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b64081c42280f47c$var$_possibleConstructorReturn(this, result);
    };
}
function $b64081c42280f47c$var$_possibleConstructorReturn(self, call) {
    if (call && ($b64081c42280f47c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b64081c42280f47c$var$_assertThisInitialized(self);
}
function $b64081c42280f47c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b64081c42280f47c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b64081c42280f47c$var$_getPrototypeOf(o) {
    $b64081c42280f47c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b64081c42280f47c$var$_getPrototypeOf(o);
}
function $b64081c42280f47c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $b64081c42280f47c$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    $b64081c42280f47c$var$_inherits(StandAloneQuarterParser, _Parser);
    var _super = $b64081c42280f47c$var$_createSuper(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        $b64081c42280f47c$var$_classCallCheck(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $b64081c42280f47c$var$_defineProperty($b64081c42280f47c$var$_assertThisInitialized(_this), "priority", 120);
        $b64081c42280f47c$var$_defineProperty($b64081c42280f47c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $b64081c42280f47c$var$_createClass(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $hUQxR.Parser));

});

parcelRegister("4rJhG", function(module, exports) {

$parcel$export(module.exports, "MonthParser", function () { return $33cccf8698e26325$export$400dd8b40ef138a3; });

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
function $33cccf8698e26325$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $33cccf8698e26325$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $33cccf8698e26325$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $33cccf8698e26325$var$_typeof(obj);
}
function $33cccf8698e26325$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $33cccf8698e26325$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $33cccf8698e26325$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $33cccf8698e26325$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $33cccf8698e26325$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $33cccf8698e26325$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $33cccf8698e26325$var$_setPrototypeOf(subClass, superClass);
}
function $33cccf8698e26325$var$_setPrototypeOf(o, p) {
    $33cccf8698e26325$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $33cccf8698e26325$var$_setPrototypeOf(o, p);
}
function $33cccf8698e26325$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $33cccf8698e26325$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $33cccf8698e26325$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $33cccf8698e26325$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $33cccf8698e26325$var$_possibleConstructorReturn(this, result);
    };
}
function $33cccf8698e26325$var$_possibleConstructorReturn(self, call) {
    if (call && ($33cccf8698e26325$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $33cccf8698e26325$var$_assertThisInitialized(self);
}
function $33cccf8698e26325$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $33cccf8698e26325$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $33cccf8698e26325$var$_getPrototypeOf(o) {
    $33cccf8698e26325$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $33cccf8698e26325$var$_getPrototypeOf(o);
}
function $33cccf8698e26325$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $33cccf8698e26325$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    $33cccf8698e26325$var$_inherits(MonthParser, _Parser);
    var _super = $33cccf8698e26325$var$_createSuper(MonthParser);
    function MonthParser() {
        var _this;
        $33cccf8698e26325$var$_classCallCheck(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $33cccf8698e26325$var$_defineProperty($33cccf8698e26325$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        $33cccf8698e26325$var$_defineProperty($33cccf8698e26325$var$_assertThisInitialized(_this), "priority", 110);
        return _this;
    }
    $33cccf8698e26325$var$_createClass(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("l09IK", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", function () { return $f4a12364ed86f021$export$1d7eaa53eaa5deba; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $f4a12364ed86f021$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f4a12364ed86f021$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f4a12364ed86f021$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f4a12364ed86f021$var$_typeof(obj);
}
function $f4a12364ed86f021$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f4a12364ed86f021$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f4a12364ed86f021$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f4a12364ed86f021$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f4a12364ed86f021$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f4a12364ed86f021$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f4a12364ed86f021$var$_setPrototypeOf(subClass, superClass);
}
function $f4a12364ed86f021$var$_setPrototypeOf(o, p) {
    $f4a12364ed86f021$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f4a12364ed86f021$var$_setPrototypeOf(o, p);
}
function $f4a12364ed86f021$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f4a12364ed86f021$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f4a12364ed86f021$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f4a12364ed86f021$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f4a12364ed86f021$var$_possibleConstructorReturn(this, result);
    };
}
function $f4a12364ed86f021$var$_possibleConstructorReturn(self, call) {
    if (call && ($f4a12364ed86f021$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f4a12364ed86f021$var$_assertThisInitialized(self);
}
function $f4a12364ed86f021$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f4a12364ed86f021$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f4a12364ed86f021$var$_getPrototypeOf(o) {
    $f4a12364ed86f021$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f4a12364ed86f021$var$_getPrototypeOf(o);
}
function $f4a12364ed86f021$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f4a12364ed86f021$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    $f4a12364ed86f021$var$_inherits(StandAloneMonthParser, _Parser);
    var _super = $f4a12364ed86f021$var$_createSuper(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        $f4a12364ed86f021$var$_classCallCheck(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $f4a12364ed86f021$var$_defineProperty($f4a12364ed86f021$var$_assertThisInitialized(_this), "priority", 110);
        $f4a12364ed86f021$var$_defineProperty($f4a12364ed86f021$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $f4a12364ed86f021$var$_createClass(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $hUQxR.Parser));

});

parcelRegister("kHjhn", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", function () { return $f116c747f72ce972$export$c4005ffc174e07c0; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $dv4uq = parcelRequire("dv4uq");

var $j1YKz = parcelRequire("j1YKz");
function $f116c747f72ce972$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f116c747f72ce972$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f116c747f72ce972$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f116c747f72ce972$var$_typeof(obj);
}
function $f116c747f72ce972$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f116c747f72ce972$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f116c747f72ce972$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f116c747f72ce972$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f116c747f72ce972$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f116c747f72ce972$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f116c747f72ce972$var$_setPrototypeOf(subClass, superClass);
}
function $f116c747f72ce972$var$_setPrototypeOf(o, p) {
    $f116c747f72ce972$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f116c747f72ce972$var$_setPrototypeOf(o, p);
}
function $f116c747f72ce972$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f116c747f72ce972$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f116c747f72ce972$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f116c747f72ce972$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f116c747f72ce972$var$_possibleConstructorReturn(this, result);
    };
}
function $f116c747f72ce972$var$_possibleConstructorReturn(self, call) {
    if (call && ($f116c747f72ce972$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f116c747f72ce972$var$_assertThisInitialized(self);
}
function $f116c747f72ce972$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f116c747f72ce972$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f116c747f72ce972$var$_getPrototypeOf(o) {
    $f116c747f72ce972$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f116c747f72ce972$var$_getPrototypeOf(o);
}
function $f116c747f72ce972$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $f116c747f72ce972$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    $f116c747f72ce972$var$_inherits(LocalWeekParser, _Parser);
    var _super = $f116c747f72ce972$var$_createSuper(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        $f116c747f72ce972$var$_classCallCheck(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $f116c747f72ce972$var$_defineProperty($f116c747f72ce972$var$_assertThisInitialized(_this), "priority", 100);
        $f116c747f72ce972$var$_defineProperty($f116c747f72ce972$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    $f116c747f72ce972$var$_createClass(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $j1YKz.default)((0, $dv4uq.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("dv4uq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d41a7323856a4d2$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $bCYgf = parcelRequire("bCYgf");

var $6RzIO = parcelRequire("6RzIO");
function $9d41a7323856a4d2$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var week = (0, $8d3vD.default)(dirtyWeek);
    var diff = (0, $bCYgf.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("ijC3v", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", function () { return $d557856122cd2900$export$6fc8dbedd560a6af; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");

var $eK3pq = parcelRequire("eK3pq");

var $byvVj = parcelRequire("byvVj");
function $d557856122cd2900$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d557856122cd2900$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d557856122cd2900$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d557856122cd2900$var$_typeof(obj);
}
function $d557856122cd2900$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d557856122cd2900$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d557856122cd2900$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d557856122cd2900$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d557856122cd2900$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d557856122cd2900$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d557856122cd2900$var$_setPrototypeOf(subClass, superClass);
}
function $d557856122cd2900$var$_setPrototypeOf(o, p) {
    $d557856122cd2900$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d557856122cd2900$var$_setPrototypeOf(o, p);
}
function $d557856122cd2900$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d557856122cd2900$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d557856122cd2900$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d557856122cd2900$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d557856122cd2900$var$_possibleConstructorReturn(this, result);
    };
}
function $d557856122cd2900$var$_possibleConstructorReturn(self, call) {
    if (call && ($d557856122cd2900$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d557856122cd2900$var$_assertThisInitialized(self);
}
function $d557856122cd2900$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d557856122cd2900$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d557856122cd2900$var$_getPrototypeOf(o) {
    $d557856122cd2900$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d557856122cd2900$var$_getPrototypeOf(o);
}
function $d557856122cd2900$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d557856122cd2900$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    $d557856122cd2900$var$_inherits(ISOWeekParser, _Parser);
    var _super = $d557856122cd2900$var$_createSuper(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        $d557856122cd2900$var$_classCallCheck(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d557856122cd2900$var$_defineProperty($d557856122cd2900$var$_assertThisInitialized(_this), "priority", 100);
        $d557856122cd2900$var$_defineProperty($d557856122cd2900$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $d557856122cd2900$var$_createClass(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $byvVj.default)((0, $eK3pq.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $hUQxR.Parser));

});
parcelRegister("eK3pq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abb8018924dbdc39$export$2e2bcd8739ae039; });

var $8d3vD = parcelRequire("8d3vD");

var $le96L = parcelRequire("le96L");

var $9rMx7 = parcelRequire("9rMx7");

var $6RzIO = parcelRequire("6RzIO");
function $abb8018924dbdc39$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var isoWeek = (0, $8d3vD.default)(dirtyISOWeek);
    var diff = (0, $9rMx7.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("k1agz", function(module, exports) {

$parcel$export(module.exports, "DateParser", function () { return $03c2c5a25468de8c$export$e8d4b28a20981dd2; });

var $34rIp = parcelRequire("34rIp");

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");
function $03c2c5a25468de8c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $03c2c5a25468de8c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $03c2c5a25468de8c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $03c2c5a25468de8c$var$_typeof(obj);
}
function $03c2c5a25468de8c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $03c2c5a25468de8c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $03c2c5a25468de8c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $03c2c5a25468de8c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $03c2c5a25468de8c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $03c2c5a25468de8c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $03c2c5a25468de8c$var$_setPrototypeOf(subClass, superClass);
}
function $03c2c5a25468de8c$var$_setPrototypeOf(o, p) {
    $03c2c5a25468de8c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $03c2c5a25468de8c$var$_setPrototypeOf(o, p);
}
function $03c2c5a25468de8c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $03c2c5a25468de8c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $03c2c5a25468de8c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $03c2c5a25468de8c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $03c2c5a25468de8c$var$_possibleConstructorReturn(this, result);
    };
}
function $03c2c5a25468de8c$var$_possibleConstructorReturn(self, call) {
    if (call && ($03c2c5a25468de8c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $03c2c5a25468de8c$var$_assertThisInitialized(self);
}
function $03c2c5a25468de8c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $03c2c5a25468de8c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $03c2c5a25468de8c$var$_getPrototypeOf(o) {
    $03c2c5a25468de8c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $03c2c5a25468de8c$var$_getPrototypeOf(o);
}
function $03c2c5a25468de8c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $03c2c5a25468de8c$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // Day of the month
var $03c2c5a25468de8c$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    $03c2c5a25468de8c$var$_inherits(DateParser, _Parser);
    var _super = $03c2c5a25468de8c$var$_createSuper(DateParser);
    function DateParser() {
        var _this;
        $03c2c5a25468de8c$var$_classCallCheck(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $03c2c5a25468de8c$var$_defineProperty($03c2c5a25468de8c$var$_assertThisInitialized(_this), "priority", 90);
        $03c2c5a25468de8c$var$_defineProperty($03c2c5a25468de8c$var$_assertThisInitialized(_this), "subPriority", 1);
        $03c2c5a25468de8c$var$_defineProperty($03c2c5a25468de8c$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $03c2c5a25468de8c$var$_createClass(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $03c2c5a25468de8c$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hfumD", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", function () { return $c8eb640c9739e432$export$6cfe0d613455f615; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $c8eb640c9739e432$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c8eb640c9739e432$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c8eb640c9739e432$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c8eb640c9739e432$var$_typeof(obj);
}
function $c8eb640c9739e432$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c8eb640c9739e432$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c8eb640c9739e432$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c8eb640c9739e432$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c8eb640c9739e432$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c8eb640c9739e432$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c8eb640c9739e432$var$_setPrototypeOf(subClass, superClass);
}
function $c8eb640c9739e432$var$_setPrototypeOf(o, p) {
    $c8eb640c9739e432$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c8eb640c9739e432$var$_setPrototypeOf(o, p);
}
function $c8eb640c9739e432$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c8eb640c9739e432$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c8eb640c9739e432$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c8eb640c9739e432$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c8eb640c9739e432$var$_possibleConstructorReturn(this, result);
    };
}
function $c8eb640c9739e432$var$_possibleConstructorReturn(self, call) {
    if (call && ($c8eb640c9739e432$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c8eb640c9739e432$var$_assertThisInitialized(self);
}
function $c8eb640c9739e432$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c8eb640c9739e432$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c8eb640c9739e432$var$_getPrototypeOf(o) {
    $c8eb640c9739e432$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c8eb640c9739e432$var$_getPrototypeOf(o);
}
function $c8eb640c9739e432$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c8eb640c9739e432$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    $c8eb640c9739e432$var$_inherits(DayOfYearParser, _Parser);
    var _super = $c8eb640c9739e432$var$_createSuper(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        $c8eb640c9739e432$var$_classCallCheck(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c8eb640c9739e432$var$_defineProperty($c8eb640c9739e432$var$_assertThisInitialized(_this), "priority", 90);
        $c8eb640c9739e432$var$_defineProperty($c8eb640c9739e432$var$_assertThisInitialized(_this), "subpriority", 1);
        $c8eb640c9739e432$var$_defineProperty($c8eb640c9739e432$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $c8eb640c9739e432$var$_createClass(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $34rIp.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $hUQxR.Parser));

});

parcelRegister("34xUW", function(module, exports) {

$parcel$export(module.exports, "DayParser", function () { return $23cc0e1fc897acb6$export$1b03c8b76262f7bd; });

var $hUQxR = parcelRequire("hUQxR");

var $crAxU = parcelRequire("crAxU");
function $23cc0e1fc897acb6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $23cc0e1fc897acb6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $23cc0e1fc897acb6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $23cc0e1fc897acb6$var$_typeof(obj);
}
function $23cc0e1fc897acb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $23cc0e1fc897acb6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $23cc0e1fc897acb6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $23cc0e1fc897acb6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $23cc0e1fc897acb6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $23cc0e1fc897acb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $23cc0e1fc897acb6$var$_setPrototypeOf(subClass, superClass);
}
function $23cc0e1fc897acb6$var$_setPrototypeOf(o, p) {
    $23cc0e1fc897acb6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $23cc0e1fc897acb6$var$_setPrototypeOf(o, p);
}
function $23cc0e1fc897acb6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $23cc0e1fc897acb6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $23cc0e1fc897acb6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $23cc0e1fc897acb6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $23cc0e1fc897acb6$var$_possibleConstructorReturn(this, result);
    };
}
function $23cc0e1fc897acb6$var$_possibleConstructorReturn(self, call) {
    if (call && ($23cc0e1fc897acb6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $23cc0e1fc897acb6$var$_assertThisInitialized(self);
}
function $23cc0e1fc897acb6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $23cc0e1fc897acb6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $23cc0e1fc897acb6$var$_getPrototypeOf(o) {
    $23cc0e1fc897acb6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $23cc0e1fc897acb6$var$_getPrototypeOf(o);
}
function $23cc0e1fc897acb6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $23cc0e1fc897acb6$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    $23cc0e1fc897acb6$var$_inherits(DayParser, _Parser);
    var _super = $23cc0e1fc897acb6$var$_createSuper(DayParser);
    function DayParser() {
        var _this;
        $23cc0e1fc897acb6$var$_classCallCheck(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $23cc0e1fc897acb6$var$_defineProperty($23cc0e1fc897acb6$var$_assertThisInitialized(_this), "priority", 90);
        $23cc0e1fc897acb6$var$_defineProperty($23cc0e1fc897acb6$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $23cc0e1fc897acb6$var$_createClass(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("crAxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $90f45aecbf821b24$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");

var $dCCOX = parcelRequire("dCCOX");
function $90f45aecbf821b24$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(2, arguments);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var weekStartsOn = (0, $8d3vD.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $le96L.default)(dirtyDate);
    var day = (0, $8d3vD.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("1hrH9", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", function () { return $0eecdc9e9334cc90$export$44d1c127ab42c480; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
function $0eecdc9e9334cc90$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $0eecdc9e9334cc90$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $0eecdc9e9334cc90$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $0eecdc9e9334cc90$var$_typeof(obj);
}
function $0eecdc9e9334cc90$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0eecdc9e9334cc90$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0eecdc9e9334cc90$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0eecdc9e9334cc90$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0eecdc9e9334cc90$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $0eecdc9e9334cc90$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0eecdc9e9334cc90$var$_setPrototypeOf(subClass, superClass);
}
function $0eecdc9e9334cc90$var$_setPrototypeOf(o, p) {
    $0eecdc9e9334cc90$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0eecdc9e9334cc90$var$_setPrototypeOf(o, p);
}
function $0eecdc9e9334cc90$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0eecdc9e9334cc90$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $0eecdc9e9334cc90$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $0eecdc9e9334cc90$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $0eecdc9e9334cc90$var$_possibleConstructorReturn(this, result);
    };
}
function $0eecdc9e9334cc90$var$_possibleConstructorReturn(self, call) {
    if (call && ($0eecdc9e9334cc90$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $0eecdc9e9334cc90$var$_assertThisInitialized(self);
}
function $0eecdc9e9334cc90$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $0eecdc9e9334cc90$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $0eecdc9e9334cc90$var$_getPrototypeOf(o) {
    $0eecdc9e9334cc90$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0eecdc9e9334cc90$var$_getPrototypeOf(o);
}
function $0eecdc9e9334cc90$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $0eecdc9e9334cc90$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    $0eecdc9e9334cc90$var$_inherits(LocalDayParser, _Parser);
    var _super = $0eecdc9e9334cc90$var$_createSuper(LocalDayParser);
    function LocalDayParser() {
        var _this;
        $0eecdc9e9334cc90$var$_classCallCheck(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $0eecdc9e9334cc90$var$_defineProperty($0eecdc9e9334cc90$var$_assertThisInitialized(_this), "priority", 90);
        $0eecdc9e9334cc90$var$_defineProperty($0eecdc9e9334cc90$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $0eecdc9e9334cc90$var$_createClass(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("1y17U", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", function () { return $1209d7268c6c9e45$export$e447a647caaaec1d; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $crAxU = parcelRequire("crAxU");
function $1209d7268c6c9e45$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1209d7268c6c9e45$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1209d7268c6c9e45$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1209d7268c6c9e45$var$_typeof(obj);
}
function $1209d7268c6c9e45$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1209d7268c6c9e45$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1209d7268c6c9e45$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1209d7268c6c9e45$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1209d7268c6c9e45$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1209d7268c6c9e45$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1209d7268c6c9e45$var$_setPrototypeOf(subClass, superClass);
}
function $1209d7268c6c9e45$var$_setPrototypeOf(o, p) {
    $1209d7268c6c9e45$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1209d7268c6c9e45$var$_setPrototypeOf(o, p);
}
function $1209d7268c6c9e45$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1209d7268c6c9e45$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1209d7268c6c9e45$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1209d7268c6c9e45$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1209d7268c6c9e45$var$_possibleConstructorReturn(this, result);
    };
}
function $1209d7268c6c9e45$var$_possibleConstructorReturn(self, call) {
    if (call && ($1209d7268c6c9e45$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1209d7268c6c9e45$var$_assertThisInitialized(self);
}
function $1209d7268c6c9e45$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1209d7268c6c9e45$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1209d7268c6c9e45$var$_getPrototypeOf(o) {
    $1209d7268c6c9e45$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1209d7268c6c9e45$var$_getPrototypeOf(o);
}
function $1209d7268c6c9e45$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1209d7268c6c9e45$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    $1209d7268c6c9e45$var$_inherits(StandAloneLocalDayParser, _Parser);
    var _super = $1209d7268c6c9e45$var$_createSuper(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        $1209d7268c6c9e45$var$_classCallCheck(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1209d7268c6c9e45$var$_defineProperty($1209d7268c6c9e45$var$_assertThisInitialized(_this), "priority", 90);
        $1209d7268c6c9e45$var$_defineProperty($1209d7268c6c9e45$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    $1209d7268c6c9e45$var$_createClass(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $34rIp.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $crAxU.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $hUQxR.Parser));

});

parcelRegister("lAmiB", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", function () { return $fb6e41e61f98589a$export$693fb1e525095b2a; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");

var $4QPB4 = parcelRequire("4QPB4");
function $fb6e41e61f98589a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fb6e41e61f98589a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fb6e41e61f98589a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fb6e41e61f98589a$var$_typeof(obj);
}
function $fb6e41e61f98589a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fb6e41e61f98589a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fb6e41e61f98589a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fb6e41e61f98589a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fb6e41e61f98589a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fb6e41e61f98589a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fb6e41e61f98589a$var$_setPrototypeOf(subClass, superClass);
}
function $fb6e41e61f98589a$var$_setPrototypeOf(o, p) {
    $fb6e41e61f98589a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fb6e41e61f98589a$var$_setPrototypeOf(o, p);
}
function $fb6e41e61f98589a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fb6e41e61f98589a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fb6e41e61f98589a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fb6e41e61f98589a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fb6e41e61f98589a$var$_possibleConstructorReturn(this, result);
    };
}
function $fb6e41e61f98589a$var$_possibleConstructorReturn(self, call) {
    if (call && ($fb6e41e61f98589a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fb6e41e61f98589a$var$_assertThisInitialized(self);
}
function $fb6e41e61f98589a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fb6e41e61f98589a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fb6e41e61f98589a$var$_getPrototypeOf(o) {
    $fb6e41e61f98589a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fb6e41e61f98589a$var$_getPrototypeOf(o);
}
function $fb6e41e61f98589a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $fb6e41e61f98589a$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    $fb6e41e61f98589a$var$_inherits(ISODayParser, _Parser);
    var _super = $fb6e41e61f98589a$var$_createSuper(ISODayParser);
    function ISODayParser() {
        var _this;
        $fb6e41e61f98589a$var$_classCallCheck(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $fb6e41e61f98589a$var$_defineProperty($fb6e41e61f98589a$var$_assertThisInitialized(_this), "priority", 90);
        $fb6e41e61f98589a$var$_defineProperty($fb6e41e61f98589a$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    $fb6e41e61f98589a$var$_createClass(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $34rIp.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $4QPB4.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $hUQxR.Parser));

});
parcelRegister("4QPB4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38840ad6986b421a$export$2e2bcd8739ae039; });

var $le96L = parcelRequire("le96L");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $38840ad6986b421a$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $6RzIO.default)(2, arguments);
    var day = (0, $8d3vD.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $le96L.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("hBBos", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", function () { return $cd12e5ead675216a$export$8d1e08492351df91; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $cd12e5ead675216a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cd12e5ead675216a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cd12e5ead675216a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cd12e5ead675216a$var$_typeof(obj);
}
function $cd12e5ead675216a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cd12e5ead675216a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cd12e5ead675216a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cd12e5ead675216a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cd12e5ead675216a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cd12e5ead675216a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cd12e5ead675216a$var$_setPrototypeOf(subClass, superClass);
}
function $cd12e5ead675216a$var$_setPrototypeOf(o, p) {
    $cd12e5ead675216a$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cd12e5ead675216a$var$_setPrototypeOf(o, p);
}
function $cd12e5ead675216a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cd12e5ead675216a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cd12e5ead675216a$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cd12e5ead675216a$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cd12e5ead675216a$var$_possibleConstructorReturn(this, result);
    };
}
function $cd12e5ead675216a$var$_possibleConstructorReturn(self, call) {
    if (call && ($cd12e5ead675216a$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cd12e5ead675216a$var$_assertThisInitialized(self);
}
function $cd12e5ead675216a$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cd12e5ead675216a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cd12e5ead675216a$var$_getPrototypeOf(o) {
    $cd12e5ead675216a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cd12e5ead675216a$var$_getPrototypeOf(o);
}
function $cd12e5ead675216a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $cd12e5ead675216a$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    $cd12e5ead675216a$var$_inherits(AMPMParser, _Parser);
    var _super = $cd12e5ead675216a$var$_createSuper(AMPMParser);
    function AMPMParser() {
        var _this;
        $cd12e5ead675216a$var$_classCallCheck(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $cd12e5ead675216a$var$_defineProperty($cd12e5ead675216a$var$_assertThisInitialized(_this), "priority", 80);
        $cd12e5ead675216a$var$_defineProperty($cd12e5ead675216a$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $cd12e5ead675216a$var$_createClass(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iaLki", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", function () { return $d3addf314db295bf$export$73ca2bd0a17d273; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $d3addf314db295bf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d3addf314db295bf$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d3addf314db295bf$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d3addf314db295bf$var$_typeof(obj);
}
function $d3addf314db295bf$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d3addf314db295bf$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d3addf314db295bf$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d3addf314db295bf$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d3addf314db295bf$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d3addf314db295bf$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d3addf314db295bf$var$_setPrototypeOf(subClass, superClass);
}
function $d3addf314db295bf$var$_setPrototypeOf(o, p) {
    $d3addf314db295bf$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d3addf314db295bf$var$_setPrototypeOf(o, p);
}
function $d3addf314db295bf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d3addf314db295bf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d3addf314db295bf$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d3addf314db295bf$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d3addf314db295bf$var$_possibleConstructorReturn(this, result);
    };
}
function $d3addf314db295bf$var$_possibleConstructorReturn(self, call) {
    if (call && ($d3addf314db295bf$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d3addf314db295bf$var$_assertThisInitialized(self);
}
function $d3addf314db295bf$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d3addf314db295bf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d3addf314db295bf$var$_getPrototypeOf(o) {
    $d3addf314db295bf$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d3addf314db295bf$var$_getPrototypeOf(o);
}
function $d3addf314db295bf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d3addf314db295bf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    $d3addf314db295bf$var$_inherits(AMPMMidnightParser, _Parser);
    var _super = $d3addf314db295bf$var$_createSuper(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        $d3addf314db295bf$var$_classCallCheck(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d3addf314db295bf$var$_defineProperty($d3addf314db295bf$var$_assertThisInitialized(_this), "priority", 80);
        $d3addf314db295bf$var$_defineProperty($d3addf314db295bf$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $d3addf314db295bf$var$_createClass(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $hUQxR.Parser));

});

parcelRegister("hjAYL", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", function () { return $c9b0e545431616d4$export$bb9212adf05373db; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $c9b0e545431616d4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c9b0e545431616d4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c9b0e545431616d4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c9b0e545431616d4$var$_typeof(obj);
}
function $c9b0e545431616d4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c9b0e545431616d4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c9b0e545431616d4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c9b0e545431616d4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c9b0e545431616d4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c9b0e545431616d4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c9b0e545431616d4$var$_setPrototypeOf(subClass, superClass);
}
function $c9b0e545431616d4$var$_setPrototypeOf(o, p) {
    $c9b0e545431616d4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c9b0e545431616d4$var$_setPrototypeOf(o, p);
}
function $c9b0e545431616d4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c9b0e545431616d4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c9b0e545431616d4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c9b0e545431616d4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c9b0e545431616d4$var$_possibleConstructorReturn(this, result);
    };
}
function $c9b0e545431616d4$var$_possibleConstructorReturn(self, call) {
    if (call && ($c9b0e545431616d4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c9b0e545431616d4$var$_assertThisInitialized(self);
}
function $c9b0e545431616d4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c9b0e545431616d4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c9b0e545431616d4$var$_getPrototypeOf(o) {
    $c9b0e545431616d4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c9b0e545431616d4$var$_getPrototypeOf(o);
}
function $c9b0e545431616d4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c9b0e545431616d4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    $c9b0e545431616d4$var$_inherits(DayPeriodParser, _Parser);
    var _super = $c9b0e545431616d4$var$_createSuper(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        $c9b0e545431616d4$var$_classCallCheck(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c9b0e545431616d4$var$_defineProperty($c9b0e545431616d4$var$_assertThisInitialized(_this), "priority", 80);
        $c9b0e545431616d4$var$_defineProperty($c9b0e545431616d4$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    $c9b0e545431616d4$var$_createClass(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $34rIp.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5c3u4", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", function () { return $3c80c6964acf8bae$export$8a04050a727a1756; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $3c80c6964acf8bae$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3c80c6964acf8bae$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3c80c6964acf8bae$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3c80c6964acf8bae$var$_typeof(obj);
}
function $3c80c6964acf8bae$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3c80c6964acf8bae$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3c80c6964acf8bae$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3c80c6964acf8bae$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3c80c6964acf8bae$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3c80c6964acf8bae$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3c80c6964acf8bae$var$_setPrototypeOf(subClass, superClass);
}
function $3c80c6964acf8bae$var$_setPrototypeOf(o, p) {
    $3c80c6964acf8bae$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3c80c6964acf8bae$var$_setPrototypeOf(o, p);
}
function $3c80c6964acf8bae$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3c80c6964acf8bae$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3c80c6964acf8bae$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3c80c6964acf8bae$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3c80c6964acf8bae$var$_possibleConstructorReturn(this, result);
    };
}
function $3c80c6964acf8bae$var$_possibleConstructorReturn(self, call) {
    if (call && ($3c80c6964acf8bae$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3c80c6964acf8bae$var$_assertThisInitialized(self);
}
function $3c80c6964acf8bae$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3c80c6964acf8bae$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3c80c6964acf8bae$var$_getPrototypeOf(o) {
    $3c80c6964acf8bae$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3c80c6964acf8bae$var$_getPrototypeOf(o);
}
function $3c80c6964acf8bae$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3c80c6964acf8bae$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    $3c80c6964acf8bae$var$_inherits(Hour1to12Parser, _Parser);
    var _super = $3c80c6964acf8bae$var$_createSuper(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        $3c80c6964acf8bae$var$_classCallCheck(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3c80c6964acf8bae$var$_defineProperty($3c80c6964acf8bae$var$_assertThisInitialized(_this), "priority", 70);
        $3c80c6964acf8bae$var$_defineProperty($3c80c6964acf8bae$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $3c80c6964acf8bae$var$_createClass(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("gBHKn", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", function () { return $c1720943b4076094$export$e56f4dea2c3e56dd; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $c1720943b4076094$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c1720943b4076094$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c1720943b4076094$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c1720943b4076094$var$_typeof(obj);
}
function $c1720943b4076094$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1720943b4076094$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c1720943b4076094$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1720943b4076094$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1720943b4076094$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c1720943b4076094$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c1720943b4076094$var$_setPrototypeOf(subClass, superClass);
}
function $c1720943b4076094$var$_setPrototypeOf(o, p) {
    $c1720943b4076094$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1720943b4076094$var$_setPrototypeOf(o, p);
}
function $c1720943b4076094$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c1720943b4076094$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c1720943b4076094$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c1720943b4076094$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c1720943b4076094$var$_possibleConstructorReturn(this, result);
    };
}
function $c1720943b4076094$var$_possibleConstructorReturn(self, call) {
    if (call && ($c1720943b4076094$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c1720943b4076094$var$_assertThisInitialized(self);
}
function $c1720943b4076094$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c1720943b4076094$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c1720943b4076094$var$_getPrototypeOf(o) {
    $c1720943b4076094$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1720943b4076094$var$_getPrototypeOf(o);
}
function $c1720943b4076094$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c1720943b4076094$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    $c1720943b4076094$var$_inherits(Hour0to23Parser, _Parser);
    var _super = $c1720943b4076094$var$_createSuper(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        $c1720943b4076094$var$_classCallCheck(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $c1720943b4076094$var$_defineProperty($c1720943b4076094$var$_assertThisInitialized(_this), "priority", 70);
        $c1720943b4076094$var$_defineProperty($c1720943b4076094$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $c1720943b4076094$var$_createClass(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("iBp2S", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", function () { return $d8af1c30a51245af$export$cbbe855312f87d77; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $d8af1c30a51245af$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d8af1c30a51245af$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d8af1c30a51245af$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d8af1c30a51245af$var$_typeof(obj);
}
function $d8af1c30a51245af$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d8af1c30a51245af$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d8af1c30a51245af$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d8af1c30a51245af$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d8af1c30a51245af$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d8af1c30a51245af$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d8af1c30a51245af$var$_setPrototypeOf(subClass, superClass);
}
function $d8af1c30a51245af$var$_setPrototypeOf(o, p) {
    $d8af1c30a51245af$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d8af1c30a51245af$var$_setPrototypeOf(o, p);
}
function $d8af1c30a51245af$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d8af1c30a51245af$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d8af1c30a51245af$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d8af1c30a51245af$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d8af1c30a51245af$var$_possibleConstructorReturn(this, result);
    };
}
function $d8af1c30a51245af$var$_possibleConstructorReturn(self, call) {
    if (call && ($d8af1c30a51245af$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d8af1c30a51245af$var$_assertThisInitialized(self);
}
function $d8af1c30a51245af$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d8af1c30a51245af$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d8af1c30a51245af$var$_getPrototypeOf(o) {
    $d8af1c30a51245af$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d8af1c30a51245af$var$_getPrototypeOf(o);
}
function $d8af1c30a51245af$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d8af1c30a51245af$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    $d8af1c30a51245af$var$_inherits(Hour0To11Parser, _Parser);
    var _super = $d8af1c30a51245af$var$_createSuper(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        $d8af1c30a51245af$var$_classCallCheck(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d8af1c30a51245af$var$_defineProperty($d8af1c30a51245af$var$_assertThisInitialized(_this), "priority", 70);
        $d8af1c30a51245af$var$_defineProperty($d8af1c30a51245af$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    $d8af1c30a51245af$var$_createClass(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("5MoaU", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", function () { return $43543015b40a6495$export$6008046d2b34b6a5; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $43543015b40a6495$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $43543015b40a6495$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $43543015b40a6495$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $43543015b40a6495$var$_typeof(obj);
}
function $43543015b40a6495$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $43543015b40a6495$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $43543015b40a6495$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $43543015b40a6495$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $43543015b40a6495$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $43543015b40a6495$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $43543015b40a6495$var$_setPrototypeOf(subClass, superClass);
}
function $43543015b40a6495$var$_setPrototypeOf(o, p) {
    $43543015b40a6495$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $43543015b40a6495$var$_setPrototypeOf(o, p);
}
function $43543015b40a6495$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $43543015b40a6495$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $43543015b40a6495$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $43543015b40a6495$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $43543015b40a6495$var$_possibleConstructorReturn(this, result);
    };
}
function $43543015b40a6495$var$_possibleConstructorReturn(self, call) {
    if (call && ($43543015b40a6495$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $43543015b40a6495$var$_assertThisInitialized(self);
}
function $43543015b40a6495$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $43543015b40a6495$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $43543015b40a6495$var$_getPrototypeOf(o) {
    $43543015b40a6495$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $43543015b40a6495$var$_getPrototypeOf(o);
}
function $43543015b40a6495$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $43543015b40a6495$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    $43543015b40a6495$var$_inherits(Hour1To24Parser, _Parser);
    var _super = $43543015b40a6495$var$_createSuper(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        $43543015b40a6495$var$_classCallCheck(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $43543015b40a6495$var$_defineProperty($43543015b40a6495$var$_assertThisInitialized(_this), "priority", 70);
        $43543015b40a6495$var$_defineProperty($43543015b40a6495$var$_assertThisInitialized(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    $43543015b40a6495$var$_createClass(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $hUQxR.Parser));

});

parcelRegister("4WIYq", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", function () { return $399f7706a432e843$export$2b52670d9e2be53; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $399f7706a432e843$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $399f7706a432e843$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $399f7706a432e843$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $399f7706a432e843$var$_typeof(obj);
}
function $399f7706a432e843$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $399f7706a432e843$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $399f7706a432e843$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $399f7706a432e843$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $399f7706a432e843$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $399f7706a432e843$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $399f7706a432e843$var$_setPrototypeOf(subClass, superClass);
}
function $399f7706a432e843$var$_setPrototypeOf(o, p) {
    $399f7706a432e843$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $399f7706a432e843$var$_setPrototypeOf(o, p);
}
function $399f7706a432e843$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $399f7706a432e843$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $399f7706a432e843$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $399f7706a432e843$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $399f7706a432e843$var$_possibleConstructorReturn(this, result);
    };
}
function $399f7706a432e843$var$_possibleConstructorReturn(self, call) {
    if (call && ($399f7706a432e843$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $399f7706a432e843$var$_assertThisInitialized(self);
}
function $399f7706a432e843$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $399f7706a432e843$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $399f7706a432e843$var$_getPrototypeOf(o) {
    $399f7706a432e843$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $399f7706a432e843$var$_getPrototypeOf(o);
}
function $399f7706a432e843$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $399f7706a432e843$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    $399f7706a432e843$var$_inherits(MinuteParser, _Parser);
    var _super = $399f7706a432e843$var$_createSuper(MinuteParser);
    function MinuteParser() {
        var _this;
        $399f7706a432e843$var$_classCallCheck(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $399f7706a432e843$var$_defineProperty($399f7706a432e843$var$_assertThisInitialized(_this), "priority", 60);
        $399f7706a432e843$var$_defineProperty($399f7706a432e843$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $399f7706a432e843$var$_createClass(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $hUQxR.Parser));

});

parcelRegister("pKJVW", function(module, exports) {

$parcel$export(module.exports, "SecondParser", function () { return $04d6977a32f84464$export$94d46d540cf1366a; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $04d6977a32f84464$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $04d6977a32f84464$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $04d6977a32f84464$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $04d6977a32f84464$var$_typeof(obj);
}
function $04d6977a32f84464$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $04d6977a32f84464$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $04d6977a32f84464$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $04d6977a32f84464$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $04d6977a32f84464$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $04d6977a32f84464$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $04d6977a32f84464$var$_setPrototypeOf(subClass, superClass);
}
function $04d6977a32f84464$var$_setPrototypeOf(o, p) {
    $04d6977a32f84464$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $04d6977a32f84464$var$_setPrototypeOf(o, p);
}
function $04d6977a32f84464$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $04d6977a32f84464$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $04d6977a32f84464$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $04d6977a32f84464$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $04d6977a32f84464$var$_possibleConstructorReturn(this, result);
    };
}
function $04d6977a32f84464$var$_possibleConstructorReturn(self, call) {
    if (call && ($04d6977a32f84464$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $04d6977a32f84464$var$_assertThisInitialized(self);
}
function $04d6977a32f84464$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $04d6977a32f84464$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $04d6977a32f84464$var$_getPrototypeOf(o) {
    $04d6977a32f84464$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $04d6977a32f84464$var$_getPrototypeOf(o);
}
function $04d6977a32f84464$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $04d6977a32f84464$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    $04d6977a32f84464$var$_inherits(SecondParser, _Parser);
    var _super = $04d6977a32f84464$var$_createSuper(SecondParser);
    function SecondParser() {
        var _this;
        $04d6977a32f84464$var$_classCallCheck(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $04d6977a32f84464$var$_defineProperty($04d6977a32f84464$var$_assertThisInitialized(_this), "priority", 50);
        $04d6977a32f84464$var$_defineProperty($04d6977a32f84464$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $04d6977a32f84464$var$_createClass(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $34rIp.parseNumericPattern)((0, $hTmlY.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $34rIp.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("9ieQT", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", function () { return $6c4150d24044e0a5$export$b8e6f8b2d70893b1; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $6c4150d24044e0a5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6c4150d24044e0a5$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6c4150d24044e0a5$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6c4150d24044e0a5$var$_typeof(obj);
}
function $6c4150d24044e0a5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6c4150d24044e0a5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6c4150d24044e0a5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6c4150d24044e0a5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6c4150d24044e0a5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6c4150d24044e0a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6c4150d24044e0a5$var$_setPrototypeOf(subClass, superClass);
}
function $6c4150d24044e0a5$var$_setPrototypeOf(o, p) {
    $6c4150d24044e0a5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6c4150d24044e0a5$var$_setPrototypeOf(o, p);
}
function $6c4150d24044e0a5$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6c4150d24044e0a5$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6c4150d24044e0a5$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6c4150d24044e0a5$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6c4150d24044e0a5$var$_possibleConstructorReturn(this, result);
    };
}
function $6c4150d24044e0a5$var$_possibleConstructorReturn(self, call) {
    if (call && ($6c4150d24044e0a5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6c4150d24044e0a5$var$_assertThisInitialized(self);
}
function $6c4150d24044e0a5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6c4150d24044e0a5$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6c4150d24044e0a5$var$_getPrototypeOf(o) {
    $6c4150d24044e0a5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6c4150d24044e0a5$var$_getPrototypeOf(o);
}
function $6c4150d24044e0a5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6c4150d24044e0a5$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    $6c4150d24044e0a5$var$_inherits(FractionOfSecondParser, _Parser);
    var _super = $6c4150d24044e0a5$var$_createSuper(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        $6c4150d24044e0a5$var$_classCallCheck(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $6c4150d24044e0a5$var$_defineProperty($6c4150d24044e0a5$var$_assertThisInitialized(_this), "priority", 30);
        $6c4150d24044e0a5$var$_defineProperty($6c4150d24044e0a5$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    $6c4150d24044e0a5$var$_createClass(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $34rIp.mapValue)((0, $34rIp.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $hUQxR.Parser));

});

parcelRegister("58dhe", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", function () { return $3bc7ffa050e36def$export$104d901d49fea29b; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $3bc7ffa050e36def$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3bc7ffa050e36def$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3bc7ffa050e36def$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3bc7ffa050e36def$var$_typeof(obj);
}
function $3bc7ffa050e36def$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3bc7ffa050e36def$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3bc7ffa050e36def$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3bc7ffa050e36def$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3bc7ffa050e36def$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3bc7ffa050e36def$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3bc7ffa050e36def$var$_setPrototypeOf(subClass, superClass);
}
function $3bc7ffa050e36def$var$_setPrototypeOf(o, p) {
    $3bc7ffa050e36def$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3bc7ffa050e36def$var$_setPrototypeOf(o, p);
}
function $3bc7ffa050e36def$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3bc7ffa050e36def$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3bc7ffa050e36def$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3bc7ffa050e36def$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3bc7ffa050e36def$var$_possibleConstructorReturn(this, result);
    };
}
function $3bc7ffa050e36def$var$_possibleConstructorReturn(self, call) {
    if (call && ($3bc7ffa050e36def$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3bc7ffa050e36def$var$_assertThisInitialized(self);
}
function $3bc7ffa050e36def$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3bc7ffa050e36def$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3bc7ffa050e36def$var$_getPrototypeOf(o) {
    $3bc7ffa050e36def$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3bc7ffa050e36def$var$_getPrototypeOf(o);
}
function $3bc7ffa050e36def$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3bc7ffa050e36def$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    $3bc7ffa050e36def$var$_inherits(ISOTimezoneWithZParser, _Parser);
    var _super = $3bc7ffa050e36def$var$_createSuper(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        $3bc7ffa050e36def$var$_classCallCheck(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $3bc7ffa050e36def$var$_defineProperty($3bc7ffa050e36def$var$_assertThisInitialized(_this), "priority", 10);
        $3bc7ffa050e36def$var$_defineProperty($3bc7ffa050e36def$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    $3bc7ffa050e36def$var$_createClass(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $hUQxR.Parser));

});

parcelRegister("5zhxn", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", function () { return $40ddd330e4d7bdd4$export$12910e5204b52b9; });

var $hUQxR = parcelRequire("hUQxR");

var $hTmlY = parcelRequire("hTmlY");

var $34rIp = parcelRequire("34rIp");
function $40ddd330e4d7bdd4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $40ddd330e4d7bdd4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $40ddd330e4d7bdd4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $40ddd330e4d7bdd4$var$_typeof(obj);
}
function $40ddd330e4d7bdd4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $40ddd330e4d7bdd4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $40ddd330e4d7bdd4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $40ddd330e4d7bdd4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $40ddd330e4d7bdd4$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $40ddd330e4d7bdd4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $40ddd330e4d7bdd4$var$_setPrototypeOf(subClass, superClass);
}
function $40ddd330e4d7bdd4$var$_setPrototypeOf(o, p) {
    $40ddd330e4d7bdd4$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $40ddd330e4d7bdd4$var$_setPrototypeOf(o, p);
}
function $40ddd330e4d7bdd4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $40ddd330e4d7bdd4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $40ddd330e4d7bdd4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $40ddd330e4d7bdd4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $40ddd330e4d7bdd4$var$_possibleConstructorReturn(this, result);
    };
}
function $40ddd330e4d7bdd4$var$_possibleConstructorReturn(self, call) {
    if (call && ($40ddd330e4d7bdd4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $40ddd330e4d7bdd4$var$_assertThisInitialized(self);
}
function $40ddd330e4d7bdd4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $40ddd330e4d7bdd4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $40ddd330e4d7bdd4$var$_getPrototypeOf(o) {
    $40ddd330e4d7bdd4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $40ddd330e4d7bdd4$var$_getPrototypeOf(o);
}
function $40ddd330e4d7bdd4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $40ddd330e4d7bdd4$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    $40ddd330e4d7bdd4$var$_inherits(ISOTimezoneParser, _Parser);
    var _super = $40ddd330e4d7bdd4$var$_createSuper(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        $40ddd330e4d7bdd4$var$_classCallCheck(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $40ddd330e4d7bdd4$var$_defineProperty($40ddd330e4d7bdd4$var$_assertThisInitialized(_this), "priority", 10);
        $40ddd330e4d7bdd4$var$_defineProperty($40ddd330e4d7bdd4$var$_assertThisInitialized(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    $40ddd330e4d7bdd4$var$_createClass(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $34rIp.parseTimezonePattern)((0, $hTmlY.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $hUQxR.Parser));

});

parcelRegister("ap9CX", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", function () { return $7933b4f85229502e$export$2cd8bf877a05e96; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $7933b4f85229502e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7933b4f85229502e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $7933b4f85229502e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7933b4f85229502e$var$_typeof(obj);
}
function $7933b4f85229502e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7933b4f85229502e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7933b4f85229502e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7933b4f85229502e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7933b4f85229502e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7933b4f85229502e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7933b4f85229502e$var$_setPrototypeOf(subClass, superClass);
}
function $7933b4f85229502e$var$_setPrototypeOf(o, p) {
    $7933b4f85229502e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7933b4f85229502e$var$_setPrototypeOf(o, p);
}
function $7933b4f85229502e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7933b4f85229502e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7933b4f85229502e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7933b4f85229502e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7933b4f85229502e$var$_possibleConstructorReturn(this, result);
    };
}
function $7933b4f85229502e$var$_possibleConstructorReturn(self, call) {
    if (call && ($7933b4f85229502e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $7933b4f85229502e$var$_assertThisInitialized(self);
}
function $7933b4f85229502e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7933b4f85229502e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7933b4f85229502e$var$_getPrototypeOf(o) {
    $7933b4f85229502e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7933b4f85229502e$var$_getPrototypeOf(o);
}
function $7933b4f85229502e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $7933b4f85229502e$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    $7933b4f85229502e$var$_inherits(TimestampSecondsParser, _Parser);
    var _super = $7933b4f85229502e$var$_createSuper(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        $7933b4f85229502e$var$_classCallCheck(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $7933b4f85229502e$var$_defineProperty($7933b4f85229502e$var$_assertThisInitialized(_this), "priority", 40);
        $7933b4f85229502e$var$_defineProperty($7933b4f85229502e$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $7933b4f85229502e$var$_createClass(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $hUQxR.Parser));

});

parcelRegister("iiRyl", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", function () { return $d53372f35b035150$export$6d8f69c6906d6368; });

var $hUQxR = parcelRequire("hUQxR");

var $34rIp = parcelRequire("34rIp");
function $d53372f35b035150$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d53372f35b035150$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d53372f35b035150$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d53372f35b035150$var$_typeof(obj);
}
function $d53372f35b035150$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d53372f35b035150$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d53372f35b035150$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d53372f35b035150$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d53372f35b035150$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d53372f35b035150$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d53372f35b035150$var$_setPrototypeOf(subClass, superClass);
}
function $d53372f35b035150$var$_setPrototypeOf(o, p) {
    $d53372f35b035150$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d53372f35b035150$var$_setPrototypeOf(o, p);
}
function $d53372f35b035150$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d53372f35b035150$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d53372f35b035150$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d53372f35b035150$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d53372f35b035150$var$_possibleConstructorReturn(this, result);
    };
}
function $d53372f35b035150$var$_possibleConstructorReturn(self, call) {
    if (call && ($d53372f35b035150$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d53372f35b035150$var$_assertThisInitialized(self);
}
function $d53372f35b035150$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d53372f35b035150$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d53372f35b035150$var$_getPrototypeOf(o) {
    $d53372f35b035150$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d53372f35b035150$var$_getPrototypeOf(o);
}
function $d53372f35b035150$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d53372f35b035150$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    $d53372f35b035150$var$_inherits(TimestampMillisecondsParser, _Parser);
    var _super = $d53372f35b035150$var$_createSuper(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        $d53372f35b035150$var$_classCallCheck(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $d53372f35b035150$var$_defineProperty($d53372f35b035150$var$_assertThisInitialized(_this), "priority", 20);
        $d53372f35b035150$var$_defineProperty($d53372f35b035150$var$_assertThisInitialized(_this), "incompatibleTokens", '*');
        return _this;
    }
    $d53372f35b035150$var$_createClass(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $34rIp.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $hUQxR.Parser));

});



parcelRegister("25W9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1869277eefbd126c$export$2e2bcd8739ae039; });

var $6QTFS = parcelRequire("6QTFS");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $1869277eefbd126c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $6RzIO.default)(1, arguments);
    var additionalDigits = (0, $8d3vD.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $1869277eefbd126c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $1869277eefbd126c$var$parseYear(dateStrings.date, additionalDigits);
        date = $1869277eefbd126c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $1869277eefbd126c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $1869277eefbd126c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $1869277eefbd126c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $1869277eefbd126c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $1869277eefbd126c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $1869277eefbd126c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $1869277eefbd126c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($1869277eefbd126c$var$patterns.dateTimeDelimiter);
    var timeString; // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($1869277eefbd126c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($1869277eefbd126c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $1869277eefbd126c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $1869277eefbd126c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex); // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $1869277eefbd126c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($1869277eefbd126c$var$dateRegex); // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $1869277eefbd126c$var$parseDateUnit(captures[1]);
    var month = $1869277eefbd126c$var$parseDateUnit(captures[2]) - 1;
    var day = $1869277eefbd126c$var$parseDateUnit(captures[3]);
    var week = $1869277eefbd126c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $1869277eefbd126c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$1869277eefbd126c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $1869277eefbd126c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$1869277eefbd126c$var$validateDate(year, month, day) || !$1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $1869277eefbd126c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $1869277eefbd126c$var$parseTime(timeString) {
    var captures = timeString.match($1869277eefbd126c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $1869277eefbd126c$var$parseTimeUnit(captures[1]);
    var minutes = $1869277eefbd126c$var$parseTimeUnit(captures[2]);
    var seconds = $1869277eefbd126c$var$parseTimeUnit(captures[3]);
    if (!$1869277eefbd126c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute) + seconds * 1000;
}
function $1869277eefbd126c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $1869277eefbd126c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($1869277eefbd126c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$1869277eefbd126c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6QTFS.millisecondsInHour) + minutes * (0, $6QTFS.millisecondsInMinute));
}
function $1869277eefbd126c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
} // Validation functions
// February is null to handle the leap year (using ||)
var $1869277eefbd126c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $1869277eefbd126c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $1869277eefbd126c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($1869277eefbd126c$var$daysInMonths[month] || ($1869277eefbd126c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $1869277eefbd126c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($1869277eefbd126c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $1869277eefbd126c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $1869277eefbd126c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $1869277eefbd126c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("6sTEQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", function () { return $4b508817b8c063d5$export$e2911fc69bd3195e; });
$parcel$export(module.exports, "default", function () { return $4b508817b8c063d5$export$2e2bcd8739ae039; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");
function $4b508817b8c063d5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $4b508817b8c063d5$var$_setPrototypeOf(subClass, superClass);
}
function $4b508817b8c063d5$var$_setPrototypeOf(o, p) {
    $4b508817b8c063d5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $4b508817b8c063d5$var$_setPrototypeOf(o, p);
}
function $4b508817b8c063d5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4b508817b8c063d5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $4b508817b8c063d5$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $4b508817b8c063d5$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $4b508817b8c063d5$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $4b508817b8c063d5$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $4b508817b8c063d5$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function $4b508817b8c063d5$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $4b508817b8c063d5$var$uid = $4b508817b8c063d5$var$autoInc();
var $4b508817b8c063d5$var$passiveEventSupport;
var $4b508817b8c063d5$var$handlersMap = {};
var $4b508817b8c063d5$var$enabledInstances = {};
var $4b508817b8c063d5$var$touchEvents = [
    'touchstart',
    'touchmove'
];
var $4b508817b8c063d5$export$e2911fc69bd3195e = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function $4b508817b8c063d5$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = null;
    var isTouchEvent = $4b508817b8c063d5$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $4b508817b8c063d5$var$passiveEventSupport) handlerOptions = {
        passive: !instance.props.preventDefault
    };
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $4b508817b8c063d5$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $4b508817b8c063d5$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, $6afFj.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || $4b508817b8c063d5$var$enabledInstances[_this._uid]) return;
                if (typeof $4b508817b8c063d5$var$passiveEventSupport === 'undefined') $4b508817b8c063d5$var$passiveEventSupport = $4b508817b8c063d5$var$testPassiveEventSupport();
                $4b508817b8c063d5$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $4b508817b8c063d5$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $4b508817b8c063d5$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($4b508817b8c063d5$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $4b508817b8c063d5$var$handlersMap[_this._uid], $4b508817b8c063d5$var$getEventHandlerOptions($4b508817b8c063d5$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $4b508817b8c063d5$var$enabledInstances[_this._uid];
                var fn = $4b508817b8c063d5$var$handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $4b508817b8c063d5$var$getEventHandlerOptions($4b508817b8c063d5$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $4b508817b8c063d5$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $4b508817b8c063d5$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        };
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $4b508817b8c063d5$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $bh6RR.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $bh6RR.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $4b508817b8c063d5$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $4b508817b8c063d5$export$2e2bcd8739ae039 = $4b508817b8c063d5$var$onClickOutsideHOC;

});

parcelRegister("bPViW", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return (parcelRequire("8XXJh")).Popper; });
$parcel$export(module.exports, "Manager", function () { return (parcelRequire("fQTei")).Manager; });
$parcel$export(module.exports, "Reference", function () { return (parcelRequire("jyim3")).Reference; });
$parcel$export(module.exports, "usePopper", function () { return (parcelRequire("jsttU")).usePopper; });
// Public components

var $8XXJh = parcelRequire("8XXJh");

var $fQTei = parcelRequire("fQTei");

var $jyim3 = parcelRequire("jyim3");

var $jsttU = parcelRequire("jsttU");
 // Public types

});
parcelRegister("8XXJh", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $68722a686ed32563$export$badac9ada3a0bdf9; });

var $bh6RR = parcelRequire("bh6RR");

var $fQTei = parcelRequire("fQTei");

var $kbbqr = parcelRequire("kbbqr");

var $jsttU = parcelRequire("jsttU");
var $68722a686ed32563$var$NOOP = function NOOP() {
    return void 0;
};
var $68722a686ed32563$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $68722a686ed32563$var$EMPTY_MODIFIERS = [];
function $68722a686ed32563$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $68722a686ed32563$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $bh6RR.useContext((0, $fQTei.ManagerReferenceNodeContext));
    var _React$useState = $bh6RR.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $bh6RR.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $bh6RR.useEffect(function() {
        (0, $kbbqr.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $bh6RR.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $jsttU.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $bh6RR.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $68722a686ed32563$var$NOOP,
            update: update || $68722a686ed32563$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $kbbqr.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("fQTei", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $b8a68dc8500f308a$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $b8a68dc8500f308a$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $b8a68dc8500f308a$export$d0d38e7dec7a1a61; });

var $bh6RR = parcelRequire("bh6RR");
var $b8a68dc8500f308a$export$3dbd3405086fec7b = $bh6RR.createContext();
var $b8a68dc8500f308a$export$cbabb21c2529b130 = $bh6RR.createContext();
function $b8a68dc8500f308a$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $bh6RR.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $bh6RR.useRef(false);
    $bh6RR.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $bh6RR.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $bh6RR.createElement($b8a68dc8500f308a$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $bh6RR.createElement($b8a68dc8500f308a$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("kbbqr", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $eb0db29d4fc67c08$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $eb0db29d4fc67c08$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $eb0db29d4fc67c08$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $eb0db29d4fc67c08$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $eb0db29d4fc67c08$export$700979bc83e7db82; });

var $bh6RR = parcelRequire("bh6RR");
var $eb0db29d4fc67c08$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $eb0db29d4fc67c08$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $eb0db29d4fc67c08$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $eb0db29d4fc67c08$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $eb0db29d4fc67c08$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $eb0db29d4fc67c08$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;

});

parcelRegister("jsttU", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $e2a7803dce6e03b8$export$f4d5bf230a36dd6e; });

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");

var $fZq58 = parcelRequire("fZq58");

var $e3YvI = parcelRequire("e3YvI");

var $kbbqr = parcelRequire("kbbqr");
var $e2a7803dce6e03b8$var$EMPTY_MODIFIERS = [];
var $e2a7803dce6e03b8$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $bh6RR.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $e2a7803dce6e03b8$var$EMPTY_MODIFIERS
    };
    var _React$useState = $bh6RR.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $bh6RR.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $6afFj.flushSync(function() {
                    setState({
                        styles: (0, $kbbqr.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $kbbqr.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $bh6RR.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($e3YvI)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $bh6RR.useRef();
    (0, $kbbqr.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $kbbqr.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $fZq58.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("fZq58", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9; });

var $fTJao = parcelRequire("fTJao");

var $745n9 = parcelRequire("745n9");

var $4mt2C = parcelRequire("4mt2C");

var $2SszJ = parcelRequire("2SszJ");

var $5KdgE = parcelRequire("5KdgE");

var $eqE9J = parcelRequire("eqE9J");

var $5QuYB = parcelRequire("5QuYB");

var $fVANH = parcelRequire("fVANH");

var $7HVwH = parcelRequire("7HVwH");

var $9bSGP = parcelRequire("9bSGP");


var $ba40c8d2bf74e5cd$export$d34966752335dd47 = [
    (0, $745n9.default),
    (0, $4mt2C.default),
    (0, $2SszJ.default),
    (0, $5KdgE.default),
    (0, $eqE9J.default),
    (0, $5QuYB.default),
    (0, $fVANH.default),
    (0, $7HVwH.default),
    (0, $9bSGP.default)
];
var $ba40c8d2bf74e5cd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $fTJao.popperGenerator)({
    defaultModifiers: $ba40c8d2bf74e5cd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("fTJao", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $b92f073993d3fb52$export$ed5e13716264f202; });

var $2HKsI = parcelRequire("2HKsI");

var $7oVdA = parcelRequire("7oVdA");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");


var $2J8Wv = parcelRequire("2J8Wv");

var $1hlpY = parcelRequire("1hlpY");




var $jvpLE = parcelRequire("jvpLE");


var $1c9xk = parcelRequire("1c9xk");

var $b92f073993d3fb52$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $b92f073993d3fb52$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $b92f073993d3fb52$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b92f073993d3fb52$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b92f073993d3fb52$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b92f073993d3fb52$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b92f073993d3fb52$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $1c9xk.isElement)(reference) ? (0, $iJYQU.default)(reference) : reference.contextElement ? (0, $iJYQU.default)(reference.contextElement) : [],
                    popper: (0, $iJYQU.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $2J8Wv.default)((0, $jvpLE.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2HKsI.default)(reference, (0, $aI24A.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $7oVdA.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $1hlpY.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b92f073993d3fb52$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b92f073993d3fb52$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b92f073993d3fb52$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2HKsI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f83a3590a58ca81$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $arVrm = parcelRequire("arVrm");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");

var $2vFiA = parcelRequire("2vFiA");

var $oVXMR = parcelRequire("oVXMR");

var $juuAX = parcelRequire("juuAX");

var $cQirN = parcelRequire("cQirN");
function $1f83a3590a58ca81$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $cQirN.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $cQirN.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1f83a3590a58ca81$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $1c9xk.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $1c9xk.isHTMLElement)(offsetParent) && $1f83a3590a58ca81$var$isElementScaled(offsetParent);
    var documentElement = (0, $oVXMR.default)(offsetParent);
    var rect = (0, $bsh7Q.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $a72Qo.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $juuAX.default)(documentElement)) scroll = (0, $arVrm.default)(offsetParent);
        if ((0, $1c9xk.isHTMLElement)(offsetParent)) {
            offsets = (0, $bsh7Q.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $2vFiA.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("bsh7Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $856f97fdf7a31786$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");

var $cQirN = parcelRequire("cQirN");

var $fWtCY = parcelRequire("fWtCY");

var $f2h41 = parcelRequire("f2h41");
function $856f97fdf7a31786$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $1c9xk.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $cQirN.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $cQirN.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $1c9xk.isElement)(element) ? (0, $fWtCY.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $f2h41.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("1c9xk", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $0dee4f2dddb22277$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $0dee4f2dddb22277$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $0dee4f2dddb22277$export$af51f0f06c0f328a; });

var $fWtCY = parcelRequire("fWtCY");
function $0dee4f2dddb22277$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $fWtCY.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $0dee4f2dddb22277$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $fWtCY.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $0dee4f2dddb22277$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $fWtCY.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("fWtCY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9b3413274c87e21$export$2e2bcd8739ae039; });
function $b9b3413274c87e21$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("cQirN", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $9598a69d154bbd1e$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $9598a69d154bbd1e$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $9598a69d154bbd1e$export$2077e0241d6afd3c; });
var $9598a69d154bbd1e$export$8960430cfd85939f = Math.max;
var $9598a69d154bbd1e$export$96ec731ed4dcb222 = Math.min;
var $9598a69d154bbd1e$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("f2h41", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af244778ac85956c$export$2e2bcd8739ae039; });

var $eFBAH = parcelRequire("eFBAH");
function $af244778ac85956c$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $eFBAH.default)());
}

});
parcelRegister("eFBAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aae20dd24c8de568$export$2e2bcd8739ae039; });
function $aae20dd24c8de568$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("arVrm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01f698b37b56f293$export$2e2bcd8739ae039; });

var $6uoC5 = parcelRequire("6uoC5");

var $fWtCY = parcelRequire("fWtCY");

var $1c9xk = parcelRequire("1c9xk");

var $ea8tK = parcelRequire("ea8tK");
function $01f698b37b56f293$export$2e2bcd8739ae039(node) {
    if (node === (0, $fWtCY.default)(node) || !(0, $1c9xk.isHTMLElement)(node)) return (0, $6uoC5.default)(node);
    else return (0, $ea8tK.default)(node);
}

});
parcelRegister("6uoC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b98a3172bacf8ec$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $4b98a3172bacf8ec$export$2e2bcd8739ae039(node) {
    var win = (0, $fWtCY.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ea8tK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4f89398deb81d5a$export$2e2bcd8739ae039; });
function $a4f89398deb81d5a$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("a72Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75ccc39d2a806d7f$export$2e2bcd8739ae039; });
function $75ccc39d2a806d7f$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("2vFiA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d3e8317bca2b13b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");

var $oVXMR = parcelRequire("oVXMR");

var $6uoC5 = parcelRequire("6uoC5");
function $1d3e8317bca2b13b$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $bsh7Q.default)((0, $oVXMR.default)(element)).left + (0, $6uoC5.default)(element).scrollLeft;
}

});
parcelRegister("oVXMR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04af344fb3b2461e$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $04af344fb3b2461e$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $1c9xk.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("juuAX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3088d3b293d3951$export$2e2bcd8739ae039; });

var $2L33g = parcelRequire("2L33g");
function $e3088d3b293d3951$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $2L33g.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("2L33g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $202256889fb084f4$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
function $202256889fb084f4$export$2e2bcd8739ae039(element) {
    return (0, $fWtCY.default)(element).getComputedStyle(element);
}

});



parcelRegister("7oVdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $563728a12da0f86b$export$2e2bcd8739ae039; });

var $bsh7Q = parcelRequire("bsh7Q");
function $563728a12da0f86b$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $bsh7Q.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("iJYQU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da4ba1ff29e25ddd$export$2e2bcd8739ae039; });

var $l4kGm = parcelRequire("l4kGm");

var $aSiof = parcelRequire("aSiof");

var $fWtCY = parcelRequire("fWtCY");

var $juuAX = parcelRequire("juuAX");
function $da4ba1ff29e25ddd$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $l4kGm.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $fWtCY.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $juuAX.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($da4ba1ff29e25ddd$export$2e2bcd8739ae039((0, $aSiof.default)(target)));
}

});
parcelRegister("l4kGm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f56a03bea423dc7d$export$2e2bcd8739ae039; });

var $aSiof = parcelRequire("aSiof");

var $juuAX = parcelRequire("juuAX");

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
function $f56a03bea423dc7d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $a72Qo.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $1c9xk.isHTMLElement)(node) && (0, $juuAX.default)(node)) return node;
    return $f56a03bea423dc7d$export$2e2bcd8739ae039((0, $aSiof.default)(node));
}

});
parcelRegister("aSiof", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ead366da1fe435a$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $oVXMR = parcelRequire("oVXMR");

var $1c9xk = parcelRequire("1c9xk");
function $7ead366da1fe435a$export$2e2bcd8739ae039(element) {
    if ((0, $a72Qo.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $1c9xk.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $oVXMR.default)(element) // fallback
    );
}

});



parcelRegister("aI24A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7cbf9f1a43b4b54b$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $a72Qo = parcelRequire("a72Qo");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bJ3lS = parcelRequire("bJ3lS");

var $aSiof = parcelRequire("aSiof");

var $eFBAH = parcelRequire("eFBAH");
function $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element) {
    if (!(0, $1c9xk.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $2L33g.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $7cbf9f1a43b4b54b$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $eFBAH.default)());
    var isIE = /Trident/i.test((0, $eFBAH.default)());
    if (isIE && (0, $1c9xk.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $2L33g.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $aSiof.default)(element);
    if ((0, $1c9xk.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $1c9xk.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $a72Qo.default)(currentNode)) < 0){
        var css = (0, $2L33g.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $7cbf9f1a43b4b54b$export$2e2bcd8739ae039(element) {
    var window = (0, $fWtCY.default)(element);
    var offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bJ3lS.default)(offsetParent) && (0, $2L33g.default)(offsetParent).position === 'static')offsetParent = $7cbf9f1a43b4b54b$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $a72Qo.default)(offsetParent) === 'html' || (0, $a72Qo.default)(offsetParent) === 'body' && (0, $2L33g.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $7cbf9f1a43b4b54b$var$getContainingBlock(element) || window;
}

});
parcelRegister("bJ3lS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88967f4bf6e216d4$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");
function $88967f4bf6e216d4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $a72Qo.default)(element)) >= 0;
}

});


parcelRegister("2J8Wv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc6b88d850995f4$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");
function $1fc6b88d850995f4$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $1fc6b88d850995f4$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $1fc6b88d850995f4$var$order(modifiers); // order based on phase
    return (0, $5juCh.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("5juCh", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $3de679e4868fd918$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $3de679e4868fd918$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $3de679e4868fd918$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $3de679e4868fd918$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $3de679e4868fd918$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $3de679e4868fd918$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $3de679e4868fd918$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $3de679e4868fd918$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $3de679e4868fd918$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $3de679e4868fd918$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $3de679e4868fd918$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $3de679e4868fd918$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $3de679e4868fd918$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $3de679e4868fd918$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $3de679e4868fd918$export$d087d3878fdf71d5; });
var $3de679e4868fd918$export$1e95b668f3b82d = 'top';
var $3de679e4868fd918$export$40e543e69a8b3fbb = 'bottom';
var $3de679e4868fd918$export$79ffe56a765070d2 = 'right';
var $3de679e4868fd918$export$eabcd2c8791e7bf4 = 'left';
var $3de679e4868fd918$export$dfb5619354ba860 = 'auto';
var $3de679e4868fd918$export$aec2ce47c367b8c3 = [
    $3de679e4868fd918$export$1e95b668f3b82d,
    $3de679e4868fd918$export$40e543e69a8b3fbb,
    $3de679e4868fd918$export$79ffe56a765070d2,
    $3de679e4868fd918$export$eabcd2c8791e7bf4
];
var $3de679e4868fd918$export$b3571188c770cc5a = 'start';
var $3de679e4868fd918$export$bd5df0f255a350f8 = 'end';
var $3de679e4868fd918$export$390fd549c5303b4d = 'clippingParents';
var $3de679e4868fd918$export$d7b7311ec04a3e8f = 'viewport';
var $3de679e4868fd918$export$ae5ab1c730825774 = 'popper';
var $3de679e4868fd918$export$ca50aac9f3ba507f = 'reference';
var $3de679e4868fd918$export$368f9a87e87fa4e1 = /*#__PURE__*/ $3de679e4868fd918$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []);
var $3de679e4868fd918$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($3de679e4868fd918$export$aec2ce47c367b8c3, [
    $3de679e4868fd918$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $3de679e4868fd918$export$b3571188c770cc5a,
        placement + "-" + $3de679e4868fd918$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $3de679e4868fd918$export$421679a7c3d56e = 'beforeRead';
var $3de679e4868fd918$export$aafa59e2e03f2942 = 'read';
var $3de679e4868fd918$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $3de679e4868fd918$export$c65e99957a05207c = 'beforeMain';
var $3de679e4868fd918$export$f22da7240b7add18 = 'main';
var $3de679e4868fd918$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $3de679e4868fd918$export$8d4d2d70e7d46032 = 'beforeWrite';
var $3de679e4868fd918$export$68d8715fc104d294 = 'write';
var $3de679e4868fd918$export$70a6e5159acce2e6 = 'afterWrite';
var $3de679e4868fd918$export$d087d3878fdf71d5 = [
    $3de679e4868fd918$export$421679a7c3d56e,
    $3de679e4868fd918$export$aafa59e2e03f2942,
    $3de679e4868fd918$export$6964f6c886723980,
    $3de679e4868fd918$export$c65e99957a05207c,
    $3de679e4868fd918$export$f22da7240b7add18,
    $3de679e4868fd918$export$bab79516f2d662fe,
    $3de679e4868fd918$export$8d4d2d70e7d46032,
    $3de679e4868fd918$export$68d8715fc104d294,
    $3de679e4868fd918$export$70a6e5159acce2e6
];

});


parcelRegister("1hlpY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ee7fe20308229e3$export$2e2bcd8739ae039; });
function $0ee7fe20308229e3$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("jvpLE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e334e679a8da4fd2$export$2e2bcd8739ae039; });
function $e334e679a8da4fd2$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("745n9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $524d12f5e3f410b7$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");
var $524d12f5e3f410b7$var$passive = {
    passive: true
};
function $524d12f5e3f410b7$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $fWtCY.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $524d12f5e3f410b7$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $524d12f5e3f410b7$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $524d12f5e3f410b7$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $524d12f5e3f410b7$var$effect,
    data: {}
};

});

parcelRegister("4mt2C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32cfbe7d0e900a5d$export$2e2bcd8739ae039; });

var $h8FhS = parcelRequire("h8FhS");
function $32cfbe7d0e900a5d$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $h8FhS.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $32cfbe7d0e900a5d$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $32cfbe7d0e900a5d$var$popperOffsets,
    data: {}
};

});
parcelRegister("h8FhS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a335ce8d6c7e22$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $5JvSi = parcelRequire("5JvSi");

var $5juCh = parcelRequire("5juCh");
function $c7a335ce8d6c7e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $7HOne.default)(placement) : null;
    var variation = placement ? (0, $a9b5p.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $5juCh.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $5juCh.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $5juCh.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $5juCh.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $5JvSi.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $5juCh.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $5juCh.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("7HOne", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c39fbf33d0fa38$export$2e2bcd8739ae039; });

function $59c39fbf33d0fa38$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("a9b5p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $763358296bc7f0da$export$2e2bcd8739ae039; });
function $763358296bc7f0da$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("5JvSi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42c9e163adb38c23$export$2e2bcd8739ae039; });
function $42c9e163adb38c23$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("2SszJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2186ca614d1914c5$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $aI24A = parcelRequire("aI24A");

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $7HOne = parcelRequire("7HOne");

var $a9b5p = parcelRequire("a9b5p");

var $cQirN = parcelRequire("cQirN");
var $2186ca614d1914c5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $2186ca614d1914c5$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $cQirN.round)(x * dpr) / dpr || 0,
        y: (0, $cQirN.round)(y * dpr) / dpr || 0
    };
}
function $2186ca614d1914c5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $5juCh.left);
    var sideY = (0, $5juCh.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $aI24A.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $fWtCY.default)(popper)) {
            offsetParent = (0, $oVXMR.default)(popper);
            if ((0, $2L33g.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $5juCh.top) || (placement === (0, $5juCh.left) || placement === (0, $5juCh.right)) && variation === (0, $5juCh.end)) {
            sideY = (0, $5juCh.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $5juCh.left) || (placement === (0, $5juCh.top) || placement === (0, $5juCh.bottom)) && variation === (0, $5juCh.end)) {
            sideX = (0, $5juCh.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $2186ca614d1914c5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $2186ca614d1914c5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $2186ca614d1914c5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $7HOne.default)(state.placement),
        variation: (0, $a9b5p.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $2186ca614d1914c5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $2186ca614d1914c5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $2186ca614d1914c5$var$computeStyles,
    data: {}
};

});

parcelRegister("5KdgE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42eb8a49ca42db39$export$2e2bcd8739ae039; });

var $a72Qo = parcelRequire("a72Qo");

var $1c9xk = parcelRequire("1c9xk");
// and applies them to the HTMLElements such as popper and arrow
function $42eb8a49ca42db39$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $42eb8a49ca42db39$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $1c9xk.isHTMLElement)(element) || !(0, $a72Qo.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $42eb8a49ca42db39$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $42eb8a49ca42db39$var$applyStyles,
    effect: $42eb8a49ca42db39$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eqE9J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812a48e30738572$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $5juCh = parcelRequire("5juCh");
function $a812a48e30738572$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $7HOne.default)(placement);
    var invertDistance = [
        (0, $5juCh.left),
        (0, $5juCh.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $a812a48e30738572$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $5juCh.placements).reduce(function(acc, placement) {
        acc[placement] = $a812a48e30738572$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a812a48e30738572$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $a812a48e30738572$var$offset
};

});

parcelRegister("5QuYB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4419d659c5aee896$export$2e2bcd8739ae039; });

var $1rXBE = parcelRequire("1rXBE");

var $7HOne = parcelRequire("7HOne");

var $3PXal = parcelRequire("3PXal");

var $5uUmA = parcelRequire("5uUmA");

var $cPMZw = parcelRequire("cPMZw");

var $5juCh = parcelRequire("5juCh");

var $a9b5p = parcelRequire("a9b5p");
function $4419d659c5aee896$var$getExpandedFallbackPlacements(placement) {
    if ((0, $7HOne.default)(placement) === (0, $5juCh.auto)) return [];
    var oppositePlacement = (0, $1rXBE.default)(placement);
    return [
        (0, $3PXal.default)(placement),
        oppositePlacement,
        (0, $3PXal.default)(oppositePlacement)
    ];
}
function $4419d659c5aee896$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $7HOne.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $1rXBE.default)(preferredPlacement)
    ] : $4419d659c5aee896$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $7HOne.default)(placement) === (0, $5juCh.auto) ? (0, $cPMZw.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $7HOne.default)(placement);
        var isStartVariation = (0, $a9b5p.default)(placement) === (0, $5juCh.start);
        var isVertical = [
            (0, $5juCh.top),
            (0, $5juCh.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $5juCh.right) : (0, $5juCh.left) : isStartVariation ? (0, $5juCh.bottom) : (0, $5juCh.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var altVariationSide = (0, $1rXBE.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $4419d659c5aee896$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $4419d659c5aee896$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("1rXBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10e68ca32d71e128$export$2e2bcd8739ae039; });
var $10e68ca32d71e128$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $10e68ca32d71e128$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $10e68ca32d71e128$var$hash[matched];
    });
}

});

parcelRegister("3PXal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb407a558844daa$export$2e2bcd8739ae039; });
var $2cb407a558844daa$var$hash = {
    start: 'end',
    end: 'start'
};
function $2cb407a558844daa$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2cb407a558844daa$var$hash[matched];
    });
}

});

parcelRegister("5uUmA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400b79aa76081eef$export$2e2bcd8739ae039; });

var $i1jxU = parcelRequire("i1jxU");

var $oVXMR = parcelRequire("oVXMR");

var $bsh7Q = parcelRequire("bsh7Q");

var $h8FhS = parcelRequire("h8FhS");

var $jWjgS = parcelRequire("jWjgS");

var $5juCh = parcelRequire("5juCh");

var $1c9xk = parcelRequire("1c9xk");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");
function $400b79aa76081eef$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $5juCh.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $5juCh.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $5juCh.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
    var altContext = elementContext === (0, $5juCh.popper) ? (0, $5juCh.reference) : (0, $5juCh.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $i1jxU.default)((0, $1c9xk.isElement)(element) ? element : element.contextElement || (0, $oVXMR.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $bsh7Q.default)(state.elements.reference);
    var popperOffsets = (0, $h8FhS.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $jWjgS.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $5juCh.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $5juCh.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $5juCh.right),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $5juCh.top),
                (0, $5juCh.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("i1jxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1e77b65493ae185$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $43VfI = parcelRequire("43VfI");

var $1xbC0 = parcelRequire("1xbC0");

var $iJYQU = parcelRequire("iJYQU");

var $aI24A = parcelRequire("aI24A");

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $1c9xk = parcelRequire("1c9xk");

var $bsh7Q = parcelRequire("bsh7Q");

var $aSiof = parcelRequire("aSiof");

var $jFWJP = parcelRequire("jFWJP");

var $a72Qo = parcelRequire("a72Qo");

var $jWjgS = parcelRequire("jWjgS");

var $cQirN = parcelRequire("cQirN");
function $d1e77b65493ae185$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $bsh7Q.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $5juCh.viewport) ? (0, $jWjgS.default)((0, $43VfI.default)(element, strategy)) : (0, $1c9xk.isElement)(clippingParent) ? $d1e77b65493ae185$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $jWjgS.default)((0, $1xbC0.default)((0, $oVXMR.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $d1e77b65493ae185$var$getClippingParents(element) {
    var clippingParents = (0, $iJYQU.default)((0, $aSiof.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $2L33g.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $1c9xk.isHTMLElement)(element) ? (0, $aI24A.default)(element) : element;
    if (!(0, $1c9xk.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $1c9xk.isElement)(clippingParent) && (0, $jFWJP.default)(clippingParent, clipperElement) && (0, $a72Qo.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $d1e77b65493ae185$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $d1e77b65493ae185$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $d1e77b65493ae185$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $cQirN.max)(rect.top, accRect.top);
        accRect.right = (0, $cQirN.min)(rect.right, accRect.right);
        accRect.bottom = (0, $cQirN.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $cQirN.max)(rect.left, accRect.left);
        return accRect;
    }, $d1e77b65493ae185$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("43VfI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f53da607b3746be$export$2e2bcd8739ae039; });

var $fWtCY = parcelRequire("fWtCY");

var $oVXMR = parcelRequire("oVXMR");

var $2vFiA = parcelRequire("2vFiA");

var $f2h41 = parcelRequire("f2h41");
function $2f53da607b3746be$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $fWtCY.default)(element);
    var html = (0, $oVXMR.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $f2h41.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $2vFiA.default)(element),
        y: y
    };
}

});

parcelRegister("1xbC0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e1e16d619599d0$export$2e2bcd8739ae039; });

var $oVXMR = parcelRequire("oVXMR");

var $2L33g = parcelRequire("2L33g");

var $2vFiA = parcelRequire("2vFiA");

var $6uoC5 = parcelRequire("6uoC5");

var $cQirN = parcelRequire("cQirN");
function $11e1e16d619599d0$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $oVXMR.default)(element);
    var winScroll = (0, $6uoC5.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $cQirN.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $cQirN.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $2vFiA.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $2L33g.default)(body || html).direction === 'rtl') x += (0, $cQirN.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("jFWJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e52f68d10ea05d88$export$2e2bcd8739ae039; });

var $1c9xk = parcelRequire("1c9xk");
function $e52f68d10ea05d88$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $1c9xk.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("jWjgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e84261f8276e3310$export$2e2bcd8739ae039; });
function $e84261f8276e3310$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("cg2ZW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec94e005bd060d7$export$2e2bcd8739ae039; });

var $kGFu9 = parcelRequire("kGFu9");
function $8ec94e005bd060d7$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $kGFu9.default)(), paddingObject);
}

});
parcelRegister("kGFu9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0f7e8fd5f6df53a$export$2e2bcd8739ae039; });
function $f0f7e8fd5f6df53a$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("aSXwy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039; });
function $7ecd1ec68ebe7fbd$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cPMZw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $958040209c61c1c6$export$2e2bcd8739ae039; });

var $a9b5p = parcelRequire("a9b5p");

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");

var $7HOne = parcelRequire("7HOne");
function $958040209c61c1c6$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $5juCh.placements) : _options$allowedAutoP;
    var variation = (0, $a9b5p.default)(placement);
    var placements = variation ? flipVariations ? (0, $5juCh.variationPlacements) : (0, $5juCh.variationPlacements).filter(function(placement) {
        return (0, $a9b5p.default)(placement) === variation;
    }) : (0, $5juCh.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $5uUmA.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $7HOne.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("fVANH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b988b9b26e42e386$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $7HOne = parcelRequire("7HOne");

var $5JvSi = parcelRequire("5JvSi");

var $6Eqmz = parcelRequire("6Eqmz");

var $16lvl = parcelRequire("16lvl");

var $7oVdA = parcelRequire("7oVdA");

var $aI24A = parcelRequire("aI24A");

var $5uUmA = parcelRequire("5uUmA");

var $a9b5p = parcelRequire("a9b5p");

var $kGFu9 = parcelRequire("kGFu9");

var $cQirN = parcelRequire("cQirN");
function $b988b9b26e42e386$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $5uUmA.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $7HOne.default)(state.placement);
    var variation = (0, $a9b5p.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $5JvSi.default)(basePlacement);
    var altAxis = (0, $6Eqmz.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
        var altSide = mainAxis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $5juCh.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $5juCh.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7oVdA.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $kGFu9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $16lvl.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $aI24A.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $16lvl.within)(tether ? (0, $cQirN.min)(min, tetherMin) : min, offset, tether ? (0, $cQirN.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $5juCh.top) : (0, $5juCh.left);
        var _altSide = mainAxis === 'x' ? (0, $5juCh.bottom) : (0, $5juCh.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $5juCh.top),
            (0, $5juCh.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $16lvl.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $16lvl.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $b988b9b26e42e386$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $b988b9b26e42e386$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("6Eqmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039; });
function $4d7aeda2d1cf8bc0$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("16lvl", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $0cd708593435dba4$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $0cd708593435dba4$export$86c8af6d3ef0b4a; });

var $cQirN = parcelRequire("cQirN");
function $0cd708593435dba4$export$f28d906d67a997f3(min, value, max) {
    return (0, $cQirN.max)(min, (0, $cQirN.min)(value, max));
}
function $0cd708593435dba4$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0cd708593435dba4$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("7HVwH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59c92c1fc46a893e$export$2e2bcd8739ae039; });

var $7HOne = parcelRequire("7HOne");

var $7oVdA = parcelRequire("7oVdA");

var $jFWJP = parcelRequire("jFWJP");

var $aI24A = parcelRequire("aI24A");

var $5JvSi = parcelRequire("5JvSi");

var $16lvl = parcelRequire("16lvl");

var $cg2ZW = parcelRequire("cg2ZW");

var $aSXwy = parcelRequire("aSXwy");

var $5juCh = parcelRequire("5juCh");

var $59c92c1fc46a893e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cg2ZW.default)(typeof padding !== 'number' ? padding : (0, $aSXwy.default)(padding, (0, $5juCh.basePlacements)));
};
function $59c92c1fc46a893e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $7HOne.default)(state.placement);
    var axis = (0, $5JvSi.default)(basePlacement);
    var isVertical = [
        (0, $5juCh.left),
        (0, $5juCh.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $59c92c1fc46a893e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7oVdA.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $5juCh.top) : (0, $5juCh.left);
    var maxProp = axis === 'y' ? (0, $5juCh.bottom) : (0, $5juCh.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $aI24A.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $16lvl.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $59c92c1fc46a893e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $jFWJP.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $59c92c1fc46a893e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $59c92c1fc46a893e$var$arrow,
    effect: $59c92c1fc46a893e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("9bSGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b0f9068ca75a57d$export$2e2bcd8739ae039; });

var $5juCh = parcelRequire("5juCh");

var $5uUmA = parcelRequire("5uUmA");
function $6b0f9068ca75a57d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6b0f9068ca75a57d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $5juCh.top),
        (0, $5juCh.right),
        (0, $5juCh.bottom),
        (0, $5juCh.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6b0f9068ca75a57d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $5uUmA.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $5uUmA.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6b0f9068ca75a57d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6b0f9068ca75a57d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6b0f9068ca75a57d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6b0f9068ca75a57d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6b0f9068ca75a57d$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $6b0f9068ca75a57d$var$hide
};

});


parcelRegister("e3YvI", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $a3d048a3d26aa23b$var$hasElementType = typeof Element !== 'undefined';
var $a3d048a3d26aa23b$var$hasMap = typeof Map === 'function';
var $a3d048a3d26aa23b$var$hasSet = typeof Set === 'function';
var $a3d048a3d26aa23b$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $a3d048a3d26aa23b$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a3d048a3d26aa23b$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($a3d048a3d26aa23b$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$a3d048a3d26aa23b$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($a3d048a3d26aa23b$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($a3d048a3d26aa23b$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($a3d048a3d26aa23b$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$a3d048a3d26aa23b$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $a3d048a3d26aa23b$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("jyim3", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $e3bf6e22f5fa065d$export$e0be378c32fb70a7; });

var $bh6RR = parcelRequire("bh6RR");

var $I0KDW = parcelRequire("I0KDW");

var $fQTei = parcelRequire("fQTei");

var $kbbqr = parcelRequire("kbbqr");
function $e3bf6e22f5fa065d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $bh6RR.useContext((0, $fQTei.ManagerReferenceNodeSetterContext));
    var refHandler = $bh6RR.useCallback(function(node) {
        (0, $kbbqr.setRef)(innerRef, node);
        (0, $kbbqr.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $bh6RR.useEffect(function() {
        return function() {
            return (0, $kbbqr.setRef)(innerRef, null);
        };
    }, []);
    $bh6RR.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($I0KDW)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $kbbqr.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("I0KDW", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $0844b15ea8db3747$var$__DEV__ = false;
var $0844b15ea8db3747$var$warning = function() {};
if ($0844b15ea8db3747$var$__DEV__) {
    var $0844b15ea8db3747$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $0844b15ea8db3747$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $0844b15ea8db3747$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $0844b15ea8db3747$var$warning;

});



parcelRegister("gGwmr", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("7jkLd"))($parcel$resolve("4icVR")),
    $parcel$import("dwmxf")
]).then(()=>parcelRequire('3ISVs'));

});
parcelRegister("7jkLd", function(module, exports) {
"use strict";

var $boLNp = parcelRequire("boLNp");
module.exports = $boLNp(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("boLNp", function(module, exports) {
"use strict";
var $84c702df89f2997b$var$cachedBundles = {};
var $84c702df89f2997b$var$cachedPreloads = {};
var $84c702df89f2997b$var$cachedPrefetches = {};
function $84c702df89f2997b$var$getCache(type) {
    switch(type){
        case 'preload':
            return $84c702df89f2997b$var$cachedPreloads;
        case 'prefetch':
            return $84c702df89f2997b$var$cachedPrefetches;
        default:
            return $84c702df89f2997b$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $84c702df89f2997b$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $c3063f12ea35bd72$exports = {};
$parcel$extendImportMap({
    "dwmxf": "SVGFlag.5f091ba2.js",
    "4icVR": "SVGFlag.61f96cfd.css"
});


var $ih19M = parcelRequire("ih19M");

var $7MXrw = parcelRequire("7MXrw");
var $e23ae39501459ba4$exports = {};
var $5555d428bd3bf37b$exports = {};
var $90ef0c6889924fa4$exports = {};
function $90ef0c6889924fa4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $90ef0c6889924fa4$exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $90ef0c6889924fa4$exports.__esModule = true, $90ef0c6889924fa4$exports["default"] = $90ef0c6889924fa4$exports, $90ef0c6889924fa4$var$_typeof(o);
}
$90ef0c6889924fa4$exports = $90ef0c6889924fa4$var$_typeof, $90ef0c6889924fa4$exports.__esModule = true, $90ef0c6889924fa4$exports["default"] = $90ef0c6889924fa4$exports;


var $5555d428bd3bf37b$var$_typeof = $90ef0c6889924fa4$exports.default;
var $210013a7b1d5e66c$exports = {};

var $210013a7b1d5e66c$var$_typeof = $90ef0c6889924fa4$exports.default;
function $210013a7b1d5e66c$var$toPrimitive(t, r) {
    if ("object" != $210013a7b1d5e66c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $210013a7b1d5e66c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$210013a7b1d5e66c$exports = $210013a7b1d5e66c$var$toPrimitive, $210013a7b1d5e66c$exports.__esModule = true, $210013a7b1d5e66c$exports["default"] = $210013a7b1d5e66c$exports;


function $5555d428bd3bf37b$var$toPropertyKey(t) {
    var i = $210013a7b1d5e66c$exports(t, "string");
    return "symbol" == $5555d428bd3bf37b$var$_typeof(i) ? i : i + "";
}
$5555d428bd3bf37b$exports = $5555d428bd3bf37b$var$toPropertyKey, $5555d428bd3bf37b$exports.__esModule = true, $5555d428bd3bf37b$exports["default"] = $5555d428bd3bf37b$exports;


function $e23ae39501459ba4$var$_defineProperty(e, r, t) {
    return (r = $5555d428bd3bf37b$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$e23ae39501459ba4$exports = $e23ae39501459ba4$var$_defineProperty, $e23ae39501459ba4$exports.__esModule = true, $e23ae39501459ba4$exports["default"] = $e23ae39501459ba4$exports;


var $45d29d2a9970da25$exports = {};
var $30cb065ea47a1f86$exports = {};
function $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$30cb065ea47a1f86$exports = $30cb065ea47a1f86$var$_objectWithoutPropertiesLoose, $30cb065ea47a1f86$exports.__esModule = true, $30cb065ea47a1f86$exports["default"] = $30cb065ea47a1f86$exports;


function $45d29d2a9970da25$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $30cb065ea47a1f86$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$45d29d2a9970da25$exports = $45d29d2a9970da25$var$_objectWithoutProperties, $45d29d2a9970da25$exports.__esModule = true, $45d29d2a9970da25$exports["default"] = $45d29d2a9970da25$exports;



var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");
var $5ee2aab835b0f90b$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $5ee2aab835b0f90b$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $ddf3c644b1550715$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $ddf3c644b1550715$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($5ee2aab835b0f90b$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($ddf3c644b1550715$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $ddf3c644b1550715$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $ddf3c644b1550715$var$i = /^\s*$/, $ddf3c644b1550715$var$s = Object.create(null);
function $ddf3c644b1550715$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($ddf3c644b1550715$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var $ddf3c644b1550715$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $ddf3c644b1550715$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($ddf3c644b1550715$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $ddf3c644b1550715$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $ddf3c644b1550715$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $ddf3c644b1550715$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $ddf3c644b1550715$var$a("", t);
        }, "");
    }
};
var $ddf3c644b1550715$export$2e2bcd8739ae039 = $ddf3c644b1550715$var$c;


function $7d69daea948e51df$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $7d69daea948e51df$var$alreadyWarned = {};
function $7d69daea948e51df$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $7d69daea948e51df$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $7d69daea948e51df$var$alreadyWarned[args[0]] = new Date();
    $7d69daea948e51df$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $7d69daea948e51df$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
};
function $7d69daea948e51df$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $7d69daea948e51df$var$loadedClb(i18n, cb));
}
function $7d69daea948e51df$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $7d69daea948e51df$var$loadedClb(i18n, cb));
}
function $7d69daea948e51df$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $7d69daea948e51df$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $7d69daea948e51df$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $7d69daea948e51df$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $7d69daea948e51df$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}



var $af984864056706c1$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $af984864056706c1$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $af984864056706c1$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $af984864056706c1$var$htmlEntities[m];
};
var $af984864056706c1$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($af984864056706c1$var$matchHtmlEntity, $af984864056706c1$var$unescapeHtmlEntity);
};


function $07052676fb667a2e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07052676fb667a2e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07052676fb667a2e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07052676fb667a2e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $07052676fb667a2e$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $af984864056706c1$export$e8bacd2802a88316)
};
function $07052676fb667a2e$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $07052676fb667a2e$var$defaultOptions = $07052676fb667a2e$var$_objectSpread($07052676fb667a2e$var$_objectSpread({}, $07052676fb667a2e$var$defaultOptions), options);
}
function $07052676fb667a2e$export$212bb2fc580a90a8() {
    return $07052676fb667a2e$var$defaultOptions;
}


var $e08137f4d99c5823$var$i18nInstance;
function $e08137f4d99c5823$export$a039134f2fc7e0(instance) {
    $e08137f4d99c5823$var$i18nInstance = instance;
}
function $e08137f4d99c5823$export$64af334f494c2f47() {
    return $e08137f4d99c5823$var$i18nInstance;
}


var $16e51de87f01a7b4$var$_excluded = [
    "format"
], $16e51de87f01a7b4$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $16e51de87f01a7b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16e51de87f01a7b4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $16e51de87f01a7b4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $16e51de87f01a7b4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16e51de87f01a7b4$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $16e51de87f01a7b4$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $16e51de87f01a7b4$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every(function(child) {
        return (0, $bh6RR.isValidElement)(child);
    });
}
function $16e51de87f01a7b4$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $16e51de87f01a7b4$var$mergeProps(source, target) {
    var newTarget = $16e51de87f01a7b4$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $16e51de87f01a7b4$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = $16e51de87f01a7b4$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === 'string') stringNode += "".concat(child);
        else if ((0, $bh6RR.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $16e51de87f01a7b4$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $7d69daea948e51df$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(child) === 'object') {
            var format = child.format, clone = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(child, $16e51de87f01a7b4$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $7d69daea948e51df$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $7d69daea948e51df$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $16e51de87f01a7b4$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $16e51de87f01a7b4$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === 'string') return;
            if ($16e51de87f01a7b4$var$hasChildren(child)) getData($16e51de87f01a7b4$var$getChildren(child));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(child) === 'object' && !(0, $bh6RR.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $ddf3c644b1550715$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $16e51de87f01a7b4$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $16e51de87f01a7b4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $bh6RR.cloneElement)(child, $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $16e51de87f01a7b4$var$getAsArray(reactNode);
        var astNodes = $16e51de87f01a7b4$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $16e51de87f01a7b4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $bh6RR.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $16e51de87f01a7b4$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(child) === 'object' && child.dummy && !isElement;
                var isKnownComponent = (0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($16e51de87f01a7b4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $bh6RR.cloneElement)(child, $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $bh6RR.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $bh6RR.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(child) === 'object' && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $bh6RR.cloneElement)(child, $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $bh6RR.cloneElement)(child, $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $bh6RR.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $16e51de87f01a7b4$var$getAsArray(children || []));
    return $16e51de87f01a7b4$var$getChildren(result[0]);
}
function $16e51de87f01a7b4$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(_ref, $16e51de87f01a7b4$var$_excluded2);
    var i18n = i18nFromProps || (0, $e08137f4d99c5823$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $7d69daea948e51df$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, (0, $07052676fb667a2e$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var defaultValue = defaults || $16e51de87f01a7b4$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = $16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread($16e51de87f01a7b4$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $16e51de87f01a7b4$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $bh6RR.createElement)(useAsParent, additionalProps, content) : content;
}



var $82f9fe10102e948b$exports = {};
function $82f9fe10102e948b$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$82f9fe10102e948b$exports = $82f9fe10102e948b$var$_classCallCheck, $82f9fe10102e948b$exports.__esModule = true, $82f9fe10102e948b$exports["default"] = $82f9fe10102e948b$exports;


var $f23d94100a43e193$exports = {};

function $f23d94100a43e193$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5555d428bd3bf37b$exports(o.key), o);
    }
}
function $f23d94100a43e193$var$_createClass(e, r, t) {
    return r && $f23d94100a43e193$var$_defineProperties(e.prototype, r), t && $f23d94100a43e193$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$f23d94100a43e193$exports = $f23d94100a43e193$var$_createClass, $f23d94100a43e193$exports.__esModule = true, $f23d94100a43e193$exports["default"] = $f23d94100a43e193$exports;



var $bh6RR = parcelRequire("bh6RR");




var $a56b92b0360baa63$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        (0, $07052676fb667a2e$export$2e2366488d12e20d)(instance.options.react);
        (0, $e08137f4d99c5823$export$a039134f2fc7e0)(instance);
    }
};


function $533d75f77e305a3e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $533d75f77e305a3e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $533d75f77e305a3e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $533d75f77e305a3e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $533d75f77e305a3e$export$5603ab5ced17ce64 = (0, $bh6RR.createContext)();
var $533d75f77e305a3e$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, (/*@__PURE__*/$parcel$interopDefault($82f9fe10102e948b$exports)))(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f23d94100a43e193$exports)))(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $533d75f77e305a3e$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $533d75f77e305a3e$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($533d75f77e305a3e$var$_objectSpread($533d75f77e305a3e$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $533d75f77e305a3e$export$704200e5d0b9e8f() {
    var i18n = (0, $e08137f4d99c5823$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $8879b7f8b812ce42$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $8879b7f8b812ce42$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8879b7f8b812ce42$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8879b7f8b812ce42$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8879b7f8b812ce42$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8879b7f8b812ce42$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(_ref, $8879b7f8b812ce42$var$_excluded);
    var _ref2 = (0, $bh6RR.useContext)((0, $533d75f77e305a3e$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $e08137f4d99c5823$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $16e51de87f01a7b4$export$8d6a9236f2e3f2ce)($8879b7f8b812ce42$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}



var $aec0ef34f2c5a862$exports = {};
var $efbf14b6e6102ff5$exports = {};
function $efbf14b6e6102ff5$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$efbf14b6e6102ff5$exports = $efbf14b6e6102ff5$var$_arrayWithHoles, $efbf14b6e6102ff5$exports.__esModule = true, $efbf14b6e6102ff5$exports["default"] = $efbf14b6e6102ff5$exports;


var $c291ac134490aa92$exports = {};
function $c291ac134490aa92$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$c291ac134490aa92$exports = $c291ac134490aa92$var$_iterableToArrayLimit, $c291ac134490aa92$exports.__esModule = true, $c291ac134490aa92$exports["default"] = $c291ac134490aa92$exports;


var $036c4d1914e85e94$exports = {};
var $5195fd8f0d7eac4d$exports = {};
function $5195fd8f0d7eac4d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$5195fd8f0d7eac4d$exports = $5195fd8f0d7eac4d$var$_arrayLikeToArray, $5195fd8f0d7eac4d$exports.__esModule = true, $5195fd8f0d7eac4d$exports["default"] = $5195fd8f0d7eac4d$exports;


function $036c4d1914e85e94$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5195fd8f0d7eac4d$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5195fd8f0d7eac4d$exports(r, a) : void 0;
    }
}
$036c4d1914e85e94$exports = $036c4d1914e85e94$var$_unsupportedIterableToArray, $036c4d1914e85e94$exports.__esModule = true, $036c4d1914e85e94$exports["default"] = $036c4d1914e85e94$exports;


var $046c0957b668f83c$exports = {};
function $046c0957b668f83c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$046c0957b668f83c$exports = $046c0957b668f83c$var$_nonIterableRest, $046c0957b668f83c$exports.__esModule = true, $046c0957b668f83c$exports["default"] = $046c0957b668f83c$exports;


function $aec0ef34f2c5a862$var$_slicedToArray(r, e) {
    return $efbf14b6e6102ff5$exports(r) || $c291ac134490aa92$exports(r, e) || $036c4d1914e85e94$exports(r, e) || $046c0957b668f83c$exports();
}
$aec0ef34f2c5a862$exports = $aec0ef34f2c5a862$var$_slicedToArray, $aec0ef34f2c5a862$exports.__esModule = true, $aec0ef34f2c5a862$exports["default"] = $aec0ef34f2c5a862$exports;





var $bh6RR = parcelRequire("bh6RR");


function $0fbd9fed15f24a6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0fbd9fed15f24a6d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0fbd9fed15f24a6d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0fbd9fed15f24a6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $0fbd9fed15f24a6d$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $0fbd9fed15f24a6d$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $bh6RR.useContext)((0, $533d75f77e305a3e$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $e08137f4d99c5823$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $533d75f77e305a3e$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $7d69daea948e51df$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, (/*@__PURE__*/$parcel$interopDefault($90ef0c6889924fa4$exports)))(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $7d69daea948e51df$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $0fbd9fed15f24a6d$var$_objectSpread($0fbd9fed15f24a6d$var$_objectSpread($0fbd9fed15f24a6d$var$_objectSpread({}, (0, $07052676fb667a2e$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $7d69daea948e51df$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $bh6RR.useState)(getT), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($aec0ef34f2c5a862$exports)))(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $0fbd9fed15f24a6d$var$usePrevious(joinedNS);
    var isMounted = (0, $bh6RR.useRef)(true);
    (0, $bh6RR.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $7d69daea948e51df$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $7d69daea948e51df$export$83be934b53fff43b)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $bh6RR.useRef)(true);
    (0, $bh6RR.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $7d69daea948e51df$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $7d69daea948e51df$export$83be934b53fff43b)(i18n, namespaces, function() {
            return resolve();
        });
    });
}






var $bh6RR = parcelRequire("bh6RR");


var $2acef1b1ce7d6078$var$_excluded = [
    "forwardedRef"
];
function $2acef1b1ce7d6078$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2acef1b1ce7d6078$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2acef1b1ce7d6078$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2acef1b1ce7d6078$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2acef1b1ce7d6078$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(_ref, $2acef1b1ce7d6078$var$_excluded);
            var _useTranslation = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)(ns, $2acef1b1ce7d6078$var$_objectSpread($2acef1b1ce7d6078$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($aec0ef34f2c5a862$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $2acef1b1ce7d6078$var$_objectSpread($2acef1b1ce7d6078$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $bh6RR.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $7d69daea948e51df$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $bh6RR.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $bh6RR.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $528aabe96418bc09$var$_excluded = [
    "ns",
    "children"
];
function $528aabe96418bc09$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(props, $528aabe96418bc09$var$_excluded);
    var _useTranslation = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($aec0ef34f2c5a862$exports)))(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $bh6RR = parcelRequire("bh6RR");

function $0785203770bac6d0$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $bh6RR.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $bh6RR.createElement)((0, $533d75f77e305a3e$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

function $afff88bbf86556f7$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $bh6RR.useContext)((0, $533d75f77e305a3e$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $e08137f4d99c5823$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $00b43b39e76ef8bf$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $00b43b39e76ef8bf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $00b43b39e76ef8bf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $00b43b39e76ef8bf$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($e23ae39501459ba4$exports)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $00b43b39e76ef8bf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $00b43b39e76ef8bf$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, (/*@__PURE__*/$parcel$interopDefault($45d29d2a9970da25$exports)))(_ref, $00b43b39e76ef8bf$var$_excluded);
            (0, $afff88bbf86556f7$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $bh6RR.createElement)(WrappedComponent, $00b43b39e76ef8bf$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $533d75f77e305a3e$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $7d69daea948e51df$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







var $2d1060335d2ea13e$export$324d90190a8b822a = function date() {
    return '';
};
var $2d1060335d2ea13e$export$2da9be4cfdb689b1 = function time() {
    return '';
};
var $2d1060335d2ea13e$export$98e628dec113755e = function number() {
    return '';
};
var $2d1060335d2ea13e$export$2e6c959c16ff56b8 = function select() {
    return '';
};
var $2d1060335d2ea13e$export$4e35d5c922a95490 = function plural() {
    return '';
};
var $2d1060335d2ea13e$export$720a3b9db04b7a0f = function selectOrdinal() {
    return '';
};


var $31a6d56c40e917fc$exports = {};
$31a6d56c40e917fc$exports = JSON.parse('{"sv":{"translation":{"your-trip":"Din Resa","edit-your-trip":"\xc4ndra din Resa","edit-fields-expiration-warning":"Vissa f\xe4lt kan inte l\xe4ngre \xe4ndras om {{time}}","edit-fields-expiration-subtext":"Spara dina \xe4ndringar eller de kan l\xe5sas","edit-fields-no-changes-title":"Kan inte g\xf6ra \xe4ndringar","edit-fields-no-changes-message":"Det \xe4r inte l\xe4ngre m\xf6jligt att g\xf6ra n\xe5gra \xe4ndringar i denna bokning.","header-where-do-you-want-to-go":"Vart vill du \xe5ka?","header-book-taxi":"Boka taxi","placeholder-origin-location":"Jag vill resa fr\xe5n...","placeholder-destination-location":"Jag vill resa till...","placeholder-add-stop":"L\xe4gg till ett stopp","button-add-stop":"L\xe4gg till ett stopp","button-go-now":"\xc5ka nu","button-go-later":"F\xf6rboka","button-no-available-cars":"Inga tillg\xe4ngliga bilar","booking-login-info":"F\xf6r att slutf\xf6ra din bokning kommer det att kr\xe4vas att du bekr\xe4ftar ditt telefonnummer i slutfasen av bokningen.","validation-departure-required":"Du m\xe5ste v\xe4lja en upph\xe4mtningsplats.","validation-destination-required":"Du m\xe5ste v\xe4lja en destination.","validation-airport-not-allowed":"Du kan inte v\xe4lja en flygplats som en viaadress.","validation-departure-invalid":"Vi kan tyv\xe4rr inte h\xe4mta upp p\xe5 denna address","validation-destination-invalid":"Vi kan tyv\xe4rr inte stanna p\xe5 denna address","validation-intermediate-invalid":"Ogiltig som via-adress","info-enter-street-number":"V\xe4nligen fyll<br/>i gatunummer","error-no-estimate":"Det verkar som du har d\xe5lig uppkopling, var v\xe4nlig f\xf6rs\xf6k igen eller ring v\xe5r v\xe4xel 08-15 00 00 s\xe5 hj\xe4lper de dig att boka.","info-select-redirect":"V\xe4nligen v\xe4lj en alternativ plats.","header-when-do-you-want-to-go":"N\xe4r vill du \xe5ka?","header-when-does-your-flight-land":"N\xe4r landar ditt flyg?","flightnumber-info":"Du kan vanligtvis hitta ditt flygnummer p\xe5 din biljett eller bokningsbekr\xe4ftlese.","button-continue":"Forts\xe4tt","placeholder-flight-number":"Flightnummer","placeholder-pick-date":"V\xe4lj landningstid","info-flight-number":"Vi bevakar flygets ankomsttid","title-baggage":"Incheckat baggage","info-baggage":"Vi tar h\xe4nsyn till att det kan ta tid att f\xe5 ditt incheckade bagage i handen efter landning","section-flight-number":"Flygnummer","section-landing-time":"Landningstid","section-luggage":"Bagage","header-passengers":"Passagerare","label-passenger-count":"{{count}} passagerare","label-group-size":"Antal passagerare","info-passenger-count":"Leverant\xf6ren beh\xf6ver veta hur m\xe5nga passagerare ni \xe4r i bilen. Ni kan dela denna resa med andra passagerare.","validation-need-passenger-count":"Ange antal passagerare","modal-passenger-required-title":"Passagerare kr\xe4vs","modal-passenger-required-body":"V\xe4nligen ange hur m\xe5nga ni \xe4r som reser.","validation-date-not-valid":"Datum och tid \xe4r inte giltigt.","validation-date-too-far-ahead":"Datum och tid \xe4r f\xf6r l\xe5ngt fram.","validation-need-date":"Du m\xe5ste v\xe4lja en dag och tid.","validation-need-flight-number":"V\xe4nligen fyll i ett giltigt flightnummer, (t.ex., AB123, A1B234, 1A999Z)","title-invalid-time":"Ogiltig tid","message-invalid-time":"Den valda tiden \xe4r inte tillg\xe4nglig och har justerats till n\xe4rmast m\xf6jliga tid.","title-fully-booked":"Tiden \xe4r fullbokad","message-select-other-time":"Just nu \xe4r f\xf6rbokningar fullbokade minst en timme fram\xe5t via webben, om m\xf6jligt v\xe4lj en annan tid eller kontakta v\xe5r v\xe4xel p\xe5 08-15 00 00 s\xe5 hj\xe4lper de dig.","message-select-next-available-time":"V\xe4lj en annan tid eller den f\xf6reslagna tiden.<br/><br/>N\xe4sta lediga tid \xe4r {{time}}","button-select-other-time":"V\xe4lj annan tid","button-select-available-time":"V\xe4lj f\xf6reslagen tid","button-ok":"Ok","header-how-do-you-want-to-go":"Hur vill du \xe5ka?","header-select-car":"V\xe4lj bil","header-select-partner":"V\xe4lj partner","header-no-providers-found":"Inga partners hittades","info-no-providers-found":"Ingen partner matchar ditt val. Prova att \xe4ndra tillval eller biltyp.","cartype-taxi":"Standardtaxi","cartype-large-car":"Storbil","cartype-estate":"Kombi","cartype-business":"Business","cartype-taxi-info":"F\xf6r dina vardagliga resor","cartype-large-car-info":"F\xf6r st\xf6rre grupper","cartype-estate-info":"Mer lastutrymme","cartype-business-info":"Premiumtaxi","num-persons-3":"3 personer","num-persons-4":"4 personer","num-persons-7":"7 personer","approx-min":"ca {{minutes}} min","title-fixed-price":"Fastpris","info-fixed-price-not-available":"Fastpris \xe4r inte tillg\xe4ngligt","info-price-estimate-failed":"Vi kunde inte h\xe4mta ett fastpris f\xf6r resan.","button-try-again":"F\xf6rs\xf6k igen","info-taxameter-not-available":"Taxameter \xe4r inte tillg\xe4ngligt","title-private-or-company":"Privat eller f\xf6retagsresa","info-private":"Privat","title-booking-options":"Tillval","info-booking-options":"L\xe4gg till extra tillval","label-luggage-fits":"Os\xe4ker om ditt bagage f\xe5r plats?","title-pet-option":"Resa med djur","title-low-option":"L\xe5g bil","info-low-option":"L\xe4ttare att ta sig in och ut","info-pet-option":"T\xe4nk p\xe5 att v\xe4lja en stor bil om det beh\xf6vs","title-stationwagon-option":"Kombi","title-childseat-option":"Bak\xe5tv\xe4nd bilbarnstol","info-childseat-option":"F\xf6r barn minst 9 m\xe5nader eller 9kg","title-booster-option":"B\xe4lteskudde","info-booster-option":"F\xf6r barn minst 4 \xe5r eller 15kg","title-electric-car":"Elbil","info-electric-car":"Om tillg\xe4ngligt, f\xf6redrar jag en elbil","button-done":"Klar","label-i-want-to-go-now":"Direktbokning","label-direct-booking":"Direktbokning","label-prebooked":"F\xf6rbokning","info-flight-monitoring":"Vi bevakar flygets ankomsttid","label-checked-baggage":"Incheckat bagage","label-from":"Fr\xe5n","label-to":"Till","label-when":"N\xe4r","label-payment":"Betalning","label-receipt":"Kvitto","label-how":"Hur","label-fixed-price":"Fastpris","label-taxameter":"Taxameter","label-price-information":"Prisinformation","label-total":"Totalt","label-incl-tip":"inkl. dricks","label-pet-option":"Resa med djur","label-low-option":"L\xe5g bil","label-stationwagon-option":"Kombi","label-childseat-option":"Bak\xe5tv\xe4nd bilbarnstol","label-booster-1-option":"1 b\xe4lteskudde","label-booster-2-option":"2 b\xe4lteskuddar","label-electric-option":"Elbil","label-option-free":"Gratis","label-booking-number":"Bokningsnummer","info-available-in":"Tillg\xe4nglig om ca {{minutes}} minuter","button-download-receipt":"Visa kvitto","info-receipt-not-available":"Kvitto ej tillg\xe4ngligt","info-receipt-pending":"Kvitto tillg\xe4ngligt efter registrerad betalning","info-receipt-refunded":"\xc5terbetalning genomf\xf6rd","info-num-vouchers_one":"{{count}} rabattkod tillg\xe4nglig","info-num-vouchers_other":"{{count}} rabattkoder tillg\xe4ngliga","header-welcome":"V\xe4lkommen!","info-welcome-subtitle":"Res s\xe4kert med Stockholms mest erfarna taxibolag","label-phone-number":"Telefonnummer","button-login-apple":"Forts\xe4tt med Apple","button-login-google":"Forts\xe4tt med Google","label-or":"eller","info-by-continuing-terms":"Genom att forts\xe4tta godk\xe4nner du v\xe5ra <link1>Villkor</link1>","header-google-signin":"Logga in med Google","info-google-signin":"Logga in med ditt Google-konto f\xf6r att forts\xe4tta.","error-google-signin-failed":"Det gick inte att logga in med Google. F\xf6rs\xf6k igen.","error-apple-signin-failed":"Det gick inte att logga in med Apple. F\xf6rs\xf6k igen.","header-add-phone-social":"Ditt telefonnummer","info-add-phone-social":"Vi anv\xe4nder ditt nummer ifall vi beh\xf6ver kontakta dig ang\xe5ende din resa. Vi skickar en verifieringsl\xe4nk till dig.","info-enter-code-sent-social":"Skriv in koden som skickades till nummer {{dialCode}} {{phone}}","header-is-this-you":"\xc4r det du?","header-login-as":"Logga in som {{name}}?","info-existing-account-found":"Vi hittade ett befintligt konto som anv\xe4nder samma telefonnummer som du angett.","button-not-me":"Det \xe4r inte jag","button-yes-thats-me":"Ja, det \xe4r jag","button-create-new-account":"Skapa nytt konto","header-confirm-phone":"Bekr\xe4fta ditt telefonnummer","info-confirm-phone":"En kod kommer att skickas till ditt nummer. Vi anv\xe4nder ditt nummer f\xf6r att smsa dig om viktiga uppdateringar p\xe5 din resa.","info-confirm-phone-login":"F\xf6r att logga in m\xe5ste du bekr\xe4fta ditt telefonnummer.","button-cancel":"Avbryt","validation-only-numbers":"F\xe5r bara inneh\xe5lla siffror.","validation-need-phone":"Du m\xe5ste fylla i telefonnummer.","validation-length-phone":"M\xe5ste vara mellan 6 och 14 siffor.","header-enter-your-code":"Skriv in din kod","info-enter-the-code-sent-to":"Skriv in koden som skickades till nummer {{dialCode}} {{phone}}","button-did-not-get-code":"Jag fick ingen kod","header-enter-your-email":"Ange din epostadress","placeholder-enter-your-email":"Ange din epostadress","info-we-use-your-email":"Vi anv\xe4nder din e-post f\xf6r att logga in dig. Vi skickar en verifieringsl\xe4nk till dig.","validation-invalid-email":"Ogiltig epostadress.","validation-need-email":"Du m\xe5ste fylla i epostadress.","header-welcome-back":"V\xe4lkommen tillbaka!","info-your-phone-is-linked":"Ditt telefonnummer \xe4r l\xe4nkat till epostadressen {{maskedEmail}}. V\xe4nligen ange verifieringskoden som vi har mailat dig.","button-select-other-email":"V\xe4lj annan epost","change-email-message":"Om du loggar in med en annan epostadress kommer bokningar du gjort med din tidigare adress inte synas i din historik.","header-enter-name":"Ange ditt namn","info-driver-confirm-pickup":"Detta hj\xe4lper v\xe5r chauff\xf6r att bekr\xe4fta att det \xe4r du n\xe4r de h\xe4mtar dig.","placeholder-firstname":"F\xf6rnamn","placeholder-lastname":"Efternamn","validation-need-firstname":"Du m\xe5ste fylla i f\xf6rnamn.","validation-need-lastname":"Du m\xe5ste fylla i efternamn.","header-terms-and-conditions":"Regler och villkor","info-accept-terms":"V\xe4nligen l\xe4s och godk\xe4nn v\xe5ra <link1>regler och villkor</link1>.","title-accept-terms":"Jag bekr\xe4ftar att jag l\xe4st och accepterar vilkoren","title-accept-marketing":"Jag vill f\xe5 erbjudanden, nyheter och uppdateringar fr\xe5n Taxi Stockholm","button-confirm":"Forts\xe4tt","header-confirm-your-booking":"Betala och bekr\xe4fta","header-confirm-edit":"Bekr\xe4fta \xe4ndring","placeholder-name":"Namn","placeholder-phone":"Telefonnummer","title-payment":"Betalning","title-vouchers":"Rabattkoder","title-voucher":"Rabattkod:","title-pay-in-car":"Betala i taxin","title-pay-in-car-sender":"Betala i taxin (avs\xe4ndaren betalar)","button-add-new-card":"L\xe4gg till nytt betalkort","button-add-new-account":"L\xe4gg till nytt konto","button-add-new-voucher":"L\xe4gg till ny rabattkod","title-message-to-driver":"Meddelande till f\xf6raren","info-message-to-driver":"H\xe4r kan du beskriva hur f\xf6raren kan hitta dig.","placeholder-reference":"Referens","info-accept-booking-terms":"Genom att resa med oss s\xe5 godk\xe4nner du v\xe5ra <link1>resevillkor</link1>.","title-message":"Meddelande","validation-need-name":"Du m\xe5ste fylla i namn.","validation-need-reference":"Du m\xe5ste fylla i referens.","validation-need-payment":"Du m\xe5ste v\xe4lja betals\xe4tt.","button-book-now":"Bekr\xe4fta bokning","button-confirm-edit":"Bekr\xe4fta \xe4ndring","error-payment":"N\xe5got gick fel med betalningen. V\xe4nligen f\xf6rs\xf6k igen.","error-network":"Ingen kontakt med servern. Kontrollera din uppkoppling och f\xf6rs\xf6k igen.","error-network-uncertain":"Vi kunde inte bekr\xe4fta om din bokning gick igenom. Kontrollera dina aktiva bokningar innan du f\xf6rs\xf6ker boka igen.","header-whos-travel":"Resen\xe4r","button-edit-booking":"\xc4ndra bokning","button-cancel-booking":"Avboka","button-close":"St\xe4ng","button-book-again":"Boka resa igen","button-return-trip":"Boka returresa","button-add-to-calendar":"L\xe4gg till i kalender","button-forward-confirmation":"Vidarebefordra bokningsbekr\xe4ftelse","button-modify-booking":"\xc4ndra bokning","button-receipt-unavailable":"Kvitto ej tillg\xe4ngligt","header-price-change":"Priset har \xe4ndrats","info-price-change":"Det nya priset f\xf6r din bokning \xe4r {{newPrice}} kr. Vill du acceptera det nya priset?","button-accept-price":"Acceptera nytt pris","button-reject-price":"Avbryt","label-name":"Namn","label-phone":"Telefonnummer","label-message-to-driver":"Meddelande till f\xf6raren","header-thanks-for-your-booking":"Tack f\xf6r din bokning!","info-booking-done":"Du hittar dina bokningar under den gula ikonen uppe till h\xf6ger. Genom att resa med oss s\xe5 godk\xe4nner du v\xe5ra <link1>resevillkor</link1>.","title-car-and-eta":"{{taxi}} - ({{vehicle}}) ankommer ca {{eta}}","title-car":"{{taxi}} - ({{vehicle}})","tooltip-here-is-your-bookings":"H\xe4r finns dina bokningar","header-your-bookings":"Dina bokningar","info-arrives-apx":"Ca:","label-date":"Datum","label-flight-number":"Flightnummer","label-baggage":"Bagage","label-account":"Konto","label-company-trip":"F\xf6retagsresa","label-private-trip":"Privatresa","label-booking-options":"Tillval","label-yes":"Ja","label-no":"Nej","label-message":"Meddelande","button-show-more":"Visa mer","button-show-less":"Visa mindre","info-login-to-update-profile":"Logga in f\xf6r att l\xe4gga till betalmedel, se resehistorik eller uppdatera din profil.","label-firstname":"F\xf6rnamn","label-lastname":"Efternamn","label-mobile-phone":"Mobiltelefon","label-not-verified":"Ej verifierad","marketing-consent-title":"Vill du f\xe5 exklusiva erbjudanden och nyheter?","marketing-consent-body":"Vi skickar dig erbjudanden och nyheter via notiser, e-post eller SMS. Du kan alltid \xe4ndra detta i din profil.","marketing-consent-yes":"Ja tack","marketing-consent-no":"Inte nu","add-payment-title":"L\xe4gg till betalningsmetod","add-payment-body":"Spara en betalningsmetod f\xf6r enklare bokningar! Vissa resor kr\xe4ver det.","add-payment-button":"L\xe4gg till betalningsmetod","add-payment-not-now":"Inte nu","add-payment-type-card":"Betalkort","add-payment-type-tsab":"TSAB-konto","button-back":"Tillbaka","button-verify-email":"Verifiera","email-verify-sent-title":"Kolla din inkorg","email-verify-sent-body":"Vi har skickat ett verifieringsmejl till","email-verify-resend-countdown":"Skicka igen ({{seconds}}s)","email-verify-resend":"Skicka igen","button-verify-phone":"Verifiera","phone-verify-sent-title":"Ange din kod","phone-verify-sent-body":"Vi har skickat en kod via SMS till","phone-verify-resend-countdown":"Skicka ny kod ({{seconds}}s)","phone-verify-resend":"Skicka ny kod","phone-verified-title":"Ditt telefonnummer \xe4r verifierat","phone-verified-body":"Tack! Ditt telefonnummer \xe4r nu bekr\xe4ftat. Du kan st\xe4nga det h\xe4r f\xf6nstret eller logga in f\xf6r att forts\xe4tta.","error-phone-verify-failed":"Det gick inte att verifiera telefonnumret, var v\xe4nlig f\xf6rs\xf6k igen","validation-phone-format":"Ange ett giltigt telefonnummer.","label-company":"F\xf6retag","label-connected-email":"F\xf6retagsmail","label-communications":"Kommunikation","info-change-phone":"F\xf6r att anv\xe4nda ett annat telefonnummer beh\xf6ver du logga ut och skapa ett nytt konto.","info-verify-phone":"Om du \xe4ndrar ditt telefonnummer skickar vi en kod via SMS f\xf6r att verifiera det. Numret sparas f\xf6rst n\xe4r koden \xe4r bekr\xe4ftad.","reset-booking-message":"Vill du verkligen avbryta din bokning?","reset-edit-message":"Vill du verkligen avbryta din \xe4ndring?","reset-login-message":"Vill du verkligen avbryta din inloggning?","button-login":"Logga in","button-yes":"Ja","button-no":"Nej","price_basePrice":"Grundpris","price_vat":"Varav moms","price_terminalFee":"Terminalavgift","price_environmentalFee":"Milj\xf6avgift","price_waitingFee":"V\xe4ntetaxa","price_fixedAdditionalFee":"Fasta till\xe4gg i bil","price_vehicleOption":"Tillval","price_tip":"Dricks","button-read-more":"L\xe4s mer","status-pre-booked":"F\xf6rbokad","status-searching":"S\xf6ker bil","status-header-received":"Bokningen \xe4r mottagen","status-header-dispatched":"Bilen \xe4r p\xe5 v\xe4g","status-header-plate-prefix":"Taxi ","status-header-dispatched-suffix":" \xe4r p\xe5 v\xe4g","status-header-approaching":"Bilen \xe4r n\xe4stan framme","status-header-approaching-suffix":" \xe4r n\xe4stan framme","status-header-at-pickup":"Din bil \xe4r framme","status-header-at-pickup-suffix":" \xe4r framme","status-header-en-route":"Trevlig resa","status-header-completed":"Utf\xf6rd","status-header-cancelled":"Avbest\xe4lld","status-header-no-show":"Ej kundkontakt","status-header-rejected":"Bokning nekad","status-header-failed":"Ej bokad","status-header-cancellation-requested":"Avbokning beg\xe4rd","status-header-cancellation-rejected":"Avbokning nekad","status-header-annulled":"Anullerad","status-subtitle-received":"Vi har tagit emot din bokning, en bil \xe4r snart p\xe5 v\xe4g","status-subtitle-searching":"Vi har snart en bil p\xe5 v\xe4g","status-subtitle-prebooked":"Din bokning \xe4r bekr\xe4ftad","status-subtitle-dispatched":"Din taxi h\xe4mtar snart upp dig","status-subtitle-dispatched-with-address":"Taxin kommer att h\xe4mta dig p\xe5 {{address}}","status-subtitle-approaching-with-address":"Taxin kommer att h\xe4mta dig p\xe5 {{address}}","status-subtitle-at-pickup":"Din bil \xe4r framme","status-subtitle-at-pickup-with-address":"Taxin v\xe4ntar vid {{address}}","status-subtitle-en-route":"Trevlig resa!","status-subtitle-en-route-with-destination":"Taxin k\xf6r dig till {{destination}}","status-subtitle-completed":"Tack f\xf6r att du valt att resa med Taxi Stockholm","status-subtitle-cancelled":"Din resa \xe4r avbokad","status-subtitle-no-show":"Din resa \xe4r avbokad","status-waiting-for-confirmation":"Bokningen \xe4r mottagen","menu-my-bookings":"Mina resor","header-previous-bookings":"Tidigare resor","button-book-taxi":"Boka taxi","button-book-delivery":"Boka bud","label-as-soon-as-possible":"S\xe5 snart som m\xf6jligt","label-price":"Pris","header-book-delivery":"Boka bud","placeholder-pickup-address":"Upph\xe4mtningsadress","placeholder-delivery-address":"Leveransadress","button-prebook-delivery":"F\xf6rboka bud","button-book-delivery-now":"Boka bud nu","validation-pickup-address-required":"Du m\xe5ste v\xe4lja en upph\xe4mtningsadress.","validation-delivery-address-required":"Du m\xe5ste v\xe4lja en leveransadress.","header-when-should-we-pickup":"N\xe4r ska vi h\xe4mta?","header-what-would-you-like-to-send":"Vad vill du skicka?","title-ENVELOPE":"Kuvert","title-BOX":"Liten l\xe5da","title-BAG":"Kasse","title-MOVING_BOX":"Flyttl\xe5da","weight-0-20":"Vikt 0-20 kg","info-delivery-categories":"Ovanst\xe5ende kategorier anv\xe4nds f\xf6r att avg\xf6ra vilken biltyp som kommer att beh\xf6vas f\xf6r ditt bud (max bilstorlek \xe4r kombi).","info-delivery":"Om du vill skicka mer skrymmande gods eller har fr\xe5gor, ring v\xe5r budv\xe4xel p\xe5 08-612 60 00.<br/> Mer information om vad som g\xe4ller f\xf6r budbokning via webb hittar du <button1>h\xe4r</button1>.","info-delivery-terms":"<strong>Mer information om bud via v\xe5r hemsida</strong><br/><br/><ul><li>V\xe5r budservice hanterar ej farligt gods (tex bensin, cigarett\xe4ndare, gasol), varmh\xe5llen mat, tobak, djur eller st\xf6rre flyttransporter.</li><li>Maxvikt per kolli \xe4r 20 kg vid budbokning via v\xe5r hemsida.</li><li>10 min v\xe4ntetid ing\xe5r i priset f\xf6r budbokning, d\xe4refter debiteras v\xe4ntetaxa.</li><li>Ev. f\xe4rjeavgift kan tillkomma om rutten innefattar en f\xe4rja med avgift.</li><li>Ev. terminalavgifter \xe4r inkluderade i priset f\xf6r vissa destinationer. Se aktuella prisuppgifter f\xf6r terminalavgifter <a href=\\"/sv/hjalpcenter/priser\\" target=\\"_blank\\">h\xe4r</a>.</li><li>I de fall f\xf6raren inte \xe4r till\xe5ten att l\xe4mna godset vid d\xf6rren och mottagaren ej \xe4r tillg\xe4nglig vid avl\xe4mning, kommer godset att returneras till s\xe4ndaren. En ev. returresa debiteras.</li><li>Vid betalningsmetod Betala i taxin, s\xe5 m\xe5ste resan betalas av avs\xe4ndaren innan den p\xe5b\xf6rjas.</li><li>Vi kan tyv\xe4rr inte hj\xe4lpa till med ink\xf6p av varor.</li><li>Vi kan tyv\xe4rr inte h\xe4mta ut paket d\xe4r legitimation kr\xe4vs.</li><li>S\xe4tet i bilen kommer tyv\xe4rr inte att kunna f\xe4llas ner vid budbokning via hemsidan. Om du vill skicka skrymmande gods (gods med stor volym/m\xe5tt) eller har fr\xe5gor, kontakta v\xe5r budv\xe4xel p\xe5 08-612 60 00.</li></ul>","validation-package-required":"Du m\xe5ste v\xe4lja \xe5tminstone en typ av bud du vill skicka.","header-whos-the-sender":"Vem skickar?","placeholder-name-on-door":"Namn p\xe5 d\xf6rren","placeholder-number-of-stairs":"Antal trappor","placeholder-door-code":"Eventuell portkod","header-whos-the-receiver":"Vem tar emot?","placeholder-name-receiver-on-door":"Namn mottagare / p\xe5 d\xf6rren","placeholder-phone-receiver":"Telefon mottagare","title-extra-information":"Extra information","info-extra-information":"H\xe4r kan du fylla i extra information till f\xf6raren.","title-leave-outside":"L\xe4mna utanf\xf6r","validation-name-receiver-required":"Du m\xe5ste fylla i namn p\xe5 mottagare.","label-name-on-door":"Namn p\xe5 d\xf6rren","label-number-of-stairs":"Antal trappor","label-door-code":"Eventuell portkod","label-name-receiver-on-door":"Namn mottagare / p\xe5 d\xf6rren","label-phone-receiver":"Telefon mottagare","type-ENVELOPE":"{{count}} kuvert","type-BOX_one":"{{count}} liten l\xe5da","type-BOX_other":"{{count}} sm\xe5 l\xe5dor","type-BAG_one":"{{count}} kasse","type-BAG_other":"{{count}} kassar","type-MOVING_BOX_one":"{{count}} flyttl\xe5da","type-MOVING_BOX_other":"{{count}} flyttl\xe5dor","header-account":"Konto","header-accounts":"Konton","header-card":"Betalkort","header-cards":"Betalkort","header-vouchers":"Rabattkoder","info-no-accounts":"Du har inte lagt till n\xe5gra konton \xe4nnu.","info-no-cards":"Du har inte lagt till n\xe5gra betalkort \xe4nnu.","info-no-vouchers":"Du har inte lagt till n\xe5gra rabattkoder \xe4nnu.","header-no-payment-methods":"Ingen betalmetod tillagd","info-no-payment-methods":"Den h\xe4r resan kr\xe4ver f\xf6rbetalning. L\xe4gg till en betalmetod f\xf6r att forts\xe4tta.","button-add-payment":"L\xe4gg till betalmetod","button-add-card":"L\xe4gg till betalkort","button-add-account":"L\xe4gg till konto","button-add-voucher":"L\xe4gg till rabattkod","button-save":"Spara","info-confirm-remove-card":"\xc4r du s\xe4ker p\xe5 att du vill ta bort betalkortet fr\xe5n din profil?","header-add-account":"L\xe4gg till konto","header-add-voucher":"L\xe4gg till rabattkod","header-details":"Uppgifter","placeholder-account-number":"Kontonummer","placeholder-account-password":"L\xf6senord","placeholder-voucher-code":"Rabattkod","validation-need-voucher-code":"Du m\xe5ste ange en kod.","validation-need-account-number":"Du m\xe5ste ange kontonummer.","validation-need-account-password":"Du m\xe5ste ange l\xf6senord.","expires-at":"Giltig t.o.m {{date}}","free-trip":"Gratis resa*","info-voucher-max":"Rabatt p\xe5 f\xf6rsta {{amount}}kr","info-voucher-codes":"Det \xe4r bara m\xf6jligt att anv\xe4nda en rabattkod per resa. Se v\xe5ra <link1>betalningsvillkor</link1> f\xf6r mer information.","info-voucher-codes-partner":"Rabattkoder kan ej anv\xe4ndas vid bokning med partners. Se v\xe5ra <link1>betalningsvillkor</link1>.","info-voucher-disabled-payment-method":"Rabattkoder kan inte anv\xe4ndas med denna betalningsmetod.","info-voucher-disabled-provider":"Rabattkoder kan inte anv\xe4ndas med denna partner.","info-voucher-disabled-taxameter":"Rabattkoder kan inte anv\xe4ndas med taxameter.","button-send-confirmation":"Epostbekr\xe4ftelse","header-send-confirmation":"Skicka epostbekr\xe4ftelse","placeholder-email":"Epostadress","button-send":"Skicka","info-confirmation-sent":"En bekr\xe4ftelse har skickats.","label-important-about-your-trip":"Viktig information om din resa","return-trip-offer-title":"Boka returen direkt?","return-trip-offer-subtitle":"Vi har f\xf6rberett din returresa fr\xe5n {{destination}}.","button-not-now":"Inte nu","return-trip-title":"Returresa","return-trip-subtitle":"Vi har fyllt i vissa detaljer fr\xe5n din tidigare bokning.","return-trip-subtitle-flight":"Vi f\xf6ljer flygets ankomsttid och justerar upph\xe4mtningstiden automatiskt.","label-prefilled-details":"F\xf6rifyllda detaljer","button-change":"\xc4ndra","label-pickup-time":"Upph\xe4mtningstid","placeholder-select-pickup-time":"V\xe4lj upph\xe4mtningstid","placeholder-select-landing-time":"V\xe4lj landningstid","validation-need-landing-time":"V\xe4nligen ange din landningstid","validation-need-pickup-time":"V\xe4nligen ange upph\xe4mtningstid","button-book-and-pay":"Boka & betala {{price}}:-","return-trip-error-title":"Vi kan inte boka den h\xe4r returresan","return-trip-error-not-available":"Vi kan inte utf\xf6ra den h\xe4r returresan just nu. Forts\xe4tt f\xf6r att \xe4ndra din bokning.","return-trip-error-car-type":"Biltypen fr\xe5n din f\xf6rra resa \xe4r inte tillg\xe4nglig f\xf6r den h\xe4r returresan. Forts\xe4tt f\xf6r att v\xe4lja en annan.","return-trip-error-extras":"Tillval fr\xe5n din f\xf6rra resa \xe4r inte tillg\xe4ngliga f\xf6r den h\xe4r returresan. Forts\xe4tt f\xf6r att v\xe4lja igen.","return-trip-error-payment-method":"Betals\xe4ttet fr\xe5n din f\xf6rra resa kan inte anv\xe4ndas f\xf6r den h\xe4r returresan. Forts\xe4tt f\xf6r att \xe4ndra det."}},"en":{"translation":{"your-trip":"Your trip","edit-your-trip":"Edit your trip","edit-fields-expiration-warning":"Some fields will be disabled for editing in {{time}}","edit-fields-expiration-subtext":"Save your changes or they may be locked","edit-fields-no-changes-title":"Cannot Make Changes","edit-fields-no-changes-message":"It is no longer possible to make any changes to this booking.","header-where-do-you-want-to-go":"Where do tou want to go?","header-book-taxi":"Book taxi","placeholder-origin-location":"Where can we pick you up?","placeholder-destination-location":"Where do you want to go?","placeholder-add-stop":"Add a stop","button-add-stop":"Add a stop","button-go-now":"Book taxi now","button-go-later":"Pre-book","button-no-available-cars":"No available cars","booking-login-info":"To complete your booking, you will be required to verify your phone number.","validation-departure-required":"You must select a pickup location.","validation-destination-required":"You must select a destination.","validation-airport-not-allowed":"You cannot select an airport as an intermediate stop.","validation-departure-invalid":"We can\'t pickup at this location","validation-destination-invalid":"We can\'t stop at this location","validation-intermediate-invalid":"Not valid as intermediate stop","info-enter-street-number":"Please enter the<br/>street number","error-no-estimate":"It seems like you have a bad connection, please try again or call our exchange 08-15 00 00 and they will help you book.","info-select-redirect":"Please select an alternative location.","header-when-do-you-want-to-go":"When can we pick you up?","header-when-does-your-flight-land":"When will your flight arrive?","flightnumber-info":"You can usually find your flight number on your ticket or booking confirmation.","button-continue":"Continue","placeholder-flight-number":"Flight number","placeholder-pick-date":"Pick landing time","info-flight-number":"We will monitor your flight arrival time","title-baggage":"Checked Baggage","info-baggage":"We take into account that it may take time to receive your checked baggage after landing","section-flight-number":"Flight number","section-landing-time":"Landing time","section-luggage":"Luggage","header-passengers":"Passengers","label-passenger-count":"{{count}} passengers","label-group-size":"How many in your group?","info-passenger-count":"The provider needs to know how many passengers you will be in the car. You may share this ride with other passengers.","validation-need-passenger-count":"Enter number of passengers","modal-passenger-required-title":"Passengers required","modal-passenger-required-body":"Please enter how many passengers are travelling with you.","validation-date-not-valid":"Date and time is not valid.","validation-date-too-far-ahead":"Date and time too far ahead.","validation-need-date":"You need to select a day and time.","validation-need-flight-number":"Please enter a valid flight number (e.g., AB123, A1B234, 1A999Z)","title-invalid-time":"Invalid time","message-invalid-time":"The selected time is not available and has been adjusted to the nearest valid time.","title-fully-booked":"The time is fully booked","message-select-other-time":"The time is fully booked. At the moment pre-bookings are fully booked at least one hour ahead, if possible select another time or call ourcustomer service on 08-15 00 00.","message-select-next-available-time":"Please pick another time or the suggested next available time.<br/><br/>The next available time is {{time}}","button-select-other-time":"Pick another time","button-select-available-time":"Pick suggested time","button-ok":"Ok","header-how-do-you-want-to-go":"Select your trip details","header-select-car":"Select car","header-select-partner":"Select partner","header-no-providers-found":"No providers found","info-no-providers-found":"No provider matches your current selection. Try changing add-ons or car type.","cartype-taxi":"Standardtaxi","cartype-large-car":"People carrier","cartype-estate":"Estate","cartype-business":"Business","cartype-taxi-info":"For your everyday needs","cartype-large-car-info":"For bigger groups","cartype-estate-info":"More cargo space","cartype-business-info":"Premium cars","num-persons-3":"3 persons","num-persons-4":"4 persons","num-persons-7":"7 persons","approx-min":"about {{minutes}} min","title-fixed-price":"Fixed price","info-fixed-price-not-available":"Fixed price is not available","info-price-estimate-failed":"We could not fetch a fixed price for this trip.","button-try-again":"Try again","info-taxameter-not-available":"Taxameter is not available","title-private-or-company":"Private or company trip","info-private":"Private","title-booking-options":"Extras","info-booking-options":"Add extra options","label-luggage-fits":"Unsure if your luggage fits?","title-pet-option":"Pet","title-low-option":"Low car","info-low-option":"Easier to get in and out","info-pet-option":"Consider selecting a larger car if needed","title-stationwagon-option":"Estate","title-childseat-option":"Rear-facing child seat","info-childseat-option":"For children 9 months and older or 9kg","title-booster-option":"Booster seat","info-booster-option":"For children over 4 years or 15kg","title-electric-car":"Electric car","info-electric-car":"If available, I prefer an electric car","button-done":"Done","label-i-want-to-go-now":"Direct booking","label-direct-booking":"Direct booking","label-prebooked":"Pre-booking","info-flight-monitoring":"We will monitor your flight arrival time","label-checked-baggage":"Checked baggage","label-from":"From","label-to":"To","label-when":"When","label-payment":"Payment","label-receipt":"Receipt","label-how":"How","label-fixed-price":"Fixed price","label-taxameter":"Taxameter","label-price-information":"Price information","label-total":"Total","label-incl-tip":"incl. tip","label-pet-option":"Pet","label-low-option":"Low car","label-stationwagon-option":"Estate","label-childseat-option":"Rear-facing child seat","label-booster-1-option":"1 booster seat","label-booster-2-option":"2 booster seats","label-electric-option":"Electric car","label-option-free":"Free","label-booking-number":"Booking number","info-available-in":"Available in about {{minutes}} minutes","button-download-receipt":"Show receipt","info-receipt-not-available":"Receipt not available","info-receipt-pending":"Receipt available after registered payment","info-receipt-refunded":"Refund completed","info-num-vouchers_one":"{{count}} available voucher","info-num-vouchers_other":"{{count}} available vouchers","header-welcome":"Welcome!","info-welcome-subtitle":"Travel safely with Stockholm\'s most experienced taxi company","label-phone-number":"Phone number","button-login-apple":"Continue with Apple","button-login-google":"Continue with Google","label-or":"or","info-by-continuing-terms":"By continuing, you accept our <link1>Terms & conditions</link1>","header-google-signin":"Sign in with Google","info-google-signin":"Sign in with your Google account to continue.","error-google-signin-failed":"Failed to sign in with Google. Please try again.","error-apple-signin-failed":"Failed to sign in with Apple. Please try again.","header-add-phone-social":"Your phone number","info-add-phone-social":"We use your number in case we need to contact you about your trip. We\'ll send you a verification link.","info-enter-code-sent-social":"We sent it to number {{dialCode}} {{phone}}","header-is-this-you":"Is this you?","header-login-as":"Log in as {{name}}?","info-existing-account-found":"We found an existing account that uses the same phone number as you entered.","button-not-me":"Not me","button-yes-thats-me":"Yes, that\'s me","button-create-new-account":"Create new account","header-confirm-phone":"Verify your number","info-confirm-phone":"A code will be sent to your number. We use your number to text you about important updates on your journey.","info-confirm-phone-login":"To login, you must confirm your phone number.","button-cancel":"Cancel","validation-only-numbers":"May only contain numbers.","validation-need-phone":"Phone number can not be empty.","validation-length-phone":"Must be between 6 and 14 digits.","header-enter-your-code":"Please enter your code","info-enter-the-code-sent-to":"We sent it to number {{dialCode}} {{phone}}","button-did-not-get-code":"Resend code","header-enter-your-email":"What\u2019s your email?","placeholder-enter-your-email":"Enter your email address","info-we-use-your-email":"We use your email to sign you in. We\u2019ll send you a verification link.","validation-invalid-email":"Invalid email address.","validation-need-email":"You must enter an email address.","header-welcome-back":"Welcome back!","info-your-phone-is-linked":"Your phone number is linked to the email address {{maskedEmail}}. Please enter the verification code we emailed you.","button-select-other-email":"Use a different email","change-email-message":"If you sign in with a new email, your bookings made with the previous email will not show in your history.","header-enter-name":"What\u2019s your name?","info-driver-confirm-pickup":"This helps our driver confirm it\'s you when they pick you up.","placeholder-firstname":"First name","placeholder-lastname":"Last name","validation-need-firstname":"You need to fill in first name.","validation-need-lastname":"You need to fill in last name.","header-terms-and-conditions":"Terms and conditions","info-accept-terms":"Please read and accept our <link1>terms and conditions</link1>.","title-accept-terms":"I confirm that I have read and accept the terms and conditions","title-accept-marketing":"I want to receive offers, news and updates from Taxi Stockholm","button-confirm":"Confirm","header-confirm-your-booking":"Confirm your booking","header-confirm-edit":"Confirm changes","placeholder-name":"Name","placeholder-phone":"Phone number","title-payment":"Payment","title-vouchers":"Vouchers","title-voucher":"Voucher:","title-pay-in-car":"Pay in car","title-pay-in-car-sender":"Pay in car (sender pays)","button-add-new-card":"Add new payment card","button-add-new-account":"Add new account","button-add-new-voucher":"Add new voucher","title-message-to-driver":"Message to the driver","placeholder-reference":"Reference","info-accept-booking-terms":"By traveling with us, you accept our <link1>terms and conditions</link1>.","title-message":"Message to the driver","info-message-to-driver":"Here you can clarify how the driver may find you.","validation-need-name":"Name can not be empty.","validation-need-reference":"You need to fill in reference.","validation-need-payment":"You need to choose a payment method.","button-book-now":"Confirm","button-confirm-edit":"Confirm changes","error-payment":"Something went wrong with the payment. Please try again.","error-network":"Could not reach the server. Check your connection and try again.","error-network-uncertain":"We could not confirm whether your booking went through. Please check your active bookings before booking again.","header-whos-travel":"Traveler","button-edit-booking":"Edit booking","button-cancel-booking":"Cancel booking","button-close":"Close","button-book-again":"Book trip again","button-return-trip":"Book return trip","button-add-to-calendar":"Add to calendar","button-forward-confirmation":"Forward booking confirmation","button-modify-booking":"Modify booking","button-receipt-unavailable":"Receipt not available","header-price-change":"Price has changed","info-price-change":"The new price for your booking is {{newPrice}} kr. Do you want to accept the new price?","button-accept-price":"Accept new price","button-reject-price":"Cancel","label-name":"Name","label-phone":"Phone number","label-message-to-driver":"Message to the driver","header-thanks-for-your-booking":"Thank you for your booking!","info-booking-done":"You will find your bookings under the yellow icon at the top right. By traveling with us, you agree to our <link1>terms and conditions</link1>.","title-car-and-eta":"{{taxi}} - ({{vehicle}}) arrives approx. {{eta}}","title-car":"{{taxi}} - ({{vehicle}})","tooltip-here-is-your-bookings":"Here is your bookings","header-your-bookings":"Your bookings","info-arrives-apx":"Approx.","label-date":"Date","label-flight-number":"Flight number","label-baggage":"Baggage","label-account":"Account","label-company-trip":"Company trip","label-private-trip":"Private trip","label-booking-options":"Extras","label-yes":"Yes","label-no":"No","label-message":"Message to the driver","button-show-more":"Show more","button-show-less":"Show less","info-login-to-update-profile":"Log in to add payment methods, view travel history or update your profile.","label-firstname":"First Name","label-lastname":"Last Name","label-mobile-phone":"Mobile phone","label-not-verified":"Not verified","marketing-consent-title":"Want to receive exclusive offers and news?","marketing-consent-body":"We\'ll send you offers and news via notifications, email or text. You can always change this in your profile.","marketing-consent-yes":"Yes please","marketing-consent-no":"Not now","add-payment-title":"Add a payment method","add-payment-body":"Save a payment method for simpler bookings! Some trips require it.","add-payment-button":"Add payment method","add-payment-not-now":"Not now","add-payment-type-card":"Payment card","add-payment-type-tsab":"TSAB account","button-back":"Back","button-verify-email":"Verify","email-verify-sent-title":"Check your inbox","email-verify-sent-body":"We\'ve sent a verification email to","email-verify-resend-countdown":"Resend email ({{seconds}}s)","email-verify-resend":"Resend email","button-verify-phone":"Verify","phone-verify-sent-title":"Enter your code","phone-verify-sent-body":"We\'ve sent a code by text message to","phone-verify-resend-countdown":"Send new code ({{seconds}}s)","phone-verify-resend":"Send new code","phone-verified-title":"Your phone number is verified","phone-verified-body":"Thanks! Your phone number is now confirmed. You can close this window or log in to continue.","error-phone-verify-failed":"The phone number could not be verified, please try again","validation-phone-format":"Enter a valid phone number.","label-company":"Company","label-connected-email":"Company email","label-communications":"Communications","info-change-phone":"To use a different phone number, you need to log out and create a new account.","info-verify-phone":"If you change your phone number we\'ll send a code by text message to verify it. The number is saved once the code is confirmed.","reset-booking-message":"Do you really want to cancel your booking?","reset-edit-message":"Do you really want to cancel your changes?","reset-login-message":"Do you really want to cancel your login?","button-login":"Login","button-yes":"Yes","button-no":"No","price_basePrice":"Base price","price_vat":"VAT","price_terminalFee":"Terminal fee","price_environmentalFee":"Environmental fee","price_waitingFee":"Waiting fee","price_fixedAdditionalFee":"Fixed additional fee","price_vehicleOption":"Extra options","price_tip":"Tip","button-read-more":"Read more","status-pre-booked":"Pre-booked","status-searching":"Looking for a car","status-header-received":"Booking received","status-header-dispatched":"The car is on the way","status-header-plate-prefix":"Taxi ","status-header-dispatched-suffix":" is on the way","status-header-approaching":"The car is almost there","status-header-approaching-suffix":" is almost there","status-header-at-pickup":"Your car has arrived","status-header-at-pickup-suffix":" has arrived","status-header-en-route":"Have a nice trip","status-header-completed":"Completed","status-header-cancelled":"Cancelled","status-header-no-show":"No passenger contact","status-header-rejected":"Booking denied","status-header-failed":"Rejected","status-header-cancellation-requested":"Cancellation requested","status-header-cancellation-rejected":"Cancellation denied","status-header-annulled":"Annulled","status-subtitle-received":"We have received your booking, a car is soon on its way","status-subtitle-searching":"We\'ll soon have a car for you","status-subtitle-prebooked":"Your booking is confirmed","status-subtitle-dispatched":"Your taxi will soon pick you up","status-subtitle-dispatched-with-address":"Your taxi will soon pick you up at {{address}}","status-subtitle-approaching-with-address":"Your taxi will soon pick you up at {{address}}","status-subtitle-at-pickup":"Your car has arrived","status-subtitle-at-pickup-with-address":"Your taxi is waiting at {{address}}","status-subtitle-en-route":"Enjoy your ride!","status-subtitle-en-route-with-destination":"The taxi will take you to {{destination}}","status-subtitle-completed":"Thank you for travelling with Taxi Stockholm","status-subtitle-cancelled":"The trip was cancelled","status-subtitle-no-show":"The trip was cancelled","status-waiting-for-confirmation":"Booking received","menu-my-bookings":"My bookings","header-previous-bookings":"Previous bookings","button-book-taxi":"Book taxi","button-book-delivery":"Book delivery","label-as-soon-as-possible":"As soon as possible","label-price":"Price","header-book-delivery":"Book delivery","placeholder-pickup-address":"Pickup address","placeholder-delivery-address":"Delivery address","button-prebook-delivery":"Pre-book delivery","button-book-delivery-now":"Book delivery&nbsp;now","validation-pickup-address-required":"You must select a pickup address.","validation-delivery-address-required":"You must select a delivery address.","header-when-should-we-pickup":"When should we pick up?","header-what-would-you-like-to-send":"What do you want to send?","title-ENVELOPE":"Envelope","title-BOX":"Small box","title-BAG":"Bag","title-MOVING_BOX":"Moving box","weight-0-20":"Weight 0-20 kg","info-delivery-categories":"The above categories are used to determine the type of car that will be needed for your bid (max car size is station wagon).","info-delivery":"If you want to send more bulky goods or have questions, call our courier service on 08-612 60 00. You can find more information about what applies to courier reservations via the web <button1>here</button1>.","info-delivery-terms":"<strong>More information about our courier service via the website</strong><br/><br/><ul><li>Our courier service does not handle hazardous goods (for example petrol, cigarette lighters), heated food, tobacco, pets or larger moving transports.</li><li>Maximum weight per package is 20 kg when booking is made via our website.</li><li>10 min waiting time is included in the price, after which a waiting fee is charged.</li><li>Ferry fee may be added if the route includes a ferry with a fee.</li><li>Terminal fees are included in the price for some destinations. See current price information for terminal fees <a href=\\"/en/helpdesk/fares-and-payment\\" target=\\"_blank\\">here</a>.</li><li>In case the driver is not allowed to leave the goods at the door and the recipient is not available for delivery, the goods will be returned to the sender. The return trip will be charged.</li><li>If payment method Pay in car is selected, the payment has to be made by the sender before the trip is started.</li><li>We will not be able to help with purchase of any goods as part our service.</li><li>We will not be able to pick up packages where identification is required.</li><li>It will not be possible to fold the seat when booking is made via our website. If you want to send bulky goods (goods with large volume/dimensions) or have questions, contact our courier service on 08-612 60 00 and they will help you.</li></ul>","validation-package-required":"You must select at least one type you want to send.","header-whos-the-sender":"Who is the sender?","placeholder-name-on-door":"Name on door","placeholder-number-of-stairs":"Number of stairs","placeholder-door-code":"Door code","header-whos-the-receiver":"Who is the receiver?","placeholder-name-receiver-on-door":"Receiver name / name on door","placeholder-phone-receiver":"Receiver phone","title-extra-information":"Extra information","info-extra-information":"Here you can enter extra information for the driver.","title-leave-outside":"Leave outside","validation-name-receiver-required":"You must enter the name of the receiver.","label-name-on-door":"Name on door","label-number-of-stairs":"Number of stairs","label-door-code":"Door code","label-name-receiver-on-door":"Receiver name / name on door","label-phone-receiver":"Receiver phone","type-ENVELOPE_one":"{{count}} envelope","type-ENVELOPE_other":"{{count}} envelopes","type-BOX_one":"{{count}} small box","type-BOX_other":"{{count}} small boxes","type-BAG_one":"{{count}} bag","type-BAG_other":"{{count}} bags","type-MOVING_BOX_one":"{{count}} moving box","type-MOVING_BOX_other":"{{count}} moving boxes","header-account":"Account","header-accounts":"Accounts","header-card":"Payment card","header-cards":"Payment cards","header-vouchers":"Vouchers","info-no-accounts":"You have not added any accounts yet.","info-no-cards":"You have not added any payment cards yet.","info-no-vouchers":"You have not added any vouchers yet.","header-no-payment-methods":"No added payment method","info-no-payment-methods":"This trip requires pre-payment. Add a payment method to continue.","button-add-payment":"Add payment","button-add-card":"Add payment card","button-add-account":"Add account","button-add-voucher":"Add voucher","button-save":"Save","info-confirm-remove-card":"Are you sure you want to remove the payment card from your profile?","header-add-account":"Add account","header-add-voucher":"Add voucher","header-details":"Details","placeholder-account-number":"Account number","placeholder-account-password":"password","placeholder-voucher-code":"Voucher code","validation-need-voucher-code":"You have to enter a code.","validation-need-account-number":"You have to enter an account number.","validation-need-account-password":"You have to enter the password.","expires-at":"Expires {{date}}","free-trip":"Free ride*","info-voucher-max":"Discount on first {{amount}}kr","info-voucher-codes":"It\'s only possible to use one voucher per trip. Please see our <link1>payment terms</link1> for more information.","info-voucher-codes-partner":"Vouchers can\u2019t be used when booking with partners. Please see our <link1>payment terms</link1>.","info-voucher-disabled-payment-method":"Vouchers can not be used with this payment method.","info-voucher-disabled-provider":"Vouchers can not be used with this provider.","info-voucher-disabled-taxameter":"Vouchers can not be used with taximeter.","button-send-confirmation":"Email confirmation","header-send-confirmation":"Send email confirmation","placeholder-email":"Email address","button-send":"Send","info-confirmation-sent":"A confirmation has been sent.","label-important-about-your-trip":"Important about your trip","return-trip-offer-title":"Book your return now?","return-trip-offer-subtitle":"We\u2019ve prepared your return trip from {{destination}}.","button-not-now":"Not now","return-trip-title":"Return trip","return-trip-subtitle":"We\u2019ve filled in some details from your previous booking.","return-trip-subtitle-flight":"We monitor your flight\'s arrival time and automatically adjust the pickup time.","label-prefilled-details":"Prefilled details","button-change":"Edit","label-pickup-time":"Pickup time","placeholder-select-pickup-time":"Select pickup time","placeholder-select-landing-time":"Select landing time","validation-need-landing-time":"Please enter your landing time","validation-need-pickup-time":"Please enter a pickup time","button-book-and-pay":"Book & pay {{price}}:-","return-trip-error-title":"We can\'t book this return trip","return-trip-error-not-available":"We can\'t serve this return trip right now. Continue to adjust your booking.","return-trip-error-car-type":"The car type from your previous trip isn\'t available for this return trip. Continue to choose another.","return-trip-error-extras":"The add-ons from your previous trip aren\'t available for this return trip. Continue to choose again.","return-trip-error-payment-method":"The payment method from your previous trip can\'t be used for this return trip. Continue to change it."}}}');


const $c0695f6ebaa4acbb$var$getLang = ()=>{
    const lang = document.querySelector('html')?.getAttribute('lang')?.substr(0, 2);
    return [
        'sv',
        'en'
    ].indexOf(lang) !== -1 ? lang : 'sv';
};
(0, $7MXrw.default).use((0, $a56b92b0360baa63$export$ae7e14d40d89f296))// .use(Backend)
.init({
    lng: $c0695f6ebaa4acbb$var$getLang(),
    fallbackLng: 'sv',
    resources: $31a6d56c40e917fc$exports,
    // backend: {
    //   loadPath: '/app/themes/taxi-stockholm/static/locales/{{lng}}/{{ns}}.json'
    // },
    interpolation: {
        escapeValue: false
    }
});
var $c0695f6ebaa4acbb$export$2e2bcd8739ae039 = (0, $7MXrw.default);



var $bh6RR = parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
'use strict';

var $6afFj = parcelRequire("6afFj");
var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $6afFj.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $6afFj.hydrateRoot;


var $d2abdbb88c8390d6$exports = {};
Object.defineProperty($d2abdbb88c8390d6$exports, '__esModule', {
    value: true
});

var $bh6RR = parcelRequire("bh6RR");
var $d2abdbb88c8390d6$var$targetElement;
function $d2abdbb88c8390d6$var$getElement() {
    if (!$d2abdbb88c8390d6$var$targetElement) $d2abdbb88c8390d6$var$targetElement = document.createElement('div');
    return $d2abdbb88c8390d6$var$targetElement;
}
function $d2abdbb88c8390d6$var$useCustomEventListener(eventName, eventHandler, deps) {
    var element;
    $bh6RR.useEffect(function() {
        element = element || $d2abdbb88c8390d6$var$getElement();
        var handleEvent = function(event) {
            var data = event.detail;
            eventHandler(data);
        };
        element.addEventListener(eventName, handleEvent, false);
        return function() {
            element === null || element === void 0 || element.removeEventListener(eventName, handleEvent, false);
        };
    }, deps);
    return function(el) {
        element = el;
    };
}
function $d2abdbb88c8390d6$var$emitCustomEvent(eventName, data) {
    var element = $d2abdbb88c8390d6$var$getElement();
    var event = new CustomEvent(eventName, {
        detail: data
    });
    element.dispatchEvent(event);
}
function $d2abdbb88c8390d6$var$newCustomEventEmitter() {
    var element;
    function setElement(el) {
        element = el;
    }
    setElement.emit = function(eventName, data) {
        var event = new CustomEvent(eventName, {
            bubbles: true,
            detail: data
        });
        element === null || element === void 0 || element.dispatchEvent(event);
    };
    return setElement;
}
$d2abdbb88c8390d6$exports.emitCustomEvent = $d2abdbb88c8390d6$var$emitCustomEvent;
$d2abdbb88c8390d6$exports.newCustomEventEmitter = $d2abdbb88c8390d6$var$newCustomEventEmitter;
$d2abdbb88c8390d6$exports.useCustomEventListener = $d2abdbb88c8390d6$var$useCustomEventListener;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


var $bh6RR = parcelRequire("bh6RR");
const $e1f0702c5201c0a7$export$bced253d99be73e5 = (func, deps)=>{
    const didMount = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (didMount.current) func();
        else didMount.current = true;
    }, deps);
};
const $e1f0702c5201c0a7$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};


var $de51e1280ea129a8$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
'use strict';
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
'use strict';
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $034686670a8a195b$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup['-'.charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup['_'.charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case 'ascii':
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case 'base64':
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $034686670a8a195b$export$6100ba28696e12de(buf);
    else return $034686670a8a195b$export$6100ba28696e12de(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $454af19f7384844b$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $454af19f7384844b$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $034686670a8a195b$export$d622b2ad8d90c771($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $de51e1280ea129a8$require$Buffer = $d4ecdbf520e63dca$export$a143d493d941bafc;



(function() {
    var crypt = (parcelRequire("fSg2G")), utf8 = (parcelRequire("28Nm5")).utf8, bin = (parcelRequire("28Nm5")).bin, // The core
    sha1 = function(message) {
        // Convert to byte array
        if (message.constructor == String) message = utf8.stringToBytes(message);
        else if (typeof $de51e1280ea129a8$require$Buffer !== 'undefined' && typeof $de51e1280ea129a8$require$Buffer.isBuffer == 'function' && $de51e1280ea129a8$require$Buffer.isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message)) message = message.toString();
        // otherwise assume byte array
        var m = crypt.bytesToWords(message), l = message.length * 8, w = [], H0 = 1732584193, H1 = -271733879, H2 = -1732584194, H3 = 271733878, H4 = -1009589776;
        // Padding
        m[l >> 5] |= 0x80 << 24 - l % 32;
        m[(l + 64 >>> 9 << 4) + 15] = l;
        for(var i = 0; i < m.length; i += 16){
            var a = H0, b = H1, c = H2, d = H3, e = H4;
            for(var j = 0; j < 80; j++){
                if (j < 16) w[j] = m[i + j];
                else {
                    var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
                    w[j] = n << 1 | n >>> 31;
                }
                var t = (H0 << 5 | H0 >>> 27) + H4 + (w[j] >>> 0) + (j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 : j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 : j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 : (H1 ^ H2 ^ H3) - 899497514);
                H4 = H3;
                H3 = H2;
                H2 = H1 << 30 | H1 >>> 2;
                H1 = H0;
                H0 = t;
            }
            H0 += a;
            H1 += b;
            H2 += c;
            H3 += d;
            H4 += e;
        }
        return [
            H0,
            H1,
            H2,
            H3,
            H4
        ];
    }, // Public API
    api = function(message, options) {
        var digestbytes = crypt.wordsToBytes(sha1(message));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
    api._blocksize = 16;
    api._digestsize = 20;
    $de51e1280ea129a8$exports = api;
})();


let $e7016a9af9b25e86$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';


let $cf399e049a9c4d34$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $cf399e049a9c4d34$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step | 0;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $cf399e049a9c4d34$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$cf399e049a9c4d34$export$a5cee9e955a615e5(alphabet, size, $cf399e049a9c4d34$export$4385e60b38654f68);
let $cf399e049a9c4d34$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');



// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $283a85b679154342$exports = {};
"use strict";
Object.defineProperty($283a85b679154342$exports, "__esModule", {
    value: true
});
$283a85b679154342$exports.default = $283a85b679154342$var$cloneObject;

var $283a85b679154342$var$_index = $283a85b679154342$var$_interopRequireDefault((parcelRequire("2LfAb")));
function $283a85b679154342$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $283a85b679154342$var$cloneObject(object) {
    return (0, $283a85b679154342$var$_index.default)({}, object);
}
$283a85b679154342$exports = $283a85b679154342$exports.default;


var $2252559e2fde9de5$exports = {};
"use strict";
Object.defineProperty($2252559e2fde9de5$exports, "__esModule", {
    value: true
});
$2252559e2fde9de5$exports.default = $2252559e2fde9de5$var$format;

var $2252559e2fde9de5$var$_index = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("fV4Tl")));

var $2252559e2fde9de5$var$_index2 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("bkUS7")));

var $2252559e2fde9de5$var$_index3 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("99U8H")));

var $2252559e2fde9de5$var$_index4 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("cB9mK")));

var $2252559e2fde9de5$var$_index5 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("Js4Jx")));

var $2252559e2fde9de5$var$_index6 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("kXZ8N")));
var $6601e89fd41ce2c4$exports = {};
"use strict";
Object.defineProperty($6601e89fd41ce2c4$exports, "__esModule", {
    value: true
});
$6601e89fd41ce2c4$exports.isProtectedDayOfYearToken = $6601e89fd41ce2c4$var$isProtectedDayOfYearToken;
$6601e89fd41ce2c4$exports.isProtectedWeekYearToken = $6601e89fd41ce2c4$var$isProtectedWeekYearToken;
$6601e89fd41ce2c4$exports.throwProtectedError = $6601e89fd41ce2c4$var$throwProtectedError;
var $6601e89fd41ce2c4$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $6601e89fd41ce2c4$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $6601e89fd41ce2c4$var$isProtectedDayOfYearToken(token) {
    return $6601e89fd41ce2c4$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $6601e89fd41ce2c4$var$isProtectedWeekYearToken(token) {
    return $6601e89fd41ce2c4$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $6601e89fd41ce2c4$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}



var $2252559e2fde9de5$var$_index8 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("8WZx9")));

var $2252559e2fde9de5$var$_index9 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("kMAIB")));

var $fFrSb = parcelRequire("fFrSb");

var $2252559e2fde9de5$var$_index11 = $2252559e2fde9de5$var$_interopRequireDefault((parcelRequire("3NNiF")));
function $2252559e2fde9de5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2252559e2fde9de5$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2252559e2fde9de5$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2252559e2fde9de5$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2252559e2fde9de5$var$doubleQuoteRegExp = /''/g;
var $2252559e2fde9de5$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $2252559e2fde9de5$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $2252559e2fde9de5$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $fFrSb.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $2252559e2fde9de5$var$_index11.default;
    var firstWeekContainsDate = (0, $2252559e2fde9de5$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $2252559e2fde9de5$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $2252559e2fde9de5$var$_index3.default)(dirtyDate);
    if (!(0, $2252559e2fde9de5$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2252559e2fde9de5$var$_index6.default)(originalDate);
    var utcDate = (0, $2252559e2fde9de5$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2252559e2fde9de5$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $2252559e2fde9de5$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($2252559e2fde9de5$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2252559e2fde9de5$var$cleanEscapedString(substring);
        var formatter = $2252559e2fde9de5$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $6601e89fd41ce2c4$exports.isProtectedWeekYearToken)(substring)) (0, $6601e89fd41ce2c4$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $6601e89fd41ce2c4$exports.isProtectedDayOfYearToken)(substring)) (0, $6601e89fd41ce2c4$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2252559e2fde9de5$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2252559e2fde9de5$var$cleanEscapedString(input) {
    var matched = input.match($2252559e2fde9de5$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2252559e2fde9de5$var$doubleQuoteRegExp, "'");
}
$2252559e2fde9de5$exports = $2252559e2fde9de5$exports.default;


/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $70ba3223d5637e80$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $70ba3223d5637e80$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $70ba3223d5637e80$var$partsTimeZone(dtf, date) : $70ba3223d5637e80$var$hackyTimeZone(dtf, date);
}
function $70ba3223d5637e80$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $70ba3223d5637e80$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $70ba3223d5637e80$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $7950e93beecdfa6b$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $7950e93beecdfa6b$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $7950e93beecdfa6b$var$partsOffset(dtf, date) : $7950e93beecdfa6b$var$hackyOffset(dtf, date);
}
var $7950e93beecdfa6b$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $7950e93beecdfa6b$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $7950e93beecdfa6b$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $7950e93beecdfa6b$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $7950e93beecdfa6b$var$dtfCache = {};
function $7950e93beecdfa6b$var$getDateTimeFormat(timeZone) {
    if (!$7950e93beecdfa6b$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $7950e93beecdfa6b$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $7950e93beecdfa6b$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $3bdbd550bd19a664$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


var $1b66b7d2a8db9a3a$var$MILLISECONDS_IN_HOUR = 3600000;
var $1b66b7d2a8db9a3a$var$MILLISECONDS_IN_MINUTE = 60000;
var $1b66b7d2a8db9a3a$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $1b66b7d2a8db9a3a$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $1b66b7d2a8db9a3a$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $1b66b7d2a8db9a3a$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$1b66b7d2a8db9a3a$var$validateTimezone(hours)) return NaN;
        return -(hours * $1b66b7d2a8db9a3a$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $1b66b7d2a8db9a3a$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$1b66b7d2a8db9a3a$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $1b66b7d2a8db9a3a$var$MILLISECONDS_IN_HOUR + minutes * $1b66b7d2a8db9a3a$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($1b66b7d2a8db9a3a$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $1b66b7d2a8db9a3a$var$toUtcDate(date);
        var offset = $1b66b7d2a8db9a3a$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $1b66b7d2a8db9a3a$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $1b66b7d2a8db9a3a$var$toUtcDate(date) {
    return (0, $3bdbd550bd19a664$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $1b66b7d2a8db9a3a$var$calcOffset(date, timezoneString) {
    var tokens = (0, $7950e93beecdfa6b$export$2e2bcd8739ae039)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $3bdbd550bd19a664$export$2e2bcd8739ae039)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $1b66b7d2a8db9a3a$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $1b66b7d2a8db9a3a$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $1b66b7d2a8db9a3a$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $1b66b7d2a8db9a3a$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $1b66b7d2a8db9a3a$var$validIANATimezoneCache = {};
function $1b66b7d2a8db9a3a$var$isValidTimezoneIANAString(timeZoneString) {
    if ($1b66b7d2a8db9a3a$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $1b66b7d2a8db9a3a$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


var $5ca1d85728734a20$var$MILLISECONDS_IN_MINUTE = 60000;
var $5ca1d85728734a20$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $5ca1d85728734a20$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $5ca1d85728734a20$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $5ca1d85728734a20$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $5ca1d85728734a20$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $5ca1d85728734a20$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $5ca1d85728734a20$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $5ca1d85728734a20$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $5ca1d85728734a20$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $5ca1d85728734a20$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $5ca1d85728734a20$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $5ca1d85728734a20$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $70ba3223d5637e80$export$2e2bcd8739ae039)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $70ba3223d5637e80$export$2e2bcd8739ae039)('long', date, options);
        }
    }
};
function $5ca1d85728734a20$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $1b66b7d2a8db9a3a$export$2e2bcd8739ae039)(timeZone, originalDate, true) / $5ca1d85728734a20$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $5ca1d85728734a20$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $5ca1d85728734a20$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $5ca1d85728734a20$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $5ca1d85728734a20$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $5ca1d85728734a20$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $5ca1d85728734a20$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $5ca1d85728734a20$var$formatTimezone(offset, dirtyDelimeter);
}
function $5ca1d85728734a20$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $5ca1d85728734a20$var$addLeadingZeros(minutes, 2);
}
var $5ca1d85728734a20$export$2e2bcd8739ae039 = $5ca1d85728734a20$var$formatters;



var $8WZx9 = parcelRequire("8WZx9");

var $kXZ8N = parcelRequire("kXZ8N");

/** Regex to identify the presence of a time zone specifier in a date string */ var $91f36a7f369648f6$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $91f36a7f369648f6$export$2e2bcd8739ae039 = $91f36a7f369648f6$var$tzPattern;


var $00960a1f81ae1cda$var$MILLISECONDS_IN_HOUR = 3600000;
var $00960a1f81ae1cda$var$MILLISECONDS_IN_MINUTE = 60000;
var $00960a1f81ae1cda$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $00960a1f81ae1cda$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $91f36a7f369648f6$export$2e2bcd8739ae039)
};
function $00960a1f81ae1cda$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $00960a1f81ae1cda$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($8WZx9)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $00960a1f81ae1cda$var$splitDateString(argument);
    var parseYearResult = $00960a1f81ae1cda$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $00960a1f81ae1cda$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $00960a1f81ae1cda$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $1b66b7d2a8db9a3a$export$2e2bcd8739ae039)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($kXZ8N)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($kXZ8N)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $00960a1f81ae1cda$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $00960a1f81ae1cda$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $00960a1f81ae1cda$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $00960a1f81ae1cda$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $00960a1f81ae1cda$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $00960a1f81ae1cda$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $00960a1f81ae1cda$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $00960a1f81ae1cda$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $00960a1f81ae1cda$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $00960a1f81ae1cda$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $00960a1f81ae1cda$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$00960a1f81ae1cda$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $00960a1f81ae1cda$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$00960a1f81ae1cda$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $00960a1f81ae1cda$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$00960a1f81ae1cda$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $00960a1f81ae1cda$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$00960a1f81ae1cda$var$validateWeekDate(year, week)) return new Date(NaN);
        return $00960a1f81ae1cda$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $00960a1f81ae1cda$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$00960a1f81ae1cda$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $00960a1f81ae1cda$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $00960a1f81ae1cda$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $00960a1f81ae1cda$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$00960a1f81ae1cda$var$validateTime(hours)) return NaN;
        return hours % 24 * $00960a1f81ae1cda$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $00960a1f81ae1cda$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$00960a1f81ae1cda$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $00960a1f81ae1cda$var$MILLISECONDS_IN_HOUR + minutes * $00960a1f81ae1cda$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $00960a1f81ae1cda$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$00960a1f81ae1cda$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $00960a1f81ae1cda$var$MILLISECONDS_IN_HOUR + minutes * $00960a1f81ae1cda$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $00960a1f81ae1cda$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $00960a1f81ae1cda$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $00960a1f81ae1cda$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $00960a1f81ae1cda$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $00960a1f81ae1cda$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $00960a1f81ae1cda$var$isLeapYearIndex(year);
        if (isLeapYear && date > $00960a1f81ae1cda$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $00960a1f81ae1cda$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $00960a1f81ae1cda$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $00960a1f81ae1cda$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $00960a1f81ae1cda$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $00960a1f81ae1cda$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


var $d44409313a6b8501$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $d44409313a6b8501$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($d44409313a6b8501$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $5ca1d85728734a20$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2252559e2fde9de5$exports)))(dirtyDate, formatStr, options);
}




function $d3fd156832cf6168$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(dirtyDate, options);
    var offsetMilliseconds = (0, $1b66b7d2a8db9a3a$export$2e2bcd8739ae039)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $135a487cc5b2c57a$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($283a85b679154342$exports)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $d44409313a6b8501$export$2e2bcd8739ae039)((0, $d3fd156832cf6168$export$2e2bcd8739ae039)(date, timeZone), formatStr, extendedOptions);
}










function $df7d6df00d41111e$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $91f36a7f369648f6$export$2e2bcd8739ae039))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($283a85b679154342$exports)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(date, extendedOptions);
    }
    var d = (0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(date, options);
    var utc = (0, $3bdbd550bd19a664$export$2e2bcd8739ae039)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $1b66b7d2a8db9a3a$export$2e2bcd8739ae039)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}





var $8MQJ5 = parcelRequire("8MQJ5");
var $fxy8a = parcelRequire("fxy8a");
var $k0Sb0 = parcelRequire("k0Sb0");
var $dCCOX = parcelRequire("dCCOX");

var $fxy8a = parcelRequire("fxy8a");

var $k0Sb0 = parcelRequire("k0Sb0");

var $fhQJu = parcelRequire("fhQJu");

var $cfoI5 = parcelRequire("cfoI5");

var $le96L = parcelRequire("le96L");

var $8zxzx = parcelRequire("8zxzx");

var $6RzIO = parcelRequire("6RzIO");

var $8d3vD = parcelRequire("8d3vD");
function $5910869d63631745$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $6RzIO.default)(2, arguments);
    var date = (0, $le96L.default)(dirtyDate);
    var baseDate = (0, $le96L.default)(dirtyBaseDate);
    var defaultOptions = (0, $dCCOX.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $fhQJu.default);
    var weekStartsOn = (0, $8d3vD.default)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    if (!locale.formatRelative) throw new RangeError('locale must contain formatRelative property');
    var diff = (0, $fxy8a.default)(date, baseDate);
    if (isNaN(diff)) throw new RangeError('Invalid time value');
    var token;
    if (diff < -6) token = 'other';
    else if (diff < -1) token = 'lastWeek';
    else if (diff < 0) token = 'yesterday';
    else if (diff < 1) token = 'today';
    else if (diff < 2) token = 'tomorrow';
    else if (diff < 7) token = 'nextWeek';
    else token = 'other';
    var utcDate = (0, $cfoI5.default)(date, (0, $8zxzx.default)(date));
    var utcBaseDate = (0, $cfoI5.default)(baseDate, (0, $8zxzx.default)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $k0Sb0.default)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}


var $72adecb1b967a90a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $72adecb1b967a90a$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $72adecb1b967a90a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $72adecb1b967a90a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $72adecb1b967a90a$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $72adecb1b967a90a$export$2e2bcd8739ae039 = $72adecb1b967a90a$var$formatDistance;



var $lbh04 = parcelRequire("lbh04");
var $b1cedb195374d3ee$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $b1cedb195374d3ee$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $b1cedb195374d3ee$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $b1cedb195374d3ee$var$formatLong = {
    date: (0, $lbh04.default)({
        formats: $b1cedb195374d3ee$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $lbh04.default)({
        formats: $b1cedb195374d3ee$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $lbh04.default)({
        formats: $b1cedb195374d3ee$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b1cedb195374d3ee$export$2e2bcd8739ae039 = $b1cedb195374d3ee$var$formatLong;


var $ee0816e9546cff89$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $ee0816e9546cff89$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ee0816e9546cff89$var$formatRelativeLocale[token];
};
var $ee0816e9546cff89$export$2e2bcd8739ae039 = $ee0816e9546cff89$var$formatRelative;



var $jZkn4 = parcelRequire("jZkn4");
var $1cef59db4b5d2311$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $1cef59db4b5d2311$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $1cef59db4b5d2311$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $1cef59db4b5d2311$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $1cef59db4b5d2311$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $1cef59db4b5d2311$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $1cef59db4b5d2311$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $1cef59db4b5d2311$var$localize = {
    ordinalNumber: $1cef59db4b5d2311$var$ordinalNumber,
    era: (0, $jZkn4.default)({
        values: $1cef59db4b5d2311$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $jZkn4.default)({
        values: $1cef59db4b5d2311$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $jZkn4.default)({
        values: $1cef59db4b5d2311$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $jZkn4.default)({
        values: $1cef59db4b5d2311$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $jZkn4.default)({
        values: $1cef59db4b5d2311$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1cef59db4b5d2311$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1cef59db4b5d2311$export$2e2bcd8739ae039 = $1cef59db4b5d2311$var$localize;



var $gcy5I = parcelRequire("gcy5I");

var $jChsd = parcelRequire("jChsd");
var $29d779103fe97f21$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $29d779103fe97f21$var$parseOrdinalNumberPattern = /\d+/i;
var $29d779103fe97f21$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $29d779103fe97f21$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $29d779103fe97f21$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $29d779103fe97f21$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29d779103fe97f21$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $29d779103fe97f21$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $29d779103fe97f21$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $29d779103fe97f21$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $29d779103fe97f21$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $29d779103fe97f21$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $29d779103fe97f21$var$match = {
    ordinalNumber: (0, $jChsd.default)({
        matchPattern: $29d779103fe97f21$var$matchOrdinalNumberPattern,
        parsePattern: $29d779103fe97f21$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gcy5I.default)({
        matchPatterns: $29d779103fe97f21$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29d779103fe97f21$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $gcy5I.default)({
        matchPatterns: $29d779103fe97f21$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29d779103fe97f21$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gcy5I.default)({
        matchPatterns: $29d779103fe97f21$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29d779103fe97f21$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $gcy5I.default)({
        matchPatterns: $29d779103fe97f21$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $29d779103fe97f21$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $gcy5I.default)({
        matchPatterns: $29d779103fe97f21$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $29d779103fe97f21$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $29d779103fe97f21$export$2e2bcd8739ae039 = $29d779103fe97f21$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $328fea4f4b85c31f$var$locale = {
    code: 'sv',
    formatDistance: (0, $72adecb1b967a90a$export$2e2bcd8739ae039),
    formatLong: (0, $b1cedb195374d3ee$export$2e2bcd8739ae039),
    formatRelative: (0, $ee0816e9546cff89$export$2e2bcd8739ae039),
    localize: (0, $1cef59db4b5d2311$export$2e2bcd8739ae039),
    match: (0, $29d779103fe97f21$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 4
    }
};
var $328fea4f4b85c31f$export$2e2bcd8739ae039 = $328fea4f4b85c31f$var$locale;





var $igItr = parcelRequire("igItr");
var $hBud4 = parcelRequire("hBud4");
var $kzEvi = parcelRequire("kzEvi");
var $j1vsN = parcelRequire("j1vsN");

const $c94184dfef1a7d71$var$STOCKHOLM_TZ = 'Europe/Stockholm';
const $c94184dfef1a7d71$export$57957ca6633a6742 = (values)=>{
    return !isNaN(values.bookingId) && values.bookingId > 0;
};
const $c94184dfef1a7d71$export$52403c2973de3b69 = (availability)=>{
    if (!availability?.servicesByProvider) return availability;
    const providers = availability.servicesByProvider;
    const statusPriority = {
        AS_REQUESTED: 2,
        DELAYED: 1,
        NOT_AVAILABLE: 0
    };
    const byServiceType = {};
    for (const provider of providers)for (const a of provider.availabilities || []){
        const current = byServiceType[a.serviceType];
        if (!current || statusPriority[a.availableAt] > statusPriority[current.availableAt]) byServiceType[a.serviceType] = {
            ...a,
            vehicleOptions: [
                ...new Set([
                    ...current?.vehicleOptions || [],
                    ...a.vehicleOptions || []
                ])
            ]
        };
        else current.vehicleOptions = [
            ...new Set([
                ...current.vehicleOptions || [],
                ...a.vehicleOptions || []
            ])
        ];
    }
    const priceTypeMap = {};
    for (const provider of providers){
        for (const pt of provider.priceAndPaymentRules?.priceTypes || [])if (!priceTypeMap[pt.type]) priceTypeMap[pt.type] = pt;
    }
    const maxStops = providers.reduce((max, p)=>{
        const n = p.tripRules?.maxAllowedIntermediateStops;
        return n !== undefined ? Math.max(max, n) : max;
    }, availability.tripRules?.maxAllowedIntermediateStops ?? 0);
    const maxLatestPrebook = providers.reduce((max, p)=>{
        const d = p.tripRules?.latestPrebookingDateTime;
        if (!d) return max;
        if (!max) return d;
        return new Date(d) > new Date(max) ? d : max;
    }, availability.tripRules?.latestPrebookingDateTime ?? null);
    const maxEarliestPrebook = providers.reduce((max, p)=>{
        const d = p.tripRules?.earliestPrebookingDateTime;
        if (!d) return max;
        if (!max) return d;
        return new Date(d) > new Date(max) ? d : max;
    }, availability.tripRules?.earliestPrebookingDateTime ?? null);
    // Boolean flags: true if ANY provider requires it (most restrictive wins)
    const requiresDestForPrebook = providers.some((p)=>p.tripRules?.preBookingRequiresDestination === true);
    const requiresDestForDirect = providers.some((p)=>p.tripRules?.directBookingRequiresDestination === true);
    return {
        ...availability,
        availabilities: Object.values(byServiceType),
        priceAndPaymentRules: {
            priceTypes: Object.values(priceTypeMap)
        },
        tripRules: {
            ...availability.tripRules,
            maxAllowedIntermediateStops: maxStops,
            ...maxLatestPrebook ? {
                latestPrebookingDateTime: maxLatestPrebook
            } : {},
            ...maxEarliestPrebook ? {
                earliestPrebookingDateTime: maxEarliestPrebook
            } : {},
            ...requiresDestForPrebook ? {
                preBookingRequiresDestination: true
            } : {},
            ...requiresDestForDirect ? {
                directBookingRequiresDestination: true
            } : {}
        }
    };
};
const $c94184dfef1a7d71$export$e50b5889a6b86caf = (values, fieldPath)=>{
    if (!$c94184dfef1a7d71$export$57957ca6633a6742(values)) return true; // All fields editable in new booking mode
    return values.editableFields?.includes(fieldPath) || false;
};
const $c94184dfef1a7d71$export$45f0d338a0ae68ff = (values)=>{
    // In edit mode, only return options that are editable
    if ($c94184dfef1a7d71$export$57957ca6633a6742(values) && values.editableOptions?.vehicleOptions) return values.editableOptions.vehicleOptions.map((opt)=>opt.vehicleOption);
    const key = values.pickupTime === '' ? 'direct' : 'prebook';
    const type = (values?.autoValues?.serviceType || values?.serviceType) === 'estate' ? 'taxi' : values?.autoValues?.serviceType || values?.serviceType;
    // Always use the normalized availabilities which already union vehicleOptions across all providers
    const availabilities = values.availability?.[key]?.availabilities;
    if (!availabilities || !Array.isArray(availabilities)) return [];
    const options = availabilities.find((item)=>item.serviceType === type)?.vehicleOptions;
    return options !== undefined ? options : [];
};
const $c94184dfef1a7d71$export$165a4cf04149c778 = (values, vehicleOption)=>{
    const key = values.pickupTime === '' ? 'direct' : 'prebook';
    const type = (values?.autoValues?.serviceType || values?.serviceType) === 'estate' ? 'taxi' : values?.autoValues?.serviceType || values?.serviceType;
    // In multi-provider mode, use the selected provider's price if available,
    // otherwise fall back to the highest price across all providers (the option will
    // auto-switch to a provider that charges for it, so show that cost as a hint)
    const servicesByProvider = values.availability?.[key]?.servicesByProvider;
    if (Array.isArray(servicesByProvider) && values.selectedProviderId) {
        const provider = servicesByProvider.find((p)=>p.providerData.providerId === values.selectedProviderId);
        const price = provider?.availabilities?.find((a)=>a.serviceType === type)?.chargeableVehicleOptions?.find((c)=>c.vehicleOption === vehicleOption)?.price;
        if (price !== undefined) return price;
        // Selected provider has no price — return the highest across all providers
        const maxPrice = servicesByProvider.reduce((max, p)=>{
            const p2 = p.availabilities?.find((a)=>a.serviceType === type)?.chargeableVehicleOptions?.find((c)=>c.vehicleOption === vehicleOption)?.price;
            return p2 !== undefined && p2 > max ? p2 : max;
        }, 0);
        return maxPrice;
    }
    const availabilities = values.availability?.[key]?.availabilities;
    if (!availabilities || !Array.isArray(availabilities)) return 0;
    const price = availabilities.find((item)=>item.serviceType === type)?.chargeableVehicleOptions?.find((item)=>item.vehicleOption === vehicleOption)?.price;
    return price !== undefined ? price : 0;
};
const $c94184dfef1a7d71$export$8f69041b6eded98d = (values)=>{
    const key = values.pickupTime === '' ? 'direct' : 'prebook';
    if (values.availability[key] !== false) {
        const a = values.availability[key];
        return a?.tripRules?.maxAllowedIntermediateStops !== undefined ? a.tripRules.maxAllowedIntermediateStops : 0;
    }
    return 0;
};
const $c94184dfef1a7d71$export$a33cf11b13c37ea0 = (values, tag)=>{
    return values.departure?.locationInformation?.filter((info)=>info?.tag === tag)?.length > 0;
};
const $c94184dfef1a7d71$export$e5957f49ec813c50 = (locationInformation, pickupTime, showBothBookingTypes = false)=>{
    if (!locationInformation) return [];
    const hasNewTags = locationInformation.some((item)=>item?.tag === 'DEPARTURE_INFO_PREBOOK' || item?.tag === 'DEPARTURE_INFO_DIRECT');
    // INFO tag is always included regardless of booking type
    const infoItems = locationInformation.filter((item)=>item?.tag === 'INFO');
    if (!hasNewTags) return locationInformation.filter((item)=>[
            'DEPARTURE_INFO',
            'INFO'
        ].includes(item?.tag));
    if (showBothBookingTypes) return [
        ...locationInformation.filter((item)=>item?.tag === 'DEPARTURE_INFO_PREBOOK' || item?.tag === 'DEPARTURE_INFO_DIRECT'),
        ...infoItems
    ];
    const tag = pickupTime ? 'DEPARTURE_INFO_PREBOOK' : 'DEPARTURE_INFO_DIRECT';
    return [
        ...locationInformation.filter((item)=>item?.tag === tag),
        ...infoItems
    ];
};
const $c94184dfef1a7d71$export$25dd954bca15c04f = (values)=>{
    // If we're in SelectTime, we're selecting a future time, so use 'prebook' key
    const key = 'prebook';
    if (values?.availability && values.availability[key] !== false && values.availability[key] !== undefined) {
        const a = values.availability[key];
        if (a?.tripRules?.latestPrebookingDateTime) {
            const latestDateString = a.tripRules.latestPrebookingDateTime;
            // Parse the date string directly to extract just the date part (YYYY-MM-DD)
            // This avoids timezone conversion issues
            const dateMatch = latestDateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
            if (dateMatch) {
                const year = parseInt(dateMatch[1], 10);
                const month = parseInt(dateMatch[2], 10) - 1; // JavaScript months are 0-indexed
                const day = parseInt(dateMatch[3], 10);
                // Create 23:59:59 in Stockholm time for that calendar date
                const endOfDay = (0, $df7d6df00d41111e$export$2e2bcd8739ae039)(new Date(year, month, day, 23, 59, 59, 0), $c94184dfef1a7d71$var$STOCKHOLM_TZ);
                return endOfDay;
            }
            // Fallback: parse the full datetime and extract calendar date in Stockholm timezone
            const latestDate = new Date(latestDateString);
            const stockholmStr = latestDate.toLocaleDateString('sv-SE', {
                timeZone: $c94184dfef1a7d71$var$STOCKHOLM_TZ
            });
            const [y, mo, d] = stockholmStr.split('-').map(Number);
            return (0, $df7d6df00d41111e$export$2e2bcd8739ae039)(new Date(y, mo - 1, d, 23, 59, 59, 0), $c94184dfef1a7d71$var$STOCKHOLM_TZ);
        }
    }
    // Fallback: if availability not loaded yet, use a very far future date to avoid false validation errors
    // The validation will be updated once availability loads
    return (0, $igItr.default)((0, $hBud4.default)((0, $kzEvi.default)((0, $j1vsN.default)(new Date(), 0), 59), 23), 365); // 1 year ahead as safe fallback
};
const $c94184dfef1a7d71$export$282819a3391760b8 = (values, type = false)=>{
    const key = type || (values.pickupTime === '' ? 'direct' : 'prebook');
    return values.availability[key] !== false;
};
const $c94184dfef1a7d71$export$20098f5b816895fe = (values, type = false)=>{
    const key = type || (values.pickupTime === '' ? 'direct' : 'prebook');
    return values.availability[key]?.availabilities?.find((item)=>item.availableAt === 'AS_REQUESTED' || item.availableAt === 'DELAYED') !== undefined;
};
const $c94184dfef1a7d71$export$b33f61cb8ec2f9c = (values, type = false)=>{
    const key = type || (values.pickupTime === '' ? 'direct' : 'prebook');
    return values.availability[key]?.availabilities.find((item)=>item.availableAt === 'DELAYED') !== undefined;
};
const $c94184dfef1a7d71$export$b32ff072b832c976 = (values, type = false)=>{
    const key = type || (values.pickupTime === '' ? 'direct' : 'prebook');
    return values.availability[key]?.availabilities.find((item)=>item.availableAt === 'AS_REQUESTED') !== undefined;
};
// Maps old type names to normalized names used throughout the app
const $c94184dfef1a7d71$var$PRICE_TYPE_ALIASES = {
    FIXED_PRICE: 'FIXED',
    TAXIMETER_PRICE: 'TAXIMETER'
};
const $c94184dfef1a7d71$export$f1b9397fe7b6198c = (pt)=>{
    const type = $c94184dfef1a7d71$var$PRICE_TYPE_ALIASES[pt.type] || pt.type;
    if (pt.paymentMethodConfigurations) {
        const configs = pt.paymentMethodConfigurations.map((c)=>({
                paymentMethod: c.paymentMethod,
                voucherEnabled: c.voucherEnabled === true || c.voucherEnabled === 'true'
            }));
        return {
            ...pt,
            type: type,
            paymentMethods: configs.map((c)=>c.paymentMethod),
            voucherEnabled: configs.some((c)=>c.voucherEnabled),
            paymentMethodConfigurations: configs
        };
    }
    if (pt.paymentMethods) return {
        ...pt,
        type: type,
        paymentMethodConfigurations: pt.paymentMethods.map((method)=>({
                paymentMethod: method,
                voucherEnabled: pt.voucherEnabled === true
            }))
    };
    return {
        ...pt,
        type: type
    };
};
const $c94184dfef1a7d71$export$369f738c5ad4634 = (payment, account)=>{
    if (payment === 'PayInCar') return 'PayInCar';
    if (payment?.startsWith('CreditCard')) return 'CreditCard';
    if (payment?.startsWith('Account')) {
        if (account?.type === 'TSAB') return 'TSABAccount';
        if (account?.type === 'TCA') return 'TravelClearingAccount';
    }
    return null;
};
const $c94184dfef1a7d71$export$d3f4c2863c03c2f9 = (values)=>{
    const isCreditCard = !!values.payment && values.payment.indexOf('CreditCard') !== -1;
    const icon = !values.payment || values.payment === 'DefaultNoSelect' ? 'PayInCar' : values.payment === 'PayInCar' ? 'PayInCar' : values.payment === 'Klarna' ? 'Klarna' : values.payment === 'ApplePay' ? 'ApplePay' : isCreditCard ? `Card${values.account?.cardType}` : 'TSAB';
    const title = values.payment === 'PayInCar' ? (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-pay-in-car') : values.payment === 'Klarna' ? 'Klarna' : values.payment === 'ApplePay' ? 'Apple Pay' : isCreditCard ? values.account?.maskedAccount : values.account?.accountName;
    const subtitle = isCreditCard ? values.account?.cardType : values.account?.accountNumber || null;
    return {
        icon: icon,
        title: title,
        subtitle: subtitle,
        isCreditCard: isCreditCard
    };
};
const $c94184dfef1a7d71$export$9e6e5cf28f33a45e = (voucher)=>{
    if (voucher.valueType == 'AMOUNT') return `${voucher.value}kr`;
    else if (voucher.valueType == 'PERCENTAGE') return `${voucher.value}%`;
    else if (voucher.valueType == 'OPEN_AMOUNT') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('free-trip');
};
const $c94184dfef1a7d71$export$f3066f7c12fa0043 = ()=>[
        {
            value: 'taxi',
            asValue: 'taxi',
            title: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-taxi'),
            info: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-taxi-info'),
            capacity: 4
        },
        {
            value: 'estate',
            asValue: 'taxi',
            title: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-estate'),
            info: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-estate-info'),
            capacity: 4
        },
        {
            value: 'largeCar',
            asValue: 'largeCar',
            title: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-large-car'),
            info: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-large-car-info'),
            capacity: 7
        },
        {
            value: 'business',
            asValue: 'business',
            title: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-business'),
            info: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('cartype-business-info'),
            capacity: 3
        },
        {
            value: 'delivery',
            asValue: 'delivery',
            title: 'Bud',
            info: ''
        }
    ];
const $c94184dfef1a7d71$export$80d7df4f587449e4 = (serviceType)=>{
    return $c94184dfef1a7d71$export$f3066f7c12fa0043().find((c)=>c.value === serviceType);
};
const $c94184dfef1a7d71$export$ee531e92e111dc40 = (priceComponents)=>{
    if (priceComponents === undefined) return false;
    return priceComponents.findIndex((c)=>c.type === 'fixedPrice') !== -1;
};
const $c94184dfef1a7d71$export$d723c02cf6cd4e3 = (prices, serviceType)=>{
    return prices.find((p)=>p.serviceType === serviceType)?.finalPrice;
// ?.priceComponents.find(c => c.type === 'fixedPrice').amount
};
const $c94184dfef1a7d71$export$60d56ed3961c839c = (options)=>{
    if (options === undefined) return [];
    return options.filter((value)=>[
            'pet',
            'low',
            'stationWagon',
            'boosterSeat1',
            'boosterSeat2',
            'rearFacingChildSeat',
            'electric'
        ].includes(value));
};
const $c94184dfef1a7d71$export$c165bf529a45fce1 = (value)=>{
    if (value === 'pet') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-pet-option');
    if (value === 'low') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-low-option');
    if (value === 'stationWagon') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-stationwagon-option');
    if (value === 'boosterSeat1') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-booster-1-option');
    if (value === 'boosterSeat2') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-booster-2-option');
    if (value === 'rearFacingChildSeat') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-childseat-option');
    if (value === 'electric') return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('label-electric-option');
};
const $c94184dfef1a7d71$export$88cbc18f81616dbf = (booking)=>{
    switch(booking.receiptStatus){
        // 100	AVAILABLE
        // 200	PENDING
        case '200':
            return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-receipt-pending');
        // 300	NO_RECEIPT_CANCELLED_ORDER (Cancelled order without upfront payment)
        // 400	NO_RECEIPT_FAILED_ORDER
        // 500	NO_RECEIPT (Since order is not paid by registered credit cards)
        // 600	NO_RECEIPT_TOO_OLD_ORDER
        // 700	NO_RECEIPT_LOST_BOM
        case '300':
        case '400':
        case '500':
        case '600':
        case '700':
            return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-receipt-not-available');
        // 800	NO_RECEIPT_REFUNDED_ORDER
        case '800':
            return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-receipt-refunded');
    }
};
const $c94184dfef1a7d71$export$60eeeada66bc4067 = (value)=>{
    // Different copy depending on count
    const key = 'type-' + value.packageType;
    return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t(key, {
        count: value.count
    });
};
const $c94184dfef1a7d71$export$47c2c83385bd5cef = (booking)=>{
    if (booking.bookingStatus.vehiclePlate !== undefined) {
        if (booking.bookingStatus.eta) return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-car-and-eta', {
            taxi: booking.bookingStatus.vehiclePlate,
            vehicle: `${booking.bookingStatus.vehicleColor} ${booking.bookingStatus.vehicleMake} ${booking.bookingStatus.vehicleModel}`,
            eta: (0, $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1)(new Date(booking.bookingStatus.eta))
        });
        else return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-car', {
            taxi: booking.bookingStatus.vehiclePlate,
            vehicle: `${booking.bookingStatus.vehicleColor} ${booking.bookingStatus.vehicleMake} ${booking.bookingStatus.vehicleModel}`
        });
    }
    return null;
};
const $c94184dfef1a7d71$export$45e40f7bd1bea381 = (booking)=>{
    return [
        120,
        310,
        320
    ].includes(booking?.bookingStatus?.statusCode) && booking?.bookingStatus?.vehiclePlate !== undefined;
};
const $c94184dfef1a7d71$export$4d66b7747958f839 = (booking)=>{
    if (!booking || booking === undefined || booking === null) return false;
    return [
        110,
        120,
        121,
        310,
        320
    ].includes(booking?.bookingStatus?.statusCode);
};
const $c94184dfef1a7d71$export$101b6e7d76ab4fe5 = (booking)=>{
    if (!booking || booking === undefined || booking === null) return false;
    if (!booking.editableUntil) return false;
    // Don't allow editing canceled bookings (status codes: 220=Cancelled, 610=Terminated, 620=TerminatedNoShow)
    if ([
        220,
        610,
        620
    ].includes(booking?.bookingStatus?.statusCode)) return false;
    return new Date(booking.editableUntil) > new Date();
};
const $c94184dfef1a7d71$export$b4300df105f88c53 = (booking)=>{
    return [
        220,
        510,
        610,
        620
    ].includes(booking?.bookingStatus?.statusCode);
};
const $c94184dfef1a7d71$export$32e796a9286f339b = (booking)=>{
    // TODO: This should be replaced
    const COPY = window.COPY;
    // Check if booking and bookingStatus exist to prevent errors during polling
    if (!booking?.bookingStatus?.statusCode) return '-';
    if (booking.bookingStatus.statusCode == 110) return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('status-waiting-for-confirmation');
    // 120 Confirmed
    if (booking.bookingStatus.statusCode == 120 || booking.bookingStatus.statusCode == 121) return booking.bookingType === 'PRE_BOOKING' ? (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('status-pre-booked') : (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('status-searching');
    // 220 Cancelled
    if (booking.bookingStatus.statusCode == 220) return COPY.booking.status_cancelled;
    // 310 Dispatched
    if (booking.bookingStatus.statusCode == 310) return COPY.booking.status_dispatched;
    // 320 AtPickup
    if (booking.bookingStatus.statusCode == 320) return COPY.booking.status_at_pickup;
    // 410 EnRoute
    if (booking.bookingStatus.statusCode == 410) return COPY.booking.status_en_route;
    // 510 Done
    if (booking.bookingStatus.statusCode == 510) return COPY.booking.status_done;
    // 610 Terminated
    if (booking.bookingStatus.statusCode == 610) return COPY.booking.status_cancelled;
    // 620 TerminatedNoShow
    if (booking.bookingStatus.statusCode == 620) return COPY.booking.status_no_show;
    return '-';
};
const $c94184dfef1a7d71$export$705b78797a4b1907 = (booking)=>{
    // Check if booking and bookingStatus exist to prevent errors during polling
    if (!booking?.bookingStatus?.statusCode) return '';
    // 120 Confirmed
    if (booking.bookingStatus.statusCode == 120 || booking.bookingStatus.statusCode == 121) return booking.bookingType === 'PRE_BOOKING' ? 'prebooked' : 'searching';
    // 220 Cancelled / 610 Terminated / 620 TerminatedNoShow
    if (booking.bookingStatus.statusCode == 220 || booking.bookingStatus.statusCode == 610 || booking.bookingStatus.statusCode == 620) return 'cancelled';
    // 310 Dispatched
    if (booking.bookingStatus.statusCode == 310) return 'arriving';
    // 320 AtPickup / 410 EnRoute
    if (booking.bookingStatus.statusCode == 320 || booking.bookingStatus.statusCode == 410) return 'in-car';
    // 510 Done
    if (booking.bookingStatus.statusCode == 510) return 'finished';
};


// Components

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
var $0d0e6f732666edae$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(this && this[arg] || arg);
            else if (Array.isArray(arg)) classes.push(classNames.apply(this, arg));
            else if (argType === 'object') {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(this && this[key] || key);
            }
        }
        return classes.join(' ');
    }
    if ($0d0e6f732666edae$exports) {
        classNames.default = classNames;
        $0d0e6f732666edae$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $3fedcca89ace4432$export$80c2a3957bcb42ea(initialValue) {
    if (initialValue === void 0) initialValue = false;
    var isMounted = (0, $bh6RR.useRef)(initialValue);
    var get = (0, $bh6RR.useCallback)(function() {
        return isMounted.current;
    }, []);
    (0, $bh6RR.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    return get;
}


function $76fff3f0cf23fcb0$export$31ed1f10e45d55c0(initialState) {
    var _a = (0, $bh6RR.useState)(initialState), state = _a[0], setState = _a[1];
    var isMounted = (0, $3fedcca89ace4432$export$80c2a3957bcb42ea)(true);
    return [
        state,
        (0, $bh6RR.useCallback)(function(value) {
            if (isMounted()) setState(value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])
    ];
}


var $12e08c191a152860$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $12e08c191a152860$var$DEFAULT_THRESHOLD = [
    0
];
var $12e08c191a152860$var$DEFAULT_ROOT_MARGIN = '0px';
var $12e08c191a152860$var$observers = new Map();
var $12e08c191a152860$var$getObserverEntry = function(options) {
    var _a;
    var root = (_a = options.root) !== null && _a !== void 0 ? _a : document;
    var rootObservers = $12e08c191a152860$var$observers.get(root);
    if (!rootObservers) {
        rootObservers = new Map();
        $12e08c191a152860$var$observers.set(root, rootObservers);
    }
    var opt = JSON.stringify([
        options.rootMargin,
        options.threshold
    ]);
    var entry = rootObservers.get(opt);
    if (!entry) {
        var callbacks_1 = new Map();
        var observer_1 = new IntersectionObserver(function(entries) {
            return entries.forEach(function(e) {
                var _a;
                return (_a = callbacks_1.get(e.target)) === null || _a === void 0 ? void 0 : _a.forEach(function(cb) {
                    return setTimeout(function() {
                        return cb(e);
                    }, 0);
                });
            });
        }, options);
        entry = {
            observer: observer_1,
            observe: function(target, callback) {
                var cbs = callbacks_1.get(target);
                if (!cbs) {
                    // if target has no observers yet - register it
                    cbs = new Set();
                    callbacks_1.set(target, cbs);
                    observer_1.observe(target);
                }
                // as Set is duplicate-safe - simply add callback on each call
                cbs.add(callback);
            },
            unobserve: function(target, callback) {
                var cbs = callbacks_1.get(target);
                // else branch should never occur in case of normal execution
                // because callbacks map is hidden in closure - it is impossible to
                // simulate situation with non-existent `cbs` Set
                /* istanbul ignore else */ if (cbs) {
                    // remove current observer
                    cbs.delete(callback);
                    if (!cbs.size) {
                        // if no observers left unregister target completely
                        callbacks_1.delete(target);
                        observer_1.unobserve(target);
                        // if not tracked elements left - disconnect observer
                        if (!callbacks_1.size) {
                            observer_1.disconnect();
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            rootObservers.delete(opt);
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            if (!rootObservers.size) $12e08c191a152860$var$observers.delete(root);
                        }
                    }
                }
            }
        };
        rootObservers.set(opt, entry);
    }
    return entry;
};
function $12e08c191a152860$export$a7395f9832c00176(target, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.threshold, threshold = _c === void 0 ? $12e08c191a152860$var$DEFAULT_THRESHOLD : _c, r = _b.root, _d = _b.rootMargin, rootMargin = _d === void 0 ? $12e08c191a152860$var$DEFAULT_ROOT_MARGIN : _d;
    var _e = (0, $76fff3f0cf23fcb0$export$31ed1f10e45d55c0)(), state = _e[0], setState = _e[1];
    (0, $bh6RR.useEffect)(function() {
        var tgt = target && 'current' in target ? target.current : target;
        if (!tgt) return;
        var subscribed = true;
        var observerEntry = $12e08c191a152860$var$getObserverEntry({
            root: r && 'current' in r ? r.current : r,
            rootMargin: rootMargin,
            threshold: threshold
        });
        var handler = function(entry) {
            // it is reinsurance for the highly asynchronous invocations, almost
            // impossible to achieve in tests, thus excluding from LOC
            /* istanbul ignore else */ if (subscribed) setState(entry);
        };
        observerEntry.observe(tgt, handler);
        return function() {
            subscribed = false;
            observerEntry.unobserve(tgt, handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $12e08c191a152860$var$__spreadArray([
        target,
        r,
        rootMargin
    ], threshold, true));
    return state;
}


var $6f98ce5fa2dc1234$exports = {};
/*! js-cookie v3.0.1 | MIT */ (function(global, factory) {
    $6f98ce5fa2dc1234$exports = factory();
})($6f98ce5fa2dc1234$exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
        }
        function get(key) {
            if (typeof document === 'undefined' || arguments.length && !key) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var foundKey = decodeURIComponent(parts[0]);
                    jar[foundKey] = converter.read(value, foundKey);
                    if (key === foundKey) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(key, attributes) {
                set(key, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");
var $8be90def2b6d80b2$export$8793edee2d425525 = function() {};
var $8be90def2b6d80b2$export$4e09c449d6c407f7 = typeof window !== 'undefined' && typeof navigator !== 'undefined' && typeof document !== 'undefined';
var $8be90def2b6d80b2$export$bbcfc742c65abdc2 = function(prev, next) {
    return prev === next;
};
var $8be90def2b6d80b2$export$756d8210573f3cd1 = function(conditions) {
    return conditions.every(Boolean);
};
var $8be90def2b6d80b2$export$861c6d3c5a798b6c = function(conditions) {
    return conditions.some(Boolean);
};


var $ef42d3c0207235e0$var$queriesMap = new Map();
var $ef42d3c0207235e0$var$createQueryEntry = function(query) {
    var mql = matchMedia(query);
    var dispatchers = new Set();
    var listener = function() {
        dispatchers.forEach(function(d) {
            return d(mql.matches);
        });
    };
    if (mql.addEventListener) mql.addEventListener('change', listener, {
        passive: true
    });
    else mql.addListener(listener);
    return {
        mql: mql,
        dispatchers: dispatchers,
        listener: listener
    };
};
var $ef42d3c0207235e0$var$querySubscribe = function(query, setState) {
    var entry = $ef42d3c0207235e0$var$queriesMap.get(query);
    if (!entry) {
        entry = $ef42d3c0207235e0$var$createQueryEntry(query);
        $ef42d3c0207235e0$var$queriesMap.set(query, entry);
    }
    entry.dispatchers.add(setState);
    setState(entry.mql.matches);
};
var $ef42d3c0207235e0$var$queryUnsubscribe = function(query, setState) {
    var entry = $ef42d3c0207235e0$var$queriesMap.get(query);
    // else path is impossible to test in normal situation
    /* istanbul ignore else */ if (entry) {
        var mql = entry.mql, dispatchers = entry.dispatchers, listener = entry.listener;
        dispatchers.delete(setState);
        if (!dispatchers.size) {
            $ef42d3c0207235e0$var$queriesMap.delete(query);
            if (mql.removeEventListener) mql.removeEventListener('change', listener);
            else mql.removeListener(listener);
        }
    }
};
function $ef42d3c0207235e0$export$32d5543ab307c01(query, options) {
    if (options === void 0) options = {};
    var _a = options.initializeWithValue, initializeWithValue = _a === void 0 ? true : _a;
    if (!(0, $8be90def2b6d80b2$export$4e09c449d6c407f7)) initializeWithValue = false;
    var _b = (0, $bh6RR.useState)(function() {
        if (initializeWithValue) {
            var entry = $ef42d3c0207235e0$var$queriesMap.get(query);
            if (!entry) {
                entry = $ef42d3c0207235e0$var$createQueryEntry(query);
                $ef42d3c0207235e0$var$queriesMap.set(query, entry);
            }
            return entry.mql.matches;
        }
    }), state = _b[0], setState = _b[1];
    (0, $bh6RR.useEffect)(function() {
        $ef42d3c0207235e0$var$querySubscribe(query, setState);
        return function() {
            return $ef42d3c0207235e0$var$queryUnsubscribe(query, setState);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    return state;
}








const $3804040dc4640bb3$export$3f6fecd573f3fa48 = ()=>{
    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CLOSE_GLOBAL_MODAL');
};
const $3804040dc4640bb3$export$d7e8d4d4450c819c = (message, buttons, options = {})=>{
    const opts = typeof options === 'boolean' ? {
        isWide: options
    } : options;
    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_GLOBAL_MODAL', {
        message: message,
        buttons: buttons || [],
        type: 'modal',
        ...opts
    });
};
const $3804040dc4640bb3$export$ca5dd0f8f0ed3310 = (title, message, buttons)=>{
    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_GLOBAL_MODAL', {
        title: title,
        message: message,
        buttons: buttons || [],
        type: 'information'
    });
};
const $3804040dc4640bb3$export$e1df0da8f8fc570c = (render)=>{
    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_GLOBAL_CONTENT_MODAL', render);
};


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=199-4806

var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");

var $0014bad5f179b3c3$exports = {};
/**
 * marked v18.0.0 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    $0014bad5f179b3c3$exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : $0014bad5f179b3c3$exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var G = Object.defineProperty;
    var Te = Object.getOwnPropertyDescriptor;
    var Oe = Object.getOwnPropertyNames;
    var we = Object.prototype.hasOwnProperty;
    var ye = (l, e)=>{
        for(var t in e)G(l, t, {
            get: e[t],
            enumerable: !0
        });
    }, Pe = (l, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let r of Oe(e))!we.call(l, r) && r !== t && G(l, r, {
            get: ()=>e[r],
            enumerable: !(n = Te(e, r)) || n.enumerable
        });
        return l;
    };
    var Se = (l)=>Pe(G({}, "__esModule", {
            value: !0
        }), l);
    var bt = {};
    ye(bt, {
        Hooks: ()=>P,
        Lexer: ()=>x,
        Marked: ()=>A,
        Parser: ()=>b,
        Renderer: ()=>y,
        TextRenderer: ()=>S,
        Tokenizer: ()=>w,
        defaults: ()=>R,
        getDefaults: ()=>_,
        lexer: ()=>xt,
        marked: ()=>g,
        options: ()=>ct,
        parse: ()=>ft,
        parseInline: ()=>gt,
        parser: ()=>mt,
        setOptions: ()=>ht,
        use: ()=>kt,
        walkTokens: ()=>dt
    });
    module1.exports = Se(bt);
    function _() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var R = _();
    function N(l) {
        R = l;
    }
    var M = {
        exec: ()=>null
    };
    function k(l, e = "") {
        let t = typeof l == "string" ? l : l.source, n = {
            replace: (r, i)=>{
                let s = typeof i == "string" ? i : i.source;
                return s = s.replace(m.caret, "$1"), t = t.replace(r, s), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var $e = (()=>{
        try {
            return new RegExp("(?<=1)(?<!1)"), true;
        } catch  {
            return !1;
        }
    })(), m = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (l)=>new RegExp(`^( {0,3}${l})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}#`),
        htmlBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}<(?:[a-z].*>|!--)`, "i"),
        blockquoteBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}>`)
    }, Le = /^(?:[ \t]*(?:\n|$))+/, _e = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Me = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, B = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, ze = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, j = / {0,3}(?:[*+-]|\d{1,9}[.)])/, oe = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, ae = k(oe).replace(/bull/g, j).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), Ee = k(oe).replace(/bull/g, j).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), F = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Ie = /^[^\n]+/, U = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, Ae = k(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", U).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ce = k(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, j).getRegex(), v = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", K = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Be = k("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", K).replace("tag", v).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), le = k(F).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), De = k(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", le).getRegex(), W = {
        blockquote: De,
        code: _e,
        def: Ae,
        fences: Me,
        heading: ze,
        hr: B,
        html: Be,
        lheading: ae,
        list: Ce,
        newline: Le,
        paragraph: le,
        table: M,
        text: Ie
    }, se = k("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), qe = {
        ...W,
        lheading: Ee,
        table: se,
        paragraph: k(F).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", se).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex()
    }, ve = {
        ...W,
        html: k(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", K).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: M,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: k(F).replace("hr", B).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", ae).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, He = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, Ze = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, ue = /^( {2,}|\\)\n(?!\s*$)/, Ge = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, E = /[\p{P}\p{S}]/u, H = /[\s\p{P}\p{S}]/u, X = /[^\s\p{P}\p{S}]/u, Ne = k(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, H).getRegex(), pe = /(?!~)[\p{P}\p{S}]/u, Qe = /(?!~)[\s\p{P}\p{S}]/u, je = /(?:[^\s\p{P}\p{S}]|~)/u, Fe = k(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", $e ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), ce = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, Ue = k(ce, "u").replace(/punct/g, E).getRegex(), Ke = k(ce, "u").replace(/punct/g, pe).getRegex(), he = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", We = k(he, "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, E).getRegex(), Xe = k(he, "gu").replace(/notPunctSpace/g, je).replace(/punctSpace/g, Qe).replace(/punct/g, pe).getRegex(), Je = k("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, E).getRegex(), Ve = k(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, E).getRegex(), Ye = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", et = k(Ye, "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, E).getRegex(), tt = k(/\\(punct)/, "gu").replace(/punct/g, E).getRegex(), nt = k(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), rt = k(K).replace("(?:-->|$)", "-->").getRegex(), st = k("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", rt).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), q = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, it = k(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", q).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), ke = k(/^!?\[(label)\]\[(ref)\]/).replace("label", q).replace("ref", U).getRegex(), de = k(/^!?\[(ref)\](?:\[\])?/).replace("ref", U).getRegex(), ot = k("reflink|nolink(?!\\()", "g").replace("reflink", ke).replace("nolink", de).getRegex(), ie = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, J = {
        _backpedal: M,
        anyPunctuation: tt,
        autolink: nt,
        blockSkip: Fe,
        br: ue,
        code: Ze,
        del: M,
        delLDelim: M,
        delRDelim: M,
        emStrongLDelim: Ue,
        emStrongRDelimAst: We,
        emStrongRDelimUnd: Je,
        escape: He,
        link: it,
        nolink: de,
        punctuation: Ne,
        reflink: ke,
        reflinkSearch: ot,
        tag: st,
        text: Ge,
        url: M
    }, at = {
        ...J,
        link: k(/^!?\[(label)\]\((.*?)\)/).replace("label", q).getRegex(),
        reflink: k(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", q).getRegex()
    }, Q = {
        ...J,
        emStrongRDelimAst: Xe,
        emStrongLDelim: Ke,
        delLDelim: Ve,
        delRDelim: et,
        url: k(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", ie).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: k(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", ie).getRegex()
    }, lt = {
        ...Q,
        br: k(ue).replace("{2,}", "*").getRegex(),
        text: k(Q.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, D = {
        normal: W,
        gfm: qe,
        pedantic: ve
    }, I = {
        normal: J,
        gfm: Q,
        breaks: lt,
        pedantic: at
    };
    var ut = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, ge = (l)=>ut[l];
    function O(l, e) {
        if (e) {
            if (m.escapeTest.test(l)) return l.replace(m.escapeReplace, ge);
        } else if (m.escapeTestNoEncode.test(l)) return l.replace(m.escapeReplaceNoEncode, ge);
        return l;
    }
    function V(l) {
        try {
            l = encodeURI(l).replace(m.percentDecode, "%");
        } catch  {
            return null;
        }
        return l;
    }
    function Y(l, e) {
        let t = l.replace(m.findPipe, (i, s, a)=>{
            let o = !1, u = s;
            for(; --u >= 0 && a[u] === "\\";)o = !o;
            return o ? "|" : " |";
        }), n = t.split(m.splitPipe), r = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; r < n.length; r++)n[r] = n[r].trim().replace(m.slashPipe, "|");
        return n;
    }
    function L(l, e, t) {
        let n = l.length;
        if (n === 0) return "";
        let r = 0;
        for(; r < n;){
            let i = l.charAt(n - r - 1);
            if (i === e && !t) r++;
            else if (i !== e && t) r++;
            else break;
        }
        return l.slice(0, n - r);
    }
    function ee(l) {
        let e = l.split(`
`), t = e.length - 1;
        for(; t >= 0 && !e[t].trim();)t--;
        return e.length - t <= 2 ? l : e.slice(0, t + 1).join(`
`);
    }
    function fe(l, e) {
        if (l.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < l.length; n++)if (l[n] === "\\") n++;
        else if (l[n] === e[0]) t++;
        else if (l[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function me(l, e = 0) {
        let t = e, n = "";
        for (let r of l)if (r === "	") {
            let i = 4 - t % 4;
            n += " ".repeat(i), t += i;
        } else n += r, t++;
        return n;
    }
    function xe(l, e, t, n, r) {
        let i = e.href, s = e.title || null, a = l[1].replace(r.other.outputLinkReplace, "$1");
        n.state.inLink = !0;
        let o = {
            type: l[0].charAt(0) === "!" ? "image" : "link",
            raw: t,
            href: i,
            title: s,
            text: a,
            tokens: n.inlineTokens(a)
        };
        return n.state.inLink = !1, o;
    }
    function pt(l, e, t) {
        let n = l.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let r = n[1];
        return e.split(`
`).map((i)=>{
            let s = i.match(t.other.beginningSpace);
            if (s === null) return i;
            let [a] = s;
            return a.length >= r.length ? i.slice(r.length) : i;
        }).join(`
`);
    }
    var w = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || R;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = this.options.pedantic ? t[0] : ee(t[0]), r = n.replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: n,
                    codeBlockStyle: "indented",
                    text: r
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], r = pt(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: r
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let r = L(n, "#");
                    (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (n = r.trim());
                }
                return {
                    type: "heading",
                    raw: L(t[0], `
`),
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: L(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = L(t[0], `
`).split(`
`), r = "", i = "", s = [];
                for(; n.length > 0;){
                    let a = !1, o = [], u;
                    for(u = 0; u < n.length; u++)if (this.rules.other.blockquoteStart.test(n[u])) o.push(n[u]), a = !0;
                    else if (!a) o.push(n[u]);
                    else break;
                    n = n.slice(u);
                    let p = o.join(`
`), c = p.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    r = r ? `${r}
${p}` : p, i = i ? `${i}
${c}` : c;
                    let d = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(c, s, !0), this.lexer.state.top = d, n.length === 0) break;
                    let h = s.at(-1);
                    if (h?.type === "code") break;
                    if (h?.type === "blockquote") {
                        let T = h, f = T.raw + `
` + n.join(`
`), $ = this.blockquote(f);
                        s[s.length - 1] = $, r = r.substring(0, r.length - T.raw.length) + $.raw, i = i.substring(0, i.length - T.text.length) + $.text;
                        break;
                    } else if (h?.type === "list") {
                        let T = h, f = T.raw + `
` + n.join(`
`), $ = this.list(f);
                        s[s.length - 1] = $, r = r.substring(0, r.length - h.raw.length) + $.raw, i = i.substring(0, i.length - T.raw.length) + $.raw, n = f.substring(s.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: r,
                    tokens: s,
                    text: i
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), r = n.length > 1, i = {
                    type: "list",
                    raw: "",
                    ordered: r,
                    start: r ? +n.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
                let s = this.rules.other.listItemRegex(n), a = !1;
                for(; e;){
                    let u = !1, p = "", c = "";
                    if (!(t = s.exec(e)) || this.rules.block.hr.test(e)) break;
                    p = t[0], e = e.substring(p.length);
                    let d = me(t[2].split(`
`, 1)[0], t[1].length), h = e.split(`
`, 1)[0], T = !d.trim(), f = 0;
                    if (this.options.pedantic ? (f = 2, c = d.trimStart()) : T ? f = t[1].length + 1 : (f = d.search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, c = d.slice(f), f += t[1].length), T && this.rules.other.blankLine.test(h) && (p += h + `
`, e = e.substring(h.length + 1), u = !0), !u) {
                        let $ = this.rules.other.nextBulletRegex(f), te = this.rules.other.hrRegex(f), ne = this.rules.other.fencesBeginRegex(f), re = this.rules.other.headingBeginRegex(f), be = this.rules.other.htmlBeginRegex(f), Re = this.rules.other.blockquoteBeginRegex(f);
                        for(; e;){
                            let Z = e.split(`
`, 1)[0], C;
                            if (h = Z, this.options.pedantic ? (h = h.replace(this.rules.other.listReplaceNesting, "  "), C = h) : C = h.replace(this.rules.other.tabCharGlobal, "    "), ne.test(h) || re.test(h) || be.test(h) || Re.test(h) || $.test(h) || te.test(h)) break;
                            if (C.search(this.rules.other.nonSpaceChar) >= f || !h.trim()) c += `
` + C.slice(f);
                            else {
                                if (T || d.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || ne.test(d) || re.test(d) || te.test(d)) break;
                                c += `
` + h;
                            }
                            T = !h.trim(), p += Z + `
`, e = e.substring(Z.length + 1), d = C.slice(f);
                        }
                    }
                    i.loose || (a ? i.loose = !0 : this.rules.other.doubleBlankLine.test(p) && (a = !0)), i.items.push({
                        type: "list_item",
                        raw: p,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(c),
                        loose: !1,
                        text: c,
                        tokens: []
                    }), i.raw += p;
                }
                let o = i.items.at(-1);
                if (o) o.raw = o.raw.trimEnd(), o.text = o.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for (let u of i.items){
                    if (this.lexer.state.top = !1, u.tokens = this.lexer.blockTokens(u.text, []), u.task) {
                        if (u.text = u.text.replace(this.rules.other.listReplaceTask, ""), u.tokens[0]?.type === "text" || u.tokens[0]?.type === "paragraph") {
                            u.tokens[0].raw = u.tokens[0].raw.replace(this.rules.other.listReplaceTask, ""), u.tokens[0].text = u.tokens[0].text.replace(this.rules.other.listReplaceTask, "");
                            for(let c = this.lexer.inlineQueue.length - 1; c >= 0; c--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[c].src)) {
                                this.lexer.inlineQueue[c].src = this.lexer.inlineQueue[c].src.replace(this.rules.other.listReplaceTask, "");
                                break;
                            }
                        }
                        let p = this.rules.other.listTaskCheckbox.exec(u.raw);
                        if (p) {
                            let c = {
                                type: "checkbox",
                                raw: p[0] + " ",
                                checked: p[0] !== "[ ]"
                            };
                            u.checked = c.checked, i.loose ? u.tokens[0] && [
                                "paragraph",
                                "text"
                            ].includes(u.tokens[0].type) && "tokens" in u.tokens[0] && u.tokens[0].tokens ? (u.tokens[0].raw = c.raw + u.tokens[0].raw, u.tokens[0].text = c.raw + u.tokens[0].text, u.tokens[0].tokens.unshift(c)) : u.tokens.unshift({
                                type: "paragraph",
                                raw: c.raw,
                                text: c.raw,
                                tokens: [
                                    c
                                ]
                            }) : u.tokens.unshift(c);
                        }
                    }
                    if (!i.loose) {
                        let p = u.tokens.filter((d)=>d.type === "space"), c = p.length > 0 && p.some((d)=>this.rules.other.anyLine.test(d.raw));
                        i.loose = c;
                    }
                }
                if (i.loose) for (let u of i.items){
                    u.loose = !0;
                    for (let p of u.tokens)p.type === "text" && (p.type = "paragraph");
                }
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) {
                let n = ee(t[0]);
                return {
                    type: "html",
                    block: !0,
                    raw: n,
                    pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                    text: n
                };
            }
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: L(t[0], `
`),
                    href: r,
                    title: i
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = Y(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], s = {
                type: "table",
                raw: L(t[0], `
`),
                header: [],
                align: [],
                rows: []
            };
            if (n.length === r.length) {
                for (let a of r)this.rules.other.tableAlignRight.test(a) ? s.align.push("right") : this.rules.other.tableAlignCenter.test(a) ? s.align.push("center") : this.rules.other.tableAlignLeft.test(a) ? s.align.push("left") : s.align.push(null);
                for(let a = 0; a < n.length; a++)s.header.push({
                    text: n[a],
                    tokens: this.lexer.inline(n[a]),
                    header: !0,
                    align: s.align[a]
                });
                for (let a of i)s.rows.push(Y(a, s.header.length).map((o, u)=>({
                        text: o,
                        tokens: this.lexer.inline(o),
                        header: !1,
                        align: s.align[u]
                    })));
                return s;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let n = t[1].trim();
                return {
                    type: "heading",
                    raw: L(t[0], `
`),
                    depth: t[2].charAt(0) === "=" ? 1 : 2,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                    if (!this.rules.other.endAngleBracket.test(n)) return;
                    let s = L(n.slice(0, -1), "\\");
                    if ((n.length - s.length) % 2 === 0) return;
                } else {
                    let s = fe(t[2], "()");
                    if (s === -2) return;
                    if (s > -1) {
                        let o = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                        t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, o).trim(), t[3] = "";
                    }
                }
                let r = t[2], i = "";
                if (this.options.pedantic) {
                    let s = this.rules.other.pedanticHrefTitle.exec(r);
                    s && (r = s[1], i = s[3]);
                } else i = t[3] ? t[3].slice(1, -1) : "";
                return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? r = r.slice(1) : r = r.slice(1, -1)), xe(t, {
                    href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[r.toLowerCase()];
                if (!i) {
                    let s = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: s,
                        text: s
                    };
                }
                return xe(n, i, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let r = this.rules.inline.emStrongLDelim.exec(e);
            if (!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(r[1] || r[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let s = [
                    ...r[0]
                ].length - 1, a, o, u = s, p = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = c.exec(t)) !== null;){
                    if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a) continue;
                    if (o = [
                        ...a
                    ].length, r[3] || r[4]) {
                        u += o;
                        continue;
                    } else if ((r[5] || r[6]) && s % 3 && !((s + o) % 3)) {
                        p += o;
                        continue;
                    }
                    if (u -= o, u > 0) continue;
                    o = Math.min(o, o + u + p);
                    let d = [
                        ...r[0]
                    ][0].length, h = e.slice(0, s + r.index + d + o);
                    if (Math.min(s, o) % 2) {
                        let f = h.slice(1, -1);
                        return {
                            type: "em",
                            raw: h,
                            text: f,
                            tokens: this.lexer.inlineTokens(f)
                        };
                    }
                    let T = h.slice(2, -2);
                    return {
                        type: "strong",
                        raw: h,
                        text: T,
                        tokens: this.lexer.inlineTokens(T)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), r = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return r && i && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e, t, n = "") {
            let r = this.rules.inline.delLDelim.exec(e);
            if (!r) return;
            if (!(r[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let s = [
                    ...r[0]
                ].length - 1, a, o, u = s, p = this.rules.inline.delRDelim;
                for(p.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = p.exec(t)) !== null;){
                    if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a || (o = [
                        ...a
                    ].length, o !== s)) continue;
                    if (r[3] || r[4]) {
                        u += o;
                        continue;
                    }
                    if (u -= o, u > 0) continue;
                    o = Math.min(o, o + u);
                    let c = [
                        ...r[0]
                    ][0].length, d = e.slice(0, s + r.index + c + o), h = d.slice(s, -s);
                    return {
                        type: "del",
                        raw: d,
                        text: h,
                        tokens: this.lexer.inlineTokens(h)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, r;
                return t[2] === "@" ? (n = t[1], r = "mailto:" + n) : (n = t[1], r = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, r;
                if (t[2] === "@") n = t[0], r = "mailto:" + n;
                else {
                    let i;
                    do i = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (i !== t[0]);
                    n = t[0], t[1] === "www." ? r = "http://" + t[0] : r = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: t[0],
                    escaped: n
                };
            }
        }
    };
    var x = class l {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || R, this.options.tokenizer = this.options.tokenizer || new w, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: m,
                block: D.normal,
                inline: I.normal
            };
            this.options.pedantic ? (t.block = D.pedantic, t.inline = I.pedantic) : this.options.gfm && (t.block = D.gfm, this.options.breaks ? t.inline = I.breaks : t.inline = I.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: D,
                inline: I
            };
        }
        static lex(e, t) {
            return new l(t).lex(e);
        }
        static lexInline(e, t) {
            return new l(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(m.tabCharGlobal, "    ").replace(m.spaceLine, "")); e;){
                let r;
                if (this.options.extensions?.block?.some((s)=>(r = s.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let s = 1 / 0, a = e.slice(1), o;
                    this.options.extensions.startBlock.forEach((u)=>{
                        o = u.call({
                            lexer: this
                        }, a), typeof o == "number" && o >= 0 && (s = Math.min(s, o));
                    }), s < 1 / 0 && s >= 0 && (i = e.substring(0, s + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let s = t.at(-1);
                    n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let s = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(s);
                        break;
                    } else throw new Error(s);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = e, r = null;
            if (this.tokens.links) {
                let o = Object.keys(this.tokens.links);
                if (o.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) !== null;)o.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) !== null;)n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let i;
            for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) !== null;)i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let s = !1, a = "";
            for(; e;){
                s || (a = ""), s = !1;
                let o;
                if (this.options.extensions?.inline?.some((p)=>(o = p.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
                if (o = this.tokenizer.escape(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.tag(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.link(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(o.raw.length);
                    let p = t.at(-1);
                    o.type === "text" && p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                    continue;
                }
                if (o = this.tokenizer.emStrong(e, n, a)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.codespan(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.br(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.del(e, n, a)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.autolink(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (!this.state.inLink && (o = this.tokenizer.url(e))) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                let u = e;
                if (this.options.extensions?.startInline) {
                    let p = 1 / 0, c = e.slice(1), d;
                    this.options.extensions.startInline.forEach((h)=>{
                        d = h.call({
                            lexer: this
                        }, c), typeof d == "number" && d >= 0 && (p = Math.min(p, d));
                    }), p < 1 / 0 && p >= 0 && (u = e.substring(0, p + 1));
                }
                if (o = this.tokenizer.inlineText(u)) {
                    e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (a = o.raw.slice(-1)), s = !0;
                    let p = t.at(-1);
                    p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                    continue;
                }
                if (e) {
                    let p = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(p);
                        break;
                    } else throw new Error(p);
                }
            }
            return t;
        }
    };
    var y = class {
        options;
        parser;
        constructor(e){
            this.options = e || R;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let r = (t || "").match(m.notSpaceStart)?.[0], i = e.replace(m.endingNewline, "") + `
`;
            return r ? '<pre><code class="language-' + O(r) + '">' + (n ? i : O(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : O(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, r = "";
            for(let a = 0; a < e.items.length; a++){
                let o = e.items[a];
                r += this.listitem(o);
            }
            let i = t ? "ol" : "ul", s = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + i + s + `>
` + r + "</" + i + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let i = 0; i < e.header.length; i++)n += this.tablecell(e.header[i]);
            t += this.tablerow({
                text: n
            });
            let r = "";
            for(let i = 0; i < e.rows.length; i++){
                let s = e.rows[i];
                n = "";
                for(let a = 0; a < s.length; a++)n += this.tablecell(s[a]);
                r += this.tablerow({
                    text: n
                });
            }
            return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${O(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let r = this.parser.parseInline(n), i = V(e);
            if (i === null) return r;
            e = i;
            let s = '<a href="' + e + '"';
            return t && (s += ' title="' + O(t) + '"'), s += ">" + r + "</a>", s;
        }
        image({ href: e, title: t, text: n, tokens: r }) {
            r && (n = this.parser.parseInline(r, this.parser.textRenderer));
            let i = V(e);
            if (i === null) return O(n);
            e = i;
            let s = `<img src="${e}" alt="${O(n)}"`;
            return t && (s += ` title="${O(t)}"`), s += ">", s;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : O(e.text);
        }
    };
    var S = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
        checkbox({ raw: e }) {
            return e;
        }
    };
    var b = class l {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || R, this.options.renderer = this.options.renderer || new y, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new S;
        }
        static parse(e, t) {
            return new l(t).parse(e);
        }
        static parseInline(e, t) {
            return new l(t).parseInline(e);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = "";
            for(let n = 0; n < e.length; n++){
                let r = e[n];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let s = r, a = this.options.extensions.renderers[s.type].call({
                        parser: this
                    }, s);
                    if (a !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(s.type)) {
                        t += a || "";
                        continue;
                    }
                }
                let i = r;
                switch(i.type){
                    case "space":
                        t += this.renderer.space(i);
                        break;
                    case "hr":
                        t += this.renderer.hr(i);
                        break;
                    case "heading":
                        t += this.renderer.heading(i);
                        break;
                    case "code":
                        t += this.renderer.code(i);
                        break;
                    case "table":
                        t += this.renderer.table(i);
                        break;
                    case "blockquote":
                        t += this.renderer.blockquote(i);
                        break;
                    case "list":
                        t += this.renderer.list(i);
                        break;
                    case "checkbox":
                        t += this.renderer.checkbox(i);
                        break;
                    case "html":
                        t += this.renderer.html(i);
                        break;
                    case "def":
                        t += this.renderer.def(i);
                        break;
                    case "paragraph":
                        t += this.renderer.paragraph(i);
                        break;
                    case "text":
                        t += this.renderer.text(i);
                        break;
                    default:
                        {
                            let s = 'Token with "' + i.type + '" type was not found.';
                            if (this.options.silent) return console.error(s), "";
                            throw new Error(s);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = "";
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let a = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (a !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(i.type)) {
                        n += a || "";
                        continue;
                    }
                }
                let s = i;
                switch(s.type){
                    case "escape":
                        n += t.text(s);
                        break;
                    case "html":
                        n += t.html(s);
                        break;
                    case "link":
                        n += t.link(s);
                        break;
                    case "image":
                        n += t.image(s);
                        break;
                    case "checkbox":
                        n += t.checkbox(s);
                        break;
                    case "strong":
                        n += t.strong(s);
                        break;
                    case "em":
                        n += t.em(s);
                        break;
                    case "codespan":
                        n += t.codespan(s);
                        break;
                    case "br":
                        n += t.br(s);
                        break;
                    case "del":
                        n += t.del(s);
                        break;
                    case "text":
                        n += t.text(s);
                        break;
                    default:
                        {
                            let a = 'Token with "' + s.type + '" type was not found.';
                            if (this.options.silent) return console.error(a), "";
                            throw new Error(a);
                        }
                }
            }
            return n;
        }
    };
    var P = class {
        options;
        block;
        constructor(e){
            this.options = e || R;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens",
            "emStrongMask"
        ]);
        static passThroughHooksRespectAsync = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer(e = this.block) {
            return e ? x.lex : x.lexInline;
        }
        provideParser(e = this.block) {
            return e ? b.parse : b.parseInline;
        }
    };
    var A = class {
        defaults = _();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = b;
        Renderer = y;
        TextRenderer = S;
        Lexer = x;
        Tokenizer = w;
        Hooks = P;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
                case "table":
                    {
                        let i = r;
                        for (let s of i.header)n = n.concat(this.walkTokens(s.tokens, t));
                        for (let s of i.rows)for (let a of s)n = n.concat(this.walkTokens(a.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let i = r;
                        n = n.concat(this.walkTokens(i.items, t));
                        break;
                    }
                default:
                    {
                        let i = r;
                        this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((s)=>{
                            let a = i[s].flat(1 / 0);
                            n = n.concat(this.walkTokens(a, t));
                        }) : i.tokens && (n = n.concat(this.walkTokens(i.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let r = {
                    ...n
                };
                if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i)=>{
                    if (!i.name) throw new Error("extension name required");
                    if ("renderer" in i) {
                        let s = t.renderers[i.name];
                        s ? t.renderers[i.name] = function(...a) {
                            let o = i.renderer.apply(this, a);
                            return o === !1 && (o = s.apply(this, a)), o;
                        } : t.renderers[i.name] = i.renderer;
                    }
                    if ("tokenizer" in i) {
                        if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let s = t[i.level];
                        s ? s.unshift(i.tokenizer) : t[i.level] = [
                            i.tokenizer
                        ], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [
                            i.start
                        ] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [
                            i.start
                        ]));
                    }
                    "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
                }), r.extensions = t), n.renderer) {
                    let i = this.defaults.renderer || new y(this.defaults);
                    for(let s in n.renderer){
                        if (!(s in i)) throw new Error(`renderer '${s}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(s)) continue;
                        let a = s, o = n.renderer[a], u = i[a];
                        i[a] = (...p)=>{
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c || "";
                        };
                    }
                    r.renderer = i;
                }
                if (n.tokenizer) {
                    let i = this.defaults.tokenizer || new w(this.defaults);
                    for(let s in n.tokenizer){
                        if (!(s in i)) throw new Error(`tokenizer '${s}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(s)) continue;
                        let a = s, o = n.tokenizer[a], u = i[a];
                        i[a] = (...p)=>{
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.tokenizer = i;
                }
                if (n.hooks) {
                    let i = this.defaults.hooks || new P;
                    for(let s in n.hooks){
                        if (!(s in i)) throw new Error(`hook '${s}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(s)) continue;
                        let a = s, o = n.hooks[a], u = i[a];
                        P.passThroughHooks.has(s) ? i[a] = (p)=>{
                            if (this.defaults.async && P.passThroughHooksRespectAsync.has(s)) return (async ()=>{
                                let d = await o.call(i, p);
                                return u.call(i, d);
                            })();
                            let c = o.call(i, p);
                            return u.call(i, c);
                        } : i[a] = (...p)=>{
                            if (this.defaults.async) return (async ()=>{
                                let d = await o.apply(i, p);
                                return d === !1 && (d = await u.apply(i, p)), d;
                            })();
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.hooks = i;
                }
                if (n.walkTokens) {
                    let i = this.defaults.walkTokens, s = n.walkTokens;
                    r.walkTokens = function(a) {
                        let o = [];
                        return o.push(s.call(this, a)), i && (o = o.concat(i.call(this, a))), o;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...r
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return x.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return b.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, r)=>{
                let i = {
                    ...r
                }, s = {
                    ...this.defaults,
                    ...i
                }, a = this.onError(!!s.silent, !!s.async);
                if (this.defaults.async === !0 && i.async === !1) return a(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return a(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return a(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                if (s.hooks && (s.hooks.options = s, s.hooks.block = e), s.async) return (async ()=>{
                    let o = s.hooks ? await s.hooks.preprocess(n) : n, p = await (s.hooks ? await s.hooks.provideLexer(e) : e ? x.lex : x.lexInline)(o, s), c = s.hooks ? await s.hooks.processAllTokens(p) : p;
                    s.walkTokens && await Promise.all(this.walkTokens(c, s.walkTokens));
                    let h = await (s.hooks ? await s.hooks.provideParser(e) : e ? b.parse : b.parseInline)(c, s);
                    return s.hooks ? await s.hooks.postprocess(h) : h;
                })().catch(a);
                try {
                    s.hooks && (n = s.hooks.preprocess(n));
                    let u = (s.hooks ? s.hooks.provideLexer(e) : e ? x.lex : x.lexInline)(n, s);
                    s.hooks && (u = s.hooks.processAllTokens(u)), s.walkTokens && this.walkTokens(u, s.walkTokens);
                    let c = (s.hooks ? s.hooks.provideParser(e) : e ? b.parse : b.parseInline)(u, s);
                    return s.hooks && (c = s.hooks.postprocess(c)), c;
                } catch (o) {
                    return a(o);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let r = "<p>An error occurred:</p><pre>" + O(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(r) : r;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var z = new A;
    function g(l, e) {
        return z.parse(l, e);
    }
    g.options = g.setOptions = function(l) {
        return z.setOptions(l), g.defaults = z.defaults, N(g.defaults), g;
    };
    g.getDefaults = _;
    g.defaults = R;
    g.use = function(...l) {
        return z.use(...l), g.defaults = z.defaults, N(g.defaults), g;
    };
    g.walkTokens = function(l, e) {
        return z.walkTokens(l, e);
    };
    g.parseInline = z.parseInline;
    g.Parser = b;
    g.parser = b.parse;
    g.Renderer = y;
    g.TextRenderer = S;
    g.Lexer = x;
    g.lexer = x.lex;
    g.Tokenizer = w;
    g.Hooks = P;
    g.parse = g;
    var ct = g.options, ht = g.setOptions, kt = g.use, dt = g.walkTokens, gt = g.parseInline, ft = g, mt = b.parse, xt = x.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});




// Dedicated Marked instance with notification modal styling from Figma
// node: NEW-TSAB-Shared-Customer-Library / 4480-3533
const $b599ddbdca2685a0$var$notifMarked = new (0, $0014bad5f179b3c3$exports.Marked)({
    breaks: true,
    renderer: {
        heading ({ tokens: tokens, depth: depth }) {
            const content = this.parser.parseInline(tokens);
            if (depth === 1) return `<p style="font-size:16px;font-weight:600;text-transform:uppercase;font-stretch:condensed;line-height:normal;color:#17181a;padding-bottom:8px;">${content}</p>`;
            return `<p style="font-size:16px;font-weight:600;font-stretch:condensed;line-height:24px;letter-spacing:0.32px;text-transform:uppercase;color:#17181a;padding-top:12px;padding-bottom:4px;">${content}</p>`;
        },
        paragraph ({ tokens: tokens }) {
            const content = this.parser.parseInline(tokens);
            return `<p style="font-size:15px;font-weight:400;line-height:20px;color:#5d5d5f;padding-bottom:16px;">${content}</p>`;
        },
        link ({ href: href, title: title, tokens: tokens }) {
            const text = this.parser.parseInline(tokens);
            const t = title ? ` title="${title}"` : '';
            return `<a href="${href}"${t} target="_blank" rel="noopener noreferrer">${text}</a>`;
        },
        list ({ ordered: ordered, items: items }) {
            if (!ordered) {
                const body = items.map((item)=>{
                    const inlineTokens = item.tokens?.[0]?.tokens ?? [];
                    const content = this.parser.parseInline(inlineTokens);
                    return `<li style="font-size:15px;line-height:20px;color:#5d5d5f;padding-bottom:10px;">${content}</li>`;
                }).join('');
                return `<ul style="padding-left:15px;margin:0;padding-bottom:8px;list-style-type:disc;">${body}</ul>`;
            }
            return items.map((item, i)=>{
                const inlineTokens = item.tokens?.[0]?.tokens ?? [];
                const content = this.parser.parseInline(inlineTokens);
                return `<div style="display:flex;gap:12px;align-items:flex-start;padding:8px 0;">` + `<div style="background:#17181a;color:white;border-radius:24px;width:22px;height:22px;font-size:15px;font-weight:500;text-align:center;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0;">${i + 1}</div>` + `<div style="font-size:15px;font-weight:400;line-height:20px;color:#17181a;flex:1;">${content}</div>` + `</div>`;
            }).join('');
        }
    }
});
const $b599ddbdca2685a0$export$34d09d236aef65c = (text)=>$b599ddbdca2685a0$var$notifMarked.parse(text || '');
const $b599ddbdca2685a0$export$c470c39bf64377a2 = (text)=>(text || '').split('\n').find((l)=>l.trim())?.replace(/[#*_`~[\]()>]/g, '').trim() ?? '';
const $b599ddbdca2685a0$export$ebeab083b736347a = (title, messages)=>{
    let section = '';
    if (title) section += `<p style="font-size:26px;font-weight:600;line-height:24px;letter-spacing:0.32px;color:#17181a;padding-bottom:16px;">${title}</p>`;
    section += (messages || []).map($b599ddbdca2685a0$export$34d09d236aef65c).join('');
    (0, $3804040dc4640bb3$export$ca5dd0f8f0ed3310)(null, section, [
        {
            title: COPY.booking.button_ok
        }
    ]);
};
const $b599ddbdca2685a0$var$InfoIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
                clipPath: "url(#notif-clip)",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 14.4333C11.553 14.4333 14.4333 11.553 14.4333 8C14.4333 4.44697 11.553 1.56667 8 1.56667C4.44697 1.56667 1.56667 4.44697 1.56667 8C1.56667 11.553 4.44697 14.4333 8 14.4333ZM8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.2",
                        y: "4",
                        width: "1.6",
                        height: "1.6",
                        rx: "0.8",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.467",
                        y: "6.667",
                        width: "1.067",
                        height: "5.333",
                        rx: "0.213",
                        fill: "#17181A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("clipPath", {
                    id: "notif-clip",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $b599ddbdca2685a0$var$ChevronRightIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M1 1L7 7L1 13",
            stroke: "#17181A",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
function $b599ddbdca2685a0$export$2e2bcd8739ae039({ fullscreen: fullscreen, forceMessages: forceMessages, showBothBookingTypes: showBothBookingTypes = false }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    if (forceMessages) {
        if (forceMessages.length === 0) return null;
        return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            style: {
                overflow: 'hidden'
            },
            children: forceMessages.map((item, i)=>/*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                    type: "button",
                    className: "w-full flex items-center gap-2 px-4 h-14 rounded-[10px] bg-secondary-container border-[1.5px] border-solid border-secondary text-left",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($b599ddbdca2685a0$var$InfoIcon, {}),
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            className: "flex-1 text-body-sm font-medium text-on-surface",
                            style: {
                                minWidth: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            },
                            children: item?.shortMessage || item
                        })
                    ]
                }, i))
        });
    }
    // Departure notifications: new tag logic applied here so filtering is always
    // reactive to current pickupTime without needing to rebuild originInfo.
    const depItems = (0, $c94184dfef1a7d71$export$e5957f49ec813c50)(values.departure?.locationInformation, values.pickupTime, showBothBookingTypes);
    const depMessages = depItems.map((item)=>item.message).filter(Boolean);
    // Destination notifications: INFO tag items stored in originInfo
    const destInfo = values.originInfo?.filter((item)=>item.info?.length > 0) || [];
    const destMessages = destInfo.flatMap((item)=>item.info);
    const totalCount = depMessages.length + destMessages.length;
    if (totalCount === 0) return null;
    const shortMessage = $b599ddbdca2685a0$export$c470c39bf64377a2(depMessages[0] || destMessages[0]);
    const multipleInfo = totalCount > 1;
    const SECTION_GAP = '<div style="height:24px;"></div>';
    const readMore = ()=>{
        const sections = [];
        let title = "";
        if (depMessages.length > 0) {
            title = values.departure?.name || values.departure?.address?.poiName;
            let section = '';
            if (title) section += `<p style="font-size:26px;font-weight:600;line-height:24px;letter-spacing:0.32px;color:#17181a;padding-bottom:16px;">${title}</p>`;
            section += depMessages.map($b599ddbdca2685a0$export$34d09d236aef65c).join('');
            sections.push(section);
        }
        destInfo.forEach((item)=>{
            let section = '';
            if (item.title) title = item.title; //section += `<p style="font-size:16px;font-weight:600;line-height:24px;letter-spacing:0.32px;text-transform:uppercase;color:#17181a;padding-bottom:4px;">${item.title}</p>`
            section += item.info.map($b599ddbdca2685a0$export$34d09d236aef65c).join('');
            sections.push(section);
        });
        (0, $3804040dc4640bb3$export$ca5dd0f8f0ed3310)(null, sections.join(SECTION_GAP), [
            {
                title: COPY.booking.button_ok
            }
        ]);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: fullscreen ? 'px-0' : '',
        style: {
            overflow: 'hidden'
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
            type: "button",
            onClick: readMore,
            className: "w-full flex items-center gap-2 px-4 h-14 rounded-[10px] bg-secondary-container border-[1.5px] border-solid border-secondary text-left",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($b599ddbdca2685a0$var$InfoIcon, {}),
                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "flex-1 text-body-sm font-medium text-on-surface truncate",
                    style: {
                        minWidth: 0
                    },
                    children: multipleInfo ? t('label-important-about-your-trip') : shortMessage
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)($b599ddbdca2685a0$var$ChevronRightIcon, {})
            ]
        })
    });
}


// Return trip feature (docs/RETURNTRIP.md).
//
// Client-side rules for the return trip offer, ported from the iOS/Android apps
// (ReturnTripSuggestionResolver, ReturnTripPlacedBookingTracker, ReturnTripDismissalStore).
// The backend decides whether a booking is eligible at all via `returnTripRules`; on top of
// that the client only offers for a booking the user just placed, does not interrupt an
// ongoing direct trip and never re-offers something the user already declined.



const $740a278ce29d303f$var$DISMISSED_KEY = 'returnTripDismissedBookingId';
// Statuses for a direct booking that is actively in progress, up to and including the
// customer being in the car. Mirrors APIBookingStatus.StatusCode.isOngoingUpToCustomerInCar.
const $740a278ce29d303f$var$ONGOING_DIRECT_CODES = [
    110,
    120,
    121,
    310,
    315,
    320,
    410
];
// In memory on purpose and answered only once per booking, so an offer can neither
// survive a reload nor come back the next time the same booking's details are opened.
let $740a278ce29d303f$var$justPlacedBookingId = null;
const $740a278ce29d303f$export$e9c33ea3d5deb681 = ()=>typeof CONFIG !== 'undefined' && CONFIG.return_trip === true;
const $740a278ce29d303f$export$12eefddf5beacf4d = (bookingId)=>{
    $740a278ce29d303f$var$justPlacedBookingId = bookingId;
};
const $740a278ce29d303f$export$dd8e193d965fde49 = (bookingId)=>{
    // Ids arrive as numbers from the booking response but may be strings from the store
    const wasJustPlaced = $740a278ce29d303f$var$justPlacedBookingId !== null && String($740a278ce29d303f$var$justPlacedBookingId) === String(bookingId);
    if (wasJustPlaced) $740a278ce29d303f$var$justPlacedBookingId = null;
    return wasJustPlaced;
};
const $740a278ce29d303f$export$c07511697229d32 = (bookingId)=>{
    try {
        localStorage.setItem($740a278ce29d303f$var$DISMISSED_KEY, String(bookingId));
    } catch (e) {}
};
const $740a278ce29d303f$export$7f2fd8107288bfb1 = (bookingId)=>{
    try {
        return localStorage.getItem($740a278ce29d303f$var$DISMISSED_KEY) === String(bookingId);
    } catch (e) {
        return false;
    }
};
const $740a278ce29d303f$export$612590b53a74238e = (booking)=>booking?.returnTripRules?.shouldShowReturnTripOption === true && !!booking?.destinationLocation;
const $740a278ce29d303f$export$a4b60a5a63198f3f = (booking)=>$740a278ce29d303f$export$e9c33ea3d5deb681() && !!booking?.destinationLocation;
// A booking without bookingType (possible in the store's list) only counts once a car is
// involved; a waiting booking of unknown type is more likely a prebooking than a direct trip.
const $740a278ce29d303f$var$CAR_INVOLVED_CODES = [
    310,
    315,
    320,
    410
];
const $740a278ce29d303f$export$bcb79615a4bb8cdc = (bookings)=>(bookings || []).some((booking)=>{
        const code = Number(booking?.bookingStatus?.statusCode);
        if (booking?.bookingType === 'PRE_BOOKING') return false;
        if (!booking?.bookingType) return $740a278ce29d303f$var$CAR_INVOLVED_CODES.includes(code);
        return $740a278ce29d303f$var$ONGOING_DIRECT_CODES.includes(code);
    });
const $740a278ce29d303f$var$skip = (reason)=>{
    console.warn(`[ReturnTrip] offer skipped: ${reason}`);
    return null;
};
async function $740a278ce29d303f$export$c23e31024771323a(closedBooking, activeBookings) {
    if (!$740a278ce29d303f$export$e9c33ea3d5deb681()) return $740a278ce29d303f$var$skip('feature disabled');
    if (!closedBooking?.id) return $740a278ce29d303f$var$skip('no booking to evaluate');
    if (!$740a278ce29d303f$export$dd8e193d965fde49(closedBooking.id)) return $740a278ce29d303f$var$skip(`booking ${closedBooking.id} was not just placed`);
    if ($740a278ce29d303f$export$7f2fd8107288bfb1(closedBooking.id)) return $740a278ce29d303f$var$skip(`booking ${closedBooking.id} was dismissed earlier`);
    if ((0, $c94184dfef1a7d71$export$b4300df105f88c53)(closedBooking)) return $740a278ce29d303f$var$skip(`booking ${closedBooking.id} has ended`);
    // The store's copy of the closed booking may lack bookingType (status polling merges);
    // use the type BookingDone already resolved for it.
    const bookings = (activeBookings || []).map((booking)=>booking.id === closedBooking.id ? {
            ...booking,
            bookingType: booking.bookingType || closedBooking.bookingType
        } : booking);
    if ($740a278ce29d303f$export$bcb79615a4bb8cdc(bookings)) {
        const ongoing = bookings.filter((b)=>$740a278ce29d303f$export$bcb79615a4bb8cdc([
                b
            ])).map((b)=>`${b.id} (${b.bookingType || 'type unknown'}, status ${b.bookingStatus?.statusCode})`);
        return $740a278ce29d303f$var$skip(`a direct booking is ongoing: ${ongoing.join(', ')}`);
    }
    // Prefer the freshest copy of the booking, which carries the backend's latest rules.
    let booking = bookings.find((item)=>item.id === closedBooking.id) || closedBooking;
    if (!booking.returnTripRules) try {
        booking = {
            ...booking,
            ...await (0, $135a523c4bea715f$export$98a8f978e5e12ae4)(booking.id)
        };
    } catch (error) {
        console.error('Could not refresh booking for return trip offer', error);
    }
    if (!$740a278ce29d303f$export$612590b53a74238e(booking)) return $740a278ce29d303f$var$skip(`booking ${booking.id} not eligible (shouldShowReturnTripOption=${booking.returnTripRules?.shouldShowReturnTripOption}, destination=${!!booking.destinationLocation})`);
    return booking;
}
async function $740a278ce29d303f$export$9965a32afefbb8ca(booking) {
    let fresh = booking;
    try {
        fresh = {
            ...booking,
            ...await (0, $135a523c4bea715f$export$98a8f978e5e12ae4)(booking.id)
        };
    } catch (error) {
        console.error('Could not refresh booking for return trip', error);
    }
    if (!fresh?.destinationLocation) return;
    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RETURN_TRIP_BOOKING', fresh);
}


var $b45f65279de752c6$exports = {};

$parcel$export($b45f65279de752c6$exports, "arriving", function () { return $b45f65279de752c6$export$cfd41488b6f5e9d3; }, function (v) { return $b45f65279de752c6$export$cfd41488b6f5e9d3 = v; });
$parcel$export($b45f65279de752c6$exports, "bottom", function () { return $b45f65279de752c6$export$40e543e69a8b3fbb; }, function (v) { return $b45f65279de752c6$export$40e543e69a8b3fbb = v; });
$parcel$export($b45f65279de752c6$exports, "bottomClickable", function () { return $b45f65279de752c6$export$2c1271b3f40f29e; }, function (v) { return $b45f65279de752c6$export$2c1271b3f40f29e = v; });
$parcel$export($b45f65279de752c6$exports, "buttonRow", function () { return $b45f65279de752c6$export$a5121a49a1f63d8a; }, function (v) { return $b45f65279de752c6$export$a5121a49a1f63d8a = v; });
$parcel$export($b45f65279de752c6$exports, "cancelled", function () { return $b45f65279de752c6$export$b108ea1063c657e3; }, function (v) { return $b45f65279de752c6$export$b108ea1063c657e3 = v; });
$parcel$export($b45f65279de752c6$exports, "capitalize", function () { return $b45f65279de752c6$export$9a00dee1beb8f576; }, function (v) { return $b45f65279de752c6$export$9a00dee1beb8f576 = v; });
$parcel$export($b45f65279de752c6$exports, "carInfo", function () { return $b45f65279de752c6$export$32b9802c91758687; }, function (v) { return $b45f65279de752c6$export$32b9802c91758687 = v; });
$parcel$export($b45f65279de752c6$exports, "companyIcon", function () { return $b45f65279de752c6$export$b1a462fdc93c6e5a; }, function (v) { return $b45f65279de752c6$export$b1a462fdc93c6e5a = v; });
$parcel$export($b45f65279de752c6$exports, "destination", function () { return $b45f65279de752c6$export$547cb0ec68beb837; }, function (v) { return $b45f65279de752c6$export$547cb0ec68beb837 = v; });
$parcel$export($b45f65279de752c6$exports, "error", function () { return $b45f65279de752c6$export$a3bc9b8ed74fc; }, function (v) { return $b45f65279de752c6$export$a3bc9b8ed74fc = v; });
$parcel$export($b45f65279de752c6$exports, "finished", function () { return $b45f65279de752c6$export$90407f30cb0073b9; }, function (v) { return $b45f65279de752c6$export$90407f30cb0073b9 = v; });
$parcel$export($b45f65279de752c6$exports, "in-car", function () { return $b45f65279de752c6$export$c87c38d16ee24598; }, function (v) { return $b45f65279de752c6$export$c87c38d16ee24598 = v; });
$parcel$export($b45f65279de752c6$exports, "info", function () { return $b45f65279de752c6$export$a80b3bd66acc52ff; }, function (v) { return $b45f65279de752c6$export$a80b3bd66acc52ff = v; });
$parcel$export($b45f65279de752c6$exports, "infoParts", function () { return $b45f65279de752c6$export$96a7bfef19ee0cc0; }, function (v) { return $b45f65279de752c6$export$96a7bfef19ee0cc0 = v; });
$parcel$export($b45f65279de752c6$exports, "infoSection", function () { return $b45f65279de752c6$export$b8b8aad8fe7bf2ef; }, function (v) { return $b45f65279de752c6$export$b8b8aad8fe7bf2ef = v; });
$parcel$export($b45f65279de752c6$exports, "intermediate", function () { return $b45f65279de752c6$export$28824b7d7b72532c; }, function (v) { return $b45f65279de752c6$export$28824b7d7b72532c = v; });
$parcel$export($b45f65279de752c6$exports, "isClosed", function () { return $b45f65279de752c6$export$4210f5ea57fbae57; }, function (v) { return $b45f65279de752c6$export$4210f5ea57fbae57 = v; });
$parcel$export($b45f65279de752c6$exports, "item", function () { return $b45f65279de752c6$export$7061c75fc5af8b7e; }, function (v) { return $b45f65279de752c6$export$7061c75fc5af8b7e = v; });
$parcel$export($b45f65279de752c6$exports, "option", function () { return $b45f65279de752c6$export$a75d1723e6bda2ec; }, function (v) { return $b45f65279de752c6$export$a75d1723e6bda2ec = v; });
$parcel$export($b45f65279de752c6$exports, "options", function () { return $b45f65279de752c6$export$41c562ebe57d11e2; }, function (v) { return $b45f65279de752c6$export$41c562ebe57d11e2 = v; });
$parcel$export($b45f65279de752c6$exports, "prebooked", function () { return $b45f65279de752c6$export$f0c348d5d8c2ea5d; }, function (v) { return $b45f65279de752c6$export$f0c348d5d8c2ea5d = v; });
$parcel$export($b45f65279de752c6$exports, "receiptButton", function () { return $b45f65279de752c6$export$ad9400fe967f64de; }, function (v) { return $b45f65279de752c6$export$ad9400fe967f64de = v; });
$parcel$export($b45f65279de752c6$exports, "row", function () { return $b45f65279de752c6$export$120ff0929b202a6d; }, function (v) { return $b45f65279de752c6$export$120ff0929b202a6d = v; });
$parcel$export($b45f65279de752c6$exports, "searching", function () { return $b45f65279de752c6$export$fddadf6320237c22; }, function (v) { return $b45f65279de752c6$export$fddadf6320237c22 = v; });
$parcel$export($b45f65279de752c6$exports, "showBorder", function () { return $b45f65279de752c6$export$769219883396fa4b; }, function (v) { return $b45f65279de752c6$export$769219883396fa4b = v; });
$parcel$export($b45f65279de752c6$exports, "spacer", function () { return $b45f65279de752c6$export$8cc075c801fd6817; }, function (v) { return $b45f65279de752c6$export$8cc075c801fd6817 = v; });
$parcel$export($b45f65279de752c6$exports, "stateIcon", function () { return $b45f65279de752c6$export$d138d1363acbec1f; }, function (v) { return $b45f65279de752c6$export$d138d1363acbec1f = v; });
$parcel$export($b45f65279de752c6$exports, "stateStatus", function () { return $b45f65279de752c6$export$45fe22d909ee3083; }, function (v) { return $b45f65279de752c6$export$45fe22d909ee3083 = v; });
$parcel$export($b45f65279de752c6$exports, "stop", function () { return $b45f65279de752c6$export$fa6813432f753b0d; }, function (v) { return $b45f65279de752c6$export$fa6813432f753b0d = v; });
$parcel$export($b45f65279de752c6$exports, "stops", function () { return $b45f65279de752c6$export$23813356bdaf66ca; }, function (v) { return $b45f65279de752c6$export$23813356bdaf66ca = v; });
$parcel$export($b45f65279de752c6$exports, "stopsContainer", function () { return $b45f65279de752c6$export$84f8c5ea1603eb3e; }, function (v) { return $b45f65279de752c6$export$84f8c5ea1603eb3e = v; });
$parcel$export($b45f65279de752c6$exports, "subtitle", function () { return $b45f65279de752c6$export$c96745152eb2740f; }, function (v) { return $b45f65279de752c6$export$c96745152eb2740f = v; });
$parcel$export($b45f65279de752c6$exports, "taxiInfo", function () { return $b45f65279de752c6$export$ed00718a355a694d; }, function (v) { return $b45f65279de752c6$export$ed00718a355a694d = v; });
$parcel$export($b45f65279de752c6$exports, "tipParts", function () { return $b45f65279de752c6$export$c8643bab5e073f70; }, function (v) { return $b45f65279de752c6$export$c8643bab5e073f70 = v; });
$parcel$export($b45f65279de752c6$exports, "top", function () { return $b45f65279de752c6$export$1e95b668f3b82d; }, function (v) { return $b45f65279de752c6$export$1e95b668f3b82d = v; });
$parcel$export($b45f65279de752c6$exports, "totalInclTip", function () { return $b45f65279de752c6$export$bf77824ae8615ca8; }, function (v) { return $b45f65279de752c6$export$bf77824ae8615ca8 = v; });
$parcel$export($b45f65279de752c6$exports, "vehicleInfo", function () { return $b45f65279de752c6$export$ee78d4e549fd52d9; }, function (v) { return $b45f65279de752c6$export$ee78d4e549fd52d9 = v; });
var $b45f65279de752c6$export$cfd41488b6f5e9d3;
var $b45f65279de752c6$export$40e543e69a8b3fbb;
var $b45f65279de752c6$export$2c1271b3f40f29e;
var $b45f65279de752c6$export$a5121a49a1f63d8a;
var $b45f65279de752c6$export$b108ea1063c657e3;
var $b45f65279de752c6$export$9a00dee1beb8f576;
var $b45f65279de752c6$export$32b9802c91758687;
var $b45f65279de752c6$export$b1a462fdc93c6e5a;
var $b45f65279de752c6$export$547cb0ec68beb837;
var $b45f65279de752c6$export$a3bc9b8ed74fc;
var $b45f65279de752c6$export$90407f30cb0073b9;
var $b45f65279de752c6$export$c87c38d16ee24598;
var $b45f65279de752c6$export$a80b3bd66acc52ff;
var $b45f65279de752c6$export$96a7bfef19ee0cc0;
var $b45f65279de752c6$export$b8b8aad8fe7bf2ef;
var $b45f65279de752c6$export$28824b7d7b72532c;
var $b45f65279de752c6$export$4210f5ea57fbae57;
var $b45f65279de752c6$export$7061c75fc5af8b7e;
var $b45f65279de752c6$export$a75d1723e6bda2ec;
var $b45f65279de752c6$export$41c562ebe57d11e2;
var $b45f65279de752c6$export$f0c348d5d8c2ea5d;
var $b45f65279de752c6$export$ad9400fe967f64de;
var $b45f65279de752c6$export$120ff0929b202a6d;
var $b45f65279de752c6$export$fddadf6320237c22;
var $b45f65279de752c6$export$769219883396fa4b;
var $b45f65279de752c6$export$8cc075c801fd6817;
var $b45f65279de752c6$export$d138d1363acbec1f;
var $b45f65279de752c6$export$45fe22d909ee3083;
var $b45f65279de752c6$export$fa6813432f753b0d;
var $b45f65279de752c6$export$23813356bdaf66ca;
var $b45f65279de752c6$export$84f8c5ea1603eb3e;
var $b45f65279de752c6$export$c96745152eb2740f;
var $b45f65279de752c6$export$ed00718a355a694d;
var $b45f65279de752c6$export$c8643bab5e073f70;
var $b45f65279de752c6$export$1e95b668f3b82d;
var $b45f65279de752c6$export$bf77824ae8615ca8;
var $b45f65279de752c6$export$ee78d4e549fd52d9;
$b45f65279de752c6$export$cfd41488b6f5e9d3 = `sWWoQW_arriving`;
$b45f65279de752c6$export$40e543e69a8b3fbb = `sWWoQW_bottom`;
$b45f65279de752c6$export$2c1271b3f40f29e = `sWWoQW_bottomClickable`;
$b45f65279de752c6$export$a5121a49a1f63d8a = `sWWoQW_buttonRow`;
$b45f65279de752c6$export$b108ea1063c657e3 = `sWWoQW_cancelled`;
$b45f65279de752c6$export$9a00dee1beb8f576 = `sWWoQW_capitalize`;
$b45f65279de752c6$export$32b9802c91758687 = `sWWoQW_carInfo`;
$b45f65279de752c6$export$b1a462fdc93c6e5a = `sWWoQW_companyIcon`;
$b45f65279de752c6$export$547cb0ec68beb837 = `sWWoQW_destination`;
$b45f65279de752c6$export$a3bc9b8ed74fc = `sWWoQW_error`;
$b45f65279de752c6$export$90407f30cb0073b9 = `sWWoQW_finished`;
$b45f65279de752c6$export$c87c38d16ee24598 = `sWWoQW_in-car`;
$b45f65279de752c6$export$a80b3bd66acc52ff = `sWWoQW_info`;
$b45f65279de752c6$export$96a7bfef19ee0cc0 = `sWWoQW_infoParts`;
$b45f65279de752c6$export$b8b8aad8fe7bf2ef = `sWWoQW_infoSection`;
$b45f65279de752c6$export$28824b7d7b72532c = `sWWoQW_intermediate`;
$b45f65279de752c6$export$4210f5ea57fbae57 = `sWWoQW_isClosed`;
$b45f65279de752c6$export$7061c75fc5af8b7e = `sWWoQW_item`;
$b45f65279de752c6$export$a75d1723e6bda2ec = `sWWoQW_option`;
$b45f65279de752c6$export$41c562ebe57d11e2 = `sWWoQW_options`;
$b45f65279de752c6$export$f0c348d5d8c2ea5d = `sWWoQW_prebooked`;
$b45f65279de752c6$export$ad9400fe967f64de = `sWWoQW_receiptButton`;
$b45f65279de752c6$export$120ff0929b202a6d = `sWWoQW_row`;
$b45f65279de752c6$export$fddadf6320237c22 = `sWWoQW_searching`;
$b45f65279de752c6$export$769219883396fa4b = `sWWoQW_showBorder`;
$b45f65279de752c6$export$8cc075c801fd6817 = `sWWoQW_spacer`;
$b45f65279de752c6$export$d138d1363acbec1f = `sWWoQW_stateIcon`;
$b45f65279de752c6$export$45fe22d909ee3083 = `sWWoQW_stateStatus`;
$b45f65279de752c6$export$fa6813432f753b0d = `sWWoQW_stop`;
$b45f65279de752c6$export$23813356bdaf66ca = `sWWoQW_stops`;
$b45f65279de752c6$export$84f8c5ea1603eb3e = `sWWoQW_stopsContainer`;
$b45f65279de752c6$export$c96745152eb2740f = `sWWoQW_subtitle`;
$b45f65279de752c6$export$ed00718a355a694d = `sWWoQW_taxiInfo`;
$b45f65279de752c6$export$c8643bab5e073f70 = `sWWoQW_tipParts`;
$b45f65279de752c6$export$1e95b668f3b82d = `sWWoQW_top`;
$b45f65279de752c6$export$bf77824ae8615ca8 = `sWWoQW_totalInclTip`;
$b45f65279de752c6$export$ee78d4e549fd52d9 = `sWWoQW_vehicleInfo`;


var $f35967c56a9f3d99$exports = {};

$parcel$export($f35967c56a9f3d99$exports, "bold", function () { return $f35967c56a9f3d99$export$73ba5813cda80a49; }, function (v) { return $f35967c56a9f3d99$export$73ba5813cda80a49 = v; });
$parcel$export($f35967c56a9f3d99$exports, "bottomButton", function () { return $f35967c56a9f3d99$export$2fba6a0930a7d2ef; }, function (v) { return $f35967c56a9f3d99$export$2fba6a0930a7d2ef = v; });
$parcel$export($f35967c56a9f3d99$exports, "capitalize", function () { return $f35967c56a9f3d99$export$9a00dee1beb8f576; }, function (v) { return $f35967c56a9f3d99$export$9a00dee1beb8f576 = v; });
$parcel$export($f35967c56a9f3d99$exports, "content", function () { return $f35967c56a9f3d99$export$a7db06668cad9adb; }, function (v) { return $f35967c56a9f3d99$export$a7db06668cad9adb = v; });
$parcel$export($f35967c56a9f3d99$exports, "contentBottom", function () { return $f35967c56a9f3d99$export$c09c292f11cd9d1; }, function (v) { return $f35967c56a9f3d99$export$c09c292f11cd9d1 = v; });
$parcel$export($f35967c56a9f3d99$exports, "contentFull", function () { return $f35967c56a9f3d99$export$98090d4d513c0fe6; }, function (v) { return $f35967c56a9f3d99$export$98090d4d513c0fe6 = v; });
$parcel$export($f35967c56a9f3d99$exports, "contentOptions", function () { return $f35967c56a9f3d99$export$3f8ad60d2877fa1; }, function (v) { return $f35967c56a9f3d99$export$3f8ad60d2877fa1 = v; });
$parcel$export($f35967c56a9f3d99$exports, "doubleButtonDrawer", function () { return $f35967c56a9f3d99$export$9bd4d234138a4af4; }, function (v) { return $f35967c56a9f3d99$export$9bd4d234138a4af4 = v; });
$parcel$export($f35967c56a9f3d99$exports, "fieldDescription", function () { return $f35967c56a9f3d99$export$b84494756f225a7d; }, function (v) { return $f35967c56a9f3d99$export$b84494756f225a7d = v; });
$parcel$export($f35967c56a9f3d99$exports, "fullHeight", function () { return $f35967c56a9f3d99$export$8491d5f88b8d686b; }, function (v) { return $f35967c56a9f3d99$export$8491d5f88b8d686b = v; });
$parcel$export($f35967c56a9f3d99$exports, "fullWidth", function () { return $f35967c56a9f3d99$export$f59aa6be2711b90; }, function (v) { return $f35967c56a9f3d99$export$f59aa6be2711b90 = v; });
$parcel$export($f35967c56a9f3d99$exports, "fullscreen", function () { return $f35967c56a9f3d99$export$af93ab412ae68734; }, function (v) { return $f35967c56a9f3d99$export$af93ab412ae68734 = v; });
$parcel$export($f35967c56a9f3d99$exports, "gray", function () { return $f35967c56a9f3d99$export$3e2c219d3ab79d01; }, function (v) { return $f35967c56a9f3d99$export$3e2c219d3ab79d01 = v; });
$parcel$export($f35967c56a9f3d99$exports, "group", function () { return $f35967c56a9f3d99$export$e5e25fbcc1f7affe; }, function (v) { return $f35967c56a9f3d99$export$e5e25fbcc1f7affe = v; });
$parcel$export($f35967c56a9f3d99$exports, "hidden", function () { return $f35967c56a9f3d99$export$73920f18ca706874; }, function (v) { return $f35967c56a9f3d99$export$73920f18ca706874 = v; });
$parcel$export($f35967c56a9f3d99$exports, "icon", function () { return $f35967c56a9f3d99$export$1ca1ec8b29a4ce27; }, function (v) { return $f35967c56a9f3d99$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($f35967c56a9f3d99$exports, "isLoading", function () { return $f35967c56a9f3d99$export$20bb0d907fbbe433; }, function (v) { return $f35967c56a9f3d99$export$20bb0d907fbbe433 = v; });
$parcel$export($f35967c56a9f3d99$exports, "label", function () { return $f35967c56a9f3d99$export$1237798dc640739a; }, function (v) { return $f35967c56a9f3d99$export$1237798dc640739a = v; });
$parcel$export($f35967c56a9f3d99$exports, "largePadding", function () { return $f35967c56a9f3d99$export$c03fd75451e5a4e7; }, function (v) { return $f35967c56a9f3d99$export$c03fd75451e5a4e7 = v; });
$parcel$export($f35967c56a9f3d99$exports, "linkButton", function () { return $f35967c56a9f3d99$export$9126ebe212f3bdac; }, function (v) { return $f35967c56a9f3d99$export$9126ebe212f3bdac = v; });
$parcel$export($f35967c56a9f3d99$exports, "narrow", function () { return $f35967c56a9f3d99$export$ec67f55c222e1546; }, function (v) { return $f35967c56a9f3d99$export$ec67f55c222e1546 = v; });
$parcel$export($f35967c56a9f3d99$exports, "noBackground", function () { return $f35967c56a9f3d99$export$ecd0cfa6d6b75e08; }, function (v) { return $f35967c56a9f3d99$export$ecd0cfa6d6b75e08 = v; });
$parcel$export($f35967c56a9f3d99$exports, "noPadding", function () { return $f35967c56a9f3d99$export$21f8faa572cd92e9; }, function (v) { return $f35967c56a9f3d99$export$21f8faa572cd92e9 = v; });
$parcel$export($f35967c56a9f3d99$exports, "option", function () { return $f35967c56a9f3d99$export$a75d1723e6bda2ec; }, function (v) { return $f35967c56a9f3d99$export$a75d1723e6bda2ec = v; });
$parcel$export($f35967c56a9f3d99$exports, "smaller", function () { return $f35967c56a9f3d99$export$3f732695c1493aec; }, function (v) { return $f35967c56a9f3d99$export$3f732695c1493aec = v; });
$parcel$export($f35967c56a9f3d99$exports, "subtitle", function () { return $f35967c56a9f3d99$export$c96745152eb2740f; }, function (v) { return $f35967c56a9f3d99$export$c96745152eb2740f = v; });
$parcel$export($f35967c56a9f3d99$exports, "tabsLeft", function () { return $f35967c56a9f3d99$export$b12316f7ed3508b4; }, function (v) { return $f35967c56a9f3d99$export$b12316f7ed3508b4 = v; });
$parcel$export($f35967c56a9f3d99$exports, "title", function () { return $f35967c56a9f3d99$export$fb184b623420d9be; }, function (v) { return $f35967c56a9f3d99$export$fb184b623420d9be = v; });
$parcel$export($f35967c56a9f3d99$exports, "titleLarge", function () { return $f35967c56a9f3d99$export$1a94cd0d0a967a9e; }, function (v) { return $f35967c56a9f3d99$export$1a94cd0d0a967a9e = v; });
$parcel$export($f35967c56a9f3d99$exports, "warning", function () { return $f35967c56a9f3d99$export$491112666e282270; }, function (v) { return $f35967c56a9f3d99$export$491112666e282270 = v; });
$parcel$export($f35967c56a9f3d99$exports, "widgetWrapper", function () { return $f35967c56a9f3d99$export$1c4e4560041c6881; }, function (v) { return $f35967c56a9f3d99$export$1c4e4560041c6881 = v; });
var $f35967c56a9f3d99$export$73ba5813cda80a49;
var $f35967c56a9f3d99$export$2fba6a0930a7d2ef;
var $f35967c56a9f3d99$export$9a00dee1beb8f576;
var $f35967c56a9f3d99$export$a7db06668cad9adb;
var $f35967c56a9f3d99$export$c09c292f11cd9d1;
var $f35967c56a9f3d99$export$98090d4d513c0fe6;
var $f35967c56a9f3d99$export$3f8ad60d2877fa1;
var $f35967c56a9f3d99$export$9bd4d234138a4af4;
var $f35967c56a9f3d99$export$b84494756f225a7d;
var $f35967c56a9f3d99$export$8491d5f88b8d686b;
var $f35967c56a9f3d99$export$f59aa6be2711b90;
var $f35967c56a9f3d99$export$af93ab412ae68734;
var $f35967c56a9f3d99$export$3e2c219d3ab79d01;
var $f35967c56a9f3d99$export$e5e25fbcc1f7affe;
var $f35967c56a9f3d99$export$73920f18ca706874;
var $f35967c56a9f3d99$export$1ca1ec8b29a4ce27;
var $f35967c56a9f3d99$export$20bb0d907fbbe433;
var $f35967c56a9f3d99$export$1237798dc640739a;
var $f35967c56a9f3d99$export$c03fd75451e5a4e7;
var $f35967c56a9f3d99$export$9126ebe212f3bdac;
var $f35967c56a9f3d99$export$ec67f55c222e1546;
var $f35967c56a9f3d99$export$ecd0cfa6d6b75e08;
var $f35967c56a9f3d99$export$21f8faa572cd92e9;
var $f35967c56a9f3d99$export$a75d1723e6bda2ec;
var $f35967c56a9f3d99$export$3f732695c1493aec;
var $f35967c56a9f3d99$export$c96745152eb2740f;
var $f35967c56a9f3d99$export$b12316f7ed3508b4;
var $f35967c56a9f3d99$export$fb184b623420d9be;
var $f35967c56a9f3d99$export$1a94cd0d0a967a9e;
var $f35967c56a9f3d99$export$491112666e282270;
var $f35967c56a9f3d99$export$1c4e4560041c6881;
$f35967c56a9f3d99$export$73ba5813cda80a49 = `eA4Q8G_bold`;
$f35967c56a9f3d99$export$2fba6a0930a7d2ef = `eA4Q8G_bottomButton`;
$f35967c56a9f3d99$export$9a00dee1beb8f576 = `eA4Q8G_capitalize`;
$f35967c56a9f3d99$export$a7db06668cad9adb = `eA4Q8G_content`;
$f35967c56a9f3d99$export$c09c292f11cd9d1 = `eA4Q8G_contentBottom`;
$f35967c56a9f3d99$export$98090d4d513c0fe6 = `eA4Q8G_contentFull`;
$f35967c56a9f3d99$export$3f8ad60d2877fa1 = `eA4Q8G_contentOptions`;
$f35967c56a9f3d99$export$9bd4d234138a4af4 = `eA4Q8G_doubleButtonDrawer`;
$f35967c56a9f3d99$export$b84494756f225a7d = `eA4Q8G_fieldDescription`;
$f35967c56a9f3d99$export$8491d5f88b8d686b = `eA4Q8G_fullHeight`;
$f35967c56a9f3d99$export$f59aa6be2711b90 = `eA4Q8G_fullWidth`;
$f35967c56a9f3d99$export$af93ab412ae68734 = `eA4Q8G_fullscreen`;
$f35967c56a9f3d99$export$3e2c219d3ab79d01 = `eA4Q8G_gray`;
$f35967c56a9f3d99$export$e5e25fbcc1f7affe = `eA4Q8G_group`;
$f35967c56a9f3d99$export$73920f18ca706874 = `eA4Q8G_hidden`;
$f35967c56a9f3d99$export$1ca1ec8b29a4ce27 = `eA4Q8G_icon`;
$f35967c56a9f3d99$export$20bb0d907fbbe433 = `eA4Q8G_isLoading`;
$f35967c56a9f3d99$export$1237798dc640739a = `eA4Q8G_label`;
$f35967c56a9f3d99$export$c03fd75451e5a4e7 = `eA4Q8G_largePadding`;
$f35967c56a9f3d99$export$9126ebe212f3bdac = `eA4Q8G_linkButton`;
$f35967c56a9f3d99$export$ec67f55c222e1546 = `eA4Q8G_narrow`;
$f35967c56a9f3d99$export$ecd0cfa6d6b75e08 = `eA4Q8G_noBackground`;
$f35967c56a9f3d99$export$21f8faa572cd92e9 = `eA4Q8G_noPadding`;
$f35967c56a9f3d99$export$a75d1723e6bda2ec = `eA4Q8G_option`;
$f35967c56a9f3d99$export$3f732695c1493aec = `eA4Q8G_smaller`;
$f35967c56a9f3d99$export$c96745152eb2740f = `eA4Q8G_subtitle`;
$f35967c56a9f3d99$export$b12316f7ed3508b4 = `eA4Q8G_tabsLeft`;
$f35967c56a9f3d99$export$fb184b623420d9be = `eA4Q8G_title`;
$f35967c56a9f3d99$export$1a94cd0d0a967a9e = `eA4Q8G_titleLarge`;
$f35967c56a9f3d99$export$491112666e282270 = `eA4Q8G_warning`;
$f35967c56a9f3d99$export$1c4e4560041c6881 = `eA4Q8G_widgetWrapper`;




const $ee4f9bead648b485$export$6b2a7d5132615086 = (event, data)=>{
    data.event = event;
    if (window?.dataLayer?.push) window.dataLayer.push(data);
};
const $ee4f9bead648b485$export$5a6ec5e5079bbe35 = (error)=>{
    const data = {
        event: 'formError',
        error: error
    };
    if (window?.dataLayer?.push) window.dataLayer.push(data);
};


const $e195d2535fb91e12$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($b45f65279de752c6$exports);
const $e195d2535fb91e12$var$getShortAddress = (address)=>{
    if (!address) return '-';
    const addressParts = (0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)({
        address: address
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: addressParts.title
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $b45f65279de752c6$exports.subtitle,
                children: addressParts.subtitle
            })
        ]
    });
};
const $e195d2535fb91e12$var$formatDate = (booking)=>{
    if (!(0, $c94184dfef1a7d71$export$b4300df105f88c53)(booking) && booking.bookingStatus.vehiclePlate !== undefined && booking.bookingStatus.eta) return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-arrives-apx') + ' ' + (0, $200ec6b1b2ca8c5a$export$3203edd9e5edd663)(new Date(booking.bookingStatus.eta));
    return (0, $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1)(new Date(booking.pickUpTimeStamp));
};
const $e195d2535fb91e12$var$order = [
    'basePrice',
    'fixedAdditionalFee',
    'waitingFee',
    'tip'
];
const $e195d2535fb91e12$var$renderPriceParts = (booking)=>{
    const price = booking?.price;
    let parts = [];
    parts = parts.concat(price.priceComponents.filter((p)=>p.type !== 'fixedPrice').sort((a, b)=>{
        const indexA = $e195d2535fb91e12$var$order.indexOf(a.type);
        const indexB = $e195d2535fb91e12$var$order.indexOf(b.type);
        if (indexA === -1 && indexB === -1) return 0;
        else if (indexA === -1 && indexB > -1) return 1;
        else if (indexA > -1 && indexB === -1) return -1;
        return indexA - indexB;
    }).map((p, index)=>{
        return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
            children: [
                p.name || (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('price_' + p.type),
                " ",
                Math.round(p.amount),
                " kr",
                /*#__PURE__*/ (0, $ih19M.jsx)("br", {})
            ]
        }, index);
    }));
    if (price.vat) parts.unshift(/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        children: [
            (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('price_vat'),
            " ",
            price.vat.toString().replace('.', ','),
            " kr",
            /*#__PURE__*/ (0, $ih19M.jsx)("br", {})
        ]
    }, "vat"));
    if (price.discount) parts.push(price.discountComponents.map((item, index)=>{
        const title = item.name + (item.type === 'voucher' ? `:` + item.code : '');
        return /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    children: title
                }),
                " ",
                -Math.round(item.amount),
                " kr",
                /*#__PURE__*/ (0, $ih19M.jsx)("br", {})
            ]
        }, index);
    }));
    return parts;
};
function $e195d2535fb91e12$export$2e2bcd8739ae039({ booking: booking, showDate: showDate, showBorder: showBorder, onCancel: onCancel, onEdit: onEdit }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, refreshUser: refreshUser, paymentAccounts: paymentAccounts } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const isPreBooking = booking.bookingType === 'PRE_BOOKING';
    const hasPrice = booking?.price;
    const tip = Number(booking?.price?.tippedAmount) || 0;
    const isDelivery = booking.serviceType === 'delivery';
    const isCreditCard = booking?.paymentStatus?.paymentMethod === 'CreditCard';
    const cardType = isCreditCard ? paymentAccounts?.find((account)=>account?.accountId === booking?.paymentStatus?.accountNumber)?.cardType : null;
    const hasReceipt = booking?.receiptStatus === '100';
    const hasStops = booking.intermediateStopLocations?.length > 0;
    const numStops = booking.intermediateStopLocations?.length;
    const deliveryInfo = booking?.packageDeliveryInfo;
    const flightInfo = booking.originLocation?.flightInfo;
    const showAccount = booking?.account?.number;
    const showCompany = booking?.company !== undefined;
    const showTaxiInfo = (0, $c94184dfef1a7d71$export$45e40f7bd1bea381)(booking);
    const destinationChar = hasStops ? 'ABCDE'[booking.intermediateStopLocations.length + 1] : 'B';
    const vehicleOptions = (0, $c94184dfef1a7d71$export$60d56ed3961c839c)(booking.vehicleOptions).filter((opt)=>opt !== 'stationWagon');
    const serviceType = booking.serviceType === 'taxi' && booking.vehicleOptions.includes('stationWagon') ? 'estate' : booking.serviceType;
    const carType = (0, $c94184dfef1a7d71$export$80d7df4f587449e4)(serviceType);
    const isMobile = (0, $ef42d3c0207235e0$export$32d5543ab307c01)('only screen and (max-width: 969px)');
    //if (isMobile && hasEnded(booking)) showDate = false
    const cancelBooking = ()=>{
        setMessage(null);
        setIsLoading(true);
        // NOTE: clientBookingToken is only used for anonymous bookings
        (0, $135a523c4bea715f$export$b7b1ce5fabd1b486)(booking.id, booking?.clientBookingToken).then((response)=>{
            refreshUser();
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CANCEL_BOOKING', booking.id);
            (0, $ee4f9bead648b485$export$6b2a7d5132615086)('cancelBooking', {
                bookingNumber: booking.id
            });
            setIsLoading(false);
            onCancel();
        }).catch((error)=>{
            if (error?.response?.error === 'ALREADY_CANCELLED_BOOKING') onCancel();
            else if (error?.isUnauthorized || error?.status === 401) ;
            else {
                console.error(error);
                setMessage(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
            setIsLoading(false);
        });
    };
    const openReceipt = (e)=>{
        e.stopPropagation();
        setMessage(null);
        (0, $135a523c4bea715f$export$e6a7cb28487f7150)(user.userId, booking.id).then((res)=>res.blob()).then((blob)=>{
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `${booking.id}.pdf`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        }).catch((error)=>{
            if (error?.isUnauthorized || error?.status === 401) ;
            else {
                console.error(error);
                setMessage(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
        });
    };
    const cancel = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(COPY.booking.receipt_confirm_cancel, [
            {
                title: COPY.booking.button_ok,
                callback: cancelBooking
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    // Location info is markdown; show it like the booking flow's notification modal
    const readMore = (message)=>{
        (0, $b599ddbdca2685a0$export$ebeab083b736347a)((0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)({
            address: booking.originLocation
        }).title, [
            message
        ]);
    };
    const toggle = ()=>setIsOpen(!isOpen);
    const openSendConfirmation = ()=>{
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $4741aed6d26ee9f4$export$2e2bcd8739ae039), {
                bookingId: booking.id,
                onComplete: close
            }));
    };
    const editBooking = ()=>{
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('EDIT_BOOKING', booking);
        if (onEdit) onEdit();
    };
    // Return trip from the list (docs/RETURNTRIP.md): offered for any active or historical
    // booking the backend has flagged. Opens the prefilled sheet in the booking module, or in
    // the dynamic overlay on pages without one (same as edit).
    const canBookReturnTrip = (0, $740a278ce29d303f$export$a4b60a5a63198f3f)(booking);
    const bookReturnTrip = ()=>{
        setMessage(null);
        setIsLoading(true);
        (0, $740a278ce29d303f$export$9965a32afefbb8ca)(booking).then(()=>{
            if (onEdit) onEdit();
        }).finally(()=>setIsLoading(false));
    };
    const buttons = [
        ...canBookReturnTrip ? [
            {
                func: bookReturnTrip,
                title: t('button-return-trip'),
                isLoading: isLoading
            }
        ] : [],
        {
            func: editBooking,
            title: t('button-edit-booking'),
            disabled: !(0, $c94184dfef1a7d71$export$101b6e7d76ab4fe5)(booking)
        },
        {
            func: openSendConfirmation,
            title: t('button-send-confirmation'),
            disabled: !(0, $c94184dfef1a7d71$export$4d66b7747958f839)(booking)
        },
        {
            func: cancel,
            title: t('button-cancel-booking'),
            disabled: !(0, $c94184dfef1a7d71$export$4d66b7747958f839)(booking),
            isLoading: isLoading
        }
    ];
    const renderStops = (stops)=>{
        return stops.map((item, index)=>{
            return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.stop, $b45f65279de752c6$exports.intermediate),
                children: $e195d2535fb91e12$var$getShortAddress(item)
            }, index);
        });
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
        className: $e195d2535fb91e12$var$cx('order-item', $b45f65279de752c6$exports.item, {
            loading: isLoading
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $b45f65279de752c6$exports.top,
                onClick: toggle,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.stateIcon, $b45f65279de752c6$exports[(0, $c94184dfef1a7d71$export$705b78797a4b1907)(booking)])
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $b45f65279de752c6$exports.stateStatus,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: (0, $c94184dfef1a7d71$export$32e796a9286f339b)(booking)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $e195d2535fb91e12$var$cx($f35967c56a9f3d99$export$3f732695c1493aec, $b45f65279de752c6$exports.carInfo),
                                children: [
                                    carType?.title,
                                    showCompany && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                                        id: "suitcase",
                                        className: $b45f65279de752c6$exports.companyIcon
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $b45f65279de752c6$exports.taxiInfo,
                        children: [
                            (showTaxiInfo || showDate) && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: $e195d2535fb91e12$var$formatDate(booking)
                            }),
                            showTaxiInfo && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$export$3f732695c1493aec,
                                children: booking.bookingStatus.vehiclePlate
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        children: isOpen ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                            id: "white-minus"
                        }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                            id: "white-plus"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.bottom, {
                    showBorder: showBorder
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                        className: "booking-notifications",
                        children: booking.originInfo && booking.originInfo.map((item, index)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                className: "notification",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "message",
                                        children: (0, $b599ddbdca2685a0$export$c470c39bf64377a2)(item)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                        className: "text-button",
                                        onClick: ()=>readMore(item),
                                        children: t('button-read-more')
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $b45f65279de752c6$exports.bottomClickable,
                        onClick: toggle,
                        children: [
                            booking.bookingStatus.vehiclePlate && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $b45f65279de752c6$exports.vehicleInfo,
                                children: [
                                    booking.bookingStatus.vehiclePlate,
                                    " ",
                                    booking.bookingStatus.vehicleMake && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            "- (",
                                            booking.bookingStatus.vehicleColor,
                                            " ",
                                            booking.bookingStatus.vehicleMake,
                                            " ",
                                            booking.bookingStatus.vehicleModel,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.stopsContainer, {
                                    hasStops: hasStops
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.content, $b45f65279de752c6$exports.departure, {
                                            hasStops: hasStops
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                                                char: "A",
                                                className: $b45f65279de752c6$exports.charIcon,
                                                small: true
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: $b45f65279de752c6$exports.stop,
                                                children: $e195d2535fb91e12$var$getShortAddress(booking.originLocation)
                                            })
                                        ]
                                    }),
                                    hasStops && (isOpen || numStops === 1) && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $b45f65279de752c6$exports.stops,
                                        children: renderStops(booking.intermediateStopLocations)
                                    }),
                                    hasStops && !isOpen && numStops > 1 && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $b45f65279de752c6$exports.stops,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                                                char: booking.intermediateStopLocations.length,
                                                className: $b45f65279de752c6$exports.charIcon,
                                                small: true,
                                                gray: true
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: $b45f65279de752c6$exports.stop,
                                                children: [
                                                    booking.intermediateStopLocations.length,
                                                    " stopp"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.content, $b45f65279de752c6$exports.destination, {
                                            hasStops: hasStops
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                                                char: destinationChar,
                                                className: $b45f65279de752c6$exports.charIcon,
                                                small: true
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.stop, $b45f65279de752c6$exports.destination),
                                                children: $e195d2535fb91e12$var$getShortAddress(booking.destinationLocation)
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.infoSection, {
                                    isClosed: !isOpen
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-booking-number'),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: booking.id
                                            })
                                        ]
                                    }),
                                    (isPreBooking || showDate) && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-date'),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: (0, $200ec6b1b2ca8c5a$export$a2b50b91b78100e5)(new Date(booking.pickUpTimeStamp))
                                            })
                                        ]
                                    }),
                                    !isDelivery && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-name'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: booking?.traveler?.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-phone'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: booking?.traveler?.phoneNumber
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    flightInfo && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-flight-number'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: flightInfo.flightNumber
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-baggage'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: flightInfo.checkedInBaggage ? t('label-yes') : t('label-no')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    hasPrice && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                children: t('label-price-information')
                                            }),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                        children: [
                                                            t('label-total'),
                                                            " ",
                                                            booking.price.finalPrice,
                                                            " kr"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.infoParts,
                                                        children: $e195d2535fb91e12$var$renderPriceParts(booking)
                                                    }),
                                                    tip > 0 && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                        className: $b45f65279de752c6$exports.tipParts,
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                                children: [
                                                                    t('price_tip'),
                                                                    " ",
                                                                    Math.round(tip),
                                                                    " kr"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                                className: $b45f65279de752c6$exports.totalInclTip,
                                                                children: [
                                                                    t('label-total'),
                                                                    " ",
                                                                    t('label-incl-tip'),
                                                                    " ",
                                                                    Math.round(booking.price.finalPrice + tip),
                                                                    " kr"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isCreditCard && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                children: t('label-payment')
                                            }),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        children: booking.paymentStatus.paymentMethodLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.infoParts,
                                                        children: cardType
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-receipt'),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: [
                                                    hasReceipt && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                        className: $b45f65279de752c6$exports.receiptButton,
                                                        onClick: openReceipt,
                                                        children: t('button-download-receipt')
                                                    }),
                                                    !hasReceipt && (0, $c94184dfef1a7d71$export$88cbc18f81616dbf)(booking)
                                                ]
                                            })
                                        ]
                                    }),
                                    showAccount && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                children: t('label-account')
                                            }),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        children: booking.account?.name
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.infoParts,
                                                        children: booking.account?.number
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showCompany && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-company-trip'),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: booking.company?.name
                                            })
                                        ]
                                    }),
                                    !isDelivery && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-booking-options'),
                                            ":",
                                            vehicleOptions?.length === 0 && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: "-"
                                            }),
                                            vehicleOptions?.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                className: $b45f65279de752c6$exports.options,
                                                children: vehicleOptions.map((value, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                                        className: $b45f65279de752c6$exports.option,
                                                        children: (0, $c94184dfef1a7d71$export$c165bf529a45fce1)(value)
                                                    }, index))
                                            })
                                        ]
                                    }),
                                    isDelivery && deliveryInfo && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('title-extra-information'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.otherInformation
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                    className: $b45f65279de752c6$exports.options,
                                                    children: deliveryInfo.packages.map((value, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                                            className: $b45f65279de752c6$exports.option,
                                                            children: (0, $c94184dfef1a7d71$export$60eeeada66bc4067)(value)
                                                        }, index))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.spacer)
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-name'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: booking?.traveler?.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-phone'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: booking?.traveler?.phoneNumber
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-name-on-door'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageSender.nameOnDoor
                                                    })
                                                ]
                                            }),
                                            deliveryInfo.packageSender.doorCode && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-door-code'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageSender.doorCode
                                                    })
                                                ]
                                            }),
                                            deliveryInfo.packageSender.numberOfStairs && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-number-of-stairs'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageSender.numberOfStairs
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                                className: $e195d2535fb91e12$var$cx($b45f65279de752c6$exports.spacer)
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-name-receiver-on-door'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageReceiver.nameOnDoor
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-phone-receiver'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageReceiver.phoneNumber
                                                    })
                                                ]
                                            }),
                                            deliveryInfo.packageReceiver.doorCode && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-door-code'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageReceiver.doorCode
                                                    })
                                                ]
                                            }),
                                            deliveryInfo.packageReceiver.numberOfStairs && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('label-number-of-stairs'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageReceiver.numberOfStairs
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: $b45f65279de752c6$exports.row,
                                                children: [
                                                    t('title-leave-outside'),
                                                    ": ",
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: $b45f65279de752c6$exports.info,
                                                        children: deliveryInfo.packageReceiver.leaveOutsideDoor ? t('label-yes') : t('label-no')
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    booking.generalComment && /*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                        className: $b45f65279de752c6$exports.row,
                                        children: [
                                            t('label-message'),
                                            ": ",
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: $b45f65279de752c6$exports.info,
                                                children: booking.generalComment
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                        buttons: buttons,
                        isLoading: isLoading,
                        className: $e195d2535fb91e12$var$cx({
                            isClosed: !isOpen
                        }),
                        children: message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $b45f65279de752c6$exports.error,
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039), {
                                children: message
                            })
                        })
                    })
                ]
            })
        ]
    });
}


var $a4ac175b7e0a20c1$exports = {};

$parcel$export($a4ac175b7e0a20c1$exports, "button", function () { return $a4ac175b7e0a20c1$export$2ba01fb71ed41cb6; }, function (v) { return $a4ac175b7e0a20c1$export$2ba01fb71ed41cb6 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "buttonWrapper", function () { return $a4ac175b7e0a20c1$export$a3b9b213fa74e4fd; }, function (v) { return $a4ac175b7e0a20c1$export$a3b9b213fa74e4fd = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "content", function () { return $a4ac175b7e0a20c1$export$a7db06668cad9adb; }, function (v) { return $a4ac175b7e0a20c1$export$a7db06668cad9adb = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "header", function () { return $a4ac175b7e0a20c1$export$38e42c68cf43b5d4; }, function (v) { return $a4ac175b7e0a20c1$export$38e42c68cf43b5d4 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "isOpen", function () { return $a4ac175b7e0a20c1$export$ea0830439c7fc698; }, function (v) { return $a4ac175b7e0a20c1$export$ea0830439c7fc698 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "isVisible", function () { return $a4ac175b7e0a20c1$export$795910f5f15a9633; }, function (v) { return $a4ac175b7e0a20c1$export$795910f5f15a9633 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "num", function () { return $a4ac175b7e0a20c1$export$61cc6a0be4938a2a; }, function (v) { return $a4ac175b7e0a20c1$export$61cc6a0be4938a2a = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "show", function () { return $a4ac175b7e0a20c1$export$57bf213be019eeb0; }, function (v) { return $a4ac175b7e0a20c1$export$57bf213be019eeb0 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "tooltip", function () { return $a4ac175b7e0a20c1$export$4e6f96734dfe12f4; }, function (v) { return $a4ac175b7e0a20c1$export$4e6f96734dfe12f4 = v; });
$parcel$export($a4ac175b7e0a20c1$exports, "wrapper", function () { return $a4ac175b7e0a20c1$export$cc74dcc53cfce4eb; }, function (v) { return $a4ac175b7e0a20c1$export$cc74dcc53cfce4eb = v; });
var $a4ac175b7e0a20c1$export$2ba01fb71ed41cb6;
var $a4ac175b7e0a20c1$export$a3b9b213fa74e4fd;
var $a4ac175b7e0a20c1$export$a7db06668cad9adb;
var $a4ac175b7e0a20c1$export$38e42c68cf43b5d4;
var $a4ac175b7e0a20c1$export$ea0830439c7fc698;
var $a4ac175b7e0a20c1$export$795910f5f15a9633;
var $a4ac175b7e0a20c1$export$61cc6a0be4938a2a;
var $a4ac175b7e0a20c1$export$57bf213be019eeb0;
var $a4ac175b7e0a20c1$export$4e6f96734dfe12f4;
var $a4ac175b7e0a20c1$export$cc74dcc53cfce4eb;
$a4ac175b7e0a20c1$export$2ba01fb71ed41cb6 = `DVFiga_button`;
$a4ac175b7e0a20c1$export$a3b9b213fa74e4fd = `DVFiga_buttonWrapper`;
$a4ac175b7e0a20c1$export$a7db06668cad9adb = `DVFiga_content`;
$a4ac175b7e0a20c1$export$38e42c68cf43b5d4 = `DVFiga_header`;
$a4ac175b7e0a20c1$export$ea0830439c7fc698 = `DVFiga_isOpen`;
$a4ac175b7e0a20c1$export$795910f5f15a9633 = `DVFiga_isVisible`;
$a4ac175b7e0a20c1$export$61cc6a0be4938a2a = `DVFiga_num`;
$a4ac175b7e0a20c1$export$57bf213be019eeb0 = `DVFiga_show`;
$a4ac175b7e0a20c1$export$4e6f96734dfe12f4 = `DVFiga_tooltip`;
$a4ac175b7e0a20c1$export$cc74dcc53cfce4eb = `DVFiga_wrapper`;



const $5376430f3892d5f5$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($a4ac175b7e0a20c1$exports);
function $5376430f3892d5f5$export$2e2bcd8739ae039({ slideableContent: slideableContent, header: header }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { bookings: bookings, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const contentRef = (0, $bh6RR.useRef)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [hideTooltip, setHideTooltip] = (0, $bh6RR.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).get('hideTooltip') || 'false');
    const intersection = (0, $12e08c191a152860$export$a7395f9832c00176)(header, {
        root: document,
        threshold: [
            0
        ]
    });
    const onClick = ()=>{
        if (contentRef.current) {
            const el = contentRef.current;
            if (slideableContent) slideableContent.style.transform = isOpen ? '' : `translateX(-${el.offsetWidth}px)`;
            setIsOpen(!isOpen);
            if (hideTooltip !== 'true') {
                setHideTooltip('true');
                (0, (/*@__PURE__*/$parcel$interopDefault($6f98ce5fa2dc1234$exports))).set('hideTooltip', 'true', {
                    expires: 3600 / 86400
                }); // expires in seconds converted to days
            }
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen && bookings?.length === 0) onClick();
    }, [
        bookings,
        isOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (contentRef.current && intersection) {
            const el = contentRef.current.parentElement;
            if (intersection.isIntersecting && el.classList.contains('fixed')) el.classList.remove('fixed');
            else if (!intersection.isIntersecting && !el.classList.contains('fixed')) el.classList.add('fixed');
        }
    }, [
        intersection
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: contentRef,
        className: $5376430f3892d5f5$var$cx($a4ac175b7e0a20c1$exports.wrapper, {
            isOpen: isOpen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $5376430f3892d5f5$var$cx($a4ac175b7e0a20c1$exports.buttonWrapper, {
                    isOpen: isOpen,
                    isVisible: bookings?.length > 0
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $5376430f3892d5f5$var$cx($a4ac175b7e0a20c1$exports.tooltip, {
                            show: bookings?.length > 0 && hideTooltip !== 'true'
                        }),
                        children: t('tooltip-here-is-your-bookings')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        tabIndex: "-1",
                        type: "button",
                        className: $a4ac175b7e0a20c1$exports.button,
                        onClick: onClick,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $5376430f3892d5f5$var$cx($a4ac175b7e0a20c1$exports.num, {
                                show: bookings?.length > 0
                            }),
                            children: bookings?.length
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $a4ac175b7e0a20c1$exports.content,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: $a4ac175b7e0a20c1$exports.header,
                        children: t('header-your-bookings')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                        children: bookings && bookings.map((booking)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $e195d2535fb91e12$export$2e2bcd8739ae039), {
                                booking: booking,
                                onCancel: getActiveBookings,
                                onEdit: isOpen ? onClick : null
                            }, booking.id))
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



function $ae610dbd0c463545$export$2e2bcd8739ae039({ region: region, onLocationSelected: onLocationSelected, parentLocation: parentLocation }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const ref = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        ref.current?.focus();
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
        initialValues: {
            destination: '',
            region: region
        },
        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)($ae610dbd0c463545$var$FormikListener, {
                    onLocationSelected: onLocationSelected
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                    name: "destination",
                    parentLocation: parentLocation,
                    placeholder: t('placeholder-add-stop'),
                    innerRef: ref,
                    component: (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039)
                })
            ]
        })
    });
}
const $ae610dbd0c463545$var$FormikListener = ({ onLocationSelected: onLocationSelected })=>{
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    const prevLocation = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(values.destination);
    (0, $bh6RR.useEffect)(()=>{
        if (values.destination?.address && values.destination !== prevLocation) onLocationSelected(values.destination);
    }, [
        values.destination
    ]);
    return null;
};



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

const $b1f47dcfa609295f$export$91b1e15bb76ddaff = /*#__PURE__*/ (0, $bh6RR.createContext)();
const $b1f47dcfa609295f$export$b2d7bc9e68dacbc = (p)=>{
    const { View: View, props: props } = (0, $bh6RR.useContext)($b1f47dcfa609295f$export$91b1e15bb76ddaff);
    const pr = {
        ...props,
        ...p
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)(View, {
        ...pr
    });
};
function $b1f47dcfa609295f$export$2e2bcd8739ae039({ views: views, complete: complete, sendEvent: sendEvent, initialView: initialView, onBack: onBack, children: children }) {
    if (!views?.length) return console.error('No views supplied');
    const parentContext = (0, $bh6RR.useContext)($b1f47dcfa609295f$export$91b1e15bb76ddaff);
    const [isWaitingForPoll, setIsWaitingForPoll] = (0, $bh6RR.useState)(false);
    const initialId = initialView && views.find((v)=>v.id === initialView) ? initialView : views[0].id;
    const [steps, setSteps] = (0, $bh6RR.useState)([
        initialId
    ]);
    // Listen for waiting for poll state
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('BOOKING_WAITING_FOR_POLL', ({ waiting: waiting })=>{
        setIsWaitingForPoll(waiting || false);
    }, []);
    const getCurrentId = ()=>{
        return steps[steps.length - 1];
    };
    const getCurrentView = ()=>{
        const id = getCurrentId();
        const view = views.find((item)=>item.id === id);
        return [
            id,
            view?.component,
            view?.props
        ];
    };
    const prev = (id)=>{
        // Don't allow navigation when waiting for poll
        if (isWaitingForPoll) return;
        // If a requested id is not in steps but in views ie. jump back to a prev not visited view...
        if (typeof id === 'string' && steps.findIndex((item)=>item === id) === -1 && views.findIndex((item)=>item.id === id)) {
            const index = views.findIndex((item)=>item.id === id);
            setSteps(views.filter((item, i)=>i < index + 1).map((item)=>item.id));
        } else if (typeof id === 'string' && steps.findIndex((item)=>item === id) !== -1) {
            const index = steps.findIndex((item)=>item === id);
            setSteps((previous)=>previous.slice(0, index + 1));
        } else if (steps.length > 1) setSteps((previous)=>previous.slice(0, previous.length - 1));
        else if (onBack) onBack();
        else if (parentContext?.prev) parentContext.prev(id);
    };
    const next = (id)=>{
        // Don't allow navigation when waiting for poll (except for done step which is handled by ConfirmBooking)
        if (isWaitingForPoll && id !== 'done') return;
        if (typeof id !== 'string') {
            const index = views.findIndex((item)=>item.id === getCurrentId());
            if (index + 1 < views.length) id = views[index + 1].id;
            else if (parentContext?.next) parentContext.next();
            else if (complete) complete();
        }
        if (typeof id === 'string' && views.findIndex((item)=>item.id === id) !== -1) setSteps((previous)=>[
                ...previous,
                id
            ]);
    // TODO: Remove this, used for debugging only
    // else {
    //   console.error(`No view "${id}" found!`)
    // }
    };
    const reset = ()=>{
        setSteps([
            views[0].id
        ]);
    };
    const [id, View, props] = getCurrentView();
    // Emit event with the current id for parent components
    // NOTE: maybe add an id for the stepper also
    (0, $bh6RR.useEffect)(()=>{
        if (sendEvent === true) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('VIEW_CHANGE', {
            id: id
        });
    }, [
        id,
        sendEvent
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)($b1f47dcfa609295f$export$91b1e15bb76ddaff.Provider, {
        value: {
            prev: prev,
            next: next,
            reset: reset,
            parentContext: parentContext,
            id: id,
            View: View,
            props: props
        },
        children: typeof children !== 'function' ? children : children({
            prev: prev,
            next: next,
            reset: reset,
            parentContext: parentContext,
            id: id,
            View: View,
            props: props
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $lW2XZ = parcelRequire("lW2XZ");




var $edbd2298efd2b44f$export$34e0f9847d4c02dd;
var $edbd2298efd2b44f$export$af309894e65e3534;
var $edbd2298efd2b44f$export$fb184b623420d9be;
var $edbd2298efd2b44f$export$cc74dcc53cfce4eb;
$edbd2298efd2b44f$export$34e0f9847d4c02dd = `_65QRaW_container`;
$edbd2298efd2b44f$export$af309894e65e3534 = `_65QRaW_mapButtons`;
$edbd2298efd2b44f$export$fb184b623420d9be = `_65QRaW_title`;
$edbd2298efd2b44f$export$cc74dcc53cfce4eb = `_65QRaW_wrapper`;


const $fe006b865354386b$export$b2e9cb17ec66c407 = ({ id: id })=>{
    const { values: values, errors: errors, resetForm: resetForm } = (0, $lW2XZ.useFormikContext)();
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('LOG_VALUES', (targetId)=>{}, [
        values,
        errors
    ]);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_VALUES', (targetId)=>{
        if (id === targetId) resetForm();
    }, [
        resetForm
    ]);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('SEARCH', (query)=>{
        (0, $135a523c4bea715f$export$ce3a8ce471b7d4ad)(query, false).then((locations)=>{}).catch((error)=>{
            if (error.name !== 'AbortError') console.error(error.message);
        });
    }, []);
    return null;
};
function $fe006b865354386b$export$2e2bcd8739ae039() {
    const { user: user, bookings: bookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports)))($edbd2298efd2b44f$export$cc74dcc53cfce4eb, $edbd2298efd2b44f$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $edbd2298efd2b44f$export$fb184b623420d9be,
                children: "Debug:"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>void 0,
                children: "User"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>void 0,
                children: "Bookings"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "|"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('LOG_VALUES', 'main'),
                children: "Booking values"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_VALUES', 'main'),
                children: "Reset"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "|"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('LOG_VALUES', 'package'),
                children: "Package values"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('LOG_VALUES', 'otp'),
                children: "OTP values"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                children: "|"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SEARCH', 'kva'),
                children: "Search 1"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SEARCH', 'kvarn'),
                children: "Search 2"
            })
        ]
    });
}





// Maps a booking from the API (flat locations, vehicleOptions array, paymentStatus) onto
// the booking form's Formik values. Shared by the edit flow (EDIT_BOOKING) and the
// return trip sheet (RETURN_TRIP_BOOKING).
// The booking API returns flat locations, but the form expects a nested address object.
const $41fa9b8a4b906cc1$export$32eda01d55099ab8 = (loc, isOriginWithFlightInfo = false)=>{
    if (!loc) return null;
    // Add FLIGHT_NBR tag to locationInformation if this is an airport (has flight info)
    const locationInformation = loc.locationInformation || [];
    if (isOriginWithFlightInfo && !locationInformation.some((info)=>info.tag === 'FLIGHT_NBR')) locationInformation.push({
        tag: 'FLIGHT_NBR'
    });
    return {
        ...loc,
        address: {
            streetName: loc.streetName,
            streetNumber: loc.streetNumber,
            city: loc.city,
            municipality: loc.municipality,
            zone: loc.zone,
            position: loc.position,
            region: loc.region,
            connectedRegions: loc.connectedRegions,
            locationType: loc.locationType,
            countryCode: loc.countryCode,
            poiName: loc.poiName
        },
        locationInformation: locationInformation
    };
};
const $41fa9b8a4b906cc1$export$c6c55fc676373d68 = (booking)=>{
    const vehicleOptionsArray = booking.vehicleOptions || [];
    // Handle estate as taxi + stationWagon
    const isEstate = booking.serviceType === 'taxi' && vehicleOptionsArray.includes('stationWagon');
    return {
        serviceType: isEstate ? 'estate' : booking.serviceType,
        pet: vehicleOptionsArray.includes('pet'),
        low: vehicleOptionsArray.includes('low'),
        // When serviceType is 'estate', stationWagon is already represented, so don't show it as separate option
        stationWagon: isEstate ? false : vehicleOptionsArray.includes('stationWagon'),
        rearFacingChildSeat: vehicleOptionsArray.includes('rearFacingChildSeat'),
        booster: vehicleOptionsArray.filter((opt)=>opt.startsWith('boosterSeat')).length,
        electric: vehicleOptionsArray.includes('electric')
    };
};
const $41fa9b8a4b906cc1$export$78159ad0f2a992bf = (booking, user, paymentAccounts)=>{
    let account = false;
    let payment = 'DefaultNoSelect';
    if (booking.paymentStatus?.paymentMethod === 'CreditCard') {
        account = paymentAccounts?.find((acc)=>acc.accountId === booking.paymentStatus.accountNumber);
        if (account) payment = `CreditCard-${account.accountId}`;
        else if (booking.paymentStatus.accountNumber) {
            // Handle credit card that's no longer in user's profile (orphaned)
            payment = `CreditCard-Orphaned-${booking.paymentStatus.accountNumber}`;
            account = {
                accountId: booking.paymentStatus.accountNumber,
                maskedAccount: booking.paymentStatus.paymentMethodLabel || 'Credit Card',
                cardType: 'Unknown',
                type: 'creditcard',
                isOrphaned: true
            };
        }
    } else if (booking.paymentMethod === 'PayInCar') payment = 'PayInCar';
    else if (booking.paymentMethod === 'Klarna' || booking.paymentStatus?.paymentMethod === 'Klarna') // Handle Klarna payments from other channels
    payment = 'Klarna';
    else if (booking.paymentMethod === 'ApplePay' || booking.paymentStatus?.paymentMethod === 'ApplePay') // Handle ApplePay payments from other channels
    payment = 'ApplePay';
    else if (booking.account) {
        // Find the full account object from user's accounts (has flags and other properties)
        account = user?.accounts?.find((acc)=>acc.accountNumber === booking.account.number);
        if (account) payment = `Account-${account.accountNumber}`;
        else {
            // Fallback to booking account if not found in user's accounts (orphaned)
            payment = `Account-Orphaned-${booking.account.number}`;
            account = {
                accountNumber: booking.account.number,
                accountName: booking.account.name || 'Account',
                type: booking.account.type || 'TSAB',
                isOrphaned: true
            };
        }
    }
    return {
        payment: payment,
        account: account
    };
};
const $41fa9b8a4b906cc1$export$a48220273aa14edc = (payment, account)=>{
    if (account?.isOrphaned) return false;
    return payment === 'PayInCar' || /^(CreditCard|Account)-/.test(payment || '');
};





var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");
// ES6 Map
var $df3a053a1f092148$var$map;
try {
    $df3a053a1f092148$var$map = Map;
} catch (_) {}
var $df3a053a1f092148$var$set;
// ES6 Set
try {
    $df3a053a1f092148$var$set = Set;
} catch (_) {}
function $df3a053a1f092148$var$baseClone(src, circulars, clones) {
    // Null/undefined/functions/etc
    if (!src || typeof src !== 'object' || typeof src === 'function') return src;
    // DOM Node
    if (src.nodeType && 'cloneNode' in src) return src.cloneNode(true);
    // Date
    if (src instanceof Date) return new Date(src.getTime());
    // RegExp
    if (src instanceof RegExp) return new RegExp(src);
    // Arrays
    if (Array.isArray(src)) return src.map($df3a053a1f092148$export$2e2bcd8739ae039);
    // ES6 Maps
    if ($df3a053a1f092148$var$map && src instanceof $df3a053a1f092148$var$map) return new Map(Array.from(src.entries()));
    // ES6 Sets
    if ($df3a053a1f092148$var$set && src instanceof $df3a053a1f092148$var$set) return new Set(Array.from(src.values()));
    // Object
    if (src instanceof Object) {
        circulars.push(src);
        var obj = Object.create(src);
        clones.push(obj);
        for(var key in src){
            var idx = circulars.findIndex(function(i) {
                return i === src[key];
            });
            obj[key] = idx > -1 ? clones[idx] : $df3a053a1f092148$var$baseClone(src[key], circulars, clones);
        }
        return obj;
    }
    // ???
    return src;
}
function $df3a053a1f092148$export$2e2bcd8739ae039(src) {
    return $df3a053a1f092148$var$baseClone(src, [], []);
}


const $c17a300a1d15ba7f$var$toString = Object.prototype.toString;
const $c17a300a1d15ba7f$var$errorToString = Error.prototype.toString;
const $c17a300a1d15ba7f$var$regExpToString = RegExp.prototype.toString;
const $c17a300a1d15ba7f$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $c17a300a1d15ba7f$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $c17a300a1d15ba7f$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $c17a300a1d15ba7f$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $c17a300a1d15ba7f$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $c17a300a1d15ba7f$var$symbolToString.call(val).replace($c17a300a1d15ba7f$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $c17a300a1d15ba7f$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $c17a300a1d15ba7f$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $c17a300a1d15ba7f$var$regExpToString.call(val);
    return null;
}
function $c17a300a1d15ba7f$export$2e2bcd8739ae039(value, quoteStrings) {
    let result = $c17a300a1d15ba7f$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $c17a300a1d15ba7f$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}


let $e918c4ca8768491c$export$9b30b6294c1449a8 = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        let isCast = originalValue != null && originalValue !== value;
        let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${(0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(value, true)}\`` + (isCast ? ` (cast from the value \`${(0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(originalValue, true)}\`).` : '.');
        if (value === null) msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
        return msg;
    },
    defined: '${path} must be defined'
};
let $e918c4ca8768491c$export$22b082955e083ec3 = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $e918c4ca8768491c$export$98e628dec113755e = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $e918c4ca8768491c$export$324d90190a8b822a = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $e918c4ca8768491c$export$4a21f16c33752377 = {
    isValue: '${path} field must be ${value}'
};
let $e918c4ca8768491c$export$be5493f9613cbbe = {
    noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let $e918c4ca8768491c$export$2f23118c22fb2630 = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
var $e918c4ca8768491c$export$2e2bcd8739ae039 = Object.assign(Object.create(null), {
    mixed: $e918c4ca8768491c$export$9b30b6294c1449a8,
    string: $e918c4ca8768491c$export$22b082955e083ec3,
    number: $e918c4ca8768491c$export$98e628dec113755e,
    date: $e918c4ca8768491c$export$324d90190a8b822a,
    object: $e918c4ca8768491c$export$be5493f9613cbbe,
    array: $e918c4ca8768491c$export$2f23118c22fb2630,
    boolean: $e918c4ca8768491c$export$4a21f16c33752377
});


var $57951377449b53e6$exports = {};
var $0a3bfcba9cfb2344$exports = {};
/** Used for built-in method references. */ var $0a3bfcba9cfb2344$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0a3bfcba9cfb2344$var$hasOwnProperty = $0a3bfcba9cfb2344$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $0a3bfcba9cfb2344$var$baseHas(object, key) {
    return object != null && $0a3bfcba9cfb2344$var$hasOwnProperty.call(object, key);
}
$0a3bfcba9cfb2344$exports = $0a3bfcba9cfb2344$var$baseHas;


var $15587d13e03f2293$exports = {};
var $fe9c73848a5358a3$exports = {};
var $730d1b366662da48$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $730d1b366662da48$var$isArray = Array.isArray;
$730d1b366662da48$exports = $730d1b366662da48$var$isArray;


var $b862d544b65a608a$exports = {};

var $42e9ee7d3311848a$exports = {};
var $396b15940342a7f1$exports = {};
var $2388da93fa592950$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $2388da93fa592950$var$Symbol = $dnnhb.Symbol;
$2388da93fa592950$exports = $2388da93fa592950$var$Symbol;


var $8005b8efeeb9f4e7$exports = {};

/** Used for built-in method references. */ var $8005b8efeeb9f4e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8005b8efeeb9f4e7$var$hasOwnProperty = $8005b8efeeb9f4e7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8005b8efeeb9f4e7$var$nativeObjectToString = $8005b8efeeb9f4e7$var$objectProto.toString;
/** Built-in value references. */ var $8005b8efeeb9f4e7$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8005b8efeeb9f4e7$var$getRawTag(value) {
    var isOwn = $8005b8efeeb9f4e7$var$hasOwnProperty.call(value, $8005b8efeeb9f4e7$var$symToStringTag), tag = value[$8005b8efeeb9f4e7$var$symToStringTag];
    try {
        value[$8005b8efeeb9f4e7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8005b8efeeb9f4e7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8005b8efeeb9f4e7$var$symToStringTag] = tag;
        else delete value[$8005b8efeeb9f4e7$var$symToStringTag];
    }
    return result;
}
$8005b8efeeb9f4e7$exports = $8005b8efeeb9f4e7$var$getRawTag;


var $8777fc9d1b1902f9$exports = {};
/** Used for built-in method references. */ var $8777fc9d1b1902f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8777fc9d1b1902f9$var$nativeObjectToString = $8777fc9d1b1902f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8777fc9d1b1902f9$var$objectToString(value) {
    return $8777fc9d1b1902f9$var$nativeObjectToString.call(value);
}
$8777fc9d1b1902f9$exports = $8777fc9d1b1902f9$var$objectToString;


/** `Object#toString` result references. */ var $396b15940342a7f1$var$nullTag = '[object Null]', $396b15940342a7f1$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $396b15940342a7f1$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $396b15940342a7f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $396b15940342a7f1$var$undefinedTag : $396b15940342a7f1$var$nullTag;
    return $396b15940342a7f1$var$symToStringTag && $396b15940342a7f1$var$symToStringTag in Object(value) ? $8005b8efeeb9f4e7$exports(value) : $8777fc9d1b1902f9$exports(value);
}
$396b15940342a7f1$exports = $396b15940342a7f1$var$baseGetTag;


var $4a94b44c4940d5a5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a94b44c4940d5a5$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$4a94b44c4940d5a5$exports = $4a94b44c4940d5a5$var$isObjectLike;


/** `Object#toString` result references. */ var $42e9ee7d3311848a$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $42e9ee7d3311848a$var$isSymbol(value) {
    return typeof value == 'symbol' || $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $42e9ee7d3311848a$var$symbolTag;
}
$42e9ee7d3311848a$exports = $42e9ee7d3311848a$var$isSymbol;


/** Used to match property names within property paths. */ var $b862d544b65a608a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $b862d544b65a608a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $b862d544b65a608a$var$isKey(value, object) {
    if ($730d1b366662da48$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $42e9ee7d3311848a$exports(value)) return true;
    return $b862d544b65a608a$var$reIsPlainProp.test(value) || !$b862d544b65a608a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$b862d544b65a608a$exports = $b862d544b65a608a$var$isKey;


var $151c0e66f55bb8a0$exports = {};
var $31b0b104ae58f2f5$exports = {};
var $78841c5cb95dbb3f$exports = {};
var $eb2847cf8b43e448$exports = {};
var $0ef93b41d443d840$exports = {};
var $096b6e8d9d98217d$exports = {};
var $a41c4150a4a0597c$exports = {};
var $3775533b2ea97104$exports = {};
var $507cda0e3d4397c2$exports = {};
var $8d02eb250319088c$exports = {};
var $3c413d87f292fe2c$exports = {};

var $e4bea0192758232a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$e4bea0192758232a$exports = $e4bea0192758232a$var$isObject;


/** `Object#toString` result references. */ var $3c413d87f292fe2c$var$asyncTag = '[object AsyncFunction]', $3c413d87f292fe2c$var$funcTag = '[object Function]', $3c413d87f292fe2c$var$genTag = '[object GeneratorFunction]', $3c413d87f292fe2c$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3c413d87f292fe2c$var$isFunction(value) {
    if (!$e4bea0192758232a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $396b15940342a7f1$exports(value);
    return tag == $3c413d87f292fe2c$var$funcTag || tag == $3c413d87f292fe2c$var$genTag || tag == $3c413d87f292fe2c$var$asyncTag || tag == $3c413d87f292fe2c$var$proxyTag;
}
$3c413d87f292fe2c$exports = $3c413d87f292fe2c$var$isFunction;


var $53e75170d73e0e3c$exports = {};
var $558079b1ab119fea$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Used to detect overreaching core-js shims. */ var $558079b1ab119fea$var$coreJsData = $dnnhb["__core-js_shared__"];
$558079b1ab119fea$exports = $558079b1ab119fea$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $53e75170d73e0e3c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($558079b1ab119fea$exports && $558079b1ab119fea$exports.keys && $558079b1ab119fea$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $53e75170d73e0e3c$var$isMasked(func) {
    return !!$53e75170d73e0e3c$var$maskSrcKey && $53e75170d73e0e3c$var$maskSrcKey in func;
}
$53e75170d73e0e3c$exports = $53e75170d73e0e3c$var$isMasked;



var $5d4c9208b54c16cf$exports = {};
/** Used for built-in method references. */ var $5d4c9208b54c16cf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5d4c9208b54c16cf$var$funcToString = $5d4c9208b54c16cf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5d4c9208b54c16cf$var$toSource(func) {
    if (func != null) {
        try {
            return $5d4c9208b54c16cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$5d4c9208b54c16cf$exports = $5d4c9208b54c16cf$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d02eb250319088c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d02eb250319088c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d02eb250319088c$var$funcProto = Function.prototype, $8d02eb250319088c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d02eb250319088c$var$funcToString = $8d02eb250319088c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d02eb250319088c$var$hasOwnProperty = $8d02eb250319088c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d02eb250319088c$var$reIsNative = RegExp('^' + $8d02eb250319088c$var$funcToString.call($8d02eb250319088c$var$hasOwnProperty).replace($8d02eb250319088c$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d02eb250319088c$var$baseIsNative(value) {
    if (!$e4bea0192758232a$exports(value) || $53e75170d73e0e3c$exports(value)) return false;
    var pattern = $3c413d87f292fe2c$exports(value) ? $8d02eb250319088c$var$reIsNative : $8d02eb250319088c$var$reIsHostCtor;
    return pattern.test($5d4c9208b54c16cf$exports(value));
}
$8d02eb250319088c$exports = $8d02eb250319088c$var$baseIsNative;


var $d117e89f87247905$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d117e89f87247905$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d117e89f87247905$exports = $d117e89f87247905$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $507cda0e3d4397c2$var$getNative(object, key) {
    var value = $d117e89f87247905$exports(object, key);
    return $8d02eb250319088c$exports(value) ? value : undefined;
}
$507cda0e3d4397c2$exports = $507cda0e3d4397c2$var$getNative;


/* Built-in method references that are verified to be native. */ var $3775533b2ea97104$var$nativeCreate = $507cda0e3d4397c2$exports(Object, 'create');
$3775533b2ea97104$exports = $3775533b2ea97104$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a41c4150a4a0597c$var$hashClear() {
    this.__data__ = $3775533b2ea97104$exports ? $3775533b2ea97104$exports(null) : {};
    this.size = 0;
}
$a41c4150a4a0597c$exports = $a41c4150a4a0597c$var$hashClear;


var $512e538f8ec06abe$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512e538f8ec06abe$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$512e538f8ec06abe$exports = $512e538f8ec06abe$var$hashDelete;


var $305befcd54445446$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $305befcd54445446$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $305befcd54445446$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $305befcd54445446$var$hasOwnProperty = $305befcd54445446$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $305befcd54445446$var$hashGet(key) {
    var data = this.__data__;
    if ($3775533b2ea97104$exports) {
        var result = data[key];
        return result === $305befcd54445446$var$HASH_UNDEFINED ? undefined : result;
    }
    return $305befcd54445446$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$305befcd54445446$exports = $305befcd54445446$var$hashGet;


var $e98c409e6c78ac8d$exports = {};

/** Used for built-in method references. */ var $e98c409e6c78ac8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e98c409e6c78ac8d$var$hasOwnProperty = $e98c409e6c78ac8d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e98c409e6c78ac8d$var$hashHas(key) {
    var data = this.__data__;
    return $3775533b2ea97104$exports ? data[key] !== undefined : $e98c409e6c78ac8d$var$hasOwnProperty.call(data, key);
}
$e98c409e6c78ac8d$exports = $e98c409e6c78ac8d$var$hashHas;


var $5aa4d120853b2dad$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $5aa4d120853b2dad$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5aa4d120853b2dad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3775533b2ea97104$exports && value === undefined ? $5aa4d120853b2dad$var$HASH_UNDEFINED : value;
    return this;
}
$5aa4d120853b2dad$exports = $5aa4d120853b2dad$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096b6e8d9d98217d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096b6e8d9d98217d$var$Hash.prototype.clear = $a41c4150a4a0597c$exports;
$096b6e8d9d98217d$var$Hash.prototype['delete'] = $512e538f8ec06abe$exports;
$096b6e8d9d98217d$var$Hash.prototype.get = $305befcd54445446$exports;
$096b6e8d9d98217d$var$Hash.prototype.has = $e98c409e6c78ac8d$exports;
$096b6e8d9d98217d$var$Hash.prototype.set = $5aa4d120853b2dad$exports;
$096b6e8d9d98217d$exports = $096b6e8d9d98217d$var$Hash;


var $6600d6a94bbfda55$exports = {};
var $88f8a458a1ebfb99$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88f8a458a1ebfb99$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$88f8a458a1ebfb99$exports = $88f8a458a1ebfb99$var$listCacheClear;


var $ed3d1b1aa1c6eb21$exports = {};
var $f0b9af7eb68dc1e4$exports = {};
var $d3b5784bbbc55641$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d3b5784bbbc55641$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d3b5784bbbc55641$exports = $d3b5784bbbc55641$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0b9af7eb68dc1e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d3b5784bbbc55641$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f0b9af7eb68dc1e4$exports = $f0b9af7eb68dc1e4$var$assocIndexOf;


/** Used for built-in method references. */ var $ed3d1b1aa1c6eb21$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ed3d1b1aa1c6eb21$var$splice = $ed3d1b1aa1c6eb21$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed3d1b1aa1c6eb21$var$listCacheDelete(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ed3d1b1aa1c6eb21$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$ed3d1b1aa1c6eb21$exports = $ed3d1b1aa1c6eb21$var$listCacheDelete;


var $22784f0ffcbfc03d$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22784f0ffcbfc03d$var$listCacheGet(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$22784f0ffcbfc03d$exports = $22784f0ffcbfc03d$var$listCacheGet;


var $4d131af2d890865b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d131af2d890865b$var$listCacheHas(key) {
    return $f0b9af7eb68dc1e4$exports(this.__data__, key) > -1;
}
$4d131af2d890865b$exports = $4d131af2d890865b$var$listCacheHas;


var $0a2d0ac185e5d2a7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a2d0ac185e5d2a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0a2d0ac185e5d2a7$exports = $0a2d0ac185e5d2a7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6600d6a94bbfda55$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6600d6a94bbfda55$var$ListCache.prototype.clear = $88f8a458a1ebfb99$exports;
$6600d6a94bbfda55$var$ListCache.prototype['delete'] = $ed3d1b1aa1c6eb21$exports;
$6600d6a94bbfda55$var$ListCache.prototype.get = $22784f0ffcbfc03d$exports;
$6600d6a94bbfda55$var$ListCache.prototype.has = $4d131af2d890865b$exports;
$6600d6a94bbfda55$var$ListCache.prototype.set = $0a2d0ac185e5d2a7$exports;
$6600d6a94bbfda55$exports = $6600d6a94bbfda55$var$ListCache;


var $ab52caa45642ed43$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $ab52caa45642ed43$var$Map = $507cda0e3d4397c2$exports($dnnhb, 'Map');
$ab52caa45642ed43$exports = $ab52caa45642ed43$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0ef93b41d443d840$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $096b6e8d9d98217d$exports,
        'map': new ($ab52caa45642ed43$exports || $6600d6a94bbfda55$exports),
        'string': new $096b6e8d9d98217d$exports
    };
}
$0ef93b41d443d840$exports = $0ef93b41d443d840$var$mapCacheClear;


var $d766380f20569b4b$exports = {};
var $134523692be3fdae$exports = {};
var $674a762a247d0e5a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $674a762a247d0e5a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$674a762a247d0e5a$exports = $674a762a247d0e5a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $134523692be3fdae$var$getMapData(map, key) {
    var data = map.__data__;
    return $674a762a247d0e5a$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$134523692be3fdae$exports = $134523692be3fdae$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d766380f20569b4b$var$mapCacheDelete(key) {
    var result = $134523692be3fdae$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d766380f20569b4b$exports = $d766380f20569b4b$var$mapCacheDelete;


var $31567d8d775c5c8a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $31567d8d775c5c8a$var$mapCacheGet(key) {
    return $134523692be3fdae$exports(this, key).get(key);
}
$31567d8d775c5c8a$exports = $31567d8d775c5c8a$var$mapCacheGet;


var $3d8e18ae61a2fd42$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d8e18ae61a2fd42$var$mapCacheHas(key) {
    return $134523692be3fdae$exports(this, key).has(key);
}
$3d8e18ae61a2fd42$exports = $3d8e18ae61a2fd42$var$mapCacheHas;


var $908883b24173d38c$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $908883b24173d38c$var$mapCacheSet(key, value) {
    var data = $134523692be3fdae$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$908883b24173d38c$exports = $908883b24173d38c$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eb2847cf8b43e448$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eb2847cf8b43e448$var$MapCache.prototype.clear = $0ef93b41d443d840$exports;
$eb2847cf8b43e448$var$MapCache.prototype['delete'] = $d766380f20569b4b$exports;
$eb2847cf8b43e448$var$MapCache.prototype.get = $31567d8d775c5c8a$exports;
$eb2847cf8b43e448$var$MapCache.prototype.has = $3d8e18ae61a2fd42$exports;
$eb2847cf8b43e448$var$MapCache.prototype.set = $908883b24173d38c$exports;
$eb2847cf8b43e448$exports = $eb2847cf8b43e448$var$MapCache;


/** Error message constants. */ var $78841c5cb95dbb3f$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $78841c5cb95dbb3f$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($78841c5cb95dbb3f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($78841c5cb95dbb3f$var$memoize.Cache || $eb2847cf8b43e448$exports);
    return memoized;
}
// Expose `MapCache`.
$78841c5cb95dbb3f$var$memoize.Cache = $eb2847cf8b43e448$exports;
$78841c5cb95dbb3f$exports = $78841c5cb95dbb3f$var$memoize;


/** Used as the maximum memoize cache size. */ var $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $31b0b104ae58f2f5$var$memoizeCapped(func) {
    var result = $78841c5cb95dbb3f$exports(func, function(key) {
        if (cache.size === $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$31b0b104ae58f2f5$exports = $31b0b104ae58f2f5$var$memoizeCapped;


/** Used to match property names within property paths. */ var $151c0e66f55bb8a0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $151c0e66f55bb8a0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $151c0e66f55bb8a0$var$stringToPath = $31b0b104ae58f2f5$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($151c0e66f55bb8a0$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($151c0e66f55bb8a0$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$151c0e66f55bb8a0$exports = $151c0e66f55bb8a0$var$stringToPath;


var $a863ad98b2851f02$exports = {};
var $2859adc7c6ec1638$exports = {};

var $2984cf9c242fe53a$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2984cf9c242fe53a$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$2984cf9c242fe53a$exports = $2984cf9c242fe53a$var$arrayMap;




/** Used as references for various `Number` constants. */ var $2859adc7c6ec1638$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2859adc7c6ec1638$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $2859adc7c6ec1638$var$symbolToString = $2859adc7c6ec1638$var$symbolProto ? $2859adc7c6ec1638$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2859adc7c6ec1638$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($730d1b366662da48$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $2984cf9c242fe53a$exports(value, $2859adc7c6ec1638$var$baseToString) + '';
    if ($42e9ee7d3311848a$exports(value)) return $2859adc7c6ec1638$var$symbolToString ? $2859adc7c6ec1638$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$2859adc7c6ec1638$var$INFINITY ? '-0' : result;
}
$2859adc7c6ec1638$exports = $2859adc7c6ec1638$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a863ad98b2851f02$var$toString(value) {
    return value == null ? '' : $2859adc7c6ec1638$exports(value);
}
$a863ad98b2851f02$exports = $a863ad98b2851f02$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $fe9c73848a5358a3$var$castPath(value, object) {
    if ($730d1b366662da48$exports(value)) return value;
    return $b862d544b65a608a$exports(value, object) ? [
        value
    ] : $151c0e66f55bb8a0$exports($a863ad98b2851f02$exports(value));
}
$fe9c73848a5358a3$exports = $fe9c73848a5358a3$var$castPath;


var $dd94877d05f10850$exports = {};
var $8f38f8261e818ef2$exports = {};


/** `Object#toString` result references. */ var $8f38f8261e818ef2$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8f38f8261e818ef2$var$baseIsArguments(value) {
    return $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $8f38f8261e818ef2$var$argsTag;
}
$8f38f8261e818ef2$exports = $8f38f8261e818ef2$var$baseIsArguments;



/** Used for built-in method references. */ var $dd94877d05f10850$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd94877d05f10850$var$hasOwnProperty = $dd94877d05f10850$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dd94877d05f10850$var$propertyIsEnumerable = $dd94877d05f10850$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dd94877d05f10850$var$isArguments = $8f38f8261e818ef2$exports(function() {
    return arguments;
}()) ? $8f38f8261e818ef2$exports : function(value) {
    return $4a94b44c4940d5a5$exports(value) && $dd94877d05f10850$var$hasOwnProperty.call(value, 'callee') && !$dd94877d05f10850$var$propertyIsEnumerable.call(value, 'callee');
};
$dd94877d05f10850$exports = $dd94877d05f10850$var$isArguments;



var $ec0ca5ffb2ff14ec$exports = {};
/** Used as references for various `Number` constants. */ var $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec0ca5ffb2ff14ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec0ca5ffb2ff14ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $ec0ca5ffb2ff14ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ec0ca5ffb2ff14ec$exports = $ec0ca5ffb2ff14ec$var$isIndex;


var $cb5309a5575a37b9$exports = {};
/** Used as references for various `Number` constants. */ var $cb5309a5575a37b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cb5309a5575a37b9$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $cb5309a5575a37b9$var$MAX_SAFE_INTEGER;
}
$cb5309a5575a37b9$exports = $cb5309a5575a37b9$var$isLength;


var $c4981d9c30ac136e$exports = {};

/** Used as references for various `Number` constants. */ var $c4981d9c30ac136e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c4981d9c30ac136e$var$toKey(value) {
    if (typeof value == 'string' || $42e9ee7d3311848a$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c4981d9c30ac136e$var$INFINITY ? '-0' : result;
}
$c4981d9c30ac136e$exports = $c4981d9c30ac136e$var$toKey;


/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $15587d13e03f2293$var$hasPath(object, path, hasFunc) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $c4981d9c30ac136e$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cb5309a5575a37b9$exports(length) && $ec0ca5ffb2ff14ec$exports(key, length) && ($730d1b366662da48$exports(object) || $dd94877d05f10850$exports(object));
}
$15587d13e03f2293$exports = $15587d13e03f2293$var$hasPath;


/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $57951377449b53e6$var$has(object, path) {
    return object != null && $15587d13e03f2293$exports(object, path, $0a3bfcba9cfb2344$exports);
}
$57951377449b53e6$exports = $57951377449b53e6$var$has;


const $a379620def444ff5$var$isSchema = (obj)=>obj && obj.__isYupSchema__;
var $a379620def444ff5$export$2e2bcd8739ae039 = $a379620def444ff5$var$isSchema;


class $1847512880a44a81$var$Condition {
    constructor(refs, options){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        if (typeof options === 'function') {
            this.fn = options;
            return;
        }
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($57951377449b53e6$exports)))(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
        if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = options;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        this.fn = function(...args) {
            let options = args.pop();
            let schema = args.pop();
            let branch = check(...args) ? then : otherwise;
            if (!branch) return undefined;
            if (typeof branch === 'function') return branch(schema);
            return schema.concat(branch.resolve(options));
        };
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn.apply(base, values.concat(base, options));
        if (schema === undefined || schema === base) return base;
        if (!(0, $a379620def444ff5$export$2e2bcd8739ae039)(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
var $1847512880a44a81$export$2e2bcd8739ae039 = $1847512880a44a81$var$Condition;



function $88c746c2c38495a5$export$2e2bcd8739ae039(value) {
    return value == null ? [] : [].concat(value);
}


function $841702205e82e4dd$var$_extends() {
    $841702205e82e4dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $841702205e82e4dd$var$_extends.apply(this, arguments);
}
let $841702205e82e4dd$var$strReg = /\$\{\s*(\w+)\s*\}/g;
class $841702205e82e4dd$export$2e2bcd8739ae039 extends Error {
    static formatError(message, params) {
        const path = params.label || params.path || 'this';
        if (path !== params.path) params = $841702205e82e4dd$var$_extends({}, params, {
            path: path
        });
        if (typeof message === 'string') return message.replace($841702205e82e4dd$var$strReg, (_, key)=>(0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type){
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.errors = void 0;
        this.params = void 0;
        this.inner = void 0;
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        (0, $88c746c2c38495a5$export$2e2bcd8739ae039)(errorOrErrors).forEach((err)=>{
            if ($841702205e82e4dd$export$2e2bcd8739ae039.isError(err)) {
                this.errors.push(...err.errors);
                this.inner = this.inner.concat(err.inner.length ? err.inner : err);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $841702205e82e4dd$export$2e2bcd8739ae039);
    }
}


const $a2a091fa47a581a7$var$once = (cb)=>{
    let fired = false;
    return (...args)=>{
        if (fired) return;
        fired = true;
        cb(...args);
    };
};
function $a2a091fa47a581a7$export$2e2bcd8739ae039(options, cb) {
    let { endEarly: endEarly, tests: tests, args: args, value: value, errors: errors, sort: sort, path: path } = options;
    let callback = $a2a091fa47a581a7$var$once(cb);
    let count = tests.length;
    const nestedErrors = [];
    errors = errors ? errors : [];
    if (!count) return errors.length ? callback(new (0, $841702205e82e4dd$export$2e2bcd8739ae039)(errors, value, path)) : callback(null, value);
    for(let i = 0; i < tests.length; i++){
        const test = tests[i];
        test(args, function finishTestRun(err) {
            if (err) {
                // always return early for non validation errors
                if (!(0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(err)) return callback(err, value);
                if (endEarly) {
                    err.value = value;
                    return callback(err, value);
                }
                nestedErrors.push(err);
            }
            if (--count <= 0) {
                if (nestedErrors.length) {
                    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name
                    if (errors.length) nestedErrors.push(...errors);
                    errors = nestedErrors;
                }
                if (errors.length) {
                    callback(new (0, $841702205e82e4dd$export$2e2bcd8739ae039)(errors, value, path), value);
                    return;
                }
                callback(null, value);
            }
        });
    }
}


var $468520a99798aaf1$exports = {};
var $7ac8911b657c3928$exports = {};
var $63ec4d08c2de17a4$exports = {};

var $63ec4d08c2de17a4$var$defineProperty = function() {
    try {
        var func = $507cda0e3d4397c2$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$63ec4d08c2de17a4$exports = $63ec4d08c2de17a4$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7ac8911b657c3928$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $63ec4d08c2de17a4$exports) $63ec4d08c2de17a4$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$7ac8911b657c3928$exports = $7ac8911b657c3928$var$baseAssignValue;


var $9a2fd95e744f294f$exports = {};
var $2ffd2d73f118f911$exports = {};
var $39a9db840e8a5122$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $39a9db840e8a5122$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$39a9db840e8a5122$exports = $39a9db840e8a5122$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2ffd2d73f118f911$var$baseFor = $39a9db840e8a5122$exports();
$2ffd2d73f118f911$exports = $2ffd2d73f118f911$var$baseFor;


var $cf65da43818f725f$exports = {};
var $39a283488d173d50$exports = {};
var $7f7a679ab009c8e0$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7f7a679ab009c8e0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$7f7a679ab009c8e0$exports = $7f7a679ab009c8e0$var$baseTimes;





var $8TKuU = parcelRequire("8TKuU");

var $54ae0102d9b8cfdf$exports = {};
var $f4e10a0fb2366352$exports = {};



/** `Object#toString` result references. */ var $f4e10a0fb2366352$var$argsTag = '[object Arguments]', $f4e10a0fb2366352$var$arrayTag = '[object Array]', $f4e10a0fb2366352$var$boolTag = '[object Boolean]', $f4e10a0fb2366352$var$dateTag = '[object Date]', $f4e10a0fb2366352$var$errorTag = '[object Error]', $f4e10a0fb2366352$var$funcTag = '[object Function]', $f4e10a0fb2366352$var$mapTag = '[object Map]', $f4e10a0fb2366352$var$numberTag = '[object Number]', $f4e10a0fb2366352$var$objectTag = '[object Object]', $f4e10a0fb2366352$var$regexpTag = '[object RegExp]', $f4e10a0fb2366352$var$setTag = '[object Set]', $f4e10a0fb2366352$var$stringTag = '[object String]', $f4e10a0fb2366352$var$weakMapTag = '[object WeakMap]';
var $f4e10a0fb2366352$var$arrayBufferTag = '[object ArrayBuffer]', $f4e10a0fb2366352$var$dataViewTag = '[object DataView]', $f4e10a0fb2366352$var$float32Tag = '[object Float32Array]', $f4e10a0fb2366352$var$float64Tag = '[object Float64Array]', $f4e10a0fb2366352$var$int8Tag = '[object Int8Array]', $f4e10a0fb2366352$var$int16Tag = '[object Int16Array]', $f4e10a0fb2366352$var$int32Tag = '[object Int32Array]', $f4e10a0fb2366352$var$uint8Tag = '[object Uint8Array]', $f4e10a0fb2366352$var$uint8ClampedTag = '[object Uint8ClampedArray]', $f4e10a0fb2366352$var$uint16Tag = '[object Uint16Array]', $f4e10a0fb2366352$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $f4e10a0fb2366352$var$typedArrayTags = {};
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float64Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8ClampedTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint32Tag] = true;
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$argsTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayBufferTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$boolTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dataViewTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dateTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$errorTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$funcTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$mapTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$numberTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$objectTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$regexpTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$setTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$stringTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f4e10a0fb2366352$var$baseIsTypedArray(value) {
    return $4a94b44c4940d5a5$exports(value) && $cb5309a5575a37b9$exports(value.length) && !!$f4e10a0fb2366352$var$typedArrayTags[$396b15940342a7f1$exports(value)];
}
$f4e10a0fb2366352$exports = $f4e10a0fb2366352$var$baseIsTypedArray;


var $82313b399bb9d3fb$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $82313b399bb9d3fb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$82313b399bb9d3fb$exports = $82313b399bb9d3fb$var$baseUnary;



var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $54ae0102d9b8cfdf$var$nodeIsTypedArray = $1mm29 && $1mm29.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $54ae0102d9b8cfdf$var$isTypedArray = $54ae0102d9b8cfdf$var$nodeIsTypedArray ? $82313b399bb9d3fb$exports($54ae0102d9b8cfdf$var$nodeIsTypedArray) : $f4e10a0fb2366352$exports;
$54ae0102d9b8cfdf$exports = $54ae0102d9b8cfdf$var$isTypedArray;


/** Used for built-in method references. */ var $39a283488d173d50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39a283488d173d50$var$hasOwnProperty = $39a283488d173d50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $39a283488d173d50$var$arrayLikeKeys(value, inherited) {
    var isArr = $730d1b366662da48$exports(value), isArg = !isArr && $dd94877d05f10850$exports(value), isBuff = !isArr && !isArg && $8TKuU(value), isType = !isArr && !isArg && !isBuff && $54ae0102d9b8cfdf$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7f7a679ab009c8e0$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $39a283488d173d50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $ec0ca5ffb2ff14ec$exports(key, length)))) result.push(key);
    return result;
}
$39a283488d173d50$exports = $39a283488d173d50$var$arrayLikeKeys;


var $409962ffb97dfa14$exports = {};
var $966736caab723063$exports = {};
/** Used for built-in method references. */ var $966736caab723063$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $966736caab723063$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $966736caab723063$var$objectProto;
    return value === proto;
}
$966736caab723063$exports = $966736caab723063$var$isPrototype;


var $6a42e4b2642f3889$exports = {};
var $fd668335d1985147$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd668335d1985147$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fd668335d1985147$exports = $fd668335d1985147$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a42e4b2642f3889$var$nativeKeys = $fd668335d1985147$exports(Object.keys, Object);
$6a42e4b2642f3889$exports = $6a42e4b2642f3889$var$nativeKeys;


/** Used for built-in method references. */ var $409962ffb97dfa14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $409962ffb97dfa14$var$hasOwnProperty = $409962ffb97dfa14$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $409962ffb97dfa14$var$baseKeys(object) {
    if (!$966736caab723063$exports(object)) return $6a42e4b2642f3889$exports(object);
    var result = [];
    for(var key in Object(object))if ($409962ffb97dfa14$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$409962ffb97dfa14$exports = $409962ffb97dfa14$var$baseKeys;


var $681032a0f414881e$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $681032a0f414881e$var$isArrayLike(value) {
    return value != null && $cb5309a5575a37b9$exports(value.length) && !$3c413d87f292fe2c$exports(value);
}
$681032a0f414881e$exports = $681032a0f414881e$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cf65da43818f725f$var$keys(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object) : $409962ffb97dfa14$exports(object);
}
$cf65da43818f725f$exports = $cf65da43818f725f$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $9a2fd95e744f294f$var$baseForOwn(object, iteratee) {
    return object && $2ffd2d73f118f911$exports(object, iteratee, $cf65da43818f725f$exports);
}
$9a2fd95e744f294f$exports = $9a2fd95e744f294f$var$baseForOwn;


var $9cb616549df16e8a$exports = {};
var $0eb3b1f0b77150e5$exports = {};
var $f85ee30bf79cc837$exports = {};
var $419ba895b4ae45e6$exports = {};

var $9d1ea3c08850b010$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9d1ea3c08850b010$var$stackClear() {
    this.__data__ = new $6600d6a94bbfda55$exports;
    this.size = 0;
}
$9d1ea3c08850b010$exports = $9d1ea3c08850b010$var$stackClear;


var $0ff58e43e318c414$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0ff58e43e318c414$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$0ff58e43e318c414$exports = $0ff58e43e318c414$var$stackDelete;


var $81d58a22530578d0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81d58a22530578d0$var$stackGet(key) {
    return this.__data__.get(key);
}
$81d58a22530578d0$exports = $81d58a22530578d0$var$stackGet;


var $48cf88273b00b4ea$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $48cf88273b00b4ea$var$stackHas(key) {
    return this.__data__.has(key);
}
$48cf88273b00b4ea$exports = $48cf88273b00b4ea$var$stackHas;


var $37ff411d932fb6f2$exports = {};



/** Used as the size to enable large array optimizations. */ var $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $37ff411d932fb6f2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6600d6a94bbfda55$exports) {
        var pairs = data.__data__;
        if (!$ab52caa45642ed43$exports || pairs.length < $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $eb2847cf8b43e448$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$37ff411d932fb6f2$exports = $37ff411d932fb6f2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $419ba895b4ae45e6$var$Stack(entries) {
    var data = this.__data__ = new $6600d6a94bbfda55$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$419ba895b4ae45e6$var$Stack.prototype.clear = $9d1ea3c08850b010$exports;
$419ba895b4ae45e6$var$Stack.prototype['delete'] = $0ff58e43e318c414$exports;
$419ba895b4ae45e6$var$Stack.prototype.get = $81d58a22530578d0$exports;
$419ba895b4ae45e6$var$Stack.prototype.has = $48cf88273b00b4ea$exports;
$419ba895b4ae45e6$var$Stack.prototype.set = $37ff411d932fb6f2$exports;
$419ba895b4ae45e6$exports = $419ba895b4ae45e6$var$Stack;


var $f62f68a862120e6f$exports = {};
var $c81129c59aef2ccf$exports = {};

var $0f039f12cd2ac022$exports = {};
var $cb3d1d2f030b3948$exports = {};

var $975c698101e172f2$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $975c698101e172f2$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $975c698101e172f2$var$setCacheAdd(value) {
    this.__data__.set(value, $975c698101e172f2$var$HASH_UNDEFINED);
    return this;
}
$975c698101e172f2$exports = $975c698101e172f2$var$setCacheAdd;


var $2b07a45d13b540cb$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2b07a45d13b540cb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2b07a45d13b540cb$exports = $2b07a45d13b540cb$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cb3d1d2f030b3948$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $eb2847cf8b43e448$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cb3d1d2f030b3948$var$SetCache.prototype.add = $cb3d1d2f030b3948$var$SetCache.prototype.push = $975c698101e172f2$exports;
$cb3d1d2f030b3948$var$SetCache.prototype.has = $2b07a45d13b540cb$exports;
$cb3d1d2f030b3948$exports = $cb3d1d2f030b3948$var$SetCache;


var $c0ac884d1efe56ee$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c0ac884d1efe56ee$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c0ac884d1efe56ee$exports = $c0ac884d1efe56ee$var$arraySome;


var $058827dcb6837216$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $058827dcb6837216$var$cacheHas(cache, key) {
    return cache.has(key);
}
$058827dcb6837216$exports = $058827dcb6837216$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG = 1, $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0f039f12cd2ac022$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG ? new $cb3d1d2f030b3948$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c0ac884d1efe56ee$exports(other, function(othValue, othIndex) {
                if (!$058827dcb6837216$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$0f039f12cd2ac022$exports = $0f039f12cd2ac022$var$equalArrays;


var $e7b4f0da30108603$exports = {};

var $f3f1e8c287dc271d$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $f3f1e8c287dc271d$var$Uint8Array = $dnnhb.Uint8Array;
$f3f1e8c287dc271d$exports = $f3f1e8c287dc271d$var$Uint8Array;




var $aa101734006c8cb4$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $aa101734006c8cb4$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$aa101734006c8cb4$exports = $aa101734006c8cb4$var$mapToArray;


var $3fc617daaa01c913$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3fc617daaa01c913$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$3fc617daaa01c913$exports = $3fc617daaa01c913$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG = 1, $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e7b4f0da30108603$var$boolTag = '[object Boolean]', $e7b4f0da30108603$var$dateTag = '[object Date]', $e7b4f0da30108603$var$errorTag = '[object Error]', $e7b4f0da30108603$var$mapTag = '[object Map]', $e7b4f0da30108603$var$numberTag = '[object Number]', $e7b4f0da30108603$var$regexpTag = '[object RegExp]', $e7b4f0da30108603$var$setTag = '[object Set]', $e7b4f0da30108603$var$stringTag = '[object String]', $e7b4f0da30108603$var$symbolTag = '[object Symbol]';
var $e7b4f0da30108603$var$arrayBufferTag = '[object ArrayBuffer]', $e7b4f0da30108603$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $e7b4f0da30108603$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $e7b4f0da30108603$var$symbolValueOf = $e7b4f0da30108603$var$symbolProto ? $e7b4f0da30108603$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7b4f0da30108603$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e7b4f0da30108603$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e7b4f0da30108603$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $f3f1e8c287dc271d$exports(object), new $f3f1e8c287dc271d$exports(other))) return false;
            return true;
        case $e7b4f0da30108603$var$boolTag:
        case $e7b4f0da30108603$var$dateTag:
        case $e7b4f0da30108603$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d3b5784bbbc55641$exports(+object, +other);
        case $e7b4f0da30108603$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e7b4f0da30108603$var$regexpTag:
        case $e7b4f0da30108603$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $e7b4f0da30108603$var$mapTag:
            var convert = $aa101734006c8cb4$exports;
        case $e7b4f0da30108603$var$setTag:
            var isPartial = bitmask & $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $3fc617daaa01c913$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0f039f12cd2ac022$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $e7b4f0da30108603$var$symbolTag:
            if ($e7b4f0da30108603$var$symbolValueOf) return $e7b4f0da30108603$var$symbolValueOf.call(object) == $e7b4f0da30108603$var$symbolValueOf.call(other);
    }
    return false;
}
$e7b4f0da30108603$exports = $e7b4f0da30108603$var$equalByTag;


var $a7b235c007594e3f$exports = {};
var $3087323db8ebdb4a$exports = {};
var $8ff55e87051475e3$exports = {};
var $ce3fbf26bf92081d$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ce3fbf26bf92081d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ce3fbf26bf92081d$exports = $ce3fbf26bf92081d$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8ff55e87051475e3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $730d1b366662da48$exports(object) ? result : $ce3fbf26bf92081d$exports(result, symbolsFunc(object));
}
$8ff55e87051475e3$exports = $8ff55e87051475e3$var$baseGetAllKeys;


var $6f0ffdf0419abb03$exports = {};
var $4f67014188a0aed7$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $4f67014188a0aed7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$4f67014188a0aed7$exports = $4f67014188a0aed7$var$arrayFilter;


var $be064eff5dc241cd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $be064eff5dc241cd$var$stubArray() {
    return [];
}
$be064eff5dc241cd$exports = $be064eff5dc241cd$var$stubArray;


/** Used for built-in method references. */ var $6f0ffdf0419abb03$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6f0ffdf0419abb03$var$propertyIsEnumerable = $6f0ffdf0419abb03$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6f0ffdf0419abb03$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6f0ffdf0419abb03$var$getSymbols = !$6f0ffdf0419abb03$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4f67014188a0aed7$exports($6f0ffdf0419abb03$var$nativeGetSymbols(object), function(symbol) {
        return $6f0ffdf0419abb03$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6f0ffdf0419abb03$exports = $6f0ffdf0419abb03$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3087323db8ebdb4a$var$getAllKeys(object) {
    return $8ff55e87051475e3$exports(object, $cf65da43818f725f$exports, $6f0ffdf0419abb03$exports);
}
$3087323db8ebdb4a$exports = $3087323db8ebdb4a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a7b235c007594e3f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7b235c007594e3f$var$hasOwnProperty = $a7b235c007594e3f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a7b235c007594e3f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG, objProps = $3087323db8ebdb4a$exports(object), objLength = objProps.length, othProps = $3087323db8ebdb4a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a7b235c007594e3f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$a7b235c007594e3f$exports = $a7b235c007594e3f$var$equalObjects;


var $79d963e32ece07b6$exports = {};
var $bc0c33c3265e5ae1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $bc0c33c3265e5ae1$var$DataView = $507cda0e3d4397c2$exports($dnnhb, 'DataView');
$bc0c33c3265e5ae1$exports = $bc0c33c3265e5ae1$var$DataView;



var $692fc18a853ab7b1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $692fc18a853ab7b1$var$Promise = $507cda0e3d4397c2$exports($dnnhb, 'Promise');
$692fc18a853ab7b1$exports = $692fc18a853ab7b1$var$Promise;


var $2f7af927ce68d1f1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $2f7af927ce68d1f1$var$Set = $507cda0e3d4397c2$exports($dnnhb, 'Set');
$2f7af927ce68d1f1$exports = $2f7af927ce68d1f1$var$Set;


var $47cc78defb163815$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $47cc78defb163815$var$WeakMap = $507cda0e3d4397c2$exports($dnnhb, 'WeakMap');
$47cc78defb163815$exports = $47cc78defb163815$var$WeakMap;




/** `Object#toString` result references. */ var $79d963e32ece07b6$var$mapTag = '[object Map]', $79d963e32ece07b6$var$objectTag = '[object Object]', $79d963e32ece07b6$var$promiseTag = '[object Promise]', $79d963e32ece07b6$var$setTag = '[object Set]', $79d963e32ece07b6$var$weakMapTag = '[object WeakMap]';
var $79d963e32ece07b6$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $79d963e32ece07b6$var$dataViewCtorString = $5d4c9208b54c16cf$exports($bc0c33c3265e5ae1$exports), $79d963e32ece07b6$var$mapCtorString = $5d4c9208b54c16cf$exports($ab52caa45642ed43$exports), $79d963e32ece07b6$var$promiseCtorString = $5d4c9208b54c16cf$exports($692fc18a853ab7b1$exports), $79d963e32ece07b6$var$setCtorString = $5d4c9208b54c16cf$exports($2f7af927ce68d1f1$exports), $79d963e32ece07b6$var$weakMapCtorString = $5d4c9208b54c16cf$exports($47cc78defb163815$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $79d963e32ece07b6$var$getTag = $396b15940342a7f1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($bc0c33c3265e5ae1$exports && $79d963e32ece07b6$var$getTag(new $bc0c33c3265e5ae1$exports(new ArrayBuffer(1))) != $79d963e32ece07b6$var$dataViewTag || $ab52caa45642ed43$exports && $79d963e32ece07b6$var$getTag(new $ab52caa45642ed43$exports) != $79d963e32ece07b6$var$mapTag || $692fc18a853ab7b1$exports && $79d963e32ece07b6$var$getTag($692fc18a853ab7b1$exports.resolve()) != $79d963e32ece07b6$var$promiseTag || $2f7af927ce68d1f1$exports && $79d963e32ece07b6$var$getTag(new $2f7af927ce68d1f1$exports) != $79d963e32ece07b6$var$setTag || $47cc78defb163815$exports && $79d963e32ece07b6$var$getTag(new $47cc78defb163815$exports) != $79d963e32ece07b6$var$weakMapTag) $79d963e32ece07b6$var$getTag = function(value) {
    var result = $396b15940342a7f1$exports(value), Ctor = result == $79d963e32ece07b6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5d4c9208b54c16cf$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $79d963e32ece07b6$var$dataViewCtorString:
            return $79d963e32ece07b6$var$dataViewTag;
        case $79d963e32ece07b6$var$mapCtorString:
            return $79d963e32ece07b6$var$mapTag;
        case $79d963e32ece07b6$var$promiseCtorString:
            return $79d963e32ece07b6$var$promiseTag;
        case $79d963e32ece07b6$var$setCtorString:
            return $79d963e32ece07b6$var$setTag;
        case $79d963e32ece07b6$var$weakMapCtorString:
            return $79d963e32ece07b6$var$weakMapTag;
    }
    return result;
};
$79d963e32ece07b6$exports = $79d963e32ece07b6$var$getTag;




var $8TKuU = parcelRequire("8TKuU");

/** Used to compose bitmasks for value comparisons. */ var $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c81129c59aef2ccf$var$argsTag = '[object Arguments]', $c81129c59aef2ccf$var$arrayTag = '[object Array]', $c81129c59aef2ccf$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c81129c59aef2ccf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c81129c59aef2ccf$var$hasOwnProperty = $c81129c59aef2ccf$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c81129c59aef2ccf$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $730d1b366662da48$exports(object), othIsArr = $730d1b366662da48$exports(other), objTag = objIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(object), othTag = othIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(other);
    objTag = objTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : objTag;
    othTag = othTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : othTag;
    var objIsObj = objTag == $c81129c59aef2ccf$var$objectTag, othIsObj = othTag == $c81129c59aef2ccf$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $8TKuU(object)) {
        if (!$8TKuU(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $419ba895b4ae45e6$exports);
        return objIsArr || $54ae0102d9b8cfdf$exports(object) ? $0f039f12cd2ac022$exports(object, other, bitmask, customizer, equalFunc, stack) : $e7b4f0da30108603$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $419ba895b4ae45e6$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $419ba895b4ae45e6$exports);
    return $a7b235c007594e3f$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c81129c59aef2ccf$exports = $c81129c59aef2ccf$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f62f68a862120e6f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4a94b44c4940d5a5$exports(value) && !$4a94b44c4940d5a5$exports(other)) return value !== value && other !== other;
    return $c81129c59aef2ccf$exports(value, other, bitmask, customizer, $f62f68a862120e6f$var$baseIsEqual, stack);
}
$f62f68a862120e6f$exports = $f62f68a862120e6f$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG = 1, $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f85ee30bf79cc837$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $419ba895b4ae45e6$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f62f68a862120e6f$exports(srcValue, objValue, $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG | $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$f85ee30bf79cc837$exports = $f85ee30bf79cc837$var$baseIsMatch;


var $9cf3abfcab32b22c$exports = {};
var $9de722725cfbc330$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9de722725cfbc330$var$isStrictComparable(value) {
    return value === value && !$e4bea0192758232a$exports(value);
}
$9de722725cfbc330$exports = $9de722725cfbc330$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $9cf3abfcab32b22c$var$getMatchData(object) {
    var result = $cf65da43818f725f$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9de722725cfbc330$exports(value)
        ];
    }
    return result;
}
$9cf3abfcab32b22c$exports = $9cf3abfcab32b22c$var$getMatchData;


var $e1a2bd7c53e7bf62$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e1a2bd7c53e7bf62$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$e1a2bd7c53e7bf62$exports = $e1a2bd7c53e7bf62$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0eb3b1f0b77150e5$var$baseMatches(source) {
    var matchData = $9cf3abfcab32b22c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $e1a2bd7c53e7bf62$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $f85ee30bf79cc837$exports(object, source, matchData);
    };
}
$0eb3b1f0b77150e5$exports = $0eb3b1f0b77150e5$var$baseMatches;


var $b73195e081a09370$exports = {};

var $2edb8fed42c63e28$exports = {};
var $eabd71162fd83291$exports = {};


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $eabd71162fd83291$var$baseGet(object, path) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$c4981d9c30ac136e$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$eabd71162fd83291$exports = $eabd71162fd83291$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $2edb8fed42c63e28$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $eabd71162fd83291$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$2edb8fed42c63e28$exports = $2edb8fed42c63e28$var$get;


var $095bca068d70c25b$exports = {};
var $3cd7cedfbee269d1$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3cd7cedfbee269d1$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$3cd7cedfbee269d1$exports = $3cd7cedfbee269d1$var$baseHasIn;



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $095bca068d70c25b$var$hasIn(object, path) {
    return object != null && $15587d13e03f2293$exports(object, path, $3cd7cedfbee269d1$exports);
}
$095bca068d70c25b$exports = $095bca068d70c25b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $b73195e081a09370$var$COMPARE_PARTIAL_FLAG = 1, $b73195e081a09370$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b73195e081a09370$var$baseMatchesProperty(path, srcValue) {
    if ($b862d544b65a608a$exports(path) && $9de722725cfbc330$exports(srcValue)) return $e1a2bd7c53e7bf62$exports($c4981d9c30ac136e$exports(path), srcValue);
    return function(object) {
        var objValue = $2edb8fed42c63e28$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $095bca068d70c25b$exports(object, path) : $f62f68a862120e6f$exports(srcValue, objValue, $b73195e081a09370$var$COMPARE_PARTIAL_FLAG | $b73195e081a09370$var$COMPARE_UNORDERED_FLAG);
    };
}
$b73195e081a09370$exports = $b73195e081a09370$var$baseMatchesProperty;


var $a961fb58d7bfedbf$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a961fb58d7bfedbf$var$identity(value) {
    return value;
}
$a961fb58d7bfedbf$exports = $a961fb58d7bfedbf$var$identity;



var $6f16c695e053e5a0$exports = {};
var $7a7ff6914d162e21$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7a7ff6914d162e21$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$7a7ff6914d162e21$exports = $7a7ff6914d162e21$var$baseProperty;


var $280ff13719d2f033$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $280ff13719d2f033$var$basePropertyDeep(path) {
    return function(object) {
        return $eabd71162fd83291$exports(object, path);
    };
}
$280ff13719d2f033$exports = $280ff13719d2f033$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6f16c695e053e5a0$var$property(path) {
    return $b862d544b65a608a$exports(path) ? $7a7ff6914d162e21$exports($c4981d9c30ac136e$exports(path)) : $280ff13719d2f033$exports(path);
}
$6f16c695e053e5a0$exports = $6f16c695e053e5a0$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9cb616549df16e8a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $a961fb58d7bfedbf$exports;
    if (typeof value == 'object') return $730d1b366662da48$exports(value) ? $b73195e081a09370$exports(value[0], value[1]) : $0eb3b1f0b77150e5$exports(value);
    return $6f16c695e053e5a0$exports(value);
}
$9cb616549df16e8a$exports = $9cb616549df16e8a$var$baseIteratee;


/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $468520a99798aaf1$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $9cb616549df16e8a$exports(iteratee, 3);
    $9a2fd95e744f294f$exports(object, function(value, key, object) {
        $7ac8911b657c3928$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$468520a99798aaf1$exports = $468520a99798aaf1$var$mapValues;



var $7b8e6223f25a2f80$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $7b8e6223f25a2f80$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$7b8e6223f25a2f80$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$7b8e6223f25a2f80$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$7b8e6223f25a2f80$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $7b8e6223f25a2f80$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $7b8e6223f25a2f80$var$DIGIT_REGEX = /^\d+$/, $7b8e6223f25a2f80$var$LEAD_DIGIT_REGEX = /^\d/, $7b8e6223f25a2f80$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $7b8e6223f25a2f80$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $7b8e6223f25a2f80$var$MAX_CACHE_SIZE = 512;
var $7b8e6223f25a2f80$var$pathCache = new $7b8e6223f25a2f80$var$Cache($7b8e6223f25a2f80$var$MAX_CACHE_SIZE), $7b8e6223f25a2f80$var$setCache = new $7b8e6223f25a2f80$var$Cache($7b8e6223f25a2f80$var$MAX_CACHE_SIZE), $7b8e6223f25a2f80$var$getCache = new $7b8e6223f25a2f80$var$Cache($7b8e6223f25a2f80$var$MAX_CACHE_SIZE);
var $7b8e6223f25a2f80$var$config;
$7b8e6223f25a2f80$exports = {
    Cache: $7b8e6223f25a2f80$var$Cache,
    split: $7b8e6223f25a2f80$var$split,
    normalizePath: $7b8e6223f25a2f80$var$normalizePath,
    setter: function(path) {
        var parts = $7b8e6223f25a2f80$var$normalizePath(path);
        return $7b8e6223f25a2f80$var$setCache.get(path) || $7b8e6223f25a2f80$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $7b8e6223f25a2f80$var$normalizePath(path);
        return $7b8e6223f25a2f80$var$getCache.get(path) || $7b8e6223f25a2f80$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($7b8e6223f25a2f80$var$isQuoted(part) || $7b8e6223f25a2f80$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $7b8e6223f25a2f80$var$forEach(Array.isArray(path) ? path : $7b8e6223f25a2f80$var$split(path), cb, thisArg);
    }
};
function $7b8e6223f25a2f80$var$normalizePath(path) {
    return $7b8e6223f25a2f80$var$pathCache.get(path) || $7b8e6223f25a2f80$var$pathCache.set(path, $7b8e6223f25a2f80$var$split(path).map(function(part) {
        return part.replace($7b8e6223f25a2f80$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $7b8e6223f25a2f80$var$split(path) {
    return path.match($7b8e6223f25a2f80$var$SPLIT_REGEX) || [
        ''
    ];
}
function $7b8e6223f25a2f80$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($7b8e6223f25a2f80$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $7b8e6223f25a2f80$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $7b8e6223f25a2f80$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $7b8e6223f25a2f80$var$hasLeadingNumber(part) {
    return part.match($7b8e6223f25a2f80$var$LEAD_DIGIT_REGEX) && !part.match($7b8e6223f25a2f80$var$DIGIT_REGEX);
}
function $7b8e6223f25a2f80$var$hasSpecialChars(part) {
    return $7b8e6223f25a2f80$var$SPEC_CHAR_REGEX.test(part);
}
function $7b8e6223f25a2f80$var$shouldBeQuoted(part) {
    return !$7b8e6223f25a2f80$var$isQuoted(part) && ($7b8e6223f25a2f80$var$hasLeadingNumber(part) || $7b8e6223f25a2f80$var$hasSpecialChars(part));
}


const $b3adddf52d229d80$var$prefixes = {
    context: '$',
    value: '.'
};
function $b3adddf52d229d80$export$185802fd694ee1f5(key, options) {
    return new $b3adddf52d229d80$export$2e2bcd8739ae039(key, options);
}
class $b3adddf52d229d80$export$2e2bcd8739ae039 {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $b3adddf52d229d80$var$prefixes.context;
        this.isValue = this.key[0] === $b3adddf52d229d80$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $b3adddf52d229d80$var$prefixes.context : this.isValue ? $b3adddf52d229d80$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $7b8e6223f25a2f80$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
} // @ts-ignore
$b3adddf52d229d80$export$2e2bcd8739ae039.prototype.__isYupRef = true;


function $97786f2b6f41467d$var$_extends() {
    $97786f2b6f41467d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97786f2b6f41467d$var$_extends.apply(this, arguments);
}
function $97786f2b6f41467d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $97786f2b6f41467d$export$2e2bcd8739ae039(config) {
    function validate(_ref, cb) {
        let { value: value, path: path = '', label: label, options: options, originalValue: originalValue, sync: sync } = _ref, rest = $97786f2b6f41467d$var$_objectWithoutPropertiesLoose(_ref, [
            "value",
            "path",
            "label",
            "options",
            "originalValue",
            "sync"
        ]);
        const { name: name, test: test, params: params, message: message } = config;
        let { parent: parent, context: context } = options;
        function resolve(item) {
            return (0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = (0, (/*@__PURE__*/$parcel$interopDefault($468520a99798aaf1$exports)))($97786f2b6f41467d$var$_extends({
                value: value,
                originalValue: originalValue,
                label: label,
                path: overrides.path || path
            }, params, overrides.params), resolve);
            const error = new (0, $841702205e82e4dd$export$2e2bcd8739ae039)((0, $841702205e82e4dd$export$2e2bcd8739ae039).formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
            error.params = nextParams;
            return error;
        }
        let ctx = $97786f2b6f41467d$var$_extends({
            path: path,
            parent: parent,
            type: name,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue
        }, rest);
        if (!sync) {
            try {
                Promise.resolve(test.call(ctx, value, ctx)).then((validOrError)=>{
                    if ((0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(validOrError)) cb(validOrError);
                    else if (!validOrError) cb(createError());
                    else cb(null, validOrError);
                }).catch(cb);
            } catch (err) {
                cb(err);
            }
            return;
        }
        let result;
        try {
            var _ref2;
            result = test.call(ctx, value, ctx);
            if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
        } catch (err) {
            cb(err);
            return;
        }
        if ((0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(result)) cb(result);
        else if (!result) cb(createError());
        else cb(null, result);
    }
    validate.OPTIONS = config;
    return validate;
}





let $e522fd5cc9eaefd2$var$trim = (part)=>part.substr(0, part.length - 1).substr(1);
function $e522fd5cc9eaefd2$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug; // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $7b8e6223f25a2f80$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? $e522fd5cc9eaefd2$var$trim(_part) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        if (schema.innerType) {
            let idx = isArray ? parseInt(part, 10) : 0;
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = schema.innerType;
        } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
const $e522fd5cc9eaefd2$var$reach = (obj, path, value, context)=>$e522fd5cc9eaefd2$export$c52e5867d5879e24(obj, path, value, context).schema;
var $e522fd5cc9eaefd2$export$2e2bcd8739ae039 = $e522fd5cc9eaefd2$var$reach;




class $7afd9b25ec697a76$export$2e2bcd8739ae039 {
    constructor(){
        this.list = void 0;
        this.refs = void 0;
        this.list = new Set();
        this.refs = new Map();
    }
    get size() {
        return this.list.size + this.refs.size;
    }
    describe() {
        const description = [];
        for (const item of this.list)description.push(item);
        for (const [, ref] of this.refs)description.push(ref.describe());
        return description;
    }
    toArray() {
        return Array.from(this.list).concat(Array.from(this.refs.values()));
    }
    resolveAll(resolve) {
        return this.toArray().reduce((acc, e)=>acc.concat((0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(e) ? resolve(e) : e), []);
    }
    add(value) {
        (0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
    }
    delete(value) {
        (0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
    }
    clone() {
        const next = new $7afd9b25ec697a76$export$2e2bcd8739ae039();
        next.list = new Set(this.list);
        next.refs = new Map(this.refs);
        return next;
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.list.forEach((value)=>next.add(value));
        newItems.refs.forEach((value)=>next.add(value));
        removeItems.list.forEach((value)=>next.delete(value));
        removeItems.refs.forEach((value)=>next.delete(value));
        return next;
    }
}



function $8acfe9a6cc2d46bd$var$_extends() {
    $8acfe9a6cc2d46bd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8acfe9a6cc2d46bd$var$_extends.apply(this, arguments);
}
class $8acfe9a6cc2d46bd$export$2e2bcd8739ae039 {
    constructor(options){
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this._typeError = void 0;
        this._whitelist = new (0, $7afd9b25ec697a76$export$2e2bcd8739ae039)();
        this._blacklist = new (0, $7afd9b25ec697a76$export$2e2bcd8739ae039)();
        this.exclusiveTests = Object.create(null);
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError((0, $e918c4ca8768491c$export$9b30b6294c1449a8).notType);
        });
        this.type = (options == null ? void 0 : options.type) || 'mixed';
        this.spec = $8acfe9a6cc2d46bd$var$_extends({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            nullable: false,
            presence: 'optional'
        }, options == null ? void 0 : options.spec);
    }
    get _type() {
        return this.type;
    }
    _typeCheck(_value) {
        return true;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        } // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeError = this._typeError;
        next._whitelistError = this._whitelistError;
        next._blacklistError = this._blacklistError;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.exclusiveTests = $8acfe9a6cc2d46bd$var$_extends({}, this.exclusiveTests); // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = (0, $df3a053a1f092148$export$2e2bcd8739ae039)($8acfe9a6cc2d46bd$var$_extends({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    //   TCast,
    //   TContext,
    //   TOutput
    // > {
    //   return this as any;
    // }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = $8acfe9a6cc2d46bd$var$_extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
        //   mergedSpec.nullable = base.spec.nullable;
        // if (combined.spec.presence === UNSET)
        //   mergedSpec.presence = base.spec.presence;
        combined.spec = mergedSpec;
        combined._typeError || (combined._typeError = base._typeError);
        combined._whitelistError || (combined._whitelistError = base._whitelistError);
        combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (this.spec.nullable && v === null) return true;
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((schema, condition)=>condition.resolve(schema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve($8acfe9a6cc2d46bd$var$_extends({
            value: value
        }, options));
        let result = resolvedSchema._cast(value, options);
        if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
            let formattedValue = (0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(value);
            let formattedResult = (0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, _options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn)=>fn.call(this, value, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault();
        return value;
    }
    _validate(_value, options = {}, cb) {
        let { sync: sync, path: path, from: from = [], originalValue: originalValue = _value, strict: strict = this.spec.strict, abortEarly: abortEarly = this.spec.abortEarly } = options;
        let value = _value;
        if (!strict) // this._validating = true;
        value = this._cast(value, $8acfe9a6cc2d46bd$var$_extends({
            assert: false
        }, options)); // this._validating = false;
         // value is cast, we can check if it meets type requirements
        let args = {
            value: value,
            path: path,
            options: options,
            originalValue: originalValue,
            schema: this,
            label: this.spec.label,
            sync: sync,
            from: from
        };
        let initialTests = [];
        if (this._typeError) initialTests.push(this._typeError);
        let finalTests = [];
        if (this._whitelistError) finalTests.push(this._whitelistError);
        if (this._blacklistError) finalTests.push(this._blacklistError);
        (0, $a2a091fa47a581a7$export$2e2bcd8739ae039)({
            args: args,
            value: value,
            path: path,
            sync: sync,
            tests: initialTests,
            endEarly: abortEarly
        }, (err)=>{
            if (err) return void cb(err, value);
            (0, $a2a091fa47a581a7$export$2e2bcd8739ae039)({
                tests: this.tests.concat(finalTests),
                args: args,
                path: path,
                sync: sync,
                value: value,
                endEarly: abortEarly
            }, cb);
        });
    }
    validate(value, options, maybeCb) {
        let schema = this.resolve($8acfe9a6cc2d46bd$var$_extends({}, options, {
            value: value
        })); // callback case is for nested validations
        return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject)=>schema._validate(value, options, (err, value)=>{
                if (err) reject(err);
                else resolve(value);
            }));
    }
    validateSync(value, options) {
        let schema = this.resolve($8acfe9a6cc2d46bd$var$_extends({}, options, {
            value: value
        }));
        let result;
        schema._validate(value, $8acfe9a6cc2d46bd$var$_extends({}, options, {
            sync: true
        }), (err, value)=>{
            if (err) throw err;
            result = value;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ((0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ((0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(err)) return false;
            throw err;
        }
    }
    _getDefault() {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this) : (0, $df3a053a1f092148$export$2e2bcd8739ae039)(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault();
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        let next = this.clone();
        next.spec.strict = isStrict;
        return next;
    }
    _isPresent(value) {
        return value != null;
    }
    defined(message = (0, $e918c4ca8768491c$export$9b30b6294c1449a8).defined) {
        return this.test({
            message: message,
            name: 'defined',
            exclusive: true,
            test (value) {
                return value !== undefined;
            }
        });
    }
    required(message = (0, $e918c4ca8768491c$export$9b30b6294c1449a8).required) {
        return this.clone({
            presence: 'required'
        }).withMutation((s)=>s.test({
                message: message,
                name: 'required',
                exclusive: true,
                test (value) {
                    return this.schema._isPresent(value);
                }
            }));
    }
    notRequired() {
        let next = this.clone({
            presence: 'optional'
        });
        next.tests = next.tests.filter((test)=>test.OPTIONS.name !== 'required');
        return next;
    }
    nullable(isNullable = true) {
        let next = this.clone({
            nullable: isNullable !== false
        });
        return next;
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = (0, $e918c4ca8768491c$export$9b30b6294c1449a8).default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = (0, $97786f2b6f41467d$export$2e2bcd8739ae039)(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = (0, $88c746c2c38495a5$export$2e2bcd8739ae039)(keys).map((key)=>new (0, $b3adddf52d229d80$export$2e2bcd8739ae039)(key));
        deps.forEach((dep)=>{
            // @ts-ignore
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(new (0, $1847512880a44a81$export$2e2bcd8739ae039)(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next._typeError = (0, $97786f2b6f41467d$export$2e2bcd8739ae039)({
            message: message,
            name: 'typeError',
            test (value) {
                if (value !== undefined && !this.schema.isType(value)) return this.createError({
                    params: {
                        type: this.schema._type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = (0, $e918c4ca8768491c$export$9b30b6294c1449a8).oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next._whitelistError = (0, $97786f2b6f41467d$export$2e2bcd8739ae039)({
            message: message,
            name: 'oneOf',
            test (value) {
                if (value === undefined) return true;
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: valids.toArray().join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = (0, $e918c4ca8768491c$export$9b30b6294c1449a8).notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next._blacklistError = (0, $97786f2b6f41467d$export$2e2bcd8739ae039)({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: invalids.toArray().join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    describe() {
        const next = this.clone();
        const { label: label, meta: meta } = next.spec;
        const description = {
            meta: meta,
            label: label,
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
} // eslint-disable-next-line @typescript-eslint/no-unused-vars
// @ts-expect-error
$8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = (0, $e522fd5cc9eaefd2$export$c52e5867d5879e24)(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], $8acfe9a6cc2d46bd$var$_extends({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype[alias] = $8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype[alias] = $8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype.notOneOf;
$8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype.optional = $8acfe9a6cc2d46bd$export$2e2bcd8739ae039.prototype.notRequired;


const $2da2ea4b605d7bd9$var$Mixed = (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039);
var $2da2ea4b605d7bd9$export$2e2bcd8739ae039 = $2da2ea4b605d7bd9$var$Mixed;
function $2da2ea4b605d7bd9$export$185802fd694ee1f5() {
    return new $2da2ea4b605d7bd9$var$Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class
$2da2ea4b605d7bd9$export$185802fd694ee1f5.prototype = $2da2ea4b605d7bd9$var$Mixed.prototype;




const $06cc44d8b3bca62c$var$isAbsent = (value)=>value == null;
var $06cc44d8b3bca62c$export$2e2bcd8739ae039 = $06cc44d8b3bca62c$var$isAbsent;


function $82dfc9a766b01b73$export$185802fd694ee1f5() {
    return new $82dfc9a766b01b73$export$2e2bcd8739ae039();
}
class $82dfc9a766b01b73$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'boolean'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (!this.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    _typeCheck(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
    }
    isTrue(message = (0, $e918c4ca8768491c$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === true;
            }
        });
    }
    isFalse(message = (0, $e918c4ca8768491c$export$4a21f16c33752377).isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === false;
            }
        });
    }
}
$82dfc9a766b01b73$export$185802fd694ee1f5.prototype = $82dfc9a766b01b73$export$2e2bcd8739ae039.prototype;





let $a0206caf38308288$var$rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line
let $a0206caf38308288$var$rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line
let $a0206caf38308288$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $a0206caf38308288$var$isTrimmed = (value)=>(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === value.trim();
let $a0206caf38308288$var$objStringTag = ({}).toString();
function $a0206caf38308288$export$185802fd694ee1f5() {
    return new $a0206caf38308288$export$2e2bcd8739ae039();
}
class $a0206caf38308288$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'string'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                if (strValue === $a0206caf38308288$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
    }
    _isPresent(value) {
        return super._isPresent(value) && !!value.length;
    }
    length(length, message = (0, $e918c4ca8768491c$export$22b082955e083ec3).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message = (0, $e918c4ca8768491c$export$22b082955e083ec3).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $e918c4ca8768491c$export$22b082955e083ec3).max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || (0, $e918c4ca8768491c$export$22b082955e083ec3).matches,
            params: {
                regex: regex
            },
            test: (value)=>(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).email) {
        return this.matches($a0206caf38308288$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).url) {
        return this.matches($a0206caf38308288$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).uuid) {
        return this.matches($a0206caf38308288$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $a0206caf38308288$var$isTrimmed
        });
    }
    lowercase(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).lowercase) {
        return this.transform((value)=>!(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = (0, $e918c4ca8768491c$export$22b082955e083ec3).uppercase) {
        return this.transform((value)=>!(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            test: (value)=>(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value === value.toUpperCase()
        });
    }
}
$a0206caf38308288$export$185802fd694ee1f5.prototype = $a0206caf38308288$export$2e2bcd8739ae039.prototype; //
 // String Interfaces
 //





let $6e6ad40c65975a5d$var$isNaN = (value)=>value != +value;
function $6e6ad40c65975a5d$export$185802fd694ee1f5() {
    return new $6e6ad40c65975a5d$export$2e2bcd8739ae039();
}
class $6e6ad40c65975a5d$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'number'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                if (this.isType(parsed)) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    _typeCheck(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !$6e6ad40c65975a5d$var$isNaN(value);
    }
    min(min, message = (0, $e918c4ca8768491c$export$98e628dec113755e).min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value >= this.resolve(min);
            }
        });
    }
    max(max, message = (0, $e918c4ca8768491c$export$98e628dec113755e).max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = (0, $e918c4ca8768491c$export$98e628dec113755e).lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = (0, $e918c4ca8768491c$export$98e628dec113755e).moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value > this.resolve(more);
            }
        });
    }
    positive(msg = (0, $e918c4ca8768491c$export$98e628dec113755e).positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = (0, $e918c4ca8768491c$export$98e628dec113755e).negative) {
        return this.lessThan(0, msg);
    }
    integer(message = (0, $e918c4ca8768491c$export$98e628dec113755e).integer) {
        return this.test({
            name: 'integer',
            message: message,
            test: (val)=>(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(val) || Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!(0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) ? Math[method](value) : value);
    }
}
$6e6ad40c65975a5d$export$185802fd694ee1f5.prototype = $6e6ad40c65975a5d$export$2e2bcd8739ae039.prototype; //
 // Number Interfaces
 //


// @ts-ignore
/* eslint-disable */ /**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ //              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var $55941b357fc0fb04$var$isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $55941b357fc0fb04$export$2e2bcd8739ae039(date) {
    var numericKeys = [
        1,
        4,
        5,
        6,
        7,
        10,
        11
    ], minutesOffset = 0, timestamp, struct;
    if (struct = $55941b357fc0fb04$var$isoReg.exec(date)) {
        // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
        for(var i = 0, k; k = numericKeys[i]; ++i)struct[k] = +struct[k] || 0; // allow undefined days and months
        struct[2] = (+struct[2] || 1) - 1;
        struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds
        struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time
        if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);
        else {
            if (struct[8] !== 'Z' && struct[9] !== undefined) {
                minutesOffset = struct[10] * 60 + struct[11];
                if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
            }
            timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
        }
    } else timestamp = Date.parse ? Date.parse(date) : NaN;
    return timestamp;
}






let $2efeb86fe7f1b8d4$var$invalidDate = new Date('');
let $2efeb86fe7f1b8d4$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $2efeb86fe7f1b8d4$export$185802fd694ee1f5() {
    return new $2efeb86fe7f1b8d4$export$2e2bcd8739ae039();
}
class $2efeb86fe7f1b8d4$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(){
        super({
            type: 'date'
        });
        this.withMutation(()=>{
            this.transform(function(value) {
                if (this.isType(value)) return value;
                value = (0, $55941b357fc0fb04$export$2e2bcd8739ae039)(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $2efeb86fe7f1b8d4$var$invalidDate;
            });
        });
    }
    _typeCheck(v) {
        return $2efeb86fe7f1b8d4$var$isDate(v) && !isNaN(v.getTime());
    }
    prepareParam(ref, name) {
        let param;
        if (!(0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = (0, $e918c4ca8768491c$export$324d90190a8b822a).min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value >= this.resolve(limit);
            }
        });
    }
    max(max, message = (0, $e918c4ca8768491c$export$324d90190a8b822a).max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value <= this.resolve(limit);
            }
        });
    }
}
$2efeb86fe7f1b8d4$export$2e2bcd8739ae039.INVALID_DATE = $2efeb86fe7f1b8d4$var$invalidDate;
$2efeb86fe7f1b8d4$export$185802fd694ee1f5.prototype = $2efeb86fe7f1b8d4$export$2e2bcd8739ae039.prototype;
$2efeb86fe7f1b8d4$export$185802fd694ee1f5.INVALID_DATE = $2efeb86fe7f1b8d4$var$invalidDate;



var $2ed6aaa3fdd7a5e2$exports = {};
var $448b6cb720a55fb8$exports = {};
var $0206f3c93c36a3b6$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $0206f3c93c36a3b6$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$0206f3c93c36a3b6$exports = $0206f3c93c36a3b6$var$arrayReduce;


var $671754e211b59dce$exports = {};
var $a96c6abce01f47e5$exports = {};
var $6f427ab56224fad7$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $6f427ab56224fad7$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$6f427ab56224fad7$exports = $6f427ab56224fad7$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $a96c6abce01f47e5$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $a96c6abce01f47e5$var$deburrLetter = $6f427ab56224fad7$exports($a96c6abce01f47e5$var$deburredLetters);
$a96c6abce01f47e5$exports = $a96c6abce01f47e5$var$deburrLetter;



/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $671754e211b59dce$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $671754e211b59dce$var$rsComboMarksRange = '\\u0300-\\u036f', $671754e211b59dce$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $671754e211b59dce$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $671754e211b59dce$var$rsComboRange = $671754e211b59dce$var$rsComboMarksRange + $671754e211b59dce$var$reComboHalfMarksRange + $671754e211b59dce$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $671754e211b59dce$var$rsCombo = '[' + $671754e211b59dce$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $671754e211b59dce$var$reComboMark = RegExp($671754e211b59dce$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $671754e211b59dce$var$deburr(string) {
    string = $a863ad98b2851f02$exports(string);
    return string && string.replace($671754e211b59dce$var$reLatin, $a96c6abce01f47e5$exports).replace($671754e211b59dce$var$reComboMark, '');
}
$671754e211b59dce$exports = $671754e211b59dce$var$deburr;


var $f7aa76ef659e7fe4$exports = {};
var $0e6bf15907342c1b$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $0e6bf15907342c1b$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $0e6bf15907342c1b$var$asciiWords(string) {
    return string.match($0e6bf15907342c1b$var$reAsciiWord) || [];
}
$0e6bf15907342c1b$exports = $0e6bf15907342c1b$var$asciiWords;


var $55ab3e4bcd690578$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $55ab3e4bcd690578$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $55ab3e4bcd690578$var$hasUnicodeWord(string) {
    return $55ab3e4bcd690578$var$reHasUnicodeWord.test(string);
}
$55ab3e4bcd690578$exports = $55ab3e4bcd690578$var$hasUnicodeWord;



var $adfdebcb03bb94ac$exports = {};
/** Used to compose unicode character classes. */ var $adfdebcb03bb94ac$var$rsAstralRange = '\\ud800-\\udfff', $adfdebcb03bb94ac$var$rsComboMarksRange = '\\u0300-\\u036f', $adfdebcb03bb94ac$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $adfdebcb03bb94ac$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $adfdebcb03bb94ac$var$rsComboRange = $adfdebcb03bb94ac$var$rsComboMarksRange + $adfdebcb03bb94ac$var$reComboHalfMarksRange + $adfdebcb03bb94ac$var$rsComboSymbolsRange, $adfdebcb03bb94ac$var$rsDingbatRange = '\\u2700-\\u27bf', $adfdebcb03bb94ac$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $adfdebcb03bb94ac$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $adfdebcb03bb94ac$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $adfdebcb03bb94ac$var$rsPunctuationRange = '\\u2000-\\u206f', $adfdebcb03bb94ac$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $adfdebcb03bb94ac$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $adfdebcb03bb94ac$var$rsVarRange = '\\ufe0e\\ufe0f', $adfdebcb03bb94ac$var$rsBreakRange = $adfdebcb03bb94ac$var$rsMathOpRange + $adfdebcb03bb94ac$var$rsNonCharRange + $adfdebcb03bb94ac$var$rsPunctuationRange + $adfdebcb03bb94ac$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $adfdebcb03bb94ac$var$rsApos = "['\u2019]", $adfdebcb03bb94ac$var$rsBreak = '[' + $adfdebcb03bb94ac$var$rsBreakRange + ']', $adfdebcb03bb94ac$var$rsCombo = '[' + $adfdebcb03bb94ac$var$rsComboRange + ']', $adfdebcb03bb94ac$var$rsDigits = '\\d+', $adfdebcb03bb94ac$var$rsDingbat = '[' + $adfdebcb03bb94ac$var$rsDingbatRange + ']', $adfdebcb03bb94ac$var$rsLower = '[' + $adfdebcb03bb94ac$var$rsLowerRange + ']', $adfdebcb03bb94ac$var$rsMisc = '[^' + $adfdebcb03bb94ac$var$rsAstralRange + $adfdebcb03bb94ac$var$rsBreakRange + $adfdebcb03bb94ac$var$rsDigits + $adfdebcb03bb94ac$var$rsDingbatRange + $adfdebcb03bb94ac$var$rsLowerRange + $adfdebcb03bb94ac$var$rsUpperRange + ']', $adfdebcb03bb94ac$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $adfdebcb03bb94ac$var$rsModifier = '(?:' + $adfdebcb03bb94ac$var$rsCombo + '|' + $adfdebcb03bb94ac$var$rsFitz + ')', $adfdebcb03bb94ac$var$rsNonAstral = '[^' + $adfdebcb03bb94ac$var$rsAstralRange + ']', $adfdebcb03bb94ac$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $adfdebcb03bb94ac$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $adfdebcb03bb94ac$var$rsUpper = '[' + $adfdebcb03bb94ac$var$rsUpperRange + ']', $adfdebcb03bb94ac$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $adfdebcb03bb94ac$var$rsMiscLower = '(?:' + $adfdebcb03bb94ac$var$rsLower + '|' + $adfdebcb03bb94ac$var$rsMisc + ')', $adfdebcb03bb94ac$var$rsMiscUpper = '(?:' + $adfdebcb03bb94ac$var$rsUpper + '|' + $adfdebcb03bb94ac$var$rsMisc + ')', $adfdebcb03bb94ac$var$rsOptContrLower = '(?:' + $adfdebcb03bb94ac$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $adfdebcb03bb94ac$var$rsOptContrUpper = '(?:' + $adfdebcb03bb94ac$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $adfdebcb03bb94ac$var$reOptMod = $adfdebcb03bb94ac$var$rsModifier + '?', $adfdebcb03bb94ac$var$rsOptVar = '[' + $adfdebcb03bb94ac$var$rsVarRange + ']?', $adfdebcb03bb94ac$var$rsOptJoin = '(?:' + $adfdebcb03bb94ac$var$rsZWJ + '(?:' + [
    $adfdebcb03bb94ac$var$rsNonAstral,
    $adfdebcb03bb94ac$var$rsRegional,
    $adfdebcb03bb94ac$var$rsSurrPair
].join('|') + ')' + $adfdebcb03bb94ac$var$rsOptVar + $adfdebcb03bb94ac$var$reOptMod + ')*', $adfdebcb03bb94ac$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $adfdebcb03bb94ac$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $adfdebcb03bb94ac$var$rsSeq = $adfdebcb03bb94ac$var$rsOptVar + $adfdebcb03bb94ac$var$reOptMod + $adfdebcb03bb94ac$var$rsOptJoin, $adfdebcb03bb94ac$var$rsEmoji = '(?:' + [
    $adfdebcb03bb94ac$var$rsDingbat,
    $adfdebcb03bb94ac$var$rsRegional,
    $adfdebcb03bb94ac$var$rsSurrPair
].join('|') + ')' + $adfdebcb03bb94ac$var$rsSeq;
/** Used to match complex or compound words. */ var $adfdebcb03bb94ac$var$reUnicodeWord = RegExp([
    $adfdebcb03bb94ac$var$rsUpper + '?' + $adfdebcb03bb94ac$var$rsLower + '+' + $adfdebcb03bb94ac$var$rsOptContrLower + '(?=' + [
        $adfdebcb03bb94ac$var$rsBreak,
        $adfdebcb03bb94ac$var$rsUpper,
        '$'
    ].join('|') + ')',
    $adfdebcb03bb94ac$var$rsMiscUpper + '+' + $adfdebcb03bb94ac$var$rsOptContrUpper + '(?=' + [
        $adfdebcb03bb94ac$var$rsBreak,
        $adfdebcb03bb94ac$var$rsUpper + $adfdebcb03bb94ac$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $adfdebcb03bb94ac$var$rsUpper + '?' + $adfdebcb03bb94ac$var$rsMiscLower + '+' + $adfdebcb03bb94ac$var$rsOptContrLower,
    $adfdebcb03bb94ac$var$rsUpper + '+' + $adfdebcb03bb94ac$var$rsOptContrUpper,
    $adfdebcb03bb94ac$var$rsOrdUpper,
    $adfdebcb03bb94ac$var$rsOrdLower,
    $adfdebcb03bb94ac$var$rsDigits,
    $adfdebcb03bb94ac$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $adfdebcb03bb94ac$var$unicodeWords(string) {
    return string.match($adfdebcb03bb94ac$var$reUnicodeWord) || [];
}
$adfdebcb03bb94ac$exports = $adfdebcb03bb94ac$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $f7aa76ef659e7fe4$var$words(string, pattern, guard) {
    string = $a863ad98b2851f02$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $55ab3e4bcd690578$exports(string) ? $adfdebcb03bb94ac$exports(string) : $0e6bf15907342c1b$exports(string);
    return string.match(pattern) || [];
}
$f7aa76ef659e7fe4$exports = $f7aa76ef659e7fe4$var$words;


/** Used to compose unicode capture groups. */ var $448b6cb720a55fb8$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $448b6cb720a55fb8$var$reApos = RegExp($448b6cb720a55fb8$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $448b6cb720a55fb8$var$createCompounder(callback) {
    return function(string) {
        return $0206f3c93c36a3b6$exports($f7aa76ef659e7fe4$exports($671754e211b59dce$exports(string).replace($448b6cb720a55fb8$var$reApos, '')), callback, '');
    };
}
$448b6cb720a55fb8$exports = $448b6cb720a55fb8$var$createCompounder;


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */ var $2ed6aaa3fdd7a5e2$var$snakeCase = $448b6cb720a55fb8$exports(function(result, word, index) {
    return result + (index ? '_' : '') + word.toLowerCase();
});
$2ed6aaa3fdd7a5e2$exports = $2ed6aaa3fdd7a5e2$var$snakeCase;


var $5ed6a3d40b486924$exports = {};
var $4763a82b995aec94$exports = {};

var $50e3eda4de3dd6f5$exports = {};
var $2c576ceab8066055$exports = {};
var $743b7678d7215cf5$exports = {};
var $3bb41473d1f4ffc9$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3bb41473d1f4ffc9$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$3bb41473d1f4ffc9$exports = $3bb41473d1f4ffc9$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $743b7678d7215cf5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $3bb41473d1f4ffc9$exports(array, start, end);
}
$743b7678d7215cf5$exports = $743b7678d7215cf5$var$castSlice;


var $1e0ada66bef6ffd8$exports = {};
/** Used to compose unicode character classes. */ var $1e0ada66bef6ffd8$var$rsAstralRange = '\\ud800-\\udfff', $1e0ada66bef6ffd8$var$rsComboMarksRange = '\\u0300-\\u036f', $1e0ada66bef6ffd8$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $1e0ada66bef6ffd8$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $1e0ada66bef6ffd8$var$rsComboRange = $1e0ada66bef6ffd8$var$rsComboMarksRange + $1e0ada66bef6ffd8$var$reComboHalfMarksRange + $1e0ada66bef6ffd8$var$rsComboSymbolsRange, $1e0ada66bef6ffd8$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $1e0ada66bef6ffd8$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $1e0ada66bef6ffd8$var$reHasUnicode = RegExp('[' + $1e0ada66bef6ffd8$var$rsZWJ + $1e0ada66bef6ffd8$var$rsAstralRange + $1e0ada66bef6ffd8$var$rsComboRange + $1e0ada66bef6ffd8$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $1e0ada66bef6ffd8$var$hasUnicode(string) {
    return $1e0ada66bef6ffd8$var$reHasUnicode.test(string);
}
$1e0ada66bef6ffd8$exports = $1e0ada66bef6ffd8$var$hasUnicode;


var $bc107dcd6c0c9207$exports = {};
var $54b3949beac402eb$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $54b3949beac402eb$var$asciiToArray(string) {
    return string.split('');
}
$54b3949beac402eb$exports = $54b3949beac402eb$var$asciiToArray;



var $bb7d3c3112592181$exports = {};
/** Used to compose unicode character classes. */ var $bb7d3c3112592181$var$rsAstralRange = '\\ud800-\\udfff', $bb7d3c3112592181$var$rsComboMarksRange = '\\u0300-\\u036f', $bb7d3c3112592181$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $bb7d3c3112592181$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $bb7d3c3112592181$var$rsComboRange = $bb7d3c3112592181$var$rsComboMarksRange + $bb7d3c3112592181$var$reComboHalfMarksRange + $bb7d3c3112592181$var$rsComboSymbolsRange, $bb7d3c3112592181$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $bb7d3c3112592181$var$rsAstral = '[' + $bb7d3c3112592181$var$rsAstralRange + ']', $bb7d3c3112592181$var$rsCombo = '[' + $bb7d3c3112592181$var$rsComboRange + ']', $bb7d3c3112592181$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $bb7d3c3112592181$var$rsModifier = '(?:' + $bb7d3c3112592181$var$rsCombo + '|' + $bb7d3c3112592181$var$rsFitz + ')', $bb7d3c3112592181$var$rsNonAstral = '[^' + $bb7d3c3112592181$var$rsAstralRange + ']', $bb7d3c3112592181$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $bb7d3c3112592181$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $bb7d3c3112592181$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $bb7d3c3112592181$var$reOptMod = $bb7d3c3112592181$var$rsModifier + '?', $bb7d3c3112592181$var$rsOptVar = '[' + $bb7d3c3112592181$var$rsVarRange + ']?', $bb7d3c3112592181$var$rsOptJoin = '(?:' + $bb7d3c3112592181$var$rsZWJ + '(?:' + [
    $bb7d3c3112592181$var$rsNonAstral,
    $bb7d3c3112592181$var$rsRegional,
    $bb7d3c3112592181$var$rsSurrPair
].join('|') + ')' + $bb7d3c3112592181$var$rsOptVar + $bb7d3c3112592181$var$reOptMod + ')*', $bb7d3c3112592181$var$rsSeq = $bb7d3c3112592181$var$rsOptVar + $bb7d3c3112592181$var$reOptMod + $bb7d3c3112592181$var$rsOptJoin, $bb7d3c3112592181$var$rsSymbol = '(?:' + [
    $bb7d3c3112592181$var$rsNonAstral + $bb7d3c3112592181$var$rsCombo + '?',
    $bb7d3c3112592181$var$rsCombo,
    $bb7d3c3112592181$var$rsRegional,
    $bb7d3c3112592181$var$rsSurrPair,
    $bb7d3c3112592181$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $bb7d3c3112592181$var$reUnicode = RegExp($bb7d3c3112592181$var$rsFitz + '(?=' + $bb7d3c3112592181$var$rsFitz + ')|' + $bb7d3c3112592181$var$rsSymbol + $bb7d3c3112592181$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $bb7d3c3112592181$var$unicodeToArray(string) {
    return string.match($bb7d3c3112592181$var$reUnicode) || [];
}
$bb7d3c3112592181$exports = $bb7d3c3112592181$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $bc107dcd6c0c9207$var$stringToArray(string) {
    return $1e0ada66bef6ffd8$exports(string) ? $bb7d3c3112592181$exports(string) : $54b3949beac402eb$exports(string);
}
$bc107dcd6c0c9207$exports = $bc107dcd6c0c9207$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $2c576ceab8066055$var$createCaseFirst(methodName) {
    return function(string) {
        string = $a863ad98b2851f02$exports(string);
        var strSymbols = $1e0ada66bef6ffd8$exports(string) ? $bc107dcd6c0c9207$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $743b7678d7215cf5$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$2c576ceab8066055$exports = $2c576ceab8066055$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $50e3eda4de3dd6f5$var$upperFirst = $2c576ceab8066055$exports('toUpperCase');
$50e3eda4de3dd6f5$exports = $50e3eda4de3dd6f5$var$upperFirst;


/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $4763a82b995aec94$var$capitalize(string) {
    return $50e3eda4de3dd6f5$exports($a863ad98b2851f02$exports(string).toLowerCase());
}
$4763a82b995aec94$exports = $4763a82b995aec94$var$capitalize;



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $5ed6a3d40b486924$var$camelCase = $448b6cb720a55fb8$exports(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $4763a82b995aec94$exports(word) : word);
});
$5ed6a3d40b486924$exports = $5ed6a3d40b486924$var$camelCase;


var $49dc9e8d6709dfbd$exports = {};



/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $49dc9e8d6709dfbd$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $9cb616549df16e8a$exports(iteratee, 3);
    $9a2fd95e744f294f$exports(object, function(value, key, object) {
        $7ac8911b657c3928$exports(result, iteratee(value, key, object), value);
    });
    return result;
}
$49dc9e8d6709dfbd$exports = $49dc9e8d6709dfbd$var$mapKeys;






var $2fd3442123efe402$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $2fd3442123efe402$exports = function(edges) {
    return $2fd3442123efe402$var$toposort($2fd3442123efe402$var$uniqueNodes(edges), edges);
};
$2fd3442123efe402$exports.array = $2fd3442123efe402$var$toposort;
function $2fd3442123efe402$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $2fd3442123efe402$var$makeOutgoingEdges(edges), nodesHash = $2fd3442123efe402$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $2fd3442123efe402$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $2fd3442123efe402$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $2fd3442123efe402$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}





function $3ffe3848d5e98294$export$2e2bcd8739ae039(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $7b8e6223f25a2f80$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for(const key in fields)if ((0, (/*@__PURE__*/$parcel$interopDefault($57951377449b53e6$exports)))(fields, key)) {
        let value = fields[key];
        nodes.add(key);
        if ((0, $b3adddf52d229d80$export$2e2bcd8739ae039).isRef(value) && value.isSibling) addNode(value.path, key);
        else if ((0, $a379620def444ff5$export$2e2bcd8739ae039)(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($2fd3442123efe402$exports))).array(Array.from(nodes), edges).reverse();
}


function $d549782a96ca87b9$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $d549782a96ca87b9$export$2e2bcd8739ae039(keys) {
    return (a, b)=>{
        return $d549782a96ca87b9$var$findIndex(keys, a) - $d549782a96ca87b9$var$findIndex(keys, b);
    };
}





function $e6d972962a22d393$var$_extends() {
    $e6d972962a22d393$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6d972962a22d393$var$_extends.apply(this, arguments);
}
let $e6d972962a22d393$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $e6d972962a22d393$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $e6d972962a22d393$var$defaultSort = (0, $d549782a96ca87b9$export$2e2bcd8739ae039)([]);
class $e6d972962a22d393$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(spec){
        super({
            type: 'object'
        });
        this.fields = Object.create(null);
        this._sortErrors = $e6d972962a22d393$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            this.transform(function coerce(value) {
                if (typeof value === 'string') try {
                    value = JSON.parse(value);
                } catch (err) {
                    value = null;
                }
                if (this.isType(value)) return value;
                return null;
            });
            if (spec) this.shape(spec);
        });
    }
    _typeCheck(value) {
        return $e6d972962a22d393$var$isObject(value) || typeof value === 'function';
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options); //should ignore nulls here
        if (value === undefined) return this.getDefault();
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = this._nodes.concat(Object.keys(value).filter((v)=>this._nodes.indexOf(v) === -1));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = $e6d972962a22d393$var$_extends({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = (0, (/*@__PURE__*/$parcel$interopDefault($57951377449b53e6$exports)))(value, prop);
            if (field) {
                let fieldValue;
                let inputValue = value[prop]; // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = 'spec' in field ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec == null ? void 0 : fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, opts = {}, callback) {
        let errors = [];
        let { sync: sync, from: from = [], originalValue: originalValue = _value, abortEarly: abortEarly = this.spec.abortEarly, recursive: recursive = this.spec.recursive } = opts;
        from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ]; // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        opts.__validating = true;
        opts.originalValue = originalValue;
        opts.from = from;
        super._validate(_value, opts, (err, value)=>{
            if (err) {
                if (!(0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(err) || abortEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !$e6d972962a22d393$var$isObject(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = this._nodes.map((key)=>(_, cb)=>{
                    let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
                    let field = this.fields[key];
                    if (field && 'validate' in field) {
                        field.validate(value[key], $e6d972962a22d393$var$_extends({}, opts, {
                            path: // @ts-ignore
                            path,
                            from: from,
                            // inner fields are always strict:
                            // 1. this isn't strict so the casting will also have cast inner values
                            // 2. this is strict in which case the nested values weren't cast either
                            strict: true,
                            parent: value,
                            originalValue: originalValue[key]
                        }), cb);
                        return;
                    }
                    cb(null);
                });
            (0, $a2a091fa47a581a7$export$2e2bcd8739ae039)({
                sync: sync,
                tests: tests,
                value: value,
                errors: errors,
                endEarly: abortEarly,
                sort: this._sortErrors,
                path: opts.path
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = $e6d972962a22d393$var$_extends({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            if (target === undefined) nextFields[field] = schemaOrRef;
            else if (target instanceof (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) && schemaOrRef instanceof (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039)) nextFields[field] = schemaOrRef.concat(target);
        }
        return next.withMutation(()=>next.shape(nextFields, this._excludedEdges));
    }
    getDefaultFromShape() {
        let dft = {};
        this._nodes.forEach((key)=>{
            const field = this.fields[key];
            dft[key] = 'default' in field ? field.getDefault() : undefined;
        });
        return dft;
    }
    _getDefault() {
        if ('default' in this.spec) return super._getDefault();
         // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        return this.getDefaultFromShape();
    }
    shape(additions, excludes = []) {
        let next = this.clone();
        let fields = Object.assign(next.fields, additions);
        next.fields = fields;
        next._sortErrors = (0, $d549782a96ca87b9$export$2e2bcd8739ae039)(Object.keys(fields));
        if (excludes.length) {
            // this is a convenience for when users only supply a single pair
            if (!Array.isArray(excludes[0])) excludes = [
                excludes
            ];
            next._excludedEdges = [
                ...next._excludedEdges,
                ...excludes
            ];
        }
        next._nodes = (0, $3ffe3848d5e98294$export$2e2bcd8739ae039)(fields, next._excludedEdges);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.clone().withMutation((next)=>{
            next.fields = {};
            return next.shape(picked);
        });
    }
    omit(keys) {
        const next = this.clone();
        const fields = next.fields;
        next.fields = {};
        for (const key of keys)delete fields[key];
        return next.withMutation(()=>next.shape(fields));
    }
    from(from, to, alias) {
        let fromGetter = (0, $7b8e6223f25a2f80$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (obj == null) return obj;
            let newObj = obj;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($57951377449b53e6$exports)))(obj, from)) {
                newObj = $e6d972962a22d393$var$_extends({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    noUnknown(noAllow = true, message = (0, $e918c4ca8768491c$export$be5493f9613cbbe).noUnknown) {
        if (typeof noAllow === 'string') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $e6d972962a22d393$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = (0, $e918c4ca8768491c$export$be5493f9613cbbe).noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>obj && (0, (/*@__PURE__*/$parcel$interopDefault($49dc9e8d6709dfbd$exports)))(obj, (_, key)=>fn(key)));
    }
    camelCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($5ed6a3d40b486924$exports))));
    }
    snakeCase() {
        return this.transformKeys((0, (/*@__PURE__*/$parcel$interopDefault($2ed6aaa3fdd7a5e2$exports))));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, (/*@__PURE__*/$parcel$interopDefault($2ed6aaa3fdd7a5e2$exports)))(key).toUpperCase());
    }
    describe() {
        let base = super.describe();
        base.fields = (0, (/*@__PURE__*/$parcel$interopDefault($468520a99798aaf1$exports)))(this.fields, (value)=>value.describe());
        return base;
    }
}
function $e6d972962a22d393$export$185802fd694ee1f5(spec) {
    return new $e6d972962a22d393$export$2e2bcd8739ae039(spec);
}
$e6d972962a22d393$export$185802fd694ee1f5.prototype = $e6d972962a22d393$export$2e2bcd8739ae039.prototype;









function $2145de3a81489cd9$var$_extends() {
    $2145de3a81489cd9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2145de3a81489cd9$var$_extends.apply(this, arguments);
}
function $2145de3a81489cd9$export$185802fd694ee1f5(type) {
    return new $2145de3a81489cd9$export$2e2bcd8739ae039(type);
}
class $2145de3a81489cd9$export$2e2bcd8739ae039 extends (0, $8acfe9a6cc2d46bd$export$2e2bcd8739ae039) {
    constructor(type){
        super({
            type: 'array'
        }); // `undefined` specifically means uninitialized, as opposed to
        // "no subtype"
        this.innerType = void 0;
        this.innerType = type;
        this.withMutation(()=>{
            this.transform(function(values) {
                if (typeof values === 'string') try {
                    values = JSON.parse(values);
                } catch (err) {
                    values = null;
                }
                return this.isType(values) ? values : null;
            });
        });
    }
    _typeCheck(v) {
        return Array.isArray(v);
    }
    get _subType() {
        return this.innerType;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts); //should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, $2145de3a81489cd9$var$_extends({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, callback) {
        var _options$abortEarly, _options$recursive;
        let errors = [];
        let sync = options.sync;
        let path = options.path;
        let innerType = this.innerType;
        let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        let originalValue = options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, (err, value)=>{
            if (err) {
                if (!(0, $841702205e82e4dd$export$2e2bcd8739ae039).isError(err) || endEarly) return void callback(err, value);
                errors.push(err);
            }
            if (!recursive || !innerType || !this._typeCheck(value)) {
                callback(errors[0] || null, value);
                return;
            }
            originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let idx = 0; idx < value.length; idx++){
                let item = value[idx];
                let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation
                let innerOptions = $2145de3a81489cd9$var$_extends({}, options, {
                    path: path,
                    strict: true,
                    parent: value,
                    index: idx,
                    originalValue: originalValue[idx]
                });
                tests[idx] = (_, cb)=>innerType.validate(item, innerOptions, cb);
            }
            (0, $a2a091fa47a581a7$export$2e2bcd8739ae039)({
                sync: sync,
                path: path,
                value: value,
                errors: errors,
                endEarly: endEarly,
                tests: tests
            }, callback);
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.innerType = this.innerType;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        next.innerType = this.innerType;
        if (schema.innerType) next.innerType = next.innerType ? next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!(0, $a379620def444ff5$export$2e2bcd8739ae039)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0, $c17a300a1d15ba7f$export$2e2bcd8739ae039)(schema)); // FIXME(ts):
        next.innerType = schema;
        return next;
    }
    length(length, message = (0, $e918c4ca8768491c$export$2f23118c22fb2630).length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || (0, $e918c4ca8768491c$export$2f23118c22fb2630).min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            // FIXME(ts): Array<typeof T>
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || (0, $e918c4ca8768491c$export$2f23118c22fb2630).max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            test (value) {
                return (0, $06cc44d8b3bca62c$export$2e2bcd8739ae039)(value) || value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe() {
        let base = super.describe();
        if (this.innerType) base.innerType = this.innerType.describe();
        return base;
    }
    nullable(isNullable = true) {
        return super.nullable(isNullable);
    }
    defined() {
        return super.defined();
    }
    required(msg) {
        return super.required(msg);
    }
}
$2145de3a81489cd9$export$185802fd694ee1f5.prototype = $2145de3a81489cd9$export$2e2bcd8739ae039.prototype; //
 // Interfaces
 //




function $17344374c5244d24$export$185802fd694ee1f5(builder) {
    return new $17344374c5244d24$var$Lazy(builder);
}
class $17344374c5244d24$var$Lazy {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.__inputType = void 0;
        this.__outputType = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!(0, $a379620def444ff5$export$2e2bcd8739ae039)(schema)) throw new TypeError('lazy() functions must return a valid schema');
            return schema.resolve(options);
        };
        this.builder = builder;
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    validate(value, options, maybeCb) {
        // @ts-expect-error missing public callback on type
        return this._resolve(value, options).validate(value, options, maybeCb);
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return this._resolve(value, options).validateAt(path, value, options);
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    describe() {
        return null;
    }
    isValid(value, options) {
        return this._resolve(value, options).isValid(value, options);
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
}
var $17344374c5244d24$export$2e2bcd8739ae039 = $17344374c5244d24$var$Lazy;






function $dac932fcb06a6927$export$2e2bcd8739ae039(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            (0, $e918c4ca8768491c$export$2e2bcd8739ae039)[type][method] = custom[type][method];
        });
    });
}



function $5fe60eb48993b2d4$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !(0, $a379620def444ff5$export$2e2bcd8739ae039)(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}






var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
function $49a4d2e16d635cf0$export$ab7c8fab0bc555b6(value) {
    var ref = (0, $bh6RR.useRef)(value);
    ref.current = value;
    return (0, $bh6RR.useMemo)(function() {
        return Object.freeze({
            get current () {
                return ref.current;
            }
        });
    }, []);
}



var $772927ded777173a$var$observerSingleton;
function $772927ded777173a$var$getResizeObserver() {
    if (!(0, $8be90def2b6d80b2$export$4e09c449d6c407f7)) return undefined;
    if ($772927ded777173a$var$observerSingleton) return $772927ded777173a$var$observerSingleton;
    var callbacks = new Map();
    var observer = new ResizeObserver(function(entries) {
        entries.forEach(function(entry) {
            var _a;
            return (_a = callbacks.get(entry.target)) === null || _a === void 0 ? void 0 : _a.forEach(function(cb) {
                return setTimeout(function() {
                    return cb(entry);
                }, 0);
            });
        });
    });
    $772927ded777173a$var$observerSingleton = {
        observer: observer,
        subscribe: function(target, callback) {
            var cbs = callbacks.get(target);
            if (!cbs) {
                // if target has no observers yet - register it
                cbs = new Set();
                callbacks.set(target, cbs);
                observer.observe(target);
            }
            // as Set is duplicate-safe - simply add callback on each call
            cbs.add(callback);
        },
        unsubscribe: function(target, callback) {
            var cbs = callbacks.get(target);
            // else branch should never occur in case of normal execution
            // because callbacks map is hidden in closure - it is impossible to
            // simulate situation with non-existent `cbs` Set
            /* istanbul ignore else */ if (cbs) {
                // remove current observer
                cbs.delete(callback);
                if (!cbs.size) {
                    // if no observers left unregister target completely
                    callbacks.delete(target);
                    observer.unobserve(target);
                }
            }
        }
    };
    return $772927ded777173a$var$observerSingleton;
}
function $772927ded777173a$export$683480f191c0e3ea(target, callback, enabled) {
    if (enabled === void 0) enabled = true;
    var ro = enabled && $772927ded777173a$var$getResizeObserver();
    var cb = (0, $49a4d2e16d635cf0$export$ab7c8fab0bc555b6)(callback);
    var tgt = target && 'current' in target ? target.current : target;
    (0, $bh6RR.useEffect)(function() {
        // this secondary target resolve required for case when we receive ref object, which, most
        // likely, contains null during render stage, but already populated with element during
        // effect stage.
        // eslint-disable-next-line @typescript-eslint/no-shadow
        var tgt = target && 'current' in target ? target.current : target;
        if (!ro || !tgt) return;
        // as unsubscription in internals of our ResizeObserver abstraction can
        // happen a bit later than effect cleanup invocation - we need a marker,
        // that this handler should not be invoked anymore
        var subscribed = true;
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // it is reinsurance for the highly asynchronous invocations, almost
            // impossible to achieve in tests, thus excluding from LOC
            /* istanbul ignore else */ if (subscribed) cb.current.apply(cb, args);
        };
        ro.subscribe(tgt, handler);
        return function() {
            subscribed = false;
            ro.unsubscribe(tgt, handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tgt,
        ro
    ]);
}



var $bh6RR = parcelRequire("bh6RR");

function $da8fcd3c3d85ef71$export$dfc920b3a256ac30(initialValue, onSet, onGet) {
    var onSetRef = (0, $49a4d2e16d635cf0$export$ab7c8fab0bc555b6)(onSet);
    var onGetRef = (0, $49a4d2e16d635cf0$export$ab7c8fab0bc555b6)(onGet);
    return (0, $bh6RR.useMemo)(function() {
        var v = initialValue;
        return {
            get current () {
                return onGetRef.current === undefined ? v : onGetRef.current(v);
            },
            set current (val){
                v = onSetRef.current === undefined ? val : onSetRef.current(val);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $c81e3996b5300ebd$export$f3a192d0cbd30b96(effect) {
    var effectRef = (0, $49a4d2e16d635cf0$export$ab7c8fab0bc555b6)(effect);
    (0, $bh6RR.useEffect)(function() {
        return function() {
            effectRef.current();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
}



function $f4a46ef9faab4607$export$79465d637252833b(cb) {
    var cbRef = (0, $49a4d2e16d635cf0$export$ab7c8fab0bc555b6)(cb);
    var frame = (0, $bh6RR.useRef)(0);
    var cancel = (0, $bh6RR.useCallback)(function() {
        if (!(0, $8be90def2b6d80b2$export$4e09c449d6c407f7)) return;
        if (frame.current) {
            cancelAnimationFrame(frame.current);
            frame.current = 0;
        }
    }, []);
    (0, $c81e3996b5300ebd$export$f3a192d0cbd30b96)(cancel);
    return [
        (0, $bh6RR.useMemo)(function() {
            var wrapped = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                if (!(0, $8be90def2b6d80b2$export$4e09c449d6c407f7)) return;
                cancel();
                frame.current = requestAnimationFrame(function() {
                    cbRef.current.apply(cbRef, args);
                    frame.current = 0;
                });
            };
            Object.defineProperties(wrapped, {
                length: {
                    value: cb.length
                },
                name: {
                    value: "".concat(cb.name || 'anonymous', "__raf")
                }
            });
            return wrapped;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []),
        cancel
    ];
}



function $7d64a83d758ae887$export$e295b0c537d32d7d(enabled) {
    if (enabled === void 0) enabled = true;
    var _a = (0, $76fff3f0cf23fcb0$export$31ed1f10e45d55c0)(null), element = _a[0], setElement = _a[1];
    var elementRef = (0, $da8fcd3c3d85ef71$export$dfc920b3a256ac30)(null, function(v) {
        setElement(v);
        return v;
    });
    var _b = (0, $76fff3f0cf23fcb0$export$31ed1f10e45d55c0)(), measures = _b[0], setMeasures = _b[1];
    var observerHandler = (0, $f4a46ef9faab4607$export$79465d637252833b)(function(entry) {
        return setMeasures({
            width: entry.contentRect.width,
            height: entry.contentRect.height
        });
    })[0];
    (0, $772927ded777173a$export$683480f191c0e3ea)(element, observerHandler, enabled);
    return [
        measures,
        elementRef
    ];
}







var $ih19M = parcelRequire("ih19M");

var $2b46565ae75b486a$exports = {};

$parcel$export($2b46565ae75b486a$exports, "active", function () { return $2b46565ae75b486a$export$89da14300d534261; }, function (v) { return $2b46565ae75b486a$export$89da14300d534261 = v; });
$parcel$export($2b46565ae75b486a$exports, "icon", function () { return $2b46565ae75b486a$export$1ca1ec8b29a4ce27; }, function (v) { return $2b46565ae75b486a$export$1ca1ec8b29a4ce27 = v; });
var $2b46565ae75b486a$export$89da14300d534261;
var $2b46565ae75b486a$export$1ca1ec8b29a4ce27;
$2b46565ae75b486a$export$89da14300d534261 = `jlqDWG_active`;
$2b46565ae75b486a$export$1ca1ec8b29a4ce27 = `jlqDWG_icon`;


const $56e05d11b2edbc73$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($2b46565ae75b486a$exports);
function $56e05d11b2edbc73$export$2e2bcd8739ae039({ className: className, active: active }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        viewBox: "0 0 17 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: $56e05d11b2edbc73$var$cx($2b46565ae75b486a$exports.icon, className, {
            active: active
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M11.5964 12.0973C12.7207 10.9739 13.4161 9.42161 13.4161 7.7069C13.4161 4.27892 10.6367 1.5 7.20807 1.5C3.77945 1.5 1 4.27892 1 7.7069C1 11.1349 3.77945 13.9138 7.20807 13.9138C8.92166 13.9138 10.4731 13.2196 11.5964 12.0973ZM11.5964 12.0973L16 16.5",
            strokeWidth: "2"
        })
    });
}


var $1d27ba7d2744ae6e$exports = {};

$parcel$export($1d27ba7d2744ae6e$exports, "charIcon", function () { return $1d27ba7d2744ae6e$export$5dd68419f8c7e5a7; }, function (v) { return $1d27ba7d2744ae6e$export$5dd68419f8c7e5a7 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "container", function () { return $1d27ba7d2744ae6e$export$34e0f9847d4c02dd; }, function (v) { return $1d27ba7d2744ae6e$export$34e0f9847d4c02dd = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "dropDown", function () { return $1d27ba7d2744ae6e$export$bd4558eab3154e95; }, function (v) { return $1d27ba7d2744ae6e$export$bd4558eab3154e95 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "dropDownAddress", function () { return $1d27ba7d2744ae6e$export$e44ac5ceb0ea9f23; }, function (v) { return $1d27ba7d2744ae6e$export$e44ac5ceb0ea9f23 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "dropDownVisible", function () { return $1d27ba7d2744ae6e$export$949e8fe95f85be45; }, function (v) { return $1d27ba7d2744ae6e$export$949e8fe95f85be45 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "dropdown", function () { return $1d27ba7d2744ae6e$export$81207e5cc4186890; }, function (v) { return $1d27ba7d2744ae6e$export$81207e5cc4186890 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "fieldwrapper", function () { return $1d27ba7d2744ae6e$export$3f86e1ad16ac99b; }, function (v) { return $1d27ba7d2744ae6e$export$3f86e1ad16ac99b = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "fullscreen", function () { return $1d27ba7d2744ae6e$export$af93ab412ae68734; }, function (v) { return $1d27ba7d2744ae6e$export$af93ab412ae68734 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "hasError", function () { return $1d27ba7d2744ae6e$export$5e63894f961a3223; }, function (v) { return $1d27ba7d2744ae6e$export$5e63894f961a3223 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "icon", function () { return $1d27ba7d2744ae6e$export$1ca1ec8b29a4ce27; }, function (v) { return $1d27ba7d2744ae6e$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "item", function () { return $1d27ba7d2744ae6e$export$7061c75fc5af8b7e; }, function (v) { return $1d27ba7d2744ae6e$export$7061c75fc5af8b7e = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "locationIcon", function () { return $1d27ba7d2744ae6e$export$5c643f429ab0c3b4; }, function (v) { return $1d27ba7d2744ae6e$export$5c643f429ab0c3b4 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "locationbutton", function () { return $1d27ba7d2744ae6e$export$8c24b68213ccac0e; }, function (v) { return $1d27ba7d2744ae6e$export$8c24b68213ccac0e = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "message", function () { return $1d27ba7d2744ae6e$export$a8ecead220dd38a6; }, function (v) { return $1d27ba7d2744ae6e$export$a8ecead220dd38a6 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "scrollable", function () { return $1d27ba7d2744ae6e$export$e19e816763c25ac; }, function (v) { return $1d27ba7d2744ae6e$export$e19e816763c25ac = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "selected", function () { return $1d27ba7d2744ae6e$export$d90250155de6d7e7; }, function (v) { return $1d27ba7d2744ae6e$export$d90250155de6d7e7 = v; });
$parcel$export($1d27ba7d2744ae6e$exports, "upward", function () { return $1d27ba7d2744ae6e$export$b066907a6a5b213c; }, function (v) { return $1d27ba7d2744ae6e$export$b066907a6a5b213c = v; });
var $1d27ba7d2744ae6e$export$5dd68419f8c7e5a7;
var $1d27ba7d2744ae6e$export$34e0f9847d4c02dd;
var $1d27ba7d2744ae6e$export$bd4558eab3154e95;
var $1d27ba7d2744ae6e$export$e44ac5ceb0ea9f23;
var $1d27ba7d2744ae6e$export$949e8fe95f85be45;
var $1d27ba7d2744ae6e$export$81207e5cc4186890;
var $1d27ba7d2744ae6e$export$3f86e1ad16ac99b;
var $1d27ba7d2744ae6e$export$af93ab412ae68734;
var $1d27ba7d2744ae6e$export$5e63894f961a3223;
var $1d27ba7d2744ae6e$export$1ca1ec8b29a4ce27;
var $1d27ba7d2744ae6e$export$7061c75fc5af8b7e;
var $1d27ba7d2744ae6e$export$5c643f429ab0c3b4;
var $1d27ba7d2744ae6e$export$8c24b68213ccac0e;
var $1d27ba7d2744ae6e$export$a8ecead220dd38a6;
var $1d27ba7d2744ae6e$export$e19e816763c25ac;
var $1d27ba7d2744ae6e$export$d90250155de6d7e7;
var $1d27ba7d2744ae6e$export$b066907a6a5b213c;
$1d27ba7d2744ae6e$export$5dd68419f8c7e5a7 = `_483SWG_charIcon`;
$1d27ba7d2744ae6e$export$34e0f9847d4c02dd = `_483SWG_container`;
$1d27ba7d2744ae6e$export$bd4558eab3154e95 = `_483SWG_dropDown`;
$1d27ba7d2744ae6e$export$e44ac5ceb0ea9f23 = `_483SWG_dropDownAddress`;
$1d27ba7d2744ae6e$export$949e8fe95f85be45 = `_483SWG_dropDownVisible`;
$1d27ba7d2744ae6e$export$81207e5cc4186890 = `_483SWG_dropdown`;
$1d27ba7d2744ae6e$export$3f86e1ad16ac99b = `_483SWG_fieldwrapper`;
$1d27ba7d2744ae6e$export$af93ab412ae68734 = `_483SWG_fullscreen`;
$1d27ba7d2744ae6e$export$5e63894f961a3223 = `_483SWG_hasError`;
$1d27ba7d2744ae6e$export$1ca1ec8b29a4ce27 = `_483SWG_icon`;
$1d27ba7d2744ae6e$export$7061c75fc5af8b7e = `_483SWG_item`;
$1d27ba7d2744ae6e$export$5c643f429ab0c3b4 = `_483SWG_locationIcon`;
$1d27ba7d2744ae6e$export$8c24b68213ccac0e = `_483SWG_locationbutton`;
$1d27ba7d2744ae6e$export$a8ecead220dd38a6 = `_483SWG_message`;
$1d27ba7d2744ae6e$export$e19e816763c25ac = `_483SWG_scrollable`;
$1d27ba7d2744ae6e$export$d90250155de6d7e7 = `_483SWG_selected`;
$1d27ba7d2744ae6e$export$b066907a6a5b213c = `_483SWG_upward`;




const $b6b4255c134cf0ab$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($1d27ba7d2744ae6e$exports);
const $b6b4255c134cf0ab$var$hasValue = (field)=>field.value !== '' && field.value !== '-' && field.value?.address !== undefined;
const $b6b4255c134cf0ab$var$formatLocationWithId = (location)=>{
    // NOTE: Rename locationId to id
    const { locationId: id, ...rest } = location;
    // Add unique id to every location object to use as React key in the search locations component.
    // This allows duplicate addresses, for example if departure and destination is the same but with multiple stops in between.
    if (rest?.address?.streetName && !rest.key) rest.key = (0, $cf399e049a9c4d34$export$ac4959f4f1338dfc)(10);
    return {
        id: id,
        ...rest
    };
};
const $b6b4255c134cf0ab$export$a79e2b3ea5d10ee0 = ()=>{};
function $b6b4255c134cf0ab$export$2e2bcd8739ae039({ fullscreen: fullscreen, field: field, // { name, value, onChange, onBlur }
form: { errors: errors, touched: touched, setFieldValue: setFieldValue, setFieldTouched: setFieldTouched }, innerRef: // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
innerRef, useLocation: useLocation = false, key: key, resetSearch: resetSearch, parentLocation: parentLocation, fieldIndex: fieldIndex, ...props }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const minChars = 3;
    const [listSize, listRef] = (0, $7d64a83d758ae887$export$e295b0c537d32d7d)();
    const [listContentSize, listContentRef] = (0, $7d64a83d758ae887$export$e295b0c537d32d7d)();
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    const [searchValue, setSearchValue] = (0, $bh6RR.useState)($b6b4255c134cf0ab$var$hasValue(field) ? (0, $200ec6b1b2ca8c5a$export$5964fc5149281592)(field.value) : '');
    const [locations, setLocations] = (0, $bh6RR.useState)();
    const [currentIndex, setCurrentIndex] = (0, $bh6RR.useState)(null);
    const [isVisible, setIsVisible] = (0, $bh6RR.useState)(false);
    // const [hasGeolocation, setHasGeolocation] = useState(false)
    const [toolTipVisible, setToolTipVisible] = (0, $bh6RR.useState)(false);
    const [redirectMessageVisible, setRedirectMessageVisible] = (0, $bh6RR.useState)(false);
    const [redirectMessage, setRedirectMessage] = (0, $bh6RR.useState)(false);
    const [currentExceptionZone, setCurrentExceptionZone] = (0, $bh6RR.useState)(null);
    const [addressError, setAddressError] = (0, $bh6RR.useState)(false);
    const isSelected = typeof field.value === 'object';
    const cityRef = (0, $bh6RR.useRef)();
    const streetRef = (0, $bh6RR.useRef)();
    const gotoNextLocationField = (currentFieldIndex)=>{
        if (currentFieldIndex + 1 === fieldIndex) {
            // Set a flag to indicate this is an automatic focus, not user-initiated
            // Use a longer timeout to ensure the flag persists through any Formik validation cycles
            window.AUTO_FOCUS_FIELD = field.name;
            setTimeout(()=>{
                innerRef.current?.focus();
                // Clear the flag after a longer delay to prevent validation during auto-focus
                setTimeout(()=>{
                    window.AUTO_FOCUS_FIELD = null;
                }, 500);
            }, 100);
        }
    //
    };
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('GOTO_NEXT_LOCATION_FIELD', gotoNextLocationField);
    if (innerRef === undefined) innerRef = (0, $bh6RR.useRef)();
    // Reset when clearing the search value
    const prevSearchValue = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(searchValue);
    // Reset component when the parent form is reset
    // NOTE: This only works when you have selected an address!
    const prevField = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(field);
    const reset = ()=>{
        setLocations();
        setCurrentIndex(null);
        setIsVisible(false);
        setCurrentExceptionZone(null);
        setAddressError(false);
        setRedirectMessageVisible(false);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (field.name === 'departure' && field.value?.address?.connectedRegions?.length) setFieldValue('region', field.value.address.connectedRegions.join(','));
    }, [
        field.value
    ]);
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        if (!$b6b4255c134cf0ab$var$hasValue(field)) {
            setSearchValue('');
            reset();
        } else if ($b6b4255c134cf0ab$var$hasValue(field)) {
            setSearchValue((0, $200ec6b1b2ca8c5a$export$5964fc5149281592)(field.value));
            reset();
        }
    }, [
        field.value
    ]);
    (0, $bh6RR.useEffect)(()=>{
        //console.log("useEffect searchValue", searchValue, prevSearchValue);
        if (searchValue === '' && prevSearchValue?.length > 0) // console.log('Reset location search component')
        reset();
    }, [
        searchValue,
        prevSearchValue
    ]);
    // NOTE: Handle lost focus problem with the reorder component
    (0, $bh6RR.useEffect)(()=>{
        if (innerRef.current && window?.FIELD_FOCUS?.[field.name] === true) innerRef.current.focus();
    }, [
        innerRef
    ]);
    // Keep field untouched when auto-focused to prevent premature validation errors
    // Use a ref to track if this field was auto-focused, so we can prevent it from being touched
    const wasAutoFocusedRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const isAutoFocused = window.AUTO_FOCUS_FIELD === field.name;
        if (isAutoFocused) {
            wasAutoFocusedRef.current = true;
            // Keep un-touching the field while it's auto-focused
            if (setFieldTouched && (0, $lW2XZ.getIn)(touched, field.name)) setFieldTouched(field.name, false, false);
        } else if (wasAutoFocusedRef.current && !(0, $lW2XZ.getIn)(touched, field.name)) // Field was auto-focused but is no longer auto-focused and not touched
        // Reset the flag - user can now interact normally
        wasAutoFocusedRef.current = false;
        else if (wasAutoFocusedRef.current && (0, $lW2XZ.getIn)(touched, field.name)) // Field has been explicitly touched without auto-focus active (e.g. submit validation)
        // Reset the flag so the error is allowed to render
        wasAutoFocusedRef.current = false;
    }, [
        touched,
        field.name,
        setFieldTouched
    ]);
    // Set scrollTop when switching lists
    (0, $bh6RR.useEffect)(()=>{
        if (isVisible && listRef.current) listRef.current.scrollTop = fullscreen ? 0 : 50000;
    }, [
        locations,
        isVisible,
        listRef
    ]);
    // useEffect(() => {
    //   if (useLocation && navigator.geolocation) {
    //     setHasGeolocation(true)
    //   }
    // }, [])
    const search = (value)=>{
        if (value.length >= minChars) {
            const r = field.name !== 'departure' ? values.region : null;
            // For departure field in embed mode, prioritize provider location as reference
            let referencePosition = parentLocation?.address?.position;
            const embedConfig = window.EMBED_CONFIG || {};
            if (field.name === 'departure' && embedConfig.isEmbed && embedConfig.providerLocation) // Always use provider location for departure field in embed mode
            referencePosition = {
                latitude: embedConfig.providerLocation.latitude,
                longitude: embedConfig.providerLocation.longitude
            };
            (0, $135a523c4bea715f$export$ce3a8ce471b7d4ad)(value, r, cityRef.current, referencePosition).then((locations)=>{
                if (!fullscreen) locations.reverse();
                setIsVisible(true);
                setLocations(locations);
            }).catch((error)=>{
                if (error.name !== 'AbortError') console.error(error.message);
            });
        } else if (value === '' && $b6b4255c134cf0ab$var$hasValue(field)) setFieldValue(field.name, '-');
        else if (isVisible) {
            setIsVisible(false);
            setCurrentExceptionZone(null);
        }
    };
    // -----------------------------------------------------
    //  Event handlers 
    // -----------------------------------------------------
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CLEAR_LOCATION_SEARCH', (name)=>{
        if (field.name === name) {
            setSearchValue('');
            reset();
        }
    });
    const handleChange = (event)=>{
        const v = event.target.value;
        if (streetRef.current && v.indexOf(streetRef.current) === -1) {
            cityRef.current = null;
            streetRef.current = null;
        }
        setSearchValue(v);
        setCurrentIndex(null);
        // Hide tooltip when changing input
        if (toolTipVisible) setToolTipVisible(false);
        // Hide error
        if (addressError !== false) setAddressError(false);
        search(v);
    };
    const handleKeyDown = (event)=>{
        // Prevent arrow up/down to change cursor position in the input field
        if (event.keyCode == 38 || event.keyCode == 40) event.preventDefault();
    };
    const handleKeyUp = (event)=>{
        if (locations?.length > 0) {
            if (event.keyCode == 13) {
                if (currentIndex != null) handleSelect(currentIndex);
                else if (locations.length === 1) handleSelect(0);
            } else if (event.keyCode == 38 || event.keyCode == 40) {
                if (currentIndex === null) {
                    const index = fullscreen ? 0 : locations.length - 1;
                    setCurrentIndex(index);
                } else {
                    const list = locations;
                    let ci = event.keyCode == 38 ? currentIndex - 1 : currentIndex + 1;
                    if (ci >= list.length) ci = list.length - 1;
                    else if (ci < 0) ci = 0;
                    setCurrentIndex(ci);
                    if (listRef.current) {
                        const listHeight = listSize.height;
                        const itemHeight = listContentSize.height / list.length;
                        const itemTop = ci * itemHeight;
                        const scrollTop = listRef.current.scrollTop;
                        if (itemTop + itemHeight > scrollTop + listHeight) listRef.current.scrollTop = itemTop + itemHeight - listHeight;
                        else if (itemTop < scrollTop) listRef.current.scrollTop = itemTop;
                    }
                }
            }
        }
    };
    const handleFocus = (event)=>{
        // NOTE: Handle lost focus problem with the reorder component
        if (window.FIELD_FOCUS === undefined) window.FIELD_FOCUS = {};
        window.FIELD_FOCUS[field.name] = true;
        setIsVisible(true);
        if (currentExceptionZone) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DRAW_EXEPTIONS_ZONE', currentExceptionZone);
        // If this is an automatic focus, ensure the field is NOT marked as touched
        // This prevents premature validation errors
        const isAutoFocus = window.AUTO_FOCUS_FIELD === field.name;
        if (isAutoFocus && setFieldTouched) // Explicitly un-touch the field if it was auto-focused
        setFieldTouched(field.name, false, false);
        if (props.onFocus) props.onFocus(event);
    };
    const handleBlur = (event)=>{
        // if (!useLocation) setIsVisible(false)
        // NOTE: Handle lost focus problem with the reorder component
        window.FIELD_FOCUS[field.name] = false;
        // In mobile overlay mode keep the dropdown visible — the overlay handles closing
        if (props.mobileOverlay) return;
        setIsVisible(false);
        // Only trigger Formik's onBlur if this wasn't an automatic focus transition
        // This prevents validation errors when focus moves automatically between fields
        const isAutoFocus = window.AUTO_FOCUS_FIELD === field.name;
        if (!isAutoFocus) field.onBlur(event);
        else // If this is an auto-focus field, prevent Formik from marking it as touched
        // by not calling field.onBlur, which would trigger validation
        // Also explicitly ensure it's not marked as touched
        if (setFieldTouched) setFieldTouched(field.name, false, false);
        if (props.onBlur) props.onBlur(event);
    };
    const getExeptionZoneInfo = (info)=>{
        const title = info?.exceptionZone?.name ? info?.exceptionZone?.name : '';
        const description = info?.locationInformation?.filter((item)=>[
                "EXCEPTION_ZONE_INFO"
            ].includes(item?.tag))?.[0]?.message;
        return title + (description ? " \u2013 " + description : '');
    };
    const handleSelect = (index)=>{
        const item = locations[index];
        // If incomplete address (ie. a street name)
        if (item?.locationType === 'STREET') {
            setSearchValue(item.address.streetName + ' ');
            innerRef.current?.focus();
            if (field.name === 'departure') setFieldValue('region', item.address.connectedRegions.join(','));
            // Continue search only in this city
            cityRef.current = item.address.city;
            streetRef.current = item.address.streetName;
            setToolTipVisible(true);
            setCurrentIndex(null);
            search(item.address.streetName);
            return;
        }
        setIsVisible(false);
        setCurrentExceptionZone(null);
        setSearchValue((0, $200ec6b1b2ca8c5a$export$5964fc5149281592)(item));
        // NOTE: v3 if the item already has the locationInformation we do not need to fetch again
        if (item?.locationInformation) {
            setFieldValue(field.name, $b6b4255c134cf0ab$var$formatLocationWithId(item));
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('GOTO_NEXT_LOCATION_FIELD', fieldIndex);
            if (props.onMobileSelect) setTimeout(props.onMobileSelect, 100);
            return;
        }
        (0, $135a523c4bea715f$export$359350a296630f29)(item).then((info)=>{
            // NOTE: Handle redirectLocations here
            if (info?.bookable === false && info?.exceptionZone?.redirectLocations?.length > 0) {
                const redirectLocations = info?.exceptionZone?.redirectLocations?.map($b6b4255c134cf0ab$var$formatLocationWithId).filter((item)=>{
                    // TODO: v3 Filter locations depending on TAG insted of type
                    if (field.name === 'departure') return item?.locationInformation?.filter((info)=>[
                            'NO_PICKUP'
                        ].includes(info?.tag)).length === 0;
                    if (field.name === 'destination') return item?.locationInformation?.filter((info)=>[
                            'NO_DROP_OFF'
                        ].includes(info?.tag)).length === 0;
                    if (field.name.includes('intermediateStopLocations')) return item?.locationInformation?.filter((info)=>[
                            'NO_INTERMEDIATE_STOP',
                            'NO_DROP_OFF',
                            'NO_PICKUP'
                        ].includes(info?.tag)).length === 0;
                    return false;
                });
                //value?.locationInformation?.filter(info => ['NO_INTERMEDIATE_STOP', 'NO_DROP_OFF', 'NO_PICKUP'].includes(info?.tag)).length === 0 || createError({ path, message: errorMessage })
                const locationMessage = getExeptionZoneInfo(info);
                if (info?.exceptionZone?.area?.coordinates?.[0]) {
                    // If there is an exception zone, draw it on the map
                    setRedirectMessageVisible(true);
                    setRedirectMessage(locationMessage || t('info-select-redirect'));
                    setCurrentExceptionZone({
                        paths: info.exceptionZone.area.coordinates[0].map((coord)=>({
                                lat: coord[1],
                                lng: coord[0]
                            })),
                        locations: redirectLocations.map((item)=>({
                                lat: item.address.position.latitude,
                                lng: item.address.position.longitude,
                                locationId: item.id,
                                mapExceptionZone: info?.exceptionZone
                            }))
                    });
                    setIsVisible(true);
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DRAW_EXEPTIONS_ZONE', {
                        paths: info.exceptionZone.area.coordinates[0].map((coord)=>({
                                lat: coord[1],
                                lng: coord[0]
                            })),
                        locations: redirectLocations.map((item)=>({
                                lat: item.address.position.latitude,
                                lng: item.address.position.longitude,
                                locationId: item.id,
                                mapExceptionZone: info?.exceptionZone
                            }))
                    });
                }
                if (redirectLocations.length === 0) {
                    setFieldValue(field.name, $b6b4255c134cf0ab$var$formatLocationWithId(info));
                    if (props.onMobileSelect) setTimeout(props.onMobileSelect, 100);
                } else {
                    setRedirectMessageVisible(true);
                    setRedirectMessage(locationMessage || t('info-select-redirect'));
                    setLocations(redirectLocations.map((item)=>{
                        return {
                            mapExceptionZone: info?.exceptionZone,
                            ...item
                        };
                    }));
                    setIsVisible(true);
                }
                // TODO: v3 Filter locations depending on type=PICKUP/DROP_OFF/BOTH
                /*.filter(item => {
          if (field.name === 'departure' && item.type === 'DROP_OFF') return false
          if (field.name === 'destination' && item.type === 'PICKUP') return false
          return true
        })*/ return;
            } else if (info?.exceptionZone) {
                const redirectLocations = info?.exceptionZone?.redirectLocations?.length > 0 ? [
                    $b6b4255c134cf0ab$var$formatLocationWithId(info),
                    ...info?.exceptionZone?.redirectLocations?.map($b6b4255c134cf0ab$var$formatLocationWithId)
                ].filter((item, id, arr)=>{
                    return arr.find((itemFind, index)=>{
                        return itemFind.id === item.id && index !== id;
                    }) === undefined;
                }) : [];
                const bookableLocation = $b6b4255c134cf0ab$var$formatLocationWithId(info);
                redirectLocations.push(bookableLocation);
                const locationMessage = getExeptionZoneInfo(info);
                if (locationMessage) {
                    setRedirectMessage(locationMessage);
                    setRedirectMessageVisible(true);
                    setIsVisible(true);
                    const bookableLocation = $b6b4255c134cf0ab$var$formatLocationWithId(info);
                    bookableLocation.mapExceptionZone = info?.exceptionZone;
                    setLocations(redirectLocations.map((item)=>{
                        return {
                            mapExceptionZone: info?.exceptionZone,
                            ...item
                        };
                    }));
                //setFieldValue(field.name, bookableLocation);
                }
                if (info?.exceptionZone?.area?.coordinates?.[0]) {
                    // If there is an exception zone, draw it on the map
                    setCurrentExceptionZone({
                        paths: info.exceptionZone.area.coordinates[0].map((coord)=>({
                                lat: coord[1],
                                lng: coord[0]
                            })),
                        locations: redirectLocations.map((item)=>({
                                lat: item.address.position.latitude,
                                lng: item.address.position.longitude,
                                locationId: item.id,
                                mapExceptionZone: info?.exceptionZone
                            }))
                    });
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DRAW_EXEPTIONS_ZONE', {
                        paths: info.exceptionZone.area.coordinates[0].map((coord)=>({
                                lat: coord[1],
                                lng: coord[0]
                            })),
                        locations: redirectLocations.map((item)=>({
                                lat: item.address.position.latitude,
                                lng: item.address.position.longitude,
                                locationId: item.id,
                                mapExceptionZone: info?.exceptionZone
                            }))
                    });
                }
            } else {
                setFieldValue(field.name, $b6b4255c134cf0ab$var$formatLocationWithId(info));
                (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('GOTO_NEXT_LOCATION_FIELD', fieldIndex);
                if (props.onMobileSelect) setTimeout(props.onMobileSelect, 100);
            }
        }).catch((error)=>{
            console.error(error.message);
        // NOTE: We cannot use setFieldError because that error will be overridden when the validation runs
        // so we use internal state and set a special "error" when an address could not be found.
        // if (error?.response?.error === 'LOCATION_NOT_FOUND') {
        //   setAddressError(error?.response?.message)
        // }
        });
    };
    // const fetchGeolocation = () => {
    //   navigator.geolocation.getCurrentPosition(
    //     (result) => {
    //       console.log(result)
    //       searchNearby(result.coords).then((locations) => {
    //         if (!isMobile) locations.reverse()
    //         console.log(locations)
    //         setCurrentIndex(null)
    //         setIsVisible(true)
    //         setLocations(locations)
    //       })
    //       .catch((error) => {
    //         console.error(error.message)
    //       })
    //     }, 
    //     (error) => {
    //       console.error(error)
    //     }
    //   )
    // }
    const handleIconClick = ()=>{
        if (field.value?.address) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('ZOOM_LOCATION', field.value);
    };
    // -----------------------------------------------------
    //  Utils
    // -----------------------------------------------------
    const hasItems = ()=>{
        return locations?.length > 0 || redirectMessageVisible;
    };
    const formatItemForDropdown = (item)=>{
        const o = (0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)(item);
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $1d27ba7d2744ae6e$exports.dropDown,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $4c82bd27a7e186ea$export$2e2bcd8739ae039), {
                    location: item,
                    className: $1d27ba7d2744ae6e$exports.locationIcon
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $1d27ba7d2744ae6e$exports.dropDownAddress,
                    children: [
                        o.title,
                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                            children: o.subtitle
                        })
                    ]
                })
            ]
        });
    };
    // -----------------------------------------------------
    //  Rendering 
    // -----------------------------------------------------
    const renderList = (fullscreen)=>{
        // console.log("renderList");
        const list = locations;
        if (list && list.length > 0) return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $b6b4255c134cf0ab$var$cx($1d27ba7d2744ae6e$exports.dropdown, {
                fullscreen: fullscreen
            }),
            children: [
                redirectMessageVisible && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $1d27ba7d2744ae6e$exports.message,
                    children: redirectMessage
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $1d27ba7d2744ae6e$exports.scrollable,
                    ref: listRef,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                        ref: listContentRef,
                        children: list.map((item, index)=>// NOTE: The onMouseDown prevents the onBlur event on the input field triggering and hiding the drop down before the onClick is called
                            /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                className: $b6b4255c134cf0ab$var$cx($1d27ba7d2744ae6e$exports.item, {
                                    selected: index === currentIndex
                                }),
                                onMouseDown: (event)=>event.preventDefault(),
                                onClick: ()=>handleSelect(index),
                                onMouseOver: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('HOVER_LIST_ITEM', {
                                        item: item
                                    }),
                                onMouseOut: ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CLEAR_ITEM_HOVER', {
                                        item: item
                                    }),
                                children: formatItemForDropdown(item)
                            }, index))
                    })
                })
            ]
        });
        else if (!list || list?.length === 0) // console.log("LIST EMPTY");
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $b6b4255c134cf0ab$var$cx($1d27ba7d2744ae6e$exports.dropdown, {
                fullscreen: fullscreen
            }),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $1d27ba7d2744ae6e$exports.message
                }),
                redirectMessageVisible && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $1d27ba7d2744ae6e$exports.message,
                    children: redirectMessage
                })
            ]
        });
    };
    // NOTE: Override field error with the internal error stat if set
    const error = addressError || (0, $lW2XZ.getIn)(errors, field.name);
    // Don't show error if this field was auto-focused and hasn't been manually interacted with
    const isAutoFocused = window.AUTO_FOCUS_FIELD === field.name || wasAutoFocusedRef.current;
    const touch = addressError !== false || (0, $lW2XZ.getIn)(touched, field.name) && !isAutoFocused;
    const exceptionInfo = getExeptionZoneInfo(field?.value);
    const exceptionInfoVisible = field?.value?.exceptionZone?.redirectLocations?.length <= 0 && exceptionInfo;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $1d27ba7d2744ae6e$exports.container,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $00f0005d7186c141$export$2e2bcd8739ae039), {
                title: t('info-enter-street-number'),
                isVisible: toolTipVisible,
                isMultiline: true
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $b6b4255c134cf0ab$var$cx($1d27ba7d2744ae6e$exports.fieldwrapper, {
                    dropDownVisible: isVisible && hasItems(),
                    hasError: error && touch,
                    upward: !fullscreen
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $56e05d11b2edbc73$export$2e2bcd8739ae039), {
                        className: $1d27ba7d2744ae6e$exports.icon,
                        active: isVisible || searchValue !== ''
                    }),
                    isSelected && /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                        char: 'ABCDEFGHIJKLMNOPQRST'[fieldIndex],
                        className: $1d27ba7d2744ae6e$exports.charIcon,
                        onClick: handleIconClick
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                        type: "text",
                        name: field.name,
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        spellCheck: "false",
                        ref: innerRef,
                        value: searchValue,
                        onChange: handleChange,
                        onKeyDown: handleKeyDown,
                        onKeyUp: handleKeyUp,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        placeholder: props.placeholder,
                        tabIndex: props.tabIndex !== undefined ? props.tabIndex : 0,
                        autoFocus: !!props.mobileOverlay
                    }),
                    renderList(fullscreen)
                ]
            }),
            error && touch && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039), {
                useMotion: false,
                children: error
            })
        ]
    });
}





var $bcca0743a96b46a5$export$70b61ad426ddbe54;
var $bcca0743a96b46a5$export$a7db06668cad9adb;
var $bcca0743a96b46a5$export$38e42c68cf43b5d4;
var $bcca0743a96b46a5$export$29dd17c7f3c81c36;
var $bcca0743a96b46a5$export$fb184b623420d9be;
var $bcca0743a96b46a5$export$e614dc9140f7ae71;
var $bcca0743a96b46a5$export$39e4cd302b1fb413;
var $bcca0743a96b46a5$export$6179dc028a9cff48;
var $bcca0743a96b46a5$export$94afd0ab841668fd;
$bcca0743a96b46a5$export$70b61ad426ddbe54 = `dlYREG_cancel`;
$bcca0743a96b46a5$export$a7db06668cad9adb = `dlYREG_content`;
$bcca0743a96b46a5$export$38e42c68cf43b5d4 = `dlYREG_header`;
$bcca0743a96b46a5$export$29dd17c7f3c81c36 = `dlYREG_overlay`;
$bcca0743a96b46a5$export$fb184b623420d9be = `dlYREG_title`;
$bcca0743a96b46a5$export$e614dc9140f7ae71 = `dlYREG_trigger`;
$bcca0743a96b46a5$export$39e4cd302b1fb413 = `dlYREG_triggerIcon`;
$bcca0743a96b46a5$export$6179dc028a9cff48 = `dlYREG_triggerPlaceholder`;
$bcca0743a96b46a5$export$94afd0ab841668fd = `dlYREG_triggerValue`;


function $26a24512e4b2e050$export$2e2bcd8739ae039({ field: field, form: form, placeholder: placeholder, fullscreen: fullscreen, onFocus: onFocus, onBlur: onBlur, ...rest }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [overlayOpen, setOverlayOpen] = (0, $bh6RR.useState)(false);
    const [isMobile, setIsMobile] = (0, $bh6RR.useState)(()=>window.innerWidth < 970);
    (0, $bh6RR.useEffect)(()=>{
        const handler = ()=>setIsMobile(window.innerWidth < 970);
        window.addEventListener('resize', handler);
        return ()=>window.removeEventListener('resize', handler);
    }, []);
    // Prevent body scroll while overlay is open
    (0, $bh6RR.useEffect)(()=>{
        if (overlayOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return ()=>{
            document.body.style.overflow = '';
        };
    }, [
        overlayOpen
    ]);
    if (!isMobile) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $b6b4255c134cf0ab$export$2e2bcd8739ae039), {
        field: field,
        form: form,
        placeholder: placeholder,
        fullscreen: fullscreen,
        onFocus: onFocus,
        onBlur: onBlur,
        ...rest
    });
    const isSelected = typeof field.value === 'object';
    const displayValue = isSelected ? (0, $200ec6b1b2ca8c5a$export$5964fc5149281592)(field.value) : null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $bcca0743a96b46a5$export$e614dc9140f7ae71,
                onClick: ()=>setOverlayOpen(true),
                children: [
                    isSelected ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                        char: 'ABCDEFGHIJKLMNOPQRST'[rest.fieldIndex],
                        className: $bcca0743a96b46a5$export$39e4cd302b1fb413
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $56e05d11b2edbc73$export$2e2bcd8739ae039), {
                        className: $bcca0743a96b46a5$export$39e4cd302b1fb413,
                        active: false
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: isSelected ? $bcca0743a96b46a5$export$94afd0ab841668fd : $bcca0743a96b46a5$export$6179dc028a9cff48,
                        children: displayValue || placeholder
                    })
                ]
            }),
            overlayOpen && /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $bcca0743a96b46a5$export$29dd17c7f3c81c36,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $bcca0743a96b46a5$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $bcca0743a96b46a5$export$fb184b623420d9be,
                                children: placeholder
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                className: $bcca0743a96b46a5$export$70b61ad426ddbe54,
                                onClick: ()=>setOverlayOpen(false),
                                children: t('button-cancel')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $bcca0743a96b46a5$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b6b4255c134cf0ab$export$2e2bcd8739ae039), {
                            field: field,
                            form: form,
                            placeholder: placeholder,
                            fullscreen: true,
                            mobileOverlay: true,
                            onMobileSelect: ()=>setOverlayOpen(false),
                            ...rest
                        })
                    })
                ]
            }), document.body)
        ]
    });
}





const $30acdccbb47e8004$export$e772c8ff12451969 = (ms)=>new Promise((r)=>setTimeout(r, ms));
let $30acdccbb47e8004$var$timeout = null;
const $30acdccbb47e8004$export$9dc4ecf953986f04 = {
    start: (at, cb)=>{
        if ($30acdccbb47e8004$var$timeout !== null) $30acdccbb47e8004$export$9dc4ecf953986f04.clear();
        $30acdccbb47e8004$var$timeout = setTimeout(cb, at * 1000);
    },
    clear: ()=>{
        if ($30acdccbb47e8004$var$timeout !== null) {
            clearTimeout($30acdccbb47e8004$var$timeout);
            $30acdccbb47e8004$var$timeout = null;
        }
    }
};
const $30acdccbb47e8004$export$36f48d5522f46534 = (obj)=>{
    return Object.keys(obj).reduce((a, v)=>{
        // return typeof obj[v] === 'object' ? { ...a, [v]: setTrue(obj[v]) } : { ...a, [v]: true }
        if (Array.isArray(obj[v])) return {
            ...a,
            [v]: obj[v].map(()=>true)
        };
        else if (typeof obj[v] === 'object') return {
            ...a,
            [v]: $30acdccbb47e8004$export$36f48d5522f46534(obj[v])
        };
        else return {
            ...a,
            [v]: true
        };
    }, {});
};
const $30acdccbb47e8004$export$95742212c462b028 = (func, { validateForm: validateForm, setErrors: setErrors, setTouched: setTouched })=>{
    return (id)=>{
        validateForm().then((errors)=>{
            if (Object.keys(errors).length > 0) {
                window.AUTO_FOCUS_FIELD = null;
                setErrors(errors);
                const touched = $30acdccbb47e8004$export$36f48d5522f46534(errors);
                setTouched(touched, false);
            } else func(id);
        });
    };
};
const $30acdccbb47e8004$export$8bc71694d368e075 = ({ validateForm: validateForm, setErrors: setErrors, setTouched: setTouched })=>{
    return ()=>{
        validateForm().then((errors)=>{
            if (Object.keys(errors).length > 0) {
                setErrors(errors);
                const touched = $30acdccbb47e8004$export$36f48d5522f46534(errors);
                setTouched(touched, false);
            }
        });
    };
};
const $30acdccbb47e8004$export$eb122250488b74d5 = (message, callback = null)=>{
    const btn = callback ? {
        title: COPY.booking.button_ok,
        callback: callback
    } : {
        title: COPY.booking.button_ok
    };
    (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(message, [
        btn
    ]);
};
const $30acdccbb47e8004$export$836aee6bce45247 = (selector)=>document.querySelector(selector);
const $30acdccbb47e8004$export$9ca9051b92b5a6d2 = (selector)=>[
        ...document.querySelectorAll(selector)
    ];




var $ee8457ae4f41cf9c$exports = {};

$parcel$export($ee8457ae4f41cf9c$exports, "addLocationButton", function () { return $ee8457ae4f41cf9c$export$a79ae1a42784b55a; }, function (v) { return $ee8457ae4f41cf9c$export$a79ae1a42784b55a = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "addLocationForm", function () { return $ee8457ae4f41cf9c$export$c377d8e24f0479c2; }, function (v) { return $ee8457ae4f41cf9c$export$c377d8e24f0479c2 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "dragHandle", function () { return $ee8457ae4f41cf9c$export$2659f07e2f1eee65; }, function (v) { return $ee8457ae4f41cf9c$export$2659f07e2f1eee65 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "dragging", function () { return $ee8457ae4f41cf9c$export$8e6c816465ea7419; }, function (v) { return $ee8457ae4f41cf9c$export$8e6c816465ea7419 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "enabled", function () { return $ee8457ae4f41cf9c$export$25eaa035e2e3a214; }, function (v) { return $ee8457ae4f41cf9c$export$25eaa035e2e3a214 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "field", function () { return $ee8457ae4f41cf9c$export$e0f35d825088c098; }, function (v) { return $ee8457ae4f41cf9c$export$e0f35d825088c098 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "focus-visible", function () { return $ee8457ae4f41cf9c$export$f86455e47a9336bd; }, function (v) { return $ee8457ae4f41cf9c$export$f86455e47a9336bd = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "locations", function () { return $ee8457ae4f41cf9c$export$c2de8e0aab246379; }, function (v) { return $ee8457ae4f41cf9c$export$c2de8e0aab246379 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "removeBackground", function () { return $ee8457ae4f41cf9c$export$bcbafd0c688e5b8d; }, function (v) { return $ee8457ae4f41cf9c$export$bcbafd0c688e5b8d = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "removeButton", function () { return $ee8457ae4f41cf9c$export$8d776830dbcce823; }, function (v) { return $ee8457ae4f41cf9c$export$8d776830dbcce823 = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "row", function () { return $ee8457ae4f41cf9c$export$120ff0929b202a6d; }, function (v) { return $ee8457ae4f41cf9c$export$120ff0929b202a6d = v; });
$parcel$export($ee8457ae4f41cf9c$exports, "text", function () { return $ee8457ae4f41cf9c$export$6f093cfa640b7166; }, function (v) { return $ee8457ae4f41cf9c$export$6f093cfa640b7166 = v; });
var $ee8457ae4f41cf9c$export$a79ae1a42784b55a;
var $ee8457ae4f41cf9c$export$c377d8e24f0479c2;
var $ee8457ae4f41cf9c$export$2659f07e2f1eee65;
var $ee8457ae4f41cf9c$export$8e6c816465ea7419;
var $ee8457ae4f41cf9c$export$25eaa035e2e3a214;
var $ee8457ae4f41cf9c$export$e0f35d825088c098;
var $ee8457ae4f41cf9c$export$f86455e47a9336bd;
var $ee8457ae4f41cf9c$export$c2de8e0aab246379;
var $ee8457ae4f41cf9c$export$bcbafd0c688e5b8d;
var $ee8457ae4f41cf9c$export$8d776830dbcce823;
var $ee8457ae4f41cf9c$export$120ff0929b202a6d;
var $ee8457ae4f41cf9c$export$6f093cfa640b7166;
$ee8457ae4f41cf9c$export$a79ae1a42784b55a = `DeBHyq_addLocationButton`;
$ee8457ae4f41cf9c$export$c377d8e24f0479c2 = `DeBHyq_addLocationForm`;
$ee8457ae4f41cf9c$export$2659f07e2f1eee65 = `DeBHyq_dragHandle`;
$ee8457ae4f41cf9c$export$8e6c816465ea7419 = `DeBHyq_dragging`;
$ee8457ae4f41cf9c$export$25eaa035e2e3a214 = `DeBHyq_enabled`;
$ee8457ae4f41cf9c$export$e0f35d825088c098 = `DeBHyq_field`;
$ee8457ae4f41cf9c$export$f86455e47a9336bd = `DeBHyq_focus-visible`;
$ee8457ae4f41cf9c$export$c2de8e0aab246379 = `DeBHyq_locations`;
$ee8457ae4f41cf9c$export$bcbafd0c688e5b8d = `DeBHyq_removeBackground`;
$ee8457ae4f41cf9c$export$8d776830dbcce823 = `DeBHyq_removeButton`;
$ee8457ae4f41cf9c$export$120ff0929b202a6d = `DeBHyq_row`;
$ee8457ae4f41cf9c$export$6f093cfa640b7166 = `DeBHyq_text`;



var $98ac0ca34222ada7$exports = {};

$parcel$export($98ac0ca34222ada7$exports, "Group", function () { return $ea2890a6f84b6f68$export$be27b7672e0f20ab; });
$parcel$export($98ac0ca34222ada7$exports, "Item", function () { return $f0e1e7092c24a168$export$dfd959aaaf2d771a; });

var $ih19M = parcelRequire("ih19M");
/*#__NO_SIDE_EFFECTS__*/ const $c13dd6518645747b$export$8793edee2d425525 = (any)=>any;


let $af7e1b70fef19820$export$491112666e282270 = (0, $c13dd6518645747b$export$8793edee2d425525);
let $af7e1b70fef19820$export$f5708dca728d7177 = (0, $c13dd6518645747b$export$8793edee2d425525);
var $af7e1b70fef19820$var$check, $af7e1b70fef19820$var$message, $af7e1b70fef19820$var$check1, $af7e1b70fef19820$var$message1;


/*#__NO_SIDE_EFFECTS__*/ function $43b56f3d6cf00122$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}



/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ const $ae2145642557546a$export$504d7abb21fa8c9 = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};


/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $3ae67a7aa0703caa$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;





var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
const $19dd5dd6b7ca2184$export$2b8a1fb072f61d10 = (0, $bh6RR.createContext)(null);



function $118ccf88bcfc51b9$export$3af29c0efb268f04(componentFactory) {
    if (typeof Proxy === "undefined") return componentFactory;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const deprecatedFactoryFunction = (...args)=>{
        return componentFactory(...args);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return componentFactory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, componentFactory(key));
            return componentCache.get(key);
        }
    });
}


function $6c424f3bd35daf15$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}



const $96ae1bfc697c0155$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


function $b3131a4296a9915c$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}


/**
 * Decides if the supplied variable is variant label
 */ function $e4ec7857057a08b6$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


function $960c679efe64d12b$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 || visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $960c679efe64d12b$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $960c679efe64d12b$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}


function $dfe6a10b7b91d234$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}


const $eb6a0a2a824114cd$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $eb6a0a2a824114cd$export$1405a65085f40b9 = [
    "initial",
    ...$eb6a0a2a824114cd$export$16e45afcc206d3a8
];




const $ab6abce9b1295760$export$20d68f04f30763a5 = (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(()=>window.ScrollTimeline !== undefined);


class $9ee3497bd4e58b1a$export$4d0c371993b9283e {
    constructor(animations){
        // Bound to accomodate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        // Support for new finished Promise and legacy thennable API
        return Promise.all(this.animations.map((animation)=>"finished" in animation ? animation.finished : animation));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline, fallback) {
        const subscriptions = this.animations.map((animation)=>{
            if ((0, $ab6abce9b1295760$export$20d68f04f30763a5)() && animation.attachTimeline) return animation.attachTimeline(timeline);
            else if (typeof fallback === "function") return fallback(animation);
        });
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        let max = 0;
        for(let i = 0; i < this.animations.length; i++)max = Math.max(max, this.animations[i].duration);
        return max;
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    flatten() {
        this.runAll("flatten");
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}


/**
 * TODO: This is a temporary class to support the legacy
 * thennable API
 */ class $d45984ddbb5525e6$export$c1e41718f71efe41 extends (0, $9ee3497bd4e58b1a$export$4d0c371993b9283e) {
    then(onResolve, onReject) {
        return Promise.all(this.animations).then(onResolve).catch(onReject);
    }
}


function $7fa3dbba529c0c38$export$7c1391340308742e(transition, key) {
    return transition ? transition[key] || transition["default"] || transition : undefined;
}


/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $175defc6e5d60949$export$f4ff70a5b4808fd8 = 20000;
function $175defc6e5d60949$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $175defc6e5d60949$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $175defc6e5d60949$export$f4ff70a5b4808fd8 ? Infinity : duration;
}




/**
 * Create a progress => progress easing function from a generator.
 */ function $6a97c49c15a1f41b$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator), (0, $175defc6e5d60949$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(duration)
    };
}


function $da585aaca4fb3c01$export$6ab7812f1bac68be(type) {
    return typeof type === "function";
}



function $dd415ea26b351a85$export$5bd0fcbc73622e13(animation, timeline) {
    animation.timeline = timeline;
    animation.onfinish = null;
}


class $694df88d74106604$export$a361fbe706f8c9b {
    constructor(animation){
        this.animation = animation;
    }
    get duration() {
        var _a, _b, _c;
        const durationInMs = ((_b = (_a = this.animation) === null || _a === void 0 ? void 0 : _a.effect) === null || _b === void 0 ? void 0 : _b.getComputedTiming().duration) || ((_c = this.options) === null || _c === void 0 ? void 0 : _c.duration) || 300;
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(Number(durationInMs));
    }
    get time() {
        var _a;
        if (this.animation) return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(((_a = this.animation) === null || _a === void 0 ? void 0 : _a.currentTime) || 0);
        return 0;
    }
    set time(newTime) {
        if (this.animation) this.animation.currentTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        return this.animation ? this.animation.playbackRate : 1;
    }
    set speed(newSpeed) {
        if (this.animation) this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.animation ? this.animation.playState : "finished";
    }
    get startTime() {
        return this.animation ? this.animation.startTime : null;
    }
    get finished() {
        return this.animation ? this.animation.finished : Promise.resolve();
    }
    play() {
        this.animation && this.animation.play();
    }
    pause() {
        this.animation && this.animation.pause();
    }
    stop() {
        if (!this.animation || this.state === "idle" || this.state === "finished") return;
        if (this.animation.commitStyles) this.animation.commitStyles();
        this.cancel();
    }
    flatten() {
        var _a;
        if (!this.animation) return;
        (_a = this.animation.effect) === null || _a === void 0 || _a.updateTiming({
            easing: "linear"
        });
    }
    attachTimeline(timeline) {
        if (this.animation) (0, $dd415ea26b351a85$export$5bd0fcbc73622e13)(this.animation, timeline);
        return 0, $c13dd6518645747b$export$8793edee2d425525;
    }
    complete() {
        this.animation && this.animation.finish();
    }
    cancel() {
        try {
            this.animation && this.animation.cancel();
        } catch (e) {}
    }
}



const $b0f58e8e5196544e$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $df7346e5ebc6717b$export$e3ad02c335474dee = {
    linearEasing: undefined
};


function $42785ca7c0cb63b9$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _a;
        return (_a = (0, $df7346e5ebc6717b$export$e3ad02c335474dee)[supportsFlag]) !== null && _a !== void 0 ? _a : memoized();
    };
}


const $9c7c93019429f6d6$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $42785ca7c0cb63b9$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");



const $3345c58b9a5b9ea2$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += easing((0, $ae2145642557546a$export$504d7abb21fa8c9)(0, numPoints - 1, i)) + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


function $2bf71e9ed42b773d$export$fcdd8f3f2160beda(easing) {
    return Boolean(typeof easing === "function" && (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)() || !easing || typeof easing === "string" && (easing in $2bf71e9ed42b773d$export$2cf569f5e2221176 || (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)()) || (0, $b0f58e8e5196544e$export$ff43f99925d7366b)(easing) || Array.isArray(easing) && easing.every($2bf71e9ed42b773d$export$fcdd8f3f2160beda));
}
const $2bf71e9ed42b773d$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;
const $2bf71e9ed42b773d$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ $2bf71e9ed42b773d$export$2523b8f0bd8f44cb([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ $2bf71e9ed42b773d$export$2523b8f0bd8f44cb([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ $2bf71e9ed42b773d$export$2523b8f0bd8f44cb([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ $2bf71e9ed42b773d$export$2523b8f0bd8f44cb([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};
function $2bf71e9ed42b773d$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function" && (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)()) return (0, $3345c58b9a5b9ea2$export$66d3851e2b1ec912)(easing, duration);
    else if ((0, $b0f58e8e5196544e$export$ff43f99925d7366b)(easing)) return $2bf71e9ed42b773d$export$2523b8f0bd8f44cb(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$2bf71e9ed42b773d$export$916ea73bcd3a6030(segmentEasing, duration) || $2bf71e9ed42b773d$export$2cf569f5e2221176.easeOut);
    else return $2bf71e9ed42b773d$export$2cf569f5e2221176[easing];
}



const $11aaa3516eb4fe3b$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $11aaa3516eb4fe3b$export$1b3dd616664938e4() {
    return $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.x || $11aaa3516eb4fe3b$export$9e9bc3c487fccc00.y;
}


function $5c6341e39395a445$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    var _a;
    if (elementOrSelector instanceof Element) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) // TODO: Refactor to utils package
        // invariant(
        //     Boolean(scope.current),
        //     "Scope provided, but no element detected."
        // )
        root = scope.current;
        const elements = (_a = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _a !== void 0 ? _a : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector);
}


function $c98cdcb0020672a8$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $5c6341e39395a445$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


/**
 * Filter out events that are not pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $62aebe68f5a3cc52$var$filterEvents(callback) {
    return (event)=>{
        if (event.pointerType === "touch" || (0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)()) return;
        callback(event);
    };
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $62aebe68f5a3cc52$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const onPointerEnter = $62aebe68f5a3cc52$var$filterEvents((enterEvent)=>{
        const { target: target } = enterEvent;
        const onHoverEnd = onHoverStart(enterEvent);
        if (typeof onHoverEnd !== "function" || !target) return;
        const onPointerLeave = $62aebe68f5a3cc52$var$filterEvents((leaveEvent)=>{
            onHoverEnd(leaveEvent);
            target.removeEventListener("pointerleave", onPointerLeave);
        });
        target.addEventListener("pointerleave", onPointerLeave, eventOptions);
    });
    elements.forEach((element)=>{
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
    });
    return cancel;
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $e3dc885e9b4ce990$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $e3dc885e9b4ce990$export$e841ada32ff745b(parent, child.parentElement);
};


const $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};



const $9e66ba36736ca475$var$focusableElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
function $9e66ba36736ca475$export$5f6976e2f961e8b7(element) {
    return $9e66ba36736ca475$var$focusableElements.has(element.tagName) || element.tabIndex !== -1;
}


const $38fc35b2f99bbeec$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $ec2e5a2e73f36afc$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $ec2e5a2e73f36afc$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $ec2e5a2e73f36afc$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $ec2e5a2e73f36afc$var$filterEvents(()=>{
        if ((0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
        $ec2e5a2e73f36afc$var$firePointerEvent(element, "down");
        const handleKeyup = $ec2e5a2e73f36afc$var$filterEvents(()=>{
            $ec2e5a2e73f36afc$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$ec2e5a2e73f36afc$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $1fb501146082d657$var$isValidPressEvent(event) {
    return (0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && !(0, $11aaa3516eb4fe3b$export$1b3dd616664938e4)();
}
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $1fb501146082d657$export$dbe9198142dace0c(elementOrSelector, onPressStart, options = {}) {
    const [elements, eventOptions, cancelEvents] = (0, $c98cdcb0020672a8$export$edc0ace9d5e7e842)(elementOrSelector, options);
    const startPress = (startEvent)=>{
        const element = startEvent.currentTarget;
        if (!$1fb501146082d657$var$isValidPressEvent(startEvent) || (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
        (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).add(element);
        const onPressEnd = onPressStart(startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if (!$1fb501146082d657$var$isValidPressEvent(endEvent) || !(0, $38fc35b2f99bbeec$export$7987404a4e35b84b).has(element)) return;
            (0, $38fc35b2f99bbeec$export$7987404a4e35b84b).delete(element);
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, options.useGlobalTarget || (0, $e3dc885e9b4ce990$export$e841ada32ff745b)(element, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    elements.forEach((element)=>{
        if (!(0, $9e66ba36736ca475$export$5f6976e2f961e8b7)(element) && element.getAttribute("tabindex") === null) element.tabIndex = 0;
        const target = options.useGlobalTarget ? window : element;
        target.addEventListener("pointerdown", startPress, eventOptions);
        element.addEventListener("focus", (event)=>(0, $ec2e5a2e73f36afc$export$4b5790288fe12a79)(event, eventOptions), eventOptions);
    });
    return cancelEvents;
}


















const $145354fa94448767$var$defaultEasing = "easeOut";
function $145354fa94448767$export$a31269144d66b4a(options) {
    var _a;
    if ((0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(options.type)) {
        const generatorOptions = (0, $6a97c49c15a1f41b$export$7f1511d09ee75a99)(options, 100, options.type);
        options.ease = (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)() ? generatorOptions.ease : $145354fa94448767$var$defaultEasing;
        options.duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
        options.type = "keyframes";
    } else {
        options.duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)((_a = options.duration) !== null && _a !== void 0 ? _a : 0.3);
        options.ease = options.ease || $145354fa94448767$var$defaultEasing;
    }
}
// TODO: Reuse for NativeAnimation
function $145354fa94448767$export$f837a3b7321adfa5(valueName, keyframes, options) {
    var _a;
    const nativeKeyframes = {};
    const nativeOptions = {
        fill: "both",
        easing: "linear",
        composite: "replace"
    };
    nativeOptions.delay = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)((_a = options.delay) !== null && _a !== void 0 ? _a : 0);
    $145354fa94448767$export$a31269144d66b4a(options);
    nativeOptions.duration = options.duration;
    const { ease: ease, times: times } = options;
    if (times) nativeKeyframes.offset = times;
    nativeKeyframes[valueName] = keyframes;
    const easing = (0, $2bf71e9ed42b773d$export$916ea73bcd3a6030)(ease, options.duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) nativeKeyframes.easing = easing;
    else nativeOptions.easing = easing;
    return {
        keyframes: nativeKeyframes,
        options: nativeOptions
    };
}


class $d3eb0fa51c70eea8$export$bd39eb4d1b05262c extends (0, $694df88d74106604$export$a361fbe706f8c9b) {
    constructor(target, pseudoElement, valueName, keyframes, options){
        const animationOptions = (0, $145354fa94448767$export$f837a3b7321adfa5)(valueName, keyframes, options);
        const animation = target.animate(animationOptions.keyframes, {
            pseudoElement: pseudoElement,
            ...animationOptions.options
        });
        super(animation);
    }
}




function $424c093e4ef26fba$export$f156731db478ee9e(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}


let $1337f74a535e6728$var$pendingRules = {};
let $1337f74a535e6728$var$style = null;
const $1337f74a535e6728$export$dbf350e5966cf602 = {
    set: (selector, values)=>{
        $1337f74a535e6728$var$pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!$1337f74a535e6728$var$style) {
            $1337f74a535e6728$var$style = document.createElement("style");
            $1337f74a535e6728$var$style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in $1337f74a535e6728$var$pendingRules){
            const rule = $1337f74a535e6728$var$pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        $1337f74a535e6728$var$style.textContent = cssText;
        document.head.appendChild($1337f74a535e6728$var$style);
        $1337f74a535e6728$var$pendingRules = {};
    },
    remove: ()=>{
        if ($1337f74a535e6728$var$style && $1337f74a535e6728$var$style.parentElement) $1337f74a535e6728$var$style.parentElement.removeChild($1337f74a535e6728$var$style);
    }
};


function $f73ecebbb7d032ce$export$318a4a45ce9f2d6a(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}


function $ec3f5e8ba3b5cf35$var$filterViewAnimations(animation) {
    var _a;
    const { effect: effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && ((_a = effect.pseudoElement) === null || _a === void 0 ? void 0 : _a.startsWith("::view-transition"));
}
function $ec3f5e8ba3b5cf35$export$8d6316dd934b3f3b() {
    return document.getAnimations().filter($ec3f5e8ba3b5cf35$var$filterViewAnimations);
}


function $9196e4c5105a6fd0$export$cb29cf2b8e0a8ae1(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}


const $742fa6963c3f4200$var$definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function $742fa6963c3f4200$export$43cd2edcbb51216c(update, defaultOptions, targets) {
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, $9ee3497bd4e58b1a$export$4d0c371993b9283e)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, $9196e4c5105a6fd0$export$cb29cf2b8e0a8ae1)("root", targets)) (0, $1337f74a535e6728$export$dbf350e5966cf602).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, $1337f74a535e6728$export$dbf350e5966cf602).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, $1337f74a535e6728$export$dbf350e5966cf602).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, $1337f74a535e6728$export$dbf350e5966cf602).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            var _a;
            const generatedViewAnimations = (0, $ec3f5e8ba3b5cf35$export$8d6316dd934b3f3b)();
            const animations = [];
            /**
             * Create animations for our definitions
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of $742fa6963c3f4200$var$definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes: keyframes, options: options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(defaultOptions, valueName),
                            ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(options, valueName)
                        };
                        const type = (0, $424c093e4ef26fba$export$f156731db478ee9e)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        const animation = new (0, $d3eb0fa51c70eea8$export$bd39eb4d1b05262c)(document.documentElement, `::view-transition-${type}(${target})`, valueName, valueKeyframes, valueOptions);
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect: effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement: pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, $f73ecebbb7d032ce$export$318a4a45ce9f2d6a)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    const animationTransition = {
                        ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(defaultOptions, transitionName)
                    };
                    (0, $145354fa94448767$export$a31269144d66b4a)(animationTransition);
                    const easing = (0, $2bf71e9ed42b773d$export$916ea73bcd3a6030)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)((_a = animationTransition.delay) !== null && _a !== void 0 ? _a : 0),
                        duration: animationTransition.duration,
                        easing: easing
                    });
                    animations.push(new (0, $694df88d74106604$export$a361fbe706f8c9b)(animation));
                } else if ($742fa6963c3f4200$var$hasOpacity(targetDefinition, "enter") && $742fa6963c3f4200$var$hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, $694df88d74106604$export$a361fbe706f8c9b)(animation));
                else animation.cancel();
            }
            resolve(new (0, $9ee3497bd4e58b1a$export$4d0c371993b9283e)(animations));
        });
    });
}
function $742fa6963c3f4200$var$hasOpacity(target, key) {
    var _a;
    return (_a = target === null || target === void 0 ? void 0 : target[key]) === null || _a === void 0 ? void 0 : _a.keyframes.opacity;
}


/**
 * TODO:
 * - Create view transition on next tick
 * - Replace animations with Motion animations
 * - Return GroupAnimation on next tick
 */ class $53b72804841003d4$export$a25c8c3ef5e625d7 {
    constructor(update, options = {}){
        this.currentTarget = "root";
        this.targets = new Map();
        this.notifyReady = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        queueMicrotask(()=>{
            (0, $742fa6963c3f4200$export$43cd2edcbb51216c)(update, options, this.targets).then((animation)=>this.notifyReady(animation));
        });
    }
    get(selector) {
        this.currentTarget = selector;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentTarget: currentTarget, targets: targets } = this;
        if (!targets.has(currentTarget)) targets.set(currentTarget, {});
        const targetData = targets.get(currentTarget);
        targetData[target] = {
            keyframes: keyframes,
            options: options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function $53b72804841003d4$export$c4ddc81c7b2c8d7a(update, defaultOptions = {}) {
    return new $53b72804841003d4$export$a25c8c3ef5e625d7(update, defaultOptions);
}




function $7a2dafd130edc18a$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x || (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).x = (0, $11aaa3516eb4fe3b$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}






/**
 * Generate a list of every possible transform key.
 */ const $a910d77444956bd4$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const $a910d77444956bd4$export$7b42a0094fb00b6e = new Set($a910d77444956bd4$export$280dc01950909d86);


const $1b3c8c7753362ba0$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $a910d77444956bd4$export$280dc01950909d86)
]);



const $b9d94c0c185391a2$export$2f308ad9864b3ac9 = (v)=>{
    return Boolean(v && typeof v === "object" && v.mix && v.toValue);
};
const $b9d94c0c185391a2$export$5485128c47bd48bb = (v)=>{
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
};


const $6c4fc775126b27b6$export$dd826089e3c5e502 = {
    skipAnimations: false,
    useManualTiming: false
};




function $1b7b86ec18a0a90a$export$b995e5e85f5c8289(runNextFrame) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            if (!queue.has(callback)) queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            [thisFrame, nextFrame] = [
                nextFrame,
                thisFrame
            ];
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $3c9d516863748892$export$71ecace0a033b35a = [
    "read",
    "resolveKeyframes",
    "update",
    "preRender",
    "render",
    "postRender"
];
const $3c9d516863748892$var$maxElapsed = 40;
function $3c9d516863748892$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        acc[key] = (0, $1b7b86ec18a0a90a$export$b995e5e85f5c8289)(flagRunNextFrame);
        return acc;
    }, {});
    const { read: read, resolveKeyframes: resolveKeyframes, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const timestamp = (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $3c9d516863748892$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        read.process(state);
        resolveKeyframes.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = $3c9d516863748892$export$71ecace0a033b35a.reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < $3c9d516863748892$export$71ecace0a033b35a.length; i++)steps[$3c9d516863748892$export$71ecace0a033b35a[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $6491bdd13544fdda$export$2cef06c20297c17d, cancel: $6491bdd13544fdda$export$ec99c0ef4978dccb, state: $6491bdd13544fdda$export$fff89137e9e818ce, steps: $6491bdd13544fdda$export$1811c3a7e3af92f0 } = (0, $3c9d516863748892$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $c13dd6518645747b$export$8793edee2d425525), true);


let $05b982fb85a2786e$var$now;
function $05b982fb85a2786e$var$clearTime() {
    $05b982fb85a2786e$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $05b982fb85a2786e$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($05b982fb85a2786e$var$now === undefined) $05b982fb85a2786e$export$2da9be4cfdb689b1.set((0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).useManualTiming ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : performance.now());
        return $05b982fb85a2786e$var$now;
    },
    set: (newTime)=>{
        $05b982fb85a2786e$var$now = newTime;
        queueMicrotask($05b982fb85a2786e$var$clearTime);
    }
};


function $13ad1cfa8b4681b0$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $13ad1cfa8b4681b0$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}


/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $8d9716de34c4d522$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $925342fde4532b85$var$MAX_VELOCITY_DELTA = 30;
const $925342fde4532b85$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $925342fde4532b85$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $925342fde4532b85$export$8cea36d14ee64562 {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     *
     * @internal
     */ constructor(init, options = {}){
        /**
         * This will be replaced by the build step with the latest version number.
         * When MotionValues are provided to motion components, warn if versions are mixed.
         */ this.version = "11.18.2";
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v, render = true)=>{
            const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev && this.events.change) this.events.change.notify(this.current);
            // Update render subscribers
            if (render && this.events.renderRequest) this.events.renderRequest.notify(this.current);
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $925342fde4532b85$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     *
     * @internal
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v, render = true) {
        if (!render || !this.passiveEffect) this.updateAndNotify(v, render);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($925342fde4532b85$export$67fcd818a264039d.current) $925342fde4532b85$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $925342fde4532b85$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $925342fde4532b85$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     *
     * @internal
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function $925342fde4532b85$export$ce8bdc721e76545f(init, options) {
    return new $925342fde4532b85$export$8cea36d14ee64562(init, options);
}



/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(value));
}
function $4ddbbe2518feafa3$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition);
    let { transitionEnd: transitionEnd = {}, transition: transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = (0, $b9d94c0c185391a2$export$5485128c47bd48bb)(target[key]);
        $4ddbbe2518feafa3$var$setMotionValue(visualElement, key, value);
    }
}


const $d449570363f09a53$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);


function $7b21dab475728d1e$export$98397f3adbf6259f(value) {
    return Boolean((0, $d449570363f09a53$export$605d60a2578142d3)(value) && value.add);
}


function $bd95401810c788ae$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $7b21dab475728d1e$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
}


/**
 * Convert camelCase to dash-case properties.
 */ const $002b84d235cc9e7f$export$9fd24a634729c672 = (str)=>str.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase();


const $6b140fcbcf20767d$export$ed7b8fa9dbf0105d = "framerAppearId";
const $6b140fcbcf20767d$export$8592e1c077c890a6 = "data-" + (0, $002b84d235cc9e7f$export$9fd24a634729c672)($6b140fcbcf20767d$export$ed7b8fa9dbf0105d);


function $e2f74713dde14d85$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
}






const $636ef95c23a1ebef$export$888a3d84909f9e3d = {
    current: false
};





/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticiably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $704adaa4b6058bb3$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $704adaa4b6058bb3$var$subdivisionPrecision = 0.0000001;
const $704adaa4b6058bb3$var$subdivisionMaxIterations = 12;
function $704adaa4b6058bb3$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $704adaa4b6058bb3$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $704adaa4b6058bb3$var$subdivisionPrecision && ++i < $704adaa4b6058bb3$var$subdivisionMaxIterations);
    return currentT;
}
function $704adaa4b6058bb3$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $c13dd6518645747b$export$8793edee2d425525;
    const getTForX = (aX)=>$704adaa4b6058bb3$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $704adaa4b6058bb3$var$calcBezier(getTForX(t), mY1, mY2);
}


// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
const $89b4bec8fd3fdad1$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
const $0437738b097fa26f$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $d3c4eaabf34a945a$export$77edfce482316a60 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $d3c4eaabf34a945a$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $0437738b097fa26f$export$2c07eeff45156d4d)($d3c4eaabf34a945a$export$77edfce482316a60);
const $d3c4eaabf34a945a$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($d3c4eaabf34a945a$export$b01116c84cdfe1a2);


const $1a7a42634de0d0af$export$6b0af63b873d419e = (p)=>(p *= 2) < 1 ? 0.5 * (0, $d3c4eaabf34a945a$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $f0e499eff44e3cea$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $f0e499eff44e3cea$export$c8d67a19199d1a50 = (0, $0437738b097fa26f$export$2c07eeff45156d4d)($f0e499eff44e3cea$export$e444123e42d03385);
const $f0e499eff44e3cea$export$30d3455eee55bed5 = (0, $89b4bec8fd3fdad1$export$f946554fb8aeaf0d)($f0e499eff44e3cea$export$e444123e42d03385);


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $e46637106d3b5fd8$export$ade84c85e44a6cb1 = (v)=>/^0[^.\s]+$/u.test(v);


function $cfbb3fdee2e93a54$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value);
    else return true;
}



const $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};



const $84044ef4463ca44e$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $84044ef4463ca44e$export$58f0f39f63f3cf42 = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    transform: (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, v)
};
const $84044ef4463ca44e$export$dcdf75081b88279d = {
    ...$84044ef4463ca44e$export$98e628dec113755e,
    default: 1
};


// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $08533e7dcf2265d2$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $0cfc69005916d580$export$2444ca58c08448e4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;


function $ea92e7c60948441e$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $c20d4ae2b38f8df9$export$ed808ff6ecd39e8d = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $5722faa01ec1ec2e$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $c20d4ae2b38f8df9$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $ea92e7c60948441e$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $5722faa01ec1ec2e$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $0cfc69005916d580$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $73de4a1e9f0dd80c$var$clampRgbUnit = (v)=>(0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 255, v);
const $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: (v)=>Math.round($73de4a1e9f0dd80c$var$clampRgbUnit(v))
};
const $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(red) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(green) + ", " + $73de4a1e9f0dd80c$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $30a5a0b739818b6d$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $30a5a0b739818b6d$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("#"),
    parse: $30a5a0b739818b6d$var$parseHex,
    transform: (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform
};



const $ee89500f7aaa2f56$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $ee89500f7aaa2f56$export$41fc368e1a942b97 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("deg");
const $ee89500f7aaa2f56$export$626336c2cd4b14de = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("%");
const $ee89500f7aaa2f56$export$91c0eda1d06bf008 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("px");
const $ee89500f7aaa2f56$export$f91e8c45a95a32f2 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("vh");
const $ee89500f7aaa2f56$export$aed3d7b7d206c196 = /*@__PURE__*/ $ee89500f7aaa2f56$var$createUnitType("vw");
const $ee89500f7aaa2f56$export$44e2e1705876d7ed = {
    ...$ee89500f7aaa2f56$export$626336c2cd4b14de,
    parse: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.parse(v) / 100,
    transform: (v)=>$ee89500f7aaa2f56$export$626336c2cd4b14de.transform(v * 100)
};




const $0843b7e1fb4696f0$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $5722faa01ec1ec2e$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).transform((0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)((0, $84044ef4463ca44e$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $7a26ed3125820d32$export$35e9368ef982300f = {
    test: (v)=>(0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v) || (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).test(v) || (0, $0843b7e1fb4696f0$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).test(v)) return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $0843b7e1fb4696f0$export$810b04175080204c).test(v)) return (0, $0843b7e1fb4696f0$export$810b04175080204c).parse(v);
        else return (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(v) : (0, $0843b7e1fb4696f0$export$810b04175080204c).transform(v);
    }
};


const $f8337b1228d779df$export$740b69c5fad25dba = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;




function $a554c66132092e1c$var$test(v) {
    var _a, _b;
    return isNaN(v) && typeof v === "string" && (((_a = v.match((0, $0cfc69005916d580$export$2444ca58c08448e4))) === null || _a === void 0 ? void 0 : _a.length) || 0) + (((_b = v.match((0, $f8337b1228d779df$export$740b69c5fad25dba))) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
}
const $a554c66132092e1c$var$NUMBER_TOKEN = "number";
const $a554c66132092e1c$var$COLOR_TOKEN = "color";
const $a554c66132092e1c$var$VAR_TOKEN = "var";
const $a554c66132092e1c$var$VAR_FUNCTION_TOKEN = "var(";
const $a554c66132092e1c$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $a554c66132092e1c$var$complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function $a554c66132092e1c$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($a554c66132092e1c$var$complexRegex, (parsedValue)=>{
        if ((0, $7a26ed3125820d32$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($a554c66132092e1c$var$COLOR_TOKEN);
            values.push((0, $7a26ed3125820d32$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($a554c66132092e1c$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($a554c66132092e1c$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($a554c66132092e1c$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $a554c66132092e1c$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($a554c66132092e1c$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $a554c66132092e1c$var$parseComplexValue(v) {
    return $a554c66132092e1c$export$b61fc7c44bf646d5(v).values;
}
function $a554c66132092e1c$var$createTransformer(source) {
    const { split: split, types: types } = $a554c66132092e1c$export$b61fc7c44bf646d5(source);
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $a554c66132092e1c$var$NUMBER_TOKEN) output += (0, $08533e7dcf2265d2$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $a554c66132092e1c$var$COLOR_TOKEN) output += (0, $7a26ed3125820d32$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
const $a554c66132092e1c$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : v;
function $a554c66132092e1c$var$getAnimatableNone(v) {
    const parsed = $a554c66132092e1c$var$parseComplexValue(v);
    const transformer = $a554c66132092e1c$var$createTransformer(v);
    return transformer(parsed.map($a554c66132092e1c$var$convertNumbersToZero));
}
const $a554c66132092e1c$export$83a0e34f1302825b = {
    test: $a554c66132092e1c$var$test,
    parse: $a554c66132092e1c$var$parseComplexValue,
    createTransformer: $a554c66132092e1c$var$createTransformer,
    getAnimatableNone: $a554c66132092e1c$var$getAnimatableNone
};





/**
 * Properties that should default to 1 or 100%
 */ const $9326f348bb1b920e$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $9326f348bb1b920e$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $0cfc69005916d580$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $9326f348bb1b920e$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $9326f348bb1b920e$var$functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const $9326f348bb1b920e$export$3dea766d36a8935f = {
    ...(0, $a554c66132092e1c$export$83a0e34f1302825b),
    getAnimatableNone: (v)=>{
        const functions = v.match($9326f348bb1b920e$var$functionRegex);
        return functions ? functions.map($9326f348bb1b920e$var$applyDefaultFilter).join(" ") : v;
    }
};







const $61e57eb6323393a7$export$2fb74b0a4e7d7c4a = {
    // Border props
    borderWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRightWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    radius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxWidth: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    height: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    maxHeight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    top: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    right: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    bottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    left: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    paddingLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    margin: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginTop: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginRight: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginBottom: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    marginLeft: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008)
};




const $a68f72253e3f5800$export$f2e4285fee37e26 = {
    rotate: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    rotateZ: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    scale: $84044ef4463ca44e$export$dcdf75081b88279d,
    scaleX: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleY: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    scaleZ: (0, $84044ef4463ca44e$export$dcdf75081b88279d),
    skew: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewX: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    skewY: (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    distance: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateX: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateY: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    translateZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    x: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    y: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    z: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    perspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    transformPerspective: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    opacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    originX: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originY: (0, $ee89500f7aaa2f56$export$44e2e1705876d7ed),
    originZ: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008)
};



const $1500fa361742b746$export$7d260a2a5f8bc19e = {
    ...(0, $84044ef4463ca44e$export$98e628dec113755e),
    transform: Math.round
};


const $e26e0ac69c88d1e3$export$eec14432cd1cb67b = {
    ...(0, $61e57eb6323393a7$export$2fb74b0a4e7d7c4a),
    ...(0, $a68f72253e3f5800$export$f2e4285fee37e26),
    zIndex: (0, $1500fa361742b746$export$7d260a2a5f8bc19e),
    size: (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    // SVG
    fillOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $84044ef4463ca44e$export$58f0f39f63f3cf42),
    numOctaves: (0, $1500fa361742b746$export$7d260a2a5f8bc19e)
};


/**
 * A map of default value types for common values
 */ const $5244b39289cc5c6d$export$98cd7c72c5a731fb = {
    ...(0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b),
    color: // Color props
    $7a26ed3125820d32$export$35e9368ef982300f,
    backgroundColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    outlineColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    fill: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    stroke: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderTopColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderRightColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderBottomColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    borderLeftColor: (0, $7a26ed3125820d32$export$35e9368ef982300f),
    filter: $9326f348bb1b920e$export$3dea766d36a8935f,
    WebkitFilter: (0, $9326f348bb1b920e$export$3dea766d36a8935f)
};
/**
 * Gets the default ValueType for the provided value key
 */ const $5244b39289cc5c6d$export$67d1babe0338d23b = (key)=>$5244b39289cc5c6d$export$98cd7c72c5a731fb[key];


function $1838583c06c42261$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
    if (defaultValueType !== (0, $9326f348bb1b920e$export$3dea766d36a8935f)) defaultValueType = (0, $a554c66132092e1c$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $7a2127a321ebfc42$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $7a2127a321ebfc42$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$7a2127a321ebfc42$var$invalidTemplates.has(keyframe) && (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $1838583c06c42261$export$cea0cedcb94873b5)(name, animatableTemplate);
}





const $2b1f30070063653f$export$8e5250d1aa9bf370 = (v)=>v === (0, $84044ef4463ca44e$export$98e628dec113755e) || v === (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008);
const $2b1f30070063653f$var$getPosFromMatrix = (matrix, pos)=>parseFloat(matrix.split(", ")[pos]);
const $2b1f30070063653f$var$getTranslateFromMatrix = (pos2, pos3)=>(_bbox, { transform: transform })=>{
        if (transform === "none" || !transform) return 0;
        const matrix3d = transform.match(/^matrix3d\((.+)\)$/u);
        if (matrix3d) return $2b1f30070063653f$var$getPosFromMatrix(matrix3d[1], pos3);
        else {
            const matrix = transform.match(/^matrix\((.+)\)$/u);
            if (matrix) return $2b1f30070063653f$var$getPosFromMatrix(matrix[1], pos2);
            else return 0;
        }
    };
const $2b1f30070063653f$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $2b1f30070063653f$var$nonTranslationalTransformKeys = (0, $a910d77444956bd4$export$280dc01950909d86).filter((key)=>!$2b1f30070063653f$var$transformKeys.has(key));
function $2b1f30070063653f$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $2b1f30070063653f$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $2b1f30070063653f$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0" })=>x.max - x.min - parseFloat(paddingLeft) - parseFloat(paddingRight),
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0" })=>y.max - y.min - parseFloat(paddingTop) - parseFloat(paddingBottom),
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: $2b1f30070063653f$var$getTranslateFromMatrix(4, 13),
    y: $2b1f30070063653f$var$getTranslateFromMatrix(5, 14)
};
// Alias translate longform names
$2b1f30070063653f$export$781d46a8aa670d52.translateX = $2b1f30070063653f$export$781d46a8aa670d52.x;
$2b1f30070063653f$export$781d46a8aa670d52.translateY = $2b1f30070063653f$export$781d46a8aa670d52.y;



const $8a643b2da1c7bc40$var$toResolve = new Set();
let $8a643b2da1c7bc40$var$isScheduled = false;
let $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
function $8a643b2da1c7bc40$var$measureAllKeyframes() {
    if ($8a643b2da1c7bc40$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($8a643b2da1c7bc40$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $2b1f30070063653f$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _a;
                (_a = element.getValue(key)) === null || _a === void 0 || _a.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8a643b2da1c7bc40$var$anyNeedsMeasurement = false;
    $8a643b2da1c7bc40$var$isScheduled = false;
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>resolver.complete());
    $8a643b2da1c7bc40$var$toResolve.clear();
}
function $8a643b2da1c7bc40$var$readAllKeyframes() {
    $8a643b2da1c7bc40$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8a643b2da1c7bc40$var$anyNeedsMeasurement = true;
    });
}
function $8a643b2da1c7bc40$export$78b96d2a12593b05() {
    $8a643b2da1c7bc40$var$readAllKeyframes();
    $8a643b2da1c7bc40$var$measureAllKeyframes();
}
class $8a643b2da1c7bc40$export$74d34ca3182f1750 {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        /**
         * Track whether this resolver has completed. Once complete, it never
         * needs to attempt keyframe resolution again.
         */ this.isComplete = false;
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        /**
         * Track whether this resolver is currently scheduled to resolve
         * to allow it to be cancelled and resumed externally.
         */ this.isScheduled = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.isScheduled = true;
        if (this.isAsync) {
            $8a643b2da1c7bc40$var$toResolve.add(this);
            if (!$8a643b2da1c7bc40$var$isScheduled) {
                $8a643b2da1c7bc40$var$isScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).read($8a643b2da1c7bc40$var$readAllKeyframes);
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).resolveKeyframes($8a643b2da1c7bc40$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        /**
         * If a keyframe is null, we hydrate it either by reading it from
         * the instance, or propagating from previous keyframes.
         */ for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null) {
            /**
                 * If the first keyframe is null, we need to find its value by sampling the element
                 */ if (i === 0) {
                const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                else if (element && name) {
                    const valueAsRead = element.readValue(name, finalKeyframe);
                    if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                }
                if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
            } else unresolvedKeyframes[i] = unresolvedKeyframes[i - 1];
        }
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete() {
        this.isComplete = true;
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe);
        $8a643b2da1c7bc40$var$toResolve.delete(this);
    }
    cancel() {
        if (!this.isComplete) {
            this.isScheduled = false;
            $8a643b2da1c7bc40$var$toResolve.delete(this);
        }
    }
    resume() {
        if (!this.isComplete) this.scheduleResolve();
    }
}



/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $307e1e0a636b2ddb$export$65583ed5a868f2d9 = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);


const $9223341d00255d67$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $9223341d00255d67$export$9de1236619d9e756 = /*@__PURE__*/ $9223341d00255d67$var$checkStringStartsWith("--");
const $9223341d00255d67$var$startsAsVariableToken = /*@__PURE__*/ $9223341d00255d67$var$checkStringStartsWith("var(--");
const $9223341d00255d67$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $9223341d00255d67$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $9223341d00255d67$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $9223341d00255d67$var$singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;


/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $ff42741a21ccb940$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function $ff42741a21ccb940$export$b9f0c1f373aee2b0(current) {
    const match = $ff42741a21ccb940$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $ff42741a21ccb940$var$maxDepth = 4;
function $ff42741a21ccb940$export$289398774300c991(current, element, depth = 1) {
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(depth <= $ff42741a21ccb940$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`);
    const [token, fallback] = $ff42741a21ccb940$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $9223341d00255d67$export$31f9caa2600b5723)(fallback) ? $ff42741a21ccb940$export$289398774300c991(fallback, element, depth + 1) : fallback;
}






/**
 * Tests a provided value against a ValueType
 */ const $bce78752b9f7f913$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * ValueType for "auto"
 */ const $6e9d07411e0549ee$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};


/**
 * A list of value types commonly used for dimensions
 */ const $d03d4f627f09ffbd$export$d176691c1998a1f5 = [
    (0, $84044ef4463ca44e$export$98e628dec113755e),
    (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008),
    (0, $ee89500f7aaa2f56$export$626336c2cd4b14de),
    (0, $ee89500f7aaa2f56$export$41fc368e1a942b97),
    (0, $ee89500f7aaa2f56$export$aed3d7b7d206c196),
    (0, $ee89500f7aaa2f56$export$f91e8c45a95a32f2),
    (0, $6e9d07411e0549ee$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $d03d4f627f09ffbd$export$eefdd52e3ccae428 = (v)=>$d03d4f627f09ffbd$export$d176691c1998a1f5.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));


class $c8b2f05e40a653fe$export$4983792d11b61017 extends (0, $8a643b2da1c7bc40$export$74d34ca3182f1750) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $9223341d00255d67$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $ff42741a21ccb940$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $1b3c8c7753362ba0$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $d03d4f627f09ffbd$export$eefdd52e3ccae428)(target);
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $2b1f30070063653f$export$8e5250d1aa9bf370)(originType) && (0, $2b1f30070063653f$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if ((0, $cfbb3fdee2e93a54$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $7a2127a321ebfc42$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _a;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $2b1f30070063653f$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_a = this.removedTransforms) === null || _a === void 0 ? void 0 : _a.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}








/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $9af063a91152801b$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys tat might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $a554c66132092e1c$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $dd719f2577620065$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $dd719f2577620065$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $9af063a91152801b$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $af7e1b70fef19820$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". ${originKeyframe} is not an animatable value - to enable this animation set ${originKeyframe} to a value animatable to ${targetKeyframe} via the \`style\` property.`);
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $dd719f2577620065$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(type)) && velocity;
}


const $cb21c6c57eea1e02$var$isNotNull = (value)=>value !== null;
function $cb21c6c57eea1e02$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe) {
    const resolvedKeyframes = keyframes.filter($cb21c6c57eea1e02$var$isNotNull);
    const index = repeat && repeatType !== "loop" && repeat % 2 === 1 ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $9e9bbf9cd1b9c15e$var$MAX_RESOLVE_DELAY = 40;
class $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1 {
    constructor({ autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", ...options }){
        // Track whether the animation has been stopped. Stopped animations won't restart.
        this.isStopped = false;
        this.hasAttemptedResolve = false;
        this.createdAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        this.options = {
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            ...options
        };
        this.updateFinishedPromise();
    }
    /**
     * This method uses the createdAt and resolvedAt to calculate the
     * animation startTime. *Ideally*, we would use the createdAt time as t=0
     * as the following frame would then be the first frame of the animation in
     * progress, which would feel snappier.
     *
     * However, if there's a delay (main thread work) between the creation of
     * the animation and the first commited frame, we prefer to use resolvedAt
     * to avoid a sudden jump into the animation.
     */ calcStartTime() {
        if (!this.resolvedAt) return this.createdAt;
        return this.resolvedAt - this.createdAt > $9e9bbf9cd1b9c15e$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt;
    }
    /**
     * A getter for resolved data. If keyframes are not yet resolved, accessing
     * this.resolved will synchronously flush all pending keyframe resolvers.
     * This is a deoptimisation, but at its worst still batches read/writes.
     */ get resolved() {
        if (!this._resolved && !this.hasAttemptedResolve) (0, $8a643b2da1c7bc40$export$78b96d2a12593b05)();
        return this._resolved;
    }
    /**
     * A method to be called when the keyframes resolver completes. This method
     * will check if its possible to run the animation and, if not, skip it.
     * Otherwise, it will call initPlayback on the implementing class.
     */ onKeyframesResolved(keyframes, finalKeyframe) {
        this.resolvedAt = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
        this.hasAttemptedResolve = true;
        const { name: name, type: type, velocity: velocity, delay: delay, onComplete: onComplete, onUpdate: onUpdate, isGenerator: isGenerator } = this.options;
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ if (!isGenerator && !(0, $dd719f2577620065$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            // Finish immediately
            if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || !delay) {
                onUpdate && onUpdate((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
                onComplete && onComplete();
                this.resolveFinishedPromise();
                return;
            } else this.options.duration = 0;
        }
        const resolvedAnimation = this.initPlayback(keyframes, finalKeyframe);
        if (resolvedAnimation === false) return;
        this._resolved = {
            keyframes: keyframes,
            finalKeyframe: finalKeyframe,
            ...resolvedAnimation
        };
        this.onPostResolved();
    }
    onPostResolved() {}
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.currentFinishedPromise.then(resolve, reject);
    }
    flatten() {
        this.options.type = "keyframes";
        this.options.ease = "linear";
    }
    updateFinishedPromise() {
        this.currentFinishedPromise = new Promise((resolve)=>{
            this.resolveFinishedPromise = resolve;
        });
    }
}






/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $87248eb8ba080f28$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};




// Adapted from https://gist.github.com/mjackson/5311256
function $5429745468e3b812$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $5429745468e3b812$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $5429745468e3b812$var$hueToRgb(p, q, hue + 1 / 3);
        green = $5429745468e3b812$var$hueToRgb(p, q, hue);
        blue = $5429745468e3b812$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}





function $a4bfef1e47c99c15$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}


// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $3587923dc2cfe4e2$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $3587923dc2cfe4e2$var$colorTypes = [
    (0, $30a5a0b739818b6d$export$834dfc94dde4b3d8),
    (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b),
    (0, $0843b7e1fb4696f0$export$810b04175080204c)
];
const $3587923dc2cfe4e2$var$getColorType = (v)=>$3587923dc2cfe4e2$var$colorTypes.find((type)=>type.test(v));
function $3587923dc2cfe4e2$var$asRGBA(color) {
    const type = $3587923dc2cfe4e2$var$getColorType(color);
    (0, $af7e1b70fef19820$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`);
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $0843b7e1fb4696f0$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $5429745468e3b812$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $3587923dc2cfe4e2$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $3587923dc2cfe4e2$var$asRGBA(from);
    const toRGBA = $3587923dc2cfe4e2$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $3587923dc2cfe4e2$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $73de4a1e9f0dd80c$export$4e46ac54fc82cf3b).transform(blended);
    };
};


/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $6cc9e4dbba39be5c$var$combineFunctions = (a, b)=>(v)=>b(a(v));
const $6cc9e4dbba39be5c$export$a4627e546088548d = (...transformers)=>transformers.reduce($6cc9e4dbba39be5c$var$combineFunctions);






const $d051ba1e71c72dc9$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $d051ba1e71c72dc9$export$fed62ccc3fb1a568(origin, target) {
    if ($d051ba1e71c72dc9$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}



function $bbad6d399b1675c4$var$mixNumber(a, b) {
    return (p)=>(0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $bbad6d399b1675c4$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $bbad6d399b1675c4$var$mixNumber;
    else if (typeof a === "string") return (0, $9223341d00255d67$export$31f9caa2600b5723)(a) ? (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1) : (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$65516310a87d8205;
    else if (Array.isArray(a)) return $bbad6d399b1675c4$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $7a26ed3125820d32$export$35e9368ef982300f).test(a) ? (0, $3587923dc2cfe4e2$export$51e568cf5c039bac) : $bbad6d399b1675c4$export$ebc23b6840c51ba1;
    return 0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1;
}
function $bbad6d399b1675c4$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$bbad6d399b1675c4$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $bbad6d399b1675c4$export$ebc23b6840c51ba1(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $bbad6d399b1675c4$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $bbad6d399b1675c4$var$matchOrder(origin, target) {
    var _a;
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = (_a = origin.values[originIndex]) !== null && _a !== void 0 ? _a : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $bbad6d399b1675c4$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $a554c66132092e1c$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $d051ba1e71c72dc9$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $d051ba1e71c72dc9$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $d051ba1e71c72dc9$export$fed62ccc3fb1a568)(origin, target);
        return (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($bbad6d399b1675c4$export$3bbefa2f402845c4($bbad6d399b1675c4$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $af7e1b70fef19820$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`);
        return (0, $a4bfef1e47c99c15$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $ffbcc7e5194b07fa$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $bbad6d399b1675c4$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}







const $53c11e9376dd0d8e$var$velocitySampleDuration = 5; // ms
function $53c11e9376dd0d8e$export$854187271d233eb5(resolveValue, t, current) {
    const prevT = Math.max(t - $53c11e9376dd0d8e$var$velocitySampleDuration, 0);
    return (0, $8d9716de34c4d522$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


const $3c52e59ffa955590$export$86436497e7b05d16 = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};





const $e053e23acb72da0f$var$safeMin = 0.001;
function $e053e23acb72da0f$export$b15f158dc6d6f458({ duration: duration = (0, $3c52e59ffa955590$export$86436497e7b05d16).duration, bounce: bounce = (0, $3c52e59ffa955590$export$86436497e7b05d16).bounce, velocity: velocity = (0, $3c52e59ffa955590$export$86436497e7b05d16).velocity, mass: mass = (0, $3c52e59ffa955590$export$86436497e7b05d16).mass }) {
    let envelope;
    let derivative;
    (0, $af7e1b70fef19820$export$491112666e282270)(duration <= (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)((0, $3c52e59ffa955590$export$86436497e7b05d16).maxDuration), "Spring duration must be 10 seconds or less");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)((0, $3c52e59ffa955590$export$86436497e7b05d16).minDamping, (0, $3c52e59ffa955590$export$86436497e7b05d16).maxDamping, dampingRatio);
    duration = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)((0, $3c52e59ffa955590$export$86436497e7b05d16).minDuration, (0, $3c52e59ffa955590$export$86436497e7b05d16).maxDuration, (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $e053e23acb72da0f$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $e053e23acb72da0f$export$5f679887c3a78b15(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $e053e23acb72da0f$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$e053e23acb72da0f$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: (0, $3c52e59ffa955590$export$86436497e7b05d16).stiffness,
        damping: (0, $3c52e59ffa955590$export$86436497e7b05d16).damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $e053e23acb72da0f$var$rootIterations = 12;
function $e053e23acb72da0f$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $e053e23acb72da0f$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
function $e053e23acb72da0f$export$5f679887c3a78b15(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}


const $883a7f57df047776$var$durationKeys = [
    "duration",
    "bounce"
];
const $883a7f57df047776$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $883a7f57df047776$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $883a7f57df047776$var$getSpringOptions(options) {
    let springOptions = {
        velocity: (0, $3c52e59ffa955590$export$86436497e7b05d16).velocity,
        stiffness: (0, $3c52e59ffa955590$export$86436497e7b05d16).stiffness,
        damping: (0, $3c52e59ffa955590$export$86436497e7b05d16).damping,
        mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!$883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$physicsKeys) && $883a7f57df047776$var$isSpringType(options, $883a7f57df047776$var$durationKeys)) {
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass,
                stiffness: stiffness,
                damping: damping
            };
        } else {
            const derived = (0, $e053e23acb72da0f$export$b15f158dc6d6f458)(options);
            springOptions = {
                ...springOptions,
                ...derived,
                mass: (0, $3c52e59ffa955590$export$86436497e7b05d16).mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $883a7f57df047776$export$b36281d89752ae66(optionsOrVisualDuration = (0, $3c52e59ffa955590$export$86436497e7b05d16).visualDuration, bounce = (0, $3c52e59ffa955590$export$86436497e7b05d16).bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $883a7f57df047776$var$getSpringOptions({
        ...options,
        velocity: -(0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? (0, $3c52e59ffa955590$export$86436497e7b05d16).restSpeed.granular : (0, $3c52e59ffa955590$export$86436497e7b05d16).restSpeed.default);
    restDelta || (restDelta = isGranularScale ? (0, $3c52e59ffa955590$export$86436497e7b05d16).restDelta.granular : (0, $3c52e59ffa955590$export$86436497e7b05d16).restDelta.default);
    let resolveSpring;
    if (dampingRatio < 1) {
        const angularFreq = (0, $e053e23acb72da0f$export$5f679887c3a78b15)(undampedAngularFreq, dampingRatio);
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) // Critically damped spring
    resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
    else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        next: (t)=>{
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                let currentVelocity = 0.0;
                /**
                 * We only need to calculate velocity for under-damped springs
                 * as over- and critically-damped springs can't overshoot, so
                 * checking only for displacement is enough.
                 */ if (dampingRatio < 1) currentVelocity = t === 0 ? (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(initialVelocity) : (0, $53c11e9376dd0d8e$export$854187271d233eb5)(resolveSpring, t, current);
                const isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                const isBelowDisplacementThreshold = Math.abs(target - current) <= restDelta;
                state.done = isBelowVelocityThreshold && isBelowDisplacementThreshold;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator), (0, $175defc6e5d60949$export$f4ff70a5b4808fd8));
            const easing = (0, $3345c58b9a5b9ea2$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        }
    };
    return generator;
}



function $45d5055f4c56892a$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $883a7f57df047776$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $53c11e9376dd0d8e$export$854187271d233eb5)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



const $d8968a9bf4ef9569$export$929e5a82286172a6 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $d8968a9bf4ef9569$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $d8968a9bf4ef9569$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);


const $77de1aec9c0d8bc3$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};









const $d606f3c6c8f4d23c$var$easingLookup = {
    linear: (0, $c13dd6518645747b$export$8793edee2d425525),
    easeIn: $d8968a9bf4ef9569$export$929e5a82286172a6,
    easeInOut: $d8968a9bf4ef9569$export$c07234257a03d5e9,
    easeOut: $d8968a9bf4ef9569$export$57636bb43b1ccbb0,
    circIn: $f0e499eff44e3cea$export$e444123e42d03385,
    circInOut: $f0e499eff44e3cea$export$30d3455eee55bed5,
    circOut: $f0e499eff44e3cea$export$c8d67a19199d1a50,
    backIn: $d3c4eaabf34a945a$export$b01116c84cdfe1a2,
    backInOut: $d3c4eaabf34a945a$export$ddc5fd596f6c71b2,
    backOut: $d3c4eaabf34a945a$export$77edfce482316a60,
    anticipate: $1a7a42634de0d0af$export$6b0af63b873d419e
};
const $d606f3c6c8f4d23c$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $b0f58e8e5196544e$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`);
        const [x1, y1, x2, y2] = definition;
        return (0, $704adaa4b6058bb3$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if (typeof definition === "string") {
        // Else lookup from table
        (0, $af7e1b70fef19820$export$f5708dca728d7177)($d606f3c6c8f4d23c$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`);
        return $d606f3c6c8f4d23c$var$easingLookup[definition];
    }
    return definition;
};






function $db1b2cb99cb3914e$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $c13dd6518645747b$export$8793edee2d425525) : ease;
            mixer = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revist this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $db1b2cb99cb3914e$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $db1b2cb99cb3914e$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $ae2145642557546a$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $3d0a1060fe6b890b$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $ae2145642557546a$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $3d0a1060fe6b890b$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $56a5cdb9e012c5ee$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $a441228218aac9d3$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $d8968a9bf4ef9569$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $a441228218aac9d3$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $77de1aec9c0d8bc3$export$216948827bbdc797)(ease) ? ease.map((0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)) : (0, $d606f3c6c8f4d23c$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $56a5cdb9e012c5ee$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $b4d6c80c1f693ab4$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $db1b2cb99cb3914e$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $a441228218aac9d3$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}






const $eb7f9ad0d187e388$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: ()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).update(passTimestamp, true),
        stop: ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing ? (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp : (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now()
    };
};



const $38d8d0fc14215eff$var$generators = {
    decay: (0, $45d5055f4c56892a$export$ee3ff3a17106998),
    inertia: $45d5055f4c56892a$export$ee3ff3a17106998,
    tween: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    keyframes: (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e),
    spring: $883a7f57df047776$export$b36281d89752ae66
};
const $38d8d0fc14215eff$var$percentToProgress = (percent)=>percent / 100;
/**
 * Animation that runs on the main thread. Designed to be WAAPI-spec in the subset of
 * features we expose publically. Mostly the compatibility is to ensure visual identity
 * between both WAAPI and main thread animations.
 */ class $38d8d0fc14215eff$export$fd98d9cca67a58bc extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * The time at which the animation was cancelled.
         */ this.cancelTime = null;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * The state of the animation to apply when the animation is resolved. This
         * allows calls to the public API to control the animation before it is resolved,
         * without us having to resolve it first.
         */ this.pendingPlayState = "running";
        /**
         * The time at which the animation was started.
         */ this.startTime = null;
        this.state = "idle";
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            this.resolver.cancel();
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            const { onStop: onStop } = this.options;
            onStop && onStop();
        };
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $8a643b2da1c7bc40$export$74d34ca3182f1750);
        const onResolved = (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe);
        this.resolver = new KeyframeResolver$1(keyframes, onResolved, name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    flatten() {
        super.flatten();
        // If we've already resolved the animation, re-initialise it
        if (this._resolved) Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
    }
    initPlayback(keyframes$1) {
        const { type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = this.options;
        const generatorFactory = (0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(type) ? type : $38d8d0fc14215eff$var$generators[type] || (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e);
        /**
         * If our generator doesn't support mixing numbers, we need to replace keyframes with
         * [0, 100] and then make a function that maps that to the actual keyframes.
         *
         * 100 is chosen instead of 1 as it works nicer with spring animations.
         */ let mapPercentToKeyframes;
        let mirroredGenerator;
        if (generatorFactory !== (0, $a441228218aac9d3$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            mapPercentToKeyframes = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)($38d8d0fc14215eff$var$percentToProgress, (0, $ffbcc7e5194b07fa$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...this.options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") mirroredGenerator = generatorFactory({
            ...this.options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $175defc6e5d60949$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        const resolvedDuration = calculatedDuration + repeatDelay;
        const totalDuration = resolvedDuration * (repeat + 1) - repeatDelay;
        return {
            generator: generator,
            mirroredGenerator: mirroredGenerator,
            mapPercentToKeyframes: mapPercentToKeyframes,
            calculatedDuration: calculatedDuration,
            resolvedDuration: resolvedDuration,
            totalDuration: totalDuration
        };
    }
    onPostResolved() {
        const { autoplay: autoplay = true } = this.options;
        this.play();
        if (this.pendingPlayState === "paused" || !autoplay) this.pause();
        else this.state = this.pendingPlayState;
    }
    tick(timestamp, sample = false) {
        const { resolved: resolved } = this;
        // If the animations has failed to resolve, return the final keyframe.
        if (!resolved) {
            const { keyframes: keyframes } = this.options;
            return {
                done: true,
                value: keyframes[keyframes.length - 1]
            };
        }
        const { finalKeyframe: finalKeyframe, generator: generator, mirroredGenerator: mirroredGenerator, mapPercentToKeyframes: mapPercentToKeyframes, keyframes: keyframes, calculatedDuration: calculatedDuration, totalDuration: totalDuration, resolvedDuration: resolvedDuration } = resolved;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, onUpdate: onUpdate } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        // Update currentTime
        if (sample) this.currentTime = timestamp;
        else if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = Math.round(timestamp - this.startTime) * this.speed;
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.speed >= 0 ? 1 : -1);
        const isInDelayPhase = this.speed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ const state = isInDelayPhase ? {
            done: false,
            value: keyframes[0]
        } : frameGenerator.next(elapsed);
        if (mapPercentToKeyframes) state.value = mapPercentToKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.speed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        if (isAnimationFinished && finalKeyframe !== undefined) state.value = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    get duration() {
        const { resolved: resolved } = this;
        return resolved ? (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(resolved.calculatedDuration) : 0;
    }
    get time() {
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.holdTime !== null || this.speed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.speed;
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        this.playbackSpeed = newSpeed;
        if (hasChanged) this.time = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        if (!this.resolver.isScheduled) this.resolver.resume();
        if (!this._resolved) {
            this.pendingPlayState = "running";
            return;
        }
        if (this.isStopped) return;
        const { driver: driver = (0, $eb7f9ad0d187e388$export$c1033964b5ad7fef), onPlay: onPlay, startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        onPlay && onPlay();
        const now = this.driver.now();
        if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        else if (this.state === "finished") this.startTime = now;
        if (this.state === "finished") this.updateFinishedPromise();
        this.cancelTime = this.startTime;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        var _a;
        if (!this._resolved) {
            this.pendingPlayState = "paused";
            return;
        }
        this.state = "paused";
        this.holdTime = (_a = this.currentTime) !== null && _a !== void 0 ? _a : 0;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.pendingPlayState = this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.teardown();
        this.state = "finished";
        const { onComplete: onComplete } = this.options;
        onComplete && onComplete();
    }
    cancel() {
        if (this.cancelTime !== null) this.tick(this.cancelTime);
        this.teardown();
        this.updateFinishedPromise();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        this.startTime = this.cancelTime = null;
        this.resolver.cancel();
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(time) {
        this.startTime = 0;
        return this.tick(time, true);
    }
}
// Legacy interface
function $38d8d0fc14215eff$export$ee9b76de7353d815(options) {
    return new $38d8d0fc14215eff$export$fd98d9cca67a58bc(options);
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $a48a2668cc2264ec$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



function $2b04773fa5493e28$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeInOut", times: times } = {}) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $2bf71e9ed42b773d$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    return element.animate(keyframeOptions, {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    });
}




const $5e339d6188e4f0f2$export$51ea9b46fb7a8c5d = /*@__PURE__*/ (0, $43b56f3d6cf00122$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $264f965dbb30cd85$var$sampleDelta = 10; //ms
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $264f965dbb30cd85$var$maxDuration = 20000;
/**
 * Check if an animation can run natively via WAAPI or requires pregenerated keyframes.
 * WAAPI doesn't support spring or function easings so we run these as JS animation before
 * handing off.
 */ function $264f965dbb30cd85$var$requiresPregeneratedKeyframes(options) {
    return (0, $da585aaca4fb3c01$export$6ab7812f1bac68be)(options.type) || options.type === "spring" || !(0, $2bf71e9ed42b773d$export$fcdd8f3f2160beda)(options.ease);
}
function $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options) {
    /**
     * Create a main-thread animation to pregenerate keyframes.
     * We sample this at regular intervals to generate keyframes that we then
     * linearly interpolate between.
     */ const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
        ...options,
        keyframes: keyframes,
        repeat: 0,
        delay: 0,
        isGenerator: true
    });
    let state = {
        done: false,
        value: keyframes[0]
    };
    const pregeneratedKeyframes = [];
    /**
     * Bail after 20 seconds of pre-generated keyframes as it's likely
     * we're heading for an infinite loop.
     */ let t = 0;
    while(!state.done && t < $264f965dbb30cd85$var$maxDuration){
        state = sampleAnimation.sample(t);
        pregeneratedKeyframes.push(state.value);
        t += $264f965dbb30cd85$var$sampleDelta;
    }
    return {
        times: undefined,
        keyframes: pregeneratedKeyframes,
        duration: t - $264f965dbb30cd85$var$sampleDelta,
        ease: "linear"
    };
}
const $264f965dbb30cd85$var$unsupportedEasingFunctions = {
    anticipate: $1a7a42634de0d0af$export$6b0af63b873d419e,
    backInOut: $d3c4eaabf34a945a$export$ddc5fd596f6c71b2,
    circInOut: $f0e499eff44e3cea$export$30d3455eee55bed5
};
function $264f965dbb30cd85$var$isUnsupportedEase(key) {
    return key in $264f965dbb30cd85$var$unsupportedEasingFunctions;
}
class $264f965dbb30cd85$export$2a45abb4e6513325 extends (0, $9e9bbf9cd1b9c15e$export$d1e4f34b9c2550c1) {
    constructor(options){
        super(options);
        const { name: name, motionValue: motionValue, element: element, keyframes: keyframes } = this.options;
        this.resolver = new (0, $c8b2f05e40a653fe$export$4983792d11b61017)(keyframes, (resolvedKeyframes, finalKeyframe)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe), name, motionValue, element);
        this.resolver.scheduleResolve();
    }
    initPlayback(keyframes, finalKeyframe) {
        let { duration: duration = 300, times: times, ease: ease, type: type, motionValue: motionValue, name: name, startTime: startTime } = this.options;
        /**
         * If element has since been unmounted, return false to indicate
         * the animation failed to initialised.
         */ if (!motionValue.owner || !motionValue.owner.current) return false;
        /**
         * If the user has provided an easing function name that isn't supported
         * by WAAPI (like "anticipate"), we need to provide the corressponding
         * function. This will later get converted to a linear() easing function.
         */ if (typeof ease === "string" && (0, $9c7c93019429f6d6$export$866c1d07a1ac2ab)() && $264f965dbb30cd85$var$isUnsupportedEase(ease)) ease = $264f965dbb30cd85$var$unsupportedEasingFunctions[ease];
        /**
         * If this animation needs pre-generated keyframes then generate.
         */ if ($264f965dbb30cd85$var$requiresPregeneratedKeyframes(this.options)) {
            const { onComplete: onComplete, onUpdate: onUpdate, motionValue: motionValue, element: element, ...options } = this.options;
            const pregeneratedAnimation = $264f965dbb30cd85$var$pregenerateKeyframes(keyframes, options);
            keyframes = pregeneratedAnimation.keyframes;
            // If this is a very short animation, ensure we have
            // at least two keyframes to animate between as older browsers
            // can't animate between a single keyframe.
            if (keyframes.length === 1) keyframes[1] = keyframes[0];
            duration = pregeneratedAnimation.duration;
            times = pregeneratedAnimation.times;
            ease = pregeneratedAnimation.ease;
            type = "keyframes";
        }
        const animation = (0, $2b04773fa5493e28$export$d896de52f97cb615)(motionValue.owner.current, name, keyframes, {
            ...this.options,
            duration: duration,
            times: times,
            ease: ease
        });
        // Override the browser calculated startTime with one synchronised to other JS
        // and WAAPI animations starting this event loop.
        animation.startTime = startTime !== null && startTime !== void 0 ? startTime : this.calcStartTime();
        if (this.pendingTimeline) {
            (0, $dd415ea26b351a85$export$5bd0fcbc73622e13)(animation, this.pendingTimeline);
            this.pendingTimeline = undefined;
        } else /**
             * Prefer the `onfinish` prop as it's more widely supported than
             * the `finished` promise.
             *
             * Here, we synchronously set the provided MotionValue to the end
             * keyframe. If we didn't, when the WAAPI animation is finished it would
             * be removed from the element which would then revert to its old styles.
             */ animation.onfinish = ()=>{
            const { onComplete: onComplete } = this.options;
            motionValue.set((0, $cb21c6c57eea1e02$export$14de59408fad90b)(keyframes, this.options, finalKeyframe));
            onComplete && onComplete();
            this.cancel();
            this.resolveFinishedPromise();
        };
        return {
            animation: animation,
            duration: duration,
            times: times,
            type: type,
            ease: ease,
            keyframes: keyframes
        };
    }
    get duration() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { duration: duration } = resolved;
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(duration);
    }
    get time() {
        const { resolved: resolved } = this;
        if (!resolved) return 0;
        const { animation: animation } = resolved;
        return (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(animation.currentTime || 0);
    }
    set time(newTime) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.currentTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(newTime);
    }
    get speed() {
        const { resolved: resolved } = this;
        if (!resolved) return 1;
        const { animation: animation } = resolved;
        return animation.playbackRate;
    }
    set speed(newSpeed) {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.playbackRate = newSpeed;
    }
    get state() {
        const { resolved: resolved } = this;
        if (!resolved) return "idle";
        const { animation: animation } = resolved;
        return animation.playState;
    }
    get startTime() {
        const { resolved: resolved } = this;
        if (!resolved) return null;
        const { animation: animation } = resolved;
        // Coerce to number as TypeScript incorrectly types this
        // as CSSNumberish
        return animation.startTime;
    }
    /**
     * Replace the default DocumentTimeline with another AnimationTimeline.
     * Currently used for scroll animations.
     */ attachTimeline(timeline) {
        if (!this._resolved) this.pendingTimeline = timeline;
        else {
            const { resolved: resolved } = this;
            if (!resolved) return 0, $c13dd6518645747b$export$8793edee2d425525;
            const { animation: animation } = resolved;
            (0, $dd415ea26b351a85$export$5bd0fcbc73622e13)(animation, timeline);
        }
        return 0, $c13dd6518645747b$export$8793edee2d425525;
    }
    play() {
        if (this.isStopped) return;
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        if (animation.playState === "finished") this.updateFinishedPromise();
        animation.play();
    }
    pause() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation } = resolved;
        animation.pause();
    }
    stop() {
        this.resolver.cancel();
        this.isStopped = true;
        if (this.state === "idle") return;
        this.resolveFinishedPromise();
        this.updateFinishedPromise();
        const { resolved: resolved } = this;
        if (!resolved) return;
        const { animation: animation, keyframes: keyframes, duration: duration, type: type, ease: ease, times: times } = resolved;
        if (animation.playState === "idle" || animation.playState === "finished") return;
        /**
         * WAAPI doesn't natively have any interruption capabilities.
         *
         * Rather than read commited styles back out of the DOM, we can
         * create a renderless JS animation and sample it twice to calculate
         * its current value, "previous" value, and therefore allow
         * Motion to calculate velocity for any subsequent animation.
         */ if (this.time) {
            const { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element, ...options } = this.options;
            const sampleAnimation = new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)({
                ...options,
                keyframes: keyframes,
                duration: duration,
                type: type,
                ease: ease,
                times: times,
                isGenerator: true
            });
            const sampleTime = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(this.time);
            motionValue.setWithVelocity(sampleAnimation.sample(sampleTime - $264f965dbb30cd85$var$sampleDelta).value, sampleAnimation.sample(sampleTime).value, $264f965dbb30cd85$var$sampleDelta);
        }
        const { onStop: onStop } = this.options;
        onStop && onStop();
        this.cancel();
    }
    complete() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.finish();
    }
    cancel() {
        const { resolved: resolved } = this;
        if (!resolved) return;
        resolved.animation.cancel();
    }
    static supports(options) {
        const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type } = options;
        if (!motionValue || !motionValue.owner || !(motionValue.owner.current instanceof HTMLElement)) return false;
        const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
        return (0, $5e339d6188e4f0f2$export$51ea9b46fb7a8c5d)() && name && (0, $a48a2668cc2264ec$export$a27eefbd8fb5e404).has(name) && /**
             * If we're outputting values to onUpdate then we can't use WAAPI as there's
             * no way to read the value from WAAPI every frame.
             */ !onUpdate && !transformTemplate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
    }
}





const $943a3f0a32f59f42$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $943a3f0a32f59f42$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $943a3f0a32f59f42$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $943a3f0a32f59f42$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $943a3f0a32f59f42$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $943a3f0a32f59f42$var$keyframesTransition;
    else if ((0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $943a3f0a32f59f42$var$criticallyDampedSpring(keyframes[1]) : $943a3f0a32f59f42$var$underDampedSpring;
    return $943a3f0a32f59f42$var$ease;
};


/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7({ when: when, delay: _delay, delayChildren: delayChildren, staggerChildren: staggerChildren, staggerDirection: staggerDirection, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, from: from, elapsed: elapsed, ...transition }) {
    return !!Object.keys(transition).length;
}


const $3431270835958863$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $7fa3dbba529c0c38$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(delay);
        let options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unqiue transition settings for this value.
     */ if (!(0, $21fa6358c07b6e55$export$ca8e47dc8ed5a9d7)(valueTransition)) options = {
            ...options,
            ...(0, $943a3f0a32f59f42$export$262124b154b9f1c0)(name, options)
        };
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ if (options.duration) options.duration = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(options.duration);
        if (options.repeatDelay) options.repeatDelay = (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(options.repeatDelay);
        if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            options.duration = 0;
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $636ef95c23a1ebef$export$888a3d84909f9e3d).current || (0, $6c4fc775126b27b6$export$dd826089e3c5e502).skipAnimations) {
            shouldSkip = true;
            options.duration = 0;
            options.delay = 0;
        }
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $cb21c6c57eea1e02$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                // We still want to return some animation controls here rather
                // than returning undefined
                return new (0, $d45984ddbb5525e6$export$c1e41718f71efe41)([]);
            }
        }
        /**
     * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
     * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
     * optimised animation.
     */ if (!isHandoff && (0, $264f965dbb30cd85$export$2a45abb4e6513325).supports(options)) return new (0, $264f965dbb30cd85$export$2a45abb4e6513325)(options);
        else return new (0, $38d8d0fc14215eff$export$fd98d9cca67a58bc)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $cbfc21822c188a13$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $cbfc21822c188a13$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    var _a;
    let { transition: transition = visualElement.getDefaultTransition(), transitionEnd: transitionEnd, ...target } = targetAndTransition;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, (_a = visualElement.latestValues[key]) !== null && _a !== void 0 ? _a : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $cbfc21822c188a13$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay: delay,
            ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(transition || {}, key)
        };
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $6491bdd13544fdda$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(visualElement, key);
        value.start((0, $3431270835958863$export$90b3dfc33ff3548)(key, value, valueTarget, visualElement.shouldReduceMotion && (0, $1b3c8c7753362ba0$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) Promise.all(animations).then(()=>{
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
            transitionEnd && (0, $4ddbbe2518feafa3$export$1f61c53461aff4a5)(visualElement, transitionEnd);
        });
    });
    return animations;
}




function $8c445c76717d72c0$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _a;
    const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $8c445c76717d72c0$var$animateChildren(visualElement, variant, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    const maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
    const generateStaggerDuration = staggerDirection === 1 ? (i = 0)=>i * staggerChildren : (i = 0)=>maxStaggerDuration - i * staggerChildren;
    Array.from(visualElement.variantChildren).sort($8c445c76717d72c0$export$523a0bedf33ad781).forEach((child, i)=>{
        child.notify("AnimationStart", variant);
        animations.push($8c445c76717d72c0$export$4709dc300705b2af(child, variant, {
            ...options,
            delay: delayChildren + generateStaggerDuration(i)
        }).then(()=>child.notify("AnimationComplete", variant)));
    });
    return Promise.all(animations);
}
function $8c445c76717d72c0$export$523a0bedf33ad781(a, b) {
    return a.sortNodePosition(b);
}


function $ca7433f5e9b78911$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $8c445c76717d72c0$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $cbfc21822c188a13$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}




const $51a01f65a0f496d4$var$numVariantProps = (0, $eb6a0a2a824114cd$export$1405a65085f40b9).length;
function $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $51a01f65a0f496d4$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $51a01f65a0f496d4$var$numVariantProps; i++){
        const name = (0, $eb6a0a2a824114cd$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $e4ec7857057a08b6$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}


const $e4063d3013cf053c$var$reversePriorityOrder = [
    ...(0, $eb6a0a2a824114cd$export$16e45afcc206d3a8)
].reverse();
const $e4063d3013cf053c$var$numAnimationTypes = (0, $eb6a0a2a824114cd$export$16e45afcc206d3a8).length;
function $e4063d3013cf053c$var$animateList(visualElement) {
    return (animations)=>Promise.all(animations.map(({ animation: animation, options: options })=>(0, $ca7433f5e9b78911$export$ff62cf473653f109)(visualElement, animation, options)));
}
function $e4063d3013cf053c$export$bb53502b7a672aa8(visualElement) {
    let animate = $e4063d3013cf053c$var$animateList(visualElement);
    let state = $e4063d3013cf053c$var$createState();
    let isInitialRender = true;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _a;
            const resolved = (0, $dfe6a10b7b91d234$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_a = visualElement.presenceContext) === null || _a === void 0 ? void 0 : _a.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $51a01f65a0f496d4$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $e4063d3013cf053c$var$numAnimationTypes; i++){
            const type = $e4063d3013cf053c$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $e4ec7857057a08b6$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            /**
             *
             */ if (isInherited && isInitialRender && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $e4063d3013cf053c$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(next) && (0, $96ae1bfc697c0155$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            /**
             *
             */ if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if (isInitialRender && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>({
                    animation: animation,
                    options: {
                        type: type
                    }
                })));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var _a;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        (_a = visualElement.variantChildren) === null || _a === void 0 || _a.forEach((child)=>{
            var _a;
            return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $e4063d3013cf053c$var$createState();
            isInitialRender = true;
        }
    };
}
function $e4063d3013cf053c$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $b3131a4296a9915c$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $e4063d3013cf053c$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $e4063d3013cf053c$var$createState() {
    return {
        animate: $e4063d3013cf053c$var$createTypeState(true),
        whileInView: $e4063d3013cf053c$var$createTypeState(),
        whileHover: $e4063d3013cf053c$var$createTypeState(),
        whileTap: $e4063d3013cf053c$var$createTypeState(),
        whileDrag: $e4063d3013cf053c$var$createTypeState(),
        whileFocus: $e4063d3013cf053c$var$createTypeState(),
        exit: $e4063d3013cf053c$var$createTypeState()
    };
}


class $8c269db61902fb68$export$6e91cf7616333d5 {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}


class $f32e32aeb432bca6$export$b45b3fe5caabdca extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $e4063d3013cf053c$export$bb53502b7a672aa8)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _a;
        this.node.animationState.reset();
        (_a = this.unmountControls) === null || _a === void 0 || _a.call(this);
    }
}



let $a4f717d2e1520e94$var$id = 0;
class $a4f717d2e1520e94$export$4989d1eb6104cc6c extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.id = $a4f717d2e1520e94$var$id++;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>onExitComplete(this.id));
    }
    mount() {
        const { register: register } = this.node.presenceContext || {};
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}


const $61912b83da9ce72c$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f32e32aeb432bca6$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $a4f717d2e1520e94$export$4989d1eb6104cc6c)
    }
};








function $5727f053dc302d4d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}



function $c20245f8d567b28b$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $c20245f8d567b28b$export$c404e80f92c98d29 = (handler)=>{
    return (event)=>(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event) && handler(event, $c20245f8d567b28b$export$12f84bb882d06e1a(event));
};


function $149813d40ccb6fe7$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(target, eventName, (0, $c20245f8d567b28b$export$c404e80f92c98d29)(handler), options);
}



const $d4f8ff7f023adf4a$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $d4f8ff7f023adf4a$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.x, b.x);
    const yDelta = $d4f8ff7f023adf4a$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}




/**
 * @internal
 */ class $f05cb07b67532e20$export$d9c66232c9c4689c {
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow, dragSnapToOrigin: dragSnapToOrigin = false } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const info = $f05cb07b67532e20$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursoe.
            const isDistancePastThreshold = (0, $d4f8ff7f023adf4a$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= 3;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
            this.history.push({
                ...point,
                timestamp: timestamp
            });
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastMoveEventInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            if (this.dragSnapToOrigin) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $f05cb07b67532e20$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $c46cbf3dcf8631f9$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.contextWindow = contextWindow || window;
        const info = (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event);
        const initialInfo = $f05cb07b67532e20$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $6491bdd13544fdda$export$fff89137e9e818ce);
        this.history = [
            {
                ...point,
                timestamp: timestamp
            }
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $f05cb07b67532e20$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updatePoint);
    }
}
function $f05cb07b67532e20$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $f05cb07b67532e20$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $f05cb07b67532e20$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$lastDevicePoint(history)),
        offset: $f05cb07b67532e20$var$subtractPoint(point, $f05cb07b67532e20$var$startDevicePoint(history)),
        velocity: $f05cb07b67532e20$var$getVelocity(history, 0.1)
    };
}
function $f05cb07b67532e20$var$startDevicePoint(history) {
    return history[0];
}
function $f05cb07b67532e20$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $f05cb07b67532e20$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $f05cb07b67532e20$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    const time = (0, $3ae67a7aa0703caa$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}


function $0dc8dc297bc3aa83$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}





const $d9901b0e7f584a90$var$SCALE_PRECISION = 0.0001;
const $d9901b0e7f584a90$var$SCALE_MIN = 1 - $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$SCALE_MAX = 1 + $d9901b0e7f584a90$var$SCALE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_PRECISION = 0.01;
const $d9901b0e7f584a90$var$TRANSLATE_MIN = 0 - $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
const $d9901b0e7f584a90$var$TRANSLATE_MAX = 0 + $d9901b0e7f584a90$var$TRANSLATE_PRECISION;
function $d9901b0e7f584a90$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $d9901b0e7f584a90$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $d9901b0e7f584a90$export$c1c127004b72a37(target) / $d9901b0e7f584a90$export$c1c127004b72a37(source);
    delta.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $d9901b0e7f584a90$var$SCALE_MIN && delta.scale <= $d9901b0e7f584a90$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $d9901b0e7f584a90$var$TRANSLATE_MIN && delta.translate <= $d9901b0e7f584a90$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $d9901b0e7f584a90$export$c0d25e96fc67d310(delta, source, target, origin) {
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $d9901b0e7f584a90$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $d9901b0e7f584a90$export$cabef5b392704b41(target, relative, parent) {
    target.min = parent.min + relative.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(relative);
}
function $d9901b0e7f584a90$export$426154f9d100f99(target, relative, parent) {
    $d9901b0e7f584a90$export$cabef5b392704b41(target.x, relative.x, parent.x);
    $d9901b0e7f584a90$export$cabef5b392704b41(target.y, relative.y, parent.y);
}
function $d9901b0e7f584a90$export$ecd3d3bef81102c3(target, layout, parent) {
    target.min = layout.min - parent.min;
    target.max = target.min + $d9901b0e7f584a90$export$c1c127004b72a37(layout);
}
function $d9901b0e7f584a90$export$2785bfcc929c5650(target, layout, parent) {
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.x, layout.x, parent.x);
    $d9901b0e7f584a90$export$ecd3d3bef81102c3(target.y, layout.y, parent.y);
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $e4bc4f9b398dfeb3$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $e4bc4f9b398dfeb3$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.x, left, right),
        y: $e4bc4f9b398dfeb3$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $e4bc4f9b398dfeb3$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $e4bc4f9b398dfeb3$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $e4bc4f9b398dfeb3$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(source);
    const targetLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $ae2145642557546a$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $ae2145642557546a$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $e4bc4f9b398dfeb3$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22(dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $e4bc4f9b398dfeb3$export$a3366d3bac43a742;
    return {
        x: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $e4bc4f9b398dfeb3$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $e4bc4f9b398dfeb3$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $93b39ae61dedc877$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $93b39ae61dedc877$export$3d227df54007d73a = ()=>({
        x: $93b39ae61dedc877$export$ff25708b37f72782(),
        y: $93b39ae61dedc877$export$ff25708b37f72782()
    });
const $93b39ae61dedc877$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $93b39ae61dedc877$export$6459fc9e86be362e = ()=>({
        x: $93b39ae61dedc877$export$6db76765312617ac(),
        y: $93b39ae61dedc877$export$6db76765312617ac()
    });


function $c68037220032f1d8$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $040c3e7ac51c9eb3$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $040c3e7ac51c9eb3$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $040c3e7ac51c9eb3$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}



function $fed21f2a9fad1fb9$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $fed21f2a9fad1fb9$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$fed21f2a9fad1fb9$var$isIdentityScale(scale) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleX) || !$fed21f2a9fad1fb9$var$isIdentityScale(scaleY);
}
function $fed21f2a9fad1fb9$export$a545127cf1fbb600(values) {
    return $fed21f2a9fad1fb9$export$bdf30dca883ea463(values) || $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f(values) {
    return $fed21f2a9fad1fb9$var$is2DTranslate(values.x) || $fed21f2a9fad1fb9$var$is2DTranslate(values.y);
}
function $fed21f2a9fad1fb9$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $4c951bbfa32a6f81$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $4c951bbfa32a6f81$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $4c951bbfa32a6f81$export$d80074982803af5c(box, { x: x, y: y }) {
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $4c951bbfa32a6f81$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) $4c951bbfa32a6f81$export$58b16271041fbfb(box, {
            x: -node.scroll.offset.x,
            y: -node.scroll.offset.y
        });
        if (delta) {
            // Incoporate each ancestor's scale into a culmulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $4c951bbfa32a6f81$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) $4c951bbfa32a6f81$export$58b16271041fbfb(box, node.latestValues);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.x > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MAX && treeScale.y > $4c951bbfa32a6f81$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $4c951bbfa32a6f81$export$a807a5ce5ebb3895(axis, distance) {
    axis.min = axis.min + distance;
    axis.max = axis.max + distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $4c951bbfa32a6f81$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $4c951bbfa32a6f81$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $4c951bbfa32a6f81$export$58b16271041fbfb(box, transform) {
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.x, transform.x, transform.scaleX, transform.scale, transform.originX);
    $4c951bbfa32a6f81$export$625f1dd140a2f5e7(box.y, transform.y, transform.scaleY, transform.scale, transform.originY);
}


function $0b2600dd2e3d7275$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)((0, $040c3e7ac51c9eb3$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $0b2600dd2e3d7275$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $0b2600dd2e3d7275$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}









// Fixes https://github.com/motiondivision/motion/issues/2270
const $1a5cc9ddc6d87d3a$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};




const $0ba13f75c89670e3$export$f0a15892c27dc07c = new WeakMap();
/**
 *
 */ // let latestPointerEvent: PointerEvent
class $0ba13f75c89670e3$export$86bff71f18910307 {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor: snapToCursor = false } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
            // Stop or pause any animations on both axis values immediately. This allows the user to throw and catch
            // the component.
            dragSnapToOrigin ? this.pauseAnimation() : this.stopAnimation();
            if (snapToCursor) this.snapToCursor((0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event).point);
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $7a2dafd130edc18a$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin
             */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onDragStart(event, info));
            (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            // latestPointerEvent = event
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $0ba13f75c89670e3$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ onDrag && onDrag(event, info);
        };
        const onSessionEnd = (event, info)=>this.stop(event, info);
        const resumeAnimation = ()=>(0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                var _a;
                return this.getAnimationState(axis) === "paused" && ((_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.play());
            });
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.visualElement)
        });
    }
    stop(event, info) {
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging) return;
        const { velocity: velocity } = info;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onDragEnd(event, info));
    }
    cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.panSession && this.panSession.end();
        this.panSession = undefined;
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $e4bc4f9b398dfeb3$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _a;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_a = this.visualElement.projection) === null || _a === void 0 ? void 0 : _a.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $e4bc4f9b398dfeb3$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $e4bc4f9b398dfeb3$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative.
         */ if (prevConstraints !== this.constraints && layout && this.constraints && !this.hasMutatedConstraints) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $e4bc4f9b398dfeb3$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $af7e1b70fef19820$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, $0b2600dd2e3d7275$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $e4bc4f9b398dfeb3$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $040c3e7ac51c9eb3$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $040c3e7ac51c9eb3$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $bd95401810c788ae$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $3431270835958863$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    pauseAnimation() {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            var _a;
            return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.pause();
        });
    }
    getAnimationState(axis) {
        var _a;
        return (_a = this.getAxisMotionValue(axis).animation) === null || _a === void 0 ? void 0 : _a.state;
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                axisValue.set(point[axis] - (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, 0.5));
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $e4bc4f9b398dfeb3$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            if (!$0ba13f75c89670e3$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $0ba13f75c89670e3$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            drag && dragListener && this.start(event);
        });
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) this.constraints = this.resolveRefConstraints();
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $e4bc4f9b398dfeb3$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return {
            ...props,
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        };
    }
}
function $0ba13f75c89670e3$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $0ba13f75c89670e3$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $012c82f716440bf2$export$5d97dc2872682820 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.removeListeners = (0, $c13dd6518645747b$export$8793edee2d425525);
        this.controls = new (0, $0ba13f75c89670e3$export$86bff71f18910307)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
    }
}








const $a23e02b288283422$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>handler(event, info));
    };
class $a23e02b288283422$export$b4f8f1ee75ce5859 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $c13dd6518645747b$export$8793edee2d425525);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $f05cb07b67532e20$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $1a5cc9ddc6d87d3a$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $a23e02b288283422$var$asyncHandler(onPanSessionStart),
            onStart: $a23e02b288283422$var$asyncHandler(onPanStart),
            onMove: onPan,
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $149813d40ccb6fe7$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $12e60920c2394b39$export$f224e4635b6f8ce2 = (0, $bh6RR.createContext)(null);


/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed the tree, but
 * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $11db8f3094dfc6f1$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $bh6RR.useId)();
    (0, $bh6RR.useEffect)(()=>{
        if (subscribe) register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $bh6RR.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $11db8f3094dfc6f1$export$8249053f690ea39a() {
    return $11db8f3094dfc6f1$export$ee27c052bca048fb((0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2)));
}
function $11db8f3094dfc6f1$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $364741b44296b530$export$a3579ca508007a95 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $b8a0e6b50203ba18$export$da5f7b802957459a = (0, $bh6RR.createContext)({});


/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $fb51e1392d812b31$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



function $e543877808356f59$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $e543877808356f59$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $e543877808356f59$export$fafff692be55225d(latest, node.target.x);
        const y = $e543877808356f59$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $2e837016dedbf14e$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $a554c66132092e1c$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $a554c66132092e1c$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $93233d74f0d10a65$export$91ddd985b97788d1 = {};
function $93233d74f0d10a65$export$de9e7791c71225fd(correctors) {
    Object.assign($93233d74f0d10a65$export$91ddd985b97788d1, correctors);
}



const { schedule: $3858c82cd1ca695a$export$bb76eed83315504c, cancel: $3858c82cd1ca695a$export$3252729004b8456e } = (0, $3c9d516863748892$export$510b0596a933801a)(queueMicrotask, false);



"use client";
class $b6e93d5d187b3d6c$var$MeasureLayoutWithContext extends (0, $bh6RR.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        (0, $93233d74f0d10a65$export$de9e7791c71225fd)($b6e93d5d187b3d6c$var$defaultScaleCorrectors);
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const projection = visualElement.projection;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { projection: projection } = this.props.visualElement;
        if (projection) {
            projection.root.didUpdate();
            (0, $3858c82cd1ca695a$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $b6e93d5d187b3d6c$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $11db8f3094dfc6f1$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    return (0, $ih19M.jsx)($b6e93d5d187b3d6c$var$MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}
const $b6e93d5d187b3d6c$var$defaultScaleCorrectors = {
    borderRadius: {
        ...(0, $e543877808356f59$export$5eafb6257a5844c),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $e543877808356f59$export$5eafb6257a5844c),
    boxShadow: (0, $2e837016dedbf14e$export$eb0bc629e74dcf8)
};







function $a676325df12b3ad9$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value : (0, $925342fde4532b85$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $3431270835958863$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}






function $7982a746f864c4a2$export$17eda790a720ec57(element) {
    return element instanceof SVGElement && element.tagName !== "svg";
}



const $b2b47619cf5d2c84$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $1f12cfa00e0c731b$export$1465d17e3de78a96 {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $b2b47619cf5d2c84$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}






/**
 * Timeout defined in ms
 */ function $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(checkElapsed, true);
    return ()=>(0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(checkElapsed);
}
function $d62baf960e3e1cd2$export$fcd451ca460f8a2a(callback, timeout) {
    return $d62baf960e3e1cd2$export$1391212d75b2ee65(callback, (0, $3ae67a7aa0703caa$export$fc3e7e8557f8c8c7)(timeout));
}






/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 *
 * TODO: Remove and move to library
 */ function $9e7923b7600c25b9$export$fcc2206ecb6d74b(value) {
    const unwrappedValue = (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    return (0, $b9d94c0c185391a2$export$2f308ad9864b3ac9)(unwrappedValue) ? unwrappedValue.toValue() : unwrappedValue;
}






const $210c6abc2ab907de$var$borders = [
    "TopLeft",
    "TopRight",
    "BottomLeft",
    "BottomRight"
];
const $210c6abc2ab907de$var$numBorders = $210c6abc2ab907de$var$borders.length;
const $210c6abc2ab907de$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $210c6abc2ab907de$var$isPx = (value)=>typeof value === "number" || (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).test(value);
function $210c6abc2ab907de$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(0, // TODO Reinstate this if only child
        lead.opacity !== undefined ? lead.opacity : 1, $210c6abc2ab907de$var$easeCrossfadeIn(progress));
        target.opacityExit = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, 0, $210c6abc2ab907de$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.opacity !== undefined ? follow.opacity : 1, lead.opacity !== undefined ? lead.opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $210c6abc2ab907de$var$numBorders; i++){
        const borderLabel = `border${$210c6abc2ab907de$var$borders[i]}Radius`;
        let followRadius = $210c6abc2ab907de$var$getRadius(follow, borderLabel);
        let leadRadius = $210c6abc2ab907de$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $210c6abc2ab907de$var$isPx(followRadius) === $210c6abc2ab907de$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)($210c6abc2ab907de$var$asNumber(followRadius), $210c6abc2ab907de$var$asNumber(leadRadius), progress), 0);
            if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(leadRadius) || (0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $210c6abc2ab907de$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
// /**
//  * We only want to mix the background color if there's a follow element
//  * that we're not crossfading opacity between. For instance with switch
//  * AnimateSharedLayout animations, this helps the illusion of a continuous
//  * element being animated but also cuts down on the number of paints triggered
//  * for elements where opacity is doing that work for us.
//  */
// if (
//     !hasFollowElement &&
//     latestLeadValues.backgroundColor &&
//     latestFollowValues.backgroundColor
// ) {
//     /**
//      * This isn't ideal performance-wise as mixColor is creating a new function every frame.
//      * We could probably create a mixer that runs at the start of the animation but
//      * the idea behind the crossfader is that it runs dynamically between two potentially
//      * changing targets (ie opacity or borderRadius may be animating independently via variants)
//      */
//     leadState.backgroundColor = followState.backgroundColor = mixColor(
//         latestFollowValues.backgroundColor as string,
//         latestLeadValues.backgroundColor as string
//     )(p)
// }
const $210c6abc2ab907de$var$easeCrossfadeIn = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0, 0.5, (0, $f0e499eff44e3cea$export$c8d67a19199d1a50));
const $210c6abc2ab907de$var$easeCrossfadeOut = /*@__PURE__*/ $210c6abc2ab907de$var$compress(0.5, 0.95, (0, $c13dd6518645747b$export$8793edee2d425525));
function $210c6abc2ab907de$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $ae2145642557546a$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$c53fd88f45d77e4b(box, originBox) {
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.x, originBox.x);
    $44cebc6c5c69ba9d$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $44cebc6c5c69ba9d$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $749794150c53d8b2$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $4c951bbfa32a6f81$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $749794150c53d8b2$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $ee89500f7aaa2f56$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $749794150c53d8b2$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $749794150c53d8b2$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $749794150c53d8b2$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $749794150c53d8b2$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $749794150c53d8b2$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $749794150c53d8b2$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.x, transforms, $749794150c53d8b2$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $749794150c53d8b2$export$42b76f1d0d16d5b(box.y, transforms, $749794150c53d8b2$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $360ce5c67f749464$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $360ce5c67f749464$export$a7ec7642fe550fb6(delta) {
    return $360ce5c67f749464$var$isAxisDeltaZero(delta.x) && $360ce5c67f749464$var$isAxisDeltaZero(delta.y);
}
function $360ce5c67f749464$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $360ce5c67f749464$export$8d5cf76bb7daff09(a, b) {
    return $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.x, b.x) && $360ce5c67f749464$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $360ce5c67f749464$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $360ce5c67f749464$export$ef641b782d85522(a, b) {
    return $360ce5c67f749464$export$22adf28bfca1c186(a.x, b.x) && $360ce5c67f749464$export$22adf28bfca1c186(a.y, b.y);
}
function $360ce5c67f749464$export$c5706146bc63213(box) {
    return (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.x) / (0, $d9901b0e7f584a90$export$c1c127004b72a37)(box.y);
}
function $360ce5c67f749464$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $183043a6fc74a7d6$export$39be5b2d82fc9dc7 {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, $13ad1cfa8b4681b0$export$20e507e47fae79fd)(this.members, node);
        node.scheduleRender();
    }
    remove(node) {
        (0, $13ad1cfa8b4681b0$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        const indexOfNode = this.members.findIndex((member)=>node === member);
        if (indexOfNode === 0) return false;
        /**
         * Find the next projection node that is present
         */ let prevLead;
        for(let i = indexOfNode; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false) {
                prevLead = member;
                break;
            }
        }
        if (prevLead) {
            this.promote(prevLead);
            return true;
        } else return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.instance && prevLead.scheduleRender();
            node.scheduleRender();
            node.resumeFrom = prevLead;
            if (preserveFollowOpacity) node.resumeFrom.preserveOpacity = true;
            if (prevLead.snapshot) {
                node.snapshot = prevLead.snapshot;
                node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
            }
            if (node.root && node.root.isUpdating) node.isLayoutDirty = true;
            const { crossfade: crossfade } = node.options;
            if (crossfade === false) prevLead.hide();
        /**
             * TODO:
             *   - Test border radius when previous node was deleted
             *   - boxShadow mixing
             *   - Shared between element A in scrolled container and element B (scroll stays the same or changes)
             *   - Shared between element A in transformed container and element B (transform stays the same or changes)
             *   - Shared between element A in scrolled page and element B (scroll stays the same or changes)
             * ---
             *   - Crossfade opacity of root nodes
             *   - layoutId changes after animation
             *   - layoutId changes mid animation
             */ }
    }
    exitAnimationComplete() {
        this.members.forEach((node)=>{
            const { options: options, resumingFrom: resumingFrom } = node;
            options.onExitComplete && options.onExitComplete();
            if (resumingFrom) resumingFrom.options.onExitComplete && resumingFrom.options.onExitComplete();
        });
    }
    scheduleRender() {
        this.members.forEach((node)=>{
            node.instance && node.scheduleRender(false);
        });
    }
    /**
     * Clear any leads that have been removed this render to prevent them from being
     * used in future animations and to prevent memory leaks
     */ removeLeadSnapshot() {
        if (this.lead && this.lead.snapshot) this.lead.snapshot = undefined;
    }
}



function $bec23b122ca5d293$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}





const $281d58aebf127403$var$metrics = {
    type: "projectionFrame",
    totalNodes: 0,
    resolvedTargetDeltas: 0,
    recalculatedProjection: 0
};
const $281d58aebf127403$var$isDebug = typeof window !== "undefined" && window.MotionDebug !== undefined;
const $281d58aebf127403$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
const $281d58aebf127403$var$hiddenVisibility = {
    visibility: "hidden"
};
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $281d58aebf127403$var$animationTarget = 1000;
let $281d58aebf127403$var$id = 0;
function $281d58aebf127403$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $e2f74713dde14d85$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $6491bdd13544fdda$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $281d58aebf127403$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $281d58aebf127403$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.totalNodes = $281d58aebf127403$var$metrics.resolvedTargetDeltas = $281d58aebf127403$var$metrics.recalculatedProjection = 0;
                this.nodes.forEach($281d58aebf127403$export$131f2f0cc5fe9609);
                this.nodes.forEach($281d58aebf127403$var$resolveTargetDelta);
                this.nodes.forEach($281d58aebf127403$var$calcProjection);
                this.nodes.forEach($281d58aebf127403$export$c2664f37bc951031);
                if ($281d58aebf127403$var$isDebug) window.MotionDebug.record($281d58aebf127403$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $1f12cfa00e0c731b$export$1465d17e3de78a96)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance, isLayoutDirty = this.root.hasTreeAnimated) {
            if (this.instance) return;
            this.isSVG = (0, $7982a746f864c4a2$export$17eda790a720ec57)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (isLayoutDirty && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                attachResizeListener(instance, ()=>{
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $d62baf960e3e1cd2$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($281d58aebf127403$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeTargetChanged: hasRelativeTargetChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $281d58aebf127403$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const targetChanged = !this.targetLayout || !(0, $360ce5c67f749464$export$ef641b782d85522)(this.targetLayout, newLayout) || hasRelativeTargetChanged;
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeTargetChanged;
                if (this.options.layoutRoot || this.resumeFrom && this.resumeFrom.instance || hasOnlyRelativeTargetChanged || hasLayoutChanged && (targetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                    const animationOptions = {
                        ...(0, $7fa3dbba529c0c38$export$7c1391340308742e)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never commited to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $281d58aebf127403$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($281d58aebf127403$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $281d58aebf127403$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                this.unblockUpdate();
                this.clearAllSnapshots();
                this.nodes.forEach($281d58aebf127403$var$clearMeasurements);
                return;
            }
            if (!this.isUpdating) this.nodes.forEach($281d58aebf127403$var$clearIsLayoutDirty);
            this.isUpdating = false;
            /**
             * Write
             */ this.nodes.forEach($281d58aebf127403$var$resetTransformStyle);
            /**
             * Read ==================
             */ // Update layout measurements of updated children
            this.nodes.forEach($281d58aebf127403$var$updateLayout);
            /**
             * Write
             */ // Notify listeners that the layout is updated
            this.nodes.forEach($281d58aebf127403$var$notifyLayoutUpdate);
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).delta = (0, $bb2cd2f4425aee0a$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp);
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp = now;
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = true;
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).update.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).preRender.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$1811c3a7e3af92f0).render.process((0, $6491bdd13544fdda$export$fff89137e9e818ce));
            (0, $6491bdd13544fdda$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $3858c82cd1ca695a$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($281d58aebf127403$var$clearSnapshot);
            this.sharedNodes.forEach($281d58aebf127403$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
        }
        updateLayout() {
            if (!this.instance) return;
            // TODO: Incorporate into a forwarded scroll offset
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutCorrected = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && (hasProjection || (0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $281d58aebf127403$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _a;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) || this.path.some($281d58aebf127403$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _a;
            const boxWithoutScroll = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_a = this.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $4c951bbfa32a6f81$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false) {
            const withTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, {
                    x: -node.scroll.offset.x,
                    y: -node.scroll.offset.y
                });
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, node.latestValues);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(withTransforms, this.latestValues);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!node.instance) continue;
                if (!(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                const sourceBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const nodeBox = node.measurePageBox();
                (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(sourceBox, nodeBox);
                (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, node.snapshot ? node.snapshot.layoutBox : undefined, sourceBox);
            }
            if ((0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) (0, $749794150c53d8b2$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _a;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp;
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && relativeParent.layout && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.layout.layoutBox, relativeParent.layout.layoutBox);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $d9901b0e7f584a90$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) // TODO: This is creating a new object every frame
                this.target = this.applyTransform(this.layout.layoutBox);
                else (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $4c951bbfa32a6f81$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                const relativeParent = this.getClosestProjectingParent();
                if (relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) {
                    this.relativeParent = relativeParent;
                    this.forceRelativeParentToResolveTarget();
                    this.relativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    this.relativeTargetOrigin = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(this.relativeTargetOrigin, this.target, relativeParent.target);
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
                } else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.resolvedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $fed21f2a9fad1fb9$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $fed21f2a9fad1fb9$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        calcProjection() {
            var _a;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_a = this.parent) === null || _a === void 0 ? void 0 : _a.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $6491bdd13544fdda$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $4c951bbfa32a6f81$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $44cebc6c5c69ba9d$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $360ce5c67f749464$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.recalculatedProjection++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _a;
            (_a = this.options.visualElement) === null || _a === void 0 || _a.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($281d58aebf127403$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.x, delta.x, progress);
                $281d58aebf127403$export$91dbf443e1bf1de1(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox);
                    $281d58aebf127403$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $360ce5c67f749464$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $210c6abc2ab907de$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation && this.currentAnimation.stop();
            if (this.resumingFrom && this.resumingFrom.currentAnimation) this.resumingFrom.currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $6491bdd13544fdda$export$2cef06c20297c17d).update(()=>{
                (0, $fb51e1392d812b31$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                this.currentAnimation = (0, $a676325df12b3ad9$export$335a17c977067b99)(0, $281d58aebf127403$var$animationTarget, {
                    ...options,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onComplete: ()=>{
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($281d58aebf127403$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $281d58aebf127403$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                const xLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $44cebc6c5c69ba9d$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $4c951bbfa32a6f81$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $183043a6fc74a7d6$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.lead) || this : this;
        }
        getPrevLead() {
            var _a;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_a = this.getStack()) === null || _a === void 0 ? void 0 : _a.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $281d58aebf127403$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $281d58aebf127403$var$transformAxes.length; i++){
                $281d58aebf127403$var$resetDistortingTransform(`rotate${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $281d58aebf127403$var$resetDistortingTransform(`skew${$281d58aebf127403$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        getProjectionStyles(styleProp) {
            var _a, _b;
            if (!this.instance || this.isSVG) return undefined;
            if (!this.isVisible) return $281d58aebf127403$var$hiddenVisibility;
            const styles = {
                visibility: ""
            };
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                styles.opacity = "";
                styles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                styles.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return styles;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                const emptyStyles = {};
                if (this.options.layoutId) {
                    emptyStyles.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    emptyStyles.pointerEvents = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $fed21f2a9fad1fb9$export$a545127cf1fbb600)(this.latestValues)) {
                    emptyStyles.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return emptyStyles;
            }
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            styles.transform = (0, $bec23b122ca5d293$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) styles.transform = transformTemplate(valuesToRender, styles.transform);
            const { x: x, y: y } = this.projectionDelta;
            styles.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ styles.opacity = lead === this ? (_b = (_a = valuesToRender.opacity) !== null && _a !== void 0 ? _a : this.latestValues.opacity) !== null && _b !== void 0 ? _b : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ styles.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $93233d74f0d10a65$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo } = (0, $93233d74f0d10a65$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = styles.transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)styles[applyTo[i]] = corrected;
                } else styles[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) styles.pointerEvents = lead === this ? (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
            return styles;
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _a;
                return (_a = node.currentAnimation) === null || _a === void 0 ? void 0 : _a.stop();
            });
            this.root.nodes.forEach($281d58aebf127403$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function $281d58aebf127403$var$updateLayout(node) {
    node.updateLayout();
}
function $281d58aebf127403$var$notifyLayoutUpdate(node) {
    var _a;
    const snapshot = ((_a = node.resumeFrom) === null || _a === void 0 ? void 0 : _a.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if ($281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $c68037220032f1d8$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $d9901b0e7f584a90$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $93b39ae61dedc877$export$3d227df54007d73a)();
        if (isShared) (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $d9901b0e7f584a90$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $360ce5c67f749464$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeTargetChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const relativeSnapshot = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox);
                    const relativeLayout = (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
                    (0, $d9901b0e7f584a90$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox);
                    if (!(0, $360ce5c67f749464$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeTargetChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeTargetChanged: hasRelativeTargetChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $281d58aebf127403$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ($281d58aebf127403$var$isDebug) $281d58aebf127403$var$metrics.totalNodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $281d58aebf127403$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $281d58aebf127403$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $281d58aebf127403$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $281d58aebf127403$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
function $281d58aebf127403$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $281d58aebf127403$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $281d58aebf127403$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $281d58aebf127403$var$calcProjection(node) {
    node.calcProjection();
}
function $281d58aebf127403$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $281d58aebf127403$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $281d58aebf127403$export$91dbf443e1bf1de1(output, delta, p) {
    output.translate = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $281d58aebf127403$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $281d58aebf127403$export$6ffd3e6ae339a132(output, from, to, p) {
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $281d58aebf127403$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $281d58aebf127403$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $281d58aebf127403$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $281d58aebf127403$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $281d58aebf127403$var$roundPoint = $281d58aebf127403$var$userAgentContains("applewebkit/") && !$281d58aebf127403$var$userAgentContains("chrome/") ? Math.round : (0, $c13dd6518645747b$export$8793edee2d425525);
function $281d58aebf127403$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $281d58aebf127403$var$roundPoint(axis.min);
    axis.max = $281d58aebf127403$var$roundPoint(axis.max);
}
function $281d58aebf127403$var$roundBox(box) {
    $281d58aebf127403$var$roundAxis(box.x);
    $281d58aebf127403$var$roundAxis(box.y);
}
function $281d58aebf127403$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $d9901b0e7f584a90$export$28d0384c4b79bde2)((0, $360ce5c67f749464$export$c5706146bc63213)(snapshot), (0, $360ce5c67f749464$export$c5706146bc63213)(layout), 0.2);
}
function $281d58aebf127403$var$checkNodeWasScrollRoot(node) {
    var _a;
    return node !== node.root && ((_a = node.scroll) === null || _a === void 0 ? void 0 : _a.wasRoot);
}




const $b2724fa5a1f79278$export$2d029a49a09b6177 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $5727f053dc302d4d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body.scrollLeft,
            y: document.documentElement.scrollTop || document.body.scrollTop
        }),
    checkIsScrollRoot: ()=>true
});


const $e8dff807472b9243$export$b91509fcf893b648 = {
    current: undefined
};
const $e8dff807472b9243$export$b61a9eb3dbde8858 = (0, $281d58aebf127403$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$e8dff807472b9243$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b2724fa5a1f79278$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $e8dff807472b9243$export$b91509fcf893b648.current = documentNode;
        }
        return $e8dff807472b9243$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $5e0aeefdd70dc82e$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $a23e02b288283422$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $012c82f716440bf2$export$5d97dc2872682820),
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};






function $d74f51ccafbc2725$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $d74f51ccafbc2725$export$93a81ea037eac456 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $62aebe68f5a3cc52$export$3f60957f5dbf3876)(current, (startEvent)=>{
            $d74f51ccafbc2725$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$d74f51ccafbc2725$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}





class $194e5f2fba7dd91c$export$d4826db40d47595b extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $6cc9e4dbba39be5c$export$a4627e546088548d)((0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $5727f053dc302d4d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}






function $7978956cdecaf1df$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $6491bdd13544fdda$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $c20245f8d567b28b$export$12f84bb882d06e1a)(event)));
}
class $7978956cdecaf1df$export$f026abdbba7f0c9e extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $1fb501146082d657$export$dbe9198142dace0c)(current, (startEvent)=>{
            $7978956cdecaf1df$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$7978956cdecaf1df$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: this.node.props.globalTapTarget
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ const $a7da81711d7ddff5$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $a7da81711d7ddff5$var$observers = new WeakMap();
const $a7da81711d7ddff5$var$fireObserverCallback = (entry)=>{
    const callback = $a7da81711d7ddff5$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $a7da81711d7ddff5$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($a7da81711d7ddff5$var$fireObserverCallback);
};
function $a7da81711d7ddff5$var$initIntersectionObserver({ root: root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$a7da81711d7ddff5$var$observers.has(lookupRoot)) $a7da81711d7ddff5$var$observers.set(lookupRoot, {});
    const rootObservers = $a7da81711d7ddff5$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($a7da81711d7ddff5$var$fireAllObserverCallbacks, {
        root: root,
        ...options
    });
    return rootObservers[key];
}
function $a7da81711d7ddff5$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $a7da81711d7ddff5$var$initIntersectionObserver(options);
    $a7da81711d7ddff5$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $a7da81711d7ddff5$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $62d26f27ee79826d$var$thresholdNames = {
    some: 0,
    all: 1
};
class $62d26f27ee79826d$export$150851c8cc2f0c72 extends (0, $8c269db61902fb68$export$6e91cf7616333d5) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.unmount();
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $62d26f27ee79826d$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        return (0, $a7da81711d7ddff5$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($62d26f27ee79826d$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {}
}
function $62d26f27ee79826d$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $aadd72d7ca06bd3a$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $62d26f27ee79826d$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $7978956cdecaf1df$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $194e5f2fba7dd91c$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $d74f51ccafbc2725$export$93a81ea037eac456)
    }
};




const $17a320fc4896a503$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $e8dff807472b9243$export$b61a9eb3dbde8858),
        MeasureLayout: $b6e93d5d187b3d6c$export$779f5fb01ad751cd
    }
};



var $ih19M = parcelRequire("ih19M");


var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
"use client";
const $6a5cdc65c5393968$export$40f10139ecf1f171 = (0, $bh6RR.createContext)({
    strict: false
});



var $bh6RR = parcelRequire("bh6RR");
"use client";
/**
 * @public
 */ const $f69ceb430ae9345a$export$22a697fb29aac98d = (0, $bh6RR.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $bh6RR = parcelRequire("bh6RR");
"use client";
const $38e1c7c15d587098$export$2285bbca2c666415 = (0, $bh6RR.createContext)({});



var $bh6RR = parcelRequire("bh6RR");





function $a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) {
    return (0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(props.animate) || (0, $eb6a0a2a824114cd$export$1405a65085f40b9).some((name)=>(0, $e4ec7857057a08b6$export$720b90e312cea233)(props[name]));
}
function $a01dc07902ba23d1$export$ce46fa4165cdec40(props) {
    return Boolean($a01dc07902ba23d1$export$4b3c3bd8d910d78d(props) || props.variants);
}


function $be811e3f75d8f6fc$export$12fc32fc096a04a3(props, context) {
    if ((0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $e4ec7857057a08b6$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $e4ec7857057a08b6$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


function $a6e92297d8c984af$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $be811e3f75d8f6fc$export$12fc32fc096a04a3)(props, (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415)));
    return (0, $bh6RR.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a6e92297d8c984af$var$variantLabelsAsDependency(initial),
        $a6e92297d8c984af$var$variantLabelsAsDependency(animate)
    ]);
}
function $a6e92297d8c984af$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}


const $0ec11121663cc82b$export$4e09c449d6c407f7 = typeof window !== "undefined";


const $145d8d26c6dc52b8$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
const $145d8d26c6dc52b8$export$65570e08d843624d = {};
for(const key in $145d8d26c6dc52b8$var$featureProps)$145d8d26c6dc52b8$export$65570e08d843624d[key] = {
    isEnabled: (props)=>$145d8d26c6dc52b8$var$featureProps[key].some((name)=>!!props[name])
};



function $8223c64d87d3460d$export$449561ec5703cdc8(features) {
    for(const key in features)(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key] = {
        ...(0, $145d8d26c6dc52b8$export$65570e08d843624d)[key],
        ...features[key]
    };
}


const $92847778545e8ed0$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $bh6RR = parcelRequire("bh6RR");

/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $29bcaad27b8bb245$export$c684914703d321fd(visualState, visualElement, externalRef) {
    return (0, $bh6RR.useCallback)((instance)=>{
        if (instance) visualState.onMount && visualState.onMount(instance);
        if (visualElement) {
            if (instance) visualElement.mount(instance);
            else visualElement.unmount();
        }
        if (externalRef) {
            if (typeof externalRef === "function") externalRef(instance);
            else if ((0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(externalRef)) externalRef.current = instance;
        }
    }, /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */ [
        visualElement
    ]);
}



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

const $56377e0c81527360$export$700979bc83e7db82 = (0, $0ec11121663cc82b$export$4e09c449d6c407f7) ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);








function $05aa2ab8e054331c$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor) {
    var _a, _b;
    const { visualElement: parent } = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
    const lazyContext = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171));
    const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
    const reducedMotionConfig = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)).reducedMotion;
    const visualElementRef = (0, $bh6RR.useRef)(null);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) visualElementRef.current = createVisualElement(Component, {
        visualState: visualState,
        parent: parent,
        props: props,
        presenceContext: presenceContext,
        blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
        reducedMotionConfig: reducedMotionConfig
    });
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $bh6RR.useContext)((0, $b8a0e6b50203ba18$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $05aa2ab8e054331c$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $6b140fcbcf20767d$export$8592e1c077c890a6];
    const wantsHandoff = (0, $bh6RR.useRef)(Boolean(optimisedAppearId) && !((_a = window.MotionHandoffIsComplete) === null || _a === void 0 ? void 0 : _a.call(window, optimisedAppearId)) && ((_b = window.MotionHasOptimisedAnimation) === null || _b === void 0 ? void 0 : _b.call(window, optimisedAppearId)));
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        (0, $3858c82cd1ca695a$export$bb76eed83315504c).render(visualElement.render);
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $bh6RR.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _a;
                (_a = window.MotionHandoffMarkAsComplete) === null || _a === void 0 || _a.call(window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
    });
    return visualElement;
}
function $05aa2ab8e054331c$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $0dc8dc297bc3aa83$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot
    });
}
function $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $05aa2ab8e054331c$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $0c5a031ea8dd3973$export$c3ad4a902bccc2d8({ preloadedFeatures: preloadedFeatures, createVisualElement: createVisualElement, useRender: useRender, useVisualState: useVisualState, Component: Component }) {
    var _a, _b;
    preloadedFeatures && (0, $8223c64d87d3460d$export$449561ec5703cdc8)(preloadedFeatures);
    function MotionComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d)),
            ...props,
            layoutId: $0c5a031ea8dd3973$var$useLayoutId(props)
        };
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $a6e92297d8c984af$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && (0, $0ec11121663cc82b$export$4e09c449d6c407f7)) {
            $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $0c5a031ea8dd3973$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $05aa2ab8e054331c$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $ih19M.jsxs)((0, $38e1c7c15d587098$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $ih19M.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                useRender(Component, props, (0, $29bcaad27b8bb245$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, context.visualElement)
            ]
        });
    }
    MotionComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_b = (_a = Component.displayName) !== null && _a !== void 0 ? _a : Component.name) !== null && _b !== void 0 ? _b : ""})`}`;
    const ForwardRefMotionComponent = (0, $bh6RR.forwardRef)(MotionComponent);
    ForwardRefMotionComponent[0, $92847778545e8ed0$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $0c5a031ea8dd3973$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $0c5a031ea8dd3973$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $bh6RR.useContext)((0, $6a5cdc65c5393968$export$40f10139ecf1f171)).strict;
}
function $0c5a031ea8dd3973$var$getProjectionFunctionality(props) {
    const { drag: drag, layout: layout } = (0, $145d8d26c6dc52b8$export$65570e08d843624d);
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $c47a60ce42aa9a7c$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $f9a5862a9160f78d$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $c47a60ce42aa9a7c$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}




var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $9237e2773f81c3d0$export$fe4300aa8eebea86(init) {
    const ref = (0, $bh6RR.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}



function $e82a2bc47b563e2e$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState, onUpdate: onUpdate }, props, context, presenceContext) {
    const state = {
        latestValues: $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    if (onUpdate) {
        /**
         * onMount works without the VisualElement because it could be
         * called before the VisualElement payload has been hydrated.
         * (e.g. if someone is using m components <m.circle />)
         */ state.onMount = (instance)=>onUpdate({
                props: props,
                current: instance,
                ...state
            });
        state.onUpdate = (visualElement)=>onUpdate(visualElement);
    }
    return state;
}
const $e82a2bc47b563e2e$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $bh6RR.useContext)((0, $38e1c7c15d587098$export$2285bbca2c666415));
        const presenceContext = (0, $bh6RR.useContext)((0, $12e60920c2394b39$export$f224e4635b6f8ce2));
        const make = ()=>$e82a2bc47b563e2e$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(make);
    };
function $e82a2bc47b563e2e$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $9e7923b7600c25b9$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $6c424f3bd35daf15$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}




/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $40c56554da907737$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};






const $6330a89fb7e6648e$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $6330a89fb7e6648e$var$numTransforms = (0, $a910d77444956bd4$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $6330a89fb7e6648e$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $6330a89fb7e6648e$var$numTransforms; i++){
        const key = (0, $a910d77444956bd4$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else valueIsDefault = parseFloat(value) === 0;
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $40c56554da907737$export$453ef540a9a1bd6b)(value, (0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $6330a89fb7e6648e$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}



function $5a314cc097974a58$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $9223341d00255d67$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $40c56554da907737$export$453ef540a9a1bd6b)(value, (0, $e26e0ac69c88d1e3$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $6330a89fb7e6648e$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}



const $3fd910e6a82125ad$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $3fd910e6a82125ad$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 */ function $3fd910e6a82125ad$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $3fd910e6a82125ad$var$dashKeys : $3fd910e6a82125ad$var$camelKeys;
    // Build the dash offset
    attrs[keys.offset] = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(-offset);
    // Build the dash array
    const pathLength = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(length);
    const pathSpacing = (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(spacing);
    attrs[keys.array] = `${pathLength} ${pathSpacing}`;
}



function $72f78baea8d3959f$var$calcOrigin(origin, offset, size) {
    return typeof origin === "string" ? origin : (0, $ee89500f7aaa2f56$export$91c0eda1d06bf008).transform(offset + size * origin);
}
/**
 * The SVG transform origin defaults are different to CSS and is less intuitive,
 * so we use the measured dimensions of the SVG to reconcile these.
 */ function $72f78baea8d3959f$export$d4fbcfc8e5472155(dimensions, originX, originY) {
    const pxOriginX = $72f78baea8d3959f$var$calcOrigin(originX, dimensions.x, dimensions.width);
    const pxOriginY = $72f78baea8d3959f$var$calcOrigin(originY, dimensions.y, dimensions.height);
    return `${pxOriginX} ${pxOriginY}`;
}


/**
 * Build SVG visual attrbutes, like cx and style.transform
 */ function $6f8e2d5207755192$export$5475d24f125d7053(state, { attrX: attrX, attrY: attrY, attrScale: attrScale, originX: originX, originY: originY, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate) {
    (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style, dimensions: dimensions } = state;
    /**
     * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
     * and copy it into style.
     */ if (attrs.transform) {
        if (dimensions) style.transform = attrs.transform;
        delete attrs.transform;
    }
    // Parse transformOrigin
    if (dimensions && (originX !== undefined || originY !== undefined || style.transform)) style.transformOrigin = (0, $72f78baea8d3959f$export$d4fbcfc8e5472155)(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $3fd910e6a82125ad$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


const $44dd7fb05ec6c3e6$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


const $a6f7f4461a184c55$export$41be8b43e1c4d4f9 = ()=>({
        ...(0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)(),
        attrs: {}
    });


const $5c8095c47c03f29b$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";



function $46b26a876b49a8ee$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    Object.assign(element.style, style, projection && projection.getProjectionStyles(styleProp));
    // Loop over any CSS variables and assign those.
    for(const key in vars)element.style.setProperty(key, vars[key]);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $896574d8c8ac028d$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


function $50c74351dd8901bc$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $46b26a876b49a8ee$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}






function $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $93233d74f0d10a65$export$91ddd985b97788d1)[key] || key === "opacity");
}



function $c0a33d9fc770b07f$export$16da615486abaa45(props, prevProps, visualElement) {
    var _a;
    const { style: style } = props;
    const newValues = {};
    for(const key in style)if ((0, $d449570363f09a53$export$605d60a2578142d3)(style[key]) || prevProps.style && (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps.style[key]) || (0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props) || ((_a = visualElement === null || visualElement === void 0 ? void 0 : visualElement.getValue(key)) === null || _a === void 0 ? void 0 : _a.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}


function $4c234d289d8baf9a$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $d449570363f09a53$export$605d60a2578142d3)(props[key]) || (0, $d449570363f09a53$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $a910d77444956bd4$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


function $ecbb32c06e7c035d$var$updateSVGDimensions(instance, renderState) {
    try {
        renderState.dimensions = typeof instance.getBBox === "function" ? instance.getBBox() : instance.getBoundingClientRect();
    } catch (e) {
        // Most likely trying to measure an unrendered element under Firefox
        renderState.dimensions = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
}
const $ecbb32c06e7c035d$var$layoutProps = [
    "x",
    "y",
    "width",
    "height",
    "cx",
    "cy",
    "r"
];
const $ecbb32c06e7c035d$export$44dabd3fae512e85 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: (0, $4c234d289d8baf9a$export$16da615486abaa45),
        createRenderState: (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9),
        onUpdate: ({ props: props, prevProps: prevProps, current: current, renderState: renderState, latestValues: latestValues })=>{
            if (!current) return;
            let hasTransform = !!props.drag;
            if (!hasTransform) {
                for(const key in latestValues)if ((0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key)) {
                    hasTransform = true;
                    break;
                }
            }
            if (!hasTransform) return;
            let needsMeasure = !prevProps;
            if (prevProps) /**
                 * Check the layout props for changes, if any are found we need to
                 * measure the element again.
                 */ for(let i = 0; i < $ecbb32c06e7c035d$var$layoutProps.length; i++){
                const key = $ecbb32c06e7c035d$var$layoutProps[i];
                if (props[key] !== prevProps[key]) needsMeasure = true;
            }
            if (!needsMeasure) return;
            (0, $6491bdd13544fdda$export$2cef06c20297c17d).read(()=>{
                $ecbb32c06e7c035d$var$updateSVGDimensions(current, renderState);
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).render(()=>{
                    (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(current.tagName), props.transformTemplate);
                    (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(current, renderState);
                });
            });
        }
    })
};





const $cb524d462e20deb3$export$e13ea21d87ea57c8 = {
    useVisualState: (0, $e82a2bc47b563e2e$export$e91e107bc6d03a8e)({
        scrapeMotionValuesFromProps: $c0a33d9fc770b07f$export$16da615486abaa45,
        createRenderState: (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)
    })
};



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");




function $1988bd02b7e1d29b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $d449570363f09a53$export$605d60a2578142d3)(source[key]) && !(0, $3ba7f2184a7a36c2$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $1988bd02b7e1d29b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $bh6RR.useMemo)(()=>{
        const state = (0, $44dd7fb05ec6c3e6$export$8940b483cf52eeda)();
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $1988bd02b7e1d29b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $1988bd02b7e1d29b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $1988bd02b7e1d29b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $1988bd02b7e1d29b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $1988bd02b7e1d29b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}


/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $a022688aad5e3d50$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $a022688aad5e3d50$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $a022688aad5e3d50$var$validMotionProps.has(key);
}


let $2d7757648940a601$var$shouldForward = (key)=>!(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key);
function $2d7757648940a601$export$59d6962c470509a5(isValidProp) {
    if (!isValidProp) return;
    // Explicitly filter our events
    $2d7757648940a601$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) : isValidProp(key);
}

/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     */ $2d7757648940a601$export$59d6962c470509a5($2d7757648940a601$import$c6bce8c37c642938$2e2bcd8739ae039);
} catch (_a) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $2d7757648940a601$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ($2d7757648940a601$var$shouldForward(key) || forwardMotionProps === true && (0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || !isDom && !(0, $a022688aad5e3d50$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}




var $bh6RR = parcelRequire("bh6RR");




function $f708387b704893ba$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $bh6RR.useMemo)(()=>{
        const state = (0, $a6f7f4461a184c55$export$41be8b43e1c4d4f9)();
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(state, visualState, (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(Component), props.transformTemplate);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $1988bd02b7e1d29b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}



function $890426a95a69aae0$export$5d29104eefd89cc8(forwardMotionProps = false) {
    const useRender = (Component, props, ref, { latestValues: latestValues }, isStatic)=>{
        const useVisualProps = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $f708387b704893ba$export$84309c4f53cb1bd5) : (0, $1988bd02b7e1d29b$export$57be0a314572d87d);
        const visualProps = useVisualProps(props, latestValues, isStatic, Component);
        const filteredProps = (0, $2d7757648940a601$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
        const elementProps = Component !== (0, $bh6RR.Fragment) ? {
            ...filteredProps,
            ...visualProps,
            ref: ref
        } : {};
        /**
         * If component has been handed a motion value as its child,
         * memoise its initial value and render that. Subsequent updates
         * will be handled by the onChange handler
         */ const { children: children } = props;
        const renderedChildren = (0, $bh6RR.useMemo)(()=>(0, $d449570363f09a53$export$605d60a2578142d3)(children) ? children.get() : children, [
            children
        ]);
        return (0, $bh6RR.createElement)(Component, {
            ...elementProps,
            children: renderedChildren
        });
    };
    return useRender;
}


function $047ad38a006b91b1$export$d86feac869a7f0d5(preloadedFeatures, createVisualElement) {
    return function createMotionComponent(Component, { forwardMotionProps: forwardMotionProps } = {
        forwardMotionProps: false
    }) {
        const baseConfig = (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? (0, $ecbb32c06e7c035d$export$44dabd3fae512e85) : (0, $cb524d462e20deb3$export$e13ea21d87ea57c8);
        const config = {
            ...baseConfig,
            preloadedFeatures: preloadedFeatures,
            useRender: (0, $890426a95a69aae0$export$5d29104eefd89cc8)(forwardMotionProps),
            createVisualElement: createVisualElement,
            Component: Component
        };
        return (0, $0c5a031ea8dd3973$export$c3ad4a902bccc2d8)(config);
    };
}



var $bh6RR = parcelRequire("bh6RR");







// Does this device prefer reduced motion? Returns `null` server-side.
const $16faa30fcf534207$export$ff7706047246b98b = {
    current: null
};
const $16faa30fcf534207$export$6476d16e2fd2d0db = {
    current: false
};


function $8c52f85ab085b323$export$ca9f41fb23dded3d() {
    (0, $16faa30fcf534207$export$6476d16e2fd2d0db).current = true;
    if (!(0, $0ec11121663cc82b$export$4e09c449d6c407f7)) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $16faa30fcf534207$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addListener(setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $16faa30fcf534207$export$ff7706047246b98b).current = false;
}













/**
 * A list of all ValueTypes
 */ const $3f77fa41782f639b$var$valueTypes = [
    ...(0, $d03d4f627f09ffbd$export$d176691c1998a1f5),
    (0, $7a26ed3125820d32$export$35e9368ef982300f),
    (0, $a554c66132092e1c$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $3f77fa41782f639b$export$950e7e59ea1ffed7 = (v)=>$3f77fa41782f639b$var$valueTypes.find((0, $bce78752b9f7f913$export$6eae4d0a6a7ca7cd)(v));



const $7680e86648d809f1$export$bc2a978a17abfdde = new WeakMap();







function $c1ce9b34358097f3$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $d449570363f09a53$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $925342fde4532b85$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}




const $59dc28bcfaa62e03$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $59dc28bcfaa62e03$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $8a643b2da1c7bc40$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $05b982fb85a2786e$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $6491bdd13544fdda$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState, onUpdate: onUpdate } = visualState;
        this.onUpdate = onUpdate;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $a01dc07902ba23d1$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $a01dc07902ba23d1$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange: willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $d449570363f09a53$export$605d60a2578142d3)(value)) value.set(latestValues[key], false);
        }
    }
    mount(instance) {
        this.current = instance;
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        if (!(0, $16faa30fcf534207$export$6476d16e2fd2d0db).current) (0, $8c52f85ab085b323$export$ca9f41fb23dded3d)();
        this.shouldReduceMotion = this.reducedMotionConfig === "never" ? false : this.reducedMotionConfig === "always" ? true : (0, $16faa30fcf534207$export$ff7706047246b98b).current;
        if (this.parent) this.parent.children.add(this);
        this.update(this.props, this.presenceContext);
    }
    unmount() {
        (0, $7680e86648d809f1$export$bc2a978a17abfdde).delete(this.current);
        this.projection && this.projection.unmount();
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent && this.parent.children.delete(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        const valueIsTransform = (0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key);
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
        });
        const removeOnRenderRequest = value.on("renderRequest", this.scheduleRender);
        let removeSyncCheck;
        if (window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            removeOnRenderRequest();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in 0, $145d8d26c6dc52b8$export$65570e08d843624d){
            const featureDefinition = (0, $145d8d26c6dc52b8$export$65570e08d843624d)[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $93b39ae61dedc877$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $59dc28bcfaa62e03$var$propEventHandlers.length; i++){
            const key = $59dc28bcfaa62e03$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $c1ce9b34358097f3$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
        this.onUpdate && this.onUpdate(this);
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $925342fde4532b85$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _a;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_a = this.getBaseTargetFromProps(this.props, key)) !== null && _a !== void 0 ? _a : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $307e1e0a636b2ddb$export$65583ed5a868f2d9)(value) || (0, $e46637106d3b5fd8$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $3f77fa41782f639b$export$950e7e59ea1ffed7)(value) && (0, $a554c66132092e1c$export$83a0e34f1302825b).test(target)) value = (0, $1838583c06c42261$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        var _a;
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, $960c679efe64d12b$export$d68f140c4d9b48bc)(this.props, initial, (_a = this.presenceContext) === null || _a === void 0 ? void 0 : _a.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $d449570363f09a53$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $fe92d8ac7a8c9e00$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
}




class $f82c67e8782ea4e3$export$e49735c2a366bdc7 extends (0, $59dc28bcfaa62e03$export$fa8b653c0f3714e5) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $c8b2f05e40a653fe$export$4983792d11b61017);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        return props.style ? props.style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $d449570363f09a53$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}








function $c22d56f4f698c1a8$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $c22d56f4f698c1a8$export$23fea75b03ac16b3 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $46b26a876b49a8ee$export$1a32bf6229c258c0);
    }
    readValueFromInstance(instance, key) {
        if ((0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        } else {
            const computedStyle = $c22d56f4f698c1a8$export$3735103072e4a80(instance);
            const value = ((0, $9223341d00255d67$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $0b2600dd2e3d7275$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $5a314cc097974a58$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $c0a33d9fc770b07f$export$16da615486abaa45)(props, prevProps, visualElement);
    }
}












class $86a41d187babab09$export$86bcdffbaf733d84 extends (0, $f82c67e8782ea4e3$export$e49735c2a366bdc7) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $93b39ae61dedc877$export$6459fc9e86be362e);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $a910d77444956bd4$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $5244b39289cc5c6d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $896574d8c8ac028d$export$28931db5d57958e5).has(key) ? (0, $002b84d235cc9e7f$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $4c234d289d8baf9a$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $6f8e2d5207755192$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $50c74351dd8901bc$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $5c8095c47c03f29b$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
}



const $584c8429f63c1575$export$56ba0183203348f5 = (Component, options)=>{
    return (0, $f9a5862a9160f78d$export$88f3fc2fd3766989)(Component) ? new (0, $86a41d187babab09$export$86bcdffbaf733d84)(options) : new (0, $c22d56f4f698c1a8$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $bh6RR.Fragment)
    });
};


const $ec34781bd544d1a0$export$46b7e4b9dc6110c3 = /*@__PURE__*/ (0, $047ad38a006b91b1$export$d86feac869a7f0d5)({
    ...(0, $61912b83da9ce72c$export$7f9953c70dacfd7f),
    ...(0, $aadd72d7ca06bd3a$export$e5b72898e5a201f1),
    ...(0, $5e0aeefdd70dc82e$export$d7d5d435647ed5a0),
    ...(0, $17a320fc4896a503$export$b3219800bda33a1f)
}, (0, $584c8429f63c1575$export$56ba0183203348f5));


const $08c9f1bffbd2aec7$export$e25e478948902b8b = /*@__PURE__*/ (0, $118ccf88bcfc51b9$export$3af29c0efb268f04)((0, $ec34781bd544d1a0$export$46b7e4b9dc6110c3));





function $f8ef3b3add304d76$export$bdf3520827dcd47e(order, value, offset, velocity) {
    if (!velocity) return order;
    const index = order.findIndex((item)=>item.value === value);
    if (index === -1) return order;
    const nextOffset = velocity > 0 ? 1 : -1;
    const nextItem = order[index + nextOffset];
    if (!nextItem) return order;
    const item = order[index];
    const nextLayout = nextItem.layout;
    const nextItemCenter = (0, $87248eb8ba080f28$export$3bb0b4ff1037b8dd)(nextLayout.min, nextLayout.max, 0.5);
    if (nextOffset === 1 && item.layout.max + offset > nextItemCenter || nextOffset === -1 && item.layout.min + offset < nextItemCenter) return (0, $13ad1cfa8b4681b0$export$ec937e64de6c1257)(order, index, index + nextOffset);
    return order;
}


"use client";
function $ea2890a6f84b6f68$export$abfa6c50086175ee({ children: children, as: as = "ul", axis: axis = "y", onReorder: onReorder, values: values, ...props }, externalRef) {
    const Component = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(()=>(0, $08c9f1bffbd2aec7$export$e25e478948902b8b)[as]);
    const order = [];
    const isReordering = (0, $bh6RR.useRef)(false);
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(Boolean(values), "Reorder.Group must be provided a values prop");
    const context = {
        axis: axis,
        registerItem: (value, layout)=>{
            // If the entry was already added, update it rather than adding it again
            const idx = order.findIndex((entry)=>value === entry.value);
            if (idx !== -1) order[idx].layout = layout[axis];
            else order.push({
                value: value,
                layout: layout[axis]
            });
            order.sort($ea2890a6f84b6f68$var$compareMin);
        },
        updateOrder: (item, offset, velocity)=>{
            if (isReordering.current) return;
            const newOrder = (0, $f8ef3b3add304d76$export$bdf3520827dcd47e)(order, item, offset, velocity);
            if (order !== newOrder) {
                isReordering.current = true;
                onReorder(newOrder.map($ea2890a6f84b6f68$var$getValue).filter((value)=>values.indexOf(value) !== -1));
            }
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        isReordering.current = false;
    });
    return (0, $ih19M.jsx)(Component, {
        ...props,
        ref: externalRef,
        ignoreStrict: true,
        children: (0, $ih19M.jsx)((0, $19dd5dd6b7ca2184$export$2b8a1fb072f61d10).Provider, {
            value: context,
            children: children
        })
    });
}
const $ea2890a6f84b6f68$export$be27b7672e0f20ab = /*@__PURE__*/ (0, $bh6RR.forwardRef)($ea2890a6f84b6f68$export$abfa6c50086175ee);
function $ea2890a6f84b6f68$var$getValue(item) {
    return item.value;
}
function $ea2890a6f84b6f68$var$compareMin(a, b) {
    return a.layout.min - b.layout.min;
}



var $ih19M = parcelRequire("ih19M");


var $bh6RR = parcelRequire("bh6RR");




var $bh6RR = parcelRequire("bh6RR");



/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */ function $d8dc30821f939484$export$15b697acf84c78b9(initial) {
    const value = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(()=>(0, $925342fde4532b85$export$ce8bdc721e76545f)(initial));
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */ const { isStatic: isStatic } = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d));
    if (isStatic) {
        const [, setLatest] = (0, $bh6RR.useState)(initial);
        (0, $bh6RR.useEffect)(()=>value.on("change", setLatest), []);
    }
    return value;
}



const $81a4718e79f38ff9$var$isCustomValueType = (v)=>{
    return v && typeof v === "object" && v.mix;
};
const $81a4718e79f38ff9$var$getMixer = (v)=>$81a4718e79f38ff9$var$isCustomValueType(v) ? v.mix : undefined;
function $81a4718e79f38ff9$export$51186ad6e864892a(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, $db1b2cb99cb3914e$export$89e29e4ab65e70a9)(inputRange, outputRange, {
        mixer: $81a4718e79f38ff9$var$getMixer(outputRange[0]),
        ...options
    });
    return useImmediate ? interpolator(inputValue) : interpolator;
}





function $66c890166c81c6eb$export$7dee4fa9fc2b33f3(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */ const value = (0, $d8dc30821f939484$export$15b697acf84c78b9)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */ const updateValue = ()=>value.set(combineValues());
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */ updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */ (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        const scheduleUpdate = ()=>(0, $6491bdd13544fdda$export$2cef06c20297c17d).preRender(updateValue, false, true);
        const subscriptions = values.map((v)=>v.on("change", scheduleUpdate));
        return ()=>{
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            (0, $6491bdd13544fdda$export$ec99c0ef4978dccb)(updateValue);
        };
    });
    return value;
}





function $0b9a78fde85b3a0c$export$e3d20747ab930783(compute) {
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * will be saved into this array.
     */ (0, $925342fde4532b85$export$67fcd818a264039d).current = [];
    compute();
    const value = (0, $66c890166c81c6eb$export$7dee4fa9fc2b33f3)((0, $925342fde4532b85$export$67fcd818a264039d).current, compute);
    /**
     * Synchronously close session of collectMotionValues.
     */ (0, $925342fde4532b85$export$67fcd818a264039d).current = undefined;
    return value;
}


function $fc251da38bd5792d$export$a87ba948fb2b39ec(input, inputRangeOrTransformer, outputRange, options) {
    if (typeof input === "function") return (0, $0b9a78fde85b3a0c$export$e3d20747ab930783)(input);
    const transformer = typeof inputRangeOrTransformer === "function" ? inputRangeOrTransformer : (0, $81a4718e79f38ff9$export$51186ad6e864892a)(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input) ? $fc251da38bd5792d$var$useListTransform(input, transformer) : $fc251da38bd5792d$var$useListTransform([
        input
    ], ([latest])=>transformer(latest));
}
function $fc251da38bd5792d$var$useListTransform(values, transformer) {
    const latest = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(()=>[]);
    return (0, $66c890166c81c6eb$export$7dee4fa9fc2b33f3)(values, ()=>{
        latest.length = 0;
        const numValues = values.length;
        for(let i = 0; i < numValues; i++)latest[i] = values[i].get();
        return transformer(latest);
    });
}



"use client";
function $f0e1e7092c24a168$var$useDefaultMotionValue(value, defaultValue = 0) {
    return (0, $d449570363f09a53$export$605d60a2578142d3)(value) ? value : (0, $d8dc30821f939484$export$15b697acf84c78b9)(defaultValue);
}
function $f0e1e7092c24a168$export$448c382d6053ed2c({ children: children, style: style = {}, value: value, as: as = "li", onDrag: onDrag, layout: layout = true, ...props }, externalRef) {
    const Component = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(()=>(0, $08c9f1bffbd2aec7$export$e25e478948902b8b)[as]);
    const context = (0, $bh6RR.useContext)((0, $19dd5dd6b7ca2184$export$2b8a1fb072f61d10));
    const point = {
        x: $f0e1e7092c24a168$var$useDefaultMotionValue(style.x),
        y: $f0e1e7092c24a168$var$useDefaultMotionValue(style.y)
    };
    const zIndex = (0, $fc251da38bd5792d$export$a87ba948fb2b39ec)([
        point.x,
        point.y
    ], ([latestX, latestY])=>latestX || latestY ? 1 : "unset");
    (0, $af7e1b70fef19820$export$f5708dca728d7177)(Boolean(context), "Reorder.Item must be a child of Reorder.Group");
    const { axis: axis, registerItem: registerItem, updateOrder: updateOrder } = context;
    return (0, $ih19M.jsx)(Component, {
        drag: axis,
        ...props,
        dragSnapToOrigin: true,
        style: {
            ...style,
            x: point.x,
            y: point.y,
            zIndex: zIndex
        },
        layout: layout,
        onDrag: (event, gesturePoint)=>{
            const { velocity: velocity } = gesturePoint;
            velocity[axis] && updateOrder(value, point[axis].get(), velocity[axis]);
            onDrag && onDrag(event, gesturePoint);
        },
        onLayoutMeasure: (measured)=>registerItem(value, measured),
        ref: externalRef,
        ignoreStrict: true,
        children: children
    });
}
const $f0e1e7092c24a168$export$dfd959aaaf2d771a = /*@__PURE__*/ (0, $bh6RR.forwardRef)($f0e1e7092c24a168$export$448c382d6053ed2c);







var $ih19M = parcelRequire("ih19M");

/**
 * Can manually trigger a drag gesture on one or more `drag`-enabled `motion` components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */ class $03f1c3c2dc0fe1d4$export$350d0cf1f91b53f4 {
    constructor(){
        this.componentControls = new Set();
    }
    /**
     * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
     *
     * @internal
     */ subscribe(controls) {
        this.componentControls.add(controls);
        return ()=>this.componentControls.delete(controls);
    }
    /**
     * Start a drag gesture on every `motion` component that has this set of drag controls
     * passed into it via the `dragControls` prop.
     *
     * ```jsx
     * dragControls.start(e, {
     *   snapToCursor: true
     * })
     * ```
     *
     * @param event - PointerEvent
     * @param options - Options
     *
     * @public
     */ start(event, options) {
        this.componentControls.forEach((controls)=>{
            controls.start(event.nativeEvent || event, options);
        });
    }
}
const $03f1c3c2dc0fe1d4$var$createDragControls = ()=>new $03f1c3c2dc0fe1d4$export$350d0cf1f91b53f4();
/**
 * Usually, dragging is initiated by pressing down on a `motion` component with a `drag` prop
 * and moving it. For some use-cases, for instance clicking at an arbitrary point on a video scrubber, we
 * might want to initiate that dragging from a different component than the draggable one.
 *
 * By creating a `dragControls` using the `useDragControls` hook, we can pass this into
 * the draggable component's `dragControls` prop. It exposes a `start` method
 * that can start dragging from pointer events on other components.
 *
 * ```jsx
 * const dragControls = useDragControls()
 *
 * function startDrag(event) {
 *   dragControls.start(event, { snapToCursor: true })
 * }
 *
 * return (
 *   <>
 *     <div onPointerDown={startDrag} />
 *     <motion.div drag="x" dragControls={dragControls} />
 *   </>
 * )
 * ```
 *
 * @public
 */ function $03f1c3c2dc0fe1d4$export$425dee5eb7bfc616() {
    return (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)($03f1c3c2dc0fe1d4$var$createDragControls);
}



var $7d240f1d896b67d1$exports = {};

$parcel$export($7d240f1d896b67d1$exports, "dragHandle", function () { return $7d240f1d896b67d1$export$2659f07e2f1eee65; }, function (v) { return $7d240f1d896b67d1$export$2659f07e2f1eee65 = v; });
$parcel$export($7d240f1d896b67d1$exports, "dragging", function () { return $7d240f1d896b67d1$export$8e6c816465ea7419; }, function (v) { return $7d240f1d896b67d1$export$8e6c816465ea7419 = v; });
$parcel$export($7d240f1d896b67d1$exports, "enabled", function () { return $7d240f1d896b67d1$export$25eaa035e2e3a214; }, function (v) { return $7d240f1d896b67d1$export$25eaa035e2e3a214 = v; });
$parcel$export($7d240f1d896b67d1$exports, "field", function () { return $7d240f1d896b67d1$export$e0f35d825088c098; }, function (v) { return $7d240f1d896b67d1$export$e0f35d825088c098 = v; });
$parcel$export($7d240f1d896b67d1$exports, "removeBackground", function () { return $7d240f1d896b67d1$export$bcbafd0c688e5b8d; }, function (v) { return $7d240f1d896b67d1$export$bcbafd0c688e5b8d = v; });
$parcel$export($7d240f1d896b67d1$exports, "removeButton", function () { return $7d240f1d896b67d1$export$8d776830dbcce823; }, function (v) { return $7d240f1d896b67d1$export$8d776830dbcce823 = v; });
$parcel$export($7d240f1d896b67d1$exports, "row", function () { return $7d240f1d896b67d1$export$120ff0929b202a6d; }, function (v) { return $7d240f1d896b67d1$export$120ff0929b202a6d = v; });
var $7d240f1d896b67d1$export$2659f07e2f1eee65;
var $7d240f1d896b67d1$export$8e6c816465ea7419;
var $7d240f1d896b67d1$export$25eaa035e2e3a214;
var $7d240f1d896b67d1$export$e0f35d825088c098;
var $7d240f1d896b67d1$export$bcbafd0c688e5b8d;
var $7d240f1d896b67d1$export$8d776830dbcce823;
var $7d240f1d896b67d1$export$120ff0929b202a6d;
$7d240f1d896b67d1$export$2659f07e2f1eee65 = `_1knIFq_dragHandle`;
$7d240f1d896b67d1$export$8e6c816465ea7419 = `_1knIFq_dragging`;
$7d240f1d896b67d1$export$25eaa035e2e3a214 = `_1knIFq_enabled`;
$7d240f1d896b67d1$export$e0f35d825088c098 = `_1knIFq_field`;
$7d240f1d896b67d1$export$bcbafd0c688e5b8d = `_1knIFq_removeBackground`;
$7d240f1d896b67d1$export$8d776830dbcce823 = `_1knIFq_removeButton`;
$7d240f1d896b67d1$export$120ff0929b202a6d = `_1knIFq_row`;



const $8a289e9e0a6f1c97$var$cxs = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($7d240f1d896b67d1$exports);
const $8a289e9e0a6f1c97$var$handleDragStart = (e, handleItemDragStart)=>{
    //const el = e.target.closest('.' + styles.row)
    //if (el) el.classList.add(styles.dragging)
    if (handleItemDragStart) handleItemDragStart(e);
};
const $8a289e9e0a6f1c97$var$handleDragEnd = (e, handleItemDragEnd)=>{
    //const el = e.target.closest('.' + styles.row)
    //if (el) el.classList.remove(styles.dragging)
    if (handleItemDragEnd) handleItemDragEnd(e);
// setDraggable(false)
// updateValues(fields)
};
/*
onMouseEnter={() => setDraggable(true)}
          onMouseLeave={() => setDraggable(false)} // retain this for better animation
          onTouchStart={() => setDraggable(true)} // for mobile: need to set draggable to `false` in `onDragEnd` prop, not `onTouchEnd`
 onDragStart={(e) => handleDragStart(e, handleItemDragStart)}
      onDragEnd={(e) => handleDragEnd(e, handleItemDragEnd)}
          dragConstraints={ref}
          */ /*
onDragStart={handleDragStart}
      onDragEnd={handleDragEnd} 
onDragStart={(e) => handleDragStart(e, handleItemDragStart)}
      onDragEnd={(e) => handleDragEnd(e, handleItemDragEnd)}


      
*/ function $8a289e9e0a6f1c97$var$LocationItem({ item: item, dragConstraints: dragConstraints, isReorderEnabled: isReorderEnabled, reorderKey: reorderKey, handleItemDragStart: handleItemDragStart, handleItemDragEnd: handleItemDragEnd, handleRemove: handleRemove }) {
    const controls = (0, $03f1c3c2dc0fe1d4$export$425dee5eb7bfc616)();
    const index = item?.element?.props?.fieldIndex || 0;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $98ac0ca34222ada7$exports).Item, {
        value: item,
        dragConstraints: dragConstraints,
        dragListener: false,
        dragControls: controls,
        onDragEnd: (e)=>$8a289e9e0a6f1c97$var$handleDragEnd(e, handleItemDragEnd),
        initial: {
            opacity: 0,
            y: 0
        },
        animate: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0
            }
        },
        dragElastic: 0.05,
        className: $7d240f1d896b67d1$exports.row,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $7d240f1d896b67d1$exports.field,
                children: [
                    item.element,
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $8a289e9e0a6f1c97$var$cxs($7d240f1d896b67d1$exports.dragHandle, {
                            enabled: isReorderEnabled
                        }),
                        onPointerDown: (e)=>controls.start(e),
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                            id: "drag"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                onClick: ()=>{
                    handleRemove(index);
                },
                className: $7d240f1d896b67d1$exports.removeButton,
                tabIndex: "-1",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $7d240f1d896b67d1$exports.removeBackground,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                        id: "plus"
                    })
                })
            })
        ]
    }, reorderKey);
}
var $8a289e9e0a6f1c97$export$2e2bcd8739ae039 = $8a289e9e0a6f1c97$var$LocationItem;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");




var $5d7ef1a15deccfec$export$efe229eab43a9869;
var $5d7ef1a15deccfec$export$82e6205b15e6c637;
var $5d7ef1a15deccfec$export$c79cdbceb5e65039;
var $5d7ef1a15deccfec$export$5d32de6bea244def;
var $5d7ef1a15deccfec$export$8929e07d808734d0;
var $5d7ef1a15deccfec$export$28e0029c99b7d569;
var $5d7ef1a15deccfec$export$d1e6de57dc4d952e;
$5d7ef1a15deccfec$export$efe229eab43a9869 = `cp5VEW_closeButton`;
$5d7ef1a15deccfec$export$82e6205b15e6c637 = `cp5VEW_fadeIn`;
$5d7ef1a15deccfec$export$82e6205b15e6c637;
$5d7ef1a15deccfec$export$c79cdbceb5e65039 = `cp5VEW_warningBanner`;
$5d7ef1a15deccfec$export$5d32de6bea244def = `cp5VEW_warningContent`;
$5d7ef1a15deccfec$export$8929e07d808734d0 = `cp5VEW_warningIcon`;
$5d7ef1a15deccfec$export$28e0029c99b7d569 = `cp5VEW_warningSubtext`;
$5d7ef1a15deccfec$export$d1e6de57dc4d952e = `cp5VEW_warningText`;


const $bc55ceba36084ea6$var$WARNING_THRESHOLD_MS = 300000; // 5 minutes
function $bc55ceba36084ea6$var$formatTimeRemaining(ms) {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor(ms % 60000 / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
function $bc55ceba36084ea6$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const [timeRemaining, setTimeRemaining] = (0, $bh6RR.useState)(null);
    const [showWarning, setShowWarning] = (0, $bh6RR.useState)(false);
    const [hasExpired, setHasExpired] = (0, $bh6RR.useState)(false);
    const [isDismissed, setIsDismissed] = (0, $bh6RR.useState)(false);
    const validUntil = values.editableFieldsValidUntil;
    const handleExpiration = (0, $bh6RR.useCallback)(async ()=>{
        if (hasExpired) return; // Already handled
        // Set hasExpired immediately to prevent duplicate calls
        // (interval might call this multiple times before API responds)
        setHasExpired(true);
        try {
            // Fetch the updated editable fields from the API
            const bookingId = values.bookingId;
            if (!bookingId) {
                console.error('No booking ID available');
                return;
            }
            const editableData = await (0, $135a523c4bea715f$export$81ea9e0398c88adc)(bookingId);
            // Get the previous and new editable fields
            const previousEditableFields = values.editableFields || [];
            const newEditableFields = editableData.editableFields || [];
            // Check if no fields are editable anymore
            if (newEditableFields.length === 0) {
                // Define the reset function to exit edit mode
                const exitEditMode = ()=>{
                    // Use setTimeout to ensure any modal is fully closed before triggering events
                    setTimeout(()=>{
                        if (typeof APP !== 'undefined' && APP.trigger && APP.events) APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
                        else console.warn('APP or APP.events not available');
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_FORM');
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_MAP');
                    }, 50);
                };
                const message = `<strong>${t('edit-fields-no-changes-title')}</strong><br/><br/>${t('edit-fields-no-changes-message')}`;
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(message, exitEditMode);
                // Clear validUntil to stop the polling timer
                // This prevents the timer from triggering again
                setFieldValue('editableFieldsValidUntil', null, false);
                return;
            }
            // Find fields that were editable but are no longer editable
            const disabledFields = previousEditableFields.filter((field)=>!newEditableFields.includes(field));
            // Get the original booking data
            const originalBooking = values.booking;
            if (!originalBooking) {
                console.error('No original booking data available');
                return;
            }
            // Map of field paths to their original values
            const fieldMapping = {
                'traveler.name': originalBooking.traveler?.name || '',
                'traveler.phoneNumber': originalBooking.traveler?.phoneNumber || '',
                'generalComment': originalBooking.generalComment || '',
                'invoiceReference': originalBooking.invoiceReference || '',
                'originLocation.flightInfo.flightNumber': originalBooking.originLocation?.flightInfo?.flightNumber || '',
                'originLocation.flightInfo.checkedInBaggage': originalBooking.originLocation?.flightInfo?.checkedInBaggage || false,
                'pickUpTimeStamp': originalBooking.pickUpTimeStamp || ''
            };
            // Map of field paths to form field names
            const formFieldMapping = {
                'traveler.name': 'name',
                'traveler.phoneNumber': 'phone',
                'generalComment': 'generalComment',
                'invoiceReference': 'accountReference',
                'originLocation.flightInfo.flightNumber': 'flightNumber',
                'originLocation.flightInfo.checkedInBaggage': 'checkedInBaggage',
                'pickUpTimeStamp': 'pickupTime'
            };
            // Revert only the fields that were disabled and have been changed
            disabledFields.forEach((fieldPath)=>{
                if (fieldMapping[fieldPath] !== undefined) {
                    const formFieldName = formFieldMapping[fieldPath];
                    let originalValue = fieldMapping[fieldPath];
                    const currentValue = values[formFieldName];
                    // Convert pickUpTimeStamp string to Date object for pickupTime field
                    if (fieldPath === 'pickUpTimeStamp' && originalValue) originalValue = new Date(originalValue);
                    // For time fields, compare timestamps instead of direct equality
                    const valuesAreDifferent = fieldPath === 'pickUpTimeStamp' ? new Date(currentValue).getTime() !== new Date(originalValue).getTime() : currentValue !== originalValue;
                    if (valuesAreDifferent) setFieldValue(formFieldName, originalValue, false);
                }
            });
            // Update to the new editable fields list
            setFieldValue('editableFields', newEditableFields, false);
            // Update editable options (vehicle options, etc.) if provided
            if (editableData.editableOptions !== undefined) setFieldValue('editableOptions', editableData.editableOptions, false);
            // Update the new validUntil timestamp if provided
            if (editableData.validUntil) {
                setFieldValue('editableFieldsValidUntil', editableData.validUntil, false);
                // Reset hasExpired so the new timer can trigger
                setHasExpired(false);
            } else {
                // Clear validUntil to stop the timer
                setFieldValue('editableFieldsValidUntil', null, false);
                setHasExpired(true);
            }
        } catch (error) {
            console.error('Error fetching updated editable fields:', error);
        }
    }, [
        hasExpired,
        values,
        setFieldValue,
        t
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!validUntil) {
            setShowWarning(false);
            // Don't reset hasExpired here - if there's no validUntil, we should stay expired
            return;
        }
        // hasExpired is now managed in handleExpiration based on whether a new validUntil is received
        const checkExpiration = ()=>{
            const now = Date.now();
            const expirationTime = new Date(validUntil).getTime();
            const remaining = expirationTime - now;
            setTimeRemaining(remaining);
            if (remaining <= 0) {
                // Time has expired - fetch updated fields
                handleExpiration();
                setShowWarning(false);
            } else if (remaining <= $bc55ceba36084ea6$var$WARNING_THRESHOLD_MS) // Show warning
            setShowWarning(true);
            else // Not yet time to warn
            setShowWarning(false);
        };
        // Initial check
        checkExpiration();
        // Set up interval to check every second
        const interval = setInterval(checkExpiration, 1000);
        return ()=>clearInterval(interval);
    }, [
        validUntil,
        handleExpiration
    ]);
    if (!showWarning || timeRemaining === null || timeRemaining <= 0 || isDismissed) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $5d7ef1a15deccfec$export$c79cdbceb5e65039,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $5d7ef1a15deccfec$export$5d32de6bea244def,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $5d7ef1a15deccfec$export$d1e6de57dc4d952e,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                        children: t('edit-fields-expiration-warning', {
                            time: $bc55ceba36084ea6$var$formatTimeRemaining(timeRemaining)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    className: $5d7ef1a15deccfec$export$efe229eab43a9869,
                    onClick: ()=>setIsDismissed(true),
                    "aria-label": "Close warning",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: 2,
                            d: "M6 18L18 6M6 6l12 12"
                        })
                    })
                })
            ]
        })
    });
}


const $9f195eb774806913$var$MOBILE_LOCATION_OVERLAY = false;
const $9f195eb774806913$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $9f195eb774806913$var$cxs = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($ee8457ae4f41cf9c$exports);
const $9f195eb774806913$var$hasValue = (value)=>value !== '' && value !== '-' && value?.address !== undefined;
// Works out whether a destination is mandatory before the user can continue, using the
// loaded availability.direct response (the start page only fetches direct). A destination
// is needed when there are intermediate stops, when the trip rules say so, or when no
// usable price type exists for the current mode (e.g. taximeter is switched off so only
// fixed price remains, which cannot be priced without a destination).
// NOTE: gotoHow replicates the Yup destination.when check here because values.priceType
// may be stale from prebook when returning from SelectTime (the priceType effect doesn't
// re-fire on pickupTime change alone, only when values.availability changes).
const $9f195eb774806913$var$getDestinationRequirements = (values)=>{
    const directAvail = values.availability?.direct;
    const directLoaded = directAvail !== undefined && directAvail !== false;
    const directFixed = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const directPriceTypeStr = directFixed ? 'FIXED' : 'TAXIMETER';
    const directRawPriceTypes = directLoaded ? directAvail.priceAndPaymentRules?.priceTypes || [] : [];
    const directPriceType = directRawPriceTypes.map((0, $c94184dfef1a7d71$export$f1b9397fe7b6198c)).find((pt)=>pt.type === directPriceTypeStr) ?? false;
    const tripRules = directAvail?.tripRules ?? values.availability?.prebook?.tripRules;
    const hasStops = values.intermediateStopLocations?.length > 0;
    const noUsablePriceType = directLoaded && (directPriceType === false || directPriceType?.paymentMethods?.length === 0);
    const destinationMissing = !values.destination?.address;
    const directNeedsDestination = !!(hasStops || noUsablePriceType || tripRules?.directBookingRequiresDestination === true);
    const prebookNeedsDestination = !!(hasStops || noUsablePriceType || tripRules?.preBookingRequiresDestination === true);
    return {
        directPriceType: directPriceType,
        tripRules: tripRules,
        destinationMissing: destinationMissing,
        directNeedsDestination: directNeedsDestination,
        prebookNeedsDestination: prebookNeedsDestination,
        // Only trust the "missing" verdict once availability is loaded, otherwise the
        // buttons would flip state before we know anything about the trip
        directMissingDestination: directLoaded && directNeedsDestination && destinationMissing,
        prebookMissingDestination: directLoaded && prebookNeedsDestination && destinationMissing
    };
};
const $9f195eb774806913$var$SelectLocations = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const validateForm = (0, $30acdccbb47e8004$export$8bc71694d368e075)((0, $lW2XZ.useFormikContext)());
    const { values: values, setFieldValue: setFieldValue, errors: errors, setErrors: setErrors, setTouched: setTouched, validateForm: formikValidateForm } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = (0, $c94184dfef1a7d71$export$57957ca6633a6742)(values);
    const [isAdding, setIsAdding] = (0, $bh6RR.useState)(false);
    const maxAllowedIntermediateStops = (0, $c94184dfef1a7d71$export$8f69041b6eded98d)(values);
    const isAddEnabled = !isAdding && values.departure?.address && values.destination?.address && maxAllowedIntermediateStops > 0 && values.intermediateStopLocations?.length < maxAllowedIntermediateStops;
    const isReorderEnabled = true; /*
                                 values.departure?.address ||
                                 values.destination?.address ||
                                 values.intermediateStopLocations?.length > 0*/ 
    const noDirectBooking = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'NO_DIRECT_BOOK');
    // When the backend cannot offer any cars *because* a destination is missing (e.g. only
    // fixed price is available), keep the buttons clickable so the click surfaces the red
    // "Destination krävs" validation instead of a dead "Inga tillgängliga bilar" state.
    const { directMissingDestination: directMissingDestination, prebookMissingDestination: prebookMissingDestination } = $9f195eb774806913$var$getDestinationRequirements(values);
    const isDirectBookDisabled = (0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'direct') && !directMissingDestination ? !(0, $c94184dfef1a7d71$export$20098f5b816895fe)(values, 'direct') : false;
    const noAvailabilities = !(values?.availability?.direct?.availabilities?.length > 0 || values?.availability?.prebook?.availabilities?.length > 0);
    const isPreebookDisabled = noAvailabilities && !prebookMissingDestination;
    const [isLaterClicked, setIsLaterClicked] = (0, $bh6RR.useState)(false);
    const [isNextClicked, setIsNextClicked] = (0, $bh6RR.useState)(false);
    const gotoNextLocationField = (currentFieldIndex)=>{};
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('GOTO_NEXT_LOCATION_FIELD', gotoNextLocationField);
    const intervalRef = (0, $bh6RR.useRef)();
    const handleFocus = (event, location)=>{
        const el = event.target.closest('li');
        if (el) {
            const setZindex = ()=>{
                el.style.zIndex = 2;
            };
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(setZindex, 10);
            setZindex();
        }
        if (location?.address) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('ZOOM_LOCATION', location);
        // Disable cover widget
        APP.trigger(APP.events.BOOKING_MODULE_DISABLE_HIDE_MAP);
    };
    const handleBlur = ()=>{
        clearInterval(intervalRef.current);
    };
    // NOTE: Reorder.Group needs a key to to be able to sort the items
    const getFields = (fullscreen)=>{
        let fieldIndex = 0;
        // console.log("vals", values);
        return [
            {
                // data: values.departure,
                key: values?.departure?.key ? `reorder${values?.departure?.key}` : `reorder${fieldIndex}`,
                data: $9f195eb774806913$var$hasValue(values.departure) ? values.departure : {
                    key: 'departure'
                },
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                    name: "departure",
                    fieldIndex: fieldIndex,
                    placeholder: t('placeholder-origin-location'),
                    component: $9f195eb774806913$var$MOBILE_LOCATION_OVERLAY ? (0, $26a24512e4b2e050$export$2e2bcd8739ae039) : (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039),
                    fullscreen: fullscreen,
                    onFocus: (e)=>handleFocus(e, values.departure),
                    onBlur: handleBlur,
                    useLocation: true
                }, values?.departure?.key ? `field${values?.departure?.key}` : `field${fieldIndex}`)
            },
            ...values.intermediateStopLocations.map((location, index)=>{
                fieldIndex++;
                return {
                    // data: location,
                    key: location?.key ? `reorder${location?.key}` : `reorder${fieldIndex}`,
                    data: $9f195eb774806913$var$hasValue(location) ? location : {
                        key: `stop${index}`
                    },
                    element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: `intermediateStopLocations[${index}]`,
                        parentLocation: values?.intermediateStopLocations?.[index - 1] || values?.departure,
                        fieldIndex: fieldIndex,
                        placeholder: t('placeholder-add-stop'),
                        component: $9f195eb774806913$var$MOBILE_LOCATION_OVERLAY ? (0, $26a24512e4b2e050$export$2e2bcd8739ae039) : (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039),
                        fullscreen: fullscreen,
                        onFocus: (e)=>handleFocus(e, location),
                        onBlur: handleBlur
                    }, location?.key ? `field${location?.key}` : `field${fieldIndex}`)
                };
            }),
            {
                // data: values.destination,
                key: values?.destination?.key ? `reorder${values?.destination?.key}` : `reorder${fieldIndex + 1}`,
                data: $9f195eb774806913$var$hasValue(values.destination) ? values.destination : {
                    key: 'destination'
                },
                element: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                    name: "destination",
                    parentLocation: values?.intermediateStopLocations?.length > 0 ? values?.intermediateStopLocations[values?.intermediateStopLocations?.length - 1] : values?.departure,
                    fieldIndex: fieldIndex + 1,
                    placeholder: t('placeholder-destination-location'),
                    component: $9f195eb774806913$var$MOBILE_LOCATION_OVERLAY ? (0, $26a24512e4b2e050$export$2e2bcd8739ae039) : (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039),
                    fullscreen: fullscreen,
                    onFocus: (e)=>handleFocus(e, values.destination),
                    onBlur: handleBlur
                }, values?.destination?.key ? `field${values?.destination?.key}` : `field${fieldIndex + 1}`)
            }
        ];
    };
    const [fields, setFields] = (0, $bh6RR.useState)(getFields(fullscreen));
    const [draggable, setDraggable] = (0, $bh6RR.useState)(false);
    const ref = (0, $bh6RR.useRef)();
    const gotoTime = ()=>{
        if (values.availabilityIsLoading) {
            setIsLaterClicked(true);
            return;
        }
        formikValidateForm().then((freshErrors)=>{
            const { prebookMissingDestination: prebookMissingDestination } = $9f195eb774806913$var$getDestinationRequirements(values);
            const errorsToShow = {
                ...freshErrors
            };
            if (prebookMissingDestination) errorsToShow.destination = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required');
            const hasBlockingError = !!errorsToShow.departure || !!errorsToShow.destination || !!errorsToShow.intermediateStopLocations;
            if (hasBlockingError) {
                setErrors(errorsToShow);
                setTouched((0, $30acdccbb47e8004$export$36f48d5522f46534)(errorsToShow), false);
            } else next('time');
        });
    };
    const gotoHow = ()=>{
        if (values.availabilityIsLoading) {
            setIsNextClicked(true);
            return;
        }
        setFieldValue('pickupTime', '');
        // Clear flight details — only valid for prebook airport pickups
        setFieldValue('flightNumber', '', false);
        setFieldValue('checkedInBaggage', false, false);
        // Use cached errors directly — async re-validation can return clean due to
        // timing issues, so we apply the already-computed errors and touch them directly.
        if (Object.keys(errors).length > 0) {
            window.AUTO_FOCUS_FIELD = null;
            setErrors(errors);
            setTouched((0, $30acdccbb47e8004$export$36f48d5522f46534)(errors), false);
            return;
        }
        // Replicate the Yup destination.when check for DIRECT mode using availability.direct
        // (see getDestinationRequirements for why values.priceType can't be trusted here).
        const { directPriceType: directPriceType, directNeedsDestination: directNeedsDestination, tripRules: tripRules } = $9f195eb774806913$var$getDestinationRequirements(values);
        if (directNeedsDestination && !values.destination?.address) {
            const destError = {
                destination: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required')
            };
            window.AUTO_FOCUS_FIELD = null;
            setErrors(destError);
            setTouched({
                destination: true
            }, false);
            return;
        }
        if ((0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'direct') && (0, $c94184dfef1a7d71$export$20098f5b816895fe)(values, 'direct')) wrappedNext('how');
        else validateForm();
    };
    const buttons = [
        {
            func: gotoTime,
            title: t('button-go-later'),
            isPrimary: noDirectBooking || isDirectBookDisabled,
            disabled: isPreebookDisabled,
            isLoading: isLaterClicked && values.availabilityIsLoading
        },
        {
            func: gotoHow,
            title: isDirectBookDisabled ? t('button-no-available-cars') : t('button-go-now'),
            disabled: noDirectBooking || isDirectBookDisabled,
            isLoading: (isNextClicked || isDirectBookDisabled) && values.availabilityIsLoading
        }
    ];
    const showAddStop = ()=>{
        setIsAdding(true);
    };
    const handleAddLocation = (location)=>{
        // console.log("values", values);
        setFieldValue('intermediateStopLocations', [
            ...values.intermediateStopLocations,
            values.destination
        ]);
        setFieldValue('destination', location);
        setIsAdding(false);
        setTimeout(()=>validateForm(), 10);
    // setTimeout(() => {updateValues(fields)}, 1000);
    };
    const handleRemove = (index)=>{
        if (typeof index === 'number') {
            //fields[index].element.props.component.reset();
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CLEAR_LOCATION_SEARCH', fields[index]?.element?.props?.name);
            if (fields.length > 2) {
                const items = fields.filter((v, i)=>i !== index);
                setFields(items);
                updateValues(items);
            } else setFieldValue(index === 0 ? 'departure' : 'destination', undefined);
        }
    };
    const handleReorder = (items)=>{
        const allowFlightNumber = items[0]?.data?.locationInformation?.map((item)=>item.tag).includes('FLIGHT_NBR');
        if (!allowFlightNumber) {
            setFieldValue('flightNumber', '');
            setFieldValue('checkedInBaggage', undefined);
        }
        //setFieldValue('flightNumber', value.toUpperCase()); checkedInBaggage
        setFields(items);
    };
    const handleDragStart = (e)=>{
        const el = e.target.closest('.' + $ee8457ae4f41cf9c$exports.row);
        if (el) el.classList.add($ee8457ae4f41cf9c$exports.dragging);
    };
    const handleDragEnd = (e)=>{
        //const el = e.target.closest('.' + styles.row)
        //if (el) el.classList.remove(styles.dragging)
        //setDraggable(false)
        updateValues(fields);
    };
    const updateValues = (items)=>{
        // setFieldValue('departure', items[0]?.data || '')
        // setFieldValue('destination', items[items.length - 1]?.data || '')
        setFieldValue('departure', items[0]?.data?.address ? items[0].data : '');
        setFieldValue('destination', items[items.length - 1]?.data?.address ? items[items.length - 1].data : '');
        if (items.length > 2) {
            const stops = items.slice(1, -1).map((item)=>item?.data?.address ? item.data : '');
            setFieldValue('intermediateStopLocations', stops);
        } else setFieldValue('intermediateStopLocations', []);
        setTimeout(()=>validateForm(), 1);
    };
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        if (!values.availabilityIsLoading) {
            if (isNextClicked) {
                setIsNextClicked(false);
                const { directMissingDestination: directMissingDestination } = $9f195eb774806913$var$getDestinationRequirements(values);
                if (directMissingDestination) {
                    // The response says a destination is required - show that instead of validating
                    // against values.priceType, which may not have been updated by the Fetcher yet
                    window.AUTO_FOCUS_FIELD = null;
                    setErrors({
                        destination: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required')
                    });
                    setTouched({
                        destination: true
                    }, false);
                } else if ((0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'direct') && !isDirectBookDisabled) setTimeout(()=>{
                    wrappedNext('how');
                }, 500);
                else validateForm();
            } else if (isLaterClicked) {
                setIsLaterClicked(false);
                formikValidateForm().then((freshErrors)=>{
                    const { prebookMissingDestination: prebookMissingDestination } = $9f195eb774806913$var$getDestinationRequirements(values);
                    const errorsToShow = {
                        ...freshErrors
                    };
                    if (prebookMissingDestination) errorsToShow.destination = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required');
                    const hasBlockingError = !!errorsToShow.departure || !!errorsToShow.destination || !!errorsToShow.intermediateStopLocations;
                    if (hasBlockingError) {
                        setErrors(errorsToShow);
                        setTouched((0, $30acdccbb47e8004$export$36f48d5522f46534)(errorsToShow), false);
                    } else setTimeout(()=>{
                        next('time');
                    }, 500);
                });
            }
        }
    }, [
        values.availability,
        values.availabilityIsLoading
    ]);
    (0, $bh6RR.useEffect)(()=>{
        APP.trigger(APP.events.BOOKING_MODULE_ENABLE_HIDE_MAP);
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        setFields(getFields(fullscreen));
    }, [
        values.departure,
        values.destination,
        values.intermediateStopLocations
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $9f195eb774806913$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen,
            tabsLeft: true
        }),
        children: [
            fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                            onlyFullscreen: true,
                            children: inEditMode ? t('edit-your-trip') : t('your-trip')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                            onlyMobile: true,
                            children: t('header-where-do-you-want-to-go')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                            fullscreen: fullscreen,
                            showBothBookingTypes: true
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                            values: values,
                            currentView: currentView
                        })
                    ]
                })
            }),
            !fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                showBothBookingTypes: true
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9248d934b0a2f4d5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: fullscreen ? $f35967c56a9f3d99$exports.contentBottom : null,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bc55ceba36084ea6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                        noStyle: fullscreen,
                        children: [
                            fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                                onlyFullscreen: true,
                                children: t('header-where-do-you-want-to-go')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $98ac0ca34222ada7$exports).Group, {
                                axis: "y",
                                values: fields,
                                onReorder: handleReorder,
                                ref: ref,
                                className: $ee8457ae4f41cf9c$exports.locations,
                                children: fields.map((item, index)=>{
                                    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $8a289e9e0a6f1c97$export$2e2bcd8739ae039), {
                                        //handleItemDragStart={}
                                        previusItem: fields[index - 1] || null,
                                        handleRemove: handleRemove,
                                        handleItemDragEnd: handleDragEnd,
                                        reorderKey: item?.key || index,
                                        dragConstraints: ref,
                                        item: item,
                                        isReorderEnabled: isReorderEnabled
                                    }, item?.key || index);
                                })
                            }),
                            isAdding && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $ee8457ae4f41cf9c$exports.addLocationForm,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $ae610dbd0c463545$export$2e2bcd8739ae039), {
                                    parentLocation: values?.destination,
                                    region: values.region,
                                    onLocationSelected: handleAddLocation
                                })
                            }),
                            maxAllowedIntermediateStops > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                className: $ee8457ae4f41cf9c$exports.addLocationButton,
                                onClick: showAddStop,
                                disabled: !isAddEnabled,
                                tabIndex: "0",
                                children: t('button-add-stop')
                            }),
                            user === null && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $ee8457ae4f41cf9c$exports.text,
                                children: t('booking-login-info')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$5fe60eb48993b2d4$export$20be359f745f973c($e6d972962a22d393$export$185802fd694ee1f5, 'validStop', function(errorMessage) {
    return this.test('test-valid-stop', errorMessage, function(value) {
        const { path: path, createError: createError } = this;
        return value?.pointOfInterestType !== 'AIRPORT' || createError({
            path: path,
            message: errorMessage
        });
    });
});
$5fe60eb48993b2d4$export$20be359f745f973c($e6d972962a22d393$export$185802fd694ee1f5, 'validDepature', function(errorMessage) {
    return this.test('test-valid-depature', errorMessage, function(value) {
        const { path: path, createError: createError } = this;
        if (value?.bookable === false) return createError({
            path: path,
            message: errorMessage
        });
        return !value || value?.locationInformation?.filter((info)=>[
                'NO_PICKUP'
            ].includes(info?.tag)).length === 0 || createError({
            path: path,
            message: errorMessage
        });
    });
});
$5fe60eb48993b2d4$export$20be359f745f973c($e6d972962a22d393$export$185802fd694ee1f5, 'validDestination', function(errorMessage) {
    return this.test('test-valid-destination', errorMessage, function(value) {
        const { path: path, createError: createError } = this;
        if (value?.bookable === false) return createError({
            path: path,
            message: errorMessage
        });
        return !value || value?.locationInformation?.filter((info)=>[
                'NO_DROP_OFF'
            ].includes(info?.tag)).length === 0 || createError({
            path: path,
            message: errorMessage
        });
    });
});
$5fe60eb48993b2d4$export$20be359f745f973c($e6d972962a22d393$export$185802fd694ee1f5, 'validIntermediate', function(errorMessage) {
    return this.test('test-valid-intermediate', errorMessage, function(value) {
        const { path: path, createError: createError } = this;
        if (value?.bookable === false) return createError({
            path: path,
            message: errorMessage
        });
        return value?.locationInformation?.filter((info)=>[
                'NO_INTERMEDIATE_STOP',
                'NO_DROP_OFF',
                'NO_PICKUP'
            ].includes(info?.tag)).length === 0 || createError({
            path: path,
            message: errorMessage
        });
    });
});
$9f195eb774806913$var$SelectLocations.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    // TODO: This does not work when loading JSON from the server...
    departure: $e6d972962a22d393$export$185802fd694ee1f5().nullable().validDepature((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-departure-invalid')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-departure-required')),
    destination: $e6d972962a22d393$export$185802fd694ee1f5().when([
        'intermediateStopLocations',
        'priceType',
        'pickupTime',
        'availability'
    ], (intermediateStopLocations, priceType, pickupTime, availability)=>{
        const key = pickupTime === '' ? 'direct' : 'prebook';
        const tripRules = availability?.[key]?.tripRules;
        const requiresDestination = key === 'direct' ? tripRules?.directBookingRequiresDestination === true : tripRules?.preBookingRequiresDestination === true;
        const required = !!(intermediateStopLocations?.length > 0 || priceType === false || priceType?.paymentMethods?.length === 0 || requiresDestination);
        return required ? $e6d972962a22d393$export$185802fd694ee1f5().nullable().validDestination((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-invalid')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required')) : $e6d972962a22d393$export$185802fd694ee1f5().nullable().validDestination((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-invalid'));
    }),
    intermediateStopLocations: $2145de3a81489cd9$export$185802fd694ee1f5().of($e6d972962a22d393$export$185802fd694ee1f5().nullable().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-destination-required')).validIntermediate((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-intermediate-invalid')))
});
var $9f195eb774806913$export$2e2bcd8739ae039 = $9f195eb774806913$var$SelectLocations;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");


var $igItr = parcelRequire("igItr");
var $8MQJ5 = parcelRequire("8MQJ5");
var $51vFz = parcelRequire("51vFz");

var $57Qo5 = parcelRequire("57Qo5");

var $6RzIO = parcelRequire("6RzIO");
function $9a41dab598251ed0$export$2e2bcd8739ae039(date, _ref) {
    var start = _ref.start, end = _ref.end;
    (0, $6RzIO.default)(2, arguments);
    return (0, $57Qo5.default)([
        (0, $51vFz.default)([
            date,
            start
        ]),
        end
    ]);
}


var $le96L = parcelRequire("le96L");
var $74e69f179d1a936e$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $74e69f179d1a936e$var$defaultRoundingMethod = 'trunc';
function $74e69f179d1a936e$export$b6474a47258c1211(method) {
    return method ? $74e69f179d1a936e$var$roundingMap[method] : $74e69f179d1a936e$var$roundingMap[$74e69f179d1a936e$var$defaultRoundingMethod];
}



var $8d3vD = parcelRequire("8d3vD");
function $ae4bf4599579267f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _options$nearestTo;
    if (arguments.length < 1) throw new TypeError('1 argument required, but only none provided present');
    var nearestTo = (0, $8d3vD.default)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
    if (nearestTo < 1 || nearestTo > 30) throw new RangeError('`options.nearestTo` must be between 1 and 30');
    var date = (0, $le96L.default)(dirtyDate);
    var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
    var minutes = date.getMinutes() + seconds / 60;
    var roundingMethod = (0, $74e69f179d1a936e$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod);
    var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    var remainderMinutes = minutes % nearestTo;
    var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}


var $hBud4 = parcelRequire("hBud4");
var $kzEvi = parcelRequire("kzEvi");
var $j1vsN = parcelRequire("j1vsN");











var $c7dccc85457db9a0$export$a2abc71b50183d06;
$c7dccc85457db9a0$export$a2abc71b50183d06 = `uV84GG_datepicker`;



var $ih19M = parcelRequire("ih19M");

// Enter animation for view content: a short opacity fade only. The earlier 20px upward slide
// made every header and group in a view arrive from a different place, which read as the
// layout "jumping" together with the fullscreen switch.
const $1ab1ad86cd1cb08e$var$conf = {
    transition: {
        duration: .15,
        ease: 'easeOut'
    },
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
function $1ab1ad86cd1cb08e$export$7edd4a21fac8ce55(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).h3, {
        ...props,
        ...$1ab1ad86cd1cb08e$var$conf
    });
}
function $1ab1ad86cd1cb08e$export$159d9494db57879b({ type: type, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
        ...props,
        ...$1ab1ad86cd1cb08e$var$conf
    });
}




const $b1e48e867c2e2e0c$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $b1e48e867c2e2e0c$var$PassengerRequiredAlert = ({ onClose: onClose })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex gap-1 items-center px-4 pt-4",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        className: "shrink-0",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
                                clipPath: "url(#pra-clip)",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M8 14.4333C11.553 14.4333 14.4333 11.553 14.4333 8C14.4333 4.44697 11.553 1.56667 8 1.56667C4.44697 1.56667 1.56667 4.44697 1.56667 8C1.56667 11.553 4.44697 14.4333 8 14.4333ZM8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                                        fill: "#17181A"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                                        x: "7.2",
                                        y: "4",
                                        width: "1.6",
                                        height: "1.6",
                                        rx: "0.8",
                                        fill: "#17181A"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                                        x: "7.467",
                                        y: "6.667",
                                        width: "1.067",
                                        height: "5.333",
                                        rx: "0.213",
                                        fill: "#17181A"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)("clipPath", {
                                    id: "pra-clip",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                                        width: "16",
                                        height: "16",
                                        fill: "white"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-headline font-semibold uppercase text-on-surface",
                        children: t('modal-passenger-required-title')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "px-4 pt-3 pb-4 text-on-surface-variant text-body-sm",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    children: t('modal-passenger-required-body')
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onClose,
                className: "w-full py-3 bg-on-surface text-on-primary text-btn font-semibold uppercase tracking-[0.68px] leading-5",
                children: "OK"
            })
        ]
    });
};
const $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f = (prebookTripRules)=>{
    const earliest = prebookTripRules?.earliestPrebookingDateTime;
    if (earliest) {
        const d = (0, $8MQJ5.default)(new Date(earliest), 5);
        // Floor to nearest 5 minutes; use explicit constructor to zero milliseconds so
        // repeated API calls with slightly different ms values don't cause comparison drift
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), Math.floor(d.getMinutes() / 5) * 5, 0, 0);
    }
    return (0, $8MQJ5.default)((0, $j1vsN.default)((0, $ae4bf4599579267f$export$2e2bcd8739ae039)(new Date(), {
        nearestTo: 5
    }), 0), 40);
};
const $b1e48e867c2e2e0c$export$70719a9c368c2090 = (values)=>{
    if (values) return (0, $c94184dfef1a7d71$export$25dd954bca15c04f)(values);
    // Fallback to 28 days ahead if values not available (27 days + today)
    return (0, $igItr.default)((0, $hBud4.default)((0, $kzEvi.default)((0, $j1vsN.default)(new Date(), 0), 59), 23), 27);
};
const $b1e48e867c2e2e0c$var$SelectTime = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = (0, $c94184dfef1a7d71$export$57957ca6633a6742)(values);
    const departureIsAirport = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'FLIGHT_NBR');
    const requiresPassengerCount = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'TRAVELER_COUNT_REQUIRED');
    // Max passengers = highest maxTravelers across available service types
    const availabilityKey = values.pickupTime === '' ? 'direct' : 'prebook';
    const availabilities = values.availability?.[availabilityKey]?.availabilities || [];
    const maxPassengers = availabilities.reduce((max, a)=>{
        if (a.availableAt === 'NOT_AVAILABLE' || !a.maxTravelers) return max;
        return Math.max(max, a.maxTravelers);
    }, 0) || 50;
    // Check if specific fields are editable in edit mode
    const isTimeEditable = inEditMode ? values.editableFields?.includes('pickUpTimeStamp') : true;
    // Only check availability if time is editable or not in edit mode
    // If time is not editable, we're keeping the original booking time regardless of current availability
    const isDirectBookDisabled = (0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'direct') ? !(0, $c94184dfef1a7d71$export$20098f5b816895fe)(values, 'direct') : false;
    const directTripRules = values.availability?.direct?.tripRules ?? values.availability?.prebook?.tripRules;
    const goNowNeedsDestination = departureIsAirport || directTripRules?.directBookingRequiresDestination === true;
    const noDirectBooking = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'NO_DIRECT_BOOK');
    const isGoNowDisabled = noDirectBooking || isDirectBookDisabled || goNowNeedsDestination && !values.destination?.address;
    const isBookingDelayed = isTimeEditable && (0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'prebook') ? (0, $c94184dfef1a7d71$export$b33f61cb8ec2f9c)(values, 'prebook') : false;
    const isBookingDisabled = isTimeEditable && (0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'prebook') ? !(0, $c94184dfef1a7d71$export$b32ff072b832c976)(values, 'prebook') : false;
    const prebookTripRules = values.availability?.prebook?.tripRules;
    const minDate = $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f(prebookTripRules);
    const maxDate = $b1e48e867c2e2e0c$export$70719a9c368c2090(values);
    // If the selected time is before the UI minimum (earliestPrebookingDateTime + 5 min buffer),
    // keep the button enabled so goNext can show the correction modal. Without this,
    // isBookingDisabled would disable the button and the click would never reach goNext.
    // Only apply when we actually have API-derived data (guard on earliestPrebookingDateTime).
    const isTimeOverdue = !inEditMode && !!prebookTripRules?.earliestPrebookingDateTime && !!values.pickupTime && new Date(values.pickupTime) < minDate;
    const prebookRequiresDestination = prebookTripRules?.preBookingRequiresDestination === true;
    // isBookingDelayed keeps the button live for the same reason isTimeOverdue does. The
    // modal that offers the next available time is raised from useDidMountEffect, and only
    // when isNextClicked — which nothing sets but goNext, which needs an enabled button. Its
    // condition is `isBookingDisabled && isBookingDelayed`, so disabling on isBookingDisabled
    // alone makes that branch unreachable by clicking and the user has no way forward at all.
    // It appeared to work only while isTimeOverdue happened to be true as well; any re-render
    // that corrected pickupTime up to minDate dropped that and left the button greyed out.
    const isContinueDisabled = isTimeOverdue || isBookingDelayed ? false : isBookingDisabled;
    const [isNextClicked, setIsNextClicked] = (0, $bh6RR.useState)(false);
    // Blocks useDidMountEffect from acting on re-fetch results while the overdue-correction
    // modal is visible. A ref (not state) so it's synchronously visible across renders.
    const isShowingCorrectionModal = (0, $bh6RR.useRef)(false);
    const isFlightNumberEditable = inEditMode ? values.editableFields?.includes('originLocation.flightInfo.flightNumber') : false;
    const isCheckedBaggageEditable = inEditMode ? values.editableFields?.includes('originLocation.flightInfo.checkedInBaggage') : false;
    const showFlightFields = departureIsAirport && (isFlightNumberEditable || isCheckedBaggageEditable || !inEditMode);
    const [isModalOpen, setIsModalOpen] = (0, $bh6RR.useState)(false);
    const [modalTitle, setModalTitle] = (0, $bh6RR.useState)();
    const [modalMessage, setModalMessage] = (0, $bh6RR.useState)();
    const [modalButtons, setModalButtons] = (0, $bh6RR.useState)();
    // Check if the time has been changed from the original
    const originalTime = values?.originalPickupTime;
    const currentTime = values?.pickupTime;
    const timeHasChanged = originalTime && currentTime && new Date(originalTime).getTime() !== new Date(currentTime).getTime();
    // In edit mode with unchanged time, don't clamp or enforce min/max
    // Once the user changes the time, apply all constraints
    const shouldEnforceConstraints = !inEditMode || timeHasChanged;
    const clampDate = shouldEnforceConstraints ? (date)=>(0, $9a41dab598251ed0$export$2e2bcd8739ae039)(date, {
            start: minDate,
            end: maxDate
        }) : (date)=>date; // Identity function - don't modify the date
    const closeModal = ()=>{
        setIsModalOpen(false);
    };
    const showInvalidTimeModal = ()=>{
        setIsModalOpen(true);
        setModalTitle(t('title-invalid-time'));
        setModalMessage(t('message-invalid-time'));
        setModalButtons([
            {
                func: closeModal,
                title: 'Ok'
            }
        ]);
    };
    const goNow = ()=>{
        setFieldValue('pickupTime', '', false);
        setFieldValue('flightNumber', '', false);
        setFieldValue('checkedInBaggage', false, false);
        next();
    };
    // effectiveTime lets callers pass a just-set time directly, bypassing the stale
    // Formik values.pickupTime (setFieldValue is async — the new value isn't in values yet)
    const goNext = (effectiveTime)=>{
        // When passed as an onClick handler, React provides a SyntheticEvent as the first arg.
        // Ignore it — only accept an actual Date or ISO string as an override.
        const isValidTime = effectiveTime instanceof Date || typeof effectiveTime === 'string' && effectiveTime !== '';
        const pickupTime = isValidTime ? effectiveTime : values.pickupTime;
        if (pickupTime === '') {
            setIsNextClicked(true);
            setFieldValue('pickupTime', minDate, false);
            return;
        }
        if (isValidTime) {
            // Called from the correction modal with an explicit accepted time — skip the re-fetch
            // and proceed directly. The time has already been validated against the current minDate.
            if (requiresPassengerCount && values.passengerCount === 0) (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)($b1e48e867c2e2e0c$var$PassengerRequiredAlert, {
                    onClose: close
                }));
            else wrappedNext();
            return;
        }
        // Normal Next click: trigger a fresh service-availability fetch so the overdue check in
        // useDidMountEffect runs against the latest earliestPrebookingDateTime, not cached data.
        // The Fetcher re-fetches whenever pickupTime changes — a new Date object with the same
        // millisecond value is a different reference and triggers it.
        if (values.availabilityIsLoading) {
            setIsNextClicked(true);
            return;
        }
        setIsNextClicked(true);
        const pt = pickupTime instanceof Date ? pickupTime : new Date(pickupTime);
        setFieldValue('pickupTime', new Date(pt.getTime()), false);
    };
    const setPropsedTime = ()=>{
        const service = values.availability.prebook.availabilities.find((item)=>item.availableAt === 'DELAYED');
        const time = new Date(service.pickupTime);
        setFieldValue('pickupTime', time, false);
        goNext(time);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (inEditMode) {
            // Store the original pickup time for comparison in validation
            if (values.pickupTime) setFieldValue('originalPickupTime', values.pickupTime, false);
            return;
        }
        // In create mode, set default time if empty
        if (values.pickupTime === '') setFieldValue('pickupTime', minDate, false);
    }, []);
    // Prebook availability (and its earliestPrebookingDateTime) arrives after the initial
    // render — the Fetcher only fetches it once pickupTime is set to something non-empty.
    //
    // First entry (pickupTimeInitialized=false): snap to API minimum + 5 min buffer so the
    // user sees a sensible default. Mark initialized in Formik so this only runs once per
    // booking session — the flag survives SelectTime unmounting (navigating away and back).
    //
    // Re-entry or re-fetch (pickupTimeInitialized=true): only correct if the existing time
    // has become strictly before the API hard minimum (no buffer). This preserves a time the
    // user already confirmed even if it falls within the 5-min buffer zone.
    (0, $bh6RR.useEffect)(()=>{
        const earliest = prebookTripRules?.earliestPrebookingDateTime;
        if (inEditMode) return;
        if (!earliest) return;
        const newMinDate = $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f(prebookTripRules);
        const currentPickup = values.pickupTime ? new Date(values.pickupTime) : null;
        if (!values.pickupTimeInitialized) {
            setFieldValue('pickupTimeInitialized', true, false);
            // Always snap to the API-derived minimum on first entry so the user sees a
            // meaningful default — not the generic now+40min fallback which is likely ahead of it.
            setFieldValue('pickupTime', newMinDate, false);
        } else if (currentPickup && currentPickup < new Date(earliest)) // Time is genuinely before the API hard minimum — correct it
        setFieldValue('pickupTime', newMinDate, false);
    }, [
        prebookTripRules?.earliestPrebookingDateTime
    ]);
    // Auto-navigate to next view when flight fields become non-editable due to expiration
    (0, $bh6RR.useEffect)(()=>{
        // Only auto-navigate if:
        // 1. We're in edit mode
        // 2. This is an airport departure (has flight fields)
        // 3. Flight fields are now hidden (both flight number and baggage fields are not editable)
        // 4. We're currently on this view
        if (inEditMode && departureIsAirport && !showFlightFields && currentView) {
            // Small delay to allow state updates to complete
            const timer = setTimeout(()=>{
                next();
            }, 100);
            return ()=>clearTimeout(timer);
        }
    }, [
        showFlightFields,
        inEditMode,
        departureIsAirport,
        currentView,
        next
    ]);
    // In edit mode, don't allow back navigation to SelectLocations
    const buttons = inEditMode ? [
        {
            func: goNow,
            title: t('button-go-now'),
            disabled: true
        },
        // Always disabled when editing - can't change to "go now"
        {
            func: goNext,
            title: t('button-continue'),
            disabled: isBookingDisabled,
            isLoading: (isNextClicked || isBookingDisabled) && values.availabilityIsLoading
        }
    ] : [
        {
            func: ()=>{
                setFieldValue('pickupTime', '', false);
                prev();
            },
            isBack: true
        },
        {
            func: goNow,
            title: t('button-go-now'),
            disabled: isGoNowDisabled
        },
        {
            func: goNext,
            title: t('button-continue'),
            disabled: isContinueDisabled,
            isLoading: (isNextClicked || isContinueDisabled) && values.availabilityIsLoading
        }
    ];
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        // While any correction modal is visible, block all re-fetch results from acting.
        if (isShowingCorrectionModal.current) return;
        // Edit mode: skip availability checks when time is unchanged; only navigate on Next.
        if (inEditMode && !timeHasChanged) {
            if (isNextClicked) wrappedNext();
            return;
        }
        // Only act when the user explicitly clicked Next. Background re-fetches triggered by
        // the snap effect run with isNextClicked=false and must be ignored — otherwise they
        // would show modals or navigate without user intent.
        if (!isNextClicked) return;
        if ((0, $c94184dfef1a7d71$export$282819a3391760b8)(values, 'prebook') && !values.availabilityIsLoading) {
            if (isBookingDisabled && !isBookingDelayed) {
                setIsNextClicked(false);
                setIsModalOpen(true);
                setModalTitle(t('title-fully-booked'));
                setModalMessage(t('message-select-other-time'));
                setModalButtons([
                    {
                        func: closeModal,
                        title: 'Ok'
                    }
                ]);
            } else if (isBookingDisabled && isBookingDelayed) {
                setIsNextClicked(false);
                const service = values.availability.prebook.availabilities.find((item)=>item.availableAt === 'DELAYED');
                const time = (0, $200ec6b1b2ca8c5a$export$3203edd9e5edd663)(new Date(service.pickupTime));
                setIsModalOpen(true);
                setModalTitle(t('title-fully-booked'));
                setModalMessage(t('message-select-next-available-time', {
                    time: time
                }));
                setModalButtons([
                    {
                        func: closeModal,
                        title: t('button-select-other-time')
                    },
                    {
                        func: setPropsedTime,
                        title: t('button-select-available-time')
                    }
                ]);
            } else {
                if (prebookTripRules?.earliestPrebookingDateTime && new Date(values.pickupTime) < minDate) {
                    const correctedTime = minDate;
                    isShowingCorrectionModal.current = true;
                    setIsNextClicked(false);
                    setFieldValue('pickupTime', correctedTime, false);
                    const timeStr = (0, $200ec6b1b2ca8c5a$export$3203edd9e5edd663)(correctedTime);
                    setIsModalOpen(true);
                    setModalTitle(t('title-fully-booked'));
                    setModalMessage(t('message-select-next-available-time', {
                        time: timeStr
                    }));
                    setModalButtons([
                        {
                            func: ()=>{
                                isShowingCorrectionModal.current = false;
                                closeModal();
                            },
                            title: t('button-select-other-time')
                        },
                        {
                            func: ()=>{
                                isShowingCorrectionModal.current = false;
                                closeModal();
                                goNext(correctedTime);
                            },
                            title: t('button-select-available-time')
                        }
                    ]);
                } else if (requiresPassengerCount && values.passengerCount === 0) {
                    setIsNextClicked(false);
                    (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)($b1e48e867c2e2e0c$var$PassengerRequiredAlert, {
                            onClose: close
                        }));
                } else wrappedNext();
            }
        }
    }, [
        values.availability,
        values.availabilityIsLoading
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $b1e48e867c2e2e0c$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8a4f32cb57f72457$export$2e2bcd8739ae039), {
                title: modalTitle,
                message: modalMessage,
                buttons: modalButtons,
                onClose: closeModal,
                isOpen: isModalOpen,
                absolute: true
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: departureIsAirport ? t('header-when-does-your-flight-land') : t('header-when-do-you-want-to-go')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                        fullscreen: fullscreen,
                        showBothBookingTypes: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                        values: values,
                        showTime: true,
                        currentView: currentView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bc55ceba36084ea6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: departureIsAirport ? t('header-when-does-your-flight-land') : t('header-when-do-you-want-to-go')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$exports.content,
                        children: showFlightFields ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $f35967c56a9f3d99$exports.group,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.label,
                                            children: t('section-flight-number')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                            name: "flightNumber",
                                            placeholder: t('placeholder-flight-number'),
                                            component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                                            disabled: inEditMode && !isFlightNumberEditable,
                                            onChange: (e)=>{
                                                const value = e.target.value || "";
                                                setFieldValue('flightNumber', value.toUpperCase());
                                            }
                                        })
                                    ]
                                }),
                                isTimeEditable && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.label,
                                            children: t('section-landing-time')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                            className: $c7dccc85457db9a0$export$a2abc71b50183d06,
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                name: "pickupTime",
                                                minDate: shouldEnforceConstraints ? minDate : undefined,
                                                maxDate: shouldEnforceConstraints ? maxDate : undefined,
                                                clampDate: clampDate,
                                                component: (0, $d2eecefb00e70187$export$2e2bcd8739ae039),
                                                showTimeInput: true,
                                                isAirport: departureIsAirport,
                                                onInvalidTime: showInvalidTimeModal
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                            name: "pickupTime",
                                            component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                        })
                                    ]
                                }),
                                requiresPassengerCount && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.label,
                                            children: t('header-passengers')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: "flex items-center gap-3 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    className: "flex-1 text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                                                    children: t('label-group-size')
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $966dfe9a48e4742e$export$2e2bcd8739ae039), {
                                                    value: values.passengerCount,
                                                    min: 0,
                                                    max: maxPassengers,
                                                    onChange: (v)=>setFieldValue('passengerCount', v)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.subtitle,
                                            children: t('info-passenger-count')
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.label,
                                            children: t('section-luggage')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                            name: "checkedInBaggage",
                                            title: t('title-baggage'),
                                            tabIndex: "0",
                                            alternateBackground: fullscreen,
                                            component: (0, $20f208c249841caf$export$2e2bcd8739ae039),
                                            padding: "py-2",
                                            disabled: inEditMode && !isCheckedBaggageEditable,
                                            icon: "Luggage"
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.subtitle,
                                            children: t('info-baggage')
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                isTimeEditable && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                            className: $c7dccc85457db9a0$export$a2abc71b50183d06,
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                name: "pickupTime",
                                                minDate: shouldEnforceConstraints ? minDate : undefined,
                                                maxDate: shouldEnforceConstraints ? maxDate : undefined,
                                                clampDate: clampDate,
                                                component: (0, $d2eecefb00e70187$export$2e2bcd8739ae039),
                                                isAirport: departureIsAirport,
                                                onInvalidTime: showInvalidTimeModal
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                            name: "pickupTime",
                                            component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                        })
                                    ]
                                }),
                                requiresPassengerCount && values.pickupTime !== '' && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.label,
                                            children: t('header-passengers')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: "flex items-center gap-3 py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                    className: "flex-1 text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                                                    children: t('label-group-size')
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $966dfe9a48e4742e$export$2e2bcd8739ae039), {
                                                    value: values.passengerCount,
                                                    min: 0,
                                                    max: maxPassengers,
                                                    onChange: (v)=>setFieldValue('passengerCount', v)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: $f35967c56a9f3d99$exports.subtitle,
                                            children: t('info-passenger-count')
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$b1e48e867c2e2e0c$var$SelectTime.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    pickupTime: $2efeb86fe7f1b8d4$export$185802fd694ee1f5().when([
        'bookingId',
        'editableFields',
        'originalPickupTime',
        'availability'
    ], (bookingId, editableFields, originalPickupTime, availability)=>{
        const inEditMode = !isNaN(bookingId) && bookingId > 0;
        const isTimeEditable = inEditMode ? editableFields?.includes('pickUpTimeStamp') : true;
        // Check if time has changed
        const timeHasChanged = originalPickupTime && new Date(originalPickupTime).getTime() !== new Date().getTime(); // Will be properly compared during validation
        // Calculate maxDate
        const hasAvailability = availability?.prebook !== undefined && availability?.prebook !== false;
        const maxDate = hasAvailability ? $b1e48e867c2e2e0c$export$70719a9c368c2090({
            availability: availability
        }) : (0, $igItr.default)((0, $hBud4.default)((0, $kzEvi.default)((0, $j1vsN.default)(new Date(), 0), 59), 23), 365);
        if (inEditMode && !isTimeEditable) // In edit mode with non-editable time: accept any value
        return $2efeb86fe7f1b8d4$export$185802fd694ee1f5().nullable();
        else if (inEditMode && isTimeEditable) // In edit mode with editable time: only validate if changed
        // For now, require date but allow past times
        return $2efeb86fe7f1b8d4$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-date'));
        else {
            // New booking mode: full validation.
            // Only apply the API-derived minimum when earliestPrebookingDateTime is present.
            // Without it getMinDate falls back to now+40min which would reject valid times
            // during a Fetcher re-fetch when tripRules is momentarily absent.
            const earliest = availability?.prebook?.tripRules?.earliestPrebookingDateTime;
            const schema = $2efeb86fe7f1b8d4$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-date')).max(maxDate, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-too-far-ahead'));
            return earliest ? schema.min($b1e48e867c2e2e0c$export$a26bb6a012e2ca6f(availability.prebook.tripRules), (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-not-valid')) : schema;
        }
    }),
    flightNumber: $a0206caf38308288$export$185802fd694ee1f5().when([
        'departure',
        'bookingId',
        'editableFields'
    ], (departure, bookingId, editableFields)=>{
        const inEditMode = !isNaN(bookingId) && bookingId > 0;
        const isFlightNumberEditable = inEditMode ? editableFields?.includes('originLocation.flightInfo.flightNumber') : true;
        if (inEditMode && !isFlightNumberEditable) // In edit mode with non-editable flight number: accept any value
        return $a0206caf38308288$export$185802fd694ee1f5();
        else if (departure?.locationInformation?.filter((info)=>info?.tag === 'FLIGHT_NBR')?.length > 0) // Airport departure requires flight number
        return $a0206caf38308288$export$185802fd694ee1f5().matches(/^([0-9A-Z][0-9A-Z])[A-Z]?[0-9]{1,4}[A-Z]?$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-flight-number')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-flight-number'));
        else return $a0206caf38308288$export$185802fd694ee1f5();
    }),
    passengerCount: $6e6ad40c65975a5d$export$185802fd694ee1f5().when([
        'departure',
        'pickupTime'
    ], (departure, pickupTime)=>{
        const isPrebook = !!pickupTime;
        const required = isPrebook && departure?.locationInformation?.some((info)=>info?.tag === 'TRAVELER_COUNT_REQUIRED');
        return required ? $6e6ad40c65975a5d$export$185802fd694ee1f5().min(1, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-passenger-count')) : $6e6ad40c65975a5d$export$185802fd694ee1f5();
    }),
    // Include edit mode fields so they're accessible in .when()
    bookingId: $2da2ea4b605d7bd9$export$185802fd694ee1f5(),
    editableFields: $2da2ea4b605d7bd9$export$185802fd694ee1f5(),
    originalPickupTime: $2da2ea4b605d7bd9$export$185802fd694ee1f5(),
    availability: $2da2ea4b605d7bd9$export$185802fd694ee1f5()
});
var $b1e48e867c2e2e0c$export$2e2bcd8739ae039 = $b1e48e867c2e2e0c$var$SelectTime;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



/**
 * Configuration for vehicle options
 * Each option defines:
 * - key: The API key used in vehicleOptions array
 * - formField: The form field name
 * - componentName: Name of the component to render ('CheckboxField' or 'BoosterField')
 * - icon: Icon name for the component
 * - titleKey: Translation key for the title
 * - infoKey: Translation key for additional info (optional)
 * - checkPrice: Whether to check for pricing (optional)
 * - customLogic: Function to handle custom availability/display logic (optional)
 * - customProps: Function to generate additional props based on context (optional)
 */ const $eddd725036e990a0$export$b596089018b4172d = [
    {
        key: 'pet',
        formField: 'pet',
        componentName: 'CheckboxField',
        icon: 'Pet',
        titleKey: 'title-pet-option',
        tabIndex: 0
    },
    {
        key: 'low',
        formField: 'low',
        componentName: 'CheckboxField',
        icon: 'Low',
        titleKey: 'title-low-option',
        infoKey: 'info-low-option',
        tabIndex: 0
    },
    /*{
  key: 'stationWagon',
  formField: 'stationWagon',
  componentName: 'CheckboxField',
  icon: 'CarEstate',
  titleKey: 'title-stationwagon-option',
  tabIndex: 0,
},*/ {
        key: 'boosterSeat',
        // For booster seats, we check both boosterSeat1 and boosterSeat2
        apiKeys: [
            'boosterSeat1',
            'boosterSeat2'
        ],
        formField: 'booster',
        componentName: 'BoosterField',
        icon: 'BoosterSeat',
        titleKey: 'title-booster-option',
        infoKey: 'info-booster-option',
        tabIndex: 0,
        checkPrice: true,
        // Custom logic for booster seats (different from standard options)
        customLogic: (vehicleOptions, editableVehicleOptions, values, inEditMode)=>{
            const haveRearFacingChildSeat = values.rearFacingChildSeat;
            const boosterSeat1Available = vehicleOptions.includes('boosterSeat1');
            const boosterSeat2Available = vehicleOptions.includes('boosterSeat2') && !haveRearFacingChildSeat;
            const currentlySelected = values.booster > 0;
            const boosterSeat1IsEditable = editableVehicleOptions.includes('boosterSeat1');
            const boosterSeat2IsEditable = editableVehicleOptions.includes('boosterSeat2') && !haveRearFacingChildSeat;
            const available = boosterSeat1Available || boosterSeat2Available;
            const isEditable = boosterSeat1IsEditable || boosterSeat2IsEditable;
            const show = available || inEditMode && currentlySelected;
            const numSeatsMax = boosterSeat1Available || inEditMode && boosterSeat1IsEditable ? boosterSeat2Available || inEditMode && boosterSeat2IsEditable ? 2 : 1 : 0;
            return {
                available: available,
                currentlySelected: currentlySelected,
                isEditable: isEditable,
                show: show,
                numSeatsMax: numSeatsMax
            };
        },
        customProps: (context)=>({
                numSeatsMax: context.numSeatsMax
            }),
        shouldShow: (values)=>values?.serviceType !== 'business'
    },
    {
        key: 'rearFacingChildSeat',
        formField: 'rearFacingChildSeat',
        componentName: 'CheckboxField',
        icon: 'ChildSeat',
        titleKey: 'title-childseat-option',
        infoKey: 'info-childseat-option',
        tabIndex: 2,
        checkPrice: true
    }
];
const $eddd725036e990a0$export$a9c05265c8b59769 = (option, vehicleOptions, editableVehicleOptions, values, inEditMode)=>{
    // If custom logic is provided, use it
    if (option.customLogic) return {
        ...option,
        ...option.customLogic(vehicleOptions, editableVehicleOptions, values, inEditMode)
    };
    // Standard logic for simple options
    const apiKey = option.apiKeys ? option.apiKeys[0] : option.key;
    const available = option.apiKeys ? option.apiKeys.some((key)=>vehicleOptions.includes(key)) : vehicleOptions.includes(apiKey);
    const currentlySelected = values[option.formField] === true;
    const isEditable = option.apiKeys ? option.apiKeys.some((key)=>editableVehicleOptions.includes(key)) : editableVehicleOptions.includes(apiKey);
    const show = available || inEditMode && currentlySelected;
    return {
        ...option,
        available: available,
        currentlySelected: currentlySelected,
        isEditable: isEditable,
        show: show
    };
};


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2780-30318
// Figma component name: AddOns (collapsible card)
//
// Props:
//   children     — the addon rows (CheckboxField / BoosterField via Formik Field)
//   activePills  — string[] of selected addon labels shown in collapsed header
//   disabled     — locks the whole card
//   forceOpen    — always expanded (used in fullscreen mode)
//   title        — card header title

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");
// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2040-27031
// Figma component name: Pill
/**
 * Pill badge with three variants:
 *   "important"   — yellow background (secondary-container), used for time estimates, booking-only notices
 *   "default"     — dark gray background (on-surface-variant), used for unavailable/info states
 *   "user-choice" — outlined, used for user-selected options
 */ 
var $ih19M = parcelRequire("ih19M");
function $fefe7f9cbdf4c037$export$2e2bcd8739ae039({ text: text, type: type = 'default' }) {
    if (type === 'important') return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: "inline-flex items-center px-[5px] pb-[2px] rounded-[4px] bg-secondary-container border-solid border-[0.5px] border-secondary text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap",
        children: text
    });
    if (type === 'user-choice') return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: "inline-flex items-center px-[5px] pb-[2px] rounded-[4px] border-solid border border-on-surface-variant text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap",
        children: text
    });
    // default
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: "inline-flex items-center px-[5px] pb-[2px] rounded-[4px] bg-on-surface-variant text-[15px] font-medium leading-5 text-white whitespace-nowrap",
        children: text
    });
}


function $457be27c9a8a3827$var$ChevronIcon({ open: open }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: open ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6',
            stroke: "#17181A",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $457be27c9a8a3827$export$2e2bcd8739ae039({ children: children, activePills: activePills = [], disabled: disabled, defaultOpen: defaultOpen = false, title: title }) {
    const [open, setOpen] = (0, $bh6RR.useState)(defaultOpen);
    const isOpen = open;
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    const base = `/app/themes/${theme}/static/img/option-icons`;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex flex-col w-full bg-surface-container-low rounded-[10px] overflow-hidden', disabled && 'opacity-[0.38] pointer-events-none'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                type: "button",
                onClick: ()=>setOpen((o)=>!o),
                disabled: disabled,
                className: "bg-surface-container-high flex gap-3 items-center p-2 w-full text-left",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "relative overflow-clip size-11 shrink-0 bg-surface-container",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `${base}/Pet.png`,
                                alt: "",
                                className: "absolute object-cover size-[34px]",
                                style: {
                                    left: -9,
                                    top: -4
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `${base}/BoosterSeat.png`,
                                alt: "",
                                className: "absolute object-cover size-[34px]",
                                style: {
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(calc(-50% - 6px), calc(-50% + 11px))'
                                }
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `${base}/ChildSeat.png`,
                                alt: "",
                                className: "absolute object-cover size-[34px]",
                                style: {
                                    left: '50%',
                                    top: '50%',
                                    transform: 'translate(calc(-50% + 10px), calc(-50% - 10px))'
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex-1 flex flex-col items-start min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                                children: title
                            }),
                            activePills.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex gap-1 flex-wrap mt-0.5",
                                children: activePills.map((text)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                        text: text,
                                        type: "user-choice"
                                    }, text))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($457be27c9a8a3827$var$ChevronIcon, {
                        open: isOpen
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex flex-col px-2 divide-y divide-outline/20",
                children: children
            })
        ]
    });
}


const $1dc82d3b40a7e000$export$7e993028413288c5 = ({ vehicleOptions: vehicleOptions, editableVehicleOptions: editableVehicleOptions, values: values, inEditMode: inEditMode })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const COMPONENT_MAP = (0, $bh6RR.useMemo)(()=>({
            CheckboxField: $20f208c249841caf$export$2e2bcd8739ae039,
            BoosterField: $efabb32800674410$export$2e2bcd8739ae039
        }), []);
    const processedOptions = (0, $bh6RR.useMemo)(()=>{
        return (0, $eddd725036e990a0$export$b596089018b4172d).map((option)=>(0, $eddd725036e990a0$export$a9c05265c8b59769)(option, vehicleOptions, editableVehicleOptions, values, inEditMode)).filter((option)=>{
            if (!option.show) return false;
            if (option.shouldShow && !option.shouldShow(values)) return false;
            return true;
        });
    }, [
        vehicleOptions,
        editableVehicleOptions,
        values,
        inEditMode
    ]);
    // Compute active-selection pill labels for the card header
    const activePills = (0, $bh6RR.useMemo)(()=>{
        const pills = [];
        if (values.pet) pills.push(t('title-pet-option'));
        if (values.low) pills.push(t('title-low-option'));
        if (values.booster === 1) pills.push(`1 ${t('title-booster-option')}`);
        if (values.booster >= 2) pills.push(`${values.booster} ${t('title-booster-option')}`);
        if (values.rearFacingChildSeat) pills.push(t('title-childseat-option'));
        return pills;
    }, [
        values.pet,
        values.low,
        values.booster,
        values.rearFacingChildSeat,
        t
    ]);
    if (processedOptions.length === 0) return null;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $457be27c9a8a3827$export$2e2bcd8739ae039), {
        title: t('title-booking-options'),
        activePills: activePills,
        children: processedOptions.map((option)=>{
            const FieldComponent = COMPONENT_MAP[option.componentName];
            const fieldProps = {
                name: option.formField,
                icon: option.icon,
                tabIndex: option.tabIndex,
                title: t(option.titleKey),
                component: FieldComponent
            };
            if (option.infoKey) fieldProps.info = t(option.infoKey);
            if (inEditMode && !option.isEditable) fieldProps.disabled = true;
            if (option.customProps) Object.assign(fieldProps, option.customProps(option));
            const apiKey = option.apiKeys?.[0] || option.key;
            const priceAmount = (0, $c94184dfef1a7d71$export$165a4cf04149c778)(values, apiKey);
            fieldProps.price = priceAmount > 0 ? `${priceAmount}:-` : t('label-option-free');
            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                ...fieldProps
            }, option.key);
        })
    });
};
const $1dc82d3b40a7e000$export$fb2e108552c0d31 = ({ vehicleOptions: vehicleOptions, editableVehicleOptions: editableVehicleOptions, values: values, inEditMode: inEditMode })=>{
    return (0, $bh6RR.useMemo)(()=>{
        return (0, $eddd725036e990a0$export$b596089018b4172d).reduce((acc, option)=>{
            acc[option.key] = (0, $eddd725036e990a0$export$a9c05265c8b59769)(option, vehicleOptions, editableVehicleOptions, values, inEditMode);
            return acc;
        }, {});
    }, [
        vehicleOptions,
        editableVehicleOptions,
        values,
        inEditMode
    ]);
};



var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");




function $703a2ef17cefd820$export$2e2bcd8739ae039({ providers: providers, sectionNumber: sectionNumber = 2, error: error = false, headingRef: headingRef }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const onSelect = (providerId)=>{
        setFieldValue('selectedProviderId', providerId, false);
    };
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    return /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
        className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3f9dfc4319f20848$export$2e2bcd8739ae039), {
                number: sectionNumber,
                title: t('header-select-partner'),
                error: error,
                innerRef: headingRef
            }),
            providers.length === 0 ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $8edb314d6528ebec$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: `/app/themes/${theme}/static/img/logo-allians.png`,
                    alt: "",
                    className: "size-8 object-contain"
                }),
                title: t('header-no-providers-found'),
                description: t('info-no-providers-found')
            }) : providers.map((provider)=>{
                const { providerId: providerId, name: name } = provider.providerData;
                const effectiveServiceType = values.serviceType === 'estate' ? 'taxi' : values.serviceType;
                const availability = provider.availabilities?.find((a)=>a.serviceType === effectiveServiceType);
                const waitTime = availability?.expectedWaitTime;
                const priceEntry = values.serviceType ? values.priceEstimate?.prices?.find((p)=>p.providerId === providerId && p.serviceType === effectiveServiceType) : null;
                const originalPrice = priceEntry && priceEntry.fullPrice !== priceEntry.finalPrice ? `${priceEntry.fullPrice}:-` : undefined;
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $35bcf1734d1aebd2$export$2e2bcd8739ae039), {
                    type: "option",
                    providerId: providerId,
                    name: name,
                    subtitle: waitTime != null ? `${waitTime} min` : undefined,
                    price: priceEntry ? `${priceEntry.finalPrice}:-` : undefined,
                    originalPrice: originalPrice,
                    selected: values.selectedProviderId === providerId,
                    priceLoading: values.priceIsLoading,
                    onClick: ()=>onSelect(providerId)
                }, providerId);
            })
        ]
    });
}



var $0612daa0ab0e92a1$export$322b07c09b50f40e;
$0612daa0ab0e92a1$export$322b07c09b50f40e = `ctxrQW_companyPadding`;




const $868fdca409bb61c6$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $868fdca409bb61c6$var$findPrice = (prices, serviceType, providerId = null)=>providerId && prices.find((p)=>p.serviceType === serviceType && p.providerId === providerId) || prices.find((p)=>p.serviceType === serviceType);
const $868fdca409bb61c6$var$renderPrice = (prices, serviceType, providerId = null)=>{
    const price = $868fdca409bb61c6$var$findPrice(prices, serviceType, providerId);
    if (price === undefined) {
        console.error('Could not find price for servicetype:', serviceType);
        return null;
    }
    return `${price.finalPrice}:-`;
};
const $868fdca409bb61c6$var$getOriginalPrice = (prices, serviceType, providerId = null)=>{
    const price = $868fdca409bb61c6$var$findPrice(prices, serviceType, providerId);
    if (price === undefined || price.finalPrice === price.fullPrice) return null;
    return `${price.fullPrice}:-`;
};
const $868fdca409bb61c6$var$getReducedPrice = (prices, serviceType, providerId = null)=>{
    const price = $868fdca409bb61c6$var$findPrice(prices, serviceType, providerId);
    if (price === undefined) {
        console.error('Could not find price for servicetype:', serviceType);
        return false;
    }
    if (price.finalPrice === price.fullPrice) return false;
    else {
        let type = false;
        price.discountComponents?.forEach((dis)=>{
            if (dis.type == 'campaign') type = dis.name;
        });
        return type;
    }
};
const $868fdca409bb61c6$var$SelectHow = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const carTypeRef = (0, $bh6RR.useRef)();
    const partnerHeadingRef = (0, $bh6RR.useRef)();
    const [partnerError, setPartnerError] = (0, $bh6RR.useState)(false);
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user, setIsCompanyTrip: setIsCompanyTrip } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue, handleChange: handleChange, handleBlur: handleBlur } = (0, $lW2XZ.useFormikContext)();
    // const showAvailability = values.departure?.address !== undefined && values.pickupTime === ''
    const inEditMode = (0, $c94184dfef1a7d71$export$57957ca6633a6742)(values);
    const disableFixedPrice = values.destination?.address === undefined || values.autoValues.fixedPriceAvailable === null;
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    // Memoize vehicleOptions to prevent infinite render loop
    const vehicleOptions = (0, $bh6RR.useMemo)(()=>{
        return (0, $c94184dfef1a7d71$export$45f0d338a0ae68ff)(values);
    }, [
        values.bookingId,
        values.editableOptions,
        values.availability,
        values.pickupTime,
        values.serviceType,
        values.autoValues.serviceType,
        values.selectedProviderId
    ]);
    // In edit mode, determine which options can be edited and which are just shown (disabled)
    const editableVehicleOptions = (0, $bh6RR.useMemo)(()=>{
        if (!inEditMode) return vehicleOptions;
        return values.editableOptions?.vehicleOptions?.map((opt)=>opt.vehicleOption) || [];
    }, [
        inEditMode,
        values.editableOptions,
        vehicleOptions
    ]);
    // Use the configuration-based hook to process all vehicle options
    const processedOptions = (0, $1dc82d3b40a7e000$export$fb2e108552c0d31)({
        vehicleOptions: vehicleOptions,
        editableVehicleOptions: editableVehicleOptions,
        values: values,
        inEditMode: inEditMode
    });
    // Extract specific options for backward compatibility and useEffect dependencies
    const petAvailable = processedOptions.pet?.available || false;
    const petCurrentlySelected = processedOptions.pet?.currentlySelected || false;
    const lowAvailable = processedOptions.low?.available || false;
    const lowCurrentlySelected = processedOptions.low?.currentlySelected || false;
    const boosterCurrentlySelected = processedOptions.boosterSeat?.currentlySelected || false;
    const numSeatsMax = processedOptions.boosterSeat?.numSeatsMax || 0;
    // Options not in config (handled separately)
    const electricCarAvailable = vehicleOptions.includes('electric');
    const stationWagonAvailable = false; //vehicleOptions.includes('stationWagon')
    const showCompany = user && user?.companyConnections?.length > 0;
    // Memoize company to prevent unnecessary recalculations and useEffect triggers
    const company = (0, $bh6RR.useMemo)(()=>{
        return values.isCompanyTrip && user?.companyConnections?.length > 0 ? user.companyConnections[0] : false;
    }, [
        values.isCompanyTrip,
        user?.companyConnections
    ]);
    // Multiple partners: servicesByProvider filtered to providers that support the selected service type
    // multipleProviders: providers filtered to those supporting the current service type.
    // Returns null only when there are globally ≤1 providers (hides the section entirely).
    // Returns a 1-item array when only 1 provider supports the current service type
    // (section stays visible to avoid UI jumps; that provider is auto-selected below).
    const multipleProviders = (0, $bh6RR.useMemo)(()=>{
        const key = values.pickupTime === '' ? 'direct' : 'prebook';
        let providers = values.availability?.[key]?.servicesByProvider;
        if (!Array.isArray(providers) || providers.length === 0) return null;
        // In edit mode, lock to the original booking's provider — partner cannot be changed.
        // Filter down to just that provider; if not found in current availability, keep all.
        if (inEditMode && values.lockedProviderId) {
            const locked = providers.find((p)=>p.providerData?.providerId === values.lockedProviderId);
            if (locked) providers = [
                locked
            ];
        }
        // Hide the section only when the sole provider is TSAB (native Taxi Stockholm flow)
        if (providers.length === 1 && providers[0].providerData?.providerId === 'TSAB') return null;
        const effectiveSt = values.serviceType === 'estate' ? 'taxi' : values.serviceType;
        // Collect add-on keys the user has selected
        const selectedAddonKeys = [];
        if (values.pet) selectedAddonKeys.push('pet');
        if (values.low) selectedAddonKeys.push('low');
        if (values.booster > 0) selectedAddonKeys.push('boosterSeat1');
        if (values.rearFacingChildSeat) selectedAddonKeys.push('rearFacingChildSeat');
        if (values.electric) selectedAddonKeys.push('electric');
        // null renders as Taxameter in FixedPriceSwitch (Boolean(null) === false), so treat it the same
        const requiredPriceType = fixedPrice ? 'FIXED' : 'TAXIMETER';
        return providers.filter((p)=>{
            const a = p.availabilities?.find((a)=>a.serviceType === effectiveSt);
            if (!a || a.availableAt === 'NOT_AVAILABLE') return false;
            // Filter out providers that don't support all selected add-ons
            if (!selectedAddonKeys.every((k)=>a.vehicleOptions?.includes(k))) return false;
            // Filter out providers that don't support the current price type
            if (requiredPriceType) {
                const priceTypes = p.priceAndPaymentRules?.priceTypes || [];
                if (!priceTypes.some((pt)=>pt.type === requiredPriceType)) return false;
            }
            return true;
        });
    }, [
        values.availability,
        values.pickupTime,
        values.serviceType,
        values.pet,
        values.low,
        values.booster,
        values.rearFacingChildSeat,
        values.electric,
        fixedPrice,
        inEditMode,
        values.lockedProviderId
    ]);
    // Section shows whenever there are globally 2+ providers, regardless of current service type
    const shouldShowProviderSelection = multipleProviders !== null;
    const showPrices = !inEditMode && fixedPrice && values.priceEstimate && !shouldShowProviderSelection;
    const showDiscountPill = !inEditMode && fixedPrice && values.priceEstimate;
    // Memoize partnerData to prevent unnecessary recalculations
    const partnerData = (0, $bh6RR.useMemo)(()=>{
        if (values?.availability?.direct?.providerData?.providerId && (values?.availability?.direct?.providerData?.providerId !== "TSAB" || CONFIG.svea_module)) return values?.availability?.direct?.providerData;
        if (values?.availability?.prebook?.providerData?.providerId && (values?.availability?.prebook?.providerData?.providerId !== "TSAB" || CONFIG.svea_module)) return values?.availability?.prebook?.providerData;
        return null;
    }, [
        values.availability
    ]);
    // Check availability from priceAndPaymentRules
    const availabilityKey = values.pickupTime === '' ? 'direct' : 'prebook';
    const priceTypes = values.availability?.[availabilityKey]?.priceAndPaymentRules?.priceTypes || [];
    const fixedPriceAvailable = priceTypes.find((item)=>item.type === 'FIXED') !== undefined;
    const taxiMeterAvailable = priceTypes.find((item)=>item.type === 'TAXIMETER') !== undefined;
    const fixedPriceNotAvailable = values.autoValues.fixedPriceAvailable === false || partnerData && !CONFIG.svea_module || !fixedPriceAvailable;
    const taxameterNotAvailable = !taxiMeterAvailable;
    // Memoize fields to prevent infinite render loop
    const fields = (0, $bh6RR.useMemo)(()=>{
        return (0, $c94184dfef1a7d71$export$f3066f7c12fa0043)().filter((field)=>field.value !== 'delivery').filter((field)=>{
            const key = values.pickupTime === '' ? 'direct' : 'prebook';
            const name = field.asValue;
            // Check if availability data exists for this key
            if (!values.availability?.[key]?.availabilities) return false;
            const estateAvailability = values.availability[key].availabilities.find((item)=>'taxi' === item.serviceType);
            if (field.value === 'estate' && !estateAvailability?.vehicleOptions?.includes('stationWagon')) return false;
            return values.availability[key].availabilities.find((item)=>name === item.serviceType) !== undefined;
        }).map((field)=>{
            const key = values.pickupTime === '' ? 'direct' : 'prebook';
            const name = field.asValue;
            if (values.availability[key]?.availabilities?.length) {
                field.availability = values.availability[key].availabilities.find((item)=>name === item.serviceType);
                field.disabled = field.availability.availableAt === 'NOT_AVAILABLE';
            }
            // In edit mode, disable service types that aren't currently selected
            if (inEditMode && field.value !== values.serviceType) {
                field.disabled = true;
                field.hideDisabledPill = true; // Don't show pill when disabled in edit mode
            }
            if (showPrices) field.price = $868fdca409bb61c6$var$renderPrice(values.priceEstimate.prices, field.asValue);
            if (showPrices) field.originalPrice = $868fdca409bb61c6$var$getOriginalPrice(values.priceEstimate.prices, field.asValue);
            if (showDiscountPill) field.reducedPrice = $868fdca409bb61c6$var$getReducedPrice(values.priceEstimate.prices, field.asValue);
            if (field.value === values.serviceType) field.labelRef = carTypeRef;
            // Disable if passenger count exceeds this service type's capacity
            if (!field.disabled && values.passengerCount > 0 && field.availability?.maxTravelers > 0) {
                if (values.passengerCount > field.availability.maxTravelers) field.disabled = true;
            }
            return field;
        });
    }, [
        values.availability,
        values.pickupTime,
        values.serviceType,
        values.priceEstimate,
        values.passengerCount,
        inEditMode,
        showPrices,
        showDiscountPill
    ]);
    const wrappedNext = ()=>{
        if (shouldShowProviderSelection && !values.selectedProviderId) {
            setPartnerError(true);
            partnerHeadingRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
            return;
        }
        if (!user) next();
        else {
            (0, $ee4f9bead648b485$export$6b2a7d5132615086)('initiateCheckout', {
                carType: values.serviceType,
                preBook: values.pickupTime ? true : false,
                userId: user?.userId || false
            });
            next('confirm');
        }
    };
    (0, $bh6RR.useEffect)(()=>{
        if (values.selectedProviderId) setPartnerError(false);
    }, [
        values.selectedProviderId
    ]);
    // In edit mode, allow back navigation if time-related fields are editable
    // This allows users to go back to SelectTime but not to SelectLocations
    const isTimeEditable = values.editableFields?.includes('pickUpTimeStamp');
    // Check if location actually supports flight information
    const hasFlightInfoTag = values.departure?.locationInformation?.some((info)=>info.tag === 'FLIGHT_NBR');
    // Flight fields are only truly editable if the location supports flight info
    const isFlightNumberEditable = hasFlightInfoTag && values.editableFields?.includes('originLocation.flightInfo.flightNumber');
    const isCheckedBaggageEditable = hasFlightInfoTag && values.editableFields?.includes('originLocation.flightInfo.checkedInBaggage');
    const allowBackInEditMode = inEditMode && (isTimeEditable || isFlightNumberEditable || isCheckedBaggageEditable);
    inEditMode;
    const buttons = inEditMode && !allowBackInEditMode ? [
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ] : [
        {
            func: prev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        // Handle vehicle options from SAS here
        // In edit mode, only unset options if they're not currently selected
        if (!petAvailable && !(inEditMode && petCurrentlySelected)) setFieldValue('pet', false, false);
        if (!lowAvailable && !(inEditMode && lowCurrentlySelected)) setFieldValue('low', false, false);
        if (!stationWagonAvailable) setFieldValue('stationWagon', false, false);
        if (numSeatsMax === 0 && !(inEditMode && boosterCurrentlySelected)) setFieldValue('booster', 0, false);
        else if (numSeatsMax > 0 && values.booster > numSeatsMax) setFieldValue('booster', numSeatsMax, false);
    }, [
        petAvailable,
        lowAvailable,
        stationWagonAvailable,
        numSeatsMax,
        values.booster,
        setFieldValue,
        inEditMode,
        petCurrentlySelected,
        lowCurrentlySelected,
        boosterCurrentlySelected
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const newCompanyValue = company !== false ? company : false;
        const newIsCompanyTrip = company !== false;
        // Only update if values have actually changed
        if (values.company !== newCompanyValue || values.isCompanyTrip !== newIsCompanyTrip) {
            setFieldValue('company', newCompanyValue, false);
            setIsCompanyTrip(newIsCompanyTrip);
        }
    }, [
        company,
        values.company,
        values.isCompanyTrip,
        setFieldValue,
        setIsCompanyTrip
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (carTypeRef.current) carTypeRef.current.focus();
    }, [
        carTypeRef
    ]);
    // Auto-switch service type if the selected one is disabled by passenger count
    (0, $bh6RR.useEffect)(()=>{
        if (!values.passengerCount || inEditMode) return;
        const currentField = fields.find((f)=>f.value === values.serviceType);
        if (currentField?.disabled) {
            const firstFit = fields.find((f)=>!f.disabled);
            if (firstFit) setFieldValue('serviceType', firstFit.value, false);
        }
    }, [
        values.passengerCount,
        fields
    ]);
    // Auto-select the first available provider:
    // - Always select the first if none is selected
    // - Keep current selection if still available after service type / add-on change
    // - Fall back to first if current selection is no longer available
    (0, $bh6RR.useEffect)(()=>{
        if (!shouldShowProviderSelection || !multipleProviders?.length) {
            if (values.selectedProviderId) setFieldValue('selectedProviderId', '', false);
            return;
        }
        const currentStillAvailable = multipleProviders.some((p)=>p.providerData.providerId === values.selectedProviderId);
        if (!currentStillAvailable) setFieldValue('selectedProviderId', multipleProviders[0].providerData.providerId, false);
    }, [
        multipleProviders,
        shouldShowProviderSelection
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $868fdca409bb61c6$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: t('header-how-do-you-want-to-go')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                        fullscreen: fullscreen
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                        values: values,
                        showHow: true,
                        currentView: currentView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $868fdca409bb61c6$var$cx($f35967c56a9f3d99$exports.contentBottom, showCompany && !inEditMode ? 'app-lg:!pb-36' : 'app-lg:!pb-20'),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bc55ceba36084ea6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: t('header-how-do-you-want-to-go')
                    }),
                    partnerData && /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                        fullscreen: fullscreen,
                        forceMessages: [
                            CONFIG.svea_module ? "Svea Taxi Allians best\xe5r av ett n\xe4tverk av partners. Tillg\xe4ngliga tj\xe4nster kan variera " : "Du reser med en av v\xe5ra Svea Partner. Tillg\xe4ngliga tj\xe4nster kan variera."
                        ],
                        skipReadMore: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$exports.group,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $lW2XZ.Field), {
                                field: {
                                    name: 'fixedPrice',
                                    onChange: handleChange,
                                    onBlur: handleBlur,
                                    value: fixedPrice
                                },
                                tabIndex: "0",
                                title: t('title-fixed-price'),
                                disabled: disableFixedPrice || fixedPriceNotAvailable || taxameterNotAvailable || inEditMode,
                                component: (0, $f0b83ec70997a01f$export$2e2bcd8739ae039),
                                children: [
                                    inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: $f35967c56a9f3d99$exports.subtitle,
                                        children: "Kan inte \xe4ndras vid redigering"
                                    }),
                                    disableFixedPrice && !inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: $f35967c56a9f3d99$exports.subtitle,
                                        children: "Fastpris kr\xe4ver destination"
                                    }),
                                    fixedPriceNotAvailable && !disableFixedPrice && !inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: $f35967c56a9f3d99$exports.subtitle,
                                        children: t('info-fixed-price-not-available')
                                    }),
                                    taxameterNotAvailable && !disableFixedPrice && !fixedPriceNotAvailable && !inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: $f35967c56a9f3d99$exports.subtitle,
                                        children: t('info-taxameter-not-available')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "fixedPrice",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039),
                                        noMarginTop: true
                                    })
                                ]
                            }),
                            shouldShowProviderSelection && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "mt-4",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $3f9dfc4319f20848$export$2e2bcd8739ae039), {
                                    number: 1,
                                    title: t('header-select-car')
                                })
                            }),
                            fields.map((field, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    type: "radio",
                                    name: "serviceType",
                                    component: (0, $61cc6ab30242b4e5$export$2e2bcd8739ae039),
                                    ...field
                                }, index)),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "electric",
                                title: t('title-electric-car'),
                                info: t('info-electric-car'),
                                disabled: !electricCarAvailable,
                                component: (0, $ebfa6821d606098e$export$2e2bcd8739ae039)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$exports.group,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "-mx-2",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1dc82d3b40a7e000$export$7e993028413288c5), {
                                vehicleOptions: vehicleOptions,
                                editableVehicleOptions: editableVehicleOptions,
                                values: values,
                                inEditMode: inEditMode
                            })
                        })
                    }),
                    shouldShowProviderSelection && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "mt-6",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $703a2ef17cefd820$export$2e2bcd8739ae039), {
                            providers: multipleProviders,
                            sectionNumber: 2,
                            error: partnerError,
                            headingRef: partnerHeadingRef
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: true,
                children: showCompany && !inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                    icon1: "Private",
                    icon2: "Company",
                    name: "isCompanyTrip",
                    tabIndex: "0",
                    title: t('title-private-or-company'),
                    info: company?.name || t('info-private'),
                    noPadding: true,
                    component: (0, $e03c7e0a8499a421$export$2e2bcd8739ae039)
                })
            })
        ]
    });
};
$868fdca409bb61c6$var$SelectHow.validationSchema = null;
var $868fdca409bb61c6$export$2e2bcd8739ae039 = $868fdca409bb61c6$var$SelectHow;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class $ac1170d8eaf727fe$var$PopChildMeasure extends $bh6RR.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function $ac1170d8eaf727fe$export$1d6cdde0c6816c6d({ children: children, isPresent: isPresent }) {
    const id = (0, $bh6RR.useId)();
    const ref = (0, $bh6RR.useRef)(null);
    const size = (0, $bh6RR.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0
    });
    const { nonce: nonce } = (0, $bh6RR.useContext)((0, $f69ceb430ae9345a$export$22a697fb29aac98d));
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, $bh6RR.useInsertionEffect)(()=>{
        const { width: width, height: height, top: top, left: left } = size.current;
        if (isPresent || !ref.current || !width || !height) return;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            top: ${top}px !important;
            left: ${left}px !important;
          }
        `);
        return ()=>{
            document.head.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, $ih19M.jsx)($ac1170d8eaf727fe$var$PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        children: $bh6RR.cloneElement(children, {
            ref: ref
        })
    });
}


"use client";
const $1fc7283dda0b311f$export$979daf65881a382a = ({ children: children, initial: initial, isPresent: isPresent, onExitComplete: onExitComplete, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode })=>{
    const presenceChildren = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)($1fc7283dda0b311f$var$newChildrenMap);
    const id = (0, $bh6RR.useId)();
    const memoizedOnExitComplete = (0, $bh6RR.useCallback)((childId)=>{
        presenceChildren.set(childId, true);
        for (const isComplete of presenceChildren.values()){
            if (!isComplete) return; // can stop searching when any is incomplete
        }
        onExitComplete && onExitComplete();
    }, [
        presenceChildren,
        onExitComplete
    ]);
    const context = (0, $bh6RR.useMemo)(()=>({
            id: id,
            initial: initial,
            isPresent: isPresent,
            custom: custom,
            onExitComplete: memoizedOnExitComplete,
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        }), /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ presenceAffectsLayout ? [
        Math.random(),
        memoizedOnExitComplete
    ] : [
        isPresent,
        memoizedOnExitComplete
    ]);
    (0, $bh6RR.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ $bh6RR.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    if (mode === "popLayout") children = (0, $ih19M.jsx)((0, $ac1170d8eaf727fe$export$1d6cdde0c6816c6d), {
        isPresent: isPresent,
        children: children
    });
    return (0, $ih19M.jsx)((0, $12e60920c2394b39$export$f224e4635b6f8ce2).Provider, {
        value: context,
        children: children
    });
};
function $1fc7283dda0b311f$var$newChildrenMap() {
    return new Map();
}




var $bh6RR = parcelRequire("bh6RR");
const $b9f1ae3ae93aad5e$export$10e61aed958678dd = (child)=>child.key || "";
function $b9f1ae3ae93aad5e$export$872a3a1281f4b357(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, $bh6RR.Children).forEach(children, (child)=>{
        if ((0, $bh6RR.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}



"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const $86643c55894bf611$export$3ae376d12526dd6f = ({ children: children, custom: custom, initial: initial = true, onExitComplete: onExitComplete, presenceAffectsLayout: presenceAffectsLayout = true, mode: mode = "sync", propagate: propagate = false })=>{
    const [isParentPresent, safeToRemove] = (0, $11db8f3094dfc6f1$export$2a8c16d82a0a0e26)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, $bh6RR.useMemo)(()=>(0, $b9f1ae3ae93aad5e$export$872a3a1281f4b357)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, $b9f1ae3ae93aad5e$export$10e61aed958678dd));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, $bh6RR.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, $bh6RR.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, $9237e2773f81c3d0$export$fe4300aa8eebea86)(()=>new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, $bh6RR.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, $bh6RR.useState)(presentChildren);
    (0, $56377e0c81527360$export$700979bc83e7db82)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, $b9f1ae3ae93aad5e$export$10e61aed958678dd)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else exitComplete.delete(key);
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, $b9f1ae3ae93aad5e$export$10e61aed958678dd)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, $b9f1ae3ae93aad5e$export$872a3a1281f4b357)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender: forceRender } = (0, $bh6RR.useContext)((0, $364741b44296b530$export$a3579ca508007a95));
    return (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, $b9f1ae3ae93aad5e$export$10e61aed958678dd)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitComplete.has(key)) exitComplete.set(key, true);
                else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender === null || forceRender === void 0 || forceRender();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && (safeToRemove === null || safeToRemove === void 0 || safeToRemove());
                    onExitComplete && onExitComplete();
                }
            };
            return (0, $ih19M.jsx)((0, $1fc7283dda0b311f$export$979daf65881a382a), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: isPresent ? undefined : custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                onExitComplete: isPresent ? undefined : onExit,
                children: child
            }, key);
        })
    });
};












var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");










function $6a274741627bfde6$export$2e2bcd8739ae039({ onNotAvailable: onNotAvailable, onDatetimeBeforeNow: onDatetimeBeforeNow } = {}) {
    const { next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user, refreshUser: refreshUser, setPreferredPaymentAccount: setPreferredPaymentAccount, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setValues: setValues, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [pendingBookingId, setPendingBookingId] = (0, $bh6RR.useState)(null);
    const [waitingForPoll, setWaitingForPoll] = (0, $bh6RR.useState)(false);
    const timeoutRef = (0, $bh6RR.useRef)(null);
    const creditCardBookingIdRef = (0, $bh6RR.useRef)(null); // Set when prepareBooking returns; fallback when PAYMENT_MODAL_CLOSED never fires
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const sendToGTM = (values, bookingId)=>{
        const booking = (0, $200ec6b1b2ca8c5a$export$9f1f9dfacc50ba0)(values);
        const priceEntry = fixedPrice ? values.priceEstimate?.prices?.find((value)=>value.serviceType === booking.serviceType) : null;
        const price = priceEntry?.finalPrice || false;
        const trackData = {
            price: price,
            currency: 'SEK',
            preBook: values.pickupTime ? true : false,
            pickupTime: booking.pickUpTimeStamp,
            bookingNumber: bookingId,
            carType: booking.serviceType,
            extras: booking.vehicleOptions,
            fixedPrice: fixedPrice && booking.priceToken ? true : false,
            userId: user?.userId || false,
            ...values.originalBookingReference ? {
                returnTrip: true
            } : {}
        };
        (0, $ee4f9bead648b485$export$6b2a7d5132615086)('confirmBooking', trackData);
    };
    const handleBookingComplete = (response)=>{
        setIsLoading(false);
        setPendingBookingId(null);
        setWaitingForPoll(false);
        creditCardBookingIdRef.current = null;
        // Remember the booking the user just placed so BookingDone can offer a return trip when closed
        (0, $740a278ce29d303f$export$12eefddf5beacf4d)(response.bookingId);
        // Save preferred payment - include payment method for PayInCar
        setPreferredPaymentAccount(values.account, values.isCompanyTrip, values.payment);
        // IMPORTANT: Capture all current form values before any async operations
        // This prevents form values from being cleared during navigation
        const currentValues = {
            ...values
        };
        // Use setValues to update bookingId while preserving ALL other form values
        // This ensures form values are preserved when navigating to 'done'
        setValues({
            ...currentValues,
            bookingId: response.bookingId
        }, false);
        // Navigate first, then do async operations after navigation completes
        // Use setTimeout to ensure navigation happens in the next tick
        setTimeout(()=>{
            next('done');
            // Do async operations after navigation to prevent form reset
            setTimeout(()=>{
                getActiveBookings();
                refreshUser();
                sendToGTM(currentValues, response.bookingId);
            }, 100);
        }, 0);
    };
    // Credit card: the booking is prepared, then paid in the PIQ cashier. The bookingId is
    // tracked in localStorage so the booking can be recovered if the modal is closed.
    const startCreditCardPayment = (response)=>{
        // Track bookingId so PENDING_BOOKING_CONFIRMED can navigate even if PAYMENT_MODAL_CLOSED never fires
        creditCardBookingIdRef.current = response.bookingId;
        // Store bookingID in localStorage for recovery if payment modal is closed
        const pendingBookings = JSON.parse(localStorage.getItem('pendingCreditCardBookings') || '[]');
        if (!pendingBookings.includes(response.bookingId)) {
            pendingBookings.push(response.bookingId);
            localStorage.setItem('pendingCreditCardBookings', JSON.stringify(pendingBookings));
        }
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CASHIER_PAY_BOOKING', {
            bookingId: response.bookingId,
            accountId: values.account.accountId,
            success: ()=>{
                // Remove from pending bookings on success
                const updatedPending = JSON.parse(localStorage.getItem('pendingCreditCardBookings') || '[]').filter((id)=>id !== response.bookingId);
                localStorage.setItem('pendingCreditCardBookings', JSON.stringify(updatedPending));
                handleBookingComplete(response);
            },
            doneLoading: ()=>setIsLoading(false)
        });
    };
    const isUnauthorized = (error)=>error?.isUnauthorized || error?.status === 401 || error?.response?.status === 401 && error?.response?.error === 'Unauthorized';
    const placeBooking = ()=>{
        const isCreditCard = values.payment.indexOf('CreditCard') !== -1;
        const bookingFunc = isCreditCard ? (0, $135a523c4bea715f$export$59f37aaaaab070bd) : (0, $135a523c4bea715f$export$3877e99530b0c773);
        setIsLoading(true);
        bookingFunc(values, user.userId).then((response)=>{
            if (!isNaN(response?.bookingId)) {
                if (isCreditCard) startCreditCardPayment(response);
                else handleBookingComplete(response);
            }
        }).catch(async (error)=>{
            if (error?.response?.error === 'INVALID_SERVICE_TOKEN_SERVICE') {
                try {
                    // The booking may have used autoValues.pickupTime (a delayed time) rather than
                    // values.pickupTime. Use that same effective time for the service-availability
                    // refetch so the dateTime param matches what was actually sent to /bookings.
                    const effectivePickupTime = values.autoValues?.pickupTime || values.pickupTime;
                    const valuesForAvailability = effectivePickupTime !== values.pickupTime ? {
                        ...values,
                        pickupTime: effectivePickupTime
                    } : values;
                    const freshAvail = (0, $c94184dfef1a7d71$export$52403c2973de3b69)(await (0, $135a523c4bea715f$export$740face6f9071f68)(valuesForAvailability, user));
                    const availKey = values.pickupTime === '' ? 'direct' : 'prebook';
                    const hasAsRequested = freshAvail?.servicesByProvider ? freshAvail.servicesByProvider.some((p)=>p.availabilities?.some((a)=>a.availableAt === 'AS_REQUESTED')) : freshAvail?.availabilities?.some((a)=>a.availableAt === 'AS_REQUESTED');
                    if (!hasAsRequested) {
                        setFieldValue(`availability.${availKey}`, freshAvail, false);
                        setIsLoading(false);
                        onNotAvailable?.();
                        return;
                    }
                    // Update Formik so the form stays in sync with the fresh token
                    setFieldValue(`availability.${availKey}`, freshAvail, false);
                    // Retry with fresh availability inline (Formik update is async, can't rely on it)
                    const updatedValues = {
                        ...values,
                        availability: {
                            ...values.availability,
                            [availKey]: freshAvail
                        }
                    };
                    const retryResponse = await bookingFunc(updatedValues, user.userId);
                    if (!isNaN(retryResponse?.bookingId)) {
                        if (isCreditCard) startCreditCardPayment(retryResponse);
                        else handleBookingComplete(retryResponse);
                    }
                } catch (retryError) {
                    if (retryError?.response?.error === 'DATETIME_BEFORE_NOW') {
                        setIsLoading(false);
                        onDatetimeBeforeNow?.();
                        return;
                    }
                    if (!isUnauthorized(retryError)) (0, $30acdccbb47e8004$export$eb122250488b74d5)(retryError?.response?.message || retryError?.message || 'Ett fel uppstod');
                    setIsLoading(false);
                }
                return;
            }
            if (error?.response?.error === 'INVALID_PHONE_NUMBER') setFieldError('phone', error?.response?.message);
            else if (!isUnauthorized(error)) {
                console.error(error);
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
            setIsLoading(false);
        });
    };
    // Listen for payment modal closed event
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('PAYMENT_MODAL_CLOSED', ({ bookingId: bookingId })=>{
        if (bookingId && !isNaN(bookingId)) {
            setPendingBookingId(bookingId);
            setWaitingForPoll(true);
            setIsLoading(true); // Show spinner - this will disable the button
            // Emit event to disable all interactions in booking module
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_WAITING_FOR_POLL', {
                waiting: true
            });
            // Set a timeout to enable button if no poll completes within reasonable time
            // This handles the case where user closes modal before any poll happens
            timeoutRef.current = setTimeout(()=>{
                setWaitingForPoll(false);
                setIsLoading(false);
                (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_WAITING_FOR_POLL', {
                    waiting: false
                });
                timeoutRef.current = null;
            }, 12000);
        }
    }, []);
    // Listen for pending booking confirmation
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('PENDING_BOOKING_CONFIRMED', ({ bookingId: bookingId })=>{
        // Race condition: poll fires while PIQ modal is still open (PAYMENT_MODAL_CLOSED not yet fired).
        // FormikListener handles navigation in this case; we only need to save the preference here.
        if (creditCardBookingIdRef.current === bookingId && pendingBookingId !== bookingId) {
            creditCardBookingIdRef.current = null;
            setPreferredPaymentAccount(values.account, values.isCompanyTrip, values.payment);
        }
        if (pendingBookingId === bookingId) {
            creditCardBookingIdRef.current = null;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            setPendingBookingId(null);
            setWaitingForPoll(false);
            setIsLoading(false);
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_WAITING_FOR_POLL', {
                waiting: false
            });
            (0, $740a278ce29d303f$export$12eefddf5beacf4d)(bookingId);
            setPreferredPaymentAccount(values.account, values.isCompanyTrip, values.payment);
            const currentValues = {
                ...values
            };
            setValues({
                ...currentValues,
                bookingId: bookingId
            }, false);
            setTimeout(()=>{
                next('done');
                setTimeout(()=>{
                    getActiveBookings();
                    refreshUser();
                    sendToGTM(currentValues, bookingId);
                }, 100);
            }, 0);
        }
    }, [
        pendingBookingId,
        setValues,
        next,
        values,
        setPreferredPaymentAccount,
        getActiveBookings,
        refreshUser
    ]);
    // Listen for payment/booking failure (statusCode 190)
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('PENDING_BOOKING_FAILED', ({ bookingId: bookingId })=>{
        if (pendingBookingId === bookingId || creditCardBookingIdRef.current === bookingId) {
            creditCardBookingIdRef.current = null;
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            setPendingBookingId(null);
            setWaitingForPoll(false);
            setIsLoading(false);
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_WAITING_FOR_POLL', {
                waiting: false
            });
            (0, $30acdccbb47e8004$export$eb122250488b74d5)((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('error-payment'));
        }
    }, [
        pendingBookingId,
        waitingForPoll
    ]);
    // Listen for first poll result - if booking not confirmed, enable button
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('FIRST_POLL_COMPLETE', ({ bookingId: bookingId })=>{
        if (pendingBookingId === bookingId && waitingForPoll) {
            // Clear timeout since poll completed
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            // First poll completed but booking not confirmed - enable button
            setWaitingForPoll(false);
            setIsLoading(false);
            // Re-enable all interactions
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_WAITING_FOR_POLL', {
                waiting: false
            });
        // Keep pendingBookingId so we can still navigate if it gets confirmed later
        }
    }, [
        pendingBookingId,
        waitingForPoll
    ]);
    return {
        placeBooking: placeBooking,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        waitingForPoll: waitingForPoll
    };
}







var $f32c3824ac71a1eb$export$76174c80c75f9baa;
var $f32c3824ac71a1eb$export$5cf73536239227d6;
var $f32c3824ac71a1eb$export$9d70389615de760d;
var $f32c3824ac71a1eb$export$43932195d679aeb8;
var $f32c3824ac71a1eb$export$8e8ef14327394d2d;
var $f32c3824ac71a1eb$export$2ba01fb71ed41cb6;
var $f32c3824ac71a1eb$export$8ce26137b68253e6;
var $f32c3824ac71a1eb$export$f86455e47a9336bd;
var $f32c3824ac71a1eb$export$1ca1ec8b29a4ce27;
var $f32c3824ac71a1eb$export$a80b3bd66acc52ff;
var $f32c3824ac71a1eb$export$21ba78b50397401d;
var $f32c3824ac71a1eb$export$efefed464537bbb5;
var $f32c3824ac71a1eb$export$a8ecead220dd38a6;
var $f32c3824ac71a1eb$export$c197cb2257df8828;
var $f32c3824ac71a1eb$export$7438695bb8f63a91;
var $f32c3824ac71a1eb$export$487a3752a608c2d;
var $f32c3824ac71a1eb$export$fb184b623420d9be;
var $f32c3824ac71a1eb$export$761648c26da3b71b;
var $f32c3824ac71a1eb$export$cc74dcc53cfce4eb;
$f32c3824ac71a1eb$export$76174c80c75f9baa = `mS3upG_addButton`;
$f32c3824ac71a1eb$export$5cf73536239227d6 = `mS3upG_addPaymentItem`;
$f32c3824ac71a1eb$export$9d70389615de760d = `mS3upG_addPaymentItemTitle`;
$f32c3824ac71a1eb$export$43932195d679aeb8 = `mS3upG_addPaymentPanel`;
$f32c3824ac71a1eb$export$8e8ef14327394d2d = `mS3upG_addPaymentPanelTitle`;
$f32c3824ac71a1eb$export$2ba01fb71ed41cb6 = `mS3upG_button`;
$f32c3824ac71a1eb$export$8ce26137b68253e6 = `mS3upG_dimmer`;
$f32c3824ac71a1eb$export$f86455e47a9336bd = `mS3upG_focus-visible`;
$f32c3824ac71a1eb$export$1ca1ec8b29a4ce27 = `mS3upG_icon`;
$f32c3824ac71a1eb$export$a80b3bd66acc52ff = `mS3upG_info`;
$f32c3824ac71a1eb$export$21ba78b50397401d = `mS3upG_instructions`;
$f32c3824ac71a1eb$export$efefed464537bbb5 = `mS3upG_marginTop`;
$f32c3824ac71a1eb$export$a8ecead220dd38a6 = `mS3upG_message`;
$f32c3824ac71a1eb$export$c197cb2257df8828 = `mS3upG_panelGray`;
$f32c3824ac71a1eb$export$7438695bb8f63a91 = `mS3upG_panelPadding`;
$f32c3824ac71a1eb$export$487a3752a608c2d = `mS3upG_subHeader`;
$f32c3824ac71a1eb$export$fb184b623420d9be = `mS3upG_title`;
$f32c3824ac71a1eb$export$761648c26da3b71b = `mS3upG_vouchersPanel`;
$f32c3824ac71a1eb$export$cc74dcc53cfce4eb = `mS3upG_wrapper`;


var $234ae484ae699dc2$exports = {};

$parcel$export($234ae484ae699dc2$exports, "alternateBackground", function () { return $234ae484ae699dc2$export$7c7945898a349c4d; }, function (v) { return $234ae484ae699dc2$export$7c7945898a349c4d = v; });
$parcel$export($234ae484ae699dc2$exports, "error", function () { return $234ae484ae699dc2$export$a3bc9b8ed74fc; }, function (v) { return $234ae484ae699dc2$export$a3bc9b8ed74fc = v; });
$parcel$export($234ae484ae699dc2$exports, "fullscreen", function () { return $234ae484ae699dc2$export$af93ab412ae68734; }, function (v) { return $234ae484ae699dc2$export$af93ab412ae68734 = v; });
$parcel$export($234ae484ae699dc2$exports, "infoText", function () { return $234ae484ae699dc2$export$fda920bf43776f02; }, function (v) { return $234ae484ae699dc2$export$fda920bf43776f02 = v; });
$parcel$export($234ae484ae699dc2$exports, "isOpen", function () { return $234ae484ae699dc2$export$ea0830439c7fc698; }, function (v) { return $234ae484ae699dc2$export$ea0830439c7fc698 = v; });
$parcel$export($234ae484ae699dc2$exports, "noPadding", function () { return $234ae484ae699dc2$export$21f8faa572cd92e9; }, function (v) { return $234ae484ae699dc2$export$21f8faa572cd92e9 = v; });
$parcel$export($234ae484ae699dc2$exports, "noTopMargin", function () { return $234ae484ae699dc2$export$64456f4a1e59b800; }, function (v) { return $234ae484ae699dc2$export$64456f4a1e59b800 = v; });
$parcel$export($234ae484ae699dc2$exports, "overlay", function () { return $234ae484ae699dc2$export$29dd17c7f3c81c36; }, function (v) { return $234ae484ae699dc2$export$29dd17c7f3c81c36 = v; });
$parcel$export($234ae484ae699dc2$exports, "panel", function () { return $234ae484ae699dc2$export$21f42ab9b6679f44; }, function (v) { return $234ae484ae699dc2$export$21f42ab9b6679f44 = v; });
$parcel$export($234ae484ae699dc2$exports, "panelContent", function () { return $234ae484ae699dc2$export$de08decf4c56dbc9; }, function (v) { return $234ae484ae699dc2$export$de08decf4c56dbc9 = v; });
$parcel$export($234ae484ae699dc2$exports, "title", function () { return $234ae484ae699dc2$export$fb184b623420d9be; }, function (v) { return $234ae484ae699dc2$export$fb184b623420d9be = v; });
$parcel$export($234ae484ae699dc2$exports, "wrapper", function () { return $234ae484ae699dc2$export$cc74dcc53cfce4eb; }, function (v) { return $234ae484ae699dc2$export$cc74dcc53cfce4eb = v; });
var $234ae484ae699dc2$export$7c7945898a349c4d;
var $234ae484ae699dc2$export$a3bc9b8ed74fc;
var $234ae484ae699dc2$export$af93ab412ae68734;
var $234ae484ae699dc2$export$fda920bf43776f02;
var $234ae484ae699dc2$export$ea0830439c7fc698;
var $234ae484ae699dc2$export$21f8faa572cd92e9;
var $234ae484ae699dc2$export$64456f4a1e59b800;
var $234ae484ae699dc2$export$29dd17c7f3c81c36;
var $234ae484ae699dc2$export$21f42ab9b6679f44;
var $234ae484ae699dc2$export$de08decf4c56dbc9;
var $234ae484ae699dc2$export$fb184b623420d9be;
var $234ae484ae699dc2$export$cc74dcc53cfce4eb;
$234ae484ae699dc2$export$7c7945898a349c4d = `M00oNW_alternateBackground`;
$234ae484ae699dc2$export$a3bc9b8ed74fc = `M00oNW_error`;
$234ae484ae699dc2$export$af93ab412ae68734 = `M00oNW_fullscreen`;
$234ae484ae699dc2$export$fda920bf43776f02 = `M00oNW_infoText`;
$234ae484ae699dc2$export$ea0830439c7fc698 = `M00oNW_isOpen`;
$234ae484ae699dc2$export$21f8faa572cd92e9 = `M00oNW_noPadding`;
$234ae484ae699dc2$export$64456f4a1e59b800 = `M00oNW_noTopMargin`;
$234ae484ae699dc2$export$29dd17c7f3c81c36 = `M00oNW_overlay`;
$234ae484ae699dc2$export$21f42ab9b6679f44 = `M00oNW_panel`;
$234ae484ae699dc2$export$de08decf4c56dbc9 = `M00oNW_panelContent`;
$234ae484ae699dc2$export$fb184b623420d9be = `M00oNW_title`;
$234ae484ae699dc2$export$cc74dcc53cfce4eb = `M00oNW_wrapper`;






var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");

var $5TnqA = parcelRequire("5TnqA");


var $c5a3c1ab9b05ca83$exports = {};

$parcel$export($c5a3c1ab9b05ca83$exports, "message", function () { return $c5a3c1ab9b05ca83$export$a8ecead220dd38a6; }, function (v) { return $c5a3c1ab9b05ca83$export$a8ecead220dd38a6 = v; });
$parcel$export($c5a3c1ab9b05ca83$exports, "title", function () { return $c5a3c1ab9b05ca83$export$fb184b623420d9be; }, function (v) { return $c5a3c1ab9b05ca83$export$fb184b623420d9be = v; });
$parcel$export($c5a3c1ab9b05ca83$exports, "wrapper", function () { return $c5a3c1ab9b05ca83$export$cc74dcc53cfce4eb; }, function (v) { return $c5a3c1ab9b05ca83$export$cc74dcc53cfce4eb = v; });
var $c5a3c1ab9b05ca83$export$a8ecead220dd38a6;
var $c5a3c1ab9b05ca83$export$fb184b623420d9be;
var $c5a3c1ab9b05ca83$export$cc74dcc53cfce4eb;
$c5a3c1ab9b05ca83$export$a8ecead220dd38a6 = `hB6uvW_message`;
$c5a3c1ab9b05ca83$export$fb184b623420d9be = `hB6uvW_title`;
$c5a3c1ab9b05ca83$export$cc74dcc53cfce4eb = `hB6uvW_wrapper`;


const $6b31562d915eea0d$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA))).bind($c5a3c1ab9b05ca83$exports);
function $6b31562d915eea0d$export$2e2bcd8739ae039({ innerRef: innerRef, isOptionsOpen: isOptionsOpen, onClose: onClose }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $c5a3c1ab9b05ca83$exports.wrapper,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $c5a3c1ab9b05ca83$exports.title,
                children: t('title-message-to-driver')
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                name: "generalComment",
                placeholder: t('title-message-to-driver'),
                tabIndex: isOptionsOpen ? 0 : -1,
                innerRef: innerRef,
                maxLength: "30",
                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: [
                    {
                        func: onClose,
                        title: t('button-save')
                    }
                ]
            })
        ]
    });
}


const $e68f4d42f1872239$var$getPaymentText = (values)=>{
    if (values.payment.indexOf('Account') !== -1) return values?.account?.accountName;
    else if (values.payment.indexOf('CreditCard') !== -1) return values?.account?.maskedAccount;
    else if (values.payment === 'Klarna') return 'Klarna';
    else if (values.payment === 'ApplePay') return 'Apple Pay';
    return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-pay-in-car');
};
const $e68f4d42f1872239$var$renderVoucherInfo = (voucher)=>{
    let str = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('expires-at', {
        date: (0, $200ec6b1b2ca8c5a$export$f0a889078b7435f7)(new Date(voucher.expiry))
    });
    if (voucher.valueType == 'PERCENTAGE') return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            str,
            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
            (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-voucher-max', {
                amount: voucher.maxPriceToBeDiscounted
            })
        ]
    });
    return str;
};
const $e68f4d42f1872239$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $e68f4d42f1872239$var$ConfirmBooking = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const paymentButtonRef = (0, $bh6RR.useRef)();
    const payInCarRef = (0, $bh6RR.useRef)();
    const optionsButtonRef = (0, $bh6RR.useRef)();
    const messageFieldRef = (0, $bh6RR.useRef)();
    const nameFieldRef = (0, $bh6RR.useRef)();
    const [isPaymentOpen, setIsPaymentOpen] = (0, $bh6RR.useState)(false);
    const [isOptionsOpen, setIsOptionsOpen] = (0, $bh6RR.useState)(false);
    const [isPaymentModuleOpen, setIsPaymentModuleOpen] = (0, $bh6RR.useState)(false);
    const showPaymentModule = ()=>{
        setIsPaymentModuleOpen(true);
    };
    const hidePaymentModule = ()=>{
        setIsPaymentModuleOpen(false);
    };
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { config: config, user: user, paymentAccounts: paymentAccounts, refreshUser: refreshUser, setCurrentPaymentAccount: setCurrentPaymentAccount, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { errors: errors, touched: touched, values: values, setFieldValue: setFieldValue, setValues: setValues } = (0, $lW2XZ.useFormikContext)();
    const paymentError = (0, $lW2XZ.getIn)(errors, 'payment');
    // Placing a new booking (incl. credit card payment and the pending-booking poll) is
    // shared with the return trip sheet; editing an existing booking stays here.
    const { placeBooking: placeBooking, isLoading: isLoading, setIsLoading: setIsLoading, waitingForPoll: waitingForPoll } = (0, $6a274741627bfde6$export$2e2bcd8739ae039)({
        onNotAvailable: ()=>prev('how'),
        onDatetimeBeforeNow: ()=>prev('time')
    });
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const disableCreditCards = !values.priceType?.paymentMethods?.includes('CreditCard');
    const disableTSABAccounts = !values.priceType?.paymentMethods?.includes('TSABAccount');
    const disableTCAAccounts = !values.priceType?.paymentMethods?.includes('TravelClearingAccount');
    const disablePayInCar = !values.priceType?.paymentMethods?.includes('PayInCar');
    const noPaymentMethodsAvailable = values.priceType !== undefined && Array.isArray(values.priceType?.paymentMethods) && values.priceType.paymentMethods.length === 0;
    const selectedPaymentMethodKey = (0, $c94184dfef1a7d71$export$369f738c5ad4634)(values.payment, values.account);
    const disableVouchers = selectedPaymentMethodKey && values.priceType?.paymentMethodConfigurations ? !values.priceType.paymentMethodConfigurations.find((c)=>c.paymentMethod === selectedPaymentMethodKey)?.voucherEnabled : !values.priceType?.voucherEnabled;
    const availabilityKey = values.pickupTime === '' ? 'direct' : 'prebook';
    const servicesByProvider = values.availability?.[availabilityKey]?.servicesByProvider;
    const hasMultipleProviders = Array.isArray(servicesByProvider) && servicesByProvider.length > 1 && !(servicesByProvider.length === 1 && servicesByProvider[0].providerData?.providerId === 'TSAB');
    const voucherDisabledMessage = (()=>{
        if (!disableVouchers) return null;
        const configs = values.priceType?.paymentMethodConfigurations;
        if (configs?.some((c)=>c.voucherEnabled)) return t('info-voucher-disabled-payment-method');
        if (hasMultipleProviders) return t('info-voucher-disabled-provider');
        if (!fixedPrice) return t('info-voucher-disabled-taxameter');
        return null;
    })();
    const prevAccounts = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(user?.accounts);
    const prevPaymentAccounts = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(paymentAccounts);
    const prevVouchers = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(user?.vouchers);
    const hasAccounts = user?.accounts?.length > 0;
    const hasCreditCards = paymentAccounts?.length > 0;
    const hasVouchers = user?.vouchers?.length > 0;
    const showReference = values?.company !== false || values?.account?.type === 'TSAB' || values?.account?.type === 'TCA';
    // In edit mode, use isReferenceRequired from API if available
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const showPaymentEmptyState = !inEditMode && (noPaymentMethodsAvailable || disablePayInCar && !hasCreditCards && !hasAccounts);
    const isReferenceEditable = inEditMode ? values.editableFields?.includes('invoiceReference') : true;
    const needReference = inEditMode && values.editableOptions?.isReferenceRequired !== undefined ? values.editableOptions.isReferenceRequired : values?.company?.requireReference === true || values?.account !== false && (values?.account?.type === 'TSAB' || values?.account?.type === 'TCA') && values?.account?.flags?.includes('reference');
    const makeRequest = ()=>{
        const isEditMode = !isNaN(values.bookingId);
        if (isEditMode) {
            // Edit existing booking
            setIsLoading(true);
            (0, $135a523c4bea715f$export$9bd5699329fe0aaa)(values.bookingId, values).then((response)=>{
                if (response.newPrice) {
                    const editToken = response.editToken;
                    (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(t('info-price-change', {
                        newPrice: response.newPrice.finalPrice
                    }), [
                        {
                            title: t('button-reject-price')
                        },
                        {
                            title: t('button-accept-price'),
                            callback: ()=>confirmEditBooking(editToken)
                        }
                    ], {
                        title: t('header-price-change')
                    });
                    setIsLoading(false);
                } else // No price change, confirm edit directly
                confirmEditBooking(response.editToken);
            }).catch((error)=>{
                console.error("Error on edit estimate:", error);
                if (!(error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message);
                setIsLoading(false);
            });
        } else // Create new booking
        placeBooking();
    };
    const confirmEditBooking = (editToken)=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$c3b4580b68ed2909)(values.bookingId, editToken).then(()=>{
            // Refresh store in the background while fetching fresh booking data
            getActiveBookings();
            refreshUser();
            return (0, $135a523c4bea715f$export$98a8f978e5e12ae4)(values.bookingId);
        }).then((updatedBooking)=>{
            // Patch bookingType from original booking data if the single-booking API omits it.
            // The active-bookings list endpoint includes bookingType; the single-booking endpoint
            // may not. Without it BookingDone falls back to 'Söker bil' for status 120 prebookings.
            const originalBookingType = values.booking?.bookingType;
            const patchedBooking = updatedBooking && !updatedBooking.bookingType && originalBookingType ? {
                ...updatedBooking,
                bookingType: originalBookingType
            } : updatedBooking;
            // Use setValues (atomic) + setTimeout like handleBookingComplete so all form values
            // are committed before BookingDone renders — prevents a race where values.booking
            // is null on the first render and effectiveBooking resolves to null.
            const currentValues = {
                ...values
            };
            setValues({
                ...currentValues,
                booking: patchedBooking
            }, false);
            setIsLoading(false);
            setTimeout(()=>next('done'), 0);
        }).catch((error)=>{
            console.error("Error confirming edit:", error);
            if (!(error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message);
            setIsLoading(false);
        });
    };
    const wrappedPrev = ()=>{
        prev('how');
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    const setAccount = (account)=>{
        if (!account) setFieldValue('accountReference', '', false);
        setFieldValue('account', account, false);
    };
    const openOptions = ()=>{
        setIsOptionsOpen(true);
        setTimeout(()=>{
            if (messageFieldRef.current) messageFieldRef.current.focus();
        }, 200);
    };
    const closeOptions = ()=>{
        setIsOptionsOpen(false);
        if (optionsButtonRef.current) optionsButtonRef.current.focus();
    };
    const openPayment = ()=>{
        setIsPaymentOpen(true);
        setTimeout(()=>{
            if (payInCarRef.current) payInCarRef.current.focus();
        }, 200);
    };
    const closePayment = ()=>{
        setIsPaymentOpen(false);
        if (paymentButtonRef.current) paymentButtonRef.current.focus();
    };
    const addCard = ()=>{
        hidePaymentModule();
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CASHIER_ADD_CARD', {
            success: refreshUser
        });
    };
    const openAddAccount = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $f5a01b8c00777f68$export$2e2bcd8739ae039), {
                onComplete: ()=>{
                    close();
                    hidePaymentModule();
                }
            }));
    const openAddVoucher = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $006192e901cb3229$export$2e2bcd8739ae039), {
                onComplete: close
            }));
    const openReference = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue(id, val, false),
                fields: [
                    {
                        id: 'accountReference',
                        title: t('placeholder-reference')
                    }
                ],
                title: t('placeholder-reference'),
                onClose: close
            }));
    const buttons = [
        {
            func: wrappedPrev,
            isBack: true
        },
        {
            func: waitingForPoll || isLoading ? ()=>{} : wrappedNext,
            title: inEditMode ? t('button-confirm-edit') : t('button-book-now'),
            isLoading: isLoading || waitingForPoll,
            disabled: waitingForPoll || isLoading // Disable button while waiting for poll or loading
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        if (user?.accounts?.length > prevAccounts?.length) {
            const addedAccount = user?.accounts?.find((a)=>{
                return prevAccounts.find((b)=>b.accountNumber === a.accountNumber) === undefined ? true : false;
            });
            if (addedAccount !== undefined) {
                setFieldValue('payment', `Account-${addedAccount.accountNumber}`, false);
                setAccount(addedAccount);
            }
        }
    }, [
        user?.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (paymentAccounts?.length > prevPaymentAccounts?.length) {
            const addedAccount = paymentAccounts.find((a)=>{
                return prevPaymentAccounts.find((b)=>b.accountId === a.accountId) === undefined ? true : false;
            });
            if (addedAccount !== undefined) {
                setFieldValue('payment', `CreditCard-${addedAccount.accountId}`, false);
                setAccount(addedAccount);
            }
        }
    }, [
        paymentAccounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (user?.vouchers?.length > prevVouchers?.length) {
            const addedVoucher = user?.vouchers?.find((a)=>{
                return prevVouchers.find((b)=>b.voucherCode === a.voucherCode) === undefined ? true : false;
            });
            if (addedVoucher !== undefined) {
                if (!disableVouchers) setFieldValue('vouchers', [
                    addedVoucher.voucherCode
                ], false);
            }
        }
    }, [
        user?.vouchers
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (disableVouchers && values.vouchers?.length > 0) setFieldValue('vouchers', [], false);
    }, [
        disableVouchers
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (nameFieldRef.current) nameFieldRef.current.focus();
    }, [
        nameFieldRef
    ]);
    const contentOptions = true;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $e68f4d42f1872239$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            isLoading: isLoading,
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: inEditMode ? t('header-confirm-edit') : t('header-confirm-your-booking')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                        fullscreen: fullscreen
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                        values: values,
                        showHow: true,
                        showPayment: true,
                        currentView: currentView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $bc55ceba36084ea6$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('header-confirm-edit') : t('header-confirm-your-booking')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $e68f4d42f1872239$var$cx('text-[18px] font-semibold tracking-[0.54px] leading-normal -mb-2 mb-2', paymentError ? 'text-[#da0a2b]' : 'text-on-surface'),
                        children: t('title-payment')
                    }),
                    inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $234ae484ae699dc2$export$fda920bf43776f02,
                        children: "Kan inte \xe4ndras vid redigering"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "PayInCar",
                        name: "payment",
                        title: "DefaultNoSelect",
                        value: "DefaultNoSelect",
                        hidden: true,
                        onClick: ()=>{
                            setAccount(false);
                            setCurrentPaymentAccount(false, values.isCompanyTrip, 'DefaultNoSelect');
                        },
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: inEditMode
                    }),
                    (!disablePayInCar || inEditMode && values.payment === 'PayInCar') && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "PayInCar",
                        name: "payment",
                        title: t('title-pay-in-car'),
                        value: "PayInCar",
                        onClick: ()=>{
                            setAccount(false);
                            setCurrentPaymentAccount(false, values.isCompanyTrip, 'PayInCar');
                        },
                        innerRef: payInCarRef,
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: inEditMode && values.payment !== 'PayInCar'
                    }),
                    showPaymentEmptyState && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8edb314d6528ebec$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: "/app/themes/taxi-stockholm/static/img/icons/icon-payments.png",
                            alt: "",
                            className: "size-8 object-contain"
                        }),
                        title: t('header-no-payment-methods'),
                        description: t('info-no-payment-methods')
                    }),
                    inEditMode && values.payment === 'Klarna' && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "Klarna",
                        name: "payment",
                        title: "Klarna",
                        value: "Klarna",
                        onClick: ()=>{
                            setAccount(false);
                            setCurrentPaymentAccount(false, values.isCompanyTrip, 'Klarna');
                        },
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: false
                    }),
                    inEditMode && values.payment === 'ApplePay' && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "ApplePay",
                        name: "payment",
                        title: "Apple Pay",
                        value: "ApplePay",
                        onClick: ()=>{
                            setAccount(false);
                            setCurrentPaymentAccount(false, values.isCompanyTrip, 'ApplePay');
                        },
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: false
                    }),
                    paymentAccounts?.map((account, index)=>{
                        const isSelected = values.payment === `CreditCard-${account.accountId}`;
                        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                            type: "radio",
                            name: "payment",
                            icon: `Card${account.cardType}`,
                            title: account.maskedAccount,
                            info: account.cardType,
                            value: `CreditCard-${account.accountId}`,
                            onClick: ()=>{
                                setAccount(account), setCurrentPaymentAccount(account, values.isCompanyTrip);
                            },
                            tabIndex: isPaymentOpen ? 0 : -1,
                            disabled: inEditMode && !isSelected || disableCreditCards,
                            disabledDescription: disableCreditCards && !fixedPrice ? "Fastpris kr\xe4vs" : disableCreditCards ? "Inte tillg\xe4ngligt" : null,
                            component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                        }, index);
                    }),
                    inEditMode && values.account?.isOrphaned && values.account?.type === 'creditcard' && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "PayInCar",
                        name: "payment",
                        title: values.account.maskedAccount,
                        info: "(Inte l\xe4ngre tillg\xe4ngligt)",
                        value: values.payment,
                        onClick: ()=>{
                            setAccount(values.account), setCurrentPaymentAccount(values.account, values.isCompanyTrip);
                        },
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: false
                    }),
                    user?.accounts?.map((account, index)=>{
                        const isSelected = values.payment === `Account-${account.accountNumber}`;
                        const disableNoDestination = account?.flags?.includes('destination') && (values?.destination === "" || values?.destination === undefined || values?.destination === null) ? true : false;
                        const disableOnlyCompany = account?.restrictedToCompanyId && account?.restrictedToCompanyId !== values?.company?.id ? true : false;
                        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                            type: "radio",
                            name: "payment",
                            icon: "TSAB",
                            title: account.accountName,
                            info: account.accountNumber,
                            value: `Account-${account.accountNumber}`,
                            onClick: ()=>{
                                setAccount(account), setCurrentPaymentAccount(account, values.isCompanyTrip);
                            },
                            tabIndex: isPaymentOpen ? 0 : -1,
                            disabledDescription: disableNoDestination ? "Destination kr\xe4vs" : disableOnlyCompany ? "Endast f\xf6retagskonto" : account.type === 'TSAB' && disableTSABAccounts || account.type === 'TCA' && disableTCAAccounts ? "Inte tillg\xe4ngligt" : null,
                            disabled: inEditMode && !isSelected || disableNoDestination || disableOnlyCompany || account.type === 'TSAB' && disableTSABAccounts || account.type === 'TCA' && disableTCAAccounts,
                            component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                        }, index);
                    }),
                    inEditMode && values.account?.isOrphaned && (values.account?.type === 'TSAB' || values.account?.type === 'TCA') && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "TSAB",
                        name: "payment",
                        title: values.account.accountName,
                        info: `${values.account.accountNumber} (Inte l\xe4ngre tillg\xe4ngligt)`,
                        value: values.payment,
                        onClick: ()=>{
                            setAccount(values.account), setCurrentPaymentAccount(values.account, values.isCompanyTrip);
                        },
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039),
                        disabled: false
                    }),
                    showReference && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $2ca492d729f5176c$export$2e2bcd8739ae039), {
                                title: t('placeholder-reference'),
                                value: !values.accountReference || values.accountReference.trim() === '' ? needReference && touched.accountReference ? t('validation-need-reference') : '' : values.accountReference,
                                onEdit: isReferenceEditable ? openReference : null,
                                required: true,
                                empty: (!values.accountReference || values.accountReference.trim() === '') && needReference && !!touched.accountReference
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$exports.hidden,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "accountReference",
                                    placeholder: t('placeholder-reference'),
                                    maxLength: "40",
                                    component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                                })
                            })
                        ]
                    }),
                    !inEditMode && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "py-1",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $25ea23ed8632858c$export$2e2bcd8739ae039), {
                            label: t('button-add-payment'),
                            onClick: showPaymentModule,
                            tabIndex: isPaymentOpen ? 0 : -1
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
                        children: [
                            isPaymentModuleOpen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
                                initial: {
                                    opacity: 0
                                },
                                exit: {
                                    opacity: 0
                                },
                                animate: {
                                    opacity: 1
                                },
                                className: $f32c3824ac71a1eb$export$8ce26137b68253e6,
                                onClick: hidePaymentModule
                            }),
                            isPaymentModuleOpen && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
                                transition: {
                                    duration: 0.15,
                                    ease: "circOut"
                                },
                                style: {
                                    originY: 0
                                },
                                initial: {
                                    scaleY: 0,
                                    height: 'auto'
                                },
                                exit: {
                                    scaleY: 0,
                                    height: 0
                                },
                                animate: {
                                    scaleY: 1
                                },
                                className: $f32c3824ac71a1eb$export$43932195d679aeb8,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $f32c3824ac71a1eb$export$8e8ef14327394d2d,
                                        children: "L\xe4gg till betalmetod"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fa620ad2e74576c$export$2e2bcd8739ae039), {
                                        onClick: hidePaymentModule,
                                        small: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $f32c3824ac71a1eb$export$5cf73536239227d6,
                                        onClick: addCard,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: $f32c3824ac71a1eb$export$9d70389615de760d,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                                        src: `/app/themes/taxi-stockholm/static/img/option-icons/PayInCar.png`,
                                                        className: $f32c3824ac71a1eb$export$1ca1ec8b29a4ce27
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                                                        title: "Betalkort"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                                                id: "plus"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $f32c3824ac71a1eb$export$5cf73536239227d6,
                                        onClick: openAddAccount,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: $f32c3824ac71a1eb$export$9d70389615de760d,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                                        src: `/app/themes/taxi-stockholm/static/img/option-icons/TSAB.png`,
                                                        className: $f32c3824ac71a1eb$export$1ca1ec8b29a4ce27
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                                                        title: "Konto"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                                                id: "plus"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    !inEditMode && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $f32c3824ac71a1eb$export$761648c26da3b71b,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "text-[18px] font-semibold tracking-[0.54px] leading-normal -mb-2 text-on-surface mb-2",
                                children: t('title-vouchers')
                            }),
                            voucherDisabledMessage && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $e68f4d42f1872239$var$cx($f32c3824ac71a1eb$export$21ba78b50397401d, $f35967c56a9f3d99$exports.fullWidth),
                                children: voucherDisabledMessage
                            }),
                            !hasVouchers && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f32c3824ac71a1eb$export$21ba78b50397401d,
                                children: t('info-no-vouchers')
                            }),
                            user?.vouchers?.map((voucher, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "vouchers",
                                    icon: "DigitalVoucher",
                                    value: voucher.voucherCode,
                                    title: `${voucher.voucherCode} - ${(0, $c94184dfef1a7d71$export$9e6e5cf28f33a45e)(voucher)}`,
                                    info: $e68f4d42f1872239$var$renderVoucherInfo(voucher),
                                    disabled: disableVouchers || values?.vouchers?.length > 0 && !values?.vouchers?.includes(voucher.voucherCode),
                                    disabledDescription: disableVouchers || values?.vouchers?.length > 0 && !values?.vouchers?.includes(voucher.voucherCode) ? "Inte tillg\xe4ngligt" : null,
                                    noPadding: true,
                                    tabIndex: isPaymentOpen ? 0 : -1,
                                    component: (0, $20f208c249841caf$export$2e2bcd8739ae039)
                                }, index)),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "py-1",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $25ea23ed8632858c$export$2e2bcd8739ae039), {
                                    label: t('button-add-new-voucher'),
                                    onClick: openAddVoucher,
                                    tabIndex: isPaymentOpen ? 0 : -1
                                })
                            }),
                            !disableVouchers && hasVouchers && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $e68f4d42f1872239$var$cx($f32c3824ac71a1eb$export$21ba78b50397401d, $f35967c56a9f3d99$exports.fullWidth),
                                style: {
                                    marginTop: '10px'
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "info-voucher-codes",
                                    components: {
                                        link1: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                            href: config.paymentTermsLink,
                                            target: "_blank"
                                        })
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $f0cb867bf70eee97$export$2e2bcd8739ae039), {})
        ]
    });
};
$5fe60eb48993b2d4$export$20be359f745f973c($a0206caf38308288$export$185802fd694ee1f5, 'validPayment', function(errorMessage) {
    return this.test('test-valid-payment', errorMessage, function(value) {
        const { path: path, createError: createError } = this;
        if (value === 'DefaultNoSelect') return createError({
            path: path,
            message: errorMessage
        });
        return true;
    });
});
$e68f4d42f1872239$var$ConfirmBooking.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    name: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-name')),
    phone: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-phone')),
    payment: $a0206caf38308288$export$185802fd694ee1f5().validPayment((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-payment')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-payment')),
    accountReference: $a0206caf38308288$export$185802fd694ee1f5().when([
        'account',
        'company',
        'editableOptions',
        'bookingId'
    ], (account, company, editableOptions, bookingId)=>{
        const isEditMode = !isNaN(bookingId) && bookingId > 0;
        // In edit mode, use isReferenceRequired from editableOptions if available
        if (isEditMode && editableOptions?.isReferenceRequired !== undefined) return editableOptions.isReferenceRequired ? $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-reference')) : $a0206caf38308288$export$185802fd694ee1f5();
        // Normal mode: check company and account flags
        const needReference = company?.requireReference === true || account !== false && (account?.type === 'TSAB' || account?.type === 'TCA') && account?.flags.includes('reference');
        return needReference ? $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-reference')) : $a0206caf38308288$export$185802fd694ee1f5();
    })
});
var $e68f4d42f1872239$export$2e2bcd8739ae039 = $e68f4d42f1872239$var$ConfirmBooking;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");





// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2029-26935
// Variant: Size=Full screen sheet

var $ih19M = parcelRequire("ih19M");

function $a7fcf797d7d7638b$var$CompletedIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex items-center justify-center size-11",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    x: "0.25",
                    y: "0.25",
                    width: "39.5",
                    height: "39.5",
                    rx: "19.75",
                    fill: "#FFCC00"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    x: "0.25",
                    y: "0.25",
                    width: "39.5",
                    height: "39.5",
                    rx: "19.75",
                    stroke: "#BA8200",
                    strokeWidth: "0.5"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M12.5 20.8898L17.2956 26.8272C17.5632 27.1586 18.0766 27.131 18.3073 26.7729L27.5 12.5",
                    stroke: "#17181A",
                    strokeWidth: "2.5",
                    strokeLinecap: "round"
                })
            ]
        })
    });
}
function $a7fcf797d7d7638b$var$CancelledIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex items-center justify-center size-11",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            width: "40",
            height: "40",
            viewBox: "0 0 40 40",
            fill: "none",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    width: "40",
                    height: "40",
                    rx: "20",
                    fill: "#121212"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M9.5 20H30.5",
                    stroke: "white",
                    strokeWidth: "2.5",
                    strokeLinecap: "round"
                })
            ]
        })
    });
}
function $a7fcf797d7d7638b$var$PrebookedIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex items-center justify-center p-0.5 size-11 rounded-full",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: "bg-[#121212] flex items-center justify-center p-2 rounded-full size-10",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "15",
                height: "16",
                viewBox: "0 0 15.0713 16.001",
                fill: "none",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M4.45215 7.09766C6.911 7.09766 8.90416 9.09049 8.9043 11.5488C8.9043 14.0073 6.91109 16.001 4.45215 16.001C1.99328 16.0009 0 14.0072 0 11.5488C0.000141755 9.09054 1.99337 7.09774 4.45215 7.09766ZM4.81445 0C5.10003 0 5.24317 0 5.35156 0.0556641C5.44675 0.104798 5.5237 0.183326 5.57129 0.279297C5.62542 0.388604 5.62283 0.531739 5.61816 0.817383L5.61133 1.22656C5.60822 1.41683 5.60748 1.51212 5.64355 1.58496C5.6753 1.64893 5.72656 1.70164 5.79004 1.73438C5.86223 1.77147 5.95751 1.77148 6.14746 1.77148H9.59863C9.7834 1.77148 9.87621 1.77104 9.94727 1.73535C10.0098 1.70388 10.0613 1.65378 10.0938 1.5918C10.1307 1.52135 10.1318 1.42883 10.1348 1.24414L10.1426 0.791016C10.1471 0.513734 10.1497 0.375255 10.2051 0.269531C10.2538 0.176545 10.3301 0.100937 10.4238 0.053711C10.5304 0.0000627254 10.6692 0 10.9463 0H11.1357C11.4213 0 11.5645 0 11.6729 0.0556641C11.7681 0.104766 11.845 0.183335 11.8926 0.279297C11.9467 0.388593 11.9451 0.531764 11.9404 0.817383L11.9326 1.26074C11.9297 1.44078 11.9283 1.53096 11.9629 1.60254C11.9931 1.66513 12.0435 1.71767 12.1045 1.75098C12.1743 1.78898 12.2651 1.79174 12.4463 1.79785C12.4833 1.7991 12.5099 1.80016 12.5195 1.80078C12.816 1.82071 13.1133 1.86481 13.4062 1.98438C14.0668 2.25399 14.5915 2.77115 14.8652 3.42188C14.9866 3.71044 15.0315 4.00291 15.0518 4.29492C15.071 4.57225 15.0713 4.90759 15.0713 5.2959V11.3809C15.0713 11.8476 15.0705 12.2503 15.043 12.582C15.0139 12.9322 14.9507 13.2811 14.7773 13.6162C14.5189 14.1159 14.1058 14.5217 13.5986 14.7764C13.2585 14.9471 12.9042 15.0105 12.5488 15.0391C12.2122 15.0661 11.8037 15.0664 11.3301 15.0664H10.2676C9.98607 15.0664 9.84483 15.0665 9.7373 15.0117C9.64277 14.9635 9.56575 14.8865 9.51758 14.792C9.46282 14.6845 9.46289 14.5432 9.46289 14.2617V14.0996C9.46289 13.8181 9.46279 13.6769 9.51758 13.5693C9.56577 13.4748 9.64277 13.3978 9.7373 13.3496C9.84483 13.2948 9.98607 13.2949 10.2676 13.2949H11.2949C11.8132 13.2949 12.1486 13.2949 12.4033 13.2744C12.6472 13.2548 12.7378 13.2205 12.7822 13.1982C12.9512 13.1133 13.0887 12.9781 13.1748 12.8115C13.1974 12.7678 13.231 12.6787 13.251 12.4385C13.2718 12.1875 13.2725 11.8573 13.2725 11.3467V5.32422C13.2725 4.89985 13.2723 4.62579 13.2578 4.41602C13.2438 4.2141 13.2196 4.13646 13.2041 4.09961C13.1128 3.88286 12.9379 3.7109 12.7178 3.62109C12.6803 3.60583 12.6023 3.58213 12.3975 3.56836C12.1844 3.55404 11.9057 3.55371 11.4746 3.55371H4.2832C3.85211 3.55371 3.57337 3.55404 3.36035 3.56836C3.15572 3.58214 3.07742 3.60584 3.04004 3.62109C2.82007 3.71097 2.64494 3.8829 2.55371 4.09961C2.53822 4.13646 2.51398 4.2141 2.5 4.41602C2.48549 4.62579 2.48535 4.89987 2.48535 5.32422V5.60645C2.48535 5.88795 2.48545 6.0292 2.43066 6.13672C2.38247 6.23125 2.30548 6.30827 2.21094 6.35645C2.10349 6.41114 1.96275 6.41113 1.68164 6.41113H1.49219C1.21074 6.41113 1.06943 6.4112 0.961914 6.35645C0.867364 6.30827 0.79038 6.23126 0.742188 6.13672C0.687403 6.0292 0.6875 5.88795 0.6875 5.60645V5.2959C0.687489 4.90759 0.687824 4.57225 0.707031 4.29492C0.727271 4.00292 0.771256 3.71043 0.892578 3.42188C1.16633 2.771 1.69182 2.25399 2.35254 1.98438C2.64544 1.86489 2.94188 1.82071 3.23828 1.80078C3.24673 1.80021 3.26895 1.79994 3.2998 1.79883C3.4761 1.79247 3.56437 1.78851 3.63281 1.75195C3.6927 1.71988 3.74251 1.66986 3.77344 1.60938C3.80873 1.5402 3.81064 1.45241 3.81348 1.27734L3.82129 0.791016C3.82578 0.513988 3.82756 0.375223 3.88281 0.269531C3.93156 0.176494 4.00872 0.100939 4.10254 0.053711C4.20914 0.0000955 4.34777 0 4.625 0H4.81445ZM7.33496 9.81543C7.0797 9.54746 6.65571 9.53675 6.3877 9.79199L3.95215 12.1104L2.83789 11.1416C2.5586 10.8988 2.13545 10.9278 1.89258 11.207C1.64972 11.4863 1.6797 11.9095 1.95898 12.1523L3.53418 13.5225C3.79504 13.7491 4.18523 13.7402 4.43555 13.502L7.3125 10.7627C7.58042 10.5074 7.59018 10.0834 7.33496 9.81543Z",
                    fill: "white"
                })
            })
        })
    });
}
function $a7fcf797d7d7638b$var$CarIcon() {
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    // Only taxi-stockholm ships taxi-booking-status.png, so every Svea theme — and
    // the embed, which forces CONFIG.svea_module on — renders a broken image here.
    // Fall back to the same theme's own car icon rather than borrowing another
    // theme's status image: that one has the operator's livery printed on it, so
    // reusing it across themes would show the wrong brand. Remove this once each
    // theme has its own taxi-booking-status.png.
    const handleError = (event)=>{
        if (event.target.dataset.fallbackApplied) return; // fallback missing too — stop, don't loop
        event.target.dataset.fallbackApplied = 'true';
        event.target.src = `/app/themes/${theme}/static/img/car-icons/taxi.png`;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "overflow-hidden relative size-11",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
            src: `/app/themes/${theme}/static/img/taxi-booking-status.png`,
            onError: handleError,
            alt: "",
            className: "absolute w-14 h-14 object-cover pointer-events-none",
            style: {
                top: 'calc(50% - 6px)',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }
        })
    });
}
function $a7fcf797d7d7638b$export$9ba6f99bbe78dab5(location) {
    if (!location) return '';
    if (location.poiName && location.locationType !== 'STREET') return location.poiName;
    const parts = [];
    if (location.streetName) {
        let s = location.streetName;
        if (location.streetNumber) s += ` ${location.streetNumber}`;
        parts.push(s);
    }
    if (location.city) parts.push(location.city);
    return parts.join(', ');
}
const $a7fcf797d7d7638b$var$CANCELLED_CODES = [
    130,
    190,
    220,
    230,
    610,
    620,
    630
];
function $a7fcf797d7d7638b$var$StatusIcon({ booking: booking }) {
    const code = Number(booking?.bookingStatus?.statusCode);
    const isPrebook = booking?.bookingType === 'PRE_BOOKING';
    if ($a7fcf797d7d7638b$var$CANCELLED_CODES.includes(code)) return /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$CancelledIcon, {});
    if (code === 510) return /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$CompletedIcon, {});
    if (code === 120 && isPrebook) return /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$PrebookedIcon, {});
    return /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$CarIcon, {});
}
function $a7fcf797d7d7638b$var$StatusTitle({ booking: booking, t: t }) {
    const code = Number(booking?.bookingStatus?.statusCode);
    const isPrebook = booking?.bookingType === 'PRE_BOOKING';
    const plate = booking?.bookingStatus?.vehiclePlate;
    if (code === 620) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-no-show')
    });
    if (code === 630) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-annulled')
    });
    if (code === 130) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-rejected')
    });
    if (code === 190) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-failed')
    });
    if ([
        220,
        230,
        610
    ].includes(code)) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-cancelled')
    });
    if (code === 510) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-completed')
    });
    if (code === 410) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-en-route')
    });
    if (code === 320) return plate ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            t('status-header-plate-prefix'),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "text-secondary",
                children: plate
            }),
            t('status-header-at-pickup-suffix')
        ]
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-at-pickup')
    });
    if (code === 315) return plate ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            t('status-header-plate-prefix'),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "text-secondary",
                children: plate
            }),
            t('status-header-approaching-suffix')
        ]
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-approaching')
    });
    if (code === 310) return plate ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            t('status-header-plate-prefix'),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "text-secondary",
                children: plate
            }),
            t('status-header-dispatched-suffix')
        ]
    }) : /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-dispatched')
    });
    if (code === 240) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-cancellation-rejected')
    });
    if (code === 210) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-cancellation-requested')
    });
    if (code === 110) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-header-received')
    });
    if (code === 120 && isPrebook) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-pre-booked')
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-searching')
    });
}
function $a7fcf797d7d7638b$var$StatusSubtitle({ booking: booking, t: t }) {
    const code = Number(booking?.bookingStatus?.statusCode);
    const isPrebook = booking?.bookingType === 'PRE_BOOKING';
    const origin = $a7fcf797d7d7638b$export$9ba6f99bbe78dab5(booking?.originLocation);
    const dest = $a7fcf797d7d7638b$export$9ba6f99bbe78dab5(booking?.destinationLocation);
    if ([
        220,
        230,
        610,
        620
    ].includes(code)) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-subtitle-cancelled')
    });
    if (code === 510) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-subtitle-completed')
    });
    if (code === 410) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: dest ? t('status-subtitle-en-route-with-destination', {
            destination: dest
        }) : t('status-subtitle-en-route')
    });
    if (code === 320) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: origin ? t('status-subtitle-at-pickup-with-address', {
            address: origin
        }) : t('status-subtitle-at-pickup')
    });
    if (code === 315) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: origin ? t('status-subtitle-approaching-with-address', {
            address: origin
        }) : t('status-subtitle-dispatched')
    });
    if (code === 310) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: origin ? t('status-subtitle-dispatched-with-address', {
            address: origin
        }) : t('status-subtitle-dispatched')
    });
    if (code === 110) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-subtitle-received')
    });
    if (code === 120 && isPrebook) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-subtitle-prebooked')
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: t('status-subtitle-searching')
    });
}
function $a7fcf797d7d7638b$export$2e2bcd8739ae039({ booking: booking }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "bg-surface-container-low w-full flex flex-col items-center px-6 pt-6 pb-8 gap-4",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$StatusIcon, {
                booking: booking
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-col items-center gap-1 text-center w-full",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[28px] font-bold leading-none text-on-surface w-full",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$StatusTitle, {
                            booking: booking,
                            t: t
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[17px] leading-[22px] text-on-surface-variant w-full",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($a7fcf797d7d7638b$var$StatusSubtitle, {
                            booking: booking,
                            t: t
                        })
                    })
                ]
            })
        ]
    });
}







// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=19286-101463
// The app's `returnTripOfferSheet` (a bottom sheet) interpreted for the web as the standard
// content modal: title, subtitle and the two modal buttons. Shown via showContentModal when
// the user closes the details of a booking that is eligible for a return trip.

var $ih19M = parcelRequire("ih19M");



function $ceece7bc287dac2f$export$2e2bcd8739ae039({ booking: booking, onContinue: onContinue, onNotNow: onNotNow }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const destination = (0, $a7fcf797d7d7638b$export$9ba6f99bbe78dab5)(booking?.destinationLocation);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "px-4 pt-4 pb-4 pr-12",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[28px] font-bold leading-none text-on-surface mb-1",
                        children: t('return-trip-offer-title')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[17px] leading-[22px] text-on-surface-variant",
                        children: t('return-trip-offer-subtitle', {
                            destination: destination
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                modal: true,
                buttons: [
                    {
                        title: t('button-not-now'),
                        func: onNotNow
                    },
                    {
                        title: t('button-continue'),
                        func: onContinue
                    }
                ]
            })
        ]
    });
}



var $702a4a03572e0afc$export$3b287ad9e95ea0f4;
var $702a4a03572e0afc$export$950c571e8f12d47e;
var $702a4a03572e0afc$export$a80b3bd66acc52ff;
$702a4a03572e0afc$export$3b287ad9e95ea0f4 = `_1W6YBa_actionDrawer`;
$702a4a03572e0afc$export$950c571e8f12d47e = `_1W6YBa_hideOverflow`;
$702a4a03572e0afc$export$a80b3bd66acc52ff = `_1W6YBa_info`;




const $c0b58a92d2a95efd$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $c0b58a92d2a95efd$var$BookingDone = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values, initialValues: initialValues, resetForm: resetForm } = (0, $lW2XZ.useFormikContext)();
    const { reset: resetStepper } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { config: config, bookings: bookings, getActiveBookings: getActiveBookings, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [lastKnownBooking, setLastKnownBooking] = (0, $bh6RR.useState)(null);
    const lastKnownBookingRef = (0, $bh6RR.useRef)(null);
    const drawerRef = (0, $bh6RR.useRef)(null);
    const [drawerHeight, setDrawerHeight] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        const el = drawerRef.current;
        if (!el) return;
        const observer = new ResizeObserver(()=>setDrawerHeight(el.offsetHeight));
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    const bookingsRef = (0, $bh6RR.useRef)(bookings);
    bookingsRef.current = bookings;
    // Set on every exit that is not the user closing the details (edit, cancel, return
    // trip), so the return trip offer is only evaluated when the details are closed.
    const skipReturnTripOfferRef = (0, $bh6RR.useRef)(false);
    const booking = bookings?.find((item)=>item.id === values.bookingId);
    const baseEffective = booking || lastKnownBooking || values.booking;
    // bookingType can be missing from the store's active-bookings response.
    // Resolve it with three fallbacks in priority order:
    //   1. whatever the store/lastKnown has (already authoritative when present)
    //   2. values.booking from the full /v1/bookings/:id fetch after edit confirm
    //   3. values.pickupTime — a non-empty pickupTime always means PRE_BOOKING
    const resolvedBookingType = baseEffective?.bookingType || values.booking?.bookingType || (values.pickupTime ? 'PRE_BOOKING' : undefined);
    const effectiveBooking = baseEffective ? {
        ...baseEffective,
        bookingType: resolvedBookingType
    } : null;
    // Keep lastKnownBooking in sync, preserving the resolved bookingType
    (0, $bh6RR.useEffect)(()=>{
        if (booking) {
            const resolvedType = booking.bookingType || values.booking?.bookingType || (values.pickupTime ? 'PRE_BOOKING' : undefined);
            const toSave = resolvedType !== booking.bookingType ? {
                ...booking,
                bookingType: resolvedType
            } : booking;
            lastKnownBookingRef.current = toSave;
            setLastKnownBooking(toSave);
        }
    }, [
        booking
    ]);
    // Return trip offer (docs/RETURNTRIP.md): the web's "booking details" is this view, and it
    // is closed by the module's reset button, which resets the stepper and unmounts us. So the
    // offer is evaluated on unmount, for the booking the user just placed, unless the exit was
    // an edit/cancel/return trip (skipReturnTripOfferRef). The resolver consumes the
    // just-placed marker, so it fires at most once per booking.
    (0, $bh6RR.useEffect)(()=>{
        if (!(0, $740a278ce29d303f$export$e9c33ea3d5deb681)()) return;
        return ()=>{
            if (skipReturnTripOfferRef.current) return;
            const closedBooking = lastKnownBookingRef.current;
            if (!closedBooking) return;
            (0, $740a278ce29d303f$export$c23e31024771323a)(closedBooking, bookingsRef.current).then((suggestion)=>{
                if (!suggestion) return;
                (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $ceece7bc287dac2f$export$2e2bcd8739ae039), {
                        booking: suggestion,
                        onContinue: ()=>{
                            close();
                            (0, $740a278ce29d303f$export$9965a32afefbb8ca)(suggestion);
                        },
                        onNotNow: ()=>{
                            (0, $740a278ce29d303f$export$c07511697229d32)(suggestion.id);
                            close();
                        }
                    }));
            });
        };
    }, []);
    // Delayed user refresh to pick up updated voucher list after backend processes the booking
    (0, $bh6RR.useEffect)(()=>{
        if (!values.bookingId) return;
        const id = setTimeout(refreshUser, 3000);
        return ()=>clearTimeout(id);
    }, [
        values.bookingId
    ]);
    // Intensive status polling — keeps the header accurate after booking drops from active list
    (0, $bh6RR.useEffect)(()=>{
        if (!values.bookingId) return;
        const TERMINAL = [
            510,
            220,
            610,
            620
        ];
        const poll = async ()=>{
            const current = lastKnownBookingRef.current;
            if (!current) return;
            if (TERMINAL.includes(Number(current?.bookingStatus?.statusCode))) return;
            try {
                const results = await (0, $135a523c4bea715f$export$b70265791d2079d4)([
                    current
                ]);
                const statusData = results?.find((item)=>item.bookingId === current.id);
                if (statusData?.bookingStatus) {
                    const updated = {
                        ...current,
                        bookingStatus: statusData.bookingStatus
                    };
                    lastKnownBookingRef.current = updated;
                    setLastKnownBooking(updated);
                }
            } catch (e) {
            // silently ignore — main store polling continues independently
            }
        };
        const interval = setInterval(poll, 5000);
        return ()=>clearInterval(interval);
    }, [
        values.bookingId
    ]);
    const cancelBooking = ()=>{
        setIsLoading(true);
        skipReturnTripOfferRef.current = true;
        (0, $135a523c4bea715f$export$b7b1ce5fabd1b486)(values?.bookingId).then((response)=>{
            (0, $ee4f9bead648b485$export$6b2a7d5132615086)('cancelBooking', {
                bookingNumber: values?.bookingId
            });
            getActiveBookings();
            close();
        }).catch((error)=>{
            if (error?.response?.error === 'ALREADY_CANCELLED_BOOKING') {
                getActiveBookings();
                close();
            } else if (!(error?.isUnauthorized || error?.status === 401 || error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) {
                console.error(error);
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const cancel = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(COPY.booking.receipt_confirm_cancel, [
            {
                title: COPY.booking.button_ok,
                callback: cancelBooking
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    const close = ()=>{
        const resetValues = initialValues;
        resetValues.isCompanyTrip = values.isCompanyTrip; // Preserve company trip status
        resetValues.company = values.company; // Preserve company name if set
        resetForm({
            values: resetValues
        });
        resetStepper();
    };
    const openSendConfirmation = ()=>{
        const bookingId = values.bookingId;
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $4741aed6d26ee9f4$export$2e2bcd8739ae039), {
                bookingId: bookingId,
                onComplete: close
            }));
    };
    const editBooking = ()=>{
        if (booking) {
            skipReturnTripOfferRef.current = true;
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('EDIT_BOOKING', booking);
        }
    };
    // "Book return trip": opens the prefilled return trip sheet for this booking. Closes the
    // details first (same as the reset button) so the sheet starts from a clean form.
    const bookReturnTrip = ()=>{
        const original = effectiveBooking;
        if (!original) return;
        skipReturnTripOfferRef.current = true;
        close();
        (0, $740a278ce29d303f$export$9965a32afefbb8ca)(original);
    };
    const canBookReturnTrip = (0, $740a278ce29d303f$export$a4b60a5a63198f3f)(effectiveBooking);
    const canCancel = (0, $c94184dfef1a7d71$export$4d66b7747958f839)(booking);
    const canEdit = (0, $c94184dfef1a7d71$export$101b6e7d76ab4fe5)(booking);
    const actionButtons = [
        // { label: t('button-book-again'), icon: <RouteIcon />, onClick: close },
        ...canBookReturnTrip ? [
            {
                label: t('button-return-trip'),
                icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e891d0fba1229c08$export$af37dba276592e85), {}),
                onClick: bookReturnTrip
            }
        ] : [],
        //{ label: t('button-add-to-calendar'), icon: <CalendarIcon />, onClick: () => {}, disabled: true },
        {
            label: t('button-forward-confirmation'),
            icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e891d0fba1229c08$export$6c65bc9b1cd4941d), {}),
            onClick: openSendConfirmation
        },
        {
            label: t('button-modify-booking'),
            icon: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e891d0fba1229c08$export$d2c72b688139a728), {}),
            onClick: editBooking,
            disabled: !canEdit
        },
        // { label: t('button-receipt-unavailable'), icon: <ReceiptIcon />, onClick: () => {}, disabled: true },
        ...canCancel ? [
            {
                label: t('button-cancel-booking'),
                onClick: cancel,
                destructive: true,
                disabled: isLoading
            }
        ] : []
    ];
    // A return trip started from the bookings drawer replaces this view; don't offer on top of it.
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RETURN_TRIP_BOOKING', ()=>{
        skipReturnTripOfferRef.current = true;
    }, []);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CANCEL_BOOKING', (bookingId)=>{
        if (values.bookingId === bookingId) {
            skipReturnTripOfferRef.current = true;
            close();
        }
    }, [
        values.bookingId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $c0b58a92d2a95efd$var$cx($f35967c56a9f3d99$exports.widgetWrapper, $702a4a03572e0afc$export$950c571e8f12d47e, {
            fullHeight: fullscreen,
            narrow: true,
            isLoading: isLoading
        }),
        style: {
            paddingBottom: 0
        },
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                noRadius: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "-mx-6 -mt-6 mb-4",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a7fcf797d7d7638b$export$2e2bcd8739ae039), {
                            booking: effectiveBooking
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                        values: values,
                        showHow: true,
                        showPayment: true,
                        currentView: currentView,
                        afterLocations: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                            fullscreen: fullscreen
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: `${$702a4a03572e0afc$export$a80b3bd66acc52ff} mt-4`,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                children: t('header-thanks-for-your-booking')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "info-booking-done",
                                    components: {
                                        link1: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                            href: config.termsLink,
                                            target: "_blank"
                                        })
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "hidden app-lg:block shrink-0",
                        style: {
                            height: drawerHeight
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                ref: drawerRef,
                className: $702a4a03572e0afc$export$3b287ad9e95ea0f4,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e891d0fba1229c08$export$2e2bcd8739ae039), {
                    buttons: actionButtons
                })
            })
        ]
    });
};
$c0b58a92d2a95efd$var$BookingDone.validationSchema = null;
var $c0b58a92d2a95efd$export$2e2bcd8739ae039 = $c0b58a92d2a95efd$var$BookingDone;


// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=19307-115632
// The app's `returnTripBookingSheet` (docs/RETURNTRIP.md) as a view in the booking module.
//
// Everything is prefilled from the original booking (RETURN_TRIP_BOOKING in BookingModule);
// the user only picks a pickup time — or flight number, landing time and luggage when the
// return pickup is an airport — and books. Availability, price, price type and payment
// validation come from the module's Fetcher exactly like the regular flow, and the booking
// itself goes through usePlaceBooking, shared with ConfirmBooking.
//
// Web interpretation of the sheet: laid out like the booking summary rather than the app's
// sheet. FormContent holds the title and the summary rows — the time/flight inputs in the time
// sheet. FormContent (right column in fullscreen) holds the title and the summary rows: trip,
// payment with the price, car type, company, reference, passenger and message, with edit
// pencils (trip parts leave for the normal flow with everything kept; the rest edit in place;
// payment is locked). contentBottom (left column) holds the time/flight inputs and the single
// "Book & pay" button in the button drawer. The module's reset button is Close.

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");


var $igItr = parcelRequire("igItr");
var $hBud4 = parcelRequire("hBud4");
var $kzEvi = parcelRequire("kzEvi");
var $j1vsN = parcelRequire("j1vsN");



// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=4185-31323
// Price breakdown modal — shown when tapping the ⓘ on a fixed-price SelectedPayment row.
// Works with both real booking prices (priceComponents + vat) and pre-booking estimates
// (finalPrice / fullPrice / discountComponents).

var $ih19M = parcelRequire("ih19M");

const $95edecdc1b70ca9a$var$priceOrder = [
    'basePrice',
    'fixedAdditionalFee',
    'waitingFee',
    'tip'
];
const $95edecdc1b70ca9a$var$InfoFilledIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shrink-0",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
                clipPath: "url(#pim-clip)",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 14.4333C11.553 14.4333 14.4333 11.553 14.4333 8C14.4333 4.44697 11.553 1.56667 8 1.56667C4.44697 1.56667 1.56667 4.44697 1.56667 8C1.56667 11.553 4.44697 14.4333 8 14.4333ZM8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.2",
                        y: "4",
                        width: "1.6",
                        height: "1.6",
                        rx: "0.8",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.467",
                        y: "6.667",
                        width: "1.067",
                        height: "5.333",
                        rx: "0.213",
                        fill: "#17181A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("clipPath", {
                    id: "pim-clip",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
function $95edecdc1b70ca9a$export$2e2bcd8739ae039({ price: price, onClose: onClose }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    // Real booking price: has priceComponents array
    const priceComponents = price?.priceComponents ? price.priceComponents.filter((p)=>p.type !== 'fixedPrice').sort((a, b)=>{
        const ia = $95edecdc1b70ca9a$var$priceOrder.indexOf(a.type);
        const ib = $95edecdc1b70ca9a$var$priceOrder.indexOf(b.type);
        if (ia === -1 && ib === -1) return 0;
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
    }) : null;
    const hasDiscount = price?.discount && price?.discountComponents?.length > 0;
    const hasVat = !!price?.vat;
    const tip = Number(price?.tippedAmount) || 0;
    const hasTip = tip > 0;
    // Build rows array — used for aligned two-column layout
    const rows = [];
    if (priceComponents) priceComponents.forEach((p, i)=>{
        // The API sends a localized display name per component (e.g. "Bilbarnstol" for a
        // vehicleOption); the apps show that. The type translation is only a fallback, since
        // several add-ons would otherwise all read as "Tillval".
        rows.push({
            key: `pc-${i}`,
            label: p.name || t('price_' + p.type),
            amount: `${Math.round(p.amount)} kr`
        });
    });
    else if (price?.fullPrice && price.fullPrice !== price.finalPrice) // Estimate price: show full (undiscounted) price as base row
    rows.push({
        key: 'base',
        label: t('price_basePrice'),
        amount: `${price.fullPrice} kr`
    });
    if (hasDiscount) price.discountComponents.forEach((d, i)=>{
        const label = d.name + (d.type === 'voucher' && d.code ? ` ${d.code}` : '');
        rows.push({
            key: `d-${i}`,
            label: label,
            amount: `-${Math.round(d.amount)} kr`
        });
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex gap-1 items-center px-4 pt-4",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($95edecdc1b70ca9a$var$InfoFilledIcon, {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-headline font-semibold uppercase text-on-surface",
                        children: t('label-price-information')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-col gap-4 px-4 pt-3 pb-4 text-on-surface-variant text-body-sm",
                children: [
                    rows.length > 0 && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex gap-1.5 items-start",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex-1 flex flex-col gap-1.5 min-w-0",
                                children: rows.map((r)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "font-medium",
                                        children: r.label
                                    }, r.key))
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex flex-col gap-1.5 items-end shrink-0 text-right whitespace-nowrap",
                                children: rows.map((r)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        children: r.amount
                                    }, r.key))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex gap-1.5 items-start",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex-1 flex flex-col gap-0.5 min-w-0",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: "text-headline font-semibold uppercase",
                                        children: t('label-total')
                                    }),
                                    hasVat && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        children: t('price_vat')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex flex-col gap-2 items-end shrink-0 text-right whitespace-nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "font-medium",
                                        children: [
                                            price?.finalPrice,
                                            " kr"
                                        ]
                                    }),
                                    hasVat && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        children: [
                                            price.vat.toString().replace('.', ','),
                                            " kr"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasTip && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-col gap-1.5 pt-4",
                        style: {
                            borderTop: '1px solid rgba(0, 0, 0, 0.10)'
                        },
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex gap-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: "flex-1 font-medium",
                                        children: t('price_tip')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "shrink-0 whitespace-nowrap",
                                        children: [
                                            Math.round(tip),
                                            " kr"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex gap-1.5 items-baseline",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "flex-1",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-headline font-semibold uppercase",
                                                children: t('label-total')
                                            }),
                                            " ",
                                            t('label-incl-tip')
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                        className: "shrink-0 whitespace-nowrap font-medium",
                                        children: [
                                            Math.round((price?.finalPrice || 0) + tip),
                                            " kr"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onClose,
                className: "w-full py-3 bg-on-surface text-on-primary text-btn font-semibold uppercase tracking-[0.68px] leading-5",
                children: "OK"
            })
        ]
    });
}














const $b2f068b631255673$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $b2f068b631255673$var$ReturnTripBooking = ({ fullscreen: fullscreen })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const formik = (0, $lW2XZ.useFormikContext)();
    const { values: values, errors: errors, touched: touched, setFieldValue: setFieldValue } = formik;
    const { prev: prev } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const original = values.returnTripBooking;
    const departureIsAirport = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'FLIGHT_NBR');
    const requiresPassengerCount = (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'TRAVELER_COUNT_REQUIRED');
    const timeSelected = values.pickupTime !== '' && values.pickupTime !== null && values.pickupTime !== undefined;
    const prebookTripRules = values.availability?.prebook?.tripRules;
    const minDate = (0, $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f)(prebookTripRules);
    const maxDate = (0, $b1e48e867c2e2e0c$export$70719a9c368c2090)(values);
    const clampDate = (date)=>(0, $9a41dab598251ed0$export$2e2bcd8739ae039)(date, {
            start: minDate,
            end: maxDate
        });
    const availabilities = values.availability?.prebook?.availabilities || [];
    const maxPassengers = availabilities.reduce((max, a)=>{
        if (a.availableAt === 'NOT_AVAILABLE' || !a.maxTravelers) return max;
        return Math.max(max, a.maxTravelers);
    }, 0) || 50;
    // "Edit", and the blocking-problem dialogs: leave the sheet for the normal flow with
    // everything the customer entered intact (addresses, car type, add-ons, time, flight info,
    // originalBookingReference), starting from the first step like the app's start page.
    const leaveForNormalFlow = ()=>prev('locations');
    const { placeBooking: placeBooking, isLoading: isLoading, waitingForPoll: waitingForPoll } = (0, $6a274741627bfde6$export$2e2bcd8739ae039)({
        onNotAvailable: leaveForNormalFlow,
        // The picked time has passed by the time we booked: clear it so the field asks again.
        onDatetimeBeforeNow: ()=>setFieldValue('pickupTime', '', false)
    });
    const book = (0, $30acdccbb47e8004$export$95742212c462b028)(placeBooking, formik);
    // Price (same lookup as BookingSummary)
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const serviceType = values.autoValues.serviceType !== null ? values.autoValues.serviceType : values.serviceType;
    const actualServiceType = serviceType === 'estate' ? 'taxi' : serviceType;
    const price = values?.priceEstimate?.prices?.find((p)=>p.serviceType === actualServiceType && (values.selectedProviderId ? p.providerId === values.selectedProviderId : true));
    const showPrice = timeSelected && !!fixedPrice && !!price;
    const priceLoading = timeSelected && (values.priceIsLoading || values.availabilityIsLoading);
    const { icon: paymentIcon, title: paymentTitle, subtitle: paymentSubtitle } = (0, $c94184dfef1a7d71$export$d3f4c2863c03c2f9)(values);
    const openPriceInfo = showPrice ? ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $95edecdc1b70ca9a$export$2e2bcd8739ae039), {
                price: price,
                onClose: close
            })) : null;
    // Prefilled details
    const companyName = values.company?.name;
    const reference = values.accountReference?.trim();
    // Prebook availability (and its earliestPrebookingDateTime) only arrives once a time is set.
    // Snap a picked time that turns out to be before the API minimum, once, like SelectTime.
    (0, $bh6RR.useEffect)(()=>{
        const earliest = prebookTripRules?.earliestPrebookingDateTime;
        if (!earliest || !timeSelected) return;
        const newMinDate = (0, $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f)(prebookTripRules);
        if (!values.pickupTimeInitialized) {
            setFieldValue('pickupTimeInitialized', true, false);
            if (new Date(values.pickupTime) < newMinDate) setFieldValue('pickupTime', newMinDate, false);
        } else if (new Date(values.pickupTime) < new Date(earliest)) setFieldValue('pickupTime', newMinDate, false);
    }, [
        prebookTripRules?.earliestPrebookingDateTime
    ]);
    // The prebook availability for the picked time, once it is in and the time is one the
    // backend accepts. The date picker commits "now" when it is opened, and the backend answers
    // NOT_AVAILABLE for every car type until the snap effect above has moved the time to the
    // earliest prebooking time, so nothing below may judge that first, too-early answer.
    const prebook = values.availability?.prebook;
    const earliest = prebookTripRules?.earliestPrebookingDateTime;
    const snapPending = !!earliest && new Date(values.pickupTime) < (0, $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f)(prebookTripRules);
    // The time each prebook answer was fetched for. The Fetcher refetches on a time change, but
    // in the render where the time changed the previous answer is still in the form.
    // Recorded during render (not in an effect) so the render that brings the answer sees it.
    const lastPrebookRef = (0, $bh6RR.useRef)(null);
    const fetchedForRef = (0, $bh6RR.useRef)(null);
    if (prebook !== lastPrebookRef.current) {
        lastPrebookRef.current = prebook;
        fetchedForRef.current = prebook ? new Date(values.pickupTime).getTime() : null;
    }
    const prebookIsForPickupTime = !!prebook && fetchedForRef.current === new Date(values.pickupTime).getTime();
    const prebookSettled = timeSelected && !values.availabilityIsLoading && prebookIsForPickupTime && !snapPending;
    // Payment is locked to the original trip, so it is checked against the price types of the
    // prebook availability itself rather than values.priceType, which the Fetcher derives one
    // render later (and which still belongs to the direct availability fetched when the sheet
    // opened). Fixed price vs taximeter is left to the Fetcher like in the regular flow.
    const originalPayment = values.returnTripPayment;
    const prebookPriceTypes = $b2f068b631255673$var$getPrebookPriceTypes(prebook, values.selectedProviderId);
    const originalPaymentAllowed = $b2f068b631255673$var$isPaymentAllowed(originalPayment, prebookPriceTypes, values.company?.id);
    // The Fetcher may have cleared the carried-over payment while the direct availability from
    // the sheet's opening was the current one (its price types can exclude e.g. cards), and it
    // only restores the *preferred* payment. Put the original trip's payment back once the
    // prebook availability allows it.
    (0, $bh6RR.useEffect)(()=>{
        if (!prebookSettled || !originalPaymentAllowed) return;
        if (values.payment === originalPayment.payment) return;
        setFieldValue('payment', originalPayment.payment, false);
        setFieldValue('account', originalPayment.account, false);
    }, [
        prebookSettled,
        originalPaymentAllowed,
        values.payment,
        values.priceType
    ]);
    // Problems that can't be fixed inside the sheet (car type, add-ons and payment method are
    // locked to the original trip). The user is offered to continue in the normal flow. A time
    // that is merely DELAYED is not blocking: the autoValues handle it like the regular flow.
    const problemShownRef = (0, $bh6RR.useRef)(false);
    const originalOptions = (0, $c94184dfef1a7d71$export$60d56ed3961c839c)(original?.vehicleOptions);
    (0, $bh6RR.useEffect)(()=>{
        if (!prebookSettled || problemShownRef.current) return;
        const usable = (prebook.availabilities || []).filter((a)=>a.availableAt !== 'NOT_AVAILABLE');
        const wanted = values.serviceType === 'estate' ? 'taxi' : values.serviceType;
        const available = (0, $c94184dfef1a7d71$export$45f0d338a0ae68ff)(values);
        let problem = null;
        if (usable.length === 0 || prebookPriceTypes.length === 0) problem = 'return-trip-error-not-available';
        else if (!usable.some((a)=>a.serviceType === wanted)) problem = 'return-trip-error-car-type';
        else if (!originalOptions.every((option)=>available.includes(option))) problem = 'return-trip-error-extras';
        else if (!originalPaymentAllowed) problem = 'return-trip-error-payment-method';
        if (!problem) return;
        problemShownRef.current = true;
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(t(problem), [
            {
                title: t('button-continue'),
                callback: leaveForNormalFlow
            }
        ], {
            title: t('return-trip-error-title')
        });
    }, [
        prebook,
        prebookSettled,
        originalPaymentAllowed
    ]);
    const timeError = !!(touched.pickupTime && errors.pickupTime);
    const bookTitle = showPrice && !priceLoading ? t('button-book-and-pay', {
        price: price.finalPrice
    }) : t('button-book-taxi');
    const buttons = [
        {
            func: book,
            title: bookTitle,
            isLoading: isLoading || waitingForPoll,
            disabled: isLoading || waitingForPoll || priceLoading
        }
    ];
    // Edit pencils. Trip parts (addresses, car type, add-ons) are edited in the normal flow with
    // everything kept, like the blocking-problem dialogs; name, phone, message and reference are
    // edited in place with the same modals as the booking summary.
    const editLocations = leaveForNormalFlow;
    const editCar = ()=>prev(timeSelected ? 'how' : 'time');
    const saveField = (id, value)=>setFieldValue(id, value, false);
    const validateName = (value)=>String(value ?? '').length < 2 ? t('validation-need-name') : undefined;
    const validatePhone = (value)=>{
        if (!String(value ?? '').match(/^\+?\d+$/)) return t('validation-only-numbers');
        if (String(value).length < 2) return t('validation-need-phone');
        return undefined;
    };
    const openEditPassenger = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                validate: true,
                formValues: values,
                onFieldSave: saveField,
                title: t('header-whos-travel'),
                onClose: close,
                fields: [
                    {
                        id: 'name',
                        title: t('placeholder-name'),
                        validate: validateName
                    },
                    {
                        id: 'phone',
                        title: t('placeholder-phone'),
                        validate: validatePhone
                    }
                ]
            }));
    const openEditMessage = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: saveField,
                title: t('title-message-to-driver'),
                onClose: close,
                fields: [
                    {
                        id: 'generalComment',
                        title: t('title-message-to-driver')
                    }
                ]
            }));
    const openEditReference = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: saveField,
                title: t('placeholder-reference'),
                onClose: close,
                fields: [
                    {
                        id: 'accountReference',
                        title: t('placeholder-reference')
                    }
                ]
            }));
    const showReference = !!values.company || values.account?.type === 'TSAB' || values.account?.type === 'TCA';
    const passengerCountField = requiresPassengerCount && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                className: $f35967c56a9f3d99$exports.label,
                children: t('header-passengers')
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex items-center gap-3 py-2",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "flex-1 text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: t('label-group-size')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $966dfe9a48e4742e$export$2e2bcd8739ae039), {
                        value: values.passengerCount,
                        min: 0,
                        max: maxPassengers,
                        onChange: (v)=>setFieldValue('passengerCount', v)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                className: $f35967c56a9f3d99$exports.subtitle,
                children: t('info-passenger-count')
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $b2f068b631255673$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen,
            isLoading: isLoading
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('return-trip-title')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b599ddbdca2685a0$export$2e2bcd8739ae039), {
                        fullscreen: fullscreen,
                        showBothBookingTypes: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $b2f068b631255673$var$cx($f35967c56a9f3d99$exports.contentFull, 'items-start'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex items-start",
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cd9136fbd575d4a5$export$2e2bcd8739ae039), {
                                                departure: values.departure,
                                                destination: values.destination,
                                                stops: values.intermediateStopLocations
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                            type: "button",
                                            onClick: editLocations,
                                            className: "shrink-0 p-2 -mr-2 mt-2",
                                            "aria-label": t('button-change'),
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                                                id: "pen"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b32edab973d0099$export$2e2bcd8739ae039), {
                                        icon: paymentIcon,
                                        title: paymentTitle || t('title-payment'),
                                        subtitle: paymentSubtitle,
                                        priceLabel: timeSelected ? showPrice ? t('label-fixed-price') : fixedPrice ? null : t('label-taxameter') : null,
                                        price: showPrice ? price : null,
                                        priceLoading: priceLoading,
                                        voucherPills: [],
                                        onInfo: openPriceInfo
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "payment",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "accountReference",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fe0b386f10b85dbf$export$2e2bcd8739ae039), {
                                    serviceType: values.serviceType,
                                    options: (0, $200ec6b1b2ca8c5a$export$d2312e68e1f5ad00)(values).map((0, $c94184dfef1a7d71$export$c165bf529a45fce1)),
                                    onEdit: editCar
                                })
                            }),
                            values.company && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7e46addbea690aa5$export$2e2bcd8739ae039), {
                                    type: "company",
                                    name: companyName
                                })
                            }),
                            showReference && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $51837c0e5cd1599b$export$2e2bcd8739ae039), {
                                    title: t('placeholder-reference'),
                                    value: reference || t('validation-need-reference'),
                                    icon: "Reference",
                                    changeToggle: openEditReference,
                                    required: true,
                                    empty: !reference
                                })
                            }),
                            (values.name || values.phone) && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $52bbc20651dec586$export$2e2bcd8739ae039), {
                                    name: values.name,
                                    phone: values.phone,
                                    onEdit: openEditPassenger
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f638b72bf31980aa$export$2e2bcd8739ae039), {
                                    message: values.generalComment || "Hj\xe4lp f\xf6raren att hitta dig.",
                                    onEdit: openEditMessage
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: departureIsAirport ? t('header-when-does-your-flight-land') : t('header-when-do-you-want-to-go')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$exports.content,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $f35967c56a9f3d99$exports.group,
                            children: departureIsAirport ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.label,
                                                children: t('section-flight-number')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                name: "flightNumber",
                                                placeholder: t('placeholder-flight-number'),
                                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                                                onChange: (e)=>{
                                                    const value = e.target.value || "";
                                                    setFieldValue('flightNumber', value.toUpperCase());
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.label,
                                                children: t('section-landing-time')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: $c7dccc85457db9a0$export$a2abc71b50183d06,
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                    name: "pickupTime",
                                                    minDate: minDate,
                                                    maxDate: maxDate,
                                                    clampDate: clampDate,
                                                    component: (0, $d2eecefb00e70187$export$2e2bcd8739ae039),
                                                    showTimeInput: true,
                                                    commitOnOpen: true,
                                                    placeholder: t('placeholder-select-landing-time'),
                                                    error: timeError,
                                                    isAirport: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                                name: "pickupTime",
                                                component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.subtitle,
                                                children: t('return-trip-subtitle-flight')
                                            })
                                        ]
                                    }),
                                    passengerCountField,
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.label,
                                                children: t('section-luggage')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                name: "checkedInBaggage",
                                                title: t('title-baggage'),
                                                tabIndex: "0",
                                                alternateBackground: fullscreen,
                                                component: (0, $20f208c249841caf$export$2e2bcd8739ae039),
                                                padding: "py-2",
                                                icon: "Luggage"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.subtitle,
                                                children: t('info-baggage')
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                className: $f35967c56a9f3d99$exports.label,
                                                children: t('label-pickup-time')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: $c7dccc85457db9a0$export$a2abc71b50183d06,
                                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                    name: "pickupTime",
                                                    minDate: minDate,
                                                    maxDate: maxDate,
                                                    clampDate: clampDate,
                                                    component: (0, $d2eecefb00e70187$export$2e2bcd8739ae039),
                                                    showTimeInput: true,
                                                    commitOnOpen: true,
                                                    placeholder: t('placeholder-select-pickup-time'),
                                                    error: timeError
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                                name: "pickupTime",
                                                component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                            })
                                        ]
                                    }),
                                    passengerCountField
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
// Price types of a (normalized) availability, for the selected provider in multiple-partner
// mode, otherwise the aggregated ones. Same lookup as the Fetcher's getPriceTypes.
const $b2f068b631255673$var$getPrebookPriceTypes = (availability, selectedProviderId)=>{
    if (!availability) return [];
    const providers = availability.servicesByProvider;
    const selected = Array.isArray(providers) && selectedProviderId ? providers.find((p)=>p.providerData?.providerId === selectedProviderId) : null;
    const priceTypes = selected ? selected.priceAndPaymentRules?.priceTypes : availability.priceAndPaymentRules?.priceTypes;
    return (priceTypes || []).map((0, $c94184dfef1a7d71$export$f1b9397fe7b6198c));
};
// Whether the carried-over payment can be used with any of the price types (same rules as
// the Fetcher: method must be offered, and a company-restricted account needs that company).
const $b2f068b631255673$var$isPaymentAllowed = (originalPayment, priceTypes, companyId)=>{
    if (!originalPayment) return false;
    const { payment: payment, account: account } = originalPayment;
    const method = (0, $c94184dfef1a7d71$export$369f738c5ad4634)(payment, account);
    if (!method) return false;
    if (account?.restrictedToCompanyId && account.restrictedToCompanyId !== companyId) return false;
    return priceTypes.some((pt)=>pt.paymentMethods?.includes(method));
};
const $b2f068b631255673$var$FLIGHT_NUMBER_PATTERN = /^([0-9A-Z][0-9A-Z])[A-Z]?[0-9]{1,4}[A-Z]?$/;
// Time + flight rules from SelectTime (with the return trip's own "pick a time" copy),
// plus ConfirmBooking's payment/reference/traveler rules.
$b2f068b631255673$var$ReturnTripBooking.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    pickupTime: $2efeb86fe7f1b8d4$export$185802fd694ee1f5().when([
        'departure',
        'availability'
    ], (departure, availability)=>{
        const isAirport = departure?.locationInformation?.some((info)=>info?.tag === 'FLIGHT_NBR');
        const message = isAirport ? (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-landing-time') : (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-pickup-time');
        const hasAvailability = availability?.prebook !== undefined && availability?.prebook !== false;
        const maxDate = hasAvailability ? (0, $b1e48e867c2e2e0c$export$70719a9c368c2090)({
            availability: availability
        }) : (0, $igItr.default)((0, $hBud4.default)((0, $kzEvi.default)((0, $j1vsN.default)(new Date(), 0), 59), 23), 365);
        const earliest = availability?.prebook?.tripRules?.earliestPrebookingDateTime;
        const schema = $2efeb86fe7f1b8d4$export$185802fd694ee1f5().typeError(message).required(message).max(maxDate, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-too-far-ahead'));
        return earliest ? schema.min((0, $b1e48e867c2e2e0c$export$a26bb6a012e2ca6f)(availability.prebook.tripRules), (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-not-valid')) : schema;
    }),
    flightNumber: $a0206caf38308288$export$185802fd694ee1f5().when('departure', (departure)=>{
        if (departure?.locationInformation?.some((info)=>info?.tag === 'FLIGHT_NBR')) return $a0206caf38308288$export$185802fd694ee1f5().matches($b2f068b631255673$var$FLIGHT_NUMBER_PATTERN, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-flight-number')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-flight-number'));
        return $a0206caf38308288$export$185802fd694ee1f5();
    }),
    passengerCount: $6e6ad40c65975a5d$export$185802fd694ee1f5().when('departure', (departure)=>{
        const required = departure?.locationInformation?.some((info)=>info?.tag === 'TRAVELER_COUNT_REQUIRED');
        return required ? $6e6ad40c65975a5d$export$185802fd694ee1f5().min(1, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-passenger-count')) : $6e6ad40c65975a5d$export$185802fd694ee1f5();
    }),
    departure: $2da2ea4b605d7bd9$export$185802fd694ee1f5(),
    availability: $2da2ea4b605d7bd9$export$185802fd694ee1f5()
}).concat((0, $e68f4d42f1872239$export$2e2bcd8739ae039).validationSchema);
var $b2f068b631255673$export$2e2bcd8739ae039 = $b2f068b631255673$var$ReturnTripBooking;


var $d42fe1adac46a4bb$exports = {};

$parcel$export($d42fe1adac46a4bb$exports, "bookingwidget", function () { return $d42fe1adac46a4bb$export$4936eb119b30c4d; }, function (v) { return $d42fe1adac46a4bb$export$4936eb119b30c4d = v; });
$parcel$export($d42fe1adac46a4bb$exports, "fullscreen", function () { return $d42fe1adac46a4bb$export$af93ab412ae68734; }, function (v) { return $d42fe1adac46a4bb$export$af93ab412ae68734 = v; });
$parcel$export($d42fe1adac46a4bb$exports, "loadingOverlay", function () { return $d42fe1adac46a4bb$export$63950c2525d2f62b; }, function (v) { return $d42fe1adac46a4bb$export$63950c2525d2f62b = v; });
var $d42fe1adac46a4bb$export$4936eb119b30c4d;
var $d42fe1adac46a4bb$export$af93ab412ae68734;
var $d42fe1adac46a4bb$export$63950c2525d2f62b;
$d42fe1adac46a4bb$export$4936eb119b30c4d = `ievK_G_bookingwidget`;
$d42fe1adac46a4bb$export$af93ab412ae68734 = `ievK_G_fullscreen`;
$d42fe1adac46a4bb$export$63950c2525d2f62b = `ievK_G_loadingOverlay`;




const $20dd04332cd47de5$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($d42fe1adac46a4bb$exports);
// The embed is permanently in fullscreen: there is no surrounding page to
// collapse back into, so the module keeps the "booking started" layout from the
// first render and never leaves it. See body.embed-mode in modern/index.css for
// the matching layout rules.
const $20dd04332cd47de5$var$isEmbed = ()=>!!window.EMBED_CONFIG?.isEmbed;
const $20dd04332cd47de5$var$getPaymentType = (account)=>{
    if (account?.type === 'creditcard') return `CreditCard-${account.accountId}`;
    else if (account?.type === 'TSAB' || account?.type === 'TCA') return `Account-${account.accountNumber}`;
    return 'DefaultNoSelect';
};
const $20dd04332cd47de5$var$BookingModule = ()=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { preferredPaymentAccount: preferredPaymentAccount, preferredPaymentAccountCompany: preferredPaymentAccountCompany, preferredPaymentMethod: preferredPaymentMethod, preferredPaymentMethodCompany: preferredPaymentMethodCompany, isCompanyTrip: isCompanyTrip, user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const preferredPayment = isCompanyTrip ? preferredPaymentAccountCompany : preferredPaymentAccount;
    const preferredMethod = isCompanyTrip ? preferredPaymentMethodCompany : preferredPaymentMethod;
    const pt = preferredMethod === 'PayInCar' ? 'PayInCar' : $20dd04332cd47de5$var$getPaymentType(preferredPayment);
    // Memoize initialValues to prevent unnecessary re-renders when isCompanyTrip changes
    // This prevents Formik from reinitializing and losing fullscreen state
    const initialValues = (0, $bh6RR.useMemo)(()=>({
            autoValues: {
                pickupTime: null,
                serviceType: null,
                fixedPrice: null
            },
            pickupTime: '',
            departure: '',
            destination: '',
            payment: pt,
            account: preferredMethod === 'PayInCar' ? false : preferredPayment,
            intermediateStopLocations: [],
            serviceType: 'taxi',
            flightNumber: '',
            checkedInBaggage: false,
            passengerCount: 0,
            priceToken: '',
            pet: false,
            low: false,
            stationWagon: false,
            booster: 0,
            rearFacingChildSeat: false,
            electric: false,
            name: '',
            phone: '',
            generalComment: '',
            accountReference: '',
            company: isCompanyTrip && user?.companyConnections?.[0] ? user?.companyConnections?.[0] : false,
            isCompanyTrip: isCompanyTrip,
            fixedPrice: true,
            priceIsLoading: false,
            priceEstimate: '',
            originInfo: [],
            vouchers: [],
            voucherObjects: [],
            selectedProviderId: '',
            lockedProviderId: '',
            // In edit mode: the original booking's provider, cannot be changed
            availability: {
                direct: false,
                prebook: false
            },
            availabilityIsLoading: false,
            priceType: false,
            region: null,
            // Edit mode fields
            pickupTimeInitialized: false,
            // true once SelectTime has applied the API-derived minimum
            bookingId: NaN,
            // NaN for new bookings, number for edits
            booking: null,
            // Full booking object in edit mode
            editableFields: [],
            // Array of editable field paths from API
            editableOptions: {},
            // Object with editable vehicle options
            editToken: '',
            // Token from edit-estimate response
            // Return trip fields (docs/RETURNTRIP.md)
            originalBookingReference: null,
            // Tracking reference from the original booking's returnTripRules, sent with the booking request
            returnTripBooking: null,
            // The original booking the return trip was prefilled from (read-only details in the sheet)
            returnTripPayment: null // { payment, account } carried over from the original booking; the sheet keeps the form on it
        }), [
        pt,
        preferredMethod,
        preferredPayment,
        isCompanyTrip,
        user?.companyConnections
    ]);
    const views = [
        {
            id: 'locations',
            component: (0, $9f195eb774806913$export$2e2bcd8739ae039)
        },
        {
            id: 'time',
            component: (0, $b1e48e867c2e2e0c$export$2e2bcd8739ae039)
        },
        {
            id: 'how',
            component: (0, $868fdca409bb61c6$export$2e2bcd8739ae039)
        },
        {
            id: 'otpflow',
            component: (0, $f3d0713c6d8a0a0e$export$2e2bcd8739ae039)
        },
        {
            id: 'confirm',
            component: (0, $e68f4d42f1872239$export$2e2bcd8739ae039)
        },
        {
            id: 'done',
            component: (0, $c0b58a92d2a95efd$export$2e2bcd8739ae039)
        },
        // Prefilled return trip sheet; entered via RETURN_TRIP_BOOKING, never by next() from 'done'
        {
            id: 'returntrip',
            component: (0, $b2f068b631255673$export$2e2bcd8739ae039)
        }
    ];
    const embed = $20dd04332cd47de5$var$isEmbed();
    const [fullscreen, setFullscreen] = (0, $bh6RR.useState)(embed);
    const [bookingStarted, setBookingStarted] = (0, $bh6RR.useState)(false);
    const [isLoadingEdit, setIsLoadingEdit] = (0, $bh6RR.useState)(false);
    const bookingStartedRef = (0, $bh6RR.useRef)(false);
    // Use ref to preserve fullscreen state across re-renders when isCompanyTrip changes
    const fullscreenRef = (0, $bh6RR.useRef)(embed);
    (0, $bh6RR.useEffect)(()=>{
        bookingStartedRef.current = bookingStarted;
    }, [
        bookingStarted
    ]);
    (0, $bh6RR.useEffect)(()=>{
        fullscreenRef.current = fullscreen;
    }, [
        fullscreen
    ]);
    // While a return trip is being prefilled (RETURN_TRIP_BOOKING until the next reset) the
    // module is not yet fullscreen, so lock the form explicitly: a reinitialize in that window
    // (e.g. the preferred payment saved by the booking just placed) would wipe the prefill.
    const returnTripRef = (0, $bh6RR.useRef)(false);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RETURN_TRIP_BOOKING', ()=>{
        returnTripRef.current = true;
    }, []);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
        setBookingStarted(false);
        // Also update the ref right away: handleViewChange runs in a layout effect on the very
        // next render and must not see the stale "started" value (it would re-enter fullscreen).
        bookingStartedRef.current = false;
        returnTripRef.current = false;
        // In the embed there is nothing to collapse back into, so stay fullscreen.
        if (embed) return;
        setFullscreen(false);
        if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_END_FULLSCREEN);
    }, [
        setFullscreen,
        setBookingStarted,
        embed
    ]);
    // Called from ViewListener's layout effect, synchronously (it used to run 50 ms later via
    // setTimeout, which painted the new view in the old layout for a frame and then reflowed it).
    const handleViewChange = (id, prevId)=>{
        if (id !== 'locations' || bookingStartedRef.current) {
            setFullscreen(true);
            setBookingStarted(true);
            bookingStartedRef.current = true;
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_STARTED');
            if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_FULLSCREEN);
        } else if (!embed) {
            setFullscreen(false);
            if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_END_FULLSCREEN);
        }
        if (id === 'locations' || prevId === 'locations') (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DISPLAY_TRIP');
    };
    const [isWaitingForPoll, setIsWaitingForPoll] = (0, $bh6RR.useState)(false);
    // Listen for waiting for poll state to add overlay
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('BOOKING_WAITING_FOR_POLL', ({ waiting: waiting })=>{
        setIsWaitingForPoll(waiting || false);
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            isWaitingForPoll && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.0)',
                    zIndex: 10000,
                    pointerEvents: 'all',
                    cursor: 'not-allowed'
                }
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $20dd04332cd47de5$var$cx($d42fe1adac46a4bb$exports.bookingwidget, {
                    fullscreen: fullscreen
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$2e2bcd8739ae039), {
                        views: views,
                        sendEvent: true,
                        children: ({ View: View, id: id })=>{
                            // Memoize formInitialValues to prevent Formik reinitialization when isCompanyTrip changes
                            // This prevents fullscreen from being lost when switching between private/company
                            const formInitialValues = (0, $bh6RR.useMemo)(()=>({
                                    ...initialValues
                                }), [
                                initialValues
                            ]);
                            // Check if we're in edit mode (editing an existing booking)
                            const isInEditMode = !isNaN(formInitialValues.bookingId) && formInitialValues.bookingId > 0;
                            // Disable reinitialize on 'done' step to prevent form reset when booking is confirmed
                            // Also disable reinitialize when we're already in fullscreen to prevent CSS issues
                            // Also disable reinitialize when in edit mode to prevent form values from being reset while user is editing
                            // This ensures booking details are preserved when navigating to confirmation
                            //
                            // The embed is fullscreen from the first render, so fullscreenRef would lock
                            // the form immediately and initialValues (preferred payment, user details)
                            // could never land after login. Gate on bookingStarted there instead — the
                            // same point in the flow the fullscreen check stands in for elsewhere.
                            const valuesLocked = (embed ? bookingStartedRef.current : fullscreenRef.current) || returnTripRef.current;
                            const shouldReinitialize = id !== 'done' && id !== 'returntrip' && !valuesLocked && !isInEditMode;
                            return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
                                initialValues: formInitialValues,
                                enableReinitialize: shouldReinitialize,
                                validationSchema: typeof View.validationSchema === 'function' ? (formikValues)=>{
                                    // Re-evaluate validation schema with current form values
                                    // This ensures it updates when availability data loads
                                    return View.validationSchema(formikValues);
                                } : View.validationSchema,
                                validateOnChange: true,
                                validateOnBlur: id === 'locations',
                                onSubmit: async (values)=>{},
                                onReset: ()=>{
                                    if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
                                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_FORM');
                                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_MAP');
                                },
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9832901ac9096800$export$2e2bcd8739ae039), {}),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$b2d7bc9e68dacbc), {
                                            currentView: id,
                                            fullscreen: fullscreen
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $247ae7f4639f55fe$export$2e2bcd8739ae039), {
                                            message: t('reset-booking-message')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $57ccc41fcf47abfa$export$2e2bcd8739ae039), {
                                            onViewChange: handleViewChange
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)($20dd04332cd47de5$var$FormikListener, {
                                            setIsLoadingEdit: setIsLoadingEdit
                                        }),
                                        false
                                    ]
                                })
                            }, "booking-form-stable" // Stable key to prevent unnecessary remounting that clears values
                            );
                        }
                    }),
                    isLoadingEdit && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $d42fe1adac46a4bb$exports.loadingOverlay,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        ]
    });
};
const $20dd04332cd47de5$var$FormikListener = ({ setIsLoadingEdit: setIsLoadingEdit })=>{
    const { user: user, preferredPaymentAccount: preferredPaymentAccount, preferredPaymentAccountCompany: preferredPaymentAccountCompany, preferredPaymentMethod: preferredPaymentMethod, preferredPaymentMethodCompany: preferredPaymentMethodCompany, setCurrentPaymentAccount: setCurrentPaymentAccount, isCompanyTrip: isCompanyTrip, paymentAccounts: paymentAccounts } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, dirty: dirty, setFieldValue: setFieldValue, setValues: setValues, resetForm: resetForm, initialValues: initialValues } = (0, $lW2XZ.useFormikContext)();
    const { next: next, reset: resetStepper } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    //const [bookingStarted, setBookingStarted] = useState(false);
    const prevDeparture = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(values.departure);
    const prevDestination = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(values.destination);
    const prevLocations = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)([
        values.departure,
        ...values.intermediateStopLocations,
        values.destination
    ]);
    // Listen for pending booking confirmation
    // NOTE: This is a fallback handler. The main handler is in ConfirmBooking component.
    // This only handles cases where ConfirmBooking isn't mounted (shouldn't happen normally)
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('PENDING_BOOKING_CONFIRMED', ({ bookingId: bookingId })=>{
        // Only handle if bookingId is not already set (fallback case)
        // The ConfirmBooking component should handle this normally
        if (isNaN(values?.bookingId)) {
            // Fallback: set bookingId and navigate if ConfirmBooking didn't handle it
            (0, $740a278ce29d303f$export$12eefddf5beacf4d)(bookingId);
            setFieldValue('bookingId', bookingId, false);
            // Use requestAnimationFrame to ensure setFieldValue completes before navigation
            requestAnimationFrame(()=>{
                next('done');
            });
        }
    });
    const hasUpdatedUser = (0, $bh6RR.useRef)(false);
    const isWaitingForAvailability = (0, $bh6RR.useRef)(false);
    // Set while a return trip is being prefilled, so RESET_FORM's delayed preferred-payment
    // restore (300 ms) doesn't overwrite the payment carried over from the original booking.
    const returnTripPendingRef = (0, $bh6RR.useRef)(false);
    // Update preferred acount and payment type on form reset
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
        returnTripPendingRef.current = false;
        const preferredPayment = isCompanyTrip ? preferredPaymentAccountCompany : preferredPaymentAccount;
        const preferredMethod = isCompanyTrip ? preferredPaymentMethodCompany : preferredPaymentMethod;
        setCurrentPaymentAccount(null, false);
        setCurrentPaymentAccount(null, true);
        isWaitingForAvailability.current = false; // Cancel any pending navigation
        hasUpdatedUser.current = false; // Reset so user name/phone will be re-filled
        // Reset form to initial values
        const resetValues = {
            ...initialValues
        };
        resetValues.isCompanyTrip = values.isCompanyTrip; // Preserve company trip status
        resetValues.company = values.company; // Preserve company name if set
        resetForm({
            values: resetValues
        });
        resetStepper();
        setTimeout(()=>{
            if (returnTripPendingRef.current) return;
            // Restore PayInCar if preferred
            if (preferredMethod === 'PayInCar') {
                setFieldValue('payment', 'PayInCar', false);
                setFieldValue('account', false, false);
            } else if (preferredPayment && preferredPayment !== false) {
                setFieldValue('payment', $20dd04332cd47de5$var$getPaymentType(preferredPayment), false);
                setFieldValue('account', preferredPayment, false);
            }
        }, 300);
    }, [
        setFieldValue,
        resetForm,
        initialValues,
        resetStepper,
        preferredPaymentAccount,
        preferredPaymentAccountCompany,
        preferredPaymentMethod,
        preferredPaymentMethodCompany,
        setCurrentPaymentAccount,
        isCompanyTrip,
        values.isCompanyTrip,
        values.company
    ]);
    // Handle edit booking event
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('EDIT_BOOKING', async (booking)=>{
        // Trigger fullscreen immediately so loading spinner covers the whole page
        if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_FULLSCREEN);
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_STARTED');
        setIsLoadingEdit(true);
        try {
            // Fetch editable fields from API
            const editableData = await (0, $135a523c4bea715f$export$81ea9e0398c88adc)(booking.id);
            // Map booking data to form values
            const hasFlightInfo = booking.originLocation?.flightInfo !== undefined;
            const pickupTime = booking.bookingType === 'PRE_BOOKING' ? new Date(booking.pickUpTimeStamp) : '';
            // Service type (estate = taxi + stationWagon), add-ons and payment — shared with the return trip prefill
            const { serviceType: serviceType, pet: pet, low: low, stationWagon: stationWagon, booster: boosterSeats, rearFacingChildSeat: rearFacingChildSeat, electric: electric } = (0, $41fa9b8a4b906cc1$export$c6c55fc676373d68)(booking);
            const { payment: payment, account: account } = (0, $41fa9b8a4b906cc1$export$78159ad0f2a992bf)(booking, user, paymentAccounts);
            // Transform booking locations to form format
            // Booking API returns flat structure, but form expects nested address object
            const transformedDeparture = (0, $41fa9b8a4b906cc1$export$32eda01d55099ab8)(booking.originLocation, hasFlightInfo);
            const transformedDestination = (0, $41fa9b8a4b906cc1$export$32eda01d55099ab8)(booking.destinationLocation);
            const transformedIntermediateStops = (booking.intermediateStopLocations || []).map((loc)=>(0, $41fa9b8a4b906cc1$export$32eda01d55099ab8)(loc));
            // Set all form values for edit mode
            setFieldValue('bookingId', booking.id, false);
            setFieldValue('booking', booking, false); // Store the full booking object
            setFieldValue('editableFields', editableData.editableFields || [], false);
            // Lock to the original booking's provider so partner cannot be changed during edit
            const lockedProviderId = booking.providerData?.providerId || booking.providerId || '';
            setFieldValue('lockedProviderId', lockedProviderId, false);
            if (lockedProviderId) setFieldValue('selectedProviderId', lockedProviderId, false);
            setFieldValue('editableOptions', editableData.editableOptions || {}, false);
            setFieldValue('editableFieldsValidUntil', editableData.validUntil || null, false);
            setFieldValue('departure', transformedDeparture, false);
            setFieldValue('destination', transformedDestination, false);
            setFieldValue('intermediateStopLocations', transformedIntermediateStops, false);
            setFieldValue('pickupTime', pickupTime, false);
            setFieldValue('serviceType', serviceType, false);
            setFieldValue('name', booking.traveler?.name || '', false);
            setFieldValue('phone', booking.traveler?.phoneNumber || '', false);
            setFieldValue('generalComment', booking.generalComment || '', false);
            setFieldValue('accountReference', booking.invoiceReference || '', false);
            setFieldValue('flightNumber', hasFlightInfo ? booking.originLocation.flightInfo.flightNumber : '', false);
            setFieldValue('checkedInBaggage', hasFlightInfo ? booking.originLocation.flightInfo.checkedInBaggage : false, false);
            setFieldValue('pet', pet, false);
            setFieldValue('low', low, false);
            setFieldValue('stationWagon', stationWagon, false);
            setFieldValue('booster', boosterSeats, false);
            setFieldValue('rearFacingChildSeat', rearFacingChildSeat, false);
            setFieldValue('electric', electric, false);
            setFieldValue('payment', payment, false);
            setFieldValue('account', account, false);
            setFieldValue('company', booking.company || false, false);
            setFieldValue('isCompanyTrip', booking.company !== undefined, false);
            // Set flag to navigate to 'how' view once availability data is loaded
            isWaitingForAvailability.current = true;
            // Navigate to locations view with pre-filled data
            // This triggers the Fetcher to load availability data
            // Note: BOOKING_STARTED and FULLSCREEN are now triggered at the start of EDIT_BOOKING
            setTimeout(()=>{}, 100);
        } catch (error) {
            console.error('=== Error loading booking for edit ===', error);
            setIsLoadingEdit(false);
        }
    }, [
        setFieldValue,
        paymentAccounts,
        user,
        values,
        setIsLoadingEdit
    ]);
    // Return trip (docs/RETURNTRIP.md): prefill the form from the original booking with the trip
    // reversed and open the return trip sheet. Mirrors the app's prepareReturnTripService:
    // original destination becomes pickup, original origin becomes destination, intermediate
    // stops reversed; car type, add-ons, passengers, company, reference and payment method are
    // carried over; the time (and flight info for an airport pickup) is left for the user.
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RETURN_TRIP_BOOKING', async (booking)=>{
        if (!booking?.destinationLocation) return;
        returnTripPendingRef.current = true;
        if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_FULLSCREEN);
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_STARTED');
        setIsLoadingEdit(true);
        try {
            // Resolve precise locations so the information tags (e.g. FLIGHT_NBR, which decides
            // whether the sheet asks for flight info) are present. Fall back to the booking's own
            // flat location if the lookup fails.
            const resolveLocation = async (loc)=>{
                try {
                    const full = await (0, $135a523c4bea715f$export$359350a296630f29)(loc);
                    // /locations/{id} answers with `locationId`; the form (and the availability query)
                    // expects `id`, like LocationSearch's formatLocationWithId.
                    if (full?.address?.streetName) {
                        const { locationId: locationId, ...rest } = full;
                        return {
                            id: locationId || loc.id,
                            ...rest
                        };
                    }
                } catch (error) {
                    console.error('Could not resolve location for return trip', error);
                }
                return (0, $41fa9b8a4b906cc1$export$32eda01d55099ab8)(loc);
            };
            const [departure, destination, ...intermediateStopLocations] = await Promise.all([
                resolveLocation(booking.destinationLocation),
                resolveLocation(booking.originLocation),
                ...(booking.intermediateStopLocations || []).slice().reverse().map(resolveLocation)
            ]);
            const vehicle = (0, $41fa9b8a4b906cc1$export$c6c55fc676373d68)(booking);
            let { payment: payment, account: account } = (0, $41fa9b8a4b906cc1$export$78159ad0f2a992bf)(booking, user, paymentAccounts);
            // Klarna/Apple Pay/removed cards can't be booked with here; leave the payment unselected so
            // the sheet raises the "payment method not available" problem once availability is in.
            if (!(0, $41fa9b8a4b906cc1$export$a48220273aa14edc)(payment, account)) {
                payment = 'DefaultNoSelect';
                account = false;
            }
            // Keep the original trip's company (prefer the live connection for requireReference etc.)
            const company = booking.company ? user?.companyConnections?.find((c)=>c.id === booking.company.id) || booking.company : false;
            setValues({
                ...values,
                bookingId: NaN,
                booking: null,
                editableFields: [],
                editableOptions: {},
                editToken: '',
                lockedProviderId: '',
                selectedProviderId: booking.providerData?.providerId || '',
                departure: departure,
                destination: destination,
                intermediateStopLocations: intermediateStopLocations,
                pickupTime: '',
                pickupTimeInitialized: false,
                flightNumber: '',
                checkedInBaggage: false,
                passengerCount: booking.traveler?.travelerCount || 0,
                ...vehicle,
                name: booking.traveler?.name || values.name || (0, $200ec6b1b2ca8c5a$export$c1fb9bac27b52cdd)(user),
                phone: booking.traveler?.phoneNumber || values.phone || user?.phone || '',
                generalComment: '',
                accountReference: booking.invoiceReference || '',
                payment: payment,
                account: account,
                company: company,
                isCompanyTrip: booking.company !== undefined,
                fixedPrice: true,
                vouchers: [],
                voucherObjects: [],
                priceEstimate: '',
                priceToken: '',
                priceType: false,
                autoValues: {
                    pickupTime: null,
                    serviceType: null,
                    fixedPrice: null
                },
                availability: {
                    direct: false,
                    prebook: false
                },
                originalBookingReference: booking.returnTripRules?.originalBookingReference || null,
                returnTripBooking: booking,
                returnTripPayment: {
                    payment: payment,
                    account: account
                }
            }, false);
            setTimeout(()=>{
                next('returntrip');
                setIsLoadingEdit(false);
            }, 50);
        } catch (error) {
            console.error('=== Error preparing return trip ===', error);
            returnTripPendingRef.current = false;
            setIsLoadingEdit(false);
        }
    }, [
        setValues,
        values,
        user,
        paymentAccounts,
        next,
        setIsLoadingEdit
    ]);
    // Update voucherObjects array when vouchers are changed
    // The objects are used to render details in the BookingSummary
    (0, $bh6RR.useEffect)(()=>{
        if (user && user.vouchers) {
            const voucherObjects = user.vouchers.filter((item)=>values.vouchers.includes(item.voucherCode));
            setFieldValue('voucherObjects', voucherObjects, false);
        }
    }, [
        values.vouchers
    ]);
    // Set username and phone if we have a logged in user
    (0, $bh6RR.useEffect)(()=>{
        if (user && (dirty === false || hasUpdatedUser.current === false)) {
            if (values.name === '') setFieldValue('name', (0, $200ec6b1b2ca8c5a$export$c1fb9bac27b52cdd)(user), false);
            if (values.phone === '') setFieldValue('phone', user.phone, false);
            hasUpdatedUser.current = true;
        }
    }, [
        user,
        values,
        dirty,
        hasUpdatedUser,
        setFieldValue
    ]);
    // Auto-navigate to appropriate view once availability data is loaded in edit mode
    (0, $bh6RR.useEffect)(()=>{
        if (isWaitingForAvailability.current) {
            const key = values.pickupTime === '' ? 'direct' : 'prebook';
            const hasAvailability = values.availability?.[key]?.availabilities !== undefined;
            if (hasAvailability) {
                isWaitingForAvailability.current = false;
                // Check if time or flight info fields are editable
                const isTimeEditable = values.editableFields?.includes('pickUpTimeStamp');
                const isFlightNumberEditable = values.editableFields?.includes('originLocation.flightInfo.flightNumber');
                const isCheckedBaggageEditable = values.editableFields?.includes('originLocation.flightInfo.checkedInBaggage');
                // Check if origin location has FLIGHT_NBR tag
                const hasFlightNumberTag = values.departure?.locationInformation?.some((info)=>info.tag === 'FLIGHT_NBR') || false;
                // Show SelectTime if:
                // 1. pickUpTimeStamp is editable OR
                // 2. (flight info fields are editable AND origin has FLIGHT_NBR tag)
                const shouldStartOnTime = isTimeEditable || (isFlightNumberEditable || isCheckedBaggageEditable) && hasFlightNumberTag;
                setTimeout(()=>{
                    if (shouldStartOnTime) next('time');
                    else next('how');
                    setIsLoadingEdit(false);
                }, 100);
            }
        }
    }, [
        values.availability,
        values.departure,
        values.destination,
        values.serviceType,
        values.bookingId,
        values.editableFields,
        next,
        setIsLoadingEdit
    ]);
    const hasValue = (value)=>value !== '' && value !== '-' && value?.address !== undefined;
    // Trigger events to update the map
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        const locations = [
            values.departure,
            ...values.intermediateStopLocations,
            values.destination
        ];
        const locationAdded = locations.length > prevLocations?.length || locations.length === prevLocations?.length && locations.some((item, index)=>hasValue(item) && !hasValue(prevLocations[index]));
        // const locationRemoved = locations.length < prevLocations?.length || locations.length === prevLocations?.length && locations.some((item, index) => !hasValue(item) && hasValue(prevLocations[index]))
        // const orderChanged = locations.length === prevLocations?.length && !locationRemoved && locations.every(item => prevLocations.includes(item))
        // console.log(prevLocations)
        // console.log(locations)
        // console.log('locationAdded:', locationAdded)
        // console.log('locationRemoved:', locationRemoved)
        // console.log('orderChanged:', orderChanged)
        let indexAdded = null;
        // If location is added, find index to zoom in on that item on the map
        if (locationAdded) indexAdded = locations.findIndex((item, index)=>item !== prevLocations[index]);
        // Set destination INFO messages in originInfo (departure notifications are
        // handled directly by Notifications component using new tag logic).
        const destinationInfo = {
            title: values.destination?.name || values.destination?.address?.poiName,
            info: null
        };
        destinationInfo.info = values.destination?.locationInformation?.filter((item)=>[
                'INFO'
            ].includes(item?.tag)).map((item)=>item.message) || [];
        setFieldValue('originInfo', [
            destinationInfo
        ].filter((info)=>info.info.length > 0), false);
        // If destination is changed, update origin info
        if (values.departure?.address && values.departure !== prevDeparture) setFieldValue('originInfo', [
            destinationInfo
        ].filter((info)=>info.info.length > 0), false);
        else if (!hasValue(values.departure) && hasValue(prevDeparture)) {
            setFieldValue('originInfo', [], false);
            setFieldValue('region', null, false);
        }
        // Update map with locations, change any empty locations to null
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('LOCATION_CHANGE', {
            locations: locations.map((item)=>!hasValue(item) ? null : item),
            active: indexAdded
        });
        // Zoom out and display trip
        if (!locationAdded) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DISPLAY_TRIP');
    }, [
        values.departure,
        values.destination,
        values.intermediateStopLocations
    ]);
    return null;
};
var $20dd04332cd47de5$export$2e2bcd8739ae039 = $20dd04332cd47de5$var$BookingModule;



var $ih19M = parcelRequire("ih19M");


var $bh6RR = parcelRequire("bh6RR");




var $622f9278207e0894$exports = {};

$parcel$export($622f9278207e0894$exports, "active", function () { return $622f9278207e0894$export$89da14300d534261; }, function (v) { return $622f9278207e0894$export$89da14300d534261 = v; });
$parcel$export($622f9278207e0894$exports, "button", function () { return $622f9278207e0894$export$2ba01fb71ed41cb6; }, function (v) { return $622f9278207e0894$export$2ba01fb71ed41cb6 = v; });
$parcel$export($622f9278207e0894$exports, "buttons", function () { return $622f9278207e0894$export$bbea856fdb3e3c5f; }, function (v) { return $622f9278207e0894$export$bbea856fdb3e3c5f = v; });
$parcel$export($622f9278207e0894$exports, "corner", function () { return $622f9278207e0894$export$32c9958544d81ba4; }, function (v) { return $622f9278207e0894$export$32c9958544d81ba4 = v; });
$parcel$export($622f9278207e0894$exports, "cornerTabsLeft", function () { return $622f9278207e0894$export$c3b61f3dc1da6f61; }, function (v) { return $622f9278207e0894$export$c3b61f3dc1da6f61 = v; });
$parcel$export($622f9278207e0894$exports, "left", function () { return $622f9278207e0894$export$eabcd2c8791e7bf4; }, function (v) { return $622f9278207e0894$export$eabcd2c8791e7bf4 = v; });
$parcel$export($622f9278207e0894$exports, "right", function () { return $622f9278207e0894$export$79ffe56a765070d2; }, function (v) { return $622f9278207e0894$export$79ffe56a765070d2 = v; });
var $622f9278207e0894$export$89da14300d534261;
var $622f9278207e0894$export$2ba01fb71ed41cb6;
var $622f9278207e0894$export$bbea856fdb3e3c5f;
var $622f9278207e0894$export$32c9958544d81ba4;
var $622f9278207e0894$export$c3b61f3dc1da6f61;
var $622f9278207e0894$export$eabcd2c8791e7bf4;
var $622f9278207e0894$export$79ffe56a765070d2;
$622f9278207e0894$export$89da14300d534261 = `_1hDY3q_active`;
$622f9278207e0894$export$2ba01fb71ed41cb6 = `_1hDY3q_button`;
$622f9278207e0894$export$bbea856fdb3e3c5f = `_1hDY3q_buttons`;
$622f9278207e0894$export$32c9958544d81ba4 = `_1hDY3q_corner`;
$622f9278207e0894$export$c3b61f3dc1da6f61 = `_1hDY3q_cornerTabsLeft`;
$622f9278207e0894$export$eabcd2c8791e7bf4 = `_1hDY3q_left`;
$622f9278207e0894$export$79ffe56a765070d2 = `_1hDY3q_right`;



const $d029f9e7b709ac5b$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($622f9278207e0894$exports);
// TODO: Make a global solution to this
const $d029f9e7b709ac5b$var$supportedLangs = [
    'sv',
    'en'
];
let $d029f9e7b709ac5b$var$lang = document.querySelector('html').getAttribute('lang')?.substr(0, 2);
if (!$d029f9e7b709ac5b$var$supportedLangs.includes($d029f9e7b709ac5b$var$lang)) $d029f9e7b709ac5b$var$lang = 'sv';
const $d029f9e7b709ac5b$var$hashes = {
    sv: {
        bookTaxi: '#boka-taxi',
        bookDelivery: '#boka-bud',
        bookDeliveryPath: 'boka-bud'
    },
    en: {
        bookTaxi: '#book-taxi',
        bookDelivery: '#book-delivery',
        bookDeliveryPath: 'book-delivery'
    }
};
const $d029f9e7b709ac5b$var$getLocalizedHash = (hash)=>{
    return $d029f9e7b709ac5b$var$hashes[$d029f9e7b709ac5b$var$lang][hash];
};
function $d029f9e7b709ac5b$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isDirty, setIsDirty] = (0, $bh6RR.useState)(false);
    const [isPackage, setIsPackage] = (0, $bh6RR.useState)(location.hash === $d029f9e7b709ac5b$var$getLocalizedHash('bookDelivery') ? true : location.href.includes($d029f9e7b709ac5b$var$getLocalizedHash('bookDeliveryPath')));
    const [showButtons, setShowButtons] = (0, $bh6RR.useState)(true);
    const [bookingStarted, setBookingStarted] = (0, $bh6RR.useState)(false);
    const switchBooking = (showPackage)=>{
        const callback = ()=>{
            setIsPackage(showPackage);
            setIsDirty(false);
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_MAP');
            location.href = $d029f9e7b709ac5b$var$getLocalizedHash(showPackage ? 'bookDelivery' : 'bookTaxi');
            APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
        };
        if (!isDirty) callback();
        else (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(t('reset-booking-message'), [
            {
                title: t('button-yes'),
                callback: callback
            },
            {
                title: t('button-no')
            }
        ]);
    };
    const handleHashClick = (e)=>{
        const t = e.target.hash === $d029f9e7b709ac5b$var$getLocalizedHash('bookTaxi');
        const d = e.target.hash === $d029f9e7b709ac5b$var$getLocalizedHash('bookDelivery');
        if (t || d) {
            switchBooking(d);
            scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    };
    // Show the buttons only on the first step
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('VIEW_CHANGE', (data)=>{
        setShowButtons(data.id === 'locations');
    }, [
        showButtons
    ]);
    // Set isDirty when a location is selected
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('LOCATION_CHANGE', ({ locations: locations })=>{
        if (!locations.every((item)=>item === null)) setIsDirty(true);
    }, [
        isDirty
    ]);
    // Resetting the form clears the isDirty flag
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
        setIsDirty(false);
        setBookingStarted(false);
    }, [
        isDirty,
        bookingStarted
    ]);
    // Remove buttons if booking started
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('BOOKING_STARTED', ()=>{
        setBookingStarted(true);
    }, [
        bookingStarted
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setTimeout(()=>{
            APP.trigger(APP.events.SHOW_BOOKING_WIDGET);
        }, 50);
        // Get all links containing a hash
        const links = [];
        const l = (0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('a[href*="#"]');
        if (l.length > 0) {
            // Get hashes for current lang
            const h = Object.values($d029f9e7b709ac5b$var$hashes[$d029f9e7b709ac5b$var$lang]);
            // Iterate links and hashes
            l.forEach((link)=>{
                h.forEach((hash)=>{
                    // If there is a link to the current page + a hash add a click listener
                    if (link.href === location.origin + location.pathname + hash) {
                        link.addEventListener('click', handleHashClick);
                        links.push(link);
                    }
                });
            });
        }
        // Return function that removes listeners
        return ()=>{
            links.forEach((link)=>{
                link.removeEventListener('click', handleHashClick);
            });
        };
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            showButtons && !bookingStarted && !CONFIG.svea_module && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $622f9278207e0894$exports.buttons,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                        onClick: ()=>switchBooking(false),
                        className: $d029f9e7b709ac5b$var$cx($622f9278207e0894$exports.button, {
                            active: !isPackage
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $622f9278207e0894$exports.cornerTabsLeft
                            }),
                            t('button-book-taxi'),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $d029f9e7b709ac5b$var$cx($622f9278207e0894$exports.corner, {
                                    right: true
                                })
                            })
                        ]
                    }),
                    !CONFIG.svea_module && /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                        onClick: ()=>switchBooking(true),
                        className: $d029f9e7b709ac5b$var$cx($622f9278207e0894$exports.button, {
                            active: isPackage
                        }),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $d029f9e7b709ac5b$var$cx($622f9278207e0894$exports.corner, {
                                    left: true
                                })
                            }),
                            t('button-book-delivery'),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $d029f9e7b709ac5b$var$cx($622f9278207e0894$exports.corner, {
                                    right: true
                                })
                            })
                        ]
                    })
                ]
            }),
            !isPackage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $20dd04332cd47de5$export$2e2bcd8739ae039), {}),
            isPackage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $8d3f5c7c22e09279$export$2e2bcd8739ae039), {})
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $5aa1ea04dd4019e5$exports = {};
!function(e, t) {
    $5aa1ea04dd4019e5$exports = t();
}("undefined" != typeof self ? self : $5aa1ea04dd4019e5$exports, ()=>(()=>{
        var e = {
            750: function(e, t, a) {
                var n, r;
                !function(i, o, c) {
                    "use strict";
                    "undefined" != typeof window && a.amdO ? void 0 === (r = "function" == typeof (n = c) ? n.call(t, a, t, e) : n) || (e.exports = r) : e.exports ? e.exports = c() : o.exports ? o.exports = c() : o.Fingerprint2 = c();
                }(0, this, function() {
                    "use strict";
                    void 0 === Array.isArray && (Array.isArray = function(e) {
                        return "[object Array]" === Object.prototype.toString.call(e);
                    });
                    var e = function(e, t) {
                        e = [
                            e[0] >>> 16,
                            65535 & e[0],
                            e[1] >>> 16,
                            65535 & e[1]
                        ], t = [
                            t[0] >>> 16,
                            65535 & t[0],
                            t[1] >>> 16,
                            65535 & t[1]
                        ];
                        var a = [
                            0,
                            0,
                            0,
                            0
                        ];
                        return a[3] += e[3] + t[3], a[2] += a[3] >>> 16, a[3] &= 65535, a[2] += e[2] + t[2], a[1] += a[2] >>> 16, a[2] &= 65535, a[1] += e[1] + t[1], a[0] += a[1] >>> 16, a[1] &= 65535, a[0] += e[0] + t[0], a[0] &= 65535, [
                            a[0] << 16 | a[1],
                            a[2] << 16 | a[3]
                        ];
                    }, t = function(e, t) {
                        e = [
                            e[0] >>> 16,
                            65535 & e[0],
                            e[1] >>> 16,
                            65535 & e[1]
                        ], t = [
                            t[0] >>> 16,
                            65535 & t[0],
                            t[1] >>> 16,
                            65535 & t[1]
                        ];
                        var a = [
                            0,
                            0,
                            0,
                            0
                        ];
                        return a[3] += e[3] * t[3], a[2] += a[3] >>> 16, a[3] &= 65535, a[2] += e[2] * t[3], a[1] += a[2] >>> 16, a[2] &= 65535, a[2] += e[3] * t[2], a[1] += a[2] >>> 16, a[2] &= 65535, a[1] += e[1] * t[3], a[0] += a[1] >>> 16, a[1] &= 65535, a[1] += e[2] * t[2], a[0] += a[1] >>> 16, a[1] &= 65535, a[1] += e[3] * t[1], a[0] += a[1] >>> 16, a[1] &= 65535, a[0] += e[0] * t[3] + e[1] * t[2] + e[2] * t[1] + e[3] * t[0], a[0] &= 65535, [
                            a[0] << 16 | a[1],
                            a[2] << 16 | a[3]
                        ];
                    }, a = function(e, t) {
                        return 32 == (t %= 64) ? [
                            e[1],
                            e[0]
                        ] : t < 32 ? [
                            e[0] << t | e[1] >>> 32 - t,
                            e[1] << t | e[0] >>> 32 - t
                        ] : (t -= 32, [
                            e[1] << t | e[0] >>> 32 - t,
                            e[0] << t | e[1] >>> 32 - t
                        ]);
                    }, n = function(e, t) {
                        return 0 == (t %= 64) ? e : t < 32 ? [
                            e[0] << t | e[1] >>> 32 - t,
                            e[1] << t
                        ] : [
                            e[1] << t - 32,
                            0
                        ];
                    }, r = function(e, t) {
                        return [
                            e[0] ^ t[0],
                            e[1] ^ t[1]
                        ];
                    }, i = function(e) {
                        return e = r(e, [
                            0,
                            e[0] >>> 1
                        ]), e = t(e, [
                            4283543511,
                            3981806797
                        ]), e = r(e, [
                            0,
                            e[0] >>> 1
                        ]), e = t(e, [
                            3301882366,
                            444984403
                        ]), r(e, [
                            0,
                            e[0] >>> 1
                        ]);
                    }, o = function(o, c) {
                        c = c || 0;
                        for(var s = (o = o || "").length % 16, d = o.length - s, l = [
                            0,
                            c
                        ], u = [
                            0,
                            c
                        ], f = [
                            0,
                            0
                        ], p = [
                            0,
                            0
                        ], h = [
                            2277735313,
                            289559509
                        ], m = [
                            1291169091,
                            658871167
                        ], g = 0; g < d; g += 16)f = [
                            255 & o.charCodeAt(g + 4) | (255 & o.charCodeAt(g + 5)) << 8 | (255 & o.charCodeAt(g + 6)) << 16 | (255 & o.charCodeAt(g + 7)) << 24,
                            255 & o.charCodeAt(g) | (255 & o.charCodeAt(g + 1)) << 8 | (255 & o.charCodeAt(g + 2)) << 16 | (255 & o.charCodeAt(g + 3)) << 24
                        ], p = [
                            255 & o.charCodeAt(g + 12) | (255 & o.charCodeAt(g + 13)) << 8 | (255 & o.charCodeAt(g + 14)) << 16 | (255 & o.charCodeAt(g + 15)) << 24,
                            255 & o.charCodeAt(g + 8) | (255 & o.charCodeAt(g + 9)) << 8 | (255 & o.charCodeAt(g + 10)) << 16 | (255 & o.charCodeAt(g + 11)) << 24
                        ], f = t(f, h), f = a(f, 31), f = t(f, m), l = r(l, f), l = a(l, 27), l = e(l, u), l = e(t(l, [
                            0,
                            5
                        ]), [
                            0,
                            1390208809
                        ]), p = t(p, m), p = a(p, 33), p = t(p, h), u = r(u, p), u = a(u, 31), u = e(u, l), u = e(t(u, [
                            0,
                            5
                        ]), [
                            0,
                            944331445
                        ]);
                        switch(f = [
                            0,
                            0
                        ], p = [
                            0,
                            0
                        ], s){
                            case 15:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 14)
                                ], 48));
                            case 14:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 13)
                                ], 40));
                            case 13:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 12)
                                ], 32));
                            case 12:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 11)
                                ], 24));
                            case 11:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 10)
                                ], 16));
                            case 10:
                                p = r(p, n([
                                    0,
                                    o.charCodeAt(g + 9)
                                ], 8));
                            case 9:
                                p = r(p, [
                                    0,
                                    o.charCodeAt(g + 8)
                                ]), p = t(p, m), p = a(p, 33), p = t(p, h), u = r(u, p);
                            case 8:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 7)
                                ], 56));
                            case 7:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 6)
                                ], 48));
                            case 6:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 5)
                                ], 40));
                            case 5:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 4)
                                ], 32));
                            case 4:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 3)
                                ], 24));
                            case 3:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 2)
                                ], 16));
                            case 2:
                                f = r(f, n([
                                    0,
                                    o.charCodeAt(g + 1)
                                ], 8));
                            case 1:
                                f = r(f, [
                                    0,
                                    o.charCodeAt(g)
                                ]), f = t(f, h), f = a(f, 31), f = t(f, m), l = r(l, f);
                        }
                        return l = r(l, [
                            0,
                            o.length
                        ]), u = r(u, [
                            0,
                            o.length
                        ]), l = e(l, u), u = e(u, l), l = i(l), u = i(u), l = e(l, u), u = e(u, l), ("00000000" + (l[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (l[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (u[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (u[1] >>> 0).toString(16)).slice(-8);
                    }, c = {
                        preprocessor: null,
                        audio: {
                            timeout: 1e3,
                            excludeIOS11: !0
                        },
                        fonts: {
                            swfContainerId: "fingerprintjs2",
                            swfPath: "flash/compiled/FontList.swf",
                            userDefinedFonts: [],
                            extendedJsFonts: !1
                        },
                        screen: {
                            detectScreenOrientation: !0
                        },
                        plugins: {
                            sortPluginsFor: [
                                /palemoon/i
                            ],
                            excludeIE: !1
                        },
                        extraComponents: [],
                        excludes: {
                            enumerateDevices: !0,
                            pixelRatio: !0,
                            doNotTrack: !0,
                            fontsFlash: !0,
                            adBlock: !0
                        },
                        NOT_AVAILABLE: "not available",
                        ERROR: "error",
                        EXCLUDED: "excluded"
                    }, s = function(e, t) {
                        if (Array.prototype.forEach && e.forEach === Array.prototype.forEach) e.forEach(t);
                        else if (e.length === +e.length) for(var a = 0, n = e.length; a < n; a++)t(e[a], a, e);
                        else for(var r in e)e.hasOwnProperty(r) && t(e[r], r, e);
                    }, d = function(e, t) {
                        var a = [];
                        return null == e ? a : Array.prototype.map && e.map === Array.prototype.map ? e.map(t) : (s(e, function(e, n, r) {
                            a.push(t(e, n, r));
                        }), a);
                    }, l = function(e) {
                        if (null == navigator.plugins) return e.NOT_AVAILABLE;
                        for(var t = [], a = 0, n = navigator.plugins.length; a < n; a++)navigator.plugins[a] && t.push(navigator.plugins[a]);
                        return u(e) && (t = t.sort(function(e, t) {
                            return e.name > t.name ? 1 : e.name < t.name ? -1 : 0;
                        })), d(t, function(e) {
                            var t = d(e, function(e) {
                                return [
                                    e.type,
                                    e.suffixes
                                ];
                            });
                            return [
                                e.name,
                                e.description,
                                t
                            ];
                        });
                    }, u = function(e) {
                        for(var t = !1, a = 0, n = e.plugins.sortPluginsFor.length; a < n; a++){
                            var r = e.plugins.sortPluginsFor[a];
                            if (navigator.userAgent.match(r)) {
                                t = !0;
                                break;
                            }
                        }
                        return t;
                    }, f = function() {
                        var e = document.createElement("canvas");
                        return !(!e.getContext || !e.getContext("2d"));
                    }, p = function() {
                        if (!f()) return !1;
                        var e = m(), t = !!window.WebGLRenderingContext && !!e;
                        return g(e), t;
                    }, h = function() {
                        return ("msWriteProfilerMark" in window) + ("msLaunchUri" in navigator) + ("msSaveBlob" in navigator) >= 2;
                    }, m = function() {
                        var e = document.createElement("canvas"), t = null;
                        try {
                            t = e.getContext("webgl") || e.getContext("experimental-webgl");
                        } catch (e) {}
                        return t || (t = null), t;
                    }, g = function(e) {
                        var t = e.getExtension("WEBGL_lose_context");
                        null != t && t.loseContext();
                    }, v = [
                        {
                            key: "userAgent",
                            getData: function(e) {
                                e(navigator.userAgent);
                            }
                        },
                        {
                            key: "webdriver",
                            getData: function(e, t) {
                                e(null == navigator.webdriver ? t.NOT_AVAILABLE : navigator.webdriver);
                            }
                        },
                        {
                            key: "language",
                            getData: function(e, t) {
                                e(navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "colorDepth",
                            getData: function(e, t) {
                                e(window.screen.colorDepth || t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "deviceMemory",
                            getData: function(e, t) {
                                e(navigator.deviceMemory || t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "pixelRatio",
                            getData: function(e, t) {
                                e(window.devicePixelRatio || t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "hardwareConcurrency",
                            getData: function(e, t) {
                                e(function(e) {
                                    return navigator.hardwareConcurrency ? navigator.hardwareConcurrency : e.NOT_AVAILABLE;
                                }(t));
                            }
                        },
                        {
                            key: "screenResolution",
                            getData: function(e, t) {
                                e(function(e) {
                                    var t = [
                                        window.screen.width,
                                        window.screen.height
                                    ];
                                    return e.screen.detectScreenOrientation && t.sort().reverse(), t;
                                }(t));
                            }
                        },
                        {
                            key: "availableScreenResolution",
                            getData: function(e, t) {
                                e(function(e) {
                                    if (window.screen.availWidth && window.screen.availHeight) {
                                        var t = [
                                            window.screen.availHeight,
                                            window.screen.availWidth
                                        ];
                                        return e.screen.detectScreenOrientation && t.sort().reverse(), t;
                                    }
                                    return e.NOT_AVAILABLE;
                                }(t));
                            }
                        },
                        {
                            key: "timezoneOffset",
                            getData: function(e) {
                                e((new Date).getTimezoneOffset());
                            }
                        },
                        {
                            key: "timezone",
                            getData: function(e, t) {
                                window.Intl && window.Intl.DateTimeFormat ? e((new window.Intl.DateTimeFormat).resolvedOptions().timeZone || t.NOT_AVAILABLE) : e(t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "sessionStorage",
                            getData: function(e, t) {
                                e(function(e) {
                                    try {
                                        return !!window.sessionStorage;
                                    } catch (t) {
                                        return e.ERROR;
                                    }
                                }(t));
                            }
                        },
                        {
                            key: "localStorage",
                            getData: function(e, t) {
                                e(function(e) {
                                    try {
                                        return !!window.localStorage;
                                    } catch (t) {
                                        return e.ERROR;
                                    }
                                }(t));
                            }
                        },
                        {
                            key: "indexedDb",
                            getData: function(e, t) {
                                e(function(e) {
                                    if (h()) return e.EXCLUDED;
                                    try {
                                        return !!window.indexedDB;
                                    } catch (t) {
                                        return e.ERROR;
                                    }
                                }(t));
                            }
                        },
                        {
                            key: "addBehavior",
                            getData: function(e) {
                                e(!!window.HTMLElement.prototype.addBehavior);
                            }
                        },
                        {
                            key: "openDatabase",
                            getData: function(e) {
                                e(!!window.openDatabase);
                            }
                        },
                        {
                            key: "cpuClass",
                            getData: function(e, t) {
                                e(function(e) {
                                    return navigator.cpuClass || e.NOT_AVAILABLE;
                                }(t));
                            }
                        },
                        {
                            key: "platform",
                            getData: function(e, t) {
                                e(function(e) {
                                    return navigator.platform ? navigator.platform : e.NOT_AVAILABLE;
                                }(t));
                            }
                        },
                        {
                            key: "doNotTrack",
                            getData: function(e, t) {
                                e(function(e) {
                                    return navigator.doNotTrack ? navigator.doNotTrack : navigator.msDoNotTrack ? navigator.msDoNotTrack : window.doNotTrack ? window.doNotTrack : e.NOT_AVAILABLE;
                                }(t));
                            }
                        },
                        {
                            key: "plugins",
                            getData: function(e, t) {
                                "Microsoft Internet Explorer" === navigator.appName || "Netscape" === navigator.appName && /Trident/.test(navigator.userAgent) ? t.plugins.excludeIE ? e(t.EXCLUDED) : e(function(e) {
                                    var t = [];
                                    return Object.getOwnPropertyDescriptor && Object.getOwnPropertyDescriptor(window, "ActiveXObject") || "ActiveXObject" in window ? t = d([
                                        "AcroPDF.PDF",
                                        "Adodb.Stream",
                                        "AgControl.AgControl",
                                        "DevalVRXCtrl.DevalVRXCtrl.1",
                                        "MacromediaFlashPaper.MacromediaFlashPaper",
                                        "Msxml2.DOMDocument",
                                        "Msxml2.XMLHTTP",
                                        "PDF.PdfCtrl",
                                        "QuickTime.QuickTime",
                                        "QuickTimeCheckObject.QuickTimeCheck.1",
                                        "RealPlayer",
                                        "RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)",
                                        "RealVideo.RealVideo(tm) ActiveX Control (32-bit)",
                                        "Scripting.Dictionary",
                                        "SWCtl.SWCtl",
                                        "Shell.UIHelper",
                                        "ShockwaveFlash.ShockwaveFlash",
                                        "Skype.Detection",
                                        "TDCCtl.TDCCtl",
                                        "WMPlayer.OCX",
                                        "rmocx.RealPlayer G2 Control",
                                        "rmocx.RealPlayer G2 Control.1"
                                    ], function(t) {
                                        try {
                                            return new window.ActiveXObject(t), t;
                                        } catch (t) {
                                            return e.ERROR;
                                        }
                                    }) : t.push(e.NOT_AVAILABLE), navigator.plugins && (t = t.concat(l(e))), t;
                                }(t)) : e(l(t));
                            }
                        },
                        {
                            key: "canvas",
                            getData: function(e, t) {
                                f() ? e(function(e) {
                                    var t = [], a = document.createElement("canvas");
                                    a.width = 2e3, a.height = 200, a.style.display = "inline";
                                    var n = a.getContext("2d");
                                    return n.rect(0, 0, 10, 10), n.rect(2, 2, 6, 6), t.push("canvas winding:" + (!1 === n.isPointInPath(5, 5, "evenodd") ? "yes" : "no")), n.textBaseline = "alphabetic", n.fillStyle = "#f60", n.fillRect(125, 1, 62, 20), n.fillStyle = "#069", e.dontUseFakeFontInCanvas ? n.font = "11pt Arial" : n.font = "11pt no-real-font-123", n.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 2, 15), n.fillStyle = "rgba(102, 204, 0, 0.2)", n.font = "18pt Arial", n.fillText("Cwm fjordbank glyphs vext quiz, \uD83D\uDE03", 4, 45), n.globalCompositeOperation = "multiply", n.fillStyle = "rgb(255,0,255)", n.beginPath(), n.arc(50, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(0,255,255)", n.beginPath(), n.arc(100, 50, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,255,0)", n.beginPath(), n.arc(75, 100, 50, 0, 2 * Math.PI, !0), n.closePath(), n.fill(), n.fillStyle = "rgb(255,0,255)", n.arc(75, 75, 75, 0, 2 * Math.PI, !0), n.arc(75, 75, 25, 0, 2 * Math.PI, !0), n.fill("evenodd"), a.toDataURL && t.push("canvas fp:" + a.toDataURL()), t;
                                }(t)) : e(t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "webgl",
                            getData: function(e, t) {
                                p() ? e(function() {
                                    var e, t = function(t) {
                                        return e.clearColor(0, 0, 0, 1), e.enable(e.DEPTH_TEST), e.depthFunc(e.LEQUAL), e.clear(e.COLOR_BUFFER_BIT | e.DEPTH_BUFFER_BIT), "[" + t[0] + ", " + t[1] + "]";
                                    };
                                    if (!(e = m())) return null;
                                    var a = [], n = e.createBuffer();
                                    e.bindBuffer(e.ARRAY_BUFFER, n);
                                    var r = new Float32Array([
                                        -0.2,
                                        -0.9,
                                        0,
                                        .4,
                                        -0.26,
                                        0,
                                        0,
                                        .732134444,
                                        0
                                    ]);
                                    e.bufferData(e.ARRAY_BUFFER, r, e.STATIC_DRAW), n.itemSize = 3, n.numItems = 3;
                                    var i = e.createProgram(), o = e.createShader(e.VERTEX_SHADER);
                                    e.shaderSource(o, "attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}"), e.compileShader(o);
                                    var c = e.createShader(e.FRAGMENT_SHADER);
                                    e.shaderSource(c, "precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}"), e.compileShader(c), e.attachShader(i, o), e.attachShader(i, c), e.linkProgram(i), e.useProgram(i), i.vertexPosAttrib = e.getAttribLocation(i, "attrVertex"), i.offsetUniform = e.getUniformLocation(i, "uniformOffset"), e.enableVertexAttribArray(i.vertexPosArray), e.vertexAttribPointer(i.vertexPosAttrib, n.itemSize, e.FLOAT, !1, 0, 0), e.uniform2f(i.offsetUniform, 1, 1), e.drawArrays(e.TRIANGLE_STRIP, 0, n.numItems);
                                    try {
                                        a.push(e.canvas.toDataURL());
                                    } catch (e) {}
                                    a.push("extensions:" + (e.getSupportedExtensions() || []).join(";")), a.push("webgl aliased line width range:" + t(e.getParameter(e.ALIASED_LINE_WIDTH_RANGE))), a.push("webgl aliased point size range:" + t(e.getParameter(e.ALIASED_POINT_SIZE_RANGE))), a.push("webgl alpha bits:" + e.getParameter(e.ALPHA_BITS)), a.push("webgl antialiasing:" + (e.getContextAttributes().antialias ? "yes" : "no")), a.push("webgl blue bits:" + e.getParameter(e.BLUE_BITS)), a.push("webgl depth bits:" + e.getParameter(e.DEPTH_BITS)), a.push("webgl green bits:" + e.getParameter(e.GREEN_BITS)), a.push("webgl max anisotropy:" + function(e) {
                                        var t = e.getExtension("EXT_texture_filter_anisotropic") || e.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || e.getExtension("MOZ_EXT_texture_filter_anisotropic");
                                        if (t) {
                                            var a = e.getParameter(t.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                                            return 0 === a && (a = 2), a;
                                        }
                                        return null;
                                    }(e)), a.push("webgl max combined texture image units:" + e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS)), a.push("webgl max cube map texture size:" + e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE)), a.push("webgl max fragment uniform vectors:" + e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS)), a.push("webgl max render buffer size:" + e.getParameter(e.MAX_RENDERBUFFER_SIZE)), a.push("webgl max texture image units:" + e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS)), a.push("webgl max texture size:" + e.getParameter(e.MAX_TEXTURE_SIZE)), a.push("webgl max varying vectors:" + e.getParameter(e.MAX_VARYING_VECTORS)), a.push("webgl max vertex attribs:" + e.getParameter(e.MAX_VERTEX_ATTRIBS)), a.push("webgl max vertex texture image units:" + e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS)), a.push("webgl max vertex uniform vectors:" + e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS)), a.push("webgl max viewport dims:" + t(e.getParameter(e.MAX_VIEWPORT_DIMS))), a.push("webgl red bits:" + e.getParameter(e.RED_BITS)), a.push("webgl renderer:" + e.getParameter(e.RENDERER)), a.push("webgl shading language version:" + e.getParameter(e.SHADING_LANGUAGE_VERSION)), a.push("webgl stencil bits:" + e.getParameter(e.STENCIL_BITS)), a.push("webgl vendor:" + e.getParameter(e.VENDOR)), a.push("webgl version:" + e.getParameter(e.VERSION));
                                    try {
                                        var d = e.getExtension("WEBGL_debug_renderer_info");
                                        d && (a.push("webgl unmasked vendor:" + e.getParameter(d.UNMASKED_VENDOR_WEBGL)), a.push("webgl unmasked renderer:" + e.getParameter(d.UNMASKED_RENDERER_WEBGL)));
                                    } catch (e) {}
                                    return e.getShaderPrecisionFormat ? (s([
                                        "FLOAT",
                                        "INT"
                                    ], function(t) {
                                        s([
                                            "VERTEX",
                                            "FRAGMENT"
                                        ], function(n) {
                                            s([
                                                "HIGH",
                                                "MEDIUM",
                                                "LOW"
                                            ], function(r) {
                                                s([
                                                    "precision",
                                                    "rangeMin",
                                                    "rangeMax"
                                                ], function(i) {
                                                    var o = e.getShaderPrecisionFormat(e[n + "_SHADER"], e[r + "_" + t])[i];
                                                    "precision" !== i && (i = "precision " + i);
                                                    var c = [
                                                        "webgl ",
                                                        n.toLowerCase(),
                                                        " shader ",
                                                        r.toLowerCase(),
                                                        " ",
                                                        t.toLowerCase(),
                                                        " ",
                                                        i,
                                                        ":",
                                                        o
                                                    ].join("");
                                                    a.push(c);
                                                });
                                            });
                                        });
                                    }), g(e), a) : (g(e), a);
                                }()) : e(t.NOT_AVAILABLE);
                            }
                        },
                        {
                            key: "webglVendorAndRenderer",
                            getData: function(e) {
                                p() ? e(function() {
                                    try {
                                        var e = m(), t = e.getExtension("WEBGL_debug_renderer_info"), a = e.getParameter(t.UNMASKED_VENDOR_WEBGL) + "~" + e.getParameter(t.UNMASKED_RENDERER_WEBGL);
                                        return g(e), a;
                                    } catch (e) {
                                        return null;
                                    }
                                }()) : e();
                            }
                        },
                        {
                            key: "adBlock",
                            getData: function(e) {
                                e(function() {
                                    var e = document.createElement("div");
                                    e.innerHTML = "&nbsp;", e.className = "adsbox";
                                    var t = !1;
                                    try {
                                        document.body.appendChild(e), t = 0 === document.getElementsByClassName("adsbox")[0].offsetHeight, document.body.removeChild(e);
                                    } catch (e) {
                                        t = !1;
                                    }
                                    return t;
                                }());
                            }
                        },
                        {
                            key: "hasLiedLanguages",
                            getData: function(e) {
                                e(function() {
                                    if (void 0 !== navigator.languages) try {
                                        if (navigator.languages[0].substr(0, 2) !== navigator.language.substr(0, 2)) return !0;
                                    } catch (e) {
                                        return !0;
                                    }
                                    return !1;
                                }());
                            }
                        },
                        {
                            key: "hasLiedResolution",
                            getData: function(e) {
                                e(window.screen.width < window.screen.availWidth || window.screen.height < window.screen.availHeight);
                            }
                        },
                        {
                            key: "hasLiedOs",
                            getData: function(e) {
                                e(function() {
                                    var e, t = navigator.userAgent.toLowerCase(), a = navigator.oscpu, n = navigator.platform.toLowerCase();
                                    if (e = t.indexOf("windows phone") >= 0 ? "Windows Phone" : t.indexOf("windows") >= 0 || t.indexOf("win16") >= 0 || t.indexOf("win32") >= 0 || t.indexOf("win64") >= 0 || t.indexOf("win95") >= 0 || t.indexOf("win98") >= 0 || t.indexOf("winnt") >= 0 || t.indexOf("wow64") >= 0 ? "Windows" : t.indexOf("android") >= 0 ? "Android" : t.indexOf("linux") >= 0 || t.indexOf("cros") >= 0 || t.indexOf("x11") >= 0 ? "Linux" : t.indexOf("iphone") >= 0 || t.indexOf("ipad") >= 0 || t.indexOf("ipod") >= 0 || t.indexOf("crios") >= 0 || t.indexOf("fxios") >= 0 ? "iOS" : t.indexOf("macintosh") >= 0 || t.indexOf("mac_powerpc)") >= 0 ? "Mac" : "Other", ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) && "Windows" !== e && "Windows Phone" !== e && "Android" !== e && "iOS" !== e && "Other" !== e && -1 === t.indexOf("cros")) return !0;
                                    if (void 0 !== a) {
                                        if ((a = a.toLowerCase()).indexOf("win") >= 0 && "Windows" !== e && "Windows Phone" !== e) return !0;
                                        if (a.indexOf("linux") >= 0 && "Linux" !== e && "Android" !== e) return !0;
                                        if (a.indexOf("mac") >= 0 && "Mac" !== e && "iOS" !== e) return !0;
                                        if ((-1 === a.indexOf("win") && -1 === a.indexOf("linux") && -1 === a.indexOf("mac")) != ("Other" === e)) return !0;
                                    }
                                    return n.indexOf("win") >= 0 && "Windows" !== e && "Windows Phone" !== e || (n.indexOf("linux") >= 0 || n.indexOf("android") >= 0 || n.indexOf("pike") >= 0) && "Linux" !== e && "Android" !== e || (n.indexOf("mac") >= 0 || n.indexOf("ipad") >= 0 || n.indexOf("ipod") >= 0 || n.indexOf("iphone") >= 0) && "Mac" !== e && "iOS" !== e || !(n.indexOf("arm") >= 0 && "Windows Phone" === e) && !(n.indexOf("pike") >= 0 && t.indexOf("opera mini") >= 0) && ((n.indexOf("win") < 0 && n.indexOf("linux") < 0 && n.indexOf("mac") < 0 && n.indexOf("iphone") < 0 && n.indexOf("ipad") < 0 && n.indexOf("ipod") < 0) != ("Other" === e) || void 0 === navigator.plugins && "Windows" !== e && "Windows Phone" !== e);
                                }());
                            }
                        },
                        {
                            key: "hasLiedBrowser",
                            getData: function(e) {
                                e(function() {
                                    var e, t = navigator.userAgent.toLowerCase(), a = navigator.productSub;
                                    if (t.indexOf("edge/") >= 0 || t.indexOf("iemobile/") >= 0) return !1;
                                    if (t.indexOf("opera mini") >= 0) return !1;
                                    if (("Chrome" == (e = t.indexOf("firefox/") >= 0 ? "Firefox" : t.indexOf("opera/") >= 0 || t.indexOf(" opr/") >= 0 ? "Opera" : t.indexOf("chrome/") >= 0 ? "Chrome" : t.indexOf("safari/") >= 0 ? t.indexOf("android 1.") >= 0 || t.indexOf("android 2.") >= 0 || t.indexOf("android 3.") >= 0 || t.indexOf("android 4.") >= 0 ? "AOSP" : "Safari" : t.indexOf("trident/") >= 0 ? "Internet Explorer" : "Other") || "Safari" === e || "Opera" === e) && "20030107" !== a) return !0;
                                    var n, r = eval.toString().length;
                                    if (37 === r && "Safari" !== e && "Firefox" !== e && "Other" !== e) return !0;
                                    if (39 === r && "Internet Explorer" !== e && "Other" !== e) return !0;
                                    if (33 === r && "Chrome" !== e && "AOSP" !== e && "Opera" !== e && "Other" !== e) return !0;
                                    try {
                                        throw "a";
                                    } catch (e) {
                                        try {
                                            e.toSource(), n = !0;
                                        } catch (e) {
                                            n = !1;
                                        }
                                    }
                                    return n && "Firefox" !== e && "Other" !== e;
                                }());
                            }
                        },
                        {
                            key: "touchSupport",
                            getData: function(e) {
                                e(function() {
                                    var e, t = 0;
                                    void 0 !== navigator.maxTouchPoints ? t = navigator.maxTouchPoints : void 0 !== navigator.msMaxTouchPoints && (t = navigator.msMaxTouchPoints);
                                    try {
                                        document.createEvent("TouchEvent"), e = !0;
                                    } catch (t) {
                                        e = !1;
                                    }
                                    return [
                                        t,
                                        e,
                                        "ontouchstart" in window
                                    ];
                                }());
                            }
                        },
                        {
                            key: "fonts",
                            getData: function(e, t) {
                                var a = [
                                    "monospace",
                                    "sans-serif",
                                    "serif"
                                ], n = [
                                    "Andale Mono",
                                    "Arial",
                                    "Arial Black",
                                    "Arial Hebrew",
                                    "Arial MT",
                                    "Arial Narrow",
                                    "Arial Rounded MT Bold",
                                    "Arial Unicode MS",
                                    "Bitstream Vera Sans Mono",
                                    "Book Antiqua",
                                    "Bookman Old Style",
                                    "Calibri",
                                    "Cambria",
                                    "Cambria Math",
                                    "Century",
                                    "Century Gothic",
                                    "Century Schoolbook",
                                    "Comic Sans",
                                    "Comic Sans MS",
                                    "Consolas",
                                    "Courier",
                                    "Courier New",
                                    "Geneva",
                                    "Georgia",
                                    "Helvetica",
                                    "Helvetica Neue",
                                    "Impact",
                                    "Lucida Bright",
                                    "Lucida Calligraphy",
                                    "Lucida Console",
                                    "Lucida Fax",
                                    "LUCIDA GRANDE",
                                    "Lucida Handwriting",
                                    "Lucida Sans",
                                    "Lucida Sans Typewriter",
                                    "Lucida Sans Unicode",
                                    "Microsoft Sans Serif",
                                    "Monaco",
                                    "Monotype Corsiva",
                                    "MS Gothic",
                                    "MS Outlook",
                                    "MS PGothic",
                                    "MS Reference Sans Serif",
                                    "MS Sans Serif",
                                    "MS Serif",
                                    "MYRIAD",
                                    "MYRIAD PRO",
                                    "Palatino",
                                    "Palatino Linotype",
                                    "Segoe Print",
                                    "Segoe Script",
                                    "Segoe UI",
                                    "Segoe UI Light",
                                    "Segoe UI Semibold",
                                    "Segoe UI Symbol",
                                    "Tahoma",
                                    "Times",
                                    "Times New Roman",
                                    "Times New Roman PS",
                                    "Trebuchet MS",
                                    "Verdana",
                                    "Wingdings",
                                    "Wingdings 2",
                                    "Wingdings 3"
                                ];
                                t.fonts.extendedJsFonts && (n = n.concat([
                                    "Abadi MT Condensed Light",
                                    "Academy Engraved LET",
                                    "ADOBE CASLON PRO",
                                    "Adobe Garamond",
                                    "ADOBE GARAMOND PRO",
                                    "Agency FB",
                                    "Aharoni",
                                    "Albertus Extra Bold",
                                    "Albertus Medium",
                                    "Algerian",
                                    "Amazone BT",
                                    "American Typewriter",
                                    "American Typewriter Condensed",
                                    "AmerType Md BT",
                                    "Andalus",
                                    "Angsana New",
                                    "AngsanaUPC",
                                    "Antique Olive",
                                    "Aparajita",
                                    "Apple Chancery",
                                    "Apple Color Emoji",
                                    "Apple SD Gothic Neo",
                                    "Arabic Typesetting",
                                    "ARCHER",
                                    "ARNO PRO",
                                    "Arrus BT",
                                    "Aurora Cn BT",
                                    "AvantGarde Bk BT",
                                    "AvantGarde Md BT",
                                    "AVENIR",
                                    "Ayuthaya",
                                    "Bandy",
                                    "Bangla Sangam MN",
                                    "Bank Gothic",
                                    "BankGothic Md BT",
                                    "Baskerville",
                                    "Baskerville Old Face",
                                    "Batang",
                                    "BatangChe",
                                    "Bauer Bodoni",
                                    "Bauhaus 93",
                                    "Bazooka",
                                    "Bell MT",
                                    "Bembo",
                                    "Benguiat Bk BT",
                                    "Berlin Sans FB",
                                    "Berlin Sans FB Demi",
                                    "Bernard MT Condensed",
                                    "BernhardFashion BT",
                                    "BernhardMod BT",
                                    "Big Caslon",
                                    "BinnerD",
                                    "Blackadder ITC",
                                    "BlairMdITC TT",
                                    "Bodoni 72",
                                    "Bodoni 72 Oldstyle",
                                    "Bodoni 72 Smallcaps",
                                    "Bodoni MT",
                                    "Bodoni MT Black",
                                    "Bodoni MT Condensed",
                                    "Bodoni MT Poster Compressed",
                                    "Bookshelf Symbol 7",
                                    "Boulder",
                                    "Bradley Hand",
                                    "Bradley Hand ITC",
                                    "Bremen Bd BT",
                                    "Britannic Bold",
                                    "Broadway",
                                    "Browallia New",
                                    "BrowalliaUPC",
                                    "Brush Script MT",
                                    "Californian FB",
                                    "Calisto MT",
                                    "Calligrapher",
                                    "Candara",
                                    "CaslonOpnface BT",
                                    "Castellar",
                                    "Centaur",
                                    "Cezanne",
                                    "CG Omega",
                                    "CG Times",
                                    "Chalkboard",
                                    "Chalkboard SE",
                                    "Chalkduster",
                                    "Charlesworth",
                                    "Charter Bd BT",
                                    "Charter BT",
                                    "Chaucer",
                                    "ChelthmITC Bk BT",
                                    "Chiller",
                                    "Clarendon",
                                    "Clarendon Condensed",
                                    "CloisterBlack BT",
                                    "Cochin",
                                    "Colonna MT",
                                    "Constantia",
                                    "Cooper Black",
                                    "Copperplate",
                                    "Copperplate Gothic",
                                    "Copperplate Gothic Bold",
                                    "Copperplate Gothic Light",
                                    "CopperplGoth Bd BT",
                                    "Corbel",
                                    "Cordia New",
                                    "CordiaUPC",
                                    "Cornerstone",
                                    "Coronet",
                                    "Cuckoo",
                                    "Curlz MT",
                                    "DaunPenh",
                                    "Dauphin",
                                    "David",
                                    "DB LCD Temp",
                                    "DELICIOUS",
                                    "Denmark",
                                    "DFKai-SB",
                                    "Didot",
                                    "DilleniaUPC",
                                    "DIN",
                                    "DokChampa",
                                    "Dotum",
                                    "DotumChe",
                                    "Ebrima",
                                    "Edwardian Script ITC",
                                    "Elephant",
                                    "English 111 Vivace BT",
                                    "Engravers MT",
                                    "EngraversGothic BT",
                                    "Eras Bold ITC",
                                    "Eras Demi ITC",
                                    "Eras Light ITC",
                                    "Eras Medium ITC",
                                    "EucrosiaUPC",
                                    "Euphemia",
                                    "Euphemia UCAS",
                                    "EUROSTILE",
                                    "Exotc350 Bd BT",
                                    "FangSong",
                                    "Felix Titling",
                                    "Fixedsys",
                                    "FONTIN",
                                    "Footlight MT Light",
                                    "Forte",
                                    "FrankRuehl",
                                    "Fransiscan",
                                    "Freefrm721 Blk BT",
                                    "FreesiaUPC",
                                    "Freestyle Script",
                                    "French Script MT",
                                    "FrnkGothITC Bk BT",
                                    "Fruitger",
                                    "FRUTIGER",
                                    "Futura",
                                    "Futura Bk BT",
                                    "Futura Lt BT",
                                    "Futura Md BT",
                                    "Futura ZBlk BT",
                                    "FuturaBlack BT",
                                    "Gabriola",
                                    "Galliard BT",
                                    "Gautami",
                                    "Geeza Pro",
                                    "Geometr231 BT",
                                    "Geometr231 Hv BT",
                                    "Geometr231 Lt BT",
                                    "GeoSlab 703 Lt BT",
                                    "GeoSlab 703 XBd BT",
                                    "Gigi",
                                    "Gill Sans",
                                    "Gill Sans MT",
                                    "Gill Sans MT Condensed",
                                    "Gill Sans MT Ext Condensed Bold",
                                    "Gill Sans Ultra Bold",
                                    "Gill Sans Ultra Bold Condensed",
                                    "Gisha",
                                    "Gloucester MT Extra Condensed",
                                    "GOTHAM",
                                    "GOTHAM BOLD",
                                    "Goudy Old Style",
                                    "Goudy Stout",
                                    "GoudyHandtooled BT",
                                    "GoudyOLSt BT",
                                    "Gujarati Sangam MN",
                                    "Gulim",
                                    "GulimChe",
                                    "Gungsuh",
                                    "GungsuhChe",
                                    "Gurmukhi MN",
                                    "Haettenschweiler",
                                    "Harlow Solid Italic",
                                    "Harrington",
                                    "Heather",
                                    "Heiti SC",
                                    "Heiti TC",
                                    "HELV",
                                    "Herald",
                                    "High Tower Text",
                                    "Hiragino Kaku Gothic ProN",
                                    "Hiragino Mincho ProN",
                                    "Hoefler Text",
                                    "Humanst 521 Cn BT",
                                    "Humanst521 BT",
                                    "Humanst521 Lt BT",
                                    "Imprint MT Shadow",
                                    "Incised901 Bd BT",
                                    "Incised901 BT",
                                    "Incised901 Lt BT",
                                    "INCONSOLATA",
                                    "Informal Roman",
                                    "Informal011 BT",
                                    "INTERSTATE",
                                    "IrisUPC",
                                    "Iskoola Pota",
                                    "JasmineUPC",
                                    "Jazz LET",
                                    "Jenson",
                                    "Jester",
                                    "Jokerman",
                                    "Juice ITC",
                                    "Kabel Bk BT",
                                    "Kabel Ult BT",
                                    "Kailasa",
                                    "KaiTi",
                                    "Kalinga",
                                    "Kannada Sangam MN",
                                    "Kartika",
                                    "Kaufmann Bd BT",
                                    "Kaufmann BT",
                                    "Khmer UI",
                                    "KodchiangUPC",
                                    "Kokila",
                                    "Korinna BT",
                                    "Kristen ITC",
                                    "Krungthep",
                                    "Kunstler Script",
                                    "Lao UI",
                                    "Latha",
                                    "Leelawadee",
                                    "Letter Gothic",
                                    "Levenim MT",
                                    "LilyUPC",
                                    "Lithograph",
                                    "Lithograph Light",
                                    "Long Island",
                                    "Lydian BT",
                                    "Magneto",
                                    "Maiandra GD",
                                    "Malayalam Sangam MN",
                                    "Malgun Gothic",
                                    "Mangal",
                                    "Marigold",
                                    "Marion",
                                    "Marker Felt",
                                    "Market",
                                    "Marlett",
                                    "Matisse ITC",
                                    "Matura MT Script Capitals",
                                    "Meiryo",
                                    "Meiryo UI",
                                    "Microsoft Himalaya",
                                    "Microsoft JhengHei",
                                    "Microsoft New Tai Lue",
                                    "Microsoft PhagsPa",
                                    "Microsoft Tai Le",
                                    "Microsoft Uighur",
                                    "Microsoft YaHei",
                                    "Microsoft Yi Baiti",
                                    "MingLiU",
                                    "MingLiU_HKSCS",
                                    "MingLiU_HKSCS-ExtB",
                                    "MingLiU-ExtB",
                                    "Minion",
                                    "Minion Pro",
                                    "Miriam",
                                    "Miriam Fixed",
                                    "Mistral",
                                    "Modern",
                                    "Modern No. 20",
                                    "Mona Lisa Solid ITC TT",
                                    "Mongolian Baiti",
                                    "MONO",
                                    "MoolBoran",
                                    "Mrs Eaves",
                                    "MS LineDraw",
                                    "MS Mincho",
                                    "MS PMincho",
                                    "MS Reference Specialty",
                                    "MS UI Gothic",
                                    "MT Extra",
                                    "MUSEO",
                                    "MV Boli",
                                    "Nadeem",
                                    "Narkisim",
                                    "NEVIS",
                                    "News Gothic",
                                    "News GothicMT",
                                    "NewsGoth BT",
                                    "Niagara Engraved",
                                    "Niagara Solid",
                                    "Noteworthy",
                                    "NSimSun",
                                    "Nyala",
                                    "OCR A Extended",
                                    "Old Century",
                                    "Old English Text MT",
                                    "Onyx",
                                    "Onyx BT",
                                    "OPTIMA",
                                    "Oriya Sangam MN",
                                    "OSAKA",
                                    "OzHandicraft BT",
                                    "Palace Script MT",
                                    "Papyrus",
                                    "Parchment",
                                    "Party LET",
                                    "Pegasus",
                                    "Perpetua",
                                    "Perpetua Titling MT",
                                    "PetitaBold",
                                    "Pickwick",
                                    "Plantagenet Cherokee",
                                    "Playbill",
                                    "PMingLiU",
                                    "PMingLiU-ExtB",
                                    "Poor Richard",
                                    "Poster",
                                    "PosterBodoni BT",
                                    "PRINCETOWN LET",
                                    "Pristina",
                                    "PTBarnum BT",
                                    "Pythagoras",
                                    "Raavi",
                                    "Rage Italic",
                                    "Ravie",
                                    "Ribbon131 Bd BT",
                                    "Rockwell",
                                    "Rockwell Condensed",
                                    "Rockwell Extra Bold",
                                    "Rod",
                                    "Roman",
                                    "Sakkal Majalla",
                                    "Santa Fe LET",
                                    "Savoye LET",
                                    "Sceptre",
                                    "Script",
                                    "Script MT Bold",
                                    "SCRIPTINA",
                                    "Serifa",
                                    "Serifa BT",
                                    "Serifa Th BT",
                                    "ShelleyVolante BT",
                                    "Sherwood",
                                    "Shonar Bangla",
                                    "Showcard Gothic",
                                    "Shruti",
                                    "Signboard",
                                    "SILKSCREEN",
                                    "SimHei",
                                    "Simplified Arabic",
                                    "Simplified Arabic Fixed",
                                    "SimSun",
                                    "SimSun-ExtB",
                                    "Sinhala Sangam MN",
                                    "Sketch Rockwell",
                                    "Skia",
                                    "Small Fonts",
                                    "Snap ITC",
                                    "Snell Roundhand",
                                    "Socket",
                                    "Souvenir Lt BT",
                                    "Staccato222 BT",
                                    "Steamer",
                                    "Stencil",
                                    "Storybook",
                                    "Styllo",
                                    "Subway",
                                    "Swis721 BlkEx BT",
                                    "Swiss911 XCm BT",
                                    "Sylfaen",
                                    "Synchro LET",
                                    "System",
                                    "Tamil Sangam MN",
                                    "Technical",
                                    "Teletype",
                                    "Telugu Sangam MN",
                                    "Tempus Sans ITC",
                                    "Terminal",
                                    "Thonburi",
                                    "Traditional Arabic",
                                    "Trajan",
                                    "TRAJAN PRO",
                                    "Tristan",
                                    "Tubular",
                                    "Tunga",
                                    "Tw Cen MT",
                                    "Tw Cen MT Condensed",
                                    "Tw Cen MT Condensed Extra Bold",
                                    "TypoUpright BT",
                                    "Unicorn",
                                    "Univers",
                                    "Univers CE 55 Medium",
                                    "Univers Condensed",
                                    "Utsaah",
                                    "Vagabond",
                                    "Vani",
                                    "Vijaya",
                                    "Viner Hand ITC",
                                    "VisualUI",
                                    "Vivaldi",
                                    "Vladimir Script",
                                    "Vrinda",
                                    "Westminster",
                                    "WHITNEY",
                                    "Wide Latin",
                                    "ZapfEllipt BT",
                                    "ZapfHumnst BT",
                                    "ZapfHumnst Dm BT",
                                    "Zapfino",
                                    "Zurich BlkEx BT",
                                    "Zurich Ex BT",
                                    "ZWAdobeF"
                                ])), n = (n = n.concat(t.fonts.userDefinedFonts)).filter(function(e, t) {
                                    return n.indexOf(e) === t;
                                });
                                var r = document.getElementsByTagName("body")[0], i = document.createElement("div"), o = document.createElement("div"), c = {}, s = {}, d = function() {
                                    var e = document.createElement("span");
                                    return e.style.position = "absolute", e.style.left = "-9999px", e.style.fontSize = "72px", e.style.fontStyle = "normal", e.style.fontWeight = "normal", e.style.letterSpacing = "normal", e.style.lineBreak = "auto", e.style.lineHeight = "normal", e.style.textTransform = "none", e.style.textAlign = "left", e.style.textDecoration = "none", e.style.textShadow = "none", e.style.whiteSpace = "normal", e.style.wordBreak = "normal", e.style.wordSpacing = "normal", e.innerHTML = "mmmmmmmmmmlli", e;
                                }, l = function(e, t) {
                                    var a = d();
                                    return a.style.fontFamily = "'" + e + "'," + t, a;
                                }, u = function(e) {
                                    for(var t = !1, n = 0; n < a.length; n++)if (t = e[n].offsetWidth !== c[a[n]] || e[n].offsetHeight !== s[a[n]]) return t;
                                    return t;
                                }, f = function() {
                                    for(var e = [], t = 0, n = a.length; t < n; t++){
                                        var r = d();
                                        r.style.fontFamily = a[t], i.appendChild(r), e.push(r);
                                    }
                                    return e;
                                }();
                                r.appendChild(i);
                                for(var p = 0, h = a.length; p < h; p++)c[a[p]] = f[p].offsetWidth, s[a[p]] = f[p].offsetHeight;
                                var m = function() {
                                    for(var e = {}, t = 0, r = n.length; t < r; t++){
                                        for(var i = [], c = 0, s = a.length; c < s; c++){
                                            var d = l(n[t], a[c]);
                                            o.appendChild(d), i.push(d);
                                        }
                                        e[n[t]] = i;
                                    }
                                    return e;
                                }();
                                r.appendChild(o);
                                for(var g = [], v = 0, y = n.length; v < y; v++)u(m[n[v]]) && g.push(n[v]);
                                r.removeChild(o), r.removeChild(i), e(g);
                            },
                            pauseBefore: !0
                        },
                        {
                            key: "fontsFlash",
                            getData: function(e, t) {
                                return void 0 !== window.swfobject ? window.swfobject.hasFlashPlayerVersion("9.0.0") ? t.fonts.swfPath ? void function(e, t) {
                                    var a = "___fp_swf_loaded";
                                    window[a] = function(t) {
                                        e(t);
                                    };
                                    var n, r = t.fonts.swfContainerId;
                                    (n = document.createElement("div")).setAttribute("id", (void 0).fonts.swfContainerId), document.body.appendChild(n);
                                    var i = {
                                        onReady: a
                                    };
                                    window.swfobject.embedSWF(t.fonts.swfPath, r, "1", "1", "9.0.0", !1, i, {
                                        allowScriptAccess: "always",
                                        menu: "false"
                                    }, {});
                                }(function(t) {
                                    e(t);
                                }, t) : e("missing options.fonts.swfPath") : e("flash not installed") : e("swf object not loaded");
                            },
                            pauseBefore: !0
                        },
                        {
                            key: "audio",
                            getData: function(e, t) {
                                var a = t.audio;
                                if (a.excludeIOS11 && navigator.userAgent.match(/OS 11.+Version\/11.+Safari/)) return e(t.EXCLUDED);
                                var n = window.OfflineAudioContext || window.webkitOfflineAudioContext;
                                if (null == n) return e(t.NOT_AVAILABLE);
                                var r = new n(1, 44100, 44100), i = r.createOscillator();
                                i.type = "triangle", i.frequency.setValueAtTime(1e4, r.currentTime);
                                var o = r.createDynamicsCompressor();
                                s([
                                    [
                                        "threshold",
                                        -50
                                    ],
                                    [
                                        "knee",
                                        40
                                    ],
                                    [
                                        "ratio",
                                        12
                                    ],
                                    [
                                        "reduction",
                                        -20
                                    ],
                                    [
                                        "attack",
                                        0
                                    ],
                                    [
                                        "release",
                                        .25
                                    ]
                                ], function(e) {
                                    void 0 !== o[e[0]] && "function" == typeof o[e[0]].setValueAtTime && o[e[0]].setValueAtTime(e[1], r.currentTime);
                                }), i.connect(o), o.connect(r.destination), i.start(0), r.startRendering();
                                var c = setTimeout(function() {
                                    return console.warn('Audio fingerprint timed out. Please report bug at https://github.com/fingerprintjs/fingerprintjs with your user agent: "' + navigator.userAgent + '".'), r.oncomplete = function() {}, r = null, e("audioTimeout");
                                }, a.timeout);
                                r.oncomplete = function(t) {
                                    var a;
                                    try {
                                        clearTimeout(c), a = t.renderedBuffer.getChannelData(0).slice(4500, 5e3).reduce(function(e, t) {
                                            return e + Math.abs(t);
                                        }, 0).toString(), i.disconnect(), o.disconnect();
                                    } catch (t) {
                                        return void e(t);
                                    }
                                    e(a);
                                };
                            }
                        },
                        {
                            key: "enumerateDevices",
                            getData: function(e, t) {
                                if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return e(t.NOT_AVAILABLE);
                                navigator.mediaDevices.enumerateDevices().then(function(t) {
                                    e(t.map(function(e) {
                                        return "id=" + e.deviceId + ";gid=" + e.groupId + ";" + e.kind + ";" + e.label;
                                    }));
                                }).catch(function(t) {
                                    e(t);
                                });
                            }
                        }
                    ], y = function(e) {
                        throw new Error("'new Fingerprint()' is deprecated, see https://github.com/fingerprintjs/fingerprintjs#upgrade-guide-from-182-to-200");
                    };
                    return y.get = function(e, t) {
                        t ? e || (e = {}) : (t = e, e = {}), function(e, t) {
                            if (null == t) return e;
                            var a, n;
                            for(n in t)null == (a = t[n]) || Object.prototype.hasOwnProperty.call(e, n) || (e[n] = a);
                        }(e, c), e.components = e.extraComponents.concat(v);
                        var a = {
                            data: [],
                            addPreprocessedComponent: function(t, n) {
                                "function" == typeof e.preprocessor && (n = e.preprocessor(t, n)), a.data.push({
                                    key: t,
                                    value: n
                                });
                            }
                        }, n = -1, r = function(i) {
                            if ((n += 1) >= e.components.length) t(a.data);
                            else {
                                var o = e.components[n];
                                if (e.excludes[o.key]) r(!1);
                                else {
                                    if (!i && o.pauseBefore) return n -= 1, void setTimeout(function() {
                                        r(!0);
                                    }, 1);
                                    try {
                                        o.getData(function(e) {
                                            a.addPreprocessedComponent(o.key, e), r(!1);
                                        }, e);
                                    } catch (e) {
                                        a.addPreprocessedComponent(o.key, String(e)), r(!1);
                                    }
                                }
                            }
                        };
                        r(!1);
                    }, y.getPromise = function(e) {
                        return new Promise(function(t, a) {
                            y.get(e, t);
                        });
                    }, y.getV18 = function(e, t) {
                        return null == t && (t = e, e = {}), y.get(e, function(a) {
                            for(var n = [], r = 0; r < a.length; r++){
                                var i = a[r];
                                if (i.value === (e.NOT_AVAILABLE || "not available")) n.push({
                                    key: i.key,
                                    value: "unknown"
                                });
                                else if ("plugins" === i.key) n.push({
                                    key: "plugins",
                                    value: d(i.value, function(e) {
                                        var t = d(e[2], function(e) {
                                            return e.join ? e.join("~") : e;
                                        }).join(",");
                                        return [
                                            e[0],
                                            e[1],
                                            t
                                        ].join("::");
                                    })
                                });
                                else if (-1 !== [
                                    "canvas",
                                    "webgl"
                                ].indexOf(i.key) && Array.isArray(i.value)) n.push({
                                    key: i.key,
                                    value: i.value.join("~")
                                });
                                else if (-1 !== [
                                    "sessionStorage",
                                    "localStorage",
                                    "indexedDb",
                                    "addBehavior",
                                    "openDatabase"
                                ].indexOf(i.key)) {
                                    if (!i.value) continue;
                                    n.push({
                                        key: i.key,
                                        value: 1
                                    });
                                } else i.value ? n.push(i.value.join ? {
                                    key: i.key,
                                    value: i.value.join(";")
                                } : i) : n.push({
                                    key: i.key,
                                    value: i.value
                                });
                            }
                            var c = o(d(n, function(e) {
                                return e.value;
                            }).join("~~~"), 31);
                            t(c, n);
                        });
                    }, y.x64hash128 = o, y.VERSION = "2.1.4", y;
                });
            }
        }, t = {};
        function a(n) {
            var r = t[n];
            if (void 0 !== r) return r.exports;
            var i = t[n] = {
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, a), i.exports;
        }
        a.amdO = {}, a.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return a.d(t, {
                a: t
            }), t;
        }, a.d = (e, t)=>{
            for(var n in t)a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: t[n]
            });
        }, a.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), a.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var n = {};
        return (()=>{
            "use strict";
            a.r(n), a.d(n, {
                default: ()=>K
            });
            var e = function() {
                return e = Object.assign || function(e) {
                    for(var t, a = 1, n = arguments.length; a < n; a++)for(var r in t = arguments[a])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    return e;
                }, e.apply(this, arguments);
            };
            function t(e, t, a, n) {
                return new (a || (a = Promise))(function(r, i) {
                    function o(e) {
                        try {
                            s(n.next(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function c(e) {
                        try {
                            s(n.throw(e));
                        } catch (e) {
                            i(e);
                        }
                    }
                    function s(e) {
                        var t;
                        e.done ? r(e.value) : (t = e.value, t instanceof a ? t : new a(function(e) {
                            e(t);
                        })).then(o, c);
                    }
                    s((n = n.apply(e, t || [])).next());
                });
            }
            function r(e, t) {
                var a, n, r, i, o = {
                    label: 0,
                    sent: function() {
                        if (1 & r[0]) throw r[1];
                        return r[1];
                    },
                    trys: [],
                    ops: []
                };
                return i = {
                    next: c(0),
                    throw: c(1),
                    return: c(2)
                }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
                    return this;
                }), i;
                function c(i) {
                    return function(c) {
                        return function(i) {
                            if (a) throw new TypeError("Generator is already executing.");
                            for(; o;)try {
                                if (a = 1, n && (r = 2 & i[0] ? n.return : i[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, i[1])).done) return r;
                                switch(n = 0, r && (i = [
                                    2 & i[0],
                                    r.value
                                ]), i[0]){
                                    case 0:
                                    case 1:
                                        r = i;
                                        break;
                                    case 4:
                                        return o.label++, {
                                            value: i[1],
                                            done: !1
                                        };
                                    case 5:
                                        o.label++, n = i[1], i = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        i = o.ops.pop(), o.trys.pop();
                                        continue;
                                    default:
                                        if (!((r = (r = o.trys).length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                            o = 0;
                                            continue;
                                        }
                                        if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                            o.label = i[1];
                                            break;
                                        }
                                        if (6 === i[0] && o.label < r[1]) {
                                            o.label = r[1], r = i;
                                            break;
                                        }
                                        if (r && o.label < r[2]) {
                                            o.label = r[2], o.ops.push(i);
                                            break;
                                        }
                                        r[2] && o.ops.pop(), o.trys.pop();
                                        continue;
                                }
                                i = t.call(e, o);
                            } catch (e) {
                                i = [
                                    6,
                                    e
                                ], n = 0;
                            } finally{
                                a = r = 0;
                            }
                            if (5 & i[0]) throw i[1];
                            return {
                                value: i[0] ? i[1] : void 0,
                                done: !0
                            };
                        }([
                            i,
                            c
                        ]);
                    };
                }
            }
            var i = a(750), o = a.n(i);
            const c = "UPDATE_DATA", s = "CASHIER_PAUSE", d = "CASHIER_RESUME", l = "PIQ_INITIATE_NATIVE_PAYMENT", u = "PIQ_PROCESS_NATIVE_PAYMENT", f = "CASHIER_INIT_LOAD", p = "IS_LOADING", h = "ONLOAD_ERROR", m = "PIQ_LOOKUP_SHA_256";
            var g = "piq-cashier-wrapper", v = "cashier_container_uid", y = null, T = null, w = null, A = function(e) {
                y = e, window.removeEventListener("message", C, !1), window.addEventListener("message", C);
            };
            function E(e) {
                return !(-1 !== [
                    "https://test-api.paymentiq.io",
                    "https://mrgreen-api.paymentiq.io",
                    "https://casumo-api.paymentiq.io",
                    "https://api.paymentiq.io",
                    "https://api.ecomtransactions.io",
                    "https://pay.paymentiq.io",
                    "https://checkout.paymentiq.io",
                    "http://localhost:5000",
                    "http://0.0.0.0:5000",
                    "http://0.0.0.0:4000",
                    "http://localhost:4000"
                ].indexOf(e.origin) || e.data && e.data.eventType && -1 !== [
                    "CASHIER_INIT_LOAD",
                    "LOOKUP_INIT_LOAD",
                    "IS_LOADING"
                ].indexOf(e.data.eventType) || (e.data && e.data.eventType && console.error("Integration: Failed to read post message - invalid origin", e.origin, e.data.eventType), 0));
            }
            function S(e) {
                e.data && e.data.eventType && console.error("Invalid origin - will not read PIQ Cashier events", e.data.eventType, e.origin);
            }
            var C = function(e) {
                if (E(e)) return S(e);
                switch(e.data.eventType){
                    case f:
                        if (y.cashierInitLoad) return y.cashierInitLoad();
                        break;
                    case "LOOKUP_INIT_LOAD":
                        if (y.lookupInitLoad) return y.lookupInitLoad();
                        break;
                    case "CHANGE":
                        if (y.change) return y.change({
                            data: e.data.payload
                        });
                        break;
                    case c:
                        if (y.update) return y.update({
                            data: e.data.payload
                        });
                        break;
                    case "TX_SUCCESS":
                        if (y.success) return y.success({
                            data: e.data.payload
                        });
                        break;
                    case "TX_FAILED":
                        if (y.failure) return y.failure({
                            data: e.data.payload
                        });
                        break;
                    case "TX_PENDING":
                        if (y.pending) return y.pending({
                            data: e.data.payload
                        });
                        break;
                    case "TX_UNRESOLVED":
                        if (y.unresolved) return y.unresolved({
                            data: e.data.payload
                        });
                        break;
                    case "APP_SET_HEIGHT":
                        return G(e.data.payload.height);
                    case s:
                        if (y.pause) return y.pause({
                            data: e.data.payload
                        });
                        break;
                    case d:
                        if (y.resume) return y.resume({
                            data: e.data.payload
                        });
                        break;
                    case p:
                        if (y.isLoading) return y.isLoading({
                            data: e.data.eventType
                        });
                        break;
                    case "DONE_LOADING":
                        if (y.doneLoading) return y.doneLoading({
                            data: e.data.eventType
                        });
                        break;
                    case "APP_VISIBLE":
                        if (y.isVisible) return y.isVisible();
                        break;
                    case "APP_HIDDEN":
                        if (y.isHidden) return y.isHidden();
                        break;
                    case "SELECTED_TX_METHOD":
                        if (y.paymentMethodSelect && e.data && e.data.payload) return y.paymentMethodSelect({
                            data: e.data.payload
                        });
                        break;
                    case "PAYMENT_AMOUNT_CHANGE":
                        if (y.paymentAmountChange && e.data && e.data.payload) return y.paymentAmountChange({
                            data: e.data.payload
                        });
                        break;
                    case "ENTERED_TX_METHOD_PAGE":
                        if (y.paymentMethodPageEntered && e.data && e.data.payload) return y.paymentMethodPageEntered({
                            data: e.data.payload
                        });
                        break;
                    case "APP_ROUTE_CHANGE":
                        if (y.navigate && e.data && e.data.payload) return y.navigate({
                            data: e.data.payload
                        });
                        break;
                    case "NEW_IFRAME":
                    case "NEW_WINDOW":
                        if (y.newProviderWindow) return y.newProviderWindow({
                            data: e.data.eventType
                        });
                        break;
                    case "CANCEL_PENDING_WITHDRAWAL":
                        if (y.cancelledPendingWD) return y.cancelledPendingWD({
                            data: e.data.payload
                        });
                        break;
                    case "TX_VALIDATION_FAILED":
                        if (y.validationFailed) return y.validationFailed({
                            data: e.data.payload
                        });
                        break;
                    case "PIQ_LOOKUP_CUSTOMER_IDENTIFIED":
                        return function(e) {
                            var t = e.data, a = t.eventType, n = t.payload;
                            if (!a && "string" == typeof e.data) {
                                var r = JSON.parse(e.data);
                                a = r.eventType, n = r.payload;
                            }
                            if (y.lookupUserIdentified && y.lookupUserIdentified({
                                data: n
                            }), !w || w.cashierLoaded) return P({
                                iframe: document.getElementById("cashierIframe")
                            });
                            var i = {
                                userId: n.userId,
                                sessionId: n.sessionId || null,
                                user: n.user,
                                attributes: n.attributes,
                                didToken: n.didToken || null
                            };
                            w.setupCashier(i);
                        }(e);
                    case "PIQ_CUSTOMER_DATA":
                        if (y.lookupUserData) return y.lookupUserData({
                            data: e.data.payload
                        });
                    case "TX_CANCELLED":
                        if (y.cancelled) return y.cancelled({
                            data: e.data.payload
                        });
                        break;
                    case h:
                        if (y.onLoadError) return y.onLoadError({
                            data: e.data.payload
                        });
                        break;
                    case "TRANSACTION_INIT":
                        if (y.transactionInit) return y.transactionInit({
                            data: e.data.payload
                        });
                }
            }, I = function(e) {
                return t(void 0, void 0, void 0, function() {
                    var a, n, i, o, c, s, d, f;
                    return r(this, function(p) {
                        if (E(e)) return [
                            2,
                            S(e)
                        ];
                        try {
                            switch(a = e.data, n = a.eventType, i = a.payload, n || "string" != typeof e.data || (o = JSON.parse(e.data), n = o.eventType, i = o.payload), n){
                                case "ADD_CONFIG_TO_WINDOW":
                                    W(i);
                                    break;
                                case "SETUP_AUTHORIZE_SCRIPT":
                                    !function(e) {
                                        if (e && e.authorizeScript) {
                                            var t = e.provider, a = e.authorizeScript;
                                            try {
                                                var n = "Authenticate_".concat(t);
                                                if (!document.getElementById(n)) {
                                                    var r = document.createElement("script");
                                                    r.id = n, r.innerHTML = a, document.body.appendChild(r);
                                                }
                                            } catch (e) {
                                                console.log(e), console.error("Unable to add authenticate script for ".concat(t));
                                            }
                                        }
                                    }(i);
                                    break;
                                case "EXECUTE_AUTHORIZE_METHOD":
                                    c = i.method, s = i.parameters, window[c](s);
                                    break;
                                case "GET_INTEGRATIONS_SCRIPT_URL":
                                    return [
                                        2,
                                        T(i)
                                    ];
                                case "TOP_URL_REPLACE":
                                    !function(e) {
                                        window.location.replace(e.url);
                                        var t = JSON.stringify({
                                            eventType: "APPLICATION_REDIRECT",
                                            payload: e
                                        });
                                        window.ReactNativeWebView ? O(t, window.ReactNativeWebView, "*") : O(t);
                                    }(i);
                                    break;
                                case l:
                                    !function(e) {
                                        var t = JSON.stringify({
                                            eventType: l,
                                            payload: e
                                        });
                                        window.ReactNativeWebView ? O(t, window.ReactNativeWebView, "*") : O(t);
                                    }(i);
                                    break;
                                case u:
                                    d = document.getElementById("cashierIframe"), O({
                                        eventType: u,
                                        payload: i
                                    }, d.contentWindow, R());
                                    break;
                                case "PIQ_STATUS_NATIVE_PAYMENT":
                                    f = JSON.stringify({
                                        eventType: "PIQ_STATUS_NATIVE_PAYMENT",
                                        payload: i
                                    }), window.ReactNativeWebView ? O(f, window.ReactNativeWebView, "*") : O(f);
                                    break;
                                case m:
                                    !function(e) {
                                        t(void 0, void 0, void 0, function() {
                                            var t, a, n, i, o;
                                            return r(this, function(r) {
                                                switch(r.label){
                                                    case 0:
                                                        return e.codeVerifier ? (t = e.codeVerifier, a = new TextEncoder, n = a.encode(t), [
                                                            4,
                                                            window.crypto.subtle.digest("SHA-256", n)
                                                        ]) : [
                                                            3,
                                                            2
                                                        ];
                                                    case 1:
                                                        i = r.sent(), o = document.getElementById("lookupIframe"), x({
                                                            eventType: m,
                                                            payload: {
                                                                codeChallenge: i,
                                                                codeVerifier: t
                                                            }
                                                        }, o.contentWindow, D(o)), r.label = 2;
                                                    case 2:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                    }(i);
                                    break;
                                case "PIQ_LOOKUP_EDIT_USER":
                                    return [
                                        2,
                                        _({
                                            iframe: document.getElementById("cashierIframe")
                                        })
                                    ];
                                case "PIQ_LOOKUP_CUSTOMER_RESET":
                                    X(), w.cashierLoaded = !1;
                                    break;
                                case "PIQ_LOOKUP_REPORT_HEIGHT":
                                    return [
                                        2,
                                        H(e.data.payload.height)
                                    ];
                            }
                        } catch (e) {
                            console.log(e);
                        }
                        return [
                            2
                        ];
                    });
                });
            }, b = "https://checkout.paymentiq.io", O = function(e, t, a) {
                void 0 === t && (t = null), void 0 === a && (a = null);
                try {
                    t ? t.postMessage(e, a) : window.postMessage(e, R());
                } catch (t) {
                    e.eventType ? console.error("Failed to send postMessage: ", e.eventType) : console.error(t);
                }
            }, x = function(e, t, a) {
                O(e, t, a), a !== b && O(e, t, b);
            }, B = function(e, t) {
                x({
                    eventType: "SET_CSS",
                    payload: e
                }, t.iframe.contentWindow, D(t.iframe));
            }, _ = function(e) {
                if (!e.iframe) return null;
                x({
                    eventType: s
                }, e.iframe.contentWindow, D(e.iframe));
                var t = document.getElementById("cashierIframe");
                t && (t.tabIndex = -1);
            }, P = function(e) {
                x({
                    eventType: d
                }, e.iframe.contentWindow, D(e.iframe)), document.getElementById("cashierIframe").tabIndex = 0;
            }, k = function(e) {
                var t = document.querySelector("#cashierIframe");
                x({
                    eventType: "POST_INTEGRATION_URL",
                    payload: {
                        url: V("txRefId", e.txRefId),
                        txRefId: e.txRefId
                    }
                }, t.contentWindow, D(t));
            }, M = function(e) {
                if (window._piqDFP) {
                    var t = document.getElementById(e);
                    L(t, window._piqDFP), delete window._piqDFP;
                } else setTimeout(function() {
                    M(e);
                }, 50);
            }, L = function(e, t) {
                t ? x({
                    eventType: "PIQ_DEVICE_ID",
                    payload: {
                        deviceId: t
                    }
                }, e.contentWindow, D(e)) : console.error("DeviceId not defined");
            };
            function R() {
                return window.location.origin || (window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : "")), window.location.origin;
            }
            var D = function(e) {
                var t = e.src.match(/^.+:\/\/[^/]+/)[0];
                return "https://test-api.paymentiq.io" === t || "https://api.paymentiq.io" === t || "https://mrgreen-api.paymentiq.io" === t || "https://casumo-api.paymentiq.io" === t || "https://api.ecomtransactions.io" === t ? "https://checkout.paymentiq.io" : t;
            }, N = function(e, t, a) {
                void 0 === t && (t = !0), void 0 === a && (a = !1);
                try {
                    var n = function(e) {
                        return a ? e : encodeURIComponent(e);
                    }, r = function(e, t) {
                        return n("object" == typeof e && "trackingPixels" === t ? JSON.stringify(e) : e);
                    }, i = [];
                    for(var o in e){
                        var c = e[o];
                        t ? null !== e[o] && "" !== e[o] && i.push("".concat(n(o), "=").concat(r(c, o))) : i.push("".concat(n(o), "=").concat(r(c, o)));
                    }
                    return i.join("&");
                } catch (e) {
                    console.error(e);
                }
            }, U = function(t) {
                var a = e({}, t);
                try {
                    var n = a.theme;
                    for(var r in delete a.theme, n)for(var i in n[r])a["theme_".concat(r, "_").concat(i)] = n[r][i];
                } catch (e) {
                    console.log(e);
                }
                try {
                    var o = a.attributes;
                    for(var c in function(e) {
                        delete e.containerMinHeight, delete e.initLoadErrorTimeout, delete e.attributes;
                    }(a), o)a["attributes.".concat(c)] = o[c];
                    var s = a.user;
                    for(var d in delete a.user, s)a["user.".concat(d)] = s[d];
                } catch (e) {
                    console.log(e);
                }
                return a;
            }, F = function(t) {
                var a = e({}, t);
                return a.config && (delete a.config.merchantId, delete a.config.userId, delete a.config.sessionId), a;
            }, G = function(e) {
                document.getElementById("cashierIframe").style.height = "".concat(e, "px");
            }, H = function(e) {
                document.getElementById("lookupIframe").style.height = "".concat(e, "px");
            }, V = function(e, t) {
                var a = self.window.location.href, n = null, r = new RegExp("[&\\?]" + e + "=");
                return r.test(a) ? (r = new RegExp("([&\\?])" + e + "=\\d+"), n = a.replace(r, "$1".concat(e, "=").concat(t))) : n = a.indexOf("?") > -1 ? "".concat(a, "&").concat(e, "=").concat(t) : "".concat(a, "?").concat(e, "=").concat(t), n;
            }, W = function(t) {
                try {
                    var a = JSON.parse(t.config), n = "".concat(window.PIQ_CASHIER_URI.split("?")[0], "?").concat(N(U(a)));
                    window.PIQ_BO_CONFIG_URI = n, window.PIQ_BO_CONFIG_MERGED = e(e({}, window.__PIQ_CASHIER_CONFIG__), t);
                } catch (e) {
                    console.log(e);
                }
            }, X = function() {
                try {
                    var e = document.getElementById("cashierIframe");
                    e ? e.remove() : console.log("No PIQ Cashier found and can't reset");
                } catch (e) {
                    console.error(e), console.log("Unable to destroy PIQ Cashier - has it been setup?");
                }
            }, j = "geolocation *;camera *;payment *;clipboard-read *;clipboard-write *;autoplay *;microphone *;fullscreen *;accelerometer *;magnetometer *;gyroscope *;picture-in-picture *;otp-credentials *;";
            var q = function() {
                function t(t, a, n) {
                    this.initCssSet = !1;
                    var r = document.querySelector(t);
                    r.className = g, this.cashierContainerId = (new Date).getTime().toString(), r.setAttribute(v, this.cashierContainerId), a.containerMinHeight && (this.containerMinHeight = a.containerMinHeight);
                    var i = e({}, a), c = function(t) {
                        var a = t.font, n = t.locale, r = R();
                        if (t.attributes || (t.attributes = {}), t.attributes.hostUri = r, t.lookupConfig) {
                            var i = e({}, t.lookupConfig), o = e(e(e(e({
                                merchantId: t.merchantId
                            }, i), a && {
                                font: a
                            }), n && {
                                locale: n
                            }), {
                                hostUri: r,
                                theme: e({}, t.theme),
                                containerWidth: t.containerWidth || void 0,
                                environment: i.environment || t.environment || "production"
                            });
                            return delete t.lookupConfig, {
                                cashierConfig: t,
                                lookupConfig: o
                            };
                        }
                        return {
                            cashierConfig: t
                        };
                    }(i), s = c.cashierConfig, d = c.lookupConfig;
                    return this.cashierConfig = s, this.element = r, this.lookupLoaded = !1, this.cashierLoaded = !1, d ? this.setupCheckoutFlow(r, d, n, this) : this.setupCashierFlow(n), function() {
                        try {
                            o().getV18({}, function(e) {
                                window._piqDFP = e;
                            });
                        } catch (e) {
                            console.error("Failed to generate device id"), console.error(e);
                        }
                    }(), window.__PIQ_CASHIER_CONFIG__ = i, this.api(!1, null);
                }
                return t.prototype.setupCashierFlow = function(e) {
                    this.setupCashier({
                        callback: e
                    });
                }, t.prototype.setupCheckoutFlow = function(t, a, n, r) {
                    var i = this, o = null;
                    a && (a.domElement || t) && (o = function(t, a, n) {
                        var r = e({}, a);
                        r.didAccessToken && (r.didAccessToken = JSON.stringify(r.didAccessToken)), r.userData && (r.userData = JSON.stringify(r.userData)), n.iframe = document.createElement("iframe");
                        var i = r.environment, o = (r.containerHeight, r.containerWidth), c = void 0 === o ? "1px" : o, s = r.containerMinHeight, d = void 0 === s ? "0px" : s, l = function(e, t, a) {
                            if (!e) return "http://localhost:4000";
                            switch(e){
                                case "production":
                                case "test":
                                    return "https://".concat(a ? "checkout" : "pay", ".paymentiq.io/checkout-client/").concat(t || "master");
                                case "development":
                                    return "http://localhost:4000";
                            }
                        }(i, r.version, r.useExperimentalCdn);
                        n.iframe.style.borderWidth = 0, n.iframe.style.height = "250px", n.iframe.style.minHeight = d, n.iframe.style.width = c, n.iframe.style.minWidth = "100%", n.iframe.style.left = "0px", n.iframe.allow = j, n.iframe.id = "lookupIframe", n.iframe.setAttribute("data-hj-allow-iframe", "true"), n.iframe.setAttribute("data-cy", "lookup-iframe");
                        var u = N(U(r));
                        return u.length > 2e3 && console.error("Query length is over 2000 characters. self can be breaking in some browsers. Look into your passed in parameters, are all needed? Did you know that any passed in attributes can be passed in using the Javascript-API instead?. Read more over at https://docs.paymentiq.io/europe/cashier/general/javascriptapi"), n.iframe.src = "".concat(l, "/?").concat(u), t.appendChild(n.iframe), n.iframe;
                    }(a.domElement || t, a, r)), o.onload = function() {
                        i.lookupLoaded = !0, n(i.api(!0, o));
                    };
                }, t.prototype.setupCashier = function(t) {
                    var a, n, r = this;
                    try {
                        var i = t.callback, o = void 0 === i ? null : i, c = t.userId, s = t.sessionId, d = t.user, l = void 0 === d ? {} : d, u = t.attributes, f = void 0 === u ? {} : u, p = t.didToken, m = void 0 === p ? null : p, y = this, T = y.element, w = y.cashierConfig, A = y.cashierLoaded;
                        if (T && w && !A) {
                            c && (w.userId = c), s && (w.sessionId = s), m && (w.attributes || (w.attributes = {}), w.attributes.didToken = m), w.user = e(e({}, w.user), l), w.attributes = e(e({}, w.attributes), f);
                            var E = function(e, t, a, n) {
                                a.iframe = document.createElement("iframe");
                                var r = t.environment, i = t.containerHeight, o = void 0 === i ? "100%" : i, c = t.containerWidth, s = void 0 === c ? "100%" : c, d = t.containerMinHeight, l = void 0 === d ? "0px" : d, u = function(e) {
                                    if (!e) return "https://api.paymentiq.io/paymentiq/cashier";
                                    switch(e){
                                        case "production":
                                            return "https://api.paymentiq.io/paymentiq/cashier";
                                        case "mrgreen":
                                            return "https://mrgreen-api.paymentiq.io/paymentiq/cashier";
                                        case "casumo":
                                            return "https://casumo-api.paymentiq.io/paymentiq/cashier";
                                        case "ecom":
                                            return "https://api.ecomtransactions.io/paymentiq/cashier";
                                        case "test":
                                            return "https://test-api.paymentiq.io/paymentiq/cashier";
                                        case "development":
                                            return "http://localhost:5000";
                                    }
                                }(r);
                                a.iframe.style.borderWidth = 0, a.iframe.style.height = o, a.iframe.style.minHeight = l, a.iframe.style.width = s, a.iframe.style.left = "0px", a.iframe.allow = j, a.iframe.allowTransparency, a.iframe.id = "cashierIframe", a.iframe.setAttribute("data-hj-allow-iframe", "true"), a.iframe.setAttribute("data-cy", "cashier-iframe");
                                var f = N(U(t));
                                f.length > 2e3 && console.error("Query length is over 2000 characters. self can be breaking in some browsers. Look into your passed in parameters, are all needed? Did you know that any passed in attributes can be passed in using the Javascript-API instead?. Read more over at https://docs.paymentiq.io/europe/cashier/general/javascriptapi");
                                var p = "".concat(u, "/?").concat(f, "&attributes.bootstrapVersion=").concat("1.4.4");
                                return a.iframe.src = p, a.iframe.onload = n, e.appendChild(a.iframe), window.PIQ_CASHIER_URI = p, a.iframe;
                            }(T, w, this, function() {
                                r.cashierLoaded = !0, o && o(r.api(!0, E));
                            });
                            a = w.initLoadErrorTimeout, n = this.cashierContainerId, void 0 === a && (a = 1e4), setTimeout(function() {
                                var e, t = document.querySelector(".".concat(g)), i = (null == t ? void 0 : t.attributes) ? null === (e = t.attributes[v]) || void 0 === e ? void 0 : e.value : "";
                                r.cashierLoaded || n !== i || self.postMessage({
                                    eventType: h,
                                    payload: {
                                        status: "Could not load cashier iframe. Execution time limit was exceeded: ".concat(a, " milliseconds"),
                                        timeLimit: a
                                    }
                                }, "*");
                            }, a);
                        }
                    } catch (e) {
                        console.log("Failed to setup cashier"), console.error(e);
                    }
                }, t.prototype.api = function(t, a) {
                    var n, r, i = this, o = {
                        set: function(e) {
                            !function(e, t) {
                                x({
                                    eventType: c,
                                    payload: F(e)
                                }, t.iframe.contentWindow, D(t.iframe));
                            }(e, i);
                        },
                        css: function(e) {
                            B(e, i);
                        },
                        pause: function() {
                            _(i);
                        },
                        resume: function() {
                            P(i);
                        },
                        on: function() {}
                    };
                    return this.containerMinHeight && !this.initCssSet && (n = this.containerMinHeight, r = this, window.addEventListener("message", function(e) {
                        if (e.data.eventType === f) {
                            typeof n;
                            var t = "\n      #app-container.auto-height {\n        min-height: ".concat(n, "!important;\n      }\n      ");
                            B(t, r);
                        }
                    }), this.initCssSet = !0), t && a ? (M(a.id), w = this, T = k, window.removeEventListener("message", I, !1), window.addEventListener("message", I), e(e({}, o), {
                        on: function(e) {
                            !function(e) {
                                var t;
                                A(e), e.isLoading && (t = document.querySelector("#cashierIframe")) && x({
                                    eventType: p
                                }, t.contentWindow, D(t));
                            }(e);
                        }
                    })) : o;
                }, t;
            }();
            window._PaymentIQCashier = q, window._PaymentIQCashierReset = X;
            const K = q;
        })(), n;
    })());






function $460ce94dc26906c4$var$e(e) {
    this.message = e;
}
$460ce94dc26906c4$var$e.prototype = new Error, $460ce94dc26906c4$var$e.prototype.name = "InvalidCharacterError";
var $460ce94dc26906c4$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $460ce94dc26906c4$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $460ce94dc26906c4$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($460ce94dc26906c4$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $460ce94dc26906c4$var$r(t);
    }
}
function $460ce94dc26906c4$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $460ce94dc26906c4$var$o(e, r) {
    if ("string" != typeof e) throw new $460ce94dc26906c4$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($460ce94dc26906c4$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $460ce94dc26906c4$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$460ce94dc26906c4$export$b9721ef022f71a68.prototype = new Error, $460ce94dc26906c4$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $460ce94dc26906c4$export$2e2bcd8739ae039 = $460ce94dc26906c4$var$o;




const $e9d25ab963e7e928$var$PAYMENTIQ_ENVIRONMENT = "production", $e9d25ab963e7e928$var$PAYMENTIQ_API_URL = "https://api.paymentiq.io/paymentiq/api", $e9d25ab963e7e928$var$MERCHANT_ID = "100223001";
// console.log('PAYMENTIQ_ENVIRONMENT:', PAYMENTIQ_ENVIRONMENT)
// console.log('PAYMENTIQ_API_URL:', PAYMENTIQ_API_URL)
// console.log('MERCHANT_ID:', MERCHANT_ID)
// console.log(i18next.language)
const $e9d25ab963e7e928$var$locale = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language === 'sv' ? 'sv_SE' : 'en_GB';
async function $e9d25ab963e7e928$var$api(endPoint, body = null, method = 'GET') {
    const headers = {
        'Content-Type': 'application/json'
    };
    let query = endPoint.indexOf('?') === -1 ? '?' : '&';
    query += 'locale=' + $e9d25ab963e7e928$var$locale;
    // A dropped connection while processing the deposit leaves the already-prepared
    // booking in an unknown state — the PSP may still confirm it to the backend.
    const isUncertain = endPoint.startsWith('/creditcard/deposit/process');
    const res = await fetch(`${$e9d25ab963e7e928$var$PAYMENTIQ_API_URL}${endPoint}${query}`, {
        method: method,
        headers: headers,
        body: body
    }).catch((error)=>{
        console.error(error);
        // Same as in lib/api.js: `res` was undefined here and res.json() threw a TypeError.
        throw new (0, $135a523c4bea715f$export$bae979e68e4dc802)((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t(isUncertain ? 'error-network-uncertain' : 'error-network'), isUncertain);
    });
    // console.log(res)
    const json = await res.json();
    // TODO: Implement error handling
    // Check for API errors
    // if (res.status !== 200) {
    //   if (json?.error) json.message = getErrorMessage(endPoint, json.error)
    //   if (res.status === 401 && json?.error === 'Unauthorized') {
    //     emitCustomEvent('UNAUTHORIZED')
    //   }
    //   throw new ApiError(`${json.error} ${json.message}`, json)
    // }
    return json;
}
async function $e9d25ab963e7e928$export$160a2ee907bcaf92(userId, sessionId) {
    const res = await $e9d25ab963e7e928$var$api(`/user/account/${$e9d25ab963e7e928$var$MERCHANT_ID}/${userId}?sessionId=${sessionId}`);
    return res;
}
async function $e9d25ab963e7e928$export$d2736c8011eb8c55(userId, accountId, sessionId) {
    const res = await $e9d25ab963e7e928$var$api(`/user/account/${$e9d25ab963e7e928$var$MERCHANT_ID}/${userId}/${accountId}?sessionId=${sessionId}`, null, 'DELETE');
    return res;
}
async function $e9d25ab963e7e928$export$5b0728622257034(userId, accountId, sessionId) {
    const decoded = (0, $460ce94dc26906c4$export$2e2bcd8739ae039)(sessionId);
    const redirectBase = `${location.origin}/payment?status=`;
    const req = {
        sessionId: `${sessionId}`,
        userId: userId,
        merchantId: `${$e9d25ab963e7e928$var$MERCHANT_ID}`,
        amount: decoded.transactionAmount,
        accountId: `${accountId}`,
        attributes: {
            paymentToken: `${sessionId}`,
            userId: userId,
            successUrl: `${redirectBase}success`,
            failureUrl: `${redirectBase}failure`,
            pendingUrl: `${redirectBase}pending`,
            cancelUrl: `${redirectBase}cancel`
        }
    };
    const res = await $e9d25ab963e7e928$var$api(`/creditcard/deposit/process`, JSON.stringify(req), 'POST');
    return res;
}




var $2fa28d384d170a3e$exports = {};

$parcel$export($2fa28d384d170a3e$exports, "container", function () { return $2fa28d384d170a3e$export$34e0f9847d4c02dd; }, function (v) { return $2fa28d384d170a3e$export$34e0f9847d4c02dd = v; });
$parcel$export($2fa28d384d170a3e$exports, "form", function () { return $2fa28d384d170a3e$export$6210fa4921d2a466; }, function (v) { return $2fa28d384d170a3e$export$6210fa4921d2a466 = v; });
$parcel$export($2fa28d384d170a3e$exports, "isCashier", function () { return $2fa28d384d170a3e$export$2107893639eecd3c; }, function (v) { return $2fa28d384d170a3e$export$2107893639eecd3c = v; });
$parcel$export($2fa28d384d170a3e$exports, "isVisible", function () { return $2fa28d384d170a3e$export$795910f5f15a9633; }, function (v) { return $2fa28d384d170a3e$export$795910f5f15a9633 = v; });
$parcel$export($2fa28d384d170a3e$exports, "wrapper", function () { return $2fa28d384d170a3e$export$cc74dcc53cfce4eb; }, function (v) { return $2fa28d384d170a3e$export$cc74dcc53cfce4eb = v; });
var $2fa28d384d170a3e$export$34e0f9847d4c02dd;
var $2fa28d384d170a3e$export$6210fa4921d2a466;
var $2fa28d384d170a3e$export$2107893639eecd3c;
var $2fa28d384d170a3e$export$795910f5f15a9633;
var $2fa28d384d170a3e$export$cc74dcc53cfce4eb;
$2fa28d384d170a3e$export$34e0f9847d4c02dd = `RzzdwG_container`;
$2fa28d384d170a3e$export$6210fa4921d2a466 = `RzzdwG_form`;
$2fa28d384d170a3e$export$2107893639eecd3c = `RzzdwG_isCashier`;
$2fa28d384d170a3e$export$795910f5f15a9633 = `RzzdwG_isVisible`;
$2fa28d384d170a3e$export$cc74dcc53cfce4eb = `RzzdwG_wrapper`;


const $571eab651e6de4c8$var$baseConfig = {
    mode: 'ecommerce',
    listType: 'grid',
    displayLogoOrName: 'name',
    providerType: 'creditcard',
    accountDelete: false,
    autoOpenFirstPaymentMethod: false,
    autoSetIframeProviderHeight: false,
    disableBtnAtZero: false,
    hideTxOverview: true,
    predefinedValues: false,
    showAccounts: false,
    showFee: false,
    showFooter: false,
    showHeader: false,
    showReceipt: false,
    showTransactionOverview: false,
    singlePageFlow: true,
    theme: {
        // labels: {
        //   color: '#FFFFFF'
        // },
        loader: {
            color: '#F7CE46'
        },
        error: {
            color: '#FF0000'
        },
        buttons: {
            color: '#FEBF00'
        }
    }
};
const $571eab651e6de4c8$export$6c1e1b42ea9c3f5f = {
    ...$571eab651e6de4c8$var$baseConfig
};
const $571eab651e6de4c8$export$74c9190620762180 = {
    ...$571eab651e6de4c8$var$baseConfig,
    showAccounts: 'list-first',
    showFee: true
};


//console.log(process.env);
const $55e74f19e167cb27$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($2fa28d384d170a3e$exports);
//const PAYMENTIQ_ENVIRONMENT = "";
//const MERCHANT_ID = "";
const $55e74f19e167cb27$var$PAYMENTIQ_ENVIRONMENT = "production", $55e74f19e167cb27$var$MERCHANT_ID = "100223001";
function $55e74f19e167cb27$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [isVisible, setIsVisible] = (0, $bh6RR.useState)(false);
    const [isCashier, setIsCashier] = (0, $bh6RR.useState)(false);
    const statusFuncRef = (0, $bh6RR.useRef)();
    const doneLoadingRef = (0, $bh6RR.useRef)();
    const containerRef = (0, $bh6RR.useRef)();
    const cashierRef = (0, $bh6RR.useRef)();
    const wrapperRef = (0, $bh6RR.useRef)();
    const bookingIdRef = (0, $bh6RR.useRef)();
    const showCashier = (baseConfig, userId, paymentToken, amount, accountId = null, success = null)=>{
        // Reset cashier if it was already rendered
        window._PaymentIQCashierReset();
        const config = {
            ...baseConfig,
            environment: $55e74f19e167cb27$var$PAYMENTIQ_ENVIRONMENT,
            merchantId: $55e74f19e167cb27$var$MERCHANT_ID,
            userId: userId,
            sessionId: paymentToken,
            amount: amount,
            attributes: {
                paymentToken: paymentToken,
                userId: userId
            },
            locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language === 'sv' ? 'sv_SE' : 'en_GB'
        };
        if (accountId) config.accountId = accountId;
        new (0, (/*@__PURE__*/$parcel$interopDefault($5aa1ea04dd4019e5$exports)))('#cashier', config, (api)=>{
            api.on({
                cashierInitLoad: ()=>void 0,
                update: (data)=>void 0,
                success: (data)=>{
                    if (success) success();
                    setTimeout(closeModal, 100);
                },
                failure: (data)=>void 0,
                pending: (data)=>void 0,
                unresolved: (data)=>void 0,
                isLoading: (data)=>void 0,
                doneLoading: (data)=>void 0,
                newProviderWindow: (data)=>void 0,
                paymentMethodSelect: (data)=>void 0,
                paymentMethodPageEntered: (data)=>void 0,
                navigate: (data)=>void 0,
                cancelledPendingWD: (data)=>void 0,
                validationFailed: (data)=>void 0,
                cancelled: (data)=>void 0,
                onLoadError: (data)=>void 0,
                transactionInit: (data)=>void 0
            });
            api.css(``);
        });
    };
    const addCard = ({ success: success })=>{
        if (user?.userId) {
            setIsVisible(true);
            setIsCashier(true);
            (0, $135a523c4bea715f$export$4ed561c675781f86)(user.userId).then((paymentToken)=>{
                showCashier((0, $571eab651e6de4c8$export$6c1e1b42ea9c3f5f), user.userId, paymentToken, 0, null, success);
            });
        }
    };
    // const payBooking = ({ bookingId, accountId, success }) => {
    //   if (user?.userId) {
    //     setIsVisible(true)
    //     getPaymentToken(user.userId, bookingId).then((paymentToken) => {
    //       console.log(paymentToken)
    //       const decoded = jwt_decode(paymentToken)
    //       showCashier(payBookingConfig, user.userId, paymentToken, decoded.transactionAmount, accountId, success)
    //     })
    //   }
    // }
    const payBooking = ({ bookingId: bookingId, accountId: accountId, success: success, doneLoading: doneLoading })=>{
        if (user?.userId) {
            // Store bookingID to track if modal is closed without success
            bookingIdRef.current = bookingId;
            (0, $135a523c4bea715f$export$904a7cbfa3bf44c7)(user.userId, bookingId).then((paymentToken)=>{
                (0, $e9d25ab963e7e928$export$5b0728622257034)(user.userId, accountId, paymentToken).then((response)=>{
                    if (response.success) {
                        // Show IFRAME with provider redirect
                        if (response.redirectOutput) {
                            // Keep bookingID ref until redirect completes (user might close modal)
                            doneLoadingRef.current = doneLoading;
                            openRedirect(response.redirectOutput, success);
                        } else {
                            // Clear bookingID ref on success (no redirect, so no modal)
                            bookingIdRef.current = null;
                            success();
                        }
                    } else {
                        bookingIdRef.current = null; // Clear on error
                        let message = response.errors.map((item)=>item.msg).join('. ');
                        if (!/\.$/.test(message)) message += '.';
                        (0, $30acdccbb47e8004$export$eb122250488b74d5)(message);
                        doneLoading();
                    }
                }).catch((error)=>{
                    bookingIdRef.current = null; // Clear on error
                    console.error(error);
                    // A dropped connection here is ambiguous — the booking is already prepared
                    // and the PSP may still confirm it. Say so instead of failing silently.
                    if (error?.isNetworkError) (0, $30acdccbb47e8004$export$eb122250488b74d5)(error.message);
                    doneLoading();
                });
            }).catch((error)=>{
                bookingIdRef.current = null; // Clear on error
                console.error(error);
                if (error?.isNetworkError) (0, $30acdccbb47e8004$export$eb122250488b74d5)(error.message);
                doneLoading();
            });
        }
    };
    const closeModal = ()=>{
        setIsVisible(false);
        setIsCashier(false);
        // Emit event when payment modal is closed (without success)
        // This allows components to track pending payments
        // Only emit if there's a pending booking (modal was closed without success)
        if (bookingIdRef.current) {
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('PAYMENT_MODAL_CLOSED', {
                bookingId: bookingIdRef.current
            });
            // Don't call doneLoading if there's a pending booking - let the event handler manage loading state
            bookingIdRef.current = null;
        } else // No pending booking, safe to call doneLoading
        if (doneLoadingRef.current) {
            doneLoadingRef.current();
            doneLoadingRef.current = null;
        }
        if (wrapperRef.current) wrapperRef.current.remove();
        if (statusFuncRef.current) {
            window.removeEventListener('message', statusFuncRef.current);
            statusFuncRef.current = null;
        }
        window._PaymentIQCashierReset();
    };
    const openRedirect = (redirect, success)=>{
        if (containerRef.current) {
            // Eventhandler that handles postMessage from the redirect URL:s 
            statusFuncRef.current = ({ origin: origin, data: data })=>{
                if (origin === location.origin && data?.type === 'PAYMENT_STATUS') {
                    if (data.status === 'success') {
                        // Clear bookingID ref on success
                        bookingIdRef.current = null;
                        closeModal();
                        success();
                    } else if (data.status === 'failure') {
                        // Keep bookingID ref so closeModal() emits PAYMENT_MODAL_CLOSED — backend may still confirm
                        closeModal();
                        (0, $30acdccbb47e8004$export$eb122250488b74d5)(t('error-payment'));
                    } else if (data.status === 'pending') ;
                    else if (data.status === 'cancel') // Keep bookingID ref on cancel so we can track it
                    closeModal();
                }
            };
            window.addEventListener('message', statusFuncRef.current);
            // NOTE: Testing of POST with parameters
            // redirect.method = 'POST'
            // redirect.parameters = {
            //   testing: 'testing the POST',
            //   param: 'a parameter',
            //   terms: 'termslink'
            // }
            // Create wrapper to hold all created elements
            const wrapper = document.createElement('div');
            containerRef.current.appendChild(wrapper);
            wrapperRef.current = wrapper;
            // Create IFRAME
            const iframe = document.createElement('iframe');
            iframe.name = 'payment-iframe';
            iframe.className = $2fa28d384d170a3e$exports.iframe;
            iframe.width = redirect.width;
            iframe.height = redirect.height;
            wrapper.appendChild(iframe);
            // If POST create a form and post to the IFRAME
            if (redirect.method === 'POST') {
                const form = document.createElement('form');
                form.className = $2fa28d384d170a3e$exports.form;
                form.method = 'POST';
                form.target = 'payment-iframe';
                form.action = redirect.url;
                // Create inputs
                Object.entries(redirect.parameters).forEach(([key, value])=>{
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value;
                    form.appendChild(input);
                });
                wrapper.appendChild(form);
                form.submit();
            } else iframe.src = redirect.url;
            setIsVisible(true);
        }
    };
    // useCustomEventListener('SHOW_IFRAME', openRedirect)
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CASHIER_ADD_CARD', addCard);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CASHIER_PAY_BOOKING', payBooking);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $55e74f19e167cb27$var$cx($2fa28d384d170a3e$exports.wrapper, {
            isVisible: isVisible
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            ref: containerRef,
            className: $55e74f19e167cb27$var$cx($2fa28d384d170a3e$exports.container, {
                isCashier: isCashier
            }),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fa620ad2e74576c$export$2e2bcd8739ae039), {
                    onClick: closeModal
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    ref: cashierRef,
                    id: "cashier"
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");




var $lW2XZ = parcelRequire("lW2XZ");






var $a5378f5f92f9caff$exports = {};

$parcel$export($a5378f5f92f9caff$exports, "container", function () { return $a5378f5f92f9caff$export$34e0f9847d4c02dd; }, function (v) { return $a5378f5f92f9caff$export$34e0f9847d4c02dd = v; });
$parcel$export($a5378f5f92f9caff$exports, "form", function () { return $a5378f5f92f9caff$export$6210fa4921d2a466; }, function (v) { return $a5378f5f92f9caff$export$6210fa4921d2a466 = v; });
$parcel$export($a5378f5f92f9caff$exports, "isCashier", function () { return $a5378f5f92f9caff$export$2107893639eecd3c; }, function (v) { return $a5378f5f92f9caff$export$2107893639eecd3c = v; });
$parcel$export($a5378f5f92f9caff$exports, "isVisible", function () { return $a5378f5f92f9caff$export$795910f5f15a9633; }, function (v) { return $a5378f5f92f9caff$export$795910f5f15a9633 = v; });
$parcel$export($a5378f5f92f9caff$exports, "wrapper", function () { return $a5378f5f92f9caff$export$cc74dcc53cfce4eb; }, function (v) { return $a5378f5f92f9caff$export$cc74dcc53cfce4eb = v; });
var $a5378f5f92f9caff$export$34e0f9847d4c02dd;
var $a5378f5f92f9caff$export$6210fa4921d2a466;
var $a5378f5f92f9caff$export$2107893639eecd3c;
var $a5378f5f92f9caff$export$795910f5f15a9633;
var $a5378f5f92f9caff$export$cc74dcc53cfce4eb;
$a5378f5f92f9caff$export$34e0f9847d4c02dd = `vxVWUW_container`;
$a5378f5f92f9caff$export$6210fa4921d2a466 = `vxVWUW_form`;
$a5378f5f92f9caff$export$2107893639eecd3c = `vxVWUW_isCashier`;
$a5378f5f92f9caff$export$795910f5f15a9633 = `vxVWUW_isVisible`;
$a5378f5f92f9caff$export$cc74dcc53cfce4eb = `vxVWUW_wrapper`;





const $f0cb867bf70eee97$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($a5378f5f92f9caff$exports);
const $f0cb867bf70eee97$var$renderVoucherInfo = (voucher)=>{
    let str = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('expires-at', {
        date: (0, $200ec6b1b2ca8c5a$export$f0a889078b7435f7)(new Date(voucher.expiry))
    });
    if (voucher.valueType == 'PERCENTAGE') return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            str,
            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
            (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-voucher-max', {
                amount: voucher.maxPriceToBeDiscounted
            })
        ]
    });
    return str;
};
function $f0cb867bf70eee97$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isVisible, setIsVisible] = (0, $bh6RR.useState)(false);
    // const payBooking = ({ bookingId, accountId, success }) => {
    //   if (user?.userId) {
    //     setIsVisible(true)
    //     getPaymentToken(user.userId, bookingId).then((paymentToken) => {
    //       console.log(paymentToken)
    //       const decoded = jwt_decode(paymentToken)
    //       showCashier(payBookingConfig, user.userId, paymentToken, decoded.transactionAmount, accountId, success)
    //     })
    //   }
    // }
    const paymentButtonRef = (0, $bh6RR.useRef)();
    const payInCarRef = (0, $bh6RR.useRef)();
    const optionsButtonRef = (0, $bh6RR.useRef)();
    const messageFieldRef = (0, $bh6RR.useRef)();
    const nameFieldRef = (0, $bh6RR.useRef)();
    const [isPaymentOpen, setIsPaymentOpen] = (0, $bh6RR.useState)(false);
    const [isOptionsOpen, setIsOptionsOpen] = (0, $bh6RR.useState)(false);
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const { config: config, user: user, paymentAccounts: paymentAccounts, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const disableCreditCards = !values.priceType?.paymentMethods?.includes('CreditCard');
    const disableTSABAccounts = !values.priceType?.paymentMethods?.includes('TSABAccount');
    const disableTCAAccounts = !values.priceType?.paymentMethods?.includes('TravelClearingAccount');
    const disableVouchers = !values.priceType?.voucherEnabled;
    const hasAccounts = user?.accounts?.length > 0;
    const hasCreditCards = paymentAccounts?.length > 0;
    const hasVouchers = user?.vouchers?.length > 0;
    const makeRequest = ()=>{
        const isCreditCard = values.payment.indexOf('CreditCard') !== -1;
        const bookingFunc = isCreditCard ? prepareBooking : createBooking;
        setIsLoading(true);
        bookingFunc(values, user.userId).then((response)=>{
            if (!isNaN(response?.bookingId)) {
                if (isCreditCard) {
                    // Store bookingID in localStorage for recovery if payment modal is closed
                    const pendingBookings = JSON.parse(localStorage.getItem('pendingCreditCardBookings') || '[]');
                    if (!pendingBookings.includes(response.bookingId)) {
                        pendingBookings.push(response.bookingId);
                        localStorage.setItem('pendingCreditCardBookings', JSON.stringify(pendingBookings));
                    }
                    emitCustomEvent('CASHIER_PAY_BOOKING', {
                        bookingId: response.bookingId,
                        accountId: values.account.accountId,
                        success: ()=>{
                            // Remove from pending bookings on success
                            const updatedPending = JSON.parse(localStorage.getItem('pendingCreditCardBookings') || '[]').filter((id)=>id !== response.bookingId);
                            localStorage.setItem('pendingCreditCardBookings', JSON.stringify(updatedPending));
                            handleBookingComplete(response);
                        },
                        doneLoading: ()=>setIsLoading(false)
                    });
                } else handleBookingComplete(response);
            }
        }).catch((error)=>{
            if (error?.response?.error === 'INVALID_PHONE_NUMBER') setFieldError('phone', error?.response?.message);
            else if (!(error?.isUnauthorized || error?.status === 401 || error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) {
                console.error(error);
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
            setIsLoading(false);
        });
    // .finally(() => {
    //   setIsLoading(false)
    // })
    };
    const sendToGTM = (values, bookingId)=>{
        const booking = (0, $200ec6b1b2ca8c5a$export$9f1f9dfacc50ba0)(values);
        const priceComponents = fixedPrice ? values.priceEstimate?.prices?.filter((value)=>{
            return value.serviceType === booking.serviceType;
        }) : false;
        const prices = priceComponents && priceComponents.length > 0 ? priceComponents[0].priceComponents?.filter((value)=>{
            return value.type === 'fixedPrice';
        }) : false;
        const price = prices && prices.length > 0 ? prices[0].amount : false;
        const trackData = {
            price: price,
            currency: 'SEK',
            preBook: values.pickupTime ? true : false,
            pickupTime: booking.pickUpTimeStamp,
            bookingNumber: bookingId,
            carType: booking.serviceType,
            extras: booking.vehicleOptions,
            fixedPrice: fixedPrice && booking.priceToken ? true : false
        };
        track('confirmBooking', trackData);
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    const setAccount = (account)=>{
        if (!account) setFieldValue('accountReference', '', false);
        setFieldValue('account', account, false);
    };
    const openOptions = ()=>{
        setIsOptionsOpen(true);
        setTimeout(()=>{
            if (messageFieldRef.current) messageFieldRef.current.focus();
        }, 200);
    };
    const closeOptions = ()=>{
        setIsOptionsOpen(false);
        if (optionsButtonRef.current) optionsButtonRef.current.focus();
    };
    const openPayment = ()=>{
        setIsPaymentOpen(true);
        setTimeout(()=>{
            if (payInCarRef.current) payInCarRef.current.focus();
        }, 200);
    };
    const closePayment = ()=>{
        setIsPaymentOpen(false);
        if (paymentButtonRef.current) paymentButtonRef.current.focus();
    };
    const addCard = ()=>{
        closeOptions();
        emitCustomEvent('CASHIER_ADD_CARD', {
            success: refreshUser
        });
    };
    const openAddAccount = ()=>{
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $f5a01b8c00777f68$export$2e2bcd8739ae039), {
                onComplete: close
            }));
    };
    const openAddVoucher = ()=>{
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $006192e901cb3229$export$2e2bcd8739ae039), {
                onComplete: close
            }));
    };
    const closeModal = ()=>{
        setIsVisible(false);
    };
    // useCustomEventListener('SHOW_IFRAME', openRedirect)
    // useCustomEventListener('CASHIER_ADD_CARD', addCard)
    // useCustomEventListener('CASHIER_PAY_BOOKING', payBooking)
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.wrapper, {
            isVisible: isVisible
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.container, {}),
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $f0cb867bf70eee97$var$cx($f35967c56a9f3d99$export$c09c292f11cd9d1, {
                        fullscreen: true,
                        contentOptions: true,
                        noBackground: true
                    }),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                            type: "radio",
                            name: "payment",
                            title: t('title-pay-in-car'),
                            value: "PayInCar",
                            onClick: ()=>setAccount(false),
                            innerRef: payInCarRef,
                            component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.subHeader, $a5378f5f92f9caff$exports.marginTop, $f35967c56a9f3d99$export$f59aa6be2711b90),
                            children: t('header-card')
                        }),
                        !hasCreditCards && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $a5378f5f92f9caff$exports.instructions,
                            children: t('info-no-cards')
                        }),
                        paymentAccounts?.map((account, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                type: "radio",
                                name: "payment",
                                title: account.maskedAccount,
                                info: account.cardType,
                                value: `CreditCard-${account.accountId}`,
                                onClick: ()=>setAccount(account),
                                tabIndex: isPaymentOpen ? 0 : -1,
                                disabled: disableCreditCards,
                                component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                            }, index)),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.instructions, $f35967c56a9f3d99$export$f59aa6be2711b90),
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                className: $a5378f5f92f9caff$exports.button,
                                onClick: addCard,
                                tabIndex: isPaymentOpen ? 0 : -1,
                                children: [
                                    "+ ",
                                    t('button-add-new-card')
                                ]
                            })
                        }),
                        !hasAccounts && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $a5378f5f92f9caff$exports.instructions,
                            children: t('info-no-accounts')
                        }),
                        user?.accounts?.map((account, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                type: "radio",
                                name: "payment",
                                title: account.accountName,
                                info: account.accountNumber,
                                value: `Account-${account.accountNumber}`,
                                onClick: ()=>setAccount(account),
                                tabIndex: isPaymentOpen ? 0 : -1,
                                disabled: account.type === 'TSAB' && disableTSABAccounts || account.type === 'TCA' && disableTCAAccounts,
                                component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                            }, index)),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.instructions, $f35967c56a9f3d99$export$f59aa6be2711b90),
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                className: $a5378f5f92f9caff$exports.button,
                                onClick: openAddAccount,
                                tabIndex: isPaymentOpen ? 0 : -1,
                                children: [
                                    "+ ",
                                    t('button-add-new-account')
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $234ae484ae699dc2$export$fb184b623420d9be,
                    children: t('title-vouchers')
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $f0cb867bf70eee97$var$cx($f35967c56a9f3d99$export$c09c292f11cd9d1, {
                        contentOptions: true,
                        noPadding: true
                    }),
                    children: [
                        !hasVouchers && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $a5378f5f92f9caff$exports.instructions,
                            children: t('info-no-vouchers')
                        }),
                        user?.vouchers?.map((voucher, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "vouchers",
                                value: voucher.voucherCode,
                                title: `${voucher.voucherCode} - ${(0, $c94184dfef1a7d71$export$9e6e5cf28f33a45e)(voucher)}`,
                                info: $f0cb867bf70eee97$var$renderVoucherInfo(voucher),
                                disabled: disableVouchers || values?.vouchers?.length > 0 && !values?.vouchers?.includes(voucher.voucherCode),
                                tabIndex: isPaymentOpen ? 0 : -1,
                                component: (0, $20f208c249841caf$export$2e2bcd8739ae039),
                                larger: true
                            }, index)),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.instructions, $f35967c56a9f3d99$export$f59aa6be2711b90),
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                className: $a5378f5f92f9caff$exports.button,
                                onClick: openAddVoucher,
                                tabIndex: isPaymentOpen ? 0 : -1,
                                children: [
                                    "+ ",
                                    t('button-add-new-voucher')
                                ]
                            })
                        }),
                        hasVouchers && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $f0cb867bf70eee97$var$cx($a5378f5f92f9caff$exports.instructions, $f35967c56a9f3d99$export$f59aa6be2711b90),
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                    i18nKey: disableVouchers ? 'info-voucher-codes-partner' : 'info-voucher-codes',
                                    components: {
                                        link1: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                            href: config.paymentTermsLink,
                                            target: "_blank"
                                        })
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fa620ad2e74576c$export$2e2bcd8739ae039), {
                    onClick: closeModal
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









function $e2f99346c9bbe6af$var$loadGIS() {
    return new Promise((resolve, reject)=>{
        if (window.google?.accounts?.id) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
function $e2f99346c9bbe6af$var$loadAppleSignIn() {
    return new Promise((resolve, reject)=>{
        if (window.AppleID) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
    });
}
function $e2f99346c9bbe6af$export$2e2bcd8739ae039({ fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { config: config, loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isPhoneLoading, setIsPhoneLoading] = (0, $bh6RR.useState)(false);
    const [isGoogleLoading, setIsGoogleLoading] = (0, $bh6RR.useState)(false);
    const [isAppleLoading, setIsAppleLoading] = (0, $bh6RR.useState)(false);
    const [googleError, setGoogleError] = (0, $bh6RR.useState)(null);
    const [appleError, setAppleError] = (0, $bh6RR.useState)(null);
    const inputRef = (0, $bh6RR.useRef)();
    const googleOverlayRef = (0, $bh6RR.useRef)();
    const googleInnerRef = (0, $bh6RR.useRef)();
    // SOCIAL_LOGIN_ENABLED is the kill switch: with it off, neither provider is offered
    // and neither SDK is loaded, whatever client IDs happen to be configured. A client ID
    // is still required on top, so a provider we have no credentials for stays hidden.
    const socialLoginEnabled = typeof CONFIG !== 'undefined' && !!CONFIG.social_login_enabled;
    const googleLoginEnabled = socialLoginEnabled && !!CONFIG.google_client_id;
    const appleLoginEnabled = socialLoginEnabled && !!CONFIG.apple_client_id;
    // Phone flow
    const makePhoneRequest = ()=>{
        setIsPhoneLoading(true);
        (0, $135a523c4bea715f$export$281f59c767225686)(values.dialCode, values.phone).then((response)=>{
            if (response?.deviceActivationState === 'PHONE_OTP_INITIATED') next('validatePhone');
        }).catch((error)=>setFieldError('phone', error?.response?.message)).finally(()=>setIsPhoneLoading(false));
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makePhoneRequest, (0, $lW2XZ.useFormikContext)());
    // After auto-login (no consent needed), navigate based on context
    const handleLoginComplete = (userId)=>{
        loginAndFetchBookings(userId);
        if (fullscreen) parentContext?.next('confirm');
        else (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
    };
    // Google credential handler (called by GIS after OAuth)
    const handleGoogleCredential = async (credentialResponse)=>{
        setIsGoogleLoading(true);
        setGoogleError(null);
        try {
            await (0, $135a523c4bea715f$export$8a95d6164a049576)();
            const result = await (0, $135a523c4bea715f$export$353a804191b94a80)(credentialResponse.credential);
            if (result.shouldConsentToMarketing !== undefined) setFieldValue('shouldConsentToMarketing', result.shouldConsentToMarketing, false);
            if (result.shouldConsentToTermsAndConditions !== undefined) setFieldValue('shouldConsentToTermsAndConditions', result.shouldConsentToTermsAndConditions, false);
            if (result.externalEmail) setFieldValue('externalEmail', result.externalEmail, false);
            if (result.userInfo?.firstName) setFieldValue('firstName', result.userInfo.firstName, false);
            if (result.userInfo?.lastName) setFieldValue('lastName', result.userInfo.lastName, false);
            const state = result.deviceActivationState;
            if (result.userId && (state === 'ACTIVATION_COMPLETE_EXISTING_USER' || state === 'ACTIVATION_COMPLETE_NEW_USER')) // Server completed activation immediately (token already in localStorage)
            handleLoginComplete(result.userId);
            else if (state === 'EXTERNAL_LOGIN_COMPLETE_EXISTING_USER') {
                // ADD_PHONE has to win: activation can't complete without a phone number.
                // Marketing consent is collected after login by MarketingConsentModal, so
                // only an outstanding terms consent still needs the acceptTerms screen.
                if (result.expectedActions?.includes('ADD_PHONE')) next('socialAddPhone');
                else if (result.shouldConsentToTermsAndConditions) next('acceptTerms');
                else {
                    const activation = await (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                        termsAndConditions: true
                    });
                    if (activation.userId) handleLoginComplete(activation.userId);
                }
            } else if (state === 'EXTERNAL_LOGIN_COMPLETE_NEW_USER') next('socialAddPhone');
            else {
                console.warn('[Google] Unhandled deviceActivationState:', state, result);
                setGoogleError(t('error-google-signin-failed'));
            }
        } catch (err) {
            console.error(err);
            setGoogleError(err?.response?.message || t('error-google-signin-failed'));
        } finally{
            setIsGoogleLoading(false);
        }
    };
    // Stretch whatever GIS produced over the full area of our own button.
    const applyGoogleScale = ()=>{
        const overlay = googleOverlayRef.current;
        const inner = googleInnerRef.current;
        if (!overlay || !inner) return;
        const width = overlay.offsetWidth;
        const height = overlay.offsetHeight;
        const rendered = inner.offsetWidth;
        const renderedHeight = inner.offsetHeight;
        if (!width || !height || !rendered || !renderedHeight) return;
        inner.style.transform = `scale(${width / rendered}, ${height / renderedHeight})`;
    };
    // GIS renders its own button into an invisible overlay so we can show our own
    // design underneath. It clamps the width to 200-400px and picks its own height,
    // so the result almost never matches our button - it has to be stretched, or
    // the parts of our button it doesn't reach have nothing behind them to click.
    const renderGoogleButton = ()=>{
        const overlay = googleOverlayRef.current;
        const inner = googleInnerRef.current;
        if (!overlay || !inner || !window.google?.accounts?.id) return;
        const width = overlay.offsetWidth;
        const height = overlay.offsetHeight;
        if (!width || !height) return; // Not laid out yet - the observer calls back
        inner.style.transform = 'none';
        inner.innerHTML = '';
        window.google.accounts.id.renderButton(inner, {
            theme: 'outline',
            size: 'large',
            width: Math.min(Math.max(Math.round(width), 200), 400),
            text: 'continue_with',
            shape: 'rectangular'
        });
        applyGoogleScale();
    };
    // Load GIS on mount and render invisible overlay button
    (0, $bh6RR.useEffect)(()=>{
        if (!googleLoginEnabled) return;
        let observer;
        let innerObserver;
        $e2f99346c9bbe6af$var$loadGIS().then(()=>{
            const clientId = CONFIG.google_client_id;
            window.google.accounts.id.initialize({
                client_id: clientId,
                callback: handleGoogleCredential,
                use_fedcm_for_prompt: false
            });
            // Re-render on every size change. The first callback arrives once the
            // overlay has been laid out, which is what we used to miss: measuring at
            // mount gave 0 and silently fell back to a fixed 360px wide button.
            if (typeof ResizeObserver !== 'undefined' && googleOverlayRef.current && googleInnerRef.current) {
                observer = new ResizeObserver(renderGoogleButton);
                observer.observe(googleOverlayRef.current);
                // GIS injects its button asynchronously, so rescale whenever the
                // rendered size actually lands. A transform doesn't change layout size,
                // so this can't feed itself.
                innerObserver = new ResizeObserver(applyGoogleScale);
                innerObserver.observe(googleInnerRef.current);
            } else renderGoogleButton();
        }).catch((err)=>console.error('GIS load failed', err));
        return ()=>{
            observer?.disconnect();
            innerObserver?.disconnect();
        };
    }, []);
    // Load Apple Sign-In SDK on mount
    (0, $bh6RR.useEffect)(()=>{
        if (!appleLoginEnabled) return;
        $e2f99346c9bbe6af$var$loadAppleSignIn().then(()=>{
            window.AppleID.auth.init({
                clientId: CONFIG.apple_client_id,
                scope: 'name email',
                redirectURI: `${window.location.origin}/auth/apple/callback`,
                usePopup: true
            });
        }).catch((err)=>console.error('Apple Sign-In load failed', err));
    }, []);
    const handleAppleSignIn = async ()=>{
        setIsAppleLoading(true);
        setAppleError(null);
        try {
            // signIn() must be called in the same sync tick as the click to avoid
            // Safari popup blocker — run initiate in parallel, not before
            const [response] = await Promise.all([
                window.AppleID.auth.signIn(),
                (0, $135a523c4bea715f$export$925729d2b6abebca)()
            ]);
            const idToken = response.authorization.id_token;
            // Apple only sends name on first sign-in
            if (response.user?.name?.firstName) setFieldValue('firstName', response.user.name.firstName, false);
            if (response.user?.name?.lastName) setFieldValue('lastName', response.user.name.lastName, false);
            const result = await (0, $135a523c4bea715f$export$353a804191b94a80)(idToken);
            if (result.shouldConsentToMarketing !== undefined) setFieldValue('shouldConsentToMarketing', result.shouldConsentToMarketing, false);
            if (result.shouldConsentToTermsAndConditions !== undefined) setFieldValue('shouldConsentToTermsAndConditions', result.shouldConsentToTermsAndConditions, false);
            if (result.externalEmail) setFieldValue('externalEmail', result.externalEmail, false);
            if (result.userInfo?.firstName) setFieldValue('firstName', result.userInfo.firstName, false);
            if (result.userInfo?.lastName) setFieldValue('lastName', result.userInfo.lastName, false);
            const state = result.deviceActivationState;
            if (result.userId && (state === 'ACTIVATION_COMPLETE_EXISTING_USER' || state === 'ACTIVATION_COMPLETE_NEW_USER')) handleLoginComplete(result.userId);
            else if (state === 'EXTERNAL_LOGIN_COMPLETE_EXISTING_USER') {
                // Same ordering as the Google handler above — see the comment there.
                if (result.expectedActions?.includes('ADD_PHONE')) next('socialAddPhone');
                else if (result.shouldConsentToTermsAndConditions) next('acceptTerms');
                else {
                    const activation = await (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                        termsAndConditions: true
                    });
                    if (activation.userId) handleLoginComplete(activation.userId);
                }
            } else if (state === 'EXTERNAL_LOGIN_COMPLETE_NEW_USER') next('socialAddPhone');
            else {
                console.warn('[Apple] Unhandled deviceActivationState:', state, result);
                setAppleError(t('error-apple-signin-failed'));
            }
        } catch (err) {
            // User cancelled the popup — not an error
            if (err?.error === 'popup_closed_by_user' || err?.error === 'user_trigger_new_signin_flow' || err?.error === 'popup_blocked_by_browser') return;
            console.error(err);
            setAppleError(err?.response?.message || t('error-apple-signin-failed'));
        } finally{
            setIsAppleLoading(false);
        }
    };
    const isLoading = isPhoneLoading || isGoogleLoading || isAppleLoading;
    const buttons = [
        ...fullscreen ? [
            {
                func: prev,
                isBack: true
            }
        ] : [],
        {
            func: wrappedNext,
            title: t('button-continue'),
            isLoading: isPhoneLoading,
            disabled: isLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: fullscreen ? t('header-confirm-phone') : t('header-welcome')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "pb-4 flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-body-lg text-on-surface-variant m-0",
                                children: fullscreen ? t('info-confirm-phone-login') : t('info-welcome-subtitle')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "flex flex-col gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: "text-xs font-bold uppercase tracking-[0.32px] text-on-surface-variant m-0",
                                        children: t('label-phone-number')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $afc2c9aeefa09a63$export$2e2bcd8739ae039), {
                                        innerRef: inputRef,
                                        onSubmit: wrappedNext
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "phone",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            (googleLoginEnabled || appleLoginEnabled) && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "flex items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("hr", {
                                                className: "flex-1 border-0 border-t border-outline/40 m-0"
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-xs font-bold uppercase tracking-[0.32px] text-on-surface-variant whitespace-nowrap",
                                                children: t('label-or')
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("hr", {
                                                className: "flex-1 border-0 border-t border-outline/40 m-0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            googleLoginEnabled && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                                        className: "flex items-center justify-center gap-1.5 h-[50px] min-h-11 rounded-button bg-white text-black text-body-lg font-medium w-full transition-colors cursor-pointer disabled:opacity-50",
                                                        style: {
                                                            border: '1.5px solid #000'
                                                        },
                                                        type: "button",
                                                        disabled: isLoading,
                                                        "aria-label": t('button-login-google'),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                                                                width: "20",
                                                                height: "20",
                                                                viewBox: "0 0 20 20",
                                                                fill: "none",
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                                                        d: "M19.6 10.23c0-.68-.06-1.36-.18-2H10v3.79h5.4a4.6 4.6 0 0 1-2 3.03v2.5h3.22C18.5 15.77 19.6 13.2 19.6 10.23z",
                                                                        fill: "#4285F4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                                                        d: "M10 20c2.7 0 4.96-.9 6.62-2.45l-3.23-2.5c-.89.6-2.04.95-3.39.95-2.6 0-4.8-1.76-5.6-4.12H1.08v2.58A9.99 9.99 0 0 0 10 20z",
                                                                        fill: "#34A853"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                                                        d: "M4.4 11.88A5.98 5.98 0 0 1 4.08 10c0-.65.11-1.29.32-1.88V5.54H1.08A9.99 9.99 0 0 0 0 10c0 1.61.39 3.14 1.08 4.46l3.32-2.58z",
                                                                        fill: "#FBBC04"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                                                        d: "M10 3.96c1.47 0 2.79.5 3.83 1.5l2.86-2.86C14.96.9 12.7 0 10 0A9.99 9.99 0 0 0 1.08 5.54L4.4 8.12C5.2 5.72 7.4 3.96 10 3.96z",
                                                                        fill: "#EA4335"
                                                                    })
                                                                ]
                                                            }),
                                                            t('button-login-google')
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                        ref: googleOverlayRef,
                                                        className: "absolute inset-0 overflow-hidden opacity-0 cursor-pointer",
                                                        style: {
                                                            pointerEvents: isLoading ? 'none' : 'auto'
                                                        },
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                            ref: googleInnerRef,
                                                            className: "absolute top-0 left-0 origin-top-left"
                                                        })
                                                    })
                                                ]
                                            }),
                                            appleLoginEnabled && /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                                className: "flex items-center justify-center gap-1.5 h-[50px] min-h-11 rounded-button bg-white text-black text-body-lg font-medium w-full transition-colors cursor-pointer disabled:opacity-50",
                                                style: {
                                                    border: '1.5px solid #000'
                                                },
                                                type: "button",
                                                disabled: isLoading,
                                                onClick: handleAppleSignIn,
                                                "aria-label": t('button-login-apple'),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                                                        width: "17",
                                                        height: "20",
                                                        viewBox: "0 0 24 24",
                                                        fill: "currentColor",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                                                            d: "M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"
                                                        })
                                                    }),
                                                    t('button-login-apple')
                                                ]
                                            })
                                        ]
                                    }),
                                    googleError && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: "text-[13px] text-red-600 m-0",
                                        children: googleError
                                    }),
                                    appleError && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                        className: "text-[13px] text-red-600 m-0",
                                        children: appleError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-[13px] leading-5 text-center text-on-surface-variant m-0 [&_a]:font-bold [&_a]:text-inherit",
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "info-by-continuing-terms",
                                    components: {
                                        link1: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                            href: config.termsLink,
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                        })
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                fullscreen: fullscreen
            })
        ]
    });
}
$e2f99346c9bbe6af$export$2e2bcd8739ae039.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    phone: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')).min(6, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-length-phone')).max(14, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-length-phone')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-phone'))
});



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");








function $e12f6ca7761957b6$export$2e2bcd8739ae039({ fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const inputRef = (0, $bh6RR.useRef)();
    const { reset: reset, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, initialValues: initialValues, setFieldValue: setFieldValue, setFieldError: setFieldError, setFieldTouched: setFieldTouched } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [isButtonDisabled, setButtonDisabled] = (0, $bh6RR.useState)(true);
    const [isButtonLoading, setButtonIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const wrappedReset = ()=>{
        for (const [key, value] of Object.entries(initialValues))setFieldValue(key, value, false);
        reset();
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$1836188376808b25)(values.phoneCode).then((response)=>{
            if (response?.deviceActivationState === 'PHONE_OTP_COMPLETE_EXISTING_DEVICE') {
                if (response.expectedActions?.includes('SELECT_EMAIL')) {
                    if (response.externalEmail) setFieldValue('externalEmail', response.externalEmail, false);
                    if (response.userInfo?.firstName) setFieldValue('firstName', response.userInfo.firstName, false);
                    setFieldValue('maskedEmail', response.maskedEmail || '', false);
                    next('socialSelectEmail');
                } else {
                    (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                        termsAndConditions: true
                    }).then((activation)=>{
                        if (activation.userId) {
                            loginAndFetchBookings(activation.userId);
                            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                            parentContext?.next();
                        }
                    }).catch((error)=>setFieldError('phoneCode', error?.response?.message)).finally(()=>setIsLoading(false));
                    return;
                }
            } else if (response?.deviceActivationState === 'ACTIVATION_COMPLETE_EXISTING_USER' || response?.deviceActivationState === 'ACTIVATION_COMPLETE_NEW_USER') {
                if (response.userId) {
                    loginAndFetchBookings(response.userId);
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                    parentContext?.next();
                } else setFieldError('phoneCode', t('error-phone-verify-failed'));
                return;
            } else if (response?.deviceActivationState === 'PHONE_OTP_COMPLETE_NEW_USER') next('inputEmail');
            else if (response?.deviceActivationState === 'EMAIL_OTP_INITIATED') {
                setFieldValue('maskedEmail', response.maskedEmail);
                next('validateEmail');
            }
        }).catch((error)=>{
            console.error(error);
            setFieldError('phoneCode', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const makeNewRequest = ()=>{
        setButtonIsLoading(true);
        (0, $135a523c4bea715f$export$67faf1bc20afbc8d)().then((response)=>{
            setFieldValue('phoneCode', '');
            inputRef.current?.focus();
        }).catch((error)=>{
            console.error(error);
            setFieldTouched('phoneCode', true, true);
            // NOTE: Workaround to force the field to show the error
            setTimeout(()=>setFieldError('phoneCode', error?.response?.message), 100);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setButtonIsLoading(false);
            setButtonDisabled(true);
        });
    };
    const buttons = [
        {
            func: wrappedReset,
            isBack: true
        },
        {
            func: makeNewRequest,
            title: t('button-did-not-get-code'),
            disabled: isButtonDisabled || activationBadState,
            isLoading: isButtonLoading
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        let timeoutId;
        if (isButtonDisabled) timeoutId = setTimeout(()=>setButtonDisabled(false), 5000);
        return ()=>clearTimeout(timeoutId);
    }, [
        isButtonDisabled
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (values.phoneCode.length === 4) makeRequest();
    }, [
        values.phoneCode
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading || isButtonLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        isLoading: isLoading,
                        children: t('header-enter-your-code')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                        name: "phoneCode",
                                        inputRef: inputRef,
                                        component: (0, $06bd433d73a68758$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "phoneCode",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$export$b84494756f225a7d,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                    i18nKey: "info-enter-the-code-sent-to",
                                    values: {
                                        dialCode: values.dialCode,
                                        phone: values.phone
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading || isButtonLoading,
                fullscreen: fullscreen
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









const $cf0f1ff2adb2601d$var$InputEmail = ({ fullscreen: fullscreen })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { reset: reset, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { values: values, initialValues: initialValues, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const wrappedReset = ()=>{
        for (const [key, value] of Object.entries(initialValues))setFieldValue(key, value, false);
        reset();
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$56c422d8d4a8ba98)(values.email).then((response)=>{
            if (response?.deviceActivationState === 'EMAIL_ADDED') next('inputName');
            else if (response?.deviceActivationState === 'EMAIL_OTP_INITIATED') {
                setFieldValue('maskedEmail', response.maskedEmail);
                next('validateEmail');
            }
        }).catch((error)=>{
            console.error(error);
            setFieldError('email', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    const buttons = [
        {
            func: wrappedReset,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue'),
            disabled: activationBadState,
            isLoading: isLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-enter-your-email')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "email",
                                placeholder: t('placeholder-enter-your-email'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$export$b84494756f225a7d,
                                children: t('info-we-use-your-email')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                fullscreen: fullscreen
            })
        ]
    });
};
$cf0f1ff2adb2601d$var$InputEmail.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    email: $a0206caf38308288$export$185802fd694ee1f5().email((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-invalid-email')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-email'))
});
var $cf0f1ff2adb2601d$export$2e2bcd8739ae039 = $cf0f1ff2adb2601d$var$InputEmail;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









function $2f309c3398f4225a$export$2e2bcd8739ae039({ fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const inputRef = (0, $bh6RR.useRef)();
    const { reset: reset, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, initialValues: initialValues, setFieldValue: setFieldValue, setFieldError: setFieldError, setFieldTouched: setFieldTouched } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [isButtonDisabled, setButtonDisabled] = (0, $bh6RR.useState)(true);
    const [isButtonLoading, setButtonIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    // NOTE: Reset code when switching views
    const wrappedNext = (id)=>{
        setFieldValue('emailCode', '');
        next(id);
    };
    const wrappedReset = ()=>{
        for (const [key, value] of Object.entries(initialValues))setFieldValue(key, value, false);
        reset();
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$9266817a7ac678fe)(values.emailCode).then((response)=>{
            if (response?.deviceActivationState === 'ACTIVATION_COMPLETE_EXISTING_USER') {
                loginAndFetchBookings(response.userId);
                (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                parentContext?.next();
                return;
            }
            if (response?.deviceActivationState === 'EMAIL_OTP_COMPLETE') {
                if (response.expectedActions?.includes('COMPLETE_ACTIVATION')) {
                    (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                        termsAndConditions: true
                    }).then((activation)=>{
                        if (activation.userId) {
                            loginAndFetchBookings(activation.userId);
                            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                            parentContext?.next();
                        }
                    }).catch((error)=>setFieldError('emailCode', error?.response?.message)).finally(()=>setIsLoading(false));
                    return;
                }
                if (response.userId) {
                    loginAndFetchBookings(response.userId);
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                    parentContext?.next();
                }
            }
        }).catch((error)=>{
            console.error(error);
            setFieldError('emailCode', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const makeNewRequest = ()=>{
        setButtonIsLoading(true);
        (0, $135a523c4bea715f$export$7738159be2c9b2bf)().then((response)=>{
            setFieldValue('emailCode', '');
            inputRef.current?.focus();
        }).catch((error)=>{
            console.error(error);
            setFieldTouched('emailCode', true, true);
            // NOTE: Workaround to force the field to show the error
            setTimeout(()=>setFieldError('emailCode', error?.response?.message), 100);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setButtonIsLoading(false);
            setButtonDisabled(true);
        });
    };
    const useOtherEmail = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(t('change-email-message'), [
            {
                title: COPY.booking.button_ok,
                callback: ()=>wrappedNext('inputEmail')
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    const buttons = [
        {
            func: wrappedReset,
            isBack: true
        },
        {
            func: useOtherEmail,
            title: t('button-select-other-email'),
            disabled: activationBadState
        },
        {
            func: makeNewRequest,
            title: t('button-did-not-get-code'),
            disabled: isButtonDisabled || activationBadState,
            isLoading: isButtonLoading
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        let timeoutId;
        if (isButtonDisabled) timeoutId = setTimeout(()=>setButtonDisabled(false), 5000);
        return ()=>clearTimeout(timeoutId);
    }, [
        isButtonDisabled
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (values.emailCode.length === 4) makeRequest();
    }, [
        values.emailCode
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading || isButtonLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-welcome-back')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: $f35967c56a9f3d99$export$f59aa6be2711b90,
                                children: t('info-your-phone-is-linked', {
                                    maskedEmail: values.maskedEmail
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $f35967c56a9f3d99$export$f59aa6be2711b90,
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                        name: "emailCode",
                                        inputRef: inputRef,
                                        component: (0, $06bd433d73a68758$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "emailCode",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading || isButtonLoading,
                fullscreen: fullscreen
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");












const $f711080ef67fa6b9$var$InputName = ({ fullscreen: fullscreen })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { reset: reset, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, initialValues: initialValues, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const wrappedReset = ()=>{
        for (const [key, value] of Object.entries(initialValues))setFieldValue(key, value, false);
        reset();
    };
    const handleLoginComplete = (userId)=>{
        loginAndFetchBookings(userId);
        if (fullscreen) parentContext?.next('confirm');
        else (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$d04c19dd275cdbbd)(values.firstName, values.lastName).then((response)=>{
            const state = response?.deviceActivationState;
            if (state === 'ACTIVATION_COMPLETE_NEW_USER' || state === 'ACTIVATION_COMPLETE_EXISTING_USER') {
                // Session already complete on server — login directly, do not call /complete
                if (response.shouldConsentToMarketing !== undefined) setFieldValue('shouldConsentToMarketing', response.shouldConsentToMarketing, false);
                if (response.shouldConsentToTermsAndConditions !== undefined) setFieldValue('shouldConsentToTermsAndConditions', response.shouldConsentToTermsAndConditions, false);
                if (response.shouldConsentToTermsAndConditions) next('acceptTerms');
                else if (response.userId) {
                    (0, $ee4f9bead648b485$export$6b2a7d5132615086)('confirmRegistration', {
                        userId: response.userId
                    });
                    handleLoginComplete(response.userId);
                }
            } else if (state === 'NAME_ADDED') {
                (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                    termsAndConditions: true
                }).then((activation)=>{
                    if (activation.userId) {
                        (0, $ee4f9bead648b485$export$6b2a7d5132615086)('confirmRegistration', {
                            userId: activation.userId
                        });
                        handleLoginComplete(activation.userId);
                    }
                }).catch((error)=>setFieldError('firstName', error?.response?.message)).finally(()=>setIsLoading(false));
                return;
            }
        }).catch((error)=>{
            console.error(error);
            setFieldError('firstName', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    const buttons = [
        {
            func: wrappedReset,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue'),
            disabled: activationBadState,
            isLoading: isLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-enter-name')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$export$f59aa6be2711b90,
                                children: t('info-driver-confirm-pickup')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "firstName",
                                placeholder: t('placeholder-firstname'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "lastName",
                                placeholder: t('placeholder-lastname'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                fullscreen: fullscreen
            })
        ]
    });
};
$f711080ef67fa6b9$var$InputName.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    firstName: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-firstname')),
    lastName: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-lastname'))
});
var $f711080ef67fa6b9$export$2e2bcd8739ae039 = $f711080ef67fa6b9$var$InputName;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");





var $474bcfd54f1611e3$export$32180ef41b15b513;
var $474bcfd54f1611e3$export$cc74dcc53cfce4eb;
$474bcfd54f1611e3$export$32180ef41b15b513 = `XU-nOG_body`;
$474bcfd54f1611e3$export$cc74dcc53cfce4eb = `XU-nOG_wrapper`;



function $7d4acd3ee9d93151$export$2e2bcd8739ae039({ isLogin: isLogin, fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { reset: reset, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { values: values, initialValues: initialValues, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const { config: config, loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const switchRef = (0, $bh6RR.useRef)();
    const wrappedReset = ()=>{
        for (const [key, value] of Object.entries(initialValues))setFieldValue(key, value, false);
        reset();
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        const obj = {
            termsAndConditions: values.termsAndConditions
        };
        if (values.shouldConsentToMarketing) obj.marketingOptIn = values.marketingOptIn;
        (0, $135a523c4bea715f$export$f3fd28dd107273ce)(obj).then((response)=>{
            if (response.userId && (response?.deviceActivationState === 'ACTIVATION_COMPLETE_EXISTING_USER' || response?.deviceActivationState === 'ACTIVATION_COMPLETE_NEW_USER')) {
                loginAndFetchBookings(response.userId);
                if (isLogin) {
                    next();
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                } else parentContext.prev(); // Go back to SelectHow if this is triggered in the booking module flow
            } else console.error('Error!');
        }).catch((error)=>{
            console.error(error);
            setFieldError('termsAndConditions', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const buttons = [
        {
            func: wrappedReset,
            isBack: true
        },
        {
            func: makeRequest,
            title: t('button-confirm'),
            disabled: values.termsAndConditions === false || activationBadState,
            isLoading: isLoading
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        if (switchRef.current) switchRef.current.focus();
    }, [
        switchRef
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-terms-and-conditions')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: $474bcfd54f1611e3$export$32180ef41b15b513,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                            i18nKey: "info-accept-terms",
                            components: {
                                link1: /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                                    href: config.termsLink,
                                    target: "_blank"
                                })
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $474bcfd54f1611e3$export$cc74dcc53cfce4eb,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                        name: "termsAndConditions",
                                        title: t('title-accept-terms'),
                                        innerRef: switchRef,
                                        component: (0, $1a524575b258b4c5$export$2e2bcd8739ae039),
                                        alternateBackground: fullscreen
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "termsAndConditions",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            values.shouldConsentToMarketing && /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "marketingOptIn",
                                title: t('title-accept-marketing'),
                                component: (0, $1a524575b258b4c5$export$2e2bcd8739ae039),
                                alternateBackground: fullscreen
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                fullscreen: fullscreen
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









function $313a05dd87b8b311$export$2e2bcd8739ae039({ fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const inputRef = (0, $bh6RR.useRef)();
    const handleLoginComplete = (userId)=>{
        loginAndFetchBookings(userId);
        if (fullscreen) parentContext?.next('confirm');
        else (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$fca1fd251061bfc4)(values.dialCode, values.phone).then((response)=>{
            const state = response?.deviceActivationState;
            if (state === 'PHONE_OTP_INITIATED' || state === 'UPDATE_PHONE_OTP_INITIATED') next('socialValidatePhone');
            else if (state === 'ACTIVATION_COMPLETE_EXISTING_USER' || state === 'ACTIVATION_COMPLETE_NEW_USER') // Session is fully complete on the server — calling /complete again would fail.
            // Login directly with the userId we already have.
            {
                if (response.userId) handleLoginComplete(response.userId);
            } else if (state === 'EXTERNAL_LOGIN_COMPLETE_EXISTING_USER' || state === 'EXTERNAL_LOGIN_COMPLETE_NEW_USER') {
                // Session needs explicit completion; consent flags and expected actions determine routing.
                if (response.shouldConsentToMarketing !== undefined) setFieldValue('shouldConsentToMarketing', response.shouldConsentToMarketing, false);
                if (response.shouldConsentToTermsAndConditions !== undefined) setFieldValue('shouldConsentToTermsAndConditions', response.shouldConsentToTermsAndConditions, false);
                if (response.userInfo?.firstName) setFieldValue('firstName', response.userInfo.firstName, false);
                if (response.userInfo?.lastName) setFieldValue('lastName', response.userInfo.lastName, false);
                if (response.expectedActions?.includes('ADD_NAME')) next('inputName');
                else if (response.shouldConsentToTermsAndConditions) next('acceptTerms');
                else if (response.userId) handleLoginComplete(response.userId);
            }
        }).catch((error)=>{
            setFieldError('phone', error?.response?.message);
        }).finally(()=>setIsLoading(false));
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    (0, $bh6RR.useEffect)(()=>{
        if (inputRef.current) inputRef.current.focus();
    }, [
        inputRef
    ]);
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue'),
            isLoading: isLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-add-phone-social')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "pb-4 flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $afc2c9aeefa09a63$export$2e2bcd8739ae039), {
                                innerRef: inputRef,
                                onSubmit: wrappedNext
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                name: "phone",
                                component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-body-lg text-on-surface-variant m-0",
                                children: t('info-add-phone-social')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                fullscreen: fullscreen
            })
        ]
    });
}
$313a05dd87b8b311$export$2e2bcd8739ae039.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    phone: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')).min(6, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-length-phone')).max(14, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-length-phone')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-phone'))
});



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");






function $1f01605bcc1665ea$export$2e2bcd8739ae039({ fullscreen: fullscreen }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const inputRef = (0, $bh6RR.useRef)();
    const { prev: prev, next: next, parentContext: parentContext } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError, setFieldTouched: setFieldTouched } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [isResendDisabled, setIsResendDisabled] = (0, $bh6RR.useState)(true);
    const [isResendLoading, setIsResendLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const handleLoginComplete = (userId)=>{
        loginAndFetchBookings(userId);
        if (fullscreen) parentContext?.next('confirm');
        else (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
    };
    // Marketing consent is asked after login by MarketingConsentModal, so only an
    // outstanding terms consent still needs the acceptTerms screen mid-flow.
    const needsConsent = ()=>values.shouldConsentToTermsAndConditions;
    const completeIfNeeded = (onDone)=>{
        if (needsConsent()) {
            next('acceptTerms');
            return;
        }
        if (onDone) {
            onDone();
            return;
        }
        // Nothing left to ask for, so finish the activation here — without this the
        // flow would silently stall on this screen. Returned so the caller's promise
        // chain keeps the spinner up until it resolves.
        return (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
            termsAndConditions: true
        }).then((activation)=>{
            if (activation.userId) handleLoginComplete(activation.userId);
        }).catch((error)=>setFieldError('phoneCode', error?.response?.message));
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$1836188376808b25)(values.phoneCode).then((response)=>{
            if (response?.shouldConsentToMarketing !== undefined) setFieldValue('shouldConsentToMarketing', response.shouldConsentToMarketing, false);
            const state = response?.deviceActivationState;
            if (state === 'PHONE_OTP_COMPLETE_NEW_USER') next('inputName');
            else if (state === 'PHONE_OTP_COMPLETE_UPDATED_USER') {
                if (response.userInfo) {
                    setFieldValue('existingUserName', `${response.userInfo.firstName || ''} ${response.userInfo.lastName || ''}`.trim(), false);
                    setFieldValue('existingUserEmail', response.userInfo.email || response.maskedEmail || '', false);
                } else if (response.maskedEmail) setFieldValue('existingUserEmail', response.maskedEmail, false);
                next('confirmExistingProfile');
            } else if (state === 'PHONE_OTP_COMPLETE_EXISTING_DEVICE') {
                if (response.expectedActions?.includes('SELECT_EMAIL')) {
                    if (response.externalEmail) setFieldValue('externalEmail', response.externalEmail, false);
                    setFieldValue('maskedEmail', response.maskedEmail || '', false);
                    next('socialSelectEmail');
                } else if (response.expectedActions?.includes('ADD_EMAIL') && values.externalEmail) {
                    (0, $135a523c4bea715f$export$56c422d8d4a8ba98)(values.externalEmail).then((activation)=>{
                        if (activation.userId) handleLoginComplete(activation.userId);
                        else if (activation.deviceActivationState === 'EMAIL_OTP_INITIATED') {
                            setFieldValue('maskedEmail', activation.maskedEmail || '', false);
                            next('validateEmail');
                        } else return completeIfNeeded();
                    }).catch((error)=>setFieldError('phoneCode', error?.response?.message)).finally(()=>setIsLoading(false));
                    return;
                } else return completeIfNeeded();
            } else if (state === 'ACTIVATION_COMPLETE_EXISTING_USER') handleLoginComplete(response.userId);
            else if (response?.success === true) {
                if (response.userId) handleLoginComplete(response.userId);
                else return completeIfNeeded();
            } else if (state === 'EMAIL_OTP_INITIATED') {
                setFieldValue('maskedEmail', response.maskedEmail, false);
                next('validateEmail');
            }
        }).catch((error)=>{
            setFieldError('phoneCode', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>setIsLoading(false));
    };
    const handleResend = ()=>{
        setIsResendLoading(true);
        (0, $135a523c4bea715f$export$67faf1bc20afbc8d)().then(()=>{
            setFieldValue('phoneCode', '');
            inputRef.current?.focus();
        }).catch((error)=>{
            setFieldTouched('phoneCode', true, true);
            setTimeout(()=>setFieldError('phoneCode', error?.response?.message), 100);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>{
            setIsResendLoading(false);
            setIsResendDisabled(true);
        });
    };
    (0, $bh6RR.useEffect)(()=>{
        let id;
        if (isResendDisabled) id = setTimeout(()=>setIsResendDisabled(false), 5000);
        return ()=>clearTimeout(id);
    }, [
        isResendDisabled
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (values.phoneCode.length === 4) makeRequest();
    }, [
        values.phoneCode
    ]);
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: handleResend,
            title: t('button-did-not-get-code'),
            disabled: isResendDisabled || activationBadState,
            isLoading: isResendLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading || isResendLoading,
                fullscreen: fullscreen,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        isLoading: isLoading,
                        children: t('header-enter-your-code')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "pb-4 flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                        name: "phoneCode",
                                        inputRef: inputRef,
                                        component: (0, $06bd433d73a68758$export$2e2bcd8739ae039)
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "phoneCode",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-body-lg text-on-surface-variant m-0",
                                children: t('info-enter-code-sent-social', {
                                    dialCode: values.dialCode,
                                    phone: values.phone
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading || isResendLoading,
                fullscreen: fullscreen
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");






const $dbfc10e7606e003e$var$UserIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
function $dbfc10e7606e003e$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldError: setFieldError, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const existingName = values.existingUserName || '';
    const existingEmail = values.existingUserEmail || '';
    const handleUseExisting = ()=>{
        if (existingEmail) setFieldValue('maskedEmail', existingEmail, false);
        // Server sends email OTP to the existing email — navigate to validate it
        next('validateEmail');
    };
    const handleCreateNew = ()=>{
        // Drop the matched profile's name before creating a separate one. By this point
        // firstName/lastName can hold the name of the profile that already owns this phone
        // number — SocialAddPhone and SelectMethod both copy them out of the response's
        // userInfo — and InputName renders straight from these fields, so the old name would
        // be pre-filled and saved onto the new profile.
        setFieldValue('firstName', '', false);
        setFieldValue('lastName', '', false);
        // Use the social login email for a new profile instead
        const googleEmail = values.externalEmail;
        if (!googleEmail) {
            next('inputName');
            return;
        }
        setIsLoading(true);
        (0, $135a523c4bea715f$export$56c422d8d4a8ba98)(googleEmail).then((response)=>{
            const actions = response?.expectedActions || [];
            if (response?.userId) (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                termsAndConditions: true
            }).then((a)=>{
                if (a.userId) {
                    loginAndFetchBookings(a.userId);
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                }
            }).catch((err)=>setFieldError('email', err?.response?.message));
            else if (response?.deviceActivationState === 'EMAIL_OTP_INITIATED') {
                setFieldValue('maskedEmail', response.maskedEmail, false);
                next('validateEmail');
            } else if (response?.deviceActivationState === 'EMAIL_ADDED') {
                if (actions.includes('ADD_NAME')) next('inputName');
                else (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                    termsAndConditions: true
                }).then((a)=>{
                    if (a.userId) {
                        loginAndFetchBookings(a.userId);
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                    }
                }).catch((err)=>setFieldError('email', err?.response?.message));
            }
        }).catch((error)=>{
            setFieldError('email', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>setIsLoading(false));
    };
    const buttons = [
        {
            func: handleCreateNew,
            title: t('button-create-new-account'),
            disabled: isLoading || activationBadState
        },
        {
            func: handleUseExisting,
            title: t('button-login'),
            disabled: isLoading || activationBadState
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "pt-6 pb-4 flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                    className: "text-[18px] font-bold tracking-[0.54px] m-0",
                                    children: existingName ? t('header-login-as', {
                                        name: existingName
                                    }) : t('header-is-this-you')
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "text-body-lg text-on-surface m-0",
                                    children: t('info-existing-account-found')
                                })
                            ]
                        }),
                        (existingName || existingEmail) && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex items-center gap-3 py-1",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "bg-surface-container p-1 rounded-[24px] shrink-0",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "flex items-center justify-center w-6 h-6 text-on-surface-variant",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($dbfc10e7606e003e$var$UserIcon, {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex flex-col gap-0.5 min-w-0",
                                    children: [
                                        existingName && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: "text-body-lg font-medium text-on-surface tracking-[-0.34px] m-0 truncate",
                                            children: existingName
                                        }),
                                        existingEmail && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: "text-body-lg text-on-surface-variant m-0 truncate",
                                            children: existingEmail
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");






const $f3175d49746face5$var$UserIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "12",
                cy: "7",
                r: "4"
            })
        ]
    });
function $f3175d49746face5$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { loginAndFetchBookings: loginAndFetchBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    const [localError, setLocalError] = (0, $bh6RR.useState)(null);
    const completeLogin = ()=>{
        (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
            termsAndConditions: true
        }).then((a)=>{
            if (a.userId) {
                loginAndFetchBookings(a.userId);
                (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
            }
        }).catch((err)=>setLocalError(err?.response?.message));
    };
    const handleResponse = (response)=>{
        if (response?.deviceActivationState === 'EMAIL_OTP_INITIATED') {
            setFieldValue('maskedEmail', response.maskedEmail || values.maskedEmail, false);
            next('validateEmail');
        } else completeLogin();
    };
    const handleUseExisting = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$56c422d8d4a8ba98)(values.maskedEmail).then(handleResponse).catch((error)=>{
            setFieldError('email', error?.response?.message);
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>setIsLoading(false));
    };
    const handleNotMe = ()=>{
        // Same reason as in ConfirmExistingProfile: firstName/lastName may hold the matched
        // profile's name — ValidatePhone copies firstName out of the response's userInfo on
        // the way to this screen — and InputName renders from these fields, so without this
        // the other person's name is pre-filled and saved onto the new profile.
        setFieldValue('firstName', '', false);
        setFieldValue('lastName', '', false);
        const googleEmail = values.externalEmail;
        if (!googleEmail) {
            setLocalError('No external email available');
            return;
        }
        setIsLoading(true);
        setLocalError(null);
        (0, $135a523c4bea715f$export$56c422d8d4a8ba98)(googleEmail).then((response)=>{
            const actions = response?.expectedActions || [];
            if (response?.userId) completeLogin();
            else if (response?.deviceActivationState === 'EMAIL_OTP_INITIATED') {
                setFieldValue('maskedEmail', response.maskedEmail || '', false);
                next('validateEmail');
            } else if (response?.deviceActivationState === 'EMAIL_ADDED') {
                if (actions.includes('ADD_NAME')) next('inputName');
                else (0, $135a523c4bea715f$export$f3fd28dd107273ce)({
                    termsAndConditions: true
                }).then((a)=>{
                    if (a.userId) {
                        loginAndFetchBookings(a.userId);
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', false);
                    }
                }).catch((err)=>setLocalError(err?.response?.message));
            } else {
                console.warn('[SocialSelectEmail] Unhandled state:', response?.deviceActivationState, actions);
                setLocalError(`Unhandled state: ${response?.deviceActivationState}`);
            }
        }).catch((error)=>{
            console.error('[SocialSelectEmail] handleNotMe error:', error);
            setLocalError(error?.response?.message || error?.message || 'Unknown error');
            if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
        }).finally(()=>setIsLoading(false));
    };
    const displayName = values.firstName || values.maskedEmail;
    const buttons = [
        {
            func: handleNotMe,
            title: t('button-create-new-account'),
            disabled: isLoading || activationBadState
        },
        {
            func: handleUseExisting,
            title: t('button-login'),
            disabled: isLoading || activationBadState
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "pt-6 pb-4 flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex flex-col gap-1",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                    className: "text-[18px] font-bold tracking-[0.54px] m-0",
                                    children: displayName ? t('header-login-as', {
                                        name: displayName
                                    }) : t('header-is-this-you')
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "text-body-lg text-on-surface m-0",
                                    children: t('info-existing-account-found')
                                })
                            ]
                        }),
                        (values.firstName || values.maskedEmail) && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "flex items-center gap-3 py-1",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: "bg-surface-container p-1 rounded-[24px] shrink-0",
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "flex items-center justify-center w-6 h-6 text-on-surface-variant",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)($f3175d49746face5$var$UserIcon, {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: "flex flex-col gap-0.5 min-w-0",
                                    children: [
                                        values.firstName && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: "text-body-lg font-medium text-on-surface tracking-[-0.34px] m-0 truncate",
                                            children: values.firstName
                                        }),
                                        values.maskedEmail && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                            className: "text-body-lg text-on-surface-variant m-0 truncate",
                                            children: values.maskedEmail
                                        })
                                    ]
                                })
                            ]
                        }),
                        localError && /*#__PURE__*/ (0, $ih19M.jsx)((0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039), {
                            children: localError
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading
            })
        ]
    });
}


var $50a7b49ba283afed$exports = {};

$parcel$export($50a7b49ba283afed$exports, "isOpen", function () { return $50a7b49ba283afed$export$ea0830439c7fc698; }, function (v) { return $50a7b49ba283afed$export$ea0830439c7fc698 = v; });
$parcel$export($50a7b49ba283afed$exports, "overlay", function () { return $50a7b49ba283afed$export$29dd17c7f3c81c36; }, function (v) { return $50a7b49ba283afed$export$29dd17c7f3c81c36 = v; });
$parcel$export($50a7b49ba283afed$exports, "wrapper", function () { return $50a7b49ba283afed$export$cc74dcc53cfce4eb; }, function (v) { return $50a7b49ba283afed$export$cc74dcc53cfce4eb = v; });
var $50a7b49ba283afed$export$ea0830439c7fc698;
var $50a7b49ba283afed$export$29dd17c7f3c81c36;
var $50a7b49ba283afed$export$cc74dcc53cfce4eb;
$50a7b49ba283afed$export$ea0830439c7fc698 = `pR4fgW_isOpen`;
$50a7b49ba283afed$export$29dd17c7f3c81c36 = `pR4fgW_overlay`;
$50a7b49ba283afed$export$cc74dcc53cfce4eb = `pR4fgW_wrapper`;



const $ff450cbdbee3675c$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($50a7b49ba283afed$exports);
function $ff450cbdbee3675c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [completeCallback, setCompleteCallback] = (0, $bh6RR.useState)(null);
    const [startView, setStartView] = (0, $bh6RR.useState)(null);
    const views = [
        {
            id: 'selectMethod',
            component: (0, $e2f99346c9bbe6af$export$2e2bcd8739ae039)
        },
        {
            id: 'validatePhone',
            component: (0, $e12f6ca7761957b6$export$2e2bcd8739ae039)
        },
        {
            id: 'inputEmail',
            component: (0, $cf0f1ff2adb2601d$export$2e2bcd8739ae039)
        },
        {
            id: 'validateEmail',
            component: (0, $2f309c3398f4225a$export$2e2bcd8739ae039)
        },
        {
            id: 'inputName',
            component: (0, $f711080ef67fa6b9$export$2e2bcd8739ae039)
        },
        {
            id: 'acceptTerms',
            component: (0, $7d4acd3ee9d93151$export$2e2bcd8739ae039),
            props: {
                isLogin: true
            }
        },
        {
            id: 'socialAddPhone',
            component: (0, $313a05dd87b8b311$export$2e2bcd8739ae039)
        },
        {
            id: 'socialValidatePhone',
            component: (0, $1f01605bcc1665ea$export$2e2bcd8739ae039)
        },
        {
            id: 'confirmExistingProfile',
            component: (0, $dbfc10e7606e003e$export$2e2bcd8739ae039)
        },
        {
            id: 'socialSelectEmail',
            component: (0, $f3175d49746face5$export$2e2bcd8739ae039)
        }
    ];
    const initialValues = {
        dialCode: '+46',
        phone: '',
        phoneCode: '',
        email: '',
        maskedEmail: '',
        emailCode: '',
        firstName: '',
        lastName: '',
        marketingOptIn: false,
        termsAndConditions: false,
        shouldConsentToMarketing: true,
        shouldConsentToTermsAndConditions: true,
        externalEmail: '',
        existingUserName: '',
        existingUserEmail: ''
    };
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('SHOW_LOGIN', (data)=>{
        const show = data === null || data?.show === true;
        if (show && data?.callback) setCompleteCallback(()=>data.callback);
        else setCompleteCallback(null);
        if (show && data?.startView) setStartView(data.startView);
        else setStartView(null);
        setIsOpen(show);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $ff450cbdbee3675c$var$cx($50a7b49ba283afed$exports.overlay, {
            isOpen: isOpen
        }),
        children: isOpen && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: $50a7b49ba283afed$exports.wrapper,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$2e2bcd8739ae039), {
                views: views,
                complete: completeCallback,
                initialView: startView,
                onBack: ()=>setIsOpen(false),
                children: ({ View: View })=>{
                    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
                        initialValues: initialValues,
                        validationSchema: View?.validationSchema || null,
                        onReset: ()=>{
                            setIsOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$b2d7bc9e68dacbc), {}),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $247ae7f4639f55fe$export$2e2bcd8739ae039), {
                                    message: t('reset-login-message')
                                })
                            ]
                        })
                    });
                }
            })
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");




var $3af171330cdb8a96$export$32180ef41b15b513;
$3af171330cdb8a96$export$32180ef41b15b513 = `RI3whG_body`;


function $e41d0db0a1294d0c$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, setUser: setUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    if (!user?.shouldConsentToMarketing) return null;
    const handleConsent = (consent)=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$87808cfd18c2bb49)(user.userId, consent).then((response)=>setUser(response)).catch(()=>setUser({
                ...user,
                shouldConsentToMarketing: false
            })).finally(()=>setIsLoading(false));
    };
    const buttons = [
        {
            func: ()=>handleConsent(false),
            title: t('marketing-consent-no'),
            isLoading: isLoading
        },
        {
            func: ()=>handleConsent(true),
            title: t('marketing-consent-yes'),
            isLoading: isLoading
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('marketing-consent-title')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: $3af171330cdb8a96$export$32180ef41b15b513,
                        children: t('marketing-consent-body')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading,
                modal: true
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");



var $bh6RR = parcelRequire("bh6RR");


var $ih19M = parcelRequire("ih19M");
/**
 * @param {string|RegExp} input The route pattern
 * @param {boolean} [loose] Allow open-ended matching. Ignored with `RegExp` input.
 */ function $a4301ecae062d975$export$98e6a39c04603d36(input, loose) {
    if (input instanceof RegExp) return {
        keys: false,
        pattern: input
    };
    var c, o, tmp, ext, keys = [], pattern = '', arr = input.split('/');
    arr[0] || arr.shift();
    while(tmp = arr.shift()){
        c = tmp[0];
        if (c === '*') {
            keys.push(c);
            pattern += tmp[1] === '?' ? '(?:/(.*))?' : '/(.*)';
        } else if (c === ':') {
            o = tmp.indexOf('?', 1);
            ext = tmp.indexOf('.', 1);
            keys.push(tmp.substring(1, !!~o ? o : !!~ext ? ext : tmp.length));
            pattern += !!~o && !~ext ? '(?:/([^/]+?))?' : '/([^/]+?)';
            if (!!~ext) pattern += (!!~o ? '?' : '') + '\\' + tmp.substring(ext);
        } else pattern += '/' + tmp;
    }
    return {
        keys: keys,
        pattern: new RegExp('^' + pattern + (loose ? '(?=$|\/)' : '\/?$'), 'i')
    };
}
var $a4301ecae062d975$var$RGX = /(\/|^)([:*][^/]*?)(\?)?(?=[/.]|$)/g;
function $a4301ecae062d975$export$a976684a0efeb93f(route, values) {
    return route.replace($a4301ecae062d975$var$RGX, (x, lead, key, optional)=>{
        x = values[key == '*' ? key : key.substring(1)];
        return x ? '/' + x : optional || key == '*' ? '' : '/' + key;
    });
}



var $bh6RR = parcelRequire("bh6RR");
var $d0e6e094f08343c4$exports = {};
'use strict';

$d0e6e094f08343c4$exports = (parcelRequire("1JHgz"));




// React.useInsertionEffect is not available in React <18
// This hack fixes a transpilation issue on some apps
const $7c547a065d4f8a42$var$useBuiltinInsertionEffect = $bh6RR.useInsertionEffect;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $7c547a065d4f8a42$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $7c547a065d4f8a42$export$700979bc83e7db82 = $7c547a065d4f8a42$var$canUseDOM ? $bh6RR.useLayoutEffect : $bh6RR.useEffect;
const $7c547a065d4f8a42$export$aaabe4eda9ed9969 = $7c547a065d4f8a42$var$useBuiltinInsertionEffect || $7c547a065d4f8a42$export$700979bc83e7db82;
const $7c547a065d4f8a42$export$90fc3a17d93f704c = (fn)=>{
    const ref = $bh6RR.useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $7c547a065d4f8a42$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $718230fb41ec7306$var$eventPopstate = "popstate";
const $718230fb41ec7306$var$eventPushState = "pushState";
const $718230fb41ec7306$var$eventReplaceState = "replaceState";
const $718230fb41ec7306$var$eventHashchange = "hashchange";
const $718230fb41ec7306$var$events = [
    $718230fb41ec7306$var$eventPopstate,
    $718230fb41ec7306$var$eventPushState,
    $718230fb41ec7306$var$eventReplaceState,
    $718230fb41ec7306$var$eventHashchange
];
const $718230fb41ec7306$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $718230fb41ec7306$var$events)addEventListener(event, callback);
    return ()=>{
        for (const event of $718230fb41ec7306$var$events)removeEventListener(event, callback);
    };
};
const $718230fb41ec7306$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $d0e6e094f08343c4$exports.useSyncExternalStore)($718230fb41ec7306$var$subscribeToLocationUpdates, fn, ssrFn);
const $718230fb41ec7306$var$currentSearch = ()=>location.search;
const $718230fb41ec7306$export$bd221a7c56b93941 = ({ ssrSearch: ssrSearch } = {})=>$718230fb41ec7306$export$3a1ff78c39f8a86($718230fb41ec7306$var$currentSearch, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrSearch="?foo",
    // client hydrates with just <Router /> and reads from location.search
    ssrSearch != null ? ()=>ssrSearch : $718230fb41ec7306$var$currentSearch);
const $718230fb41ec7306$var$currentPathname = ()=>location.pathname;
const $718230fb41ec7306$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$718230fb41ec7306$export$3a1ff78c39f8a86($718230fb41ec7306$var$currentPathname, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrPath="/foo",
    // client hydrates with just <Router /> and reads from location.pathname
    ssrPath != null ? ()=>ssrPath : $718230fb41ec7306$var$currentPathname);
const $718230fb41ec7306$var$currentHistoryState = ()=>history.state;
const $718230fb41ec7306$export$3ba9310fb9209e7f = ()=>$718230fb41ec7306$export$3a1ff78c39f8a86($718230fb41ec7306$var$currentHistoryState, ()=>null);
const $718230fb41ec7306$export$ff7962acd6052c28 = (to, { replace: replace = false, state: state = null } = {})=>history[replace ? $718230fb41ec7306$var$eventReplaceState : $718230fb41ec7306$var$eventPushState](state, "", to);
const $718230fb41ec7306$export$29c60f5332583 = (opts = {})=>[
        $718230fb41ec7306$export$2a28ef6a9fe822a4(opts),
        $718230fb41ec7306$export$ff7962acd6052c28
    ];
const $718230fb41ec7306$var$patchKey = Symbol.for("wouter_v3");
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined" && typeof window[$718230fb41ec7306$var$patchKey] === "undefined") {
    for (const type of [
        $718230fb41ec7306$var$eventPushState,
        $718230fb41ec7306$var$eventReplaceState
    ]){
        const original = history[type];
        // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
        // however that will require an additional peer dependency on react-dom.
        // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
        history[type] = function() {
            const result = original.apply(this, arguments);
            const event = new Event(type);
            event.arguments = arguments;
            dispatchEvent(event);
            return result;
        };
    }
    // patch history object only once
    // See: https://github.com/molefrog/wouter/issues/167
    Object.defineProperty(window, $718230fb41ec7306$var$patchKey, {
        value: true
    });
}



var $bh6RR = parcelRequire("bh6RR");
/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $dfbe0912b5e3c4a0$var$_relativePath = (base, path)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
/**
 * When basepath is `undefined` or '/' it is ignored (we assume it's empty string)
 */ const $dfbe0912b5e3c4a0$var$baseDefaults = (base = "")=>base === "/" ? "" : base;
const $dfbe0912b5e3c4a0$export$f1dd14e03b54dad4 = (to, base)=>to[0] === "~" ? to.slice(1) : $dfbe0912b5e3c4a0$var$baseDefaults(base) + to;
const $dfbe0912b5e3c4a0$export$7413eea5ad243d4 = (base = "", path)=>$dfbe0912b5e3c4a0$var$_relativePath($dfbe0912b5e3c4a0$var$unescape($dfbe0912b5e3c4a0$var$baseDefaults(base)), $dfbe0912b5e3c4a0$var$unescape(path));
/*
 * Removes leading question mark
 */ const $dfbe0912b5e3c4a0$var$stripQm = (str)=>str[0] === "?" ? str.slice(1) : str;
/*
 * decodes escape sequences such as %20
 */ const $dfbe0912b5e3c4a0$var$unescape = (str)=>{
    try {
        return decodeURI(str);
    } catch (_e) {
        // fail-safe mode: if string can't be decoded do nothing
        return str;
    }
};
const $dfbe0912b5e3c4a0$export$79dec46ffa0fcc35 = (search)=>$dfbe0912b5e3c4a0$var$unescape($dfbe0912b5e3c4a0$var$stripQm(search));


/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $7ddf83017cd4a2fe$var$defaultRouter = {
    hook: (0, $718230fb41ec7306$export$29c60f5332583),
    searchHook: (0, $718230fb41ec7306$export$bd221a7c56b93941),
    parser: (0, $a4301ecae062d975$export$98e6a39c04603d36),
    base: "",
    // this option is used to override the current location during SSR
    ssrPath: undefined,
    ssrSearch: undefined,
    // optional context to track render state during SSR
    ssrContext: undefined,
    // customizes how `href` props are transformed for <Link />
    hrefs: (x)=>x
};
const $7ddf83017cd4a2fe$var$RouterCtx = (0, $bh6RR.createContext)($7ddf83017cd4a2fe$var$defaultRouter);
const $7ddf83017cd4a2fe$export$9a302a45f65d0572 = ()=>(0, $bh6RR.useContext)($7ddf83017cd4a2fe$var$RouterCtx);
/**
 * Parameters context. Used by `useParams()` to get the
 * matched params from the innermost `Route` component.
 */ const $7ddf83017cd4a2fe$var$Params0 = {}, $7ddf83017cd4a2fe$var$ParamsCtx = (0, $bh6RR.createContext)($7ddf83017cd4a2fe$var$Params0);
const $7ddf83017cd4a2fe$export$99eaa27ddbbb95ef = ()=>(0, $bh6RR.useContext)($7ddf83017cd4a2fe$var$ParamsCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $7ddf83017cd4a2fe$var$useLocationFromRouter = (router)=>{
    const [location, navigate] = router.hook(router);
    // the function reference should stay the same between re-renders, so that
    // it can be passed down as an element prop without any performance concerns.
    // (This is achieved via `useEvent`.)
    return [
        (0, $dfbe0912b5e3c4a0$export$7413eea5ad243d4)(router.base, location),
        (0, $7c547a065d4f8a42$export$90fc3a17d93f704c)((to, navOpts)=>navigate((0, $dfbe0912b5e3c4a0$export$f1dd14e03b54dad4)(to, router.base), navOpts))
    ];
};
const $7ddf83017cd4a2fe$export$45d76561a5302f2b = ()=>$7ddf83017cd4a2fe$var$useLocationFromRouter($7ddf83017cd4a2fe$export$9a302a45f65d0572());
const $7ddf83017cd4a2fe$export$bd221a7c56b93941 = ()=>{
    const router = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    return (0, $dfbe0912b5e3c4a0$export$79dec46ffa0fcc35)(router.searchHook(router));
};
const $7ddf83017cd4a2fe$export$b4ee0d6794375c82 = (parser, route, path, loose)=>{
    // if the input is a regexp, skip parsing
    const { pattern: pattern, keys: keys } = route instanceof RegExp ? {
        keys: false,
        pattern: route
    } : parser(route || "*", loose);
    // array destructuring loses keys, so this is done in two steps
    const result = pattern.exec(path) || [];
    // when parser is in "loose" mode, `$base` is equal to the
    // first part of the route that matches the pattern
    // (e.g. for pattern `/a/:b` and path `/a/1/2/3` the `$base` is `a/1`)
    // we use this for route nesting
    const [$base, ...matches] = result;
    return $base !== undefined ? [
        true,
        (()=>{
            // for regex paths, `keys` will always be false
            // an object with parameters matched, e.g. { foo: "bar" } for "/:foo"
            // we "zip" two arrays here to construct the object
            // ["foo"], ["bar"] → { foo: "bar" }
            const groups = keys !== false ? Object.fromEntries(keys.map((key, i)=>[
                    key,
                    matches[i]
                ])) : result.groups;
            // convert the array to an instance of object
            // this makes it easier to integrate with the existing param implementation
            let obj = {
                ...matches
            };
            // merge named capture groups with matches array
            groups && Object.assign(obj, groups);
            return obj;
        })(),
        // the third value if only present when parser is in "loose" mode,
        // so that we can extract the base path for nested routes
        ...loose ? [
            $base
        ] : []
    ] : [
        false,
        null
    ];
};
const $7ddf83017cd4a2fe$export$3f79f0b98112cf57 = (pattern)=>$7ddf83017cd4a2fe$export$b4ee0d6794375c82($7ddf83017cd4a2fe$export$9a302a45f65d0572().parser, pattern, $7ddf83017cd4a2fe$export$45d76561a5302f2b()[0]);
const $7ddf83017cd4a2fe$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    // the router we will inherit from - it is the closest router in the tree,
    // unless the custom `hook` is provided (in that case it's the default one)
    const parent_ = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    const parent = props.hook ? $7ddf83017cd4a2fe$var$defaultRouter : parent_;
    // holds to the context value: the router object
    let value = parent;
    // when `ssrPath` contains a `?` character, we can extract the search from it.
    // also, ensure ssrSearch is always defined when ssrPath is provided, so that
    // useSearch behavior matches usePathname (proper SSR hydration when client
    // renders <Router> without props after server rendered with ssrPath/ssrSearch)
    const [path, search = props.ssrSearch ?? ""] = props.ssrPath?.split("?") ?? [];
    if (path) props.ssrSearch = search, props.ssrPath = path;
    // hooks can define their own `href` formatter (e.g. for hash location)
    props.hrefs = props.hrefs ?? props.hook?.hrefs;
    // hooks can define their own search hook (e.g. for memory location)
    props.searchHook = props.searchHook ?? props.hook?.searchHook;
    // what is happening below: to avoid unnecessary rerenders in child components,
    // we ensure that the router object reference is stable, unless there are any
    // changes that require reload (e.g. `base` prop changes -> all components that
    // get the router from the context should rerender, even if the component is memoized).
    // the expected behaviour is:
    //
    //   1) when the resulted router is no different from the parent, use parent
    //   2) if the custom `hook` prop is provided, we always inherit from the
    //      default router instead. this resets all previously overridden options.
    //   3) when the router is customized here, it should stay stable between renders
    let ref = (0, $bh6RR.useRef)({}), prev = ref.current, next = prev;
    for(let k in parent){
        const option = k === "base" ? /* base is special case, it is appended to the parent's base */ parent[k] + (props[k] ?? "") : props[k] ?? parent[k];
        if (prev === next && option !== next[k]) ref.current = next = {
            ...next
        };
        next[k] = option;
        // the new router is no different from the parent or from the memoized value, use parent
        if (option !== parent[k] || option !== value[k]) value = next;
    }
    return (0, $bh6RR.createElement)($7ddf83017cd4a2fe$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
const $7ddf83017cd4a2fe$var$h_route = ({ children: children, component: component }, params)=>{
    // React-Router style `component` prop
    if (component) return (0, $bh6RR.createElement)(component, {
        params: params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
// Cache params object between renders if values are shallow equal
const $7ddf83017cd4a2fe$var$useCachedParams = (value)=>{
    let prev = (0, $bh6RR.useRef)($7ddf83017cd4a2fe$var$Params0);
    const curr = prev.current;
    return prev.current = // Update cache if number of params changed or any value changed
    Object.keys(value).length !== Object.keys(curr).length || Object.entries(value).some(([k, v])=>v !== curr[k]) ? value // Return new value if there are changes
     : curr; // Return cached value if nothing changed
};
function $7ddf83017cd4a2fe$export$f1a78c17382fe22a() {
    const [location, navigate] = $7ddf83017cd4a2fe$export$45d76561a5302f2b();
    const search = $7ddf83017cd4a2fe$export$bd221a7c56b93941();
    const searchParams = (0, $bh6RR.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    // cached value before next render, so you can call setSearchParams multiple times
    let tempSearchParams = searchParams;
    const setSearchParams = (0, $7c547a065d4f8a42$export$90fc3a17d93f704c)((nextInit, options)=>{
        tempSearchParams = new URLSearchParams(typeof nextInit === "function" ? nextInit(tempSearchParams) : nextInit);
        navigate(location + "?" + tempSearchParams, options);
    });
    return [
        searchParams,
        setSearchParams
    ];
}
const $7ddf83017cd4a2fe$export$e7b0ac011bb776c6 = ({ path: path, nest: nest, match: match, ...renderProps })=>{
    const router = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    const [location] = $7ddf83017cd4a2fe$var$useLocationFromRouter(router);
    const [matches, routeParams, base] = // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    match ?? $7ddf83017cd4a2fe$export$b4ee0d6794375c82(router.parser, path, location, nest);
    // when `routeParams` is `null` (there was no match), the argument
    // below becomes {...null} = {}, see the Object Spread specs
    // https://tc39.es/proposal-object-rest-spread/#AbstractOperations-CopyDataProperties
    const params = $7ddf83017cd4a2fe$var$useCachedParams({
        ...$7ddf83017cd4a2fe$export$99eaa27ddbbb95ef(),
        ...routeParams
    });
    if (!matches) return null;
    const children = base ? (0, $bh6RR.createElement)($7ddf83017cd4a2fe$export$55185c17a0fcbe46, {
        base: base
    }, $7ddf83017cd4a2fe$var$h_route(renderProps, params)) : $7ddf83017cd4a2fe$var$h_route(renderProps, params);
    return (0, $bh6RR.createElement)($7ddf83017cd4a2fe$var$ParamsCtx.Provider, {
        value: params,
        children: children
    });
};
const $7ddf83017cd4a2fe$export$a6c7ac8248d6e38a = (0, $bh6RR.forwardRef)((props, ref)=>{
    const router = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    const [currentPath, navigate] = $7ddf83017cd4a2fe$var$useLocationFromRouter(router);
    const { to: to = "", href: targetPath = to, onClick: _onClick, asChild: asChild, children: children, className: cls, replace: /* eslint-disable no-unused-vars */ replace /* ignore nav props */ , state: state /* ignore nav props */ , /* eslint-enable no-unused-vars */ ...restProps } = props;
    const onClick = (0, $7c547a065d4f8a42$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        _onClick?.(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(targetPath, props);
        }
    });
    // handle nested routers and absolute paths
    const href = router.hrefs(targetPath[0] === "~" ? targetPath.slice(1) : router.base + targetPath, router // pass router as a second argument for convinience
    );
    return asChild && (0, $bh6RR.isValidElement)(children) ? (0, $bh6RR.cloneElement)(children, {
        onClick: onClick,
        href: href
    }) : (0, $bh6RR.createElement)("a", {
        ...restProps,
        onClick: onClick,
        href: href,
        // `className` can be a function to apply the class if this link is active
        className: cls?.call ? cls(currentPath === targetPath) : cls,
        children: children,
        ref: ref
    });
});
const $7ddf83017cd4a2fe$var$flattenChildren = (children)=>Array.isArray(children) ? children.flatMap((c)=>$7ddf83017cd4a2fe$var$flattenChildren(c && c.type === (0, $bh6RR.Fragment) ? c.props.children : c)) : [
        children
    ];
const $7ddf83017cd4a2fe$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    const [originalLocation] = $7ddf83017cd4a2fe$var$useLocationFromRouter(router);
    for (const element of $7ddf83017cd4a2fe$var$flattenChildren(children)){
        let match = 0;
        if ((0, $bh6RR.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = $7ddf83017cd4a2fe$export$b4ee0d6794375c82(router.parser, element.props.path, location || originalLocation, element.props.nest))[0]) return (0, $bh6RR.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $7ddf83017cd4a2fe$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const router = $7ddf83017cd4a2fe$export$9a302a45f65d0572();
    const [, navigate] = $7ddf83017cd4a2fe$var$useLocationFromRouter(router);
    const redirect = (0, $7c547a065d4f8a42$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    const { ssrContext: ssrContext } = router;
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $7c547a065d4f8a42$export$700979bc83e7db82)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (ssrContext) ssrContext.redirectTo = to;
    return null;
};



var $bh6RR = parcelRequire("bh6RR");


var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");


var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");






var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


function $3df63989a2b02cce$export$2e2bcd8739ae039() {
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const COPY = window.COPY;
    return /*#__PURE__*/ (0, $ih19M.jsx)("section", {
        id: "my-pages-header",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "my-pages-container",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    children: COPY.my_pages.my_profile
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "user-name",
                    children: `${(0, $200ec6b1b2ca8c5a$export$c1fb9bac27b52cdd)(user)}`
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");



function $5800f253ac8e1667$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const toggleMenu = ()=>{
        setIsOpen(!isOpen);
    };
    const COPY = window.COPY;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("nav", {
        id: "my-pages-menu",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                className: "btn white fw menu-button",
                onClick: toggleMenu,
                children: COPY.my_pages.menu_header
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))({
                    open: isOpen
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7ddf83017cd4a2fe$export$a6c7ac8248d6e38a), {
                            href: (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('profile'),
                            children: COPY.my_pages.menu_profile
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7ddf83017cd4a2fe$export$a6c7ac8248d6e38a), {
                            href: (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('payment'),
                            children: COPY.my_pages.menu_payment
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7ddf83017cd4a2fe$export$a6c7ac8248d6e38a), {
                            href: (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('orders'),
                            children: t('menu-my-bookings')
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $d966e9f1028308f3$export$32180ef41b15b513;
$d966e9f1028308f3$export$32180ef41b15b513 = `J5ya7a_body`;


const $0bbd92d7fbbb8102$var$RESEND_COOLDOWN = 30;
function $0bbd92d7fbbb8102$export$2e2bcd8739ae039({ email: email, userId: userId, onClose: onClose }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [countdown, setCountdown] = (0, $bh6RR.useState)($0bbd92d7fbbb8102$var$RESEND_COOLDOWN);
    const [isResending, setIsResending] = (0, $bh6RR.useState)(false);
    (0, $bh6RR.useEffect)(()=>{
        if (countdown <= 0) return;
        const id = setTimeout(()=>setCountdown((c)=>c - 1), 1000);
        return ()=>clearTimeout(id);
    }, [
        countdown
    ]);
    const handleResend = ()=>{
        setIsResending(true);
        (0, $135a523c4bea715f$export$eed77d686003896a)(userId, email).then(()=>setCountdown($0bbd92d7fbbb8102$var$RESEND_COOLDOWN)).catch(()=>{}).finally(()=>setIsResending(false));
    };
    const buttons = [
        {
            func: handleResend,
            title: countdown > 0 ? t('email-verify-resend-countdown', {
                seconds: countdown
            }) : t('email-verify-resend'),
            disabled: countdown > 0 || isResending,
            isLoading: isResending
        },
        {
            func: onClose,
            title: t('button-close')
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('email-verify-sent-title')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                        className: $d966e9f1028308f3$export$32180ef41b15b513,
                        children: [
                            t('email-verify-sent-body'),
                            " ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                                children: email
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isResending,
                modal: true
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



var $8d6fcf89746f6a39$export$32180ef41b15b513;
$8d6fcf89746f6a39$export$32180ef41b15b513 = `mcFfaG_body`;


const $06b6bbff8c0eda36$var$RESEND_COOLDOWN = 30;
function $06b6bbff8c0eda36$var$VerificationForm({ phone: phone, onVerified: onVerified, onClose: onClose }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const inputRef = (0, $bh6RR.useRef)();
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError, setFieldTouched: setFieldTouched } = (0, $lW2XZ.useFormikContext)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const [isResending, setIsResending] = (0, $bh6RR.useState)(false);
    const [countdown, setCountdown] = (0, $bh6RR.useState)($06b6bbff8c0eda36$var$RESEND_COOLDOWN);
    const [activationBadState, setActivationBadState] = (0, $bh6RR.useState)(false);
    // NOTE: Workaround to force the field to show the error, same as in the OTP flow
    const showError = (error)=>{
        setFieldTouched('phoneCode', true, false);
        setTimeout(()=>setFieldError('phoneCode', error?.response?.message), 100);
        if ((0, $135a523c4bea715f$export$b45aefc478af63c4)(error)) setActivationBadState(true);
    };
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$1836188376808b25)(values.phoneCode).then(()=>onVerified()).catch((error)=>{
            console.error(error);
            // Clear the code so a retry re-triggers the length === 4 effect below
            setFieldValue('phoneCode', '', false);
            showError(error);
            inputRef.current?.focus();
        }).finally(()=>setIsLoading(false));
    };
    const handleResend = ()=>{
        setIsResending(true);
        (0, $135a523c4bea715f$export$67faf1bc20afbc8d)().then(()=>{
            setFieldValue('phoneCode', '', false);
            setCountdown($06b6bbff8c0eda36$var$RESEND_COOLDOWN);
            inputRef.current?.focus();
        }).catch((error)=>{
            console.error(error);
            showError(error);
        }).finally(()=>setIsResending(false));
    };
    (0, $bh6RR.useEffect)(()=>{
        if (countdown <= 0) return;
        const id = setTimeout(()=>setCountdown((c)=>c - 1), 1000);
        return ()=>clearTimeout(id);
    }, [
        countdown
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (values.phoneCode.length === 4) makeRequest();
    }, [
        values.phoneCode
    ]);
    const buttons = [
        {
            func: handleResend,
            title: countdown > 0 ? t('phone-verify-resend-countdown', {
                seconds: countdown
            }) : t('phone-verify-resend'),
            disabled: countdown > 0 || isResending || isLoading || activationBadState,
            isLoading: isResending
        },
        {
            func: onClose,
            title: t('button-close')
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                isLoading: isLoading || isResending,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        isLoading: isLoading,
                        children: t('phone-verify-sent-title')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("p", {
                        className: $8d6fcf89746f6a39$export$32180ef41b15b513,
                        children: [
                            t('phone-verify-sent-body'),
                            " ",
                            /*#__PURE__*/ (0, $ih19M.jsx)("strong", {
                                children: phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "phoneCode",
                                inputRef: inputRef,
                                component: (0, $06bd433d73a68758$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                name: "phoneCode",
                                component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                isLoading: isLoading || isResending,
                modal: true
            })
        ]
    });
}
function $06b6bbff8c0eda36$export$2e2bcd8739ae039({ phone: phone, onVerified: onVerified, onClose: onClose }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
            initialValues: {
                phoneCode: ''
            },
            onSubmit: ()=>{},
            children: /*#__PURE__*/ (0, $ih19M.jsx)($06b6bbff8c0eda36$var$VerificationForm, {
                phone: phone,
                onVerified: onVerified,
                onClose: onClose
            })
        })
    });
}


var $2863aa355caa7bbc$export$3e1d82fea00a44;
var $2863aa355caa7bbc$export$4f70dd1570ce06b2;
var $2863aa355caa7bbc$export$3ad1cc8902915cc5;
var $2863aa355caa7bbc$export$8bcca11081b04b26;
var $2863aa355caa7bbc$export$835553149cff2fbb;
var $2863aa355caa7bbc$export$e27ae4bec186c794;
var $2863aa355caa7bbc$export$30f015e46281c810;
var $2863aa355caa7bbc$export$b1de0fc0addaab95;
var $2863aa355caa7bbc$export$cc74dcc53cfce4eb;
$2863aa355caa7bbc$export$3e1d82fea00a44 = `K4elTG_companyGroup`;
$2863aa355caa7bbc$export$4f70dd1570ce06b2 = `K4elTG_emailInfo`;
$2863aa355caa7bbc$export$3ad1cc8902915cc5 = `K4elTG_marketingInfo`;
$2863aa355caa7bbc$export$8bcca11081b04b26 = `K4elTG_notVerified`;
$2863aa355caa7bbc$export$835553149cff2fbb = `K4elTG_phoneGroup`;
$2863aa355caa7bbc$export$e27ae4bec186c794 = `K4elTG_phoneInfo`;
$2863aa355caa7bbc$export$30f015e46281c810 = `K4elTG_verifyButton`;
$2863aa355caa7bbc$export$b1de0fc0addaab95 = `K4elTG_withVerify`;
$2863aa355caa7bbc$export$cc74dcc53cfce4eb = `K4elTG_wrapper`;



const $87a3befe680c0846$var$NotVerified = ({ t: t, onVerify: onVerify, isLoading: isLoading, label: label })=>/*#__PURE__*/ (0, $ih19M.jsxs)("span", {
        className: $2863aa355caa7bbc$export$8bcca11081b04b26,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "10"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                        x1: "12",
                        y1: "8",
                        x2: "12",
                        y2: "12"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("line", {
                        x1: "12",
                        y1: "16",
                        x2: "12.01",
                        y2: "16"
                    })
                ]
            }),
            t('label-not-verified'),
            onVerify && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                className: $2863aa355caa7bbc$export$30f015e46281c810,
                onClick: onVerify,
                disabled: isLoading,
                children: isLoading ? '...' : label || t('button-verify-email')
            })
        ]
    });
function $87a3befe680c0846$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, setUser: setUser, logoutUser: logoutUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [verifyLoading, setVerifyLoading] = (0, $bh6RR.useState)(false);
    const [verifyCompanyLoading, setVerifyCompanyLoading] = (0, $bh6RR.useState)(false);
    const [showVerifyModal, setShowVerifyModal] = (0, $bh6RR.useState)(false);
    const [verifyEmail, setVerifyEmail] = (0, $bh6RR.useState)(null);
    const [verifyPhoneLoading, setVerifyPhoneLoading] = (0, $bh6RR.useState)(false);
    const [showVerifyPhoneModal, setShowVerifyPhoneModal] = (0, $bh6RR.useState)(false);
    const [verifyPhone, setVerifyPhone] = (0, $bh6RR.useState)(null);
    (0, $bh6RR.useEffect)(()=>{
        if (!user?.userId) return;
        const interval = setInterval(()=>{
            (0, $135a523c4bea715f$export$7cbf767827cd68ba)(user.userId).then((response)=>{
                const prevCompanyEmailVerified = user.companyConnections?.[0]?.emailVerified;
                const nextCompanyEmailVerified = response.companyConnections?.[0]?.emailVerified;
                if (response.emailVerified !== user.emailVerified || response.phoneVerified !== user.phoneVerified || nextCompanyEmailVerified !== prevCompanyEmailVerified) setUser(response);
            }).catch(()=>{});
        }, 20000);
        return ()=>clearInterval(interval);
    }, [
        user?.userId,
        user?.emailVerified,
        user?.phoneVerified
    ]);
    if (!user) return null;
    const company = user && user?.companyConnections?.length > 0 ? user?.companyConnections[0] : false;
    const deleteProfile = async ()=>{
        setLoading(true);
        (0, $135a523c4bea715f$export$7d0f10f273c0438a)(user.userId).then((response)=>{
            setMessage('');
            logoutUser();
        }).catch((error)=>{
            console.error(error);
            setMessage(error?.response?.message);
        }).finally(()=>{
            setLoading(false);
        });
    };
    const logout = async ()=>{
        setLoading(true);
        (0, $135a523c4bea715f$export$8220d3f4554159a3)().then((response)=>{
            setMessage('');
            logoutUser();
        }).catch((error)=>{
            console.error(error);
            setMessage(error?.response?.message);
        }).finally(()=>{
            setLoading(false);
        });
    };
    // The OTP is validated inside the modal, but the new number only lands on the
    // user object server side, so re-fetch to pick up phone/phoneVerified.
    const handlePhoneVerified = ()=>{
        setShowVerifyPhoneModal(false);
        setMessage('');
        (0, $135a523c4bea715f$export$7cbf767827cd68ba)(user.userId).then((response)=>setUser(response)).catch((error)=>setMessage(error?.response?.message));
    };
    const onDeleteClick = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(COPY.my_pages.delete_profile_confirm, [
            {
                title: COPY.booking.button_ok,
                callback: deleteProfile
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    const initialValues = {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email || user.username,
        phone: user.phone || '',
        marketingOptIn: user?.marketingOptIn?.consent
    };
    const COPY = window.COPY;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            showVerifyModal && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0bbd92d7fbbb8102$export$2e2bcd8739ae039), {
                email: verifyEmail,
                userId: user.userId,
                onClose: ()=>setShowVerifyModal(false)
            }),
            showVerifyPhoneModal && /*#__PURE__*/ (0, $ih19M.jsx)((0, $06b6bbff8c0eda36$export$2e2bcd8739ae039), {
                phone: verifyPhone,
                onVerified: handlePhoneVerified,
                onClose: ()=>setShowVerifyPhoneModal(false)
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
                enableReinitialize: true,
                initialValues: initialValues,
                validationSchema: $e6d972962a22d393$export$185802fd694ee1f5({
                    firstName: $a0206caf38308288$export$185802fd694ee1f5().required(),
                    lastName: $a0206caf38308288$export$185802fd694ee1f5().required(),
                    email: $a0206caf38308288$export$185802fd694ee1f5().email().required(),
                    phone: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?[\d\s\-()./]+$/, t('validation-phone-format')).test('length', t('validation-phone-format'), (value)=>{
                        const digits = (0, $200ec6b1b2ca8c5a$export$842dcfa371c6bb83)(value).replace(/\D/g, '');
                        return digits.length >= 8 && digits.length <= 16;
                    }).required(t('validation-need-phone'))
                }),
                onSubmit: async (values)=>{
                    setLoading(true);
                    (0, $135a523c4bea715f$export$e3ac7a5d19605772)(user.userId, values).then((response)=>{
                        setMessage('');
                        setUser(response);
                    }).catch((error)=>{
                        setMessage(error?.response?.message);
                    }).finally(()=>{
                        setLoading(false);
                    });
                },
                children: ({ errors: errors, submitForm: submitForm, values: formValues })=>{
                    const originalEmail = user.email || user.username;
                    const emailChanged = formValues.email !== originalEmail;
                    const showVerifyBadge = user.emailVerified === false || emailChanged;
                    const phoneChanged = (0, $200ec6b1b2ca8c5a$export$842dcfa371c6bb83)(formValues.phone) !== (0, $200ec6b1b2ca8c5a$export$842dcfa371c6bb83)(user.phone);
                    const showPhoneVerifyBadge = user.phoneVerified === false || phoneChanged;
                    // Phone can't go through updateUser — it needs an OTP, so it goes via
                    // the activation endpoint and is only persisted once the code is validated.
                    const handleVerifyPhone = ()=>{
                        if (errors?.phone) {
                            setMessage(errors.phone);
                            return;
                        }
                        setVerifyPhoneLoading(true);
                        const formatted = (0, $200ec6b1b2ca8c5a$export$842dcfa371c6bb83)(formValues.phone);
                        (0, $135a523c4bea715f$export$94ea1ffa89952f1c)(formatted).then((response)=>{
                            if (response?.deviceActivationState === 'UPDATE_PHONE_OTP_INITIATED' || response?.expectedActions?.includes('VALIDATE_PHONE_OTP')) {
                                setMessage('');
                                setVerifyPhone(formatted);
                                setShowVerifyPhoneModal(true);
                            } else {
                                console.warn('Unhandled deviceActivationState:', response?.deviceActivationState, response);
                                setMessage(t('error-phone-verify-failed'));
                            }
                        }).catch((error)=>setMessage(error?.response?.message)).finally(()=>setVerifyPhoneLoading(false));
                    };
                    const handleVerifyEmail = ()=>{
                        setVerifyLoading(true);
                        const doVerify = (email)=>{
                            setVerifyEmail(email);
                            (0, $135a523c4bea715f$export$eed77d686003896a)(user.userId, email).then(()=>setShowVerifyModal(true)).catch((error)=>setMessage(error?.response?.message)).finally(()=>setVerifyLoading(false));
                        };
                        if (emailChanged) (0, $135a523c4bea715f$export$e3ac7a5d19605772)(user.userId, formValues).then((response)=>{
                            setUser(response);
                            doVerify(formValues.email);
                        }).catch((error)=>{
                            setMessage(error?.response?.message);
                            setVerifyLoading(false);
                        });
                        else doVerify(originalEmail);
                    };
                    const handleVerifyCompanyEmail = ()=>{
                        setVerifyCompanyLoading(true);
                        setVerifyEmail(company.userCompanyEmail);
                        (0, $135a523c4bea715f$export$eed77d686003896a)(user.userId, company.userCompanyEmail).then(()=>setShowVerifyModal(true)).catch((error)=>setMessage(error?.response?.message)).finally(()=>setVerifyCompanyLoading(false));
                    };
                    return /*#__PURE__*/ (0, $ih19M.jsxs)("section", {
                        className: "profile-view",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3df63989a2b02cce$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: "my-pages-container",
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5800f253ac8e1667$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "my-pages-content",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                                children: COPY.my_pages.update_profile
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('my-pages-form profile-form', {
                                                    loading: loading
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("header", {
                                                        className: "form-header",
                                                        children: COPY.my_pages.details_header
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: "form-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                htmlFor: "firstName",
                                                                children: t('label-firstname')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                                name: "firstName",
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('input-field has-label', {
                                                                    'has-error': errors?.firstName
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: "form-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                htmlFor: "lastName",
                                                                children: t('label-lastname')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                                name: "lastName",
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('input-field has-label', {
                                                                    'has-error': errors?.lastName
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group', {
                                                            [$2863aa355caa7bbc$export$b1de0fc0addaab95]: showVerifyBadge
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                htmlFor: "email",
                                                                children: COPY.my_pages.label_email
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                                name: "email",
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('input-field has-label', {
                                                                    'has-error': errors?.email
                                                                })
                                                            }),
                                                            showVerifyBadge && /*#__PURE__*/ (0, $ih19M.jsx)($87a3befe680c0846$var$NotVerified, {
                                                                t: t,
                                                                onVerify: handleVerifyEmail,
                                                                isLoading: verifyLoading
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group', {
                                                            [$2863aa355caa7bbc$export$b1de0fc0addaab95]: showPhoneVerifyBadge
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                htmlFor: "phone",
                                                                children: t('label-mobile-phone')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                                name: "phone",
                                                                type: "tel",
                                                                inputMode: "tel",
                                                                autoComplete: "tel",
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('input-field has-label', $2863aa355caa7bbc$export$835553149cff2fbb, {
                                                                    'has-error': errors?.phone
                                                                })
                                                            }),
                                                            showPhoneVerifyBadge && /*#__PURE__*/ (0, $ih19M.jsx)($87a3befe680c0846$var$NotVerified, {
                                                                t: t,
                                                                onVerify: handleVerifyPhone,
                                                                isLoading: verifyPhoneLoading,
                                                                label: t('button-verify-phone')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                                className: $2863aa355caa7bbc$export$e27ae4bec186c794,
                                                                children: t('info-verify-phone')
                                                            })
                                                        ]
                                                    }),
                                                    company && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group', $2863aa355caa7bbc$export$3e1d82fea00a44),
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                children: t('label-company')
                                                            }),
                                                            company?.name,
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                                className: $2863aa355caa7bbc$export$4f70dd1570ce06b2,
                                                                children: t('label-connected-email')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))({
                                                                    [$2863aa355caa7bbc$export$b1de0fc0addaab95]: company.emailVerified === false
                                                                }),
                                                                children: [
                                                                    company?.userCompanyEmail,
                                                                    company.emailVerified === false && /*#__PURE__*/ (0, $ih19M.jsx)($87a3befe680c0846$var$NotVerified, {
                                                                        t: t,
                                                                        onVerify: handleVerifyCompanyEmail,
                                                                        isLoading: verifyCompanyLoading
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: "form-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("label", {
                                                                htmlFor: "marketingOptIn",
                                                                children: t('label-communications')
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                                className: $2863aa355caa7bbc$export$cc74dcc53cfce4eb,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                                                        className: $2863aa355caa7bbc$export$3ad1cc8902915cc5,
                                                                        children: t('title-accept-marketing')
                                                                    }),
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                                                        name: "marketingOptIn",
                                                                        children: ({ field: field, form: form })=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $d87fa2da2c7fef35$export$2e2bcd8739ae039), {
                                                                                field: {
                                                                                    ...field,
                                                                                    onChange: (e)=>{
                                                                                        const checked = e.target.checked;
                                                                                        form.setFieldValue('marketingOptIn', checked, false);
                                                                                        (0, $135a523c4bea715f$export$87808cfd18c2bb49)(user.userId, checked).then((response)=>setUser(response)).catch((error)=>setMessage(error?.response?.message));
                                                                                    }
                                                                                },
                                                                                form: form
                                                                            })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: "form-group with-padding remove-top-padding",
                                                        children: [
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('message', {
                                                                    show: message
                                                                }),
                                                                children: message
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                                id: "save-profile-button",
                                                                className: "btn",
                                                                onClick: submitForm,
                                                                children: COPY.my_pages.save_profile_button
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                                id: "delete-profile-button",
                                                                className: "btn gray",
                                                                onClick: onDeleteClick,
                                                                children: COPY.my_pages.delete_profile_button
                                                            }),
                                                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                                id: "logout-button",
                                                                className: "btn gray",
                                                                onClick: logout,
                                                                children: COPY.my_pages.logout_button
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");










var $e71491458c69b232$export$a80b3bd66acc52ff;
var $e71491458c69b232$export$7061c75fc5af8b7e;
$e71491458c69b232$export$a80b3bd66acc52ff = `KJPp3G_info`;
$e71491458c69b232$export$7061c75fc5af8b7e = `KJPp3G_item`;



function $48061a0ec830b903$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, paymentAccounts: paymentAccounts, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const COPY = window.COPY;
    const hasAccounts = user?.accounts?.length > 0;
    const hasCreditCards = paymentAccounts?.length > 0;
    const hasVouchers = user?.vouchers?.length > 0;
    const removeAccount = (accountNumber)=>{
        setLoading(true);
        (0, $135a523c4bea715f$export$45abfc3976589d02)(user.userId, accountNumber).then((response)=>{
            setMessage('');
            refreshUser();
        }).catch((error)=>{
            console.error(error);
            setMessage(error?.response?.message);
        }).finally(()=>{
            setLoading(false);
        });
    };
    const removePaymentAccount = (accountId)=>{
        setLoading(true);
        (0, $135a523c4bea715f$export$4ed561c675781f86)(user.userId).then((userVerificationToken)=>{
            (0, $e9d25ab963e7e928$export$d2736c8011eb8c55)(user.userId, accountId, userVerificationToken).then((response)=>{
                setMessage('');
                refreshUser();
            }).catch((error)=>{
                console.error(error);
            }).finally(()=>{
                setLoading(false);
            });
        }).catch((error)=>{
            console.error(error);
            setLoading(false);
        });
    };
    const addCreditCard = ()=>{
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CASHIER_ADD_CARD', {
            success: refreshUser
        });
    };
    const openAddAccount = ()=>{
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $f5a01b8c00777f68$export$2e2bcd8739ae039), {
                onComplete: close
            }));
    };
    const openAddVoucher = ()=>{
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $006192e901cb3229$export$2e2bcd8739ae039), {
                onComplete: close
            }));
    };
    const onDeleteAccount = (accountNumber)=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(COPY.my_pages.delete_account_confirm, [
            {
                title: COPY.booking.button_ok,
                callback: ()=>removeAccount(accountNumber)
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    const onDeletePaymentAccount = (accountId)=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(t('info-confirm-remove-card'), [
            {
                title: COPY.booking.button_ok,
                callback: ()=>removePaymentAccount(accountId)
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("section", {
        className: "payment-view",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3df63989a2b02cce$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "my-pages-container",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5800f253ac8e1667$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "my-pages-content account-form",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                children: COPY.my_pages.payment_header
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('my-pages-form', {
                                    loading: loading
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("header", {
                                        className: "form-header",
                                        children: t('header-accounts')
                                    }),
                                    !hasAccounts && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "account-info",
                                        children: t('info-no-accounts')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group accounts', {
                                            show: hasAccounts
                                        }),
                                        children: user?.accounts?.map((item)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('account-item', $e71491458c69b232$export$7061c75fc5af8b7e),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: "account-name",
                                                        children: item.accountName
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                        className: $e71491458c69b232$export$a80b3bd66acc52ff,
                                                        children: item.accountNumber
                                                    }),
                                                    item.removable && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                        className: "delete-account",
                                                        onClick: ()=>onDeleteAccount(item.accountNumber)
                                                    })
                                                ]
                                            }, item.accountNumber))
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "form-group with-padding",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('message', {
                                                    show: message
                                                }),
                                                children: message
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                className: "btn",
                                                onClick: openAddAccount,
                                                children: t('button-add-account')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("header", {
                                        className: "form-header",
                                        children: t('header-cards')
                                    }),
                                    !hasCreditCards && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "account-info",
                                        children: t('info-no-cards')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group accounts', {
                                            show: hasCreditCards
                                        }),
                                        children: paymentAccounts?.map((item)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('account-item card', $e71491458c69b232$export$7061c75fc5af8b7e),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                        className: "account-name",
                                                        children: item.maskedAccount
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                        className: $e71491458c69b232$export$a80b3bd66acc52ff,
                                                        children: item.cardType
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                                        className: "delete-account",
                                                        onClick: ()=>onDeletePaymentAccount(item.accountId)
                                                    })
                                                ]
                                            }, item.accountId))
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "form-group with-padding",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                            className: "btn",
                                            onClick: addCreditCard,
                                            children: t('button-add-card')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("header", {
                                        className: "form-header",
                                        children: t('header-vouchers')
                                    }),
                                    !hasVouchers && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "account-info",
                                        children: t('info-no-vouchers')
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('form-group accounts', {
                                            show: hasVouchers
                                        }),
                                        children: user?.vouchers?.map((item)=>/*#__PURE__*/ (0, $ih19M.jsxs)("li", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('account-item', $e71491458c69b232$export$7061c75fc5af8b7e),
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                                        className: "account-name",
                                                        children: [
                                                            item.voucherCode,
                                                            " - ",
                                                            (0, $c94184dfef1a7d71$export$9e6e5cf28f33a45e)(item)
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                        className: $e71491458c69b232$export$a80b3bd66acc52ff,
                                                        children: [
                                                            t('expires-at', {
                                                                date: (0, $200ec6b1b2ca8c5a$export$f0a889078b7435f7)(new Date(item.expiry))
                                                            }),
                                                            item.valueType == 'PERCENTAGE' && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)("br", {}),
                                                                    t('info-voucher-max', {
                                                                        amount: item.maxPriceToBeDiscounted
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, item.voucherCode))
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "form-group with-padding",
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                            className: "btn",
                                            onClick: openAddVoucher,
                                            children: t('button-add-voucher')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $5TnqA = parcelRequire("5TnqA");






function $71fe4bea404e9cc5$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, bookings: bookings, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [historicBookings, setHistoricBookings] = (0, $bh6RR.useState)();
    const [pagedBookings, setPagedBookings] = (0, $bh6RR.useState)();
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [message, setMessage] = (0, $bh6RR.useState)();
    const [skip, setSkip] = (0, $bh6RR.useState)(0);
    const limit = 10;
    const headerRef = (0, $bh6RR.useRef)();
    const COPY = window.COPY;
    const prevPage = ()=>{
        setSkip(skip - limit);
        if (headerRef.current) headerRef.current.scrollIntoView();
    };
    const nextPage = ()=>{
        setSkip(skip + limit);
        if (headerRef.current) headerRef.current.scrollIntoView();
    };
    (0, $bh6RR.useEffect)(()=>{
        if (historicBookings?.length > 0) setPagedBookings(historicBookings.slice(skip, skip + limit));
    }, [
        historicBookings,
        skip
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (user?.userId) {
            setLoading(true);
            (0, $135a523c4bea715f$export$c52936fe4c70c3a4)(user.userId).then((response)=>{
                setHistoricBookings(response);
            }).catch((error)=>{
                console.error(error.response);
                setMessage(error?.response?.message);
            }).finally(()=>{
                setLoading(false);
            });
        }
    }, [
        user?.userId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("section", {
        className: "orders-view",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $3df63989a2b02cce$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "my-pages-container",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $5800f253ac8e1667$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "my-pages-content",
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: "orders-content",
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                    className: "active-header",
                                    children: COPY.my_pages.my_orders_active
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                                    className: "active-orders",
                                    children: [
                                        bookings && bookings.map((booking)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $e195d2535fb91e12$export$2e2bcd8739ae039), {
                                                booking: booking,
                                                onCancel: getActiveBookings,
                                                showBorder: true
                                            }, booking.id)),
                                        bookings && bookings.length === 0 && /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                            children: COPY.my_pages.no_active_orders
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                                    ref: headerRef,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('historic-header', {
                                        loading: loading
                                    }),
                                    children: COPY.my_pages.my_orders_historic
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("ul", {
                                    className: "historic-orders",
                                    children: [
                                        pagedBookings && pagedBookings.map((booking)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $e195d2535fb91e12$export$2e2bcd8739ae039), {
                                                booking: booking,
                                                showBorder: true,
                                                showDate: true
                                            }, booking.id)),
                                        pagedBookings && pagedBookings.length === 0 && /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                            children: COPY.my_pages.no_historic_orders
                                        }),
                                        message && /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                                            children: message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('buttons', {
                                        show: true
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                            id: "prev-button",
                                            className: "btn dynamic",
                                            disabled: skip === 0,
                                            onClick: prevPage,
                                            children: COPY.my_pages.prev_page
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                            id: "next-button",
                                            className: "btn dynamic",
                                            disabled: !historicBookings || historicBookings?.length <= skip + limit,
                                            onClick: nextPage,
                                            children: COPY.my_pages.next_page
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");




var $bh6RR = parcelRequire("bh6RR");

function $28ae6c22c89d462c$export$2e2bcd8739ae039({ headline: headline, body: body, showLogin: showLogin = false }) {
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [location, setLocation] = (0, $7ddf83017cd4a2fe$export$45d76561a5302f2b)();
    const onLoginComplete = ()=>{
        setLocation((0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('profile'));
    };
    const onLoginClick = ()=>{
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', {
            show: true,
            callback: onLoginComplete
        });
    };
    const COPY = window.COPY;
    return /*#__PURE__*/ (0, $ih19M.jsx)("section", {
        className: "not-logged-in-view info",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "text-container",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                    children: headline
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                    className: "body",
                    dangerouslySetInnerHTML: {
                        __html: body
                    }
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "form-rows-wrapper",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "form-row-bottom",
                        children: !user && showLogin && /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                            href: "#",
                            onClick: onLoginClick,
                            children: COPY.my_pages.register_login
                        })
                    })
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $lW2XZ = parcelRequire("lW2XZ");


var $5TnqA = parcelRequire("5TnqA");
function $b3c7fd5249390164$export$2e2bcd8739ae039() {
    const searchString = (0, $7ddf83017cd4a2fe$export$bd221a7c56b93941)();
    const [location, setLocation] = (0, $7ddf83017cd4a2fe$export$45d76561a5302f2b)();
    const [loading, setLoading] = (0, $bh6RR.useState)(false);
    const [success, setSuccess] = (0, $bh6RR.useState)(false);
    const [message, setMessage] = (0, $bh6RR.useState)(false);
    const initialValues = {
        newPassword: '',
        repeatPassword: ''
    };
    const COPY = window.COPY;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
        initialValues: initialValues,
        validateOnChange: false,
        validationSchema: $e6d972962a22d393$export$185802fd694ee1f5({
            newPassword: $a0206caf38308288$export$185802fd694ee1f5().required().min(8),
            repeatPassword: $a0206caf38308288$export$185802fd694ee1f5().required().min(8).oneOf([
                $b3adddf52d229d80$export$185802fd694ee1f5('newPassword')
            ], 'Your passwords do not match.')
        }),
        onSubmit: async (values, { resetForm: resetForm })=>{
            setLoading(true);
            const data = {
                token: new URLSearchParams(searchString).get('token'),
                newPassword: values.newPassword
            };
            $.ajax(APP.getAjaxConfig({
                url: CONFIG.api_base_url + '/api/update-password',
                method: 'POST',
                data: data,
                success: ()=>{
                    setLoading(false);
                    setSuccess(true);
                    setMessage(COPY.my_pages.password_change_success);
                    resetForm();
                },
                error: (jqXHR)=>{
                    setLoading(false);
                    setLocation(jqXHR?.status === 410 ? (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('tokenError') : (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('unknownError'));
                }
            }));
        },
        children: ({ errors: errors, submitForm: submitForm })=>/*#__PURE__*/ (0, $ih19M.jsx)("section", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('not-logged-in-view reset', {
                    loading: loading,
                    success: success
                }),
                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "form-container",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("h2", {
                            children: COPY.my_pages.reset_password
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "body",
                            children: COPY.my_pages.reset_password_instructions
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "form-row hideable",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "newPassword",
                                type: "password",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-input', {
                                    'has-error': errors?.newPassword
                                }),
                                placeholder: `${COPY.my_pages.label_new_password} ${COPY.my_pages.min_chars_label}`
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "form-row hideable",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "repeatPassword",
                                type: "password",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-input', {
                                    'has-error': errors?.repeatPassword
                                }),
                                placeholder: COPY.my_pages.label_repeat_password
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "form-row hideable",
                            children: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                id: "forgot-button",
                                className: "btn black fw",
                                onClick: submitForm,
                                children: COPY.my_pages.change_password_button
                            })
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "form-row message"
                        }),
                        message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "success-message",
                            children: message
                        })
                    ]
                })
            })
    });
}




const $8afe3747eee9983f$var$supportedLangs = [
    'sv',
    'en'
];
let $8afe3747eee9983f$var$lang = document.querySelector('html').getAttribute('lang')?.substr(0, 2);
if (!$8afe3747eee9983f$var$supportedLangs.includes($8afe3747eee9983f$var$lang)) $8afe3747eee9983f$var$lang = 'sv';
const $8afe3747eee9983f$var$slugs = {
    sv: {
        root: '/',
        profile: '/profil',
        payment: '/betalmedel',
        orders: '/resor',
        emailVerified: '/epost-verifierad',
        phoneVerified: '/telefon-verifierad',
        resetPassword: '/aterstall-losenord',
        tokenError: '/ogiltig-lank',
        unknownError: '/ovantat-fel'
    },
    en: {
        root: '/',
        profile: '/profile',
        payment: '/payment',
        orders: '/orders',
        emailVerified: '/email-verified',
        phoneVerified: '/phone-verified',
        resetPassword: '/reset-password',
        tokenError: '/token-error',
        unknownError: '/unknown-error'
    }
};
const $8afe3747eee9983f$var$matches = (str, slug)=>{
    const path = $8afe3747eee9983f$export$da85b9d72d60e6d5(slug);
    return str === path || str === path + '/';
};
const $8afe3747eee9983f$export$2befef4b77056293 = ()=>$8afe3747eee9983f$var$lang === 'sv' ? '/sv/mina-sidor' : '/en/my-pages';
const $8afe3747eee9983f$export$da85b9d72d60e6d5 = (slug)=>{
    return $8afe3747eee9983f$export$2befef4b77056293() + $8afe3747eee9983f$var$slugs[$8afe3747eee9983f$var$lang][slug];
};
function $8afe3747eee9983f$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [location, setLocation] = (0, $7ddf83017cd4a2fe$export$45d76561a5302f2b)();
    const searchString = (0, $7ddf83017cd4a2fe$export$bd221a7c56b93941)();
    const COPY = window.COPY;
    if ($8afe3747eee9983f$var$matches(location, 'root') && !user) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $28ae6c22c89d462c$export$2e2bcd8739ae039), {
        headline: COPY.my_pages.login_header,
        body: t('info-login-to-update-profile'),
        showLogin: true
    });
    else if ($8afe3747eee9983f$var$matches(location, 'root') || $8afe3747eee9983f$var$matches(location, 'profile')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $87a3befe680c0846$export$2e2bcd8739ae039), {});
    else if ($8afe3747eee9983f$var$matches(location, 'payment')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $48061a0ec830b903$export$2e2bcd8739ae039), {});
    else if ($8afe3747eee9983f$var$matches(location, 'orders')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $71fe4bea404e9cc5$export$2e2bcd8739ae039), {});
    else if ($8afe3747eee9983f$var$matches(location, 'emailVerified')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $28ae6c22c89d462c$export$2e2bcd8739ae039), {
        headline: COPY.my_pages.email_verified_headline,
        body: COPY.my_pages.email_verified_body,
        showLogin: true
    });
    else if ($8afe3747eee9983f$var$matches(location, 'phoneVerified')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $28ae6c22c89d462c$export$2e2bcd8739ae039), {
        headline: t('phone-verified-title'),
        body: t('phone-verified-body'),
        showLogin: true
    });
    else if ($8afe3747eee9983f$var$matches(location, 'tokenError')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $28ae6c22c89d462c$export$2e2bcd8739ae039), {
        headline: COPY.my_pages.token_error_headline,
        body: COPY.my_pages.token_error_body,
        showLogin: true
    });
    else if ($8afe3747eee9983f$var$matches(location, 'unknownError')) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $28ae6c22c89d462c$export$2e2bcd8739ae039), {
        headline: COPY.my_pages.unknown_error_headline,
        body: COPY.my_pages.unknown_error_body,
        showLogin: true
    });
    else if ($8afe3747eee9983f$var$matches(location, 'resetPassword')) {
        const token = new URLSearchParams(searchString).get('token');
        if (!token) return setLocation($8afe3747eee9983f$export$da85b9d72d60e6d5('tokenError'));
        return /*#__PURE__*/ (0, $ih19M.jsx)(TokenGate, {
            token: token,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b3c7fd5249390164$export$2e2bcd8739ae039), {})
        });
    } else setLocation($8afe3747eee9983f$export$da85b9d72d60e6d5('root'));
}


var $a9447de3235ecb31$exports = {};

$parcel$export($a9447de3235ecb31$exports, "notLoggedIn", function () { return $a9447de3235ecb31$export$8a3333caa55728f2; }, function (v) { return $a9447de3235ecb31$export$8a3333caa55728f2 = v; });
$parcel$export($a9447de3235ecb31$exports, "userIcon", function () { return $a9447de3235ecb31$export$5d233ea1b21b38d0; }, function (v) { return $a9447de3235ecb31$export$5d233ea1b21b38d0 = v; });
$parcel$export($a9447de3235ecb31$exports, "wrapper", function () { return $a9447de3235ecb31$export$cc74dcc53cfce4eb; }, function (v) { return $a9447de3235ecb31$export$cc74dcc53cfce4eb = v; });
var $a9447de3235ecb31$export$8a3333caa55728f2;
var $a9447de3235ecb31$export$5d233ea1b21b38d0;
var $a9447de3235ecb31$export$cc74dcc53cfce4eb;
$a9447de3235ecb31$export$8a3333caa55728f2 = `AZ0eJq_notLoggedIn`;
$a9447de3235ecb31$export$5d233ea1b21b38d0 = `AZ0eJq_userIcon`;
$a9447de3235ecb31$export$cc74dcc53cfce4eb = `AZ0eJq_wrapper`;



const $ab03eb32e97e1283$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($a9447de3235ecb31$exports);
const $ab03eb32e97e1283$var$getFirstName = (user)=>{
    return user?.firstName || user?.lastName?.trim().replace(/\s.+/, '');
};
const $ab03eb32e97e1283$var$getInitials = (user)=>{
    if (user.firstName !== undefined && user.lastName === undefined) return user?.firstName?.substring(0, 2).toUpperCase();
    else if (user.firstName === undefined && user.lastName !== undefined) return user?.lastName?.substring(0, 2).toUpperCase();
    return user?.firstName?.charAt(0).toUpperCase() + user?.lastName?.charAt(0).toUpperCase();
};
function $ab03eb32e97e1283$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const onLoginComplete = ()=>{};
    const onClick = ()=>{
        if (!user) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', {
            show: true,
            callback: onLoginComplete
        });
        else location.href = (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('root');
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        className: $ab03eb32e97e1283$var$cx($a9447de3235ecb31$exports.wrapper, {
            notLoggedIn: !user
        }),
        onClick: onClick,
        children: [
            user ? $ab03eb32e97e1283$var$getFirstName(user) : t('button-login'),
            user && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $a9447de3235ecb31$exports.userIcon,
                children: $ab03eb32e97e1283$var$getInitials(user)
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");





var $25bb9c3223c55ea4$exports = {};

$parcel$export($25bb9c3223c55ea4$exports, "actions", function () { return $25bb9c3223c55ea4$export$e324594224ef24da; }, function (v) { return $25bb9c3223c55ea4$export$e324594224ef24da = v; });
$parcel$export($25bb9c3223c55ea4$exports, "header", function () { return $25bb9c3223c55ea4$export$38e42c68cf43b5d4; }, function (v) { return $25bb9c3223c55ea4$export$38e42c68cf43b5d4 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "loginButton", function () { return $25bb9c3223c55ea4$export$7abe78e1eda562aa; }, function (v) { return $25bb9c3223c55ea4$export$7abe78e1eda562aa = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logo", function () { return $25bb9c3223c55ea4$export$db3c28d99448dcff; }, function (v) { return $25bb9c3223c55ea4$export$db3c28d99448dcff = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoImage", function () { return $25bb9c3223c55ea4$export$3ba0bfd74bc3a6fe; }, function (v) { return $25bb9c3223c55ea4$export$3ba0bfd74bc3a6fe = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoMain", function () { return $25bb9c3223c55ea4$export$f3647d32653f0c72; }, function (v) { return $25bb9c3223c55ea4$export$f3647d32653f0c72 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoPhone", function () { return $25bb9c3223c55ea4$export$1965191505a5f5a9; }, function (v) { return $25bb9c3223c55ea4$export$1965191505a5f5a9 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoSub", function () { return $25bb9c3223c55ea4$export$22b7a5d104e13fa5; }, function (v) { return $25bb9c3223c55ea4$export$22b7a5d104e13fa5 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoText", function () { return $25bb9c3223c55ea4$export$19ee943b107f7e95; }, function (v) { return $25bb9c3223c55ea4$export$19ee943b107f7e95 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "logoutButton", function () { return $25bb9c3223c55ea4$export$1f22e2e0afc9f037; }, function (v) { return $25bb9c3223c55ea4$export$1f22e2e0afc9f037 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "userAvatar", function () { return $25bb9c3223c55ea4$export$7db60fb4c6d4a032; }, function (v) { return $25bb9c3223c55ea4$export$7db60fb4c6d4a032 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "userInfo", function () { return $25bb9c3223c55ea4$export$94e4009ecfbf7408; }, function (v) { return $25bb9c3223c55ea4$export$94e4009ecfbf7408 = v; });
$parcel$export($25bb9c3223c55ea4$exports, "userName", function () { return $25bb9c3223c55ea4$export$c86d3ca66f38ed60; }, function (v) { return $25bb9c3223c55ea4$export$c86d3ca66f38ed60 = v; });
var $25bb9c3223c55ea4$export$e324594224ef24da;
var $25bb9c3223c55ea4$export$38e42c68cf43b5d4;
var $25bb9c3223c55ea4$export$7abe78e1eda562aa;
var $25bb9c3223c55ea4$export$db3c28d99448dcff;
var $25bb9c3223c55ea4$export$3ba0bfd74bc3a6fe;
var $25bb9c3223c55ea4$export$f3647d32653f0c72;
var $25bb9c3223c55ea4$export$1965191505a5f5a9;
var $25bb9c3223c55ea4$export$22b7a5d104e13fa5;
var $25bb9c3223c55ea4$export$19ee943b107f7e95;
var $25bb9c3223c55ea4$export$1f22e2e0afc9f037;
var $25bb9c3223c55ea4$export$7db60fb4c6d4a032;
var $25bb9c3223c55ea4$export$94e4009ecfbf7408;
var $25bb9c3223c55ea4$export$c86d3ca66f38ed60;
$25bb9c3223c55ea4$export$e324594224ef24da = `s3STda_actions`;
$25bb9c3223c55ea4$export$38e42c68cf43b5d4 = `s3STda_header`;
$25bb9c3223c55ea4$export$7abe78e1eda562aa = `s3STda_loginButton`;
$25bb9c3223c55ea4$export$db3c28d99448dcff = `s3STda_logo`;
$25bb9c3223c55ea4$export$3ba0bfd74bc3a6fe = `s3STda_logoImage`;
$25bb9c3223c55ea4$export$f3647d32653f0c72 = `s3STda_logoMain`;
$25bb9c3223c55ea4$export$1965191505a5f5a9 = `s3STda_logoPhone`;
$25bb9c3223c55ea4$export$22b7a5d104e13fa5 = `s3STda_logoSub`;
$25bb9c3223c55ea4$export$19ee943b107f7e95 = `s3STda_logoText`;
$25bb9c3223c55ea4$export$1f22e2e0afc9f037 = `s3STda_logoutButton`;
$25bb9c3223c55ea4$export$7db60fb4c6d4a032 = `s3STda_userAvatar`;
$25bb9c3223c55ea4$export$94e4009ecfbf7408 = `s3STda_userInfo`;
$25bb9c3223c55ea4$export$c86d3ca66f38ed60 = `s3STda_userName`;


const $fe44baf3183c7728$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($25bb9c3223c55ea4$exports);
const $fe44baf3183c7728$var$getFirstName = (user)=>{
    return user?.firstName || user?.lastName?.trim().replace(/\s.+/, '');
};
const $fe44baf3183c7728$var$getInitials = (user)=>{
    if (user.firstName !== undefined && user.lastName === undefined) return user?.firstName?.substring(0, 2).toUpperCase();
    else if (user.firstName === undefined && user.lastName !== undefined) return user?.lastName?.substring(0, 2).toUpperCase();
    return user?.firstName?.charAt(0).toUpperCase() + user?.lastName?.charAt(0).toUpperCase();
};
function $fe44baf3183c7728$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, logoutUser: logoutUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const providerId = window.EMBED_CONFIG?.providerId || '';
    const handleLogin = ()=>{
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('SHOW_LOGIN', {
            show: true
        });
    };
    const handleLogout = ()=>{
        if (window.confirm(t('confirm-logout') || 'Vill du logga ut?')) logoutUser();
    };
    const profileUrl = user ? (0, $8afe3747eee9983f$export$da85b9d72d60e6d5)('root') : null;
    const logoUrl = window.EMBED_CONFIG?.logoUrl || '/app/themes/taxi-stockholm/static/img/logo.png';
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.header),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                href: "/",
                className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.logo),
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.logoImage),
                    style: {
                        backgroundImage: `url(${logoUrl})`
                    }
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.actions),
                children: user ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("a", {
                        href: profileUrl,
                        className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.userInfo),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.userName),
                                children: $fe44baf3183c7728$var$getFirstName(user)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.userAvatar),
                                children: $fe44baf3183c7728$var$getInitials(user)
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    className: $fe44baf3183c7728$var$cx($25bb9c3223c55ea4$exports.loginButton),
                    onClick: handleLogin,
                    children: t('button-login') || 'Logga in'
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $7d5e9cfd6e8e6415$exports = {};


(function(global, factory) {
    factory($7d5e9cfd6e8e6415$exports, (parcelRequire("eCdfQ")), (parcelRequire("bh6RR")));
})($7d5e9cfd6e8e6415$exports, function(exports1, jsApiLoader, React) {
    'use strict';
    function _interopDefaultLegacy(e) {
        return e && typeof e === 'object' && 'default' in e ? e : {
            'default': e
        };
    }
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    /**
     * Copyright 2021 Google LLC. All Rights Reserved.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at.
     *
     *      Http://www.apache.org/licenses/LICENSE-2.0.
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */ exports1.Status = void 0;
    (function(Status) {
        Status["LOADING"] = "LOADING";
        Status["FAILURE"] = "FAILURE";
        Status["SUCCESS"] = "SUCCESS";
    })(exports1.Status || (exports1.Status = {}));
    /**
     * A component to wrap the loading of the Google Maps JavaScript API.
     *
     * ```
     * import { Wrapper } from '@googlemaps/react-wrapper';
     *
     * const MyApp = () => (
     * 	<Wrapper apiKey={'YOUR_API_KEY'}>
     * 		<MyMapComponent />
     * 	</Wrapper>
     * );
     * ```
     *
     * @param props
     */ const Wrapper = ({ children: children, render: render, callback: callback, ...options })=>{
        const [status, setStatus] = React.useState(exports1.Status.LOADING);
        React.useEffect(()=>{
            const loader = new jsApiLoader.Loader(options);
            const setStatusAndExecuteCallback = (status)=>{
                if (callback) callback(status, loader);
                setStatus(status);
            };
            setStatusAndExecuteCallback(exports1.Status.LOADING);
            loader.load().then(()=>setStatusAndExecuteCallback(exports1.Status.SUCCESS), ()=>setStatusAndExecuteCallback(exports1.Status.FAILURE));
        }, []);
        if (status === exports1.Status.SUCCESS && children) return React__default["default"].createElement(React__default["default"].Fragment, null, children);
        if (render) return render(status);
        return React__default["default"].createElement(React__default["default"].Fragment, null);
    };
    exports1.Wrapper = Wrapper;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});




var $650f2ef698fc6f68$exports = {};

$parcel$export($650f2ef698fc6f68$exports, "bounce", function () { return $650f2ef698fc6f68$export$e3ce947fb98643bf; }, function (v) { return $650f2ef698fc6f68$export$e3ce947fb98643bf = v; });
$parcel$export($650f2ef698fc6f68$exports, "dropAnim", function () { return $650f2ef698fc6f68$export$24bffbb762cdc352; }, function (v) { return $650f2ef698fc6f68$export$24bffbb762cdc352 = v; });
$parcel$export($650f2ef698fc6f68$exports, "isLoaded", function () { return $650f2ef698fc6f68$export$e141060ad697f932; }, function (v) { return $650f2ef698fc6f68$export$e141060ad697f932 = v; });
$parcel$export($650f2ef698fc6f68$exports, "loader", function () { return $650f2ef698fc6f68$export$f4c5de44377d2946; }, function (v) { return $650f2ef698fc6f68$export$f4c5de44377d2946 = v; });
$parcel$export($650f2ef698fc6f68$exports, "map", function () { return $650f2ef698fc6f68$export$871de8747c9eaa88; }, function (v) { return $650f2ef698fc6f68$export$871de8747c9eaa88 = v; });
var $650f2ef698fc6f68$export$e3ce947fb98643bf;
var $650f2ef698fc6f68$export$24bffbb762cdc352;
var $650f2ef698fc6f68$export$e141060ad697f932;
var $650f2ef698fc6f68$export$f4c5de44377d2946;
var $650f2ef698fc6f68$export$871de8747c9eaa88;
$650f2ef698fc6f68$export$e3ce947fb98643bf = `an9WHG_bounce`;
$650f2ef698fc6f68$export$e3ce947fb98643bf;
$650f2ef698fc6f68$export$24bffbb762cdc352 = `an9WHG_dropAnim`;
$650f2ef698fc6f68$export$e141060ad697f932 = `an9WHG_isLoaded`;
$650f2ef698fc6f68$export$f4c5de44377d2946 = `an9WHG_loader`;
$650f2ef698fc6f68$export$871de8747c9eaa88 = `an9WHG_map`;


const $a8850544475e04b7$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($650f2ef698fc6f68$exports);
const $a8850544475e04b7$var$settings = {
    // mapId: 'fcd856d6f8054356',
    mapId: "e52abccdf61d11e8",
    center: {
        lat: 59.323569,
        lng: 18.06683
    },
    zoom: 14
};
if (window.EMBED_CONFIG?.providerLocation) $a8850544475e04b7$var$settings.center = {
    lat: window.EMBED_CONFIG.providerLocation.latitude,
    lng: window.EMBED_CONFIG.providerLocation.longitude
};
const $a8850544475e04b7$var$formatPos = (pos)=>{
    return {
        lat: pos.latitude,
        lng: pos.longitude
    };
};
// NOTE: Only for debug
const $a8850544475e04b7$var$formatAddress = (address)=>{
    return address.streetNumber ? address.streetName + ' ' + address.streetNumber : address.streetName;
};
const $a8850544475e04b7$var$isMobile = ()=>window.innerWidth < 970;
// On mobile the form overlays the bottom of the map. After panTo the marker
// sits at the map's geometric centre, which is behind the form. Pan up by
// half the form height so the marker ends up in the visible centre above it.
// In embed mode the form is stacked below the map (not overlaying), so no offset.
const $a8850544475e04b7$var$getMobileBottomOffset = ()=>{
    if (window.EMBED_CONFIG?.isEmbed) return 0;
    const form = document.querySelector('.booking-module-modern-form');
    return form ? form.offsetHeight / 2 : 150;
};
// On desktop the form panel is right-aligned over the map, so the only visible
// map is the strip to its left. A marker panned to the geometric centre lands
// behind the panel — pan by half the inset to bring it into that strip.
// The value comes from --map-right-inset on .booking-module-modern so panel widths
// stay defined in one place: 724px normally, 942px fullscreen — which is what the
// embed uses, and why the old hardcoded 724/362 fell short there.
const $a8850544475e04b7$var$DEFAULT_RIGHT_INSET = 724;
const $a8850544475e04b7$var$getDesktopRightOffset = ()=>{
    const bm = document.querySelector('.booking-module-modern');
    if (!bm) return $a8850544475e04b7$var$DEFAULT_RIGHT_INSET;
    const inset = parseInt(getComputedStyle(bm).getPropertyValue('--map-right-inset'), 10);
    return Number.isFinite(inset) && inset > 0 ? inset : $a8850544475e04b7$var$DEFAULT_RIGHT_INSET;
};
const $a8850544475e04b7$var$MapComponent = ()=>{
    const elRef = (0, $bh6RR.useRef)();
    const mapRef = (0, $bh6RR.useRef)();
    const markersRef = (0, $bh6RR.useRef)();
    const exceptionsRef = (0, $bh6RR.useRef)();
    const listenersRef = (0, $bh6RR.useRef)();
    const timeoutRef = (0, $bh6RR.useRef)();
    const [isLoaded, setIsLoaded] = (0, $bh6RR.useState)(false);
    const initMap = ()=>{
        mapRef.current = new window.google.maps.Map(elRef.current, {
            mapId: $a8850544475e04b7$var$settings.mapId,
            gestureHandling: 'none',
            scrollwheel: false,
            disableDefaultUI: true,
            disableDoubleClickZoom: true,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            ...$a8850544475e04b7$var$settings
        });
        createMarkers();
        window.google.maps.event.addListenerOnce(mapRef.current, 'tilesloaded', ()=>{
            setIsLoaded(true);
            // NOTE: set tabindex to -1 for all elements in the map to avoid scrolling bug
            setTimeout(()=>{
                (0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#map-modern button, #map-modern *[tabindex="0"]').forEach((el)=>{
                    el.tabIndex = -1;
                });
            }, 100);
        // window.google.maps.event.addListener(mapRef.current, 'idle', () => {
        //   console.log('Map is idle')
        // })
        });
    };
    const createMarkers = async ()=>{
        const { AdvancedMarkerElement: AdvancedMarkerElement, PinElement: PinElement } = await google.maps.importLibrary('marker');
        markersRef.current = [];
        listenersRef.current = [];
        for(let i = 0; i < 10; i++){
            const pin = new PinElement({
                background: '#000000',
                borderColor: '#000000',
                glyphColor: '#FFFFFF',
                // glyph: character,
                scale: 1.25
            });
            const marker = new AdvancedMarkerElement({
                map: mapRef.current,
                // position: formatPos(location.address.position),
                content: pin.element
            });
            markersRef.current.push({
                marker: marker,
                pin: pin
            });
            listenersRef.current.push(null);
        }
    };
    const drawExeptionsZone = async ({ paths: paths, locations: locations })=>{
        if (mapRef.current) {
            const { AdvancedMarkerElement: AdvancedMarkerElement, PinElement: PinElement } = await google.maps.importLibrary('marker');
            resetExceptionsZone();
            clearTimeout(timeoutRef.current);
            if (exceptionsRef.current) exceptionsRef.current.zone = new google.maps.Polygon({
                paths: paths,
                strokeColor: "#0074ce",
                strokeOpacity: 1.0,
                strokeWeight: 2,
                fillColor: "#0074ce",
                fillOpacity: 0.15
            });
            exceptionsRef.current?.zone?.setMap(mapRef.current);
            // mapRef.current.setZoom(14)
            locations?.forEach((location)=>{
                const pin = new PinElement({
                    background: '#000000',
                    borderColor: '#FFFFFF',
                    glyphColor: '#FFFFFF',
                    // glyph: '1',
                    scale: 0.75
                });
                const marker = new AdvancedMarkerElement({
                    map: mapRef.current,
                    position: location,
                    content: pin.element
                });
                exceptionsRef.current.locations.push({
                    marker: marker,
                    pin: pin,
                    locationId: location.locationId
                });
            });
            const bounds = new google.maps.LatLngBounds();
            paths.forEach((path)=>{
                bounds.extend(path);
            });
            mapRef.current.fitBounds(bounds);
            if (!$a8850544475e04b7$var$isMobile()) mapRef.current.panBy($a8850544475e04b7$var$getDesktopRightOffset() / 2, 0); // desktop: adjust for right-side form panel
        // mapRef.current.panTo(new google.maps.LatLng(paths[0]));
        }
    };
    const resetExceptionsZone = ()=>{
        exceptionsRef?.current?.locations?.forEach((location)=>{
            location.marker.setMap(null);
        });
        if (exceptionsRef.current) exceptionsRef.current.locations = [];
        exceptionsRef?.current?.zone?.setMap(null);
        exceptionsRef.current = {
            locations: []
        };
    };
    const hoverListItem = ({ item: item })=>{
        exceptionsRef.current?.locations?.forEach((location)=>{
            if (location?.locationId === item.id) {
                location.pin.background = '#febf00';
                location.pin.scale = 1;
            } else {
                location.pin.background = '#000000';
                location.pin.scale = 0.75;
            }
        });
    //exceptionsRef.current.locations[item.locationId].marker.content = exceptionsRef.current.locations[item.locationId].pin.element;
    };
    const clearHoverListItem = ({ item: item })=>{
        exceptionsRef?.current?.locations?.forEach((location)=>{
            location.pin.background = '#000000';
            location.pin.scale = 0.75;
        });
    //exceptionsRef.current.locations[item.locationId].marker.content = exceptionsRef.current.locations[item.locationId].pin.element;    
    };
    const handleLocationChange = ({ locations: locations, active: active })=>{
        resetExceptionsZone();
        if (mapRef.current) {
            clearTimeout(timeoutRef.current);
            locations = locations.slice(-10);
            // NOTE: only for debug
            // locations.forEach(location => {
            //   if (location?.address) console.log(formatAddress(location.address))
            // })
            // Iterate map markers
            for(let i = 0; i < markersRef.current.length; i++){
                const m = markersRef.current[i];
                // If we have a location, set position and glyph
                if (locations[i]?.address?.position !== undefined) {
                    const position = $a8850544475e04b7$var$formatPos(locations[i].address.position);
                    m.marker.position = position;
                    m.exeptionZone = locations[i]?.mapExceptionZone || null;
                    m.pin.glyph = 'ABCDEFGHIJKLMNOPQRST'[i];
                    // If it is active, animate it
                    if (i === active) {
                        m.marker.content.addEventListener('animationend', ()=>{
                            m.marker.content.classList.remove($650f2ef698fc6f68$exports.dropAnim);
                        });
                        m.marker.content.classList.add($650f2ef698fc6f68$exports.dropAnim);
                        zoomPosition(m.marker.position, m.exeptionZone);
                    }
                    // Remove any previously added listeners
                    if (listenersRef[i]?.remove) listenersRef[i].remove();
                    // Create and add click listener
                    listenersRef[i] = m.marker.addListener('click', ()=>zoomPosition(m.marker.position, m.exeptionZone));
                } else {
                    m.marker.position = null;
                    if (listenersRef[i]?.remove) listenersRef[i].remove();
                }
            }
        }
    };
    const handleZoomLocation = (location)=>{
        if (mapRef.current && location?.address?.position !== undefined) {
            clearTimeout(timeoutRef.current);
            // Iterate map markers and find the one matching location position
            for(let i = 0; i < markersRef.current.length; i++){
                const m = markersRef.current[i];
                // Zoom to the marker
                if (m.marker?.position?.lat === location.address.position.latitude && m.marker?.position?.lng === location.address.position.longitude) zoomPosition(m.marker.position, m.exeptionZone);
            }
        }
    };
    // Frame the current markers for the current viewport size. Split out of
    // handleDisplayTrip so a resize can re-frame without also clearing a drawn
    // exception zone.
    const frameMarkers = ()=>{
        if (mapRef.current && markersRef.current) {
            const numLocations = markersRef.current.reduce((a, m)=>m.marker.position !== null ? a + 1 : a, 0);
            if (numLocations > 1) {
                const bounds = new google.maps.LatLngBounds();
                markersRef.current.forEach((m)=>{
                    if (m?.marker?.position) bounds.extend(m.marker.position);
                });
                if ($a8850544475e04b7$var$isMobile()) {
                    const formHeight = $a8850544475e04b7$var$getMobileBottomOffset() * 2;
                    mapRef.current.fitBounds(bounds, {
                        top: 50,
                        bottom: formHeight,
                        left: 50,
                        right: 50
                    });
                } else mapRef.current.fitBounds(bounds, {
                    top: 100,
                    bottom: 250,
                    left: 100,
                    right: $a8850544475e04b7$var$getDesktopRightOffset()
                });
            } else {
                mapRef.current.setZoom($a8850544475e04b7$var$settings.zoom);
                const m = markersRef.current.find((m)=>m.marker.position !== null);
                if (m?.marker?.position) {
                    mapRef.current.panTo(m.marker.position);
                    if (!$a8850544475e04b7$var$isMobile()) mapRef.current.panBy($a8850544475e04b7$var$getDesktopRightOffset() / 2, 0); // desktop: adjust for right-side form panel
                    else mapRef.current.panBy(0, $a8850544475e04b7$var$getMobileBottomOffset()); // mobile: pan center down so marker appears above the form
                }
            }
        }
    };
    const handleDisplayTrip = ()=>{
        if (mapRef.current) {
            clearTimeout(timeoutRef.current);
            resetExceptionsZone();
            frameMarkers();
        }
    };
    const handleReset = ()=>{
        if (mapRef.current) {
            clearTimeout(timeoutRef.current);
            markersRef.current.forEach((m)=>m.marker.position = null);
            mapRef.current.panTo($a8850544475e04b7$var$settings.center);
            mapRef.current.setZoom($a8850544475e04b7$var$settings.zoom);
        }
    };
    const zoomPosition = (position, exceptionZone)=>{
        //if(exceptionsRef.current) return;
        if (exceptionZone) drawExeptionsZone({
            paths: exceptionZone.area.coordinates[0].map((coord)=>({
                    lat: coord[1],
                    lng: coord[0]
                }))
        });
        else resetExceptionsZone();
        clearTimeout(timeoutRef.current);
        mapRef.current.setZoom($a8850544475e04b7$var$settings.zoom + 2);
        mapRef.current.panTo(position);
        if ($a8850544475e04b7$var$isMobile()) mapRef.current.panBy(0, $a8850544475e04b7$var$getMobileBottomOffset()); // mobile: pan center down so marker appears above the form
        else mapRef.current.panBy($a8850544475e04b7$var$getDesktopRightOffset() / 2, 0); // desktop: adjust for right-side form panel
        displayTrip();
    };
    const displayTrip = ()=>{
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(handleDisplayTrip, 5000);
    };
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('HOVER_LIST_ITEM', hoverListItem);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CLEAR_ITEM_HOVER', clearHoverListItem);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('LOCATION_CHANGE', handleLocationChange);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('DRAW_EXEPTIONS_ZONE', drawExeptionsZone);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('ZOOM_LOCATION', handleZoomLocation);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('DISPLAY_TRIP', handleDisplayTrip);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_MAP', handleReset);
    (0, $bh6RR.useEffect)(()=>{
        if (!mapRef.current) initMap();
    });
    // Two jobs, both triggered by the container changing size.
    //
    // 1. A map constructed while its container is hidden (display:none) or zero-sized
    //    requests no tiles, so 'tilesloaded' never fires — isLoaded stays false and the
    //    map is left at opacity:0 permanently, even once the container is shown again.
    //    That is the "map never loads in fullscreen" case.
    // 2. Re-frame the markers. Preserving the old centre is not enough: the offsets
    //    that keep pins clear of the form panel differ between breakpoints and panel
    //    widths, so after a resize — or a mobile/desktop crossover — a centre computed
    //    for the old size leaves the pins under the panel. Only picking a new location
    //    re-framed before, which is why that looked correct and resizing did not.
    (0, $bh6RR.useEffect)(()=>{
        if (!elRef.current || !window.ResizeObserver) return;
        let reframeTimer = null;
        const observer = new ResizeObserver((entries)=>{
            const { width: width, height: height } = entries[0].contentRect;
            if (!width || !height || !mapRef.current) return;
            setIsLoaded(true);
            // Debounced: a drag-resize fires this continuously.
            clearTimeout(reframeTimer);
            reframeTimer = setTimeout(frameMarkers, 150);
        });
        observer.observe(elRef.current);
        return ()=>{
            clearTimeout(reframeTimer);
            observer.disconnect();
        };
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        ref: elRef,
        id: "map",
        className: $a8850544475e04b7$var$cx($650f2ef698fc6f68$exports.map, {
            isLoaded: isLoaded
        })
    });
};
const $a8850544475e04b7$var$render = (status)=>{
    switch(status){
        case (0, $7d5e9cfd6e8e6415$exports.Status).LOADING:
            return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $650f2ef698fc6f68$exports.loader,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {})
            });
        case (0, $7d5e9cfd6e8e6415$exports.Status).FAILURE:
            return 'Error';
        case (0, $7d5e9cfd6e8e6415$exports.Status).SUCCESS:
            return /*#__PURE__*/ (0, $ih19M.jsx)($a8850544475e04b7$var$MapComponent, {});
    }
};
const $a8850544475e04b7$var$Map = ()=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $7d5e9cfd6e8e6415$exports.Wrapper), {
        apiKey: "AIzaSyCVkV2uTILscU5D4Zij6bf4zPedVjtb534",
        render: $a8850544475e04b7$var$render
    });
var $a8850544475e04b7$export$2e2bcd8739ae039 = $a8850544475e04b7$var$Map;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");








var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");







var $7c24355415e24558$export$c2de8e0aab246379;
var $7c24355415e24558$export$6f093cfa640b7166;
$7c24355415e24558$export$c2de8e0aab246379 = `XnXoGq_locations`;
$7c24355415e24558$export$6f093cfa640b7166 = `XnXoGq_text`;






const $01439255389c0b13$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $01439255389c0b13$var$SelectLocations = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const handleFocus = (event, location)=>{
        if (location?.address) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('ZOOM_LOCATION', location);
        // Disable cover widget
        APP.trigger(APP.events.BOOKING_MODULE_DISABLE_HIDE_MAP);
    };
    const gotoTime = ()=>{
        wrappedNext('time');
    };
    const gotoWhat = ()=>{
        setFieldValue('pickupTime', '');
        wrappedNext('what');
    };
    const buttons = [
        {
            func: gotoTime,
            title: t('button-prebook-delivery')
        },
        {
            func: gotoWhat,
            title: t('button-book-delivery-now')
        }
    ];
    (0, $bh6RR.useEffect)(()=>{
        APP.trigger(APP.events.BOOKING_MODULE_ENABLE_HIDE_MAP);
    }, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $01439255389c0b13$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            tabsLeft: false,
            fullscreen: fullscreen
        }),
        children: [
            fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                            onlyFullscreen: true,
                            children: inEditMode ? t('edit-your-trip') : t('your-trip')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                            onlyMobile: true,
                            children: t('header-where-do-you-want-to-go')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                            values: values,
                            showHow: true,
                            currentView: currentView
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9248d934b0a2f4d5$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: fullscreen ? $f35967c56a9f3d99$exports.contentBottom : null,
                children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                    noStyle: fullscreen,
                    children: [
                        fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                            onlyFullscreen: true,
                            children: t('header-where-do-you-want-to-go')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $9248d934b0a2f4d5$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $7c24355415e24558$export$c2de8e0aab246379,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "departure",
                                    fieldIndex: 0,
                                    placeholder: t('placeholder-pickup-address'),
                                    component: (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039),
                                    onFocus: (e)=>handleFocus(e, values.departure),
                                    useLocation: true
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "destination",
                                    fieldIndex: 1,
                                    placeholder: t('placeholder-delivery-address'),
                                    component: (0, $b6b4255c134cf0ab$export$2e2bcd8739ae039),
                                    onFocus: (e)=>handleFocus(e, values.destination)
                                })
                            ]
                        }),
                        user === null && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: $7c24355415e24558$export$6f093cfa640b7166,
                            children: t('booking-login-info')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$01439255389c0b13$var$SelectLocations.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    // TODO: This does not work when loading JSON from the server... 
    departure: $e6d972962a22d393$export$185802fd694ee1f5().nullable().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-pickup-address-required')),
    destination: $e6d972962a22d393$export$185802fd694ee1f5().nullable().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-delivery-address-required'))
});
var $01439255389c0b13$export$2e2bcd8739ae039 = $01439255389c0b13$var$SelectLocations;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



var $igItr = parcelRequire("igItr");
var $8MQJ5 = parcelRequire("8MQJ5");
var $hBud4 = parcelRequire("hBud4");
var $kzEvi = parcelRequire("kzEvi");
var $j1vsN = parcelRequire("j1vsN");





var $2c83c708069106b6$export$a2abc71b50183d06;
$2c83c708069106b6$export$a2abc71b50183d06 = `_85QTXq_datepicker`;





const $bc728e1a6ca25f9d$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $bc728e1a6ca25f9d$var$getMinDate = ()=>(0, $8MQJ5.default)((0, $j1vsN.default)((0, $ae4bf4599579267f$export$2e2bcd8739ae039)(new Date(), {
        nearestTo: 5
    }), 0), 30);
const $bc728e1a6ca25f9d$var$getMaxDate = ()=>(0, $igItr.default)((0, $hBud4.default)((0, $kzEvi.default)((0, $j1vsN.default)(new Date(), 0), 59), 23), 27);
const $bc728e1a6ca25f9d$var$SelectTime = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const minDate = $bc728e1a6ca25f9d$var$getMinDate();
    const maxDate = $bc728e1a6ca25f9d$var$getMaxDate();
    const clampDate = (date)=>(0, $9a41dab598251ed0$export$2e2bcd8739ae039)(date, {
            start: minDate,
            end: maxDate
        });
    const goNow = ()=>{
        setFieldValue('pickupTime', '', false);
        next();
    };
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: goNow,
            title: t('button-book-delivery-now')
        },
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $bc728e1a6ca25f9d$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: t('header-when-should-we-pickup')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        showTime: true,
                        currentView: currentView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: t('header-when-should-we-pickup')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                        className: $f35967c56a9f3d99$exports.content,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $2c83c708069106b6$export$a2abc71b50183d06,
                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                            name: "pickupTime",
                                            minDate: minDate,
                                            maxDate: maxDate,
                                            clampDate: clampDate,
                                            component: (0, $d2eecefb00e70187$export$2e2bcd8739ae039)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                                        name: "pickupTime",
                                        component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$exports.group,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "pickupTime",
                                    minDate: minDate,
                                    maxDate: maxDate,
                                    clampDate: clampDate,
                                    component: (0, $feceed654bcbd7e8$export$2e2bcd8739ae039)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$bc728e1a6ca25f9d$var$SelectTime.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    pickupTime: $2efeb86fe7f1b8d4$export$185802fd694ee1f5().min($bc728e1a6ca25f9d$var$getMinDate(), (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-not-valid')).max($bc728e1a6ca25f9d$var$getMaxDate(), (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-date-too-far-ahead')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-date'))
});
var $bc728e1a6ca25f9d$export$2e2bcd8739ae039 = $bc728e1a6ca25f9d$var$SelectTime;



var $ih19M = parcelRequire("ih19M");


var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









var $7e08a1d155d9ed12$export$a3bc9b8ed74fc;
var $7e08a1d155d9ed12$export$1ca1ec8b29a4ce27;
var $7e08a1d155d9ed12$export$df03f54e09e486fa;
var $7e08a1d155d9ed12$export$a80b3bd66acc52ff;
$7e08a1d155d9ed12$export$a3bc9b8ed74fc = `-buDlW_error`;
$7e08a1d155d9ed12$export$1ca1ec8b29a4ce27 = `-buDlW_icon`;
$7e08a1d155d9ed12$export$df03f54e09e486fa = `-buDlW_icons`;
$7e08a1d155d9ed12$export$a80b3bd66acc52ff = `-buDlW_info`;




const $117b606f38c641db$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $117b606f38c641db$var$SelectWhat = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const fields = [
        {
            type: 'ENVELOPE',
            title: t('title-ENVELOPE'),
            info: '',
            max: 100000
        },
        {
            type: 'BOX',
            title: t('title-BOX'),
            info: t('weight-0-20'),
            max: 4
        },
        {
            type: 'BAG',
            title: t('title-BAG'),
            info: t('weight-0-20'),
            max: 4
        },
        {
            type: 'MOVING_BOX',
            title: t('title-MOVING_BOX'),
            info: t('weight-0-20'),
            max: 2
        }
    ];
    const openModal = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-delivery-terms'));
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(()=>{
        if (!user) next();
        else next('sender');
    }, (0, $lW2XZ.useFormikContext)());
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ];
    const icons = [
        'no-animals.svg',
        'no-dangerous-goods.svg',
        'no-food.svg',
        'no-tobacco.svg'
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $117b606f38c641db$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: t('header-what-would-you-like-to-send')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        currentView: currentView
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: t('header-what-would-you-like-to-send')
                    }),
                    fields.map((field, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                            name: field.type,
                            component: (0, $64b9d58ae0ce99b7$export$2e2bcd8739ae039),
                            ...field
                        }, index)),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $7e08a1d155d9ed12$export$a3bc9b8ed74fc,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                            name: "hasPackages",
                            component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $7e08a1d155d9ed12$export$a80b3bd66acc52ff,
                        children: t('info-delivery-categories')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $117b606f38c641db$var$cx($f35967c56a9f3d99$exports.fullWidth, $f35967c56a9f3d99$exports.smaller),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7e08a1d155d9ed12$export$df03f54e09e486fa,
                                children: icons.map((icon, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                        src: `/app/themes/taxi-stockholm/static/img/${icon}`,
                                        className: $7e08a1d155d9ed12$export$1ca1ec8b29a4ce27
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $8879b7f8b812ce42$export$8d6a9236f2e3f2ce), {
                                i18nKey: "info-delivery",
                                components: {
                                    button1: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                        onClick: openModal,
                                        className: $f35967c56a9f3d99$exports.linkButton
                                    })
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
// SelectWhat.validationSchema = null
$117b606f38c641db$var$SelectWhat.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    ENVELOPE: $6e6ad40c65975a5d$export$185802fd694ee1f5(),
    BOX: $6e6ad40c65975a5d$export$185802fd694ee1f5(),
    BAG: $6e6ad40c65975a5d$export$185802fd694ee1f5(),
    MOVING_BOX: $6e6ad40c65975a5d$export$185802fd694ee1f5(),
    hasPackages: $82dfc9a766b01b73$export$185802fd694ee1f5().when([
        'ENVELOPE',
        'BOX',
        'BAG',
        'MOVING_BOX'
    ], {
        is: (...args)=>{
            const sum = args.reduce((acc, cur)=>acc + cur);
            return isNaN(sum) || sum === 0;
        },
        then: ()=>$82dfc9a766b01b73$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-package-required')),
        otherwise: ()=>$82dfc9a766b01b73$export$185802fd694ee1f5()
    })
});
var $117b606f38c641db$export$2e2bcd8739ae039 = $117b606f38c641db$var$SelectWhat;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");














const $f3c13f60b19c7ceb$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $f3c13f60b19c7ceb$var$cxPanel = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($234ae484ae699dc2$exports);
const $f3c13f60b19c7ceb$var$getPaymentText = (value, accounts)=>{
    if (value !== 'PayInCar') return accounts.find((a)=>a.accountNumber === parseInt(value))?.accountName;
    return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-pay-in-car-sender');
};
const $f3c13f60b19c7ceb$var$SelectSender = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user, paymentAccounts: paymentAccounts, setPreferredPaymentAccount: setPreferredPaymentAccount } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, errors: errors, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const paymentError = (0, $lW2XZ.getIn)(errors, 'payment');
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const paymentButtonRef = (0, $bh6RR.useRef)();
    const payInCarRef = (0, $bh6RR.useRef)();
    const wrappedPrev = ()=>{
        prev('what');
    };
    const prevAccounts = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(user?.accounts);
    const prevPaymentAccounts = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(paymentAccounts);
    const disableCreditCards = !values.priceType?.paymentMethods?.includes('CreditCard');
    const disableTSABAccounts = !values.priceType?.paymentMethods?.includes('TSABAccount');
    const disableTCAAccounts = !values.priceType?.paymentMethods?.includes('TravelClearingAccount');
    const showReference = values?.company !== false || values?.account?.type === 'TSAB' || values?.account?.type === 'TCA';
    const needReference = values?.company?.requireReference === true || values?.account !== false && (values?.account?.type === 'TSAB' || values?.account?.type === 'TCA') && values?.account?.flags?.includes('reference');
    const openReference = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue(id, val, false),
                fields: [
                    {
                        id: 'accountReference',
                        title: t('placeholder-reference')
                    }
                ],
                title: t('placeholder-reference'),
                onClose: close
            }));
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const setAccount = (account)=>{
        if (!account) setFieldValue('accountReference', '', false);
        setFieldValue('account', account, false);
    };
    const buttons = [
        {
            func: wrappedPrev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $f3c13f60b19c7ceb$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: t('header-whos-the-sender')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        currentView: currentView,
                        showPayment: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: t('header-whos-the-sender')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "name",
                        placeholder: t('placeholder-name'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "phone",
                        placeholder: t('placeholder-phone'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageSender.nameOnDoor",
                        placeholder: t('placeholder-name-on-door'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageSender.numberOfStairs",
                        placeholder: t('placeholder-number-of-stairs'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageSender.doorCode",
                        placeholder: t('placeholder-door-code'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $f3c13f60b19c7ceb$var$cx($f3c13f60b19c7ceb$var$cxPanel($234ae484ae699dc2$exports.title), {
                            'text-[#da0a2b]': paymentError
                        }),
                        children: t('title-payment')
                    }),
                    paymentError && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "text-[#da0a2b] text-sm mb-2",
                        children: paymentError
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        icon: "PayInCar",
                        name: "payment",
                        title: t('title-pay-in-car'),
                        value: "PayInCar",
                        onClick: ()=>setAccount(false),
                        innerRef: payInCarRef,
                        component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                    }),
                    user?.accounts?.map((account, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                            type: "radio",
                            name: "payment",
                            icon: "TSAB",
                            title: account.accountName,
                            info: account.accountNumber,
                            value: `Account-${account.accountNumber}`,
                            onClick: ()=>setAccount(account),
                            tabIndex: "0",
                            disabled: account.type === 'TSAB' && disableTSABAccounts || account.type === 'TCA' && disableTCAAccounts,
                            component: (0, $3dde695a71cd735d$export$2e2bcd8739ae039)
                        }, index)),
                    showReference && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $51837c0e5cd1599b$export$2e2bcd8739ae039), {
                                title: t('placeholder-reference'),
                                value: !values.accountReference || values.accountReference.trim() === '' ? needReference ? t('validation-need-reference') : '' : values.accountReference,
                                icon: "Reference",
                                changeToggle: openReference,
                                required: true,
                                empty: (!values.accountReference || values.accountReference.trim() === '') && needReference ? true : false
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $f35967c56a9f3d99$exports.hidden,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                    name: "accountReference",
                                    placeholder: t('placeholder-reference'),
                                    maxLength: "40",
                                    component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$f3c13f60b19c7ceb$var$SelectSender.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    name: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-name')),
    phone: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-phone')),
    packageDeliveryInfo: $e6d972962a22d393$export$185802fd694ee1f5({
        packageSender: $e6d972962a22d393$export$185802fd694ee1f5({
            numberOfStairs: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')),
            doorCode: $a0206caf38308288$export$185802fd694ee1f5()
        })
    }),
    payment: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-payment')).notOneOf([
        'DefaultNoSelect'
    ], (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-payment')),
    accountReference: $a0206caf38308288$export$185802fd694ee1f5().when('account', (account)=>{
        return account && account?.flags && account?.flags?.includes('reference') ? $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-reference')) : $a0206caf38308288$export$185802fd694ee1f5();
    })
});
var $f3c13f60b19c7ceb$export$2e2bcd8739ae039 = $f3c13f60b19c7ceb$var$SelectSender;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");








var $0e711196db97b898$export$a80b3bd66acc52ff;
var $0e711196db97b898$export$21ba78b50397401d;
var $0e711196db97b898$export$a8ecead220dd38a6;
$0e711196db97b898$export$a80b3bd66acc52ff = `Zu4f4W_info`;
$0e711196db97b898$export$21ba78b50397401d = `Zu4f4W_instructions`;
$0e711196db97b898$export$a8ecead220dd38a6 = `Zu4f4W_message`;




const $6ddc6b8c39af970b$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $6ddc6b8c39af970b$var$SelectReceiver = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isPanelOpen, setIsPanelOpen] = (0, $bh6RR.useState)(false);
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(next, (0, $lW2XZ.useFormikContext)());
    const openPanel = ()=>{
        setIsPanelOpen(true);
    };
    const closePanel = ()=>{
        setIsPanelOpen(false);
    };
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-continue')
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $6ddc6b8c39af970b$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyMobile: true,
                        children: t('header-whos-the-receiver')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        currentView: currentView,
                        showPayment: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
                className: $f35967c56a9f3d99$exports.contentBottom,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        onlyFullscreen: true,
                        children: t('header-whos-the-receiver')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageReceiver.nameOnDoor",
                        placeholder: t('placeholder-name-receiver-on-door'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageReceiver.phoneNumber",
                        placeholder: t('placeholder-phone-receiver'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageReceiver.numberOfStairs",
                        placeholder: t('placeholder-number-of-stairs'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageReceiver.doorCode",
                        placeholder: t('placeholder-door-code'),
                        component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                        border: true
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        name: "packageDeliveryInfo.packageReceiver.leaveOutsideDoor",
                        title: t('title-leave-outside'),
                        tabIndex: "0",
                        alternateBackground: true,
                        component: (0, $20f208c249841caf$export$2e2bcd8739ae039)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$6ddc6b8c39af970b$var$SelectReceiver.validationSchema = $e6d972962a22d393$export$185802fd694ee1f5({
    packageDeliveryInfo: $e6d972962a22d393$export$185802fd694ee1f5({
        packageReceiver: $e6d972962a22d393$export$185802fd694ee1f5({
            nameOnDoor: $a0206caf38308288$export$185802fd694ee1f5().required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-name-receiver-required')),
            phoneNumber: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')).required((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-need-phone')),
            numberOfStairs: $a0206caf38308288$export$185802fd694ee1f5().matches(/^\+?\d+$/, (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('validation-only-numbers')),
            doorCode: $a0206caf38308288$export$185802fd694ee1f5()
        })
    })
});
var $6ddc6b8c39af970b$export$2e2bcd8739ae039 = $6ddc6b8c39af970b$var$SelectReceiver;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");










var $53a2892bfbd35695$export$950c571e8f12d47e;
$53a2892bfbd35695$export$950c571e8f12d47e = `Ha2uuW_hideOverflow`;



const $93c6ef86157d5144$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $93c6ef86157d5144$var$ConfirmBooking = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const { prev: prev, next: next } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { user: user, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, errors: errors, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const makeRequest = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$3877e99530b0c773)(values, user.userId).then((response)=>{
            if (!isNaN(response?.bookingId)) {
                getActiveBookings();
                setFieldValue('bookingId', response.bookingId, false);
                next();
            }
        }).catch((error)=>{
            if (error?.response?.error === 'INVALID_PHONE_NUMBER') setFieldError('phone', error?.response?.message);
            else if (!(error?.isUnauthorized || error?.status === 401 || error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) {
                console.error(error);
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const wrappedNext = (0, $30acdccbb47e8004$export$95742212c462b028)(makeRequest, (0, $lW2XZ.useFormikContext)());
    // Deliveries are fixed price only. If the estimate failed we have no priceToken, and the
    // backend would reject the booking (FIXED_PRICE_REQUIRED), so block "Book now" and offer a retry.
    const fixedPrice = values.autoValues?.fixedPrice ?? values.fixedPrice;
    const priceMissing = !!fixedPrice && !values.priceToken;
    const retryEstimate = ()=>(0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RETRY_PRICE_ESTIMATE');
    const buttons = [
        {
            func: prev,
            isBack: true
        },
        {
            func: wrappedNext,
            title: t('button-book-now'),
            isLoading: isLoading || values.priceIsLoading,
            disabled: priceMissing
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $93c6ef86157d5144$var$cx($f35967c56a9f3d99$exports.widgetWrapper, $53a2892bfbd35695$export$950c571e8f12d47e, {
            fullHeight: fullscreen,
            narrow: true,
            isLoading: isLoading
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                noRadius: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: t('header-confirm-your-booking')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        currentView: currentView,
                        showPayment: true
                    }),
                    priceMissing && !values.priceIsLoading && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039), {
                        children: [
                            errors.fixedPrice || t('info-price-estimate-failed'),
                            ' ',
                            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                                type: "button",
                                onClick: retryEstimate,
                                className: "underline font-medium",
                                children: t('button-try-again')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$93c6ef86157d5144$var$ConfirmBooking.validationSchema = null;
var $93c6ef86157d5144$export$2e2bcd8739ae039 = $93c6ef86157d5144$var$ConfirmBooking;



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");












var $f8fd753642c3e709$export$950c571e8f12d47e;
$f8fd753642c3e709$export$950c571e8f12d47e = `_6vqfBa_hideOverflow`;



const $9188c498882407de$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $9188c498882407de$var$BookingDone = ({ fullscreen: fullscreen, currentView: currentView })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values, resetForm: resetForm } = (0, $lW2XZ.useFormikContext)();
    const { reset: resetStepper } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { bookings: bookings, getActiveBookings: getActiveBookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [isLoading, setIsLoading] = (0, $bh6RR.useState)(false);
    const booking = bookings?.find((item)=>item.id === values.bookingId);
    const cancelBooking = ()=>{
        setIsLoading(true);
        (0, $135a523c4bea715f$export$b7b1ce5fabd1b486)(values?.bookingId).then((response)=>{
            getActiveBookings();
            close();
        }).catch((error)=>{
            if (error?.response?.error === 'ALREADY_CANCELLED_BOOKING') {
                getActiveBookings();
                close();
            } else if (!(error?.isUnauthorized || error?.status === 401 || error?.response?.status === 401 && error?.response?.error === 'Unauthorized')) {
                console.error(error);
                (0, $30acdccbb47e8004$export$eb122250488b74d5)(error?.response?.message || error?.message || 'Ett fel uppstod');
            }
        }).finally(()=>{
            setIsLoading(false);
        });
    };
    const cancel = ()=>{
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(COPY.booking.receipt_confirm_cancel, [
            {
                title: COPY.booking.button_ok,
                callback: cancelBooking
            },
            {
                title: COPY.booking.button_cancel
            }
        ]);
    };
    const close = ()=>{
        resetForm();
        resetStepper();
    };
    const buttons = [
        {
            func: cancel,
            title: t('button-cancel-booking'),
            disabled: booking && !(0, $c94184dfef1a7d71$export$4d66b7747958f839)(booking),
            isLoading: isLoading
        },
        {
            func: close,
            title: t('button-close')
        }
    ];
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CANCEL_BOOKING', (bookingId)=>{
        if (values.bookingId === bookingId) close();
    }, [
        values.bookingId
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $9188c498882407de$var$cx($f35967c56a9f3d99$exports.widgetWrapper, $f8fd753642c3e709$export$950c571e8f12d47e, {
            fullHeight: fullscreen,
            narrow: true,
            isLoading: isLoading
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                noRadius: true,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: booking ? (0, $c94184dfef1a7d71$export$32e796a9286f339b)(booking) : '\u00A0'
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $e79afbceef721183$export$2e2bcd8739ae039), {
                        values: values,
                        currentView: currentView,
                        showHow: true,
                        showPayment: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: buttons,
                fullscreen: fullscreen
            })
        ]
    });
};
$9188c498882407de$var$BookingDone.validationSchema = null;
var $9188c498882407de$export$2e2bcd8739ae039 = $9188c498882407de$var$BookingDone;


var $5ee31b187546b2ff$exports = {};

$parcel$export($5ee31b187546b2ff$exports, "bookingwidget", function () { return $5ee31b187546b2ff$export$4936eb119b30c4d; }, function (v) { return $5ee31b187546b2ff$export$4936eb119b30c4d = v; });
var $5ee31b187546b2ff$export$4936eb119b30c4d;
$5ee31b187546b2ff$export$4936eb119b30c4d = `CreBYq_bookingwidget`;




parcelRequire("kEUo3");
const $8d3f5c7c22e09279$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($5ee31b187546b2ff$exports);
const $8d3f5c7c22e09279$var$PackageModule = ()=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    let initialValues = {
        autoValues: {
            pickupTime: null,
            serviceType: null,
            fixedPrice: null
        },
        pickupTime: '',
        departure: '',
        destination: '',
        serviceType: 'delivery',
        priceToken: '',
        ENVELOPE: 0,
        BOX: 0,
        BAG: 0,
        MOVING_BOX: 0,
        payment: 'DefaultNoSelect',
        name: '',
        phone: '',
        generalComment: '',
        accountReference: '',
        account: false,
        fixedPrice: true,
        priceIsLoading: false,
        priceEstimate: '',
        originInfo: [],
        packageDeliveryInfo: {
            packageSender: {
                nameOnDoor: '',
                doorCode: '',
                numberOfStairs: ''
            },
            packageReceiver: {
                nameOnDoor: '',
                phoneNumber: '',
                doorCode: '',
                numberOfStairs: '',
                leaveOutsideDoor: false
            },
            otherInformation: ''
        },
        availability: {
            direct: false,
            prebook: false
        },
        availabilityIsLoading: false
    };
    //   let temp = {
    //     "pickupTime": new Date('2023-05-13T13:30:00.000Z'),
    //     "departure": {
    //       "address": {
    //         "position": {
    //           "latitude": 59.31483,
    //           "longitude": 18.07383
    //         },
    //         "zone": 172,
    //         "streetName": "Kvarnen Restaurang",
    //         "city": "Stockholm"
    //       },
    //       "locationTypes": [
    //         "RESTAURANT"
    //       ],
    //       "availableCars": 997,
    //       "pointOfInterest": true
    //     },
    //     "destination": {
    //       "address": {
    //         "position": {
    //           "latitude": 59.29792,
    //           "longitude": 18.07497
    //         },
    //         "zone": 811,
    //         "streetName": "Etsarvägen",
    //         "streetNumber": "2",
    //         "city": "Stockholm"
    //       },
    //       "locationTypes": [
    //         "ADDRESS"
    //       ],
    //       "availableCars": 997,
    //       "pointOfInterest": false
    //     },
    //     "serviceType": "delivery",
    //     "priceToken": "",
    //     "ENVELOPE": 4,
    //     "BOX": 0,
    //     "BAG": 0,
    //     "MOVING_BOX": 1,
    //     "packageDeliveryInfo": {
    //       "packageSender": {
    //         "nameOnDoor": "We Are Yours",
    //         "doorCode": "1234",
    //         "numberOfStairs": "4"
    //       },
    //       "packageReceiver": {
    //         "nameOnDoor": "",
    //         "phoneNumber": "",
    //         "doorCode": "",
    //         "numberOfStairs": "",
    //         "leaveOutsideDoor": false
    //       }
    //     }
    //   }
    //   initialValues = { ...initialValues, ...temp }
    // initialValues = {
    //   "pickupTime": new Date('2023-05-13T13:30:00.000Z'),
    //   "departure": {
    //     "address": {
    //       "position": {
    //         "latitude": 59.31483,
    //         "longitude": 18.07383
    //       },
    //       "zone": 172,
    //       "streetName": "Kvarnen Restaurang",
    //       "city": "Stockholm"
    //     },
    //     "locationTypes": [
    //       "RESTAURANT"
    //     ],
    //     "availableCars": 997,
    //     "pointOfInterest": true
    //   },
    //   "destination": {
    //     "address": {
    //       "position": {
    //         "latitude": 59.29792,
    //         "longitude": 18.07497
    //       },
    //       "zone": 811,
    //       "streetName": "Etsarvägen",
    //       "streetNumber": "2",
    //       "city": "Stockholm"
    //     },
    //     "locationTypes": [
    //       "ADDRESS"
    //     ],
    //     "availableCars": 997,
    //     "pointOfInterest": false
    //   },
    //   "serviceType": "delivery",
    //   "priceToken": "",
    //   "ENVELOPE": 4,
    //   "BOX": 0,
    //   "BAG": 0,
    //   "MOVING_BOX": 1,
    //   "payment": "PayInCar",
    //   "name": "David Genelid",
    //   "phone": "0702515824",
    //   "generalComment": "",
    //   "accountReference": "",
    //   "account": false,
    //   "fixedPrice": true,
    //   "priceIsLoading": false,
    //   "priceEstimate": "",
    //   "packageDeliveryInfo": {
    //     "packageSender": {
    //       "nameOnDoor": "We Are Yours",
    //       "doorCode": "1234",
    //       "numberOfStairs": "4"
    //     },
    //     "packageReceiver": {
    //       "nameOnDoor": "Karl Wahlström",
    //       "phoneNumber": "08123456789",
    //       "doorCode": "9988",
    //       "numberOfStairs": "3",
    //       "leaveOutsideDoor": false
    //     },
    //     "otherInformation": "Ring innan lämning."
    //   }
    // }
    const views = [
        {
            id: 'locations',
            component: (0, $01439255389c0b13$export$2e2bcd8739ae039)
        },
        {
            id: 'time',
            component: (0, $bc728e1a6ca25f9d$export$2e2bcd8739ae039)
        },
        {
            id: 'what',
            component: (0, $117b606f38c641db$export$2e2bcd8739ae039)
        },
        {
            id: 'otpflow',
            component: (0, $f3d0713c6d8a0a0e$export$2e2bcd8739ae039)
        },
        {
            id: 'sender',
            component: (0, $f3c13f60b19c7ceb$export$2e2bcd8739ae039)
        },
        {
            id: 'receiver',
            component: (0, $6ddc6b8c39af970b$export$2e2bcd8739ae039)
        },
        {
            id: 'confirm',
            component: (0, $93c6ef86157d5144$export$2e2bcd8739ae039)
        },
        {
            id: 'done',
            component: (0, $9188c498882407de$export$2e2bcd8739ae039)
        }
    ];
    const [fullscreen, setFullscreen] = (0, $bh6RR.useState)(false);
    const [bookingStarted, setBookingStarted] = (0, $bh6RR.useState)(false);
    const bookingStartedRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        bookingStartedRef.current = bookingStarted;
    }, [
        bookingStarted
    ]);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
        setBookingStarted(false);
        bookingStartedRef.current = false; // see BookingModule: handleViewChange reads this synchronously
        setFullscreen(false);
        APP.trigger(APP.events.BOOKING_MODULE_END_FULLSCREEN);
    }, [
        setFullscreen,
        setBookingStarted
    ]);
    // Runs synchronously from ViewListener's layout effect (no setTimeout), so the fullscreen
    // layout and the new view are painted in the same frame.
    const handleViewChange = (id, prevId)=>{
        if (id !== 'locations' || bookingStartedRef.current) {
            setFullscreen(true);
            setBookingStarted(true);
            bookingStartedRef.current = true;
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('BOOKING_STARTED');
            APP.trigger(APP.events.BOOKING_MODULE_FULLSCREEN);
        } else {
            setFullscreen(false);
            APP.trigger(APP.events.BOOKING_MODULE_END_FULLSCREEN);
        }
        if (id === 'locations' || prevId === 'locations') (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('DISPLAY_TRIP');
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        style: {
            originX: 0.5,
            originY: 1
        },
        transition: {
            duration: .2
        },
        className: $8d3f5c7c22e09279$var$cx($5ee31b187546b2ff$exports.bookingwidget, {
            fullscreen: fullscreen
        }),
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$2e2bcd8739ae039), {
            views: views,
            sendEvent: true,
            children: ({ View: View, id: id })=>{
                return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
                    initialValues: initialValues,
                    validationSchema: View.validationSchema,
                    validateOnChange: true,
                    validateOnBlur: false,
                    onSubmit: async (values)=>{},
                    onReset: ()=>{
                        APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_FORM');
                        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_MAP');
                    },
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $9832901ac9096800$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$b2d7bc9e68dacbc), {
                                currentView: id,
                                fullscreen: fullscreen
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $247ae7f4639f55fe$export$2e2bcd8739ae039), {
                                message: t('reset-booking-message')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $57ccc41fcf47abfa$export$2e2bcd8739ae039), {
                                onViewChange: handleViewChange
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)($8d3f5c7c22e09279$var$FormikListener, {}),
                            false
                        ]
                    })
                });
            }
        })
    });
};
const $8d3f5c7c22e09279$var$FormikListener = ()=>{
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { values: values, dirty: dirty, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const prevDeparture = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(values.departure);
    const prevDestination = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(values.destination);
    const hasUpdatedUser = (0, $bh6RR.useRef)(false);
    // Set username and phone if we have a logged in user
    (0, $bh6RR.useEffect)(()=>{
        if (user && (dirty === false || hasUpdatedUser.current === false)) {
            if (values.name === '') setFieldValue('name', (0, $200ec6b1b2ca8c5a$export$c1fb9bac27b52cdd)(user), false);
            if (values.phone === '') setFieldValue('phone', user.phone, false);
            hasUpdatedUser.current = true;
        }
    }, [
        user,
        values,
        dirty,
        hasUpdatedUser,
        setFieldValue
    ]);
    // Trigger events to update the map
    (0, $bh6RR.useEffect)(()=>{
        if (values.departure?.address && values.departure !== prevDeparture || values.destination?.address && values.destination !== prevDestination) {
            const locations = [
                values.departure?.address ? values.departure : null
            ];
            let active = null;
            // Set destination INFO messages in originInfo (departure notifications are
            // handled directly by Notifications component using new tag logic).
            const destinationInfo = {
                title: values.destination?.name,
                info: null
            };
            destinationInfo.info = values.destination?.locationInformation?.filter((item)=>[
                    'INFO'
                ].includes(item?.tag)).map((item)=>item.message) || [];
            setFieldValue('originInfo', [
                destinationInfo
            ].filter((info)=>info.info.length > 0), false);
            // If departure changed
            if (values.departure?.address && values.departure !== prevDeparture) //const info = values.departure?.locationInformation?.filter(item => item.tag === 'DEPARTURE_INFO').map(item => item.message)
            //console.log(info)
            //setFieldValue('originInfo', info, false)
            active = 0;
            else if (values.destination?.address && values.destination !== prevDestination) {
                locations.push(values.destination);
                active = 1;
            }
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('LOCATION_CHANGE', {
                locations: locations,
                active: active
            });
        }
    }, [
        values.departure,
        values.destination
    ]);
    return null;
};
var $8d3f5c7c22e09279$export$2e2bcd8739ae039 = $8d3f5c7c22e09279$var$PackageModule;




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");



var $d4496e0c6a2b82bb$export$33e207cb9c74f488;
var $d4496e0c6a2b82bb$export$a80b3bd66acc52ff;
$d4496e0c6a2b82bb$export$33e207cb9c74f488 = `IcYX3a_alertItem`;
$d4496e0c6a2b82bb$export$a80b3bd66acc52ff = `IcYX3a_info`;


function $1ea04dc67a9d8232$export$2e2bcd8739ae039() {
    const [messages, setMessages] = (0, $bh6RR.useState)([]);
    const statusRef = (0, $bh6RR.useRef)(null);
    const getMessage = (item)=>{
        return item?.messages[(0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language];
    };
    (0, $bh6RR.useEffect)(()=>{
        (0, $135a523c4bea715f$export$4c0a6e0671743f21)().then((response)=>{
            setMessages(Array.isArray(response) ? response : []);
        //let navHeight = Document.documentElement.style.setProperty('--nav-height', navHeightTest + 'px');
        }).catch((error)=>{
            console.error(error);
        });
    }, []);
    (0, $bh6RR.useEffect)(()=>{
        function handleResize() {
            setHeight();
        }
        window.addEventListener('resize', handleResize);
        return (_)=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const setHeight = ()=>{
        let barHeight = statusRef?.current?.offsetHeight || 0;
        document.documentElement.style.setProperty('--status-height', barHeight + "px");
    // Returns the nav height as a number
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: messages.map((item)=>{
            return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
                ref: statusRef,
                initial: {
                    opacity: 0,
                    height: 0
                },
                animate: {
                    opacity: 1,
                    height: 'auto'
                },
                className: $d4496e0c6a2b82bb$export$33e207cb9c74f488,
                onUpdate: setHeight,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $d4496e0c6a2b82bb$export$a80b3bd66acc52ff
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        children: getMessage(item)
                    })
                ]
            }, item.id);
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");
















const $f3d0713c6d8a0a0e$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
const $f3d0713c6d8a0a0e$var$OtpFlow = ({ fullscreen: fullscreen })=>{
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    const views = [
        {
            id: 'selectMethod',
            component: (0, $e2f99346c9bbe6af$export$2e2bcd8739ae039)
        },
        {
            id: 'validatePhone',
            component: (0, $e12f6ca7761957b6$export$2e2bcd8739ae039)
        },
        {
            id: 'inputEmail',
            component: (0, $cf0f1ff2adb2601d$export$2e2bcd8739ae039)
        },
        {
            id: 'validateEmail',
            component: (0, $2f309c3398f4225a$export$2e2bcd8739ae039)
        },
        {
            id: 'inputName',
            component: (0, $f711080ef67fa6b9$export$2e2bcd8739ae039)
        },
        {
            id: 'acceptTerms',
            component: (0, $7d4acd3ee9d93151$export$2e2bcd8739ae039)
        },
        {
            id: 'socialAddPhone',
            component: (0, $313a05dd87b8b311$export$2e2bcd8739ae039)
        },
        {
            id: 'socialValidatePhone',
            component: (0, $1f01605bcc1665ea$export$2e2bcd8739ae039)
        },
        {
            id: 'confirmExistingProfile',
            component: (0, $dbfc10e7606e003e$export$2e2bcd8739ae039)
        },
        {
            id: 'socialSelectEmail',
            component: (0, $f3175d49746face5$export$2e2bcd8739ae039)
        }
    ];
    const initialValues = {
        dialCode: '+46',
        phone: '',
        phoneCode: '',
        email: '',
        maskedEmail: '',
        emailCode: '',
        firstName: '',
        lastName: '',
        externalEmail: '',
        existingUserName: '',
        existingUserEmail: '',
        marketingOptIn: false,
        termsAndConditions: false,
        shouldConsentToMarketing: true,
        shouldConsentToTermsAndConditions: true
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $f3d0713c6d8a0a0e$var$cx($f35967c56a9f3d99$exports.widgetWrapper, {
            fullscreen: fullscreen
        }),
        children: [
            fullscreen && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $9094094da0261b51$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e674c50b4c32bcf$export$2e2bcd8739ae039), {
                        children: inEditMode ? t('edit-your-trip') : t('your-trip')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $78f5985dc59f422c$export$2e2bcd8739ae039), {
                        values: values,
                        showHow: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$2e2bcd8739ae039), {
                views: views,
                children: ({ View: View })=>{
                    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
                        initialValues: initialValues,
                        validationSchema: View?.validationSchema || null,
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $b1f47dcfa609295f$export$b2d7bc9e68dacbc), {
                                    fullscreen: fullscreen
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)((0, $57ccc41fcf47abfa$export$2e2bcd8739ae039), {}),
                                false
                            ]
                        })
                    });
                }
            })
        ]
    });
};
$f3d0713c6d8a0a0e$var$OtpFlow.validationSchema = null;
var $f3d0713c6d8a0a0e$export$2e2bcd8739ae039 = $f3d0713c6d8a0a0e$var$OtpFlow;



// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2780-30318
// Figma component name: AddOns row (stepper variant — InputStepper)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");
function $966dfe9a48e4742e$var$MinusIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "11",
        height: "2",
        viewBox: "0 0 11 2",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M1 1H10",
            stroke: "#17181A",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}
function $966dfe9a48e4742e$var$PlusIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "11",
        height: "11",
        viewBox: "0 0 11 11",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M5.5 1V10M1 5.5H10",
            stroke: "#17181A",
            strokeWidth: "2",
            strokeLinecap: "round"
        })
    });
}
function $966dfe9a48e4742e$export$2e2bcd8739ae039({ value: value, min: min, max: max, onChange: onChange, className: className }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex items-center gap-2 px-[2px] shrink-0', className),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (value > min) onChange(value - 1);
                },
                disabled: value <= min,
                className: "border border-solid border-on-surface-variant rounded-[4px] w-5 h-[22px] flex items-center justify-center disabled:opacity-[0.38]",
                "aria-label": "Decrease",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($966dfe9a48e4742e$var$MinusIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "text-[18px] font-bold tracking-[0.54px] leading-none text-on-surface min-w-[1ch] text-center",
                children: value
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (value < max) onChange(value + 1);
                },
                disabled: value >= max,
                className: "border border-solid border-on-surface-variant rounded-[4px] w-5 h-[22px] flex items-center justify-center disabled:opacity-[0.38]",
                "aria-label": "Increase",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($966dfe9a48e4742e$var$PlusIcon, {})
            })
        ]
    });
}


function $efabb32800674410$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, title: title, info: info, icon: icon, price: price, numSeatsMax: numSeatsMax, disabled: disabled, reverseLayout: // eslint-disable-next-line no-unused-vars
reverseLayout, alternateBackground: alternateBackground }) {
    const value = field.value || 0;
    const max = numSeatsMax ?? 2;
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38] pointer-events-none'),
        children: [
            icon && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 overflow-clip flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: `/app/themes/${theme}/static/img/option-icons/${icon}.png`,
                    alt: "",
                    className: "size-full object-contain"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: title
                    }),
                    info && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: info
                    }),
                    price && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] font-medium leading-5 text-on-surface-variant",
                        children: price
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $966dfe9a48e4742e$export$2e2bcd8739ae039), {
                value: value,
                min: 0,
                max: max,
                onChange: (v)=>setFieldValue(field.name, v)
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2170-28699
// Figma component name: CarOption

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $5TnqA = parcelRequire("5TnqA");



// Figma component: nativeLoadingSpinner
// 8-bar radial spinner. Color defaults to currentColor (inherits from CSS),
// or pass light=true for white, or a hex string via the color prop.

var $ih19M = parcelRequire("ih19M");
function $e707c4e9e24b211c$export$2e2bcd8739ae039({ light: light, color: color, size: size = 24, className: className }) {
    const fill = color ?? (light ? '#ffffff' : 'currentColor');
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        className: className,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
            children: [
                [
                    0,
                    45,
                    90,
                    135,
                    180,
                    225,
                    270,
                    315
                ].map((angle, i)=>/*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.1",
                        y: "1",
                        width: "1.8",
                        height: "4.5",
                        rx: "0.9",
                        fill: fill,
                        opacity: (i + 1) / 8,
                        transform: `rotate(${angle} 8 8)`
                    }, angle)),
                /*#__PURE__*/ (0, $ih19M.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    values: "0 8 8;45 8 8;90 8 8;135 8 8;180 8 8;225 8 8;270 8 8;315 8 8;360 8 8",
                    calcMode: "discrete",
                    dur: "600ms",
                    repeatCount: "indefinite"
                })
            ]
        })
    });
}


// Matches Figma Radiobutton (node 52:1061 / 52:1063)
function $61cc6ab30242b4e5$var$RadioIcon({ selected: selected }) {
    if (selected) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                stroke: "#BA8200",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1404 6.74141C16.3176 6.88535 16.4061 6.95732 16.4635 7.03588C16.6206 7.25109 16.6517 7.53347 16.5452 7.77772C16.5064 7.86689 16.4356 7.95642 16.294 8.13548L10.6357 15.2931C10.4676 15.5057 10.3836 15.6121 10.2776 15.6621C10.1843 15.7062 10.0797 15.7203 9.97813 15.7026C9.86267 15.6825 9.75339 15.6023 9.53484 15.4419L5.92882 12.7955C5.73218 12.6512 5.63385 12.579 5.57038 12.4981C5.40396 12.2859 5.36426 12.0007 5.46639 11.7512C5.50535 11.656 5.58023 11.5597 5.72998 11.3672C5.87077 11.1862 5.94116 11.0957 6.01956 11.0362C6.2248 10.8806 6.49554 10.8411 6.73664 10.9317C6.82875 10.9664 6.92204 11.033 7.10862 11.1664L9.8395 13.1178L14.7258 6.89943C14.8706 6.71509 14.943 6.62293 15.0224 6.56357C15.2401 6.40085 15.5287 6.36861 15.7769 6.47929C15.8675 6.51967 15.9585 6.59358 16.1404 6.74141Z",
                fill: "#17181A"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "11",
            cy: "11",
            r: "10.5",
            stroke: "#8c8c8c",
            strokeWidth: "1"
        })
    });
}
// Person/capacity icon (Figma node 3509:30843)
function $61cc6ab30242b4e5$var$PersonIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "12",
        height: "13",
        viewBox: "0 0 12.5 13.5",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M6.25 8.75C4.16374 8.75 2.30845 9.77042 1.12727 11.354C0.873052 11.6948 0.745942 11.8652 0.7501 12.0955C0.753312 12.2735 0.863613 12.4979 1.00182 12.6078C1.18071 12.75 1.4286 12.75 1.9244 12.75H10.5756C11.0714 12.75 11.3193 12.75 11.4982 12.6078C11.6364 12.4979 11.7467 12.2735 11.7499 12.0955C11.7541 11.8652 11.6269 11.6948 11.3727 11.354C10.1916 9.77042 8.33626 8.75 6.25 8.75Z",
                stroke: "#5D5D5F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M6.25 6.75C7.88559 6.75 9.21149 5.40685 9.21149 3.75C9.21149 2.09315 7.88559 0.75 6.25 0.75C4.61441 0.75 3.28851 2.09315 3.28851 3.75C3.28851 5.40685 4.61441 6.75 6.25 6.75Z",
                stroke: "#5D5D5F",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
// Warning icon shown on network error / unavailable state (Figma node 2170:28899)
function $61cc6ab30242b4e5$var$WarningIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "13",
        height: "12",
        viewBox: "0 0 12.9277 11.7907",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.88035 0.343484C6.13419 -0.114495 6.79351 -0.114495 7.04735 0.343484L12.8432 10.8015C13.0893 11.2458 12.7682 11.7907 12.2602 11.7907H0.667464C0.159503 11.7907 -0.161636 11.2458 0.0844565 10.8015L5.88035 0.343484ZM6.13035 5.6804C5.94656 5.68057 5.79759 5.82962 5.79735 6.01341V9.6804C5.79741 9.86433 5.94645 10.0132 6.13035 10.0134H6.79735C6.98127 10.0133 7.13029 9.86435 7.13035 9.6804V6.01341C7.13011 5.82961 6.98117 5.68055 6.79735 5.6804H6.13035ZM6.46434 3.2136C6.09623 3.2136 5.79748 3.51251 5.79735 3.88059C5.79752 4.24863 6.09626 4.54661 6.46434 4.54661C6.83215 4.54629 7.13018 4.24844 7.13035 3.88059C7.13022 3.51271 6.83218 3.21392 6.46434 3.2136Z",
            fill: "#17181A"
        })
    });
}
function $61cc6ab30242b4e5$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, title: title, info: info, capacity: capacity, availability: availability, price: price, originalPrice: originalPrice, reducedPrice: reducedPrice, labelRef: labelRef, disabledDueToEdit: disabledDueToEdit, hideDisabledPill: hideDisabledPill, ...props }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { values: values } = (0, $lW2XZ.useFormikContext)();
    let isChecked = field.checked;
    if (values.autoValues.serviceType) isChecked = values.autoValues.serviceType === field.value;
    const isDisabled = props.disabled;
    // In edit mode, don't show delayed pill if time hasn't changed
    const isEditModeWithUnchangedTime = values.bookingId && !values.editableFields?.includes('pickUpTimeStamp');
    const clickRef = (0, $bh6RR.useRef)();
    const onKeyDown = (e)=>{
        if (e.keyCode === 32) e.preventDefault();
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 32) {
            e.preventDefault();
            setFieldValue(field.name, field.value);
            if (props.onClick) props.onClick();
        }
    };
    const wrapperClick = ()=>{
        (labelRef || clickRef)?.current?.click();
    };
    const showPriceSpinner = values.priceIsLoading;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        onClick: wrapperClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex items-center gap-3 py-3 w-full cursor-pointer', isDisabled && 'pointer-events-none'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/${CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'}/static/img/car-icons/${field.value}.png`,
                alt: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('w-11 shrink-0 object-contain', isDisabled && 'opacity-[0.38]')
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-1 flex-col min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex items-center gap-2', isDisabled && 'opacity-[0.38]'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface whitespace-nowrap",
                                children: title
                            }),
                            capacity && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: "w-1 h-1 rounded-full bg-on-surface-variant shrink-0",
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: "flex items-center gap-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsx)($61cc6ab30242b4e5$var$PersonIcon, {}),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                                className: "text-[15px] leading-5 text-on-surface-variant",
                                                children: capacity
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    info && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-[15px] leading-5 text-on-surface-variant', isDisabled && 'opacity-[0.38]'),
                        children: info
                    }),
                    availability?.availableAt === 'AS_REQUESTED' && availability?.expectedWaitTime || availability?.availableAt === 'DELAYED' && !isDisabled && !isEditModeWithUnchangedTime || isDisabled && !hideDisabledPill || reducedPrice ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex gap-1 flex-wrap mt-1",
                        children: [
                            availability?.availableAt === 'AS_REQUESTED' && availability?.expectedWaitTime && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: t('approx-min', {
                                    minutes: availability.expectedWaitTime
                                })
                            }),
                            availability?.availableAt === 'DELAYED' && !isDisabled && !isEditModeWithUnchangedTime && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: `Endast f\xf6rbokning ${(0, $200ec6b1b2ca8c5a$export$3203edd9e5edd663)(new Date(availability.pickupTime))}`,
                                type: "important"
                            }),
                            isDisabled && !hideDisabledPill && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: disabledDueToEdit ? "Kan inte \xe4ndras vid redigering" : "Ej tillg\xe4nglig"
                            }),
                            reducedPrice && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: reducedPrice,
                                type: "important"
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex items-center gap-2 shrink-0",
                children: [
                    showPriceSpinner ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "shrink-0"
                    }) : price ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex flex-col items-end', isDisabled && 'opacity-[0.38]'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[17px] font-semibold uppercase tracking-[0.68px] leading-[22px] text-on-surface whitespace-nowrap",
                                children: price
                            }),
                            originalPrice && /*#__PURE__*/ (0, $ih19M.jsx)("s", {
                                className: "text-[15px] leading-5 text-on-surface-variant",
                                children: originalPrice
                            })
                        ]
                    }) : null,
                    isDisabled && /*#__PURE__*/ (0, $ih19M.jsx)($61cc6ab30242b4e5$var$WarningIcon, {}),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                        ref: labelRef || clickRef,
                        tabIndex: "0",
                        onKeyDown: onKeyDown,
                        onKeyUp: onKeyUp,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('cursor-pointer', isDisabled && 'opacity-[0.38]'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)($61cc6ab30242b4e5$var$RadioIcon, {
                                selected: isChecked
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                type: "radio",
                                as: "input",
                                className: "sr-only",
                                name: field.name,
                                onChange: field.onChange,
                                onBlur: field.onBlur,
                                ...props
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2780-30318
// Figma component name: AddOns row (checkbox variant)
//
// Two visual modes:
//   With icon/iconNode → full addon row (44px icon + title/info/price + checkbox)
//   Without icon       → simple row (title/info + checkbox), for other form uses

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $5TnqA = parcelRequire("5TnqA");
// Matches Figma Checkbox component (node 121:3590 / 121:3592)
function $20f208c249841caf$var$CheckboxIcon({ checked: checked }) {
    if (checked) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "bg-secondary-container border-[0.5px] border-solid border-secondary rounded-[6px] size-5 flex items-center justify-center shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            width: "13",
            height: "10",
            viewBox: "0 0 13 10",
            fill: "none",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M1.5 5L4.5 8L11 1.5",
                stroke: "#17181A",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "bg-surface-container-highest border-[0.5px] border-solid border-outline rounded-[6px] size-5 shrink-0"
    });
}
function $20f208c249841caf$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, title: title, info: info, price: price, icon: icon, iconNode: iconNode, disabled: disabled, innerRef: innerRef, className: className, padding: padding = 'py-3', reverseLayout: // legacy props — accepted but not used in new layout
reverseLayout, alternateBackground: alternateBackground, larger: larger, secondOption: secondOption, noPadding: noPadding, children: children, disabledDescription: disabledDescription, ...props }) {
    const isChecked = Array.isArray(field.value) ? field.value.includes(props?.value) : Boolean(field.value);
    const clickRef = (0, $bh6RR.useRef)();
    const hasIcon = icon || iconNode;
    const handleClick = ()=>{
        if (disabled) return;
        (innerRef || clickRef)?.current?.click();
    };
    const handleKeyDown = (e)=>{
        if (e.keyCode === 32) e.preventDefault();
    };
    const handleKeyUp = (e)=>{
        if (e.keyCode === 32) {
            e.preventDefault();
            setFieldValue(field.name, !isChecked);
            if (props.onClick) props.onClick();
        }
    };
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center w-full cursor-pointer', padding, disabled && 'opacity-[0.38] pointer-events-none', className),
        children: [
            hasIcon && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 overflow-clip flex items-center justify-center",
                children: iconNode || /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: typeof icon === 'string' ? `/app/themes/${theme}/static/img/option-icons/${icon}.png` : icon,
                    alt: "",
                    className: "size-full object-contain"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: title
                    }),
                    info && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: info
                    }),
                    price && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] font-medium leading-5 text-on-surface-variant",
                        children: price
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                ref: innerRef || clickRef,
                tabIndex: disabled ? -1 : 0,
                onKeyDown: handleKeyDown,
                onKeyUp: handleKeyUp,
                className: "shrink-0 cursor-pointer",
                onClick: (e)=>e.stopPropagation(),
                "aria-label": title,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($20f208c249841caf$var$CheckboxIcon, {
                        checked: isChecked
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "checkbox",
                        as: "input",
                        className: "sr-only",
                        name: field.name,
                        onChange: field.onChange,
                        onBlur: field.onBlur,
                        disabled: disabled,
                        ...props
                    })
                ]
            })
        ]
    });
}


// Figma: same addon row style as CheckboxField, with EV icon
// Replaces the old FieldWrapper + custom checkbox implementation

var $ih19M = parcelRequire("ih19M");

function $ebfa6821d606098e$var$EvIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "size-11 flex items-center justify-center shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            "aria-hidden": "true",
            children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M19.9814 3C20.5439 3.00017 20.9998 3.4561 21 4.01855V12C21 16.9706 16.9706 21 12 21C10.1309 21 8.39479 20.4304 6.95605 19.4551C6.7282 19.3006 6.61411 19.2231 6.51074 19.2041C6.4144 19.1865 6.33056 19.1949 6.23926 19.2305C6.14145 19.2686 6.05164 19.3575 5.87305 19.5361L4.81055 20.5986C4.64615 20.763 4.56403 20.8461 4.47852 20.8955C4.24656 21.0293 3.96046 21.0293 3.72852 20.8955C3.643 20.8461 3.56088 20.763 3.39648 20.5986C3.23222 20.4344 3.14994 20.3521 3.10059 20.2666C2.96674 20.0346 2.96666 19.7486 3.10059 19.5166C3.14998 19.4312 3.23229 19.3488 3.39648 19.1846L4.45996 18.1211C4.63844 17.9426 4.72845 17.8536 4.7666 17.7559C4.80212 17.6646 4.80955 17.5807 4.79199 17.4844C4.77309 17.3811 4.69615 17.2668 4.54199 17.0391C3.56868 15.6013 3 13.867 3 12C3 7.02944 7.02944 3 12 3H19.9814ZM12.9502 11.0498C12.5597 10.6593 11.9257 10.6593 11.5352 11.0498L7.29297 15.293C6.90244 15.6835 6.90244 16.3165 7.29297 16.707C7.68349 17.0976 8.31651 17.0976 8.70703 16.707L12.9502 12.4648C13.3407 12.0743 13.3407 11.4403 12.9502 11.0498Z",
                fill: "#2B913B"
            })
        })
    });
}
function $ebfa6821d606098e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $20f208c249841caf$export$2e2bcd8739ae039), {
        ...props,
        iconNode: /*#__PURE__*/ (0, $ih19M.jsx)($ebfa6821d606098e$var$EvIcon, {})
    });
}



var $ih19M = parcelRequire("ih19M");


var $b75af0fa23f7df3a$exports = {};

$parcel$export($b75af0fa23f7df3a$exports, "isChecked", function () { return $b75af0fa23f7df3a$export$ecc98dea0bb74423; }, function (v) { return $b75af0fa23f7df3a$export$ecc98dea0bb74423 = v; });
$parcel$export($b75af0fa23f7df3a$exports, "isDisabled", function () { return $b75af0fa23f7df3a$export$30e0dc115df457ed; }, function (v) { return $b75af0fa23f7df3a$export$30e0dc115df457ed = v; });
$parcel$export($b75af0fa23f7df3a$exports, "title", function () { return $b75af0fa23f7df3a$export$fb184b623420d9be; }, function (v) { return $b75af0fa23f7df3a$export$fb184b623420d9be = v; });
$parcel$export($b75af0fa23f7df3a$exports, "wrapper", function () { return $b75af0fa23f7df3a$export$cc74dcc53cfce4eb; }, function (v) { return $b75af0fa23f7df3a$export$cc74dcc53cfce4eb = v; });
var $b75af0fa23f7df3a$export$ecc98dea0bb74423;
var $b75af0fa23f7df3a$export$30e0dc115df457ed;
var $b75af0fa23f7df3a$export$fb184b623420d9be;
var $b75af0fa23f7df3a$export$cc74dcc53cfce4eb;
$b75af0fa23f7df3a$export$ecc98dea0bb74423 = `_8UDNZW_isChecked`;
$b75af0fa23f7df3a$export$30e0dc115df457ed = `_8UDNZW_isDisabled`;
$b75af0fa23f7df3a$export$fb184b623420d9be = `_8UDNZW_title`;
$b75af0fa23f7df3a$export$cc74dcc53cfce4eb = `_8UDNZW_wrapper`;


const $1a524575b258b4c5$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($b75af0fa23f7df3a$exports);
function $1a524575b258b4c5$export$2e2bcd8739ae039({ field: field, form: form, title: title, reverseLayout: reverseLayout, alternateBackground: alternateBackground, fullscreen: fullscreen, ...props }) {
    const isChecked = field.value;
    const isDisabled = props.disabled;
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
        reverseLayout: reverseLayout,
        alternateBackground: alternateBackground,
        isDisabled: isDisabled,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $1a524575b258b4c5$var$cx($b75af0fa23f7df3a$exports.title, {
                    isChecked: isChecked,
                    fullscreen: fullscreen
                }),
                children: title
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $582402ece63dbe0f$export$2e2bcd8739ae039), {
                isChecked: isChecked,
                name: field.name,
                form: form,
                onChange: field.onChange,
                onBlur: field.onBlur,
                ...props
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $ebf6b0bc54a897c4$exports = {};

$parcel$export($ebf6b0bc54a897c4$exports, "cursor-blink", function () { return $ebf6b0bc54a897c4$export$be2d1caac636fe42; }, function (v) { return $ebf6b0bc54a897c4$export$be2d1caac636fe42 = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "hasFocus", function () { return $ebf6b0bc54a897c4$export$1c89b7ce846c4ef6; }, function (v) { return $ebf6b0bc54a897c4$export$1c89b7ce846c4ef6 = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "input", function () { return $ebf6b0bc54a897c4$export$b7e3ae3d7c15e42e; }, function (v) { return $ebf6b0bc54a897c4$export$b7e3ae3d7c15e42e = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "isLast", function () { return $ebf6b0bc54a897c4$export$3862bc4f297d2b4a; }, function (v) { return $ebf6b0bc54a897c4$export$3862bc4f297d2b4a = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "number", function () { return $ebf6b0bc54a897c4$export$98e628dec113755e; }, function (v) { return $ebf6b0bc54a897c4$export$98e628dec113755e = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "text", function () { return $ebf6b0bc54a897c4$export$6f093cfa640b7166; }, function (v) { return $ebf6b0bc54a897c4$export$6f093cfa640b7166 = v; });
$parcel$export($ebf6b0bc54a897c4$exports, "wrapper", function () { return $ebf6b0bc54a897c4$export$cc74dcc53cfce4eb; }, function (v) { return $ebf6b0bc54a897c4$export$cc74dcc53cfce4eb = v; });
var $ebf6b0bc54a897c4$export$be2d1caac636fe42;
var $ebf6b0bc54a897c4$export$1c89b7ce846c4ef6;
var $ebf6b0bc54a897c4$export$b7e3ae3d7c15e42e;
var $ebf6b0bc54a897c4$export$3862bc4f297d2b4a;
var $ebf6b0bc54a897c4$export$98e628dec113755e;
var $ebf6b0bc54a897c4$export$6f093cfa640b7166;
var $ebf6b0bc54a897c4$export$cc74dcc53cfce4eb;
$ebf6b0bc54a897c4$export$be2d1caac636fe42 = `_6DhOa_cursor-blink`;
$ebf6b0bc54a897c4$export$be2d1caac636fe42;
$ebf6b0bc54a897c4$export$1c89b7ce846c4ef6 = `_6DhOa_hasFocus`;
$ebf6b0bc54a897c4$export$b7e3ae3d7c15e42e = `_6DhOa_input`;
$ebf6b0bc54a897c4$export$3862bc4f297d2b4a = `_6DhOa_isLast`;
$ebf6b0bc54a897c4$export$98e628dec113755e = `_6DhOa_number`;
$ebf6b0bc54a897c4$export$6f093cfa640b7166 = `_6DhOa_text`;
$ebf6b0bc54a897c4$export$cc74dcc53cfce4eb = `_6DhOa_wrapper`;


const $06bd433d73a68758$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($ebf6b0bc54a897c4$exports);
function $06bd433d73a68758$export$2e2bcd8739ae039({ field: field, inputRef: inputRef, form: { setFieldValue: setFieldValue, setFieldTouched: setFieldTouched } }) {
    const [inputValue, setInputValue] = (0, $bh6RR.useState)('');
    const previousValue = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(field.value);
    const onChange = (e)=>{
        const value = e.target.value.replaceAll(/[^\d]/g, '');
        setInputValue(value);
        if (value.length === 4) {
            setFieldValue(field.name, value);
            setFieldTouched(field.name, true);
        }
    };
    const onKeyDown = (e)=>{
        onFocus();
    };
    const setFocus = ()=>{
        inputRef.current?.focus();
    };
    const onFocus = ()=>{
        const end = inputRef.current?.value?.length || 0;
        inputRef.current?.setSelectionRange(end, end);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (field.value === '' && previousValue !== '') setInputValue('');
    }, [
        field.value
    ]);
    (0, $bh6RR.useEffect)(setFocus, []);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $ebf6b0bc54a897c4$exports.wrapper,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "text",
                inputMode: "numeric",
                autoComplete: "one-time-code",
                autoFocus: true,
                tabIndex: "0",
                maxLength: "4",
                ref: inputRef,
                value: inputValue,
                onChange: onChange,
                onKeyDown: onKeyDown,
                onFocus: onFocus,
                className: $ebf6b0bc54a897c4$exports.input
            }),
            [
                0,
                1,
                2,
                3
            ].map((value, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    onClick: setFocus,
                    className: $06bd433d73a68758$var$cx($ebf6b0bc54a897c4$exports.number, {
                        hasFocus: index === inputValue.length,
                        isLast: index === 3 && inputValue.length === 4
                    }),
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: $ebf6b0bc54a897c4$exports.text,
                        children: inputValue[index] || '\u00A0'
                    })
                }, index))
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
var $87f37cb5460c1072$exports = {};






























































!function(e, t) {
    t($87f37cb5460c1072$exports, (parcelRequire("bh6RR")), (parcelRequire("eCfBx")), (parcelRequire("5TnqA")), (parcelRequire("cmc1k")), (parcelRequire("7pQzR")), (parcelRequire("k0Sb0")), (parcelRequire("8MQJ5")), (parcelRequire("jmY8A")), (parcelRequire("igItr")), (parcelRequire("h8qn4")), (parcelRequire("4jKL6")), (parcelRequire("l7KXm")), (parcelRequire("4iUK7")), (parcelRequire("kh6Tl")), (parcelRequire("2Fdb4")), (parcelRequire("5VoG8")), (parcelRequire("9c06P")), (parcelRequire("8ztBX")), (parcelRequire("itOb4")), (parcelRequire("bjv6P")), (parcelRequire("iuIgx")), (parcelRequire("dAPQy")), (parcelRequire("i8Ftf")), (parcelRequire("46D1n")), (parcelRequire("g4Oj6")), (parcelRequire("7rQJQ")), (parcelRequire("7Qx6a")), (parcelRequire("8Pk0g")), (parcelRequire("j1vsN")), (parcelRequire("kzEvi")), (parcelRequire("hBud4")), (parcelRequire("jewTs")), (parcelRequire("8Hcps")), (parcelRequire("585Rh")), (parcelRequire("57Qo5")), (parcelRequire("51vFz")), (parcelRequire("fxy8a")), (parcelRequire("frPzN")), (parcelRequire("2rZyX")), (parcelRequire("ckwmq")), (parcelRequire("h8HSd")), (parcelRequire("a0b1b")), (parcelRequire("krZy8")), (parcelRequire("5zLGe")), (parcelRequire("cbgMD")), (parcelRequire("4tTuR")), (parcelRequire("dRdrY")), (parcelRequire("TDfe5")), (parcelRequire("f66eH")), (parcelRequire("gUIpT")), (parcelRequire("kqTgn")), (parcelRequire("etVP0")), (parcelRequire("hBzYg")), (parcelRequire("jNzMQ")), (parcelRequire("22veB")), (parcelRequire("gDyFX")), (parcelRequire("le96L")), (parcelRequire("ejCCE")), (parcelRequire("25W9h")), (parcelRequire("6sTEQ")), (parcelRequire("6afFj")), (parcelRequire("bPViW")));
}($87f37cb5460c1072$exports, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, S, C, _, M, P, E, N, x, O, Y, I, T, L, R, F, A, q, W, B, K, H, j, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Se = le(D), Ce = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(S), xe = le(C), Oe = le(_), Ye = le(M), Ie = le(P), Te = le(E), Le = le(N), Re = le(x), Fe = le(O), Ae = le(Y), qe = le(I), We = le(T), Be = le(L), Ke = le(R), He = le(F), je = le(A), Qe = le(W), Ve = le(B), Ue = le(K), $e = le(H), ze = le(j), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            writable: !1
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function St(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return bt(e);
    }
    function Ct(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return St(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, xt = 12, Ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Yt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return Tt(t) ? t : null;
    }
    function It(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var p = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = Tt(p, n) && e === Lt(p, t, r)), Tt(p, n) && i && (o = p);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = Tt(o) && e === Lt(o, t, r) : Tt(o) || (t = t.match(Ot).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), Tt(o) || (o = new Date(e))), Tt(o) && i ? o : null);
    }
    function Tt(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && !nt.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Rt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ft(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Fe.default(Re.default(Le.default(e, i), o), a);
    }
    function At(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return xe.default(e, r ? {
            locale: r
        } : null);
    }
    function qt(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Bt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Kt(e) {
        return $e.default(e);
    }
    function Ht(e) {
        return Ge.default(e);
    }
    function jt(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(Ae.default(Yt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(Ae.default(Yt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(qe.default(Yt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return $t(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Yt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Ie.default(e), o = Oe.default(e), s = Ie.default(t), i = Oe.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Ie.default(e), o = Ye.default(e), s = Ie.default(t), i = Ye.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Yt(), s = Fe.default(Re.default(o, Me.default(e)), Pe.default(e)), i = Fe.default(Re.default(o, Me.default(r)), Pe.default(r)), p = Fe.default(Re.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && je.default(r, n) > 0 || a && a.every(function(e) {
            return je.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && je.default(n, r) > 0 || a && a.every(function(e) {
            return je.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) >= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) <= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xt, r = Math.ceil(Ie.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Sr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Ie.default(r) <= s), a && i && (i = Ie.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Cr = function(e) {
        wt(a, e);
        var r = Ct(a);
        function a(e) {
            var n;
            ht(this, a), Dt(bt(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(bt(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Ie.default(n.props.minDate) : null, a = n.props.maxDate ? Ie.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(n), "onChange", function(e) {
                n.props.onChange(e);
            }), Dt(bt(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), Dt(bt(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Dt(bt(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), Dt(bt(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Sr(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return yt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), _r = lt.default(Cr), Mr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Ie.default(e.props.minDate) : 1900, r = e.props.maxDate ? Ie.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Dt(bt(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function xr(e, t) {
        for(var r = [], a = Kt(e), n = Kt(t); !at.default(a, n);)r.push(Yt(a)), a = we.default(a, 1);
        return r;
    }
    var Or = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Te.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: xr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Yr = lt.default(Or), Ir = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Kt(e.props.minDate), r = Kt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Te.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Te.default(Kt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(Yr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Yt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Tr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (nt.default(d, l) || zt(d, l)) ? Gt(a, d, l) : (o && p && (at.default(d, p) || zt(d, p)) || !(!s || !p || l || !at.default(d, p) && !zt(d, p))) && Gt(a, p, d));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Oe.default(e.props.day);
            }), Dt(bt(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Oe.default(e.props.day) + 1) % 12 === e.props.month;
            }), Dt(bt(e), "isCurrentDay", function() {
                return e.isSameDay(Yt());
            }), Dt(bt(e), "isSelected", function() {
                return e.isSameDay(e.props.selected);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : At(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Bt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Tr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "isCurrentMonth", function(e, t) {
                return Ie.default(e) === Ie.default(Yt()) && t === Oe.default(Yt());
            }), Dt(bt(e), "isSelectedMonth", function(e, t, r) {
                return Oe.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "isSelectedQuarter", function(e, t, r) {
                return Ye.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Bt(Kt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Rr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Oe.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Kt(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Se.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(jt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(Ae.default(a, t), e.props),
                    "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": Oe.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = Oe.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ae.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(qe.default(a, t), e.props),
                    "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale, s = t.day, i = t.selected;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(s, t, i)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), Ar = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "isSelectedTime", function(t, r, a) {
                return e.props.selected && r === Pe.default(t) && a === Me.default(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(Yt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || Yt(), p = Pe.default(i), l = Me.default(i), d = Fe.default(Re.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0",
                        "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(Ar, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var qr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isCurrentYear", function(e) {
                return e === Ie.default(Yt());
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = Ht(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, Ht(a.props.selected)) && $t(t, Ht(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(Ht(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Ce.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Ie.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Ie.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Br(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Kr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Hr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Kr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = Yt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ae.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(Ae.default(r, Oe.default(e)), Ie.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Bt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(Ht(Ce.default(e, n)), n).endPeriod, s = r && Ie.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, c = p.previousYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(ge.default(e, n), n).startPeriod, s = r && Ie.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, c = p.nextYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Ie.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Oe.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ir, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(Yt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Ie.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Se.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Fr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(qr, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Ar, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Tt(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Br;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xt
                    };
                }
            }
        ]), r;
    }(de.default.Component), jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(jr, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(Hr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Yt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = It(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = Yt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = Yt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Se.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Ce.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Oe.default(r), s = Oe.default(n), i = Ie.default(r), p = Ie.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Rt(e, r), n = t ? Rt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Rt(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Oe.default(r) !== Oe.default(a) || Ie.default(r) !== Ie.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(jr, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xt,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Br, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});




var $gUIpT = parcelRequire("gUIpT");


var $9da14e23d49a92aa$export$56cd399753333e91;
var $9da14e23d49a92aa$export$324d90190a8b822a;
var $9da14e23d49a92aa$export$d7fd5ae7eb994a22;
var $9da14e23d49a92aa$export$a3bc9b8ed74fc;
var $9da14e23d49a92aa$export$bd9002130d306d39;
var $9da14e23d49a92aa$export$bc0aa20d42c5deb0;
var $9da14e23d49a92aa$export$b252d84101bf255b;
$9da14e23d49a92aa$export$56cd399753333e91 = `oK1Xaa_calendarOkButton`;
$9da14e23d49a92aa$export$324d90190a8b822a = `oK1Xaa_date`;
$9da14e23d49a92aa$export$d7fd5ae7eb994a22 = `oK1Xaa_dateTriggerText`;
$9da14e23d49a92aa$export$a3bc9b8ed74fc = `oK1Xaa_error`;
$9da14e23d49a92aa$export$bd9002130d306d39 = `oK1Xaa_placeholderText`;
$9da14e23d49a92aa$export$bc0aa20d42c5deb0 = `oK1Xaa_timeInput`;
$9da14e23d49a92aa$export$b252d84101bf255b = `oK1Xaa_timeInputRow`;



const $d2eecefb00e70187$var$STOCKHOLM_TZ = 'Europe/Stockholm';
const $d2eecefb00e70187$var$toDisplay = (date)=>(0, $d3fd156832cf6168$export$2e2bcd8739ae039)(date, $d2eecefb00e70187$var$STOCKHOLM_TZ);
const $d2eecefb00e70187$var$toUtc = (date)=>(0, $df7d6df00d41111e$export$2e2bcd8739ae039)(date, $d2eecefb00e70187$var$STOCKHOLM_TZ);
(0, $87f37cb5460c1072$exports.registerLocale)('sv', (0, $328fea4f4b85c31f$export$2e2bcd8739ae039));
function $d2eecefb00e70187$var$CalendarIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.00009 2.75C8.23259 2.75 8.34883 2.75 8.44421 2.77556C8.70303 2.84491 8.90519 3.04707 8.97454 3.30588C9.00009 3.40126 9.00009 3.5175 9.00009 3.75L9.0001 3.875C9.0001 3.99149 9.0001 4.04973 9.01913 4.09567C9.0445 4.15693 9.09317 4.2056 9.15442 4.23097C9.20037 4.25 9.25861 4.25 9.3751 4.25H14.6251C14.7416 4.25 14.7998 4.25 14.8458 4.23097C14.907 4.2056 14.9557 4.15693 14.9811 4.09567C15.0001 4.04973 15.0001 3.99148 15.0001 3.875L15.0001 3.75C15.0001 3.51751 15.0001 3.40126 15.0256 3.30589C15.095 3.04707 15.2972 2.84491 15.556 2.77556C15.6514 2.75 15.7676 2.75 16.0001 2.75C16.2326 2.75 16.3488 2.75 16.4442 2.77556C16.703 2.84491 16.9052 3.04707 16.9745 3.30588C17.0001 3.40126 17.0001 3.5175 17.0001 3.75L17.0001 3.89042C17.0001 4.00817 17.0001 4.06704 17.0187 4.11248C17.0422 4.17002 17.0817 4.21291 17.1372 4.24099C17.1809 4.26316 17.2431 4.26821 17.3673 4.27829C17.6085 4.29787 17.8284 4.33084 18.0354 4.3863C19.4157 4.75617 20.4939 5.83436 20.8638 7.21472C21.0009 7.72638 21.0006 8.31704 21.0001 9.11242C21.0001 9.15761 21.0001 9.20347 21.0001 9.25V15.4913C21.0001 16.2963 21.0001 16.9606 20.9559 17.5018C20.91 18.0639 20.8114 18.5806 20.5641 19.066C20.1806 19.8186 19.5687 20.4305 18.8161 20.814C18.3307 21.0613 17.814 21.1599 17.2519 21.2058C16.7107 21.25 16.0464 21.25 15.2414 21.25H8.75877C7.95381 21.25 7.28946 21.25 6.74827 21.2058C6.18617 21.1599 5.66947 21.0613 5.18413 20.814C4.43149 20.4305 3.81956 19.8186 3.43607 19.066C3.18878 18.5806 3.09022 18.0639 3.04429 17.5018C3.00007 16.9606 3.00008 16.2963 3.0001 15.4913L3.0001 9.25C3.0001 9.20346 3.00007 9.15761 3.00005 9.11242C2.99962 8.31703 2.9993 7.72637 3.13639 7.21472C3.50626 5.83436 4.58445 4.75617 5.96482 4.3863C6.17179 4.33084 6.3917 4.29787 6.63285 4.27829C6.75712 4.26821 6.81925 4.26316 6.86304 4.24099C6.91848 4.21291 6.95804 4.17001 6.98154 4.11248C7.0001 4.06704 7.0001 4.00817 7.0001 3.89042L7.00009 3.75C7.00009 3.51751 7.00009 3.40126 7.02565 3.30589C7.095 3.04707 7.29716 2.84491 7.55598 2.77556C7.65135 2.75 7.7676 2.75 8.00009 2.75ZM8.0001 6.25C7.00574 6.25 6.70474 6.25859 6.48246 6.31815C5.79227 6.50308 5.25318 7.04218 5.06824 7.73236C5.01995 7.9126 5.00517 7.4871 5.00131 7.84983C4.99983 7.98846 4.99909 8.05778 5.02613 8.11183C5.04974 8.15905 5.08855 8.19827 5.13551 8.22239C5.18928 8.25 5.25955 8.25 5.4001 8.25H18.6001C18.7406 8.25 18.8109 8.25 18.8647 8.22239C18.9116 8.19827 18.9504 8.15905 18.9741 8.11183C19.0011 8.05778 19.0004 7.98846 18.9989 7.84983C18.995 7.4871 18.9802 7.9126 18.9319 7.73236C18.747 7.04218 18.2079 6.50308 17.5177 6.31815C17.2955 6.25859 16.9944 6.25 16.0001 6.25H8.0001ZM19.0001 10.65C19.0001 10.51 19.0001 10.44 18.9728 10.3865C18.9489 10.3395 18.9106 10.3012 18.8636 10.2772C18.8101 10.25 18.7401 10.25 18.6001 10.25H5.4001C5.26008 10.25 5.19008 10.25 5.1366 10.2772C5.08956 10.3012 5.05131 10.3395 5.02734 10.3865C5.0001 10.44 5.0001 10.51 5.0001 10.65V15.45C5.0001 16.3066 5.00087 16.8889 5.03765 17.339C5.07347 17.7774 5.13839 18.0016 5.21808 18.158C5.40983 18.5343 5.71579 18.8403 6.09212 19.032C6.24852 19.1117 6.47272 19.1766 6.91113 19.2124C7.36122 19.2492 7.94352 19.25 8.8001 19.25H15.2001C16.0567 19.25 16.639 19.2492 17.0891 19.2124C17.5275 19.1766 17.7517 19.1117 17.9081 19.032C18.2844 18.8403 18.5904 18.5343 18.7821 18.158C18.8618 18.0016 18.9267 17.7774 18.9625 17.339C18.9993 16.8889 19.0001 16.3066 19.0001 15.45V10.65Z",
                fill: "#5D5D5F"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16.0001 17.25H15.0001C14.7676 17.25 14.6514 17.25 14.556 17.2244C14.2972 17.1551 14.095 16.9529 14.0256 16.6941C14.0001 16.5987 14.0001 16.4825 14.0001 16.25C14.0001 16.1055 14.0001 15.6199 14.0062 15.25C14.01 15.0245 14.016 14.842 14.0256 14.8059C14.095 14.5471 14.2972 14.3449 14.556 14.2756C14.6514 14.25 14.7676 14.25 15.0001 14.25H16.0001C16.2326 14.25 16.3488 14.25 16.4442 14.2756C16.703 14.3449 16.9052 14.5471 16.9745 14.8059C16.9842 14.842 16.9902 15.0245 16.994 15.25C17.0001 15.6199 17.0001 16.1055 17.0001 16.25C17.0001 16.4825 17.0001 16.5987 16.9745 16.6941C16.9052 16.9529 16.703 17.1551 16.4442 17.2244C16.3488 17.25 16.2326 17.25 16.0001 17.25Z",
                fill: "#5D5D5F"
            })
        ]
    });
}
function $d2eecefb00e70187$var$CalendarAirportIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M16 2.75C16.2325 2.75 16.349 2.74984 16.4443 2.77539C16.7031 2.84474 16.9052 3.04696 16.9746 3.30566C17.0002 3.40104 17 3.51751 17 3.75V3.89062C17 4.00807 17.0001 4.06691 17.0186 4.1123C17.042 4.16975 17.0814 4.21313 17.1367 4.24121C17.1805 4.26338 17.243 4.26824 17.3672 4.27832C17.6083 4.29789 17.8282 4.33128 18.0352 4.38672C19.4155 4.75659 20.4944 5.83448 20.8643 7.21484C21.0013 7.72642 21.0004 8.3171 21 9.1123V15.4912C21 16.2962 21.0003 16.9608 20.9561 17.502C20.9101 18.064 20.8117 18.5811 20.5645 19.0664C20.181 19.8189 19.5689 20.431 18.8164 20.8145C18.3311 21.0617 17.814 21.1601 17.252 21.2061C16.7108 21.2503 16.0462 21.25 15.2412 21.25H8.75879C7.95383 21.25 7.28924 21.2503 6.74805 21.2061C6.18623 21.1601 5.6697 21.0615 5.18457 20.8145C4.4321 20.4311 3.82003 19.8188 3.43652 19.0664C3.18925 18.5811 3.08987 18.064 3.04395 17.502C2.99973 16.9608 2.99999 16.2962 3 15.4912V9.1123C2.99957 8.31699 2.99964 7.72646 3.13672 7.21484C3.50658 5.8345 4.58452 4.75661 5.96484 4.38672C6.17181 4.33126 6.39167 4.2979 6.63281 4.27832C6.75708 4.26823 6.81949 4.26339 6.86328 4.24121C6.91867 4.21313 6.95796 4.1698 6.98145 4.1123C6.99995 4.06691 7 4.00813 7 3.89062V3.75C7 3.51751 6.99984 3.40104 7.02539 3.30566C7.09475 3.047 7.29701 2.84479 7.55566 2.77539C7.65103 2.74984 7.76757 2.75 8 2.75C8.23249 2.75 8.34896 2.74984 8.44434 2.77539C8.70305 2.84474 8.90522 3.04696 8.97461 3.30566C9.00016 3.40104 9 3.51751 9 3.75V3.875C9 3.99149 9.0005 4.04976 9.01953 4.0957C9.04492 4.15688 9.0931 4.2061 9.1543 4.23145C9.20022 4.25045 9.25863 4.25 9.375 4.25H14.625C14.7413 4.25 14.7998 4.25038 14.8457 4.23145C14.907 4.20607 14.9561 4.15696 14.9814 4.0957C15.0004 4.04978 15 3.9914 15 3.875V3.75C15 3.51751 14.9998 3.40104 15.0254 3.30566C15.0948 3.047 15.297 2.84479 15.5557 2.77539C15.651 2.74984 15.7676 2.75 16 2.75ZM8 6.25C7.00572 6.25 6.70469 6.2588 6.48242 6.31836C5.79228 6.50332 5.25329 7.04227 5.06836 7.73242C5.00881 7.9547 5 8.25569 5 9.25V15.4502C5 16.3066 5.00132 16.8888 5.03809 17.3389C5.07391 17.7773 5.13808 18.0018 5.21777 18.1582C5.40949 18.5344 5.71557 18.8405 6.0918 19.0322C6.2482 19.1119 6.47272 19.1771 6.91113 19.2129C7.36117 19.2497 7.94341 19.25 8.7998 19.25H15.2002C16.0566 19.25 16.6388 19.2496 17.0889 19.2129C17.5273 19.1771 17.7518 19.1119 17.9082 19.0322C18.2845 18.8405 18.5905 18.5345 18.7822 18.1582C18.8619 18.0018 18.9271 17.7773 18.9629 17.3389C18.9997 16.8888 19 16.3066 19 15.4502V9.25C19 8.25565 18.9912 7.9547 18.9316 7.73242C18.7467 7.04225 18.2078 6.50329 17.5176 6.31836C17.2953 6.25882 16.9942 6.25 16 6.25H8ZM14.0781 9.16699C14.4327 8.81242 14.9419 8.65851 15.4336 8.75684L15.5117 8.77246C15.7095 8.8121 15.8637 8.96723 15.9033 9.16504L15.9189 9.24316C16.0173 9.73491 15.8634 10.243 15.5088 10.5977L14.0137 12.0938L14.7451 15.3887C14.8667 15.9358 14.5124 16.4768 13.9629 16.5869C13.8525 16.609 13.74 16.5547 13.6895 16.4541L12.3438 13.7627L10.5557 15.3135L11.0703 16.6514C11.1164 16.7714 11.0641 16.9072 10.9492 16.9648L10.4219 17.2285C10.2984 17.2903 10.1477 17.2397 10.0859 17.1162L9.24414 15.4326L7.56055 14.5908C7.43705 14.5291 7.38649 14.3784 7.44824 14.2549L7.71191 13.7275C7.76953 13.6125 7.90529 13.5603 8.02539 13.6064L9.36328 14.1211L10.9131 12.332L8.22266 10.9873C8.1219 10.9369 8.06774 10.8244 8.08984 10.7139C8.19987 10.1643 8.7409 9.80909 9.28809 9.93066L12.583 10.6631L14.0781 9.16699Z",
            fill: "#5D5D5F"
        })
    });
}
// wasOpenRef and calendarOpen are passed through customInput JSX (not overridden by
// RDP's cloneElement which only injects onClick, value, ref).
// onMouseDown captures whether the calendar was open at mousedown time so that
// onInputClick can decide not to reopen it (toggle behaviour).
// showPlaceholder forces the placeholder even though a date is selected underneath (the
// return trip sheet keeps the field empty until the user picks a time); error turns the
// field red (Figma 19458-41583).
const $d2eecefb00e70187$var$DateTrigger = /*#__PURE__*/ (0, $bh6RR.forwardRef)(({ value: value, onClick: onClick, placeholder: placeholder, wasOpenRef: wasOpenRef, calendarOpen: calendarOpen, isAirport: isAirport, showPlaceholder: showPlaceholder, error: error }, ref)=>/*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        type: "button",
        className: `${$9da14e23d49a92aa$export$324d90190a8b822a} ${error ? $9da14e23d49a92aa$export$a3bc9b8ed74fc : ''}`,
        onMouseDown: ()=>{
            if (wasOpenRef) wasOpenRef.current = calendarOpen;
        },
        onClick: onClick,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: `${$9da14e23d49a92aa$export$d7fd5ae7eb994a22} ${showPlaceholder || !value ? $9da14e23d49a92aa$export$bd9002130d306d39 : ''}`,
                children: showPlaceholder ? placeholder : value || placeholder
            }),
            isAirport ? /*#__PURE__*/ (0, $ih19M.jsx)($d2eecefb00e70187$var$CalendarAirportIcon, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($d2eecefb00e70187$var$CalendarIcon, {})
        ]
    }));
function $d2eecefb00e70187$var$TimeInput({ value: value, min: min, max: max, onPendingChange: onPendingChange, onCommit: onCommit, onClose: onClose }) {
    const [localValue, setLocalValue] = (0, $bh6RR.useState)(value);
    const isDirty = (0, $bh6RR.useRef)(false);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $9da14e23d49a92aa$export$b252d84101bf255b,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                type: "time",
                className: $9da14e23d49a92aa$export$bc0aa20d42c5deb0,
                value: isDirty.current ? localValue : value,
                min: min,
                max: max,
                onChange: (e)=>{
                    isDirty.current = true;
                    setLocalValue(e.target.value);
                    onPendingChange(e.target.value);
                },
                onBlur: ()=>{
                    setTimeout(()=>{
                        isDirty.current = false;
                        onCommit();
                    }, 0);
                }
            }),
            onClose && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                className: $9da14e23d49a92aa$export$56cd399753333e91,
                onClick: onClose,
                children: "OK"
            })
        ]
    });
}
function $d2eecefb00e70187$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, minDate: minDate, maxDate: maxDate, showTimeInput: showTimeInput, isAirport: isAirport, onInvalidTime: onInvalidTime, placeholder: placeholder, commitOnOpen: commitOnOpen, error: error }) {
    // selectedDate is always a Stockholm "display date": getHours() returns Stockholm hour
    const [selectedDate, setSelectedDate] = (0, $bh6RR.useState)($d2eecefb00e70187$var$toDisplay(field.value || minDate || new Date()));
    const [calendarOpen, setCalendarOpen] = (0, $bh6RR.useState)(false);
    const pendingTime = (0, $bh6RR.useRef)(null);
    const selectedDateRef = (0, $bh6RR.useRef)(selectedDate);
    selectedDateRef.current = selectedDate;
    const wasOpenRef = (0, $bh6RR.useRef)(false);
    // setDate receives a real UTC Date, stores Stockholm display, writes UTC to Formik
    const setDate = (utcDate)=>{
        const displayDate = $d2eecefb00e70187$var$toDisplay(utcDate);
        selectedDateRef.current = displayDate;
        setSelectedDate(displayDate);
        setFieldValue(field.name, utcDate);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (field.value) setSelectedDate($d2eecefb00e70187$var$toDisplay(field.value));
    }, [
        field.value
    ]);
    // Convert min/max to Stockholm display for ReactDatePicker
    const displayMinDate = minDate ? $d2eecefb00e70187$var$toDisplay(minDate) : undefined;
    const displayMaxDate = maxDate ? $d2eecefb00e70187$var$toDisplay(maxDate) : undefined;
    const minTime = displayMinDate && selectedDate && (0, $gUIpT.default)(selectedDate, displayMinDate) ? (0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(minDate, $d2eecefb00e70187$var$STOCKHOLM_TZ, 'HH:mm') : undefined;
    const maxTime = displayMaxDate && selectedDate && (0, $gUIpT.default)(selectedDate, displayMaxDate) ? (0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(maxDate, $d2eecefb00e70187$var$STOCKHOLM_TZ, 'HH:mm') : undefined;
    const commitPending = ()=>{
        const t = pendingTime.current;
        if (!t) return;
        pendingTime.current = null;
        const [h, m] = t.split(':').map(Number);
        // selectedDateRef.current is a Stockholm display Date; set Stockholm h:m on it
        const newDisplayDate = new Date(selectedDateRef.current);
        newDisplayDate.setHours(h, m, 0, 0);
        const newDate = $d2eecefb00e70187$var$toUtc(newDisplayDate);
        const clamped = minDate && newDate < minDate ? new Date(minDate) : maxDate && newDate > maxDate ? new Date(maxDate) : newDate;
        if (clamped.getTime() !== newDate.getTime()) {
            setCalendarOpen(false);
            onInvalidTime?.();
        }
        setDate(clamped);
    };
    const commitRef = (0, $bh6RR.useRef)(commitPending);
    commitRef.current = commitPending;
    if (!showTimeInput) return /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87f37cb5460c1072$exports))), {
        selected: selectedDate,
        minDate: displayMinDate,
        maxDate: displayMaxDate,
        onChange: (date)=>{
            // date is a Stockholm display Date from ReactDatePicker
            const copy = new Date(date);
            if (pendingTime.current) {
                const [h, m] = pendingTime.current.split(':').map(Number);
                copy.setHours(h, m, 0, 0); // Stockholm h:m on Stockholm display Date
                pendingTime.current = null;
                const utcDate = $d2eecefb00e70187$var$toUtc(copy);
                const clamped = minDate && utcDate < minDate ? new Date(minDate) : maxDate && utcDate > maxDate ? new Date(maxDate) : utcDate;
                if (clamped.getTime() !== utcDate.getTime()) onInvalidTime?.();
                setDate(clamped);
            } else {
                copy.setHours(selectedDateRef.current.getHours(), selectedDateRef.current.getMinutes(), 0, 0);
                setDate($d2eecefb00e70187$var$toUtc(copy));
            }
        },
        locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        dateFormat: "d MMMM yyyy, HH:mm",
        showTimeInput: true,
        timeInputLabel: "",
        customTimeInput: /*#__PURE__*/ (0, $ih19M.jsx)($d2eecefb00e70187$var$TimeInput, {
            min: minTime,
            max: maxTime,
            onPendingChange: (t)=>{
                pendingTime.current = t;
            },
            onCommit: ()=>commitRef.current()
        }),
        inline: true,
        fixedHeight: true
    });
    const closeCalendar = ()=>{
        setCalendarOpen(false);
        commitRef.current();
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($87f37cb5460c1072$exports))), {
        open: calendarOpen,
        onInputClick: ()=>{
            if (!wasOpenRef.current) {
                if (commitOnOpen && !field.value) setDate($d2eecefb00e70187$var$toUtc(selectedDateRef.current));
                setCalendarOpen(true);
            }
        },
        onClickOutside: closeCalendar,
        onCalendarClose: closeCalendar,
        shouldCloseOnSelect: false,
        selected: selectedDate,
        minDate: displayMinDate,
        maxDate: displayMaxDate,
        onChange: (date)=>setDate($d2eecefb00e70187$var$toUtc(date)),
        locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        customInput: /*#__PURE__*/ (0, $ih19M.jsx)($d2eecefb00e70187$var$DateTrigger, {
            placeholder: placeholder || (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('placeholder-pick-date'),
            showPlaceholder: commitOnOpen && !field.value,
            error: error,
            wasOpenRef: wasOpenRef,
            calendarOpen: calendarOpen,
            isAirport: isAirport
        }),
        dateFormat: "d MMMM yyyy, HH:mm",
        showTimeInput: true,
        timeInputLabel: "",
        customTimeInput: /*#__PURE__*/ (0, $ih19M.jsx)($d2eecefb00e70187$var$TimeInput, {
            min: minTime,
            max: maxTime,
            onPendingChange: (t)=>{
                pendingTime.current = t;
            },
            onCommit: ()=>commitRef.current(),
            onClose: closeCalendar
        }),
        portalId: "datepicker-portal",
        fixedHeight: true
    });
}



var $ih19M = parcelRequire("ih19M");

var $b9bccc9b8a97e6c6$exports = {};

$parcel$export($b9bccc9b8a97e6c6$exports, "error", function () { return $b9bccc9b8a97e6c6$export$a3bc9b8ed74fc; }, function (v) { return $b9bccc9b8a97e6c6$export$a3bc9b8ed74fc = v; });
$parcel$export($b9bccc9b8a97e6c6$exports, "icon", function () { return $b9bccc9b8a97e6c6$export$1ca1ec8b29a4ce27; }, function (v) { return $b9bccc9b8a97e6c6$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($b9bccc9b8a97e6c6$exports, "noMarginTop", function () { return $b9bccc9b8a97e6c6$export$96e2bdae1d5029fa; }, function (v) { return $b9bccc9b8a97e6c6$export$96e2bdae1d5029fa = v; });
$parcel$export($b9bccc9b8a97e6c6$exports, "text", function () { return $b9bccc9b8a97e6c6$export$6f093cfa640b7166; }, function (v) { return $b9bccc9b8a97e6c6$export$6f093cfa640b7166 = v; });
var $b9bccc9b8a97e6c6$export$a3bc9b8ed74fc;
var $b9bccc9b8a97e6c6$export$1ca1ec8b29a4ce27;
var $b9bccc9b8a97e6c6$export$96e2bdae1d5029fa;
var $b9bccc9b8a97e6c6$export$6f093cfa640b7166;
$b9bccc9b8a97e6c6$export$a3bc9b8ed74fc = `oupmzq_error`;
$b9bccc9b8a97e6c6$export$1ca1ec8b29a4ce27 = `oupmzq_icon`;
$b9bccc9b8a97e6c6$export$96e2bdae1d5029fa = `oupmzq_noMarginTop`;
$b9bccc9b8a97e6c6$export$6f093cfa640b7166 = `oupmzq_text`;



const $bca8fddea4c4ef9b$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($b9bccc9b8a97e6c6$exports);
function $bca8fddea4c4ef9b$export$2e2bcd8739ae039({ children: children, noMarginTop: noMarginTop, useMotion: useMotion = true }) {
    const Element = useMotion ? $1ab1ad86cd1cb08e$export$159d9494db57879b : "div";
    return /*#__PURE__*/ (0, $ih19M.jsxs)(Element, {
        className: $bca8fddea4c4ef9b$var$cx($b9bccc9b8a97e6c6$exports.error, {
            noMarginTop: noMarginTop
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 15 15",
                className: $b9bccc9b8a97e6c6$exports.icon,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        fill: "#E30613",
                        d: "M7.5,13.5c3.3,0,6-2.7,6-6c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6 C1.5,10.8,4.2,13.5,7.5,13.5z M7.5,14.5c3.9,0,7-3.1,7-7c0-3.9-3.1-7-7-7c-3.9,0-7,3.1-7,7C0.5,11.4,3.6,14.5,7.5,14.5z"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fill: "#E30613",
                        d: "M7.5,3.8L7.5,3.8c0.4,0,0.8,0.3,0.8,0.8l0,0c0,0.4-0.3,0.8-0.8,0.8l0,0c-0.4,0-0.8-0.3-0.8-0.8l0,0 C6.8,4.1,7.1,3.8,7.5,3.8z"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fill: "#E30613",
                        d: "M7.2,6.2h0.6C7.9,6.2,8,6.3,8,6.4v4.6c0,0.1-0.1,0.2-0.2,0.2H7.2c-0.1,0-0.2-0.1-0.2-0.2V6.4 C7,6.3,7.1,6.2,7.2,6.2z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $b9bccc9b8a97e6c6$exports.text,
                children: children
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");


var $4a23d699a1f138e3$exports = {};

$parcel$export($4a23d699a1f138e3$exports, "alternateBackground", function () { return $4a23d699a1f138e3$export$7c7945898a349c4d; }, function (v) { return $4a23d699a1f138e3$export$7c7945898a349c4d = v; });
$parcel$export($4a23d699a1f138e3$exports, "border", function () { return $4a23d699a1f138e3$export$1edee58a52776cd9; }, function (v) { return $4a23d699a1f138e3$export$1edee58a52776cd9 = v; });
$parcel$export($4a23d699a1f138e3$exports, "changeIcon", function () { return $4a23d699a1f138e3$export$1a78b672aa2f261; }, function (v) { return $4a23d699a1f138e3$export$1a78b672aa2f261 = v; });
$parcel$export($4a23d699a1f138e3$exports, "field", function () { return $4a23d699a1f138e3$export$e0f35d825088c098; }, function (v) { return $4a23d699a1f138e3$export$e0f35d825088c098 = v; });
$parcel$export($4a23d699a1f138e3$exports, "uppercase", function () { return $4a23d699a1f138e3$export$6cfe151e6b925e83; }, function (v) { return $4a23d699a1f138e3$export$6cfe151e6b925e83 = v; });
$parcel$export($4a23d699a1f138e3$exports, "wrapper", function () { return $4a23d699a1f138e3$export$cc74dcc53cfce4eb; }, function (v) { return $4a23d699a1f138e3$export$cc74dcc53cfce4eb = v; });
var $4a23d699a1f138e3$export$7c7945898a349c4d;
var $4a23d699a1f138e3$export$1edee58a52776cd9;
var $4a23d699a1f138e3$export$1a78b672aa2f261;
var $4a23d699a1f138e3$export$e0f35d825088c098;
var $4a23d699a1f138e3$export$6cfe151e6b925e83;
var $4a23d699a1f138e3$export$cc74dcc53cfce4eb;
$4a23d699a1f138e3$export$7c7945898a349c4d = `_0zESMa_alternateBackground`;
$4a23d699a1f138e3$export$1edee58a52776cd9 = `_0zESMa_border`;
$4a23d699a1f138e3$export$1a78b672aa2f261 = `_0zESMa_changeIcon`;
$4a23d699a1f138e3$export$e0f35d825088c098 = `_0zESMa_field`;
$4a23d699a1f138e3$export$6cfe151e6b925e83 = `_0zESMa_uppercase`;
$4a23d699a1f138e3$export$cc74dcc53cfce4eb = `_0zESMa_wrapper`;


const $0c9528727d336954$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($4a23d699a1f138e3$exports);
function $0c9528727d336954$export$2e2bcd8739ae039({ field: field, form: form, border: border, alternateBackground: alternateBackground, uppercase: uppercase, changeIcon: changeIcon, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $4a23d699a1f138e3$exports.wrapper,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $4a23d699a1f138e3$exports.wrapper,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        as: "input",
                        className: $0c9528727d336954$var$cx($4a23d699a1f138e3$exports.field, {
                            border: border,
                            alternateBackground: alternateBackground,
                            uppercase: uppercase
                        }),
                        ...field,
                        ...props
                    }),
                    changeIcon && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                        id: "change",
                        className: $4a23d699a1f138e3$exports.changeIcon
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.ErrorMessage), {
                name: field.name,
                component: (0, $bca8fddea4c4ef9b$export$2e2bcd8739ae039)
            })
        ]
    });
}




var $ih19M = parcelRequire("ih19M");


var $054b8eaf2efc9950$exports = {};

$parcel$export($054b8eaf2efc9950$exports, "BAG", function () { return $054b8eaf2efc9950$export$6ef9df526709859a; }, function (v) { return $054b8eaf2efc9950$export$6ef9df526709859a = v; });
$parcel$export($054b8eaf2efc9950$exports, "BOX", function () { return $054b8eaf2efc9950$export$98e6811b31774aaa; }, function (v) { return $054b8eaf2efc9950$export$98e6811b31774aaa = v; });
$parcel$export($054b8eaf2efc9950$exports, "ENVELOPE", function () { return $054b8eaf2efc9950$export$2a2bf0aad5996982; }, function (v) { return $054b8eaf2efc9950$export$2a2bf0aad5996982 = v; });
$parcel$export($054b8eaf2efc9950$exports, "MOVING_BOX", function () { return $054b8eaf2efc9950$export$89e395a5ff7cdbd4; }, function (v) { return $054b8eaf2efc9950$export$89e395a5ff7cdbd4 = v; });
$parcel$export($054b8eaf2efc9950$exports, "field", function () { return $054b8eaf2efc9950$export$e0f35d825088c098; }, function (v) { return $054b8eaf2efc9950$export$e0f35d825088c098 = v; });
$parcel$export($054b8eaf2efc9950$exports, "icon", function () { return $054b8eaf2efc9950$export$1ca1ec8b29a4ce27; }, function (v) { return $054b8eaf2efc9950$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($054b8eaf2efc9950$exports, "iconWrapper", function () { return $054b8eaf2efc9950$export$38e6d710c8ae6ec3; }, function (v) { return $054b8eaf2efc9950$export$38e6d710c8ae6ec3 = v; });
$parcel$export($054b8eaf2efc9950$exports, "right", function () { return $054b8eaf2efc9950$export$79ffe56a765070d2; }, function (v) { return $054b8eaf2efc9950$export$79ffe56a765070d2 = v; });
$parcel$export($054b8eaf2efc9950$exports, "wrapper", function () { return $054b8eaf2efc9950$export$cc74dcc53cfce4eb; }, function (v) { return $054b8eaf2efc9950$export$cc74dcc53cfce4eb = v; });
var $054b8eaf2efc9950$export$6ef9df526709859a;
var $054b8eaf2efc9950$export$98e6811b31774aaa;
var $054b8eaf2efc9950$export$2a2bf0aad5996982;
var $054b8eaf2efc9950$export$89e395a5ff7cdbd4;
var $054b8eaf2efc9950$export$e0f35d825088c098;
var $054b8eaf2efc9950$export$1ca1ec8b29a4ce27;
var $054b8eaf2efc9950$export$38e6d710c8ae6ec3;
var $054b8eaf2efc9950$export$79ffe56a765070d2;
var $054b8eaf2efc9950$export$cc74dcc53cfce4eb;
$054b8eaf2efc9950$export$6ef9df526709859a = `v9qp_q_BAG`;
$054b8eaf2efc9950$export$98e6811b31774aaa = `v9qp_q_BOX`;
$054b8eaf2efc9950$export$2a2bf0aad5996982 = `v9qp_q_ENVELOPE`;
$054b8eaf2efc9950$export$89e395a5ff7cdbd4 = `v9qp_q_MOVING_BOX`;
$054b8eaf2efc9950$export$e0f35d825088c098 = `v9qp_q_field`;
$054b8eaf2efc9950$export$1ca1ec8b29a4ce27 = `v9qp_q_icon`;
$054b8eaf2efc9950$export$38e6d710c8ae6ec3 = `v9qp_q_iconWrapper`;
$054b8eaf2efc9950$export$79ffe56a765070d2 = `v9qp_q_right`;
$054b8eaf2efc9950$export$cc74dcc53cfce4eb = `v9qp_q_wrapper`;


const $64b9d58ae0ce99b7$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($054b8eaf2efc9950$exports);
function $64b9d58ae0ce99b7$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, type: type, title: title, info: info, max: max }) {
    const onChange = (value)=>{
        setFieldValue(field.name, value);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
        alternateBackground: true,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $054b8eaf2efc9950$exports.wrapper,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $054b8eaf2efc9950$exports.iconWrapper,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: `/app/themes/taxi-stockholm/static/img/package-icons/${type}.png`,
                            className: $64b9d58ae0ce99b7$var$cx($054b8eaf2efc9950$exports.icon, type)
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                        title: title,
                        info: info
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $054b8eaf2efc9950$exports.right,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $966dfe9a48e4742e$export$2e2bcd8739ae039), {
                    value: field.value,
                    min: 0,
                    max: max,
                    onChange: onChange
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $5b4005ce3b74faf9$export$2e2bcd8739ae039 = [
    {
        "code": "SE",
        "country": "Sweden",
        "dialCode": "+46"
    },
    {
        "code": "DK",
        "country": "Denmark",
        "dialCode": "+45"
    },
    {
        "code": "NO",
        "country": "Norway",
        "dialCode": "+47"
    },
    {
        "code": "FI",
        "country": "Finland",
        "dialCode": "+358"
    },
    {
        "code": "DE",
        "country": "Germany",
        "dialCode": "+49"
    },
    {
        "code": "AF",
        "country": "Afghanistan",
        "dialCode": "+93"
    },
    {
        "code": "AX",
        "country": "Aland Islands",
        "dialCode": "+358"
    },
    {
        "code": "AL",
        "country": "Albania",
        "dialCode": "+355"
    },
    {
        "code": "DZ",
        "country": "Algeria",
        "dialCode": "+213"
    },
    {
        "code": "AS",
        "country": "AmericanSamoa",
        "dialCode": "+1684"
    },
    {
        "code": "AD",
        "country": "Andorra",
        "dialCode": "+376"
    },
    {
        "code": "AO",
        "country": "Angola",
        "dialCode": "+244"
    },
    {
        "code": "AI",
        "country": "Anguilla",
        "dialCode": "+1264"
    },
    {
        "code": "AQ",
        "country": "Antarctica",
        "dialCode": "+672"
    },
    {
        "code": "AG",
        "country": "Antigua and Barbuda",
        "dialCode": "+1268"
    },
    {
        "code": "AR",
        "country": "Argentina",
        "dialCode": "+54"
    },
    {
        "code": "AM",
        "country": "Armenia",
        "dialCode": "+374"
    },
    {
        "code": "AW",
        "country": "Aruba",
        "dialCode": "+297"
    },
    {
        "code": "AC",
        "country": "Ascension Island",
        "dialCode": "+247"
    },
    {
        "code": "AU",
        "country": "Australia",
        "dialCode": "+61"
    },
    {
        "code": "AT",
        "country": "Austria",
        "dialCode": "+43"
    },
    {
        "code": "AZ",
        "country": "Azerbaijan",
        "dialCode": "+994"
    },
    {
        "code": "BS",
        "country": "Bahamas",
        "dialCode": "+1242"
    },
    {
        "code": "BH",
        "country": "Bahrain",
        "dialCode": "+973"
    },
    {
        "code": "BD",
        "country": "Bangladesh",
        "dialCode": "+880"
    },
    {
        "code": "BB",
        "country": "Barbados",
        "dialCode": "+1246"
    },
    {
        "code": "BY",
        "country": "Belarus",
        "dialCode": "+375"
    },
    {
        "code": "BE",
        "country": "Belgium",
        "dialCode": "+32"
    },
    {
        "code": "BZ",
        "country": "Belize",
        "dialCode": "+501"
    },
    {
        "code": "BJ",
        "country": "Benin",
        "dialCode": "+229"
    },
    {
        "code": "BM",
        "country": "Bermuda",
        "dialCode": "+1441"
    },
    {
        "code": "BT",
        "country": "Bhutan",
        "dialCode": "+975"
    },
    {
        "code": "BO",
        "country": "Bolivia",
        "dialCode": "+591"
    },
    {
        "code": "BA",
        "country": "Bosnia and Herzegovina",
        "dialCode": "+387"
    },
    {
        "code": "BW",
        "country": "Botswana",
        "dialCode": "+267"
    },
    {
        "code": "BR",
        "country": "Brazil",
        "dialCode": "+55"
    },
    {
        "code": "IO",
        "country": "British Indian Ocean Territory",
        "dialCode": "+246"
    },
    {
        "code": "BN",
        "country": "Brunei Darussalam",
        "dialCode": "+673"
    },
    {
        "code": "BG",
        "country": "Bulgaria",
        "dialCode": "+359"
    },
    {
        "code": "BF",
        "country": "Burkina Faso",
        "dialCode": "+226"
    },
    {
        "code": "BI",
        "country": "Burundi",
        "dialCode": "+257"
    },
    {
        "code": "KH",
        "country": "Cambodia",
        "dialCode": "+855"
    },
    {
        "code": "CM",
        "country": "Cameroon",
        "dialCode": "+237"
    },
    {
        "code": "CA",
        "country": "Canada",
        "dialCode": "+1"
    },
    {
        "code": "CV",
        "country": "Cape Verde",
        "dialCode": "+238"
    },
    {
        "code": "KY",
        "country": "Cayman Islands",
        "dialCode": "+1345"
    },
    {
        "code": "CF",
        "country": "Central African Republic",
        "dialCode": "+236"
    },
    {
        "code": "TD",
        "country": "Chad",
        "dialCode": "+235"
    },
    {
        "code": "CL",
        "country": "Chile",
        "dialCode": "+56"
    },
    {
        "code": "CN",
        "country": "China",
        "dialCode": "+86"
    },
    {
        "code": "CX",
        "country": "Christmas Island",
        "dialCode": "+61"
    },
    {
        "code": "CC",
        "country": "Cocos (Keeling) Islands",
        "dialCode": "+61"
    },
    {
        "code": "CO",
        "country": "Colombia",
        "dialCode": "+57"
    },
    {
        "code": "KM",
        "country": "Comoros",
        "dialCode": "+269"
    },
    {
        "code": "CG",
        "country": "Congo",
        "dialCode": "+242"
    },
    {
        "code": "CK",
        "country": "Cook Islands",
        "dialCode": "+682"
    },
    {
        "code": "CR",
        "country": "Costa Rica",
        "dialCode": "+506"
    },
    {
        "code": "CI",
        "country": "Cote d'Ivoire",
        "dialCode": "+225"
    },
    {
        "code": "HR",
        "country": "Croatia",
        "dialCode": "+385"
    },
    {
        "code": "CU",
        "country": "Cuba",
        "dialCode": "+53"
    },
    {
        "code": "CY",
        "country": "Cyprus",
        "dialCode": "+357"
    },
    {
        "code": "CZ",
        "country": "Czech Republic",
        "dialCode": "+420"
    },
    {
        "code": "CD",
        "country": "Democratic Republic of the Congo",
        "dialCode": "+243"
    },
    {
        "code": "DJ",
        "country": "Djibouti",
        "dialCode": "+253"
    },
    {
        "code": "DM",
        "country": "Dominica",
        "dialCode": "+1767"
    },
    {
        "code": "DO",
        "country": "Dominican Republic",
        "dialCode": "+1849"
    },
    {
        "code": "EC",
        "country": "Ecuador",
        "dialCode": "+593"
    },
    {
        "code": "EG",
        "country": "Egypt",
        "dialCode": "+20"
    },
    {
        "code": "SV",
        "country": "El Salvador",
        "dialCode": "+503"
    },
    {
        "code": "GQ",
        "country": "Equatorial Guinea",
        "dialCode": "+240"
    },
    {
        "code": "ER",
        "country": "Eritrea",
        "dialCode": "+291"
    },
    {
        "code": "EE",
        "country": "Estonia",
        "dialCode": "+372"
    },
    {
        "code": "SZ",
        "country": "Eswatini",
        "dialCode": "+268"
    },
    {
        "code": "ET",
        "country": "Ethiopia",
        "dialCode": "+251"
    },
    {
        "code": "FK",
        "country": "Falkland Islands (Malvinas)",
        "dialCode": "+500"
    },
    {
        "code": "FO",
        "country": "Faroe Islands",
        "dialCode": "+298"
    },
    {
        "code": "FJ",
        "country": "Fiji",
        "dialCode": "+679"
    },
    {
        "code": "FR",
        "country": "France",
        "dialCode": "+33"
    },
    {
        "code": "GF",
        "country": "French Guiana",
        "dialCode": "+594"
    },
    {
        "code": "PF",
        "country": "French Polynesia",
        "dialCode": "+689"
    },
    {
        "code": "GA",
        "country": "Gabon",
        "dialCode": "+241"
    },
    {
        "code": "GM",
        "country": "Gambia",
        "dialCode": "+220"
    },
    {
        "code": "GE",
        "country": "Georgia",
        "dialCode": "+995"
    },
    {
        "code": "GH",
        "country": "Ghana",
        "dialCode": "+233"
    },
    {
        "code": "GI",
        "country": "Gibraltar",
        "dialCode": "+350"
    },
    {
        "code": "GR",
        "country": "Greece",
        "dialCode": "+30"
    },
    {
        "code": "GL",
        "country": "Greenland",
        "dialCode": "+299"
    },
    {
        "code": "GD",
        "country": "Grenada",
        "dialCode": "+1473"
    },
    {
        "code": "GP",
        "country": "Guadeloupe",
        "dialCode": "+590"
    },
    {
        "code": "GU",
        "country": "Guam",
        "dialCode": "+1671"
    },
    {
        "code": "GT",
        "country": "Guatemala",
        "dialCode": "+502"
    },
    {
        "code": "GG",
        "country": "Guernsey",
        "dialCode": "+44"
    },
    {
        "code": "GN",
        "country": "Guinea",
        "dialCode": "+224"
    },
    {
        "code": "GW",
        "country": "Guinea-Bissau",
        "dialCode": "+245"
    },
    {
        "code": "GY",
        "country": "Guyana",
        "dialCode": "+592"
    },
    {
        "code": "HT",
        "country": "Haiti",
        "dialCode": "+509"
    },
    {
        "code": "VA",
        "country": "Holy See (Vatican City State)",
        "dialCode": "+379"
    },
    {
        "code": "HN",
        "country": "Honduras",
        "dialCode": "+504"
    },
    {
        "code": "HK",
        "country": "Hong Kong",
        "dialCode": "+852"
    },
    {
        "code": "HU",
        "country": "Hungary",
        "dialCode": "+36"
    },
    {
        "code": "IS",
        "country": "Iceland",
        "dialCode": "+354"
    },
    {
        "code": "IN",
        "country": "India",
        "dialCode": "+91"
    },
    {
        "code": "ID",
        "country": "Indonesia",
        "dialCode": "+62"
    },
    {
        "code": "IR",
        "country": "Iran",
        "dialCode": "+98"
    },
    {
        "code": "IQ",
        "country": "Iraq",
        "dialCode": "+964"
    },
    {
        "code": "IE",
        "country": "Ireland",
        "dialCode": "+353"
    },
    {
        "code": "IM",
        "country": "Isle of Man",
        "dialCode": "+44"
    },
    {
        "code": "IL",
        "country": "Israel",
        "dialCode": "+972"
    },
    {
        "code": "IT",
        "country": "Italy",
        "dialCode": "+39"
    },
    {
        "code": "JM",
        "country": "Jamaica",
        "dialCode": "+1876"
    },
    {
        "code": "JP",
        "country": "Japan",
        "dialCode": "+81"
    },
    {
        "code": "JE",
        "country": "Jersey",
        "dialCode": "+44"
    },
    {
        "code": "JO",
        "country": "Jordan",
        "dialCode": "+962"
    },
    {
        "code": "KZ",
        "country": "Kazakhstan",
        "dialCode": "+77"
    },
    {
        "code": "KE",
        "country": "Kenya",
        "dialCode": "+254"
    },
    {
        "code": "KI",
        "country": "Kiribati",
        "dialCode": "+686"
    },
    {
        "code": "KP",
        "country": "Korea, Democratic People's Republic of Korea",
        "dialCode": "+850"
    },
    {
        "code": "KR",
        "country": "Korea, Republic of South Korea",
        "dialCode": "+82"
    },
    {
        "code": "XK",
        "country": "Kosovo",
        "dialCode": "+383"
    },
    {
        "code": "KW",
        "country": "Kuwait",
        "dialCode": "+965"
    },
    {
        "code": "KG",
        "country": "Kyrgyzstan",
        "dialCode": "+996"
    },
    {
        "code": "LA",
        "country": "Laos",
        "dialCode": "+856"
    },
    {
        "code": "LV",
        "country": "Latvia",
        "dialCode": "+371"
    },
    {
        "code": "LB",
        "country": "Lebanon",
        "dialCode": "+961"
    },
    {
        "code": "LS",
        "country": "Lesotho",
        "dialCode": "+266"
    },
    {
        "code": "LR",
        "country": "Liberia",
        "dialCode": "+231"
    },
    {
        "code": "LY",
        "country": "Libya",
        "dialCode": "+218"
    },
    {
        "code": "LI",
        "country": "Liechtenstein",
        "dialCode": "+423"
    },
    {
        "code": "LT",
        "country": "Lithuania",
        "dialCode": "+370"
    },
    {
        "code": "LU",
        "country": "Luxembourg",
        "dialCode": "+352"
    },
    {
        "code": "MO",
        "country": "Macau",
        "dialCode": "+853"
    },
    {
        "code": "MG",
        "country": "Madagascar",
        "dialCode": "+261"
    },
    {
        "code": "MW",
        "country": "Malawi",
        "dialCode": "+265"
    },
    {
        "code": "MY",
        "country": "Malaysia",
        "dialCode": "+60"
    },
    {
        "code": "MV",
        "country": "Maldives",
        "dialCode": "+960"
    },
    {
        "code": "ML",
        "country": "Mali",
        "dialCode": "+223"
    },
    {
        "code": "MT",
        "country": "Malta",
        "dialCode": "+356"
    },
    {
        "code": "MH",
        "country": "Marshall Islands",
        "dialCode": "+692"
    },
    {
        "code": "MQ",
        "country": "Martinique",
        "dialCode": "+596"
    },
    {
        "code": "MR",
        "country": "Mauritania",
        "dialCode": "+222"
    },
    {
        "code": "MU",
        "country": "Mauritius",
        "dialCode": "+230"
    },
    {
        "code": "YT",
        "country": "Mayotte",
        "dialCode": "+262"
    },
    {
        "code": "MX",
        "country": "Mexico",
        "dialCode": "+52"
    },
    {
        "code": "FM",
        "country": "Micronesia, Federated States of Micronesia",
        "dialCode": "+691"
    },
    {
        "code": "MD",
        "country": "Moldova",
        "dialCode": "+373"
    },
    {
        "code": "MC",
        "country": "Monaco",
        "dialCode": "+377"
    },
    {
        "code": "MN",
        "country": "Mongolia",
        "dialCode": "+976"
    },
    {
        "code": "ME",
        "country": "Montenegro",
        "dialCode": "+382"
    },
    {
        "code": "MS",
        "country": "Montserrat",
        "dialCode": "+1664"
    },
    {
        "code": "MA",
        "country": "Morocco",
        "dialCode": "+212"
    },
    {
        "code": "MZ",
        "country": "Mozambique",
        "dialCode": "+258"
    },
    {
        "code": "MM",
        "country": "Myanmar",
        "dialCode": "+95"
    },
    {
        "code": "NA",
        "country": "Namibia",
        "dialCode": "+264"
    },
    {
        "code": "NR",
        "country": "Nauru",
        "dialCode": "+674"
    },
    {
        "code": "NP",
        "country": "Nepal",
        "dialCode": "+977"
    },
    {
        "code": "NL",
        "country": "Netherlands",
        "dialCode": "+31"
    },
    {
        "code": "NC",
        "country": "New Caledonia",
        "dialCode": "+687"
    },
    {
        "code": "NZ",
        "country": "New Zealand",
        "dialCode": "+64"
    },
    {
        "code": "NI",
        "country": "Nicaragua",
        "dialCode": "+505"
    },
    {
        "code": "NE",
        "country": "Niger",
        "dialCode": "+227"
    },
    {
        "code": "NG",
        "country": "Nigeria",
        "dialCode": "+234"
    },
    {
        "code": "NU",
        "country": "Niue",
        "dialCode": "+683"
    },
    {
        "code": "NF",
        "country": "Norfolk Island",
        "dialCode": "+672"
    },
    {
        "code": "MK",
        "country": "North Macedonia",
        "dialCode": "+389"
    },
    {
        "code": "MP",
        "country": "Northern Mariana Islands",
        "dialCode": "+1670"
    },
    {
        "code": "OM",
        "country": "Oman",
        "dialCode": "+968"
    },
    {
        "code": "PK",
        "country": "Pakistan",
        "dialCode": "+92"
    },
    {
        "code": "PW",
        "country": "Palau",
        "dialCode": "+680"
    },
    {
        "code": "PS",
        "country": "Palestine",
        "dialCode": "+970"
    },
    {
        "code": "PA",
        "country": "Panama",
        "dialCode": "+507"
    },
    {
        "code": "PG",
        "country": "Papua New Guinea",
        "dialCode": "+675"
    },
    {
        "code": "PY",
        "country": "Paraguay",
        "dialCode": "+595"
    },
    {
        "code": "PE",
        "country": "Peru",
        "dialCode": "+51"
    },
    {
        "code": "PH",
        "country": "Philippines",
        "dialCode": "+63"
    },
    {
        "code": "PN",
        "country": "Pitcairn",
        "dialCode": "+872"
    },
    {
        "code": "PL",
        "country": "Poland",
        "dialCode": "+48"
    },
    {
        "code": "PT",
        "country": "Portugal",
        "dialCode": "+351"
    },
    {
        "code": "PR",
        "country": "Puerto Rico",
        "dialCode": "+1939"
    },
    {
        "code": "QA",
        "country": "Qatar",
        "dialCode": "+974"
    },
    {
        "code": "RE",
        "country": "Reunion",
        "dialCode": "+262"
    },
    {
        "code": "RO",
        "country": "Romania",
        "dialCode": "+40"
    },
    {
        "code": "RU",
        "country": "Russia",
        "dialCode": "+7"
    },
    {
        "code": "RW",
        "country": "Rwanda",
        "dialCode": "+250"
    },
    {
        "code": "BL",
        "country": "Saint Barthelemy",
        "dialCode": "+590"
    },
    {
        "code": "SH",
        "country": "Saint Helena, Ascension and Tristan Da Cunha",
        "dialCode": "+290"
    },
    {
        "code": "KN",
        "country": "Saint Kitts and Nevis",
        "dialCode": "+1869"
    },
    {
        "code": "LC",
        "country": "Saint Lucia",
        "dialCode": "+1758"
    },
    {
        "code": "MF",
        "country": "Saint Martin",
        "dialCode": "+590"
    },
    {
        "code": "PM",
        "country": "Saint Pierre and Miquelon",
        "dialCode": "+508"
    },
    {
        "code": "VC",
        "country": "Saint Vincent and the Grenadines",
        "dialCode": "+1784"
    },
    {
        "code": "WS",
        "country": "Samoa",
        "dialCode": "+685"
    },
    {
        "code": "SM",
        "country": "San Marino",
        "dialCode": "+378"
    },
    {
        "code": "ST",
        "country": "Sao Tome and Principe",
        "dialCode": "+239"
    },
    {
        "code": "SA",
        "country": "Saudi Arabia",
        "dialCode": "+966"
    },
    {
        "code": "SN",
        "country": "Senegal",
        "dialCode": "+221"
    },
    {
        "code": "RS",
        "country": "Serbia",
        "dialCode": "+381"
    },
    {
        "code": "SC",
        "country": "Seychelles",
        "dialCode": "+248"
    },
    {
        "code": "SL",
        "country": "Sierra Leone",
        "dialCode": "+232"
    },
    {
        "code": "SG",
        "country": "Singapore",
        "dialCode": "+65"
    },
    {
        "code": "SX",
        "country": "Sint Maarten",
        "dialCode": "+1721"
    },
    {
        "code": "SK",
        "country": "Slovakia",
        "dialCode": "+421"
    },
    {
        "code": "SI",
        "country": "Slovenia",
        "dialCode": "+386"
    },
    {
        "code": "SB",
        "country": "Solomon Islands",
        "dialCode": "+677"
    },
    {
        "code": "SO",
        "country": "Somalia",
        "dialCode": "+252"
    },
    {
        "code": "ZA",
        "country": "South Africa",
        "dialCode": "+27"
    },
    {
        "code": "GS",
        "country": "South Georgia and the South Sandwich Islands",
        "dialCode": "+500"
    },
    {
        "code": "SS",
        "country": "South Sudan",
        "dialCode": "+211"
    },
    {
        "code": "ES",
        "country": "Spain",
        "dialCode": "+34"
    },
    {
        "code": "LK",
        "country": "Sri Lanka",
        "dialCode": "+94"
    },
    {
        "code": "SD",
        "country": "Sudan",
        "dialCode": "+249"
    },
    {
        "code": "SR",
        "country": "Suriname",
        "dialCode": "+597"
    },
    {
        "code": "SJ",
        "country": "Svalbard and Jan Mayen",
        "dialCode": "+47"
    },
    {
        "code": "CH",
        "country": "Switzerland",
        "dialCode": "+41"
    },
    {
        "code": "SY",
        "country": "Syrian Arab Republic",
        "dialCode": "+963"
    },
    {
        "code": "TW",
        "country": "Taiwan",
        "dialCode": "+886"
    },
    {
        "code": "TJ",
        "country": "Tajikistan",
        "dialCode": "+992"
    },
    {
        "code": "TZ",
        "country": "Tanzania, United Republic of Tanzania",
        "dialCode": "+255"
    },
    {
        "code": "TH",
        "country": "Thailand",
        "dialCode": "+66"
    },
    {
        "code": "TL",
        "country": "Timor-Leste",
        "dialCode": "+670"
    },
    {
        "code": "TG",
        "country": "Togo",
        "dialCode": "+228"
    },
    {
        "code": "TK",
        "country": "Tokelau",
        "dialCode": "+690"
    },
    {
        "code": "TO",
        "country": "Tonga",
        "dialCode": "+676"
    },
    {
        "code": "TT",
        "country": "Trinidad and Tobago",
        "dialCode": "+1868"
    },
    {
        "code": "TN",
        "country": "Tunisia",
        "dialCode": "+216"
    },
    {
        "code": "TR",
        "country": "Turkey",
        "dialCode": "+90"
    },
    {
        "code": "TM",
        "country": "Turkmenistan",
        "dialCode": "+993"
    },
    {
        "code": "TC",
        "country": "Turks and Caicos Islands",
        "dialCode": "+1649"
    },
    {
        "code": "TV",
        "country": "Tuvalu",
        "dialCode": "+688"
    },
    {
        "code": "UG",
        "country": "Uganda",
        "dialCode": "+256"
    },
    {
        "code": "UA",
        "country": "Ukraine",
        "dialCode": "+380"
    },
    {
        "code": "AE",
        "country": "United Arab Emirates",
        "dialCode": "+971"
    },
    {
        "code": "GB",
        "country": "United Kingdom",
        "dialCode": "+44"
    },
    {
        "code": "US",
        "country": "United States",
        "dialCode": "+1"
    },
    {
        "code": "UY",
        "country": "Uruguay",
        "dialCode": "+598"
    },
    {
        "code": "UZ",
        "country": "Uzbekistan",
        "dialCode": "+998"
    },
    {
        "code": "VU",
        "country": "Vanuatu",
        "dialCode": "+678"
    },
    {
        "code": "VE",
        "country": "Venezuela, Bolivarian Republic of Venezuela",
        "dialCode": "+58"
    },
    {
        "code": "VN",
        "country": "Vietnam",
        "dialCode": "+84"
    },
    {
        "code": "VG",
        "country": "Virgin Islands, British",
        "dialCode": "+1284"
    },
    {
        "code": "VI",
        "country": "Virgin Islands, U.S.",
        "dialCode": "+1340"
    },
    {
        "code": "WF",
        "country": "Wallis and Futuna",
        "dialCode": "+681"
    },
    {
        "code": "YE",
        "country": "Yemen",
        "dialCode": "+967"
    },
    {
        "code": "ZM",
        "country": "Zambia",
        "dialCode": "+260"
    },
    {
        "code": "ZW",
        "country": "Zimbabwe",
        "dialCode": "+263"
    }
];



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
var $806bea1ee1490dc4$export$bcd1dd1f397bba12;
var $806bea1ee1490dc4$export$42405f212471e8a2;
$806bea1ee1490dc4$export$bcd1dd1f397bba12 = `spcmba_fallback`;
$806bea1ee1490dc4$export$42405f212471e8a2 = `spcmba_flag`;


function $c1b7ec1e807634e0$export$64d92d620a3afdf(countryCode) {
    const codePoints = countryCode.toUpperCase().split('').map((char)=>127397 + char.charCodeAt());
    return String.fromCodePoint(...codePoints);
}
function $c1b7ec1e807634e0$export$2e2bcd8739ae039({ code: code }) {
    if (navigator.userAgent.toLowerCase().indexOf('windows') !== -1) return /*#__PURE__*/ (0, $ih19M.jsx)((0, $bh6RR.Suspense), {
        fallback: /*#__PURE__*/ (0, $ih19M.jsx)($c1b7ec1e807634e0$var$Fallback, {}),
        children: /*#__PURE__*/ (0, $ih19M.jsx)($c1b7ec1e807634e0$var$SVGFlag, {
            code: code
        })
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)($c1b7ec1e807634e0$var$EmojiFlag, {
        code: code
    });
}

const $c1b7ec1e807634e0$var$SVGFlag = /*#__PURE__*/ (0, $bh6RR.lazy)(()=>(parcelRequire("gGwmr")));
const $c1b7ec1e807634e0$var$EmojiFlag = ({ code: code })=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: $806bea1ee1490dc4$export$42405f212471e8a2,
        dangerouslySetInnerHTML: {
            __html: $c1b7ec1e807634e0$export$64d92d620a3afdf(code)
        }
    });
};
const $c1b7ec1e807634e0$var$Fallback = ()=>{
    return /*#__PURE__*/ (0, $ih19M.jsx)("span", {
        className: $806bea1ee1490dc4$export$bcd1dd1f397bba12
    });
};



var $e6356b599f647da1$exports = {};

$parcel$export($e6356b599f647da1$exports, "button", function () { return $e6356b599f647da1$export$2ba01fb71ed41cb6; }, function (v) { return $e6356b599f647da1$export$2ba01fb71ed41cb6 = v; });
$parcel$export($e6356b599f647da1$exports, "buttonWrapper", function () { return $e6356b599f647da1$export$a3b9b213fa74e4fd; }, function (v) { return $e6356b599f647da1$export$a3b9b213fa74e4fd = v; });
$parcel$export($e6356b599f647da1$exports, "dialCode", function () { return $e6356b599f647da1$export$ed6a5a90095a5c5; }, function (v) { return $e6356b599f647da1$export$ed6a5a90095a5c5 = v; });
$parcel$export($e6356b599f647da1$exports, "dropdown", function () { return $e6356b599f647da1$export$81207e5cc4186890; }, function (v) { return $e6356b599f647da1$export$81207e5cc4186890 = v; });
$parcel$export($e6356b599f647da1$exports, "flag", function () { return $e6356b599f647da1$export$42405f212471e8a2; }, function (v) { return $e6356b599f647da1$export$42405f212471e8a2 = v; });
$parcel$export($e6356b599f647da1$exports, "icon", function () { return $e6356b599f647da1$export$1ca1ec8b29a4ce27; }, function (v) { return $e6356b599f647da1$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($e6356b599f647da1$exports, "input", function () { return $e6356b599f647da1$export$b7e3ae3d7c15e42e; }, function (v) { return $e6356b599f647da1$export$b7e3ae3d7c15e42e = v; });
$parcel$export($e6356b599f647da1$exports, "inputWrapper", function () { return $e6356b599f647da1$export$248a47518f3a0001; }, function (v) { return $e6356b599f647da1$export$248a47518f3a0001 = v; });
$parcel$export($e6356b599f647da1$exports, "isOpen", function () { return $e6356b599f647da1$export$ea0830439c7fc698; }, function (v) { return $e6356b599f647da1$export$ea0830439c7fc698 = v; });
$parcel$export($e6356b599f647da1$exports, "item", function () { return $e6356b599f647da1$export$7061c75fc5af8b7e; }, function (v) { return $e6356b599f647da1$export$7061c75fc5af8b7e = v; });
$parcel$export($e6356b599f647da1$exports, "itemButton", function () { return $e6356b599f647da1$export$c185c5b66c5a695a; }, function (v) { return $e6356b599f647da1$export$c185c5b66c5a695a = v; });
$parcel$export($e6356b599f647da1$exports, "list", function () { return $e6356b599f647da1$export$8837f4fc672e936d; }, function (v) { return $e6356b599f647da1$export$8837f4fc672e936d = v; });
$parcel$export($e6356b599f647da1$exports, "renderAbove", function () { return $e6356b599f647da1$export$8e12eb72e526bcfd; }, function (v) { return $e6356b599f647da1$export$8e12eb72e526bcfd = v; });
$parcel$export($e6356b599f647da1$exports, "select", function () { return $e6356b599f647da1$export$2e6c959c16ff56b8; }, function (v) { return $e6356b599f647da1$export$2e6c959c16ff56b8 = v; });
$parcel$export($e6356b599f647da1$exports, "selected", function () { return $e6356b599f647da1$export$d90250155de6d7e7; }, function (v) { return $e6356b599f647da1$export$d90250155de6d7e7 = v; });
$parcel$export($e6356b599f647da1$exports, "text", function () { return $e6356b599f647da1$export$6f093cfa640b7166; }, function (v) { return $e6356b599f647da1$export$6f093cfa640b7166 = v; });
$parcel$export($e6356b599f647da1$exports, "wrapper", function () { return $e6356b599f647da1$export$cc74dcc53cfce4eb; }, function (v) { return $e6356b599f647da1$export$cc74dcc53cfce4eb = v; });
var $e6356b599f647da1$export$2ba01fb71ed41cb6;
var $e6356b599f647da1$export$a3b9b213fa74e4fd;
var $e6356b599f647da1$export$ed6a5a90095a5c5;
var $e6356b599f647da1$export$81207e5cc4186890;
var $e6356b599f647da1$export$42405f212471e8a2;
var $e6356b599f647da1$export$1ca1ec8b29a4ce27;
var $e6356b599f647da1$export$b7e3ae3d7c15e42e;
var $e6356b599f647da1$export$248a47518f3a0001;
var $e6356b599f647da1$export$ea0830439c7fc698;
var $e6356b599f647da1$export$7061c75fc5af8b7e;
var $e6356b599f647da1$export$c185c5b66c5a695a;
var $e6356b599f647da1$export$8837f4fc672e936d;
var $e6356b599f647da1$export$8e12eb72e526bcfd;
var $e6356b599f647da1$export$2e6c959c16ff56b8;
var $e6356b599f647da1$export$d90250155de6d7e7;
var $e6356b599f647da1$export$6f093cfa640b7166;
var $e6356b599f647da1$export$cc74dcc53cfce4eb;
$e6356b599f647da1$export$2ba01fb71ed41cb6 = `s-oIOW_button`;
$e6356b599f647da1$export$a3b9b213fa74e4fd = `s-oIOW_buttonWrapper`;
$e6356b599f647da1$export$ed6a5a90095a5c5 = `s-oIOW_dialCode`;
$e6356b599f647da1$export$81207e5cc4186890 = `s-oIOW_dropdown`;
$e6356b599f647da1$export$42405f212471e8a2 = `s-oIOW_flag`;
$e6356b599f647da1$export$1ca1ec8b29a4ce27 = `s-oIOW_icon`;
$e6356b599f647da1$export$b7e3ae3d7c15e42e = `s-oIOW_input`;
$e6356b599f647da1$export$248a47518f3a0001 = `s-oIOW_inputWrapper`;
$e6356b599f647da1$export$ea0830439c7fc698 = `s-oIOW_isOpen`;
$e6356b599f647da1$export$7061c75fc5af8b7e = `s-oIOW_item`;
$e6356b599f647da1$export$c185c5b66c5a695a = `s-oIOW_itemButton`;
$e6356b599f647da1$export$8837f4fc672e936d = `s-oIOW_list`;
$e6356b599f647da1$export$8e12eb72e526bcfd = `s-oIOW_renderAbove`;
$e6356b599f647da1$export$2e6c959c16ff56b8 = `s-oIOW_select`;
$e6356b599f647da1$export$d90250155de6d7e7 = `s-oIOW_selected`;
$e6356b599f647da1$export$6f093cfa640b7166 = `s-oIOW_text`;
$e6356b599f647da1$export$cc74dcc53cfce4eb = `s-oIOW_wrapper`;


const $afc2c9aeefa09a63$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($e6356b599f647da1$exports);
function $afc2c9aeefa09a63$export$2e2bcd8739ae039({ innerRef: innerRef, onSubmit: onSubmit }) {
    const wrapperRef = (0, $bh6RR.useRef)();
    const listRef = (0, $bh6RR.useRef)();
    const buttonRef = (0, $bh6RR.useRef)();
    const inputRef = innerRef || (0, $bh6RR.useRef)();
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const [renderAbove, setRenderAbove] = (0, $bh6RR.useState)(false);
    const isMobile = (0, $ef42d3c0207235e0$export$32d5543ab307c01)('only screen and (max-width: 969px)');
    const { values: values, setFieldValue: setFieldValue } = (0, $lW2XZ.useFormikContext)();
    const [inputField] = (0, $lW2XZ.useField)({
        name: 'phone'
    });
    const toggleOpen = ()=>{
        if (!isOpen && wrapperRef.current) {
            const rect = wrapperRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - (rect.y + rect.height);
            setRenderAbove(spaceBelow < rect.y);
        }
        setIsOpen(!isOpen);
    };
    const selectItem = (item)=>{
        setIsOpen(false);
        setFieldValue('dialCode', item.dialCode);
        inputRef?.current?.focus();
    };
    const onBlur = (e)=>{
        if (!listRef?.current?.contains(e?.relatedTarget)) setIsOpen(false);
    };
    const onChange = (e)=>{
        const item = (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039).find((item)=>item.code === e.target.value);
        setFieldValue('dialCode', item.dialCode);
        inputRef?.current?.focus();
    };
    const inputFieldChange = (e)=>{
        let value = e.target.value;
        // Strip dial code if for example pasting
        if (value.indexOf(values.dialCode) === 0) value = value.substr(values.dialCode.length);
        setFieldValue(inputField.name, value);
    };
    const handleBlur = (e)=>{
        if (e.relatedTarget !== buttonRef.current) inputField.onBlur(e);
    };
    const handleKeyDown = (e)=>{
        if (e.keyCode === 13 && onSubmit) onSubmit();
    };
    (0, $bh6RR.useEffect)(()=>{
        if (isOpen && listRef.current) listRef.current.scrollTop = renderAbove ? 50000 : 0;
    }, [
        isOpen,
        renderAbove,
        listRef
    ]);
    const selected = (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039).find((item)=>item.dialCode === values.dialCode);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: wrapperRef,
        className: $e6356b599f647da1$exports.wrapper,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $e6356b599f647da1$exports.buttonWrapper,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                        ref: buttonRef,
                        className: $afc2c9aeefa09a63$var$cx($e6356b599f647da1$exports.button, {
                            isOpen: isOpen
                        }),
                        onClick: toggleOpen,
                        onBlur: onBlur,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $c1b7ec1e807634e0$export$2e2bcd8739ae039), {
                                code: selected.code
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $e6356b599f647da1$exports.icon
                            })
                        ]
                    }),
                    isMobile && /*#__PURE__*/ (0, $ih19M.jsx)("select", {
                        value: selected.code,
                        className: $e6356b599f647da1$exports.select,
                        onChange: onChange,
                        children: (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039) && (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039).map((item)=>{
                            return /*#__PURE__*/ (0, $ih19M.jsx)("option", {
                                value: item.code,
                                dangerouslySetInnerHTML: {
                                    __html: (0, $c1b7ec1e807634e0$export$64d92d620a3afdf)(item.code) + ' ' + item.country
                                }
                            }, item.code);
                        })
                    })
                ]
            }),
            !isMobile && isOpen && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $afc2c9aeefa09a63$var$cx($e6356b599f647da1$exports.dropdown, {
                    renderAbove: renderAbove
                }),
                children: /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                    ref: listRef,
                    className: $e6356b599f647da1$exports.list,
                    children: (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039) && (renderAbove ? [
                        ...(0, $5b4005ce3b74faf9$export$2e2bcd8739ae039)
                    ].reverse() : (0, $5b4005ce3b74faf9$export$2e2bcd8739ae039)).map((item)=>{
                        return /*#__PURE__*/ (0, $ih19M.jsx)("li", {
                            className: $e6356b599f647da1$exports.item,
                            title: item.country,
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                className: $e6356b599f647da1$exports.itemButton,
                                onClick: ()=>selectItem(item),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $c1b7ec1e807634e0$export$2e2bcd8739ae039), {
                                        code: item.code
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: $e6356b599f647da1$exports.text,
                                        children: item.country
                                    })
                                ]
                            })
                        }, item.code);
                    })
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $e6356b599f647da1$exports.inputWrapper,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $e6356b599f647da1$exports.dialCode,
                        children: selected.dialCode
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                        ref: inputRef,
                        className: $e6356b599f647da1$exports.input,
                        type: "text",
                        inputMode: "numeric",
                        autoComplete: "tel-national",
                        name: inputField.name,
                        value: inputField.value,
                        onBlur: handleBlur,
                        onChange: inputFieldChange,
                        onKeyDown: handleKeyDown
                    })
                ]
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3228-31672
// Component: SelectedPayment — payment option row with icon, title/info, price, radio indicator

var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $5TnqA = parcelRequire("5TnqA");

// Matches Figma Radiobutton (node 52:1061 / 52:1063) — same as CarRadioField
function $3dde695a71cd735d$var$RadioIcon({ checked: checked }) {
    if (checked) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                stroke: "#BA8200",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1404 6.74141C16.3176 6.88535 16.4061 6.95732 16.4635 7.03588C16.6206 7.25109 16.6517 7.53347 16.5452 7.77772C16.5064 7.86689 16.4356 7.95642 16.294 8.13548L10.6357 15.2931C10.4676 15.5057 10.3836 15.6121 10.2776 15.6621C10.1843 15.7062 10.0797 15.7203 9.97813 15.7026C9.86267 15.6825 9.75339 15.6023 9.53484 15.4419L5.92882 12.7955C5.73218 12.6512 5.63385 12.579 5.57038 12.4981C5.40396 12.2859 5.36426 12.0007 5.46639 11.7512C5.50535 11.656 5.58023 11.5597 5.72998 11.3672C5.87077 11.1862 5.94116 11.0957 6.01956 11.0362C6.2248 10.8806 6.49554 10.8411 6.73664 10.9317C6.82875 10.9664 6.92204 11.033 7.10862 11.1664L9.8395 13.1178L14.7258 6.89943C14.8706 6.71509 14.943 6.62293 15.0224 6.56357C15.2401 6.40085 15.5287 6.36861 15.7769 6.47929C15.8675 6.51967 15.9585 6.59358 16.1404 6.74141Z",
                fill: "#17181A"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "11",
            cy: "11",
            r: "10.5",
            stroke: "#8c8c8c",
            strokeWidth: "1"
        })
    });
}
function $3dde695a71cd735d$var$InfoCircleIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "7",
                cy: "7",
                r: "6",
                stroke: "#8c8c8c",
                strokeWidth: "1.2"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "6.4",
                y: "6",
                width: "1.2",
                height: "4.5",
                rx: "0.6",
                fill: "#8c8c8c"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "7",
                cy: "4.25",
                r: "0.7",
                fill: "#8c8c8c"
            })
        ]
    });
}
function $3dde695a71cd735d$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, title: title, info: info, icon: icon, price: price, originalPrice: originalPrice, voucherPill: voucherPill, onInfo: onInfo, disabled: disabled, hidden: hidden, innerRef: innerRef, tabIndex: tabIndex, alternateBackground: // legacy props — accepted but not used in new layout
alternateBackground, disabledDescription: disabledDescription, ...props }) {
    const isChecked = field.checked;
    const clickRef = (0, $bh6RR.useRef)();
    const handleClick = ()=>{
        if (disabled) return;
        (innerRef || clickRef)?.current?.click();
    };
    const handleKeyDown = (e)=>{
        if (e.keyCode === 32) e.preventDefault();
    };
    const handleKeyUp = (e)=>{
        if (e.keyCode === 32) {
            e.preventDefault();
            setFieldValue(field.name, field.value);
            if (props.onClick) props.onClick();
        }
    };
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    if (hidden) return null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full cursor-pointer relative', disabled && 'pointer-events-none'),
        children: [
            onInfo && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: (e)=>{
                    e.stopPropagation();
                    onInfo();
                },
                className: "absolute top-1 right-0 p-0.5",
                tabIndex: -1,
                "aria-label": "More information",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($3dde695a71cd735d$var$InfoCircleIcon, {})
            }),
            icon && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('shrink-0 size-11 flex items-center justify-center overflow-clip', disabled && 'opacity-[0.38]'),
                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: `/app/themes/${theme}/static/img/option-icons/${icon}.png`,
                    alt: "",
                    className: "size-full object-contain"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface', disabled && 'opacity-[0.38]'),
                        children: title
                    }),
                    info && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-[15px] leading-5 text-on-surface-variant', disabled && 'opacity-[0.38]'),
                        children: info
                    }),
                    disabledDescription && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                            text: disabledDescription
                        })
                    }),
                    voucherPill && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                            text: voucherPill,
                            type: "user-choice"
                        })
                    })
                ]
            }),
            price && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex flex-col items-end gap-0.5 shrink-0', disabled && 'opacity-[0.38]'),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-bold uppercase tracking-[0.68px] leading-5 text-on-surface whitespace-nowrap",
                        children: price
                    }),
                    originalPrice && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] text-on-surface-variant line-through leading-5 whitespace-nowrap",
                        children: originalPrice
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                ref: innerRef || clickRef,
                tabIndex: disabled ? -1 : tabIndex ?? 0,
                onKeyDown: handleKeyDown,
                onKeyUp: handleKeyUp,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('shrink-0 cursor-pointer', disabled && 'opacity-[0.38]'),
                onClick: (e)=>e.stopPropagation(),
                "aria-label": title,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)($3dde695a71cd735d$var$RadioIcon, {
                        checked: isChecked
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "radio",
                        as: "input",
                        className: "sr-only",
                        name: field.name,
                        onChange: field.onChange,
                        onBlur: field.onBlur,
                        disabled: disabled,
                        ...props
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

function $d87fa2da2c7fef35$export$2e2bcd8739ae039({ field: field, form: form, title: title, reverseLayout: reverseLayout, alternateBackground: alternateBackground, ...props }) {
    const isChecked = field.value;
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $582402ece63dbe0f$export$2e2bcd8739ae039), {
        isChecked: isChecked,
        name: field.name,
        form: form,
        onChange: field.onChange,
        onBlur: field.onBlur,
        ...props
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $1f39afa560891813$export$2da9be4cfdb689b1;
$1f39afa560891813$export$2da9be4cfdb689b1 = `_0S-3CW_time`;


function $feceed654bcbd7e8$export$2e2bcd8739ae039({ field: field, form: { setFieldValue: setFieldValue }, minDate: minDate, maxDate: maxDate, clampDate: clampDate }) {
    const [selectedDate, setSelectedDate] = (0, $bh6RR.useState)(field.value || minDate || new Date());
    const onDateChange = (date)=>{
        const clamped = clampDate(date);
        setSelectedDate(clamped);
        setFieldValue(field.name, clamped);
    };
    (0, $bh6RR.useEffect)(()=>{
        if (field.value) setSelectedDate(field.value);
    }, [
        field.value
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $1f39afa560891813$export$2da9be4cfdb689b1,
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $a65d0d54e3c9a72a$export$2e2bcd8739ae039), {
            selected: selectedDate,
            onChange: onDateChange
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $0da3a91fef2604c7$export$a7db06668cad9adb;
$0da3a91fef2604c7$export$a7db06668cad9adb = `rJTyNW_content`;


function $3afd0f91fc152672$export$2e2bcd8739ae039({ field: field, form: form, title: title, info: info, showSpinner: showSpinner, secondOption: secondOption, reverseLayout: reverseLayout, alternateBackground: alternateBackground, larger: larger, children: children, innerRef: innerRef, ...props }) {
    const isChecked = Array.isArray(field.value) ? field.value.includes(props?.value) : field.value;
    const isDisabled = props.disabled;
    const clickRef = (0, $bh6RR.useRef)();
    const SwitchUi = secondOption ? (0, $70c3f2f6772c0dac$export$2e2bcd8739ae039) : (0, $582402ece63dbe0f$export$2e2bcd8739ae039);
    const wrapperClick = (e)=>{
        if (e.clientX !== 0 && e.clientY !== 0) (innerRef || clickRef)?.current?.click();
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
        reverseLayout: reverseLayout,
        noPadding: true,
        column: true,
        alternateBackground: alternateBackground,
        isDisabledVisible: isDisabled,
        larger: larger,
        onClick: wrapperClick,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)(SwitchUi, {
                innerRef: innerRef || clickRef,
                isChecked: !isChecked,
                name: field.name,
                field: field,
                form: form,
                onChange: field.onChange,
                onBlur: field.onBlur,
                option1: title,
                option2: secondOption,
                showSpinner: showSpinner,
                ...props
            }),
            children
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $10d38ac3dc965e21$export$a7db06668cad9adb;
var $10d38ac3dc965e21$export$1ca1ec8b29a4ce27;
$10d38ac3dc965e21$export$a7db06668cad9adb = `C4erWq_content`;
$10d38ac3dc965e21$export$1ca1ec8b29a4ce27 = `C4erWq_icon`;


function $196b7faa750ebd16$export$2e2bcd8739ae039({ field: field, form: form, title: title, info: info, icon1: icon1, icon2: icon2, noPadding: noPadding, reverseLayout: reverseLayout, alternateBackground: alternateBackground, larger: larger, children: children, innerRef: innerRef, ...props }) {
    const isChecked = Array.isArray(field.value) ? field.value.includes(props?.value) : field.value;
    const isDisabled = props.disabled;
    const clickRef = (0, $bh6RR.useRef)();
    const wrapperClick = (e)=>{
        if (e.clientX !== 0 && e.clientY !== 0) (innerRef || clickRef)?.current?.click();
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
        reverseLayout: reverseLayout,
        noPadding: true,
        alternateBackground: alternateBackground,
        isDisabled: isDisabled,
        larger: larger,
        onClick: wrapperClick,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $10d38ac3dc965e21$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                        title: title,
                        info: info
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $70c3f2f6772c0dac$export$2e2bcd8739ae039), {
                innerRef: innerRef || clickRef,
                isChecked: isChecked,
                icon1: icon1,
                icon2: icon2,
                name: field.name,
                field: field,
                form: form,
                onChange: field.onChange,
                onBlur: field.onBlur,
                ...props
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2045-26961
// ─── Icons ────────────────────────────────────────────────────────────────────

var $ih19M = parcelRequire("ih19M");
function $e891d0fba1229c08$export$70102a2288009899() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "18",
        height: "17",
        viewBox: "0 0 18 16.37",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M17.2002 12.3699C17.4799 12.3699 17.6197 12.3702 17.7266 12.4246C17.8205 12.4724 17.8974 12.5485 17.9453 12.6424C17.9998 12.7493 18 12.8897 18 13.1697V15.5701C18 15.8498 17.9997 15.9896 17.9453 16.0965C17.8974 16.1905 17.8206 16.2673 17.7266 16.3152C17.6197 16.3695 17.4798 16.3699 17.2002 16.3699H14.7998C14.5202 16.3699 14.3803 16.3695 14.2734 16.3152C14.1794 16.2673 14.1026 16.1905 14.0547 16.0965C14.0003 15.9896 14 15.8498 14 15.5701V13.1697C14 12.8897 14.0002 12.7493 14.0547 12.6424C14.1026 12.5485 14.1795 12.4724 14.2734 12.4246C14.3803 12.3702 14.5201 12.3699 14.7998 12.3699H17.2002ZM11 1.36989C13.2091 1.36989 15 3.16075 15 5.36989C14.9999 7.57897 13.2091 9.36989 11 9.36989H7C5.89543 9.36989 5 10.2653 5 11.3699C5.00007 12.4744 5.89547 13.3699 7 13.3699H11.1689C11.2907 13.3699 11.3518 13.3699 11.4092 13.3836C11.46 13.3958 11.5091 13.4159 11.5537 13.4431C11.6042 13.4741 11.6479 13.5178 11.7344 13.6043L12.2168 14.0867C12.3158 14.1857 12.3652 14.2357 12.3838 14.2927C12.4001 14.3429 12.4001 14.3969 12.3838 14.447C12.3652 14.5041 12.3157 14.5542 12.2168 14.6531L11.7344 15.1355C11.6479 15.222 11.6042 15.2647 11.5537 15.2957C11.509 15.323 11.4601 15.344 11.4092 15.3562C11.3518 15.3699 11.2907 15.3699 11.1689 15.3699H7C4.7909 15.3699 3.00007 13.579 3 11.3699C3 9.16075 4.79086 7.36989 7 7.36989H11C12.1045 7.36989 12.9999 6.4744 13 5.36989C13 4.26532 12.1046 3.36989 11 3.36989H7C6.76751 3.36989 6.65104 3.37005 6.55566 3.3445C6.297 3.27514 6.0948 3.07287 6.02539 2.81423C5.99984 2.71887 6 2.6023 6 2.36989C6 2.1374 5.99983 2.02093 6.02539 1.92555C6.09474 1.66682 6.29696 1.46468 6.55566 1.39528C6.65104 1.36972 6.76751 1.36989 7 1.36989H11ZM0 0.330827C0.000194149 0.0722313 0.283594 -0.0859028 0.503906 0.0495768L3.84277 2.10329C4.05256 2.23239 4.05233 2.53747 3.84277 2.66676L0.503906 4.72145C0.283608 4.85691 0.00022271 4.69877 0 4.4402V0.330827Z",
            fill: "currentColor"
        })
    });
}
function $e891d0fba1229c08$export$af37dba276592e85() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "17",
        height: "14",
        viewBox: "0 0 16.702 13.637",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M5.04971 0.101445C5.28142 -0.0330778 5.56735 -0.0338939 5.79971 0.0994917C5.88533 0.14865 5.96797 0.230449 6.13272 0.394414C6.29751 0.558415 6.38002 0.641053 6.4296 0.726445C6.56389 0.9581 6.56489 1.24421 6.43155 1.47644C6.38238 1.56202 6.29955 1.64379 6.13565 1.80848L4.28995 3.65418C4.07717 3.86798 3.97109 3.97549 3.96378 4.06727C3.95764 4.14697 3.98987 4.22535 4.05069 4.27723C4.12085 4.33688 4.27231 4.3368 4.57413 4.3368H12.7021C14.9112 4.3368 16.7021 6.12766 16.7021 8.3368C16.7021 9.20228 16.4215 10.0448 15.9023 10.7372L13.9521 13.3368C13.7035 13.668 13.2335 13.7356 12.9023 13.4872L12.5028 13.1864C12.1715 12.9379 12.1039 12.468 12.3524 12.1366L14.3026 9.53699C14.5623 9.1908 14.7021 8.76954 14.7021 8.3368C14.7021 7.23223 13.8066 6.3368 12.7021 6.3368H4.57413L4.2255 6.34461C4.1412 6.35206 4.08578 6.36653 4.05069 6.39637C3.98987 6.44824 3.95764 6.52662 3.96378 6.60633C3.97109 6.69811 4.07717 6.80561 4.28995 7.01941L6.13565 8.86512C6.29954 9.0298 6.38238 9.11158 6.43155 9.19715C6.56489 9.42938 6.56389 9.71549 6.4296 9.94715C6.38002 10.0325 6.29751 10.1152 6.13272 10.2792C5.96797 10.4431 5.88533 10.5249 5.79971 10.5741C5.56735 10.7075 5.28142 10.7067 5.04971 10.5721C4.96438 10.5226 4.88256 10.44 4.71866 10.2753L0.356354 5.90125C0.159823 5.70377 0.0612524 5.60483 0.0243232 5.49109C-0.00810773 5.39095 -0.00810773 5.28264 0.0243232 5.1825C0.061253 5.06877 0.159825 4.96982 0.356354 4.77234L4.71866 0.39832C4.88257 0.233619 4.96437 0.151029 5.04971 0.101445Z",
            fill: "currentColor"
        })
    });
}
function $e891d0fba1229c08$export$6c65bc9b1cd4941d() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "18",
        height: "14",
        viewBox: "0 0 20 16",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M18.5 4.5L11.2168 8.78421C10.774 9.04473 10.5525 9.17499 10.3166 9.22593C10.108 9.271 9.89205 9.271 9.68337 9.22593C9.44748 9.17499 9.22604 9.04473 8.78315 8.78421L1.5 4.5M19 5V11C19 12.4001 19 13.1002 18.7275 13.635C18.4878 14.1054 18.1054 14.4878 17.635 14.7275C17.1002 15 16.4001 15 15 15H5C3.59987 15 2.8998 15 2.36502 14.7275C1.89462 14.4878 1.51217 14.1054 1.27248 13.635C1 13.1002 1 12.4001 1 11V5C1 3.59987 1 2.8998 1.27248 2.36502C1.51217 1.89462 1.89462 1.51217 2.36502 1.27248C2.8998 1 3.59987 1 5 1H15C16.4001 1 17.1002 1 17.635 1.27248C18.1054 1.51217 18.4878 1.89462 18.7275 2.36502C19 2.8998 19 3.59987 19 5Z",
            stroke: "currentColor",
            strokeWidth: "2"
        })
    });
}
function $e891d0fba1229c08$export$c08de30e3fac7af1() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "17",
        viewBox: "0 0 23.948 17",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.94816 1.125C7.94816 1.24149 7.94816 1.29973 7.92913 1.34567C7.90376 1.40693 7.85509 1.4556 7.79384 1.48097C7.74789 1.5 7.68965 1.5 7.57316 1.5H6.7976C6.74815 1.5 6.69936 1.49997 6.65121 1.49994C5.7577 1.49935 5.08387 1.49891 4.46535 1.70487C3.92109 1.8861 3.42218 2.18227 3.00247 2.57328C2.52548 3.01765 2.2032 3.60942 1.77585 4.39411C1.75282 4.4364 1.72949 4.47924 1.70581 4.52266L0.348527 7.01101C0.341559 7.02378 0.33437 7.03689 0.327006 7.05031C0.246477 7.19712 0.145055 7.38202 0.0836689 7.58749C0.0303956 7.7658 0.00227012 7.95067 0.000106354 8.13676C-0.00238691 8.35119 0.0394606 8.55788 0.0726876 8.722C0.0757259 8.73701 0.078692 8.75166 0.0815456 8.76593L0.868297 12.6997C0.870316 12.7098 0.872547 12.7215 0.875058 12.7348C0.899186 12.8621 0.949238 13.1262 1.0867 13.3576C1.20244 13.5525 1.36083 13.7186 1.54997 13.8435C1.77463 13.9918 2.03602 14.0544 2.16202 14.0845C2.17514 14.0876 2.18679 14.0904 2.19678 14.0929L3.04094 14.304C3.40422 15.8495 4.79183 17 6.44816 17C8.03367 17 9.37295 15.9457 9.80322 14.5H14.0931C14.5234 15.9457 15.8627 17 17.4482 17C19.0826 17 20.4554 15.8797 20.8404 14.3651L22.4641 14.0945C22.5647 14.0778 22.6879 14.0573 22.7963 14.0307C22.9242 13.9993 23.0999 13.9444 23.2788 13.8255C23.5144 13.6688 23.7009 13.4486 23.8168 13.1904C23.9047 12.9945 23.9299 12.8121 23.9398 12.6808C23.9483 12.5695 23.9482 12.4446 23.9482 12.3426L23.9482 10.0895C23.9482 9.65119 23.9482 9.269 23.9245 8.9501C23.8992 8.61042 23.8436 8.27347 23.6971 7.93822C23.4757 7.43165 23.1186 6.9961 22.6653 6.67966C22.3653 6.47025 22.0458 6.34962 21.7177 6.25824C21.4096 6.17246 21.0349 6.09752 20.6051 6.01158L18.4412 5.5788L16.0612 3.19878C16.0368 3.17445 16.0128 3.15043 15.9891 3.12672C15.5403 2.67749 15.2012 2.33807 14.7955 2.08944C14.4376 1.87012 14.0475 1.70851 13.6393 1.61052C13.1766 1.49944 12.6968 1.49967 12.0618 1.49997C12.0283 1.49998 11.9943 1.5 11.9599 1.5H10.3232C10.2067 1.5 10.1484 1.5 10.1025 1.48097C10.0412 1.4556 9.99257 1.40693 9.96719 1.34567C9.94816 1.29973 9.94816 1.24149 9.94816 1.125V1C9.94816 0.767507 9.94816 0.651261 9.92261 0.555886C9.85326 0.297067 9.6511 0.094906 9.39228 0.0255556C9.2969 0 9.18066 0 8.94816 0C8.71567 0 8.59943 0 8.50405 0.0255556C8.24523 0.094906 8.04307 0.297067 7.97372 0.555886C7.94816 0.651261 7.94816 0.767507 7.94816 1V1.125ZM20.7554 12.3517L21.9482 12.1529V10.1234C21.9482 9.6414 21.9475 9.33422 21.93 9.09834C21.9134 8.87503 21.8853 8.78688 21.8645 8.73915C21.7907 8.57029 21.6717 8.42511 21.5206 8.31962C21.4778 8.28981 21.3969 8.24501 21.1812 8.18494C20.9533 8.12149 20.6522 8.06062 20.1796 7.96609L17.4552 7.4212L14.6469 4.61299C14.0944 4.06048 13.9289 3.90402 13.7505 3.79472C13.5716 3.68506 13.3765 3.60425 13.1724 3.55526C12.969 3.50643 12.7413 3.5 11.9599 3.5H6.7976C5.69154 3.5 5.36824 3.51219 5.09721 3.60243C4.82508 3.69305 4.57562 3.84113 4.36576 4.03664C4.15675 4.23136 3.99124 4.50936 3.4616 5.48036L2.10432 7.96871C2.04909 8.06997 2.02186 8.12028 2.00344 8.1576L2.00209 8.16034L2.00256 8.16335C2.00905 8.20446 2.02009 8.26059 2.04271 8.37369L2.80464 12.1833L3.16876 12.2744C3.66549 10.9459 4.94637 10 6.44816 10C8.03367 10 9.37295 11.0543 9.80322 12.5H14.0931C14.5234 11.0543 15.8627 10 17.4482 10C18.9789 10 20.2802 10.9827 20.7554 12.3517ZM6.44816 12C5.61974 12 4.94816 12.6716 4.94816 13.5C4.94816 14.3284 5.61974 15 6.44816 15C7.27659 15 7.94816 14.3284 7.94816 13.5C7.94816 12.6716 7.27659 12 6.44816 12ZM17.4482 12C16.6197 12 15.9482 12.6716 15.9482 13.5C15.9482 14.3284 16.6197 15 17.4482 15C18.2766 15 18.9482 14.3284 18.9482 13.5C18.9482 12.6716 18.2766 12 17.4482 12Z",
            fill: "currentColor"
        })
    });
}
function $e891d0fba1229c08$export$174e4a35fe496af8() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "16",
        height: "20",
        viewBox: "0 0 16 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M9.07032 6.47226e-05C9.36932 -0.000374039 9.67035 -0.000543953 9.96192 0.0694007C10.2168 0.130603 10.461 0.23129 10.6846 0.368229C10.9401 0.524828 11.1512 0.736549 11.3604 0.946354L15.0537 4.63971C15.2636 4.84895 15.4752 5.05989 15.6318 5.31549C15.7688 5.5391 15.8694 5.78316 15.9307 6.03815C16.0007 6.32977 16.0004 6.63069 16 6.92975V16.6358C16 17.0249 16.0004 17.3757 15.9766 17.6671C15.9511 17.9789 15.8929 18.3101 15.7275 18.6348C15.4879 19.1052 15.1052 19.4879 14.6348 19.7276C14.31 19.893 13.9788 19.9511 13.667 19.9766C13.3757 20.0004 13.0248 20.0001 12.6357 20.0001H3.36426C2.97518 20.0001 2.62432 20.0004 2.33301 19.9766C2.02118 19.9511 1.68998 19.893 1.36524 19.7276C0.894832 19.4879 0.512147 19.1052 0.272464 18.6348C0.107065 18.3101 0.0489297 17.9789 0.0234402 17.6671C-0.000361268 17.3757 -1.96735e-05 17.0249 2.73788e-06 16.6358V3.36432C-1.96607e-05 2.97545 -0.000320605 2.62527 0.0234402 2.33405C0.0489273 2.0221 0.106944 1.69018 0.272464 1.3653C0.512147 0.894894 0.894832 0.512209 1.36524 0.272526C1.68995 0.107128 2.02121 0.0489986 2.33301 0.0235022C2.62433 -0.000299283 2.97517 4.23113e-05 3.36426 6.47226e-05H9.07032ZM3.40039 2.00006C2.96385 2.00006 2.69606 2.00131 2.4961 2.01764C2.40305 2.02525 2.34671 2.03498 2.3125 2.04303C2.2966 2.04678 2.28673 2.04988 2.28125 2.05182C2.27687 2.05339 2.27428 2.05434 2.27344 2.05475C2.17936 2.10269 2.10263 2.17942 2.05469 2.2735C2.05435 2.27418 2.05344 2.2766 2.05176 2.28131C2.04982 2.28676 2.04579 2.29646 2.04199 2.31256C2.03394 2.34675 2.02519 2.4032 2.01758 2.49616C2.00124 2.69612 2 2.96392 2 3.40046V16.6007C2 17.0369 2.00125 17.3041 2.01758 17.504C2.02518 17.5969 2.03395 17.6533 2.04199 17.6876C2.04583 17.7038 2.04983 17.7144 2.05176 17.7198C2.05352 17.7247 2.05449 17.7272 2.05469 17.7276C2.10264 17.8215 2.17949 17.8975 2.27344 17.9454C2.27417 17.9457 2.27665 17.9476 2.28125 17.9493C2.28678 17.9512 2.29674 17.9544 2.3125 17.9581C2.34672 17.9661 2.40305 17.9759 2.4961 17.9835C2.69606 17.9998 2.96385 18.0001 3.40039 18.0001H12.5996C13.0362 18.0001 13.3039 17.9998 13.5039 17.9835C13.5969 17.9759 13.6533 17.9661 13.6875 17.9581C13.7033 17.9544 13.7132 17.9512 13.7188 17.9493C13.7233 17.9476 13.7258 17.9457 13.7266 17.9454C13.8205 17.8975 13.8974 17.8215 13.9453 17.7276C13.9454 17.7273 13.9464 17.7258 13.9473 17.7237C13.9477 17.7227 13.9477 17.7213 13.9482 17.7198C13.9502 17.7144 13.9542 17.7038 13.958 17.6876C13.9661 17.6533 13.9748 17.5969 13.9824 17.504C13.9988 17.3041 14 17.0369 14 16.6007V8.00006H10.5684C10.316 8.00009 10.0695 8.00047 9.86133 7.98346C9.63283 7.96477 9.36305 7.9205 9.0918 7.78229C8.71554 7.59054 8.4095 7.28454 8.21778 6.90827C8.07954 6.63696 8.03529 6.36727 8.0166 6.13874C7.9996 5.93058 7.99997 5.68409 8 5.43171V2.00006H3.40039ZM8 14.0001C8.2325 14.0001 8.34896 13.9999 8.44434 14.0255C8.703 14.0948 8.9052 14.2971 8.97461 14.5557C9.00016 14.6511 9 14.7677 9 15.0001C9 15.2326 9.00017 15.349 8.97461 15.4444C8.90527 15.7031 8.70305 15.9053 8.44434 15.9747C8.34896 16.0002 8.2325 16.0001 8 16.0001H5C4.76751 16.0001 4.65104 16.0002 4.55567 15.9747C4.29696 15.9053 4.09474 15.7031 4.02539 15.4444C3.99984 15.349 4 15.2326 4 15.0001C4 14.7677 3.99984 14.6511 4.02539 14.5557C4.09481 14.2971 4.29701 14.0948 4.55567 14.0255C4.65104 13.9999 4.76751 14.0001 5 14.0001H8ZM11 10.0001C11.2325 10.0001 11.349 9.9999 11.4443 10.0255C11.703 10.0948 11.9052 10.2971 11.9746 10.5557C12.0002 10.6511 12 10.7677 12 11.0001C12 11.2326 12.0002 11.349 11.9746 11.4444C11.9053 11.7031 11.703 11.9053 11.4443 11.9747C11.349 12.0002 11.2325 12.0001 11 12.0001H5C4.76751 12.0001 4.65104 12.0002 4.55567 11.9747C4.29696 11.9053 4.09474 15.7031 4.02539 11.4444C3.99984 11.349 4 11.2326 4 11.0001C4 10.7677 3.99984 10.6511 4.02539 10.5557C4.09481 10.2971 4.29701 10.0948 4.55567 10.0255C4.65104 9.9999 4.76751 10.0001 5 10.0001H11ZM10 5.40046C10 5.69682 10.0012 5.8591 10.0107 5.97565C10.141 5.99982 10.3033 6.00006 10.5996 6.00006H13.5859L10 2.41413V5.40046Z",
            fill: "currentColor"
        })
    });
}
function $e891d0fba1229c08$export$5fda1783bb83f57b() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "16",
        height: "18",
        viewBox: "0 0 16 17.012",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M3.47791 1.38183C3.47565 1.52362 3.47451 1.59452 3.4577 1.65568C3.41267 1.81942 3.29428 1.94415 3.13311 1.99765C3.07291 2.01763 2.99448 2.02298 2.83762 2.03368C2.50779 2.05619 2.17788 2.10569 1.85195 2.24069C1.11687 2.54518 0.532845 3.1292 0.228363 3.86428C0.0933593 4.19021 0.0438555 4.52012 0.0213515 4.84995C-2.20276e-05 5.16321 -1.118e-05 5.5417 1.09853e-06 5.98035L5.40619e-07 7.01233C4.14929e-07 7.24482 3.52084e-07 7.36107 0.025556 7.45645C0.0949063 7.71526 0.297067 7.91742 0.555886 7.98678C0.651261 8.01233 0.767508 8.01233 1 8.01233C1.23249 8.01233 1.34874 8.01233 1.44412 7.98678C1.70294 7.91742 1.9051 7.71526 1.97445 7.45645C2 7.36107 2 7.24482 2 7.01233V6.01233C2 5.53271 2.00054 5.22307 2.01671 4.98609C2.03227 4.75809 2.05889 4.67126 2.07612 4.62965C2.17762 4.38462 2.37229 4.18995 2.61732 4.08845C2.65893 4.07122 2.74576 4.0446 2.97376 4.02904C3.21074 4.01287 3.52038 4.01233 4 4.01233H12C12.4796 4.01233 12.7893 4.01287 13.0262 4.02904C13.2542 4.0446 13.3411 4.07122 13.3827 4.08845C13.6277 4.18995 13.8224 4.38462 13.9239 4.62965C13.9411 4.67126 13.9677 4.75809 13.9833 4.98609C13.9995 5.22307 14 5.53271 14 6.01233V12.8123C14 13.3889 13.9992 13.7612 13.9761 14.0445C13.9539 14.3162 13.9162 14.4169 13.891 14.4663C13.7951 14.6545 13.6422 14.8075 13.454 14.9033C13.4045 14.9285 13.3038 14.9662 13.0322 14.9884C12.7488 15.0116 12.3766 15.0123 11.8 15.0123H10C9.76751 15.0123 9.65126 15.0123 9.55589 15.0379C9.29707 15.1072 9.09491 15.3094 9.02556 15.5682C9 15.6636 9 15.7798 9 16.0123C9 16.2448 9 16.3611 9.02556 16.4564C9.09491 16.7153 9.29707 16.9174 9.55589 16.9868C9.65126 17.0123 9.76751 17.0123 10 17.0123H11.8386C12.3657 17.0124 12.8205 17.0124 13.195 16.9818C13.5904 16.9495 13.9836 16.8781 14.362 16.6854C14.9265 16.3977 15.3854 15.9388 15.673 15.3743C15.8658 14.9959 15.9371 14.6027 15.9694 14.2074C16 13.8328 16 13.378 16 12.8509V5.98034C16 5.54169 16 5.16321 15.9787 4.84995C15.9561 4.52012 15.9066 4.19021 15.7716 3.86428C15.4672 3.1292 14.8831 2.54518 14.1481 2.24069C13.8221 2.10569 13.4922 2.05619 13.1624 2.03368C12.9905 2.02196 12.9046 2.01609 12.8392 1.99267C12.682 1.93632 12.5676 1.81192 12.5247 1.65052C12.5069 1.58342 12.5081 1.50551 12.5106 1.34968L12.5159 1.0159C12.5197 0.780151 12.5216 0.662275 12.4971 0.565612C12.4305 0.303074 12.2275 0.096835 11.9661 0.0260588C11.8698 0 11.7519 0 11.5161 0C11.2871 0 11.1725 0 11.0781 0.0250222C10.8218 0.0929333 10.6204 0.291102 10.5484 0.546255C10.5219 0.640267 10.52 0.754792 10.5163 0.983842L10.5127 1.21286C10.5082 1.48881 10.506 1.62679 10.4509 1.732C10.4024 1.82456 10.3261 1.8996 10.2328 1.94659C10.1267 2 9.98875 2 9.71276 2H6.26794C5.99593 2 5.85993 2 5.75577 1.94892C5.65381 1.89891 5.5719 1.81568 5.52354 1.71292C5.47414 1.60796 5.47633 1.47197 5.4807 1.2L5.48366 1.0159C5.48745 0.780222 5.48935 0.662383 5.46486 0.565748C5.3983 0.303126 5.19528 0.096814 4.93376 0.0260416C4.83753 0 4.71968 0 4.48397 0C4.25496 0 4.14045 0 4.04606 0.0250057C3.7897 0.0929134 3.58827 0.291153 3.51628 0.546388C3.48976 0.640373 3.48793 0.754863 3.48427 0.983843L3.47791 1.38183Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M5 9.76172C5 9.34751 4.66421 9.01172 4.25 9.01172H3.75C3.33579 9.01172 3 9.34751 3 9.76172V11.5117C3 11.7879 2.77614 12.0117 2.5 12.0117H0.75C0.335786 12.0117 0 12.3475 0 12.7617V13.2617C0 13.6759 0.335786 14.0117 0.75 14.0117H2.5C2.77614 14.0117 3 14.2356 3 14.5117V16.2617C3 16.6759 3.33579 17.0117 3.75 17.0117H4.25C4.66421 17.0117 5 16.6759 5 16.2617V14.5117C5 14.2356 5.22386 14.0117 5.5 14.0117H7.25C7.66421 14.0117 8 13.6759 8 13.2617V12.7617C8 12.3475 7.66421 12.0117 7.25 12.0117H5.5C5.22386 12.0117 5 11.7879 5 11.5117V9.76172Z",
                fill: "currentColor"
            })
        ]
    });
}
function $e891d0fba1229c08$export$d2c72b688139a728() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "12",
        height: "14",
        viewBox: "0 0 2.787 13.85",
        fill: "none",
        "aria-hidden": "true",
        style: {
            transform: 'rotate(45deg)'
        },
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.7873 1.2C2.7873 0.779961 2.7873 0.569941 2.70555 0.409507C2.63365 0.268386 2.51891 0.15365 2.37779 0.0817451C2.21736 0 2.00734 0 1.5873 0H1.2C0.779961 0 0.569941 0 0.409507 0.0817451C0.268386 0.15365 0.15365 0.268386 0.0817451 0.409507C0 0.569941 0 0.779961 0 1.2V1.86125H2.7873V1.2ZM0 2.97617V11.7216C0 11.9228 0 12.0234 0.019175 12.1199C0.036189 12.2055 0.0643424 12.2886 0.102917 12.3669C0.146391 12.4552 0.207585 12.535 0.329973 12.6947L1.02685 13.6042C1.13055 13.7395 1.1824 13.8072 1.24625 13.8327C1.30224 13.8551 1.36443 13.8565 1.42136 13.8366C1.48629 13.814 1.5411 13.7487 1.65072 13.6181L2.41277 12.7103C2.55146 12.545 2.62081 12.4624 2.67018 12.3696C2.71397 12.2873 2.74604 12.1992 2.76543 12.108C2.7873 12.0052 2.7873 11.8973 2.7873 11.6816V2.97617H0Z",
            fill: "currentColor"
        })
    });
}
function $e891d0fba1229c08$export$2e2bcd8739ae039({ buttons: buttons = [] }) {
    const activeButtons = buttons.filter((b)=>!b.destructive);
    const destructiveButtons = buttons.filter((b)=>b.destructive);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col gap-2",
        children: [
            activeButtons.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "bg-[#17181a] w-full rounded-[8px] overflow-hidden",
                children: activeButtons.map((button, index)=>{
                    const isDisabled = button.disabled === true;
                    const showDivider = index < activeButtons.length - 1;
                    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                type: "button",
                                onClick: !isDisabled ? button.onClick : undefined,
                                disabled: isDisabled,
                                className: [
                                    'w-full flex items-center px-4 py-3 gap-3 text-left transition-colors duration-150',
                                    isDisabled ? 'bg-[#e4e4e6] cursor-default' : 'bg-transparent hover:bg-white/[.08] active:bg-white/[.12]'
                                ].join(' '),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: [
                                            'flex-1 text-[17px] font-medium leading-[22px] tracking-[-0.34px]',
                                            isDisabled ? 'text-[#17181a] opacity-[.38]' : 'text-white'
                                        ].join(' '),
                                        children: button.label
                                    }),
                                    button.icon && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                        className: [
                                            'flex items-center justify-center size-6 shrink-0',
                                            isDisabled ? 'text-[#17181a] opacity-[.38]' : 'text-white'
                                        ].join(' '),
                                        children: button.icon
                                    })
                                ]
                            }),
                            showDivider && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "h-[1.5px] bg-[#eff0f2]"
                            })
                        ]
                    }, index);
                })
            }),
            destructiveButtons.map((button, index)=>/*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: !button.disabled ? button.onClick : undefined,
                    disabled: button.disabled,
                    className: "w-full h-[46px] bg-[#CC2312] text-white rounded-[10px] text-[17px] font-medium leading-[22px] tracking-[-0.34px] transition-opacity duration-150 hover:opacity-90 active:opacity-80 disabled:opacity-50 disabled:cursor-default",
                    children: button.label
                }, `d-${index}`))
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

function $8a4f32cb57f72457$export$2e2bcd8739ae039({ title: title, message: message, buttons: buttons, isOpen: isOpen, onClose: onClose, lightBackground: lightBackground, absolute: absolute }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: isOpen && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
            onClose: onClose,
            isOpen: true,
            rounded: true,
            absolute: absolute,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "flex flex-col w-full p-4 gap-1.5",
                    children: [
                        title && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "text-[17px] font-semibold text-center text-[#17181a] mb-1",
                            children: title
                        }),
                        message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            className: "text-[15px] font-normal leading-[1.4] text-center text-[#5d5d5f]",
                            dangerouslySetInnerHTML: {
                                __html: message
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                    buttons: buttons,
                    modal: true
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









var $fdbcaa84cd271174$exports = {};

$parcel$export($fdbcaa84cd271174$exports, "alignStart", function () { return $fdbcaa84cd271174$export$144a00ba6044eb9; }, function (v) { return $fdbcaa84cd271174$export$144a00ba6044eb9 = v; });
$parcel$export($fdbcaa84cd271174$exports, "charIcon", function () { return $fdbcaa84cd271174$export$5dd68419f8c7e5a7; }, function (v) { return $fdbcaa84cd271174$export$5dd68419f8c7e5a7 = v; });
$parcel$export($fdbcaa84cd271174$exports, "departure", function () { return $fdbcaa84cd271174$export$f1d7a98679aed61; }, function (v) { return $fdbcaa84cd271174$export$f1d7a98679aed61 = v; });
$parcel$export($fdbcaa84cd271174$exports, "destination", function () { return $fdbcaa84cd271174$export$547cb0ec68beb837; }, function (v) { return $fdbcaa84cd271174$export$547cb0ec68beb837 = v; });
$parcel$export($fdbcaa84cd271174$exports, "ellipsis", function () { return $fdbcaa84cd271174$export$a5b94313d6908893; }, function (v) { return $fdbcaa84cd271174$export$a5b94313d6908893 = v; });
$parcel$export($fdbcaa84cd271174$exports, "gray", function () { return $fdbcaa84cd271174$export$3e2c219d3ab79d01; }, function (v) { return $fdbcaa84cd271174$export$3e2c219d3ab79d01 = v; });
$parcel$export($fdbcaa84cd271174$exports, "group", function () { return $fdbcaa84cd271174$export$e5e25fbcc1f7affe; }, function (v) { return $fdbcaa84cd271174$export$e5e25fbcc1f7affe = v; });
$parcel$export($fdbcaa84cd271174$exports, "groupContent", function () { return $fdbcaa84cd271174$export$d6a271f2cc7855f3; }, function (v) { return $fdbcaa84cd271174$export$d6a271f2cc7855f3 = v; });
$parcel$export($fdbcaa84cd271174$exports, "groupContentColumn", function () { return $fdbcaa84cd271174$export$92f902fc8c9aeaa1; }, function (v) { return $fdbcaa84cd271174$export$92f902fc8c9aeaa1 = v; });
$parcel$export($fdbcaa84cd271174$exports, "groupContentMainColumn", function () { return $fdbcaa84cd271174$export$c2145dc42cfbca09; }, function (v) { return $fdbcaa84cd271174$export$c2145dc42cfbca09 = v; });
$parcel$export($fdbcaa84cd271174$exports, "groupIcon", function () { return $fdbcaa84cd271174$export$e95871dfa811786e; }, function (v) { return $fdbcaa84cd271174$export$e95871dfa811786e = v; });
$parcel$export($fdbcaa84cd271174$exports, "hasStops", function () { return $fdbcaa84cd271174$export$18ea8aa6b72036b5; }, function (v) { return $fdbcaa84cd271174$export$18ea8aa6b72036b5 = v; });
$parcel$export($fdbcaa84cd271174$exports, "icon", function () { return $fdbcaa84cd271174$export$1ca1ec8b29a4ce27; }, function (v) { return $fdbcaa84cd271174$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($fdbcaa84cd271174$exports, "label", function () { return $fdbcaa84cd271174$export$1237798dc640739a; }, function (v) { return $fdbcaa84cd271174$export$1237798dc640739a = v; });
$parcel$export($fdbcaa84cd271174$exports, "option", function () { return $fdbcaa84cd271174$export$a75d1723e6bda2ec; }, function (v) { return $fdbcaa84cd271174$export$a75d1723e6bda2ec = v; });
$parcel$export($fdbcaa84cd271174$exports, "options", function () { return $fdbcaa84cd271174$export$41c562ebe57d11e2; }, function (v) { return $fdbcaa84cd271174$export$41c562ebe57d11e2 = v; });
$parcel$export($fdbcaa84cd271174$exports, "payment", function () { return $fdbcaa84cd271174$export$18f430e15f133060; }, function (v) { return $fdbcaa84cd271174$export$18f430e15f133060 = v; });
$parcel$export($fdbcaa84cd271174$exports, "paymentType", function () { return $fdbcaa84cd271174$export$cf6c01cadfc8fe18; }, function (v) { return $fdbcaa84cd271174$export$cf6c01cadfc8fe18 = v; });
$parcel$export($fdbcaa84cd271174$exports, "price", function () { return $fdbcaa84cd271174$export$321c0b1a406de31f; }, function (v) { return $fdbcaa84cd271174$export$321c0b1a406de31f = v; });
$parcel$export($fdbcaa84cd271174$exports, "priceEdit", function () { return $fdbcaa84cd271174$export$68330dd42131070f; }, function (v) { return $fdbcaa84cd271174$export$68330dd42131070f = v; });
$parcel$export($fdbcaa84cd271174$exports, "showStops", function () { return $fdbcaa84cd271174$export$bd78d4a159817b41; }, function (v) { return $fdbcaa84cd271174$export$bd78d4a159817b41 = v; });
$parcel$export($fdbcaa84cd271174$exports, "stop", function () { return $fdbcaa84cd271174$export$fa6813432f753b0d; }, function (v) { return $fdbcaa84cd271174$export$fa6813432f753b0d = v; });
$parcel$export($fdbcaa84cd271174$exports, "stops", function () { return $fdbcaa84cd271174$export$23813356bdaf66ca; }, function (v) { return $fdbcaa84cd271174$export$23813356bdaf66ca = v; });
var $fdbcaa84cd271174$export$144a00ba6044eb9;
var $fdbcaa84cd271174$export$5dd68419f8c7e5a7;
var $fdbcaa84cd271174$export$f1d7a98679aed61;
var $fdbcaa84cd271174$export$547cb0ec68beb837;
var $fdbcaa84cd271174$export$a5b94313d6908893;
var $fdbcaa84cd271174$export$3e2c219d3ab79d01;
var $fdbcaa84cd271174$export$e5e25fbcc1f7affe;
var $fdbcaa84cd271174$export$d6a271f2cc7855f3;
var $fdbcaa84cd271174$export$92f902fc8c9aeaa1;
var $fdbcaa84cd271174$export$c2145dc42cfbca09;
var $fdbcaa84cd271174$export$e95871dfa811786e;
var $fdbcaa84cd271174$export$18ea8aa6b72036b5;
var $fdbcaa84cd271174$export$1ca1ec8b29a4ce27;
var $fdbcaa84cd271174$export$1237798dc640739a;
var $fdbcaa84cd271174$export$a75d1723e6bda2ec;
var $fdbcaa84cd271174$export$41c562ebe57d11e2;
var $fdbcaa84cd271174$export$18f430e15f133060;
var $fdbcaa84cd271174$export$cf6c01cadfc8fe18;
var $fdbcaa84cd271174$export$321c0b1a406de31f;
var $fdbcaa84cd271174$export$68330dd42131070f;
var $fdbcaa84cd271174$export$bd78d4a159817b41;
var $fdbcaa84cd271174$export$fa6813432f753b0d;
var $fdbcaa84cd271174$export$23813356bdaf66ca;
$fdbcaa84cd271174$export$144a00ba6044eb9 = `N0Qq-W_alignStart`;
$fdbcaa84cd271174$export$5dd68419f8c7e5a7 = `N0Qq-W_charIcon`;
$fdbcaa84cd271174$export$f1d7a98679aed61 = `N0Qq-W_departure`;
$fdbcaa84cd271174$export$547cb0ec68beb837 = `N0Qq-W_destination`;
$fdbcaa84cd271174$export$a5b94313d6908893 = `N0Qq-W_ellipsis`;
$fdbcaa84cd271174$export$3e2c219d3ab79d01 = `N0Qq-W_gray`;
$fdbcaa84cd271174$export$e5e25fbcc1f7affe = `N0Qq-W_group`;
$fdbcaa84cd271174$export$d6a271f2cc7855f3 = `N0Qq-W_groupContent`;
$fdbcaa84cd271174$export$92f902fc8c9aeaa1 = `N0Qq-W_groupContentColumn`;
$fdbcaa84cd271174$export$c2145dc42cfbca09 = `N0Qq-W_groupContentMainColumn`;
$fdbcaa84cd271174$export$e95871dfa811786e = `N0Qq-W_groupIcon`;
$fdbcaa84cd271174$export$18ea8aa6b72036b5 = `N0Qq-W_hasStops`;
$fdbcaa84cd271174$export$1ca1ec8b29a4ce27 = `N0Qq-W_icon`;
$fdbcaa84cd271174$export$1237798dc640739a = `N0Qq-W_label`;
$fdbcaa84cd271174$export$a75d1723e6bda2ec = `N0Qq-W_option`;
$fdbcaa84cd271174$export$41c562ebe57d11e2 = `N0Qq-W_options`;
$fdbcaa84cd271174$export$18f430e15f133060 = `N0Qq-W_payment`;
$fdbcaa84cd271174$export$cf6c01cadfc8fe18 = `N0Qq-W_paymentType`;
$fdbcaa84cd271174$export$321c0b1a406de31f = `N0Qq-W_price`;
$fdbcaa84cd271174$export$68330dd42131070f = `N0Qq-W_priceEdit`;
$fdbcaa84cd271174$export$bd78d4a159817b41 = `N0Qq-W_showStops`;
$fdbcaa84cd271174$export$fa6813432f753b0d = `N0Qq-W_stop`;
$fdbcaa84cd271174$export$23813356bdaf66ca = `N0Qq-W_stops`;





const $78f5985dc59f422c$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($fdbcaa84cd271174$exports);
// const formatEta = (eta, serviceType) => {
//   const name = serviceType === 'business' ? 'premium' : serviceType
//   if (eta?.length > 0) {
//     const minutes = eta.find(item => name === item.vehicleType)?.expectedWaitTime
//     if (minutes === undefined) return null
//     return i18next.t('info-available-in', { minutes })
//   }
// }
const $78f5985dc59f422c$var$formatAvailability = (availabilities, serviceType)=>{
    const availability = availabilities.find((item)=>serviceType === item.serviceType);
    if (availability?.expectedWaitTime === undefined) return null;
    // if (availability?.availableAt === 'DELAYED') return `Endast förbokning ${formatTime(new Date(availability.pickupTime))}`
    if (availability?.availableAt === 'DELAYED') return `Endast f\xf6rbokning`;
    return (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-available-in', {
        minutes: availability?.expectedWaitTime
    });
};
function $78f5985dc59f422c$export$2e2bcd8739ae039({ values: values, currentView: currentView, showTime: showTime = false, showHow: showHow = false, showPayment: showPayment = false, afterLocations: afterLocations = null }) {
    const hasBooking = !isNaN(values?.bookingId);
    const inEditMode = hasBooking && values.bookingId > 0;
    // In edit mode, always show all sections
    const displayShowTime = inEditMode || showTime;
    const displayShowHow = inEditMode || showHow;
    const displayShowPayment = inEditMode || showPayment;
    const isLocationView = currentView === 'locations';
    const isTimeView = currentView === 'time';
    const isHowView = currentView === 'how';
    const isConfirmView = currentView === 'confirm';
    const isDoneView = currentView === 'done';
    // 'locations' is the first view, so 'time' is still ahead of the user there —
    // offering the edit toggle would jump them forward into a step they have not
    // reached yet. Also hidden on the time step itself, and once a booking exists.
    const canChangeTime = !hasBooking && !isTimeView && !isLocationView;
    const openEditPhone = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                validate: true,
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue?.(id, val, false),
                fields: [
                    {
                        id: 'name',
                        title: t('placeholder-name'),
                        validate: validateName
                    },
                    {
                        id: 'phone',
                        title: t('placeholder-phone'),
                        validate: validatePhone
                    }
                ],
                title: t('header-whos-travel'),
                onClose: close
            }));
    const openEditMessage = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue?.(id, val, false),
                fields: [
                    {
                        id: 'generalComment',
                        title: t('title-message-to-driver')
                    }
                ],
                title: t('title-message-to-driver'),
                onClose: close
            }));
    const openEditReference = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue?.(id, val, false),
                fields: [
                    {
                        id: 'accountReference',
                        title: t('placeholder-reference')
                    }
                ],
                title: t('placeholder-reference'),
                onClose: close
            }));
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { bookings: bookings, user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { prev: prev } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { setFieldValue: setFieldValue } = (0, $bh6RR.useContext)((0, $lW2XZ.FormikContext)) || {};
    // In edit mode, use booking from form values (stable). Otherwise, look up from store
    const booking = inEditMode && values.booking ? values.booking : bookings?.find((item)=>item.id === values.bookingId);
    const taxiAndEta = booking ? (0, $c94184dfef1a7d71$export$47c2c83385bd5cef)(booking) : '';
    const pickupTime = values.autoValues.pickupTime || values.pickupTime;
    const time = pickupTime ? (0, $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1)(pickupTime) : (0, $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1)(new Date());
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    const serviceType = values.autoValues.serviceType !== null ? values.autoValues.serviceType : values.serviceType;
    const actualServiceType = serviceType === 'estate' ? 'taxi' : serviceType;
    const availability = values.availability?.availabilities ? $78f5985dc59f422c$var$formatAvailability(values.availability.availabilities, actualServiceType) : false;
    const price = values?.priceEstimate?.prices?.find((p)=>p.serviceType === actualServiceType && (values.selectedProviderId ? p.providerId === values.selectedProviderId : true));
    // In edit mode, get price from booking if available
    const editModePrice = inEditMode && booking ? booking.price : null;
    const displayPrice = inEditMode ? editModePrice : price;
    const editModeIsFixedPrice = inEditMode && booking ? booking.price?.priceType === 'FIXED' : fixedPrice;
    const showPrice = inEditMode && editModePrice || !inEditMode && fixedPrice && price;
    const options = (0, $200ec6b1b2ca8c5a$export$d2312e68e1f5ad00)(values);
    // SelectedPayment props
    const { icon: paymentIcon, title: paymentTitle, subtitle: paymentSubtitle } = (0, $c94184dfef1a7d71$export$d3f4c2863c03c2f9)(values);
    const isPaymentFixedPrice = inEditMode ? editModeIsFixedPrice : fixedPrice && showPrice;
    const paymentPriceLabel = isPaymentFixedPrice ? t('label-fixed-price') : t('label-taxameter');
    const voucherPills = values.voucherObjects?.length > 0 ? values.voucherObjects.map((v)=>`${(0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-voucher')} ${v.voucherCode} - ${(0, $c94184dfef1a7d71$export$9e6e5cf28f33a45e)(v)}`) : [];
    const company = values.isCompanyTrip && user?.companyConnections ? user?.companyConnections[0] : false;
    const showReference = values?.company !== false || values?.account?.type === 'TSAB' || values?.account?.type === 'TCA';
    const needReference = company?.requireReference === true || values?.account !== false && (values?.account?.type === 'TSAB' || values?.account?.type === 'TCA') && values?.account?.flags?.includes('reference');
    // Check if fields are editable in edit mode
    const isNameEditable = inEditMode ? values.editableFields?.includes('traveler.name') : false;
    const isPhoneEditable = inEditMode ? values.editableFields?.includes('traveler.phoneNumber') : false;
    const isCommentEditable = inEditMode ? values.editableFields?.includes('generalComment') : false;
    const isTravelerInfoEditable = isNameEditable || isPhoneEditable;
    const partnerData = values?.availability?.direct?.providerData?.providerId && (values?.availability?.direct?.providerData?.providerId !== "TSAB" || CONFIG.svea_module) ? values?.availability?.direct?.providerData : values?.availability?.prebook?.providerData?.providerId && (values?.availability?.prebook?.providerData?.providerId !== "TSAB" || CONFIG.svea_module) ? values?.availability?.prebook?.providerData : null;
    const availabilityKey = values.pickupTime === '' ? 'direct' : 'prebook';
    const servicesByProvider = values.availability?.[availabilityKey]?.servicesByProvider;
    const selectedPartnerData = values.selectedProviderId && Array.isArray(servicesByProvider) && servicesByProvider.length > 0 && !(servicesByProvider.length === 1 && servicesByProvider[0].providerData?.providerId === 'TSAB') ? servicesByProvider.find((p)=>p.providerData?.providerId === values.selectedProviderId)?.providerData ?? null : null;
    const openPriceInfo = showPrice ? ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $95edecdc1b70ca9a$export$2e2bcd8739ae039), {
                price: displayPrice,
                onClose: close
            })) : null;
    const validatePhone = (value)=>{
        let errorMessage;
        if (!String(value).match(/^\+?\d+$/)) errorMessage = "F\xe4ltet f\xe5r bara ineh\xe5lla siffor";
        if (value.length < 2) errorMessage = "F\xe4ltet m\xe5ste inneh\xe5lla minst 2 tecken";
        return errorMessage;
    };
    const validateName = (value)=>{
        let errorMessage;
        if (value.length < 2) errorMessage = "F\xe4ltet m\xe5ste inneh\xe5lla minst 2 tecken";
        return errorMessage;
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
            className: $78f5985dc59f422c$var$cx($f35967c56a9f3d99$export$98090d4d513c0fe6, $fdbcaa84cd271174$exports.alignStart),
            children: [
                hasBooking && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $fdbcaa84cd271174$exports.group,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $fdbcaa84cd271174$exports.groupContent,
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $fdbcaa84cd271174$exports.groupContentColumn,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $fdbcaa84cd271174$exports.groupContentMainColumn,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $fdbcaa84cd271174$exports.label,
                                        children: t('label-booking-number')
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                    children: values.bookingId
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $399efa2df35e57c4$export$2e2bcd8739ae039), {
                        time: time,
                        subtitle: values.flightNumber ? t('info-flight-monitoring') : values.autoValues.pickupTime || values.pickupTime ? t('label-prebooked') : /*(hasTaxiAndEta(booking) && taxiAndEta) || availability ||*/ t('label-direct-booking'),
                        flightNumber: values.flightNumber,
                        checkedBaggage: values.checkedInBaggage,
                        changeToggle: canChangeTime ? ()=>prev('time') : null
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $cd9136fbd575d4a5$export$2e2bcd8739ae039), {
                        departure: values.departure,
                        destination: values.destination,
                        stops: values.intermediateStopLocations
                    })
                }),
                afterLocations,
                displayShowPayment && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $6b32edab973d0099$export$2e2bcd8739ae039), {
                        icon: paymentIcon,
                        title: paymentTitle,
                        subtitle: paymentSubtitle,
                        priceLabel: paymentPriceLabel,
                        price: isPaymentFixedPrice ? displayPrice : null,
                        priceLoading: !inEditMode && values.priceIsLoading,
                        voucherPills: voucherPills,
                        onInfo: openPriceInfo
                    })
                }),
                displayShowPayment && showReference && hasBooking && values.accountReference.trim() !== '' && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $51837c0e5cd1599b$export$2e2bcd8739ae039), {
                        title: t('placeholder-reference'),
                        value: !values.accountReference || values.accountReference.trim() === '' ? t('validation-need-reference') : values.accountReference,
                        icon: "Reference"
                    })
                }),
                displayShowHow && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $fe0b386f10b85dbf$export$2e2bcd8739ae039), {
                        serviceType: serviceType,
                        options: options.map((0, $c94184dfef1a7d71$export$c165bf529a45fce1)),
                        onEdit: !hasBooking && !isHowView ? ()=>prev('how') : null
                    })
                }),
                (booking?.traveler?.travelerCount > 0 || !isTimeView && (0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'TRAVELER_COUNT_REQUIRED') && values.passengerCount > 0) && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $969fbb1ccfb19bd7$export$2e2bcd8739ae039), {
                        count: booking?.traveler?.travelerCount || values.passengerCount
                    })
                }),
                selectedPartnerData && displayShowHow && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $35bcf1734d1aebd2$export$2e2bcd8739ae039), {
                        providerId: selectedPartnerData.providerId,
                        name: selectedPartnerData.name,
                        phone: selectedPartnerData.phoneNumber,
                        displayPhone: selectedPartnerData.displayPhoneNumber,
                        email: selectedPartnerData.email
                    })
                }),
                company && displayShowHow && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $7e46addbea690aa5$export$2e2bcd8739ae039), {
                        type: "company",
                        name: company.name
                    })
                }),
                user && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $52bbc20651dec586$export$2e2bcd8739ae039), {
                            name: values.name,
                            phone: values.phone,
                            onEdit: (!hasBooking || isTravelerInfoEditable) && !isDoneView ? openEditPhone : null
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $f638b72bf31980aa$export$2e2bcd8739ae039), {
                        message: values?.generalComment || "Hj\xe4lp f\xf6raren att hitta dig.",
                        onEdit: (!hasBooking || isCommentEditable) && !isDoneView ? openEditMessage : null
                    })
                }),
                partnerData && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $35bcf1734d1aebd2$export$2e2bcd8739ae039), {
                        providerId: partnerData.providerId,
                        name: partnerData.name,
                        phone: partnerData.phoneNumber,
                        displayPhone: partnerData.displayPhoneNumber,
                        email: partnerData.email
                    })
                })
            ]
        })
    });
}


// Generic summary row: icon, title, value and an optional edit pencil. Same layout and
// typography as the Figma summary rows (PassengerInfo, MessageToDriver, SelectedCar).

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

function $51837c0e5cd1599b$export$2e2bcd8739ae039({ title: title, value: value, icon: icon, changeToggle: changeToggle, required: required, empty: empty, disabled: disabled }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                    id: icon
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: title
                    }),
                    value && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-[15px] leading-5', required && empty ? 'text-[#da0a2b]' : 'text-on-surface-variant'),
                        children: value
                    })
                ]
            }),
            changeToggle && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: ()=>changeToggle(),
                className: "shrink-0 p-2 -mr-2",
                "aria-label": title,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "pen"
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=44-965
// (button base component — outlined variant: 46-838, primary variant: 46-842)
// Modal alert buttons: node-id=209-5177

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");
/**
 * Shared SVG data URLs used in button components.
 * These can't be expressed cleanly as Tailwind arbitrary values so they
 * live here as constants and are applied via the `style` prop.
 */ const $81d4f81dc159dc23$export$4543b5a60c28b5da = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.0' width='64' height='64' viewBox='0 0 128 128'%3E%3Cg%3E%3Cpath d='M59.6 0h8v40h-8V0z'/%3E%3Cpath d='M92.19 6.374l6.928 4-20 34.641-6.929-4 20-34.64zM117.226 28.19l4 6.928-34.641 20-4-6.929 34.64-20zM128 59.6v8H88v-8h40zM121.626 92.19l-4 6.928-34.641-20 4-6.929 34.64 20z' fill='%23ccc' fill-opacity='.2'/%3E%3Cpath d='M99.81 117.226l-6.928 4-20-34.641 6.929-4 20 34.64z' fill='%23b2b2b2' fill-opacity='.3'/%3E%3Cpath d='M68.4 128h-8V88h8v40z' fill='%23999' fill-opacity='.4'/%3E%3Cpath d='M35.81 121.626l-6.928-4 20-34.641 6.929 4-20 34.64z' fill='%237f7f7f' fill-opacity='.5'/%3E%3Cpath d='M10.774 99.81l-4-6.928 34.641-20 4 6.929-34.64 20z' fill='%23666' fill-opacity='.6'/%3E%3Cpath d='M0 68.4v-8h40v8H0z' fill='%234c4c4c' fill-opacity='.7'/%3E%3Cpath d='M6.374 35.81l4-6.928 34.641 20-4 6.929-34.64-20z' fill='%23333' fill-opacity='.8'/%3E%3Cpath d='M28.19 10.774l6.928-4 20 34.641-6.929 4-20-34.64z' fill='%23191919' fill-opacity='.9'/%3E%3CanimateTransform attributeName='transform' type='rotate' values='0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64' calcMode='discrete' dur='600ms' repeatCount='indefinite'/%3E%3C/g%3E%3C/svg%3E")`;
const $81d4f81dc159dc23$export$7317cf7e2928d92e = `url("data:image/svg+xml,%3Csvg width='8' height='13' viewBox='0 0 8 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 1.5L1.5 6.5L6.5 11.5' stroke='black' stroke-width='2'/%3E%3C/svg%3E")`;


function $1669b712ac7656a1$export$2e2bcd8739ae039({ buttons: buttons, isLoading: isLoading, className: className, children: children, fullscreen: fullscreen, modal: modal }) {
    // Modal variant: flush buttons at the bottom of the alert card, per Figma 209-5177.
    // No padding/border-radius — overflow:clip on the container clips the corners.
    // border-t separates buttons from content; border-r divides two side-by-side buttons.
    if (modal) return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex flex-row border-0 border-t-[1.5px] border-solid border-[#17181a]', {
            'pointer-events-none': isLoading
        }),
        children: buttons.map((button, index)=>{
            const isPrimary = index === buttons.length - 1;
            const isButtonLoading = button.isLoading === true;
            const hasDivider = index < buttons.length - 1;
            return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                tabIndex: button.tabIndex !== undefined ? button.tabIndex : 0,
                onClick: button.func,
                disabled: button?.disabled === true,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex-1 py-4 px-3 text-center', 'font-sans text-[16px] font-semibold uppercase tracking-[0.68px] leading-[1.2]', 'transition-colors duration-200', 'disabled:opacity-50 disabled:cursor-default disabled:pointer-events-none', hasDivider && 'border-0 border-r-[1.5px] border-solid border-[#17181a]', isPrimary ? 'bg-[#17181a] text-white hover:opacity-90' : 'bg-transparent text-[#17181a] hover:bg-black/5', isButtonLoading && 'cursor-default !text-transparent select-none bg-no-repeat bg-center bg-[length:24px_24px]'),
                style: {
                    backgroundImage: isButtonLoading ? (0, $81d4f81dc159dc23$export$4543b5a60c28b5da) : undefined
                },
                dangerouslySetInnerHTML: {
                    __html: button.title
                }
            }, index);
        })
    });
    // Regular flow variant: rounded buttons in a white padded drawer
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('bg-white p-2 app-lg:rounded-b-[12px]', {
            'pointer-events-none': isLoading
        }, {
            'app-lg:absolute app-lg:bottom-0 app-lg:left-0 app-lg:w-full': fullscreen
        }, className),
        children: [
            children,
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex flex-row flex-wrap gap-2 items-start",
                children: buttons.map((button, index)=>{
                    const isPrimary = index === buttons.length - 1;
                    const isBack = button.isBack === true;
                    const isButtonLoading = button.isLoading === true;
                    const isHalfWidth = buttons.length === 4;
                    return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "button",
                        tabIndex: button.tabIndex !== undefined ? button.tabIndex : 0,
                        onClick: button.func,
                        disabled: button?.disabled === true,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('whitespace-nowrap h-12 px-[25px] rounded-button border-solid', 'font-sans text-[16px] font-semibold uppercase tracking-[0.11em] leading-[1.1]', 'transition-colors duration-400 grow', 'disabled:cursor-default disabled:pointer-events-none', isPrimary ? [
                            'border border-primary bg-primary text-white',
                            'hover:bg-[rgba(0,0,0,0.7)] focus-visible:bg-[rgba(0,0,0,0.7)]',
                            '[flex-grow:7]',
                            'disabled:border-[#d0cfcf] disabled:bg-surface-container-highest disabled:text-[#a7a7a8]'
                        ] : [
                            'border border-primary bg-white text-primary',
                            'hover:bg-black/20 focus-visible:bg-black/20',
                            'disabled:border-[#d0cfcf] disabled:text-[#a7a7a8]'
                        ], isBack && 'shrink-0 !w-12 max-w-[48px] bg-no-repeat bg-center grow-0', isButtonLoading && 'cursor-default !text-transparent select-none bg-no-repeat bg-center bg-[length:24px_24px]', isHalfWidth && 'basis-[calc(50%-4px)]'),
                        style: {
                            backgroundImage: isBack ? (0, $81d4f81dc159dc23$export$7317cf7e2928d92e) : isButtonLoading ? (0, $81d4f81dc159dc23$export$4543b5a60c28b5da) : undefined
                        },
                        dangerouslySetInnerHTML: {
                            __html: button.title
                        }
                    }, index);
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=44-965
// Types: primary (black fill) | secondary (outlined) | tertiary (gray fill)
// States: active | disabled | pressed | loading

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");


function $0ff0656d4e751685$export$2e2bcd8739ae039({ title: title, isPrimary: isPrimary, isLoading: isLoading, isBack: isBack, disabled: disabled, onClick: onClick, tabIndex: tabIndex, className: className }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        type: "button",
        tabIndex: tabIndex !== undefined ? tabIndex : 0,
        onClick: onClick,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))(// Non-conflicting base
        'relative h-12 w-full px-4 rounded-button border-solid', 'text-[17px] font-bold uppercase tracking-[0.68px] leading-5', 'transition-colors duration-200', 'disabled:cursor-default disabled:pointer-events-none disabled:border-on-surface/[0.12] disabled:text-on-surface/[0.38]', // Mutually exclusive bg/text/border — no conflicts
        isBack ? 'shrink-0 !w-12 bg-white border border-primary bg-no-repeat bg-center text-transparent' : isPrimary ? [
            'border border-primary bg-primary text-on-primary',
            'hover:bg-primary/90 focus-visible:bg-primary/90',
            'disabled:bg-surface-container-highest'
        ] : [
            'border-[1.5px] border-primary bg-white text-primary',
            'hover:bg-black/[0.04] focus-visible:bg-black/[0.12]'
        ], // Loading — hide text
        isLoading && 'cursor-default !text-transparent select-none', className),
        style: isBack ? {
            backgroundImage: (0, $81d4f81dc159dc23$export$7317cf7e2928d92e)
        } : undefined,
        children: [
            isLoading && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: "absolute inset-0 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {
                    size: 16
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                dangerouslySetInnerHTML: {
                    __html: title
                }
            })
        ]
    }, title);
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=4687-3120

var $ih19M = parcelRequire("ih19M");
function $8edb314d6528ebec$export$2e2bcd8739ae039({ icon: icon, title: title, description: description }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex flex-col items-center w-full",
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: "bg-surface-container-low flex flex-col items-center gap-2 px-2 py-4 rounded-[10px] w-full",
            children: [
                icon && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: "size-11 flex items-center justify-center shrink-0",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "flex items-center justify-center",
                        style: {
                            filter: 'drop-shadow(0 0.5px 1px rgba(0,0,0,0.15)) drop-shadow(0 1px 3px rgba(0,0,0,0.15))'
                        },
                        children: icon
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: "flex flex-col gap-0.5 items-center w-full",
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "text-[18px] font-semibold tracking-[0.54px] leading-normal text-on-surface",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: "text-[15px] leading-5 text-on-surface-variant text-center",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
}


// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=TODO

var $ih19M = parcelRequire("ih19M");

function $aab55537bcbfd3cb$export$2e2bcd8739ae039({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
        type: "button",
        onClick: onClick,
        className: "w-[25px] h-[25px] pl-[7px]",
        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
            id: "pen"
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $9edbe20fa2c55ce0$exports = {};

$parcel$export($9edbe20fa2c55ce0$exports, "gray", function () { return $9edbe20fa2c55ce0$export$3e2c219d3ab79d01; }, function (v) { return $9edbe20fa2c55ce0$export$3e2c219d3ab79d01 = v; });
$parcel$export($9edbe20fa2c55ce0$exports, "icon", function () { return $9edbe20fa2c55ce0$export$1ca1ec8b29a4ce27; }, function (v) { return $9edbe20fa2c55ce0$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($9edbe20fa2c55ce0$exports, "small", function () { return $9edbe20fa2c55ce0$export$3c17b0e969a90510; }, function (v) { return $9edbe20fa2c55ce0$export$3c17b0e969a90510 = v; });
var $9edbe20fa2c55ce0$export$3e2c219d3ab79d01;
var $9edbe20fa2c55ce0$export$1ca1ec8b29a4ce27;
var $9edbe20fa2c55ce0$export$3c17b0e969a90510;
$9edbe20fa2c55ce0$export$3e2c219d3ab79d01 = `vbi8MG_gray`;
$9edbe20fa2c55ce0$export$1ca1ec8b29a4ce27 = `vbi8MG_icon`;
$9edbe20fa2c55ce0$export$3c17b0e969a90510 = `vbi8MG_small`;


const $2a77dcb101872509$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($9edbe20fa2c55ce0$exports);
function $2a77dcb101872509$export$2e2bcd8739ae039({ className: className, char: char, small: small, gray: gray, ...props }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $2a77dcb101872509$var$cx($9edbe20fa2c55ce0$exports.icon, className, {
            small: small,
            gray: gray
        }),
        ...props,
        children: char
    });
}


// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=TODO

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");
function $0fa620ad2e74576c$export$2e2bcd8739ae039({ innerRef: innerRef, onClick: onClick, small: small, disabled: disabled, className: className }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        ref: innerRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('absolute top-3 right-4 pointer-events-auto', className),
        style: disabled ? {
            pointerEvents: 'none'
        } : {},
        children: /*#__PURE__*/ (0, $ih19M.jsx)("button", {
            type: "button",
            onClick: disabled ? undefined : onClick,
            disabled: disabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('block disabled:cursor-not-allowed disabled:opacity-50', 'group', small ? 'w-8' : 'w-8 app-md:w-12'),
            children: /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                viewBox: "0 0 48 48",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                className: small ? 'w-full h-8' : 'w-full h-8 app-md:h-12',
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                        cx: "24",
                        cy: "24",
                        r: "24",
                        className: "fill-black/5 transition-[fill] duration-200 group-hover:fill-app-yellow"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M24.1424 25.4142L26.9708 28.2426L28.385 26.8284L25.5566 24L28.385 21.1716L26.9708 19.7574L24.1424 22.5858L21.3139 19.7574L19.8997 21.1716L22.7281 24L19.8997 26.8284L21.3139 28.2426L24.1424 25.4142Z",
                        className: "fill-black/50 transition-opacity duration-200 group-hover:opacity-100"
                    })
                ]
            })
        })
    });
}



var $ih19M = parcelRequire("ih19M");




const $1c12843baa9d5f4a$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($234ae484ae699dc2$exports);
function $1c12843baa9d5f4a$export$2e2bcd8739ae039({ title: title, isOpen: isOpen, onClose: onClose, children: children, noPadding: noPadding, fullscreen: fullscreen, alternateBackground: alternateBackground }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const buttons = [
        {
            func: onClose,
            title: t('button-done'),
            tabIndex: isOpen ? 0 : -1
        }
    ];
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $1c12843baa9d5f4a$var$cx($234ae484ae699dc2$exports.wrapper, {
            isOpen: isOpen,
            fullscreen: fullscreen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $1c12843baa9d5f4a$var$cx($234ae484ae699dc2$exports.overlay, {
                    fullscreen: fullscreen
                }),
                onClick: onClose
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $1c12843baa9d5f4a$var$cx($234ae484ae699dc2$exports.panel, {
                    fullscreen: fullscreen
                }),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $1c12843baa9d5f4a$var$cx($234ae484ae699dc2$exports.panelContent, {
                            fullscreen: fullscreen,
                            noPadding: noPadding
                        }),
                        children: [
                            title && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $234ae484ae699dc2$exports.title,
                                children: title
                            }),
                            children
                        ]
                    }),
                    !fullscreen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                            buttons: buttons,
                            className: alternateBackground ? $234ae484ae699dc2$exports.alternateBackground : null
                        })
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $fa8c866b4f14389a$export$2ba01fb71ed41cb6;
var $fa8c866b4f14389a$export$a7db06668cad9adb;
var $fa8c866b4f14389a$export$f86455e47a9336bd;
$fa8c866b4f14389a$export$2ba01fb71ed41cb6 = `r0lE_q_button`;
$fa8c866b4f14389a$export$a7db06668cad9adb = `r0lE_q_content`;
$fa8c866b4f14389a$export$f86455e47a9336bd = `r0lE_q_focus-visible`;


function $64568360089ef8bb$export$2e2bcd8739ae039({ title: title, info: info, innerRef: innerRef, reverseLayout: reverseLayout, alternateBackground: alternateBackground, disabled: disabled, onClick: onClick, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
        reverseLayout: reverseLayout,
        alternateBackground: alternateBackground,
        isDisabled: disabled,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $fa8c866b4f14389a$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                        title: title,
                        info: info
                    }),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                ref: innerRef,
                tabIndex: "0",
                type: "button",
                className: $fa8c866b4f14389a$export$2ba01fb71ed41cb6,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "plus"
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $6ae5a7c58175ebcb$exports = {};

$parcel$export($6ae5a7c58175ebcb$exports, "button", function () { return $6ae5a7c58175ebcb$export$2ba01fb71ed41cb6; }, function (v) { return $6ae5a7c58175ebcb$export$2ba01fb71ed41cb6 = v; });
$parcel$export($6ae5a7c58175ebcb$exports, "dropDown", function () { return $6ae5a7c58175ebcb$export$bd4558eab3154e95; }, function (v) { return $6ae5a7c58175ebcb$export$bd4558eab3154e95 = v; });
$parcel$export($6ae5a7c58175ebcb$exports, "focus-visible", function () { return $6ae5a7c58175ebcb$export$f86455e47a9336bd; }, function (v) { return $6ae5a7c58175ebcb$export$f86455e47a9336bd = v; });
$parcel$export($6ae5a7c58175ebcb$exports, "isOpen", function () { return $6ae5a7c58175ebcb$export$ea0830439c7fc698; }, function (v) { return $6ae5a7c58175ebcb$export$ea0830439c7fc698 = v; });
$parcel$export($6ae5a7c58175ebcb$exports, "wrapper", function () { return $6ae5a7c58175ebcb$export$cc74dcc53cfce4eb; }, function (v) { return $6ae5a7c58175ebcb$export$cc74dcc53cfce4eb = v; });
var $6ae5a7c58175ebcb$export$2ba01fb71ed41cb6;
var $6ae5a7c58175ebcb$export$bd4558eab3154e95;
var $6ae5a7c58175ebcb$export$f86455e47a9336bd;
var $6ae5a7c58175ebcb$export$ea0830439c7fc698;
var $6ae5a7c58175ebcb$export$cc74dcc53cfce4eb;
$6ae5a7c58175ebcb$export$2ba01fb71ed41cb6 = `kg1-YG_button`;
$6ae5a7c58175ebcb$export$bd4558eab3154e95 = `kg1-YG_dropDown`;
$6ae5a7c58175ebcb$export$f86455e47a9336bd = `kg1-YG_focus-visible`;
$6ae5a7c58175ebcb$export$ea0830439c7fc698 = `kg1-YG_isOpen`;
$6ae5a7c58175ebcb$export$cc74dcc53cfce4eb = `kg1-YG_wrapper`;


const $dc0867a3069ccd6d$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($6ae5a7c58175ebcb$exports);
function $dc0867a3069ccd6d$export$2e2bcd8739ae039({ title: title, reverseLayout: reverseLayout, alternateBackground: alternateBackground, isDisabled: isDisabled, children: children }) {
    const [isOpen, setIsOpen] = (0, $bh6RR.useState)(false);
    const wrapperRef = (0, $bh6RR.useRef)();
    const buttonRef = (0, $bh6RR.useRef)();
    const handleFocus = (e)=>{
        if (wrapperRef.current && !wrapperRef.current.contains(e.target)) close();
    };
    const toggle = ()=>{
        setIsOpen(!isOpen);
    };
    const close = ()=>{
        if (buttonRef.current) buttonRef.current.focus();
        setIsOpen(false);
    };
    const onClick = (e)=>{
        if (e.target.tagName === 'LABEL') close();
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 32 && e.target.tagName === 'LABEL') close();
    };
    (0, $bh6RR.useEffect)(()=>{
        const removeListeners = ()=>{
            document.removeEventListener('click', handleFocus);
            document.removeEventListener('focusin', handleFocus);
        };
        if (isOpen) {
            document.addEventListener('click', handleFocus);
            document.addEventListener('focusin', handleFocus);
        } else removeListeners();
        return removeListeners;
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        ref: wrapperRef,
        className: $dc0867a3069ccd6d$var$cx($6ae5a7c58175ebcb$exports.wrapper, {
            isOpen: isOpen
        }),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)((0, $7f392002d26bc778$export$2e2bcd8739ae039), {
                reverseLayout: reverseLayout,
                alternateBackground: alternateBackground,
                isDisabled: isDisabled,
                onClick: toggle,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $7b8c7358b8b86633$export$2e2bcd8739ae039), {
                        title: title
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "button",
                        className: $6ae5a7c58175ebcb$exports.button,
                        onClick: toggle,
                        ref: buttonRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $6ae5a7c58175ebcb$exports.dropDown,
                onClick: onClick,
                onKeyUp: onKeyUp,
                children: children
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $f7803be46608d457$exports = {};

$parcel$export($f7803be46608d457$exports, "alternateBackground", function () { return $f7803be46608d457$export$7c7945898a349c4d; }, function (v) { return $f7803be46608d457$export$7c7945898a349c4d = v; });
$parcel$export($f7803be46608d457$exports, "clickable", function () { return $f7803be46608d457$export$60d5655c6babb2a0; }, function (v) { return $f7803be46608d457$export$60d5655c6babb2a0 = v; });
$parcel$export($f7803be46608d457$exports, "column", function () { return $f7803be46608d457$export$4e0c71f277ca26b3; }, function (v) { return $f7803be46608d457$export$4e0c71f277ca26b3 = v; });
$parcel$export($f7803be46608d457$exports, "flexStart", function () { return $f7803be46608d457$export$64e28a56cbc178d; }, function (v) { return $f7803be46608d457$export$64e28a56cbc178d = v; });
$parcel$export($f7803be46608d457$exports, "hidden", function () { return $f7803be46608d457$export$73920f18ca706874; }, function (v) { return $f7803be46608d457$export$73920f18ca706874 = v; });
$parcel$export($f7803be46608d457$exports, "isDisabled", function () { return $f7803be46608d457$export$30e0dc115df457ed; }, function (v) { return $f7803be46608d457$export$30e0dc115df457ed = v; });
$parcel$export($f7803be46608d457$exports, "isDisabledVisible", function () { return $f7803be46608d457$export$7244068d4e23172b; }, function (v) { return $f7803be46608d457$export$7244068d4e23172b = v; });
$parcel$export($f7803be46608d457$exports, "larger", function () { return $f7803be46608d457$export$a94a7414fa942aea; }, function (v) { return $f7803be46608d457$export$a94a7414fa942aea = v; });
$parcel$export($f7803be46608d457$exports, "noPadding", function () { return $f7803be46608d457$export$21f8faa572cd92e9; }, function (v) { return $f7803be46608d457$export$21f8faa572cd92e9 = v; });
$parcel$export($f7803be46608d457$exports, "paddingTopBottom", function () { return $f7803be46608d457$export$469e6d22015a1b8; }, function (v) { return $f7803be46608d457$export$469e6d22015a1b8 = v; });
$parcel$export($f7803be46608d457$exports, "responsive", function () { return $f7803be46608d457$export$9dc15d61278b91b8; }, function (v) { return $f7803be46608d457$export$9dc15d61278b91b8 = v; });
$parcel$export($f7803be46608d457$exports, "reverseLayout", function () { return $f7803be46608d457$export$e3c4083abc257c45; }, function (v) { return $f7803be46608d457$export$e3c4083abc257c45 = v; });
$parcel$export($f7803be46608d457$exports, "row", function () { return $f7803be46608d457$export$120ff0929b202a6d; }, function (v) { return $f7803be46608d457$export$120ff0929b202a6d = v; });
$parcel$export($f7803be46608d457$exports, "wrapper", function () { return $f7803be46608d457$export$cc74dcc53cfce4eb; }, function (v) { return $f7803be46608d457$export$cc74dcc53cfce4eb = v; });
var $f7803be46608d457$export$7c7945898a349c4d;
var $f7803be46608d457$export$60d5655c6babb2a0;
var $f7803be46608d457$export$4e0c71f277ca26b3;
var $f7803be46608d457$export$64e28a56cbc178d;
var $f7803be46608d457$export$73920f18ca706874;
var $f7803be46608d457$export$30e0dc115df457ed;
var $f7803be46608d457$export$7244068d4e23172b;
var $f7803be46608d457$export$a94a7414fa942aea;
var $f7803be46608d457$export$21f8faa572cd92e9;
var $f7803be46608d457$export$469e6d22015a1b8;
var $f7803be46608d457$export$9dc15d61278b91b8;
var $f7803be46608d457$export$e3c4083abc257c45;
var $f7803be46608d457$export$120ff0929b202a6d;
var $f7803be46608d457$export$cc74dcc53cfce4eb;
$f7803be46608d457$export$7c7945898a349c4d = `VpuVxG_alternateBackground`;
$f7803be46608d457$export$60d5655c6babb2a0 = `VpuVxG_clickable`;
$f7803be46608d457$export$4e0c71f277ca26b3 = `VpuVxG_column`;
$f7803be46608d457$export$64e28a56cbc178d = `VpuVxG_flexStart`;
$f7803be46608d457$export$73920f18ca706874 = `VpuVxG_hidden`;
$f7803be46608d457$export$30e0dc115df457ed = `VpuVxG_isDisabled`;
$f7803be46608d457$export$7244068d4e23172b = `VpuVxG_isDisabledVisible`;
$f7803be46608d457$export$a94a7414fa942aea = `VpuVxG_larger`;
$f7803be46608d457$export$21f8faa572cd92e9 = `VpuVxG_noPadding`;
$f7803be46608d457$export$469e6d22015a1b8 = `VpuVxG_paddingTopBottom`;
$f7803be46608d457$export$9dc15d61278b91b8 = `VpuVxG_responsive`;
$f7803be46608d457$export$e3c4083abc257c45 = `VpuVxG_reverseLayout`;
$f7803be46608d457$export$120ff0929b202a6d = `VpuVxG_row`;
$f7803be46608d457$export$cc74dcc53cfce4eb = `VpuVxG_wrapper`;


const $7f392002d26bc778$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f7803be46608d457$exports);
function $7f392002d26bc778$export$2e2bcd8739ae039({ reverseLayout: reverseLayout, flexStart: flexStart, row: row, column: column, alternateBackground: alternateBackground, isDisabled: isDisabled, isDisabledVisible: isDisabledVisible, larger: larger, responsive: responsive, noPadding: noPadding, paddingTopBottom: paddingTopBottom, hidden: hidden, children: children, onClick: onClick }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $7f392002d26bc778$var$cx($f7803be46608d457$exports.wrapper, {
            reverseLayout: reverseLayout,
            flexStart: flexStart,
            row: row,
            column: column,
            alternateBackground: alternateBackground,
            isDisabled: isDisabled,
            isDisabledVisible: isDisabledVisible,
            larger: larger,
            responsive: responsive,
            noPadding: noPadding,
            paddingTopBottom: paddingTopBottom,
            hidden: hidden,
            clickable: typeof onClick === 'function'
        }),
        onClick: onClick,
        children: children
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");
function $9248d934b0a2f4d5$export$2e2bcd8739ae039() {
    const buttonRef = (0, $bh6RR.useRef)();
    (0, $bh6RR.useEffect)(()=>{
        if (buttonRef.current) buttonRef.current.focus();
    }, [
        buttonRef
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsx)("button", {
        ref: buttonRef,
        style: {
            position: 'absolute',
            opacity: 0
        }
    });
}



var $ih19M = parcelRequire("ih19M");

var $fe049913e994e3d1$exports = {};

$parcel$export($fe049913e994e3d1$exports, "fullscreen", function () { return $fe049913e994e3d1$export$af93ab412ae68734; }, function (v) { return $fe049913e994e3d1$export$af93ab412ae68734 = v; });
$parcel$export($fe049913e994e3d1$exports, "isLoading", function () { return $fe049913e994e3d1$export$20bb0d907fbbe433; }, function (v) { return $fe049913e994e3d1$export$20bb0d907fbbe433 = v; });
$parcel$export($fe049913e994e3d1$exports, "noRadius", function () { return $fe049913e994e3d1$export$a112047a516700d9; }, function (v) { return $fe049913e994e3d1$export$a112047a516700d9 = v; });
$parcel$export($fe049913e994e3d1$exports, "wrapper", function () { return $fe049913e994e3d1$export$cc74dcc53cfce4eb; }, function (v) { return $fe049913e994e3d1$export$cc74dcc53cfce4eb = v; });
var $fe049913e994e3d1$export$af93ab412ae68734;
var $fe049913e994e3d1$export$20bb0d907fbbe433;
var $fe049913e994e3d1$export$a112047a516700d9;
var $fe049913e994e3d1$export$cc74dcc53cfce4eb;
$fe049913e994e3d1$export$af93ab412ae68734 = `PrQI1W_fullscreen`;
$fe049913e994e3d1$export$20bb0d907fbbe433 = `PrQI1W_isLoading`;
$fe049913e994e3d1$export$a112047a516700d9 = `PrQI1W_noRadius`;
$fe049913e994e3d1$export$cc74dcc53cfce4eb = `PrQI1W_wrapper`;


const $9094094da0261b51$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($fe049913e994e3d1$exports);
function $9094094da0261b51$export$2e2bcd8739ae039({ isLoading: isLoading, noRadius: noRadius, fullscreen: fullscreen, children: children, noStyle: noStyle }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: noStyle ? null : $9094094da0261b51$var$cx($fe049913e994e3d1$exports.wrapper, {
            isLoading: isLoading,
            fullscreen: fullscreen,
            noRadius: noRadius
        }),
        children: children
    });
}



var $ih19M = parcelRequire("ih19M");

var $7a105bb9433c428d$exports = {};

$parcel$export($7a105bb9433c428d$exports, "isLoading", function () { return $7a105bb9433c428d$export$20bb0d907fbbe433; }, function (v) { return $7a105bb9433c428d$export$20bb0d907fbbe433 = v; });
$parcel$export($7a105bb9433c428d$exports, "onlyFullscreen", function () { return $7a105bb9433c428d$export$18ff49137a9a1b24; }, function (v) { return $7a105bb9433c428d$export$18ff49137a9a1b24 = v; });
$parcel$export($7a105bb9433c428d$exports, "onlyMobile", function () { return $7a105bb9433c428d$export$2e0bacb99c6be5ee; }, function (v) { return $7a105bb9433c428d$export$2e0bacb99c6be5ee = v; });
$parcel$export($7a105bb9433c428d$exports, "wrapper", function () { return $7a105bb9433c428d$export$cc74dcc53cfce4eb; }, function (v) { return $7a105bb9433c428d$export$cc74dcc53cfce4eb = v; });
var $7a105bb9433c428d$export$20bb0d907fbbe433;
var $7a105bb9433c428d$export$18ff49137a9a1b24;
var $7a105bb9433c428d$export$2e0bacb99c6be5ee;
var $7a105bb9433c428d$export$cc74dcc53cfce4eb;
$7a105bb9433c428d$export$20bb0d907fbbe433 = `eI6iTW_isLoading`;
$7a105bb9433c428d$export$18ff49137a9a1b24 = `eI6iTW_onlyFullscreen`;
$7a105bb9433c428d$export$2e0bacb99c6be5ee = `eI6iTW_onlyMobile`;
$7a105bb9433c428d$export$cc74dcc53cfce4eb = `eI6iTW_wrapper`;



const $0e674c50b4c32bcf$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($7a105bb9433c428d$exports);
function $0e674c50b4c32bcf$export$2e2bcd8739ae039({ isLoading: isLoading, onlyFullscreen: onlyFullscreen, onlyMobile: onlyMobile, className: className, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)($1ab1ad86cd1cb08e$export$7edd4a21fac8ce55, {
        className: $0e674c50b4c32bcf$var$cx($7a105bb9433c428d$exports.wrapper, className, {
            isLoading: isLoading,
            onlyFullscreen: onlyFullscreen,
            onlyMobile: onlyMobile
        }),
        children: children
    });
}



var $ih19M = parcelRequire("ih19M");

var $f44e131193ceccda$exports = {};

$parcel$export($f44e131193ceccda$exports, "svg", function () { return $f44e131193ceccda$export$7ed1367e7fa1ad68; }, function (v) { return $f44e131193ceccda$export$7ed1367e7fa1ad68 = v; });
var $f44e131193ceccda$export$7ed1367e7fa1ad68;
$f44e131193ceccda$export$7ed1367e7fa1ad68 = `Nwwt0a_svg`;


const $0e69d829785fe9a1$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f44e131193ceccda$exports);
function $0e69d829785fe9a1$export$2e2bcd8739ae039({ id: id, className: className, color: color }) {
    switch(id){
        case 'change':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "18",
                height: "5",
                viewBox: "0 0 18 5",
                className: $0e69d829785fe9a1$var$cx($f44e131193ceccda$exports.svg, className),
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                        cx: "16",
                        cy: "2.5",
                        r: "2"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                        cx: "9",
                        cy: "2.5",
                        r: "2"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                        cx: "2",
                        cy: "2.5",
                        r: "2"
                    })
                ]
            });
        case 'pin':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "16",
                height: "19",
                viewBox: "0 0 16 19",
                className: $0e69d829785fe9a1$var$cx($f44e131193ceccda$exports.svg, className),
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M2.34315 2.34315C-0.781049 5.46734 -0.781049 10.5327 2.34315 13.6569L6.58579 17.8995C7.36684 18.6805 8.63317 18.6805 9.41421 17.8995L13.6569 13.6569C16.781 10.5327 16.781 5.46734 13.6569 2.34315C10.5327 -0.781049 5.46734 -0.781049 2.34315 2.34315ZM8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5Z",
                    fill: "#17181A"
                })
            });
        case 'pen':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "11",
                height: "11",
                viewBox: "0 0 11 11",
                className: $0e69d829785fe9a1$var$cx($f44e131193ceccda$exports.svg, className),
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M10.1224 2.81944C10.4194 2.52243 10.5679 2.37393 10.6235 2.20268C10.6725 2.05205 10.6725 1.88979 10.6235 1.73915C10.5679 1.56791 10.4194 1.4194 10.1224 1.12239L9.84853 0.848528C9.55152 0.551515 9.40301 0.403009 9.23176 0.347368C9.08113 0.298424 8.91887 0.298424 8.76824 0.347368C8.59699 0.403009 8.44848 0.551516 8.15147 0.848528L7.6839 1.3161L9.65481 3.28702L10.1224 2.81944ZM6.89553 2.10447L0.711589 8.28841C0.569303 8.4307 0.49816 8.50184 0.443481 8.58364C0.394966 8.65621 0.356162 8.73483 0.328061 8.81749C0.296391 8.91064 0.28319 9.01038 0.25679 9.20986L0.106468 10.3457C0.0840982 10.5147 0.0729136 10.5993 0.100023 10.6624C0.123795 10.7179 0.166789 10.7628 0.221086 10.789C0.283011 10.8189 0.367939 10.8115 0.537795 10.7967L1.71856 10.6936C1.93347 10.6748 2.04092 10.6655 2.14146 10.6347C2.23065 10.6075 2.31559 10.5679 2.39381 10.5171C2.48199 10.4598 2.55826 10.3836 2.7108 10.231L8.86645 4.07538L6.89553 2.10447Z",
                    fill: "#17181A"
                })
            });
        case 'drag':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "16",
                height: "10",
                fill: "black",
                fillOpacity: "0.5",
                className: $0e69d829785fe9a1$var$cx(className),
                viewBox: "0 0 16 10",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M0 4h16v2H0zm0-4h16v2H0zm0 8h16v2H0z"
                })
            });
        case 'plus':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "black",
                fillOpacity: "0.5",
                className: $0e69d829785fe9a1$var$cx(className),
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9 11V15H11V11H15V9H11V5H9V9H5V11H9Z"
                })
            });
        case 'white-minus':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "10",
                height: "10",
                viewBox: "0 0 10 2",
                fill: "none",
                stroke: "#FFF",
                strokeWidth: "2",
                className: $0e69d829785fe9a1$var$cx(className),
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M0 1h10"
                })
            });
        case 'white-plus':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "10",
                height: "10",
                viewBox: "0 0 10 10",
                fill: "none",
                stroke: "#FFF",
                strokeWidth: "2",
                className: $0e69d829785fe9a1$var$cx(className),
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M5 0v10M0 5h10"
                })
            });
        case 'suitcase':
            color = color || 'white';
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "16",
                height: "13",
                fill: "none",
                className: $0e69d829785fe9a1$var$cx(className),
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fill: color,
                        d: "M1.333 5.3c0-.747 0-1.12.146-1.405.127-.251.331-.455.582-.583.285-.145.659-.145 1.406-.145h9.066c.747 0 1.12 0 1.406.145.25.128.454.332.582.583.146.285.146.658.146 1.405v5.067c0 .746 0 1.12-.146 1.405-.128.25-.332.455-.582.583-.286.145-.659.145-1.406.145H3.467c-.747 0-1.12 0-1.406-.145a1.33 1.33 0 0 1-.582-.583c-.146-.285-.146-.659-.146-1.405z"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        stroke: color,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        d: "M10.667 3.167c0-.62 0-.93-.069-1.185A2 2 0 0 0 9.184.568C8.93.5 8.62.5 8 .5s-.93 0-1.184.068A2 2 0 0 0 5.4 1.982c-.068.255-.068.565-.068 1.185M3.467 12.5h9.066c.747 0 1.12 0 1.406-.145.25-.128.454-.332.582-.583.146-.285.146-.659.146-1.405V5.3c0-.747 0-1.12-.146-1.405a1.33 1.33 0 0 0-.582-.583c-.286-.145-.659-.145-1.406-.145H3.467c-.747 0-1.12 0-1.406.145-.25.128-.455.332-.582.583-.146.285-.146.658-.146 1.405v5.067c0 .746 0 1.12.146 1.405.127.25.331.455.582.583.285.145.659.145 1.406.145"
                    })
                ]
            });
        default:
            return null;
    }
}



var $ih19M = parcelRequire("ih19M");
function $4c82bd27a7e186ea$export$2e2bcd8739ae039({ location: location, name: name, className: className }) {
    const type = name || location?.pointOfInterestType || location?.locationType;
    switch(type){
        case 'AIRPORT':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M17.7448 2.81249C18.7095 1.81601 20.3036 1.80312 21.2843 2.78387C22.2382 3.73775 22.2559 5.27872 21.3243 6.25432L18.5456 9.16409C18.3278 9.39216 18.219 9.50619 18.1518 9.63975C18.0924 9.75799 18.0571 9.88683 18.0478 10.0188C18.0374 10.1679 18.0728 10.3216 18.1438 10.6289L19.8717 18.1164C19.9444 18.4318 19.9808 18.5895 19.9691 18.7421C19.9587 18.8771 19.921 19.0086 19.8582 19.1286C19.7873 19.2642 19.6729 19.3787 19.444 19.6076L19.0732 19.9783C18.4671 20.5845 18.164 20.8875 17.8538 20.9424C17.583 20.9903 17.3043 20.9245 17.0835 20.7606C16.8306 20.5728 16.695 20.1661 16.424 19.3529L14.4142 13.3236L11.0689 16.669C10.8692 16.8687 10.7694 16.9685 10.7026 17.0861C10.6434 17.1902 10.6034 17.3042 10.5846 17.4225C10.5633 17.556 10.5789 17.6964 10.61 17.977L10.7937 19.6304C10.8249 19.9111 10.8405 20.0514 10.8192 20.185C10.8004 20.3033 10.7604 20.4172 10.7012 20.5214C10.6344 20.6389 10.5346 20.7388 10.3349 20.9385L10.1374 21.136C9.66434 21.609 9.42781 21.8456 9.16496 21.9141C8.93442 21.9742 8.68999 21.95 8.47571 21.8458C8.2314 21.7271 8.04585 21.4488 7.67475 20.8921L6.10643 18.5396C6.04013 18.4402 6.00698 18.3905 5.96849 18.3454C5.9343 18.3053 5.89701 18.268 5.85694 18.2338C5.81184 18.1953 5.76212 18.1622 5.66267 18.0959L3.31018 16.5276C2.75354 16.1565 2.47521 15.9709 2.35649 15.7266C2.25236 15.5123 2.22816 15.2679 2.28824 15.0374C2.35674 14.7745 2.59327 14.538 3.06633 14.0649L3.26384 13.8674C3.46352 13.6677 3.56337 13.5679 3.68095 13.5011C3.78511 13.4419 3.89906 13.402 4.01736 13.3831C4.15089 13.3618 4.29123 13.3774 4.5719 13.4086L6.22529 13.5923C6.50596 13.6235 6.6463 13.6391 6.77983 13.6178C6.89813 13.5989 7.01208 13.5589 7.11624 13.4997C7.23382 13.433 7.33366 13.3331 7.53335 13.1334L10.8787 9.78811L4.84939 7.77835C4.03616 7.50727 3.62955 7.37174 3.44176 7.11883C3.27777 6.89799 3.212 6.61935 3.2599 6.34849C3.31477 6.0383 3.61784 5.73523 4.22399 5.12909L4.59476 4.75831C4.82365 4.52942 4.9381 4.41497 5.07369 4.34408C5.1937 4.28134 5.3252 4.24362 5.46023 4.23323C5.61278 4.22148 5.77049 4.25787 6.0859 4.33066L13.545 6.052C13.855 6.12353 14.01 6.15929 14.1596 6.14865C14.3041 6.13838 14.4446 6.09685 14.5714 6.02693C14.7028 5.95452 14.8134 5.84025 15.0347 5.61171L17.7448 2.81249Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'FERRY_TERMINAL':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M2 20C2.60606 21.3583 4.45455 23.26 7 20C7.90909 21.3583 9.81818 23.26 12 20C12.9091 21.2074 15.1818 22.8978 17 20C17.9091 21.5092 20.1818 23.6222 22 20M5.00001 21V18L3.00001 14.5C2.5 13.5 2.00008 12.5 4.49999 12L12 10L19.5 12C21.9999 12.5 21.5 13.5 21 14.5L19 18V21M6 11.5V7H9V5H12M12 5H15V7H18V11.5M12 5V3",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'HOSPITAL':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M13.8333 7.3C13.8333 7.01997 13.8333 6.87996 13.7788 6.773C13.7309 6.67892 13.6544 6.60243 13.5603 6.5545C13.4534 6.5 13.3134 6.5 13.0333 6.5H10.9667C10.6866 6.5 10.5466 6.5 10.4397 6.5545C10.3456 6.60243 10.2691 6.67892 10.2212 6.773C10.1667 6.87996 10.1667 7.01997 10.1667 7.3V9.36667C10.1667 9.64669 10.1667 9.78671 10.1122 9.89366C10.0642 9.98774 9.98774 10.0642 9.89366 10.1122C9.78671 10.1667 9.64669 10.1667 9.36667 10.1667H7.3C7.01997 10.1667 6.87996 10.1667 6.773 10.2212C6.67892 10.2691 6.60243 10.3456 6.5545 10.4397C6.5 10.5466 6.5 10.6866 6.5 10.9667V13.0333C6.5 13.3134 6.5 13.4534 6.5545 13.5603C6.60243 13.6544 6.67892 13.7309 6.773 13.7788C6.87996 13.8333 7.01997 13.8333 7.3 13.8333H9.36667C9.64669 13.8333 9.78671 13.8333 9.89366 13.8878C9.98774 13.9358 10.0642 14.0123 10.1122 14.1063C10.1667 14.2133 10.1667 14.3533 10.1667 14.6333V16.7C10.1667 16.98 10.1667 17.12 10.2212 17.227C10.2691 17.3211 10.3456 17.3976 10.4397 17.4455C10.5466 17.5 10.6866 17.5 10.9667 17.5H13.0333C13.3134 17.5 13.4534 17.5 13.5603 17.4455C13.6544 17.3976 13.7309 17.3211 13.7788 17.227C13.8333 17.12 13.8333 16.98 13.8333 16.7V14.6333C13.8333 14.3533 13.8333 14.2133 13.8878 14.1063C13.9358 14.0123 14.0123 13.9358 14.1063 13.8878C14.2133 13.8333 14.3533 13.8333 14.6333 13.8333H16.7C16.98 13.8333 17.12 13.8333 17.227 13.7788C17.3211 13.7309 17.3976 13.6544 17.4455 13.5603C17.5 13.4534 17.5 13.3134 17.5 13.0333V10.9667C17.5 10.6866 17.5 10.5466 17.4455 10.4397C17.3976 10.3456 17.3211 10.2691 17.227 10.2212C17.12 10.1667 16.98 10.1667 16.7 10.1667H14.6333C14.3533 10.1667 14.2133 10.1667 14.1063 10.1122C14.0123 10.0642 13.9358 9.98774 13.8878 9.89366C13.8333 9.78671 13.8333 9.64669 13.8333 9.36667V7.3Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case 'RAILWAY_STATION':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M9.5 22H14.5M8 2H16M12 5V2M4 12H20M17 19L18.5 22M7 19L5.5 22M8.5 15.5H8.51M15.5 15.5H15.51M8.8 19H15.2C16.8802 19 17.7202 19 18.362 18.673C18.9265 18.3854 19.3854 17.9265 19.673 17.362C20 16.7202 20 15.8802 20 14.2V9.8C20 8.11984 20 7.27976 19.673 6.63803C19.3854 6.07354 18.9265 5.6146 18.362 5.32698C17.7202 5 16.8802 5 15.2 5H8.8C7.11984 5 6.27976 5 5.63803 5.32698C5.07354 5.6146 4.6146 6.07354 4.32698 6.63803C4 7.27976 4 8.11984 4 9.8V14.2C4 15.8802 4 16.7202 4.32698 17.362C4.6146 17.9265 5.07354 18.3854 5.63803 18.673C6.27976 19 7.11984 19 8.8 19ZM9 15.5C9 15.7761 8.77614 16 8.5 16C8.22386 16 8 15.7761 8 15.5C8 15.2239 8.22386 15 8.5 15C8.77614 15 9 15.2239 9 15.5ZM16 15.5C16 15.7761 15.7761 16 15.5 16C15.2239 16 15 15.7761 15 15.5C15 15.2239 15.2239 15 15.5 15C15.7761 15 16 15.2239 16 15.5Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'PUBLIC_TRANSPORT_STOP':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M8.5 19V21.2C8.5 21.48 8.5 21.62 8.4455 21.727C8.39757 21.8211 8.32108 21.8976 8.227 21.9455C8.12004 22 7.98003 22 7.7 22H5.8C5.51997 22 5.37996 22 5.273 21.9455C5.17892 21.8976 5.10243 21.8211 5.0545 21.727C5 21.62 5 21.48 5 21.2V19M19 19V21.2C19 21.48 19 21.62 18.9455 21.727C18.8976 21.8211 18.8211 21.8976 18.727 21.9455C18.62 22 18.48 22 18.2 22H16.3C16.02 22 15.88 22 15.773 21.9455C15.6789 21.8976 15.6024 21.8211 15.5545 21.727C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12H21M3 5.5H21M6.5 15.5H8M16 15.5H17.5M7.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V6.8C21 5.11984 21 4.27976 20.673 3.63803C20.3854 3.07354 19.9265 2.6146 19.362 2.32698C18.7202 2 17.8802 2 16.2 2H7.8C6.11984 2 5.27976 2 4.63803 2.32698C4.07354 2.6146 3.6146 3.07354 3.32698 3.63803C3 4.27976 3 5.11984 3 6.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'SHOP':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M16.0004 9V6C16.0004 3.79086 14.2095 2 12.0004 2C9.79123 2 8.00037 3.79086 8.00037 6V9M3.59237 10.352L2.99237 16.752C2.82178 18.5717 2.73648 19.4815 3.03842 20.1843C3.30367 20.8016 3.76849 21.3121 4.35839 21.6338C5.0299 22 5.94374 22 7.77142 22H16.2293C18.057 22 18.9708 22 19.6423 21.6338C20.2322 21.3121 20.6971 20.8016 20.9623 20.1843C21.2643 19.4815 21.179 18.5717 21.0084 16.752L20.4084 10.352C20.2643 8.81535 20.1923 8.04704 19.8467 7.46616C19.5424 6.95458 19.0927 6.54511 18.555 6.28984C17.9444 6 17.1727 6 15.6293 6L8.37142 6C6.82806 6 6.05638 6 5.44579 6.28984C4.90803 6.54511 4.45838 6.95458 4.15403 7.46616C3.80846 8.04704 3.73643 8.81534 3.59237 10.352Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'RESTAURANT':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M15.4348 22V12M15.4348 12V2C16.7392 2.43478 20 4.32609 20 8.5C20 11.1087 17.6087 12 15.4348 12Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M7.4783 2V22",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M4 2V6.78261C4 7.94203 4.69565 10.3478 7.47826 10.6957",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M10.9564 2V6.78261C10.9564 7.94203 10.2607 10.3478 7.47813 10.6957",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case 'HOTEL':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M15 21V15.6C15 15.0399 15 14.7599 14.891 14.546C14.7951 14.3578 14.6422 14.2049 14.454 14.109C14.2401 14 13.9601 14 13.4 14H10.6C10.0399 14 9.75992 14 9.54601 14.109C9.35785 14.2049 9.20487 14.3578 9.10899 14.546C9 14.7599 9 15.0399 9 15.6V21M3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 8.65685 16.3431 10 18 10C19.6569 10 21 8.65685 21 7M6.2 21H17.8C18.9201 21 19.4802 21 19.908 20.782C20.2843 20.5903 20.5903 20.2843 20.782 19.908C21 19.4802 21 18.9201 21 17.8V6.2C21 5.0799 21 4.51984 20.782 4.09202C20.5903 3.71569 20.2843 3.40973 19.908 3.21799C19.4802 3 18.9201 3 17.8 3H6.2C5.0799 3 4.51984 3 4.09202 3.21799C3.71569 3.40973 3.40973 3.71569 3.21799 4.09202C3 4.51984 3 5.07989 3 6.2V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'MUSEUM':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M5 9.00002V17M9.5 9.00002V17M14.5 9.00002V17M19 9.00002V17M3 18.6L3 19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7952 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7952 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.04 21 17.7599 20.891 17.546C20.7951 17.3579 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3579 3.10899 17.546C3 17.7599 3 18.04 3 18.6ZM11.6529 3.07715L4.25291 4.7216C3.80585 4.82094 3.58232 4.87062 3.41546 4.99082C3.26829 5.09685 3.15273 5.24092 3.08115 5.40759C3 5.59654 3 5.82553 3 6.28349L3 7.40002C3 7.96007 3 8.2401 3.10899 8.45401C3.20487 8.64217 3.35785 8.79515 3.54601 8.89103C3.75992 9.00002 4.03995 9.00002 4.6 9.00002H19.4C19.9601 9.00002 20.2401 9.00002 20.454 8.89103C20.6422 8.79515 20.7951 8.64217 20.891 8.45401C21 8.2401 21 7.96007 21 7.40002V6.2835C21 5.82553 21 5.59655 20.9188 5.40759C20.8473 5.24092 20.7317 5.09685 20.5845 4.99082C20.4177 4.87062 20.1942 4.82094 19.7471 4.7216L12.3471 3.07715C12.2176 3.04837 12.1528 3.03398 12.0874 3.02824C12.0292 3.02314 11.9708 3.02314 11.9126 3.02824C11.8472 3.03398 11.7824 3.04837 11.6529 3.07715Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'EMBASSY':
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V4C20 4 19 5 16 5C13 5 11 3 8 3C5 3 4 4 4 4M4 22L4 2",
                    stroke: "black",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                })
            });
        case 'THEATER':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M9.37201 9.58458C10.6032 8.93742 12.482 9.51983 12.5207 11.3864",
                        stroke: "#17181A",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M18.4041 14.6676C18.2915 13.2813 16.7937 12.0062 15.1965 12.973",
                        stroke: "#17181A",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M9.4605 14.3087L9.0218 13.9402C8.69651 13.6669 8.2002 13.8982 8.2002 14.323L8.2002 15.4226C8.2002 16.0808 8.29304 16.7358 8.47598 17.3681L8.59538 17.7808C8.98878 19.1405 10.3528 19.977 11.7431 19.7111C12.5255 19.5615 13.273 19.267 13.9472 18.8429L14.9674 18.2012C15.3195 17.9797 15.2629 17.45 14.8719 17.308L14.2892 17.0963C12.5289 16.4569 10.8945 15.5134 9.4605 14.3087Z",
                        stroke: "#17181A",
                        "stroke-width": "1.5",
                        "stroke-linejoin": "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M18.2488 7.36556C18.0931 5.59728 17.6715 3.69274 16.9557 1.62386C16.825 1.24605 16.4753 0.989667 16.076 0.968655L14.8196 0.902526C10.6309 0.682069 6.47955 1.79025 2.95797 4.06893L1.49214 5.01741C1.13561 5.2481 0.96186 5.67948 1.07244 6.08949C2.02457 9.61995 3.55275 12.3558 5.25645 14.4283C5.34301 14.5336 5.43003 14.6372 5.51745 14.7391M18.2488 7.36556C16.1548 5.95584 13.7993 4.94875 11.3019 4.41361L9.59478 4.04779C9.17955 3.95882 8.75166 4.14099 8.53993 4.50909C6.71677 7.67877 5.86281 10.6939 5.60203 13.3641C5.55619 13.8334 5.52868 14.2921 5.51745 14.7391M18.2488 7.36556C19.5938 8.27107 20.8309 9.34269 21.9284 10.5621L22.77 11.4973C23.0375 11.7944 23.1028 12.2247 22.928 12.5842C19.3177 20.0126 14.402 22.827 8.17844 23.1595C7.85314 23.1769 7.53865 23.0286 7.3659 22.7524C6.40482 21.2158 5.42646 18.3613 5.51745 14.7391",
                        stroke: "#17181A",
                        "stroke-width": "1.5",
                        "stroke-linejoin": "round"
                    })
                ]
            });
        default:
        case 'POINT_OF_INTEREST':
        case 'ADDRESS':
            return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M12 22C16 18 20 14.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 14.4183 8 18 12 22Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            });
        case 'STREET':
        case 'SHOW_MORE':
            // NOTE: This is used for the Show more search results button
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        case 'OTHER_REGION':
            // NOTE: This is used for the Search in another region button
            return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "#17181A",
                xmlns: "http://www.w3.org/2000/svg",
                className: className,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M19.2 12C19.2 15.9765 15.9765 19.2 12 19.2M19.2 12C19.2 8.02355 15.9765 4.8 12 4.8M19.2 12H21M12 19.2C8.02355 19.2 4.8 15.9765 4.8 12M12 19.2V21M4.8 12C4.8 8.02355 8.02355 4.8 12 4.8M4.8 12H3M12 4.8V3M14.7 12C14.7 13.4912 13.4912 14.7 12 14.7C10.5088 14.7 9.3 13.4912 9.3 12C9.3 10.5088 10.5088 9.3 12 9.3C13.4912 9.3 14.7 10.5088 14.7 12Z",
                    strokeWidth: "1.5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
    }
}



var $ih19M = parcelRequire("ih19M");

var $1ee48398ea86ec7f$exports = {};

$parcel$export($1ee48398ea86ec7f$exports, "icon", function () { return $1ee48398ea86ec7f$export$1ca1ec8b29a4ce27; }, function (v) { return $1ee48398ea86ec7f$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($1ee48398ea86ec7f$exports, "isSmall", function () { return $1ee48398ea86ec7f$export$813595e92b2e7a6f; }, function (v) { return $1ee48398ea86ec7f$export$813595e92b2e7a6f = v; });
var $1ee48398ea86ec7f$export$1ca1ec8b29a4ce27;
var $1ee48398ea86ec7f$export$813595e92b2e7a6f;
$1ee48398ea86ec7f$export$1ca1ec8b29a4ce27 = `ut40bW_icon`;
$1ee48398ea86ec7f$export$813595e92b2e7a6f = `ut40bW_isSmall`;


const $19c1cf018e73b338$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($1ee48398ea86ec7f$exports);
function $19c1cf018e73b338$export$2e2bcd8739ae039({ id: id, small: small }) {
    switch(id){
        case 'taxi':
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
        case 'business':
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
        case 'estate':
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
        case 'largeCar':
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
        case 'smallElectric':
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/car-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
        default:
            return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                src: `/app/themes/taxi-stockholm/static/img/option-icons/${id}.png`,
                className: $19c1cf018e73b338$var$cx($1ee48398ea86ec7f$exports.icon, {
                    isSmall: small
                })
            });
    }
}



var $ih19M = parcelRequire("ih19M");



var $30997d7afa41b96c$exports = {};

$parcel$export($30997d7afa41b96c$exports, "absolute", function () { return $30997d7afa41b96c$export$d31af2dc8039efd3; }, function (v) { return $30997d7afa41b96c$export$d31af2dc8039efd3 = v; });
$parcel$export($30997d7afa41b96c$exports, "container", function () { return $30997d7afa41b96c$export$34e0f9847d4c02dd; }, function (v) { return $30997d7afa41b96c$export$34e0f9847d4c02dd = v; });
$parcel$export($30997d7afa41b96c$exports, "fullWidth", function () { return $30997d7afa41b96c$export$f59aa6be2711b90; }, function (v) { return $30997d7afa41b96c$export$f59aa6be2711b90 = v; });
$parcel$export($30997d7afa41b96c$exports, "hasCloseButton", function () { return $30997d7afa41b96c$export$d7b257a5dc399802; }, function (v) { return $30997d7afa41b96c$export$d7b257a5dc399802 = v; });
$parcel$export($30997d7afa41b96c$exports, "lightBackground", function () { return $30997d7afa41b96c$export$3ea5dcb3fe0630c0; }, function (v) { return $30997d7afa41b96c$export$3ea5dcb3fe0630c0 = v; });
$parcel$export($30997d7afa41b96c$exports, "rounded", function () { return $30997d7afa41b96c$export$38973445a4150f11; }, function (v) { return $30997d7afa41b96c$export$38973445a4150f11 = v; });
$parcel$export($30997d7afa41b96c$exports, "wrapper", function () { return $30997d7afa41b96c$export$cc74dcc53cfce4eb; }, function (v) { return $30997d7afa41b96c$export$cc74dcc53cfce4eb = v; });
var $30997d7afa41b96c$export$d31af2dc8039efd3;
var $30997d7afa41b96c$export$34e0f9847d4c02dd;
var $30997d7afa41b96c$export$f59aa6be2711b90;
var $30997d7afa41b96c$export$d7b257a5dc399802;
var $30997d7afa41b96c$export$3ea5dcb3fe0630c0;
var $30997d7afa41b96c$export$38973445a4150f11;
var $30997d7afa41b96c$export$cc74dcc53cfce4eb;
$30997d7afa41b96c$export$d31af2dc8039efd3 = `fVTPsW_absolute`;
$30997d7afa41b96c$export$34e0f9847d4c02dd = `fVTPsW_container`;
$30997d7afa41b96c$export$f59aa6be2711b90 = `fVTPsW_fullWidth`;
$30997d7afa41b96c$export$d7b257a5dc399802 = `fVTPsW_hasCloseButton`;
$30997d7afa41b96c$export$3ea5dcb3fe0630c0 = `fVTPsW_lightBackground`;
$30997d7afa41b96c$export$38973445a4150f11 = `fVTPsW_rounded`;
$30997d7afa41b96c$export$cc74dcc53cfce4eb = `fVTPsW_wrapper`;


const $d1129c5f3177e033$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($30997d7afa41b96c$exports);
function $d1129c5f3177e033$export$2e2bcd8739ae039({ isOpen: isOpen, isPanel: isPanel, onClose: onClose, lightBackground: lightBackground, rounded: rounded, absolute: absolute, fullWidth: fullWidth, children: children }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
        children: isOpen && /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            whileInView: {
                opacity: 1
            },
            className: $d1129c5f3177e033$var$cx($30997d7afa41b96c$exports.wrapper, {
                isOpen: isOpen,
                lightBackground: lightBackground,
                rounded: rounded,
                absolute: absolute,
                isPanel: isPanel,
                fullWidth: fullWidth
            }),
            children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).div, {
                initial: {
                    y: 50
                },
                animate: {
                    y: 0
                },
                exit: {
                    y: -50
                },
                className: $d1129c5f3177e033$var$cx($30997d7afa41b96c$exports.container, {
                    isPanel: isPanel,
                    hasCloseButton: !!onClose
                }),
                children: [
                    onClose && /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fa620ad2e74576c$export$2e2bcd8739ae039), {
                        onClick: onClose,
                        small: true
                    }),
                    children
                ]
            })
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $6afFj = parcelRequire("6afFj");


/**
 * Global React modal — replaces the legacy APP.trigger(APP.events.SHOW_MODAL) system.
 * Mount once inside StoreContext. Triggered via showModal() / showInfoModal() / showContentModal() from ~/lib/modal.
 * The dynamic booking overlay (modern/index.js) mounts a second Store, and with it a second
 * GlobalModal; only the most recently mounted instance answers the events, so a modal never
 * opens twice. When it unmounts the previous instance takes over again.
 *
 * Supports three variants from Figma 209-5177:
 *   type='modal'       — centered title + centered text + flush buttons (default for confirmations)
 *   type='information' — info icon + left title + left text + flush buttons
 *   content render fn  — arbitrary JSX with a close button (via SHOW_GLOBAL_CONTENT_MODAL)
 *
 * Button order convention (matching legacy): first button = confirm, second = cancel.
 * Display order (matching Figma): cancel on left, confirm on right.
 * So the array is reversed before passing to ButtonDrawer (where last = primary/right).
 */ const $efcd9c5e78db09db$var$InfoIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("g", {
                clipPath: "url(#gm-info-clip)",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8 14.4333C11.553 14.4333 14.4333 11.553 14.4333 8C14.4333 4.44697 11.553 1.56667 8 1.56667C4.44697 1.56667 1.56667 4.44697 1.56667 8C1.56667 11.553 4.44697 14.4333 8 14.4333ZM8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.2",
                        y: "4",
                        width: "1.6",
                        height: "1.6",
                        rx: "0.8",
                        fill: "#17181A"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "7.467",
                        y: "6.667",
                        width: "1.067",
                        height: "5.333",
                        rx: "0.213",
                        fill: "#17181A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("defs", {
                children: /*#__PURE__*/ (0, $ih19M.jsx)("clipPath", {
                    id: "gm-info-clip",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white"
                    })
                })
            })
        ]
    });
// Mounted instances, last = the one that handles events
const $efcd9c5e78db09db$var$hosts = [];
function $efcd9c5e78db09db$export$2e2bcd8739ae039() {
    const [state, setState] = (0, $bh6RR.useState)(null);
    const hostRef = (0, $bh6RR.useRef)({});
    (0, $bh6RR.useEffect)(()=>{
        const host = hostRef.current;
        $efcd9c5e78db09db$var$hosts.push(host);
        return ()=>{
            const index = $efcd9c5e78db09db$var$hosts.indexOf(host);
            if (index !== -1) $efcd9c5e78db09db$var$hosts.splice(index, 1);
        };
    }, []);
    const isActiveHost = ()=>$efcd9c5e78db09db$var$hosts[$efcd9c5e78db09db$var$hosts.length - 1] === hostRef.current;
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('SHOW_GLOBAL_MODAL', ({ message: message, buttons: buttons, isWide: isWide, title: title, type: type })=>{
        if (!isActiveHost()) return;
        setState({
            message: message,
            buttons: buttons || [],
            isWide: isWide,
            title: title,
            type: type || 'modal'
        });
    });
    // Content variant: caller passes a render function (close) => JSX
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('SHOW_GLOBAL_CONTENT_MODAL', (render)=>{
        if (!isActiveHost()) return;
        setState({
            render: render
        });
    });
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('CLOSE_GLOBAL_MODAL', ()=>setState(null));
    if (!state) return null;
    const close = ()=>setState(null);
    if (state.render) return /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $ih19M.jsx)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        onClose: close,
        children: state.render(close)
    }), document.body);
    // Map legacy {title, callback} → ButtonDrawer {title, func}
    // Reverse so confirm (index 0) becomes last (= primary/right in ButtonDrawer)
    const mapped = state.buttons.map((btn)=>({
            title: btn.title,
            func: ()=>{
                btn.callback?.();
                close();
            }
        }));
    const displayButtons = mapped.length > 1 ? [
        ...mapped
    ].reverse() : mapped;
    if (displayButtons.length === 0) displayButtons.push({
        title: 'OK',
        func: close
    });
    const isInfo = state.type === 'information';
    return /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $ih19M.jsxs)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "px-4 pt-4 pb-3 overflow-y-auto max-h-[60vh]",
                children: [
                    state.title && (isInfo ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex items-center gap-1 mb-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)($efcd9c5e78db09db$var$InfoIcon, {}),
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-[16px] font-semibold uppercase leading-6 tracking-[0.32px] text-[#17181a]",
                                children: state.title
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[16px] font-semibold uppercase leading-6 tracking-[0.32px] text-[#17181a] text-center mb-1.5",
                        children: state.title
                    })),
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: `text-[15px] leading-5 text-[#5d5d5f] ${isInfo ? '' : 'text-center'}`,
                        dangerouslySetInnerHTML: {
                            __html: state.message
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: displayButtons,
                modal: true
            })
        ]
    }), document.body);
}





var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");









var $25f6298c295eba2d$exports = {};

$parcel$export($25f6298c295eba2d$exports, "alignStart", function () { return $25f6298c295eba2d$export$144a00ba6044eb9; }, function (v) { return $25f6298c295eba2d$export$144a00ba6044eb9 = v; });
$parcel$export($25f6298c295eba2d$exports, "charIcon", function () { return $25f6298c295eba2d$export$5dd68419f8c7e5a7; }, function (v) { return $25f6298c295eba2d$export$5dd68419f8c7e5a7 = v; });
$parcel$export($25f6298c295eba2d$exports, "departure", function () { return $25f6298c295eba2d$export$f1d7a98679aed61; }, function (v) { return $25f6298c295eba2d$export$f1d7a98679aed61 = v; });
$parcel$export($25f6298c295eba2d$exports, "destination", function () { return $25f6298c295eba2d$export$547cb0ec68beb837; }, function (v) { return $25f6298c295eba2d$export$547cb0ec68beb837 = v; });
$parcel$export($25f6298c295eba2d$exports, "gray", function () { return $25f6298c295eba2d$export$3e2c219d3ab79d01; }, function (v) { return $25f6298c295eba2d$export$3e2c219d3ab79d01 = v; });
$parcel$export($25f6298c295eba2d$exports, "group", function () { return $25f6298c295eba2d$export$e5e25fbcc1f7affe; }, function (v) { return $25f6298c295eba2d$export$e5e25fbcc1f7affe = v; });
$parcel$export($25f6298c295eba2d$exports, "groupContent", function () { return $25f6298c295eba2d$export$d6a271f2cc7855f3; }, function (v) { return $25f6298c295eba2d$export$d6a271f2cc7855f3 = v; });
$parcel$export($25f6298c295eba2d$exports, "groupContentColumn", function () { return $25f6298c295eba2d$export$92f902fc8c9aeaa1; }, function (v) { return $25f6298c295eba2d$export$92f902fc8c9aeaa1 = v; });
$parcel$export($25f6298c295eba2d$exports, "groupContentMainColumn", function () { return $25f6298c295eba2d$export$c2145dc42cfbca09; }, function (v) { return $25f6298c295eba2d$export$c2145dc42cfbca09 = v; });
$parcel$export($25f6298c295eba2d$exports, "groupIcon", function () { return $25f6298c295eba2d$export$e95871dfa811786e; }, function (v) { return $25f6298c295eba2d$export$e95871dfa811786e = v; });
$parcel$export($25f6298c295eba2d$exports, "hasStops", function () { return $25f6298c295eba2d$export$18ea8aa6b72036b5; }, function (v) { return $25f6298c295eba2d$export$18ea8aa6b72036b5 = v; });
$parcel$export($25f6298c295eba2d$exports, "icon", function () { return $25f6298c295eba2d$export$1ca1ec8b29a4ce27; }, function (v) { return $25f6298c295eba2d$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($25f6298c295eba2d$exports, "label", function () { return $25f6298c295eba2d$export$1237798dc640739a; }, function (v) { return $25f6298c295eba2d$export$1237798dc640739a = v; });
$parcel$export($25f6298c295eba2d$exports, "option", function () { return $25f6298c295eba2d$export$a75d1723e6bda2ec; }, function (v) { return $25f6298c295eba2d$export$a75d1723e6bda2ec = v; });
$parcel$export($25f6298c295eba2d$exports, "options", function () { return $25f6298c295eba2d$export$41c562ebe57d11e2; }, function (v) { return $25f6298c295eba2d$export$41c562ebe57d11e2 = v; });
$parcel$export($25f6298c295eba2d$exports, "payment", function () { return $25f6298c295eba2d$export$18f430e15f133060; }, function (v) { return $25f6298c295eba2d$export$18f430e15f133060 = v; });
$parcel$export($25f6298c295eba2d$exports, "paymentType", function () { return $25f6298c295eba2d$export$cf6c01cadfc8fe18; }, function (v) { return $25f6298c295eba2d$export$cf6c01cadfc8fe18 = v; });
$parcel$export($25f6298c295eba2d$exports, "price", function () { return $25f6298c295eba2d$export$321c0b1a406de31f; }, function (v) { return $25f6298c295eba2d$export$321c0b1a406de31f = v; });
$parcel$export($25f6298c295eba2d$exports, "showStops", function () { return $25f6298c295eba2d$export$bd78d4a159817b41; }, function (v) { return $25f6298c295eba2d$export$bd78d4a159817b41 = v; });
$parcel$export($25f6298c295eba2d$exports, "stop", function () { return $25f6298c295eba2d$export$fa6813432f753b0d; }, function (v) { return $25f6298c295eba2d$export$fa6813432f753b0d = v; });
$parcel$export($25f6298c295eba2d$exports, "stops", function () { return $25f6298c295eba2d$export$23813356bdaf66ca; }, function (v) { return $25f6298c295eba2d$export$23813356bdaf66ca = v; });
var $25f6298c295eba2d$export$144a00ba6044eb9;
var $25f6298c295eba2d$export$5dd68419f8c7e5a7;
var $25f6298c295eba2d$export$f1d7a98679aed61;
var $25f6298c295eba2d$export$547cb0ec68beb837;
var $25f6298c295eba2d$export$3e2c219d3ab79d01;
var $25f6298c295eba2d$export$e5e25fbcc1f7affe;
var $25f6298c295eba2d$export$d6a271f2cc7855f3;
var $25f6298c295eba2d$export$92f902fc8c9aeaa1;
var $25f6298c295eba2d$export$c2145dc42cfbca09;
var $25f6298c295eba2d$export$e95871dfa811786e;
var $25f6298c295eba2d$export$18ea8aa6b72036b5;
var $25f6298c295eba2d$export$1ca1ec8b29a4ce27;
var $25f6298c295eba2d$export$1237798dc640739a;
var $25f6298c295eba2d$export$a75d1723e6bda2ec;
var $25f6298c295eba2d$export$41c562ebe57d11e2;
var $25f6298c295eba2d$export$18f430e15f133060;
var $25f6298c295eba2d$export$cf6c01cadfc8fe18;
var $25f6298c295eba2d$export$321c0b1a406de31f;
var $25f6298c295eba2d$export$bd78d4a159817b41;
var $25f6298c295eba2d$export$fa6813432f753b0d;
var $25f6298c295eba2d$export$23813356bdaf66ca;
$25f6298c295eba2d$export$144a00ba6044eb9 = `fXA-ca_alignStart`;
$25f6298c295eba2d$export$5dd68419f8c7e5a7 = `fXA-ca_charIcon`;
$25f6298c295eba2d$export$f1d7a98679aed61 = `fXA-ca_departure`;
$25f6298c295eba2d$export$547cb0ec68beb837 = `fXA-ca_destination`;
$25f6298c295eba2d$export$3e2c219d3ab79d01 = `fXA-ca_gray`;
$25f6298c295eba2d$export$e5e25fbcc1f7affe = `fXA-ca_group`;
$25f6298c295eba2d$export$d6a271f2cc7855f3 = `fXA-ca_groupContent`;
$25f6298c295eba2d$export$92f902fc8c9aeaa1 = `fXA-ca_groupContentColumn`;
$25f6298c295eba2d$export$c2145dc42cfbca09 = `fXA-ca_groupContentMainColumn`;
$25f6298c295eba2d$export$e95871dfa811786e = `fXA-ca_groupIcon`;
$25f6298c295eba2d$export$18ea8aa6b72036b5 = `fXA-ca_hasStops`;
$25f6298c295eba2d$export$1ca1ec8b29a4ce27 = `fXA-ca_icon`;
$25f6298c295eba2d$export$1237798dc640739a = `fXA-ca_label`;
$25f6298c295eba2d$export$a75d1723e6bda2ec = `fXA-ca_option`;
$25f6298c295eba2d$export$41c562ebe57d11e2 = `fXA-ca_options`;
$25f6298c295eba2d$export$18f430e15f133060 = `fXA-ca_payment`;
$25f6298c295eba2d$export$cf6c01cadfc8fe18 = `fXA-ca_paymentType`;
$25f6298c295eba2d$export$321c0b1a406de31f = `fXA-ca_price`;
$25f6298c295eba2d$export$bd78d4a159817b41 = `fXA-ca_showStops`;
$25f6298c295eba2d$export$fa6813432f753b0d = `fXA-ca_stop`;
$25f6298c295eba2d$export$23813356bdaf66ca = `fXA-ca_stops`;





const $e79afbceef721183$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($25f6298c295eba2d$exports);
const $e79afbceef721183$var$formatAddress = (address)=>{
    return address.streetNumber ? address.streetName + ' ' + address.streetNumber : address.streetName;
};
const $e79afbceef721183$var$renderPaymentIcon = (values)=>{
    if (values.payment === 'PayInCar') return /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
        id: "PayInCar"
    });
    else {
        const isCreditCard = values.payment.indexOf('CreditCard') !== -1;
        const icon = isCreditCard ? `Card${values.account.cardType}` : 'TSAB';
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
            id: icon
        });
    }
};
const $e79afbceef721183$var$renderPayment = (values)=>{
    if (values.payment === 'DefaultNoSelect') return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $25f6298c295eba2d$exports.payment,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$c96745152eb2740f, $25f6298c295eba2d$exports.paymentType)
        })
    });
    else if (values.payment === 'PayInCar') return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $25f6298c295eba2d$exports.payment,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
            className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$c96745152eb2740f, $25f6298c295eba2d$exports.paymentType),
            children: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('title-pay-in-car')
        })
    });
    else {
        const isCreditCard = values.payment.indexOf('CreditCard') !== -1;
        const title = isCreditCard ? values.account.maskedAccount : values.account.accountName;
        const subtitle = isCreditCard ? values.account.cardType : values.account.accountNumber;
        const icon = isCreditCard ? `Card${values.account.cardType}` : 'TSAB';
        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
            className: $25f6298c295eba2d$exports.payment,
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$c96745152eb2740f, $25f6298c295eba2d$exports.paymentType),
                    children: title
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $f35967c56a9f3d99$export$c96745152eb2740f,
                    children: [
                        "\xa0(",
                        subtitle,
                        ")"
                    ]
                })
            ]
        });
    }
};
const $e79afbceef721183$var$renderPrice = (values)=>{
    if (!values?.priceEstimate?.prices) return null;
    const price = (0, $c94184dfef1a7d71$export$d723c02cf6cd4e3)(values?.priceEstimate?.prices, values?.serviceType);
    if (!price) return null;
    return `${price}:-`;
};
function $e79afbceef721183$export$2e2bcd8739ae039({ values: values, showHow: showHow = false, showPayment: showPayment = false }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, bookings: bookings } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const { prev: prev } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { setFieldValue: setFieldValue } = (0, $bh6RR.useContext)((0, $lW2XZ.FormikContext)) || {};
    const booking = bookings?.find((item)=>item.id === values.bookingId);
    const hasDeparture = values.departure?.address !== undefined;
    const hasDestination = values.destination?.address !== undefined;
    const fromAddressParts = hasDeparture ? (0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)(values.departure) : null;
    const toAddressParts = hasDestination ? (0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)(values.destination) : null;
    const taxiAndEta = booking ? (0, $c94184dfef1a7d71$export$47c2c83385bd5cef)(booking) : '';
    const time = values.pickupTime ? (0, $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1)(values.pickupTime) : t('label-as-soon-as-possible');
    const showPrice = values.priceEstimate;
    // Label by the intended price type: with a failed estimate we are still on fixed price, not taximeter
    const isFixedPrice = (values.autoValues?.fixedPrice ?? values.fixedPrice) !== false;
    const packages = (0, $200ec6b1b2ca8c5a$export$4671b48bb978508b)(values);
    const hasBooking = !isNaN(values?.bookingId);
    const openEditMessage = ()=>(0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $eb5084cc5eb47e44$export$2e2bcd8739ae039), {
                formValues: values,
                onFieldSave: (id, val)=>setFieldValue?.(id, val, false),
                fields: [
                    {
                        id: 'packageDeliveryInfo.otherInformation',
                        title: t('title-extra-information')
                    }
                ],
                title: t('title-extra-information'),
                onClose: close
            }));
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
        children: /*#__PURE__*/ (0, $ih19M.jsxs)($1ab1ad86cd1cb08e$export$159d9494db57879b, {
            className: $f35967c56a9f3d99$export$a7db06668cad9adb,
            children: [
                hasBooking && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $25f6298c295eba2d$exports.group,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $25f6298c295eba2d$exports.groupContent,
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $25f6298c295eba2d$exports.groupContentColumn,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $25f6298c295eba2d$exports.groupContentMainColumn,
                                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $25f6298c295eba2d$exports.label,
                                        children: t('label-booking-number')
                                    })
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                    children: values.bookingId
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $25f6298c295eba2d$exports.group,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupIcon,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                    id: "Prebooked"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupContent,
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: $25f6298c295eba2d$exports.groupContentColumn,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: $25f6298c295eba2d$exports.groupContentMainColumn,
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$fb184b623420d9be, $f35967c56a9f3d99$export$9a00dee1beb8f576),
                                                    children: time
                                                }),
                                                values.checkedInBaggage && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                    className: $25f6298c295eba2d$exports.options,
                                                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                            transition: {
                                                                duration: .15
                                                            },
                                                            initial: {
                                                                height: 0,
                                                                opacity: 0
                                                            },
                                                            animate: {
                                                                height: 'auto',
                                                                opacity: 1
                                                            },
                                                            exit: {
                                                                height: 0,
                                                                opacity: 0
                                                            },
                                                            className: $25f6298c295eba2d$exports.option,
                                                            children: "Incheckat bagage"
                                                        })
                                                    })
                                                }),
                                                (0, $c94184dfef1a7d71$export$45e40f7bd1bea381)(booking) && taxiAndEta && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                    className: $f35967c56a9f3d99$export$c96745152eb2740f,
                                                    children: [
                                                        taxiAndEta,
                                                        "\xa0"
                                                    ]
                                                })
                                            ]
                                        }),
                                        !hasBooking && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aab55537bcbfd3cb$export$2e2bcd8739ae039), {
                                            onClick: ()=>prev('time')
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$e5e25fbcc1f7affe, {
                        showStops: true
                    }),
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $e79afbceef721183$var$cx($25f6298c295eba2d$exports.content, $25f6298c295eba2d$exports.departure, {
                                    hasStops: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                                        char: "A",
                                        className: $25f6298c295eba2d$exports.charIcon,
                                        small: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                        children: fromAddressParts?.title
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $f35967c56a9f3d99$export$c96745152eb2740f,
                                        children: fromAddressParts?.subtitle
                                    })
                                ]
                            })
                        }),
                        hasDestination && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                className: $e79afbceef721183$var$cx($25f6298c295eba2d$exports.content, $25f6298c295eba2d$exports.destination, {
                                    hasStops: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $2a77dcb101872509$export$2e2bcd8739ae039), {
                                        char: "B",
                                        className: $25f6298c295eba2d$exports.charIcon,
                                        small: true
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                        children: toAddressParts?.title
                                    }),
                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                        className: $f35967c56a9f3d99$export$c96745152eb2740f,
                                        children: toAddressParts?.subtitle
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                        children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $25f6298c295eba2d$exports.group,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $25f6298c295eba2d$exports.groupIcon,
                                    children: $e79afbceef721183$var$renderPaymentIcon(values)
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                    className: $25f6298c295eba2d$exports.groupContent,
                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                        className: $25f6298c295eba2d$exports.groupContentColumn,
                                        children: [
                                            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                                className: $25f6298c295eba2d$exports.groupContentMainColumn,
                                                children: [
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                        className: $e79afbceef721183$var$cx($f35967c56a9f3d99$export$fb184b623420d9be),
                                                        children: isFixedPrice ? t('label-fixed-price') : 'Taxameter'
                                                    }),
                                                    showPayment && /*#__PURE__*/ (0, $ih19M.jsx)((0, $ih19M.Fragment), {
                                                        children: $e79afbceef721183$var$renderPayment(values)
                                                    }),
                                                    /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                        className: $25f6298c295eba2d$exports.options,
                                                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
                                                            children: packages.map((value, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                    transition: {
                                                                        duration: .15
                                                                    },
                                                                    initial: {
                                                                        height: 0,
                                                                        opacity: 0
                                                                    },
                                                                    animate: {
                                                                        height: 'auto',
                                                                        opacity: 1
                                                                    },
                                                                    exit: {
                                                                        height: 0,
                                                                        opacity: 0
                                                                    },
                                                                    className: $25f6298c295eba2d$exports.option,
                                                                    children: (0, $c94184dfef1a7d71$export$60eeeada66bc4067)(value)
                                                                }, index))
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                className: $25f6298c295eba2d$exports.price,
                                                children: $e79afbceef721183$var$renderPrice(values)
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $25f6298c295eba2d$exports.group,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupIcon,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                    id: "Sender"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupContent,
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: $25f6298c295eba2d$exports.groupContentColumn,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: $25f6298c295eba2d$exports.groupContentMainColumn,
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                                    children: values.name
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: $f35967c56a9f3d99$export$c96745152eb2740f,
                                                    children: values.phone
                                                }),
                                                (values.packageDeliveryInfo.packageSender.nameOnDoor || values.packageDeliveryInfo.packageSender.numberOfStairs || values.packageDeliveryInfo.packageSender.doorCode) && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                    className: $25f6298c295eba2d$exports.options,
                                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
                                                        children: [
                                                            values.packageDeliveryInfo.packageSender.nameOnDoor && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                                                        id: "NameOnDoor",
                                                                        small: true
                                                                    }),
                                                                    values.packageDeliveryInfo.packageSender.nameOnDoor
                                                                ]
                                                            }),
                                                            values.packageDeliveryInfo.packageSender.numberOfStairs && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                                                        id: "Stairs",
                                                                        small: true
                                                                    }),
                                                                    values.packageDeliveryInfo.packageSender.numberOfStairs
                                                                ]
                                                            }),
                                                            values.packageDeliveryInfo.packageSender.doorCode && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                                                        id: "Keypad",
                                                                        small: true
                                                                    }),
                                                                    values.packageDeliveryInfo.packageSender.doorCode
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $aab55537bcbfd3cb$export$2e2bcd8739ae039), {
                                            onClick: ()=>prev('sender')
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                values.packageDeliveryInfo.packageReceiver.nameOnDoor && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                    children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $25f6298c295eba2d$exports.group,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupIcon,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                    id: "Receiver"
                                })
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $25f6298c295eba2d$exports.groupContent,
                                children: /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                    className: $25f6298c295eba2d$exports.groupContentColumn,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                                            className: $25f6298c295eba2d$exports.groupContentMainColumn,
                                            children: [
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: $f35967c56a9f3d99$export$fb184b623420d9be,
                                                    children: values.packageDeliveryInfo.packageReceiver.nameOnDoor
                                                }),
                                                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                                    className: $f35967c56a9f3d99$export$c96745152eb2740f,
                                                    children: values.packageDeliveryInfo.packageReceiver.phoneNumber
                                                }),
                                                (values.packageDeliveryInfo.packageReceiver.numberOfStairs || values.packageDeliveryInfo.packageReceiver.doorCode || values.packageDeliveryInfo.packageReceiver.leaveOutsideDoor) && /*#__PURE__*/ (0, $ih19M.jsx)("ul", {
                                                    className: $25f6298c295eba2d$exports.options,
                                                    children: /*#__PURE__*/ (0, $ih19M.jsxs)((0, $86643c55894bf611$export$3ae376d12526dd6f), {
                                                        children: [
                                                            values.packageDeliveryInfo.packageReceiver.numberOfStairs && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                                                        id: "Stairs",
                                                                        small: true
                                                                    }),
                                                                    values.packageDeliveryInfo.packageReceiver.numberOfStairs
                                                                ]
                                                            }),
                                                            values.packageDeliveryInfo.packageReceiver.doorCode && /*#__PURE__*/ (0, $ih19M.jsxs)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                                                                        id: "Keypad",
                                                                        small: true
                                                                    }),
                                                                    values.packageDeliveryInfo.packageReceiver.doorCode
                                                                ]
                                                            }),
                                                            values.packageDeliveryInfo.packageReceiver.leaveOutsideDoor && /*#__PURE__*/ (0, $ih19M.jsx)((0, $08c9f1bffbd2aec7$export$e25e478948902b8b).li, {
                                                                transition: {
                                                                    duration: .15
                                                                },
                                                                initial: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                animate: {
                                                                    height: 'auto',
                                                                    opacity: 1
                                                                },
                                                                exit: {
                                                                    height: 0,
                                                                    opacity: 0
                                                                },
                                                                className: $25f6298c295eba2d$exports.option,
                                                                children: t('title-leave-outside')
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)((0, $aab55537bcbfd3cb$export$2e2bcd8739ae039), {
                                            onClick: ()=>prev('receiver')
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                    className: $f35967c56a9f3d99$export$e5e25fbcc1f7affe,
                    children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $51837c0e5cd1599b$export$2e2bcd8739ae039), {
                        title: t('title-extra-information'),
                        value: values.packageDeliveryInfo?.otherInformation ? values.packageDeliveryInfo.otherInformation : '-',
                        icon: "Message",
                        changeToggle: !hasBooking ? openEditMessage : null
                    })
                })
            ]
        })
    });
}



var $ih19M = parcelRequire("ih19M");


var $1c5e69286bcd4c56$export$4239d699c596afd;
var $1c5e69286bcd4c56$export$637835591193b83f;
$1c5e69286bcd4c56$export$4239d699c596afd = `_0TPBTq_desktop`;
$1c5e69286bcd4c56$export$637835591193b83f = `_0TPBTq_subhead`;



const $7336901c7f9efeed$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($f35967c56a9f3d99$exports);
function $7336901c7f9efeed$export$2e2bcd8739ae039({ values: values }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.group,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: $1c5e69286bcd4c56$export$637835591193b83f,
                        children: "Avs\xe4ndare"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-name')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-phone')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.phone
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-name-on-door')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageSender?.nameOnDoor || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-number-of-stairs')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageSender?.numberOfStairs || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-door-code')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageSender?.doorCode || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('title-extra-information')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo?.otherInformation || '-'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $f35967c56a9f3d99$exports.group,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("h3", {
                        className: $1c5e69286bcd4c56$export$637835591193b83f,
                        children: "Mottagare"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-name-receiver-on-door')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageReceiver.nameOnDoor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-phone')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageReceiver.phoneNumber
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $1c5e69286bcd4c56$export$4239d699c596afd,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: "\xa0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-number-of-stairs')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageReceiver?.numberOfStairs || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('label-door-code')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageReceiver?.doorCode || '-'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $7336901c7f9efeed$var$cx($f35967c56a9f3d99$exports.label, {
                                    gray: true
                                }),
                                children: t('title-leave-outside')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                children: values.packageDeliveryInfo.packageReceiver.leaveOutsideDoor ? t('label-yes') : t('label-no')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");


var $f66eH = parcelRequire("f66eH");


var $944bbfe2f8a74ad4$export$98e628dec113755e;
var $944bbfe2f8a74ad4$export$3e523c77c1f23f8c;
var $944bbfe2f8a74ad4$export$6f093cfa640b7166;
var $944bbfe2f8a74ad4$export$cc74dcc53cfce4eb;
$944bbfe2f8a74ad4$export$98e628dec113755e = `MXSnLG_number`;
$944bbfe2f8a74ad4$export$3e523c77c1f23f8c = `MXSnLG_separator`;
$944bbfe2f8a74ad4$export$6f093cfa640b7166 = `MXSnLG_text`;
$944bbfe2f8a74ad4$export$cc74dcc53cfce4eb = `MXSnLG_wrapper`;


const $a65d0d54e3c9a72a$var$useTimeInput = (initial, min, max)=>{
    const v = (0, $bh6RR.useRef)('');
    const timeout = (0, $bh6RR.useRef)();
    const [time, setTime] = (0, $bh6RR.useState)(initial);
    const clampTime = (value)=>{
        return Math.max(min, Math.min(max, value)).toString();
    };
    const formatTime = (value)=>{
        return value < 10 ? '0' + value : value;
    };
    const setter = (value)=>{
        setTime(formatTime(clampTime(value)));
    };
    const setterDelayed = (value)=>{
        clearTimeout(timeout.current);
        v.current = v.current.length < 2 ? v.current + value : value.toString();
        v.current = clampTime(v.current);
        setTime(formatTime(v.current));
        timeout.current = setTimeout(()=>{
            v.current = '';
            timeout.current = null;
        }, 1000);
    };
    return [
        time,
        setter,
        setterDelayed
    ];
};
const $a65d0d54e3c9a72a$var$getHours = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, (0, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9), 'HH');
const $a65d0d54e3c9a72a$var$getMinutes = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, (0, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9), 'mm');
function $a65d0d54e3c9a72a$export$2e2bcd8739ae039({ selected: selected, onChange: onChange }) {
    const timeout = (0, $bh6RR.useRef)();
    const [hours, setInputHours, setInputHoursDelayed] = $a65d0d54e3c9a72a$var$useTimeInput($a65d0d54e3c9a72a$var$getHours(selected), 0, 23);
    const [minutes, setInputMinutes, setInputMinutesDelayed] = $a65d0d54e3c9a72a$var$useTimeInput($a65d0d54e3c9a72a$var$getMinutes(selected), 0, 59);
    const updateTime = ()=>{
        clearTimeout(timeout.current);
        const dateStr = (0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(selected, (0, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9), 'yyyy-MM-dd');
        const d = (0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(`${dateStr} ${hours}:${minutes}:00`, {
            timeZone: (0, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9)
        });
        if (!(0, $f66eH.default)(selected, d)) onChange(d);
    };
    const onKeyDown = (e)=>{
        const isHours = e.target.id === 'hours';
        // Arrow keys
        if (e.keyCode === 38 || e.keyCode === 40) {
            const increase = e.keyCode === 38;
            e.preventDefault();
            if (isHours) {
                let h = parseInt(hours);
                h = increase ? h + 1 : h - 1;
                if (h > 23) h = 0;
                else if (h < 0) h = 23;
                setInputHours(h);
            } else {
                let m = parseInt(minutes);
                m = increase ? m + 1 : m - 1;
                if (m > 59) m = 0;
                else if (m < 0) m = 59;
                setInputMinutes(m);
            }
        } else {
            const v = parseInt(e.key);
            if (!isNaN(v)) {
                if (isHours) setInputHoursDelayed(v);
                else setInputMinutesDelayed(v);
            }
        }
    };
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        clearTimeout(timeout.current);
        timeout.current = setTimeout(updateTime, 1100);
    }, [
        hours,
        minutes
    ]);
    // Force update if selected date is changed
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        setInputHours($a65d0d54e3c9a72a$var$getHours(selected), true);
        setInputMinutes($a65d0d54e3c9a72a$var$getMinutes(selected), true);
    }, [
        selected
    ]);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $944bbfe2f8a74ad4$export$cc74dcc53cfce4eb,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $944bbfe2f8a74ad4$export$98e628dec113755e,
                id: "hours",
                tabIndex: "0",
                onBlur: updateTime,
                onKeyDown: onKeyDown,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: $944bbfe2f8a74ad4$export$6f093cfa640b7166,
                    children: hours
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $944bbfe2f8a74ad4$export$3e523c77c1f23f8c,
                children: ":"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: $944bbfe2f8a74ad4$export$98e628dec113755e,
                id: "minutes",
                tabIndex: "0",
                onBlur: updateTime,
                onKeyDown: onKeyDown,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: $944bbfe2f8a74ad4$export$6f093cfa640b7166,
                    children: minutes
                })
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");
var $628e4889d055d730$export$e0ec5eae2b039215;
var $628e4889d055d730$export$636cfe6286e3465;
var $628e4889d055d730$export$975a29d98c7283ef;
var $628e4889d055d730$export$2dfc48142fefefdb;
var $628e4889d055d730$export$f59aa6be2711b90;
var $628e4889d055d730$export$a80b3bd66acc52ff;
var $628e4889d055d730$export$321c0b1a406de31f;
var $628e4889d055d730$export$3e523c77c1f23f8c;
var $628e4889d055d730$export$fb184b623420d9be;
$628e4889d055d730$export$e0ec5eae2b039215 = `k5Wh1q_capacity`;
$628e4889d055d730$export$636cfe6286e3465 = `k5Wh1q_capacityNumber`;
$628e4889d055d730$export$975a29d98c7283ef = `k5Wh1q_capacityWrapper`;
$628e4889d055d730$export$2dfc48142fefefdb = `k5Wh1q_disableOption`;
$628e4889d055d730$export$f59aa6be2711b90 = `k5Wh1q_fullWidth`;
$628e4889d055d730$export$a80b3bd66acc52ff = `k5Wh1q_info`;
$628e4889d055d730$export$321c0b1a406de31f = `k5Wh1q_price`;
$628e4889d055d730$export$3e523c77c1f23f8c = `k5Wh1q_separator`;
$628e4889d055d730$export$fb184b623420d9be = `k5Wh1q_title`;


function $7b8c7358b8b86633$export$2e2bcd8739ae039({ title: title, info: info, capacity: capacity, fullWidth: fullWidth, children: children, disabledDescription: disabledDescription, price: price }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: fullWidth ? $628e4889d055d730$export$f59aa6be2711b90 : '',
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: $628e4889d055d730$export$fb184b623420d9be,
                children: [
                    title,
                    capacity && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $628e4889d055d730$export$975a29d98c7283ef,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $628e4889d055d730$export$3e523c77c1f23f8c
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `/app/themes/taxi-stockholm/static/img/option-icons/User.png`,
                                className: $628e4889d055d730$export$e0ec5eae2b039215
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: $628e4889d055d730$export$636cfe6286e3465,
                                children: capacity
                            })
                        ]
                    })
                ]
            }),
            info && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $628e4889d055d730$export$a80b3bd66acc52ff,
                children: info
            }),
            price && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $628e4889d055d730$export$321c0b1a406de31f,
                children: price
            }),
            children,
            disabledDescription && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $628e4889d055d730$export$2dfc48142fefefdb,
                children: disabledDescription
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $c8979054dec486b6$exports = {};

$parcel$export($c8979054dec486b6$exports, "isMultiline", function () { return $c8979054dec486b6$export$9410d0df0e93412a; }, function (v) { return $c8979054dec486b6$export$9410d0df0e93412a = v; });
$parcel$export($c8979054dec486b6$exports, "isVisible", function () { return $c8979054dec486b6$export$795910f5f15a9633; }, function (v) { return $c8979054dec486b6$export$795910f5f15a9633 = v; });
$parcel$export($c8979054dec486b6$exports, "wrapper", function () { return $c8979054dec486b6$export$cc74dcc53cfce4eb; }, function (v) { return $c8979054dec486b6$export$cc74dcc53cfce4eb = v; });
var $c8979054dec486b6$export$9410d0df0e93412a;
var $c8979054dec486b6$export$795910f5f15a9633;
var $c8979054dec486b6$export$cc74dcc53cfce4eb;
$c8979054dec486b6$export$9410d0df0e93412a = `mpun5a_isMultiline`;
$c8979054dec486b6$export$795910f5f15a9633 = `mpun5a_isVisible`;
$c8979054dec486b6$export$cc74dcc53cfce4eb = `mpun5a_wrapper`;


const $00f0005d7186c141$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($c8979054dec486b6$exports);
function $00f0005d7186c141$export$2e2bcd8739ae039({ title: title, isVisible: isVisible, isMultiline: isMultiline }) {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $00f0005d7186c141$var$cx($c8979054dec486b6$exports.wrapper, {
            isVisible: isVisible,
            isMultiline: isMultiline
        }),
        dangerouslySetInnerHTML: {
            __html: title
        }
    });
}




var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $85445a360e20e41e$exports = {};

$parcel$export($85445a360e20e41e$exports, "field", function () { return $85445a360e20e41e$export$e0f35d825088c098; }, function (v) { return $85445a360e20e41e$export$e0f35d825088c098 = v; });
$parcel$export($85445a360e20e41e$exports, "focus-visible", function () { return $85445a360e20e41e$export$f86455e47a9336bd; }, function (v) { return $85445a360e20e41e$export$f86455e47a9336bd = v; });
$parcel$export($85445a360e20e41e$exports, "isChecked", function () { return $85445a360e20e41e$export$ecc98dea0bb74423; }, function (v) { return $85445a360e20e41e$export$ecc98dea0bb74423 = v; });
$parcel$export($85445a360e20e41e$exports, "label", function () { return $85445a360e20e41e$export$1237798dc640739a; }, function (v) { return $85445a360e20e41e$export$1237798dc640739a = v; });
$parcel$export($85445a360e20e41e$exports, "wrapper", function () { return $85445a360e20e41e$export$cc74dcc53cfce4eb; }, function (v) { return $85445a360e20e41e$export$cc74dcc53cfce4eb = v; });
var $85445a360e20e41e$export$e0f35d825088c098;
var $85445a360e20e41e$export$f86455e47a9336bd;
var $85445a360e20e41e$export$ecc98dea0bb74423;
var $85445a360e20e41e$export$1237798dc640739a;
var $85445a360e20e41e$export$cc74dcc53cfce4eb;
$85445a360e20e41e$export$e0f35d825088c098 = `_3m1d2q_field`;
$85445a360e20e41e$export$f86455e47a9336bd = `_3m1d2q_focus-visible`;
$85445a360e20e41e$export$ecc98dea0bb74423 = `_3m1d2q_isChecked`;
$85445a360e20e41e$export$1237798dc640739a = `_3m1d2q_label`;
$85445a360e20e41e$export$cc74dcc53cfce4eb = `_3m1d2q_wrapper`;


const $582402ece63dbe0f$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($85445a360e20e41e$exports);
function $582402ece63dbe0f$export$2e2bcd8739ae039({ isChecked: isChecked, name: name, field: field, form: form, onChange: onChange, onBlur: onBlur, innerRef: innerRef, ...props }) {
    const inputRef = (0, $bh6RR.useRef)();
    const onKeyDown = (e)=>{
        if (e.keyCode === 32) e.preventDefault();
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 32) {
            e.preventDefault();
            inputRef?.current?.click();
            if (props.onClick) props.onClick();
        }
    };
    const handleChange = (e)=>{
        onChange(e);
        form.setFieldTouched(name, true, false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $85445a360e20e41e$exports.wrapper,
        children: /*#__PURE__*/ (0, $ih19M.jsx)("label", {
            ref: innerRef,
            tabIndex: props?.disabled ? -1 : props?.tabIndex,
            className: $582402ece63dbe0f$var$cx($85445a360e20e41e$exports.label, {
                isChecked: isChecked
            }),
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                type: "checkbox",
                as: "input",
                innerRef: inputRef,
                className: $85445a360e20e41e$exports.field,
                name: name,
                onChange: handleChange,
                onBlur: onBlur,
                ...props,
                tabIndex: "-1"
            })
        })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");

var $13c19d8e73d3ecfc$exports = {};

$parcel$export($13c19d8e73d3ecfc$exports, "checkbox", function () { return $13c19d8e73d3ecfc$export$b07e517d22efa1ca; }, function (v) { return $13c19d8e73d3ecfc$export$b07e517d22efa1ca = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "field", function () { return $13c19d8e73d3ecfc$export$e0f35d825088c098; }, function (v) { return $13c19d8e73d3ecfc$export$e0f35d825088c098 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "focus-visible", function () { return $13c19d8e73d3ecfc$export$f86455e47a9336bd; }, function (v) { return $13c19d8e73d3ecfc$export$f86455e47a9336bd = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "icon", function () { return $13c19d8e73d3ecfc$export$1ca1ec8b29a4ce27; }, function (v) { return $13c19d8e73d3ecfc$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "isChecked", function () { return $13c19d8e73d3ecfc$export$ecc98dea0bb74423; }, function (v) { return $13c19d8e73d3ecfc$export$ecc98dea0bb74423 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "isDisabled", function () { return $13c19d8e73d3ecfc$export$30e0dc115df457ed; }, function (v) { return $13c19d8e73d3ecfc$export$30e0dc115df457ed = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "isIcon", function () { return $13c19d8e73d3ecfc$export$227e6c309f2b678; }, function (v) { return $13c19d8e73d3ecfc$export$227e6c309f2b678 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "label", function () { return $13c19d8e73d3ecfc$export$1237798dc640739a; }, function (v) { return $13c19d8e73d3ecfc$export$1237798dc640739a = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "optionLabel", function () { return $13c19d8e73d3ecfc$export$245ad05b0468ea5e; }, function (v) { return $13c19d8e73d3ecfc$export$245ad05b0468ea5e = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "spinner", function () { return $13c19d8e73d3ecfc$export$641374ffb95bc399; }, function (v) { return $13c19d8e73d3ecfc$export$641374ffb95bc399 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "toggle", function () { return $13c19d8e73d3ecfc$export$e03c1c3201ee8bb7; }, function (v) { return $13c19d8e73d3ecfc$export$e03c1c3201ee8bb7 = v; });
$parcel$export($13c19d8e73d3ecfc$exports, "wrapper", function () { return $13c19d8e73d3ecfc$export$cc74dcc53cfce4eb; }, function (v) { return $13c19d8e73d3ecfc$export$cc74dcc53cfce4eb = v; });
var $13c19d8e73d3ecfc$export$b07e517d22efa1ca;
var $13c19d8e73d3ecfc$export$e0f35d825088c098;
var $13c19d8e73d3ecfc$export$f86455e47a9336bd;
var $13c19d8e73d3ecfc$export$1ca1ec8b29a4ce27;
var $13c19d8e73d3ecfc$export$ecc98dea0bb74423;
var $13c19d8e73d3ecfc$export$30e0dc115df457ed;
var $13c19d8e73d3ecfc$export$227e6c309f2b678;
var $13c19d8e73d3ecfc$export$1237798dc640739a;
var $13c19d8e73d3ecfc$export$245ad05b0468ea5e;
var $13c19d8e73d3ecfc$export$641374ffb95bc399;
var $13c19d8e73d3ecfc$export$e03c1c3201ee8bb7;
var $13c19d8e73d3ecfc$export$cc74dcc53cfce4eb;
$13c19d8e73d3ecfc$export$b07e517d22efa1ca = `TAe9RG_checkbox`;
$13c19d8e73d3ecfc$export$e0f35d825088c098 = `TAe9RG_field`;
$13c19d8e73d3ecfc$export$f86455e47a9336bd = `TAe9RG_focus-visible`;
$13c19d8e73d3ecfc$export$1ca1ec8b29a4ce27 = `TAe9RG_icon`;
$13c19d8e73d3ecfc$export$ecc98dea0bb74423 = `TAe9RG_isChecked`;
$13c19d8e73d3ecfc$export$30e0dc115df457ed = `TAe9RG_isDisabled`;
$13c19d8e73d3ecfc$export$227e6c309f2b678 = `TAe9RG_isIcon`;
$13c19d8e73d3ecfc$export$1237798dc640739a = `TAe9RG_label`;
$13c19d8e73d3ecfc$export$245ad05b0468ea5e = `TAe9RG_optionLabel`;
$13c19d8e73d3ecfc$export$641374ffb95bc399 = `TAe9RG_spinner`;
$13c19d8e73d3ecfc$export$e03c1c3201ee8bb7 = `TAe9RG_toggle`;
$13c19d8e73d3ecfc$export$cc74dcc53cfce4eb = `TAe9RG_wrapper`;



const $70c3f2f6772c0dac$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($0d0e6f732666edae$exports))).bind($13c19d8e73d3ecfc$exports);
function $70c3f2f6772c0dac$export$2e2bcd8739ae039({ isChecked: isChecked, option1: option1, option2: option2, icon1: icon1, icon2: icon2, showSpinner: showSpinner, name: name, field: field, form: form, onChange: onChange, onBlur: onBlur, innerRef: innerRef, ...props }) {
    const inputRef = (0, $bh6RR.useRef)();
    const onKeyDown = (e)=>{
        if (e.keyCode === 32) e.preventDefault();
    };
    const onKeyUp = (e)=>{
        if (e.keyCode === 32) {
            e.preventDefault();
            inputRef?.current?.click();
            if (props.onClick) props.onClick();
        }
    };
    const handleChange = (e)=>{
        onChange(e);
        form.setFieldTouched(name, true, false);
    };
    const option1ChekckedPrintout = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            option1,
            " ",
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.checkbox, {
                    isChecked: true
                })
            })
        ]
    });
    const option1Printout = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            option1,
            " ",
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.checkbox, {
                    isChecked: false
                })
            })
        ]
    });
    const option2ChekckedPrintout = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            option2,
            " ",
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.checkbox, {
                    isChecked: true
                })
            })
        ]
    });
    const option2Printout = /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            option2,
            " ",
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.checkbox, {
                    isChecked: false
                })
            })
        ]
    });
    const iconSwitch = icon1 && icon2;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.wrapper, {
            isIcon: icon1 && icon2
        }),
        children: [
            iconSwitch && /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                ref: innerRef,
                tabIndex: props?.disabled ? -1 : props?.tabIndex,
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.label, {
                    isChecked: isChecked
                }),
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: $13c19d8e73d3ecfc$exports.optionLabel,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon1}.png`,
                            className: $13c19d8e73d3ecfc$exports.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: $13c19d8e73d3ecfc$exports.optionLabel,
                        children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                            src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon2}.png`,
                            className: $13c19d8e73d3ecfc$exports.icon
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.toggle, {
                            isIcon: true
                        }),
                        children: [
                            isChecked ? icon2 ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon2}Filled.png`,
                                className: $13c19d8e73d3ecfc$exports.icon
                            }) : '' : icon1 ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon1}Filled.png`,
                                className: $13c19d8e73d3ecfc$exports.icon
                            }) : '',
                            showSpinner && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $13c19d8e73d3ecfc$exports.spinner,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "checkbox",
                        as: "input",
                        innerRef: inputRef,
                        className: $13c19d8e73d3ecfc$exports.field,
                        name: name,
                        onChange: handleChange,
                        onBlur: onBlur,
                        ...props,
                        tabIndex: "-1"
                    })
                ]
            }),
            !iconSwitch && /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                ref: innerRef,
                tabIndex: props?.disabled ? -1 : props?.tabIndex,
                className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.label, {
                    isChecked: isChecked
                }),
                onKeyDown: onKeyDown,
                onKeyUp: onKeyUp,
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.optionLabel, {
                            isDisabled: props?.disabled
                        }),
                        children: option1Printout
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: $70c3f2f6772c0dac$var$cx($13c19d8e73d3ecfc$exports.optionLabel, {
                            isDisabled: props?.disabled
                        }),
                        children: option2Printout
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $13c19d8e73d3ecfc$exports.toggle,
                        children: [
                            isChecked ? option2 ? option2ChekckedPrintout : icon2 ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon2}Filled.png`,
                                className: $13c19d8e73d3ecfc$exports.icon
                            }) : '' : option1 ? option1ChekckedPrintout : icon1 ? /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                src: `/app/themes/taxi-stockholm/static/img/option-icons/${icon1}Filled.png`,
                                className: $13c19d8e73d3ecfc$exports.icon
                            }) : '',
                            showSpinner && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $13c19d8e73d3ecfc$exports.spinner,
                                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {
                                    light: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                        type: "checkbox",
                        as: "input",
                        innerRef: inputRef,
                        className: $13c19d8e73d3ecfc$exports.field,
                        name: name,
                        onChange: handleChange,
                        onBlur: onBlur,
                        ...props,
                        tabIndex: "-1"
                    })
                ]
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=52-1113
// Figma component name: PriceToggle
// Replaces: TwoOptionField + TwoOptionSwitch for the fixedPrice field in SelectHow

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");
// Radiobutton indicator — matches Figma Radiobutton component (node 52:1061 / 52:1063)
function $f0b83ec70997a01f$var$RadioIcon({ selected: selected }) {
    if (selected) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M7.5 12l3 3 5.5-6",
                stroke: "#17181a",
                strokeWidth: "1.8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "12",
            cy: "12",
            r: "10.5",
            stroke: "#8c8c8c",
            strokeWidth: "1"
        })
    });
}
function $f0b83ec70997a01f$export$2e2bcd8739ae039({ field: field, form: form, disabled: disabled, children: children }) {
    const isFixed = Boolean(field.value);
    const handleSelect = (selectFixed)=>{
        if (disabled) return;
        form.setFieldValue(field.name, selectFixed);
        form.setFieldTouched(field.name, true, false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex flex-col gap-1 w-full",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('relative flex h-9 w-full items-center rounded-button border-solid border-[0.5px] border-outline overflow-hidden', disabled ? 'bg-on-surface-variant/[0.08]' : 'bg-[#f2f2f2]'),
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('absolute top-0 left-0 h-full w-1/2 rounded-button bg-primary', 'transition-transform duration-200 ease-in-out', !isFixed && 'translate-x-full')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                        type: "button",
                        onClick: ()=>handleSelect(true),
                        disabled: disabled,
                        "aria-pressed": isFixed,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('relative z-10 flex flex-1 h-full items-center justify-center gap-2 px-6 rounded-button', 'text-[17px] font-medium tracking-[-0.34px] leading-[22px] whitespace-nowrap', 'transition-colors duration-200', isFixed ? 'text-on-primary' : 'text-on-surface-variant', !isFixed && disabled && 'opacity-[0.38]'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                children: "Fixed price"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)($f0b83ec70997a01f$var$RadioIcon, {
                                selected: isFixed
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                        type: "button",
                        onClick: ()=>handleSelect(false),
                        disabled: disabled,
                        "aria-pressed": !isFixed,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('relative z-10 flex flex-1 h-full items-center justify-center gap-2 px-6 rounded-button', 'text-[17px] font-medium tracking-[-0.34px] leading-[22px] whitespace-nowrap', 'transition-colors duration-200', !isFixed ? 'text-on-primary' : 'text-on-surface-variant', isFixed && disabled && 'opacity-[0.38]'),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                children: "Taxameter"
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)($f0b83ec70997a01f$var$RadioIcon, {
                                selected: !isFixed
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=414-9993
// Figma component name: TripType
// Replaces: IconSwitch for the isCompanyTrip field in SelectHow

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");
// Person icon — filled black when selected, gray outline when not
function $e03c7e0a8499a421$var$PersonIcon({ selected: selected }) {
    if (selected) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z",
                fill: "#17181A",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z",
                fill: "#17181A",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z",
                stroke: "#5D5D5F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z",
                stroke: "#5D5D5F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
// Company/briefcase icon — filled black when selected, gray outline when not
function $e03c7e0a8499a421$var$CompanyIcon({ selected: selected }) {
    if (selected) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M1.66667 8.5C1.66667 7.56658 1.66667 7.09987 1.84832 6.74335C2.00811 6.42975 2.26308 6.17478 2.57668 6.01499C2.9332 5.83333 3.39991 5.83333 4.33333 5.83333H15.6667C16.6001 5.83333 17.0668 5.83333 17.4233 6.01499C17.7369 6.17478 17.9919 6.42975 18.1517 6.74335C18.3333 7.09987 18.3333 7.56658 18.3333 8.5V14.8333C18.3333 15.7668 18.3333 16.2335 18.1517 16.59C17.9919 16.9036 17.7369 17.1586 17.4233 17.3183C17.0668 17.5 16.6001 17.5 15.6667 17.5H4.33333C3.39991 17.5 2.9332 17.5 2.57668 17.3183C2.26308 17.1586 2.00811 16.9036 1.84832 16.59C1.66667 16.2335 1.66667 15.7668 1.66667 14.8333V8.5Z",
                fill: "#17181A",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M13.3333 5.83333C13.3333 5.05836 13.3333 4.67087 13.2481 4.35295C13.017 3.49022 12.3431 2.81635 11.4804 2.58519C11.1625 2.5 10.775 2.5 10 2.5C9.22502 2.5 8.83754 2.5 8.51962 2.58519C7.65689 2.81635 6.98302 3.49022 6.75185 4.35295C6.66667 4.67087 6.66667 5.05836 6.66667 5.83333",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M13.3333 5.83333C13.3333 5.05836 13.3333 4.67087 13.2481 4.35295C13.017 3.49022 12.3431 2.81635 11.4804 2.58519C11.1625 2.5 10.775 2.5 10 2.5C9.22502 2.5 8.83754 2.5 8.51962 2.58519C7.65689 2.81635 6.98302 3.49022 6.75185 4.35295C6.66667 4.67087 6.66667 5.05836 6.66667 5.83333M4.33333 17.5H15.6667C16.6001 17.5 17.0668 17.5 17.4233 17.3183C17.7369 17.1586 17.9919 16.9036 18.1517 16.59C18.3333 16.2335 18.3333 15.7668 18.3333 14.8333V8.5C18.3333 7.56658 18.3333 7.09987 18.1517 6.74335C17.9919 6.42975 17.7369 6.17478 17.4233 6.01499C17.0668 5.83333 16.6001 5.83333 15.6667 5.83333H4.33333C3.39991 5.83333 2.9332 5.83333 2.57668 6.01499C2.26308 6.17478 2.00811 6.42975 1.84832 6.74335C1.66667 7.09987 1.66667 7.56658 1.66667 8.5V14.8333C1.66667 15.7668 1.66667 16.2335 1.84832 16.59C2.00811 16.9036 2.26308 17.1586 2.57668 17.3183C2.9332 17.5 3.39991 17.5 4.33333 17.5Z",
            stroke: "#5D5D5F",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $e03c7e0a8499a421$export$2e2bcd8739ae039({ field: field, form: form, title: title, info: info, disabled: disabled }) {
    const isCompany = Boolean(field.value);
    const handleSelect = (selectCompany)=>{
        if (disabled) return;
        form.setFieldValue(field.name, selectCompany);
        form.setFieldTouched(field.name, true, false);
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex items-center w-full py-3', disabled && 'opacity-50 pointer-events-none'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-col gap-1 flex-1 min-w-0",
                children: [
                    title && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[16px] font-semibold uppercase tracking-[0.32px] leading-6 text-on-surface whitespace-nowrap",
                        children: title
                    }),
                    info && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: info
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "relative inline-flex items-center rounded-[24px] border-solid border-[0.5px] border-outline bg-[#fafafa] shrink-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        "aria-hidden": "true",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('absolute top-0 left-0 w-12 h-12 rounded-full', 'bg-secondary-container border-solid border-[0.5px] border-secondary', 'transition-transform duration-200 ease-in-out', isCompany && 'translate-x-full')
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleSelect(false),
                        disabled: disabled,
                        "aria-pressed": !isCompany,
                        "aria-label": "Private trip",
                        className: "relative z-10 flex w-12 h-12 items-center justify-center rounded-full shrink-0",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($e03c7e0a8499a421$var$PersonIcon, {
                            selected: !isCompany
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                        type: "button",
                        onClick: ()=>handleSelect(true),
                        disabled: disabled,
                        "aria-pressed": isCompany,
                        "aria-label": "Company trip",
                        className: "relative z-10 flex w-12 h-12 items-center justify-center rounded-full shrink-0",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)($e03c7e0a8499a421$var$CompanyIcon, {
                            selected: isCompany
                        })
                    })
                ]
            })
        ]
    });
}



// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=1433-21737
// Component: addButton — outlined pill button with plus icon

var $ih19M = parcelRequire("ih19M");
function $25ea23ed8632858c$export$2e2bcd8739ae039({ label: label, onClick: onClick, tabIndex: tabIndex, disabled: disabled }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
        type: "button",
        onClick: onClick,
        tabIndex: tabIndex,
        disabled: disabled,
        className: "inline-flex items-center gap-3 px-3 py-2 rounded-button border-[1.5px] border-solid border-on-surface text-[15px] font-medium leading-5 text-on-surface whitespace-nowrap transition-colors duration-200 hover:bg-black/[0.04] focus-visible:bg-black/[0.12] disabled:opacity-[0.38] disabled:pointer-events-none",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                width: "11",
                height: "11",
                viewBox: "0 0 11 11",
                fill: "none",
                "aria-hidden": "true",
                className: "shrink-0",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                    d: "M5.5 1V10M1 5.5H10",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    strokeLinecap: "round"
                })
            }),
            label
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3276-56737
// Component: PaymentReference
// States: normal | disabled (opacity-38) | required-error (red subtitle + pencil always shown)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

function $2ca492d729f5176c$export$2e2bcd8739ae039({ title: title, value: value, disabled: disabled, required: required, empty: empty, onEdit: onEdit }) {
    const hasError = required && empty;
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                    src: `/app/themes/${theme}/static/img/option-icons/Reference.png`,
                    alt: "",
                    className: "size-full object-contain"
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: title
                    }),
                    value && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('text-[15px] leading-5', hasError ? 'text-[#cc2312]' : 'text-on-surface-variant'),
                        children: value
                    })
                ]
            }),
            onEdit && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onEdit,
                className: "shrink-0 p-2 -mr-2",
                "aria-label": "Edit reference",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "pen"
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3265-55566
// Component: SveaPartner (mapped to PartnerContact)
// Variants:
//   type="contact" (default) — booking summary row: logo | name + email/phone | call button
//   type="option"            — selection list row:  logo | name + subtitle | price + radio

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

function $35bcf1734d1aebd2$var$PartnerLogo({ providerId: providerId }) {
    const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm';
    const src = providerId === 'TSAB' ? `/app/themes/${theme}/static/img/logo.png` : `/app/themes/${theme}/static/img/logo-allians.png`;
    return /*#__PURE__*/ (0, $ih19M.jsx)("img", {
        src: src,
        alt: "",
        className: "size-8 object-contain"
    });
}
function $35bcf1734d1aebd2$var$PhoneIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M6.2528 5.50015C6.84173 5.50022 7.48958 6.14708 7.75475 6.41226C8.01982 6.67733 9.19825 8.0917 9.37487 8.85757C9.50276 9.41322 8.85517 10.3101 8.40026 10.9406C8.22821 11.179 8.08411 11.3796 8.0194 11.5089C7.78765 11.9723 8.21478 13.0202 9.60729 14.3927C10.9992 15.7646 12.0265 16.2118 12.4901 15.9806C12.6195 15.9159 12.82 15.7708 13.0585 15.5988C13.689 15.1438 14.5868 14.497 15.1424 14.6251C15.9083 14.8021 17.3215 15.979 17.5868 16.2443C17.8518 16.5093 18.5 17.1581 18.4999 17.7472C18.4992 18.3302 17.2885 19.4317 17.2626 19.4552C17.2626 19.4552 15.5535 20.9283 13.0204 20.0451C10.8303 19.2814 9.368 18.3961 7.48522 16.5138C5.60711 14.6361 4.72036 13.1775 3.95397 10.9796C3.0746 8.45769 4.53084 6.75257 4.54381 6.73745C4.54381 6.73745 5.66364 5.50025 6.2528 5.50015ZM19.1923 4.00894C19.4711 4.00961 19.6111 4.01018 19.7176 4.0646C19.8113 4.11249 19.8876 4.18871 19.9354 4.28238C19.9897 4.3889 19.9904 4.52824 19.9911 4.80679L19.9999 9.57046C20.0004 9.80295 19.9998 9.91936 19.9745 10.0148C19.9057 10.2736 19.7046 10.476 19.4462 10.546C19.3508 10.5718 19.2343 10.5728 19.0018 10.5734C18.7693 10.574 18.6529 10.5733 18.5575 10.548C18.2987 10.4792 18.0963 10.2781 18.0262 10.0197C18.0005 9.92437 18.0004 9.80784 17.9999 9.57534V8.37905L18.0233 7.3898L14.201 11.213C14.0369 11.3772 13.9545 11.4596 13.869 11.5089C13.637 11.6428 13.351 11.6428 13.119 11.5089C13.0335 11.4596 12.9513 11.3773 12.787 11.213C12.6228 11.0489 12.5405 10.9664 12.4911 10.881C12.3572 10.6491 12.3573 10.363 12.4911 10.131C12.5404 10.0455 12.6226 9.9624 12.787 9.798L16.6092 5.97573L15.62 6.00015H14.4247C14.1923 5.99959 14.0756 5.99954 13.9803 5.97378C13.7218 5.90384 13.5199 5.70133 13.451 5.44253C13.4257 5.34714 13.4261 5.23048 13.4266 4.9982C13.4272 4.76579 13.4272 4.64915 13.453 4.55386C13.523 4.29521 13.7262 4.09329 13.9852 4.02456C14.0806 3.99932 14.1973 3.99959 14.4296 4.00015L19.1923 4.00894Z",
            fill: "#17181A"
        })
    });
}
// Matches RadioIcon in CarRadioField (Figma node 52:1061 / 52:1063)
function $35bcf1734d1aebd2$var$RadioIcon({ selected: selected }) {
    if (selected) return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                fill: "#FFCC00"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                x: "0.25",
                y: "0.25",
                width: "21.5",
                height: "21.5",
                rx: "10.75",
                stroke: "#BA8200",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.1404 6.74141C16.3176 6.88535 16.4061 6.95732 16.4635 7.03588C16.6206 7.25109 16.6517 7.53347 16.5452 7.77772C16.5064 7.86689 16.4356 7.95642 16.294 8.13548L10.6357 15.2931C10.4676 15.5057 10.3836 15.6121 10.2776 15.6621C10.1843 15.7062 10.0797 15.7203 9.97813 15.7026C9.86267 15.6825 9.75339 15.6023 9.53484 15.4419L5.92882 12.7955C5.73218 12.6512 5.63385 12.579 5.57038 12.4981C5.40396 12.2859 5.36426 12.0007 5.46639 11.7512C5.50535 11.656 5.58023 11.5597 5.72998 11.3672C5.87077 11.1862 5.94116 11.0957 6.01956 11.0362C6.2248 10.8806 6.49554 10.8411 6.73664 10.9317C6.82875 10.9664 6.92204 11.033 7.10862 11.1664L9.8395 13.1178L14.7258 6.89943C14.8706 6.71509 14.943 6.62293 15.0224 6.56357C15.2401 6.40085 15.5287 6.36861 15.7769 6.47929C15.8675 6.51967 15.9585 6.59358 16.1404 6.74141Z",
                fill: "#17181A"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "22",
        height: "22",
        viewBox: "0 0 22 22",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
            cx: "11",
            cy: "11",
            r: "10.5",
            stroke: "#8c8c8c",
            strokeWidth: "1"
        })
    });
}
function $35bcf1734d1aebd2$export$2e2bcd8739ae039({ type: type = 'contact', providerId: providerId, name: name, phone: phone, displayPhone: displayPhone, email: email, subtitle: subtitle, price: price, originalPrice: originalPrice, priceLoading: priceLoading, selected: selected, onClick: onClick, disabled: disabled }) {
    const isOption = type === 'option';
    const telHref = phone ? `tel:${phone}` : null;
    if (isOption) return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        onClick: onClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex items-center gap-3 py-3 w-full', onClick && 'cursor-pointer', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($35bcf1734d1aebd2$var$PartnerLogo, {
                    providerId: providerId
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: name
                    }),
                    subtitle && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex items-center gap-2 shrink-0",
                children: [
                    priceLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "shrink-0"
                    }) : price ? /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-col items-end",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[17px] font-semibold uppercase tracking-[0.68px] leading-[22px] text-on-surface whitespace-nowrap",
                                children: price
                            }),
                            originalPrice && /*#__PURE__*/ (0, $ih19M.jsx)("s", {
                                className: "text-[15px] leading-5 text-on-surface-variant",
                                children: originalPrice
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $ih19M.jsxs)("label", {
                        className: "cursor-pointer",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)($35bcf1734d1aebd2$var$RadioIcon, {
                                selected: selected
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                type: "radio",
                                className: "sr-only",
                                name: "selectedProviderId",
                                checked: selected,
                                onChange: onClick
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($35bcf1734d1aebd2$var$PartnerLogo, {
                    providerId: providerId
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: name
                    }),
                    displayPhone && (telHref ? /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                        href: telHref,
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: displayPhone
                    }) : /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: displayPhone
                    })),
                    email && /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                        href: `mailto:${email}`,
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: email
                    })
                ]
            }),
            telHref && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("a", {
                href: telHref,
                className: "shrink-0 p-2 -mr-2",
                "aria-label": `Ring ${name}`,
                children: /*#__PURE__*/ (0, $ih19M.jsx)($35bcf1734d1aebd2$var$PhoneIcon, {})
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3288-56789
// Component: MessageToDriver
// States: normal | disabled (opacity-38)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");


function $f638b72bf31980aa$var$MessageIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "24",
        height: "17",
        viewBox: "0 0 24 17",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16.5 10C17.3284 10 18 9.32843 18 8.5C18 7.67157 17.3284 7 16.5 7C15.6716 7 15 7.67157 15 8.5C15 9.32843 15.6716 10 16.5 10Z",
                fill: "#17181A"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M13.5 8.5C13.5 9.32843 12.8284 10 12 10C11.1716 10 10.5 9.32843 10.5 8.5C10.5 7.67157 11.1716 7 12 7C12.8284 7 13.5 7.67157 13.5 8.5Z",
                fill: "#17181A"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M7.5 10C8.32843 10 9 9.32843 9 8.5C9 7.67157 8.32843 7 7.5 7C6.67157 7 6 7.67157 6 8.5C6 9.32843 6.67157 10 7.5 10Z",
                fill: "#17181A"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17H21.5C22.8807 17 24 15.8807 24 14.5V8.5C24 3.80558 20.1944 0 15.5 0H8.5ZM2 8.5C2 4.91015 4.91015 2 8.5 2H15.5C19.0899 2 22 4.91015 22 8.5V14.5C22 14.7761 21.7761 15 21.5 15H8.5C4.91015 15 2 12.0899 2 8.5Z",
                fill: "#17181A"
            })
        ]
    });
}
function $f638b72bf31980aa$export$2e2bcd8739ae039({ message: message, onEdit: onEdit, disabled: disabled }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($f638b72bf31980aa$var$MessageIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: t('title-message-to-driver')
                    }),
                    message && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: message
                    })
                ]
            }),
            onEdit && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onEdit,
                className: "shrink-0 p-2 -mr-2",
                "aria-label": t('title-message-to-driver'),
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "pen"
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3265-56508
// Component: PassengerInfo
// Shows passenger name + phone number with optional edit button
// States: normal | disabled (opacity-38)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

function $52bbc20651dec586$var$UserIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
function $52bbc20651dec586$export$2e2bcd8739ae039({ name: name, phone: phone, onEdit: onEdit, disabled: disabled }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($52bbc20651dec586$var$UserIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: name
                    }),
                    phone && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: phone
                    })
                ]
            }),
            onEdit && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onEdit,
                className: "shrink-0 p-2 -mr-2",
                "aria-label": "Redigera passagerarinformation",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "pen"
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=15266-472354
// Shows traveler count from a booking (traveler.travelerCount)

var $ih19M = parcelRequire("ih19M");

function $969fbb1ccfb19bd7$var$UsersIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "9",
                cy: "7",
                r: "4",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M22 21v-2a4 4 0 0 0-3-3.87",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M15 3.13a4 4 0 0 1 0 7.75",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
function $969fbb1ccfb19bd7$export$2e2bcd8739ae039({ count: count }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    if (!count || count < 1) return null;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex gap-3 items-center py-3 w-full",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)($969fbb1ccfb19bd7$var$UsersIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex-1 min-w-0",
                children: /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                    className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                    children: t('label-passenger-count', {
                        count: count
                    })
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=1480-23229
// Component: SelectedCar
// Shows the selected car type with optional options as pills and an edit button
// States: normal | disabled (opacity-38)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");



function $fe0b386f10b85dbf$export$2e2bcd8739ae039({ serviceType: serviceType, options: options, onEdit: onEdit, disabled: disabled }) {
    const carType = (0, $c94184dfef1a7d71$export$80d7df4f587449e4)(serviceType);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 overflow-hidden flex items-center justify-center",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                    id: serviceType
                })
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: carType?.title
                    }),
                    options?.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "flex gap-1 flex-wrap mt-0.5",
                        children: options.map((option, index)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: option,
                                type: "user-choice"
                            }, index))
                    })
                ]
            }),
            onEdit && !disabled && /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                type: "button",
                onClick: onEdit,
                className: "shrink-0 p-2 -mr-2",
                "aria-label": "\xc4ndra biltyp",
                children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $0e69d829785fe9a1$export$2e2bcd8739ae039), {
                    id: "pen"
                })
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3228-31672
// Component: SelectedPayment
// Shows the selected payment method with icon, title, subtitle, price and optional voucher pills
// States: normal | disabled (opacity-38)
// Variants: fixed price (shows price + ⓘ) | taximeter (no price)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");



function $6b32edab973d0099$var$InfoIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7.25",
                stroke: "#17181A",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M8 7v5",
                stroke: "#17181A",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("circle", {
                cx: "8",
                cy: "4.5",
                r: "1",
                fill: "#17181A"
            })
        ]
    });
}
function $6b32edab973d0099$export$2e2bcd8739ae039({ icon: icon, title: title, subtitle: subtitle, priceLabel: priceLabel, price: price, priceLoading: priceLoading, voucherPills: voucherPills, onInfo: onInfo, disabled: disabled }) {
    const isFixedPrice = Boolean(price);
    const hasReducedPrice = isFixedPrice && price.finalPrice !== price.fullPrice;
    const showPriceArea = isFixedPrice || priceLoading;
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex flex-col w-full py-3', disabled && 'opacity-[0.38]'),
        children: [
            isFixedPrice && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "flex justify-end mb-0.5",
                children: onInfo ? /*#__PURE__*/ (0, $ih19M.jsx)("button", {
                    type: "button",
                    onClick: onInfo,
                    className: "p-0.5 -mr-0.5",
                    "aria-label": "Prisinformation",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)($6b32edab973d0099$var$InfoIcon, {})
                }) : /*#__PURE__*/ (0, $ih19M.jsx)($6b32edab973d0099$var$InfoIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex gap-3 items-center w-full",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "shrink-0 size-11 flex items-center justify-center",
                        children: /*#__PURE__*/ (0, $ih19M.jsx)((0, $19c1cf018e73b338$export$2e2bcd8739ae039), {
                            id: icon
                        })
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex-1 flex flex-col items-start min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[15px] leading-5 text-on-surface-variant",
                                children: subtitle
                            }),
                            priceLabel && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                className: "text-[15px] leading-5 text-on-surface-variant",
                                children: priceLabel
                            }),
                            voucherPills?.length > 0 && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: "flex gap-1 flex-wrap mt-0.5",
                                children: voucherPills.map((text, i)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                        text: text,
                                        type: "user-choice"
                                    }, i))
                            })
                        ]
                    }),
                    showPriceArea && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                        className: "shrink-0 flex flex-col items-end",
                        children: priceLoading ? /*#__PURE__*/ (0, $ih19M.jsx)((0, $e707c4e9e24b211c$export$2e2bcd8739ae039), {
                            size: 18
                        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                    className: "text-[17px] font-semibold tracking-[0.68px] uppercase leading-5 text-on-surface",
                                    children: [
                                        price.finalPrice,
                                        ":-"
                                    ]
                                }),
                                hasReducedPrice && /*#__PURE__*/ (0, $ih19M.jsxs)("span", {
                                    className: "text-[15px] leading-5 text-on-surface-variant line-through",
                                    children: [
                                        price.fullPrice,
                                        ":-"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2180-33927
// Component: BookingType
// Variants: Direct booking | Pre-booking | Pre-booking from airport (flightNumber present)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");



// Standard calendar icon
function $399efa2df35e57c4$var$CalendarIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M8.00009 2.75C8.23259 2.75 8.34883 2.75 8.44421 2.77556C8.70303 2.84491 8.90519 3.04707 8.97454 3.30588C9.00009 3.40126 9.00009 3.5175 9.00009 3.75L9.0001 3.875C9.0001 3.99149 9.0001 4.04973 9.01913 4.09567C9.0445 4.15693 9.09317 4.2056 9.15442 4.23097C9.20037 4.25 9.25861 4.25 9.3751 4.25H14.6251C14.7416 4.25 14.7998 4.25 14.8458 4.23097C14.907 4.2056 14.9557 4.15693 14.9811 4.09567C15.0001 4.04973 15.0001 3.99148 15.0001 3.875L15.0001 3.75C15.0001 3.51751 15.0001 3.40126 15.0256 3.30589C15.095 3.04707 15.2972 2.84491 15.556 2.77556C15.6514 2.75 15.7676 2.75 16.0001 2.75C16.2326 2.75 16.3488 2.75 16.4442 2.77556C16.703 2.84491 16.9052 3.04707 16.9745 3.30588C17.0001 3.40126 17.0001 3.5175 17.0001 3.75L17.0001 3.89042C17.0001 4.00817 17.0001 4.06704 17.0187 4.11248C17.0422 4.17002 17.0817 4.21291 17.1372 4.24099C17.1809 4.26316 17.2431 4.26821 17.3673 4.27829C17.6085 4.29787 17.8284 4.33084 18.0354 4.3863C19.4157 4.75617 20.4939 5.83436 20.8638 7.21472C21.0009 7.72638 21.0006 8.31704 21.0001 9.11242C21.0001 9.15761 21.0001 9.20347 21.0001 9.25V15.4913C21.0001 16.2963 21.0001 16.9606 20.9559 17.5018C20.91 18.0639 20.8114 18.5806 20.5641 19.066C20.1806 19.8186 19.5687 20.4305 18.8161 20.814C18.3307 21.0613 17.814 21.1599 17.2519 21.2058C16.7107 21.25 16.0464 21.25 15.2414 21.25H8.75877C7.95381 21.25 7.28946 21.25 6.74827 21.2058C6.18617 21.1599 5.66947 21.0613 5.18413 20.814C4.43149 20.4305 3.81956 19.8186 3.43607 19.066C3.18878 18.5806 3.09022 18.0639 3.04429 17.5018C3.00007 16.9606 3.00008 16.2963 3.0001 15.4913L3.0001 9.25C3.0001 9.20346 3.00007 9.15761 3.00005 9.11242C2.99962 8.31703 2.9993 7.72637 3.13639 7.21472C3.50626 5.83436 4.58445 4.75617 5.96482 4.3863C6.17179 4.33084 6.3917 4.29787 6.63285 4.27829C6.75712 4.26821 6.81925 4.26316 6.86304 4.24099C6.91848 4.21291 6.95804 4.17001 6.98154 4.11248C7.0001 4.06704 7.0001 4.00817 7.0001 3.89042L7.00009 3.75C7.00009 3.51751 7.00009 3.40126 7.02565 3.30589C7.095 3.04707 7.29716 2.84491 7.55598 2.77556C7.65135 2.75 7.7676 2.75 8.00009 2.75ZM8.0001 6.25C7.00574 6.25 6.70474 6.25859 6.48246 6.31815C5.79227 6.50308 5.25318 7.04218 5.06824 7.73236C5.01995 7.9126 5.00517 7.4871 5.00131 7.84983C4.99983 7.98846 4.99909 8.05778 5.02613 8.11183C5.04974 8.15905 5.08855 8.19827 5.13551 8.22239C5.18928 8.25 5.25955 8.25 5.4001 8.25H18.6001C18.7406 8.25 18.8109 8.25 18.8647 8.22239C18.9116 8.19827 18.9504 8.15905 18.9741 8.11183C19.0011 8.05778 19.0004 7.98846 18.9989 7.84983C18.995 7.4871 18.9802 7.9126 18.9319 7.73236C18.747 7.04218 18.2079 6.50308 17.5177 6.31815C17.2955 6.25859 16.9944 6.25 16.0001 6.25H8.0001ZM19.0001 10.65C19.0001 10.51 19.0001 10.44 18.9728 10.3865C18.9489 10.3395 18.9106 10.3012 18.8636 10.2772C18.8101 10.25 18.7401 10.25 18.6001 10.25H5.4001C5.26008 10.25 5.19008 10.25 5.1366 10.2772C5.08956 10.3012 5.05131 10.3395 5.02734 10.3865C5.0001 10.44 5.0001 10.51 5.0001 10.65V15.45C5.0001 16.3066 5.00087 16.8889 5.03765 17.339C5.07347 17.7774 5.13839 18.0016 5.21808 18.158C5.40983 18.5343 5.71579 18.8403 6.09212 19.032C6.24852 19.1117 6.47272 19.1766 6.91113 19.2124C7.36122 19.2492 7.94352 19.25 8.8001 19.25H15.2001C16.0567 19.25 16.639 19.2492 17.0891 19.2124C17.5275 19.1766 17.7517 19.1117 17.9081 19.032C18.2844 18.8403 18.5904 18.5343 18.7821 18.158C18.8618 18.0016 18.9267 17.7774 18.9625 17.339C18.9993 16.8889 19.0001 16.3066 19.0001 15.45V10.65Z",
                fill: "#17181A"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M16.0001 17.25H15.0001C14.7676 17.25 14.6514 17.25 14.556 17.2244C14.2972 17.1551 14.095 16.9529 14.0256 16.6941C14.0001 16.5987 14.0001 16.4825 14.0001 16.25C14.0001 16.1055 14.0001 15.6199 14.0062 15.25C14.01 15.0245 14.016 14.842 14.0256 14.8059C14.095 14.5471 14.2972 14.3449 14.556 14.2756C14.6514 14.25 14.7676 14.25 15.0001 14.25H16.0001C16.2326 14.25 16.3488 14.25 16.4442 14.2756C16.703 14.3449 16.9052 14.5471 16.9745 14.8059C16.9842 14.842 16.9902 15.0245 16.994 15.25C17.0001 15.6199 17.0001 16.1055 17.0001 16.25C17.0001 16.4825 17.0001 16.5987 16.9745 16.6941C16.9052 16.9529 16.703 17.1551 16.4442 17.2244C16.3488 17.25 16.2326 17.25 16.0001 17.25Z",
                fill: "#17181A"
            })
        ]
    });
}
// Calendar with airplane — airport pre-booking
function $399efa2df35e57c4$var$CalendarAirportIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M16 2.75C16.2325 2.75 16.349 2.74984 16.4443 2.77539C16.7031 2.84474 16.9052 3.04696 16.9746 3.30566C17.0002 3.40104 17 3.51751 17 3.75V3.89062C17 4.00807 17.0001 4.06691 17.0186 4.1123C17.042 4.16975 17.0814 4.21313 17.1367 4.24121C17.1805 4.26338 17.243 4.26824 17.3672 4.27832C17.6083 4.29789 17.8282 4.33128 18.0352 4.38672C19.4155 4.75659 20.4944 5.83448 20.8643 7.21484C21.0013 7.72642 21.0004 8.3171 21 9.1123V15.4912C21 16.2962 21.0003 16.9608 20.9561 17.502C20.9101 18.064 20.8117 18.5811 20.5645 19.0664C20.181 19.8189 19.5689 20.431 18.8164 20.8145C18.3311 21.0617 17.814 21.1601 17.252 21.2061C16.7108 21.2503 16.0462 21.25 15.2412 21.25H8.75879C7.95383 21.25 7.28924 21.2503 6.74805 21.2061C6.18623 21.1601 5.6697 21.0615 5.18457 20.8145C4.4321 20.4311 3.82003 19.8188 3.43652 19.0664C3.18925 18.5811 3.08987 18.064 3.04395 17.502C2.99973 16.9608 2.99999 16.2962 3 15.4912V9.1123C2.99957 8.31699 2.99964 7.72646 3.13672 7.21484C3.50658 5.8345 4.58452 4.75661 5.96484 4.38672C6.17181 4.33126 6.39167 4.2979 6.63281 4.27832C6.75708 4.26823 6.81949 4.26339 6.86328 4.24121C6.91867 4.21313 6.95796 4.1698 6.98145 4.1123C6.99995 4.06691 7 4.00813 7 3.89062V3.75C7 3.51751 6.99984 3.40104 7.02539 3.30566C7.09475 3.047 7.29701 2.84479 7.55566 2.77539C7.65103 2.74984 7.76757 2.75 8 2.75C8.23249 2.75 8.34896 2.74984 8.44434 2.77539C8.70305 2.84474 8.90522 3.04696 8.97461 3.30566C9.00016 3.40104 9 3.51751 9 3.75V3.875C9 3.99149 9.0005 4.04976 9.01953 4.0957C9.04492 4.15688 9.0931 4.2061 9.1543 4.23145C9.20022 4.25045 9.25863 4.25 9.375 4.25H14.625C14.7413 4.25 14.7998 4.25038 14.8457 4.23145C14.907 4.20607 14.9561 4.15696 14.9814 4.0957C15.0004 4.04978 15 3.9914 15 3.875V3.75C15 3.51751 14.9998 3.40104 15.0254 3.30566C15.0948 3.047 15.297 2.84479 15.5557 2.77539C15.651 2.74984 15.7676 2.75 16 2.75ZM8 6.25C7.00572 6.25 6.70469 6.2588 6.48242 6.31836C5.79228 6.50332 5.25329 7.04227 5.06836 7.73242C5.00881 7.9547 5 8.25569 5 9.25V15.4502C5 16.3066 5.00132 16.8888 5.03809 17.3389C5.07391 17.7773 5.13808 18.0018 5.21777 18.1582C5.40949 18.5344 5.71557 18.8405 6.0918 19.0322C6.2482 19.1119 6.47272 19.1771 6.91113 19.2129C7.36117 19.2497 7.94341 19.25 8.7998 19.25H15.2002C16.0566 19.25 16.6388 19.2496 17.0889 19.2129C17.5273 19.1771 17.7518 19.1119 17.9082 19.0322C18.2845 18.8405 18.5905 18.5345 18.7822 18.1582C18.8619 18.0018 18.9271 17.7773 18.9629 17.3389C18.9997 16.8888 19 16.3066 19 15.4502V9.25C19 8.25565 18.9912 7.9547 18.9316 7.73242C18.7467 7.04225 18.2078 6.50329 17.5176 6.31836C17.2953 6.25882 16.9942 6.25 16 6.25H8ZM14.0781 9.16699C14.4327 8.81242 14.9419 8.65851 15.4336 8.75684L15.5117 8.77246C15.7095 8.8121 15.8637 8.96723 15.9033 9.16504L15.9189 9.24316C16.0173 9.73491 15.8634 10.243 15.5088 10.5977L14.0137 12.0938L14.7451 15.3887C14.8667 15.9358 14.5124 16.4768 13.9629 16.5869C13.8525 16.609 13.74 16.5547 13.6895 16.4541L12.3438 13.7627L10.5557 15.3135L11.0703 16.6514C11.1164 16.7714 11.0641 16.9072 10.9492 16.9648L10.4219 17.2285C10.2984 17.2903 10.1477 17.2397 10.0859 17.1162L9.24414 15.4326L7.56055 14.5908C7.43705 14.5291 7.38649 14.3784 7.44824 14.2549L7.71191 13.7275C7.76953 13.6125 7.90529 13.5603 8.02539 13.6064L9.36328 14.1211L10.9131 12.332L8.22266 10.9873C8.1219 10.9369 8.06774 10.8244 8.08984 10.7139C8.19987 10.1643 8.7409 9.80909 9.28809 9.93066L12.583 10.6631L14.0781 9.16699Z",
            fill: "#17181A"
        })
    });
}
function $399efa2df35e57c4$export$2e2bcd8739ae039({ time: time, subtitle: subtitle, flightNumber: flightNumber, checkedBaggage: checkedBaggage, disabled: disabled, changeToggle: changeToggle }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const isAirport = Boolean(flightNumber);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: isAirport ? /*#__PURE__*/ (0, $ih19M.jsx)($399efa2df35e57c4$var$CalendarAirportIcon, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($399efa2df35e57c4$var$CalendarIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: time
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: subtitle
                    }),
                    isAirport && /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex gap-1 flex-wrap mt-1",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: flightNumber
                            }),
                            checkedBaggage && /*#__PURE__*/ (0, $ih19M.jsx)((0, $fefe7f9cbdf4c037$export$2e2bcd8739ae039), {
                                text: t('label-checked-baggage'),
                                type: "user-choice"
                            })
                        ]
                    })
                ]
            }),
            changeToggle && /*#__PURE__*/ (0, $ih19M.jsx)((0, $aab55537bcbfd3cb$export$2e2bcd8739ae039), {
                onClick: changeToggle
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3265-56673
// Component: TripType
// Shows trip type (company or private) with icon, title and optional company name
// States: normal | disabled (opacity-38)
// Variants: company (briefcase icon + subtitle) | private (user icon, no subtitle)

var $ih19M = parcelRequire("ih19M");

var $5TnqA = parcelRequire("5TnqA");

function $7e46addbea690aa5$var$CompanyIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M13.3333 5.83333C13.3333 5.05836 13.3333 4.67087 13.2481 4.35295C13.017 3.49022 12.3431 2.81635 11.4804 2.58519C11.1625 2.5 10.775 2.5 10 2.5C9.22502 2.5 8.83754 2.5 8.51962 2.58519C7.65689 2.81635 6.98302 3.49022 6.75185 4.35295C6.66667 4.67087 6.66667 5.05836 6.66667 5.83333M4.33333 17.5H15.6667C16.6001 17.5 17.0668 17.5 17.4233 17.3183C17.7369 17.1586 17.9919 16.9036 18.1517 16.59C18.3333 16.2335 18.3333 15.7668 18.3333 14.8333V8.5C18.3333 7.56658 18.3333 7.09987 18.1517 6.74335C17.9919 6.42975 17.7369 6.17478 17.4233 6.01499C17.0668 5.83333 16.6001 5.83333 15.6667 5.83333H4.33333C3.39991 5.83333 2.9332 5.83333 2.57668 6.01499C2.26308 6.17478 2.00811 6.42975 1.84832 6.74335C1.66667 7.09987 1.66667 7.56658 1.84832 16.59C2.00811 16.9036 2.26308 17.1586 2.57668 17.3183C2.9332 17.5 3.39991 17.5 4.33333 17.5Z",
            stroke: "#17181A",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
function $7e46addbea690aa5$var$UserIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 12.5C7.35827 12.5 5.009 13.7755 3.51333 15.755C3.19142 16.181 3.03047 16.394 3.03573 16.6819C3.0398 16.9043 3.17947 17.1849 3.35447 17.3222C3.58099 17.5 3.89489 17.5 4.52269 17.5H15.4773C16.1051 17.5 16.419 17.5 16.6455 17.3222C16.8205 17.1849 16.9602 16.9043 16.9643 16.6819C16.9695 16.394 16.8086 16.181 16.4867 15.755C14.991 13.7755 12.6417 12.5 10 12.5Z",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                d: "M10 10C12.0711 10 13.75 8.32107 13.75 6.25C13.75 4.17893 12.0711 2.5 10 2.5C7.92893 2.5 6.25 4.17893 6.25 6.25C6.25 8.32107 7.92893 10 10 10Z",
                stroke: "#17181A",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
function $7e46addbea690aa5$export$2e2bcd8739ae039({ type: type = 'company', name: name, disabled: disabled }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const isCompany = type === 'company';
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA)))('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]'),
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: "shrink-0 size-11 flex items-center justify-center",
                children: isCompany ? /*#__PURE__*/ (0, $ih19M.jsx)($7e46addbea690aa5$var$CompanyIcon, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($7e46addbea690aa5$var$UserIcon, {})
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col items-start min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: isCompany ? t('label-company-trip') : t('label-private-trip')
                    }),
                    isCompany && name && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: name
                    })
                ]
            })
        ]
    });
}


// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=83-1923&m=dev
// Component: TripLocations — Display view
// Departure → optional stops → destination with connecting line and icons

var $ih19M = parcelRequire("ih19M");

function $cd9136fbd575d4a5$var$PickupDot() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "w-2 h-2 rounded-[4px] bg-on-surface shrink-0"
    });
}
function $cd9136fbd575d4a5$var$StopDot() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "size-2 rounded-[1px] bg-on-surface shrink-0"
    });
}
function $cd9136fbd575d4a5$var$PinIcon() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        "aria-hidden": "true",
        className: "shrink-0",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6 0C3.79 0 2 1.79 2 4c0 2.5 3.5 7.5 4 8 .5-.5 4-5.5 4-8 0-2.21-1.79-4-4-4zm0 5.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
            fill: "#17181A"
        })
    });
}
function $cd9136fbd575d4a5$var$SolidLine() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "w-0.5 bg-on-surface flex-1"
    });
}
function $cd9136fbd575d4a5$var$EmptyLine() {
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: "flex-1"
    });
}
function $cd9136fbd575d4a5$var$LocationRow({ location: location, icon: icon, lineAbove: lineAbove, lineBelow: lineBelow }) {
    const { title: title, subtitle: subtitle } = (0, $200ec6b1b2ca8c5a$export$d4d145b6a34ea737)(location);
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex gap-3",
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "shrink-0 w-11 flex flex-col items-center",
                children: [
                    lineAbove === 'solid' ? /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$SolidLine, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$EmptyLine, {}),
                    icon,
                    lineBelow === 'solid' ? /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$SolidLine, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$EmptyLine, {})
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex-1 flex flex-col py-3 min-w-0",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface",
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                        className: "text-[15px] leading-5 text-on-surface-variant",
                        children: subtitle
                    })
                ]
            })
        ]
    });
}
function $cd9136fbd575d4a5$export$2e2bcd8739ae039({ departure: departure, destination: destination, stops: stops = [] }) {
    const hasDestination = Boolean(destination?.address);
    const allRows = [
        departure,
        ...stops,
        ...hasDestination ? [
            destination
        ] : []
    ].filter(Boolean);
    return /*#__PURE__*/ (0, $ih19M.jsx)("div", {
        children: allRows.map((location, i)=>{
            const isFirst = i === 0;
            const isLast = i === allRows.length - 1;
            const isDestination = isLast && hasDestination;
            const icon = isDestination ? /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$PinIcon, {}) : isFirst ? /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$PickupDot, {}) : /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$StopDot, {});
            const lineAbove = isFirst ? 'empty' : 'solid';
            const lineBelow = isLast ? 'empty' : 'solid';
            return /*#__PURE__*/ (0, $ih19M.jsx)($cd9136fbd575d4a5$var$LocationRow, {
                location: location,
                icon: icon,
                lineAbove: lineAbove,
                lineBelow: lineBelow
            }, i);
        })
    });
}


// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=7613-182239
// Component: SectionHeading
// Numbered section label: dark circle badge + uppercase condensed title

var $ih19M = parcelRequire("ih19M");
function $3f9dfc4319f20848$export$2e2bcd8739ae039({ number: number, title: title, error: error = false, innerRef: innerRef }) {
    return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: "flex items-center gap-2",
        ref: innerRef,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: `shrink-0 size-[22px] rounded-full flex items-center justify-center text-white text-[13px] font-semibold leading-none ${error ? 'bg-[#E30713]' : 'bg-[#17181A]'}`,
                children: number
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                className: `text-[17px] font-semibold tracking-[-0.34px] ${error ? 'text-[#E30713]' : 'text-[#17181A]'}`,
                children: title
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");





const $247ae7f4639f55fe$var$hideOnId = [
    ''
]; // ID:s for views where this button should be hidden
const $247ae7f4639f55fe$var$noModalOnId = [
    'done',
    'inputPhone',
    'returntrip'
]; // ID:s for views where the confirm modal should be skipped
function $247ae7f4639f55fe$export$2e2bcd8739ae039({ message: message }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { id: id, reset: resetStepper } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const { values: values, initialValues: initialValues, resetForm: resetForm } = (0, $lW2XZ.useFormikContext)();
    const ref = (0, $bh6RR.useRef)();
    const [isWaitingForPoll, setIsWaitingForPoll] = (0, $bh6RR.useState)(false);
    // Check if in edit mode (bookingId exists and is valid)
    const isEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
    // Use edit message if in edit mode, otherwise use provided message or default booking message
    const confirmMessage = isEditMode ? t('reset-edit-message') : message || t('reset-booking-message');
    const reset = ()=>{
        if (isWaitingForPoll) return; // Don't allow reset when waiting for poll
        const resetValues = initialValues;
        resetValues.isCompanyTrip = values.isCompanyTrip; // Preserve company trip status
        resetValues.company = values.company; // Preserve company name if set
        resetForm({
            values: resetValues
        });
        resetStepper();
        // Emit RESET_FORM and RESET_MAP events (same as Formik onReset handler)
        if (typeof APP !== 'undefined' && APP.trigger) APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_FORM');
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('RESET_MAP');
    };
    const [showReset, setShowReset] = (0, $bh6RR.useState)(false);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
        setShowReset(false);
    }, [
        setShowReset
    ]);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('BOOKING_STARTED', ()=>{
        setShowReset(true);
    }, [
        setShowReset
    ]);
    // Listen for waiting for poll state
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('BOOKING_WAITING_FOR_POLL', ({ waiting: waiting })=>{
        setIsWaitingForPoll(waiting || false);
    }, []);
    const onClick = ()=>{
        if (isWaitingForPoll) return; // Don't allow reset when waiting for poll
        if ($247ae7f4639f55fe$var$noModalOnId.includes(id)) reset();
        else (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(confirmMessage, [
            {
                title: t('button-yes'),
                callback: reset
            },
            {
                title: t('button-no')
            }
        ]);
    };
    (0, $bh6RR.useEffect)(()=>{
        ref.current;
    }, [
        ref,
        id
    ]);
    // Do not show on some id:s
    if (!showReset) return null;
    // booking-reset-button is a styling hook, not a behaviour flag: the embed hides
    // this button on desktop, where it would land on top of the bookings toggle.
    // Tagged here rather than on CloseButton so the modals' close buttons are unaffected.
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $0fa620ad2e74576c$export$2e2bcd8739ae039), {
        innerRef: ref,
        onClick: onClick,
        disabled: isWaitingForPoll,
        className: "booking-reset-button"
    });
}




var $bh6RR = parcelRequire("bh6RR");



function $57ccc41fcf47abfa$export$2e2bcd8739ae039({ onViewChange: onViewChange }) {
    const isMobile = (0, $ef42d3c0207235e0$export$32d5543ab307c01)('only screen and (max-width: 969px)');
    const { id: id } = (0, $bh6RR.useContext)((0, $b1f47dcfa609295f$export$91b1e15bb76ddaff));
    const prevId = (0, $e1f0702c5201c0a7$export$5cae361ad82dce8b)(id);
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        if (isMobile && document.scrollingElement.scrollTop > 70) document.scrollingElement.scrollTop = 70;
    }, [
        isMobile,
        id
    ]);
    // Layout effect, not a passive one: the module flips its fullscreen flag in this callback,
    // and a layout effect lets React re-render before the browser paints, so the new view and
    // its layout appear in the same frame instead of the view first and the reflow a beat later.
    (0, $bh6RR.useLayoutEffect)(()=>{
        if (prevId && id !== prevId) {
            if (onViewChange) onViewChange(id, prevId);
        }
    }, [
        id,
        prevId
    ]);
}




var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");


var $bh6RR = parcelRequire("bh6RR");





var $6fa6b22a9cbf57f3$export$a8ecead220dd38a6;
var $6fa6b22a9cbf57f3$export$fb184b623420d9be;
var $6fa6b22a9cbf57f3$export$cc74dcc53cfce4eb;
$6fa6b22a9cbf57f3$export$a8ecead220dd38a6 = `bXMCWq_message`;
$6fa6b22a9cbf57f3$export$fb184b623420d9be = `bXMCWq_title`;
$6fa6b22a9cbf57f3$export$cc74dcc53cfce4eb = `bXMCWq_wrapper`;


function $f5a01b8c00777f68$export$2e2bcd8739ae039({ onComplete: onComplete }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const initialValues = {
        accountNumber: '',
        accountPassword: ''
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
        initialValues: initialValues,
        validationSchema: $e6d972962a22d393$export$185802fd694ee1f5({
            accountNumber: $a0206caf38308288$export$185802fd694ee1f5().required(t('validation-need-account-number')),
            accountPassword: $a0206caf38308288$export$185802fd694ee1f5().required(t('validation-need-account-password'))
        }),
        onSubmit: async (values)=>{
            setMessage('');
            await (0, $30acdccbb47e8004$export$e772c8ff12451969)(500);
            (0, $135a523c4bea715f$export$f7dd262aa2367f3d)(user.userId, values.accountNumber, values.accountPassword).then((response)=>{
                refreshUser();
                if (onComplete) onComplete();
            }).catch((error)=>{
                console.error(error);
                setMessage(error?.response?.message);
            });
        },
        children: ({ errors: errors, submitForm: submitForm, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-col w-full p-4 gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-[17px] font-semibold uppercase text-[#17181a] mb-2.5",
                                children: t('header-add-account')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "accountNumber",
                                placeholder: t('placeholder-account-number'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "accountPassword",
                                type: "password",
                                placeholder: t('placeholder-account-password'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039)
                            }),
                            message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $6fa6b22a9cbf57f3$export$a8ecead220dd38a6,
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                        modal: true,
                        buttons: [
                            {
                                func: submitForm,
                                title: t('button-save'),
                                isLoading: isSubmitting
                            }
                        ],
                        isLoading: isSubmitting
                    })
                ]
            })
    });
}



var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");


var $bh6RR = parcelRequire("bh6RR");





var $64d72d08315477ae$export$a8ecead220dd38a6;
var $64d72d08315477ae$export$fb184b623420d9be;
var $64d72d08315477ae$export$cc74dcc53cfce4eb;
$64d72d08315477ae$export$a8ecead220dd38a6 = `L5uIoW_message`;
$64d72d08315477ae$export$fb184b623420d9be = `L5uIoW_title`;
$64d72d08315477ae$export$cc74dcc53cfce4eb = `L5uIoW_wrapper`;


function $006192e901cb3229$export$2e2bcd8739ae039({ onComplete: onComplete }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const initialValues = {
        voucherCode: ''
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
        initialValues: initialValues,
        validationSchema: $e6d972962a22d393$export$185802fd694ee1f5({
            voucherCode: $a0206caf38308288$export$185802fd694ee1f5().required(t('validation-need-voucher-code'))
        }),
        onSubmit: async (values)=>{
            setMessage('');
            await (0, $30acdccbb47e8004$export$e772c8ff12451969)(500);
            (0, $135a523c4bea715f$export$1b9cfbadf92bf372)(user.userId, values.voucherCode).then((response)=>{
                refreshUser();
                if (onComplete) onComplete();
            }).catch((error)=>{
                console.error(error);
                setMessage(error?.response?.message);
            });
        },
        children: ({ errors: errors, submitForm: submitForm, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: "flex flex-col w-full p-4 gap-1.5",
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                className: "text-[17px] font-semibold uppercase text-[#17181a] mb-2.5",
                                children: t('header-add-voucher')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "voucherCode",
                                placeholder: t('placeholder-voucher-code'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                                uppercase: true
                            }),
                            message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $64d72d08315477ae$export$a8ecead220dd38a6,
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                        modal: true,
                        buttons: [
                            {
                                func: submitForm,
                                title: t('button-save'),
                                isLoading: isSubmitting
                            }
                        ],
                        isLoading: isSubmitting
                    })
                ]
            })
    });
}



var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");



function $eb5084cc5eb47e44$export$2e2bcd8739ae039({ fields: fields, title: title, onClose: onClose, validate: validate, formValues: passedValues, onFieldSave: onFieldSave }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const formik = (0, $bh6RR.useContext)((0, $lW2XZ.FormikContext));
    const values = passedValues ?? formik?.values ?? {};
    const setFieldValue = onFieldSave ? (id, val)=>onFieldSave(id, val) : (id, val, shouldValidate)=>formik?.setFieldValue(id, val, shouldValidate);
    const [initialized, setInitialized] = (0, $bh6RR.useState)(false);
    // Local state to hold temporary values
    const [localValues, setLocalValues] = (0, $bh6RR.useState)({});
    const [localErrors, setLocalErrors] = (0, $bh6RR.useState)({});
    // Initialize local state with current form values when modal opens
    // Only initialize once to avoid resetting while user is typing
    // DO NOT include 'values' in dependency array - it would cause re-initialization during polling
    (0, $bh6RR.useEffect)(()=>{
        if (!initialized && fields) {
            const initialValues = {};
            fields?.forEach((field)=>{
                initialValues[field.id] = (0, $lW2XZ.getIn)(values, field.id) || '';
            });
            setLocalValues(initialValues);
            setLocalErrors({});
            setInitialized(true);
        }
    }, [
        fields,
        initialized
    ]); // Removed 'values' from dependencies to prevent re-init during polling
    // Reset initialized flag only when component unmounts
    // Don't reset when fields changes - that would cause re-init during parent re-renders
    (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            setInitialized(false);
        };
    }, []); // Empty dependency array - cleanup only on unmount
    const handleChange = (fieldId, value)=>{
        setLocalValues((prev)=>({
                ...prev,
                [fieldId]: value
            }));
        // Validate if needed
        const field = fields.find((f)=>f.id === fieldId);
        if (validate && field?.validate) {
            const error = field.validate(value);
            setLocalErrors((prev)=>({
                    ...prev,
                    [fieldId]: error || null
                }));
        }
    };
    const onSubmit = ()=>{
        // Validate all fields if validation is enabled
        if (validate) {
            const newErrors = {};
            let hasErrors = false;
            fields?.forEach((field)=>{
                if (field.validate) {
                    const error = field.validate(localValues[field.id] || '');
                    if (error) {
                        newErrors[field.id] = error;
                        hasErrors = true;
                    }
                }
            });
            setLocalErrors(newErrors);
            if (hasErrors) return; // Don't close if there are errors
        }
        // Save all field values to the form
        fields?.forEach((field)=>{
            setFieldValue(field.id, localValues[field.id] || '');
        });
        setInitialized(false); // Reset for next time modal opens
        onClose();
    };
    return /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                className: "flex flex-col w-full p-4 gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                        className: "text-[17px] font-semibold uppercase text-[#17181a] mb-2.5",
                        children: title
                    }),
                    fields?.map((field)=>{
                        return /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("input", {
                                    className: $4a23d699a1f138e3$export$e0f35d825088c098,
                                    name: field.id,
                                    value: localValues[field.id] || '',
                                    onChange: (e)=>handleChange(field.id, e.target.value),
                                    onBlur: ()=>{},
                                    placeholder: field.title,
                                    tabIndex: "0",
                                    maxLength: 40
                                }),
                                localErrors[field.id] && /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: "text-red-600 text-[12px] mt-1",
                                    children: localErrors[field.id]
                                })
                            ]
                        }, field.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                buttons: [
                    {
                        func: onSubmit,
                        title: t('button-save')
                    }
                ],
                modal: true
            })
        ]
    });
}



var $ih19M = parcelRequire("ih19M");

var $lW2XZ = parcelRequire("lW2XZ");


var $5TnqA = parcelRequire("5TnqA");

var $bh6RR = parcelRequire("bh6RR");





var $ad4718d8bfc4f05c$exports = {};

$parcel$export($ad4718d8bfc4f05c$exports, "message", function () { return $ad4718d8bfc4f05c$export$a8ecead220dd38a6; }, function (v) { return $ad4718d8bfc4f05c$export$a8ecead220dd38a6 = v; });
$parcel$export($ad4718d8bfc4f05c$exports, "title", function () { return $ad4718d8bfc4f05c$export$fb184b623420d9be; }, function (v) { return $ad4718d8bfc4f05c$export$fb184b623420d9be = v; });
$parcel$export($ad4718d8bfc4f05c$exports, "wrapper", function () { return $ad4718d8bfc4f05c$export$cc74dcc53cfce4eb; }, function (v) { return $ad4718d8bfc4f05c$export$cc74dcc53cfce4eb = v; });
var $ad4718d8bfc4f05c$export$a8ecead220dd38a6;
var $ad4718d8bfc4f05c$export$fb184b623420d9be;
var $ad4718d8bfc4f05c$export$cc74dcc53cfce4eb;
$ad4718d8bfc4f05c$export$a8ecead220dd38a6 = `wTEfHW_message`;
$ad4718d8bfc4f05c$export$fb184b623420d9be = `wTEfHW_title`;
$ad4718d8bfc4f05c$export$cc74dcc53cfce4eb = `wTEfHW_wrapper`;


const $4741aed6d26ee9f4$var$cx = (0, (/*@__PURE__*/$parcel$interopDefault($5TnqA))).bind($ad4718d8bfc4f05c$exports);
function $4741aed6d26ee9f4$export$2e2bcd8739ae039({ bookingId: bookingId, onComplete: onComplete }) {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [message, setMessage] = (0, $bh6RR.useState)();
    const initialValues = {
        email: user.email
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Formik), {
        initialValues: initialValues,
        validationSchema: $e6d972962a22d393$export$185802fd694ee1f5({
            email: $a0206caf38308288$export$185802fd694ee1f5().email(t('validation-invalid-email')).required(t('validation-need-email'))
        }),
        onSubmit: async (values)=>{
            setMessage('');
            await (0, $30acdccbb47e8004$export$e772c8ff12451969)(500);
            (0, $135a523c4bea715f$export$7096ad10e421c942)(bookingId, values.email).then((response)=>{
                // setMessage(t('info-confirmation-sent'))
                if (onComplete) onComplete();
            }).catch((error)=>{
                console.error(error);
                setMessage(error?.response?.message);
            });
        },
        children: ({ errors: errors, submitForm: submitForm, isSubmitting: isSubmitting })=>/*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                        className: $ad4718d8bfc4f05c$exports.wrapper,
                        children: [
                            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $ad4718d8bfc4f05c$exports.title,
                                children: t('header-send-confirmation')
                            }),
                            /*#__PURE__*/ (0, $ih19M.jsx)((0, $lW2XZ.Field), {
                                name: "email",
                                placeholder: t('placeholder-email'),
                                component: (0, $0c9528727d336954$export$2e2bcd8739ae039),
                                alternateBackground: true
                            }),
                            message && /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                className: $ad4718d8bfc4f05c$exports.message,
                                children: message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                        modal: true,
                        buttons: [
                            {
                                func: submitForm,
                                title: t('button-send'),
                                isLoading: isSubmitting
                            }
                        ],
                        isLoading: isSubmitting
                    })
                ]
            })
    });
}



var $bh6RR = parcelRequire("bh6RR");

var $lW2XZ = parcelRequire("lW2XZ");





const $266f81f9d9c6205b$export$2b4f7fc6d4c29758 = (region)=>{
    const availability = region === 'Stockholm' ? $266f81f9d9c6205b$var$stockholm : $266f81f9d9c6205b$var$partner;
    // NOTE: Add a timestamp to trigger the useEffect that sets auto values
    return {
        ...availability,
        timestamp: Date.now()
    };
};
const $266f81f9d9c6205b$var$stockholm = {
    availabilities: [],
    priceAndPaymentRules: {
        priceTypes: [
            {
                type: 'TAXIMETER',
                paymentMethods: [
                    'PayInCar',
                    'TSABAccount'
                ],
                voucherEnabled: true
            },
            {
                type: 'FIXED',
                paymentMethods: [
                    'PayInCar',
                    'TravelClearingAccount',
                    'TSABAccount',
                    'CreditCard'
                ],
                voucherEnabled: true
            }
        ]
    },
    tripRules: {
        maxAllowedIntermediateStops: 4
    }
};
const $266f81f9d9c6205b$var$partner = {
    availabilities: [],
    priceAndPaymentRules: {
        priceTypes: [
            {
                type: 'FIXED',
                paymentMethods: [
                    'PayInCar',
                    'TravelClearingAccount',
                    'TSABAccount',
                    'CreditCard'
                ],
                voucherEnabled: false
            }
        ]
    },
    tripRules: {
        maxAllowedIntermediateStops: 0
    }
};



const $9832901ac9096800$var$getNextTimeToRun = (estimate)=>{
    const validUntil = estimate?.validUntil;
    if (!validUntil) return false;
    // Refresh 30 seconds before the token expires; discard if already past
    const ms = new Date(validUntil).getTime() - Date.now() - 30000;
    return ms > 0 ? ms : false;
};
function $9832901ac9096800$export$2e2bcd8739ae039() {
    const estimateTimeout = (0, $bh6RR.useRef)();
    const hasDefaultedPayment = (0, $bh6RR.useRef)();
    const estimatePriceRef = (0, $bh6RR.useRef)(null);
    const { values: values, setFieldValue: setFieldValue, setFieldError: setFieldError } = (0, $lW2XZ.useFormikContext)();
    const { user: user, preferredPaymentAccount: preferredPaymentAccount, preferredPaymentAccountCompany: preferredPaymentAccountCompany, preferredPaymentMethod: preferredPaymentMethod, preferredPaymentMethodCompany: preferredPaymentMethodCompany, currentPaymentAccount: currentPaymentAccount, currentPaymentAccountCompany: currentPaymentAccountCompany, currentPaymentMethod: currentPaymentMethod, currentPaymentMethodCompany: currentPaymentMethodCompany, isCompanyTrip: isCompanyTrip } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const getPaymentType = (account)=>{
        if (account?.type === 'creditcard') return `CreditCard-${account.accountId}`;
        else if (account?.type === 'TSAB' || account?.type === 'TCA') return `Account-${account.accountNumber}`;
        return 'DefaultNoSelect';
    };
    // Whether the route offers TAXIMETER at all. When it doesn't (package deliveries, some fixed
    // price routes) a failed estimate must NOT switch the form to taximeter: there is no way back
    // for the user, and booking without a priceToken is rejected with FIXED_PRICE_REQUIRED.
    const isTaximeterOffered = (availability)=>getPriceTypes(availability).some((item)=>item.type === 'TAXIMETER');
    const estimatePrice = async (freshAvailability = null)=>{
        const availabilityKey = values.pickupTime === '' ? 'direct' : 'prebook';
        const availabilityForRules = freshAvailability || values.availability?.[availabilityKey];
        // Filter out vouchers that the current payment method doesn't allow,
        // guarding against stale closure timing between payment-change and voucher-clear effects.
        const selectedKey = (0, $c94184dfef1a7d71$export$369f738c5ad4634)(values.payment, values.account);
        const vouchersDisabled = selectedKey && values.priceType?.paymentMethodConfigurations ? !values.priceType.paymentMethodConfigurations.find((c)=>c.paymentMethod === selectedKey)?.voucherEnabled : !values.priceType?.voucherEnabled;
        const valuesForEstimate = vouchersDisabled && values.vouchers?.length > 0 ? {
            ...values,
            vouchers: []
        } : values;
        setFieldValue('priceIsLoading', true, false);
        try {
            const priceEstimate = await (0, $135a523c4bea715f$export$6ca48d4d1c2a28c6)(valuesForEstimate, freshAvailability);
            setFieldValue('priceEstimate', priceEstimate, false);
            setFieldValue('priceToken', priceEstimate.priceToken, false);
            estimateRetries.current = 0;
            const ms = $9832901ac9096800$var$getNextTimeToRun(priceEstimate);
            if (ms) {
                clearTimeout(estimateTimeout.current);
                estimateTimeout.current = setTimeout(()=>estimatePriceRef.current?.(), ms);
            }
        } catch (error) {
            if (error.name === 'AbortError') return;
            else if (error?.response?.error === 'FIXED_PRICE_FOR_DESTINATION_NOT_FOUND' || error?.response?.error === 'FIXED_PRICE_FOR_ORIGIN_NOT_FOUND') {
                console.error(error.response);
                const message = (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language === 'sv' ? "Tyv\xe4rr ej tillg\xe4ngligt" : 'Not available';
                setFieldError('fixedPrice', message); // TODO: This error should be fetched from the JSON
                handleEstimateFailure(availabilityForRules);
            } else {
                console.error(error.response);
                if (error.status === 500) (0, $30acdccbb47e8004$export$eb122250488b74d5)((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('error-no-estimate'));
                setFieldError('fixedPrice', error?.response?.message || (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t('info-price-estimate-failed'));
                handleEstimateFailure(availabilityForRules);
            }
        }
        setFieldValue('priceIsLoading', false, false);
    };
    // Keep ref current so the scheduled timeout always invokes the latest closure
    estimatePriceRef.current = estimatePrice;
    // A failed estimate: fall back to taximeter only if the route offers it. Otherwise stay on
    // fixed price with no token (the confirm views block booking and offer a retry), drop any
    // stale token so it is never sent, and retry on our own a few times.
    const estimateRetries = (0, $bh6RR.useRef)(0);
    function handleEstimateFailure(availability) {
        if (isTaximeterOffered(availability)) {
            setFieldValue('fixedPrice', false, false);
            return;
        }
        console.warn('[Fetcher] price estimate failed and taximeter is not offered: staying on fixed price without a token');
        setFieldValue('priceEstimate', '', false);
        setFieldValue('priceToken', '', false);
        if (estimateRetries.current < 3) {
            estimateRetries.current += 1;
            clearTimeout(estimateTimeout.current);
            estimateTimeout.current = setTimeout(()=>estimatePriceRef.current?.(), 10000);
        }
    }
    // Manual retry from a confirm view after a failed estimate
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RETRY_PRICE_ESTIMATE', ()=>{
        estimateRetries.current = 0;
        estimatePriceRef.current?.();
    }, []);
    // Get priceTypes for current context:
    // - if a provider is selected (multiple-partner mode), use that provider's priceTypes
    // - otherwise fall back to the flat/aggregated priceTypes
    const getPriceTypes = (availability)=>{
        const providers = availability?.servicesByProvider;
        if (Array.isArray(providers) && values.selectedProviderId) {
            const selected = providers.find((p)=>p.providerData.providerId === values.selectedProviderId);
            if (selected) return (selected.priceAndPaymentRules?.priceTypes || []).map((0, $c94184dfef1a7d71$export$f1b9397fe7b6198c));
        }
        return ((0, $c94184dfef1a7d71$export$52403c2973de3b69)(availability)?.priceAndPaymentRules?.priceTypes || []).map((0, $c94184dfef1a7d71$export$f1b9397fe7b6198c));
    };
    const getAutoValues = (availability, estimate = null)=>{
        // Check fixed price / taximeter availability
        const normalized = (0, $c94184dfef1a7d71$export$52403c2973de3b69)(availability);
        let fixedPrice = null;
        const priceTypes = (normalized.priceAndPaymentRules?.priceTypes || []).map((0, $c94184dfef1a7d71$export$f1b9397fe7b6198c));
        const fixedPriceAvailable = priceTypes.find((item)=>item.type === 'FIXED') !== undefined;
        const taxiMeterAvailable = priceTypes.find((item)=>item.type === 'TAXIMETER') !== undefined;
        const priceAvailable = (serviceType)=>{
            return estimate.prices?.find((item)=>item.serviceType === serviceType) !== undefined;
        };
        if (fixedPriceAvailable && !taxiMeterAvailable) fixedPrice = true;
        else if (!fixedPriceAvailable && taxiMeterAvailable) fixedPrice = false;
        if (normalized?.availabilities?.length > 0) {
            const st = values.serviceType === 'estate' ? 'taxi' : values.serviceType;
            const a = normalized.availabilities.find((item)=>item.serviceType === st);
            // Check if price is available
            if (a !== undefined && a.availableAt === 'AS_REQUESTED' && estimate) {
                if (fixedPriceAvailable && taxiMeterAvailable && !priceAvailable(a.serviceType)) fixedPrice = false;
                return {
                    pickupTime: null,
                    serviceType: null,
                    fixedPrice: fixedPrice
                };
            }
            // Set pickupTime autoValue to time for matching service type
            if (a !== undefined && a.availableAt === 'DELAYED') {
                if (estimate && fixedPriceAvailable && taxiMeterAvailable && !priceAvailable(a.serviceType)) fixedPrice = false;
                return {
                    pickupTime: a.pickupTime,
                    serviceType: null,
                    fixedPrice: fixedPrice
                };
            }
            // If the selected service type is NOT_AVAILABLE, select the first available
            if (a === undefined || a.availableAt === 'NOT_AVAILABLE') {
                const b = normalized.availabilities.find((item)=>item.availableAt === 'AS_REQUESTED' || item.availableAt === 'DELAYED');
                if (b !== undefined) {
                    if (estimate && fixedPriceAvailable && taxiMeterAvailable && !priceAvailable(b.serviceType)) fixedPrice = false;
                    return {
                        pickupTime: b.pickupTime,
                        serviceType: b.serviceType,
                        fixedPrice: fixedPrice
                    };
                }
            }
        }
        return {
            pickupTime: null,
            serviceType: null,
            fixedPrice: fixedPrice,
            fixedPriceAvailable: fixedPriceAvailable
        };
    };
    // const fetchAvailability = () => {
    //   const key = values.pickupTime === '' ? 'availability.direct' : 'availability.prebook'
    //   setFieldValue('availabilityIsLoading', true, false)
    //   fetchServiceAvailability(values, user)
    //     .then((response) => {
    //       console.log(key, response)
    //       // Sort and filter the availabilities
    //       if (response?.availabilities?.length > 0) {
    //         const order = ['taxi', 'largeCar', 'business']
    //         response.availabilities = response.availabilities.filter(item => order.includes(item.serviceType))
    //         response.availabilities.sort((a, b) => {
    //           const indexA = order.indexOf(a.serviceType)
    //           const indexB = order.indexOf(b.serviceType)    
    //           if (indexA === -1 && indexB === -1) return 0
    //           else if (indexA === -1 && indexB > -1) return 1
    //           else if (indexA > -1 && indexB === -1) return -1
    //           return indexA - indexB
    //         })
    //       }
    //       setFieldValue(key, response, false)
    //       setFieldValue('availabilityIsLoading', false, false)
    //     })
    //     .catch((error) => {
    //       // NOTE: Any error but AbortError results in using the default values
    //       if (error.name !== 'AbortError') {
    //         console.error(error)
    //         // if (error.status === 500) {
    //           // Return default values depending on region
    //           console.log('We got a status 500 so using default values')
    //           const defaultAvailability = getDefaultAvailability(values.departure.address.region)
    //           console.log(defaultAvailability)
    //           setFieldValue(key, defaultAvailability, false)
    //           setFieldValue('availabilityIsLoading', false, false)
    //         // }
    //         // else {
    //         //   setFieldValue(key, false, false)
    //         //   setFieldValue('availabilityIsLoading', false, false)
    //         // }
    //       }
    //     })
    // }
    // NOTE: This is a combined version of fetch service availability and fetch estimate
    const fetchData = async ()=>{
        // First we check service availability
        let availability = false;
        const key = values.pickupTime === '' ? 'availability.direct' : 'availability.prebook';
        setFieldValue('availabilityIsLoading', true, false);
        // Pre-set priceIsLoading so the spinner shows during the availability fetch too,
        // not just after it completes. Only when we know price will be needed.
        const currentFixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
        if (currentFixedPrice && values.departure?.address && values.destination?.address && isNaN(values.bookingId)) setFieldValue('priceIsLoading', true, false);
        try {
            availability = await (0, $135a523c4bea715f$export$740face6f9071f68)(values, user);
            // TODO: Needs to handle delivery too
            // Sort and filter the availabilities (works on flat or v4 normalized view)
            const order = values.serviceType === 'delivery' ? [
                'delivery'
            ] : [
                'taxi',
                'largeCar',
                'business'
            ];
            const sortAvailabilities = (avails)=>{
                return avails.filter((item)=>order.includes(item.serviceType)).sort((a, b)=>{
                    const indexA = order.indexOf(a.serviceType);
                    const indexB = order.indexOf(b.serviceType);
                    if (indexA === -1 && indexB === -1) return 0;
                    else if (indexA === -1 && indexB > -1) return 1;
                    else if (indexA > -1 && indexB === -1) return -1;
                    return indexA - indexB;
                });
            };
            if (availability?.servicesByProvider) // v4 multi-provider: sort each provider's availabilities
            availability.servicesByProvider = availability.servicesByProvider.map((p)=>({
                    ...p,
                    availabilities: sortAvailabilities(p.availabilities || [])
                }));
            else if (availability?.availabilities?.length > 0) availability.availabilities = sortAvailabilities(availability.availabilities);
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error(error);
                // Return default values depending on region
                availability = (0, $266f81f9d9c6205b$export$2b4f7fc6d4c29758)(values.departure.address.region);
            } else return; // NOTE: If we get an AbortError we return early
        }
        // Get auto values
        const autoValues = getAutoValues(availability);
        // Then we try to fetch a price estimate
        const fixedPrice = autoValues?.fixedPrice !== null ? autoValues?.fixedPrice : values.fixedPrice;
        if (fixedPrice && values.departure?.address && values.destination?.address && isNaN(values.bookingId)) await estimatePrice(availability);
        else setFieldValue('priceIsLoading', false, false);
        setFieldValue(key, (0, $c94184dfef1a7d71$export$52403c2973de3b69)(availability), false);
        setFieldValue('availabilityIsLoading', false, false);
    };
    // const getPriceType = () => {
    //   const key = values.pickupTime === '' ? 'direct' : 'prebook'
    //   if (values.availability[key] !== false) {
    //     const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice
    //     const type = fixedPrice ? 'FIXED' : 'TAXIMETER'
    //     return values.availability[key]?.priceAndPaymentRules?.priceTypes?.find(item => item.type === type)
    //   }
    // }
    // if (values.serviceType !== 'delivery') {
    (0, $bh6RR.useEffect)(()=>{
        // NOTE: When fetching service availability we set auto values depending on what's available for selected service type etc.
        // These are used to override user selected values instead of overwriting them. For example:
        // - The user has selected to do a direct booking of a taxi but the service returns a 45 min delay
        // - We then set the pickupTime auto value to delayed pickup time and use that to show info in the booking summary
        // - If the user navigates back and selects an address that does not have a delay the auto value is removed and the pickup time
        //   is shown in the booking summary as normal (ie. direct)
        // In edit mode, check if time has changed
        const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
        const timeHasChanged = values.originalPickupTime && values.pickupTime && new Date(values.originalPickupTime).getTime() !== new Date(values.pickupTime).getTime();
        const key = values.pickupTime === '' ? 'direct' : 'prebook';
        if (values.availability[key] !== false) {
            let autoValues = getAutoValues(values.availability[key], values.priceEstimate);
            if (autoValues !== undefined) {
                if (values.destination?.address === undefined) autoValues = {
                    ...autoValues,
                    fixedPrice: false
                };
                // In edit mode with unchanged time, don't set delayed pickupTime autoValue
                // The original booking time is valid even if it would be delayed now
                if (inEditMode && !timeHasChanged && autoValues.pickupTime !== null) autoValues = {
                    ...autoValues,
                    pickupTime: null
                };
                setFieldValue('autoValues', autoValues, false);
            }
        }
    }, [
        values.availability,
        values.serviceType,
        values.priceEstimate
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const key = values.pickupTime === '' ? 'direct' : 'prebook';
        if (values.availability[key] !== false) {
            const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
            const type = fixedPrice ? 'FIXED' : 'TAXIMETER';
            const priceType = getPriceTypes(values.availability[key]).find((item)=>item.type === type);
            if (priceType !== undefined) {
                setFieldValue('priceType', priceType, false);
                // Check if PayInCar is selected and available
                if (values.payment === 'PayInCar' && priceType.paymentMethods.includes('PayInCar')) // PayInCar is valid, keep it
                hasDefaultedPayment.current = false;
                else if (values.payment === 'PayInCar') {
                    // PayInCar was selected but is no longer available for this route/provider — reset
                    hasDefaultedPayment.current = true;
                    setFieldValue('payment', 'DefaultNoSelect', false);
                    setFieldValue('account', false, false);
                } else if (values?.account && values?.account !== false) {
                    let isAvailable = false;
                    if (values.account?.type === 'creditcard' && priceType.paymentMethods.includes('CreditCard') || values.account?.type === 'TCA' && priceType.paymentMethods.includes('TravelClearingAccount') || values.account?.type === 'TSAB' && priceType.paymentMethods.includes('TSABAccount')) isAvailable = true;
                    if (values?.account?.restrictedToCompanyId && values.account?.restrictedToCompanyId !== values?.company?.id) isAvailable = false;
                    if (!isAvailable) {
                        hasDefaultedPayment.current = true;
                        setFieldValue('payment', 'DefaultNoSelect', false);
                    } else if (hasDefaultedPayment.current) {
                        const preferredPayment = values.isCompanyTrip ? currentPaymentAccountCompany || preferredPaymentAccountCompany : currentPaymentAccount || preferredPaymentAccount;
                        const preferredMethod = values.isCompanyTrip ? currentPaymentMethodCompany || preferredPaymentMethodCompany : currentPaymentMethod || preferredPaymentMethod;
                        // Restore PayInCar if preferred
                        if (preferredMethod === 'PayInCar' && priceType.paymentMethods.includes('PayInCar')) {
                            hasDefaultedPayment.current = false;
                            setFieldValue('payment', 'PayInCar', false);
                            setFieldValue('account', false, false);
                        } else if (preferredPayment && preferredPayment !== false) {
                            hasDefaultedPayment.current = false;
                            setFieldValue('payment', getPaymentType(preferredPayment), false);
                            setFieldValue('account', preferredPayment, false);
                        }
                    }
                }
            } else setFieldValue('priceType', false, false);
        }
    }, [
        values.availability,
        values.fixedPrice,
        values.autoValues.fixedPrice,
        values.selectedProviderId
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const key = values.pickupTime === '' ? 'direct' : 'prebook';
        if (values.availability[key] !== false) {
            const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
            const type = fixedPrice ? 'FIXED' : 'TAXIMETER';
            const priceType = getPriceTypes(values.availability[key]).find((item)=>item.type === type);
            if (priceType !== undefined) {
                // Get the appropriate payment based on isCompanyTrip
                const preferredPayment = values.isCompanyTrip ? currentPaymentAccountCompany || preferredPaymentAccountCompany : currentPaymentAccount || preferredPaymentAccount;
                const preferredMethod = values.isCompanyTrip ? currentPaymentMethodCompany || preferredPaymentMethodCompany : currentPaymentMethod || preferredPaymentMethod;
                // Check if PayInCar is preferred and available
                if (preferredMethod === 'PayInCar' && priceType.paymentMethods.includes('PayInCar')) {
                    hasDefaultedPayment.current = false;
                    setFieldValue('payment', 'PayInCar', false);
                    setFieldValue('account', false, false);
                } else if (preferredPayment && preferredPayment !== false) {
                    let isAvailable = false;
                    if (preferredPayment?.type === 'creditcard' && priceType.paymentMethods.includes('CreditCard') || preferredPayment?.type === 'TCA' && priceType.paymentMethods.includes('TravelClearingAccount') || preferredPayment?.type === 'TSAB' && priceType.paymentMethods.includes('TSABAccount')) isAvailable = true;
                    if (preferredPayment?.restrictedToCompanyId && preferredPayment.restrictedToCompanyId !== values?.company?.id) isAvailable = false;
                    if (isAvailable) {
                        hasDefaultedPayment.current = false;
                        setFieldValue('payment', getPaymentType(preferredPayment), false);
                        setFieldValue('account', preferredPayment, false);
                    } else {
                        setFieldValue('payment', 'DefaultNoSelect', false);
                        setFieldValue('account', false, false);
                    }
                } else {
                    setFieldValue('payment', 'DefaultNoSelect', false);
                    setFieldValue('account', false, false);
                }
            } else setFieldValue('priceType', false, false);
        }
    }, [
        values.isCompanyTrip
    ]);
    // }
    (0, $bh6RR.useEffect)(()=>{
        const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
        if (fixedPrice && values.departure?.address && values.destination?.address) {
            if (isNaN(values.bookingId)) estimatePrice();
        } else {
            clearTimeout(estimateTimeout.current);
            if (values.priceEstimate) {
                setFieldValue('priceEstimate', '', false);
                setFieldValue('priceToken', '', false);
            }
        }
        return ()=>{
            clearTimeout(estimateTimeout.current);
        };
    }, [
        values.fixedPrice,
        values.vouchers,
        values.company
    ]);
    (0, $bh6RR.useEffect)(()=>{
        // if (values.serviceType !== 'delivery') {
        if (values.departure?.address) // fetchAvailability()
        fetchData();
        else {
            setFieldValue('availability', {
                direct: false,
                prebook: false
            }, false);
            setFieldValue('autoValues', {
                pickupTime: null,
                serviceType: null,
                fixedPrice: null
            }, false);
            if (values.priceEstimate) {
                setFieldValue('priceEstimate', '', false);
                setFieldValue('priceToken', '', false);
            }
        }
    // }
    }, [
        values.departure,
        values.destination,
        values.intermediateStopLocations,
        values.pickupTime,
        values.account?.accountNumber,
        user?.phone,
        values.rearFacingChildSeat
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (!isNaN(values.bookingId)) clearTimeout(estimateTimeout.current);
    }, [
        values.bookingId
    ]);
    // Clear selected add-ons that are no longer available for the current service type / provider.
    // Runs whenever serviceType, provider, or availability changes (but not in edit mode).
    (0, $bh6RR.useEffect)(()=>{
        const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0;
        if (inEditMode) return;
        // The return trip sheet only prebooks; the direct availability fetched while its time is
        // still unset (e.g. none at all from Arlanda) must not strip the carried-over add-ons.
        if (values.returnTripBooking && values.pickupTime === '') return;
        const available = (0, $c94184dfef1a7d71$export$45f0d338a0ae68ff)(values);
        if (values.pet && !available.includes('pet')) setFieldValue('pet', false, false);
        if (values.booster > 0 && !available.includes('boosterSeat1')) setFieldValue('booster', 0, false);
        else if (values.booster >= 2 && !available.includes('boosterSeat2')) setFieldValue('booster', 1, false);
        if (values.rearFacingChildSeat && !available.includes('rearFacingChildSeat')) setFieldValue('rearFacingChildSeat', false, false);
        if (values.electric && !available.includes('electric')) setFieldValue('electric', false, false);
    }, [
        values.serviceType,
        values.autoValues.serviceType,
        values.selectedProviderId,
        values.availability
    ]);
    return null;
}




const $200ec6b1b2ca8c5a$export$fe5fefca77a22da9 = 'Europe/Stockholm';
const $200ec6b1b2ca8c5a$export$e81c0ab3e024f31c = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9, "yyyy-MM-dd'T'HH:mm");
const $200ec6b1b2ca8c5a$export$1b924e9768a965ac = (value)=>(0, $00960a1f81ae1cda$export$2e2bcd8739ae039)(`${value}:00`, {
        timeZone: $200ec6b1b2ca8c5a$export$fe5fefca77a22da9
    });
const $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9, "yyyy-MM-dd'T'HH:mm:ssxxx");
const $200ec6b1b2ca8c5a$export$a2b50b91b78100e5 = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9, 'yyyy-MM-dd HH:mm');
const $200ec6b1b2ca8c5a$export$f0a889078b7435f7 = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9, 'yyyy-MM-dd');
const $200ec6b1b2ca8c5a$export$3203edd9e5edd663 = (date)=>(0, $135a487cc5b2c57a$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9, 'HH:mm');
const $200ec6b1b2ca8c5a$export$f611f5bcc300bb4d = (date)=>APP.lang === 'sv' ? (0, $k0Sb0.default)(date, 'do MMMM \'kl.\' p', {
        locale: (0, $328fea4f4b85c31f$export$2e2bcd8739ae039)
    }) : (0, $k0Sb0.default)(date, 'do MMMM p');
const $200ec6b1b2ca8c5a$export$9bca676dbeee7bf1 = (date)=>{
    date = (0, $d3fd156832cf6168$export$2e2bcd8739ae039)(date, $200ec6b1b2ca8c5a$export$fe5fefca77a22da9);
    const now = (0, $d3fd156832cf6168$export$2e2bcd8739ae039)(new Date(), $200ec6b1b2ca8c5a$export$fe5fefca77a22da9);
    if ((0, $fxy8a.default)(date, now) < 2) return APP.lang === 'sv' ? (0, $5910869d63631745$export$2e2bcd8739ae039)(date, now, {
        locale: (0, $328fea4f4b85c31f$export$2e2bcd8739ae039)
    }) : (0, $5910869d63631745$export$2e2bcd8739ae039)(date, now);
    return $200ec6b1b2ca8c5a$export$f611f5bcc300bb4d(date);
};
const $200ec6b1b2ca8c5a$export$c1fb9bac27b52cdd = (user)=>{
    let userName = '';
    if (user && user.firstName !== undefined) userName += user.firstName;
    if (user && user.lastName !== undefined) userName += userName !== '' ? ' ' + user.lastName : user.lastName;
    return userName;
};
const $200ec6b1b2ca8c5a$export$842dcfa371c6bb83 = (value, defaultDialCode = '+46')=>{
    const phone = (value || '').replace(/[\s\-()./]/g, '');
    if (phone.startsWith('+')) return phone;
    if (phone.startsWith('00')) return '+' + phone.substr(2);
    return defaultDialCode + phone.replace(/^0/, '');
};
function $200ec6b1b2ca8c5a$export$9ab766ce7f4c1f3c(address, streetNumber) {
    if (streetNumber) return `${address.streetName} ${streetNumber}${address.city ? ', ' + address.city : ''}`;
    return `${address.streetName}${address.streetNumber ? ' ' + address.streetNumber : ''}${address.entrance ? ' ' + address.entrance : ''}${address.city ? ', ' + address.city : ''}`;
}
function $200ec6b1b2ca8c5a$export$571ef001d6700da3(location) {
    const sa = [];
    if (location?.address) {
        const a = location.address;
        if (a?.streetName) sa.push(a?.streetName);
        if (a?.streetNumber) {
            let sn = a?.streetNumber;
            if (a?.entrance) sn += a?.entrance;
            sa.push(sn);
        }
    }
    return sa.join(' ');
}
function $200ec6b1b2ca8c5a$export$d4d145b6a34ea737(location) {
    const title = [];
    const subtitle = [];
    const sa = $200ec6b1b2ca8c5a$export$571ef001d6700da3(location);
    if (location?.locationType !== 'STREET' && (location?.address?.poiName || location?.name)) {
        title.push(location.name || location.address.poiName);
        if (sa) subtitle.push(sa);
    } else if (sa) title.push(sa);
    if (location?.address?.city) subtitle.push(location?.address?.city);
    if (location?.address?.municipality && !subtitle.includes(location?.address?.municipality)) subtitle.push(location?.address?.municipality);
    return {
        title: title.join(' '),
        subtitle: subtitle.join(', ')
    };
}
function $200ec6b1b2ca8c5a$export$5964fc5149281592(location) {
    const title = [];
    if (location?.locationType !== 'STREET' && (location?.address?.poiName || location?.name)) title.push(location.name || location.address.poiName);
    else {
        const sa = $200ec6b1b2ca8c5a$export$571ef001d6700da3(location);
        if (sa) title.push(sa);
    }
    if (location?.address?.city) title.push(location?.address?.city);
    return title.join(', ');
}
function $200ec6b1b2ca8c5a$export$89cb1f143bf63d66(location) {
    if (location.id) return location.id;
    else if (location.locationId) return location.locationId;
    else {
        const address = location.address;
        return `${address.streetName}${address.streetNumber ? ' ' + address.streetNumber : ''}${address.entrance ? ' ' + address.entrance : ''}${address.city ? ' ' + address.city : ''}`;
    }
}
function $200ec6b1b2ca8c5a$var$formatLocationForRequest(location) {
    return {
        id: $200ec6b1b2ca8c5a$export$89cb1f143bf63d66(location),
        ...location.address
    };
}
function $200ec6b1b2ca8c5a$export$4b437a92b222d4ba(location) {
    if (location.id) return location.id;
    else {
        const address = location.address;
        return `${address.streetName}${address.streetNumber ? ' ' + address.streetNumber : ''}${address.entrance ? address.entrance : ''}${address.city ? ', ' + address.city : ''}`;
    }
}
function $200ec6b1b2ca8c5a$export$d43985a4ce6e5677(values, user) {
    const params = new URLSearchParams();
    // formatLocationId takes the location (id / locationId / address), not the bare address:
    // handing it the address threw on `address.address.streetName` for any location without an id.
    if (values.departure?.address) params.append('fromLocationId', $200ec6b1b2ca8c5a$export$89cb1f143bf63d66(values.departure));
    if (values.destination?.address) params.append('toLocationId', $200ec6b1b2ca8c5a$export$89cb1f143bf63d66(values.destination));
    if (values?.intermediateStopLocations?.length > 0) {
        const stops = values.intermediateStopLocations.filter((location)=>location?.address !== undefined);
        if (stops.length > 0) params.append('intermediateLocationIdList', stops.map((location)=>$200ec6b1b2ca8c5a$export$89cb1f143bf63d66(location)).toString());
    }
    if (values.pickupTime !== '') params.append('dateTime', $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b(values.pickupTime));
    if (user && user?.phone !== '') params.append('phone', user.phone);
    if (values?.account?.accountNumber && values?.account?.type) {
        params.append('accountNumber', values.account.accountNumber);
        params.append('accountType', values.account.type);
    }
    return params.toString();
}
function $200ec6b1b2ca8c5a$export$3b2336224517b4a7(values, freshAvailability = null) {
    const booking = {
        // originLocation: filterAddress(values.departure.address),
        // destinationLocation: filterAddress(values.destination.address),
        originLocation: $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.departure),
        destinationLocation: $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.destination),
        serviceTypes: values.serviceType === 'delivery' ? [
            'delivery'
        ] : [
            'taxi',
            'largeCar',
            'business'
        ]
    };
    // v4: include providerIds for all available providers
    // freshAvailability is passed when called right after fetching (before formik state updates)
    const key = values.pickupTime === '' ? 'direct' : 'prebook';
    const avail = freshAvailability || values.availability?.[key];
    const servicesByProvider = avail?.servicesByProvider;
    if (Array.isArray(servicesByProvider) && servicesByProvider.length > 0) booking.providerIds = servicesByProvider.map((p)=>p.providerData.providerId);
    if (values.pickupTime || values.autoValues.pickupTime) booking.pickUpTimeStamp = $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b(values.autoValues.pickupTime || values.pickupTime);
    // Private or company trip?
    if (values.company) booking.companyId = values.company.id;
    if (values?.vouchers?.length > 0) booking.voucherCodes = values.vouchers;
    if (values?.intermediateStopLocations?.length > 0) {
        const stops = values.intermediateStopLocations.filter((location)=>location?.address !== undefined);
        if (stops.length > 0) // booking.intermediateStopLocations = stops.map(location => filterAddress(location.address))
        booking.intermediateStopLocations = stops.map($200ec6b1b2ca8c5a$var$formatLocationForRequest);
    }
    booking.vehicleOptions = $200ec6b1b2ca8c5a$export$1611752a0119c53a(values);
    return booking;
}
function $200ec6b1b2ca8c5a$export$1611752a0119c53a(values) {
    const chargableOptions = [];
    if (values.rearFacingChildSeat) chargableOptions.push('rearFacingChildSeat');
    return chargableOptions;
}
function $200ec6b1b2ca8c5a$export$d2312e68e1f5ad00(values) {
    const options = [];
    if (values.pet) options.push('pet');
    if (values.low) options.push('low');
    if (values.stationWagon) options.push('stationWagon');
    if (values.rearFacingChildSeat) options.push('rearFacingChildSeat');
    if (values.booster === 1) options.push('boosterSeat1');
    if (values.booster === 2) options.push('boosterSeat2');
    if (values.electric) options.push('electric');
    return options;
}
function $200ec6b1b2ca8c5a$export$4671b48bb978508b(values) {
    const packages = [];
    if (values.ENVELOPE) packages.push({
        packageType: 'ENVELOPE',
        count: values.ENVELOPE
    });
    if (values.BOX) packages.push({
        packageType: 'BOX',
        count: values.BOX
    });
    if (values.BAG) packages.push({
        packageType: 'BAG',
        count: values.BAG
    });
    if (values.MOVING_BOX) packages.push({
        packageType: 'MOVING_BOX',
        count: values.MOVING_BOX
    });
    return packages;
}
function $200ec6b1b2ca8c5a$export$9f1f9dfacc50ba0(values, userId) {
    const serviceType = (values.autoValues.serviceType || values.serviceType) === 'estate' ? 'taxi' : values.autoValues.serviceType || values.serviceType;
    const options = $200ec6b1b2ca8c5a$export$d2312e68e1f5ad00(values);
    if ((values.autoValues.serviceType || values.serviceType) === 'estate') options.push('stationWagon');
    const booking = {
        originLocation: $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.departure),
        serviceType: serviceType,
        traveler: {
            name: values.name,
            phoneNumber: values.phone,
            ...(0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'TRAVELER_COUNT_REQUIRED') && values.passengerCount > 0 ? {
                travelerCount: values.passengerCount
            } : {}
        },
        generalComment: values.generalComment,
        userId: userId,
        vehicleOptions: options
    };
    // Got destination?
    if (values.destination?.address) booking.destinationLocation = $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.destination);
    // Skip pickup time when direct booking
    if (values.pickupTime || values.autoValues.pickupTime) booking.pickUpTimeStamp = $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b(values.autoValues.pickupTime || values.pickupTime);
    // Private or company trip?
    if (values.company) booking.companyId = values.company.id;
    // Add intermediate stops
    if (values?.intermediateStopLocations?.length > 0) booking.intermediateStopLocations = values.intermediateStopLocations.map($200ec6b1b2ca8c5a$var$formatLocationForRequest);
    // Airport - only include flightInfo for pre-bookings, not direct bookings
    if ((0, $c94184dfef1a7d71$export$a33cf11b13c37ea0)(values, 'FLIGHT_NBR') && values.pickupTime !== '') booking.originLocation.flightInfo = {
        flightNumber: values.flightNumber,
        checkedInBaggage: values.checkedInBaggage
    };
    // Fixed price?
    const fixedPrice = values.autoValues.fixedPrice !== null ? values.autoValues.fixedPrice : values.fixedPrice;
    if (fixedPrice && values.priceToken) booking.priceToken = values.priceToken;
    // Add service availability token
    const key = values.pickupTime === '' ? 'direct' : 'prebook';
    const availData = values?.availability[key];
    if (availData?.servicesByProvider) {
        // v4: serviceToken is per-provider. Use the selected provider's token; when no provider
        // is explicitly selected (e.g. single-TSAB route where the partner section is hidden),
        // fall back to the first (and only) provider so the token is never silently dropped.
        const providerId = values.selectedProviderId || availData.servicesByProvider[0]?.providerData?.providerId;
        const selectedProvider = availData.servicesByProvider.find((p)=>p.providerData.providerId === providerId);
        if (selectedProvider?.serviceToken) booking.serviceToken = selectedProvider.serviceToken;
    } else if (availData?.serviceToken) booking.serviceToken = availData.serviceToken;
    // Payment
    if (values.payment.indexOf('Account') !== -1) {
        booking.paymentMethod = values.account.type === 'TCA' ? 'TravelClearingAccount' : 'TSABAccount';
        booking.accountInfo = {
            type: values.account.type,
            number: values.account.accountNumber
        };
    } else if (values.payment.indexOf('CreditCard') !== -1) booking.paymentMethod = 'CreditCard';
    else booking.paymentMethod = 'PayInCar';
    // Add reference
    if (values.company || values.payment.indexOf('Account') !== -1) booking.invoiceReference = values.accountReference;
    // Vouchers
    if (values?.vouchers?.length > 0) booking.voucherCodes = values.vouchers;
    // Return trip: link back to the original booking (from its returnTripRules) so the
    // backend can register this booking as a return trip. See docs/RETURNTRIP.md.
    if (values.originalBookingReference) booking.originalBookingReference = values.originalBookingReference;
    return booking;
}
function $200ec6b1b2ca8c5a$export$feb758fb830fa6ed(values) {
    const editableFields = values.editableFields || [];
    const request = {};
    // Traveler info - always send if exists (either modified or original)
    const hasEditableName = editableFields.includes('traveler.name');
    const hasEditablePhone = editableFields.includes('traveler.phoneNumber');
    const hasOriginalName = values.booking?.traveler?.name;
    const hasOriginalPhone = values.booking?.traveler?.phoneNumber;
    if (hasEditableName || hasEditablePhone || hasOriginalName || hasOriginalPhone) {
        request.traveler = {};
        // Send name if editable (use current value) or if it existed originally
        if (hasEditableName) request.traveler.name = values.name;
        else if (hasOriginalName) request.traveler.name = values.booking.traveler.name;
        // Send phone if editable (use current value) or if it existed originally
        if (hasEditablePhone) request.traveler.phoneNumber = values.phone;
        else if (hasOriginalPhone) request.traveler.phoneNumber = values.booking.traveler.phoneNumber;
    }
    // General comment - always send if exists (either modified or original)
    if (editableFields.includes('generalComment')) // If editable, use current value (could be empty if user cleared it)
    {
        if (values.generalComment) request.generalComment = values.generalComment;
    } else if (values.booking?.generalComment) // If not editable, use original value
    request.generalComment = values.booking.generalComment;
    // Origin location - always include if we have it
    if (values.departure?.address) request.originLocation = $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.departure);
    // Flight info - always include if there's data, even if not editable
    // The API requires these fields to be present in edit requests when they exist
    const hasFlightNumber = values.flightNumber && values.flightNumber.trim() !== '';
    const hasCheckedBaggage = values.checkedInBaggage === true;
    if (hasFlightNumber || hasCheckedBaggage) {
        if (!request.originLocation) request.originLocation = {};
        request.originLocation.flightInfo = {};
        if (hasFlightNumber) request.originLocation.flightInfo.flightNumber = values.flightNumber;
        if (hasCheckedBaggage !== undefined) request.originLocation.flightInfo.checkedInBaggage = hasCheckedBaggage;
    }
    // Destination location - always include if we have it
    if (values.destination?.address) request.destinationLocation = $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.destination);
    // Vehicle options - always send them (either modified or original)
    if (editableFields.includes('vehicleOptions')) {
        // If editable, use the current form values
        const serviceType = (values.autoValues.serviceType || values.serviceType) === 'estate' ? 'taxi' : values.autoValues.serviceType || values.serviceType;
        const options = $200ec6b1b2ca8c5a$export$d2312e68e1f5ad00(values);
        if ((values.autoValues.serviceType || values.serviceType) === 'estate') options.push('stationWagon');
        request.vehicleOptions = options;
    } else if (values.booking?.vehicleOptions) // If not editable, use the original booking's vehicleOptions
    request.vehicleOptions = values.booking.vehicleOptions;
    // Invoice reference - always send if exists (either modified or original)
    if (editableFields.includes('invoiceReference')) // If editable, use current value (could be empty if user cleared it)
    {
        if (values.accountReference && values.accountReference.trim() !== '') request.invoiceReference = values.accountReference;
    } else if (values.booking?.invoiceReference) // If not editable, use original value
    request.invoiceReference = values.booking.invoiceReference;
    // Pickup timestamp - always include if there's a value, even if not editable
    // The API requires pickUpTimeStamp to be present in edit requests
    if (values.pickupTime || values.autoValues.pickupTime) {
        // In edit mode with unchanged time, use original pickupTime, not autoValues
        const timeToUse = editableFields.includes('pickUpTimeStamp') ? values.autoValues.pickupTime || values.pickupTime : values.pickupTime;
        request.pickUpTimeStamp = $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b(timeToUse);
    }
    return request;
}
function $200ec6b1b2ca8c5a$export$7445ab76c6ed2f59(values, userId) {
    // TODO: Skip pickup time when direct booking?
    const pickup = values.pickupTime ? values.pickupTime : (0, $8MQJ5.default)(new Date(), 1);
    const booking = {
        pickUpTimeStamp: $200ec6b1b2ca8c5a$export$bfe4ac50319c1d9b(pickup),
        originLocation: $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.departure),
        destinationLocation: $200ec6b1b2ca8c5a$var$formatLocationForRequest(values.destination),
        serviceType: values.serviceType,
        traveler: {
            name: values.name,
            phoneNumber: values.phone
        },
        userId: userId,
        priceToken: values.priceToken,
        packageDeliveryInfo: values.packageDeliveryInfo
    };
    // Do not send empty strings
    if (booking.packageDeliveryInfo.packageSender.nameOnDoor === '') booking.packageDeliveryInfo.packageSender.nameOnDoor = values.name;
    if (booking.packageDeliveryInfo.packageSender.numberOfStairs === '') delete booking.packageDeliveryInfo.packageSender.numberOfStairs;
    if (booking.packageDeliveryInfo.packageSender.doorCode === '') delete booking.packageDeliveryInfo.packageSender.doorCode;
    if (booking.packageDeliveryInfo.packageReceiver.numberOfStairs === '') delete booking.packageDeliveryInfo.packageReceiver.numberOfStairs;
    if (booking.packageDeliveryInfo.packageReceiver.doorCode === '') delete booking.packageDeliveryInfo.packageReceiver.doorCode;
    // Packages
    const packages = [];
    if (values.ENVELOPE > 0) packages.push({
        packageType: 'ENVELOPE',
        count: values.ENVELOPE
    });
    if (values.BOX > 0) packages.push({
        packageType: 'BOX',
        count: values.BOX
    });
    if (values.BAG > 0) packages.push({
        packageType: 'BAG',
        count: values.BAG
    });
    if (values.MOVING_BOX > 0) packages.push({
        packageType: 'MOVING_BOX',
        count: values.MOVING_BOX
    });
    booking.packageDeliveryInfo.packages = packages;
    // Payment. Only send an account when one is actually selected; otherwise the
    // request would carry an empty accountInfo and the booking service rejects it.
    if (values.payment?.indexOf('Account') !== -1 && values.account?.accountNumber) {
        booking.paymentMethod = values.account.type === 'TCA' ? 'TravelClearingAccount' : 'TSABAccount';
        booking.accountInfo = {
            type: values.account.type,
            number: values.account.accountNumber
        };
        booking.invoiceReference = values.accountReference;
    } else booking.paymentMethod = 'PayInCar';
    return booking;
}
function $200ec6b1b2ca8c5a$export$49b5cab8367c3ef1(bookings) {
    return bookings.map((booking)=>{
        // NOTE: Support anonymous bookings using the clientBookingToken
        return booking.clientBookingToken ? {
            bookingId: booking.id,
            clientBookingToken: booking.clientBookingToken
        } : {
            bookingId: booking.id
        };
    });
}


var $6c47697536ae309f$exports = {};
$6c47697536ae309f$exports = JSON.parse('{"*":{"NETWORK_ERROR":{"en":"We couldn\'t reach the server. Check your connection and try again","sv":"Vi kunde inte n\xe5 servern. Kontrollera din uppkoppling och f\xf6rs\xf6k igen"},"INTERNAL_SERVER_ERROR":{"en":"Something went wrong on our end. Please try again in a moment","sv":"N\xe5got gick fel hos oss. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"BAD_GATEWAY_ERROR":{"en":"The service is temporarily unavailable. Please try again in a moment","sv":"Tj\xe4nsten \xe4r tillf\xe4lligt otillg\xe4nglig. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"SERVICE_UNAVAILABLE_ERROR":{"en":"The service is temporarily unavailable. Please try again in a moment","sv":"Tj\xe4nsten \xe4r tillf\xe4lligt otillg\xe4nglig. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"GATEWAY_TIMEOUT_ERROR":{"en":"The request took too long. Please try again","sv":"Det tog f\xf6r l\xe5ng tid att f\xe5 svar. Var v\xe4nlig f\xf6rs\xf6k igen"},"REQUEST_TIMEOUT_ERROR":{"en":"The request took too long. Please try again","sv":"Det tog f\xf6r l\xe5ng tid att f\xe5 svar. Var v\xe4nlig f\xf6rs\xf6k igen"},"TOO_MANY_REQUESTS":{"en":"Too many attempts. Please wait a moment and try again","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k. Var v\xe4nlig v\xe4nta en stund och f\xf6rs\xf6k igen"},"TOO_MANY_REQUESTS_ERROR":{"en":"Too many attempts. Please wait a moment and try again","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k. Var v\xe4nlig v\xe4nta en stund och f\xf6rs\xf6k igen"},"NOT_FOUND_ERROR":{"en":"We couldn\'t find what you were looking for","sv":"Vi kunde inte hitta det du s\xf6kte"},"FORBIDDEN_ERROR":{"en":"You don\'t have permission to do this","sv":"Du har tyv\xe4rr inte beh\xf6righet att g\xf6ra det h\xe4r"},"BAD_REQUEST_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"BAD_REQUEST":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"*status":{"400":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"403":{"en":"You don\'t have permission to do this","sv":"Du har tyv\xe4rr inte beh\xf6righet att g\xf6ra det h\xe4r"},"404":{"en":"We couldn\'t find what you were looking for","sv":"Vi kunde inte hitta det du s\xf6kte"},"408":{"en":"The request took too long. Please try again","sv":"Det tog f\xf6r l\xe5ng tid att f\xe5 svar. Var v\xe4nlig f\xf6rs\xf6k igen"},"429":{"en":"Too many attempts. Please wait a moment and try again","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k. Var v\xe4nlig v\xe4nta en stund och f\xf6rs\xf6k igen"},"500":{"en":"Something went wrong on our end. Please try again in a moment","sv":"N\xe5got gick fel hos oss. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"502":{"en":"The service is temporarily unavailable. Please try again in a moment","sv":"Tj\xe4nsten \xe4r tillf\xe4lligt otillg\xe4nglig. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"503":{"en":"The service is temporarily unavailable. Please try again in a moment","sv":"Tj\xe4nsten \xe4r tillf\xe4lligt otillg\xe4nglig. Var v\xe4nlig f\xf6rs\xf6k igen om en liten stund"},"504":{"en":"The request took too long. Please try again","sv":"Det tog f\xf6r l\xe5ng tid att f\xe5 svar. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/accounts/{accountId}/validate":{"INVALID_ACCOUNT":{"en":"Account was not found","sv":"Kontot finns inte"},"ACCOUNT_LOCKED":{"en":"Account is locked because of too many failed login attempts, try again later","sv":"Taxikontot \xe4r l\xe5st p\xe5 grund av f\xf6r m\xe5nga misslyckade inloggningsf\xf6rs\xf6k, f\xf6rs\xf6k igen senare"},"WRONG_PASSWORD":{"en":"Invalid password, please try again","sv":"L\xf6senordet \xe4r felaktigt, var v\xe4nlig f\xf6rs\xf6k igen"},"WRONG_PASSWORD_LAST_RETRY":{"en":"There is only one password attempt left","sv":"Det \xe4r bara ett inloggningsf\xf6rs\xf6k kvar"}},"/users/{userId}/accounts":{"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"ACCOUNT_ERROR":{"en":"It was not possible to add the account","sv":"Det gick inte att l\xe4gga till Taxi Stockholm kontot"},"ACCOUNT_TEMPORARILY_BLOCKED_ERROR":{"en":"Too many attempts, the account is temporarily blocked","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om en stund"}},"/users/{userId}/accounts/{accountNumber}":{"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"ACCOUNT_NOT_CONNECTED_TO_USER":{"en":"Account not found","sv":"Taxi Stockholm kontot finns inte"}},"/bookings":{"INVALID_PHONE_NUMBER":{"en":"The phone number provided is not in a correct format","sv":"Telefonnumret har fel format"},"INVALID_DEPARTURE_ADDRESS":{"en":"Departure address is unknown","sv":"Ok\xe4nd h\xe4mtadress"},"INVALID_DESTINATION_ADDRESS":{"en":"Destination address is unknown","sv":"Ok\xe4nd destinationsadress"},"INVALID_BOOKING_DATETIME":{"en":"The selected datetime is too far ahead","sv":"Den valda tidpunkten ligger f\xf6r l\xe5ngt fram i tiden"},"INVALID_SERVICE_TYPE_ESTIMATE":{"en":"Fixed price is not available","sv":"Fastpris \xe4r tyv\xe4rr inte tillg\xe4ngligt"},"INVALID_PRICE_TOKEN":{"en":"Fixed price is not available, please try again","sv":"Fastpriset \xe4r tyv\xe4rr inte tillg\xe4ngligt,var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_EXTERNAL_USER_ID":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_USER_ID":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"MISSING_INTERNAL_BOOKING_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_REQUEST_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"ACCOUNT_NOT_FOUND":{"en":"Account not found","sv":"Kontot finns inte"},"UNMATCHED_ACCOUNT_NUMBER":{"en":"Account not found","sv":"Kontot finns inte"},"PASSWORD_IS_NOT_STORED":{"en":"Password is missing for the account","sv":"L\xf6senord saknas f\xf6r ditt Taxi Stockholm konto"},"INVALID_PAYMENT_METHOD":{"en":"Payment method is required","sv":"F\xf6r att boka kr\xe4vs en betalningsmetod"},"FIXED_PRICE_REQUIRED":{"en":"Only fixed price is available for this trip","sv":"Endast fastpris \xe4r tillg\xe4ngligt f\xf6r denna resa"},"FIXED_PRICE_OR_PRICE_TOKEN_REQUIRED":{"en":"Only fixed price is available for this trip","sv":"Endast fastpris \xe4r tillg\xe4ngligt f\xf6r denna resa"},"BOOKING_ADDRESS_OR_TIME_MISMATCH_WITH_PRICE_ESTIMATE":{"en":"Fixed price is not available, please try again","sv":"Fastpris \xe4r tyv\xe4rr inte tillg\xe4ngligt,var v\xe4nlig f\xf6rs\xf6k igen"},"ACCOUNT_NUMBER_REQUIRED":{"en":"Account number is required","sv":"Var v\xe4nlig ange Taxi Stockholm konto"},"DESTINATION_REQUIRED":{"en":"Your TSAB account require a specified destination","sv":"F\xf6r att kunna boka med ditt TSAB konto s\xe5 beh\xf6ver du ange en destination f\xf6r din resa"},"UNMAPPED_TTES_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"RESTRICTED_DEPARTURE_FOR_DIRECT_BOOKING":{"en":"Unfortunately we are not able to handle direct bookings from Arlanda in the app. If you want a car right away please contact us on 08-15 00 00. You are always welcome to prebook a cab from Arlanda in the app.","sv":"Tyv\xe4rr kan vi inte ta emot direktbest\xe4llningar fr\xe5n Arlanda i appen. om du vill ha en taxi omg\xe5ende v\xe4nligen ring oss p\xe5 08-15 00 00. Du \xe4r alltid v\xe4lkommen att f\xf6rboka en taxi fr\xe5n Arlanda via appen."},"NO_TAXI_AVAILABLE":{"en":"We cannot accept any more pre-bookings at the selected time, please choose another time","sv":"Vi kan tyv\xe4rr inte ta emot fler f\xf6rbokningar den valda tiden, var v\xe4nlig v\xe4lj en annan tid"},"OVERLOADED":{"en":"Right now all our cars are occupied. However, you can make a pre-booking or try again later.","sv":"Just nu \xe4r alla v\xe5ra bilar upptagna. Du kan d\xe4remot g\xf6ra en f\xf6rbokning eller prova igen senare."},"INCOMPARABLE_VEHICLE_OPTION_WITH_SERVICE_TYPE":{"en":"This service_type dont allow using the specified vehicle option","sv":"Du kan tyv\xe4rr inte v\xe4lja denna biltyp"},"MULTIPLE_ONGOING_APPRIDE_BOOKINGS":{"en":"You have an active Appride booking, At the moment, you can only have one active Appride booking at a time. If you want more cars, please call our customer service.","sv":"Du har en aktiv appride bokning, Just nu kan du endast ha en aktiv Appride bokning i taget. Om du vill ha fler bilar, v\xe4nligen ring v\xe5r v\xe4xel."},"NOT_ALLOWED_INTERMEDIATE_STOPS":{"en":"Intermediate stops are not allowed for this booking","sv":"Tyv\xe4rr s\xe5 \xe4r via-adresser inte till\xe5tna f\xf6r denna resa"}},"/bookings/prepare":{"MULTIPLE_ONGOING_APPRIDE_BOOKINGS":{"en":"You have an active Appride booking, At the moment, you can only have one active Appride booking at a time. If you want more cars, please call our customer service.","sv":"Du har en aktiv appride bokning, Just nu kan du endast ha en aktiv Appride bokning i taget. Om du vill ha fler bilar, v\xe4nligen ring v\xe5r v\xe4xel."}},"/bookings/{bookingId}":{"INVALID_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_BOOKING_SEARCH_USER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_EXTERNAL_USER_ID":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_USER_ID":{"en":"Oops! Something went wrong","sv":"Oj, n\xe5got gick fel"},"MISSING_INTERNAL_BOOKING_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_REQUEST_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"Not found":{"en":"Booking not found","sv":"Bokningen kunde inte hittas"},"INVALID_PREPARE_STATUS_FOR_CANCEL":{"en":"Booking is not possible to cancel","sv":"Bokningen kunde inte avbest\xe4llas"},"INVALID_PAYMENT_STATUS_FOR_CANCEL":{"en":"Booking is not possible to cancel","sv":"Bokningen kunde inte avbest\xe4llas"},"ALREADY_COMPLETED_BOOKING":{"en":"Booking is already completed","sv":"Bokningen \xe4r redan slutf\xf6rd"},"ALREADY_CANCELLED_BOOKING":{"en":"Booking is already cancelled","sv":"Bokningen \xe4r redan avbest\xe4lld"},"NOT_ALLOWED_TO_CANCEL_BOOKING":{"en":"Booking is not possible to cancel","sv":"Bokningen kunde inte avbest\xe4llas"}},"/bookings/status":{"INVALID_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_BOOKING_SEARCH_USER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_EXTERNAL_USER_ID":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_USER_ID":{"en":"Oops! Something went wrong","sv":"Oj, n\xe5got gick fel"},"MISSING_INTERNAL_BOOKING_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_REQUEST_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"Not found":{"en":"Booking not found","sv":"Bokningen kunde inte hittas"}},"/bookings/users/{userId}":{"INVALID_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_SEARCH_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_BOOKING_SEARCH_USER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_EXTERNAL_USER_ID":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_USER_ID":{"en":"Oops! Something went wrong","sv":"Oj, n\xe5got gick fel"},"MISSING_INTERNAL_BOOKING_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_REQUEST_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"Not found":{"en":"Booking not found","sv":"Bokningen kunde inte hittas"}},"/bookings/multistop":{"INVALID_PHONE_NUMBER":{"en":"The phone number provided is not in a correct format","sv":"Telefonnumret har fel format"},"INVALID_DEPARTURE_ADDRESS":{"en":"Departure address is unknown","sv":"Ok\xe4nd h\xe4mtadress"},"INVALID_DESTINATION_ADDRESS":{"en":"Destination address is unknown","sv":"Ok\xe4nd destinationsadress"},"INVALID_BOOKING_DATETIME":{"en":"The selected datetime is too far ahead","sv":"Den valda tidpunkter ligger f\xf6r l\xe5ngt fram i tiden"},"INVALID_SERVICE_TYPE_ESTIMATE":{"en":"Fixed price is not available","sv":"Fastpris \xe4r tyv\xe4rr inte tillg\xe4ngligt"},"INVALID_PRICE_TOKEN":{"en":"Fixed price is not available, please try again","sv":"Fastpriset \xe4r tyv\xe4rr inte tillg\xe4ngligt,var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_EXTERNAL_USER_ID":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_USER_ID":{"en":"Oops! Something went wrong","sv":"Oj, n\xe5got gick fel"},"MISSING_INTERNAL_BOOKING_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_BOOKING_REQUEST_OBJECT":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"ACCOUNT_NOT_FOUND":{"en":"Account not found","sv":"Kontot finns inte"},"UNMATCHED_ACCOUNT_NUMBER":{"en":"Account not found","sv":"Kontot finns inte"},"PASSWORD_IS_NOT_STORED":{"en":"Password is missing for the account","sv":"L\xf6senord saknas f\xf6r ditt Taxi Stockholm konto"},"INVALID_PAYMENT_METHOD":{"en":"Payment method is required","sv":"F\xf6r att boka kr\xe4vs en betalningsmetod"},"FIXED_PRICE_REQUIRED":{"en":"Only fixed price is available for this trip","sv":"Endast fastpris \xe4r tillg\xe4ngligt f\xf6r denna resa"},"FIXED_PRICE_OR_PRICE_TOKEN_REQUIRED":{"en":"Only fixed price is available for this trip","sv":"Endast fastpris \xe4r tillg\xe4ngligt f\xf6r denna resa"},"BOOKING_ADDRESS_OR_TIME_MISMATCH_WITH_PRICE_ESTIMATE":{"en":"Fixed price is not available, please try again","sv":"Fastpris \xe4r tyv\xe4rr inte tillg\xe4ngligt,var v\xe4nlig f\xf6rs\xf6k igen"},"ACCOUNT_NUMBER_REQUIRED":{"en":"Account number is required","sv":"Var v\xe4nlig ange Taxi Stockholm konto"},"TOO_MANY_INTERMEDIATE_STOPS":{"en":"Sorry, but you have added too many intermediate stops","sv":"Tyv\xe4rr s\xe5 har du angivit f\xf6r m\xe5nga via-adresser"},"NOT_ALLOWED_INTERMEDIATE_STOP":{"en":"Sorry, but this location can not be added as an intermediate stop","sv":"Tyv\xe4rr s\xe5 kan denna adress inte l\xe4ggas till som via-adress"},"INVALID_INTERMEDIATE_ADDRESS":{"en":"Sorry, but we can not recognize this intermedate adress","sv":"Tyv\xe4rr s\xe5 k\xe4nner vi inte igen denna adress"}},"/bookings/{bookingId}/email-confirmation":{"BOOKING_NOT_FOUND":{"en":"Booking was not found","sv":"Bokningen hittades inte"}},"/bookings/{bookingId}/confirm-edit":{"EDIT_BOOKING_INVALID_PAYMENT_METHOD":{"en":"Payment method does not support change of amount","sv":"Betalningsmetoden st\xf6djer inte \xe4ndring av belopp"}},"/bookings/{bookingId}/edit-estimate":{"BOOKING_NOT_EDITABLE":{"en":"Unfortunately it is too close to your pickup time to make changes to your booking","sv":"Det \xe4r tyv\xe4rr f\xf6r n\xe4ra inp\xe5 din upph\xe4mtningstid f\xf6r att kunna genomf\xf6ra dina \xe4ndringar "},"FLIGHT_INFO_NOT_ALLOWED":{"en":"Flight info cannot be added to this booking","sv":"Flyginformation kan inte l\xe4ggas till i denna bokning"},"FLIGHT_INFO_REQUIRED":{"en":"Please provide a valid flight number","sv":"V\xe4nligen fyll i ett giltigt flygnummer"},"PICK_UP_TIME_TOO_NEAR":{"en":"The selected time is too close.","sv":"Den valda tiden \xe4r f\xf6r n\xe4ra inp\xe5."},"INVALID_EDITABLE_FIELDS":{"en":"Unfortunately it is too close to your pickup time to make certain changes to your booking","sv":"Det \xe4r tyv\xe4rr f\xf6r n\xe4ra inp\xe5 din upph\xe4mtningstid f\xf6r att kunna genomf\xf6ra vissa av dina \xe4ndringar"},"NO_TAXI_AVAILABLE":{"en":"Unfortunately there are no available cars at this time, please choose another time","sv":"Tyv\xe4rr finns inga lediga bilar denna tidpunkt, var v\xe4nlig v\xe4lj en annan tid"}},"/bookings/users/{userId}/{bookingId}/pdf-receipt":{"INVALID_USER_ID":{"en":"Oops! Something went wrong","sv":"Oj, n\xe5got gick fel"},"PERMISSION_DENIED":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"RECEIPT_NOT_AVAILABLE":{"en":"The receipt is not availble","sv":"Det \xe4r tyv\xe4rr inte m\xf6jligt att visa kvittot f\xf6r denna bokning"},"RECEIPT_PENDING":{"en":"Your receipt is not available yet","sv":"Ditt kvitto \xe4r inte tillg\xe4ngligt \xe4nnu"}},"/locations/{locationId}":{"LOCATION_NOT_FOUND":{"en":"Location not found","sv":"Adressen saknas"},"MISSING_CITY_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/locations/numbers":{"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/locations/nearby":{"MISSING_LONGITUDE_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/locations/search":{"MISSING_ADDRESS_STRING_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/locations/search/street-only":{"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MISSING_ADDRESS_STRING_PARAMETER":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/price/estimate":{"GPS_POS_NOT_MATCHING":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_LOCATION":{"en":"Location not found","sv":"Adressen \xe4r inte giltig"},"LOCATION_NOT_FOUND":{"en":"Location not found","sv":"Adressen saknas"},"ORIGIN_SAME_AS_DESTINATION":{"en":"Origin and destination are the same","sv":"H\xe4mtadress och destinationsadress \xe4r samma"},"SERVICE_TYPE_MISSING":{"en":"Service type missing","sv":"Tj\xe4nst saknas i anropet"},"ZONE_ID_NOT_MATCHING":{"en":"Fixed price is not available, please try again","sv":"Fastpris saknas, var v\xe4nlig f\xf6rs\xf6k igen"},"FIXED_PRICE_FOR_ORIGIN_NOT_FOUND":{"en":"Unfortunately we are not able to offer a fixed price between the selected addresses. We have switched to taximeter.","sv":"Tyv\xe4rr kan vi inte ervjuda ett fastpris mellan dessa adresser. Vi har bytt till taxameter."},"FIXED_PRICE_DISABLED":{"en":"Unfortunately we are not able to offer a fixed price right now. Payment method is changed to taximeter","sv":"Tyv\xe4rr kan vi inte ervjuda ett fastpris just nu. Betalmetod har \xe4ndrats till taxameter."}},"/price/estimate/{priceToken}":{"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"PRICE_NOT_FOUND_FOR_TOKEN":{"en":"The fixed price has expired, please try again","sv":"Fastpriset har upph\xf6rt att g\xe4lla v\xe4nligen f\xf6rs\xf6k igen"}},"/price/estimate/multistop":{"GPS_POS_NOT_MATCHING":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_LOCATION":{"en":"Location not found","sv":"Adressen \xe4r inte giltig"},"LOCATION_NOT_FOUND":{"en":"Location not found","sv":"Adressen saknas"},"ORIGIN_SAME_AS_DESTINATION":{"en":"We\'ve noticed that the same address has been added multiple times","sv":"Du har angivit samma adress flera g\xe5nger"},"SERVICE_TYPE_MISSING":{"en":"Service type missing","sv":"Tj\xe4nst saknas i anropet"},"ZONE_ID_NOT_MATCHING":{"en":"Fixed price is not available, please try again","sv":"Fastpris saknas, var v\xe4nlig f\xf6rs\xf6k igen"},"FIXED_PRICE_DISABLED":{"en":"Unfortunately we are not able to offer a fixed price right now. Payment method is changed to taximeter","sv":"Tyv\xe4rr kan vi inte ervjuda ett fastpris just nu. Betalmetod har \xe4ndrats till taxameter."}},"/price/estimate/multistop/{priceToken}":{"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"MULTISTOP_PRICE_NOT_FOUND_FOR_TOKEN":{"en":"The fixed price has expired, please try again","sv":"Fastpriset har upph\xf6rt att g\xe4lla v\xe4nligen f\xf6rs\xf6k igen"}},"/estimates/wait":{"Bad Request":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/activation/initiate":{"BAD_REQUEST_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"CLIENT_DOES_NOT_EXIST":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"TOO_MANY_OTP_RESEND_REQUESTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"},"TOO_MANY_OTP_FAILED_ATTEMPTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"}},"/activation/validate-phone-otp":{"INVALID_OTP":{"en":"Invalid code, please try again","sv":"Ogiltig kod, v\xe4nligen f\xf6rs\xf6k igen"}},"/activation/resend-phone-otp":{"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"},"TOO_MANY_OTP_RESEND_REQUESTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"}},"/activation/validate-email-otp":{"INVALID_OTP":{"en":"Invalid code, please try again","sv":"Ogiltig kod, v\xe4nligen f\xf6rs\xf6k igen"}},"/activation/resend-email-otp":{"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"},"TOO_MANY_OTP_RESEND_REQUESTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"}},"/activation/add-email":{"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"}},"/activation/add-name":{"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"}},"/activation/update-phone-number":{"BAD_REQUEST_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"INVALID_PHONE_NUMBER":{"en":"The phone number provided is not in a correct format","sv":"Telefonnumret har fel format"},"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"},"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"TOO_MANY_OTP_RESEND_REQUESTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"},"TOO_MANY_OTP_FAILED_ATTEMPTS":{"en":"Too many attempts, please try again later","sv":"F\xf6r m\xe5nga f\xf6rs\xf6k, du kan prova igen om ett tag"}},"/activation/complete":{"DEVICE_ACTIVATION_BAD_STATE":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"DEVICE_ACTIVATION_NOT_FOUND":{"en":"You code has expired, please restart your log in","sv":"Din kod g\xe4ller inte l\xe4ngre, var v\xe4nlig b\xf6rja om din inloggning"}},"/users/{userId}":{"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"USER_NOT_ALLOWED_TO_BE_REMOVED":{"en":"Unfortunately it is not possible to delete this user, please contact Customer service 08-728 27 00","sv":"Det \xe4r tyv\xe4rr inte m\xf6jligt att ta bort denna anv\xe4ndare, kontakta kundtj\xe4nst f\xf6r att f\xe5 hj\xe4lp: 08-728 27 00"},"USER_HAS_ONGOING_OR_FUTURE_TRIPS_ERROR":{"en":"It seems like you still have ongoing trips.You need to cancel them before you can delete your profile.","sv":"Det verkar som du bokningar som inte \xe4r genomf\xf6rda \xe4n. Du beh\xf6ver avboka dem innan du kan ta bort din profil."},"USER_HAS_PENDING_PAYMENTS_ERROR":{"en":"Unfortunately it is not possible to delete this user, since there are ongoing payments","sv":"Det \xe4r tyv\xe4rr inte m\xf6jligt att ta bort denna anv\xe4ndare, d\xe5 det finns p\xe5g\xe5ende betalningar"},"BAD_REQUEST_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"USER_EMAIL_EXISTS":{"en":"This email address is already in use, please enter another email address","sv":"Denna epost-adress anv\xe4nds redan, var v\xe4nlig att ange en annan"}},"/users/{userId}/vouchers":{"VOUCHER_ERROR":{"en":"This voucher is not valid","sv":"Rabattkoden \xe4r inte giltig"},"EXPIRED_VOUCHER":{"en":"This voucher has expired","sv":"Giltighetstiden f\xf6r rabattkoden har passerats"},"BAD_REQUEST":{"en":"Your voucher could not be added at the moment. Please try again later.","sv":"Rabattkoden kunde dessv\xe4rre inte registreras. F\xf6rs\xf6k igen senare"},"ADD_VOUCHER_TEMPORARILY_BLOCKED_ERROR":{"en":"Too many incorrect attempts. Try again later.","sv":"F\xf6r m\xe5nga felaktiga f\xf6rs\xf6k. F\xf6rs\xf6k igen senare."},"FORBIDDEN_ERROR":{"en":"Your voucher can unfortunately not be added.","sv":"Din rabattkod kunde tyv\xe4rr inte l\xe4ggas till."},"USER_DOES_NOT_EXIST":{"en":"Your voucher could not be added at the moment. Please try again later.","sv":"Rabattkoden kunde dessv\xe4rre inte registreras. F\xf6rs\xf6k igen senare"},"TOO_MANY_REQUESTS":{"en":"Too many incorrect attempts. Try again later.","sv":"F\xf6r m\xe5nga felaktiga f\xf6rs\xf6k. F\xf6rs\xf6k igen senare."},"BAD_GATEWAY_ERROR":{"en":"Your voucher could not be added at the moment. Please try again later.","sv":"Rabattkoden kunde dessv\xe4rre inte registreras. F\xf6rs\xf6k igen senare"}},"/emailverifications/{token}":{"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"},"VERIFICATION_TOKEN_EXPIRED_ERROR":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"}},"/status-messages/search":{"BAD_REQUEST":{"en":"Oops! Something went wrong, please try again","sv":"Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen"},"USER_DOES_NOT_EXIST":{"en":"User does not exist","sv":"Anv\xe4ndaren finns inte"}}}');


// Buckets in errors.json that are not endpoints: shared error codes and a last
// resort keyed on the HTTP status. Both are only consulted once the endpoint
// specific lookups have missed.
const $f313f76ad66d34ed$var$SHARED = '*';
const $f313f76ad66d34ed$var$STATUS = '*status';
const $f313f76ad66d34ed$export$714f3eb4b9ca37c5 = ()=>{
    return APP.lang === 'sv' ? "Oj, n\xe5got gick fel. Var v\xe4nlig f\xf6rs\xf6k igen" : 'Oops! Something went wrong, please try again';
};
// api.js always calls with a /v1 prefix that the proxy strips, and some endpoints
// carry a query string. Neither is part of the keys in errors.json.
const $f313f76ad66d34ed$var$normalize = (endPoint)=>String(endPoint ?? '').split('?')[0].replace(/^\/v\d+/, '');
const $f313f76ad66d34ed$var$escapeRegExp = (str)=>str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// '/users/{userId}/vouchers' -> /^\/users\/[^/]+\/vouchers$/
const $f313f76ad66d34ed$var$toPattern = (key)=>new RegExp('^' + key.split(/\{[^}]+\}/).map($f313f76ad66d34ed$var$escapeRegExp).join('[^/]+') + '$');
const $f313f76ad66d34ed$export$82f46aa4e6535a45 = (endPoint, error, status)=>{
    const path = $f313f76ad66d34ed$var$normalize(endPoint);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[path]?.[error]?.[APP.lang]) return (0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[path][error][APP.lang];
    // Endpoints with an id in the path need a pattern match. Keep this anchored to
    // the endpoint: matching on the error code alone hands back whichever endpoint
    // happens to define that code first in errors.json.
    for (const [key, value] of Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports))))){
        if (key === $f313f76ad66d34ed$var$SHARED || key === $f313f76ad66d34ed$var$STATUS) continue;
        if ($f313f76ad66d34ed$var$toPattern(key).test(path) && value[error]?.[APP.lang]) return value[error][APP.lang];
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[$f313f76ad66d34ed$var$SHARED]?.[error]?.[APP.lang]) return (0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[$f313f76ad66d34ed$var$SHARED][error][APP.lang];
    // Nothing knows this code, but the status still tells the user something useful.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[$f313f76ad66d34ed$var$STATUS]?.[status]?.[APP.lang]) return (0, (/*@__PURE__*/$parcel$interopDefault($6c47697536ae309f$exports)))[$f313f76ad66d34ed$var$STATUS][status][APP.lang];
    return $f313f76ad66d34ed$export$714f3eb4b9ca37c5();
};



class $135a523c4bea715f$export$f2e832acab1bdd79 extends Error {
    constructor(message, response, status){
        super(message);
        this.name = this.constructor.name;
        this.response = response;
        this.status = status;
        this.isUnauthorized = status === 401;
    }
}
class $135a523c4bea715f$export$bae979e68e4dc802 extends $135a523c4bea715f$export$f2e832acab1bdd79 {
    constructor(message, isUncertain){
        super(message, {
            error: 'NETWORK_ERROR',
            message: message
        }, null);
        this.isNetworkError = true;
        // false => the request had no lasting effect, safe to retry
        // true  => the server may have created or changed a booking without us knowing,
        //          so the user must reconcile against active bookings before retrying
        this.isUncertain = isUncertain;
    }
}
// Endpoints where a lost response leaves booking state unknown. Deliberately not
// "any non-GET": price estimates, status and search are POSTs but read-only, and
// telling someone their booking may have gone through after a failed price lookup
// would be both wrong and alarming.
const $135a523c4bea715f$var$changesBookingState = (endPoint, method)=>{
    if (method === 'POST') return /^\/v1\/bookings(\/prepare)?(\?|$)/.test(endPoint) || /^\/v1\/bookings\/[^/]+\/confirm-edit(\?|$)/.test(endPoint);
    if (method === 'DELETE') return /^\/v1\/bookings\/[^/?]+(\?|$)/.test(endPoint);
    return false;
};
const $135a523c4bea715f$export$7481aad80bb20dc6 = ()=>{
    return localStorage.getItem('token') !== null;
};
const $135a523c4bea715f$var$getOrCreateDeviceId = ()=>{
    let id = localStorage.getItem('uuid');
    if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem('uuid', id);
    }
    return id;
};
const $135a523c4bea715f$export$b45aefc478af63c4 = (error)=>{
    // TODO: Add more error codes?
    return error?.response?.error === 'DEVICE_ACTIVATION_NOT_FOUND';
};
const $135a523c4bea715f$var$pendingRequests = new Map();
async function $135a523c4bea715f$var$abortable_api(id, endPoint, body, method = 'GET', extraHeaders = null, returnFull = false) {
    const prevController = $135a523c4bea715f$var$pendingRequests.get(id);
    if (prevController) prevController.abort();
    const controller = new AbortController();
    $135a523c4bea715f$var$pendingRequests.set(id, controller);
    return $135a523c4bea715f$var$api(endPoint, body, method, extraHeaders, returnFull, controller.signal).then((response)=>{
        $135a523c4bea715f$var$pendingRequests.delete(id);
        return response;
    });
}
async function $135a523c4bea715f$var$api(endPoint, body, method = 'GET', extraHeaders = null, returnFull = false, signal = null) {
    const token = localStorage.getItem('token');
    const headers = {
        'Content-Type': 'application/json',
        'Accept-Language': (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        'X-Device-Id': $135a523c4bea715f$var$getOrCreateDeviceId(),
        ...extraHeaders
    };
    if (token) headers['Authorization'] = token;
    const options = {
        method: method,
        headers: headers,
        body: body
    };
    // Make request abortable using AbortController
    if (signal) options.signal = signal;
    const isUncertain = $135a523c4bea715f$var$changesBookingState(endPoint, method);
    const res = await fetch(`/api${endPoint}`, options).catch((error)=>{
        if (error.name === 'AbortError') throw error;
        console.error(error);
        // Without this the undefined `res` below threw a TypeError, which surfaced to the
        // user as "Cannot read properties of undefined" and let them retry a booking that
        // may already have been created. Throw a typed error the callers can reason about.
        throw new $135a523c4bea715f$export$bae979e68e4dc802((0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).t(isUncertain ? 'error-network-uncertain' : 'error-network'), isUncertain);
    });
    if (returnFull && res.status === 200) return res;
    // Check for API errors (non-2xx status codes)
    if (res.status < 200 || res.status >= 300) {
        // A 502/504 from the gateway can come back as HTML rather than JSON, so don't
        // let a parse failure escape as a SyntaxError instead of an ApiError.
        const json = await res.json().catch(()=>({}));
        if (json?.error) json.message = (0, $f313f76ad66d34ed$export$82f46aa4e6535a45)(endPoint, json.error, res.status);
        else if (!json?.message) json.message = (0, $f313f76ad66d34ed$export$82f46aa4e6535a45)(endPoint, null, res.status);
        if (res.status === 401 && json?.error === 'Unauthorized') {
            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('UNAUTHORIZED');
            // Throw a special error that won't show error modals
            // The UNAUTHORIZED event handler will show the proper logout modal
            const error = new $135a523c4bea715f$export$f2e832acab1bdd79('Unauthorized', {
                error: 'Unauthorized',
                message: 'Unauthorized'
            }, 401);
            error.isUnauthorized = true;
            throw error;
        }
        throw new $135a523c4bea715f$export$f2e832acab1bdd79(`${json.error} ${json.message}`, json, res.status);
    }
    // For successful responses, check if there's a body to parse
    const contentType = res.headers.get('content-type');
    const contentLength = res.headers.get('content-length');
    // If no content or content-length is 0, return empty object
    if (contentLength === '0' || !contentType || !contentType.includes('application/json')) {
        // Save user token
        if (res.headers.has('Authorization')) localStorage.setItem('token', res.headers.get('Authorization'));
        return {};
    }
    const json = await res.json();
    // Save user token
    if (res.headers.has('Authorization')) localStorage.setItem('token', res.headers.get('Authorization'));
    return json;
}
async function $135a523c4bea715f$export$ce3a8ce471b7d4ad(value, region, city, position) {
    value = value.replace(/[\s,]+/g, ' ');
    let url = `/v1/locations/search?address_string=${encodeURIComponent(value)}`;
    if (region !== undefined && region !== null) url += `&region=${encodeURIComponent(region)}`;
    if (city !== undefined && city !== null) url += `&city=${encodeURIComponent(city)}`;
    if (position !== undefined && position !== null) {
        url += `&reference_latitude=${encodeURIComponent(position.latitude)}`;
        url += `&reference_longitude=${encodeURIComponent(position.longitude)}`;
    }
    const res = await $135a523c4bea715f$var$abortable_api('searchLocation', url);
    return res.result || {};
}
async function $135a523c4bea715f$export$29e8c1c14a616bc1(streetName, city) {
    const res = await $135a523c4bea715f$var$api(`/v1/locations/numbers?street_name=${encodeURIComponent(streetName)}&city=${encodeURIComponent(city)}`);
    return res;
}
async function $135a523c4bea715f$export$359350a296630f29(location) {
    const res = await $135a523c4bea715f$var$api(`/v1/locations/${location.id}`);
    // NOTE: Don't know if this is needed with v3
    // const query = formatLocationQuery(location.address)
    // const res = await api(`/v1/locations/${encodeURIComponent(query)}`)
    // NOTE: Don't know if this is needed with v3
    // if (res?.address?.entrance === '') delete res.address.entrance
    // Add unique id to every location object to use as React key in the search locations component.
    // This allows duplicate addresses, for example if departure and destination is the same but with multiple stops in between.
    if (res?.address?.streetName) res.key = (0, $cf399e049a9c4d34$export$ac4959f4f1338dfc)(10);
    return res;
}
async function $135a523c4bea715f$export$48f7aa7105c4b440({ latitude: latitude, longitude: longitude, accuracy: accuracy }) {
    // const res = await api(`/v1/locations/nearby?latitude=${latitude}&longitude=${longitude}&accuracy=${Math.ceil(accuracy)}`)
    const res = await $135a523c4bea715f$var$api(`/v1/locations/nearby?latitude=${latitude}&longitude=${longitude}`);
    return res.result || {};
}
async function $135a523c4bea715f$export$afcd59c9945427b5({ latitude: latitude, longitude: longitude }) {
    // NOTE: the API returns ETA for all vehicle types but taxi is the only accurate one so we disable this for now
    // const res = await api(`/v1/estimates/wait?latitude=${latitude}&longitude=${longitude}`)
    const res = await $135a523c4bea715f$var$api(`/v1/estimates/wait?vehicleType=taxi&latitude=${latitude}&longitude=${longitude}`);
    return res;
}
async function $135a523c4bea715f$export$740face6f9071f68(values, user) {
    const query = (0, $200ec6b1b2ca8c5a$export$d43985a4ce6e5677)(values, user);
    const res = await $135a523c4bea715f$var$abortable_api('fetchServiceAvailability', `/v1/service-availability?${query}`);
    return res;
}
async function $135a523c4bea715f$export$14682eeac6801e56() {
    const res = await $135a523c4bea715f$var$api(`/v1/regions`);
    return res;
}
async function $135a523c4bea715f$export$6ca48d4d1c2a28c6(values, freshAvailability = null) {
    const req = (0, $200ec6b1b2ca8c5a$export$3b2336224517b4a7)(values, freshAvailability);
    const res = await $135a523c4bea715f$var$abortable_api('fetchPriceEstimate', '/v1/price/estimate', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$281f59c767225686(code, phone) {
    const formatted = code + phone.replace(/^0/, '');
    const req = {
        phone: formatted,
        locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        acceptTermsAndConditions: true
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/initiate', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$67faf1bc20afbc8d() {
    const res = await $135a523c4bea715f$var$api('/v1/activation/resend-phone-otp', null, 'POST');
    return res;
}
async function $135a523c4bea715f$export$1836188376808b25(otp) {
    const req = {
        otp: otp
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/validate-phone-otp', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$7738159be2c9b2bf() {
    const res = await $135a523c4bea715f$var$api('/v1/activation/resend-email-otp', null, 'POST');
    return res;
}
async function $135a523c4bea715f$export$9266817a7ac678fe(otp) {
    const req = {
        otp: otp
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/validate-email-otp', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$56c422d8d4a8ba98(email) {
    const req = {
        email: email
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/add-email', JSON.stringify(req), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$d04c19dd275cdbbd(firstName, lastName) {
    const req = {
        firstName: firstName,
        lastName: lastName
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/add-name', JSON.stringify(req), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$f3fd28dd107273ce(req) {
    const res = await $135a523c4bea715f$var$api('/v1/activation/complete', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$94ea1ffa89952f1c(phone) {
    const req = {
        phone: (0, $200ec6b1b2ca8c5a$export$842dcfa371c6bb83)(phone)
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/update-phone-number', JSON.stringify(req), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$8a95d6164a049576() {
    const req = {
        authType: 'GOOGLE_SIGN_IN',
        locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        acceptTermsAndConditions: true
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/initiate', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$925729d2b6abebca() {
    const req = {
        authType: 'APPLE_ID',
        locale: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language,
        acceptTermsAndConditions: true
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/initiate', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$353a804191b94a80(idToken) {
    const req = {
        payload: idToken
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/validate-oidc-token', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$fca1fd251061bfc4(dialCode, phone) {
    const formatted = dialCode + phone.replace(/^0/, '');
    const req = {
        phone: formatted
    };
    const res = await $135a523c4bea715f$var$api('/v1/activation/add-phone-number', JSON.stringify(req), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$7cbf767827cd68ba(userId) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}`);
    return res;
}
async function $135a523c4bea715f$export$e3ac7a5d19605772(userId, { firstName: firstName, lastName: lastName, email: email, marketingOptIn: marketingOptIn }) {
    const req = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        marketingOptIn: marketingOptIn
    };
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}`, JSON.stringify(req), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$87808cfd18c2bb49(userId, consent) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}`, JSON.stringify({
        marketingOptIn: consent
    }), 'PATCH');
    return res;
}
async function $135a523c4bea715f$export$7d0f10f273c0438a(userId) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}`, null, 'DELETE');
    return res;
}
async function $135a523c4bea715f$export$d5d451a14adbc067(userId) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}/accounts`);
    return res;
}
async function $135a523c4bea715f$export$f7dd262aa2367f3d(userId, accountNumber, accountPassword) {
    const req = {
        accountNumber: accountNumber,
        accountPassword: (0, (/*@__PURE__*/$parcel$interopDefault($de51e1280ea129a8$exports)))(accountPassword.toUpperCase())
    };
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}/accounts`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$45abfc3976589d02(userId, accountNumber) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}/accounts/${accountNumber}`, null, 'DELETE');
    return res;
}
async function $135a523c4bea715f$export$1b9cfbadf92bf372(userId, voucherCode) {
    const req = {
        voucherCode: voucherCode.toUpperCase()
    };
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}/vouchers`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$8220d3f4554159a3() {
    const res = await $135a523c4bea715f$var$api(`/v1/devices/logout`, null, 'DELETE');
    return res;
}
async function $135a523c4bea715f$export$27381a4a74739b72(token) {
    return new Promise((resolve, reject)=>{
        $.ajax(APP.getAjaxConfig({
            url: CONFIG.api_base_url + '/api/validate-token',
            method: 'POST',
            data: {
                token: token
            },
            success: resolve,
            error: function(jqXHR) {
                reject({
                    status: jqXHR.status
                });
            }
        }));
    });
}
async function $135a523c4bea715f$export$4ed561c675781f86(userId) {
    const headers = {
        'User-Id': userId
    };
    const res = await $135a523c4bea715f$var$api(`/v1/payments/user-verification-token`, null, 'GET', headers, true);
    if (res.headers.has('Payment-Token')) return res.headers.get('Payment-Token').replace('Bearer ', '');
    return null;
}
async function $135a523c4bea715f$export$3877e99530b0c773(values, userId) {
    const req = values?.serviceType === 'delivery' ? (0, $200ec6b1b2ca8c5a$export$7445ab76c6ed2f59)(values, userId) : (0, $200ec6b1b2ca8c5a$export$9f1f9dfacc50ba0)(values, userId);
    const res = await $135a523c4bea715f$var$api('/v1/bookings', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$59f37aaaaab070bd(values, userId) {
    const req = values?.serviceType === 'delivery' ? (0, $200ec6b1b2ca8c5a$export$7445ab76c6ed2f59)(values, userId) : (0, $200ec6b1b2ca8c5a$export$9f1f9dfacc50ba0)(values, userId);
    const res = await $135a523c4bea715f$var$api('/v1/bookings/prepare', JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$98a8f978e5e12ae4(bookingId) {
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}`);
    return res;
}
async function $135a523c4bea715f$export$b7b1ce5fabd1b486(bookingId, clientBookingToken) {
    // NOTE: Support anonymous bookings
    const headers = clientBookingToken ? {
        'X-Order-Token': clientBookingToken
    } : null;
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}`, null, 'DELETE', headers);
    return res;
}
async function $135a523c4bea715f$export$7096ad10e421c942(bookingId, email) {
    const req = {
        email: email
    };
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}/email-confirmation`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$523ec735df6579ca(userId) {
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/users/${userId}?filter=active`);
    return res;
}
async function $135a523c4bea715f$export$c52936fe4c70c3a4(userId) {
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/users/${userId}?filter=history&sort=DESC`);
    return res;
}
async function $135a523c4bea715f$export$b70265791d2079d4(bookings) {
    const req = (0, $200ec6b1b2ca8c5a$export$49b5cab8367c3ef1)(bookings);
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/status`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$7d7158d41e4214f8(bookings) {
    const req = bookings.map((booking)=>{
        return {
            bookingId: booking.orderId,
            clientBookingToken: booking.clientBookingToken
        };
    });
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/search`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$904a7cbfa3bf44c7(userId, bookingId) {
    const headers = {
        'User-Id': userId
    };
    const req = {
        bookingId: bookingId
    };
    const res = await $135a523c4bea715f$var$api(`/v1/payments/payment-token`, JSON.stringify(req), 'POST', headers, true);
    if (res.headers.has('Payment-Token')) return res.headers.get('Payment-Token').replace('Bearer ', '');
    return null;
}
async function $135a523c4bea715f$export$e6a7cb28487f7150(userId, bookingId) {
    const headers = {
        'User-Id': userId
    };
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/users/${userId}/${bookingId}/pdf-receipt`, null, 'GET', headers, true);
    return res;
}
async function $135a523c4bea715f$export$81ea9e0398c88adc(bookingId) {
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}/editable-fields`);
    return res;
}
async function $135a523c4bea715f$export$9bd5699329fe0aaa(bookingId, values) {
    const req = (0, $200ec6b1b2ca8c5a$export$feb758fb830fa6ed)(values);
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}/edit-estimate`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$c3b4580b68ed2909(bookingId, editToken) {
    const req = {
        editToken: editToken
    };
    const res = await $135a523c4bea715f$var$api(`/v1/bookings/${bookingId}/confirm-edit`, JSON.stringify(req), 'POST');
    return res;
}
async function $135a523c4bea715f$export$eed77d686003896a(userId, email) {
    const res = await $135a523c4bea715f$var$api(`/v1/users/${userId}/email-verification`, JSON.stringify({
        email: email
    }), 'POST');
    return res;
}
async function $135a523c4bea715f$export$4c0a6e0671743f21() {
    const date = new Date();
    const res = await $135a523c4bea715f$var$api(`/v1/status-messages/search?dateTime=${date.toISOString()}`);
    return res;
}








var $ih19M = parcelRequire("ih19M");

var $bh6RR = parcelRequire("bh6RR");





var $860c06ca7956c38a$export$32180ef41b15b513;
var $860c06ca7956c38a$export$aa3e815946b80764;
var $860c06ca7956c38a$export$a7db06668cad9adb;
var $860c06ca7956c38a$export$14439f5cc10d722f;
var $860c06ca7956c38a$export$7cc5570d1d002edf;
var $860c06ca7956c38a$export$cf3f1c4de036c60a;
var $860c06ca7956c38a$export$bb7b9ea99f713309;
var $860c06ca7956c38a$export$400c84843b745ba2;
var $860c06ca7956c38a$export$d3f8646c5048291a;
var $860c06ca7956c38a$export$22d14b87ba3dfee4;
var $860c06ca7956c38a$export$4123a50b4d9474d8;
var $860c06ca7956c38a$export$a35083d46ad72a3b;
var $860c06ca7956c38a$export$25b577c3509628cc;
var $860c06ca7956c38a$export$6f093cfa640b7166;
var $860c06ca7956c38a$export$fb184b623420d9be;
$860c06ca7956c38a$export$32180ef41b15b513 = `lg3sDG_body`;
$860c06ca7956c38a$export$aa3e815946b80764 = `lg3sDG_card`;
$860c06ca7956c38a$export$a7db06668cad9adb = `lg3sDG_content`;
$860c06ca7956c38a$export$14439f5cc10d722f = `lg3sDG_illustration`;
$860c06ca7956c38a$export$7cc5570d1d002edf = `lg3sDG_mapCircle`;
$860c06ca7956c38a$export$cf3f1c4de036c60a = `lg3sDG_plusBadge`;
$860c06ca7956c38a$export$bb7b9ea99f713309 = `lg3sDG_rowIcon`;
$860c06ca7956c38a$export$400c84843b745ba2 = `lg3sDG_rowIconImg`;
$860c06ca7956c38a$export$d3f8646c5048291a = `lg3sDG_selectorContent`;
$860c06ca7956c38a$export$22d14b87ba3dfee4 = `lg3sDG_selectorList`;
$860c06ca7956c38a$export$4123a50b4d9474d8 = `lg3sDG_selectorRow`;
$860c06ca7956c38a$export$a35083d46ad72a3b = `lg3sDG_selectorRowLabel`;
$860c06ca7956c38a$export$25b577c3509628cc = `lg3sDG_selectorTitle`;
$860c06ca7956c38a$export$6f093cfa640b7166 = `lg3sDG_text`;
$860c06ca7956c38a$export$fb184b623420d9be = `lg3sDG_title`;


const $5d526bb3b1ab5719$var$CardIllustration = ()=>/*#__PURE__*/ (0, $ih19M.jsxs)("div", {
        className: $860c06ca7956c38a$export$14439f5cc10d722f,
        children: [
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $860c06ca7956c38a$export$7cc5570d1d002edf
            }),
            /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
                className: $860c06ca7956c38a$export$aa3e815946b80764,
                width: "123",
                height: "75",
                viewBox: "0 0 123 75",
                fill: "none",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        width: "123",
                        height: "75",
                        rx: "8",
                        fill: "#1E2029"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        y: "15",
                        width: "123",
                        height: "10",
                        fill: "#F0EFEB",
                        fillOpacity: "0.15"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "10",
                        y: "48",
                        width: "72",
                        height: "7",
                        rx: "3",
                        fill: "#F0EFEB",
                        fillOpacity: "0.15"
                    }),
                    /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                        x: "10",
                        y: "38",
                        width: "52",
                        height: "5",
                        rx: "3",
                        fill: "#F0EFEB",
                        fillOpacity: "0.15"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                className: $860c06ca7956c38a$export$cf3f1c4de036c60a,
                children: /*#__PURE__*/ (0, $ih19M.jsx)("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
                        d: "M9 3v12M3 9h12",
                        stroke: "white",
                        strokeWidth: "2",
                        strokeLinecap: "round"
                    })
                })
            })
        ]
    });
const $5d526bb3b1ab5719$var$CardIcon = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("div", {
        className: $860c06ca7956c38a$export$bb7b9ea99f713309,
        children: /*#__PURE__*/ (0, $ih19M.jsxs)("svg", {
            width: "26",
            height: "19",
            viewBox: "0 0 26 19",
            fill: "none",
            "aria-hidden": "true",
            children: [
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    width: "26",
                    height: "19",
                    rx: "4",
                    fill: "#1e2029"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    y: "4",
                    width: "26",
                    height: "5",
                    fill: "rgba(240,239,235,0.25)"
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)("rect", {
                    x: "3",
                    y: "12",
                    width: "12",
                    height: "3",
                    rx: "1.5",
                    fill: "rgba(240,239,235,0.35)"
                })
            ]
        })
    });
const $5d526bb3b1ab5719$var$ChevronRight = ()=>/*#__PURE__*/ (0, $ih19M.jsx)("svg", {
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $ih19M.jsx)("path", {
            d: "M1 1l6 6-6 6",
            stroke: "#17181a",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
function $5d526bb3b1ab5719$export$2e2bcd8739ae039() {
    const { t: t } = (0, $0fbd9fed15f24a6d$export$9fc83ad70ead8663)();
    const { user: user, showAddPaymentModal: showAddPaymentModal, setShowAddPaymentModal: setShowAddPaymentModal, refreshUser: refreshUser } = (0, $bh6RR.useContext)((0, $a1f3d609b7c166c2$export$554ccc96b126a426));
    const [showSelector, setShowSelector] = (0, $bh6RR.useState)(false);
    if (!showAddPaymentModal) return null;
    if (user?.shouldConsentToMarketing) return null;
    const dismiss = ()=>{
        setShowAddPaymentModal(false);
        setShowSelector(false);
    };
    const handleSelectCard = ()=>{
        dismiss();
        (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('CASHIER_ADD_CARD', {
            success: refreshUser
        });
    };
    const handleSelectAccount = ()=>{
        dismiss();
        (0, $3804040dc4640bb3$export$e1df0da8f8fc570c)((close)=>/*#__PURE__*/ (0, $ih19M.jsx)((0, $f5a01b8c00777f68$export$2e2bcd8739ae039), {
                onComplete: ()=>{
                    close();
                    refreshUser();
                }
            }));
    };
    return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d1129c5f3177e033$export$2e2bcd8739ae039), {
        isOpen: true,
        rounded: true,
        children: !showSelector ? /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $860c06ca7956c38a$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)($5d526bb3b1ab5719$var$CardIllustration, {}),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $860c06ca7956c38a$export$6f093cfa640b7166,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: $860c06ca7956c38a$export$fb184b623420d9be,
                                    children: t('add-payment-title')
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                                    className: $860c06ca7956c38a$export$32180ef41b15b513,
                                    children: t('add-payment-body')
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                    buttons: [
                        {
                            func: ()=>setShowSelector(true),
                            title: t('add-payment-button')
                        },
                        {
                            func: dismiss,
                            title: t('add-payment-not-now')
                        }
                    ],
                    modal: true
                })
            ]
        }) : /*#__PURE__*/ (0, $ih19M.jsxs)((0, $ih19M.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                    className: $860c06ca7956c38a$export$d3f8646c5048291a,
                    children: [
                        /*#__PURE__*/ (0, $ih19M.jsx)("p", {
                            className: $860c06ca7956c38a$export$25b577c3509628cc,
                            children: t('add-payment-title')
                        }),
                        /*#__PURE__*/ (0, $ih19M.jsxs)("div", {
                            className: $860c06ca7956c38a$export$22d14b87ba3dfee4,
                            children: [
                                /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                    className: $860c06ca7956c38a$export$4123a50b4d9474d8,
                                    onClick: handleSelectCard,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)($5d526bb3b1ab5719$var$CardIcon, {}),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: $860c06ca7956c38a$export$a35083d46ad72a3b,
                                            children: t('add-payment-type-card')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)($5d526bb3b1ab5719$var$ChevronRight, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ih19M.jsxs)("button", {
                                    className: $860c06ca7956c38a$export$4123a50b4d9474d8,
                                    onClick: handleSelectAccount,
                                    children: [
                                        /*#__PURE__*/ (0, $ih19M.jsx)("div", {
                                            className: $860c06ca7956c38a$export$bb7b9ea99f713309,
                                            children: /*#__PURE__*/ (0, $ih19M.jsx)("img", {
                                                src: "/app/themes/taxi-stockholm/static/img/option-icons/TSAB.png",
                                                alt: "",
                                                className: $860c06ca7956c38a$export$400c84843b745ba2
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)("span", {
                                            className: $860c06ca7956c38a$export$a35083d46ad72a3b,
                                            children: t('add-payment-type-tsab')
                                        }),
                                        /*#__PURE__*/ (0, $ih19M.jsx)($5d526bb3b1ab5719$var$ChevronRight, {})
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ih19M.jsx)((0, $1669b712ac7656a1$export$2e2bcd8739ae039), {
                    buttons: [
                        {
                            func: ()=>setShowSelector(false),
                            title: t('button-back')
                        },
                        {
                            func: dismiss,
                            title: t('add-payment-not-now')
                        }
                    ],
                    modal: true
                })
            ]
        })
    });
}




const $a1f3d609b7c166c2$export$554ccc96b126a426 = /*#__PURE__*/ (0, $bh6RR.createContext)();
const $a1f3d609b7c166c2$var$fetchInterval = 10; // Number of seconds between fetches of bookings / statuses
const $a1f3d609b7c166c2$var$config = {
    termsLink: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language === 'sv' ? '/sv/hjalpcenter/boka/resevillkor/' : '/en/helpdesk/to-book/conditions-of-travel/',
    paymentTermsLink: (0, $c0695f6ebaa4acbb$export$2e2bcd8739ae039).language === 'sv' ? '/sv/hjalpcenter/boka/betalningsvillkor/' : '/en/helpdesk/to-book/payment-terms/'
};
const $a1f3d609b7c166c2$var$defaultStore = {
    user: null,
    bookings: null,
    paymentAccounts: null,
    preferredPaymentAccount: false,
    preferredPaymentAccountCompany: false,
    preferredPaymentMethod: false,
    preferredPaymentMethodCompany: false,
    isCompanyTrip: false,
    regions: null
};
const $a1f3d609b7c166c2$var$readStore = ()=>{
    const item = localStorage.getItem('reactStore');
    if (item) return JSON.parse(item);
    return $a1f3d609b7c166c2$var$defaultStore;
};
const $a1f3d609b7c166c2$var$writeStore = (store)=>{
    const item = JSON.stringify(store);
    localStorage.setItem('reactStore', item);
};
function $a1f3d609b7c166c2$export$2e2bcd8739ae039({ apps: apps = [], children: children, nested: nested = false }) {
    // Read store from local storage on app init
    const [store, setStore] = (0, $bh6RR.useState)($a1f3d609b7c166c2$var$readStore());
    const [sessionStore, setSessionStore] = (0, $bh6RR.useState)({});
    const [showAddPaymentModal, setShowAddPaymentModal] = (0, $bh6RR.useState)(false);
    const storeRef = (0, $bh6RR.useRef)(store);
    const intervalRef = (0, $bh6RR.useRef)(null);
    const pollingTypeRef = (0, $bh6RR.useRef)(null); // 'status' or 'active'
    const fetchRef = (0, $bh6RR.useRef)(true);
    const bookingsRef = (0, $bh6RR.useRef)(null); // Keep track of latest bookings for polling
    const isFirstLoadRef = (0, $bh6RR.useRef)(true); // true during page-load loginAndFetchBookings, false after
    const pendingAddPaymentModalRef = (0, $bh6RR.useRef)(false); // set after fresh login with no TSAB accounts; cleared by PIQ check
    const setUser = (user)=>{
        setStore((state)=>({
                ...state,
                user: user
            }));
    };
    const setBookings = (bookings)=>{
        bookingsRef.current = bookings; // Update ref for polling callbacks
        setStore((state)=>({
                ...state,
                bookings: bookings
            }));
    };
    const setPaymentAccounts = (paymentAccounts)=>{
        setStore((state)=>({
                ...state,
                paymentAccounts: paymentAccounts
            }));
    };
    const setPreferredPaymentAccount = (account, isCompanyTrip, paymentMethod = null)=>{
        if (isCompanyTrip) setStore((state)=>({
                ...state,
                preferredPaymentAccountCompany: account,
                ...paymentMethod ? {
                    preferredPaymentMethodCompany: paymentMethod
                } : {}
            }));
        else setStore((state)=>({
                ...state,
                preferredPaymentAccount: account,
                ...paymentMethod ? {
                    preferredPaymentMethod: paymentMethod
                } : {}
            }));
    };
    const setCurrentPaymentAccount = (account, isCompanyTrip, paymentMethod = null)=>{
        const s = {
            ...sessionStore
        };
        if (isCompanyTrip) {
            s.currentPaymentAccountCompany = account;
            if (paymentMethod) s.currentPaymentMethodCompany = paymentMethod;
        } else {
            s.currentPaymentAccount = account;
            if (paymentMethod) s.currentPaymentMethod = paymentMethod;
        }
        setSessionStore(s);
    };
    const setRegions = (regions)=>{
        setStore((state)=>({
                ...state,
                regions: regions
            }));
    };
    const setIsCompanyTrip = (company)=>{
        setStore((state)=>({
                ...state,
                isCompanyTrip: company
            }));
    };
    // const updateBookings = bookings => {
    //   setStore(state => {
    //     const updated = bookings.map(booking => {
    //       return { ...booking, ...state.bookings?.find(item => item.id === booking.id) }
    //     })
    //     return { ...state, updated }
    //   })
    // }
    const isLoggedIn = ()=>{
        return (0, $135a523c4bea715f$export$7481aad80bb20dc6)() && store?.user;
    };
    const loginUser = (userId, fresh = false)=>{
        (0, $135a523c4bea715f$export$7cbf767827cd68ba)(userId).then((response)=>{
            setUser(response);
            // If fresh login and no TSAB/TCA accounts, prime the pending flag — PIQ result will confirm or cancel
            if (fresh && (!response.accounts || response.accounts.length === 0)) pendingAddPaymentModalRef.current = true;
            getPaymentAccounts(response, fresh);
        // getUserRegions()
        }).catch((error)=>{
            console.error(error.response);
            if (error.response.error === 'USER_DOES_NOT_EXIST') (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('UNAUTHORIZED');
        });
    };
    const logoutUser = ()=>{
        // stop polling
        clearInterval(intervalRef.current);
        pollingTypeRef.current = null;
        // Clear all localStorage items
        localStorage.clear();
        // Clear sessionStorage as well
        sessionStorage.clear();
        // Reload the page to ensure all state is cleared
        window.location.href = '/';
    };
    const refreshUser = ()=>{
        if (store?.user?.userId) loginUser(store?.user?.userId);
    };
    const getPaymentAccounts = (user, fresh = false)=>{
        (0, $135a523c4bea715f$export$4ed561c675781f86)(user.userId).then((userVerificationToken)=>{
            (0, $e9d25ab963e7e928$export$160a2ee907bcaf92)(user.userId, userVerificationToken).then((response)=>{
                // Filter out Apple Pay cards
                if (response.accounts?.length > 0) response.accounts = response.accounts.filter((item)=>item.type !== 'applepay');
                setPaymentAccounts(response.accounts);
                // Resolve the pending modal flag: show modal if no credit cards, cancel if user has cards
                if (pendingAddPaymentModalRef.current) {
                    pendingAddPaymentModalRef.current = false;
                    if (!response.accounts || response.accounts.length === 0) setShowAddPaymentModal(true);
                }
                const latestStore = storeRef.current;
                if (latestStore?.preferredPaymentAccount && latestStore.preferredPaymentAccount !== false) verifyAccount(latestStore.preferredPaymentAccount, false, user?.accounts, response.accounts, setPreferredPaymentAccount);
                if (latestStore?.preferredPaymentAccountCompany && latestStore.preferredPaymentAccountCompany !== false) verifyAccount(latestStore.preferredPaymentAccountCompany, true, user?.accounts, response.accounts, setPreferredPaymentAccount);
                if (sessionStore?.currentPaymentAccount && sessionStore?.currentPaymentAccount !== false) verifyAccount(sessionStore.currentPaymentAccount, false, user?.accounts, response.accounts, setCurrentPaymentAccount);
                if (sessionStore?.currentPaymentAccountCompany && sessionStore?.currentPaymentAccountCompany !== false) verifyAccount(sessionStore.currentPaymentAccountCompany, true, user?.accounts, response.accounts, setCurrentPaymentAccount);
            }).catch((error)=>{
                console.error(error);
                // PIQ failed — show modal if pending (fresh login, no TSAB accounts)
                if (pendingAddPaymentModalRef.current) {
                    pendingAddPaymentModalRef.current = false;
                    setShowAddPaymentModal(true);
                }
            });
        }).catch((error)=>{
            console.error(error);
            // getUserVerificationToken failed — show modal if pending
            if (pendingAddPaymentModalRef.current) {
                pendingAddPaymentModalRef.current = false;
                setShowAddPaymentModal(true);
            }
        });
    };
    const verifyAccount = (preferred, isCompanyTrip, accounts, paymentAccounts, setPaymentAccount)=>{
        // Verify that the preferred account in store stil is available, otherwise set preferred account to false
        if (!preferred) return;
        if (preferred.type === 'creditcard' && !paymentAccounts.some((item)=>item.accountId === preferred?.accountId) || (preferred.type === 'TSAB' || preferred.type === 'TCA') && !accounts.some((item)=>item.accountNumber === preferred?.accountNumber)) setPaymentAccount(false, isCompanyTrip);
    };
    const getUserRegions = ()=>{
        (0, $135a523c4bea715f$export$14682eeac6801e56)().then((response)=>{
            if (response?.regions?.length > 0) setRegions(response.regions);
        }).catch((error)=>{
            console.error(error);
        });
    };
    // helper to start (or restart) polling using a single interval
    const startPolling = (type, fn)=>{
        // if the same type is already polling we can just keep going
        if (pollingTypeRef.current === type && intervalRef.current) return;
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(fn, 1000 * $a1f3d609b7c166c2$var$fetchInterval);
        pollingTypeRef.current = type;
    };
    const getActiveBookings = async (userId)=>{
        const id = userId || store?.user?.userId;
        if (id) try {
            // we no longer clear the interval here early; polling is managed centrally by startPolling
            let bookings = await (0, $135a523c4bea715f$export$523ec735df6579ca)(id);
            // Try to fetch any anonymous bookings made with the old API.
            // This should be removed when the site has been live for some time.
            if (localStorage?.orders) try {
                let orders = JSON.parse(localStorage.orders);
                if (orders?.length > 0) {
                    // Fetch anonymous bookings
                    let anonBookings = await (0, $135a523c4bea715f$export$7d7158d41e4214f8)(orders);
                    // Skip ended bookings, add client booking token to the bookings to be able to fetch status
                    anonBookings = anonBookings.filter((booking)=>!(0, $c94184dfef1a7d71$export$b4300df105f88c53)(booking)).map((booking)=>{
                        const clientBookingToken = orders.find((item)=>item.orderId === booking.id)?.clientBookingToken;
                        if (clientBookingToken) booking.clientBookingToken = clientBookingToken;
                        return booking;
                    });
                    // Concat and sort the bookings
                    if (anonBookings?.length > 0) bookings = [
                        ...bookings,
                        ...anonBookings
                    ].sort((a, b)=>a.pickUpTimeStamp < b.pickUpTimeStamp ? -1 : 1);
                }
            } catch (e) {
                console.error(e);
            }
            try {
                bookings = await getOriginLocationInfo(bookings);
            } catch (error) {
                console.error(error.response);
            }
            setBookings(bookings);
            // Check if any pending credit card booking has been confirmed
            try {
                const pendingBookings = JSON.parse(localStorage.getItem('pendingCreditCardBookings') || '[]');
                const isFirstPoll = !localStorage.getItem('hasPolledOnce');
                if (pendingBookings.length > 0) {
                    if (bookings?.length > 0) {
                        // Check if any pending bookingID is now in active bookings
                        // statusCode 190 means the booking/payment FAILED — do not treat as confirmed
                        const confirmedPending = pendingBookings.filter((pendingId)=>bookings.some((booking)=>booking.id === pendingId && booking?.bookingStatus?.statusCode !== 190));
                        const failedPending = pendingBookings.filter((pendingId)=>bookings.some((booking)=>booking.id === pendingId && booking?.bookingStatus?.statusCode === 190));
                        if (confirmedPending.length > 0) // Emit event to navigate to booking confirmed step
                        // The booking module will listen for this and navigate if it has the matching bookingID
                        confirmedPending.forEach((bookingId)=>{
                            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('PENDING_BOOKING_CONFIRMED', {
                                bookingId: bookingId
                            });
                        });
                        if (failedPending.length > 0) failedPending.forEach((bookingId)=>{
                            (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('PENDING_BOOKING_FAILED', {
                                bookingId: bookingId
                            });
                        });
                        const handledIds = [
                            ...confirmedPending,
                            ...failedPending
                        ];
                        if (handledIds.length > 0) {
                            const updatedPending = pendingBookings.filter((id)=>!handledIds.includes(id));
                            localStorage.setItem('pendingCreditCardBookings', JSON.stringify(updatedPending));
                        }
                    }
                    // If this is the first poll and booking not confirmed, emit event to enable button
                    if (isFirstPoll && pendingBookings.length > 0) {
                        localStorage.setItem('hasPolledOnce', 'true');
                        pendingBookings.forEach((bookingId)=>{
                            // Only emit if booking is NOT confirmed (not in active bookings)
                            if (!bookings?.some((booking)=>booking.id === bookingId)) (0, $d2abdbb88c8390d6$exports.emitCustomEvent)('FIRST_POLL_COMPLETE', {
                                bookingId: bookingId
                            });
                        });
                    }
                } else // No pending bookings, clear the poll flag
                localStorage.removeItem('hasPolledOnce');
            } catch (error) {
                console.error('Error checking pending bookings:', error);
            }
            // choose which polling behaviour we need based on current bookings
            if (bookings?.length > 0) startPolling('status', ()=>{
                // NOTE: Every other call, fetch all bookings
                // Use bookingsRef to get the latest bookings, avoiding stale closures
                if (fetchRef.current) getBookingStatus(bookingsRef.current || []);
                else getActiveBookings(id);
                fetchRef.current = !fetchRef.current;
            });
            else startPolling('active', ()=>getActiveBookings(id));
        } catch (error) {
            console.error(error.response);
        }
    };
    // Fetch location information for origin
    const getOriginLocationInfo = async (bookings)=>{
        return Promise.all(bookings.map(async (booking)=>{
            const response = await (0, $135a523c4bea715f$export$359350a296630f29)(booking.originLocation);
            const locInfo = response?.locationInformation || [];
            const hasNewTags = locInfo.some((item)=>item.tag === 'DEPARTURE_INFO_PREBOOK' || item.tag === 'DEPARTURE_INFO_DIRECT');
            const tag = hasNewTags ? booking.bookingType === 'PRE_BOOKING' ? 'DEPARTURE_INFO_PREBOOK' : 'DEPARTURE_INFO_DIRECT' : 'DEPARTURE_INFO';
            const info = locInfo.filter((item)=>item.tag === tag).map((item)=>item.message);
            // Return new object instead of mutating
            if (info) return {
                ...booking,
                originInfo: info
            };
            return booking;
        }));
    };
    const getBookingStatus = (bookings)=>{
        (0, $135a523c4bea715f$export$b70265791d2079d4)(bookings).then((response)=>{
            const updatedBookings = bookings.map((booking)=>{
                const statusData = response.find((item)=>item.bookingId === booking.id);
                // Only update if we got status data, otherwise keep the original booking intact
                // /v1/bookings/status may not return all active bookings, so preserve all from input
                if (statusData?.bookingStatus) return {
                    ...booking,
                    bookingStatus: statusData.bookingStatus
                };
                return booking;
            });
            setBookings(updatedBookings);
        }).catch((error)=>{
            console.error(error.response);
        });
    };
    const loginAndFetchBookings = async (userId)=>{
        const fresh = !isFirstLoadRef.current;
        loginUser(userId, fresh);
        getActiveBookings(userId);
        if (fresh) (0, $ee4f9bead648b485$export$6b2a7d5132615086)('login', {
            userId: userId
        });
    };
    // Keep ref in sync so async callbacks always see the latest store
    (0, $bh6RR.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    // Write store to local storage when it changes
    (0, $e1f0702c5201c0a7$export$bced253d99be73e5)(()=>{
        $a1f3d609b7c166c2$var$writeStore(store);
    }, [
        store
    ]);
    // Load user and bookings
    (0, $bh6RR.useEffect)(()=>{
        // If there is a user object (ie. logged in user), update from the API
        if (store?.user?.userId) loginAndFetchBookings(store.user.userId);
        isFirstLoadRef.current = false;
    }, []);
    // Handle unauthorized errors
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('UNAUTHORIZED', ()=>{
        const COPY = window.COPY || {};
        const message = COPY.general?.unauthorized_error || "Du har blivit utloggad. V\xe4nligen logga in igen.";
        const buttonTitle = COPY.booking?.button_ok || 'OK';
        (0, $3804040dc4640bb3$export$d7e8d4d4450c819c)(message, [
            {
                title: buttonTitle,
                callback: logoutUser
            }
        ]);
    });
    return /*#__PURE__*/ (0, $ih19M.jsxs)($a1f3d609b7c166c2$export$554ccc96b126a426.Provider, {
        value: {
            config: $a1f3d609b7c166c2$var$config,
            user: store.user,
            bookings: store.bookings,
            regions: store.regions,
            isCompanyTrip: store.isCompanyTrip,
            paymentAccounts: store.paymentAccounts,
            preferredPaymentAccount: store.preferredPaymentAccount,
            preferredPaymentAccountCompany: store.preferredPaymentAccountCompany,
            preferredPaymentMethod: store.preferredPaymentMethod,
            preferredPaymentMethodCompany: store.preferredPaymentMethodCompany,
            currentPaymentMethod: sessionStore.currentPaymentMethod,
            currentPaymentMethodCompany: sessionStore.currentPaymentMethodCompany,
            currentPaymentAccount: sessionStore.currentPaymentAccount,
            currentPaymentAccountCompany: sessionStore.currentPaymentAccountCompany,
            isLoggedIn: isLoggedIn,
            loginUser: loginUser,
            logoutUser: logoutUser,
            loginAndFetchBookings: loginAndFetchBookings,
            setUser: setUser,
            refreshUser: refreshUser,
            setPreferredPaymentAccount: setPreferredPaymentAccount,
            setCurrentPaymentAccount: setCurrentPaymentAccount,
            setIsCompanyTrip: setIsCompanyTrip,
            getActiveBookings: getActiveBookings,
            showAddPaymentModal: showAddPaymentModal,
            setShowAddPaymentModal: setShowAddPaymentModal
        },
        children: [
            apps.map((app)=>{
                return /*#__PURE__*/ (0, $6afFj.createPortal)(/*#__PURE__*/ (0, $bh6RR.createElement)(app.component, app?.props), app.el);
            }),
            children,
            !nested && /*#__PURE__*/ (0, $ih19M.jsx)((0, $e41d0db0a1294d0c$export$2e2bcd8739ae039), {}),
            !nested && /*#__PURE__*/ (0, $ih19M.jsx)((0, $5d526bb3b1ab5719$export$2e2bcd8739ae039), {}),
            !nested && /*#__PURE__*/ (0, $ih19M.jsx)((0, $efcd9c5e78db09db$export$2e2bcd8739ae039), {})
        ]
    });
}




const $0cf146259d57657d$var$MODERN = {
    allowHideMap: true // This variable is true for all booking module views except locations
};
const $0cf146259d57657d$var$apps = [
    // Embed header (only in embed mode)
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#embed-header').map((el)=>{
        return {
            el: el,
            component: (0, $fe44baf3183c7728$export$2e2bcd8739ae039)
        };
    }),
    // Booking module
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('.booking-module-modern-form').map((el)=>{
        return {
            el: el,
            component: (0, $d029f9e7b709ac5b$export$2e2bcd8739ae039)
        };
    }),
    // Cashier
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#payment-modal').map((el)=>{
        return {
            el: el,
            component: (0, $55e74f19e167cb27$export$2e2bcd8739ae039)
        };
    }),
    // Profile module
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#profile-module').map((el)=>{
        return {
            el: el,
            component: (0, $8afe3747eee9983f$export$2e2bcd8739ae039)
        };
    }),
    // Login module
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#login-module').map((el)=>{
        return {
            el: el,
            component: (0, $ff450cbdbee3675c$export$2e2bcd8739ae039)
        };
    }),
    // Login status
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('.login-status-modern').map((el)=>{
        return {
            el: el,
            component: (0, $ab03eb32e97e1283$export$2e2bcd8739ae039)
        };
    }),
    // Map
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#map-modern').map((el)=>{
        return {
            el: el,
            component: (0, $a8850544475e04b7$export$2e2bcd8739ae039)
        };
    }),
    // Status messages
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#status-messages').map((el)=>{
        return {
            el: el,
            component: (0, $1ea04dc67a9d8232$export$2e2bcd8739ae039)
        };
    }),
    // Active orders
    ...(0, $30acdccbb47e8004$export$9ca9051b92b5a6d2)('#active-bookings').map((el)=>{
        return {
            el: el,
            component: (0, $5376430f3892d5f5$export$2e2bcd8739ae039),
            props: {
                slideableContent: (0, $30acdccbb47e8004$export$836aee6bce45247)('.slideable-content'),
                header: (0, $30acdccbb47e8004$export$836aee6bce45247)('.header')
            }
        };
    })
];
const $0cf146259d57657d$var$rootElement = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.getElementById('reactStore'));
$0cf146259d57657d$var$rootElement.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $a1f3d609b7c166c2$export$2e2bcd8739ae039), {
    apps: $0cf146259d57657d$var$apps
}));
const $0cf146259d57657d$var$bmw = (0, $30acdccbb47e8004$export$836aee6bce45247)('.booking-module-modern');
if ($0cf146259d57657d$var$bmw && typeof APP !== 'undefined') {
    const hasCover = $0cf146259d57657d$var$bmw.classList.contains('has-cover');
    const isFullscreen = $0cf146259d57657d$var$bmw.classList.contains('fullscreen');
    // The embed markup ships with .fullscreen already applied and stays that way,
    // so END_FULLSCREEN must not strip it back off.
    const lockFullscreen = !!window.EMBED_CONFIG?.isEmbed;
    APP.on(APP.events.BOOKING_MODULE_FULLSCREEN, ()=>{
        $0cf146259d57657d$var$bmw.classList.add('fullscreen');
        document.body.classList.add('booking-fullscreen');
    });
    APP.on(APP.events.BOOKING_MODULE_END_FULLSCREEN, ()=>{
        if (lockFullscreen) return;
        $0cf146259d57657d$var$bmw.classList.remove('fullscreen');
        document.body.classList.remove('booking-fullscreen');
    });
    if (hasCover) {
        APP.on(APP.events.BOOKING_MODULE_HIDE_COVER, ()=>$0cf146259d57657d$var$bmw.classList.remove('cover-visible'));
        APP.on(APP.events.BOOKING_MODULE_SHOW_COVER, ()=>$0cf146259d57657d$var$bmw.classList.add('cover-visible'));
        APP.on(APP.events.BOOKING_MODULE_DISABLE_HIDE_MAP, ()=>{
            $0cf146259d57657d$var$MODERN.allowHideMap = false;
        });
        APP.on(APP.events.BOOKING_MODULE_ENABLE_HIDE_MAP, ()=>{
            $0cf146259d57657d$var$MODERN.allowHideMap = true;
        });
        const mapElement = document.getElementById('map-modern');
        if (mapElement) mapElement.addEventListener('click', ()=>{
            if ($0cf146259d57657d$var$MODERN.allowHideMap) {
                APP.trigger(APP.events.BOOKING_MODULE_SHOW_COVER);
                APP.trigger(APP.events.BOOKING_MODULE_CONTRACTED);
            }
        });
        const formElement = document.querySelector('.booking-module-modern-form');
        if (formElement) formElement.addEventListener('click', ()=>{
            APP.trigger(APP.events.BOOKING_MODULE_HIDE_COVER);
        });
    }
}
// ============================================
// Dynamic Booking Module for Edit / Return Trip Mode
// ============================================
// When EDIT_BOOKING or RETURN_TRIP_BOOKING is triggered on pages without a
// booking module, dynamically create and mount one as a fullscreen overlay
let $0cf146259d57657d$var$dynamicBookingModuleRoot = null;
let $0cf146259d57657d$var$dynamicMapRoot = null;
let $0cf146259d57657d$var$dynamicBookingModuleContainer = null;
let $0cf146259d57657d$var$pendingBookingEvent = null; // { name, data } re-emitted once the module has mounted
const $0cf146259d57657d$var$createDynamicBookingModule = (eventName, bookingData)=>{
    // Don't create if booking module already exists on the page
    if ((0, $30acdccbb47e8004$export$836aee6bce45247)('.booking-module-modern-form')) return false;
    // Store the event to re-emit after mount
    $0cf146259d57657d$var$pendingBookingEvent = {
        name: eventName,
        data: bookingData
    };
    // Set global flag for dynamic overlay mode
    window.DYNAMIC_OVERLAY_MODE = true;
    // Create overlay container
    const overlay = document.createElement('div');
    overlay.id = 'dynamic-booking-overlay';
    overlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: white;
    overflow-y: auto;
  `;
    // Create booking module structure (matching booking_module_modern.twig)
    const bookingModuleContainer = document.createElement('div');
    bookingModuleContainer.className = 'booking-module-modern fullscreen';
    const formContainer = document.createElement('div');
    formContainer.className = 'booking-module-modern-form modern-component';
    const mapContainer = document.createElement('div');
    mapContainer.id = 'map-modern';
    bookingModuleContainer.appendChild(formContainer);
    bookingModuleContainer.appendChild(mapContainer);
    overlay.appendChild(bookingModuleContainer);
    document.body.appendChild(overlay);
    // Store references
    $0cf146259d57657d$var$dynamicBookingModuleContainer = overlay;
    // Mount React app with BookingModuleWrapper
    const reactRoot = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(formContainer);
    $0cf146259d57657d$var$dynamicBookingModuleRoot = reactRoot;
    // Mount Map component on the map container
    const mapRoot = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(mapContainer);
    $0cf146259d57657d$var$dynamicMapRoot = mapRoot;
    // Create a wrapper component to handle cleanup
    const DynamicBookingWrapper = ()=>{
        (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RESET_FORM', ()=>{
            // When booking is closed/reset, remove the dynamic overlay
            setTimeout(()=>$0cf146259d57657d$var$removeDynamicBookingModule(), 100);
        });
        // Re-emit the event after the component mounts
        (0, $bh6RR.useEffect)(()=>{
            if ($0cf146259d57657d$var$pendingBookingEvent) {
                const { name: name, data: data } = $0cf146259d57657d$var$pendingBookingEvent;
                setTimeout(()=>{
                    (0, $d2abdbb88c8390d6$exports.emitCustomEvent)(name, data);
                    $0cf146259d57657d$var$pendingBookingEvent = null;
                }, 100);
            }
        }, []);
        return /*#__PURE__*/ (0, $ih19M.jsx)((0, $d029f9e7b709ac5b$export$2e2bcd8739ae039), {});
    };
    reactRoot.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $a1f3d609b7c166c2$export$2e2bcd8739ae039), {
        apps: [],
        nested: true,
        children: /*#__PURE__*/ (0, $ih19M.jsx)(DynamicBookingWrapper, {})
    }));
    // Render the Map component
    mapRoot.render(/*#__PURE__*/ (0, $ih19M.jsx)((0, $a8850544475e04b7$export$2e2bcd8739ae039), {}));
    return true;
};
const $0cf146259d57657d$var$removeDynamicBookingModule = ()=>{
    if ($0cf146259d57657d$var$dynamicBookingModuleRoot) {
        $0cf146259d57657d$var$dynamicBookingModuleRoot.unmount();
        $0cf146259d57657d$var$dynamicBookingModuleRoot = null;
    }
    if ($0cf146259d57657d$var$dynamicMapRoot) {
        $0cf146259d57657d$var$dynamicMapRoot.unmount();
        $0cf146259d57657d$var$dynamicMapRoot = null;
    }
    if ($0cf146259d57657d$var$dynamicBookingModuleContainer) {
        $0cf146259d57657d$var$dynamicBookingModuleContainer.remove();
        $0cf146259d57657d$var$dynamicBookingModuleContainer = null;
    }
    $0cf146259d57657d$var$pendingBookingEvent = null;
    // Clear dynamic overlay flag
    window.DYNAMIC_OVERLAY_MODE = false;
};
// Set up a global listener component that mounts immediately
// This listens for EDIT_BOOKING / RETURN_TRIP_BOOKING events even when the booking module isn't present
const $0cf146259d57657d$var$GlobalEditBookingListener = ()=>{
    const onBookingEvent = (eventName)=>(bookingData)=>{
            // Check if booking module doesn't exist
            if (!(0, $30acdccbb47e8004$export$836aee6bce45247)('.booking-module-modern-form')) $0cf146259d57657d$var$createDynamicBookingModule(eventName, bookingData);
        };
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('EDIT_BOOKING', onBookingEvent('EDIT_BOOKING'), []);
    (0, $d2abdbb88c8390d6$exports.useCustomEventListener)('RETURN_TRIP_BOOKING', onBookingEvent('RETURN_TRIP_BOOKING'), []);
    return null; // This component doesn't render anything
};
// Mount the global listener immediately
if (typeof window !== 'undefined') {
    const listenerRoot = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.createElement('div'));
    listenerRoot.render(/*#__PURE__*/ (0, $ih19M.jsx)($0cf146259d57657d$var$GlobalEditBookingListener, {}));
}


//# sourceMappingURL=modern.9007204f.js.map
